
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref931"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref931"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("88YbF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MergeKeyStore = module.exports.BrowserLocalStorageKeyStore = module.exports.InMemoryKeyStore = module.exports.KeyStore = void 0;

var $kELc4 = parcelRequire("kELc4");
Object.defineProperty(module.exports, "KeyStore", {
    enumerable: true,
    get: function() {
        return $kELc4.KeyStore;
    }
});

var $kWbvD = parcelRequire("kWbvD");
Object.defineProperty(module.exports, "InMemoryKeyStore", {
    enumerable: true,
    get: function() {
        return $kWbvD.InMemoryKeyStore;
    }
});

var $8OBr1 = parcelRequire("8OBr1");
Object.defineProperty(module.exports, "BrowserLocalStorageKeyStore", {
    enumerable: true,
    get: function() {
        return $8OBr1.BrowserLocalStorageKeyStore;
    }
});

var $gFytt = parcelRequire("gFytt");
Object.defineProperty(module.exports, "MergeKeyStore", {
    enumerable: true,
    get: function() {
        return $gFytt.MergeKeyStore;
    }
});

});
parcelRegister("kELc4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyStore = void 0;

var $fjvIe = parcelRequire("fjvIe");
Object.defineProperty(module.exports, "KeyStore", {
    enumerable: true,
    get: function() {
        return $fjvIe.KeyStore;
    }
});

});
parcelRegister("fjvIe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MergeKeyStore = module.exports.KeyStore = module.exports.InMemoryKeyStore = void 0;

var $6QVs7 = parcelRequire("6QVs7");
Object.defineProperty(module.exports, "InMemoryKeyStore", {
    enumerable: true,
    get: function() {
        return $6QVs7.InMemoryKeyStore;
    }
});

var $dQ9Ut = parcelRequire("dQ9Ut");
Object.defineProperty(module.exports, "KeyStore", {
    enumerable: true,
    get: function() {
        return $dQ9Ut.KeyStore;
    }
});

var $47UKp = parcelRequire("47UKp");
Object.defineProperty(module.exports, "MergeKeyStore", {
    enumerable: true,
    get: function() {
        return $47UKp.MergeKeyStore;
    }
});

});
parcelRegister("6QVs7", function(module, exports) {
"use strict";
var $4fd42a4baeae89ed$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemoryKeyStore = void 0;

var $hp647 = parcelRequire("hp647");

var $dQ9Ut = parcelRequire("dQ9Ut");
/**
 * Simple in-memory keystore for mainly for testing purposes.
 *
 * @see [https://docs.near.org/docs/develop/front-end/naj-quick-reference#key-store](https://docs.near.org/docs/develop/front-end/naj-quick-reference#key-store)
 * @example
 * ```js
 * import { connect, keyStores, utils } from 'near-api-js';
 *
 * const privateKey = '.......';
 * const keyPair = utils.KeyPair.fromString(privateKey);
 *
 * const keyStore = new keyStores.InMemoryKeyStore();
 * keyStore.setKey('testnet', 'example-account.testnet', keyPair);
 *
 * const config = {
 *   keyStore, // instance of InMemoryKeyStore
 *   networkId: 'testnet',
 *   nodeUrl: 'https://rpc.testnet.near.org',
 *   walletUrl: 'https://wallet.testnet.near.org',
 *   helperUrl: 'https://helper.testnet.near.org',
 *   explorerUrl: 'https://explorer.testnet.near.org'
 * };
 *
 * // inside an async function
 * const near = await connect(config)
 * ```
 */ class $4fd42a4baeae89ed$var$InMemoryKeyStore extends $dQ9Ut.KeyStore {
    constructor(){
        super();
        this.keys = {};
    }
    /**
     * Stores a {@link KeyPair} in in-memory storage item
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @param keyPair The key pair to store in local storage
     */ setKey(networkId, accountId, keyPair) {
        return $4fd42a4baeae89ed$var$__awaiter(this, void 0, void 0, function*() {
            this.keys[`${accountId}:${networkId}`] = keyPair.toString();
        });
    }
    /**
     * Gets a {@link KeyPair} from in-memory storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @returns {Promise<KeyPair>}
     */ getKey(networkId, accountId) {
        return $4fd42a4baeae89ed$var$__awaiter(this, void 0, void 0, function*() {
            const value = this.keys[`${accountId}:${networkId}`];
            if (!value) return null;
            return $hp647.KeyPair.fromString(value);
        });
    }
    /**
     * Removes a {@link KeyPair} from in-memory storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     */ removeKey(networkId, accountId) {
        return $4fd42a4baeae89ed$var$__awaiter(this, void 0, void 0, function*() {
            delete this.keys[`${accountId}:${networkId}`];
        });
    }
    /**
     * Removes all {@link KeyPair} from in-memory storage
     */ clear() {
        return $4fd42a4baeae89ed$var$__awaiter(this, void 0, void 0, function*() {
            this.keys = {};
        });
    }
    /**
     * Get the network(s) from in-memory storage
     * @returns {Promise<string[]>}
     */ getNetworks() {
        return $4fd42a4baeae89ed$var$__awaiter(this, void 0, void 0, function*() {
            const result = new Set();
            Object.keys(this.keys).forEach((key)=>{
                const parts = key.split(":");
                result.add(parts[1]);
            });
            return Array.from(result.values());
        });
    }
    /**
     * Gets the account(s) from in-memory storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     */ getAccounts(networkId) {
        return $4fd42a4baeae89ed$var$__awaiter(this, void 0, void 0, function*() {
            const result = new Array();
            Object.keys(this.keys).forEach((key)=>{
                const parts = key.split(":");
                if (parts[parts.length - 1] === networkId) result.push(parts.slice(0, parts.length - 1).join(":"));
            });
            return result;
        });
    }
    /** @hidden */ toString() {
        return "InMemoryKeyStore";
    }
}
module.exports.InMemoryKeyStore = $4fd42a4baeae89ed$var$InMemoryKeyStore;

});
parcelRegister("hp647", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PublicKey = module.exports.KeyPairEd25519 = module.exports.KeyPair = module.exports.KeyType = void 0;

var $byOaD = parcelRequire("byOaD");
Object.defineProperty(module.exports, "KeyType", {
    enumerable: true,
    get: function() {
        return $byOaD.KeyType;
    }
});

var $3OGIC = parcelRequire("3OGIC");
Object.defineProperty(module.exports, "KeyPair", {
    enumerable: true,
    get: function() {
        return $3OGIC.KeyPair;
    }
});

var $f23p3 = parcelRequire("f23p3");
Object.defineProperty(module.exports, "KeyPairEd25519", {
    enumerable: true,
    get: function() {
        return $f23p3.KeyPairEd25519;
    }
});

var $0kWUa = parcelRequire("0kWUa");
Object.defineProperty(module.exports, "PublicKey", {
    enumerable: true,
    get: function() {
        return $0kWUa.PublicKey;
    }
});

});
parcelRegister("byOaD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeySize = module.exports.KeyType = void 0;
/** All supported key types */ var $86a9c98716cd7aaf$var$KeyType;
(function(KeyType) {
    KeyType[KeyType["ED25519"] = 0] = "ED25519";
})($86a9c98716cd7aaf$var$KeyType = module.exports.KeyType || (module.exports.KeyType = {}));
var $86a9c98716cd7aaf$var$KeySize;
(function(KeySize) {
    KeySize[KeySize["SECRET_KEY"] = 32] = "SECRET_KEY";
})($86a9c98716cd7aaf$var$KeySize = module.exports.KeySize || (module.exports.KeySize = {}));

});

parcelRegister("3OGIC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyPair = void 0;

var $75vNW = parcelRequire("75vNW");

var $f23p3 = parcelRequire("f23p3");
class $2c772da7adf2883c$var$KeyPair extends $75vNW.KeyPairBase {
    /**
     * @param curve Name of elliptical curve, case-insensitive
     * @returns Random KeyPair based on the curve
     */ static fromRandom(curve) {
        switch(curve.toUpperCase()){
            case "ED25519":
                return $f23p3.KeyPairEd25519.fromRandom();
            default:
                throw new Error(`Unknown curve ${curve}`);
        }
    }
    /**
     * Creates a key pair from an encoded key string.
     * @param encodedKey The encoded key string.
     * @returns {KeyPair} The key pair created from the encoded key string.
     */ static fromString(encodedKey) {
        const parts = encodedKey.split(":");
        if (parts.length === 1) return new $f23p3.KeyPairEd25519(parts[0]);
        else if (parts.length === 2) switch(parts[0].toUpperCase()){
            case "ED25519":
                return new $f23p3.KeyPairEd25519(parts[1]);
            default:
                throw new Error(`Unknown curve: ${parts[0]}`);
        }
        else throw new Error("Invalid encoded key format, must be <curve>:<encoded key>");
    }
}
module.exports.KeyPair = $2c772da7adf2883c$var$KeyPair;

});
parcelRegister("75vNW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyPairBase = void 0;
class $5291abc3f40f3aa8$var$KeyPairBase {
}
module.exports.KeyPairBase = $5291abc3f40f3aa8$var$KeyPairBase;

});

parcelRegister("f23p3", function(module, exports) {
"use strict";
var $af19aeb7a65848cb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyPairEd25519 = void 0;

var $hNbI3 = parcelRequire("hNbI3");

var $kE5x4 = parcelRequire("kE5x4");

const $af19aeb7a65848cb$var$randombytes_1 = $af19aeb7a65848cb$var$__importDefault((parcelRequire("hkN9y")));

var $byOaD = parcelRequire("byOaD");

var $75vNW = parcelRequire("75vNW");

var $0kWUa = parcelRequire("0kWUa");
/**
 * This class provides key pair functionality for Ed25519 curve:
 * generating key pairs, encoding key pairs, signing and verifying.
 */ class $af19aeb7a65848cb$var$KeyPairEd25519 extends $75vNW.KeyPairBase {
    /**
     * Construct an instance of key pair given a secret key.
     * It's generally assumed that these are encoded in base58.
     * @param extendedSecretKey
     */ constructor(extendedSecretKey){
        super();
        const decoded = (0, $hNbI3.baseDecode)(extendedSecretKey);
        const secretKey = new Uint8Array(decoded.slice(0, $byOaD.KeySize.SECRET_KEY));
        const publicKey = $kE5x4.ed25519.getPublicKey(secretKey);
        this.publicKey = new $0kWUa.PublicKey({
            keyType: $byOaD.KeyType.ED25519,
            data: publicKey
        });
        this.secretKey = (0, $hNbI3.baseEncode)(secretKey);
        this.extendedSecretKey = extendedSecretKey;
    }
    /**
     * Generate a new random keypair.
     * @example
     * const keyRandom = KeyPair.fromRandom();
     * keyRandom.publicKey
     * // returns [PUBLIC_KEY]
     *
     * keyRandom.secretKey
     * // returns [SECRET_KEY]
     */ static fromRandom() {
        const secretKey = (0, $af19aeb7a65848cb$var$randombytes_1.default)($byOaD.KeySize.SECRET_KEY);
        const publicKey = $kE5x4.ed25519.getPublicKey(new Uint8Array(secretKey));
        const extendedSecretKey = new Uint8Array([
            ...secretKey,
            ...publicKey
        ]);
        return new $af19aeb7a65848cb$var$KeyPairEd25519((0, $hNbI3.baseEncode)(extendedSecretKey));
    }
    /**
     * Signs a message using the key pair's secret key.
     * @param message The message to be signed.
     * @returns {Signature} The signature object containing the signature and the public key.
     */ sign(message) {
        const signature = $kE5x4.ed25519.sign(message, (0, $hNbI3.baseDecode)(this.secretKey));
        return {
            signature: signature,
            publicKey: this.publicKey
        };
    }
    /**
     * Verifies the signature of a message using the key pair's public key.
     * @param message The message to be verified.
     * @param signature The signature to be verified.
     * @returns {boolean} `true` if the signature is valid, otherwise `false`.
     */ verify(message, signature) {
        return this.publicKey.verify(message, signature);
    }
    /**
     * Returns a string representation of the key pair in the format 'ed25519:[extendedSecretKey]'.
     * @returns {string} The string representation of the key pair.
     */ toString() {
        return `ed25519:${this.extendedSecretKey}`;
    }
    /**
     * Retrieves the public key associated with the key pair.
     * @returns {PublicKey} The public key.
     */ getPublicKey() {
        return this.publicKey;
    }
}
module.exports.KeyPairEd25519 = $af19aeb7a65848cb$var$KeyPairEd25519;

});
parcelRegister("hNbI3", function(module, exports) {
"use strict";
var $cf401887dbc5bf72$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cf401887dbc5bf72$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cf401887dbc5bf72$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cf401887dbc5bf72$var$__exportStar((parcelRequire("aEqDq")), module.exports);

$cf401887dbc5bf72$var$__exportStar((parcelRequire("lmtz6")), module.exports);

$cf401887dbc5bf72$var$__exportStar((parcelRequire("9saHl")), module.exports);

$cf401887dbc5bf72$var$__exportStar((parcelRequire("dKLr8")), module.exports);

$cf401887dbc5bf72$var$__exportStar((parcelRequire("1NFia")), module.exports);

$cf401887dbc5bf72$var$__exportStar((parcelRequire("5peqi")), module.exports);

$cf401887dbc5bf72$var$__exportStar((parcelRequire("cfGud")), module.exports);

});
parcelRegister("aEqDq", function(module, exports) {
"use strict";
var $7c124cf45ebfd0dd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_FUNCTION_CALL_GAS = void 0;

const $7c124cf45ebfd0dd$var$bn_js_1 = $7c124cf45ebfd0dd$var$__importDefault((parcelRequire("dEXSZ")));
// Default amount of gas to be sent with the function calls. Used to pay for the fees
// incurred while running the contract execution. The unused amount will be refunded back to
// the originator.
// Due to protocol changes that charge upfront for the maximum possible gas price inflation due to
// full blocks, the price of max_prepaid_gas is decreased to `300 * 10**12`.
// For discussion see https://github.com/nearprotocol/NEPs/issues/67
module.exports.DEFAULT_FUNCTION_CALL_GAS = new $7c124cf45ebfd0dd$var$bn_js_1.default("30000000000000");

});
parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("lmtz6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseRpcError = module.exports.parseResultError = module.exports.getErrorTypeFromErrorMessage = module.exports.formatError = module.exports.ServerError = module.exports.logWarning = void 0;

var $fyxYA = parcelRequire("fyxYA");
Object.defineProperty(module.exports, "logWarning", {
    enumerable: true,
    get: function() {
        return $fyxYA.logWarning;
    }
});

var $c1Ftv = parcelRequire("c1Ftv");
Object.defineProperty(module.exports, "ServerError", {
    enumerable: true,
    get: function() {
        return $c1Ftv.ServerError;
    }
});
Object.defineProperty(module.exports, "formatError", {
    enumerable: true,
    get: function() {
        return $c1Ftv.formatError;
    }
});
Object.defineProperty(module.exports, "getErrorTypeFromErrorMessage", {
    enumerable: true,
    get: function() {
        return $c1Ftv.getErrorTypeFromErrorMessage;
    }
});
Object.defineProperty(module.exports, "parseResultError", {
    enumerable: true,
    get: function() {
        return $c1Ftv.parseResultError;
    }
});
Object.defineProperty(module.exports, "parseRpcError", {
    enumerable: true,
    get: function() {
        return $c1Ftv.parseRpcError;
    }
});

});
parcelRegister("fyxYA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logWarning = void 0;

var $cfGud = parcelRequire("cfGud");
/** @deprecated */ function $b53462f77f7a50c7$var$logWarning(...args) {
    const [message, ...optionalParams] = args;
    $cfGud.Logger.warn(message, ...optionalParams);
}
module.exports.logWarning = $b53462f77f7a50c7$var$logWarning;

});
parcelRegister("cfGud", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

var $hWEr0 = parcelRequire("hWEr0");
Object.defineProperty(module.exports, "Logger", {
    enumerable: true,
    get: function() {
        return $hWEr0.Logger;
    }
});

});
parcelRegister("hWEr0", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $d10737e3b4b2063d$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

var $2AUdm = parcelRequire("2AUdm");
const $d10737e3b4b2063d$var$DEFAULT_LOG_LEVELS = [
    "verbose",
    "debug",
    "log",
    "warn",
    "error",
    "fatal"
];
const $d10737e3b4b2063d$var$DEFAULT_LOGGER = (typeof $hPtJY === "object" && undefined, new $2AUdm.ConsoleLogger($d10737e3b4b2063d$var$DEFAULT_LOG_LEVELS));
/**
 * Used to log the library messages
 */ class $d10737e3b4b2063d$var$Logger {
    static error(message, ...optionalParams) {
        var _b;
        (_b = this.instanceRef) === null || _b === void 0 || _b.error(message, ...optionalParams);
    }
    /**
     * Write a 'log' level log.
     */ static log(message, ...optionalParams) {
        var _b;
        (_b = this.instanceRef) === null || _b === void 0 || _b.log(message, ...optionalParams);
    }
    /**
     * Write a 'warn' level log.
     */ static warn(message, ...optionalParams) {
        var _b;
        (_b = this.instanceRef) === null || _b === void 0 || _b.warn(message, ...optionalParams);
    }
    /**
     * Write a 'debug' level log.
     */ static debug(message, ...optionalParams) {
        var _b, _c;
        (_c = (_b = this.instanceRef) === null || _b === void 0 ? void 0 : _b.debug) === null || _c === void 0 || _c.call(_b, message, ...optionalParams);
    }
    /**
     * Write a 'verbose' level log.
     */ static verbose(message, ...optionalParams) {
        var _b, _c;
        (_c = (_b = this.instanceRef) === null || _b === void 0 ? void 0 : _b.verbose) === null || _c === void 0 || _c.call(_b, message, ...optionalParams);
    }
    static fatal(message, ...optionalParams) {
        var _b, _c;
        (_c = (_b = this.instanceRef) === null || _b === void 0 ? void 0 : _b.fatal) === null || _c === void 0 || _c.call(_b, message, ...optionalParams);
    }
}
module.exports.Logger = $d10737e3b4b2063d$var$Logger;
$d10737e3b4b2063d$var$_a = $d10737e3b4b2063d$var$Logger;
$d10737e3b4b2063d$var$Logger.instanceRef = $d10737e3b4b2063d$var$DEFAULT_LOGGER;
$d10737e3b4b2063d$var$Logger.overrideLogger = (logger)=>{
    $d10737e3b4b2063d$var$_a.instanceRef = logger;
};

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("2AUdm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConsoleLogger = void 0;
class $1e3a8c9c703f6ed4$var$ConsoleLogger {
    constructor(logLevels){
        this.logLevels = logLevels;
        this.isLevelEnabled = (level)=>{
            return this.logLevels.includes(level);
        };
    }
    print(level, message, ...optionalParams) {
        switch(level){
            case "error":
            case "fatal":
                return console.error(message, ...optionalParams);
            case "warn":
                return console.warn(message, ...optionalParams);
            case "log":
                return console.log(message, ...optionalParams);
            case "debug":
            case "verbose":
                return console.debug(message, ...optionalParams);
        }
    }
    verbose(message, ...optionalParams) {
        if (!this.isLevelEnabled("verbose")) return;
        this.print("verbose", message, ...optionalParams);
    }
    debug(message, ...optionalParams) {
        if (!this.isLevelEnabled("debug")) return;
        this.print("debug", message, ...optionalParams);
    }
    log(message, ...optionalParams) {
        if (!this.isLevelEnabled("log")) return;
        this.print("log", message, ...optionalParams);
    }
    warn(message, ...optionalParams) {
        if (!this.isLevelEnabled("warn")) return;
        this.print("warn", message, ...optionalParams);
    }
    error(message, ...optionalParams) {
        if (!this.isLevelEnabled("error")) return;
        this.print("error", message, ...optionalParams);
    }
    fatal(message, ...optionalParams) {
        if (!this.isLevelEnabled("fatal")) return;
        this.print("fatal", message, ...optionalParams);
    }
}
module.exports.ConsoleLogger = $1e3a8c9c703f6ed4$var$ConsoleLogger;

});




parcelRegister("c1Ftv", function(module, exports) {
"use strict";
var $8c15c00ec9e4946e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getErrorTypeFromErrorMessage = module.exports.formatError = module.exports.parseResultError = module.exports.parseRpcError = module.exports.ServerError = void 0;

var $a246u = parcelRequire("a246u");

const $8c15c00ec9e4946e$var$mustache_1 = $8c15c00ec9e4946e$var$__importDefault((parcelRequire("ifgZ7")));

var $9saHl = parcelRequire("9saHl");

const $8c15c00ec9e4946e$var$error_messages_json_1 = $8c15c00ec9e4946e$var$__importDefault((parcelRequire("5UGvn")));

const $8c15c00ec9e4946e$var$rpc_error_schema_json_1 = $8c15c00ec9e4946e$var$__importDefault((parcelRequire("b5Go4")));
const $8c15c00ec9e4946e$var$mustacheHelpers = {
    formatNear: ()=>(n, render)=>(0, $9saHl.formatNearAmount)(render(n))
};
class $8c15c00ec9e4946e$var$ServerError extends $a246u.TypedError {
}
module.exports.ServerError = $8c15c00ec9e4946e$var$ServerError;
class $8c15c00ec9e4946e$var$ServerTransactionError extends $8c15c00ec9e4946e$var$ServerError {
}
function $8c15c00ec9e4946e$var$parseRpcError(errorObj) {
    const result = {};
    const errorClassName = $8c15c00ec9e4946e$var$walkSubtype(errorObj, $8c15c00ec9e4946e$var$rpc_error_schema_json_1.default.schema, result, "");
    // NOTE: This assumes that all errors extend TypedError
    const error = new $8c15c00ec9e4946e$var$ServerError($8c15c00ec9e4946e$var$formatError(errorClassName, result), errorClassName);
    Object.assign(error, result);
    return error;
}
module.exports.parseRpcError = $8c15c00ec9e4946e$var$parseRpcError;
function $8c15c00ec9e4946e$var$parseResultError(result) {
    const server_error = $8c15c00ec9e4946e$var$parseRpcError(result.status.Failure);
    const server_tx_error = new $8c15c00ec9e4946e$var$ServerTransactionError();
    Object.assign(server_tx_error, server_error);
    server_tx_error.type = server_error.type;
    server_tx_error.message = server_error.message;
    server_tx_error.transaction_outcome = result.transaction_outcome;
    return server_tx_error;
}
module.exports.parseResultError = $8c15c00ec9e4946e$var$parseResultError;
function $8c15c00ec9e4946e$var$formatError(errorClassName, errorData) {
    if (typeof $8c15c00ec9e4946e$var$error_messages_json_1.default[errorClassName] === "string") return $8c15c00ec9e4946e$var$mustache_1.default.render($8c15c00ec9e4946e$var$error_messages_json_1.default[errorClassName], Object.assign(Object.assign({}, errorData), $8c15c00ec9e4946e$var$mustacheHelpers));
    return JSON.stringify(errorData);
}
module.exports.formatError = $8c15c00ec9e4946e$var$formatError;
/**
 * Walks through defined schema returning error(s) recursively
 * @param errorObj The error to be parsed
 * @param schema A defined schema in JSON mapping to the RPC errors
 * @param result An object used in recursion or called directly
 * @param typeName The human-readable error type name as defined in the JSON mapping
 */ function $8c15c00ec9e4946e$var$walkSubtype(errorObj, schema, result, typeName) {
    let error;
    let type;
    let errorTypeName;
    for(const errorName in schema){
        if ($8c15c00ec9e4946e$var$isString(errorObj[errorName])) // Return early if error type is in a schema
        return errorObj[errorName];
        if ($8c15c00ec9e4946e$var$isObject(errorObj[errorName])) {
            error = errorObj[errorName];
            type = schema[errorName];
            errorTypeName = errorName;
        } else if ($8c15c00ec9e4946e$var$isObject(errorObj.kind) && $8c15c00ec9e4946e$var$isObject(errorObj.kind[errorName])) {
            error = errorObj.kind[errorName];
            type = schema[errorName];
            errorTypeName = errorName;
        } else continue;
    }
    if (error && type) {
        for (const prop of Object.keys(type.props))result[prop] = error[prop];
        return $8c15c00ec9e4946e$var$walkSubtype(error, schema, result, errorTypeName);
    } else {
        // TODO: is this the right thing to do?
        result.kind = errorObj;
        return typeName;
    }
}
function $8c15c00ec9e4946e$var$getErrorTypeFromErrorMessage(errorMessage, errorType) {
    // This function should be removed when JSON RPC starts returning typed errors.
    switch(true){
        case /^account .*? does not exist while viewing$/.test(errorMessage):
            return "AccountDoesNotExist";
        case /^Account .*? doesn't exist$/.test(errorMessage):
            return "AccountDoesNotExist";
        case /^access key .*? does not exist while viewing$/.test(errorMessage):
            return "AccessKeyDoesNotExist";
        case /wasm execution failed with error: FunctionCallError\(CompilationError\(CodeDoesNotExist/.test(errorMessage):
            return "CodeDoesNotExist";
        case /wasm execution failed with error: CompilationError\(CodeDoesNotExist/.test(errorMessage):
            return "CodeDoesNotExist";
        case /wasm execution failed with error: FunctionCallError\(MethodResolveError\(MethodNotFound/.test(errorMessage):
            return "MethodNotFound";
        case /wasm execution failed with error: MethodResolveError\(MethodNotFound/.test(errorMessage):
            return "MethodNotFound";
        case /Transaction nonce \d+ must be larger than nonce of the used access key \d+/.test(errorMessage):
            return "InvalidNonce";
        default:
            return errorType;
    }
}
module.exports.getErrorTypeFromErrorMessage = $8c15c00ec9e4946e$var$getErrorTypeFromErrorMessage;
/**
 * Helper function determining if the argument is an object
 * @param n Value to check
 */ function $8c15c00ec9e4946e$var$isObject(n) {
    return Object.prototype.toString.call(n) === "[object Object]";
}
/**
 * Helper function determining if the argument is a string
 * @param n Value to check
 */ function $8c15c00ec9e4946e$var$isString(n) {
    return Object.prototype.toString.call(n) === "[object String]";
}

});
parcelRegister("a246u", function(module, exports) {
"use strict";
var $01e28963e101802f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $01e28963e101802f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $01e28963e101802f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$01e28963e101802f$var$__exportStar((parcelRequire("f1urP")), module.exports);

$01e28963e101802f$var$__exportStar((parcelRequire("iHX4a")), module.exports);

$01e28963e101802f$var$__exportStar((parcelRequire("1mgzE")), module.exports);

});
parcelRegister("f1urP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Assignable = void 0;
class $aefe91583dd0b0ef$var$Assignable {
    constructor(properties){
        Object.keys(properties).map((key)=>{
            this[key] = properties[key];
        });
    }
}
module.exports.Assignable = $aefe91583dd0b0ef$var$Assignable;

});

parcelRegister("iHX4a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorContext = module.exports.TypedError = module.exports.ArgumentTypeError = module.exports.PositionalArgsError = void 0;
class $d9ea0f72b545b3be$var$PositionalArgsError extends Error {
    constructor(){
        super("Contract method calls expect named arguments wrapped in object, e.g. { argName1: argValue1, argName2: argValue2 }");
    }
}
module.exports.PositionalArgsError = $d9ea0f72b545b3be$var$PositionalArgsError;
class $d9ea0f72b545b3be$var$ArgumentTypeError extends Error {
    constructor(argName, argType, argValue){
        super(`Expected ${argType} for '${argName}' argument, but got '${JSON.stringify(argValue)}'`);
    }
}
module.exports.ArgumentTypeError = $d9ea0f72b545b3be$var$ArgumentTypeError;
class $d9ea0f72b545b3be$var$TypedError extends Error {
    constructor(message, type, context){
        super(message);
        this.type = type || "UntypedError";
        this.context = context;
    }
}
module.exports.TypedError = $d9ea0f72b545b3be$var$TypedError;
class $d9ea0f72b545b3be$var$ErrorContext {
    constructor(transactionHash){
        this.transactionHash = transactionHash;
    }
}
module.exports.ErrorContext = $d9ea0f72b545b3be$var$ErrorContext;

});

parcelRegister("1mgzE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FinalExecutionStatusBasic = module.exports.ExecutionStatusBasic = module.exports.IdType = void 0;

var $gMVQr = parcelRequire("gMVQr");
Object.defineProperty(module.exports, "IdType", {
    enumerable: true,
    get: function() {
        return $gMVQr.IdType;
    }
});

var $k7WN2 = parcelRequire("k7WN2");
Object.defineProperty(module.exports, "ExecutionStatusBasic", {
    enumerable: true,
    get: function() {
        return $k7WN2.ExecutionStatusBasic;
    }
});
Object.defineProperty(module.exports, "FinalExecutionStatusBasic", {
    enumerable: true,
    get: function() {
        return $k7WN2.FinalExecutionStatusBasic;
    }
});

});
parcelRegister("gMVQr", function(module, exports) {
"use strict";
/**
 * NEAR RPC API request types and responses
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdType = void 0;
var $c38dffcf2c6664b3$var$IdType;
(function(IdType) {
    IdType["Transaction"] = "transaction";
    IdType["Receipt"] = "receipt";
})($c38dffcf2c6664b3$var$IdType = module.exports.IdType || (module.exports.IdType = {}));

});

parcelRegister("k7WN2", function(module, exports) {
"use strict";
/**
 * NEAR RPC API request types and responses
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FinalExecutionStatusBasic = module.exports.ExecutionStatusBasic = void 0;
var $ea721092253f0093$var$ExecutionStatusBasic;
(function(ExecutionStatusBasic) {
    ExecutionStatusBasic["Unknown"] = "Unknown";
    ExecutionStatusBasic["Pending"] = "Pending";
    ExecutionStatusBasic["Failure"] = "Failure";
})($ea721092253f0093$var$ExecutionStatusBasic = module.exports.ExecutionStatusBasic || (module.exports.ExecutionStatusBasic = {}));
var $ea721092253f0093$var$FinalExecutionStatusBasic;
(function(FinalExecutionStatusBasic) {
    FinalExecutionStatusBasic["NotStarted"] = "NotStarted";
    FinalExecutionStatusBasic["Started"] = "Started";
    FinalExecutionStatusBasic["Failure"] = "Failure";
})($ea721092253f0093$var$FinalExecutionStatusBasic = module.exports.FinalExecutionStatusBasic || (module.exports.FinalExecutionStatusBasic = {}));

});



parcelRegister("ifgZ7", function(module, exports) {
// This file has been generated from mustache.mjs
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === "[object Array]";
    };
    function isFunction(object) {
        return typeof object === "function";
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? "array" : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === "object" && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== "object" && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
        "`": "&#x60;",
        "=": "&#x3D;"
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ""; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === "string") tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error("Invalid tags: " + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + "\\s*");
            closingTagRe = new RegExp("\\s*" + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp("\\s*" + escapeRegExp("}" + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += " ";
                }
                tokens.push([
                    "text",
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === "\n") {
                    stripSpace();
                    indentation = "";
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || "name";
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === "=") {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === "{") {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = "&";
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error("Unclosed tag at " + scanner.pos);
            if (type == ">") token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === "#" || type === "^") sections.push(token);
            else if (type === "/") {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === "name" || type === "{" || type === "&") nonSpace = true;
            else if (type === "=") // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === "text" && lastToken && lastToken[0] === "text") {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case "#":
                case "^":
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case "/":
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === "";
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return "";
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = "";
                break;
            case 0:
                match = "";
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            ".": this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf(".") > 0) {
                    intermediateValue = context.view;
                    names = name.split(".");
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== "undefined") this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ":" + (tags || mustache.tags).join(":");
        var isCacheEnabled = typeof cache1 !== "undefined";
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `tags` argument is given here it must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   */ Writer.prototype.render = function render(template, view, partials, tags) {
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, tags);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, tags) {
        var buffer = "";
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === "#") value = this.renderSection(token, context, partials, originalTemplate);
            else if (symbol === "^") value = this.renderInverted(token, context, partials, originalTemplate);
            else if (symbol === ">") value = this.renderPartial(token, context, partials, tags);
            else if (symbol === "&") value = this.unescapedValue(token, context);
            else if (symbol === "name") value = this.escapedValue(token, context);
            else if (symbol === "text") value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate) {
        var self = this;
        var buffer = "";
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
        else if (typeof value === "object" || typeof value === "string" || typeof value === "number") buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== "string") throw new Error("Cannot use higher-order sections without the original template");
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, "");
        var partialByNl = partial.split("\n");
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join("\n");
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, tags) {
        if (!partials) return;
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            return this.renderTokens(this.parse(indentedValue, tags), context, partials, indentedValue);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return mustache.escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    var mustache = {
        name: "mustache.js",
        version: "4.0.0",
        tags: [
            "{{",
            "}}"
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer. If the optional `tags` argument is given here it must be an
   * array with two string values: the opening and closing tags used in the
   * template (e.g. [ "<%", "%>" ]). The default is to mustache.tags.
   */ mustache.render = function render(template, view, partials, tags) {
        if (typeof template !== "string") throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + "argument for mustache#render(template, view, partials)");
        return defaultWriter.render(template, view, partials, tags);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});

});

parcelRegister("9saHl", function(module, exports) {
"use strict";
var $6e1f06fa108dc5a4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.baseDecode = module.exports.baseEncode = module.exports.parseNearAmount = module.exports.formatNearAmount = module.exports.NEAR_NOMINATION = module.exports.NEAR_NOMINATION_EXP = void 0;

const $6e1f06fa108dc5a4$var$bn_js_1 = $6e1f06fa108dc5a4$var$__importDefault((parcelRequire("dEXSZ")));

const $6e1f06fa108dc5a4$var$bs58_1 = $6e1f06fa108dc5a4$var$__importDefault((parcelRequire("bYkMz")));
/**
 * Exponent for calculating how many indivisible units are there in one NEAR. See {@link NEAR_NOMINATION}.
 */ module.exports.NEAR_NOMINATION_EXP = 24;
/**
 * Number of indivisible units in one NEAR. Derived from {@link NEAR_NOMINATION_EXP}.
 */ module.exports.NEAR_NOMINATION = new $6e1f06fa108dc5a4$var$bn_js_1.default("10", 10).pow(new $6e1f06fa108dc5a4$var$bn_js_1.default(module.exports.NEAR_NOMINATION_EXP, 10));
// Pre-calculate offsets used for rounding to different number of digits
const $6e1f06fa108dc5a4$var$ROUNDING_OFFSETS = [];
const $6e1f06fa108dc5a4$var$BN10 = new $6e1f06fa108dc5a4$var$bn_js_1.default(10);
for(let i = 0, offset = new $6e1f06fa108dc5a4$var$bn_js_1.default(5); i < module.exports.NEAR_NOMINATION_EXP; i++, offset = offset.mul($6e1f06fa108dc5a4$var$BN10))$6e1f06fa108dc5a4$var$ROUNDING_OFFSETS[i] = offset;
/**
 * Convert account balance value from internal indivisible units to NEAR. 1 NEAR is defined by {@link NEAR_NOMINATION}.
 * Effectively this divides given amount by {@link NEAR_NOMINATION}.
 *
 * @param balance decimal string representing balance in smallest non-divisible NEAR units (as specified by {@link NEAR_NOMINATION})
 * @param fracDigits number of fractional digits to preserve in formatted string. Balance is rounded to match given number of digits.
 * @returns Value in Ⓝ
 */ function $6e1f06fa108dc5a4$var$formatNearAmount(balance, fracDigits = module.exports.NEAR_NOMINATION_EXP) {
    const balanceBN = new $6e1f06fa108dc5a4$var$bn_js_1.default(balance, 10);
    if (fracDigits !== module.exports.NEAR_NOMINATION_EXP) {
        // Adjust balance for rounding at given number of digits
        const roundingExp = module.exports.NEAR_NOMINATION_EXP - fracDigits - 1;
        if (roundingExp > 0) balanceBN.iadd($6e1f06fa108dc5a4$var$ROUNDING_OFFSETS[roundingExp]);
    }
    balance = balanceBN.toString();
    const wholeStr = balance.substring(0, balance.length - module.exports.NEAR_NOMINATION_EXP) || "0";
    const fractionStr = balance.substring(balance.length - module.exports.NEAR_NOMINATION_EXP).padStart(module.exports.NEAR_NOMINATION_EXP, "0").substring(0, fracDigits);
    return $6e1f06fa108dc5a4$var$trimTrailingZeroes(`${$6e1f06fa108dc5a4$var$formatWithCommas(wholeStr)}.${fractionStr}`);
}
module.exports.formatNearAmount = $6e1f06fa108dc5a4$var$formatNearAmount;
/**
 * Convert human readable NEAR amount to internal indivisible units.
 * Effectively this multiplies given amount by {@link NEAR_NOMINATION}.
 *
 * @param amt decimal string (potentially fractional) denominated in NEAR.
 * @returns The parsed yoctoⓃ amount or null if no amount was passed in
 */ function $6e1f06fa108dc5a4$var$parseNearAmount(amt) {
    if (!amt) return null;
    amt = $6e1f06fa108dc5a4$var$cleanupAmount(amt);
    const split = amt.split(".");
    const wholePart = split[0];
    const fracPart = split[1] || "";
    if (split.length > 2 || fracPart.length > module.exports.NEAR_NOMINATION_EXP) throw new Error(`Cannot parse '${amt}' as NEAR amount`);
    return $6e1f06fa108dc5a4$var$trimLeadingZeroes(wholePart + fracPart.padEnd(module.exports.NEAR_NOMINATION_EXP, "0"));
}
module.exports.parseNearAmount = $6e1f06fa108dc5a4$var$parseNearAmount;
/**
 * Removes commas from the input
 * @param amount A value or amount that may contain commas
 * @returns string The cleaned value
 */ function $6e1f06fa108dc5a4$var$cleanupAmount(amount) {
    return amount.replace(/,/g, "").trim();
}
/**
 * Removes .000… from an input
 * @param value A value that may contain trailing zeroes in the decimals place
 * @returns string The value without the trailing zeros
 */ function $6e1f06fa108dc5a4$var$trimTrailingZeroes(value) {
    return value.replace(/\.?0*$/, "");
}
/**
 * Removes leading zeroes from an input
 * @param value A value that may contain leading zeroes
 * @returns string The value without the leading zeroes
 */ function $6e1f06fa108dc5a4$var$trimLeadingZeroes(value) {
    value = value.replace(/^0+/, "");
    if (value === "") return "0";
    return value;
}
/**
 * Returns a human-readable value with commas
 * @param value A value that may not contain commas
 * @returns string A value with commas
 */ function $6e1f06fa108dc5a4$var$formatWithCommas(value) {
    const pattern = /(-?\d+)(\d{3})/;
    while(pattern.test(value))value = value.replace(pattern, "$1,$2");
    return value;
}
/**
 * Encodes a Uint8Array or string into base58
 * @param value Uint8Array or string representing a borsh encoded object
 * @returns string base58 encoding of the value
 */ function $6e1f06fa108dc5a4$var$baseEncode(value) {
    if (typeof value === "string") {
        const bytes = [];
        for(let c = 0; c < value.length; c++)bytes.push(value.charCodeAt(c));
        value = new Uint8Array(bytes);
    }
    return $6e1f06fa108dc5a4$var$bs58_1.default.encode(value);
}
module.exports.baseEncode = $6e1f06fa108dc5a4$var$baseEncode;
/**
 * Decodes a base58 string into a Uint8Array
 * @param value base58 encoded string
 * @returns Uint8Array representing the decoded value
 */ function $6e1f06fa108dc5a4$var$baseDecode(value) {
    return new Uint8Array($6e1f06fa108dc5a4$var$bs58_1.default.decode(value));
}
module.exports.baseDecode = $6e1f06fa108dc5a4$var$baseDecode;

});
parcelRegister("bYkMz", function(module, exports) {

var $gcBt9 = parcelRequire("gcBt9");
var $8b756b3b8ee97947$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $gcBt9($8b756b3b8ee97947$var$ALPHABET);

});
parcelRegister("gcBt9", function(module, exports) {
// base-x encoding
// Forked from https://github.com/cryptocoinjs/bs58
// Originally written by Mike Hearn for BitcoinJ
// Copyright (c) 2011 Google Inc
// Ported to JavaScript by Stefan Thomas
// Merged Buffer refactorings from base58-native by Stephen Pair
// Copyright (c) 2013 BitPay Inc

var $1U9GM = parcelRequire("1U9GM");
var $bcbad4eb565141db$require$Buffer = $1U9GM.Buffer;
module.exports = function base(ALPHABET) {
    var ALPHABET_MAP = {};
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    // pre-compute lookup table
    for(var z = 0; z < ALPHABET.length; z++){
        var x = ALPHABET.charAt(z);
        if (ALPHABET_MAP[x] !== undefined) throw new TypeError(x + " is ambiguous");
        ALPHABET_MAP[x] = z;
    }
    function encode(source) {
        if (source.length === 0) return "";
        var digits = [
            0
        ];
        for(var i = 0; i < source.length; ++i){
            for(var j = 0, carry = source[i]; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % BASE;
                carry = carry / BASE | 0;
            }
            while(carry > 0){
                digits.push(carry % BASE);
                carry = carry / BASE | 0;
            }
        }
        var string = "";
        // deal with leading zeros
        for(var k = 0; source[k] === 0 && k < source.length - 1; ++k)string += ALPHABET[0];
        // convert digits to a string
        for(var q = digits.length - 1; q >= 0; --q)string += ALPHABET[digits[q]];
        return string;
    }
    function decodeUnsafe(string) {
        if (string.length === 0) return $bcbad4eb565141db$require$Buffer.allocUnsafe(0);
        var bytes = [
            0
        ];
        for(var i = 0; i < string.length; i++){
            var value = ALPHABET_MAP[string[i]];
            if (value === undefined) return;
            for(var j = 0, carry = value; j < bytes.length; ++j){
                carry += bytes[j] * BASE;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(var k = 0; string[k] === LEADER && k < string.length - 1; ++k)bytes.push(0);
        return $bcbad4eb565141db$require$Buffer.from(bytes.reverse());
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
};

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
var $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
var $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    var buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        var len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        var buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $51861dfc7ca9d588$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});






parcelRegister("5UGvn", function(module, exports) {
module.exports = JSON.parse('{"GasLimitExceeded":"Exceeded the maximum amount of gas allowed to burn per contract","MethodEmptyName":"Method name is empty","WasmerCompileError":"Wasmer compilation error: {{msg}}","GuestPanic":"Smart contract panicked: {{panic_msg}}","Memory":"Error creating Wasm memory","GasExceeded":"Exceeded the prepaid gas","MethodUTF8Error":"Method name is not valid UTF8 string","BadUTF16":"String encoding is bad UTF-16 sequence","WasmTrap":"WebAssembly trap: {{msg}}","GasInstrumentation":"Gas instrumentation failed or contract has denied instructions.","InvalidPromiseIndex":"{{promise_idx}} does not correspond to existing promises","InvalidPromiseResultIndex":"Accessed invalid promise result index: {{result_idx}}","Deserialization":"Error happened while deserializing the module","MethodNotFound":"Contract method is not found","InvalidRegisterId":"Accessed invalid register id: {{register_id}}","InvalidReceiptIndex":"VM Logic returned an invalid receipt index: {{receipt_index}}","EmptyMethodName":"Method name is empty in contract call","CannotReturnJointPromise":"Returning joint promise is currently prohibited","StackHeightInstrumentation":"Stack instrumentation failed","CodeDoesNotExist":"Cannot find contract code for account {{account_id}}","MethodInvalidSignature":"Invalid method signature","IntegerOverflow":"Integer overflow happened during contract execution","MemoryAccessViolation":"MemoryAccessViolation","InvalidIteratorIndex":"Iterator index {{iterator_index}} does not exist","IteratorWasInvalidated":"Iterator {{iterator_index}} was invalidated after its creation by performing a mutable operation on trie","InvalidAccountId":"VM Logic returned an invalid account id","Serialization":"Error happened while serializing the module","CannotAppendActionToJointPromise":"Actions can only be appended to non-joint promise.","InternalMemoryDeclared":"Internal memory declaration has been found in the module","Instantiate":"Error happened during instantiation","ProhibitedInView":"{{method_name}} is not allowed in view calls","InvalidMethodName":"VM Logic returned an invalid method name","BadUTF8":"String encoding is bad UTF-8 sequence","BalanceExceeded":"Exceeded the account balance","LinkError":"Wasm contract link error: {{msg}}","InvalidPublicKey":"VM Logic provided an invalid public key","ActorNoPermission":"Actor {{actor_id}} doesn\'t have permission to account {{account_id}} to complete the action","LackBalanceForState":"The account {{account_id}} wouldn\'t have enough balance to cover storage, required to have {{amount}} yoctoNEAR more","ReceiverMismatch":"Wrong AccessKey used for transaction: transaction is sent to receiver_id={{tx_receiver}}, but is signed with function call access key that restricted to only use with receiver_id={{ak_receiver}}. Either change receiver_id in your transaction or switch to use a FullAccessKey.","CostOverflow":"Transaction gas or balance cost is too high","InvalidSignature":"Transaction is not signed with the given public key","AccessKeyNotFound":"Signer \\"{{account_id}}\\" doesn\'t have access key with the given public_key {{public_key}}","NotEnoughBalance":"Sender {{signer_id}} does not have enough balance {{#formatNear}}{{balance}}{{/formatNear}} for operation costing {{#formatNear}}{{cost}}{{/formatNear}}","NotEnoughAllowance":"Access Key {account_id}:{public_key} does not have enough balance {{#formatNear}}{{allowance}}{{/formatNear}} for transaction costing {{#formatNear}}{{cost}}{{/formatNear}}","Expired":"Transaction has expired","DeleteAccountStaking":"Account {{account_id}} is staking and can not be deleted","SignerDoesNotExist":"Signer {{signer_id}} does not exist","TriesToStake":"Account {{account_id}} tried to stake {{#formatNear}}{{stake}}{{/formatNear}}, but has staked {{#formatNear}}{{locked}}{{/formatNear}} and only has {{#formatNear}}{{balance}}{{/formatNear}}","AddKeyAlreadyExists":"The public key {{public_key}} is already used for an existing access key","InvalidSigner":"Invalid signer account ID {{signer_id}} according to requirements","CreateAccountNotAllowed":"The new account_id {{account_id}} can\'t be created by {{predecessor_id}}","RequiresFullAccess":"The transaction contains more then one action, but it was signed with an access key which allows transaction to apply only one specific action. To apply more then one actions TX must be signed with a full access key","TriesToUnstake":"Account {{account_id}} is not yet staked, but tried to unstake","InvalidNonce":"Transaction nonce {{tx_nonce}} must be larger than nonce of the used access key {{ak_nonce}}","AccountAlreadyExists":"Can\'t create a new account {{account_id}}, because it already exists","InvalidChain":"Transaction parent block hash doesn\'t belong to the current chain","AccountDoesNotExist":"Can\'t complete the action because account {{account_id}} doesn\'t exist","AccessKeyDoesNotExist":"Can\'t complete the action because access key {{public_key}} doesn\'t exist","MethodNameMismatch":"Transaction method name {{method_name}} isn\'t allowed by the access key","DeleteAccountHasRent":"Account {{account_id}} can\'t be deleted. It has {{#formatNear}}{{balance}}{{/formatNear}}, which is enough to cover the rent","DeleteAccountHasEnoughBalance":"Account {{account_id}} can\'t be deleted. It has {{#formatNear}}{{balance}}{{/formatNear}}, which is enough to cover it\'s storage","InvalidReceiver":"Invalid receiver account ID {{receiver_id}} according to requirements","DeleteKeyDoesNotExist":"Account {{account_id}} tries to remove an access key that doesn\'t exist","Timeout":"Timeout exceeded","Closed":"Connection closed"}');

});

parcelRegister("b5Go4", function(module, exports) {
module.exports = JSON.parse('{"schema":{"AccessKeyNotFound":{"name":"AccessKeyNotFound","subtypes":[],"props":{"account_id":"","public_key":""}},"AccountAlreadyExists":{"name":"AccountAlreadyExists","subtypes":[],"props":{"account_id":""}},"AccountDoesNotExist":{"name":"AccountDoesNotExist","subtypes":[],"props":{"account_id":""}},"ActionError":{"name":"ActionError","subtypes":["AccountAlreadyExists","AccountDoesNotExist","CreateAccountOnlyByRegistrar","CreateAccountNotAllowed","ActorNoPermission","DeleteKeyDoesNotExist","AddKeyAlreadyExists","DeleteAccountStaking","LackBalanceForState","TriesToUnstake","TriesToStake","InsufficientStake","FunctionCallError","NewReceiptValidationError","OnlyImplicitAccountCreationAllowed","DeleteAccountWithLargeState","DelegateActionInvalidSignature","DelegateActionSenderDoesNotMatchTxReceiver","DelegateActionExpired","DelegateActionAccessKeyError","DelegateActionInvalidNonce","DelegateActionNonceTooLarge"],"props":{"index":""}},"ActionsValidationError":{"name":"ActionsValidationError","subtypes":["DeleteActionMustBeFinal","TotalPrepaidGasExceeded","TotalNumberOfActionsExceeded","AddKeyMethodNamesNumberOfBytesExceeded","AddKeyMethodNameLengthExceeded","IntegerOverflow","InvalidAccountId","ContractSizeExceeded","FunctionCallMethodNameLengthExceeded","FunctionCallArgumentsLengthExceeded","UnsuitableStakingKey","FunctionCallZeroAttachedGas","DelegateActionMustBeOnlyOne","UnsupportedProtocolFeature"],"props":{}},"ActorNoPermission":{"name":"ActorNoPermission","subtypes":[],"props":{"account_id":"","actor_id":""}},"AddKeyAlreadyExists":{"name":"AddKeyAlreadyExists","subtypes":[],"props":{"account_id":"","public_key":""}},"AddKeyMethodNameLengthExceeded":{"name":"AddKeyMethodNameLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"AddKeyMethodNamesNumberOfBytesExceeded":{"name":"AddKeyMethodNamesNumberOfBytesExceeded","subtypes":[],"props":{"limit":"","total_number_of_bytes":""}},"AltBn128InvalidInput":{"name":"AltBn128InvalidInput","subtypes":[],"props":{"msg":""}},"BadUTF16":{"name":"BadUTF16","subtypes":[],"props":{}},"BadUTF8":{"name":"BadUTF8","subtypes":[],"props":{}},"BalanceExceeded":{"name":"BalanceExceeded","subtypes":[],"props":{}},"BalanceMismatchError":{"name":"BalanceMismatchError","subtypes":[],"props":{"final_accounts_balance":"","final_postponed_receipts_balance":"","incoming_receipts_balance":"","incoming_validator_rewards":"","initial_accounts_balance":"","initial_postponed_receipts_balance":"","new_delayed_receipts_balance":"","other_burnt_amount":"","outgoing_receipts_balance":"","processed_delayed_receipts_balance":"","slashed_burnt_amount":"","tx_burnt_amount":""}},"CallIndirectOOB":{"name":"CallIndirectOOB","subtypes":[],"props":{}},"CannotAppendActionToJointPromise":{"name":"CannotAppendActionToJointPromise","subtypes":[],"props":{}},"CannotReturnJointPromise":{"name":"CannotReturnJointPromise","subtypes":[],"props":{}},"CodeDoesNotExist":{"name":"CodeDoesNotExist","subtypes":[],"props":{"account_id":""}},"CompilationError":{"name":"CompilationError","subtypes":["CodeDoesNotExist","PrepareError","WasmerCompileError"],"props":{}},"ContractSizeExceeded":{"name":"ContractSizeExceeded","subtypes":[],"props":{"limit":"","size":""}},"CostOverflow":{"name":"CostOverflow","subtypes":[],"props":{}},"CreateAccountNotAllowed":{"name":"CreateAccountNotAllowed","subtypes":[],"props":{"account_id":"","predecessor_id":""}},"CreateAccountOnlyByRegistrar":{"name":"CreateAccountOnlyByRegistrar","subtypes":[],"props":{"account_id":"","predecessor_id":"","registrar_account_id":""}},"DelegateActionExpired":{"name":"DelegateActionExpired","subtypes":[],"props":{}},"DelegateActionInvalidNonce":{"name":"DelegateActionInvalidNonce","subtypes":[],"props":{"ak_nonce":"","delegate_nonce":""}},"DelegateActionInvalidSignature":{"name":"DelegateActionInvalidSignature","subtypes":[],"props":{}},"DelegateActionMustBeOnlyOne":{"name":"DelegateActionMustBeOnlyOne","subtypes":[],"props":{}},"DelegateActionNonceTooLarge":{"name":"DelegateActionNonceTooLarge","subtypes":[],"props":{"delegate_nonce":"","upper_bound":""}},"DelegateActionSenderDoesNotMatchTxReceiver":{"name":"DelegateActionSenderDoesNotMatchTxReceiver","subtypes":[],"props":{"receiver_id":"","sender_id":""}},"DeleteAccountStaking":{"name":"DeleteAccountStaking","subtypes":[],"props":{"account_id":""}},"DeleteAccountWithLargeState":{"name":"DeleteAccountWithLargeState","subtypes":[],"props":{"account_id":""}},"DeleteActionMustBeFinal":{"name":"DeleteActionMustBeFinal","subtypes":[],"props":{}},"DeleteKeyDoesNotExist":{"name":"DeleteKeyDoesNotExist","subtypes":[],"props":{"account_id":"","public_key":""}},"DepositWithFunctionCall":{"name":"DepositWithFunctionCall","subtypes":[],"props":{}},"Deprecated":{"name":"Deprecated","subtypes":[],"props":{"method_name":""}},"Deserialization":{"name":"Deserialization","subtypes":[],"props":{}},"ECRecoverError":{"name":"ECRecoverError","subtypes":[],"props":{"msg":""}},"Ed25519VerifyInvalidInput":{"name":"Ed25519VerifyInvalidInput","subtypes":[],"props":{"msg":""}},"EmptyMethodName":{"name":"EmptyMethodName","subtypes":[],"props":{}},"Expired":{"name":"Expired","subtypes":[],"props":{}},"FunctionCallArgumentsLengthExceeded":{"name":"FunctionCallArgumentsLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"FunctionCallMethodNameLengthExceeded":{"name":"FunctionCallMethodNameLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"FunctionCallZeroAttachedGas":{"name":"FunctionCallZeroAttachedGas","subtypes":[],"props":{}},"GasExceeded":{"name":"GasExceeded","subtypes":[],"props":{}},"GasInstrumentation":{"name":"GasInstrumentation","subtypes":[],"props":{}},"GasLimitExceeded":{"name":"GasLimitExceeded","subtypes":[],"props":{}},"GenericTrap":{"name":"GenericTrap","subtypes":[],"props":{}},"GuestPanic":{"name":"GuestPanic","subtypes":[],"props":{"panic_msg":""}},"HostError":{"name":"HostError","subtypes":["BadUTF16","BadUTF8","GasExceeded","GasLimitExceeded","BalanceExceeded","EmptyMethodName","GuestPanic","IntegerOverflow","InvalidPromiseIndex","CannotAppendActionToJointPromise","CannotReturnJointPromise","InvalidPromiseResultIndex","InvalidRegisterId","IteratorWasInvalidated","MemoryAccessViolation","InvalidReceiptIndex","InvalidIteratorIndex","InvalidAccountId","InvalidMethodName","InvalidPublicKey","ProhibitedInView","NumberOfLogsExceeded","KeyLengthExceeded","ValueLengthExceeded","TotalLogLengthExceeded","NumberPromisesExceeded","NumberInputDataDependenciesExceeded","ReturnedValueLengthExceeded","ContractSizeExceeded","Deprecated","ECRecoverError","AltBn128InvalidInput","Ed25519VerifyInvalidInput"],"props":{}},"IllegalArithmetic":{"name":"IllegalArithmetic","subtypes":[],"props":{}},"IncorrectCallIndirectSignature":{"name":"IncorrectCallIndirectSignature","subtypes":[],"props":{}},"IndirectCallToNull":{"name":"IndirectCallToNull","subtypes":[],"props":{}},"Instantiate":{"name":"Instantiate","subtypes":[],"props":{}},"InsufficientStake":{"name":"InsufficientStake","subtypes":[],"props":{"account_id":"","minimum_stake":"","stake":""}},"IntegerOverflow":{"name":"IntegerOverflow","subtypes":[],"props":{}},"InternalMemoryDeclared":{"name":"InternalMemoryDeclared","subtypes":[],"props":{}},"InvalidAccessKeyError":{"name":"InvalidAccessKeyError","subtypes":["AccessKeyNotFound","ReceiverMismatch","MethodNameMismatch","RequiresFullAccess","NotEnoughAllowance","DepositWithFunctionCall"],"props":{}},"InvalidAccountId":{"name":"InvalidAccountId","subtypes":[],"props":{}},"InvalidChain":{"name":"InvalidChain","subtypes":[],"props":{}},"InvalidDataReceiverId":{"name":"InvalidDataReceiverId","subtypes":[],"props":{"account_id":""}},"InvalidIteratorIndex":{"name":"InvalidIteratorIndex","subtypes":[],"props":{"iterator_index":""}},"InvalidMethodName":{"name":"InvalidMethodName","subtypes":[],"props":{}},"InvalidNonce":{"name":"InvalidNonce","subtypes":[],"props":{"ak_nonce":"","tx_nonce":""}},"InvalidPredecessorId":{"name":"InvalidPredecessorId","subtypes":[],"props":{"account_id":""}},"InvalidPromiseIndex":{"name":"InvalidPromiseIndex","subtypes":[],"props":{"promise_idx":""}},"InvalidPromiseResultIndex":{"name":"InvalidPromiseResultIndex","subtypes":[],"props":{"result_idx":""}},"InvalidPublicKey":{"name":"InvalidPublicKey","subtypes":[],"props":{}},"InvalidReceiptIndex":{"name":"InvalidReceiptIndex","subtypes":[],"props":{"receipt_index":""}},"InvalidReceiverId":{"name":"InvalidReceiverId","subtypes":[],"props":{"account_id":""}},"InvalidRegisterId":{"name":"InvalidRegisterId","subtypes":[],"props":{"register_id":""}},"InvalidSignature":{"name":"InvalidSignature","subtypes":[],"props":{}},"InvalidSignerId":{"name":"InvalidSignerId","subtypes":[],"props":{"account_id":""}},"InvalidTxError":{"name":"InvalidTxError","subtypes":["InvalidAccessKeyError","InvalidSignerId","SignerDoesNotExist","InvalidNonce","NonceTooLarge","InvalidReceiverId","InvalidSignature","NotEnoughBalance","LackBalanceForState","CostOverflow","InvalidChain","Expired","ActionsValidation","TransactionSizeExceeded"],"props":{}},"IteratorWasInvalidated":{"name":"IteratorWasInvalidated","subtypes":[],"props":{"iterator_index":""}},"KeyLengthExceeded":{"name":"KeyLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"LackBalanceForState":{"name":"LackBalanceForState","subtypes":[],"props":{"account_id":"","amount":""}},"Memory":{"name":"Memory","subtypes":[],"props":{}},"MemoryAccessViolation":{"name":"MemoryAccessViolation","subtypes":[],"props":{}},"MemoryOutOfBounds":{"name":"MemoryOutOfBounds","subtypes":[],"props":{}},"MethodEmptyName":{"name":"MethodEmptyName","subtypes":[],"props":{}},"MethodInvalidSignature":{"name":"MethodInvalidSignature","subtypes":[],"props":{}},"MethodNameMismatch":{"name":"MethodNameMismatch","subtypes":[],"props":{"method_name":""}},"MethodNotFound":{"name":"MethodNotFound","subtypes":[],"props":{}},"MethodResolveError":{"name":"MethodResolveError","subtypes":["MethodEmptyName","MethodNotFound","MethodInvalidSignature"],"props":{}},"MisalignedAtomicAccess":{"name":"MisalignedAtomicAccess","subtypes":[],"props":{}},"NonceTooLarge":{"name":"NonceTooLarge","subtypes":[],"props":{"tx_nonce":"","upper_bound":""}},"NotEnoughAllowance":{"name":"NotEnoughAllowance","subtypes":[],"props":{"account_id":"","allowance":"","cost":"","public_key":""}},"NotEnoughBalance":{"name":"NotEnoughBalance","subtypes":[],"props":{"balance":"","cost":"","signer_id":""}},"NumberInputDataDependenciesExceeded":{"name":"NumberInputDataDependenciesExceeded","subtypes":[],"props":{"limit":"","number_of_input_data_dependencies":""}},"NumberOfLogsExceeded":{"name":"NumberOfLogsExceeded","subtypes":[],"props":{"limit":""}},"NumberPromisesExceeded":{"name":"NumberPromisesExceeded","subtypes":[],"props":{"limit":"","number_of_promises":""}},"OnlyImplicitAccountCreationAllowed":{"name":"OnlyImplicitAccountCreationAllowed","subtypes":[],"props":{"account_id":""}},"PrepareError":{"name":"PrepareError","subtypes":["Serialization","Deserialization","InternalMemoryDeclared","GasInstrumentation","StackHeightInstrumentation","Instantiate","Memory","TooManyFunctions","TooManyLocals"],"props":{}},"ProhibitedInView":{"name":"ProhibitedInView","subtypes":[],"props":{"method_name":""}},"ReceiptValidationError":{"name":"ReceiptValidationError","subtypes":["InvalidPredecessorId","InvalidReceiverId","InvalidSignerId","InvalidDataReceiverId","ReturnedValueLengthExceeded","NumberInputDataDependenciesExceeded","ActionsValidation"],"props":{}},"ReceiverMismatch":{"name":"ReceiverMismatch","subtypes":[],"props":{"ak_receiver":"","tx_receiver":""}},"RequiresFullAccess":{"name":"RequiresFullAccess","subtypes":[],"props":{}},"ReturnedValueLengthExceeded":{"name":"ReturnedValueLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"Serialization":{"name":"Serialization","subtypes":[],"props":{}},"SignerDoesNotExist":{"name":"SignerDoesNotExist","subtypes":[],"props":{"signer_id":""}},"StackHeightInstrumentation":{"name":"StackHeightInstrumentation","subtypes":[],"props":{}},"StackOverflow":{"name":"StackOverflow","subtypes":[],"props":{}},"TooManyFunctions":{"name":"TooManyFunctions","subtypes":[],"props":{}},"TooManyLocals":{"name":"TooManyLocals","subtypes":[],"props":{}},"TotalLogLengthExceeded":{"name":"TotalLogLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"TotalNumberOfActionsExceeded":{"name":"TotalNumberOfActionsExceeded","subtypes":[],"props":{"limit":"","total_number_of_actions":""}},"TotalPrepaidGasExceeded":{"name":"TotalPrepaidGasExceeded","subtypes":[],"props":{"limit":"","total_prepaid_gas":""}},"TransactionSizeExceeded":{"name":"TransactionSizeExceeded","subtypes":[],"props":{"limit":"","size":""}},"TriesToStake":{"name":"TriesToStake","subtypes":[],"props":{"account_id":"","balance":"","locked":"","stake":""}},"TriesToUnstake":{"name":"TriesToUnstake","subtypes":[],"props":{"account_id":""}},"TxExecutionError":{"name":"TxExecutionError","subtypes":["ActionError","InvalidTxError"],"props":{}},"Unreachable":{"name":"Unreachable","subtypes":[],"props":{}},"UnsuitableStakingKey":{"name":"UnsuitableStakingKey","subtypes":[],"props":{"public_key":""}},"UnsupportedProtocolFeature":{"name":"UnsupportedProtocolFeature","subtypes":[],"props":{"protocol_feature":"","version":""}},"ValueLengthExceeded":{"name":"ValueLengthExceeded","subtypes":[],"props":{"length":"","limit":""}},"WasmTrap":{"name":"WasmTrap","subtypes":["Unreachable","IncorrectCallIndirectSignature","MemoryOutOfBounds","CallIndirectOOB","IllegalArithmetic","MisalignedAtomicAccess","IndirectCallToNull","StackOverflow","GenericTrap"],"props":{}},"WasmerCompileError":{"name":"WasmerCompileError","subtypes":[],"props":{"msg":""}},"Closed":{"name":"Closed","subtypes":[],"props":{}},"ServerError":{"name":"ServerError","subtypes":["TxExecutionError","Timeout","Closed"],"props":{}},"Timeout":{"name":"Timeout","subtypes":[],"props":{}}}}');

});



parcelRegister("dKLr8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.printTxOutcomeLogs = module.exports.printTxOutcomeLogsAndFailures = void 0;

var $lmtz6 = parcelRequire("lmtz6");

var $cfGud = parcelRequire("cfGud");
/**
 * Parse and print details from a query execution response
 * @param params
 * @param params.contractId ID of the account/contract which made the query
 * @param params.outcome the query execution response
 */ function $a0345e2bd4f1a23a$var$printTxOutcomeLogsAndFailures({ contractId: contractId, outcome: outcome }) {
    const flatLogs = [
        outcome.transaction_outcome,
        ...outcome.receipts_outcome
    ].reduce((acc, it)=>{
        const isFailure = typeof it.outcome.status === "object" && typeof it.outcome.status.Failure === "object";
        if (it.outcome.logs.length || isFailure) return acc.concat({
            receiptIds: it.outcome.receipt_ids,
            logs: it.outcome.logs,
            failure: typeof it.outcome.status === "object" && it.outcome.status.Failure !== undefined ? (0, $lmtz6.parseRpcError)(it.outcome.status.Failure) : null
        });
        else return acc;
    }, []);
    for (const result of flatLogs){
        $cfGud.Logger.log(`Receipt${result.receiptIds.length > 1 ? "s" : ""}: ${result.receiptIds.join(", ")}`);
        $a0345e2bd4f1a23a$var$printTxOutcomeLogs({
            contractId: contractId,
            logs: result.logs,
            prefix: "	"
        });
        if (result.failure) $cfGud.Logger.warn(`\tFailure [${contractId}]: ${result.failure}`);
    }
}
module.exports.printTxOutcomeLogsAndFailures = $a0345e2bd4f1a23a$var$printTxOutcomeLogsAndFailures;
/**
 * Format and print log output from a query execution response
 * @param params
 * @param params.contractId ID of the account/contract which made the query
 * @param params.logs log output from a query execution response
 * @param params.prefix string to append to the beginning of each log
 */ function $a0345e2bd4f1a23a$var$printTxOutcomeLogs({ contractId: contractId, logs: logs, prefix: prefix = "" }) {
    for (const log of logs)$cfGud.Logger.log(`${prefix}Log [${contractId}]: ${log}`);
}
module.exports.printTxOutcomeLogs = $a0345e2bd4f1a23a$var$printTxOutcomeLogs;

});

parcelRegister("1NFia", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $14fa65c9f2613521$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getTransactionLastResult = void 0;
/** @hidden */ function $14fa65c9f2613521$var$getTransactionLastResult(txResult) {
    if (typeof txResult.status === "object" && typeof txResult.status.SuccessValue === "string") {
        const value = $14fa65c9f2613521$require$Buffer.from(txResult.status.SuccessValue, "base64").toString();
        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    }
    return null;
}
module.exports.getTransactionLastResult = $14fa65c9f2613521$var$getTransactionLastResult;

});

parcelRegister("5peqi", function(module, exports) {
"use strict";
var $3efa79b1836c86d9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.diffEpochValidators = module.exports.findSeatPrice = void 0;

const $3efa79b1836c86d9$var$bn_js_1 = $3efa79b1836c86d9$var$__importDefault((parcelRequire("dEXSZ")));

const $3efa79b1836c86d9$var$depd_1 = $3efa79b1836c86d9$var$__importDefault((parcelRequire("6TCoX")));
/** Finds seat price given validators stakes and number of seats.
 *  Calculation follow the spec: https://nomicon.io/Economics/README.html#validator-selection
 * @param validators: current or next epoch validators.
 * @param maxNumberOfSeats: maximum number of seats in the network.
 * @param minimumStakeRatio: minimum stake ratio
 * @param protocolVersion: version of the protocol from genesis config
 */ function $3efa79b1836c86d9$var$findSeatPrice(validators, maxNumberOfSeats, minimumStakeRatio, protocolVersion) {
    if (protocolVersion && protocolVersion < 49) return $3efa79b1836c86d9$var$findSeatPriceForProtocolBefore49(validators, maxNumberOfSeats);
    if (!minimumStakeRatio) {
        const deprecate = (0, $3efa79b1836c86d9$var$depd_1.default)("findSeatPrice(validators, maxNumberOfSeats)");
        deprecate("`use `findSeatPrice(validators, maxNumberOfSeats, minimumStakeRatio)` instead");
        minimumStakeRatio = [
            1,
            6250
        ]; // hardcoded minimumStakeRation from 12/7/21
    }
    return $3efa79b1836c86d9$var$findSeatPriceForProtocolAfter49(validators, maxNumberOfSeats, minimumStakeRatio);
}
module.exports.findSeatPrice = $3efa79b1836c86d9$var$findSeatPrice;
function $3efa79b1836c86d9$var$findSeatPriceForProtocolBefore49(validators, numSeats) {
    const stakes = validators.map((v)=>new $3efa79b1836c86d9$var$bn_js_1.default(v.stake, 10)).sort((a, b)=>a.cmp(b));
    const num = new $3efa79b1836c86d9$var$bn_js_1.default(numSeats);
    const stakesSum = stakes.reduce((a, b)=>a.add(b));
    if (stakesSum.lt(num)) throw new Error("Stakes are below seats");
    // assert stakesSum >= numSeats
    let left = new $3efa79b1836c86d9$var$bn_js_1.default(1), right = stakesSum.add(new $3efa79b1836c86d9$var$bn_js_1.default(1));
    while(!left.eq(right.sub(new $3efa79b1836c86d9$var$bn_js_1.default(1)))){
        const mid = left.add(right).div(new $3efa79b1836c86d9$var$bn_js_1.default(2));
        let found = false;
        let currentSum = new $3efa79b1836c86d9$var$bn_js_1.default(0);
        for(let i = 0; i < stakes.length; ++i){
            currentSum = currentSum.add(stakes[i].div(mid));
            if (currentSum.gte(num)) {
                left = mid;
                found = true;
                break;
            }
        }
        if (!found) right = mid;
    }
    return left;
}
// nearcore reference: https://github.com/near/nearcore/blob/5a8ae263ec07930cd34d0dcf5bcee250c67c02aa/chain/epoch_manager/src/validator_selection.rs#L308;L315
function $3efa79b1836c86d9$var$findSeatPriceForProtocolAfter49(validators, maxNumberOfSeats, minimumStakeRatio) {
    if (minimumStakeRatio.length != 2) throw Error("minimumStakeRatio should have 2 elements");
    const stakes = validators.map((v)=>new $3efa79b1836c86d9$var$bn_js_1.default(v.stake, 10)).sort((a, b)=>a.cmp(b));
    const stakesSum = stakes.reduce((a, b)=>a.add(b));
    if (validators.length < maxNumberOfSeats) return stakesSum.mul(new $3efa79b1836c86d9$var$bn_js_1.default(minimumStakeRatio[0])).div(new $3efa79b1836c86d9$var$bn_js_1.default(minimumStakeRatio[1]));
    else return stakes[0].add(new $3efa79b1836c86d9$var$bn_js_1.default(1));
}
/** Diff validators between current and next epoch.
 * Returns additions, subtractions and changes to validator set.
 * @param currentValidators: list of current validators.
 * @param nextValidators: list of next validators.
 */ function $3efa79b1836c86d9$var$diffEpochValidators(currentValidators, nextValidators) {
    const validatorsMap = new Map();
    currentValidators.forEach((v)=>validatorsMap.set(v.account_id, v));
    const nextValidatorsSet = new Set(nextValidators.map((v)=>v.account_id));
    return {
        newValidators: nextValidators.filter((v)=>!validatorsMap.has(v.account_id)),
        removedValidators: currentValidators.filter((v)=>!nextValidatorsSet.has(v.account_id)),
        changedValidators: nextValidators.filter((v)=>validatorsMap.has(v.account_id) && validatorsMap.get(v.account_id).stake != v.stake).map((v)=>({
                current: validatorsMap.get(v.account_id),
                next: v
            }))
    };
}
module.exports.diffEpochValidators = $3efa79b1836c86d9$var$diffEpochValidators;

});
parcelRegister("6TCoX", function(module, exports) {
/*!
 * depd
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ module.exports = $5055aaddce11faec$var$depd;
/**
 * Create deprecate for namespace in caller.
 */ function $5055aaddce11faec$var$depd(namespace) {
    if (!namespace) throw new TypeError("argument namespace is required");
    function deprecate(message) {
    // no-op in browser
    }
    deprecate._file = undefined;
    deprecate._ignored = true;
    deprecate._namespace = namespace;
    deprecate._traced = false;
    deprecate._warned = Object.create(null);
    deprecate.function = $5055aaddce11faec$var$wrapfunction;
    deprecate.property = $5055aaddce11faec$var$wrapproperty;
    return deprecate;
}
/**
 * Return a wrapped function in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $5055aaddce11faec$var$wrapfunction(fn, message) {
    if (typeof fn !== "function") throw new TypeError("argument fn must be a function");
    return fn;
}
/**
 * Wrap property in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $5055aaddce11faec$var$wrapproperty(obj, prop, message) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new TypeError("argument obj must be object");
    var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
    if (!descriptor) throw new TypeError("must call property on owner object");
    if (!descriptor.configurable) throw new TypeError("property must be configurable");
}

});



parcelRegister("kE5x4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hash_to_ristretto255 = module.exports.hashToRistretto255 = module.exports.RistrettoPoint = module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.edwardsToMontgomeryPriv = module.exports.edwardsToMontgomery = module.exports.edwardsToMontgomeryPub = module.exports.x25519 = module.exports.ed25519ph = module.exports.ed25519ctx = module.exports.ed25519 = module.exports.ED25519_TORSION_SUBGROUP = void 0;

var $bZ4nb = parcelRequire("bZ4nb");

var $9BbKC = parcelRequire("9BbKC");

var $qoWOx = parcelRequire("qoWOx");

var $kiLeO = parcelRequire("kiLeO");

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

var $rkPJ6 = parcelRequire("rkPJ6");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $f07bd5acd6595f86$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $f07bd5acd6595f86$var$ED25519_SQRT_M1 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $f07bd5acd6595f86$var$_0n = BigInt(0), $f07bd5acd6595f86$var$_1n = BigInt(1), $f07bd5acd6595f86$var$_2n = BigInt(2), $f07bd5acd6595f86$var$_5n = BigInt(5);
// prettier-ignore
const $f07bd5acd6595f86$var$_10n = BigInt(10), $f07bd5acd6595f86$var$_20n = BigInt(20), $f07bd5acd6595f86$var$_40n = BigInt(40), $f07bd5acd6595f86$var$_80n = BigInt(80);
function $f07bd5acd6595f86$var$ed25519_pow_2_252_3(x) {
    const P = $f07bd5acd6595f86$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $2D9sF.pow2)(b2, $f07bd5acd6595f86$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $2D9sF.pow2)(b4, $f07bd5acd6595f86$var$_1n, P) * x % P; // x^31
    const b10 = (0, $2D9sF.pow2)(b5, $f07bd5acd6595f86$var$_5n, P) * b5 % P;
    const b20 = (0, $2D9sF.pow2)(b10, $f07bd5acd6595f86$var$_10n, P) * b10 % P;
    const b40 = (0, $2D9sF.pow2)(b20, $f07bd5acd6595f86$var$_20n, P) * b20 % P;
    const b80 = (0, $2D9sF.pow2)(b40, $f07bd5acd6595f86$var$_40n, P) * b40 % P;
    const b160 = (0, $2D9sF.pow2)(b80, $f07bd5acd6595f86$var$_80n, P) * b80 % P;
    const b240 = (0, $2D9sF.pow2)(b160, $f07bd5acd6595f86$var$_80n, P) * b80 % P;
    const b250 = (0, $2D9sF.pow2)(b240, $f07bd5acd6595f86$var$_10n, P) * b10 % P;
    const pow_p_5_8 = (0, $2D9sF.pow2)(b250, $f07bd5acd6595f86$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $f07bd5acd6595f86$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $f07bd5acd6595f86$var$uvRatio(u, v) {
    const P = $f07bd5acd6595f86$var$ED25519_P;
    const v3 = (0, $2D9sF.mod)(v * v * v, P); // v³
    const v7 = (0, $2D9sF.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $f07bd5acd6595f86$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $2D9sF.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $2D9sF.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $2D9sF.mod)(x * $f07bd5acd6595f86$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $2D9sF.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $2D9sF.mod)(-u * $f07bd5acd6595f86$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $2D9sF.isNegativeLE)(x, P)) x = (0, $2D9sF.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
// Just in case
module.exports.ED25519_TORSION_SUBGROUP = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $f07bd5acd6595f86$var$Fp = (0, $2D9sF.Field)($f07bd5acd6595f86$var$ED25519_P, undefined, true);
const $f07bd5acd6595f86$var$ed25519Defaults = {
    // Param: a
    a: BigInt(-1),
    // d is equal to -121665/121666 over finite field.
    // Negative number is P - number, and division is invert(number, P)
    d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
    Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
    $f07bd5acd6595f86$var$Fp,
    // Subgroup order: how many points curve has
    // 2n**252n + 27742317777372353535851937790883648493n;
    n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
    // Cofactor
    h: BigInt(8),
    // Base point (x, y) aka generator point
    Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
    hash: $bZ4nb.sha512,
    randomBytes: $9BbKC.randomBytes,
    adjustScalarBytes: $f07bd5acd6595f86$var$adjustScalarBytes,
    uvRatio: // dom2
    // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
    // Constant-time, u/√v
    $f07bd5acd6595f86$var$uvRatio
};
module.exports.ed25519 = (0, $qoWOx.twistedEdwards)($f07bd5acd6595f86$var$ed25519Defaults);
function $f07bd5acd6595f86$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $9BbKC.concatBytes)((0, $9BbKC.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
module.exports.ed25519ctx = (0, $qoWOx.twistedEdwards)({
    ...$f07bd5acd6595f86$var$ed25519Defaults,
    domain: $f07bd5acd6595f86$var$ed25519_domain
});
module.exports.ed25519ph = (0, $qoWOx.twistedEdwards)({
    ...$f07bd5acd6595f86$var$ed25519Defaults,
    domain: $f07bd5acd6595f86$var$ed25519_domain,
    prehash: $bZ4nb.sha512
});
module.exports.x25519 = (()=>(0, $kiLeO.montgomery)({
        P: $f07bd5acd6595f86$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $f07bd5acd6595f86$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $f07bd5acd6595f86$var$ed25519_pow_2_252_3(x);
            return (0, $2D9sF.mod)((0, $2D9sF.pow2)(pow_p_5_8, BigInt(3), P) * b2, P);
        },
        adjustScalarBytes: $f07bd5acd6595f86$var$adjustScalarBytes,
        randomBytes: $9BbKC.randomBytes
    }))();
/**
 * Converts ed25519 public key to x25519 public key. Uses formula:
 * * `(u, v) = ((1+y)/(1-y), sqrt(-486664)*u/x)`
 * * `(x, y) = (sqrt(-486664)*u/v, (u-1)/(u+1))`
 * @example
 *   const someonesPub = ed25519.getPublicKey(ed25519.utils.randomPrivateKey());
 *   const aPriv = x25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(aPriv, edwardsToMontgomeryPub(someonesPub))
 */ function $f07bd5acd6595f86$var$edwardsToMontgomeryPub(edwardsPub) {
    const { y: y } = module.exports.ed25519.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $f07bd5acd6595f86$var$Fp.toBytes($f07bd5acd6595f86$var$Fp.create((_1n + y) * $f07bd5acd6595f86$var$Fp.inv(_1n - y)));
}
module.exports.edwardsToMontgomeryPub = $f07bd5acd6595f86$var$edwardsToMontgomeryPub;
module.exports.edwardsToMontgomery = $f07bd5acd6595f86$var$edwardsToMontgomeryPub; // deprecated
/**
 * Converts ed25519 secret key to x25519 secret key.
 * @example
 *   const someonesPub = x25519.getPublicKey(x25519.utils.randomPrivateKey());
 *   const aPriv = ed25519.utils.randomPrivateKey();
 *   x25519.getSharedSecret(edwardsToMontgomeryPriv(aPriv), someonesPub)
 */ function $f07bd5acd6595f86$var$edwardsToMontgomeryPriv(edwardsPriv) {
    const hashed = $f07bd5acd6595f86$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $f07bd5acd6595f86$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
module.exports.edwardsToMontgomeryPriv = $f07bd5acd6595f86$var$edwardsToMontgomeryPriv;
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $f07bd5acd6595f86$var$ELL2_C1 = ($f07bd5acd6595f86$var$Fp.ORDER + BigInt(3)) / BigInt(8); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $f07bd5acd6595f86$var$ELL2_C2 = $f07bd5acd6595f86$var$Fp.pow($f07bd5acd6595f86$var$_2n, $f07bd5acd6595f86$var$ELL2_C1); // 2. c2 = 2^c1
const $f07bd5acd6595f86$var$ELL2_C3 = $f07bd5acd6595f86$var$Fp.sqrt($f07bd5acd6595f86$var$Fp.neg($f07bd5acd6595f86$var$Fp.ONE)); // 3. c3 = sqrt(-1)
const $f07bd5acd6595f86$var$ELL2_C4 = ($f07bd5acd6595f86$var$Fp.ORDER - BigInt(5)) / BigInt(8); // 4. c4 = (q - 5) / 8       # Integer arithmetic
const $f07bd5acd6595f86$var$ELL2_J = BigInt(486662);
// prettier-ignore
function $f07bd5acd6595f86$var$map_to_curve_elligator2_curve25519(u) {
    let tv1 = $f07bd5acd6595f86$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $f07bd5acd6595f86$var$Fp.mul(tv1, $f07bd5acd6595f86$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $f07bd5acd6595f86$var$Fp.add(tv1, $f07bd5acd6595f86$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $f07bd5acd6595f86$var$Fp.neg($f07bd5acd6595f86$var$ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $f07bd5acd6595f86$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $f07bd5acd6595f86$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $f07bd5acd6595f86$var$Fp.mul(tv1, $f07bd5acd6595f86$var$ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $f07bd5acd6595f86$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $f07bd5acd6595f86$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $f07bd5acd6595f86$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $f07bd5acd6595f86$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $f07bd5acd6595f86$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $f07bd5acd6595f86$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $f07bd5acd6595f86$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $f07bd5acd6595f86$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $f07bd5acd6595f86$var$Fp.pow(tv2, $f07bd5acd6595f86$var$ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $f07bd5acd6595f86$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $f07bd5acd6595f86$var$Fp.mul(y11, $f07bd5acd6595f86$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $f07bd5acd6595f86$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $f07bd5acd6595f86$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $f07bd5acd6595f86$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $f07bd5acd6595f86$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $f07bd5acd6595f86$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $f07bd5acd6595f86$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $f07bd5acd6595f86$var$Fp.mul(y21, $f07bd5acd6595f86$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $f07bd5acd6595f86$var$Fp.mul(y21, $f07bd5acd6595f86$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $f07bd5acd6595f86$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $f07bd5acd6595f86$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $f07bd5acd6595f86$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $f07bd5acd6595f86$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $f07bd5acd6595f86$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $f07bd5acd6595f86$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $f07bd5acd6595f86$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $f07bd5acd6595f86$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $f07bd5acd6595f86$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $f07bd5acd6595f86$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $f07bd5acd6595f86$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $f07bd5acd6595f86$var$Fp.cmov(y, $f07bd5acd6595f86$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $f07bd5acd6595f86$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $f07bd5acd6595f86$var$ELL2_C1_EDWARDS = (0, $2D9sF.FpSqrtEven)($f07bd5acd6595f86$var$Fp, $f07bd5acd6595f86$var$Fp.neg(BigInt(486664))); // sgn0(c1) MUST equal 0
function $f07bd5acd6595f86$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $f07bd5acd6595f86$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $f07bd5acd6595f86$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $f07bd5acd6595f86$var$Fp.mul(xn, $f07bd5acd6595f86$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $f07bd5acd6595f86$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $f07bd5acd6595f86$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $f07bd5acd6595f86$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $f07bd5acd6595f86$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $f07bd5acd6595f86$var$Fp.eql(tv1, $f07bd5acd6595f86$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $f07bd5acd6595f86$var$Fp.cmov(xn, $f07bd5acd6595f86$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $f07bd5acd6595f86$var$Fp.cmov(xd, $f07bd5acd6595f86$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $f07bd5acd6595f86$var$Fp.cmov(yn, $f07bd5acd6595f86$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $f07bd5acd6595f86$var$Fp.cmov(yd, $f07bd5acd6595f86$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $f07bd5acd6595f86$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $f07bd5acd6595f86$var$Fp.mul(xn, inv[0]),
        y: $f07bd5acd6595f86$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $f07bd5acd6595f86$var$htf = /* @__PURE__ */ (()=>(0, $rkPJ6.createHasher)(module.exports.ed25519.ExtendedPoint, (scalars)=>$f07bd5acd6595f86$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $f07bd5acd6595f86$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $bZ4nb.sha512
    }))();
module.exports.hashToCurve = (()=>$f07bd5acd6595f86$var$htf.hashToCurve)();
module.exports.encodeToCurve = (()=>$f07bd5acd6595f86$var$htf.encodeToCurve)();
function $f07bd5acd6595f86$var$assertRstPoint(other) {
    if (!(other instanceof $f07bd5acd6595f86$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $f07bd5acd6595f86$var$SQRT_M1 = $f07bd5acd6595f86$var$ED25519_SQRT_M1;
// √(ad - 1)
const $f07bd5acd6595f86$var$SQRT_AD_MINUS_ONE = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $f07bd5acd6595f86$var$INVSQRT_A_MINUS_D = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $f07bd5acd6595f86$var$ONE_MINUS_D_SQ = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $f07bd5acd6595f86$var$D_MINUS_ONE_SQ = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $f07bd5acd6595f86$var$invertSqrt = (number)=>$f07bd5acd6595f86$var$uvRatio($f07bd5acd6595f86$var$_1n, number);
const $f07bd5acd6595f86$var$MAX_255B = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $f07bd5acd6595f86$var$bytes255ToNumberLE = (bytes)=>module.exports.ed25519.CURVE.Fp.create((0, $esaJO.bytesToNumberLE)(bytes) & $f07bd5acd6595f86$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $f07bd5acd6595f86$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = module.exports.ed25519.CURVE;
    const P = module.exports.ed25519.CURVE.Fp.ORDER;
    const mod = module.exports.ed25519.CURVE.Fp.create;
    const r = mod($f07bd5acd6595f86$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $f07bd5acd6595f86$var$_1n) * $f07bd5acd6595f86$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $f07bd5acd6595f86$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $2D9sF.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $f07bd5acd6595f86$var$_1n) * $f07bd5acd6595f86$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $f07bd5acd6595f86$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($f07bd5acd6595f86$var$_1n - s2); // 12
    const W3 = mod($f07bd5acd6595f86$var$_1n + s2); // 13
    return new module.exports.ed25519.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $f07bd5acd6595f86$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $f07bd5acd6595f86$var$RistPoint(module.exports.ed25519.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $esaJO.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $f07bd5acd6595f86$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $f07bd5acd6595f86$var$calcElligatorRistrettoMap(r1);
        const r2 = $f07bd5acd6595f86$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $f07bd5acd6595f86$var$calcElligatorRistrettoMap(r2);
        return new $f07bd5acd6595f86$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $esaJO.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = module.exports.ed25519.CURVE;
        const P = module.exports.ed25519.CURVE.Fp.ORDER;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $f07bd5acd6595f86$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $esaJO.equalBytes)((0, $esaJO.numberToBytesLE)(s, 32), hex) || (0, $2D9sF.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($f07bd5acd6595f86$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($f07bd5acd6595f86$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $f07bd5acd6595f86$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $2D9sF.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $2D9sF.isNegativeLE)(t, P) || y === $f07bd5acd6595f86$var$_0n) throw new Error(emsg);
        return new $f07bd5acd6595f86$var$RistPoint(new module.exports.ed25519.ExtendedPoint(x, y, $f07bd5acd6595f86$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = module.exports.ed25519.CURVE.Fp.ORDER;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $f07bd5acd6595f86$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $2D9sF.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $f07bd5acd6595f86$var$SQRT_M1);
            let _y = mod(x * $f07bd5acd6595f86$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $f07bd5acd6595f86$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $2D9sF.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $2D9sF.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $esaJO.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $esaJO.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $f07bd5acd6595f86$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = module.exports.ed25519.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $f07bd5acd6595f86$var$assertRstPoint(other);
        return new $f07bd5acd6595f86$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $f07bd5acd6595f86$var$assertRstPoint(other);
        return new $f07bd5acd6595f86$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $f07bd5acd6595f86$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $f07bd5acd6595f86$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
}
module.exports.RistrettoPoint = (()=>{
    if (!$f07bd5acd6595f86$var$RistPoint.BASE) $f07bd5acd6595f86$var$RistPoint.BASE = new $f07bd5acd6595f86$var$RistPoint(module.exports.ed25519.ExtendedPoint.BASE);
    if (!$f07bd5acd6595f86$var$RistPoint.ZERO) $f07bd5acd6595f86$var$RistPoint.ZERO = new $f07bd5acd6595f86$var$RistPoint(module.exports.ed25519.ExtendedPoint.ZERO);
    return $f07bd5acd6595f86$var$RistPoint;
})();
// Hashing to ristretto255. https://www.rfc-editor.org/rfc/rfc9380#appendix-B
const $f07bd5acd6595f86$var$hashToRistretto255 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $9BbKC.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $rkPJ6.expand_message_xmd)(msg, DST, 64, $bZ4nb.sha512);
    const P = $f07bd5acd6595f86$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
module.exports.hashToRistretto255 = $f07bd5acd6595f86$var$hashToRistretto255;
module.exports.hash_to_ristretto255 = module.exports.hashToRistretto255; // legacy

});
parcelRegister("bZ4nb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha384 = module.exports.sha512_256 = module.exports.sha512_224 = module.exports.sha512 = module.exports.SHA512 = void 0;

var $fwPy5 = parcelRequire("fwPy5");

var $gGzdG = parcelRequire("gGzdG");

var $9BbKC = parcelRequire("9BbKC");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$8b98c89755732a90$var$SHA512_Kh, $8b98c89755732a90$var$SHA512_Kl] = /* @__PURE__ */ (()=>$gGzdG.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $8b98c89755732a90$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $8b98c89755732a90$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $8b98c89755732a90$var$SHA512 extends $fwPy5.SHA2 {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $8b98c89755732a90$var$SHA512_W_H[i] = view.getUint32(offset);
            $8b98c89755732a90$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $8b98c89755732a90$var$SHA512_W_H[i - 15] | 0;
            const W15l = $8b98c89755732a90$var$SHA512_W_L[i - 15] | 0;
            const s0h = $gGzdG.default.rotrSH(W15h, W15l, 1) ^ $gGzdG.default.rotrSH(W15h, W15l, 8) ^ $gGzdG.default.shrSH(W15h, W15l, 7);
            const s0l = $gGzdG.default.rotrSL(W15h, W15l, 1) ^ $gGzdG.default.rotrSL(W15h, W15l, 8) ^ $gGzdG.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $8b98c89755732a90$var$SHA512_W_H[i - 2] | 0;
            const W2l = $8b98c89755732a90$var$SHA512_W_L[i - 2] | 0;
            const s1h = $gGzdG.default.rotrSH(W2h, W2l, 19) ^ $gGzdG.default.rotrBH(W2h, W2l, 61) ^ $gGzdG.default.shrSH(W2h, W2l, 6);
            const s1l = $gGzdG.default.rotrSL(W2h, W2l, 19) ^ $gGzdG.default.rotrBL(W2h, W2l, 61) ^ $gGzdG.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $gGzdG.default.add4L(s0l, s1l, $8b98c89755732a90$var$SHA512_W_L[i - 7], $8b98c89755732a90$var$SHA512_W_L[i - 16]);
            const SUMh = $gGzdG.default.add4H(SUMl, s0h, s1h, $8b98c89755732a90$var$SHA512_W_H[i - 7], $8b98c89755732a90$var$SHA512_W_H[i - 16]);
            $8b98c89755732a90$var$SHA512_W_H[i] = SUMh | 0;
            $8b98c89755732a90$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $gGzdG.default.rotrSH(Eh, El, 14) ^ $gGzdG.default.rotrSH(Eh, El, 18) ^ $gGzdG.default.rotrBH(Eh, El, 41);
            const sigma1l = $gGzdG.default.rotrSL(Eh, El, 14) ^ $gGzdG.default.rotrSL(Eh, El, 18) ^ $gGzdG.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $gGzdG.default.add5L(Hl, sigma1l, CHIl, $8b98c89755732a90$var$SHA512_Kl[i], $8b98c89755732a90$var$SHA512_W_L[i]);
            const T1h = $gGzdG.default.add5H(T1ll, Hh, sigma1h, CHIh, $8b98c89755732a90$var$SHA512_Kh[i], $8b98c89755732a90$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $gGzdG.default.rotrSH(Ah, Al, 28) ^ $gGzdG.default.rotrBH(Ah, Al, 34) ^ $gGzdG.default.rotrBH(Ah, Al, 39);
            const sigma0l = $gGzdG.default.rotrSL(Ah, Al, 28) ^ $gGzdG.default.rotrBL(Ah, Al, 34) ^ $gGzdG.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $gGzdG.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $gGzdG.default.add3L(T1l, sigma0l, MAJl);
            Ah = $gGzdG.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $gGzdG.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $gGzdG.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $gGzdG.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $gGzdG.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $gGzdG.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $gGzdG.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $gGzdG.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $gGzdG.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $8b98c89755732a90$var$SHA512_W_H.fill(0);
        $8b98c89755732a90$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
module.exports.SHA512 = $8b98c89755732a90$var$SHA512;
class $8b98c89755732a90$var$SHA512_224 extends $8b98c89755732a90$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $8b98c89755732a90$var$SHA512_256 extends $8b98c89755732a90$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $8b98c89755732a90$var$SHA384 extends $8b98c89755732a90$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
module.exports.sha512 = (0, $9BbKC.wrapConstructor)(()=>new $8b98c89755732a90$var$SHA512());
module.exports.sha512_224 = (0, $9BbKC.wrapConstructor)(()=>new $8b98c89755732a90$var$SHA512_224());
module.exports.sha512_256 = (0, $9BbKC.wrapConstructor)(()=>new $8b98c89755732a90$var$SHA512_256());
module.exports.sha384 = (0, $9BbKC.wrapConstructor)(()=>new $8b98c89755732a90$var$SHA384());

});
parcelRegister("fwPy5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $dAIf1 = parcelRequire("dAIf1");

var $9BbKC = parcelRequire("9BbKC");
// Polyfill for Safari 14
function $b4e1d4aa1af05b71$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $b4e1d4aa1af05b71$var$SHA2 extends $9BbKC.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $9BbKC.createView)(this.buffer);
    }
    update(data) {
        (0, $dAIf1.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $9BbKC.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $9BbKC.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $dAIf1.exists)(this);
        (0, $dAIf1.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $b4e1d4aa1af05b71$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $9BbKC.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $b4e1d4aa1af05b71$var$SHA2;

});
parcelRegister("dAIf1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $9e50f49469d56a92$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $9e50f49469d56a92$var$number;
function $9e50f49469d56a92$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $9e50f49469d56a92$var$bool;
function $9e50f49469d56a92$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $9e50f49469d56a92$var$bytes;
function $9e50f49469d56a92$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $9e50f49469d56a92$var$number(hash.outputLen);
    $9e50f49469d56a92$var$number(hash.blockLen);
}
module.exports.hash = $9e50f49469d56a92$var$hash;
function $9e50f49469d56a92$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $9e50f49469d56a92$var$exists;
function $9e50f49469d56a92$var$output(out, instance) {
    $9e50f49469d56a92$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $9e50f49469d56a92$var$output;
const $9e50f49469d56a92$var$assert = {
    number: $9e50f49469d56a92$var$number,
    bool: $9e50f49469d56a92$var$bool,
    bytes: $9e50f49469d56a92$var$bytes,
    hash: $9e50f49469d56a92$var$hash,
    exists: $9e50f49469d56a92$var$exists,
    output: $9e50f49469d56a92$var$output
};
module.exports.default = $9e50f49469d56a92$var$assert;

});

parcelRegister("9BbKC", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $gEhde = parcelRequire("gEhde");
const $6fd0af385bc5ccc9$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $6fd0af385bc5ccc9$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $6fd0af385bc5ccc9$var$u8;
const $6fd0af385bc5ccc9$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $6fd0af385bc5ccc9$var$u32;
// Cast array to view
const $6fd0af385bc5ccc9$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $6fd0af385bc5ccc9$var$createView;
// The rotate right (circular right shift) operation for uint32
const $6fd0af385bc5ccc9$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $6fd0af385bc5ccc9$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $6fd0af385bc5ccc9$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $6fd0af385bc5ccc9$var$bytesToHex(bytes) {
    if (!$6fd0af385bc5ccc9$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $6fd0af385bc5ccc9$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $6fd0af385bc5ccc9$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $6fd0af385bc5ccc9$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $6fd0af385bc5ccc9$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $6fd0af385bc5ccc9$var$nextTick = async ()=>{};
module.exports.nextTick = $6fd0af385bc5ccc9$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $6fd0af385bc5ccc9$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $6fd0af385bc5ccc9$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $6fd0af385bc5ccc9$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $6fd0af385bc5ccc9$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $6fd0af385bc5ccc9$var$toBytes(data) {
    if (typeof data === "string") data = $6fd0af385bc5ccc9$var$utf8ToBytes(data);
    if (!$6fd0af385bc5ccc9$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $6fd0af385bc5ccc9$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $6fd0af385bc5ccc9$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$6fd0af385bc5ccc9$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $6fd0af385bc5ccc9$var$concatBytes;
// For runtime check if class implements interface
class $6fd0af385bc5ccc9$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $6fd0af385bc5ccc9$var$Hash;
const $6fd0af385bc5ccc9$var$toStr = {}.toString;
function $6fd0af385bc5ccc9$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $6fd0af385bc5ccc9$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $6fd0af385bc5ccc9$var$checkOpts;
function $6fd0af385bc5ccc9$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($6fd0af385bc5ccc9$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $6fd0af385bc5ccc9$var$wrapConstructor;
function $6fd0af385bc5ccc9$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6fd0af385bc5ccc9$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $6fd0af385bc5ccc9$var$wrapConstructorWithOpts;
function $6fd0af385bc5ccc9$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($6fd0af385bc5ccc9$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $6fd0af385bc5ccc9$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $6fd0af385bc5ccc9$var$randomBytes(bytesLength = 32) {
    if ($gEhde.crypto && typeof $gEhde.crypto.getRandomValues === "function") return $gEhde.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $6fd0af385bc5ccc9$var$randomBytes;

});
parcelRegister("gEhde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("gGzdG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $c25be37d212065ae$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $c25be37d212065ae$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $c25be37d212065ae$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $c25be37d212065ae$var$U32_MASK64),
        l: Number(n >> $c25be37d212065ae$var$_32n & $c25be37d212065ae$var$U32_MASK64)
    };
    return {
        h: Number(n >> $c25be37d212065ae$var$_32n & $c25be37d212065ae$var$U32_MASK64) | 0,
        l: Number(n & $c25be37d212065ae$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $c25be37d212065ae$var$fromBig;
function $c25be37d212065ae$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $c25be37d212065ae$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $c25be37d212065ae$var$split;
const $c25be37d212065ae$var$toBig = (h, l)=>BigInt(h >>> 0) << $c25be37d212065ae$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $c25be37d212065ae$var$toBig;
// for Shift in [0, 32)
const $c25be37d212065ae$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $c25be37d212065ae$var$shrSH;
const $c25be37d212065ae$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $c25be37d212065ae$var$shrSL;
// Right rotate for Shift in [1, 32)
const $c25be37d212065ae$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $c25be37d212065ae$var$rotrSH;
const $c25be37d212065ae$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $c25be37d212065ae$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c25be37d212065ae$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $c25be37d212065ae$var$rotrBH;
const $c25be37d212065ae$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $c25be37d212065ae$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $c25be37d212065ae$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $c25be37d212065ae$var$rotr32H;
const $c25be37d212065ae$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $c25be37d212065ae$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $c25be37d212065ae$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $c25be37d212065ae$var$rotlSH;
const $c25be37d212065ae$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $c25be37d212065ae$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c25be37d212065ae$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $c25be37d212065ae$var$rotlBH;
const $c25be37d212065ae$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $c25be37d212065ae$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $c25be37d212065ae$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $c25be37d212065ae$var$add;
// Addition with more than 2 elements
const $c25be37d212065ae$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $c25be37d212065ae$var$add3L;
const $c25be37d212065ae$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $c25be37d212065ae$var$add3H;
const $c25be37d212065ae$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $c25be37d212065ae$var$add4L;
const $c25be37d212065ae$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $c25be37d212065ae$var$add4H;
const $c25be37d212065ae$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $c25be37d212065ae$var$add5L;
const $c25be37d212065ae$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $c25be37d212065ae$var$add5H;
// prettier-ignore
const $c25be37d212065ae$var$u64 = {
    fromBig: $c25be37d212065ae$var$fromBig,
    split: $c25be37d212065ae$var$split,
    toBig: $c25be37d212065ae$var$toBig,
    shrSH: $c25be37d212065ae$var$shrSH,
    shrSL: $c25be37d212065ae$var$shrSL,
    rotrSH: $c25be37d212065ae$var$rotrSH,
    rotrSL: $c25be37d212065ae$var$rotrSL,
    rotrBH: $c25be37d212065ae$var$rotrBH,
    rotrBL: $c25be37d212065ae$var$rotrBL,
    rotr32H: $c25be37d212065ae$var$rotr32H,
    rotr32L: $c25be37d212065ae$var$rotr32L,
    rotlSH: $c25be37d212065ae$var$rotlSH,
    rotlSL: $c25be37d212065ae$var$rotlSL,
    rotlBH: $c25be37d212065ae$var$rotlBH,
    rotlBL: $c25be37d212065ae$var$rotlBL,
    add: $c25be37d212065ae$var$add,
    add3L: $c25be37d212065ae$var$add3L,
    add3H: $c25be37d212065ae$var$add3H,
    add4L: $c25be37d212065ae$var$add4L,
    add4H: $c25be37d212065ae$var$add4H,
    add5H: $c25be37d212065ae$var$add5H,
    add5L: $c25be37d212065ae$var$add5L
};
module.exports.default = $c25be37d212065ae$var$u64;

});


parcelRegister("qoWOx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.twistedEdwards = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

var $esaJO = parcelRequire("esaJO");

var $lkFCe = parcelRequire("lkFCe");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $04f5c7e644575b38$var$_0n = BigInt(0), $04f5c7e644575b38$var$_1n = BigInt(1), $04f5c7e644575b38$var$_2n = BigInt(2), $04f5c7e644575b38$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $04f5c7e644575b38$var$VERIFY_DEFAULT = {
    zip215: true
};
function $04f5c7e644575b38$var$validateOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
// It is not generic twisted curve for now, but ed25519/ed448 generic implementation
function $04f5c7e644575b38$var$twistedEdwards(curveDef) {
    const CURVE = $04f5c7e644575b38$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $04f5c7e644575b38$var$_2n << BigInt(nByteLength * 8) - $04f5c7e644575b38$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $04f5c7e644575b38$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    const inBig = (n)=>typeof n === "bigint" && $04f5c7e644575b38$var$_0n < n; // n in [1..]
    const inRange = (n, max)=>inBig(n) && inBig(max) && n < max; // n in [1..max-1]
    const in0MaskRange = (n)=>n === $04f5c7e644575b38$var$_0n || inRange(n, MASK); // n in [0..MASK-1]
    function assertInRange(n, max) {
        // n in [1..max-1]
        if (inRange(n, max)) return n;
        throw new Error(`Expected valid scalar < ${max}, got ${typeof n} ${n}`);
    }
    function assertGE0(n) {
        // n in [0..CURVE_ORDER-1]
        return n === $04f5c7e644575b38$var$_0n ? n : assertInRange(n, CURVE_ORDER); // GE = prime subgroup, not full group
    }
    const pointPrecomputes = new Map();
    function isPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            if (!in0MaskRange(ex)) throw new Error("x required");
            if (!in0MaskRange(ey)) throw new Error("y required");
            if (!in0MaskRange(ez)) throw new Error("z required");
            if (!in0MaskRange(et)) throw new Error("t required");
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            if (!in0MaskRange(x) || !in0MaskRange(y)) throw new Error("invalid affine point");
            return new Point(x, y, $04f5c7e644575b38$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            const { a: a, d: d } = CURVE;
            if (this.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
            // Equation in affine coordinates: ax² + y² = 1 + dx²y²
            // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
            const { ex: X, ey: Y, ez: Z, et: T } = this;
            const X2 = modP(X * X); // X²
            const Y2 = modP(Y * Y); // Y²
            const Z2 = modP(Z * Z); // Z²
            const Z4 = modP(Z2 * Z2); // Z⁴
            const aX2 = modP(X2 * a); // aX²
            const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
            const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
            if (left !== right) throw new Error("bad point: equation left != right (1)");
            // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
            const XY = modP(X * Y);
            const ZT = modP(Z * T);
            if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        }
        // Compare one point to another.
        equals(other) {
            isPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($04f5c7e644575b38$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            isPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $04f5c7e644575b38$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $04f5c7e644575b38$var$_2n * T2);
                const D = modP(T1 * $04f5c7e644575b38$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const { p: p, f: f } = this.wNAF(assertInRange(scalar, CURVE_ORDER));
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            let n = assertGE0(scalar); // 0 <= scalar < CURVE.n
            if (n === $04f5c7e644575b38$var$_0n) return I;
            if (this.equals(I) || n === $04f5c7e644575b38$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            const { ex: x, ey: y, ez: z } = this;
            const is0 = this.is0();
            if (iz == null) iz = is0 ? $04f5c7e644575b38$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
            const ax = modP(x * iz);
            const ay = modP(y * iz);
            const zz = modP(z * iz);
            if (is0) return {
                x: $04f5c7e644575b38$var$_0n,
                y: $04f5c7e644575b38$var$_1n
            };
            if (zz !== $04f5c7e644575b38$var$_1n) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $04f5c7e644575b38$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $esaJO.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $esaJO.bytesToNumberLE(normed);
            if (y === $04f5c7e644575b38$var$_0n) ;
            else // RFC8032 prohibits >= p, but ZIP215 doesn't
            if (zip215) assertInRange(y, MASK); // zip215=true [1..P-1] (2^255-19-1 for ed25519)
            else assertInRange(y, Fp.ORDER); // zip215=false [1..MASK-1] (2^256-1 for ed25519)
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $04f5c7e644575b38$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $04f5c7e644575b38$var$_1n) === $04f5c7e644575b38$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $04f5c7e644575b38$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $esaJO.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $04f5c7e644575b38$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $esaJO.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $04f5c7e644575b38$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($04f5c7e644575b38$var$_0n, $04f5c7e644575b38$var$_1n, $04f5c7e644575b38$var$_1n, $04f5c7e644575b38$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $lkFCe.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $2D9sF.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($esaJO.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $esaJO.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $esaJO.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $esaJO.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $esaJO.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $esaJO.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        assertGE0(s); // 0 <= s < l
        const res = $esaJO.concatBytes(R, $esaJO.numberToBytesLE(s, Fp.BYTES));
        return (0, $esaJO.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $04f5c7e644575b38$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $esaJO.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $esaJO.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $esaJO.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}
module.exports.twistedEdwards = $04f5c7e644575b38$var$twistedEdwards;

});
parcelRegister("2D9sF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapHashToField = module.exports.getMinHashLength = module.exports.getFieldBytesLength = module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $esaJO = parcelRequire("esaJO");
// prettier-ignore
const $1ea6901afdde618b$var$_0n = BigInt(0), $1ea6901afdde618b$var$_1n = BigInt(1), $1ea6901afdde618b$var$_2n = BigInt(2), $1ea6901afdde618b$var$_3n = BigInt(3);
// prettier-ignore
const $1ea6901afdde618b$var$_4n = BigInt(4), $1ea6901afdde618b$var$_5n = BigInt(5), $1ea6901afdde618b$var$_8n = BigInt(8);
// prettier-ignore
const $1ea6901afdde618b$var$_9n = BigInt(9), $1ea6901afdde618b$var$_16n = BigInt(16);
// Calculates a modulo b
function $1ea6901afdde618b$var$mod(a, b) {
    const result = a % b;
    return result >= $1ea6901afdde618b$var$_0n ? result : b + result;
}
module.exports.mod = $1ea6901afdde618b$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $1ea6901afdde618b$var$pow(num, power, modulo) {
    if (modulo <= $1ea6901afdde618b$var$_0n || power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $1ea6901afdde618b$var$_1n) return $1ea6901afdde618b$var$_0n;
    let res = $1ea6901afdde618b$var$_1n;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return res;
}
module.exports.pow = $1ea6901afdde618b$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $1ea6901afdde618b$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $1ea6901afdde618b$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $1ea6901afdde618b$var$pow2;
// Inverses number over modulo
function $1ea6901afdde618b$var$invert(number, modulo) {
    if (number === $1ea6901afdde618b$var$_0n || modulo <= $1ea6901afdde618b$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $1ea6901afdde618b$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $1ea6901afdde618b$var$_0n, y = $1ea6901afdde618b$var$_1n, u = $1ea6901afdde618b$var$_1n, v = $1ea6901afdde618b$var$_0n;
    while(a !== $1ea6901afdde618b$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $1ea6901afdde618b$var$_1n) throw new Error("invert: does not exist");
    return $1ea6901afdde618b$var$mod(x, modulo);
}
module.exports.invert = $1ea6901afdde618b$var$invert;
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $1ea6901afdde618b$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $1ea6901afdde618b$var$_1n, S = 0; Q % $1ea6901afdde618b$var$_2n === $1ea6901afdde618b$var$_0n; Q /= $1ea6901afdde618b$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $1ea6901afdde618b$var$_2n; Z < P && $1ea6901afdde618b$var$pow(Z, legendreC, P) !== P - $1ea6901afdde618b$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $1ea6901afdde618b$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $1ea6901afdde618b$var$tonelliShanks;
function $1ea6901afdde618b$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $1ea6901afdde618b$var$_4n === $1ea6901afdde618b$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $1ea6901afdde618b$var$_8n === $1ea6901afdde618b$var$_5n) {
        const c1 = (P - $1ea6901afdde618b$var$_5n) / $1ea6901afdde618b$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $1ea6901afdde618b$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $1ea6901afdde618b$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $1ea6901afdde618b$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $1ea6901afdde618b$var$tonelliShanks(P);
}
module.exports.FpSqrt = $1ea6901afdde618b$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $1ea6901afdde618b$var$isNegativeLE = (num, modulo)=>($1ea6901afdde618b$var$mod(num, modulo) & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n;
module.exports.isNegativeLE = $1ea6901afdde618b$var$isNegativeLE;
// prettier-ignore
const $1ea6901afdde618b$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $1ea6901afdde618b$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $1ea6901afdde618b$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $esaJO.validateObject)(field, opts);
}
module.exports.validateField = $1ea6901afdde618b$var$validateField;
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $1ea6901afdde618b$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power > 0");
    if (power === $1ea6901afdde618b$var$_0n) return f.ONE;
    if (power === $1ea6901afdde618b$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return p;
}
module.exports.FpPow = $1ea6901afdde618b$var$FpPow;
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $1ea6901afdde618b$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $1ea6901afdde618b$var$FpInvertBatch;
function $1ea6901afdde618b$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $1ea6901afdde618b$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $1ea6901afdde618b$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $1ea6901afdde618b$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $1ea6901afdde618b$var$FpIsSquare;
// CURVE.n lengths
function $1ea6901afdde618b$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $1ea6901afdde618b$var$nLength;
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $1ea6901afdde618b$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $1ea6901afdde618b$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $1ea6901afdde618b$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $1ea6901afdde618b$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $esaJO.bitMask)(BITS),
        ZERO: $1ea6901afdde618b$var$_0n,
        ONE: $1ea6901afdde618b$var$_1n,
        create: (num)=>$1ea6901afdde618b$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $1ea6901afdde618b$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $1ea6901afdde618b$var$_0n,
        isOdd: (num)=>(num & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n,
        neg: (num)=>$1ea6901afdde618b$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$1ea6901afdde618b$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$1ea6901afdde618b$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * $1ea6901afdde618b$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$1ea6901afdde618b$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$1ea6901afdde618b$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $esaJO.numberToBytesLE)(num, BYTES) : (0, $esaJO.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $esaJO.bytesToNumberLE)(bytes) : (0, $esaJO.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $1ea6901afdde618b$var$Field;
function $1ea6901afdde618b$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $1ea6901afdde618b$var$FpSqrtOdd;
function $1ea6901afdde618b$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $1ea6901afdde618b$var$FpSqrtEven;
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $1ea6901afdde618b$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $esaJO.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $1ea6901afdde618b$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $esaJO.bytesToNumberLE)(hash) : (0, $esaJO.bytesToNumberBE)(hash);
    return $1ea6901afdde618b$var$mod(num, groupOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
}
module.exports.hashToPrivateScalar = $1ea6901afdde618b$var$hashToPrivateScalar;
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
module.exports.getFieldBytesLength = $1ea6901afdde618b$var$getFieldBytesLength;
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $1ea6901afdde618b$var$getMinHashLength(fieldOrder) {
    const length = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
module.exports.getMinHashLength = $1ea6901afdde618b$var$getMinHashLength;
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $1ea6901afdde618b$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    const minLen = $1ea6901afdde618b$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $esaJO.bytesToNumberBE)(key) : (0, $esaJO.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $1ea6901afdde618b$var$mod(num, fieldOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
    return isLE ? (0, $esaJO.numberToBytesLE)(reduced, fieldLen) : (0, $esaJO.numberToBytesBE)(reduced, fieldLen);
}
module.exports.mapHashToField = $1ea6901afdde618b$var$mapHashToField;

});
parcelRegister("esaJO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $a85c028f110aa8ce$var$_0n = BigInt(0);
const $a85c028f110aa8ce$var$_1n = BigInt(1);
const $a85c028f110aa8ce$var$_2n = BigInt(2);
const $a85c028f110aa8ce$var$u8a = (a)=>a instanceof Uint8Array;
const $a85c028f110aa8ce$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a85c028f110aa8ce$var$bytesToHex(bytes) {
    if (!$a85c028f110aa8ce$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a85c028f110aa8ce$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $a85c028f110aa8ce$var$bytesToHex;
function $a85c028f110aa8ce$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $a85c028f110aa8ce$var$numberToHexUnpadded;
function $a85c028f110aa8ce$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $a85c028f110aa8ce$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a85c028f110aa8ce$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $a85c028f110aa8ce$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $a85c028f110aa8ce$var$bytesToNumberBE(bytes) {
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $a85c028f110aa8ce$var$bytesToNumberBE;
function $a85c028f110aa8ce$var$bytesToNumberLE(bytes) {
    if (!$a85c028f110aa8ce$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $a85c028f110aa8ce$var$bytesToNumberLE;
function $a85c028f110aa8ce$var$numberToBytesBE(n, len) {
    return $a85c028f110aa8ce$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $a85c028f110aa8ce$var$numberToBytesBE;
function $a85c028f110aa8ce$var$numberToBytesLE(n, len) {
    return $a85c028f110aa8ce$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $a85c028f110aa8ce$var$numberToBytesLE;
// Unpadded, rarely used
function $a85c028f110aa8ce$var$numberToVarBytesBE(n) {
    return $a85c028f110aa8ce$var$hexToBytes($a85c028f110aa8ce$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $a85c028f110aa8ce$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $a85c028f110aa8ce$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $a85c028f110aa8ce$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($a85c028f110aa8ce$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $a85c028f110aa8ce$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a85c028f110aa8ce$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a85c028f110aa8ce$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $a85c028f110aa8ce$var$concatBytes;
function $a85c028f110aa8ce$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $a85c028f110aa8ce$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a85c028f110aa8ce$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $a85c028f110aa8ce$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $a85c028f110aa8ce$var$bitLen(n) {
    let len;
    for(len = 0; n > $a85c028f110aa8ce$var$_0n; n >>= $a85c028f110aa8ce$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $a85c028f110aa8ce$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $a85c028f110aa8ce$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $a85c028f110aa8ce$var$_1n;
}
module.exports.bitGet = $a85c028f110aa8ce$var$bitGet;
/**
 * Sets single bit at position.
 */ const $a85c028f110aa8ce$var$bitSet = (n, pos, value)=>{
    return n | (value ? $a85c028f110aa8ce$var$_1n : $a85c028f110aa8ce$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $a85c028f110aa8ce$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $a85c028f110aa8ce$var$bitMask = (n)=>($a85c028f110aa8ce$var$_2n << BigInt(n - 1)) - $a85c028f110aa8ce$var$_1n;
module.exports.bitMask = $a85c028f110aa8ce$var$bitMask;
// DRBG
const $a85c028f110aa8ce$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $a85c028f110aa8ce$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $a85c028f110aa8ce$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $a85c028f110aa8ce$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $a85c028f110aa8ce$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $a85c028f110aa8ce$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($a85c028f110aa8ce$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($a85c028f110aa8ce$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $a85c028f110aa8ce$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $a85c028f110aa8ce$var$createHmacDrbg;
// Validating curves and fields
const $a85c028f110aa8ce$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || val instanceof Uint8Array,
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $a85c028f110aa8ce$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $a85c028f110aa8ce$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $a85c028f110aa8ce$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("lkFCe", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $2D9sF.validateField)(curve.Fp);
    (0, $esaJO.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $2D9sF.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});


parcelRegister("kiLeO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.montgomery = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
const $ec7a218c4f0875a8$var$_0n = BigInt(0);
const $ec7a218c4f0875a8$var$_1n = BigInt(1);
function $ec7a218c4f0875a8$var$validateOpts(curve) {
    (0, $esaJO.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
// NOTE: not really montgomery curve, just bunch of very specific methods for X25519/X448 (RFC 7748, https://www.rfc-editor.org/rfc/rfc7748)
// Uses only one coordinate instead of two
function $ec7a218c4f0875a8$var$montgomery(curveDef) {
    const CURVE = $ec7a218c4f0875a8$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $2D9sF.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $2D9sF.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // Accepts 0 as well
    function assertFieldElement(n) {
        if (typeof n === "bigint" && $ec7a218c4f0875a8$var$_0n <= n && n < P) return n;
        throw new Error("Expected valid scalar 0 < scalar < CURVE.P");
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(pointU, scalar) {
        const u = assertFieldElement(pointU);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = assertFieldElement(scalar);
        const x_1 = u;
        let x_2 = $ec7a218c4f0875a8$var$_1n;
        let z_2 = $ec7a218c4f0875a8$var$_0n;
        let x_3 = u;
        let z_3 = $ec7a218c4f0875a8$var$_1n;
        let swap = $ec7a218c4f0875a8$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $ec7a218c4f0875a8$var$_0n; t--){
            const k_t = k >> t & $ec7a218c4f0875a8$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $esaJO.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        // This is very ugly way, but it works because fieldLen-1 is outside of bounds for X448, so this becomes NOOP
        // fieldLen - scalaryBytes = 1 for X448 and = 0 for X25519
        const u = (0, $esaJO.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        // u[fieldLen-1] crashes QuickJS (TypeError: out-of-bound numeric index)
        if (fieldLen === montgomeryBytes) u[fieldLen - 1] &= 127; // 0b0111_1111
        return (0, $esaJO.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $esaJO.ensureBytes)("scalar", n);
        if (bytes.length !== montgomeryBytes && bytes.length !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${bytes.length}`);
        return (0, $esaJO.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $ec7a218c4f0875a8$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}
module.exports.montgomery = $ec7a218c4f0875a8$var$montgomery;

});

parcelRegister("rkPJ6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createHasher = module.exports.isogenyMap = module.exports.hash_to_field = module.exports.expand_message_xof = module.exports.expand_message_xmd = void 0;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
function $0522aeca5769187c$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $esaJO.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $0522aeca5769187c$var$os2ip = $esaJO.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $0522aeca5769187c$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $0522aeca5769187c$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $0522aeca5769187c$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $0522aeca5769187c$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $0522aeca5769187c$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isBytes(DST);
    $0522aeca5769187c$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $esaJO.concatBytes)((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $esaJO.concatBytes)(DST, $0522aeca5769187c$var$i2osp(DST.length, 1));
    const Z_pad = $0522aeca5769187c$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $0522aeca5769187c$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $esaJO.concatBytes)(Z_pad, msg, l_i_b_str, $0522aeca5769187c$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $esaJO.concatBytes)(b_0, $0522aeca5769187c$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $0522aeca5769187c$var$strxor(b_0, b[i - 1]),
            $0522aeca5769187c$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $esaJO.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $esaJO.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
module.exports.expand_message_xmd = $0522aeca5769187c$var$expand_message_xmd;
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $0522aeca5769187c$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isBytes(DST);
    $0522aeca5769187c$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($0522aeca5769187c$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($0522aeca5769187c$var$i2osp(DST.length, 1)).digest();
}
module.exports.expand_message_xof = $0522aeca5769187c$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $0522aeca5769187c$var$hash_to_field(msg, count, options) {
    (0, $esaJO.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $0522aeca5769187c$var$isBytes(msg);
    $0522aeca5769187c$var$isNum(count);
    const DST = $0522aeca5769187c$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $0522aeca5769187c$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $0522aeca5769187c$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $2D9sF.mod)($0522aeca5769187c$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
module.exports.hash_to_field = $0522aeca5769187c$var$hash_to_field;
function $0522aeca5769187c$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
module.exports.isogenyMap = $0522aeca5769187c$var$isogenyMap;
function $0522aeca5769187c$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
module.exports.createHasher = $0522aeca5769187c$var$createHasher;

});


parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("0kWUa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PublicKey = void 0;

var $a246u = parcelRequire("a246u");

var $hNbI3 = parcelRequire("hNbI3");

var $kE5x4 = parcelRequire("kE5x4");

var $byOaD = parcelRequire("byOaD");
function $00104040a310258b$var$key_type_to_str(keyType) {
    switch(keyType){
        case $byOaD.KeyType.ED25519:
            return "ed25519";
        default:
            throw new Error(`Unknown key type ${keyType}`);
    }
}
function $00104040a310258b$var$str_to_key_type(keyType) {
    switch(keyType.toLowerCase()){
        case "ed25519":
            return $byOaD.KeyType.ED25519;
        default:
            throw new Error(`Unknown key type ${keyType}`);
    }
}
/**
 * PublicKey representation that has type and bytes of the key.
 */ class $00104040a310258b$var$PublicKey extends $a246u.Assignable {
    /**
     * Creates a PublicKey instance from a string or an existing PublicKey instance.
     * @param value The string or PublicKey instance to create a PublicKey from.
     * @returns {PublicKey} The PublicKey instance.
     */ static from(value) {
        if (typeof value === "string") return $00104040a310258b$var$PublicKey.fromString(value);
        return value;
    }
    /**
     * Creates a PublicKey instance from an encoded key string.
     * @param encodedKey The encoded key string.
     * @returns {PublicKey} The PublicKey instance created from the encoded key string.
     */ static fromString(encodedKey) {
        const parts = encodedKey.split(":");
        let publicKey;
        let keyType = $byOaD.KeyType.ED25519;
        if (parts.length === 1) publicKey = parts[0];
        else if (parts.length === 2) {
            publicKey = parts[1];
            keyType = $00104040a310258b$var$str_to_key_type(parts[0]);
        } else throw new Error("Invalid encoded key format, must be <curve>:<encoded key>");
        const decodedPublicKey = (0, $hNbI3.baseDecode)(publicKey);
        if (decodedPublicKey.length !== $byOaD.KeySize.SECRET_KEY) throw new Error(`Invalid public key size (${decodedPublicKey.length}), must be ${$byOaD.KeySize.SECRET_KEY}`);
        return new $00104040a310258b$var$PublicKey({
            keyType: keyType,
            data: decodedPublicKey
        });
    }
    /**
     * Returns a string representation of the public key.
     * @returns {string} The string representation of the public key.
     */ toString() {
        return `${$00104040a310258b$var$key_type_to_str(this.keyType)}:${(0, $hNbI3.baseEncode)(this.data)}`;
    }
    /**
     * Verifies a message signature using the public key.
     * @param message The message to be verified.
     * @param signature The signature to be verified.
     * @returns {boolean} `true` if the signature is valid, otherwise `false`.
     */ verify(message, signature) {
        switch(this.keyType){
            case $byOaD.KeyType.ED25519:
                return $kE5x4.ed25519.verify(signature, message, this.data);
            default:
                throw new Error(`Unknown key type ${this.keyType}`);
        }
    }
}
module.exports.PublicKey = $00104040a310258b$var$PublicKey;

});




parcelRegister("dQ9Ut", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KeyStore = void 0;
/**
 * KeyStores are passed to {@link "@near-js/wallet-account".near.Near | Near} via {@link "@near-js/wallet-account".near.NearConfig | NearConfig}
 * and are used by the {@link "@near-js/signers".in_memory_signer.InMemorySigner | InMemorySigner} to sign transactions.
 *
 */ class $a137d1922bc959a8$var$KeyStore {
}
module.exports.KeyStore = $a137d1922bc959a8$var$KeyStore;

});


parcelRegister("47UKp", function(module, exports) {
"use strict";
var $3013d5b97dfb1815$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MergeKeyStore = void 0;

var $dQ9Ut = parcelRequire("dQ9Ut");
class $3013d5b97dfb1815$var$MergeKeyStore extends $dQ9Ut.KeyStore {
    /**
     * @param keyStores read calls are attempted from start to end of array
     * @param options KeyStore options
     * @param options.writeKeyStoreIndex the keystore index that will receive all write calls
     */ constructor(keyStores, options = {
        writeKeyStoreIndex: 0
    }){
        super();
        this.options = options;
        this.keyStores = keyStores;
    }
    /**
     * Store a {@link KeyPair} to the first index of a key store array
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @param keyPair The key pair to store in local storage
     */ setKey(networkId, accountId, keyPair) {
        return $3013d5b97dfb1815$var$__awaiter(this, void 0, void 0, function*() {
            yield this.keyStores[this.options.writeKeyStoreIndex].setKey(networkId, accountId, keyPair);
        });
    }
    /**
     * Gets a {@link KeyPair} from the array of key stores
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @returns {Promise<KeyPair>}
     */ getKey(networkId, accountId) {
        return $3013d5b97dfb1815$var$__awaiter(this, void 0, void 0, function*() {
            for (const keyStore of this.keyStores){
                const keyPair = yield keyStore.getKey(networkId, accountId);
                if (keyPair) return keyPair;
            }
            return null;
        });
    }
    /**
     * Removes a {@link KeyPair} from the array of key stores
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     */ removeKey(networkId, accountId) {
        return $3013d5b97dfb1815$var$__awaiter(this, void 0, void 0, function*() {
            for (const keyStore of this.keyStores)yield keyStore.removeKey(networkId, accountId);
        });
    }
    /**
     * Removes all items from each key store
     */ clear() {
        return $3013d5b97dfb1815$var$__awaiter(this, void 0, void 0, function*() {
            for (const keyStore of this.keyStores)yield keyStore.clear();
        });
    }
    /**
     * Get the network(s) from the array of key stores
     * @returns {Promise<string[]>}
     */ getNetworks() {
        return $3013d5b97dfb1815$var$__awaiter(this, void 0, void 0, function*() {
            const result = new Set();
            for (const keyStore of this.keyStores)for (const network of yield keyStore.getNetworks())result.add(network);
            return Array.from(result);
        });
    }
    /**
     * Gets the account(s) from the array of key stores
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     */ getAccounts(networkId) {
        return $3013d5b97dfb1815$var$__awaiter(this, void 0, void 0, function*() {
            const result = new Set();
            for (const keyStore of this.keyStores)for (const account of yield keyStore.getAccounts(networkId))result.add(account);
            return Array.from(result);
        });
    }
    /** @hidden */ toString() {
        return `MergeKeyStore(${this.keyStores.join(", ")})`;
    }
}
module.exports.MergeKeyStore = $3013d5b97dfb1815$var$MergeKeyStore;

});



parcelRegister("kWbvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemoryKeyStore = void 0;

var $fjvIe = parcelRequire("fjvIe");
Object.defineProperty(module.exports, "InMemoryKeyStore", {
    enumerable: true,
    get: function() {
        return $fjvIe.InMemoryKeyStore;
    }
});

});

parcelRegister("8OBr1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserLocalStorageKeyStore = void 0;

var $lkksa = parcelRequire("lkksa");
Object.defineProperty(module.exports, "BrowserLocalStorageKeyStore", {
    enumerable: true,
    get: function() {
        return $lkksa.BrowserLocalStorageKeyStore;
    }
});

});
parcelRegister("lkksa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserLocalStorageKeyStore = void 0;

var $cztZV = parcelRequire("cztZV");
Object.defineProperty(module.exports, "BrowserLocalStorageKeyStore", {
    enumerable: true,
    get: function() {
        return $cztZV.BrowserLocalStorageKeyStore;
    }
});

});
parcelRegister("cztZV", function(module, exports) {
"use strict";
var $927005d52846a22d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BrowserLocalStorageKeyStore = void 0;

var $hp647 = parcelRequire("hp647");

var $fjvIe = parcelRequire("fjvIe");
const $927005d52846a22d$var$LOCAL_STORAGE_KEY_PREFIX = "near-api-js:keystore:";
/**
 * This class is used to store keys in the browsers local storage.
 *
 * @see [https://docs.near.org/docs/develop/front-end/naj-quick-reference#key-store](https://docs.near.org/docs/develop/front-end/naj-quick-reference#key-store)
 * @example
 * ```js
 * import { connect, keyStores } from 'near-api-js';
 *
 * const keyStore = new keyStores.BrowserLocalStorageKeyStore();
 * const config = {
 *   keyStore, // instance of BrowserLocalStorageKeyStore
 *   networkId: 'testnet',
 *   nodeUrl: 'https://rpc.testnet.near.org',
 *   walletUrl: 'https://wallet.testnet.near.org',
 *   helperUrl: 'https://helper.testnet.near.org',
 *   explorerUrl: 'https://explorer.testnet.near.org'
 * };
 *
 * // inside an async function
 * const near = await connect(config)
 * ```
 */ class $927005d52846a22d$var$BrowserLocalStorageKeyStore extends $fjvIe.KeyStore {
    /**
     * @param localStorage defaults to window.localStorage
     * @param prefix defaults to `near-api-js:keystore:`
     */ constructor(localStorage = window.localStorage, prefix = $927005d52846a22d$var$LOCAL_STORAGE_KEY_PREFIX){
        super();
        this.localStorage = localStorage;
        this.prefix = prefix;
    }
    /**
     * Stores a {@link KeyPair} in local storage.
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @param keyPair The key pair to store in local storage
     */ setKey(networkId, accountId, keyPair) {
        return $927005d52846a22d$var$__awaiter(this, void 0, void 0, function*() {
            this.localStorage.setItem(this.storageKeyForSecretKey(networkId, accountId), keyPair.toString());
        });
    }
    /**
     * Gets a {@link KeyPair} from local storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     * @returns {Promise<KeyPair>}
     */ getKey(networkId, accountId) {
        return $927005d52846a22d$var$__awaiter(this, void 0, void 0, function*() {
            const value = this.localStorage.getItem(this.storageKeyForSecretKey(networkId, accountId));
            if (!value) return null;
            return $hp647.KeyPair.fromString(value);
        });
    }
    /**
     * Removes a {@link KeyPair} from local storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the key pair
     */ removeKey(networkId, accountId) {
        return $927005d52846a22d$var$__awaiter(this, void 0, void 0, function*() {
            this.localStorage.removeItem(this.storageKeyForSecretKey(networkId, accountId));
        });
    }
    /**
     * Removes all items that start with `prefix` from local storage
     */ clear() {
        return $927005d52846a22d$var$__awaiter(this, void 0, void 0, function*() {
            for (const key of this.storageKeys())if (key.startsWith(this.prefix)) this.localStorage.removeItem(key);
        });
    }
    /**
     * Get the network(s) from local storage
     * @returns {Promise<string[]>}
     */ getNetworks() {
        return $927005d52846a22d$var$__awaiter(this, void 0, void 0, function*() {
            const result = new Set();
            for (const key of this.storageKeys())if (key.startsWith(this.prefix)) {
                const parts = key.substring(this.prefix.length).split(":");
                result.add(parts[1]);
            }
            return Array.from(result.values());
        });
    }
    /**
     * Gets the account(s) from local storage
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     */ getAccounts(networkId) {
        return $927005d52846a22d$var$__awaiter(this, void 0, void 0, function*() {
            const result = new Array();
            for (const key of this.storageKeys())if (key.startsWith(this.prefix)) {
                const parts = key.substring(this.prefix.length).split(":");
                if (parts[1] === networkId) result.push(parts[0]);
            }
            return result;
        });
    }
    /**
     * @hidden
     * Helper function to retrieve a local storage key
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account tied to the storage key that's sought
     * @returns {string} An example might be: `near-api-js:keystore:near-friend:default`
     */ storageKeyForSecretKey(networkId, accountId) {
        return `${this.prefix}${accountId}:${networkId}`;
    }
    /** @hidden */ *storageKeys() {
        for(let i = 0; i < this.localStorage.length; i++)yield this.localStorage.key(i);
    }
}
module.exports.BrowserLocalStorageKeyStore = $927005d52846a22d$var$BrowserLocalStorageKeyStore;

});



parcelRegister("gFytt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MergeKeyStore = void 0;

var $fjvIe = parcelRequire("fjvIe");
Object.defineProperty(module.exports, "MergeKeyStore", {
    enumerable: true,
    get: function() {
        return $fjvIe.MergeKeyStore;
    }
});

});


parcelRegister("dyqiS", function(module, exports) {
"use strict";
var $9de2daa993895bc8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9de2daa993895bc8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9de2daa993895bc8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9de2daa993895bc8$var$__createBinding(result, mod, k);
    }
    $9de2daa993895bc8$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletConnection = module.exports.ConnectedWalletAccount = module.exports.Near = module.exports.KeyPair = module.exports.Signer = module.exports.InMemorySigner = module.exports.Contract = module.exports.Connection = module.exports.Account = module.exports.multisig = module.exports.validators = module.exports.transactions = module.exports.utils = module.exports.providers = module.exports.accountCreator = void 0;

/** @hidden @module */ const $9de2daa993895bc8$var$providers = $9de2daa993895bc8$var$__importStar((parcelRequire("2EqIG")));
module.exports.providers = $9de2daa993895bc8$var$providers;

const $9de2daa993895bc8$var$utils = $9de2daa993895bc8$var$__importStar((parcelRequire("gphuu")));
module.exports.utils = $9de2daa993895bc8$var$utils;

const $9de2daa993895bc8$var$transactions = $9de2daa993895bc8$var$__importStar((parcelRequire("9v9vF")));
module.exports.transactions = $9de2daa993895bc8$var$transactions;

const $9de2daa993895bc8$var$validators = $9de2daa993895bc8$var$__importStar((parcelRequire("hjq28")));
module.exports.validators = $9de2daa993895bc8$var$validators;

var $2As4n = parcelRequire("2As4n");
Object.defineProperty(module.exports, "Account", {
    enumerable: true,
    get: function() {
        return $2As4n.Account;
    }
});

const $9de2daa993895bc8$var$multisig = $9de2daa993895bc8$var$__importStar((parcelRequire("iJiDq")));
module.exports.multisig = $9de2daa993895bc8$var$multisig;

const $9de2daa993895bc8$var$accountCreator = $9de2daa993895bc8$var$__importStar((parcelRequire("7lsXa")));
module.exports.accountCreator = $9de2daa993895bc8$var$accountCreator;

var $aRlce = parcelRequire("aRlce");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function() {
        return $aRlce.Connection;
    }
});

var $9BnjH = parcelRequire("9BnjH");
Object.defineProperty(module.exports, "Signer", {
    enumerable: true,
    get: function() {
        return $9BnjH.Signer;
    }
});
Object.defineProperty(module.exports, "InMemorySigner", {
    enumerable: true,
    get: function() {
        return $9BnjH.InMemorySigner;
    }
});

var $jVkqH = parcelRequire("jVkqH");
Object.defineProperty(module.exports, "Contract", {
    enumerable: true,
    get: function() {
        return $jVkqH.Contract;
    }
});

var $lsY0f = parcelRequire("lsY0f");
Object.defineProperty(module.exports, "KeyPair", {
    enumerable: true,
    get: function() {
        return $lsY0f.KeyPair;
    }
});

var $bfxBf = parcelRequire("bfxBf");
Object.defineProperty(module.exports, "Near", {
    enumerable: true,
    get: function() {
        return $bfxBf.Near;
    }
});

var $DUo3W = parcelRequire("DUo3W");
Object.defineProperty(module.exports, "ConnectedWalletAccount", {
    enumerable: true,
    get: function() {
        return $DUo3W.ConnectedWalletAccount;
    }
});
Object.defineProperty(module.exports, "WalletConnection", {
    enumerable: true,
    get: function() {
        return $DUo3W.WalletConnection;
    }
});

});
parcelRegister("2EqIG", function(module, exports) {
"use strict";
/** @hidden @module */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorContext = module.exports.TypedError = module.exports.getTransactionLastResult = module.exports.FinalExecutionStatusBasic = module.exports.JsonRpcProvider = module.exports.Provider = void 0;

var $DbQq1 = parcelRequire("DbQq1");
Object.defineProperty(module.exports, "Provider", {
    enumerable: true,
    get: function() {
        return $DbQq1.Provider;
    }
});
Object.defineProperty(module.exports, "getTransactionLastResult", {
    enumerable: true,
    get: function() {
        return $DbQq1.getTransactionLastResult;
    }
});
Object.defineProperty(module.exports, "FinalExecutionStatusBasic", {
    enumerable: true,
    get: function() {
        return $DbQq1.FinalExecutionStatusBasic;
    }
});

var $fEfLd = parcelRequire("fEfLd");
Object.defineProperty(module.exports, "JsonRpcProvider", {
    enumerable: true,
    get: function() {
        return $fEfLd.JsonRpcProvider;
    }
});
Object.defineProperty(module.exports, "TypedError", {
    enumerable: true,
    get: function() {
        return $fEfLd.TypedError;
    }
});
Object.defineProperty(module.exports, "ErrorContext", {
    enumerable: true,
    get: function() {
        return $fEfLd.ErrorContext;
    }
});

});
parcelRegister("DbQq1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FinalExecutionStatusBasic = module.exports.ExecutionStatusBasic = module.exports.IdType = module.exports.Provider = module.exports.getTransactionLastResult = void 0;

var $hNbI3 = parcelRequire("hNbI3");
Object.defineProperty(module.exports, "getTransactionLastResult", {
    enumerable: true,
    get: function() {
        return $hNbI3.getTransactionLastResult;
    }
});

var $833m4 = parcelRequire("833m4");
Object.defineProperty(module.exports, "Provider", {
    enumerable: true,
    get: function() {
        return $833m4.Provider;
    }
});

var $a246u = parcelRequire("a246u");
Object.defineProperty(module.exports, "IdType", {
    enumerable: true,
    get: function() {
        return $a246u.IdType;
    }
});
Object.defineProperty(module.exports, "ExecutionStatusBasic", {
    enumerable: true,
    get: function() {
        return $a246u.ExecutionStatusBasic;
    }
});
Object.defineProperty(module.exports, "FinalExecutionStatusBasic", {
    enumerable: true,
    get: function() {
        return $a246u.FinalExecutionStatusBasic;
    }
});

});
parcelRegister("833m4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchJson = module.exports.Provider = module.exports.JsonRpcProvider = module.exports.exponentialBackoff = void 0;

var $edtcG = parcelRequire("edtcG");
Object.defineProperty(module.exports, "exponentialBackoff", {
    enumerable: true,
    get: function() {
        return $edtcG.exponentialBackoff;
    }
});

var $lhKbn = parcelRequire("lhKbn");
Object.defineProperty(module.exports, "JsonRpcProvider", {
    enumerable: true,
    get: function() {
        return $lhKbn.JsonRpcProvider;
    }
});

var $bOfeb = parcelRequire("bOfeb");
Object.defineProperty(module.exports, "Provider", {
    enumerable: true,
    get: function() {
        return $bOfeb.Provider;
    }
});

var $bzj0m = parcelRequire("bzj0m");
Object.defineProperty(module.exports, "fetchJson", {
    enumerable: true,
    get: function() {
        return $bzj0m.fetchJson;
    }
});

});
parcelRegister("edtcG", function(module, exports) {
"use strict";
var $a598eec80cc7ada0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.exponentialBackoff = void 0;
function $a598eec80cc7ada0$var$exponentialBackoff(startWaitTime, retryNumber, waitBackoff, getResult) {
    return $a598eec80cc7ada0$var$__awaiter(this, void 0, void 0, function*() {
        // TODO: jitter?
        let waitTime = startWaitTime;
        for(let i = 0; i < retryNumber; i++){
            const result = yield getResult();
            if (result) return result;
            yield $a598eec80cc7ada0$var$sleep(waitTime);
            waitTime *= waitBackoff;
        }
        return null;
    });
}
module.exports.exponentialBackoff = $a598eec80cc7ada0$var$exponentialBackoff;
// Sleep given number of millis.
function $a598eec80cc7ada0$var$sleep(millis) {
    return new Promise((resolve)=>setTimeout(resolve, millis));
}

});

parcelRegister("lhKbn", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f7ef0269002d2615$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $f7ef0269002d2615$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f7ef0269002d2615$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcProvider = void 0;

var $hNbI3 = parcelRequire("hNbI3");

var $a246u = parcelRequire("a246u");

var $hynq1 = parcelRequire("hynq1");

var $edtcG = parcelRequire("edtcG");

var $bOfeb = parcelRequire("bOfeb");

var $bzj0m = parcelRequire("bzj0m");
/** @hidden */ // Default number of retries before giving up on a request.
const $f7ef0269002d2615$var$REQUEST_RETRY_NUMBER = 12;
// Default wait until next retry in millis.
const $f7ef0269002d2615$var$REQUEST_RETRY_WAIT = 500;
// Exponential back off for waiting to retry.
const $f7ef0269002d2615$var$REQUEST_RETRY_WAIT_BACKOFF = 1.5;
/// Keep ids unique across all connections.
let $f7ef0269002d2615$var$_nextId = 123;
/**
 * Client class to interact with the [NEAR RPC API](https://docs.near.org/api/rpc/introduction).
 * @see [https://github.com/near/nearcore/tree/master/chain/jsonrpc](https://github.com/near/nearcore/tree/master/chain/jsonrpc)
 */ class $f7ef0269002d2615$var$JsonRpcProvider extends $bOfeb.Provider {
    /**
     * @param connectionInfo Connection info
     */ constructor(connectionInfo){
        super();
        this.connection = connectionInfo || {
            url: ""
        };
    }
    /**
     * Gets the RPC's status
     * @see [https://docs.near.org/docs/develop/front-end/rpc#general-validator-status](https://docs.near.org/docs/develop/front-end/rpc#general-validator-status)
     */ status() {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            return this.sendJsonRpc("status", []);
        });
    }
    /**
     * Sends a signed transaction to the RPC and waits until transaction is fully complete
     * @see [https://docs.near.org/docs/develop/front-end/rpc#send-transaction-await](https://docs.near.org/docs/develop/front-end/rpc#general-validator-status)
     *
     * @param signedTransaction The signed transaction being sent
     */ sendTransaction(signedTransaction) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const bytes = (0, $hynq1.encodeTransaction)(signedTransaction);
            return this.sendJsonRpc("broadcast_tx_commit", [
                $f7ef0269002d2615$require$Buffer.from(bytes).toString("base64")
            ]);
        });
    }
    /**
     * Sends a signed transaction to the RPC and immediately returns transaction hash
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#send-transaction-async)
     * @param signedTransaction The signed transaction being sent
     * @returns {Promise<FinalExecutionOutcome>}
     */ sendTransactionAsync(signedTransaction) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const bytes = (0, $hynq1.encodeTransaction)(signedTransaction);
            return this.sendJsonRpc("broadcast_tx_async", [
                $f7ef0269002d2615$require$Buffer.from(bytes).toString("base64")
            ]);
        });
    }
    /**
     * Gets a transaction's status from the RPC
     * @see [https://docs.near.org/docs/develop/front-end/rpc#transaction-status](https://docs.near.org/docs/develop/front-end/rpc#general-validator-status)
     *
     * @param txHash A transaction hash as either a Uint8Array or a base58 encoded string
     * @param accountId The NEAR account that signed the transaction
     */ txStatus(txHash, accountId) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof txHash === "string") return this.txStatusString(txHash, accountId);
            else return this.txStatusUint8Array(txHash, accountId);
        });
    }
    txStatusUint8Array(txHash, accountId) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            return this.sendJsonRpc("tx", [
                (0, $hNbI3.baseEncode)(txHash),
                accountId
            ]);
        });
    }
    txStatusString(txHash, accountId) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            return this.sendJsonRpc("tx", [
                txHash,
                accountId
            ]);
        });
    }
    /**
     * Gets a transaction's status from the RPC with receipts
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#transaction-status-with-receipts)
     * @param txHash The hash of the transaction
     * @param accountId The NEAR account that signed the transaction
     * @returns {Promise<FinalExecutionOutcome>}
     */ txStatusReceipts(txHash, accountId) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            if (typeof txHash === "string") return this.sendJsonRpc("EXPERIMENTAL_tx_status", [
                txHash,
                accountId
            ]);
            else return this.sendJsonRpc("EXPERIMENTAL_tx_status", [
                (0, $hNbI3.baseEncode)(txHash),
                accountId
            ]);
        });
    }
    /**
     * Query the RPC by passing an {@link "@near-js/types".provider/request.RpcQueryRequest | RpcQueryRequest }
     * @see [https://docs.near.org/api/rpc/contracts](https://docs.near.org/api/rpc/contracts)
     *
     * @typeParam T the shape of the returned query response
     */ query(...args) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            let result;
            if (args.length === 1) {
                const _a = args[0], { block_id: block_id, blockId: blockId } = _a, otherParams = $f7ef0269002d2615$var$__rest(_a, [
                    "block_id",
                    "blockId"
                ]);
                result = yield this.sendJsonRpc("query", Object.assign(Object.assign({}, otherParams), {
                    block_id: block_id || blockId
                }));
            } else {
                const [path, data] = args;
                result = yield this.sendJsonRpc("query", [
                    path,
                    data
                ]);
            }
            if (result && result.error) throw new $a246u.TypedError(`Querying failed: ${result.error}.\n${JSON.stringify(result, null, 2)}`, (0, $hNbI3.getErrorTypeFromErrorMessage)(result.error, result.error.name));
            return result;
        });
    }
    /**
     * Query for block info from the RPC
     * pass block_id OR finality as blockQuery, not both
     * @see [https://docs.near.org/api/rpc/block-chunk](https://docs.near.org/api/rpc/block-chunk)
     *
     * @param blockQuery {@link BlockReference} (passing a {@link BlockId} is deprecated)
     */ block(blockQuery) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const { finality: finality } = blockQuery;
            const { blockId: blockId } = blockQuery;
            return this.sendJsonRpc("block", {
                block_id: blockId,
                finality: finality
            });
        });
    }
    /**
     * Query changes in block from the RPC
     * pass block_id OR finality as blockQuery, not both
     * @see [https://docs.near.org/api/rpc/block-chunk](https://docs.near.org/api/rpc/block-chunk)
     */ blockChanges(blockQuery) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const { finality: finality } = blockQuery;
            const { blockId: blockId } = blockQuery;
            return this.sendJsonRpc("EXPERIMENTAL_changes_in_block", {
                block_id: blockId,
                finality: finality
            });
        });
    }
    /**
     * Queries for details about a specific chunk appending details of receipts and transactions to the same chunk data provided by a block
     * @see [https://docs.near.org/api/rpc/block-chunk](https://docs.near.org/api/rpc/block-chunk)
     *
     * @param chunkId Hash of a chunk ID or shard ID
     */ chunk(chunkId) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            return this.sendJsonRpc("chunk", [
                chunkId
            ]);
        });
    }
    /**
     * Query validators of the epoch defined by the given block id.
     * @see [https://docs.near.org/api/rpc/network#validation-status](https://docs.near.org/api/rpc/network#validation-status)
     *
     * @param blockId Block hash or height, or null for latest.
     */ validators(blockId) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            return this.sendJsonRpc("validators", [
                blockId
            ]);
        });
    }
    /**
     * Gets the protocol config at a block from RPC
     *
     * @param blockReference specifies the block to get the protocol config for
     */ experimental_protocolConfig(blockReference) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const _a = blockReference, { blockId: blockId } = _a, otherParams = $f7ef0269002d2615$var$__rest(_a, [
                "blockId"
            ]);
            return yield this.sendJsonRpc("EXPERIMENTAL_protocol_config", Object.assign(Object.assign({}, otherParams), {
                block_id: blockId
            }));
        });
    }
    /**
     * Gets a light client execution proof for verifying execution outcomes
     * @see [https://github.com/nearprotocol/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-proof](https://github.com/nearprotocol/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-proof)
     */ lightClientProof(request) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.sendJsonRpc("EXPERIMENTAL_light_client_proof", request);
        });
    }
    /**
     * Returns the next light client block as far in the future as possible from the last known hash
     * to still be able to validate from that hash. This will either return the last block of the
     * next epoch, or the last final known block.
     *
     * @see [https://github.com/near/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-block](https://github.com/near/NEPs/blob/master/specs/ChainSpec/LightClient.md#light-client-block)
     */ nextLightClientBlock(request) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.sendJsonRpc("next_light_client_block", request);
        });
    }
    /**
     * Gets access key changes for a given array of accountIds
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-access-key-changes-all)
     * @returns {Promise<ChangeResult>}
     */ accessKeyChanges(accountIdArray, blockQuery) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const { finality: finality } = blockQuery;
            const { blockId: blockId } = blockQuery;
            return this.sendJsonRpc("EXPERIMENTAL_changes", {
                changes_type: "all_access_key_changes",
                account_ids: accountIdArray,
                block_id: blockId,
                finality: finality
            });
        });
    }
    /**
     * Gets single access key changes for a given array of access keys
     * pass block_id OR finality as blockQuery, not both
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-access-key-changes-single)
     * @returns {Promise<ChangeResult>}
     */ singleAccessKeyChanges(accessKeyArray, blockQuery) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const { finality: finality } = blockQuery;
            const { blockId: blockId } = blockQuery;
            return this.sendJsonRpc("EXPERIMENTAL_changes", {
                changes_type: "single_access_key_changes",
                keys: accessKeyArray,
                block_id: blockId,
                finality: finality
            });
        });
    }
    /**
     * Gets account changes for a given array of accountIds
     * pass block_id OR finality as blockQuery, not both
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-account-changes)
     * @returns {Promise<ChangeResult>}
     */ accountChanges(accountIdArray, blockQuery) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const { finality: finality } = blockQuery;
            const { blockId: blockId } = blockQuery;
            return this.sendJsonRpc("EXPERIMENTAL_changes", {
                changes_type: "account_changes",
                account_ids: accountIdArray,
                block_id: blockId,
                finality: finality
            });
        });
    }
    /**
     * Gets contract state changes for a given array of accountIds
     * pass block_id OR finality as blockQuery, not both
     * Note: If you pass a keyPrefix it must be base64 encoded
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-contract-state-changes)
     * @returns {Promise<ChangeResult>}
     */ contractStateChanges(accountIdArray, blockQuery, keyPrefix = "") {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const { finality: finality } = blockQuery;
            const { blockId: blockId } = blockQuery;
            return this.sendJsonRpc("EXPERIMENTAL_changes", {
                changes_type: "data_changes",
                account_ids: accountIdArray,
                key_prefix_base64: keyPrefix,
                block_id: blockId,
                finality: finality
            });
        });
    }
    /**
     * Gets contract code changes for a given array of accountIds
     * pass block_id OR finality as blockQuery, not both
     * Note: Change is returned in a base64 encoded WASM file
     * See [docs for more info](https://docs.near.org/docs/develop/front-end/rpc#view-contract-code-changes)
     * @returns {Promise<ChangeResult>}
     */ contractCodeChanges(accountIdArray, blockQuery) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const { finality: finality } = blockQuery;
            const { blockId: blockId } = blockQuery;
            return this.sendJsonRpc("EXPERIMENTAL_changes", {
                changes_type: "contract_code_changes",
                account_ids: accountIdArray,
                block_id: blockId,
                finality: finality
            });
        });
    }
    /**
     * Returns gas price for a specific block_height or block_hash.
     * @see [https://docs.near.org/api/rpc/gas](https://docs.near.org/api/rpc/gas)
     *
     * @param blockId Block hash or height, or null for latest.
     */ gasPrice(blockId) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.sendJsonRpc("gas_price", [
                blockId
            ]);
        });
    }
    /**
     * Directly call the RPC specifying the method and params
     *
     * @param method RPC method
     * @param params Parameters to the method
     */ sendJsonRpc(method, params) {
        return $f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield (0, $edtcG.exponentialBackoff)($f7ef0269002d2615$var$REQUEST_RETRY_WAIT, $f7ef0269002d2615$var$REQUEST_RETRY_NUMBER, $f7ef0269002d2615$var$REQUEST_RETRY_WAIT_BACKOFF, ()=>$f7ef0269002d2615$var$__awaiter(this, void 0, void 0, function*() {
                    var _a;
                    try {
                        const request = {
                            method: method,
                            params: params,
                            id: $f7ef0269002d2615$var$_nextId++,
                            jsonrpc: "2.0"
                        };
                        const response = yield (0, $bzj0m.fetchJson)(this.connection, JSON.stringify(request));
                        if (response.error) {
                            if (typeof response.error.data === "object") {
                                if (typeof response.error.data.error_message === "string" && typeof response.error.data.error_type === "string") // if error data has error_message and error_type properties, we consider that node returned an error in the old format
                                throw new $a246u.TypedError(response.error.data.error_message, response.error.data.error_type);
                                throw (0, $hNbI3.parseRpcError)(response.error.data);
                            } else {
                                const errorMessage = `[${response.error.code}] ${response.error.message}: ${response.error.data}`;
                                // NOTE: All this hackery is happening because structured errors not implemented
                                // TODO: Fix when https://github.com/nearprotocol/nearcore/issues/1839 gets resolved
                                if (response.error.data === "Timeout" || errorMessage.includes("Timeout error") || errorMessage.includes("query has timed out")) throw new $a246u.TypedError(errorMessage, "TimeoutError");
                                const errorType = (0, $hNbI3.getErrorTypeFromErrorMessage)(response.error.data, "");
                                if (errorType) throw new $a246u.TypedError((0, $hNbI3.formatError)(errorType, params), errorType);
                                throw new $a246u.TypedError(errorMessage, response.error.name);
                            }
                        } else if (typeof ((_a = response.result) === null || _a === void 0 ? void 0 : _a.error) === "string") {
                            const errorType = (0, $hNbI3.getErrorTypeFromErrorMessage)(response.result.error, "");
                            if (errorType) throw new $hNbI3.ServerError((0, $hNbI3.formatError)(errorType, params), errorType);
                        }
                        // Success when response.error is not exist
                        return response;
                    } catch (error) {
                        if (error.type === "TimeoutError") {
                            $hNbI3.Logger.warn(`Retrying request to ${method} as it has timed out`, params);
                            return null;
                        }
                        throw error;
                    }
                }));
            const { result: result } = response;
            // From jsonrpc spec:
            // result
            //   This member is REQUIRED on success.
            //   This member MUST NOT exist if there was an error invoking the method.
            if (typeof result === "undefined") throw new $a246u.TypedError(`Exceeded ${$f7ef0269002d2615$var$REQUEST_RETRY_NUMBER} attempts for request to ${method}.`, "RetriesExceeded");
            return result;
        });
    }
}
module.exports.JsonRpcProvider = $f7ef0269002d2615$var$JsonRpcProvider;

});
parcelRegister("hynq1", function(module, exports) {
"use strict";
var $cc77c71d825ece5b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $cc77c71d825ece5b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cc77c71d825ece5b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$cc77c71d825ece5b$var$__exportStar((parcelRequire("5zOAn")), module.exports);

$cc77c71d825ece5b$var$__exportStar((parcelRequire("1YMsj")), module.exports);

$cc77c71d825ece5b$var$__exportStar((parcelRequire("3rSY2")), module.exports);

$cc77c71d825ece5b$var$__exportStar((parcelRequire("bKqni")), module.exports);

$cc77c71d825ece5b$var$__exportStar((parcelRequire("gfQKl")), module.exports);

$cc77c71d825ece5b$var$__exportStar((parcelRequire("4BYww")), module.exports);

$cc77c71d825ece5b$var$__exportStar((parcelRequire("fYPET")), module.exports);

});
parcelRegister("5zOAn", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $40f775ec844a9571$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $40f775ec844a9571$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.actionCreators = module.exports.stringifyJsonOrBytes = void 0;

const $40f775ec844a9571$var$bn_js_1 = $40f775ec844a9571$var$__importDefault((parcelRequire("dEXSZ")));

var $1YMsj = parcelRequire("1YMsj");
/**
 * Creates a full access key with full access permissions.
 * @returns A new full access key.
 */ function $40f775ec844a9571$var$fullAccessKey() {
    return new $1YMsj.AccessKey({
        nonce: 0,
        permission: new $1YMsj.AccessKeyPermission({
            fullAccess: new $1YMsj.FullAccessPermission({})
        })
    });
}
/**
 * Creates an access key with function call permission for a specific receiver and method names.
 * @param receiverId The NEAR account ID of the function call receiver.
 * @param methodNames An array of method names allowed for function calls.
 * @param allowance An optional allowance (maximum amount) for the function call. Default: Unlimited.
 * @returns A new access key with function call permission.
 */ function $40f775ec844a9571$var$functionCallAccessKey(receiverId, methodNames, allowance) {
    return new $1YMsj.AccessKey({
        nonce: 0,
        permission: new $1YMsj.AccessKeyPermission({
            functionCall: new $1YMsj.FunctionCallPermission({
                receiverId: receiverId,
                allowance: allowance,
                methodNames: methodNames
            })
        })
    });
}
/**
 * Creates a new action for creating a new NEAR account.
 * @returns A new action for creating a new account.
 */ function $40f775ec844a9571$var$createAccount() {
    return new $1YMsj.Action({
        createAccount: new $1YMsj.CreateAccount({})
    });
}
/**
 * Creates a new action for deploying a contract with the provided code.
 * @param code The Uint8Array representing the code of the contract.
 * @returns A new action for deploying a contract.
 */ function $40f775ec844a9571$var$deployContract(code) {
    return new $1YMsj.Action({
        deployContract: new $1YMsj.DeployContract({
            code: code
        })
    });
}
/**
 * Converts an input argument to a Buffer, handling cases for both JSON and Uint8Array.
 * @param args The input argument, either JSON object or Uint8Array.
 * @returns A Buffer representation of the input argument.
 */ function $40f775ec844a9571$var$stringifyJsonOrBytes(args) {
    const isUint8Array = args.byteLength !== undefined && args.byteLength === args.length;
    return isUint8Array ? args : $40f775ec844a9571$require$Buffer.from(JSON.stringify(args));
}
module.exports.stringifyJsonOrBytes = $40f775ec844a9571$var$stringifyJsonOrBytes;
/**
 * Constructs {@link Action} instance representing contract method call.
 *
 * @param methodName the name of the method to call
 * @param args arguments to pass to method. Can be either plain JS object which gets serialized as JSON automatically
 *  or `Uint8Array` instance which represents bytes passed as is.
 * @param gas max amount of gas that method call can use
 * @param deposit amount of NEAR (in yoctoNEAR) to send together with the call
 * @param stringify Convert input arguments into bytes array.
 * @param jsContract  Is contract from JS SDK, skips stringification of arguments.
 */ function $40f775ec844a9571$var$functionCall(methodName, args, gas = new $40f775ec844a9571$var$bn_js_1.default(0), deposit = new $40f775ec844a9571$var$bn_js_1.default(0), stringify = $40f775ec844a9571$var$stringifyJsonOrBytes, jsContract = false) {
    if (jsContract) return new $1YMsj.Action({
        functionCall: new $1YMsj.FunctionCall({
            methodName: methodName,
            args: args,
            gas: gas,
            deposit: deposit
        })
    });
    return new $1YMsj.Action({
        functionCall: new $1YMsj.FunctionCall({
            methodName: methodName,
            args: stringify(args),
            gas: gas,
            deposit: deposit
        })
    });
}
/**
 * Creates a new action for transferring funds, optionally specifying a deposit amount.
 * @param deposit The amount to be deposited along with the transfer. Default: 0.
 * @returns A new action for transferring funds.
 */ function $40f775ec844a9571$var$transfer(deposit = new $40f775ec844a9571$var$bn_js_1.default(0)) {
    return new $1YMsj.Action({
        transfer: new $1YMsj.Transfer({
            deposit: deposit
        })
    });
}
/**
 * Creates a new action for staking tokens, specifying the stake amount and public key.
 * @param stake The amount to be staked. Default: 0.
 * @param publicKey The public key associated with the staking action.
 * @returns A new action for staking tokens.
 */ function $40f775ec844a9571$var$stake(stake = new $40f775ec844a9571$var$bn_js_1.default(0), publicKey) {
    return new $1YMsj.Action({
        stake: new $1YMsj.Stake({
            stake: stake,
            publicKey: publicKey
        })
    });
}
/**
 * Creates a new action for adding a public key with a specified access key.
 * @param publicKey The public key to be added.
 * @param accessKey The access key associated with the added public key.
 * @returns A new action for adding a public key.
 */ function $40f775ec844a9571$var$addKey(publicKey, accessKey) {
    return new $1YMsj.Action({
        addKey: new $1YMsj.AddKey({
            publicKey: publicKey,
            accessKey: accessKey
        })
    });
}
/**
 * Creates a new action for deleting a public key.
 * @param publicKey The public key to be deleted.
 * @returns A new action for deleting a public key.
 */ function $40f775ec844a9571$var$deleteKey(publicKey) {
    return new $1YMsj.Action({
        deleteKey: new $1YMsj.DeleteKey({
            publicKey: publicKey
        })
    });
}
/**
 * Creates a new action for deleting an account with the specified beneficiary ID.
 * @param beneficiaryId The NEAR account ID of the beneficiary.
 * @returns A new action for deleting an account.
 */ function $40f775ec844a9571$var$deleteAccount(beneficiaryId) {
    return new $1YMsj.Action({
        deleteAccount: new $1YMsj.DeleteAccount({
            beneficiaryId: beneficiaryId
        })
    });
}
/**
 * Creates a new action for a signed delegation, specifying the delegate action and signature.
 * @param delegateAction The delegate action to be performed.
 * @param signature The signature associated with the delegate action.
 * @returns A new action for a signed delegation.
 */ function $40f775ec844a9571$var$signedDelegate({ delegateAction: delegateAction, signature: signature }) {
    return new $1YMsj.Action({
        signedDelegate: new $1YMsj.SignedDelegate({
            delegateAction: delegateAction,
            signature: signature
        })
    });
}
module.exports.actionCreators = {
    addKey: $40f775ec844a9571$var$addKey,
    createAccount: $40f775ec844a9571$var$createAccount,
    deleteAccount: $40f775ec844a9571$var$deleteAccount,
    deleteKey: $40f775ec844a9571$var$deleteKey,
    deployContract: $40f775ec844a9571$var$deployContract,
    fullAccessKey: $40f775ec844a9571$var$fullAccessKey,
    functionCall: $40f775ec844a9571$var$functionCall,
    functionCallAccessKey: $40f775ec844a9571$var$functionCallAccessKey,
    signedDelegate: $40f775ec844a9571$var$signedDelegate,
    stake: $40f775ec844a9571$var$stake,
    transfer: $40f775ec844a9571$var$transfer
};

});
parcelRegister("1YMsj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Action = module.exports.SignedDelegate = module.exports.DeleteAccount = module.exports.DeleteKey = module.exports.AddKey = module.exports.Stake = module.exports.Transfer = module.exports.FunctionCall = module.exports.DeployContract = module.exports.CreateAccount = module.exports.IAction = module.exports.AccessKey = module.exports.AccessKeyPermission = module.exports.FullAccessPermission = module.exports.FunctionCallPermission = void 0;

var $a246u = parcelRequire("a246u");
class $1710fb57c83b4ec7$var$Enum {
    constructor(properties){
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this[key] = properties[key];
            this.enum = key;
        });
    }
}
class $1710fb57c83b4ec7$var$FunctionCallPermission extends $a246u.Assignable {
}
module.exports.FunctionCallPermission = $1710fb57c83b4ec7$var$FunctionCallPermission;
class $1710fb57c83b4ec7$var$FullAccessPermission extends $a246u.Assignable {
}
module.exports.FullAccessPermission = $1710fb57c83b4ec7$var$FullAccessPermission;
class $1710fb57c83b4ec7$var$AccessKeyPermission extends $1710fb57c83b4ec7$var$Enum {
}
module.exports.AccessKeyPermission = $1710fb57c83b4ec7$var$AccessKeyPermission;
class $1710fb57c83b4ec7$var$AccessKey extends $a246u.Assignable {
}
module.exports.AccessKey = $1710fb57c83b4ec7$var$AccessKey;
class $1710fb57c83b4ec7$var$IAction extends $a246u.Assignable {
}
module.exports.IAction = $1710fb57c83b4ec7$var$IAction;
class $1710fb57c83b4ec7$var$CreateAccount extends $1710fb57c83b4ec7$var$IAction {
}
module.exports.CreateAccount = $1710fb57c83b4ec7$var$CreateAccount;
class $1710fb57c83b4ec7$var$DeployContract extends $1710fb57c83b4ec7$var$IAction {
}
module.exports.DeployContract = $1710fb57c83b4ec7$var$DeployContract;
class $1710fb57c83b4ec7$var$FunctionCall extends $1710fb57c83b4ec7$var$IAction {
}
module.exports.FunctionCall = $1710fb57c83b4ec7$var$FunctionCall;
class $1710fb57c83b4ec7$var$Transfer extends $1710fb57c83b4ec7$var$IAction {
}
module.exports.Transfer = $1710fb57c83b4ec7$var$Transfer;
class $1710fb57c83b4ec7$var$Stake extends $1710fb57c83b4ec7$var$IAction {
}
module.exports.Stake = $1710fb57c83b4ec7$var$Stake;
class $1710fb57c83b4ec7$var$AddKey extends $1710fb57c83b4ec7$var$IAction {
}
module.exports.AddKey = $1710fb57c83b4ec7$var$AddKey;
class $1710fb57c83b4ec7$var$DeleteKey extends $1710fb57c83b4ec7$var$IAction {
}
module.exports.DeleteKey = $1710fb57c83b4ec7$var$DeleteKey;
class $1710fb57c83b4ec7$var$DeleteAccount extends $1710fb57c83b4ec7$var$IAction {
}
module.exports.DeleteAccount = $1710fb57c83b4ec7$var$DeleteAccount;
class $1710fb57c83b4ec7$var$SignedDelegate extends $1710fb57c83b4ec7$var$IAction {
}
module.exports.SignedDelegate = $1710fb57c83b4ec7$var$SignedDelegate;
/**
 * Contains a list of the valid transaction Actions available with this API
 * @see {@link https://nomicon.io/RuntimeSpec/Actions.html | Actions Spec}
 */ class $1710fb57c83b4ec7$var$Action extends $1710fb57c83b4ec7$var$Enum {
}
module.exports.Action = $1710fb57c83b4ec7$var$Action;

});


parcelRegister("3rSY2", function(module, exports) {
"use strict";
var $282e8815a0a777f8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createTransaction = void 0;

const $282e8815a0a777f8$var$bn_js_1 = $282e8815a0a777f8$var$__importDefault((parcelRequire("dEXSZ")));

var $gfQKl = parcelRequire("gfQKl");
/**
 * Creates a new transaction object with the provided parameters.
 * @param signerId The NEAR account ID of the transaction signer.
 * @param publicKey The public key associated with the signer.
 * @param receiverId The NEAR account ID of the transaction receiver.
 * @param nonce The nonce value for the transaction, represented as a BN, string, or number.
 * @param actions An array of transaction actions to be performed.
 * @param blockHash The hash of the block where the transaction will be included.
 * @returns A new transaction object initialized with the provided parameters.
 */ function $282e8815a0a777f8$var$createTransaction(signerId, publicKey, receiverId, nonce, actions, blockHash) {
    return new $gfQKl.Transaction({
        signerId: signerId,
        publicKey: publicKey,
        nonce: new $282e8815a0a777f8$var$bn_js_1.default(nonce),
        receiverId: receiverId,
        actions: actions,
        blockHash: blockHash
    });
}
module.exports.createTransaction = $282e8815a0a777f8$var$createTransaction;

});
parcelRegister("gfQKl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCHEMA = module.exports.SignedTransaction = module.exports.Transaction = module.exports.decodeSignedTransaction = module.exports.decodeTransaction = module.exports.encodeTransaction = module.exports.encodeSignedDelegate = module.exports.encodeDelegateAction = void 0;

var $a246u = parcelRequire("a246u");

var $7U40k = parcelRequire("7U40k");

var $9wbRZ = parcelRequire("9wbRZ");
/**
 * Borsh-encode a delegate action for inclusion as an action within a meta transaction
 * NB per NEP-461 this requires a Borsh-serialized prefix specific to delegate actions, ensuring
 *  signed delegate actions may never be identical to signed transactions with the same fields
 * @param delegateAction Delegate action to be signed by the meta transaction sender
 */ function $bd56f6684fadb45f$var$encodeDelegateAction(delegateAction) {
    return new Uint8Array([
        ...(0, $7U40k.serialize)(module.exports.SCHEMA.DelegateActionPrefix, new $9wbRZ.DelegateActionPrefix()),
        ...(0, $7U40k.serialize)(module.exports.SCHEMA.DelegateAction, delegateAction)
    ]);
}
module.exports.encodeDelegateAction = $bd56f6684fadb45f$var$encodeDelegateAction;
/**
 * Borsh-encode a signed delegate for validation and execution by a relayer
 * @param signedDelegate Signed delegate to be executed in a meta transaction
 */ function $bd56f6684fadb45f$var$encodeSignedDelegate(signedDelegate) {
    return (0, $7U40k.serialize)(module.exports.SCHEMA.SignedDelegate, signedDelegate);
}
module.exports.encodeSignedDelegate = $bd56f6684fadb45f$var$encodeSignedDelegate;
/**
* Borsh-encode a transaction or signed transaction into a serialized form.
* @param transaction The transaction or signed transaction object to be encoded.
* @returns A serialized representation of the input transaction.
*/ function $bd56f6684fadb45f$var$encodeTransaction(transaction) {
    const schema = transaction instanceof $bd56f6684fadb45f$var$SignedTransaction ? module.exports.SCHEMA.SignedTransaction : module.exports.SCHEMA.Transaction;
    return (0, $7U40k.serialize)(schema, transaction);
}
module.exports.encodeTransaction = $bd56f6684fadb45f$var$encodeTransaction;
/**
 * Borsh-decode a Transaction instance from a buffer
 * @param bytes Uint8Array data to be decoded
 */ function $bd56f6684fadb45f$var$decodeTransaction(bytes) {
    return new $bd56f6684fadb45f$var$Transaction((0, $7U40k.deserialize)(module.exports.SCHEMA.Transaction, bytes));
}
module.exports.decodeTransaction = $bd56f6684fadb45f$var$decodeTransaction;
/**
 * Borsh-decode a SignedTransaction instance from a buffer
 * @param bytes Uint8Array data to be decoded
 */ function $bd56f6684fadb45f$var$decodeSignedTransaction(bytes) {
    return new $bd56f6684fadb45f$var$SignedTransaction((0, $7U40k.deserialize)(module.exports.SCHEMA.SignedTransaction, bytes));
}
module.exports.decodeSignedTransaction = $bd56f6684fadb45f$var$decodeSignedTransaction;
class $bd56f6684fadb45f$var$Transaction extends $a246u.Assignable {
    encode() {
        return $bd56f6684fadb45f$var$encodeTransaction(this);
    }
    static decode(bytes) {
        return $bd56f6684fadb45f$var$decodeTransaction(bytes);
    }
}
module.exports.Transaction = $bd56f6684fadb45f$var$Transaction;
class $bd56f6684fadb45f$var$SignedTransaction extends $a246u.Assignable {
    encode() {
        return $bd56f6684fadb45f$var$encodeTransaction(this);
    }
    static decode(bytes) {
        return $bd56f6684fadb45f$var$decodeSignedTransaction(bytes);
    }
}
module.exports.SignedTransaction = $bd56f6684fadb45f$var$SignedTransaction;
module.exports.SCHEMA = new class BorshSchema {
    constructor(){
        this.Signature = {
            struct: {
                keyType: "u8",
                data: {
                    array: {
                        type: "u8",
                        len: 64
                    }
                }
            }
        };
        this.PublicKey = {
            struct: {
                keyType: "u8",
                data: {
                    array: {
                        type: "u8",
                        len: 32
                    }
                }
            }
        };
        this.FunctionCallPermission = {
            struct: {
                allowance: {
                    option: "u128"
                },
                receiverId: "string",
                methodNames: {
                    array: {
                        type: "string"
                    }
                }
            }
        };
        this.FullAccessPermission = {
            struct: {}
        };
        this.AccessKeyPermission = {
            enum: [
                {
                    struct: {
                        functionCall: this.FunctionCallPermission
                    }
                },
                {
                    struct: {
                        fullAccess: this.FullAccessPermission
                    }
                }
            ]
        };
        this.AccessKey = {
            struct: {
                nonce: "u64",
                permission: this.AccessKeyPermission
            }
        };
        this.CreateAccount = {
            struct: {}
        };
        this.DeployContract = {
            struct: {
                code: {
                    array: {
                        type: "u8"
                    }
                }
            }
        };
        this.FunctionCall = {
            struct: {
                methodName: "string",
                args: {
                    array: {
                        type: "u8"
                    }
                },
                gas: "u64",
                deposit: "u128"
            }
        };
        this.Transfer = {
            struct: {
                deposit: "u128"
            }
        };
        this.Stake = {
            struct: {
                stake: "u128",
                publicKey: this.PublicKey
            }
        };
        this.AddKey = {
            struct: {
                publicKey: this.PublicKey,
                accessKey: this.AccessKey
            }
        };
        this.DeleteKey = {
            struct: {
                publicKey: this.PublicKey
            }
        };
        this.DeleteAccount = {
            struct: {
                beneficiaryId: "string"
            }
        };
        this.DelegateActionPrefix = {
            struct: {
                prefix: "u32"
            }
        };
        this.ClassicActions = {
            enum: [
                {
                    struct: {
                        createAccount: this.CreateAccount
                    }
                },
                {
                    struct: {
                        deployContract: this.DeployContract
                    }
                },
                {
                    struct: {
                        functionCall: this.FunctionCall
                    }
                },
                {
                    struct: {
                        transfer: this.Transfer
                    }
                },
                {
                    struct: {
                        stake: this.Stake
                    }
                },
                {
                    struct: {
                        addKey: this.AddKey
                    }
                },
                {
                    struct: {
                        deleteKey: this.DeleteKey
                    }
                },
                {
                    struct: {
                        deleteAccount: this.DeleteAccount
                    }
                }
            ]
        };
        this.DelegateAction = {
            struct: {
                senderId: "string",
                receiverId: "string",
                actions: {
                    array: {
                        type: this.ClassicActions
                    }
                },
                nonce: "u64",
                maxBlockHeight: "u64",
                publicKey: this.PublicKey
            }
        };
        this.SignedDelegate = {
            struct: {
                delegateAction: this.DelegateAction,
                signature: this.Signature
            }
        };
        this.Action = {
            enum: [
                {
                    struct: {
                        createAccount: this.CreateAccount
                    }
                },
                {
                    struct: {
                        deployContract: this.DeployContract
                    }
                },
                {
                    struct: {
                        functionCall: this.FunctionCall
                    }
                },
                {
                    struct: {
                        transfer: this.Transfer
                    }
                },
                {
                    struct: {
                        stake: this.Stake
                    }
                },
                {
                    struct: {
                        addKey: this.AddKey
                    }
                },
                {
                    struct: {
                        deleteKey: this.DeleteKey
                    }
                },
                {
                    struct: {
                        deleteAccount: this.DeleteAccount
                    }
                },
                {
                    struct: {
                        signedDelegate: this.SignedDelegate
                    }
                }
            ]
        };
        this.Transaction = {
            struct: {
                signerId: "string",
                publicKey: this.PublicKey,
                nonce: "u64",
                receiverId: "string",
                blockHash: {
                    array: {
                        type: "u8",
                        len: 32
                    }
                },
                actions: {
                    array: {
                        type: this.Action
                    }
                }
            }
        };
        this.SignedTransaction = {
            struct: {
                transaction: this.Transaction,
                signature: this.Signature
            }
        };
    }
};

});
parcelRegister("7U40k", function(module, exports) {

$parcel$export(module.exports, "serialize", () => $5c10de8f4be47e22$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "deserialize", () => $5c10de8f4be47e22$export$efcd34ab6248d3cd);

var $46SEX = parcelRequire("46SEX");

var $kAXLb = parcelRequire("kAXLb");

var $lkOlE = parcelRequire("lkOlE");
function $5c10de8f4be47e22$export$dfdc1655ccc5b9cb(schema, value, validate) {
    if (validate === void 0) validate = true;
    if (validate) $lkOlE.validate_schema(schema);
    var serializer = new (0, $46SEX.BorshSerializer)(validate);
    return serializer.encode(value, schema);
}
function $5c10de8f4be47e22$export$efcd34ab6248d3cd(schema, buffer, validate) {
    if (validate === void 0) validate = true;
    if (validate) $lkOlE.validate_schema(schema);
    var deserializer = new (0, $kAXLb.BorshDeserializer)(buffer);
    return deserializer.decode(schema);
}

});
parcelRegister("46SEX", function(module, exports) {

$parcel$export(module.exports, "BorshSerializer", () => $2fe21f392dfbaea7$export$1752dc9b42f458bc);

var $ipwJ3 = parcelRequire("ipwJ3");

var $5uUf5 = parcelRequire("5uUf5");

var $lkOlE = parcelRequire("lkOlE");
var $2fe21f392dfbaea7$export$1752dc9b42f458bc = /** @class */ function() {
    function BorshSerializer(checkTypes) {
        this.encoded = new (0, $5uUf5.EncodeBuffer)();
        this.fieldPath = [
            "value"
        ];
        this.checkTypes = checkTypes;
    }
    BorshSerializer.prototype.encode = function(value, schema) {
        this.encode_value(value, schema);
        return this.encoded.get_used_buffer();
    };
    BorshSerializer.prototype.encode_value = function(value, schema) {
        if (typeof schema === "string") {
            if ((0, $ipwJ3.integers).includes(schema)) return this.encode_integer(value, schema);
            if (schema === "string") return this.encode_string(value);
            if (schema === "bool") return this.encode_boolean(value);
        }
        if (typeof schema === "object") {
            if ("option" in schema) return this.encode_option(value, schema);
            if ("enum" in schema) return this.encode_enum(value, schema);
            if ("array" in schema) return this.encode_array(value, schema);
            if ("set" in schema) return this.encode_set(value, schema);
            if ("map" in schema) return this.encode_map(value, schema);
            if ("struct" in schema) return this.encode_struct(value, schema);
        }
    };
    BorshSerializer.prototype.encode_integer = function(value, schema) {
        var size = parseInt(schema.substring(1));
        if (size <= 32 || schema == "f64") {
            this.checkTypes && $lkOlE.expect_type(value, "number", this.fieldPath);
            this.encoded.store_value(value, schema);
        } else {
            this.checkTypes && $lkOlE.expect_bigint(value, this.fieldPath);
            this.encode_bigint(BigInt(value), size);
        }
    };
    BorshSerializer.prototype.encode_bigint = function(value, size) {
        var buffer_len = size / 8;
        var buffer = new Uint8Array(buffer_len);
        for(var i = 0; i < buffer_len; i++){
            buffer[i] = Number(value & BigInt(0xff));
            value = value >> BigInt(8);
        }
        this.encoded.store_bytes(new Uint8Array(buffer));
    };
    BorshSerializer.prototype.encode_string = function(value) {
        this.checkTypes && $lkOlE.expect_type(value, "string", this.fieldPath);
        var _value = value;
        // 4 bytes for length
        this.encoded.store_value(_value.length, "u32");
        // string bytes
        for(var i = 0; i < _value.length; i++)this.encoded.store_value(_value.charCodeAt(i), "u8");
    };
    BorshSerializer.prototype.encode_boolean = function(value) {
        this.checkTypes && $lkOlE.expect_type(value, "boolean", this.fieldPath);
        this.encoded.store_value(value ? 1 : 0, "u8");
    };
    BorshSerializer.prototype.encode_option = function(value, schema) {
        if (value === null || value === undefined) this.encoded.store_value(0, "u8");
        else {
            this.encoded.store_value(1, "u8");
            this.encode_value(value, schema.option);
        }
    };
    BorshSerializer.prototype.encode_enum = function(value, schema) {
        this.checkTypes && $lkOlE.expect_enum(value, this.fieldPath);
        var valueKey = Object.keys(value)[0];
        for(var i = 0; i < schema["enum"].length; i++){
            var valueSchema = schema["enum"][i];
            if (valueKey === Object.keys(valueSchema.struct)[0]) {
                this.encoded.store_value(i, "u8");
                return this.encode_struct(value, valueSchema);
            }
        }
        throw new Error("Enum key (".concat(valueKey, ") not found in enum schema: ").concat(JSON.stringify(schema), " at ").concat(this.fieldPath.join(".")));
    };
    BorshSerializer.prototype.encode_array = function(value, schema) {
        if ($lkOlE.isArrayLike(value)) return this.encode_arraylike(value, schema);
        if (value instanceof ArrayBuffer) return this.encode_buffer(value, schema);
        throw new Error("Expected Array-like not ".concat(typeof value, "(").concat(value, ") at ").concat(this.fieldPath.join(".")));
    };
    BorshSerializer.prototype.encode_arraylike = function(value, schema) {
        if (schema.array.len) $lkOlE.expect_same_size(value.length, schema.array.len, this.fieldPath);
        else // 4 bytes for length
        this.encoded.store_value(value.length, "u32");
        // array values
        for(var i = 0; i < value.length; i++)this.encode_value(value[i], schema.array.type);
    };
    BorshSerializer.prototype.encode_buffer = function(value, schema) {
        if (schema.array.len) $lkOlE.expect_same_size(value.byteLength, schema.array.len, this.fieldPath);
        else // 4 bytes for length
        this.encoded.store_value(value.byteLength, "u32");
        // array values
        this.encoded.store_bytes(new Uint8Array(value));
    };
    BorshSerializer.prototype.encode_set = function(value, schema) {
        this.checkTypes && $lkOlE.expect_type(value, "object", this.fieldPath);
        var isSet = value instanceof Set;
        var values = isSet ? Array.from(value.values()) : Object.values(value);
        // 4 bytes for length
        this.encoded.store_value(values.length, "u32");
        // set values
        for(var _i = 0, values_1 = values; _i < values_1.length; _i++){
            var value_1 = values_1[_i];
            this.encode_value(value_1, schema.set);
        }
    };
    BorshSerializer.prototype.encode_map = function(value, schema) {
        this.checkTypes && $lkOlE.expect_type(value, "object", this.fieldPath);
        var isMap = value instanceof Map;
        var keys = isMap ? Array.from(value.keys()) : Object.keys(value);
        // 4 bytes for length
        this.encoded.store_value(keys.length, "u32");
        // store key/values
        for(var _i = 0, keys_1 = keys; _i < keys_1.length; _i++){
            var key = keys_1[_i];
            this.encode_value(key, schema.map.key);
            this.encode_value(isMap ? value.get(key) : value[key], schema.map.value);
        }
    };
    BorshSerializer.prototype.encode_struct = function(value, schema) {
        this.checkTypes && $lkOlE.expect_type(value, "object", this.fieldPath);
        for(var _i = 0, _a = Object.keys(schema.struct); _i < _a.length; _i++){
            var key = _a[_i];
            this.fieldPath.push(key);
            this.encode_value(value[key], schema.struct[key]);
            this.fieldPath.pop();
        }
    };
    return BorshSerializer;
}();

});
parcelRegister("ipwJ3", function(module, exports) {

$parcel$export(module.exports, "integers", () => $d673f26b838210f5$export$4d935d1adc70ab79);
var $d673f26b838210f5$export$4d935d1adc70ab79 = [
    "u8",
    "u16",
    "u32",
    "u64",
    "u128",
    "i8",
    "i16",
    "i32",
    "i64",
    "i128",
    "f32",
    "f64"
];

});

parcelRegister("5uUf5", function(module, exports) {

$parcel$export(module.exports, "EncodeBuffer", () => $400b61a38c6f6e55$export$9547582b1f5d6363);
$parcel$export(module.exports, "DecodeBuffer", () => $400b61a38c6f6e55$export$e04f9cd16b1f90b5);
var $400b61a38c6f6e55$export$9547582b1f5d6363 = /** @class */ function() {
    function EncodeBuffer() {
        this.offset = 0;
        this.buffer_size = 256;
        this.buffer = new ArrayBuffer(this.buffer_size);
        this.view = new DataView(this.buffer);
    }
    EncodeBuffer.prototype.resize_if_necessary = function(needed_space) {
        if (this.buffer_size - this.offset < needed_space) {
            this.buffer_size = Math.max(this.buffer_size * 2, this.buffer_size + needed_space);
            var new_buffer = new ArrayBuffer(this.buffer_size);
            new Uint8Array(new_buffer).set(new Uint8Array(this.buffer));
            this.buffer = new_buffer;
            this.view = new DataView(new_buffer);
        }
    };
    EncodeBuffer.prototype.get_used_buffer = function() {
        return new Uint8Array(this.buffer).slice(0, this.offset);
    };
    EncodeBuffer.prototype.store_value = function(value, type) {
        var bSize = type.substring(1);
        var size = parseInt(bSize) / 8;
        this.resize_if_necessary(size);
        var toCall = type[0] === "f" ? "setFloat".concat(bSize) : type[0] === "i" ? "setInt".concat(bSize) : "setUint".concat(bSize);
        this.view[toCall](this.offset, value, true);
        this.offset += size;
    };
    EncodeBuffer.prototype.store_bytes = function(from) {
        this.resize_if_necessary(from.length);
        new Uint8Array(this.buffer).set(new Uint8Array(from), this.offset);
        this.offset += from.length;
    };
    return EncodeBuffer;
}();
var $400b61a38c6f6e55$export$e04f9cd16b1f90b5 = /** @class */ function() {
    function DecodeBuffer(buf) {
        this.offset = 0;
        this.buffer_size = buf.length;
        this.buffer = new ArrayBuffer(buf.length);
        new Uint8Array(this.buffer).set(buf);
        this.view = new DataView(this.buffer);
    }
    DecodeBuffer.prototype.assert_enough_buffer = function(size) {
        if (this.offset + size > this.buffer.byteLength) throw new Error("Error in schema, the buffer is smaller than expected");
    };
    DecodeBuffer.prototype.consume_value = function(type) {
        var bSize = type.substring(1);
        var size = parseInt(bSize) / 8;
        this.assert_enough_buffer(size);
        var toCall = type[0] === "f" ? "getFloat".concat(bSize) : type[0] === "i" ? "getInt".concat(bSize) : "getUint".concat(bSize);
        var ret = this.view[toCall](this.offset, true);
        this.offset += size;
        return ret;
    };
    DecodeBuffer.prototype.consume_bytes = function(size) {
        this.assert_enough_buffer(size);
        var ret = this.buffer.slice(this.offset, this.offset + size);
        this.offset += size;
        return ret;
    };
    return DecodeBuffer;
}();

});

parcelRegister("lkOlE", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $f8828553a3a8e8af$export$1e2f57719e155213);
$parcel$export(module.exports, "expect_type", () => $f8828553a3a8e8af$export$7f7cdef78390d4af);
$parcel$export(module.exports, "expect_bigint", () => $f8828553a3a8e8af$export$6870fb3bec767972);
$parcel$export(module.exports, "expect_same_size", () => $f8828553a3a8e8af$export$f83b0006e29cd95e);
$parcel$export(module.exports, "expect_enum", () => $f8828553a3a8e8af$export$a76675ecf6958cb8);
$parcel$export(module.exports, "validate_schema", () => $f8828553a3a8e8af$export$4c3fc5e4e393d018);

var $ipwJ3 = parcelRequire("ipwJ3");
var $f8828553a3a8e8af$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
function $f8828553a3a8e8af$export$1e2f57719e155213(value) {
    // source: https://stackoverflow.com/questions/24048547/checking-if-an-object-is-array-like
    return Array.isArray(value) || !!value && typeof value === "object" && "length" in value && typeof value.length === "number" && (value.length === 0 || value.length > 0 && value.length - 1 in value);
}
function $f8828553a3a8e8af$export$7f7cdef78390d4af(value, type, fieldPath) {
    if (typeof value !== type) throw new Error("Expected ".concat(type, " not ").concat(typeof value, "(").concat(value, ") at ").concat(fieldPath.join(".")));
}
function $f8828553a3a8e8af$export$6870fb3bec767972(value, fieldPath) {
    var basicType = [
        "number",
        "string",
        "bigint",
        "boolean"
    ].includes(typeof value);
    var strObject = typeof value === "object" && value !== null && "toString" in value;
    if (!basicType && !strObject) throw new Error("Expected bigint, number, boolean or string not ".concat(typeof value, "(").concat(value, ") at ").concat(fieldPath.join(".")));
}
function $f8828553a3a8e8af$export$f83b0006e29cd95e(length, expected, fieldPath) {
    if (length !== expected) throw new Error("Array length ".concat(length, " does not match schema length ").concat(expected, " at ").concat(fieldPath.join(".")));
}
function $f8828553a3a8e8af$export$a76675ecf6958cb8(value, fieldPath) {
    if (typeof value !== "object" || value === null) throw new Error("Expected object not ".concat(typeof value, "(").concat(value, ") at ").concat(fieldPath.join(".")));
}
// Validate Schema
var $f8828553a3a8e8af$var$VALID_STRING_TYPES = (0, $ipwJ3.integers).concat([
    "bool",
    "string"
]);
var $f8828553a3a8e8af$var$VALID_OBJECT_KEYS = [
    "option",
    "enum",
    "array",
    "set",
    "map",
    "struct"
];
var $f8828553a3a8e8af$export$8f2c3a3994ebb27e = /** @class */ function(_super) {
    $f8828553a3a8e8af$var$__extends(ErrorSchema, _super);
    function ErrorSchema(schema, expected) {
        var message = "Invalid schema: ".concat(JSON.stringify(schema), " expected ").concat(expected);
        return _super.call(this, message) || this;
    }
    return ErrorSchema;
}(Error);
function $f8828553a3a8e8af$export$4c3fc5e4e393d018(schema) {
    if (typeof schema === "string" && $f8828553a3a8e8af$var$VALID_STRING_TYPES.includes(schema)) return;
    if (schema && typeof schema === "object") {
        var keys = Object.keys(schema);
        if (keys.length === 1 && $f8828553a3a8e8af$var$VALID_OBJECT_KEYS.includes(keys[0])) {
            var key = keys[0];
            if (key === "option") return $f8828553a3a8e8af$export$4c3fc5e4e393d018(schema[key]);
            if (key === "enum") return $f8828553a3a8e8af$var$validate_enum_schema(schema[key]);
            if (key === "array") return $f8828553a3a8e8af$var$validate_array_schema(schema[key]);
            if (key === "set") return $f8828553a3a8e8af$export$4c3fc5e4e393d018(schema[key]);
            if (key === "map") return $f8828553a3a8e8af$var$validate_map_schema(schema[key]);
            if (key === "struct") return $f8828553a3a8e8af$var$validate_struct_schema(schema[key]);
        }
    }
    throw new $f8828553a3a8e8af$export$8f2c3a3994ebb27e(schema, $f8828553a3a8e8af$var$VALID_OBJECT_KEYS.join(", ") + " or " + $f8828553a3a8e8af$var$VALID_STRING_TYPES.join(", "));
}
function $f8828553a3a8e8af$var$validate_enum_schema(schema) {
    if (!Array.isArray(schema)) throw new $f8828553a3a8e8af$export$8f2c3a3994ebb27e(schema, "Array");
    for(var _i = 0, schema_1 = schema; _i < schema_1.length; _i++){
        var sch = schema_1[_i];
        if (typeof sch !== "object" || !("struct" in sch)) throw new Error('Missing "struct" key in enum schema');
        if (typeof sch.struct !== "object" || Object.keys(sch.struct).length !== 1) throw new Error('The "struct" in each enum must have a single key');
        $f8828553a3a8e8af$export$4c3fc5e4e393d018({
            struct: sch.struct
        });
    }
}
function $f8828553a3a8e8af$var$validate_array_schema(schema) {
    if (typeof schema !== "object") throw new $f8828553a3a8e8af$export$8f2c3a3994ebb27e(schema, "{ type, len? }");
    if (schema.len && typeof schema.len !== "number") throw new Error("Invalid schema: ".concat(schema));
    if ("type" in schema) return $f8828553a3a8e8af$export$4c3fc5e4e393d018(schema.type);
    throw new $f8828553a3a8e8af$export$8f2c3a3994ebb27e(schema, "{ type, len? }");
}
function $f8828553a3a8e8af$var$validate_map_schema(schema) {
    if (typeof schema === "object" && "key" in schema && "value" in schema) {
        $f8828553a3a8e8af$export$4c3fc5e4e393d018(schema.key);
        $f8828553a3a8e8af$export$4c3fc5e4e393d018(schema.value);
    } else throw new $f8828553a3a8e8af$export$8f2c3a3994ebb27e(schema, "{ key, value }");
}
function $f8828553a3a8e8af$var$validate_struct_schema(schema) {
    if (typeof schema !== "object") throw new $f8828553a3a8e8af$export$8f2c3a3994ebb27e(schema, "object");
    for(var key in schema)$f8828553a3a8e8af$export$4c3fc5e4e393d018(schema[key]);
}

});


parcelRegister("kAXLb", function(module, exports) {

$parcel$export(module.exports, "BorshDeserializer", () => $efe5868e9d46a727$export$3d535410d1e35e6e);

var $ipwJ3 = parcelRequire("ipwJ3");

var $5uUf5 = parcelRequire("5uUf5");
var $efe5868e9d46a727$export$3d535410d1e35e6e = /** @class */ function() {
    function BorshDeserializer(bufferArray) {
        this.buffer = new (0, $5uUf5.DecodeBuffer)(bufferArray);
    }
    BorshDeserializer.prototype.decode = function(schema) {
        return this.decode_value(schema);
    };
    BorshDeserializer.prototype.decode_value = function(schema) {
        if (typeof schema === "string") {
            if ((0, $ipwJ3.integers).includes(schema)) return this.decode_integer(schema);
            if (schema === "string") return this.decode_string();
            if (schema === "bool") return this.decode_boolean();
        }
        if (typeof schema === "object") {
            if ("option" in schema) return this.decode_option(schema);
            if ("enum" in schema) return this.decode_enum(schema);
            if ("array" in schema) return this.decode_array(schema);
            if ("set" in schema) return this.decode_set(schema);
            if ("map" in schema) return this.decode_map(schema);
            if ("struct" in schema) return this.decode_struct(schema);
        }
        throw new Error("Unsupported type: ".concat(schema));
    };
    BorshDeserializer.prototype.decode_integer = function(schema) {
        var size = parseInt(schema.substring(1));
        if (size <= 32 || schema == "f64") return this.buffer.consume_value(schema);
        return this.decode_bigint(size, schema.startsWith("i"));
    };
    BorshDeserializer.prototype.decode_bigint = function(size, signed) {
        if (signed === void 0) signed = false;
        var buffer_len = size / 8;
        var buffer = new Uint8Array(this.buffer.consume_bytes(buffer_len));
        var bits = buffer.reduceRight(function(r, x) {
            return r + x.toString(16).padStart(2, "0");
        }, "");
        if (signed && buffer[buffer_len - 1]) return BigInt.asIntN(size, BigInt("0x".concat(bits)));
        return BigInt("0x".concat(bits));
    };
    BorshDeserializer.prototype.decode_string = function() {
        var len = this.decode_integer("u32");
        var buffer = new Uint8Array(this.buffer.consume_bytes(len));
        return String.fromCharCode.apply(null, buffer);
    };
    BorshDeserializer.prototype.decode_boolean = function() {
        return this.buffer.consume_value("u8") > 0;
    };
    BorshDeserializer.prototype.decode_option = function(schema) {
        var option = this.buffer.consume_value("u8");
        if (option === 1) return this.decode_value(schema.option);
        if (option !== 0) throw new Error("Invalid option ".concat(option));
        return null;
    };
    BorshDeserializer.prototype.decode_enum = function(schema) {
        var _a;
        var valueIndex = this.buffer.consume_value("u8");
        if (valueIndex > schema["enum"].length) throw new Error("Enum option ".concat(valueIndex, " is not available"));
        var struct = schema["enum"][valueIndex].struct;
        var key = Object.keys(struct)[0];
        return _a = {}, _a[key] = this.decode_value(struct[key]), _a;
    };
    BorshDeserializer.prototype.decode_array = function(schema) {
        var result = [];
        var len = schema.array.len ? schema.array.len : this.decode_integer("u32");
        for(var i = 0; i < len; ++i)result.push(this.decode_value(schema.array.type));
        return result;
    };
    BorshDeserializer.prototype.decode_set = function(schema) {
        var len = this.decode_integer("u32");
        var result = new Set();
        for(var i = 0; i < len; ++i)result.add(this.decode_value(schema.set));
        return result;
    };
    BorshDeserializer.prototype.decode_map = function(schema) {
        var len = this.decode_integer("u32");
        var result = new Map();
        for(var i = 0; i < len; ++i){
            var key = this.decode_value(schema.map.key);
            var value = this.decode_value(schema.map.value);
            result.set(key, value);
        }
        return result;
    };
    BorshDeserializer.prototype.decode_struct = function(schema) {
        var result = {};
        for(var key in schema.struct)result[key] = this.decode_value(schema.struct[key]);
        return result;
    };
    return BorshDeserializer;
}();

});


parcelRegister("9wbRZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DelegateActionPrefix = void 0;

var $a246u = parcelRequire("a246u");
const $6ee04f4c9087813b$var$ACTIONABLE_MESSAGE_BASE = Math.pow(2, 30);
// const NON_ACTIONABLE_MESSAGE_BASE = Math.pow(2, 31);
/** The set of NEPs for which an [NEP-461](https://github.com/near/NEPs/pull/461) prefix is required on the message prior to hashing **/ const $6ee04f4c9087813b$var$NEP = {
    MetaTransactions: 366
};
/** Base class for NEP message prefixes **/ class $6ee04f4c9087813b$var$NEPPrefix extends $a246u.Assignable {
}
/** Class for constructing prefixes on actionable (on-chain) messages **/ class $6ee04f4c9087813b$var$ActionableMessagePrefix extends $6ee04f4c9087813b$var$NEPPrefix {
    /** Given the NEP number, set the prefix using 2^30 as the offset **/ constructor(prefix){
        super({
            prefix: $6ee04f4c9087813b$var$ACTIONABLE_MESSAGE_BASE + prefix
        });
    }
}
/**
 * Class for constructing prefixes on non-actionable (off-chain) messages
 * @todo uncomment when off-chain messages are supported
 * **/ // abstract class NonActionableMessagePrefix extends NEPPrefix {
//     /** Given the NEP number, set the prefix using 2^31 as the offset **/
//     protected constructor(prefix: number) {
//         super({ prefix: NON_ACTIONABLE_MESSAGE_BASE + prefix });
//     }
// }
/** Prefix for delegate actions whose signatures must always be distinguishable from valid transaction signatures **/ class $6ee04f4c9087813b$var$DelegateActionPrefix extends $6ee04f4c9087813b$var$ActionableMessagePrefix {
    constructor(){
        super($6ee04f4c9087813b$var$NEP.MetaTransactions);
    }
}
module.exports.DelegateActionPrefix = $6ee04f4c9087813b$var$DelegateActionPrefix;

});



parcelRegister("bKqni", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildDelegateAction = module.exports.DelegateAction = void 0;

var $a246u = parcelRequire("a246u");

var $5zOAn = parcelRequire("5zOAn");
const { addKey: $88d8730efb389ee5$var$addKey, createAccount: $88d8730efb389ee5$var$createAccount, deleteAccount: $88d8730efb389ee5$var$deleteAccount, deleteKey: $88d8730efb389ee5$var$deleteKey, deployContract: $88d8730efb389ee5$var$deployContract, functionCall: $88d8730efb389ee5$var$functionCall, stake: $88d8730efb389ee5$var$stake, transfer: $88d8730efb389ee5$var$transfer } = $5zOAn.actionCreators;
class $88d8730efb389ee5$var$DelegateAction extends $a246u.Assignable {
}
module.exports.DelegateAction = $88d8730efb389ee5$var$DelegateAction;
/**
 * Compose a delegate action for inclusion with a meta transaction signed on the sender's behalf
 * @param actions The set of actions to be included in the meta transaction
 * @param maxBlockHeight The maximum block height for which this action can be executed as part of a transaction
 * @param nonce Current nonce on the access key used to sign the delegate action
 * @param publicKey Public key for the access key used to sign the delegate action
 * @param receiverId Account ID for the intended receiver of the meta transaction
 * @param senderId Account ID for the intended signer of the delegate action
 */ function $88d8730efb389ee5$var$buildDelegateAction({ actions: actions, maxBlockHeight: maxBlockHeight, nonce: nonce, publicKey: publicKey, receiverId: receiverId, senderId: senderId }) {
    return new $88d8730efb389ee5$var$DelegateAction({
        senderId: senderId,
        receiverId: receiverId,
        actions: actions.map((a)=>{
            // @ts-expect-error type workaround
            if (!a.type && !a.params) return a;
            // @ts-expect-error type workaround
            switch(a.type){
                case "AddKey":
                    {
                        // @ts-expect-error type workaround
                        const { publicKey: publicKey, accessKey: accessKey } = a.params;
                        return $88d8730efb389ee5$var$addKey(publicKey, accessKey);
                    }
                case "CreateAccount":
                    // @ts-expect-error type workaround
                    return $88d8730efb389ee5$var$createAccount(a.params.createAccount);
                case "DeleteAccount":
                    // @ts-expect-error type workaround
                    return $88d8730efb389ee5$var$deleteAccount(a.params.deleteAccount);
                case "DeleteKey":
                    // @ts-expect-error type workaround
                    return $88d8730efb389ee5$var$deleteKey(a.params.publicKey);
                case "DeployContract":
                    // @ts-expect-error type workaround
                    return $88d8730efb389ee5$var$deployContract(a.params.code);
                case "FunctionCall":
                    {
                        // @ts-expect-error type workaround
                        const { methodName: methodName, args: args, gas: gas, deposit: deposit } = a.params;
                        return $88d8730efb389ee5$var$functionCall(methodName, args, gas, deposit);
                    }
                case "Stake":
                    // @ts-expect-error type workaround
                    return $88d8730efb389ee5$var$stake(a.params.stake, a.params.publicKey);
                case "Transfer":
                    {
                        // @ts-expect-error type workaround
                        const { deposit: deposit } = a.params;
                        return $88d8730efb389ee5$var$transfer(deposit);
                    }
            }
            throw new Error("Unrecognized action");
        }),
        nonce: nonce,
        maxBlockHeight: maxBlockHeight,
        publicKey: publicKey
    });
}
module.exports.buildDelegateAction = $88d8730efb389ee5$var$buildDelegateAction;

});

parcelRegister("4BYww", function(module, exports) {
"use strict";
var $35b990d6ee4c2a8c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signDelegateAction = module.exports.signTransaction = void 0;

var $6XnWx = parcelRequire("6XnWx");

var $1YMsj = parcelRequire("1YMsj");

var $3rSY2 = parcelRequire("3rSY2");

var $gfQKl = parcelRequire("gfQKl");

var $fYPET = parcelRequire("fYPET");
/**
 * Signs a given transaction from an account with given keys, applied to the given network
 * @param transaction The Transaction object to sign
 * @param signer The {Signer} object that assists with signing keys
 * @param accountId The human-readable NEAR account name
 * @param networkId The targeted network. (ex. default, betanet, etc…)
 */ function $35b990d6ee4c2a8c$var$signTransactionObject(transaction, signer, accountId, networkId) {
    return $35b990d6ee4c2a8c$var$__awaiter(this, void 0, void 0, function*() {
        const message = (0, $gfQKl.encodeTransaction)(transaction);
        const hash = new Uint8Array((0, $6XnWx.sha256)(message));
        const signature = yield signer.signMessage(message, accountId, networkId);
        const signedTx = new $gfQKl.SignedTransaction({
            transaction: transaction,
            signature: new $fYPET.Signature({
                keyType: transaction.publicKey.keyType,
                data: signature.signature
            })
        });
        return [
            hash,
            signedTx
        ];
    });
}
function $35b990d6ee4c2a8c$var$signTransaction(...args) {
    return $35b990d6ee4c2a8c$var$__awaiter(this, void 0, void 0, function*() {
        if (args[0].constructor === $gfQKl.Transaction) {
            const [transaction, signer, accountId, networkId] = args;
            return $35b990d6ee4c2a8c$var$signTransactionObject(transaction, signer, accountId, networkId);
        } else {
            const [receiverId, nonce, actions, blockHash, signer, accountId, networkId] = args;
            const publicKey = yield signer.getPublicKey(accountId, networkId);
            const transaction = (0, $3rSY2.createTransaction)(accountId, publicKey, receiverId, nonce, actions, blockHash);
            return $35b990d6ee4c2a8c$var$signTransactionObject(transaction, signer, accountId, networkId);
        }
    });
}
module.exports.signTransaction = $35b990d6ee4c2a8c$var$signTransaction;
/**
 * Sign a delegate action
 * @options SignDelegate options
 * @param options.delegateAction Delegate action to be signed by the meta transaction sender
 * @param options.signer Signer instance for the meta transaction sender
 */ function $35b990d6ee4c2a8c$var$signDelegateAction({ delegateAction: delegateAction, signer: signer }) {
    return $35b990d6ee4c2a8c$var$__awaiter(this, void 0, void 0, function*() {
        const message = (0, $gfQKl.encodeDelegateAction)(delegateAction);
        const signature = yield signer.sign(message);
        const signedDelegateAction = new $1YMsj.SignedDelegate({
            delegateAction: delegateAction,
            signature: new $fYPET.Signature({
                keyType: delegateAction.publicKey.keyType,
                data: signature
            })
        });
        return {
            hash: new Uint8Array((0, $6XnWx.sha256)(message)),
            signedDelegateAction: signedDelegateAction
        };
    });
}
module.exports.signDelegateAction = $35b990d6ee4c2a8c$var$signDelegateAction;

});
parcelRegister("6XnWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $g9W9K = parcelRequire("g9W9K");

var $3Bcdj = parcelRequire("3Bcdj");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Choice: a ? b : c
const $510ad3657d73a9d2$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $510ad3657d73a9d2$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $510ad3657d73a9d2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $510ad3657d73a9d2$var$IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $510ad3657d73a9d2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $510ad3657d73a9d2$var$SHA256 extends $g9W9K.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $510ad3657d73a9d2$var$IV[0] | 0;
        this.B = $510ad3657d73a9d2$var$IV[1] | 0;
        this.C = $510ad3657d73a9d2$var$IV[2] | 0;
        this.D = $510ad3657d73a9d2$var$IV[3] | 0;
        this.E = $510ad3657d73a9d2$var$IV[4] | 0;
        this.F = $510ad3657d73a9d2$var$IV[5] | 0;
        this.G = $510ad3657d73a9d2$var$IV[6] | 0;
        this.H = $510ad3657d73a9d2$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$510ad3657d73a9d2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $510ad3657d73a9d2$var$SHA256_W[i - 15];
            const W2 = $510ad3657d73a9d2$var$SHA256_W[i - 2];
            const s0 = (0, $3Bcdj.rotr)(W15, 7) ^ (0, $3Bcdj.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3Bcdj.rotr)(W2, 17) ^ (0, $3Bcdj.rotr)(W2, 19) ^ W2 >>> 10;
            $510ad3657d73a9d2$var$SHA256_W[i] = s1 + $510ad3657d73a9d2$var$SHA256_W[i - 7] + s0 + $510ad3657d73a9d2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3Bcdj.rotr)(E, 6) ^ (0, $3Bcdj.rotr)(E, 11) ^ (0, $3Bcdj.rotr)(E, 25);
            const T1 = H + sigma1 + $510ad3657d73a9d2$var$Chi(E, F, G) + $510ad3657d73a9d2$var$SHA256_K[i] + $510ad3657d73a9d2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3Bcdj.rotr)(A, 2) ^ (0, $3Bcdj.rotr)(A, 13) ^ (0, $3Bcdj.rotr)(A, 22);
            const T2 = sigma0 + $510ad3657d73a9d2$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $510ad3657d73a9d2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $510ad3657d73a9d2$var$SHA224 extends $510ad3657d73a9d2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA256());
module.exports.sha224 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA224());

});
parcelRegister("g9W9K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $3Bcdj = parcelRequire("3Bcdj");
// Polyfill for Safari 14
function $bc3a993d7d38a7a0$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $bc3a993d7d38a7a0$var$SHA2 extends $3Bcdj.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3Bcdj.createView)(this.buffer);
    }
    update(data) {
        (0, $dNiq9.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $3Bcdj.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3Bcdj.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $dNiq9.exists)(this);
        (0, $dNiq9.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $bc3a993d7d38a7a0$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3Bcdj.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $bc3a993d7d38a7a0$var$SHA2;

});
parcelRegister("dNiq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $a0ae23f5901291b4$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $a0ae23f5901291b4$var$number;
function $a0ae23f5901291b4$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $a0ae23f5901291b4$var$bool;
// copied from utils
function $a0ae23f5901291b4$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $a0ae23f5901291b4$var$bytes(b, ...lengths) {
    if (!$a0ae23f5901291b4$var$isBytes(b)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $a0ae23f5901291b4$var$bytes;
function $a0ae23f5901291b4$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a0ae23f5901291b4$var$number(hash.outputLen);
    $a0ae23f5901291b4$var$number(hash.blockLen);
}
module.exports.hash = $a0ae23f5901291b4$var$hash;
function $a0ae23f5901291b4$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $a0ae23f5901291b4$var$exists;
function $a0ae23f5901291b4$var$output(out, instance) {
    $a0ae23f5901291b4$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $a0ae23f5901291b4$var$output;
const $a0ae23f5901291b4$var$assert = {
    number: $a0ae23f5901291b4$var$number,
    bool: $a0ae23f5901291b4$var$bool,
    bytes: $a0ae23f5901291b4$var$bytes,
    hash: $a0ae23f5901291b4$var$hash,
    exists: $a0ae23f5901291b4$var$exists,
    output: $a0ae23f5901291b4$var$output
};
module.exports.default = $a0ae23f5901291b4$var$assert;

});

parcelRegister("3Bcdj", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $dUxV2 = parcelRequire("dUxV2");
// Cast array to different type
const $29ee4d3171d9809b$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $29ee4d3171d9809b$var$u8;
const $29ee4d3171d9809b$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $29ee4d3171d9809b$var$u32;
function $29ee4d3171d9809b$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Cast array to view
const $29ee4d3171d9809b$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $29ee4d3171d9809b$var$createView;
// The rotate right (circular right shift) operation for uint32
const $29ee4d3171d9809b$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $29ee4d3171d9809b$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
// Other libraries would silently corrupt the data instead of throwing an error,
// when they don't support it.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    if (!$29ee4d3171d9809b$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
// We use optimized technique to convert hex string to byte array
const $29ee4d3171d9809b$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $29ee4d3171d9809b$var$asciiToBase16(char) {
    if (char >= $29ee4d3171d9809b$var$asciis._0 && char <= $29ee4d3171d9809b$var$asciis._9) return char - $29ee4d3171d9809b$var$asciis._0;
    if (char >= $29ee4d3171d9809b$var$asciis._A && char <= $29ee4d3171d9809b$var$asciis._F) return char - ($29ee4d3171d9809b$var$asciis._A - 10);
    if (char >= $29ee4d3171d9809b$var$asciis._a && char <= $29ee4d3171d9809b$var$asciis._f) return char - ($29ee4d3171d9809b$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
module.exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $29ee4d3171d9809b$var$nextTick = async ()=>{};
module.exports.nextTick = $29ee4d3171d9809b$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === "string") data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    if (!$29ee4d3171d9809b$var$isBytes(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $29ee4d3171d9809b$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$29ee4d3171d9809b$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
module.exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
// For runtime check if class implements interface
class $29ee4d3171d9809b$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $29ee4d3171d9809b$var$Hash;
const $29ee4d3171d9809b$var$toStr = {}.toString;
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $29ee4d3171d9809b$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
function $29ee4d3171d9809b$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $29ee4d3171d9809b$var$wrapConstructor;
function $29ee4d3171d9809b$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$wrapConstructorWithOpts;
function $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($dUxV2.crypto && typeof $dUxV2.crypto.getRandomValues === "function") return $dUxV2.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;

});
parcelRegister("dUxV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("fYPET", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Signature = void 0;

var $a246u = parcelRequire("a246u");
class $ba2487f00d30951d$var$Signature extends $a246u.Assignable {
}
module.exports.Signature = $ba2487f00d30951d$var$Signature;

});



parcelRegister("bOfeb", function(module, exports) {
"use strict";
/**
 * NEAR RPC API request types and responses
 * @module
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Provider = void 0;
/** @hidden */ class $89902d2509d7ca00$var$Provider {
}
module.exports.Provider = $89902d2509d7ca00$var$Provider;

});

parcelRegister("bzj0m", function(module, exports) {
"use strict";
var $86c1b491c3e0a094$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $86c1b491c3e0a094$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $86c1b491c3e0a094$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $86c1b491c3e0a094$var$__createBinding(result, mod, k);
    }
    $86c1b491c3e0a094$var$__setModuleDefault(result, mod);
    return result;
};
var $86c1b491c3e0a094$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $86c1b491c3e0a094$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchJson = void 0;

var $a246u = parcelRequire("a246u");

var $hNbI3 = parcelRequire("hNbI3");

const $86c1b491c3e0a094$var$http_errors_1 = $86c1b491c3e0a094$var$__importDefault((parcelRequire("58x2d")));

var $edtcG = parcelRequire("edtcG");
const $86c1b491c3e0a094$var$START_WAIT_TIME_MS = 1000;
const $86c1b491c3e0a094$var$BACKOFF_MULTIPLIER = 1.5;
const $86c1b491c3e0a094$var$RETRY_NUMBER = 10;

/**
 * Performs an HTTP request to a specified URL or connection and returns the parsed JSON response.
 * @param connectionInfoOrUrl The connection information or URL for the HTTP request.
 * @param json The JSON payload to be included in the request body for POST requests.
 * @returns A Promise that resolves to the parsed JSON response from the HTTP request.
 */ function $86c1b491c3e0a094$var$fetchJson(connectionInfoOrUrl, json) {
    return $86c1b491c3e0a094$var$__awaiter(this, void 0, void 0, function*() {
        let connectionInfo = {
            url: null
        };
        if (typeof connectionInfoOrUrl === "string") connectionInfo.url = connectionInfoOrUrl;
        else connectionInfo = connectionInfoOrUrl;
        const response = yield (0, $edtcG.exponentialBackoff)($86c1b491c3e0a094$var$START_WAIT_TIME_MS, $86c1b491c3e0a094$var$RETRY_NUMBER, $86c1b491c3e0a094$var$BACKOFF_MULTIPLIER, ()=>$86c1b491c3e0a094$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                try {
                    const response = yield ((_a = $parcel$global.fetch) !== null && _a !== void 0 ? _a : (yield Promise.resolve().then(function() {
                        return (parcelRequire("2jk50"));
                    }).then((res)=>$86c1b491c3e0a094$var$__importStar(res))).default)(connectionInfo.url, {
                        method: json ? "POST" : "GET",
                        body: json ? json : undefined,
                        headers: Object.assign(Object.assign({}, connectionInfo.headers), {
                            "Content-Type": "application/json"
                        })
                    });
                    if (!response.ok) {
                        if (response.status === 503) {
                            $hNbI3.Logger.warn(`Retrying HTTP request for ${connectionInfo.url} as it's not available now`);
                            return null;
                        } else if (response.status === 408) {
                            $hNbI3.Logger.warn(`Retrying HTTP request for ${connectionInfo.url} as the previous connection was unused for some time`);
                            return null;
                        }
                        throw (0, $86c1b491c3e0a094$var$http_errors_1.default)(response.status, (yield response.text()));
                    }
                    return response;
                } catch (error) {
                    if (error.toString().includes("FetchError") || error.toString().includes("Failed to fetch")) {
                        $hNbI3.Logger.warn(`Retrying HTTP request for ${connectionInfo.url} because of error: ${error}`);
                        return null;
                    }
                    throw error;
                }
            }));
        if (!response) throw new $a246u.TypedError(`Exceeded ${$86c1b491c3e0a094$var$RETRY_NUMBER} attempts for ${connectionInfo.url}.`, "RetriesExceeded");
        return yield response.json();
    });
}
module.exports.fetchJson = $86c1b491c3e0a094$var$fetchJson;

});
parcelRegister("58x2d", function(module, exports) {
/*!
 * http-errors
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";

/**
 * Module dependencies.
 * @private
 */ var $3bd75317c7f07a31$var$deprecate = (parcelRequire("X3KGm"))("http-errors");

var $3nZY5 = parcelRequire("3nZY5");

var $d99DW = parcelRequire("d99DW");

var $5yZrL = parcelRequire("5yZrL");

var $23DWx = parcelRequire("23DWx");
/**
 * Module exports.
 * @public
 */ module.exports = $3bd75317c7f07a31$var$createError;
module.exports.HttpError = $3bd75317c7f07a31$var$createHttpErrorConstructor();
// Populate exports for all constructors
$3bd75317c7f07a31$var$populateConstructorExports(module.exports, $d99DW.codes, module.exports.HttpError);
/**
 * Get the code class of a status code.
 * @private
 */ function $3bd75317c7f07a31$var$codeClass(status) {
    return Number(String(status).charAt(0) + "00");
}
/**
 * Create a new HTTP Error.
 *
 * @returns {Error}
 * @public
 */ function $3bd75317c7f07a31$var$createError() {
    // so much arity going on ~_~
    var err;
    var msg;
    var status = 500;
    var props = {};
    for(var i = 0; i < arguments.length; i++){
        var arg = arguments[i];
        if (arg instanceof Error) {
            err = arg;
            status = err.status || err.statusCode || status;
            continue;
        }
        switch(typeof arg){
            case "string":
                msg = arg;
                break;
            case "number":
                status = arg;
                if (i !== 0) $3bd75317c7f07a31$var$deprecate("non-first-argument status code; replace with createError(" + arg + ", ...)");
                break;
            case "object":
                props = arg;
                break;
        }
    }
    if (typeof status === "number" && (status < 400 || status >= 600)) $3bd75317c7f07a31$var$deprecate("non-error status code; use only 4xx or 5xx status codes");
    if (typeof status !== "number" || !$d99DW[status] && (status < 400 || status >= 600)) status = 500;
    // constructor
    var HttpError = $3bd75317c7f07a31$var$createError[status] || $3bd75317c7f07a31$var$createError[$3bd75317c7f07a31$var$codeClass(status)];
    if (!err) {
        // create error
        err = HttpError ? new HttpError(msg) : new Error(msg || $d99DW[status]);
        Error.captureStackTrace(err, $3bd75317c7f07a31$var$createError);
    }
    if (!HttpError || !(err instanceof HttpError) || err.status !== status) {
        // add properties to generic error
        err.expose = status < 500;
        err.status = err.statusCode = status;
    }
    for(var key in props)if (key !== "status" && key !== "statusCode") err[key] = props[key];
    return err;
}
/**
 * Create HTTP error abstract base class.
 * @private
 */ function $3bd75317c7f07a31$var$createHttpErrorConstructor() {
    function HttpError() {
        throw new TypeError("cannot construct abstract class");
    }
    $5yZrL(HttpError, Error);
    return HttpError;
}
/**
 * Create a constructor for a client error.
 * @private
 */ function $3bd75317c7f07a31$var$createClientErrorConstructor(HttpError, name, code) {
    var className = name.match(/Error$/) ? name : name + "Error";
    function ClientError(message) {
        // create the error object
        var msg = message != null ? message : $d99DW[code];
        var err = new Error(msg);
        // capture a stack trace to the construction point
        Error.captureStackTrace(err, ClientError);
        // adjust the [[Prototype]]
        $3nZY5(err, ClientError.prototype);
        // redefine the error message
        Object.defineProperty(err, "message", {
            enumerable: true,
            configurable: true,
            value: msg,
            writable: true
        });
        // redefine the error name
        Object.defineProperty(err, "name", {
            enumerable: false,
            configurable: true,
            value: className,
            writable: true
        });
        return err;
    }
    $5yZrL(ClientError, HttpError);
    $3bd75317c7f07a31$var$nameFunc(ClientError, className);
    ClientError.prototype.status = code;
    ClientError.prototype.statusCode = code;
    ClientError.prototype.expose = true;
    return ClientError;
}
/**
 * Create a constructor for a server error.
 * @private
 */ function $3bd75317c7f07a31$var$createServerErrorConstructor(HttpError, name, code) {
    var className = name.match(/Error$/) ? name : name + "Error";
    function ServerError(message) {
        // create the error object
        var msg = message != null ? message : $d99DW[code];
        var err = new Error(msg);
        // capture a stack trace to the construction point
        Error.captureStackTrace(err, ServerError);
        // adjust the [[Prototype]]
        $3nZY5(err, ServerError.prototype);
        // redefine the error message
        Object.defineProperty(err, "message", {
            enumerable: true,
            configurable: true,
            value: msg,
            writable: true
        });
        // redefine the error name
        Object.defineProperty(err, "name", {
            enumerable: false,
            configurable: true,
            value: className,
            writable: true
        });
        return err;
    }
    $5yZrL(ServerError, HttpError);
    $3bd75317c7f07a31$var$nameFunc(ServerError, className);
    ServerError.prototype.status = code;
    ServerError.prototype.statusCode = code;
    ServerError.prototype.expose = false;
    return ServerError;
}
/**
 * Set the name of a function, if possible.
 * @private
 */ function $3bd75317c7f07a31$var$nameFunc(func, name) {
    var desc = Object.getOwnPropertyDescriptor(func, "name");
    if (desc && desc.configurable) {
        desc.value = name;
        Object.defineProperty(func, "name", desc);
    }
}
/**
 * Populate the exports object with constructors for every error class.
 * @private
 */ function $3bd75317c7f07a31$var$populateConstructorExports(exports, codes, HttpError) {
    codes.forEach(function forEachCode(code) {
        var CodeError;
        var name = $23DWx($d99DW[code]);
        switch($3bd75317c7f07a31$var$codeClass(code)){
            case 400:
                CodeError = $3bd75317c7f07a31$var$createClientErrorConstructor(HttpError, name, code);
                break;
            case 500:
                CodeError = $3bd75317c7f07a31$var$createServerErrorConstructor(HttpError, name, code);
                break;
        }
        if (CodeError) {
            // export the constructor
            exports[code] = CodeError;
            exports[name] = CodeError;
        }
    });
    // backwards-compatibility
    exports["I'mateapot"] = $3bd75317c7f07a31$var$deprecate.function(exports.ImATeapot, '"I\'mateapot"; use "ImATeapot" instead');
}

});
parcelRegister("X3KGm", function(module, exports) {
/*!
 * depd
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";
/**
 * Module exports.
 * @public
 */ module.exports = $0b186bdc1ad4c3f3$var$depd;
/**
 * Create deprecate for namespace in caller.
 */ function $0b186bdc1ad4c3f3$var$depd(namespace) {
    if (!namespace) throw new TypeError("argument namespace is required");
    function deprecate(message) {
    // no-op in browser
    }
    deprecate._file = undefined;
    deprecate._ignored = true;
    deprecate._namespace = namespace;
    deprecate._traced = false;
    deprecate._warned = Object.create(null);
    deprecate.function = $0b186bdc1ad4c3f3$var$wrapfunction;
    deprecate.property = $0b186bdc1ad4c3f3$var$wrapproperty;
    return deprecate;
}
/**
 * Return a wrapped function in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $0b186bdc1ad4c3f3$var$wrapfunction(fn, message) {
    if (typeof fn !== "function") throw new TypeError("argument fn must be a function");
    return fn;
}
/**
 * Wrap property in a deprecation message.
 *
 * This is a no-op version of the wrapper, which does nothing but call
 * validation.
 */ function $0b186bdc1ad4c3f3$var$wrapproperty(obj, prop, message) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new TypeError("argument obj must be object");
    var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
    if (!descriptor) throw new TypeError("must call property on owner object");
    if (!descriptor.configurable) throw new TypeError("property must be configurable");
}

});

parcelRegister("3nZY5", function(module, exports) {
"use strict";
/* eslint no-proto: 0 */ module.exports = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $277396adfd87479d$var$setProtoOf : $277396adfd87479d$var$mixinProperties);
function $277396adfd87479d$var$setProtoOf(obj, proto) {
    obj.__proto__ = proto;
    return obj;
}
function $277396adfd87479d$var$mixinProperties(obj, proto) {
    for(var prop in proto)if (!obj.hasOwnProperty(prop)) obj[prop] = proto[prop];
    return obj;
}

});

parcelRegister("d99DW", function(module, exports) {
/*!
 * statuses
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */ "use strict";

var $12Y8A = parcelRequire("12Y8A");
/**
 * Module exports.
 * @public
 */ module.exports = $99239894da664ca7$var$status;
// status code to message map
$99239894da664ca7$var$status.STATUS_CODES = $12Y8A;
// array of status codes
$99239894da664ca7$var$status.codes = $99239894da664ca7$var$populateStatusesMap($99239894da664ca7$var$status, $12Y8A);
// status codes for redirects
$99239894da664ca7$var$status.redirect = {
    300: true,
    301: true,
    302: true,
    303: true,
    305: true,
    307: true,
    308: true
};
// status codes for empty bodies
$99239894da664ca7$var$status.empty = {
    204: true,
    205: true,
    304: true
};
// status codes for when you should retry the request
$99239894da664ca7$var$status.retry = {
    502: true,
    503: true,
    504: true
};
/**
 * Populate the statuses map for given codes.
 * @private
 */ function $99239894da664ca7$var$populateStatusesMap(statuses, codes) {
    var arr = [];
    Object.keys(codes).forEach(function forEachCode(code) {
        var message = codes[code];
        var status = Number(code);
        // Populate properties
        statuses[status] = message;
        statuses[message] = status;
        statuses[message.toLowerCase()] = status;
        // Add to array
        arr.push(status);
    });
    return arr;
}
/**
 * Get the status code.
 *
 * Given a number, this will throw if it is not a known status
 * code, otherwise the code will be returned. Given a string,
 * the string will be parsed for a number and return the code
 * if valid, otherwise will lookup the code assuming this is
 * the status message.
 *
 * @param {string|number} code
 * @returns {number}
 * @public
 */ function $99239894da664ca7$var$status(code) {
    if (typeof code === "number") {
        if (!$99239894da664ca7$var$status[code]) throw new Error("invalid status code: " + code);
        return code;
    }
    if (typeof code !== "string") throw new TypeError("code must be a number or string");
    // '403'
    var n = parseInt(code, 10);
    if (!isNaN(n)) {
        if (!$99239894da664ca7$var$status[n]) throw new Error("invalid status code: " + n);
        return n;
    }
    n = $99239894da664ca7$var$status[code.toLowerCase()];
    if (!n) throw new Error('invalid status message: "' + code + '"');
    return n;
}

});
parcelRegister("12Y8A", function(module, exports) {
module.exports = JSON.parse('{"100":"Continue","101":"Switching Protocols","102":"Processing","103":"Early Hints","200":"OK","201":"Created","202":"Accepted","203":"Non-Authoritative Information","204":"No Content","205":"Reset Content","206":"Partial Content","207":"Multi-Status","208":"Already Reported","226":"IM Used","300":"Multiple Choices","301":"Moved Permanently","302":"Found","303":"See Other","304":"Not Modified","305":"Use Proxy","306":"(Unused)","307":"Temporary Redirect","308":"Permanent Redirect","400":"Bad Request","401":"Unauthorized","402":"Payment Required","403":"Forbidden","404":"Not Found","405":"Method Not Allowed","406":"Not Acceptable","407":"Proxy Authentication Required","408":"Request Timeout","409":"Conflict","410":"Gone","411":"Length Required","412":"Precondition Failed","413":"Payload Too Large","414":"URI Too Long","415":"Unsupported Media Type","416":"Range Not Satisfiable","417":"Expectation Failed","418":"I\'m a teapot","421":"Misdirected Request","422":"Unprocessable Entity","423":"Locked","424":"Failed Dependency","425":"Unordered Collection","426":"Upgrade Required","428":"Precondition Required","429":"Too Many Requests","431":"Request Header Fields Too Large","451":"Unavailable For Legal Reasons","500":"Internal Server Error","501":"Not Implemented","502":"Bad Gateway","503":"Service Unavailable","504":"Gateway Timeout","505":"HTTP Version Not Supported","506":"Variant Also Negotiates","507":"Insufficient Storage","508":"Loop Detected","509":"Bandwidth Limit Exceeded","510":"Not Extended","511":"Network Authentication Required"}');

});


parcelRegister("5yZrL", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};

});

parcelRegister("23DWx", function(module, exports) {
/*!
 * toidentifier
 * Copyright(c) 2016 Douglas Christopher Wilson
 * MIT Licensed
 */ /**
 * Module exports.
 * @public
 */ module.exports = $17fad871ca850f0a$var$toIdentifier;
/**
 * Trasform the given string into a JavaScript identifier
 *
 * @param {string} str
 * @returns {string}
 * @public
 */ function $17fad871ca850f0a$var$toIdentifier(str) {
    return str.split(" ").map(function(token) {
        return token.slice(0, 1).toUpperCase() + token.slice(1);
    }).join("").replace(/[^ _0-9a-z]/gi, "");
}

});


parcelRegister("2jk50", function(module, exports) {

var $Gr8vk = parcelRequire("Gr8vk");
module.exports = $Gr8vk("4EhKA").then(()=>parcelRequire("4cpck"));

});
parcelRegister("Gr8vk", function(module, exports) {
"use strict";

function $07f8f9093a769793$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("27Lyk")).resolve(id));
}
module.exports = $07f8f9093a769793$var$load;

});






parcelRegister("fEfLd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JsonRpcProvider = module.exports.TypedError = module.exports.ErrorContext = void 0;

var $a246u = parcelRequire("a246u");
Object.defineProperty(module.exports, "ErrorContext", {
    enumerable: true,
    get: function() {
        return $a246u.ErrorContext;
    }
});
Object.defineProperty(module.exports, "TypedError", {
    enumerable: true,
    get: function() {
        return $a246u.TypedError;
    }
});

var $833m4 = parcelRequire("833m4");
Object.defineProperty(module.exports, "JsonRpcProvider", {
    enumerable: true,
    get: function() {
        return $833m4.JsonRpcProvider;
    }
});

});


parcelRegister("gphuu", function(module, exports) {
"use strict";
var $bf1c8c6c0b854dc2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bf1c8c6c0b854dc2$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bf1c8c6c0b854dc2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $bf1c8c6c0b854dc2$var$__createBinding(result, mod, k);
    }
    $bf1c8c6c0b854dc2$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = module.exports.logWarning = module.exports.rpc_errors = module.exports.KeyPairEd25519 = module.exports.KeyPair = module.exports.PublicKey = module.exports.format = module.exports.enums = module.exports.web = module.exports.serialize = module.exports.key_pair = void 0;

const $bf1c8c6c0b854dc2$var$key_pair = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("lsY0f")));
module.exports.key_pair = $bf1c8c6c0b854dc2$var$key_pair;

const $bf1c8c6c0b854dc2$var$serialize = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("11V5S")));
module.exports.serialize = $bf1c8c6c0b854dc2$var$serialize;

const $bf1c8c6c0b854dc2$var$web = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("9lI55")));
module.exports.web = $bf1c8c6c0b854dc2$var$web;

const $bf1c8c6c0b854dc2$var$enums = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("kVMwJ")));
module.exports.enums = $bf1c8c6c0b854dc2$var$enums;

const $bf1c8c6c0b854dc2$var$format = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("33Nhm")));
module.exports.format = $bf1c8c6c0b854dc2$var$format;

const $bf1c8c6c0b854dc2$var$rpc_errors = $bf1c8c6c0b854dc2$var$__importStar((parcelRequire("1Z4jS")));
module.exports.rpc_errors = $bf1c8c6c0b854dc2$var$rpc_errors;

Object.defineProperty(module.exports, "PublicKey", {
    enumerable: true,
    get: function() {
        return (parcelRequire("lsY0f")).PublicKey;
    }
});
Object.defineProperty(module.exports, "KeyPair", {
    enumerable: true,
    get: function() {
        return (parcelRequire("lsY0f")).KeyPair;
    }
});
Object.defineProperty(module.exports, "KeyPairEd25519", {
    enumerable: true,
    get: function() {
        return (parcelRequire("lsY0f")).KeyPairEd25519;
    }
});

var $hR4Jw = parcelRequire("hR4Jw");
Object.defineProperty(module.exports, "logWarning", {
    enumerable: true,
    get: function() {
        return $hR4Jw.logWarning;
    }
});

var $hugRD = parcelRequire("hugRD");
Object.defineProperty(module.exports, "Logger", {
    enumerable: true,
    get: function() {
        return $hugRD.Logger;
    }
});

});
parcelRegister("lsY0f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PublicKey = module.exports.KeyType = module.exports.KeyPairEd25519 = module.exports.KeyPair = void 0;

var $hp647 = parcelRequire("hp647");
Object.defineProperty(module.exports, "KeyPair", {
    enumerable: true,
    get: function() {
        return $hp647.KeyPair;
    }
});
Object.defineProperty(module.exports, "KeyPairEd25519", {
    enumerable: true,
    get: function() {
        return $hp647.KeyPairEd25519;
    }
});
Object.defineProperty(module.exports, "KeyType", {
    enumerable: true,
    get: function() {
        return $hp647.KeyType;
    }
});
Object.defineProperty(module.exports, "PublicKey", {
    enumerable: true,
    get: function() {
        return $hp647.PublicKey;
    }
});

});

parcelRegister("11V5S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.base_decode = module.exports.base_encode = module.exports.deserialize = module.exports.serialize = void 0;

var $7U40k = parcelRequire("7U40k");
Object.defineProperty(module.exports, "serialize", {
    enumerable: true,
    get: function() {
        return $7U40k.serialize;
    }
});
Object.defineProperty(module.exports, "deserialize", {
    enumerable: true,
    get: function() {
        return $7U40k.deserialize;
    }
});

var $hNbI3 = parcelRequire("hNbI3");
Object.defineProperty(module.exports, "base_encode", {
    enumerable: true,
    get: function() {
        return $hNbI3.baseEncode;
    }
});
Object.defineProperty(module.exports, "base_decode", {
    enumerable: true,
    get: function() {
        return $hNbI3.baseDecode;
    }
});

});

parcelRegister("9lI55", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fetchJson = void 0;

var $833m4 = parcelRequire("833m4");
Object.defineProperty(module.exports, "fetchJson", {
    enumerable: true,
    get: function() {
        return $833m4.fetchJson;
    }
});

});

parcelRegister("kVMwJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Enum = module.exports.Assignable = void 0;

var $a246u = parcelRequire("a246u");
Object.defineProperty(module.exports, "Assignable", {
    enumerable: true,
    get: function() {
        return $a246u.Assignable;
    }
});
/** @hidden @module */ class $f3cec5f3f44b5edc$var$Enum {
    constructor(properties){
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this[key] = properties[key];
            this.enum = key;
        });
    }
}
module.exports.Enum = $f3cec5f3f44b5edc$var$Enum;

});

parcelRegister("33Nhm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseNearAmount = module.exports.formatNearAmount = module.exports.NEAR_NOMINATION_EXP = module.exports.NEAR_NOMINATION = void 0;

var $hNbI3 = parcelRequire("hNbI3");
Object.defineProperty(module.exports, "NEAR_NOMINATION", {
    enumerable: true,
    get: function() {
        return $hNbI3.NEAR_NOMINATION;
    }
});
Object.defineProperty(module.exports, "NEAR_NOMINATION_EXP", {
    enumerable: true,
    get: function() {
        return $hNbI3.NEAR_NOMINATION_EXP;
    }
});
Object.defineProperty(module.exports, "formatNearAmount", {
    enumerable: true,
    get: function() {
        return $hNbI3.formatNearAmount;
    }
});
Object.defineProperty(module.exports, "parseNearAmount", {
    enumerable: true,
    get: function() {
        return $hNbI3.parseNearAmount;
    }
});

});

parcelRegister("1Z4jS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ServerError = module.exports.getErrorTypeFromErrorMessage = module.exports.formatError = module.exports.parseResultError = module.exports.parseRpcError = void 0;

var $hNbI3 = parcelRequire("hNbI3");
Object.defineProperty(module.exports, "parseRpcError", {
    enumerable: true,
    get: function() {
        return $hNbI3.parseRpcError;
    }
});
Object.defineProperty(module.exports, "parseResultError", {
    enumerable: true,
    get: function() {
        return $hNbI3.parseResultError;
    }
});
Object.defineProperty(module.exports, "formatError", {
    enumerable: true,
    get: function() {
        return $hNbI3.formatError;
    }
});
Object.defineProperty(module.exports, "getErrorTypeFromErrorMessage", {
    enumerable: true,
    get: function() {
        return $hNbI3.getErrorTypeFromErrorMessage;
    }
});
Object.defineProperty(module.exports, "ServerError", {
    enumerable: true,
    get: function() {
        return $hNbI3.ServerError;
    }
});

});

parcelRegister("hR4Jw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.logWarning = module.exports.TypedError = module.exports.PositionalArgsError = module.exports.ErrorContext = module.exports.ArgumentTypeError = module.exports.UnsupportedSerializationError = module.exports.UnknownArgumentError = module.exports.ConflictingOptions = module.exports.ArgumentSchemaError = void 0;

var $nk9dM = parcelRequire("nk9dM");
Object.defineProperty(module.exports, "ArgumentSchemaError", {
    enumerable: true,
    get: function() {
        return $nk9dM.ArgumentSchemaError;
    }
});
Object.defineProperty(module.exports, "ConflictingOptions", {
    enumerable: true,
    get: function() {
        return $nk9dM.ConflictingOptions;
    }
});
Object.defineProperty(module.exports, "UnknownArgumentError", {
    enumerable: true,
    get: function() {
        return $nk9dM.UnknownArgumentError;
    }
});
Object.defineProperty(module.exports, "UnsupportedSerializationError", {
    enumerable: true,
    get: function() {
        return $nk9dM.UnsupportedSerializationError;
    }
});

var $a246u = parcelRequire("a246u");
Object.defineProperty(module.exports, "ArgumentTypeError", {
    enumerable: true,
    get: function() {
        return $a246u.ArgumentTypeError;
    }
});
Object.defineProperty(module.exports, "ErrorContext", {
    enumerable: true,
    get: function() {
        return $a246u.ErrorContext;
    }
});
Object.defineProperty(module.exports, "PositionalArgsError", {
    enumerable: true,
    get: function() {
        return $a246u.PositionalArgsError;
    }
});
Object.defineProperty(module.exports, "TypedError", {
    enumerable: true,
    get: function() {
        return $a246u.TypedError;
    }
});

var $hNbI3 = parcelRequire("hNbI3");
Object.defineProperty(module.exports, "logWarning", {
    enumerable: true,
    get: function() {
        return $hNbI3.logWarning;
    }
});

});
parcelRegister("nk9dM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultisigStateStatus = module.exports.MultisigDeleteRequestRejectionError = module.exports.UnsupportedSerializationError = module.exports.UnknownArgumentError = module.exports.ConflictingOptions = module.exports.ArgumentSchemaError = module.exports.Contract = module.exports.MULTISIG_CONFIRM_METHODS = module.exports.MULTISIG_CHANGE_METHODS = module.exports.MULTISIG_DEPOSIT = module.exports.MULTISIG_GAS = module.exports.MULTISIG_ALLOWANCE = module.exports.MULTISIG_STORAGE_KEY = module.exports.Connection = module.exports.AccountMultisig = module.exports.UrlAccountCreator = module.exports.LocalAccountCreator = module.exports.AccountCreator = module.exports.Account2FA = module.exports.Account = void 0;

var $ivJvg = parcelRequire("ivJvg");
Object.defineProperty(module.exports, "Account", {
    enumerable: true,
    get: function() {
        return $ivJvg.Account;
    }
});

var $16kVz = parcelRequire("16kVz");
Object.defineProperty(module.exports, "Account2FA", {
    enumerable: true,
    get: function() {
        return $16kVz.Account2FA;
    }
});

var $jXt1N = parcelRequire("jXt1N");
Object.defineProperty(module.exports, "AccountCreator", {
    enumerable: true,
    get: function() {
        return $jXt1N.AccountCreator;
    }
});
Object.defineProperty(module.exports, "LocalAccountCreator", {
    enumerable: true,
    get: function() {
        return $jXt1N.LocalAccountCreator;
    }
});
Object.defineProperty(module.exports, "UrlAccountCreator", {
    enumerable: true,
    get: function() {
        return $jXt1N.UrlAccountCreator;
    }
});

var $gPTGa = parcelRequire("gPTGa");
Object.defineProperty(module.exports, "AccountMultisig", {
    enumerable: true,
    get: function() {
        return $gPTGa.AccountMultisig;
    }
});

var $5KY6e = parcelRequire("5KY6e");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function() {
        return $5KY6e.Connection;
    }
});

var $jAUeP = parcelRequire("jAUeP");
Object.defineProperty(module.exports, "MULTISIG_STORAGE_KEY", {
    enumerable: true,
    get: function() {
        return $jAUeP.MULTISIG_STORAGE_KEY;
    }
});
Object.defineProperty(module.exports, "MULTISIG_ALLOWANCE", {
    enumerable: true,
    get: function() {
        return $jAUeP.MULTISIG_ALLOWANCE;
    }
});
Object.defineProperty(module.exports, "MULTISIG_GAS", {
    enumerable: true,
    get: function() {
        return $jAUeP.MULTISIG_GAS;
    }
});
Object.defineProperty(module.exports, "MULTISIG_DEPOSIT", {
    enumerable: true,
    get: function() {
        return $jAUeP.MULTISIG_DEPOSIT;
    }
});
Object.defineProperty(module.exports, "MULTISIG_CHANGE_METHODS", {
    enumerable: true,
    get: function() {
        return $jAUeP.MULTISIG_CHANGE_METHODS;
    }
});
Object.defineProperty(module.exports, "MULTISIG_CONFIRM_METHODS", {
    enumerable: true,
    get: function() {
        return $jAUeP.MULTISIG_CONFIRM_METHODS;
    }
});

var $aHhhG = parcelRequire("aHhhG");
Object.defineProperty(module.exports, "Contract", {
    enumerable: true,
    get: function() {
        return $aHhhG.Contract;
    }
});

var $cqsOI = parcelRequire("cqsOI");
Object.defineProperty(module.exports, "ArgumentSchemaError", {
    enumerable: true,
    get: function() {
        return $cqsOI.ArgumentSchemaError;
    }
});
Object.defineProperty(module.exports, "ConflictingOptions", {
    enumerable: true,
    get: function() {
        return $cqsOI.ConflictingOptions;
    }
});
Object.defineProperty(module.exports, "UnknownArgumentError", {
    enumerable: true,
    get: function() {
        return $cqsOI.UnknownArgumentError;
    }
});
Object.defineProperty(module.exports, "UnsupportedSerializationError", {
    enumerable: true,
    get: function() {
        return $cqsOI.UnsupportedSerializationError;
    }
});

var $jYmNX = parcelRequire("jYmNX");
Object.defineProperty(module.exports, "MultisigDeleteRequestRejectionError", {
    enumerable: true,
    get: function() {
        return $jYmNX.MultisigDeleteRequestRejectionError;
    }
});
Object.defineProperty(module.exports, "MultisigStateStatus", {
    enumerable: true,
    get: function() {
        return $jYmNX.MultisigStateStatus;
    }
});

});
parcelRegister("ivJvg", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d79e6b3e68793bbb$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $d79e6b3e68793bbb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d79e6b3e68793bbb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account = void 0;

var $hp647 = parcelRequire("hp647");

var $833m4 = parcelRequire("833m4");

var $hynq1 = parcelRequire("hynq1");

var $a246u = parcelRequire("a246u");

var $hNbI3 = parcelRequire("hNbI3");

const $d79e6b3e68793bbb$var$bn_js_1 = $d79e6b3e68793bbb$var$__importDefault((parcelRequire("dEXSZ")));
const { addKey: $d79e6b3e68793bbb$var$addKey, createAccount: $d79e6b3e68793bbb$var$createAccount, deleteAccount: $d79e6b3e68793bbb$var$deleteAccount, deleteKey: $d79e6b3e68793bbb$var$deleteKey, deployContract: $d79e6b3e68793bbb$var$deployContract, fullAccessKey: $d79e6b3e68793bbb$var$fullAccessKey, functionCall: $d79e6b3e68793bbb$var$functionCall, functionCallAccessKey: $d79e6b3e68793bbb$var$functionCallAccessKey, stake: $d79e6b3e68793bbb$var$stake, transfer: $d79e6b3e68793bbb$var$transfer } = $hynq1.actionCreators;
// Default number of retries with different nonce before giving up on a transaction.
const $d79e6b3e68793bbb$var$TX_NONCE_RETRY_NUMBER = 12;
// Default wait until next retry in millis.
const $d79e6b3e68793bbb$var$TX_NONCE_RETRY_WAIT = 500;
// Exponential back off for waiting to retry.
const $d79e6b3e68793bbb$var$TX_NONCE_RETRY_WAIT_BACKOFF = 1.5;
function $d79e6b3e68793bbb$var$parseJsonFromRawResponse(response) {
    return JSON.parse($d79e6b3e68793bbb$require$Buffer.from(response).toString());
}
function $d79e6b3e68793bbb$var$bytesJsonStringify(input) {
    return $d79e6b3e68793bbb$require$Buffer.from(JSON.stringify(input));
}
/**
 * This class provides common account related RPC calls including signing transactions with a {@link "@near-js/crypto".key_pair.KeyPair | KeyPair}.
 */ class $d79e6b3e68793bbb$var$Account {
    constructor(connection, accountId){
        /** @hidden */ this.accessKeyByPublicKeyCache = {};
        this.connection = connection;
        this.accountId = accountId;
    }
    /**
     * Returns basic NEAR account information via the `view_account` RPC query method
     * @see [https://docs.near.org/api/rpc/contracts#view-account](https://docs.near.org/api/rpc/contracts#view-account)
     */ state() {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            return this.connection.provider.query({
                request_type: "view_account",
                account_id: this.accountId,
                finality: "optimistic"
            });
        });
    }
    /**
     * Create a signed transaction which can be broadcast to the network
     * @param receiverId NEAR account receiving the transaction
     * @param actions list of actions to perform as part of the transaction
     * @see {@link "@near-js/providers".json-rpc-provider.JsonRpcProvider.sendTransaction | JsonRpcProvider.sendTransaction}
     */ signTransaction(receiverId, actions) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            const accessKeyInfo = yield this.findAccessKey(receiverId, actions);
            if (!accessKeyInfo) throw new $a246u.TypedError(`Can not sign transactions for account ${this.accountId} on network ${this.connection.networkId}, no matching key pair exists for this account`, "KeyNotFound");
            const { accessKey: accessKey } = accessKeyInfo;
            const block = yield this.connection.provider.block({
                finality: "final"
            });
            const blockHash = block.header.hash;
            const nonce = accessKey.nonce.add(new $d79e6b3e68793bbb$var$bn_js_1.default(1));
            return yield (0, $hynq1.signTransaction)(receiverId, nonce, actions, (0, $hNbI3.baseDecode)(blockHash), this.connection.signer, this.accountId, this.connection.networkId);
        });
    }
    /**
     * Sign a transaction to perform a list of actions and broadcast it using the RPC API.
     * @see {@link "@near-js/providers".json-rpc-provider.JsonRpcProvider | JsonRpcProvider }
     *
     * @param options The options for signing and sending the transaction.
     * @param options.receiverId The NEAR account ID of the transaction receiver.
     * @param options.actions The list of actions to be performed in the transaction.
     * @param options.returnError Whether to return an error if the transaction fails.
     * @returns {Promise<FinalExecutionOutcome>} A promise that resolves to the final execution outcome of the transaction.
     */ signAndSendTransaction({ receiverId: receiverId, actions: actions, returnError: returnError }) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            let txHash, signedTx;
            // TODO: TX_NONCE (different constants for different uses of exponentialBackoff?)
            const result = yield (0, $833m4.exponentialBackoff)($d79e6b3e68793bbb$var$TX_NONCE_RETRY_WAIT, $d79e6b3e68793bbb$var$TX_NONCE_RETRY_NUMBER, $d79e6b3e68793bbb$var$TX_NONCE_RETRY_WAIT_BACKOFF, ()=>$d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
                    [txHash, signedTx] = yield this.signTransaction(receiverId, actions);
                    const publicKey = signedTx.transaction.publicKey;
                    try {
                        return yield this.connection.provider.sendTransaction(signedTx);
                    } catch (error) {
                        if (error.type === "InvalidNonce") {
                            $hNbI3.Logger.warn(`Retrying transaction ${receiverId}:${(0, $hNbI3.baseEncode)(txHash)} with new nonce.`);
                            delete this.accessKeyByPublicKeyCache[publicKey.toString()];
                            return null;
                        }
                        if (error.type === "Expired") {
                            $hNbI3.Logger.warn(`Retrying transaction ${receiverId}:${(0, $hNbI3.baseEncode)(txHash)} due to expired block hash`);
                            return null;
                        }
                        error.context = new $a246u.ErrorContext((0, $hNbI3.baseEncode)(txHash));
                        throw error;
                    }
                }));
            if (!result) // TODO: This should have different code actually, as means "transaction not submitted for sure"
            throw new $a246u.TypedError("nonce retries exceeded for transaction. This usually means there are too many parallel requests with the same access key.", "RetriesExceeded");
            (0, $hNbI3.printTxOutcomeLogsAndFailures)({
                contractId: signedTx.transaction.receiverId,
                outcome: result
            });
            // Should be falsy if result.status.Failure is null
            if (!returnError && typeof result.status === "object" && typeof result.status.Failure === "object" && result.status.Failure !== null) {
                // if error data has error_message and error_type properties, we consider that node returned an error in the old format
                if (result.status.Failure.error_message && result.status.Failure.error_type) throw new $a246u.TypedError(`Transaction ${result.transaction_outcome.id} failed. ${result.status.Failure.error_message}`, result.status.Failure.error_type);
                else throw (0, $hNbI3.parseResultError)(result);
            }
            // TODO: if Tx is Unknown or Started.
            return result;
        });
    }
    /**
     * Finds the {@link AccessKeyView} associated with the accounts {@link PublicKey} stored in the {@link "@near-js/keystores".keystore.KeyStore | Keystore}.
     *
     * @todo Find matching access key based on transaction (i.e. receiverId and actions)
     *
     * @param receiverId currently unused (see todo)
     * @param actions currently unused (see todo)
     * @returns `{ publicKey PublicKey; accessKey: AccessKeyView }`
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    findAccessKey(receiverId, actions) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            // TODO: Find matching access key based on transaction (i.e. receiverId and actions)
            const publicKey = yield this.connection.signer.getPublicKey(this.accountId, this.connection.networkId);
            if (!publicKey) throw new $a246u.TypedError(`no matching key pair found in ${this.connection.signer}`, "PublicKeyNotFound");
            const cachedAccessKey = this.accessKeyByPublicKeyCache[publicKey.toString()];
            if (cachedAccessKey !== undefined) return {
                publicKey: publicKey,
                accessKey: cachedAccessKey
            };
            try {
                const rawAccessKey = yield this.connection.provider.query({
                    request_type: "view_access_key",
                    account_id: this.accountId,
                    public_key: publicKey.toString(),
                    finality: "optimistic"
                });
                // store nonce as BN to preserve precision on big number
                const accessKey = Object.assign(Object.assign({}, rawAccessKey), {
                    nonce: new $d79e6b3e68793bbb$var$bn_js_1.default(rawAccessKey.nonce)
                });
                // this function can be called multiple times and retrieve the same access key
                // this checks to see if the access key was already retrieved and cached while
                // the above network call was in flight. To keep nonce values in line, we return
                // the cached access key.
                if (this.accessKeyByPublicKeyCache[publicKey.toString()]) return {
                    publicKey: publicKey,
                    accessKey: this.accessKeyByPublicKeyCache[publicKey.toString()]
                };
                this.accessKeyByPublicKeyCache[publicKey.toString()] = accessKey;
                return {
                    publicKey: publicKey,
                    accessKey: accessKey
                };
            } catch (e) {
                if (e.type == "AccessKeyDoesNotExist") return null;
                throw e;
            }
        });
    }
    /**
     * Create a new account and deploy a contract to it
     *
     * @param contractId NEAR account where the contract is deployed
     * @param publicKey The public key to add to the created contract account
     * @param data The compiled contract code
     * @param amount of NEAR to transfer to the created contract account. Transfer enough to pay for storage https://docs.near.org/docs/concepts/storage-staking
     */ createAndDeployContract(contractId, publicKey, data, amount) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            const accessKey = $d79e6b3e68793bbb$var$fullAccessKey();
            yield this.signAndSendTransaction({
                receiverId: contractId,
                actions: [
                    $d79e6b3e68793bbb$var$createAccount(),
                    $d79e6b3e68793bbb$var$transfer(amount),
                    $d79e6b3e68793bbb$var$addKey($hp647.PublicKey.from(publicKey), accessKey),
                    $d79e6b3e68793bbb$var$deployContract(data)
                ]
            });
            const contractAccount = new $d79e6b3e68793bbb$var$Account(this.connection, contractId);
            return contractAccount;
        });
    }
    /**
     * @param receiverId NEAR account receiving Ⓝ
     * @param amount Amount to send in yoctoⓃ
     */ sendMoney(receiverId, amount) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            return this.signAndSendTransaction({
                receiverId: receiverId,
                actions: [
                    $d79e6b3e68793bbb$var$transfer(amount)
                ]
            });
        });
    }
    /**
     * @param newAccountId NEAR account name to be created
     * @param publicKey A public key created from the masterAccount
     */ createAccount(newAccountId, publicKey, amount) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            const accessKey = $d79e6b3e68793bbb$var$fullAccessKey();
            return this.signAndSendTransaction({
                receiverId: newAccountId,
                actions: [
                    $d79e6b3e68793bbb$var$createAccount(),
                    $d79e6b3e68793bbb$var$transfer(amount),
                    $d79e6b3e68793bbb$var$addKey($hp647.PublicKey.from(publicKey), accessKey)
                ]
            });
        });
    }
    /**
     * @param beneficiaryId The NEAR account that will receive the remaining Ⓝ balance from the account being deleted
     */ deleteAccount(beneficiaryId) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            $hNbI3.Logger.log("Deleting an account does not automatically transfer NFTs and FTs to the beneficiary address. Ensure to transfer assets before deleting.");
            return this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [
                    $d79e6b3e68793bbb$var$deleteAccount(beneficiaryId)
                ]
            });
        });
    }
    /**
     * @param data The compiled contract code
     */ deployContract(data) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            return this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [
                    $d79e6b3e68793bbb$var$deployContract(data)
                ]
            });
        });
    }
    /** @hidden */ encodeJSContractArgs(contractId, method, args) {
        return $d79e6b3e68793bbb$require$Buffer.concat([
            $d79e6b3e68793bbb$require$Buffer.from(contractId),
            $d79e6b3e68793bbb$require$Buffer.from([
                0
            ]),
            $d79e6b3e68793bbb$require$Buffer.from(method),
            $d79e6b3e68793bbb$require$Buffer.from([
                0
            ]),
            $d79e6b3e68793bbb$require$Buffer.from(args)
        ]);
    }
    /**
      * Execute a function call.
      * @param options The options for the function call.
      * @param options.contractId The NEAR account ID of the smart contract.
      * @param options.methodName The name of the method to be called on the smart contract.
      * @param options.args The arguments to be passed to the method.
      * @param options.gas The maximum amount of gas to be used for the function call.
      * @param options.attachedDeposit The amount of NEAR tokens to be attached to the function call.
      * @param options.walletMeta Metadata for wallet integration.
      * @param options.walletCallbackUrl The callback URL for wallet integration.
      * @param options.stringify A function to convert input arguments into bytes array
      * @param options.jsContract Whether the contract is from JS SDK, automatically encodes args from JS SDK to binary.
      * @returns {Promise<FinalExecutionOutcome>} A promise that resolves to the final execution outcome of the function call.
      */ functionCall({ contractId: contractId, methodName: methodName, args: args = {}, gas: gas = $hNbI3.DEFAULT_FUNCTION_CALL_GAS, attachedDeposit: attachedDeposit, walletMeta: walletMeta, walletCallbackUrl: walletCallbackUrl, stringify: stringify, jsContract: jsContract }) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            this.validateArgs(args);
            let functionCallArgs;
            if (jsContract) {
                const encodedArgs = this.encodeJSContractArgs(contractId, methodName, JSON.stringify(args));
                functionCallArgs = [
                    "call_js_contract",
                    encodedArgs,
                    gas,
                    attachedDeposit,
                    null,
                    true
                ];
            } else {
                const stringifyArg = stringify === undefined ? $hynq1.stringifyJsonOrBytes : stringify;
                functionCallArgs = [
                    methodName,
                    args,
                    gas,
                    attachedDeposit,
                    stringifyArg,
                    false
                ];
            }
            return this.signAndSendTransaction({
                receiverId: jsContract ? this.connection.jsvmAccountId : contractId,
                // eslint-disable-next-line prefer-spread
                actions: [
                    $d79e6b3e68793bbb$var$functionCall.apply(void 0, functionCallArgs)
                ],
                walletMeta: walletMeta,
                walletCallbackUrl: walletCallbackUrl
            });
        });
    }
    /**
     * @see [https://docs.near.org/concepts/basics/accounts/access-keys](https://docs.near.org/concepts/basics/accounts/access-keys)
     * @todo expand this API to support more options.
     * @param publicKey A public key to be associated with the contract
     * @param contractId NEAR account where the contract is deployed
     * @param methodNames The method names on the contract that should be allowed to be called. Pass null for no method names and '' or [] for any method names.
     * @param amount Payment in yoctoⓃ that is sent to the contract during this function call
     */ addKey(publicKey, contractId, methodNames, amount) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            if (!methodNames) methodNames = [];
            if (!Array.isArray(methodNames)) methodNames = [
                methodNames
            ];
            let accessKey;
            if (!contractId) accessKey = $d79e6b3e68793bbb$var$fullAccessKey();
            else accessKey = $d79e6b3e68793bbb$var$functionCallAccessKey(contractId, methodNames, amount);
            return this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [
                    $d79e6b3e68793bbb$var$addKey($hp647.PublicKey.from(publicKey), accessKey)
                ]
            });
        });
    }
    /**
     * @param publicKey The public key to be deleted
     * @returns {Promise<FinalExecutionOutcome>}
     */ deleteKey(publicKey) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            return this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [
                    $d79e6b3e68793bbb$var$deleteKey($hp647.PublicKey.from(publicKey))
                ]
            });
        });
    }
    /**
     * @see [https://near-nodes.io/validator/staking-and-delegation](https://near-nodes.io/validator/staking-and-delegation)
     *
     * @param publicKey The public key for the account that's staking
     * @param amount The account to stake in yoctoⓃ
     */ stake(publicKey, amount) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            return this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: [
                    $d79e6b3e68793bbb$var$stake(amount, $hp647.PublicKey.from(publicKey))
                ]
            });
        });
    }
    /**
     * Compose and sign a SignedDelegate action to be executed in a transaction on behalf of this Account instance
     *
     * @param options Options for the transaction.
     * @param options.actions Actions to be included in the meta transaction
     * @param options.blockHeightTtl Number of blocks past the current block height for which the SignedDelegate action may be included in a meta transaction
     * @param options.receiverId Receiver account of the meta transaction
     */ signedDelegate({ actions: actions, blockHeightTtl: blockHeightTtl, receiverId: receiverId }) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            const { provider: provider, signer: signer } = this.connection;
            const { header: header } = yield provider.block({
                finality: "final"
            });
            const { accessKey: accessKey, publicKey: publicKey } = yield this.findAccessKey(null, null);
            const delegateAction = (0, $hynq1.buildDelegateAction)({
                actions: actions,
                maxBlockHeight: new $d79e6b3e68793bbb$var$bn_js_1.default(header.height).add(new $d79e6b3e68793bbb$var$bn_js_1.default(blockHeightTtl)),
                nonce: new $d79e6b3e68793bbb$var$bn_js_1.default(accessKey.nonce).add(new $d79e6b3e68793bbb$var$bn_js_1.default(1)),
                publicKey: publicKey,
                receiverId: receiverId,
                senderId: this.accountId
            });
            const { signedDelegateAction: signedDelegateAction } = yield (0, $hynq1.signDelegateAction)({
                delegateAction: delegateAction,
                signer: {
                    sign: (message)=>$d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
                            const { signature: signature } = yield signer.signMessage(message, delegateAction.senderId, this.connection.networkId);
                            return signature;
                        })
                }
            });
            return signedDelegateAction;
        });
    }
    /** @hidden */ validateArgs(args) {
        const isUint8Array = args.byteLength !== undefined && args.byteLength === args.length;
        if (isUint8Array) return;
        if (Array.isArray(args) || typeof args !== "object") throw new $a246u.PositionalArgsError();
    }
    /**
     * Invoke a contract view function using the RPC API.
     * @see [https://docs.near.org/api/rpc/contracts#call-a-contract-function](https://docs.near.org/api/rpc/contracts#call-a-contract-function)
     *
     * @param options Function call options.
     * @param options.contractId NEAR account where the contract is deployed
     * @param options.methodName The view-only method (no state mutations) name on the contract as it is written in the contract code
     * @param options.args Any arguments to the view contract method, wrapped in JSON
     * @param options.parse Parse the result of the call. Receives a Buffer (bytes array) and converts it to any object. By default result will be treated as json.
     * @param options.stringify Convert input arguments into a bytes array. By default the input is treated as a JSON.
     * @param options.jsContract Is contract from JS SDK, automatically encodes args from JS SDK to binary.
     * @param options.blockQuery specifies which block to query state at. By default returns last "optimistic" block (i.e. not necessarily finalized).
     * @returns {Promise<any>}
     */ viewFunction({ contractId: contractId, methodName: methodName, args: args = {}, parse: parse = $d79e6b3e68793bbb$var$parseJsonFromRawResponse, stringify: stringify = $d79e6b3e68793bbb$var$bytesJsonStringify, jsContract: jsContract = false, blockQuery: blockQuery = {
        finality: "optimistic"
    } }) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            let encodedArgs;
            this.validateArgs(args);
            if (jsContract) encodedArgs = this.encodeJSContractArgs(contractId, methodName, Object.keys(args).length > 0 ? JSON.stringify(args) : "");
            else encodedArgs = stringify(args);
            const result = yield this.connection.provider.query(Object.assign(Object.assign({
                request_type: "call_function"
            }, blockQuery), {
                account_id: jsContract ? this.connection.jsvmAccountId : contractId,
                method_name: jsContract ? "view_js_contract" : methodName,
                args_base64: encodedArgs.toString("base64")
            }));
            if (result.logs) (0, $hNbI3.printTxOutcomeLogs)({
                contractId: contractId,
                logs: result.logs
            });
            return result.result && result.result.length > 0 && parse($d79e6b3e68793bbb$require$Buffer.from(result.result));
        });
    }
    /**
     * Returns the state (key value pairs) of this account's contract based on the key prefix.
     * Pass an empty string for prefix if you would like to return the entire state.
     * @see [https://docs.near.org/api/rpc/contracts#view-contract-state](https://docs.near.org/api/rpc/contracts#view-contract-state)
     *
     * @param prefix allows to filter which keys should be returned. Empty prefix means all keys. String prefix is utf-8 encoded.
     * @param blockQuery specifies which block to query state at. By default returns last "optimistic" block (i.e. not necessarily finalized).
     */ viewState(prefix, blockQuery = {
        finality: "optimistic"
    }) {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            const { values: values } = yield this.connection.provider.query(Object.assign(Object.assign({
                request_type: "view_state"
            }, blockQuery), {
                account_id: this.accountId,
                prefix_base64: $d79e6b3e68793bbb$require$Buffer.from(prefix).toString("base64")
            }));
            return values.map(({ key: key, value: value })=>({
                    key: $d79e6b3e68793bbb$require$Buffer.from(key, "base64"),
                    value: $d79e6b3e68793bbb$require$Buffer.from(value, "base64")
                }));
        });
    }
    /**
     * Get all access keys for the account
     * @see [https://docs.near.org/api/rpc/access-keys#view-access-key-list](https://docs.near.org/api/rpc/access-keys#view-access-key-list)
     */ getAccessKeys() {
        var _a;
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.connection.provider.query({
                request_type: "view_access_key_list",
                account_id: this.accountId,
                finality: "optimistic"
            });
            // Replace raw nonce into a new BN
            return (_a = response === null || response === void 0 ? void 0 : response.keys) === null || _a === void 0 ? void 0 : _a.map((key)=>Object.assign(Object.assign({}, key), {
                    access_key: Object.assign(Object.assign({}, key.access_key), {
                        nonce: new $d79e6b3e68793bbb$var$bn_js_1.default(key.access_key.nonce)
                    })
                }));
        });
    }
    /**
     * Returns a list of authorized apps
     * @todo update the response value to return all the different keys, not just app keys.
     */ getAccountDetails() {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            // TODO: update the response value to return all the different keys, not just app keys.
            // Also if we need this function, or getAccessKeys is good enough.
            const accessKeys = yield this.getAccessKeys();
            const authorizedApps = accessKeys.filter((item)=>item.access_key.permission !== "FullAccess").map((item)=>{
                const perm = item.access_key.permission;
                return {
                    contractId: perm.FunctionCall.receiver_id,
                    amount: perm.FunctionCall.allowance,
                    publicKey: item.public_key
                };
            });
            return {
                authorizedApps: authorizedApps
            };
        });
    }
    /**
     * Returns calculated account balance
     */ getAccountBalance() {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            const protocolConfig = yield this.connection.provider.experimental_protocolConfig({
                finality: "final"
            });
            const state = yield this.state();
            const costPerByte = new $d79e6b3e68793bbb$var$bn_js_1.default(protocolConfig.runtime_config.storage_amount_per_byte);
            const stateStaked = new $d79e6b3e68793bbb$var$bn_js_1.default(state.storage_usage).mul(costPerByte);
            const staked = new $d79e6b3e68793bbb$var$bn_js_1.default(state.locked);
            const totalBalance = new $d79e6b3e68793bbb$var$bn_js_1.default(state.amount).add(staked);
            const availableBalance = totalBalance.sub($d79e6b3e68793bbb$var$bn_js_1.default.max(staked, stateStaked));
            return {
                total: totalBalance.toString(),
                stateStaked: stateStaked.toString(),
                staked: staked.toString(),
                available: availableBalance.toString()
            };
        });
    }
    /**
     * Returns the NEAR tokens balance and validators of a given account that is delegated to the staking pools that are part of the validators set in the current epoch.
     *
     * NOTE: If the tokens are delegated to a staking pool that is currently on pause or does not have enough tokens to participate in validation, they won't be accounted for.
     * @returns {Promise<ActiveDelegatedStakeBalance>}
     */ getActiveDelegatedStakeBalance() {
        return $d79e6b3e68793bbb$var$__awaiter(this, void 0, void 0, function*() {
            const block = yield this.connection.provider.block({
                finality: "final"
            });
            const blockHash = block.header.hash;
            const epochId = block.header.epoch_id;
            const { current_validators: current_validators, next_validators: next_validators, current_proposals: current_proposals } = yield this.connection.provider.validators(epochId);
            const pools = new Set();
            [
                ...current_validators,
                ...next_validators,
                ...current_proposals
            ].forEach((validator)=>pools.add(validator.account_id));
            const uniquePools = [
                ...pools
            ];
            const promises = uniquePools.map((validator)=>this.viewFunction({
                    contractId: validator,
                    methodName: "get_account_total_balance",
                    args: {
                        account_id: this.accountId
                    },
                    blockQuery: {
                        blockId: blockHash
                    }
                }));
            const results = yield Promise.allSettled(promises);
            const hasTimeoutError = results.some((result)=>{
                if (result.status === "rejected" && result.reason.type === "TimeoutError") return true;
                return false;
            });
            // When RPC is down and return timeout error, throw error
            if (hasTimeoutError) throw new Error("Failed to get delegated stake balance");
            const summary = results.reduce((result, state, index)=>{
                const validatorId = uniquePools[index];
                if (state.status === "fulfilled") {
                    const currentBN = new $d79e6b3e68793bbb$var$bn_js_1.default(state.value);
                    if (!currentBN.isZero()) return Object.assign(Object.assign({}, result), {
                        stakedValidators: [
                            ...result.stakedValidators,
                            {
                                validatorId: validatorId,
                                amount: currentBN.toString()
                            }
                        ],
                        total: result.total.add(currentBN)
                    });
                }
                if (state.status === "rejected") return Object.assign(Object.assign({}, result), {
                    failedValidators: [
                        ...result.failedValidators,
                        {
                            validatorId: validatorId,
                            error: state.reason
                        }
                    ]
                });
                return result;
            }, {
                stakedValidators: [],
                failedValidators: [],
                total: new $d79e6b3e68793bbb$var$bn_js_1.default(0)
            });
            return Object.assign(Object.assign({}, summary), {
                total: summary.total.toString()
            });
        });
    }
}
module.exports.Account = $d79e6b3e68793bbb$var$Account;

});

parcelRegister("16kVz", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $0cd695bd23dfbccb$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $0cd695bd23dfbccb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0cd695bd23dfbccb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account2FA = void 0;

var $hp647 = parcelRequire("hp647");

var $a246u = parcelRequire("a246u");

var $833m4 = parcelRequire("833m4");

var $hynq1 = parcelRequire("hynq1");

var $hNbI3 = parcelRequire("hNbI3");

const $0cd695bd23dfbccb$var$bn_js_1 = $0cd695bd23dfbccb$var$__importDefault((parcelRequire("dEXSZ")));

var $gPTGa = parcelRequire("gPTGa");

var $jAUeP = parcelRequire("jAUeP");

var $jYmNX = parcelRequire("jYmNX");
const { addKey: $0cd695bd23dfbccb$var$addKey, deleteKey: $0cd695bd23dfbccb$var$deleteKey, deployContract: $0cd695bd23dfbccb$var$deployContract, fullAccessKey: $0cd695bd23dfbccb$var$fullAccessKey, functionCall: $0cd695bd23dfbccb$var$functionCall, functionCallAccessKey: $0cd695bd23dfbccb$var$functionCallAccessKey } = $hynq1.actionCreators;
class $0cd695bd23dfbccb$var$Account2FA extends $gPTGa.AccountMultisig {
    constructor(connection, accountId, options){
        super(connection, accountId, options);
        this.helperUrl = "https://helper.testnet.near.org";
        this.helperUrl = options.helperUrl || this.helperUrl;
        this.storage = options.storage;
        this.sendCode = options.sendCode || this.sendCodeDefault;
        this.getCode = options.getCode || this.getCodeDefault;
        this.verifyCode = options.verifyCode || this.verifyCodeDefault;
        this.onConfirmResult = options.onConfirmResult;
    }
    /**
     * Sign a transaction to preform a list of actions and broadcast it using the RPC API.
     * @see {@link "@near-js/providers".json-rpc-provider.JsonRpcProvider.sendTransaction | JsonRpcProvider.sendTransaction}
     *
     * @param options Options for the transaction.
     * @param options.receiverId The NEAR account ID of the transaction receiver.
     * @param options.actions The list of actions to be included in the transaction.
     * @returns {Promise<FinalExecutionOutcome>} A promise that resolves to the final execution outcome of the transaction.
     */ signAndSendTransaction({ receiverId: receiverId, actions: actions }) {
        const _super = Object.create(null, {
            signAndSendTransaction: {
                get: ()=>super.signAndSendTransaction
            }
        });
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            yield _super.signAndSendTransaction.call(this, {
                receiverId: receiverId,
                actions: actions
            });
            // TODO: Should following override onRequestResult in superclass instead of doing custom signAndSendTransaction?
            yield this.sendCode();
            const result = yield this.promptAndVerify();
            if (this.onConfirmResult) yield this.onConfirmResult(result);
            return result;
        });
    }
    // default helpers for CH deployments of multisig
    /**
     * Deploy a multisig contract with 2FA and handle the deployment process.
     * @param contractBytes - The bytecode of the multisig contract.
     * @returns {Promise<FinalExecutionOutcome>} A promise that resolves to the final execution outcome of the deployment.
     */ deployMultisig(contractBytes) {
        const _super = Object.create(null, {
            signAndSendTransactionWithAccount: {
                get: ()=>super.signAndSendTransactionWithAccount
            }
        });
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            const { accountId: accountId } = this;
            const seedOrLedgerKey = (yield this.getRecoveryMethods()).data.filter(({ kind: kind, publicKey: publicKey })=>(kind === "phrase" || kind === "ledger") && publicKey !== null).map((rm)=>rm.publicKey);
            const fak2lak = (yield this.getAccessKeys()).filter(({ public_key: public_key, access_key: { permission: permission } })=>permission === "FullAccess" && !seedOrLedgerKey.includes(public_key)).map((ak)=>ak.public_key).map($0cd695bd23dfbccb$var$toPK);
            const confirmOnlyKey = $0cd695bd23dfbccb$var$toPK((yield this.postSignedJson("/2fa/getAccessKey", {
                accountId: accountId
            })).publicKey);
            const newArgs = $0cd695bd23dfbccb$require$Buffer.from(JSON.stringify({
                "num_confirmations": 2
            }));
            const actions = [
                ...fak2lak.map((pk)=>$0cd695bd23dfbccb$var$deleteKey(pk)),
                ...fak2lak.map((pk)=>$0cd695bd23dfbccb$var$addKey(pk, $0cd695bd23dfbccb$var$functionCallAccessKey(accountId, $jAUeP.MULTISIG_CHANGE_METHODS, null))),
                $0cd695bd23dfbccb$var$addKey(confirmOnlyKey, $0cd695bd23dfbccb$var$functionCallAccessKey(accountId, $jAUeP.MULTISIG_CONFIRM_METHODS, null)),
                $0cd695bd23dfbccb$var$deployContract(contractBytes)
            ];
            const newFunctionCallActionBatch = actions.concat($0cd695bd23dfbccb$var$functionCall("new", newArgs, $jAUeP.MULTISIG_GAS, $jAUeP.MULTISIG_DEPOSIT));
            $hNbI3.Logger.log("deploying multisig contract for", accountId);
            const { stateStatus: multisigStateStatus } = yield this.checkMultisigCodeAndStateStatus(contractBytes);
            switch(multisigStateStatus){
                case $jYmNX.MultisigStateStatus.STATE_NOT_INITIALIZED:
                    return yield _super.signAndSendTransactionWithAccount.call(this, accountId, newFunctionCallActionBatch);
                case $jYmNX.MultisigStateStatus.VALID_STATE:
                    return yield _super.signAndSendTransactionWithAccount.call(this, accountId, actions);
                case $jYmNX.MultisigStateStatus.INVALID_STATE:
                    throw new $a246u.TypedError(`Can not deploy a contract to account ${this.accountId} on network ${this.connection.networkId}, the account has existing state.`, "ContractHasExistingState");
                default:
                    throw new $a246u.TypedError(`Can not deploy a contract to account ${this.accountId} on network ${this.connection.networkId}, the account state could not be verified.`, "ContractStateUnknown");
            }
        });
    }
    /**
     * Disable 2FA with the option to clean up contract state.
     * @param options Options for disabling 2FA.
     * @param options.contractBytes The bytecode of the contract to deploy.
     * @param options.cleanupContractBytes The bytecode of the cleanup contract (optional).
     * @returns {Promise<FinalExecutionOutcome>} A promise that resolves to the final execution outcome of the operation.
     */ disableWithFAK({ contractBytes: contractBytes, cleanupContractBytes: cleanupContractBytes }) {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            let cleanupActions = [];
            if (cleanupContractBytes) {
                yield this.deleteAllRequests().catch((e)=>e);
                cleanupActions = yield this.get2faDisableCleanupActions(cleanupContractBytes);
            }
            const keyConversionActions = yield this.get2faDisableKeyConversionActions();
            const actions = [
                ...cleanupActions,
                ...keyConversionActions,
                $0cd695bd23dfbccb$var$deployContract(contractBytes)
            ];
            const accessKeyInfo = yield this.findAccessKey(this.accountId, actions);
            if (accessKeyInfo && accessKeyInfo.accessKey && accessKeyInfo.accessKey.permission !== "FullAccess") throw new $a246u.TypedError("No full access key found in keystore. Unable to bypass multisig", "NoFAKFound");
            return this.signAndSendTransactionWithAccount(this.accountId, actions);
        });
    }
    /**
     * Retrieves cleanup actions for disabling 2FA.
     * @param cleanupContractBytes - The bytecode of the cleanup contract.
     * @returns {Promise<Action[]>} - A promise that resolves to an array of cleanup actions.
     */ get2faDisableCleanupActions(cleanupContractBytes) {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            const currentAccountState = yield this.viewState("").catch((error)=>{
                const cause = error.cause && error.cause.name;
                if (cause == "NO_CONTRACT_CODE") return [];
                throw cause == "TOO_LARGE_CONTRACT_STATE" ? new $a246u.TypedError(`Can not deploy a contract to account ${this.accountId} on network ${this.connection.networkId}, the account has existing state.`, "ContractHasExistingState") : error;
            });
            const currentAccountStateKeys = currentAccountState.map(({ key: key })=>key.toString("base64"));
            return currentAccountState.length ? [
                $0cd695bd23dfbccb$var$deployContract(cleanupContractBytes),
                $0cd695bd23dfbccb$var$functionCall("clean", {
                    keys: currentAccountStateKeys
                }, $jAUeP.MULTISIG_GAS, new $0cd695bd23dfbccb$var$bn_js_1.default("0"))
            ] : [];
        });
    }
    /**
     * Retrieves key conversion actions for disabling 2FA.
     * @returns {Promise<Action[]>} - A promise that resolves to an array of key conversion actions.
     */ get2faDisableKeyConversionActions() {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            const { accountId: accountId } = this;
            const accessKeys = yield this.getAccessKeys();
            const lak2fak = accessKeys.filter(({ access_key: access_key })=>access_key.permission !== "FullAccess").filter(({ access_key: access_key })=>{
                const perm = access_key.permission.FunctionCall;
                return perm.receiver_id === accountId && perm.method_names.length === 4 && perm.method_names.includes("add_request_and_confirm");
            });
            const confirmOnlyKey = $hp647.PublicKey.from((yield this.postSignedJson("/2fa/getAccessKey", {
                accountId: accountId
            })).publicKey);
            return [
                $0cd695bd23dfbccb$var$deleteKey(confirmOnlyKey),
                ...lak2fak.map(({ public_key: public_key })=>$0cd695bd23dfbccb$var$deleteKey($hp647.PublicKey.from(public_key))),
                ...lak2fak.map(({ public_key: public_key })=>$0cd695bd23dfbccb$var$addKey($hp647.PublicKey.from(public_key), $0cd695bd23dfbccb$var$fullAccessKey()))
            ];
        });
    }
    /**
     * This method converts LAKs back to FAKs, clears state and deploys an 'empty' contract (contractBytes param)
     * @param [contractBytes]{@link https://github.com/near/near-wallet/blob/master/packages/frontend/src/wasm/main.wasm?raw=true}
     * @param [cleanupContractBytes]{@link https://github.com/near/core-contracts/blob/master/state-manipulation/res/state_cleanup.wasm?raw=true}
     * @returns {Promise<FinalExecutionOutcome>} A promise that resolves to the final execution outcome of the operation.
     */ disable(contractBytes, cleanupContractBytes) {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            const { stateStatus: stateStatus } = yield this.checkMultisigCodeAndStateStatus();
            if (stateStatus !== $jYmNX.MultisigStateStatus.VALID_STATE && stateStatus !== $jYmNX.MultisigStateStatus.STATE_NOT_INITIALIZED) throw new $a246u.TypedError(`Can not deploy a contract to account ${this.accountId} on network ${this.connection.networkId}, the account state could not be verified.`, "ContractStateUnknown");
            let deleteAllRequestsError;
            yield this.deleteAllRequests().catch((e)=>deleteAllRequestsError = e);
            const cleanupActions = yield this.get2faDisableCleanupActions(cleanupContractBytes).catch((e)=>{
                if (e.type === "ContractHasExistingState") throw deleteAllRequestsError || e;
                throw e;
            });
            const actions = [
                ...cleanupActions,
                ...yield this.get2faDisableKeyConversionActions(),
                $0cd695bd23dfbccb$var$deployContract(contractBytes)
            ];
            $hNbI3.Logger.log("disabling 2fa for", this.accountId);
            return yield this.signAndSendTransaction({
                receiverId: this.accountId,
                actions: actions
            });
        });
    }
    /**
     * Default implementation for sending the 2FA code.
     * @returns {Promise<string>} - A promise that resolves to the request ID.
     */ sendCodeDefault() {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            const { accountId: accountId } = this;
            const { requestId: requestId } = this.getRequest();
            const method = yield this.get2faMethod();
            yield this.postSignedJson("/2fa/send", {
                accountId: accountId,
                method: method,
                requestId: requestId
            });
            return requestId;
        });
    }
    getCodeDefault() {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            throw new Error('There is no getCode callback provided. Please provide your own in AccountMultisig constructor options. It has a parameter method where method.kind is "email" or "phone".');
        });
    }
    /**
     * Prompts the user to enter and verify the 2FA code.
     * @returns {Promise<any>} - A promise that resolves to the verification result.
     */ promptAndVerify() {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            const method = yield this.get2faMethod();
            const securityCode = yield this.getCode(method);
            try {
                const result = yield this.verifyCode(securityCode);
                // TODO: Parse error from result for real (like in normal account.signAndSendTransaction)
                return result;
            } catch (e) {
                $hNbI3.Logger.warn("Error validating security code:", e);
                if (e.toString().includes("invalid 2fa code provided") || e.toString().includes("2fa code not valid")) return yield this.promptAndVerify();
                throw e;
            }
        });
    }
    /**
     * Verify the 2FA code using the default method.
     * @param securityCode - The security code to verify.
     * @returns {Promise<any>} A promise that resolves to the verification result.
     */ verifyCodeDefault(securityCode) {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            const { accountId: accountId } = this;
            const request = this.getRequest();
            if (!request) throw new Error("no request pending");
            const { requestId: requestId } = request;
            return yield this.postSignedJson("/2fa/verify", {
                accountId: accountId,
                securityCode: securityCode,
                requestId: requestId
            });
        });
    }
    /**
     * Retrieves recovery methods for the account.
     * @returns {Promise<{ accountId: string, data: any }>} - A promise that resolves to recovery methods data.
     */ getRecoveryMethods() {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            const { accountId: accountId } = this;
            return {
                accountId: accountId,
                data: yield this.postSignedJson("/account/recoveryMethods", {
                    accountId: accountId
                })
            };
        });
    }
    /**
     * Gets the 2FA method (kind and detail).
     * @returns {Promise<{ kind: string, detail: string }>} A promise that resolves to the 2FA method.
     */ get2faMethod() {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            let { data: data } = yield this.getRecoveryMethods();
            if (data && data.length) data = data.find((m)=>m.kind.indexOf("2fa-") === 0);
            if (!data) return null;
            const { kind: kind, detail: detail } = data;
            return {
                kind: kind,
                detail: detail
            };
        });
    }
    /**
    * Generates a signature for the latest finalized block.
    * @returns {Promise<{ blockNumber: string, blockNumberSignature: string }>} - A promise that resolves to the signature information.
    */ signatureFor() {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            const { accountId: accountId } = this;
            const block = yield this.connection.provider.block({
                finality: "final"
            });
            const blockNumber = block.header.height.toString();
            const signed = yield this.connection.signer.signMessage($0cd695bd23dfbccb$require$Buffer.from(blockNumber), accountId, this.connection.networkId);
            const blockNumberSignature = $0cd695bd23dfbccb$require$Buffer.from(signed.signature).toString("base64");
            return {
                blockNumber: blockNumber,
                blockNumberSignature: blockNumberSignature
            };
        });
    }
    /**
    * Sends a signed JSON request to a specified path.
    * @param path - The path for the request.
    * @param body - The request body.
    * @returns {Promise<any>} - A promise that resolves to the response from the helper.
    */ postSignedJson(path, body) {
        return $0cd695bd23dfbccb$var$__awaiter(this, void 0, void 0, function*() {
            return yield (0, $833m4.fetchJson)(this.helperUrl + path, JSON.stringify(Object.assign(Object.assign({}, body), (yield this.signatureFor()))));
        });
    }
}
module.exports.Account2FA = $0cd695bd23dfbccb$var$Account2FA;
// helpers
const $0cd695bd23dfbccb$var$toPK = (pk)=>$hp647.PublicKey.from(pk);

});
parcelRegister("gPTGa", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c41c997b561a8e85$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $c41c997b561a8e85$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AccountMultisig = void 0;

var $hynq1 = parcelRequire("hynq1");

var $hNbI3 = parcelRequire("hNbI3");

var $ivJvg = parcelRequire("ivJvg");

var $jAUeP = parcelRequire("jAUeP");

var $jYmNX = parcelRequire("jYmNX");
const { deployContract: $c41c997b561a8e85$var$deployContract, functionCall: $c41c997b561a8e85$var$functionCall } = $hynq1.actionCreators;
var $c41c997b561a8e85$var$MultisigCodeStatus;
(function(MultisigCodeStatus) {
    MultisigCodeStatus[MultisigCodeStatus["INVALID_CODE"] = 0] = "INVALID_CODE";
    MultisigCodeStatus[MultisigCodeStatus["VALID_CODE"] = 1] = "VALID_CODE";
    MultisigCodeStatus[MultisigCodeStatus["UNKNOWN_CODE"] = 2] = "UNKNOWN_CODE";
})($c41c997b561a8e85$var$MultisigCodeStatus || ($c41c997b561a8e85$var$MultisigCodeStatus = {}));
// in memory request cache for node w/o localStorage
const $c41c997b561a8e85$var$storageFallback = {
    [$jAUeP.MULTISIG_STORAGE_KEY]: null
};
class $c41c997b561a8e85$var$AccountMultisig extends $ivJvg.Account {
    /**
     * Constructs an instance of the `AccountMultisig` class.
     * @param connection The NEAR connection object.
     * @param accountId The NEAR account ID.
     * @param options Additional options for the multisig account.
     * @param options.storage Storage to store data related to multisig operations.
     * @param options.onAddRequestResult Callback function to handle the result of adding a request.
     */ constructor(connection, accountId, options){
        super(connection, accountId);
        this.storage = options.storage;
        this.onAddRequestResult = options.onAddRequestResult;
    }
    /**
     * Sign and send a transaction with the multisig account as the sender.
     * @param receiverId - The NEAR account ID of the transaction receiver.
     * @param actions - The list of actions to be included in the transaction.
     * @returns {Promise<FinalExecutionOutcome>} A promise that resolves to the final execution outcome of the transaction.
     */ signAndSendTransactionWithAccount(receiverId, actions) {
        const _super = Object.create(null, {
            signAndSendTransaction: {
                get: ()=>super.signAndSendTransaction
            }
        });
        return $c41c997b561a8e85$var$__awaiter(this, void 0, void 0, function*() {
            return _super.signAndSendTransaction.call(this, {
                receiverId: receiverId,
                actions: actions
            });
        });
    }
    /**
     * Sign and send a multisig transaction to add a request and confirm it.
     * @param options Options for the multisig transaction.
     * @param options.receiverId The NEAR account ID of the transaction receiver.
     * @param options.actions The list of actions to be included in the transaction.
     * @returns {Promise<FinalExecutionOutcome>} A promise that resolves to the final execution outcome of the transaction.
     */ signAndSendTransaction({ receiverId: receiverId, actions: actions }) {
        const _super = Object.create(null, {
            signAndSendTransaction: {
                get: ()=>super.signAndSendTransaction
            }
        });
        return $c41c997b561a8e85$var$__awaiter(this, void 0, void 0, function*() {
            const { accountId: accountId } = this;
            const args = $c41c997b561a8e85$require$Buffer.from(JSON.stringify({
                request: {
                    receiver_id: receiverId,
                    actions: $c41c997b561a8e85$var$convertActions(actions, accountId, receiverId)
                }
            }));
            let result;
            try {
                result = yield _super.signAndSendTransaction.call(this, {
                    receiverId: accountId,
                    actions: [
                        $c41c997b561a8e85$var$functionCall("add_request_and_confirm", args, $jAUeP.MULTISIG_GAS, $jAUeP.MULTISIG_DEPOSIT)
                    ]
                });
            } catch (e) {
                if (e.toString().includes("Account has too many active requests. Confirm or delete some")) {
                    yield this.deleteUnconfirmedRequests();
                    return yield this.signAndSendTransaction({
                        receiverId: receiverId,
                        actions: actions
                    });
                }
                throw e;
            }
            // TODO: Are following even needed? Seems like it throws on error already
            if (!result.status) throw new Error("Request failed");
            const status = Object.assign({}, result.status);
            if (!status.SuccessValue || typeof status.SuccessValue !== "string") throw new Error("Request failed");
            this.setRequest({
                accountId: accountId,
                actions: actions,
                requestId: parseInt($c41c997b561a8e85$require$Buffer.from(status.SuccessValue, "base64").toString("ascii"), 10)
            });
            if (this.onAddRequestResult) yield this.onAddRequestResult(result);
            // NOTE there is no await on purpose to avoid blocking for 2fa
            this.deleteUnconfirmedRequests();
            return result;
        });
    }
    /**
     * This method submits a canary transaction that is expected to always fail in order to determine whether the contract currently has valid multisig state
     * and whether it is initialized. The canary transaction attempts to delete a request at index u32_max and will go through if a request exists at that index.
     * a u32_max + 1 and -1 value cannot be used for the canary due to expected u32 error thrown before deserialization attempt.
     * @param contractBytes The bytecode of the multisig contract.
     * @returns {Promise<{ codeStatus: MultisigCodeStatus; stateStatus: MultisigStateStatus }>} A promise that resolves to the status of the code and state.
     */ checkMultisigCodeAndStateStatus(contractBytes) {
        const _super = Object.create(null, {
            signAndSendTransaction: {
                get: ()=>super.signAndSendTransaction
            }
        });
        return $c41c997b561a8e85$var$__awaiter(this, void 0, void 0, function*() {
            const u32_max = 4294967295;
            const validCodeStatusIfNoDeploy = contractBytes ? $c41c997b561a8e85$var$MultisigCodeStatus.UNKNOWN_CODE : $c41c997b561a8e85$var$MultisigCodeStatus.VALID_CODE;
            try {
                if (contractBytes) yield _super.signAndSendTransaction.call(this, {
                    receiverId: this.accountId,
                    actions: [
                        $c41c997b561a8e85$var$deployContract(contractBytes),
                        $c41c997b561a8e85$var$functionCall("delete_request", {
                            request_id: u32_max
                        }, $jAUeP.MULTISIG_GAS, $jAUeP.MULTISIG_DEPOSIT)
                    ]
                });
                else yield this.deleteRequest(u32_max);
                return {
                    codeStatus: $c41c997b561a8e85$var$MultisigCodeStatus.VALID_CODE,
                    stateStatus: $jYmNX.MultisigStateStatus.VALID_STATE
                };
            } catch (e) {
                if (new RegExp($jYmNX.MultisigDeleteRequestRejectionError.CANNOT_DESERIALIZE_STATE).test(e && e.kind && e.kind.ExecutionError)) return {
                    codeStatus: validCodeStatusIfNoDeploy,
                    stateStatus: $jYmNX.MultisigStateStatus.INVALID_STATE
                };
                else if (new RegExp($jYmNX.MultisigDeleteRequestRejectionError.MULTISIG_NOT_INITIALIZED).test(e && e.kind && e.kind.ExecutionError)) return {
                    codeStatus: validCodeStatusIfNoDeploy,
                    stateStatus: $jYmNX.MultisigStateStatus.STATE_NOT_INITIALIZED
                };
                else if (new RegExp($jYmNX.MultisigDeleteRequestRejectionError.NO_SUCH_REQUEST).test(e && e.kind && e.kind.ExecutionError)) return {
                    codeStatus: validCodeStatusIfNoDeploy,
                    stateStatus: $jYmNX.MultisigStateStatus.VALID_STATE
                };
                else if (new RegExp($jYmNX.MultisigDeleteRequestRejectionError.METHOD_NOT_FOUND).test(e && e.message)) // not reachable if transaction included a deploy
                return {
                    codeStatus: $c41c997b561a8e85$var$MultisigCodeStatus.INVALID_CODE,
                    stateStatus: $jYmNX.MultisigStateStatus.UNKNOWN_STATE
                };
                throw e;
            }
        });
    }
    /**
     * Delete a multisig request by its ID.
     * @param request_id The ID of the multisig request to be deleted.
     * @returns {Promise<FinalExecutionOutcome>} A promise that resolves to the final execution outcome of the deletion.
     */ deleteRequest(request_id) {
        return super.signAndSendTransaction({
            receiverId: this.accountId,
            actions: [
                $c41c997b561a8e85$var$functionCall("delete_request", {
                    request_id: request_id
                }, $jAUeP.MULTISIG_GAS, $jAUeP.MULTISIG_DEPOSIT)
            ]
        });
    }
    /**
     * Delete all multisig requests associated with the account.
     * @returns {Promise<void>} A promise that resolves when all requests are deleted.
     */ deleteAllRequests() {
        return $c41c997b561a8e85$var$__awaiter(this, void 0, void 0, function*() {
            const request_ids = yield this.getRequestIds();
            if (request_ids.length) yield Promise.all(request_ids.map((id)=>this.deleteRequest(id)));
        });
    }
    /**
     * Delete unconfirmed multisig requests associated with the account.
     * @returns {Promise<void>} A promise that resolves when unconfirmed requests are deleted.
     */ deleteUnconfirmedRequests() {
        const _super = Object.create(null, {
            signAndSendTransaction: {
                get: ()=>super.signAndSendTransaction
            }
        });
        return $c41c997b561a8e85$var$__awaiter(this, void 0, void 0, function*() {
            // TODO: Delete in batch, don't delete unexpired
            // TODO: Delete in batch, don't delete unexpired (can reduce gas usage dramatically)
            const request_ids = yield this.getRequestIds();
            const { requestId: requestId } = this.getRequest();
            for (const requestIdToDelete of request_ids){
                if (requestIdToDelete == requestId) continue;
                try {
                    yield _super.signAndSendTransaction.call(this, {
                        receiverId: this.accountId,
                        actions: [
                            $c41c997b561a8e85$var$functionCall("delete_request", {
                                request_id: requestIdToDelete
                            }, $jAUeP.MULTISIG_GAS, $jAUeP.MULTISIG_DEPOSIT)
                        ]
                    });
                } catch (e) {
                    $hNbI3.Logger.warn("Attempt to delete an earlier request before 15 minutes failed. Will try again.");
                }
            }
        });
    }
    // helpers
    getRequestIds() {
        return $c41c997b561a8e85$var$__awaiter(this, void 0, void 0, function*() {
            // TODO: Read requests from state to allow filtering by expiration time
            // TODO: https://github.com/near/core-contracts/blob/305d1db4f4f2cf5ce4c1ef3479f7544957381f11/multisig/src/lib.rs#L84
            return this.viewFunction({
                contractId: this.accountId,
                methodName: "list_request_ids"
            });
        });
    }
    getRequest() {
        if (this.storage) return JSON.parse(this.storage.getItem($jAUeP.MULTISIG_STORAGE_KEY) || "{}");
        return $c41c997b561a8e85$var$storageFallback[$jAUeP.MULTISIG_STORAGE_KEY];
    }
    setRequest(data) {
        if (this.storage) return this.storage.setItem($jAUeP.MULTISIG_STORAGE_KEY, JSON.stringify(data));
        $c41c997b561a8e85$var$storageFallback[$jAUeP.MULTISIG_STORAGE_KEY] = data;
    }
}
module.exports.AccountMultisig = $c41c997b561a8e85$var$AccountMultisig;
const $c41c997b561a8e85$var$convertPKForContract = (pk)=>pk.toString().replace("ed25519:", "");
const $c41c997b561a8e85$var$convertActions = (actions, accountId, receiverId)=>actions.map((a)=>{
        const type = a.enum;
        const { gas: gas, publicKey: publicKey, methodName: methodName, args: args, deposit: deposit, accessKey: accessKey, code: code } = a[type];
        const action = {
            type: type[0].toUpperCase() + type.substr(1),
            gas: gas && gas.toString() || undefined,
            public_key: publicKey && $c41c997b561a8e85$var$convertPKForContract(publicKey) || undefined,
            method_name: methodName,
            args: args && $c41c997b561a8e85$require$Buffer.from(args).toString("base64") || undefined,
            code: code && $c41c997b561a8e85$require$Buffer.from(code).toString("base64") || undefined,
            amount: deposit && deposit.toString() || undefined,
            deposit: deposit && deposit.toString() || "0",
            permission: undefined
        };
        if (accessKey) {
            if (receiverId === accountId && accessKey.permission.enum !== "fullAccess") action.permission = {
                receiver_id: accountId,
                allowance: $jAUeP.MULTISIG_ALLOWANCE.toString(),
                method_names: $jAUeP.MULTISIG_CHANGE_METHODS
            };
            if (accessKey.permission.enum === "functionCall") {
                const { receiverId: receiver_id, methodNames: method_names, allowance: allowance } = accessKey.permission.functionCall;
                action.permission = {
                    receiver_id: receiver_id,
                    allowance: allowance && allowance.toString() || undefined,
                    method_names: method_names
                };
            }
        }
        return action;
    });

});
parcelRegister("jAUeP", function(module, exports) {
"use strict";
var $e43d00db51d39702$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MULTISIG_CONFIRM_METHODS = module.exports.MULTISIG_CHANGE_METHODS = module.exports.MULTISIG_DEPOSIT = module.exports.MULTISIG_GAS = module.exports.MULTISIG_ALLOWANCE = module.exports.MULTISIG_STORAGE_KEY = void 0;

var $hNbI3 = parcelRequire("hNbI3");

const $e43d00db51d39702$var$bn_js_1 = $e43d00db51d39702$var$__importDefault((parcelRequire("dEXSZ")));
module.exports.MULTISIG_STORAGE_KEY = "__multisigRequest";
module.exports.MULTISIG_ALLOWANCE = new $e43d00db51d39702$var$bn_js_1.default((0, $hNbI3.parseNearAmount)("1"));
// TODO: Different gas value for different requests (can reduce gas usage dramatically)
module.exports.MULTISIG_GAS = new $e43d00db51d39702$var$bn_js_1.default("100000000000000");
module.exports.MULTISIG_DEPOSIT = new $e43d00db51d39702$var$bn_js_1.default("0");
module.exports.MULTISIG_CHANGE_METHODS = [
    "add_request",
    "add_request_and_confirm",
    "delete_request",
    "confirm"
];
module.exports.MULTISIG_CONFIRM_METHODS = [
    "confirm"
];

});

parcelRegister("jYmNX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultisigStateStatus = module.exports.MultisigDeleteRequestRejectionError = void 0;
var $e8a54f774b2034ae$var$MultisigDeleteRequestRejectionError;
(function(MultisigDeleteRequestRejectionError) {
    MultisigDeleteRequestRejectionError["CANNOT_DESERIALIZE_STATE"] = "Cannot deserialize the contract state";
    MultisigDeleteRequestRejectionError["MULTISIG_NOT_INITIALIZED"] = "Smart contract panicked: Multisig contract should be initialized before usage";
    MultisigDeleteRequestRejectionError["NO_SUCH_REQUEST"] = "Smart contract panicked: panicked at 'No such request: either wrong number or already confirmed'";
    MultisigDeleteRequestRejectionError["REQUEST_COOLDOWN_ERROR"] = "Request cannot be deleted immediately after creation.";
    MultisigDeleteRequestRejectionError["METHOD_NOT_FOUND"] = "Contract method is not found";
})($e8a54f774b2034ae$var$MultisigDeleteRequestRejectionError = module.exports.MultisigDeleteRequestRejectionError || (module.exports.MultisigDeleteRequestRejectionError = {}));
var $e8a54f774b2034ae$var$MultisigStateStatus;
(function(MultisigStateStatus) {
    MultisigStateStatus[MultisigStateStatus["INVALID_STATE"] = 0] = "INVALID_STATE";
    MultisigStateStatus[MultisigStateStatus["STATE_NOT_INITIALIZED"] = 1] = "STATE_NOT_INITIALIZED";
    MultisigStateStatus[MultisigStateStatus["VALID_STATE"] = 2] = "VALID_STATE";
    MultisigStateStatus[MultisigStateStatus["UNKNOWN_STATE"] = 3] = "UNKNOWN_STATE";
})($e8a54f774b2034ae$var$MultisigStateStatus = module.exports.MultisigStateStatus || (module.exports.MultisigStateStatus = {}));

});



parcelRegister("jXt1N", function(module, exports) {
"use strict";
var $e87a0b559ebc7568$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlAccountCreator = module.exports.LocalAccountCreator = module.exports.AccountCreator = void 0;

var $833m4 = parcelRequire("833m4");
/**
 * Account creator provides an interface for implementations to actually create accounts
 */ class $e87a0b559ebc7568$var$AccountCreator {
}
module.exports.AccountCreator = $e87a0b559ebc7568$var$AccountCreator;
class $e87a0b559ebc7568$var$LocalAccountCreator extends $e87a0b559ebc7568$var$AccountCreator {
    constructor(masterAccount, initialBalance){
        super();
        this.masterAccount = masterAccount;
        this.initialBalance = initialBalance;
    }
    /**
     * Creates an account using a masterAccount, meaning the new account is created from an existing account
     * @param newAccountId The name of the NEAR account to be created
     * @param publicKey The public key from the masterAccount used to create this account
     * @returns {Promise<void>}
     */ createAccount(newAccountId, publicKey) {
        return $e87a0b559ebc7568$var$__awaiter(this, void 0, void 0, function*() {
            yield this.masterAccount.createAccount(newAccountId, publicKey, this.initialBalance);
        });
    }
}
module.exports.LocalAccountCreator = $e87a0b559ebc7568$var$LocalAccountCreator;
class $e87a0b559ebc7568$var$UrlAccountCreator extends $e87a0b559ebc7568$var$AccountCreator {
    constructor(connection, helperUrl){
        super();
        this.connection = connection;
        this.helperUrl = helperUrl;
    }
    /**
     * Creates an account using a helperUrl
     * This is [hosted here](https://helper.nearprotocol.com) or set up locally with the [near-contract-helper](https://github.com/nearprotocol/near-contract-helper) repository
     * @param newAccountId The name of the NEAR account to be created
     * @param publicKey The public key from the masterAccount used to create this account
     * @returns {Promise<void>}
     */ createAccount(newAccountId, publicKey) {
        return $e87a0b559ebc7568$var$__awaiter(this, void 0, void 0, function*() {
            yield (0, $833m4.fetchJson)(`${this.helperUrl}/account`, JSON.stringify({
                newAccountId: newAccountId,
                newAccountPublicKey: publicKey.toString()
            }));
        });
    }
}
module.exports.UrlAccountCreator = $e87a0b559ebc7568$var$UrlAccountCreator;

});

parcelRegister("5KY6e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = void 0;

var $lqZ7x = parcelRequire("lqZ7x");

var $833m4 = parcelRequire("833m4");
/**
 * @param config Contains connection info details
 * @returns {Provider}
 */ function $430fde1e4192c696$var$getProvider(config) {
    switch(config.type){
        case undefined:
            return config;
        case "JsonRpcProvider":
            return new $833m4.JsonRpcProvider(Object.assign({}, config.args));
        default:
            throw new Error(`Unknown provider type ${config.type}`);
    }
}
/**
 * @param config Contains connection info details
 * @returns {Signer}
 */ function $430fde1e4192c696$var$getSigner(config) {
    switch(config.type){
        case undefined:
            return config;
        case "InMemorySigner":
            return new $lqZ7x.InMemorySigner(config.keyStore);
        default:
            throw new Error(`Unknown signer type ${config.type}`);
    }
}
/**
 * Connects an account to a given network via a given provider
 */ class $430fde1e4192c696$var$Connection {
    constructor(networkId, provider, signer, jsvmAccountId){
        this.networkId = networkId;
        this.provider = provider;
        this.signer = signer;
        this.jsvmAccountId = jsvmAccountId;
    }
    /**
     * @param config Contains connection info details
     */ static fromConfig(config) {
        const provider = $430fde1e4192c696$var$getProvider(config.provider);
        const signer = $430fde1e4192c696$var$getSigner(config.signer);
        return new $430fde1e4192c696$var$Connection(config.networkId, provider, signer, config.jsvmAccountId);
    }
}
module.exports.Connection = $430fde1e4192c696$var$Connection;

});
parcelRegister("lqZ7x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Signer = module.exports.InMemorySigner = void 0;

var $gdivF = parcelRequire("gdivF");
Object.defineProperty(module.exports, "InMemorySigner", {
    enumerable: true,
    get: function() {
        return $gdivF.InMemorySigner;
    }
});

var $kxyo8 = parcelRequire("kxyo8");
Object.defineProperty(module.exports, "Signer", {
    enumerable: true,
    get: function() {
        return $kxyo8.Signer;
    }
});

});
parcelRegister("gdivF", function(module, exports) {
"use strict";
var $bcdc37e35abcb6ba$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InMemorySigner = void 0;

var $hp647 = parcelRequire("hp647");

var $fjvIe = parcelRequire("fjvIe");

var $6XnWx = parcelRequire("6XnWx");

var $kxyo8 = parcelRequire("kxyo8");
/**
 * Signs using in memory key store.
 */ class $bcdc37e35abcb6ba$var$InMemorySigner extends $kxyo8.Signer {
    constructor(keyStore){
        super();
        this.keyStore = keyStore;
    }
    /**
     * Creates a single account Signer instance with account, network and keyPair provided.
     *
     * Intended to be useful for temporary keys (e.g. claiming a Linkdrop).
     *
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @param accountId The NEAR account to assign the key pair to
     * @param keyPair The keyPair to use for signing
     */ static fromKeyPair(networkId, accountId, keyPair) {
        return $bcdc37e35abcb6ba$var$__awaiter(this, void 0, void 0, function*() {
            const keyStore = new $fjvIe.InMemoryKeyStore();
            yield keyStore.setKey(networkId, accountId, keyPair);
            return new $bcdc37e35abcb6ba$var$InMemorySigner(keyStore);
        });
    }
    /**
     * Creates a public key for the account given
     * @param accountId The NEAR account to assign a public key to
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns {Promise<PublicKey>}
     */ createKey(accountId, networkId) {
        return $bcdc37e35abcb6ba$var$__awaiter(this, void 0, void 0, function*() {
            const keyPair = $hp647.KeyPair.fromRandom("ed25519");
            yield this.keyStore.setKey(networkId, accountId, keyPair);
            return keyPair.getPublicKey();
        });
    }
    /**
     * Gets the existing public key for a given account
     * @param accountId The NEAR account to assign a public key to
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns {Promise<PublicKey>} Returns the public key or null if not found
     */ getPublicKey(accountId, networkId) {
        return $bcdc37e35abcb6ba$var$__awaiter(this, void 0, void 0, function*() {
            const keyPair = yield this.keyStore.getKey(networkId, accountId);
            if (keyPair === null) return null;
            return keyPair.getPublicKey();
        });
    }
    /**
     * @param message A message to be signed, typically a serialized transaction
     * @param accountId the NEAR account signing the message
     * @param networkId The targeted network. (ex. default, betanet, etc…)
     * @returns {Promise<Signature>}
     */ signMessage(message, accountId, networkId) {
        return $bcdc37e35abcb6ba$var$__awaiter(this, void 0, void 0, function*() {
            const hash = new Uint8Array((0, $6XnWx.sha256)(message));
            if (!accountId) throw new Error("InMemorySigner requires provided account id");
            const keyPair = yield this.keyStore.getKey(networkId, accountId);
            if (keyPair === null) throw new Error(`Key for ${accountId} not found in ${networkId}`);
            return keyPair.sign(hash);
        });
    }
    toString() {
        return `InMemorySigner(${this.keyStore})`;
    }
}
module.exports.InMemorySigner = $bcdc37e35abcb6ba$var$InMemorySigner;

});
parcelRegister("kxyo8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Signer = void 0;
/**
 * General signing interface, can be used for in memory signing, RPC singing, external wallet, HSM, etc.
 */ class $ef4190887e922f6c$var$Signer {
}
module.exports.Signer = $ef4190887e922f6c$var$Signer;

});




parcelRegister("aHhhG", function(module, exports) {
"use strict";
var $7c9b53cf3680c201$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7c9b53cf3680c201$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contract = void 0;

var $hNbI3 = parcelRequire("hNbI3");

var $a246u = parcelRequire("a246u");

var $8NAck = parcelRequire("8NAck");

const $7c9b53cf3680c201$var$ajv_1 = $7c9b53cf3680c201$var$__importDefault((parcelRequire("ilwRK")));

const $7c9b53cf3680c201$var$ajv_formats_1 = $7c9b53cf3680c201$var$__importDefault((parcelRequire("lzTPx")));

const $7c9b53cf3680c201$var$bn_js_1 = $7c9b53cf3680c201$var$__importDefault((parcelRequire("dEXSZ")));

const $7c9b53cf3680c201$var$depd_1 = $7c9b53cf3680c201$var$__importDefault((parcelRequire("6TCoX")));

var $lbI4N = parcelRequire("lbI4N");

var $cqsOI = parcelRequire("cqsOI");
// Makes `function.name` return given name
function $7c9b53cf3680c201$var$nameFunction(name, body) {
    return ({
        [name] (...args) {
            return body(...args);
        }
    })[name];
}
function $7c9b53cf3680c201$var$validateArguments(args, abiFunction, ajv, abiRoot) {
    var _a;
    if (!$7c9b53cf3680c201$var$isObject(args)) return;
    if (abiFunction.params && abiFunction.params.serialization_type !== $lbI4N.AbiSerializationType.Json) throw new $cqsOI.UnsupportedSerializationError(abiFunction.name, abiFunction.params.serialization_type);
    if (abiFunction.result && abiFunction.result.serialization_type !== $lbI4N.AbiSerializationType.Json) throw new $cqsOI.UnsupportedSerializationError(abiFunction.name, abiFunction.result.serialization_type);
    const params = ((_a = abiFunction.params) === null || _a === void 0 ? void 0 : _a.args) || [];
    for (const p of params){
        const arg = args[p.name];
        const typeSchema = p.type_schema;
        typeSchema.definitions = abiRoot.body.root_schema.definitions;
        const validate = ajv.compile(typeSchema);
        if (!validate(arg)) throw new $cqsOI.ArgumentSchemaError(p.name, validate.errors);
    }
    // Check there are no extra unknown arguments passed
    for (const argName of Object.keys(args)){
        const param = params.find((p)=>p.name === argName);
        if (!param) throw new $cqsOI.UnknownArgumentError(argName, params.map((p)=>p.name));
    }
}
function $7c9b53cf3680c201$var$createAjv() {
    // Strict mode is disabled for now as it complains about unknown formats. We need to
    // figure out if we want to support a fixed set of formats. `uint32` and `uint64`
    // are added explicitly just to reduce the amount of warnings as these are very popular
    // types.
    const ajv = new $7c9b53cf3680c201$var$ajv_1.default({
        strictSchema: false,
        formats: {
            uint32: true,
            uint64: true
        }
    });
    (0, $7c9b53cf3680c201$var$ajv_formats_1.default)(ajv);
    return ajv;
}
const $7c9b53cf3680c201$var$isUint8Array = (x)=>x && x.byteLength !== undefined && x.byteLength === x.length;
const $7c9b53cf3680c201$var$isObject = (x)=>Object.prototype.toString.call(x) === "[object Object]";
/**
 * Defines a smart contract on NEAR including the change (mutable) and view (non-mutable) methods
 *
 * @see [https://docs.near.org/tools/near-api-js/quick-reference#contract](https://docs.near.org/tools/near-api-js/quick-reference#contract)
 * @example
 * ```js
 * import { Contract } from 'near-api-js';
 *
 * async function contractExample() {
 *   const methodOptions = {
 *     viewMethods: ['getMessageByAccountId'],
 *     changeMethods: ['addMessage']
 *   };
 *   const contract = new Contract(
 *     wallet.account(),
 *     'contract-id.testnet',
 *     methodOptions
 *   );
 *
 *   // use a contract view method
 *   const messages = await contract.getMessages({
 *     accountId: 'example-account.testnet'
 *   });
 *
 *   // use a contract change method
 *   await contract.addMessage({
 *      meta: 'some info',
 *      callbackUrl: 'https://example.com/callback',
 *      args: { text: 'my message' },
 *      amount: 1
 *   })
 * }
 * ```
 */ class $7c9b53cf3680c201$var$Contract {
    /**
     * @param account NEAR account to sign change method transactions
     * @param contractId NEAR account id where the contract is deployed
     * @param options NEAR smart contract methods that your application will use. These will be available as `contract.methodName`
     */ constructor(account, contractId, options){
        this.account = account;
        this.contractId = contractId;
        this.lve = new $8NAck.LocalViewExecution(account);
        const { viewMethods: viewMethods = [], changeMethods: changeMethods = [], abi: abiRoot, useLocalViewExecution: useLocalViewExecution } = options;
        let viewMethodsWithAbi = viewMethods.map((name)=>({
                name: name,
                abi: null
            }));
        let changeMethodsWithAbi = changeMethods.map((name)=>({
                name: name,
                abi: null
            }));
        if (abiRoot) {
            if (viewMethodsWithAbi.length > 0 || changeMethodsWithAbi.length > 0) throw new $cqsOI.ConflictingOptions();
            viewMethodsWithAbi = abiRoot.body.functions.filter((m)=>m.kind === $lbI4N.AbiFunctionKind.View).map((m)=>({
                    name: m.name,
                    abi: m
                }));
            changeMethodsWithAbi = abiRoot.body.functions.filter((methodAbi)=>methodAbi.kind === $lbI4N.AbiFunctionKind.Call).map((methodAbi)=>({
                    name: methodAbi.name,
                    abi: methodAbi
                }));
        }
        const ajv = $7c9b53cf3680c201$var$createAjv();
        viewMethodsWithAbi.forEach(({ name: name, abi: abi })=>{
            Object.defineProperty(this, name, {
                writable: false,
                enumerable: true,
                value: $7c9b53cf3680c201$var$nameFunction(name, (args = {}, options = {}, ...ignored)=>$7c9b53cf3680c201$var$__awaiter(this, void 0, void 0, function*() {
                        if (ignored.length || !($7c9b53cf3680c201$var$isObject(args) || $7c9b53cf3680c201$var$isUint8Array(args)) || !$7c9b53cf3680c201$var$isObject(options)) throw new $a246u.PositionalArgsError();
                        if (abi) $7c9b53cf3680c201$var$validateArguments(args, abi, ajv, abiRoot);
                        if (useLocalViewExecution) try {
                            return yield this.lve.viewFunction(Object.assign({
                                contractId: this.contractId,
                                methodName: name,
                                args: args
                            }, options));
                        } catch (error) {
                            $hNbI3.Logger.warn(`Local view execution failed with: "${error.message}"`);
                            $hNbI3.Logger.warn(`Fallback to normal RPC call`);
                        }
                        return this.account.viewFunction(Object.assign({
                            contractId: this.contractId,
                            methodName: name,
                            args: args
                        }, options));
                    }))
            });
        });
        changeMethodsWithAbi.forEach(({ name: name, abi: abi })=>{
            Object.defineProperty(this, name, {
                writable: false,
                enumerable: true,
                value: $7c9b53cf3680c201$var$nameFunction(name, (...args)=>$7c9b53cf3680c201$var$__awaiter(this, void 0, void 0, function*() {
                        if (args.length && (args.length > 3 || !($7c9b53cf3680c201$var$isObject(args[0]) || $7c9b53cf3680c201$var$isUint8Array(args[0])))) throw new $a246u.PositionalArgsError();
                        if (args.length > 1 || !(args[0] && args[0].args)) {
                            const deprecate = (0, $7c9b53cf3680c201$var$depd_1.default)("contract.methodName(args, gas, amount)");
                            deprecate("use `contract.methodName({ args, gas?, amount?, callbackUrl?, meta? })` instead");
                            args[0] = {
                                args: args[0],
                                gas: args[1],
                                amount: args[2]
                            };
                        }
                        if (abi) $7c9b53cf3680c201$var$validateArguments(args[0].args, abi, ajv, abiRoot);
                        return this._changeMethod(Object.assign({
                            methodName: name
                        }, args[0]));
                    }))
            });
        });
    }
    _changeMethod({ args: args, methodName: methodName, gas: gas, amount: amount, meta: meta, callbackUrl: callbackUrl }) {
        return $7c9b53cf3680c201$var$__awaiter(this, void 0, void 0, function*() {
            $7c9b53cf3680c201$var$validateBNLike({
                gas: gas,
                amount: amount
            });
            const rawResult = yield this.account.functionCall({
                contractId: this.contractId,
                methodName: methodName,
                args: args,
                gas: gas,
                attachedDeposit: amount,
                walletMeta: meta,
                walletCallbackUrl: callbackUrl
            });
            return (0, $hNbI3.getTransactionLastResult)(rawResult);
        });
    }
}
module.exports.Contract = $7c9b53cf3680c201$var$Contract;
/**
 * Validation on arguments being a big number from bn.js
 * Throws if an argument is not in BN format or otherwise invalid
 * @param argMap
 */ function $7c9b53cf3680c201$var$validateBNLike(argMap) {
    const bnLike = "number, decimal string or BN";
    for (const argName of Object.keys(argMap)){
        const argValue = argMap[argName];
        if (argValue && !$7c9b53cf3680c201$var$bn_js_1.default.isBN(argValue) && isNaN(argValue)) throw new $a246u.ArgumentTypeError(argName, bnLike, argValue);
    }
}

});
parcelRegister("8NAck", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $667efa75fc805b52$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $667efa75fc805b52$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $667efa75fc805b52$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LocalViewExecution = void 0;

var $hNbI3 = parcelRequire("hNbI3");

var $dIuKF = parcelRequire("dIuKF");

var $kQfMd = parcelRequire("kQfMd");
class $667efa75fc805b52$var$LocalViewExecution {
    constructor(account){
        this.account = account;
        this.storage = new $dIuKF.Storage();
    }
    fetchContractCode(contractId, blockQuery) {
        return $667efa75fc805b52$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this.account.connection.provider.query(Object.assign({
                request_type: "view_code",
                account_id: contractId
            }, blockQuery));
            return result.code_base64;
        });
    }
    fetchContractState(blockQuery) {
        return $667efa75fc805b52$var$__awaiter(this, void 0, void 0, function*() {
            return this.account.viewState("", blockQuery);
        });
    }
    fetch(contractId, blockQuery) {
        return $667efa75fc805b52$var$__awaiter(this, void 0, void 0, function*() {
            const block = yield this.account.connection.provider.block(blockQuery);
            const blockHash = block.header.hash;
            const blockHeight = block.header.height;
            const blockTimestamp = block.header.timestamp;
            const contractCode = yield this.fetchContractCode(contractId, blockQuery);
            const contractState = yield this.fetchContractState(blockQuery);
            return {
                blockHash: blockHash,
                blockHeight: blockHeight,
                blockTimestamp: blockTimestamp,
                contractCode: contractCode,
                contractState: contractState
            };
        });
    }
    loadOrFetch(contractId, blockQuery) {
        return $667efa75fc805b52$var$__awaiter(this, void 0, void 0, function*() {
            const stored = this.storage.load(blockQuery);
            if (stored) return stored;
            const _a = yield this.fetch(contractId, blockQuery), { blockHash: blockHash } = _a, fetched = $667efa75fc805b52$var$__rest(_a, [
                "blockHash"
            ]);
            this.storage.save(blockHash, fetched);
            return fetched;
        });
    }
    /**
     * Calls a view function on a contract, fetching the contract code and state if needed.
     * @param options Options for calling the view function.
     * @param options.contractId The contract account ID.
     * @param options.methodName The name of the view function to call.
     * @param options.args The arguments to pass to the view function.
     * @param options.blockQuery The block query options.
     * @returns {Promise<any>} - A promise that resolves to the result of the view function.
     */ viewFunction(_a) {
        var { contractId: contractId, methodName: methodName, args: args = {}, blockQuery: blockQuery = {
            finality: "optimistic"
        } } = _a, ignored = $667efa75fc805b52$var$__rest(_a, [
            "contractId",
            "methodName",
            "args",
            "blockQuery"
        ]);
        return $667efa75fc805b52$var$__awaiter(this, void 0, void 0, function*() {
            const methodArgs = JSON.stringify(args);
            const { contractCode: contractCode, contractState: contractState, blockHeight: blockHeight, blockTimestamp: blockTimestamp } = yield this.loadOrFetch(contractId, blockQuery);
            const runtime = new $kQfMd.Runtime({
                contractId: contractId,
                contractCode: contractCode,
                contractState: contractState,
                blockHeight: blockHeight,
                blockTimestamp: blockTimestamp,
                methodArgs: methodArgs
            });
            const { result: result, logs: logs } = yield runtime.execute(methodName);
            if (logs) (0, $hNbI3.printTxOutcomeLogs)({
                contractId: contractId,
                logs: logs
            });
            return JSON.parse($667efa75fc805b52$require$Buffer.from(result).toString());
        });
    }
}
module.exports.LocalViewExecution = $667efa75fc805b52$var$LocalViewExecution;

});
parcelRegister("dIuKF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = void 0;

var $7ol94 = parcelRequire("7ol94");
class $9fc73d1212c17499$var$Storage {
    constructor(options = {
        max: $9fc73d1212c17499$var$Storage.MAX_ELEMENTS
    }){
        this.cache = new $7ol94.LRUMap(options.max);
        this.blockHeights = new Map();
    }
    load(blockRef) {
        const noBlockId = !("blockId" in blockRef);
        if (noBlockId) return undefined;
        let blockId = blockRef.blockId;
        // block hash is passed, so get its corresponding block height
        if (blockId.toString().length == 44) blockId = this.blockHeights.get(blockId.toString());
        // get cached values for the given block height
        return this.cache.get(blockId);
    }
    save(blockHash, { blockHeight: blockHeight, blockTimestamp: blockTimestamp, contractCode: contractCode, contractState: contractState }) {
        this.blockHeights.set(blockHash, blockHeight);
        this.cache.set(blockHeight, {
            blockHeight: blockHeight,
            blockTimestamp: blockTimestamp,
            contractCode: contractCode,
            contractState: contractState
        });
    }
}
module.exports.Storage = $9fc73d1212c17499$var$Storage;
$9fc73d1212c17499$var$Storage.MAX_ELEMENTS = 100;

});
parcelRegister("7ol94", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});


parcelRegister("kQfMd", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f2c4e6e5fee52e8e$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $f2c4e6e5fee52e8e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f2c4e6e5fee52e8e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Runtime = void 0;

var $5UUfm = parcelRequire("5UUfm");
const $f2c4e6e5fee52e8e$var$notImplemented = (name)=>()=>{
        throw new Error("method not implemented: " + name);
    };
const $f2c4e6e5fee52e8e$var$prohibitedInView = (name)=>()=>{
        throw new Error("method not available for view calls: " + name);
    };
class $f2c4e6e5fee52e8e$var$Runtime {
    constructor(_a){
        var { contractCode: contractCode } = _a, context = $f2c4e6e5fee52e8e$var$__rest(_a, [
            "contractCode"
        ]);
        this.context = context;
        this.wasm = this.prepareWASM($f2c4e6e5fee52e8e$require$Buffer.from(contractCode, "base64"));
        this.memory = new WebAssembly.Memory({
            initial: 1024,
            maximum: 2048
        });
        this.registers = {};
        this.logs = [];
        this.result = $f2c4e6e5fee52e8e$require$Buffer.from([]);
    }
    readUTF16CStr(ptr) {
        const arr = [];
        const mem = new Uint16Array(this.memory.buffer);
        let key = Number(ptr) / 2;
        while(mem[key] != 0){
            arr.push(mem[key]);
            key++;
        }
        return $f2c4e6e5fee52e8e$require$Buffer.from(Uint16Array.from(arr).buffer).toString("ucs2");
    }
    readUTF8CStr(len, ptr) {
        const arr = [];
        const mem = new Uint8Array(this.memory.buffer);
        let key = Number(ptr);
        for(let i = 0; i < len && mem[key] != 0; i++){
            arr.push(mem[key]);
            key++;
        }
        return $f2c4e6e5fee52e8e$require$Buffer.from(arr).toString("utf8");
    }
    storageRead(keyLen, keyPtr) {
        const storageKey = $f2c4e6e5fee52e8e$require$Buffer.from(new Uint8Array(this.memory.buffer, Number(keyPtr), Number(keyLen)));
        const stateVal = this.context.contractState.filter((obj)=>$f2c4e6e5fee52e8e$require$Buffer.compare(obj.key, storageKey) === 0).map((obj)=>obj.value);
        if (stateVal.length === 0) return null;
        return stateVal.length > 1 ? stateVal : stateVal[0];
    }
    prepareWASM(input) {
        const parts = [];
        const magic = input.subarray(0, 4);
        if (magic.toString("utf8") !== "\0asm") throw new Error("Invalid magic number");
        const version = input.readUInt32LE(4);
        if (version != 1) throw new Error("Invalid version: " + version);
        let offset = 8;
        parts.push(input.subarray(0, offset));
        function decodeLEB128() {
            let result = 0;
            let shift = 0;
            let byte;
            do {
                byte = input[offset++];
                result |= (byte & 0x7f) << shift;
                shift += 7;
            }while (byte & 0x80);
            return result;
        }
        function decodeLimits() {
            const flags = input[offset++];
            const hasMax = flags & 0x1;
            const initial = decodeLEB128();
            const max = hasMax ? decodeLEB128() : null;
            return {
                initial: initial,
                max: max
            };
        }
        function decodeString() {
            const length = decodeLEB128();
            const result = input.subarray(offset, offset + length);
            offset += length;
            return result.toString("utf8");
        }
        function encodeLEB128(value) {
            const result = [];
            do {
                let byte = value & 0x7f;
                value >>= 7;
                if (value !== 0) byte |= 0x80;
                result.push(byte);
            }while (value !== 0);
            return $f2c4e6e5fee52e8e$require$Buffer.from(result);
        }
        function encodeString(value) {
            const result = $f2c4e6e5fee52e8e$require$Buffer.from(value, "utf8");
            return $f2c4e6e5fee52e8e$require$Buffer.concat([
                encodeLEB128(result.length),
                result
            ]);
        }
        do {
            const sectionStart = offset;
            const sectionId = input.readUInt8(offset);
            offset++;
            const sectionSize = decodeLEB128();
            const sectionEnd = offset + sectionSize;
            if (sectionId == 5) // Memory section
            // Make sure it's empty and only imported memory is used
            parts.push($f2c4e6e5fee52e8e$require$Buffer.from([
                5,
                1,
                0
            ]));
            else if (sectionId == 2) {
                // Import section
                const sectionParts = [];
                const numImports = decodeLEB128();
                for(let i = 0; i < numImports; i++){
                    const importStart = offset;
                    decodeString();
                    decodeString();
                    const kind = input.readUInt8(offset);
                    offset++;
                    let skipImport = false;
                    switch(kind){
                        case 0:
                            // Function import
                            decodeLEB128(); // index
                            break;
                        case 1:
                            // Table import
                            offset++; // type
                            decodeLimits();
                            break;
                        case 2:
                            // Memory import
                            decodeLimits();
                            // NOTE: existing memory import is removed (so no need to add it to sectionParts)
                            skipImport = true;
                            break;
                        case 3:
                            // Global import
                            offset++; // type
                            offset++; // mutability
                            break;
                        default:
                            throw new Error("Invalid import kind: " + kind);
                    }
                    if (!skipImport) sectionParts.push(input.subarray(importStart, offset));
                }
                const importMemory = $f2c4e6e5fee52e8e$require$Buffer.concat([
                    encodeString("env"),
                    encodeString("memory"),
                    $f2c4e6e5fee52e8e$require$Buffer.from([
                        2
                    ]),
                    $f2c4e6e5fee52e8e$require$Buffer.from([
                        0
                    ]),
                    encodeLEB128(1)
                ]);
                sectionParts.push(importMemory);
                const sectionData = $f2c4e6e5fee52e8e$require$Buffer.concat([
                    encodeLEB128(sectionParts.length),
                    ...sectionParts
                ]);
                parts.push($f2c4e6e5fee52e8e$require$Buffer.concat([
                    $f2c4e6e5fee52e8e$require$Buffer.from([
                        2
                    ]),
                    encodeLEB128(sectionData.length),
                    sectionData
                ]));
            } else if (sectionId == 7) {
                // Export section
                const sectionParts = [];
                const numExports = decodeLEB128();
                for(let i = 0; i < numExports; i++){
                    const exportStart = offset;
                    decodeString();
                    const kind = input.readUInt8(offset);
                    offset++;
                    decodeLEB128();
                    if (kind !== 2) // Pass through all exports except memory
                    sectionParts.push(input.subarray(exportStart, offset));
                }
                const sectionData = $f2c4e6e5fee52e8e$require$Buffer.concat([
                    encodeLEB128(sectionParts.length),
                    ...sectionParts
                ]);
                parts.push($f2c4e6e5fee52e8e$require$Buffer.concat([
                    $f2c4e6e5fee52e8e$require$Buffer.from([
                        7
                    ]),
                    encodeLEB128(sectionData.length),
                    sectionData
                ]));
            } else parts.push(input.subarray(sectionStart, sectionEnd));
            offset = sectionEnd;
        }while (offset < input.length);
        return $f2c4e6e5fee52e8e$require$Buffer.concat(parts);
    }
    // Host functions
    getRegisterLength(registerId) {
        return BigInt(this.registers[registerId.toString()] ? this.registers[registerId.toString()].length : Number.MAX_SAFE_INTEGER);
    }
    readFromRegister(registerId, ptr) {
        const mem = new Uint8Array(this.memory.buffer);
        mem.set(this.registers[registerId.toString()] || $f2c4e6e5fee52e8e$require$Buffer.from([]), Number(ptr));
    }
    getCurrentAccountId(registerId) {
        this.registers[registerId.toString()] = $f2c4e6e5fee52e8e$require$Buffer.from(this.context.contractId);
    }
    inputMethodArgs(registerId) {
        this.registers[registerId.toString()] = $f2c4e6e5fee52e8e$require$Buffer.from(this.context.methodArgs);
    }
    getBlockHeight() {
        return BigInt(this.context.blockHeight);
    }
    getBlockTimestamp() {
        return BigInt(this.context.blockTimestamp);
    }
    sha256(valueLen, valuePtr, registerId) {
        const value = new Uint8Array(this.memory.buffer, Number(valuePtr), Number(valueLen));
        const hash = (0, $5UUfm.createHash)("sha256");
        hash.update(value);
        this.registers[registerId.toString()] = hash.digest();
    }
    returnValue(valueLen, valuePtr) {
        this.result = $f2c4e6e5fee52e8e$require$Buffer.from(new Uint8Array(this.memory.buffer, Number(valuePtr), Number(valueLen)));
    }
    panic(message) {
        throw new Error("panic: " + message);
    }
    abort(msg_ptr, filename_ptr, line, col) {
        const msg = this.readUTF16CStr(msg_ptr);
        const filename = this.readUTF16CStr(filename_ptr);
        const message = `${msg} ${filename}:${line}:${col}`;
        if (!msg || !filename) throw new Error("abort: String encoding is bad UTF-16 sequence.");
        throw new Error("abort: " + message);
    }
    appendToLog(len, ptr) {
        this.logs.push(this.readUTF8CStr(len, ptr));
    }
    readStorage(key_len, key_ptr, register_id) {
        const result = this.storageRead(key_len, key_ptr);
        if (result == null) return BigInt(0);
        this.registers[register_id] = result;
        return BigInt(1);
    }
    hasStorageKey(key_len, key_ptr) {
        const result = this.storageRead(key_len, key_ptr);
        if (result == null) return BigInt(0);
        return BigInt(1);
    }
    getHostImports() {
        return {
            register_len: this.getRegisterLength.bind(this),
            read_register: this.readFromRegister.bind(this),
            current_account_id: this.getCurrentAccountId.bind(this),
            input: this.inputMethodArgs.bind(this),
            block_index: this.getBlockHeight.bind(this),
            block_timestamp: this.getBlockTimestamp.bind(this),
            sha256: this.sha256.bind(this),
            value_return: this.returnValue.bind(this),
            abort: this.abort.bind(this),
            log_utf8: this.appendToLog.bind(this),
            log_utf16: this.appendToLog.bind(this),
            storage_read: this.readStorage.bind(this),
            storage_has_key: this.hasStorageKey.bind(this),
            panic: ()=>this.panic("explicit guest panic"),
            panic_utf8: (len, ptr)=>this.panic(this.readUTF8CStr(len, ptr)),
            // Not implemented
            epoch_height: $f2c4e6e5fee52e8e$var$notImplemented("epoch_height"),
            storage_usage: $f2c4e6e5fee52e8e$var$notImplemented("storage_usage"),
            account_balance: $f2c4e6e5fee52e8e$var$notImplemented("account_balance"),
            account_locked_balance: $f2c4e6e5fee52e8e$var$notImplemented("account_locked_balance"),
            random_seed: $f2c4e6e5fee52e8e$var$notImplemented("random_seed"),
            ripemd160: $f2c4e6e5fee52e8e$var$notImplemented("ripemd160"),
            keccak256: $f2c4e6e5fee52e8e$var$notImplemented("keccak256"),
            keccak512: $f2c4e6e5fee52e8e$var$notImplemented("keccak512"),
            ecrecover: $f2c4e6e5fee52e8e$var$notImplemented("ecrecover"),
            validator_stake: $f2c4e6e5fee52e8e$var$notImplemented("validator_stake"),
            validator_total_stake: $f2c4e6e5fee52e8e$var$notImplemented("validator_total_stake"),
            // Prohibited
            write_register: $f2c4e6e5fee52e8e$var$prohibitedInView("write_register"),
            signer_account_id: $f2c4e6e5fee52e8e$var$prohibitedInView("signer_account_id"),
            signer_account_pk: $f2c4e6e5fee52e8e$var$prohibitedInView("signer_account_pk"),
            predecessor_account_id: $f2c4e6e5fee52e8e$var$prohibitedInView("predecessor_account_id"),
            attached_deposit: $f2c4e6e5fee52e8e$var$prohibitedInView("attached_deposit"),
            prepaid_gas: $f2c4e6e5fee52e8e$var$prohibitedInView("prepaid_gas"),
            used_gas: $f2c4e6e5fee52e8e$var$prohibitedInView("used_gas"),
            promise_create: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_create"),
            promise_then: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_then"),
            promise_and: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_and"),
            promise_batch_create: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_create"),
            promise_batch_then: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_then"),
            promise_batch_action_create_account: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_create_account"),
            promise_batch_action_deploy_contract: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_deploy_contract"),
            promise_batch_action_function_call: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_function_call"),
            promise_batch_action_function_call_weight: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_function_call_weight"),
            promise_batch_action_transfer: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_transfer"),
            promise_batch_action_stake: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_stake"),
            promise_batch_action_add_key_with_full_access: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_add_key_with_full_access"),
            promise_batch_action_add_key_with_function_call: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_add_key_with_function_call"),
            promise_batch_action_delete_key: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_delete_key"),
            promise_batch_action_delete_account: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_batch_action_delete_account"),
            promise_results_count: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_results_count"),
            promise_result: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_result"),
            promise_return: $f2c4e6e5fee52e8e$var$prohibitedInView("promise_return"),
            storage_write: $f2c4e6e5fee52e8e$var$prohibitedInView("storage_write"),
            storage_remove: $f2c4e6e5fee52e8e$var$prohibitedInView("storage_remove")
        };
    }
    execute(methodName) {
        return $f2c4e6e5fee52e8e$var$__awaiter(this, void 0, void 0, function*() {
            const module = yield WebAssembly.compile(this.wasm);
            const instance = yield WebAssembly.instantiate(module, {
                env: Object.assign(Object.assign({}, this.getHostImports()), {
                    memory: this.memory
                })
            });
            const callMethod = instance.exports[methodName];
            if (callMethod == undefined) throw new Error(`Contract method '${methodName}' does not exists in contract ${this.context.contractId} for block id ${this.context.blockHeight}`);
            callMethod();
            return {
                result: this.result,
                logs: this.logs
            };
        });
    }
}
module.exports.Runtime = $f2c4e6e5fee52e8e$var$Runtime;

});
parcelRegister("5UUfm", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $44edd02a6be448cd$export$5f828d93ff035aa8, (v) => $44edd02a6be448cd$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "createHash", () => $44edd02a6be448cd$export$2fb37efbf6ae0c0e, (v) => $44edd02a6be448cd$export$2fb37efbf6ae0c0e = v);
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
"use strict";

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));

var $eFSIF = parcelRequire("eFSIF");
var $44edd02a6be448cd$var$algoKeys = Object.keys($eFSIF);
var $44edd02a6be448cd$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;

var $eyeBm = parcelRequire("eyeBm");
$44edd02a6be448cd$export$26e5786e8ac8e530 = $eyeBm.Cipher;
$44edd02a6be448cd$export$bdd223f16383713e = $eyeBm.createCipher;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $eyeBm.Cipheriv;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $eyeBm.createCipheriv;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $eyeBm.Decipher;
$44edd02a6be448cd$export$12ada9414fbc594c = $eyeBm.createDecipher;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $eyeBm.Decipheriv;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $eyeBm.createDecipheriv;
$44edd02a6be448cd$export$58a258485f1e49f6 = $eyeBm.getCiphers;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $eyeBm.listCiphers;

var $5NszM = parcelRequire("5NszM");
$44edd02a6be448cd$export$971862a2fcb1bb40 = $5NszM.DiffieHellmanGroup;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $5NszM.createDiffieHellmanGroup;
$44edd02a6be448cd$export$fdc27893e98845cc = $5NszM.getDiffieHellman;
$44edd02a6be448cd$export$6671fb9a1323bed = $5NszM.createDiffieHellman;
$44edd02a6be448cd$export$d74daf141a551db = $5NszM.DiffieHellman;

var $4zMFU = parcelRequire("4zMFU");
$44edd02a6be448cd$export$45df7cae684751af = $4zMFU.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $4zMFU.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $4zMFU.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $4zMFU.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));

var $fMM6j = parcelRequire("fMM6j");
$44edd02a6be448cd$export$512823e338ddb1b7 = $fMM6j.publicEncrypt;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $fMM6j.privateEncrypt;
$44edd02a6be448cd$export$b9d55ff329113abd = $fMM6j.publicDecrypt;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $fMM6j.privateDecrypt;

var $c34vB = parcelRequire("c34vB");
$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $c34vB.randomFill;
$44edd02a6be448cd$export$2f7171e78e524d5e = $c34vB.randomFillSync;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRegister("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1hiLA = parcelRequire("1hiLA");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $1hiLA.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $1hiLA);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("1hiLA", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $0ee5efa19004c3e2$require$Buffer = $1U9GM.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $0ee5efa19004c3e2$require$Transform = $b6RFW.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $0ee5efa19004c3e2$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$0ee5efa19004c3e2$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $0ee5efa19004c3e2$var$HashBase(blockSize) {
    $0ee5efa19004c3e2$require$Transform.call(this);
    this._block = $0ee5efa19004c3e2$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($0ee5efa19004c3e2$var$HashBase, $0ee5efa19004c3e2$require$Transform);
$0ee5efa19004c3e2$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$0ee5efa19004c3e2$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$0ee5efa19004c3e2$var$HashBase.prototype.update = function(data, encoding) {
    $0ee5efa19004c3e2$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$0ee5efa19004c3e2$require$Buffer.isBuffer(data)) data = $0ee5efa19004c3e2$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$0ee5efa19004c3e2$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$0ee5efa19004c3e2$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$0ee5efa19004c3e2$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $0ee5efa19004c3e2$var$HashBase;

});
parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

exports.finished = (parcelRequire("fiCvv"));

exports.pipeline = (parcelRequire("aGSwO"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $9845726cca5dc7eb$var$Readable;
/*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $9845726cca5dc7eb$require$Buffer = $6ZWSX.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function debug() {};

var $bF5dL = parcelRequire("bF5dL");

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $9845726cca5dc7eb$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $9845726cca5dc7eb$require$_require$codes = $6JySE.codes;
var $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE = $9845726cca5dc7eb$require$_require$codes.ERR_INVALID_ARG_TYPE, $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED = $9845726cca5dc7eb$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $9845726cca5dc7eb$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $9845726cca5dc7eb$var$StringDecoder;
var $9845726cca5dc7eb$var$createReadableStreamAsyncIterator;
var $9845726cca5dc7eb$var$from;

(parcelRequire("dlqwk"))($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$errorOrDestroy = $fMCbt.errorOrDestroy;
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream, isDuplex) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $9845726cca5dc7eb$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $bF5dL();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $9845726cca5dc7eb$var$Duplex;
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $9845726cca5dc7eb$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) $9845726cca5dc7eb$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $9845726cca5dc7eb$var$errorOrDestroy(stream, new $9845726cca5dc7eb$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $9845726cca5dc7eb$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $9845726cca5dc7eb$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $9845726cca5dc7eb$var$MAX_HWM = 0x40000000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    $9845726cca5dc7eb$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $9845726cca5dc7eb$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $9845726cca5dc7eb$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    $9845726cca5dc7eb$var$errorOrDestroy(this, new $9845726cca5dc7eb$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        var ret = dest.write(chunk);
        $9845726cca5dc7eb$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) $9845726cca5dc7eb$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $9845726cca5dc7eb$var$debug("on readable", state.length, state.reading);
            if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
$9845726cca5dc7eb$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jfAlf.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jfAlf.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($9845726cca5dc7eb$var$updateReadableListening, this);
    return res;
};
function $9845726cca5dc7eb$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    $9845726cca5dc7eb$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($9845726cca5dc7eb$var$createReadableStreamAsyncIterator === undefined) $9845726cca5dc7eb$var$createReadableStreamAsyncIterator = (parcelRequire("2UdT6"));
    return $9845726cca5dc7eb$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    $9845726cca5dc7eb$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $9845726cca5dc7eb$var$Readable.from = function(iterable, opts) {
    if ($9845726cca5dc7eb$var$from === undefined) $9845726cca5dc7eb$var$from = (parcelRequire("e6P81"));
    return $9845726cca5dc7eb$var$from($9845726cca5dc7eb$var$Readable, iterable, opts);
};
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("bF5dL", function(module, exports) {
"use strict";
function $87d792cd1b95f90e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $87d792cd1b95f90e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $87d792cd1b95f90e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $87d792cd1b95f90e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $87d792cd1b95f90e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $87d792cd1b95f90e$var$_defineProperty(obj, key, value) {
    key = $87d792cd1b95f90e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87d792cd1b95f90e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87d792cd1b95f90e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $87d792cd1b95f90e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $87d792cd1b95f90e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $87d792cd1b95f90e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $87d792cd1b95f90e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $87d792cd1b95f90e$var$_toPropertyKey(arg) {
    var key = $87d792cd1b95f90e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $87d792cd1b95f90e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $87d792cd1b95f90e$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $87d792cd1b95f90e$var$inspect = $kjyEk.inspect;
var $87d792cd1b95f90e$var$custom = $87d792cd1b95f90e$var$inspect && $87d792cd1b95f90e$var$inspect.custom || "inspect";
function $87d792cd1b95f90e$var$copyBuffer(src, target, offset) {
    $87d792cd1b95f90e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $87d792cd1b95f90e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $87d792cd1b95f90e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $87d792cd1b95f90e$var$Buffer.alloc(0);
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $87d792cd1b95f90e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $87d792cd1b95f90e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $87d792cd1b95f90e$var$custom,
            value: function value(_, options) {
                return $87d792cd1b95f90e$var$inspect(this, $87d792cd1b95f90e$var$_objectSpread($87d792cd1b95f90e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fMCbt", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b7d8f541ca4a3ff5$var$emitCloseNT, _this);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$emitErrorAndCloseNT(self, err) {
    $b7d8f541ca4a3ff5$var$emitErrorNT(self, err);
    $b7d8f541ca4a3ff5$var$emitCloseNT(self);
}
function $b7d8f541ca4a3ff5$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b7d8f541ca4a3ff5$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy,
    errorOrDestroy: $b7d8f541ca4a3ff5$var$errorOrDestroy
};

});

parcelRegister("04a3B", function(module, exports) {
"use strict";

var $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6JySE")).codes.ERR_INVALID_OPT_VALUE;
function $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $00c82cf8dac417cf$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $00c82cf8dac417cf$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $00c82cf8dac417cf$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $00c82cf8dac417cf$var$getHighWaterMark
};

});
parcelRegister("6JySE", function(module, exports) {

$parcel$export(module.exports, "codes", () => $4e720097bc0bc9d8$export$e45cb6485273080e, (v) => $4e720097bc0bc9d8$export$e45cb6485273080e = v);
var $4e720097bc0bc9d8$export$e45cb6485273080e;
"use strict";
function $4e720097bc0bc9d8$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4e720097bc0bc9d8$var$codes = {};
function $4e720097bc0bc9d8$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4e720097bc0bc9d8$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4e720097bc0bc9d8$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4e720097bc0bc9d8$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4e720097bc0bc9d8$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4e720097bc0bc9d8$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4e720097bc0bc9d8$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $4e720097bc0bc9d8$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($4e720097bc0bc9d8$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    else {
        var type = $4e720097bc0bc9d8$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($4e720097bc0bc9d8$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$4e720097bc0bc9d8$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$4e720097bc0bc9d8$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$4e720097bc0bc9d8$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$4e720097bc0bc9d8$export$e45cb6485273080e = $4e720097bc0bc9d8$var$codes;

});


parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");

(parcelRequire("dlqwk"))($076d08b0309449dc$var$Duplex, $d4xg3);
// Allow the keys array to be GC'ed.
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $076d08b0309449dc$var$onend);
        }
    }
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $6ZWSX = parcelRequire("6ZWSX");
var $2bdf55c2c4f390d3$require$Buffer = $6ZWSX.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");

var $04a3B = parcelRequire("04a3B");
var $2bdf55c2c4f390d3$var$getHighWaterMark = $04a3B.getHighWaterMark;

var $6JySE = parcelRequire("6JySE");
var $2bdf55c2c4f390d3$require$_require$codes = $6JySE.codes;
var $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_INVALID_ARG_TYPE, $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED = $2bdf55c2c4f390d3$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK = $2bdf55c2c4f390d3$require$_require$codes.ERR_MULTIPLE_CALLBACK, $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_DESTROYED, $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_NULL_VALUES, $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END = $2bdf55c2c4f390d3$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING = $2bdf55c2c4f390d3$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $2bdf55c2c4f390d3$var$errorOrDestroy = $fMCbt.errorOrDestroy;

(parcelRequire("dlqwk"))($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream, isDuplex) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $2bdf55c2c4f390d3$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $2bdf55c2c4f390d3$var$Duplex;
    if (!isDuplex && !$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    $2bdf55c2c4f390d3$var$errorOrDestroy(this, new $2bdf55c2c4f390d3$var$ERR_STREAM_CANNOT_PIPE());
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new $2bdf55c2c4f390d3$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $2bdf55c2c4f390d3$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $2bdf55c2c4f390d3$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ending) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $2bdf55c2c4f390d3$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $2bdf55c2c4f390d3$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $2bdf55c2c4f390d3$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $2bdf55c2c4f390d3$var$ERR_MULTIPLE_CALLBACK();
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $2bdf55c2c4f390d3$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $2bdf55c2c4f390d3$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("2UdT6", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $21db958e3a099d7d$var$_Object$setPrototypeO;
function $21db958e3a099d7d$var$_defineProperty(obj, key, value) {
    key = $21db958e3a099d7d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21db958e3a099d7d$var$_toPropertyKey(arg) {
    var key = $21db958e3a099d7d$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $21db958e3a099d7d$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $fiCvv = parcelRequire("fiCvv");
var $21db958e3a099d7d$var$kLastResolve = Symbol("lastResolve");
var $21db958e3a099d7d$var$kLastReject = Symbol("lastReject");
var $21db958e3a099d7d$var$kError = Symbol("error");
var $21db958e3a099d7d$var$kEnded = Symbol("ended");
var $21db958e3a099d7d$var$kLastPromise = Symbol("lastPromise");
var $21db958e3a099d7d$var$kHandlePromise = Symbol("handlePromise");
var $21db958e3a099d7d$var$kStream = Symbol("stream");
function $21db958e3a099d7d$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $21db958e3a099d7d$var$readAndResolve(iter) {
    var resolve = iter[$21db958e3a099d7d$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$21db958e3a099d7d$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$21db958e3a099d7d$var$kLastPromise] = null;
            iter[$21db958e3a099d7d$var$kLastResolve] = null;
            iter[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(data, false));
        }
    }
}
function $21db958e3a099d7d$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($21db958e3a099d7d$var$readAndResolve, iter);
}
function $21db958e3a099d7d$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$21db958e3a099d7d$var$kEnded]) {
                resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
                return;
            }
            iter[$21db958e3a099d7d$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $21db958e3a099d7d$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($21db958e3a099d7d$var$_Object$setPrototypeO = {
    get stream () {
        return this[$21db958e3a099d7d$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$21db958e3a099d7d$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$21db958e3a099d7d$var$kEnded]) return Promise.resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        if (this[$21db958e3a099d7d$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$21db958e3a099d7d$var$kError]) reject(_this[$21db958e3a099d7d$var$kError]);
                else resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$21db958e3a099d7d$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($21db958e3a099d7d$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$21db958e3a099d7d$var$kStream].read();
            if (data !== null) return Promise.resolve($21db958e3a099d7d$var$createIterResult(data, false));
            promise = new Promise(this[$21db958e3a099d7d$var$kHandlePromise]);
        }
        this[$21db958e3a099d7d$var$kLastPromise] = promise;
        return promise;
    }
}, $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $21db958e3a099d7d$var$_defineProperty($21db958e3a099d7d$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$21db958e3a099d7d$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        });
    });
}), $21db958e3a099d7d$var$_Object$setPrototypeO), $21db958e3a099d7d$var$AsyncIteratorPrototype);
var $21db958e3a099d7d$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($21db958e3a099d7d$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kStream, {
        value: stream,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastResolve, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kLastReject, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kError, {
        value: null,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $21db958e3a099d7d$var$_defineProperty(_Object$create, $21db958e3a099d7d$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$21db958e3a099d7d$var$kStream].read();
            if (data) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                resolve($21db958e3a099d7d$var$createIterResult(data, false));
            } else {
                iterator[$21db958e3a099d7d$var$kLastResolve] = resolve;
                iterator[$21db958e3a099d7d$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$21db958e3a099d7d$var$kLastPromise] = null;
    $fiCvv(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$21db958e3a099d7d$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$21db958e3a099d7d$var$kLastPromise] = null;
                iterator[$21db958e3a099d7d$var$kLastResolve] = null;
                iterator[$21db958e3a099d7d$var$kLastReject] = null;
                reject(err);
            }
            iterator[$21db958e3a099d7d$var$kError] = err;
            return;
        }
        var resolve = iterator[$21db958e3a099d7d$var$kLastResolve];
        if (resolve !== null) {
            iterator[$21db958e3a099d7d$var$kLastPromise] = null;
            iterator[$21db958e3a099d7d$var$kLastResolve] = null;
            iterator[$21db958e3a099d7d$var$kLastReject] = null;
            resolve($21db958e3a099d7d$var$createIterResult(undefined, true));
        }
        iterator[$21db958e3a099d7d$var$kEnded] = true;
    });
    stream.on("readable", $21db958e3a099d7d$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $21db958e3a099d7d$var$createReadableStreamAsyncIterator;

});
parcelRegister("fiCvv", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6JySE")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b236683171fcb6ee$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b236683171fcb6ee$var$noop() {}
function $b236683171fcb6ee$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $b236683171fcb6ee$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $b236683171fcb6ee$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b236683171fcb6ee$var$once(callback || $b236683171fcb6ee$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b236683171fcb6ee$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($b236683171fcb6ee$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $b236683171fcb6ee$var$eos;

});


parcelRegister("e6P81", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $6JySE = parcelRequire("6JySE");
var $8180203f7f0d3074$require$_require$codes = $6JySE.codes;
var $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED = $8180203f7f0d3074$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK = $8180203f7f0d3074$require$_require$codes.ERR_MULTIPLE_CALLBACK, $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0 = $8180203f7f0d3074$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $DwJuQ = parcelRequire("DwJuQ");

(parcelRequire("dlqwk"))($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $8180203f7f0d3074$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $8180203f7f0d3074$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $8180203f7f0d3074$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

(parcelRequire("dlqwk"))($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("aGSwO", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $7c881fce7a4fadf1$var$eos;
function $7c881fce7a4fadf1$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6JySE = parcelRequire("6JySE");
var $7c881fce7a4fadf1$require$_require$codes = $6JySE.codes;
var $7c881fce7a4fadf1$var$ERR_MISSING_ARGS = $7c881fce7a4fadf1$require$_require$codes.ERR_MISSING_ARGS, $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED = $7c881fce7a4fadf1$require$_require$codes.ERR_STREAM_DESTROYED;
function $7c881fce7a4fadf1$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $7c881fce7a4fadf1$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, callback) {
    callback = $7c881fce7a4fadf1$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($7c881fce7a4fadf1$var$eos === undefined) $7c881fce7a4fadf1$var$eos = (parcelRequire("fiCvv"));
    $7c881fce7a4fadf1$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($7c881fce7a4fadf1$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $7c881fce7a4fadf1$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $7c881fce7a4fadf1$var$call(fn) {
    fn();
}
function $7c881fce7a4fadf1$var$pipe(from, to) {
    return from.pipe(to);
}
function $7c881fce7a4fadf1$var$popCallback(streams) {
    if (!streams.length) return $7c881fce7a4fadf1$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $7c881fce7a4fadf1$var$noop;
    return streams.pop();
}
function $7c881fce7a4fadf1$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $7c881fce7a4fadf1$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $7c881fce7a4fadf1$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $7c881fce7a4fadf1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($7c881fce7a4fadf1$var$call);
            if (reading) return;
            destroys.forEach($7c881fce7a4fadf1$var$call);
            callback(error);
        });
    });
    return streams.reduce($7c881fce7a4fadf1$var$pipe);
}
module.exports = $7c881fce7a4fadf1$var$pipeline;

});




parcelRegister("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $8amZM = parcelRequire("8amZM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $8amZM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $8amZM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});
parcelRegister("8amZM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $5f21184fa2855fc7$require$Buffer = $1U9GM.Buffer;

var $b6RFW = parcelRequire("b6RFW");
var $5f21184fa2855fc7$require$Transform = $b6RFW.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $5f21184fa2855fc7$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$5f21184fa2855fc7$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $5f21184fa2855fc7$var$HashBase(blockSize) {
    $5f21184fa2855fc7$require$Transform.call(this);
    this._block = $5f21184fa2855fc7$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($5f21184fa2855fc7$var$HashBase, $5f21184fa2855fc7$require$Transform);
$5f21184fa2855fc7$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$5f21184fa2855fc7$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$5f21184fa2855fc7$var$HashBase.prototype.update = function(data, encoding) {
    $5f21184fa2855fc7$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$5f21184fa2855fc7$require$Buffer.isBuffer(data)) data = $5f21184fa2855fc7$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$5f21184fa2855fc7$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$5f21184fa2855fc7$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$5f21184fa2855fc7$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $5f21184fa2855fc7$var$HashBase;

});


parcelRegister("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("d4xg3"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("3LwY7"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("DwJuQ"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("b7kl8"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("4wWcs"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("fiCvv"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("aGSwO"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});



parcelRegister("1iL1D", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $0f2bf322914b61b2$var$Hmac("rmd160", key);
    if (alg === "md5") return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("eFSIF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6swAi"));

});
parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});
parcelRegister("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split(".")[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $5130da986dd86f24$var$defaultEncoding = "utf-8";
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    digest = digest || "sha1";
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRegister("eyeBm", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $a97f913e2ff95e3b$export$bdd223f16383713e, (v) => $a97f913e2ff95e3b$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $a97f913e2ff95e3b$export$26e5786e8ac8e530, (v) => $a97f913e2ff95e3b$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $a97f913e2ff95e3b$export$2f64596b8cbf08b4, (v) => $a97f913e2ff95e3b$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $a97f913e2ff95e3b$export$20533d26f07f1ee0, (v) => $a97f913e2ff95e3b$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $a97f913e2ff95e3b$export$12ada9414fbc594c, (v) => $a97f913e2ff95e3b$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a, (v) => $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $a97f913e2ff95e3b$export$36b6d6ef312eab39, (v) => $a97f913e2ff95e3b$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $a97f913e2ff95e3b$export$f5e7e39d57cd9700, (v) => $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $a97f913e2ff95e3b$export$dedd8dc3dc62b370, (v) => $a97f913e2ff95e3b$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $a97f913e2ff95e3b$export$58a258485f1e49f6, (v) => $a97f913e2ff95e3b$export$58a258485f1e49f6 = v);
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;

var $ljOtR = parcelRequire("ljOtR");

var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");

var $xsYYh = parcelRequire("xsYYh");

var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($xsYYh[suite]) {
        keyLen = $xsYYh[suite].key * 8;
        ivLen = $xsYYh[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($xsYYh[suite]) return new $ljOtR({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($xsYYh).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;

});
parcelRegister("ljOtR", function(module, exports) {

var $26nOC = parcelRequire("26nOC");

var $8SeDJ = parcelRequire("8SeDJ");

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    "des-ede3-cbc": $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    "des-ede3": $8SeDJ.EDE,
    "des-ede-cbc": $8SeDJ.CBC.instantiate($8SeDJ.EDE),
    "des-ede": $8SeDJ.EDE,
    "des-cbc": $8SeDJ.CBC.instantiate($8SeDJ.DES),
    "des-ecb": $8SeDJ.DES
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes["des-cbc"];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes["des-ede3-cbc"];
module.exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};

});
parcelRegister("8SeDJ", function(module, exports) {

$parcel$export(module.exports, "DES", () => $675eb908dbde2e68$export$cc8859615686b300, (v) => $675eb908dbde2e68$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $675eb908dbde2e68$export$8ad3f227af08fcc5, (v) => $675eb908dbde2e68$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $675eb908dbde2e68$export$947646e34766044f, (v) => $675eb908dbde2e68$export$947646e34766044f = v);
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
"use strict";

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));

});
parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
"use strict";
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("enfpo", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("dB8Kv", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dB8Kv.create({
            type: "encrypt",
            key: k1
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: "decrypt",
            key: k3
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});



parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});

parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv, true);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});


parcelRegister("xsYYh", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("5NszM", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $4387b1fafb8a1868$export$971862a2fcb1bb40, (v) => $4387b1fafb8a1868$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $4387b1fafb8a1868$export$c6ff6a88acbeaf40, (v) => $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $4387b1fafb8a1868$export$fdc27893e98845cc, (v) => $4387b1fafb8a1868$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $4387b1fafb8a1868$export$6671fb9a1323bed, (v) => $4387b1fafb8a1868$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $4387b1fafb8a1868$export$d74daf141a551db, (v) => $4387b1fafb8a1868$export$d74daf141a551db = v);
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;

var $aV75E = parcelRequire("aV75E");

var $kGErQ = parcelRequire("kGErQ");

var $bLCm8 = parcelRequire("bLCm8");
function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].prime, "hex");
    var gen = new $4387b1fafb8a1868$require$Buffer($kGErQ[mod].gen, "hex");
    return new $bLCm8(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $bLCm8($aV75E(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $bLCm8(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;

});
parcelRegister("aV75E", function(module, exports) {

var $hkN9y = parcelRequire("hkN9y");
module.exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);

var $g2bJL = parcelRequire("g2bJL");
var $7f34ba2fa9025258$var$millerRabin = new $g2bJL();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("g2bJL", function(module, exports) {

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
module.exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("kGErQ", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRegister("bLCm8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $g2bJL = parcelRequire("g2bJL");
var $8911d62d5514749e$var$millerRabin = new $g2bJL();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);

var $aV75E = parcelRequire("aV75E");

var $hkN9y = parcelRequire("hkN9y");
module.exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$aV75E.simpleSieve || !$aV75E.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("4zMFU", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $62Mby = parcelRequire("62Mby");

var $dlqwk = parcelRequire("dlqwk");

var $6E9kG = parcelRequire("6E9kG");

var $fQdau = parcelRequire("fQdau");

var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, "hex");
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $62Mby.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $62Mby.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $6E9kG(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $62Mby.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $62Mby.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $fQdau(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
module.exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};

});
parcelRegister("62Mby", function(module, exports) {

exports = module.exports = (parcelRequire("ijRUb"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("77F6W"));

exports.Duplex = (parcelRequire("gymWQ"));

exports.Transform = (parcelRequire("8hRuT"));

exports.PassThrough = (parcelRequire("fbZXo"));

});
parcelRegister("ijRUb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $d563d0cdbeba3673$var$Readable;

var $767Wy = parcelRequire("767Wy");
/*</replacement>*/ /*<replacement>*/ var $d563d0cdbeba3673$var$Duplex;
/*</replacement>*/ $d563d0cdbeba3673$var$Readable.ReadableState = $d563d0cdbeba3673$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $d563d0cdbeba3673$require$EE = $7etJZ.EventEmitter;
var $d563d0cdbeba3673$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $7TavY = parcelRequire("7TavY");

var $io3aA = parcelRequire("io3aA");
var $d563d0cdbeba3673$require$Buffer = $io3aA.Buffer;
var $d563d0cdbeba3673$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $d563d0cdbeba3673$var$_uint8ArrayToBuffer(chunk) {
    return $d563d0cdbeba3673$require$Buffer.from(chunk);
}
function $d563d0cdbeba3673$var$_isUint8Array(obj) {
    return $d563d0cdbeba3673$require$Buffer.isBuffer(obj) || obj instanceof $d563d0cdbeba3673$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $d563d0cdbeba3673$var$util = Object.create((parcelRequire("dH2Jp")));

$d563d0cdbeba3673$var$util.inherits = (parcelRequire("dlqwk"));

var $kjyEk = parcelRequire("kjyEk");
var $d563d0cdbeba3673$var$debug = void 0;
if ($kjyEk && $kjyEk.debuglog) $d563d0cdbeba3673$var$debug = $kjyEk.debuglog("stream");
else $d563d0cdbeba3673$var$debug = function() {};

var $hpl8n = parcelRequire("hpl8n");

var $dMA3M = parcelRequire("dMA3M");
var $d563d0cdbeba3673$var$StringDecoder;
$d563d0cdbeba3673$var$util.inherits($d563d0cdbeba3673$var$Readable, $7TavY);
var $d563d0cdbeba3673$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $d563d0cdbeba3673$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($767Wy(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $d563d0cdbeba3673$var$ReadableState(options, stream) {
    $d563d0cdbeba3673$var$Duplex = $d563d0cdbeba3673$var$Duplex || (parcelRequire("gymWQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $d563d0cdbeba3673$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $hpl8n();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$d563d0cdbeba3673$var$StringDecoder) $d563d0cdbeba3673$var$StringDecoder = (parcelRequire("gxvFQ")).StringDecoder;
        this.decoder = new $d563d0cdbeba3673$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $d563d0cdbeba3673$var$Readable(options) {
    $d563d0cdbeba3673$var$Duplex = $d563d0cdbeba3673$var$Duplex || (parcelRequire("gymWQ"));
    if (!(this instanceof $d563d0cdbeba3673$var$Readable)) return new $d563d0cdbeba3673$var$Readable(options);
    this._readableState = new $d563d0cdbeba3673$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $7TavY.call(this);
}
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$d563d0cdbeba3673$var$Readable.prototype.destroy = $dMA3M.destroy;
$d563d0cdbeba3673$var$Readable.prototype._undestroy = $dMA3M.undestroy;
$d563d0cdbeba3673$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$d563d0cdbeba3673$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $d563d0cdbeba3673$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $d563d0cdbeba3673$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$d563d0cdbeba3673$var$Readable.prototype.unshift = function(chunk) {
    return $d563d0cdbeba3673$var$readableAddChunk(this, chunk, null, true, false);
};
function $d563d0cdbeba3673$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $d563d0cdbeba3673$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $d563d0cdbeba3673$var$chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $d563d0cdbeba3673$require$Buffer.prototype) chunk = $d563d0cdbeba3673$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit("error", new Error("stream.unshift() after end event"));
                else $d563d0cdbeba3673$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit("error", new Error("stream.push() after EOF"));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $d563d0cdbeba3673$var$addChunk(stream, state, chunk, false);
                    else $d563d0cdbeba3673$var$maybeReadMore(stream, state);
                } else $d563d0cdbeba3673$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $d563d0cdbeba3673$var$needMoreData(state);
}
function $d563d0cdbeba3673$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit("data", chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $d563d0cdbeba3673$var$emitReadable(stream);
    }
    $d563d0cdbeba3673$var$maybeReadMore(stream, state);
}
function $d563d0cdbeba3673$var$chunkInvalid(state, chunk) {
    var er;
    if (!$d563d0cdbeba3673$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $d563d0cdbeba3673$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$d563d0cdbeba3673$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$d563d0cdbeba3673$var$Readable.prototype.setEncoding = function(enc) {
    if (!$d563d0cdbeba3673$var$StringDecoder) $d563d0cdbeba3673$var$StringDecoder = (parcelRequire("gxvFQ")).StringDecoder;
    this._readableState.decoder = new $d563d0cdbeba3673$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $d563d0cdbeba3673$var$MAX_HWM = 0x800000;
function $d563d0cdbeba3673$var$computeNewHighWaterMark(n) {
    if (n >= $d563d0cdbeba3673$var$MAX_HWM) n = $d563d0cdbeba3673$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $d563d0cdbeba3673$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$d563d0cdbeba3673$var$Readable.prototype.read = function(n) {
    $d563d0cdbeba3673$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $d563d0cdbeba3673$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $d563d0cdbeba3673$var$endReadable(this);
        else $d563d0cdbeba3673$var$emitReadable(this);
        return null;
    }
    n = $d563d0cdbeba3673$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $d563d0cdbeba3673$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $d563d0cdbeba3673$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $d563d0cdbeba3673$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $d563d0cdbeba3673$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $d563d0cdbeba3673$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $d563d0cdbeba3673$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $d563d0cdbeba3673$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $d563d0cdbeba3673$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $d563d0cdbeba3673$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $d563d0cdbeba3673$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $d563d0cdbeba3673$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $d563d0cdbeba3673$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) $bUlqC.nextTick($d563d0cdbeba3673$var$emitReadable_, stream);
        else $d563d0cdbeba3673$var$emitReadable_(stream);
    }
}
function $d563d0cdbeba3673$var$emitReadable_(stream) {
    $d563d0cdbeba3673$var$debug("emit readable");
    stream.emit("readable");
    $d563d0cdbeba3673$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $d563d0cdbeba3673$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $bUlqC.nextTick($d563d0cdbeba3673$var$maybeReadMore_, stream, state);
    }
}
function $d563d0cdbeba3673$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $d563d0cdbeba3673$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$d563d0cdbeba3673$var$Readable.prototype._read = function(n) {
    this.emit("error", new Error("_read() is not implemented"));
};
$d563d0cdbeba3673$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $d563d0cdbeba3673$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $bUlqC.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $d563d0cdbeba3673$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $d563d0cdbeba3673$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $d563d0cdbeba3673$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $d563d0cdbeba3673$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        $d563d0cdbeba3673$var$debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $d563d0cdbeba3673$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $d563d0cdbeba3673$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $d563d0cdbeba3673$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($d563d0cdbeba3673$var$EElistenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    $d563d0cdbeba3673$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $d563d0cdbeba3673$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $d563d0cdbeba3673$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $d563d0cdbeba3673$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $d563d0cdbeba3673$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $d563d0cdbeba3673$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $d563d0cdbeba3673$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $d563d0cdbeba3673$var$flow(src);
        }
    };
}
$d563d0cdbeba3673$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $d563d0cdbeba3673$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$d563d0cdbeba3673$var$Readable.prototype.on = function(ev, fn) {
    var res = $7TavY.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $bUlqC.nextTick($d563d0cdbeba3673$var$nReadingNextTick, this);
            else if (state.length) $d563d0cdbeba3673$var$emitReadable(this);
        }
    }
    return res;
};
$d563d0cdbeba3673$var$Readable.prototype.addListener = $d563d0cdbeba3673$var$Readable.prototype.on;
function $d563d0cdbeba3673$var$nReadingNextTick(self1) {
    $d563d0cdbeba3673$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$d563d0cdbeba3673$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $d563d0cdbeba3673$var$debug("resume");
        state.flowing = true;
        $d563d0cdbeba3673$var$resume(this, state);
    }
    return this;
};
function $d563d0cdbeba3673$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $bUlqC.nextTick($d563d0cdbeba3673$var$resume_, stream, state);
    }
}
function $d563d0cdbeba3673$var$resume_(stream, state) {
    if (!state.reading) {
        $d563d0cdbeba3673$var$debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    $d563d0cdbeba3673$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$d563d0cdbeba3673$var$Readable.prototype.pause = function() {
    $d563d0cdbeba3673$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $d563d0cdbeba3673$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function $d563d0cdbeba3673$var$flow(stream) {
    var state = stream._readableState;
    $d563d0cdbeba3673$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$d563d0cdbeba3673$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $d563d0cdbeba3673$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $d563d0cdbeba3673$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $d563d0cdbeba3673$var$kProxyEvents.length; n++)stream.on($d563d0cdbeba3673$var$kProxyEvents[n], this.emit.bind(this, $d563d0cdbeba3673$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $d563d0cdbeba3673$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($d563d0cdbeba3673$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$d563d0cdbeba3673$var$Readable._fromList = $d563d0cdbeba3673$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $d563d0cdbeba3673$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $d563d0cdbeba3673$var$copyFromBufferString(n, list) : $d563d0cdbeba3673$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $d563d0cdbeba3673$var$copyFromBuffer(n, list) {
    var ret = $d563d0cdbeba3673$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $d563d0cdbeba3673$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $bUlqC.nextTick($d563d0cdbeba3673$var$endReadableNT, state, stream);
    }
}
function $d563d0cdbeba3673$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function $d563d0cdbeba3673$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bUlqC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
if (typeof $hPtJY === "undefined" || !$hPtJY.version || $hPtJY.version.indexOf("v0.") === 0 || $hPtJY.version.indexOf("v1.") === 0 && $hPtJY.version.indexOf("v1.8.") !== 0) module.exports = {
    nextTick: $8ab58be9444f732a$var$nextTick
};
else module.exports = $hPtJY;
function $8ab58be9444f732a$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== "function") throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $hPtJY.nextTick(fn);
        case 2:
            return $hPtJY.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $hPtJY.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $hPtJY.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $hPtJY.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == "[object Array]";
};

});

parcelRegister("7TavY", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("io3aA", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $d62ced5552029a98$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $d62ced5552029a98$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($d62ced5552029a98$var$Buffer.from && $d62ced5552029a98$var$Buffer.alloc && $d62ced5552029a98$var$Buffer.allocUnsafe && $d62ced5552029a98$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $d62ced5552029a98$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $d62ced5552029a98$var$SafeBuffer;
}
function $d62ced5552029a98$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $d62ced5552029a98$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$d62ced5552029a98$var$copyProps($d62ced5552029a98$var$Buffer, $d62ced5552029a98$var$SafeBuffer);
$d62ced5552029a98$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $d62ced5552029a98$var$Buffer(arg, encodingOrOffset, length);
};
$d62ced5552029a98$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $d62ced5552029a98$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$d62ced5552029a98$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $d62ced5552029a98$var$Buffer(size);
};
$d62ced5552029a98$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});

parcelRegister("dH2Jp", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $9f8168ed52eee242$export$43bee75e5e14138e, (v) => $9f8168ed52eee242$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $9f8168ed52eee242$export$f9ce7b637dfbe238, (v) => $9f8168ed52eee242$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $9f8168ed52eee242$export$630801d484da15df, (v) => $9f8168ed52eee242$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $9f8168ed52eee242$export$bedb7023a7733221, (v) => $9f8168ed52eee242$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $9f8168ed52eee242$export$7e4aa119212bc614, (v) => $9f8168ed52eee242$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $9f8168ed52eee242$export$844ec244b1367d54, (v) => $9f8168ed52eee242$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $9f8168ed52eee242$export$a244864fd9645c7f, (v) => $9f8168ed52eee242$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $9f8168ed52eee242$export$fce6876652108ab, (v) => $9f8168ed52eee242$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $9f8168ed52eee242$export$49841c62b9eff15, (v) => $9f8168ed52eee242$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $9f8168ed52eee242$export$a6cdc56e425d0d0a, (v) => $9f8168ed52eee242$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $9f8168ed52eee242$export$871608497c498473, (v) => $9f8168ed52eee242$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $9f8168ed52eee242$export$e6127cc7fe7395c3, (v) => $9f8168ed52eee242$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $9f8168ed52eee242$export$f6e2535fb5126e54, (v) => $9f8168ed52eee242$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $9f8168ed52eee242$export$c3825b437cbdea5c, (v) => $9f8168ed52eee242$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $9f8168ed52eee242$export$a7884ebc965f8f54, (v) => $9f8168ed52eee242$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $9f8168ed52eee242$export$43bee75e5e14138e;
var $9f8168ed52eee242$export$f9ce7b637dfbe238;
var $9f8168ed52eee242$export$630801d484da15df;
var $9f8168ed52eee242$export$bedb7023a7733221;
var $9f8168ed52eee242$export$7e4aa119212bc614;
var $9f8168ed52eee242$export$844ec244b1367d54;
var $9f8168ed52eee242$export$a244864fd9645c7f;
var $9f8168ed52eee242$export$fce6876652108ab;
var $9f8168ed52eee242$export$49841c62b9eff15;
var $9f8168ed52eee242$export$a6cdc56e425d0d0a;
var $9f8168ed52eee242$export$871608497c498473;
var $9f8168ed52eee242$export$e6127cc7fe7395c3;
var $9f8168ed52eee242$export$f6e2535fb5126e54;
var $9f8168ed52eee242$export$c3825b437cbdea5c;
var $9f8168ed52eee242$export$a7884ebc965f8f54;
function $9f8168ed52eee242$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $9f8168ed52eee242$var$objectToString(arg) === "[object Array]";
}
$9f8168ed52eee242$export$43bee75e5e14138e = $9f8168ed52eee242$var$isArray;
function $9f8168ed52eee242$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$9f8168ed52eee242$export$f9ce7b637dfbe238 = $9f8168ed52eee242$var$isBoolean;
function $9f8168ed52eee242$var$isNull(arg) {
    return arg === null;
}
$9f8168ed52eee242$export$630801d484da15df = $9f8168ed52eee242$var$isNull;
function $9f8168ed52eee242$var$isNullOrUndefined(arg) {
    return arg == null;
}
$9f8168ed52eee242$export$bedb7023a7733221 = $9f8168ed52eee242$var$isNullOrUndefined;
function $9f8168ed52eee242$var$isNumber(arg) {
    return typeof arg === "number";
}
$9f8168ed52eee242$export$7e4aa119212bc614 = $9f8168ed52eee242$var$isNumber;
function $9f8168ed52eee242$var$isString(arg) {
    return typeof arg === "string";
}
$9f8168ed52eee242$export$844ec244b1367d54 = $9f8168ed52eee242$var$isString;
function $9f8168ed52eee242$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$9f8168ed52eee242$export$a244864fd9645c7f = $9f8168ed52eee242$var$isSymbol;
function $9f8168ed52eee242$var$isUndefined(arg) {
    return arg === void 0;
}
$9f8168ed52eee242$export$fce6876652108ab = $9f8168ed52eee242$var$isUndefined;
function $9f8168ed52eee242$var$isRegExp(re) {
    return $9f8168ed52eee242$var$objectToString(re) === "[object RegExp]";
}
$9f8168ed52eee242$export$49841c62b9eff15 = $9f8168ed52eee242$var$isRegExp;
function $9f8168ed52eee242$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$9f8168ed52eee242$export$a6cdc56e425d0d0a = $9f8168ed52eee242$var$isObject;
function $9f8168ed52eee242$var$isDate(d) {
    return $9f8168ed52eee242$var$objectToString(d) === "[object Date]";
}
$9f8168ed52eee242$export$871608497c498473 = $9f8168ed52eee242$var$isDate;
function $9f8168ed52eee242$var$isError(e) {
    return $9f8168ed52eee242$var$objectToString(e) === "[object Error]" || e instanceof Error;
}
$9f8168ed52eee242$export$e6127cc7fe7395c3 = $9f8168ed52eee242$var$isError;
function $9f8168ed52eee242$var$isFunction(arg) {
    return typeof arg === "function";
}
$9f8168ed52eee242$export$f6e2535fb5126e54 = $9f8168ed52eee242$var$isFunction;
function $9f8168ed52eee242$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$9f8168ed52eee242$export$c3825b437cbdea5c = $9f8168ed52eee242$var$isPrimitive;

$9f8168ed52eee242$export$a7884ebc965f8f54 = (parcelRequire("6ZWSX")).Buffer.isBuffer;
function $9f8168ed52eee242$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("hpl8n", function(module, exports) {
"use strict";
function $cac52a4525eaea67$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $io3aA = parcelRequire("io3aA");
var $cac52a4525eaea67$require$Buffer = $io3aA.Buffer;

var $kjyEk = parcelRequire("kjyEk");
function $cac52a4525eaea67$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $cac52a4525eaea67$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $cac52a4525eaea67$require$Buffer.alloc(0);
        var ret = $cac52a4525eaea67$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $cac52a4525eaea67$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($kjyEk && $kjyEk.inspect && $kjyEk.inspect.custom) module.exports.prototype[$kjyEk.inspect.custom] = function() {
    var obj = $kjyEk.inspect({
        length: this.length
    });
    return this.constructor.name + " " + obj;
};

});

parcelRegister("dMA3M", function(module, exports) {
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $a08bbad2eabf9353$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $bUlqC.nextTick($a08bbad2eabf9353$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $bUlqC.nextTick($a08bbad2eabf9353$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $bUlqC.nextTick($a08bbad2eabf9353$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $bUlqC.nextTick($a08bbad2eabf9353$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $a08bbad2eabf9353$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $a08bbad2eabf9353$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
module.exports = {
    destroy: $a08bbad2eabf9353$var$destroy,
    undestroy: $a08bbad2eabf9353$var$undestroy
};

});

parcelRegister("gymWQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ /*<replacement>*/ var $c0d19f59fee501bd$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $c0d19f59fee501bd$var$Duplex;

/*<replacement>*/ var $c0d19f59fee501bd$var$util = Object.create((parcelRequire("dH2Jp")));

$c0d19f59fee501bd$var$util.inherits = (parcelRequire("dlqwk"));

var $ijRUb = parcelRequire("ijRUb");

var $77F6W = parcelRequire("77F6W");
$c0d19f59fee501bd$var$util.inherits($c0d19f59fee501bd$var$Duplex, $ijRUb);
// avoid scope creep, the keys array can then be collected
var $c0d19f59fee501bd$var$keys = $c0d19f59fee501bd$var$objectKeys($77F6W.prototype);
for(var $c0d19f59fee501bd$var$v = 0; $c0d19f59fee501bd$var$v < $c0d19f59fee501bd$var$keys.length; $c0d19f59fee501bd$var$v++){
    var $c0d19f59fee501bd$var$method = $c0d19f59fee501bd$var$keys[$c0d19f59fee501bd$var$v];
    if (!$c0d19f59fee501bd$var$Duplex.prototype[$c0d19f59fee501bd$var$method]) $c0d19f59fee501bd$var$Duplex.prototype[$c0d19f59fee501bd$var$method] = $77F6W.prototype[$c0d19f59fee501bd$var$method];
}
function $c0d19f59fee501bd$var$Duplex(options) {
    if (!(this instanceof $c0d19f59fee501bd$var$Duplex)) return new $c0d19f59fee501bd$var$Duplex(options);
    $ijRUb.call(this, options);
    $77F6W.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", $c0d19f59fee501bd$var$onend);
}
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $c0d19f59fee501bd$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $bUlqC.nextTick($c0d19f59fee501bd$var$onEndNT, this);
}
function $c0d19f59fee501bd$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($c0d19f59fee501bd$var$Duplex.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$c0d19f59fee501bd$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $bUlqC.nextTick(cb, err);
};

});
parcelRegister("77F6W", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $52f9139fc7db56d4$var$Writable;
/* <replacement> */ function $52f9139fc7db56d4$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $52f9139fc7db56d4$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $52f9139fc7db56d4$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $52f9139fc7db56d4$var$asyncWrite = (0, $bUlqC.nextTick);
/*</replacement>*/ /*<replacement>*/ var $52f9139fc7db56d4$var$Duplex;
/*</replacement>*/ $52f9139fc7db56d4$var$Writable.WritableState = $52f9139fc7db56d4$var$WritableState;

/*<replacement>*/ var $52f9139fc7db56d4$var$util = Object.create((parcelRequire("dH2Jp")));

$52f9139fc7db56d4$var$util.inherits = (parcelRequire("dlqwk"));

/*</replacement>*/ /*<replacement>*/ var $52f9139fc7db56d4$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $7TavY = parcelRequire("7TavY");

var $io3aA = parcelRequire("io3aA");
var $52f9139fc7db56d4$require$Buffer = $io3aA.Buffer;
var $52f9139fc7db56d4$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $52f9139fc7db56d4$var$_uint8ArrayToBuffer(chunk) {
    return $52f9139fc7db56d4$require$Buffer.from(chunk);
}
function $52f9139fc7db56d4$var$_isUint8Array(obj) {
    return $52f9139fc7db56d4$require$Buffer.isBuffer(obj) || obj instanceof $52f9139fc7db56d4$var$OurUint8Array;
}

var $dMA3M = parcelRequire("dMA3M");
$52f9139fc7db56d4$var$util.inherits($52f9139fc7db56d4$var$Writable, $7TavY);
function $52f9139fc7db56d4$var$nop() {}

function $52f9139fc7db56d4$var$WritableState(options, stream) {
    $52f9139fc7db56d4$var$Duplex = $52f9139fc7db56d4$var$Duplex || (parcelRequire("gymWQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $52f9139fc7db56d4$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $52f9139fc7db56d4$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $52f9139fc7db56d4$var$CorkedRequest(this);
}
$52f9139fc7db56d4$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($52f9139fc7db56d4$var$WritableState.prototype, "buffer", {
            get: $52f9139fc7db56d4$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $52f9139fc7db56d4$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $52f9139fc7db56d4$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($52f9139fc7db56d4$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($52f9139fc7db56d4$var$realHasInstance.call(this, object)) return true;
            if (this !== $52f9139fc7db56d4$var$Writable) return false;
            return object && object._writableState instanceof $52f9139fc7db56d4$var$WritableState;
        }
    });
} else $52f9139fc7db56d4$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $52f9139fc7db56d4$var$Writable(options) {
    $52f9139fc7db56d4$var$Duplex = $52f9139fc7db56d4$var$Duplex || (parcelRequire("gymWQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$52f9139fc7db56d4$var$realHasInstance.call($52f9139fc7db56d4$var$Writable, this) && !(this instanceof $52f9139fc7db56d4$var$Duplex)) return new $52f9139fc7db56d4$var$Writable(options);
    this._writableState = new $52f9139fc7db56d4$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $7TavY.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$52f9139fc7db56d4$var$Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function $52f9139fc7db56d4$var$writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    $bUlqC.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $52f9139fc7db56d4$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        $bUlqC.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$52f9139fc7db56d4$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $52f9139fc7db56d4$var$_isUint8Array(chunk);
    if (isBuf && !$52f9139fc7db56d4$require$Buffer.isBuffer(chunk)) chunk = $52f9139fc7db56d4$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $52f9139fc7db56d4$var$nop;
    if (state.ended) $52f9139fc7db56d4$var$writeAfterEnd(this, cb);
    else if (isBuf || $52f9139fc7db56d4$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $52f9139fc7db56d4$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$52f9139fc7db56d4$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$52f9139fc7db56d4$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $52f9139fc7db56d4$var$clearBuffer(this, state);
    }
};
$52f9139fc7db56d4$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $52f9139fc7db56d4$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $52f9139fc7db56d4$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $52f9139fc7db56d4$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $52f9139fc7db56d4$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $52f9139fc7db56d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $52f9139fc7db56d4$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $52f9139fc7db56d4$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $bUlqC.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $bUlqC.nextTick($52f9139fc7db56d4$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
        // this can emit finish, but finish must
        // always follow error
        $52f9139fc7db56d4$var$finishMaybe(stream, state);
    }
}
function $52f9139fc7db56d4$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $52f9139fc7db56d4$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $52f9139fc7db56d4$var$onwriteStateUpdate(state);
    if (er) $52f9139fc7db56d4$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $52f9139fc7db56d4$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $52f9139fc7db56d4$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $52f9139fc7db56d4$var$asyncWrite($52f9139fc7db56d4$var$afterWrite, stream, state, finished, cb);
        else $52f9139fc7db56d4$var$afterWrite(stream, state, finished, cb);
    }
}
function $52f9139fc7db56d4$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $52f9139fc7db56d4$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $52f9139fc7db56d4$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $52f9139fc7db56d4$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $52f9139fc7db56d4$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $52f9139fc7db56d4$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $52f9139fc7db56d4$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $52f9139fc7db56d4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$52f9139fc7db56d4$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("_write() is not implemented"));
};
$52f9139fc7db56d4$var$Writable.prototype._writev = null;
$52f9139fc7db56d4$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $52f9139fc7db56d4$var$endWritable(this, state, cb);
};
function $52f9139fc7db56d4$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $52f9139fc7db56d4$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit("error", err);
        state.prefinished = true;
        stream.emit("prefinish");
        $52f9139fc7db56d4$var$finishMaybe(stream, state);
    });
}
function $52f9139fc7db56d4$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function") {
            state.pendingcb++;
            state.finalCalled = true;
            $bUlqC.nextTick($52f9139fc7db56d4$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $52f9139fc7db56d4$var$finishMaybe(stream, state) {
    var need = $52f9139fc7db56d4$var$needFinish(state);
    if (need) {
        $52f9139fc7db56d4$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
        }
    }
    return need;
}
function $52f9139fc7db56d4$var$endWritable(stream, state, cb) {
    state.ending = true;
    $52f9139fc7db56d4$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $bUlqC.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $52f9139fc7db56d4$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($52f9139fc7db56d4$var$Writable.prototype, "destroyed", {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$52f9139fc7db56d4$var$Writable.prototype.destroy = $dMA3M.destroy;
$52f9139fc7db56d4$var$Writable.prototype._undestroy = $dMA3M.undestroy;
$52f9139fc7db56d4$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("gxvFQ", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $c0a84c3476faf17a$export$63a7aa211a91ed69, (v) => $c0a84c3476faf17a$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $c0a84c3476faf17a$export$63a7aa211a91ed69;
"use strict";

var $6azWm = parcelRequire("6azWm");
var $c0a84c3476faf17a$require$Buffer = $6azWm.Buffer;
/*</replacement>*/ var $c0a84c3476faf17a$var$isEncoding = $c0a84c3476faf17a$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $c0a84c3476faf17a$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $c0a84c3476faf17a$var$normalizeEncoding(enc) {
    var nenc = $c0a84c3476faf17a$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($c0a84c3476faf17a$require$Buffer.isEncoding === $c0a84c3476faf17a$var$isEncoding || !$c0a84c3476faf17a$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$c0a84c3476faf17a$export$63a7aa211a91ed69 = $c0a84c3476faf17a$var$StringDecoder;
function $c0a84c3476faf17a$var$StringDecoder(encoding) {
    this.encoding = $c0a84c3476faf17a$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $c0a84c3476faf17a$var$utf16Text;
            this.end = $c0a84c3476faf17a$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $c0a84c3476faf17a$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $c0a84c3476faf17a$var$base64Text;
            this.end = $c0a84c3476faf17a$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $c0a84c3476faf17a$var$simpleWrite;
            this.end = $c0a84c3476faf17a$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $c0a84c3476faf17a$require$Buffer.allocUnsafe(nb);
}
$c0a84c3476faf17a$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$c0a84c3476faf17a$var$StringDecoder.prototype.end = $c0a84c3476faf17a$var$utf8End;
// Returns only complete characters in a Buffer
$c0a84c3476faf17a$var$StringDecoder.prototype.text = $c0a84c3476faf17a$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$c0a84c3476faf17a$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $c0a84c3476faf17a$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $c0a84c3476faf17a$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $c0a84c3476faf17a$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $c0a84c3476faf17a$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $c0a84c3476faf17a$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $c0a84c3476faf17a$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $c0a84c3476faf17a$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $c0a84c3476faf17a$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $c0a84c3476faf17a$var$utf8Text(buf, i) {
    var total = $c0a84c3476faf17a$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $c0a84c3476faf17a$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $c0a84c3476faf17a$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $c0a84c3476faf17a$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $c0a84c3476faf17a$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $c0a84c3476faf17a$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $c0a84c3476faf17a$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $c0a84c3476faf17a$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("6azWm", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $47df8e41f5d0e687$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $47df8e41f5d0e687$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($47df8e41f5d0e687$var$Buffer.from && $47df8e41f5d0e687$var$Buffer.alloc && $47df8e41f5d0e687$var$Buffer.allocUnsafe && $47df8e41f5d0e687$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $47df8e41f5d0e687$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $47df8e41f5d0e687$var$SafeBuffer;
}
function $47df8e41f5d0e687$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $47df8e41f5d0e687$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$47df8e41f5d0e687$var$copyProps($47df8e41f5d0e687$var$Buffer, $47df8e41f5d0e687$var$SafeBuffer);
$47df8e41f5d0e687$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $47df8e41f5d0e687$var$Buffer(arg, encodingOrOffset, length);
};
$47df8e41f5d0e687$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $47df8e41f5d0e687$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$47df8e41f5d0e687$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $47df8e41f5d0e687$var$Buffer(size);
};
$47df8e41f5d0e687$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});



parcelRegister("8hRuT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $608968b8987d674a$var$Transform;

var $gymWQ = parcelRequire("gymWQ");

/*<replacement>*/ var $608968b8987d674a$var$util = Object.create((parcelRequire("dH2Jp")));

$608968b8987d674a$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $608968b8987d674a$var$util.inherits($608968b8987d674a$var$Transform, $gymWQ);
function $608968b8987d674a$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit("error", new Error("write callback called multiple times"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $608968b8987d674a$var$Transform(options) {
    if (!(this instanceof $608968b8987d674a$var$Transform)) return new $608968b8987d674a$var$Transform(options);
    $gymWQ.call(this, options);
    this._transformState = {
        afterTransform: $608968b8987d674a$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $608968b8987d674a$var$prefinish);
}
function $608968b8987d674a$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function") this._flush(function(er, data) {
        $608968b8987d674a$var$done(_this, er, data);
    });
    else $608968b8987d674a$var$done(this, null, null);
}
$608968b8987d674a$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $gymWQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$608968b8987d674a$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("_transform() is not implemented");
};
$608968b8987d674a$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$608968b8987d674a$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$608968b8987d674a$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $gymWQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit("close");
    });
};
function $608968b8987d674a$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (stream._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}

});

parcelRegister("fbZXo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $b0f7f16f37d01e98$var$PassThrough;

var $8hRuT = parcelRequire("8hRuT");

/*<replacement>*/ var $b0f7f16f37d01e98$var$util = Object.create((parcelRequire("dH2Jp")));

$b0f7f16f37d01e98$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $b0f7f16f37d01e98$var$util.inherits($b0f7f16f37d01e98$var$PassThrough, $8hRuT);
function $b0f7f16f37d01e98$var$PassThrough(options) {
    if (!(this instanceof $b0f7f16f37d01e98$var$PassThrough)) return new $b0f7f16f37d01e98$var$PassThrough(options);
    $8hRuT.call(this, options);
}
$b0f7f16f37d01e98$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("6E9kG", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $aYksR[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $4d6db7c28d99f640$var$sign;
module.exports.getKey = $4d6db7c28d99f640$var$getKey;
module.exports.makeKey = $4d6db7c28d99f640$var$makeKey;

});
parcelRegister("3Sg1O", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d22d91c93a13ae5$require$Buffer = $6ZWSX.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, "be", len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});

parcelRegister("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});
parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.5","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRegister("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $jX0xT(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $jX0xT(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("i46nc", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});



parcelRegister("aNeDF", function(module, exports) {
"use strict";

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher["final"]());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fC6a8.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fC6a8.EncryptedPrivateKey.decode(data, "der");
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fC6a8.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fC6a8.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fC6a8.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fC6a8.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fC6a8.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
module.exports = $7db9d5f82e4113aa$var$parseKeys;

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
"use strict";

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("modulus")["int"](), this.key("publicExponent")["int"](), this.key("privateExponent")["int"](), this.key("prime1")["int"](), this.key("prime2")["int"](), this.key("exponent1")["int"](), this.key("exponent2")["int"](), this.key("coefficient")["int"]());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus")["int"](), this.key("publicExponent")["int"]());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"]()).optional());
});
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version")["int"](), this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters")["int"]())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"](), this.key("pub_key")["int"](), this.key("priv_key")["int"]());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define("DSAparam", function() {
    this["int"]();
});
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define("signature", function() {
    this.seq().obj(this.key("r")["int"](), this.key("s")["int"]());
});

});
parcelRegister("10gXo", function(module, exports) {
var $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {

var $10gXo = parcelRequire("10gXo");

var $dlqwk = parcelRequire("dlqwk");
var $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("aeJDW")).runInThisContext("(function " + this.name + "(entity) {\n" + "  this._initNamed(entity);\n" + "})");
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dlqwk(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($10gXo.decoders[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($10gXo.encoders[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("aeJDW", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, "_", {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    "Array",
    "Boolean",
    "Date",
    "Error",
    "EvalError",
    "Function",
    "Infinity",
    "JSON",
    "Math",
    "NaN",
    "Number",
    "Object",
    "RangeError",
    "ReferenceError",
    "RegExp",
    "String",
    "SyntaxError",
    "TypeError",
    "URIError",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "undefined",
    "unescape"
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement("iframe");
    if (!iframe.style) iframe.style = {};
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, "null");
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === "object") forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("5JhaY", function(module, exports) {
var $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;

var $dlqwk = parcelRequire("dlqwk");

var $5JhaY = parcelRequire("5JhaY");
var $2397844df508f52e$require$Reporter = $5JhaY.Reporter;

var $6ZWSX = parcelRequire("6ZWSX");
var $2397844df508f52e$require$Buffer = $6ZWSX.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $2397844df508f52e$var$EncoderBuffer)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $2397844df508f52e$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("h4y6g", function(module, exports) {

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$Reporter = $5JhaY.Reporter;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$EncoderBuffer = $5JhaY.EncoderBuffer;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$DecoderBuffer = $5JhaY.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
var $c6dd42f3395d566f$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
var $c6dd42f3395d566f$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
var $c6dd42f3395d566f$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6dd42f3395d566f$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
var $c6dd42f3395d566f$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, "Root node can have only one child");
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    var state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $koC21(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state["default"];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            var data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $koC21(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("3TcQc", function(module, exports) {
var $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});
parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;

var $3TcQc = parcelRequire("3TcQc");
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$138ac3909863432c$export$f18596ef8d632e49 = $3TcQc._reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$138ac3909863432c$export$f17df38a421ab9e3 = $3TcQc._reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("89TTw", function(module, exports) {
var $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $10gXo = parcelRequire("10gXo");
var $b28be291c8d179e1$var$base = $10gXo.base;
var $b28be291c8d179e1$var$bignum = $10gXo.bignum;
// Import DER constants
var $b28be291c8d179e1$var$der = $10gXo.constants.der;
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $b28be291c8d179e1$var$base.DecoderBuffer)) data = new $b28be291c8d179e1$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $b28be291c8d179e1$var$base.Node.call(this, "der", parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $b28be291c8d179e1$var$base.Node);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        var str = "";
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        var numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        var printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === "gentime") {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $b28be291c8d179e1$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $b28be291c8d179e1$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $b28be291c8d179e1$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $6ef8062b6cdbe0f4$require$Buffer = $6ZWSX.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = "pem";
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    var base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, "");
    var input = new $6ef8062b6cdbe0f4$require$Buffer(base64, "base64");
    return $fkoHA.prototype.decode.call(this, input, options);
};

});


parcelRegister("ljw8S", function(module, exports) {
var $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $1ae2666fc718ae87$require$Buffer = $6ZWSX.Buffer;

var $10gXo = parcelRequire("10gXo");
var $1ae2666fc718ae87$var$base = $10gXo.base;
// Import DER constants
var $1ae2666fc718ae87$var$der = $10gXo.constants.der;
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $1ae2666fc718ae87$var$base.Node.call(this, "der", parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $1ae2666fc718ae87$var$base.Node);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $1ae2666fc718ae87$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $1ae2666fc718ae87$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        var buf = new $1ae2666fc718ae87$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $1ae2666fc718ae87$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === "gentime") str = [
        $1ae2666fc718ae87$var$two(date.getFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $1ae2666fc718ae87$var$two(date.getFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $1ae2666fc718ae87$require$Buffer(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $1ae2666fc718ae87$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $1ae2666fc718ae87$require$Buffer(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state["default"] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1ae2666fc718ae87$var$der.tagByName.hasOwnProperty(tag)) res = $1ae2666fc718ae87$var$der.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1ae2666fc718ae87$var$der.tagClassByName[cls || "universal"] << 6;
    return res;
}

});

parcelRegister("bPffB", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = "pem";
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $2j6ve.prototype.encode.call(this, data);
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});



parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define("RelativeDistinguishedName", function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define("RDNSequence", function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define("Name", function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($877bcccea3fc6be5$var$Time), this.key("notAfter").use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0)["int"]().optional(), this.key("serialNumber")["int"](), this.key("signature").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("issuer").use($877bcccea3fc6be5$var$Name), this.key("validity").use($877bcccea3fc6be5$var$Validity), this.key("subject").use($877bcccea3fc6be5$var$Name), this.key("subjectPublicKeyInfo").use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($877bcccea3fc6be5$var$TBSCertificate), this.key("signatureAlgorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});


parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("3ILSx", function(module, exports) {
"use strict";
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], "hex");
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher["final"]());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("aYksR", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRegister("fQdau", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

var $aYksR = parcelRequire("aYksR");
function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $aYksR[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
module.exports = $b885ed4272d45f84$var$verify;

});


parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("fMM6j", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $b7e0a6843ffae451$export$512823e338ddb1b7, (v) => $b7e0a6843ffae451$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $b7e0a6843ffae451$export$7efb24e2fddf99b9, (v) => $b7e0a6843ffae451$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3, (v) => $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $b7e0a6843ffae451$export$b9d55ff329113abd, (v) => $b7e0a6843ffae451$export$b9d55ff329113abd = v);
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7("sha1").update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7("sha1").update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("c34vB", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $8c5943302864e9a5$export$bb1abf2ce84fc7e8, (v) => $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $8c5943302864e9a5$export$2f7171e78e524d5e, (v) => $8c5943302864e9a5$export$2f7171e78e524d5e = v);
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}

});




parcelRegister("ilwRK", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = void 0;

var $5hxSG = parcelRequire("5hxSG");

var $hHp9H = parcelRequire("hHp9H");

var $81ULr = parcelRequire("81ULr");

var $BbyF4 = parcelRequire("BbyF4");
const META_SUPPORT_DATA = [
    "/properties"
];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends $5hxSG.default {
    _addVocabularies() {
        super._addVocabularies();
        $hHp9H.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword($81ULr.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        const metaSchema = this.opts.$data ? this.$dataMetaSchema($BbyF4, META_SUPPORT_DATA) : $BbyF4;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
module.exports = exports = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;

var $9hgV1 = parcelRequire("9hgV1");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $9hgV1.KeywordCxt;
    }
});

var $l2ufW = parcelRequire("l2ufW");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $l2ufW._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $l2ufW.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $l2ufW.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $l2ufW.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $l2ufW.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $l2ufW.CodeGen;
    }
});

var $2gvZO = parcelRequire("2gvZO");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return $2gvZO.default;
    }
});

var $euTEo = parcelRequire("euTEo");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return $euTEo.default;
    }
});

});
parcelRegister("5hxSG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $9hgV1 = parcelRequire("9hgV1");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $9hgV1.KeywordCxt;
    }
});

var $l2ufW = parcelRequire("l2ufW");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $l2ufW._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $l2ufW.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $l2ufW.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $l2ufW.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $l2ufW.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $l2ufW.CodeGen;
    }
});

var $2gvZO = parcelRequire("2gvZO");

var $euTEo = parcelRequire("euTEo");

var $1sl6b = parcelRequire("1sl6b");

var $jstQR = parcelRequire("jstQR");

var $l2ufW = parcelRequire("l2ufW");

var $9ZpNV = parcelRequire("9ZpNV");

var $46MS3 = parcelRequire("46MS3");

var $7eX5i = parcelRequire("7eX5i");

var $83wzf = parcelRequire("83wzf");

var $FaKkF = parcelRequire("FaKkF");
const $3d88d258a9865bba$var$defaultRegExp = (str, flags)=>new RegExp(str, flags);
$3d88d258a9865bba$var$defaultRegExp.code = "new RegExp";
const $3d88d258a9865bba$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const $3d88d258a9865bba$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const $3d88d258a9865bba$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const $3d88d258a9865bba$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const $3d88d258a9865bba$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $3d88d258a9865bba$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $3d88d258a9865bba$var$defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $FaKkF.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize: optimize,
            regExp: regExp
        } : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $3d88d258a9865bba$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $3d88d258a9865bba$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class $3d88d258a9865bba$var$Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...$3d88d258a9865bba$var$requiredOptions(opts)
        };
        const { es5: es5, lines: lines } = this.opts.code;
        this.scope = new $l2ufW.ValueScope({
            scope: {},
            prefixes: $3d88d258a9865bba$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $3d88d258a9865bba$var$getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $1sl6b.getRules)();
        $3d88d258a9865bba$var$checkOptions.call(this, $3d88d258a9865bba$var$removedOptions, opts, "NOT SUPPORTED");
        $3d88d258a9865bba$var$checkOptions.call(this, $3d88d258a9865bba$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $3d88d258a9865bba$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $3d88d258a9865bba$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $3d88d258a9865bba$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $3d88d258a9865bba$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data: $data, meta: meta, schemaId: schemaId } = this.opts;
        let _dataRefSchema = $83wzf;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$83wzf
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta: meta, schemaId: schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema: loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref: $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof $euTEo.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef: missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId: schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, $9ZpNV.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = $3d88d258a9865bba$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId: schemaId } = this.opts;
            const root = new $jstQR.SchemaEnv({
                schema: {},
                schemaId: schemaId
            });
            sch = $jstQR.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = $3d88d258a9865bba$var$getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, $9ZpNV.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        $3d88d258a9865bba$var$checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, $7eX5i.eachItem)(keyword, (kwd)=>$3d88d258a9865bba$var$addRule.call(this, kwd));
            return this;
        }
        $3d88d258a9865bba$var$keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, $46MS3.getJSONTypes)(def.type),
            schemaType: (0, $46MS3.getJSONTypes)(def.schemaType)
        };
        (0, $7eX5i.eachItem)(keyword, definition.type.length === 0 ? (k)=>$3d88d258a9865bba$var$addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>$3d88d258a9865bba$var$addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES: RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator: separator = ", ", dataVar: dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data: $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = $3d88d258a9865bba$var$schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId: schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, $9ZpNV.normalizeId)(id || baseId);
        const localRefs = $9ZpNV.getSchemaRefs.call(this, schema, baseId);
        sch = new $jstQR.SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            meta: meta,
            baseId: baseId,
            localRefs: localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else $jstQR.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            $jstQR.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
module.exports.default = $3d88d258a9865bba$var$Ajv;
$3d88d258a9865bba$var$Ajv.ValidationError = $2gvZO.default;
$3d88d258a9865bba$var$Ajv.MissingRefError = $euTEo.default;
function $3d88d258a9865bba$var$checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function $3d88d258a9865bba$var$getSchEnv(keyRef) {
    keyRef = (0, $9ZpNV.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $3d88d258a9865bba$var$addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $3d88d258a9865bba$var$addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $3d88d258a9865bba$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $3d88d258a9865bba$var$getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of $3d88d258a9865bba$var$META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const $3d88d258a9865bba$var$noLogs = {
    log () {},
    warn () {},
    error () {}
};
function $3d88d258a9865bba$var$getLogger(logger) {
    if (logger === false) return $3d88d258a9865bba$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const $3d88d258a9865bba$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $3d88d258a9865bba$var$checkKeyword(keyword, def) {
    const { RULES: RULES } = this;
    (0, $7eX5i.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!$3d88d258a9865bba$var$KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $3d88d258a9865bba$var$addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword: keyword,
        definition: {
            ...definition,
            type: (0, $46MS3.getJSONTypes)(definition.type),
            schemaType: (0, $46MS3.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) $3d88d258a9865bba$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function $3d88d258a9865bba$var$addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function $3d88d258a9865bba$var$keywordMetaschema(def) {
    let { metaSchema: metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $3d88d258a9865bba$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $3d88d258a9865bba$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $3d88d258a9865bba$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $3d88d258a9865bba$var$$dataRef
        ]
    };
}

});
parcelRegister("9hgV1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.KeywordCxt = module.exports.validateFunctionCode = void 0;

var $75Cyv = parcelRequire("75Cyv");

var $46MS3 = parcelRequire("46MS3");

var $9KPK3 = parcelRequire("9KPK3");

var $46MS3 = parcelRequire("46MS3");

var $9OJAU = parcelRequire("9OJAU");

var $dTewx = parcelRequire("dTewx");

var $5eunN = parcelRequire("5eunN");

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");

var $9ZpNV = parcelRequire("9ZpNV");

var $7eX5i = parcelRequire("7eX5i");

var $hYgW9 = parcelRequire("hYgW9");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $6c12d34a75202c62$var$validateFunctionCode(it) {
    if ($6c12d34a75202c62$var$isSchemaObj(it)) {
        $6c12d34a75202c62$var$checkKeywords(it);
        if ($6c12d34a75202c62$var$schemaCxtHasRules(it)) {
            $6c12d34a75202c62$var$topSchemaObjCode(it);
            return;
        }
    }
    $6c12d34a75202c62$var$validateFunction(it, ()=>(0, $75Cyv.topBoolOrEmptySchema)(it));
}
module.exports.validateFunctionCode = $6c12d34a75202c62$var$validateFunctionCode;
function $6c12d34a75202c62$var$validateFunction({ gen: gen, validateName: validateName, schema: schema, schemaEnv: schemaEnv, opts: opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, $l2ufW._)`${$dOpvc.default.data}, ${$dOpvc.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, $l2ufW._)`"use strict"; ${$6c12d34a75202c62$var$funcSourceUrl(schema, opts)}`);
        $6c12d34a75202c62$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $l2ufW._)`${$dOpvc.default.data}, ${$6c12d34a75202c62$var$destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code($6c12d34a75202c62$var$funcSourceUrl(schema, opts)).code(body));
}
function $6c12d34a75202c62$var$destructureValCxt(opts) {
    return (0, $l2ufW._)`{${$dOpvc.default.instancePath}="", ${$dOpvc.default.parentData}, ${$dOpvc.default.parentDataProperty}, ${$dOpvc.default.rootData}=${$dOpvc.default.data}${opts.dynamicRef ? (0, $l2ufW._)`, ${$dOpvc.default.dynamicAnchors}={}` : $l2ufW.nil}}={}`;
}
function $6c12d34a75202c62$var$destructureValCxtES5(gen, opts) {
    gen.if($dOpvc.default.valCxt, ()=>{
        gen.var($dOpvc.default.instancePath, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.instancePath}`);
        gen.var($dOpvc.default.parentData, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.parentData}`);
        gen.var($dOpvc.default.parentDataProperty, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.parentDataProperty}`);
        gen.var($dOpvc.default.rootData, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.rootData}`);
        if (opts.dynamicRef) gen.var($dOpvc.default.dynamicAnchors, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.dynamicAnchors}`);
    }, ()=>{
        gen.var($dOpvc.default.instancePath, (0, $l2ufW._)`""`);
        gen.var($dOpvc.default.parentData, (0, $l2ufW._)`undefined`);
        gen.var($dOpvc.default.parentDataProperty, (0, $l2ufW._)`undefined`);
        gen.var($dOpvc.default.rootData, $dOpvc.default.data);
        if (opts.dynamicRef) gen.var($dOpvc.default.dynamicAnchors, (0, $l2ufW._)`{}`);
    });
}
function $6c12d34a75202c62$var$topSchemaObjCode(it) {
    const { schema: schema, opts: opts, gen: gen } = it;
    $6c12d34a75202c62$var$validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) $6c12d34a75202c62$var$commentKeyword(it);
        $6c12d34a75202c62$var$checkNoDefault(it);
        gen.let($dOpvc.default.vErrors, null);
        gen.let($dOpvc.default.errors, 0);
        if (opts.unevaluated) $6c12d34a75202c62$var$resetEvaluated(it);
        $6c12d34a75202c62$var$typeAndKeywords(it);
        $6c12d34a75202c62$var$returnResults(it);
    });
    return;
}
function $6c12d34a75202c62$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen: gen, validateName: validateName } = it;
    it.evaluated = gen.const("evaluated", (0, $l2ufW._)`${validateName}.evaluated`);
    gen.if((0, $l2ufW._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, $l2ufW._)`${it.evaluated}.props`, (0, $l2ufW._)`undefined`));
    gen.if((0, $l2ufW._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, $l2ufW._)`${it.evaluated}.items`, (0, $l2ufW._)`undefined`));
}
function $6c12d34a75202c62$var$funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $l2ufW._)`/*# sourceURL=${schId} */` : $l2ufW.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $6c12d34a75202c62$var$subschemaCode(it, valid) {
    if ($6c12d34a75202c62$var$isSchemaObj(it)) {
        $6c12d34a75202c62$var$checkKeywords(it);
        if ($6c12d34a75202c62$var$schemaCxtHasRules(it)) {
            $6c12d34a75202c62$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $75Cyv.boolOrEmptySchema)(it, valid);
}
function $6c12d34a75202c62$var$schemaCxtHasRules({ schema: schema, self: self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $6c12d34a75202c62$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $6c12d34a75202c62$var$subSchemaObjCode(it, valid) {
    const { schema: schema, gen: gen, opts: opts } = it;
    if (opts.$comment && schema.$comment) $6c12d34a75202c62$var$commentKeyword(it);
    $6c12d34a75202c62$var$updateContext(it);
    $6c12d34a75202c62$var$checkAsyncSchema(it);
    const errsCount = gen.const("_errs", $dOpvc.default.errors);
    $6c12d34a75202c62$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $l2ufW._)`${errsCount} === ${$dOpvc.default.errors}`);
}
function $6c12d34a75202c62$var$checkKeywords(it) {
    (0, $7eX5i.checkUnknownRules)(it);
    $6c12d34a75202c62$var$checkRefsAndKeywords(it);
}
function $6c12d34a75202c62$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $6c12d34a75202c62$var$schemaKeywords(it, [], false, errsCount);
    const types = (0, $46MS3.getSchemaTypes)(it.schema);
    const checkedTypes = (0, $46MS3.coerceAndCheckDataType)(it, types);
    $6c12d34a75202c62$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $6c12d34a75202c62$var$checkRefsAndKeywords(it) {
    const { schema: schema, errSchemaPath: errSchemaPath, opts: opts, self: self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $7eX5i.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function $6c12d34a75202c62$var$checkNoDefault(it) {
    const { schema: schema, opts: opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $7eX5i.checkStrictMode)(it, "default is ignored in the schema root");
}
function $6c12d34a75202c62$var$updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $9ZpNV.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $6c12d34a75202c62$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $6c12d34a75202c62$var$commentKeyword({ gen: gen, schemaEnv: schemaEnv, schema: schema, errSchemaPath: errSchemaPath, opts: opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $l2ufW._)`${$dOpvc.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, $l2ufW.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $l2ufW._)`${$dOpvc.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function $6c12d34a75202c62$var$returnResults(it) {
    const { gen: gen, schemaEnv: schemaEnv, validateName: validateName, ValidationError: ValidationError, opts: opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $l2ufW._)`${$dOpvc.default.errors} === 0`, ()=>gen.return($dOpvc.default.data), ()=>gen.throw((0, $l2ufW._)`new ${ValidationError}(${$dOpvc.default.vErrors})`));
    else {
        gen.assign((0, $l2ufW._)`${validateName}.errors`, $dOpvc.default.vErrors);
        if (opts.unevaluated) $6c12d34a75202c62$var$assignEvaluated(it);
        gen.return((0, $l2ufW._)`${$dOpvc.default.errors} === 0`);
    }
}
function $6c12d34a75202c62$var$assignEvaluated({ gen: gen, evaluated: evaluated, props: props, items: items }) {
    if (props instanceof $l2ufW.Name) gen.assign((0, $l2ufW._)`${evaluated}.props`, props);
    if (items instanceof $l2ufW.Name) gen.assign((0, $l2ufW._)`${evaluated}.items`, items);
}
function $6c12d34a75202c62$var$schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen: gen, schema: schema, data: data, allErrors: allErrors, opts: opts, self: self } = it;
    const { RULES: RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $7eX5i.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>$6c12d34a75202c62$var$keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) $6c12d34a75202c62$var$checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, $9KPK3.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $46MS3.checkDataType)(group.type, data, opts.strictNumbers));
            $6c12d34a75202c62$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $46MS3.reportTypeError)(it);
            }
            gen.endIf();
        } else $6c12d34a75202c62$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $l2ufW._)`${$dOpvc.default.errors} === ${errsCount || 0}`);
    }
}
function $6c12d34a75202c62$var$iterateKeywords(it, group) {
    const { gen: gen, schema: schema, opts: { useDefaults: useDefaults } } = it;
    if (useDefaults) (0, $9OJAU.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, $9KPK3.shouldUseRule)(schema, rule)) $6c12d34a75202c62$var$keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function $6c12d34a75202c62$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $6c12d34a75202c62$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $6c12d34a75202c62$var$checkMultipleTypes(it, types);
    $6c12d34a75202c62$var$checkKeywordTypes(it, it.dataTypes);
}
function $6c12d34a75202c62$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!$6c12d34a75202c62$var$includesType(it.dataTypes, t)) $6c12d34a75202c62$var$strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    it.dataTypes = it.dataTypes.filter((t)=>$6c12d34a75202c62$var$includesType(types, t));
}
function $6c12d34a75202c62$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $6c12d34a75202c62$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $6c12d34a75202c62$var$checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, $9KPK3.shouldUseRule)(it.schema, rule)) {
            const { type: type } = rule.definition;
            if (type.length && !type.some((t)=>$6c12d34a75202c62$var$hasApplicableType(ts, t))) $6c12d34a75202c62$var$strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function $6c12d34a75202c62$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $6c12d34a75202c62$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $6c12d34a75202c62$var$strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, $7eX5i.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class $6c12d34a75202c62$var$KeywordCxt {
    constructor(it, def, keyword){
        (0, $dTewx.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $7eX5i.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $6c12d34a75202c62$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $dTewx.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $dOpvc.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, $l2ufW.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, $l2ufW.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode: schemaCode } = this;
        this.fail((0, $l2ufW._)`${schemaCode} !== undefined && (${(0, $l2ufW.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? $hYgW9.reportExtraError : $hYgW9.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, $hYgW9.reportError)(this, this.def.$dataError || $hYgW9.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, $hYgW9.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = $l2ufW.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = $l2ufW.nil, $dataValid = $l2ufW.nil) {
        if (!this.$data) return;
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def } = this;
        gen.if((0, $l2ufW.or)((0, $l2ufW._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== $l2ufW.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== $l2ufW.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def, it: it } = this;
        return (0, $l2ufW.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof $l2ufW.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, $l2ufW._)`${(0, $46MS3.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $46MS3.DataType.Wrong)}`;
            }
            return $l2ufW.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, $l2ufW._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return $l2ufW.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, $5eunN.getSubschema)(this.it, appl);
        (0, $5eunN.extendSubschemaData)(subschema, this.it, appl);
        (0, $5eunN.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        $6c12d34a75202c62$var$subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it: it, gen: gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = $7eX5i.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = $7eX5i.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it: it, gen: gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, $l2ufW.Name));
            return true;
        }
    }
}
module.exports.KeywordCxt = $6c12d34a75202c62$var$KeywordCxt;
function $6c12d34a75202c62$var$keywordCode(it, keyword, def, ruleType) {
    const cxt = new $6c12d34a75202c62$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $dTewx.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $dTewx.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $dTewx.funcKeywordCode)(cxt, def);
}
const $6c12d34a75202c62$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const $6c12d34a75202c62$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $6c12d34a75202c62$var$getData($data, { dataLevel: dataLevel, dataNames: dataNames, dataPathArr: dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return $dOpvc.default.rootData;
    if ($data[0] === "/") {
        if (!$6c12d34a75202c62$var$JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = $dOpvc.default.rootData;
    } else {
        const matches = $6c12d34a75202c62$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)((0, $7eX5i.unescapeJsonPointer)(segment))}`;
        expr = (0, $l2ufW._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
module.exports.getData = $6c12d34a75202c62$var$getData;

});
parcelRegister("75Cyv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolOrEmptySchema = module.exports.topBoolOrEmptySchema = void 0;

var $hYgW9 = parcelRequire("hYgW9");

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");
const $5296e860644b4914$var$boolError = {
    message: "boolean schema is false"
};
function $5296e860644b4914$var$topBoolOrEmptySchema(it) {
    const { gen: gen, schema: schema, validateName: validateName } = it;
    if (schema === false) $5296e860644b4914$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($dOpvc.default.data);
    else {
        gen.assign((0, $l2ufW._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
module.exports.topBoolOrEmptySchema = $5296e860644b4914$var$topBoolOrEmptySchema;
function $5296e860644b4914$var$boolOrEmptySchema(it, valid) {
    const { gen: gen, schema: schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $5296e860644b4914$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
module.exports.boolOrEmptySchema = $5296e860644b4914$var$boolOrEmptySchema;
function $5296e860644b4914$var$falseSchemaError(it, overrideAllErrors) {
    const { gen: gen, data: data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $hYgW9.reportError)(cxt, $5296e860644b4914$var$boolError, undefined, overrideAllErrors);
}

});
parcelRegister("hYgW9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendErrors = module.exports.resetErrorsCount = module.exports.reportExtraError = module.exports.reportError = module.exports.keyword$DataError = module.exports.keywordError = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $dOpvc = parcelRequire("dOpvc");
module.exports.keywordError = {
    message: ({ keyword: keyword })=>(0, $l2ufW.str)`must pass "${keyword}" keyword validation`
};
module.exports.keyword$DataError = {
    message: ({ keyword: keyword, schemaType: schemaType })=>schemaType ? (0, $l2ufW.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, $l2ufW.str)`"${keyword}" keyword is invalid ($data)`
};
function $d1552d9220cfb4a2$var$reportError(cxt, error = module.exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $d1552d9220cfb4a2$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $d1552d9220cfb4a2$var$addError(gen, errObj);
    else $d1552d9220cfb4a2$var$returnErrors(it, (0, $l2ufW._)`[${errObj}]`);
}
module.exports.reportError = $d1552d9220cfb4a2$var$reportError;
function $d1552d9220cfb4a2$var$reportExtraError(cxt, error = module.exports.keywordError, errorPaths) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $d1552d9220cfb4a2$var$errorObjectCode(cxt, error, errorPaths);
    $d1552d9220cfb4a2$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $d1552d9220cfb4a2$var$returnErrors(it, $dOpvc.default.vErrors);
}
module.exports.reportExtraError = $d1552d9220cfb4a2$var$reportExtraError;
function $d1552d9220cfb4a2$var$resetErrorsCount(gen, errsCount) {
    gen.assign($dOpvc.default.errors, errsCount);
    gen.if((0, $l2ufW._)`${$dOpvc.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, $l2ufW._)`${$dOpvc.default.vErrors}.length`, errsCount), ()=>gen.assign($dOpvc.default.vErrors, null)));
}
module.exports.resetErrorsCount = $d1552d9220cfb4a2$var$resetErrorsCount;
function $d1552d9220cfb4a2$var$extendErrors({ gen: gen, keyword: keyword, schemaValue: schemaValue, data: data, errsCount: errsCount, it: it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, $dOpvc.default.errors, (i)=>{
        gen.const(err, (0, $l2ufW._)`${$dOpvc.default.vErrors}[${i}]`);
        gen.if((0, $l2ufW._)`${err}.instancePath === undefined`, ()=>gen.assign((0, $l2ufW._)`${err}.instancePath`, (0, $l2ufW.strConcat)($dOpvc.default.instancePath, it.errorPath)));
        gen.assign((0, $l2ufW._)`${err}.schemaPath`, (0, $l2ufW.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, $l2ufW._)`${err}.schema`, schemaValue);
            gen.assign((0, $l2ufW._)`${err}.data`, data);
        }
    });
}
module.exports.extendErrors = $d1552d9220cfb4a2$var$extendErrors;
function $d1552d9220cfb4a2$var$addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, $l2ufW._)`${$dOpvc.default.vErrors} === null`, ()=>gen.assign($dOpvc.default.vErrors, (0, $l2ufW._)`[${err}]`), (0, $l2ufW._)`${$dOpvc.default.vErrors}.push(${err})`);
    gen.code((0, $l2ufW._)`${$dOpvc.default.errors}++`);
}
function $d1552d9220cfb4a2$var$returnErrors(it, errs) {
    const { gen: gen, validateName: validateName, schemaEnv: schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, $l2ufW._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, $l2ufW._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const $d1552d9220cfb4a2$var$E = {
    keyword: new $l2ufW.Name("keyword"),
    schemaPath: new $l2ufW.Name("schemaPath"),
    params: new $l2ufW.Name("params"),
    propertyName: new $l2ufW.Name("propertyName"),
    message: new $l2ufW.Name("message"),
    schema: new $l2ufW.Name("schema"),
    parentSchema: new $l2ufW.Name("parentSchema")
};
function $d1552d9220cfb4a2$var$errorObjectCode(cxt, error, errorPaths) {
    const { createErrors: createErrors } = cxt.it;
    if (createErrors === false) return (0, $l2ufW._)`{}`;
    return $d1552d9220cfb4a2$var$errorObject(cxt, error, errorPaths);
}
function $d1552d9220cfb4a2$var$errorObject(cxt, error, errorPaths = {}) {
    const { gen: gen, it: it } = cxt;
    const keyValues = [
        $d1552d9220cfb4a2$var$errorInstancePath(it, errorPaths),
        $d1552d9220cfb4a2$var$errorSchemaPath(cxt, errorPaths)
    ];
    $d1552d9220cfb4a2$var$extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function $d1552d9220cfb4a2$var$errorInstancePath({ errorPath: errorPath }, { instancePath: instancePath }) {
    const instPath = instancePath ? (0, $l2ufW.str)`${errorPath}${(0, $7eX5i.getErrorPath)(instancePath, $7eX5i.Type.Str)}` : errorPath;
    return [
        $dOpvc.default.instancePath,
        (0, $l2ufW.strConcat)($dOpvc.default.instancePath, instPath)
    ];
}
function $d1552d9220cfb4a2$var$errorSchemaPath({ keyword: keyword, it: { errSchemaPath: errSchemaPath } }, { schemaPath: schemaPath, parentSchema: parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, $l2ufW.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, $l2ufW.str)`${schPath}${(0, $7eX5i.getErrorPath)(schemaPath, $7eX5i.Type.Str)}`;
    return [
        $d1552d9220cfb4a2$var$E.schemaPath,
        schPath
    ];
}
function $d1552d9220cfb4a2$var$extraErrorProps(cxt, { params: params, message: message }, keyValues) {
    const { keyword: keyword, data: data, schemaValue: schemaValue, it: it } = cxt;
    const { opts: opts, propertyName: propertyName, topSchemaRef: topSchemaRef, schemaPath: schemaPath } = it;
    keyValues.push([
        $d1552d9220cfb4a2$var$E.keyword,
        keyword
    ], [
        $d1552d9220cfb4a2$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $l2ufW._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        $d1552d9220cfb4a2$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $d1552d9220cfb4a2$var$E.schema,
        schemaValue
    ], [
        $d1552d9220cfb4a2$var$E.parentSchema,
        (0, $l2ufW._)`${topSchemaRef}${schemaPath}`
    ], [
        $dOpvc.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $d1552d9220cfb4a2$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRegister("l2ufW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.or = module.exports.and = module.exports.not = module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;

var $4GpWJ = parcelRequire("4GpWJ");

var $eNw2I = parcelRequire("eNw2I");

var $4GpWJ = parcelRequire("4GpWJ");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $4GpWJ._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $4GpWJ.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function() {
        return $4GpWJ.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $4GpWJ.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function() {
        return $4GpWJ.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $4GpWJ.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return $4GpWJ.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $4GpWJ.Name;
    }
});

var $eNw2I = parcelRequire("eNw2I");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $eNw2I.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return $eNw2I.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return $eNw2I.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function() {
        return $eNw2I.varKinds;
    }
});
module.exports.operators = {
    GT: new $4GpWJ._Code(">"),
    GTE: new $4GpWJ._Code(">="),
    LT: new $4GpWJ._Code("<"),
    LTE: new $4GpWJ._Code("<="),
    EQ: new $4GpWJ._Code("==="),
    NEQ: new $4GpWJ._Code("!=="),
    NOT: new $4GpWJ._Code("!"),
    OR: new $4GpWJ._Code("||"),
    AND: new $4GpWJ._Code("&&"),
    ADD: new $4GpWJ._Code("+")
};
class $f511411e7bf8f284$var$Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class $f511411e7bf8f284$var$Def extends $f511411e7bf8f284$var$Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5: es5, _n: _n }) {
        const varKind = es5 ? $eNw2I.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = $f511411e7bf8f284$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof $4GpWJ._CodeOrName ? this.rhs.names : {};
    }
}
class $f511411e7bf8f284$var$Assign extends $f511411e7bf8f284$var$Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n: _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof $4GpWJ.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = $f511411e7bf8f284$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof $4GpWJ.Name ? {} : {
            ...this.lhs.names
        };
        return $f511411e7bf8f284$var$addExprNames(names, this.rhs);
    }
}
class $f511411e7bf8f284$var$AssignOp extends $f511411e7bf8f284$var$Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n: _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class $f511411e7bf8f284$var$Label extends $f511411e7bf8f284$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        return `${this.label}:` + _n;
    }
}
class $f511411e7bf8f284$var$Break extends $f511411e7bf8f284$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class $f511411e7bf8f284$var$Throw extends $f511411e7bf8f284$var$Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n: _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class $f511411e7bf8f284$var$AnyCode extends $f511411e7bf8f284$var$Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n: _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = $f511411e7bf8f284$var$optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof $4GpWJ._CodeOrName ? this.code.names : {};
    }
}
class $f511411e7bf8f284$var$ParentNode extends $f511411e7bf8f284$var$Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            $f511411e7bf8f284$var$subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>$f511411e7bf8f284$var$addNames(names, n.names), {});
    }
}
class $f511411e7bf8f284$var$BlockNode extends $f511411e7bf8f284$var$ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class $f511411e7bf8f284$var$Root extends $f511411e7bf8f284$var$ParentNode {
}
class $f511411e7bf8f284$var$Else extends $f511411e7bf8f284$var$BlockNode {
}
$f511411e7bf8f284$var$Else.kind = "else";
class $f511411e7bf8f284$var$If extends $f511411e7bf8f284$var$BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new $f511411e7bf8f284$var$Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof $f511411e7bf8f284$var$If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new $f511411e7bf8f284$var$If($f511411e7bf8f284$var$not(cond), e instanceof $f511411e7bf8f284$var$If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = $f511411e7bf8f284$var$optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        $f511411e7bf8f284$var$addExprNames(names, this.condition);
        if (this.else) $f511411e7bf8f284$var$addNames(names, this.else.names);
        return names;
    }
}
$f511411e7bf8f284$var$If.kind = "if";
class $f511411e7bf8f284$var$For extends $f511411e7bf8f284$var$BlockNode {
}
$f511411e7bf8f284$var$For.kind = "for";
class $f511411e7bf8f284$var$ForLoop extends $f511411e7bf8f284$var$For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = $f511411e7bf8f284$var$optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return $f511411e7bf8f284$var$addNames(super.names, this.iteration.names);
    }
}
class $f511411e7bf8f284$var$ForRange extends $f511411e7bf8f284$var$For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? $eNw2I.varKinds.var : this.varKind;
        const { name: name, from: from, to: to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = $f511411e7bf8f284$var$addExprNames(super.names, this.from);
        return $f511411e7bf8f284$var$addExprNames(names, this.to);
    }
}
class $f511411e7bf8f284$var$ForIter extends $f511411e7bf8f284$var$For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = $f511411e7bf8f284$var$optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return $f511411e7bf8f284$var$addNames(super.names, this.iterable.names);
    }
}
class $f511411e7bf8f284$var$Func extends $f511411e7bf8f284$var$BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
$f511411e7bf8f284$var$Func.kind = "func";
class $f511411e7bf8f284$var$Return extends $f511411e7bf8f284$var$ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
$f511411e7bf8f284$var$Return.kind = "return";
class $f511411e7bf8f284$var$Try extends $f511411e7bf8f284$var$BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) $f511411e7bf8f284$var$addNames(names, this.catch.names);
        if (this.finally) $f511411e7bf8f284$var$addNames(names, this.finally.names);
        return names;
    }
}
class $f511411e7bf8f284$var$Catch extends $f511411e7bf8f284$var$BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
$f511411e7bf8f284$var$Catch.kind = "catch";
class $f511411e7bf8f284$var$Finally extends $f511411e7bf8f284$var$BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
$f511411e7bf8f284$var$Finally.kind = "finally";
class $f511411e7bf8f284$var$CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new $eNw2I.Scope({
            parent: extScope
        });
        this._nodes = [
            new $f511411e7bf8f284$var$Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new $f511411e7bf8f284$var$Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def($eNw2I.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def($eNw2I.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def($eNw2I.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new $f511411e7bf8f284$var$Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new $f511411e7bf8f284$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== $4GpWJ.nil) this._leafNode(new $f511411e7bf8f284$var$AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, $4GpWJ.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new $4GpWJ._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new $f511411e7bf8f284$var$If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new $f511411e7bf8f284$var$If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new $f511411e7bf8f284$var$Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode($f511411e7bf8f284$var$If, $f511411e7bf8f284$var$Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new $f511411e7bf8f284$var$ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? $eNw2I.varKinds.var : $eNw2I.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $f511411e7bf8f284$var$ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = $eNw2I.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof $4GpWJ.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, $4GpWJ._)`${arr}.length`, (i)=>{
                this.var(name, (0, $4GpWJ._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new $f511411e7bf8f284$var$ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? $eNw2I.varKinds.var : $eNw2I.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $4GpWJ._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $f511411e7bf8f284$var$ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode($f511411e7bf8f284$var$For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new $f511411e7bf8f284$var$Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new $f511411e7bf8f284$var$Break(label));
    }
    // `return` statement
    return(value) {
        const node = new $f511411e7bf8f284$var$Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode($f511411e7bf8f284$var$Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new $f511411e7bf8f284$var$Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new $f511411e7bf8f284$var$Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new $f511411e7bf8f284$var$Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode($f511411e7bf8f284$var$Catch, $f511411e7bf8f284$var$Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new $f511411e7bf8f284$var$Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = $4GpWJ.nil, async, funcBody) {
        this._blockNode(new $f511411e7bf8f284$var$Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode($f511411e7bf8f284$var$Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof $f511411e7bf8f284$var$If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
module.exports.CodeGen = $f511411e7bf8f284$var$CodeGen;
function $f511411e7bf8f284$var$addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $f511411e7bf8f284$var$addExprNames(names, from) {
    return from instanceof $4GpWJ._CodeOrName ? $f511411e7bf8f284$var$addNames(names, from.names) : names;
}
function $f511411e7bf8f284$var$optimizeExpr(expr, names, constants) {
    if (expr instanceof $4GpWJ.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $4GpWJ._Code(expr._items.reduce((items, c)=>{
        if (c instanceof $4GpWJ.Name) c = replaceName(c);
        if (c instanceof $4GpWJ._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof $4GpWJ._Code && e._items.some((c)=>c instanceof $4GpWJ.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function $f511411e7bf8f284$var$subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $f511411e7bf8f284$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $4GpWJ._)`!${$f511411e7bf8f284$var$par(x)}`;
}
module.exports.not = $f511411e7bf8f284$var$not;
const $f511411e7bf8f284$var$andCode = $f511411e7bf8f284$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $f511411e7bf8f284$var$and(...args) {
    return args.reduce($f511411e7bf8f284$var$andCode);
}
module.exports.and = $f511411e7bf8f284$var$and;
const $f511411e7bf8f284$var$orCode = $f511411e7bf8f284$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $f511411e7bf8f284$var$or(...args) {
    return args.reduce($f511411e7bf8f284$var$orCode);
}
module.exports.or = $f511411e7bf8f284$var$or;
function $f511411e7bf8f284$var$mappend(op) {
    return (x, y)=>x === $4GpWJ.nil ? y : y === $4GpWJ.nil ? x : (0, $4GpWJ._)`${$f511411e7bf8f284$var$par(x)} ${op} ${$f511411e7bf8f284$var$par(y)}`;
}
function $f511411e7bf8f284$var$par(x) {
    return x instanceof $4GpWJ.Name ? x : (0, $4GpWJ._)`(${x})`;
}

});
parcelRegister("4GpWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regexpCode = module.exports.getEsmExportName = module.exports.getProperty = module.exports.safeStringify = module.exports.stringify = module.exports.strConcat = module.exports.addCodeArg = module.exports.str = module.exports._ = module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
class $368f361121c33a9b$var$_CodeOrName {
}
module.exports._CodeOrName = $368f361121c33a9b$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class $368f361121c33a9b$var$Name extends $368f361121c33a9b$var$_CodeOrName {
    constructor(s){
        super();
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
module.exports.Name = $368f361121c33a9b$var$Name;
class $368f361121c33a9b$var$_Code extends $368f361121c33a9b$var$_CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof $368f361121c33a9b$var$Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
module.exports._Code = $368f361121c33a9b$var$_Code;
module.exports.nil = new $368f361121c33a9b$var$_Code("");
function $368f361121c33a9b$var$_(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        $368f361121c33a9b$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $368f361121c33a9b$var$_Code(code);
}
module.exports._ = $368f361121c33a9b$var$_;
const $368f361121c33a9b$var$plus = new $368f361121c33a9b$var$_Code("+");
function $368f361121c33a9b$var$str(strs, ...args) {
    const expr = [
        $368f361121c33a9b$var$safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push($368f361121c33a9b$var$plus);
        $368f361121c33a9b$var$addCodeArg(expr, args[i]);
        expr.push($368f361121c33a9b$var$plus, $368f361121c33a9b$var$safeStringify(strs[++i]));
    }
    $368f361121c33a9b$var$optimize(expr);
    return new $368f361121c33a9b$var$_Code(expr);
}
module.exports.str = $368f361121c33a9b$var$str;
function $368f361121c33a9b$var$addCodeArg(code, arg) {
    if (arg instanceof $368f361121c33a9b$var$_Code) code.push(...arg._items);
    else if (arg instanceof $368f361121c33a9b$var$Name) code.push(arg);
    else code.push($368f361121c33a9b$var$interpolate(arg));
}
module.exports.addCodeArg = $368f361121c33a9b$var$addCodeArg;
function $368f361121c33a9b$var$optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $368f361121c33a9b$var$plus) {
            const res = $368f361121c33a9b$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $368f361121c33a9b$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $368f361121c33a9b$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $368f361121c33a9b$var$Name)) return `"${a}${b.slice(1)}`;
    return;
}
function $368f361121c33a9b$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $368f361121c33a9b$var$str`${c1}${c2}`;
}
module.exports.strConcat = $368f361121c33a9b$var$strConcat;
// TODO do not allow arrays here
function $368f361121c33a9b$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $368f361121c33a9b$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $368f361121c33a9b$var$stringify(x) {
    return new $368f361121c33a9b$var$_Code($368f361121c33a9b$var$safeStringify(x));
}
module.exports.stringify = $368f361121c33a9b$var$stringify;
function $368f361121c33a9b$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
module.exports.safeStringify = $368f361121c33a9b$var$safeStringify;
function $368f361121c33a9b$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $368f361121c33a9b$var$_Code(`.${key}`) : $368f361121c33a9b$var$_`[${key}]`;
}
module.exports.getProperty = $368f361121c33a9b$var$getProperty;
//Does best effort to format the name properly
function $368f361121c33a9b$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $368f361121c33a9b$var$_Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
module.exports.getEsmExportName = $368f361121c33a9b$var$getEsmExportName;
function $368f361121c33a9b$var$regexpCode(rx) {
    return new $368f361121c33a9b$var$_Code(rx.toString());
}
module.exports.regexpCode = $368f361121c33a9b$var$regexpCode;

});

parcelRegister("eNw2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $4GpWJ = parcelRequire("4GpWJ");
class $ac5e7f513a485aeb$var$ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var $ac5e7f513a485aeb$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($ac5e7f513a485aeb$var$UsedValueState = module.exports.UsedValueState || (module.exports.UsedValueState = {}));
module.exports.varKinds = {
    const: new $4GpWJ.Name("const"),
    let: new $4GpWJ.Name("let"),
    var: new $4GpWJ.Name("var")
};
class $ac5e7f513a485aeb$var$Scope {
    constructor({ prefixes: prefixes, parent: parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof $4GpWJ.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new $4GpWJ.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix: prefix,
            index: 0
        };
    }
}
module.exports.Scope = $ac5e7f513a485aeb$var$Scope;
class $ac5e7f513a485aeb$var$ValueScopeName extends $4GpWJ.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property: property, itemIndex: itemIndex }) {
        this.value = value;
        this.scopePath = (0, $4GpWJ._)`.${new $4GpWJ.Name(property)}[${itemIndex}]`;
    }
}
module.exports.ValueScopeName = $ac5e7f513a485aeb$var$ValueScopeName;
const $ac5e7f513a485aeb$var$line = (0, $4GpWJ._)`\n`;
class $ac5e7f513a485aeb$var$ValueScope extends $ac5e7f513a485aeb$var$Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? $ac5e7f513a485aeb$var$line : $4GpWJ.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new $ac5e7f513a485aeb$var$ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix: prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex: itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, $4GpWJ._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = $4GpWJ.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, $ac5e7f513a485aeb$var$UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                    code = (0, $4GpWJ._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $4GpWJ._)`${code}${c}${this.opts._n}`;
                else throw new $ac5e7f513a485aeb$var$ValueError(name);
                nameSet.set(name, $ac5e7f513a485aeb$var$UsedValueState.Completed);
            });
        }
        return code;
    }
}
module.exports.ValueScope = $ac5e7f513a485aeb$var$ValueScope;

});


parcelRegister("7eX5i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkStrictMode = module.exports.getErrorPath = module.exports.Type = module.exports.useFunc = module.exports.setEvaluated = module.exports.evaluatedPropsToName = module.exports.mergeEvaluated = module.exports.eachItem = module.exports.unescapeJsonPointer = module.exports.escapeJsonPointer = module.exports.escapeFragment = module.exports.unescapeFragment = module.exports.schemaRefOrVal = module.exports.schemaHasRulesButRef = module.exports.schemaHasRules = module.exports.checkUnknownRules = module.exports.alwaysValidSchema = module.exports.toHash = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $4GpWJ = parcelRequire("4GpWJ");
// TODO refactor to use Set
function $5457ac2764e63104$var$toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
module.exports.toHash = $5457ac2764e63104$var$toHash;
function $5457ac2764e63104$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $5457ac2764e63104$var$checkUnknownRules(it, schema);
    return !$5457ac2764e63104$var$schemaHasRules(schema, it.self.RULES.all);
}
module.exports.alwaysValidSchema = $5457ac2764e63104$var$alwaysValidSchema;
function $5457ac2764e63104$var$checkUnknownRules(it, schema = it.schema) {
    const { opts: opts, self: self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) $5457ac2764e63104$var$checkStrictMode(it, `unknown keyword: "${key}"`);
}
module.exports.checkUnknownRules = $5457ac2764e63104$var$checkUnknownRules;
function $5457ac2764e63104$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
module.exports.schemaHasRules = $5457ac2764e63104$var$schemaHasRules;
function $5457ac2764e63104$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
module.exports.schemaHasRulesButRef = $5457ac2764e63104$var$schemaHasRulesButRef;
function $5457ac2764e63104$var$schemaRefOrVal({ topSchemaRef: topSchemaRef, schemaPath: schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $l2ufW._)`${schema}`;
    }
    return (0, $l2ufW._)`${topSchemaRef}${schemaPath}${(0, $l2ufW.getProperty)(keyword)}`;
}
module.exports.schemaRefOrVal = $5457ac2764e63104$var$schemaRefOrVal;
function $5457ac2764e63104$var$unescapeFragment(str) {
    return $5457ac2764e63104$var$unescapeJsonPointer(decodeURIComponent(str));
}
module.exports.unescapeFragment = $5457ac2764e63104$var$unescapeFragment;
function $5457ac2764e63104$var$escapeFragment(str) {
    return encodeURIComponent($5457ac2764e63104$var$escapeJsonPointer(str));
}
module.exports.escapeFragment = $5457ac2764e63104$var$escapeFragment;
function $5457ac2764e63104$var$escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
module.exports.escapeJsonPointer = $5457ac2764e63104$var$escapeJsonPointer;
function $5457ac2764e63104$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
module.exports.unescapeJsonPointer = $5457ac2764e63104$var$unescapeJsonPointer;
function $5457ac2764e63104$var$eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
module.exports.eachItem = $5457ac2764e63104$var$eachItem;
function $5457ac2764e63104$var$makeMergeEvaluated({ mergeNames: mergeNames, mergeToName: mergeToName, mergeValues: mergeValues, resultToName: resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof $l2ufW.Name ? (from instanceof $l2ufW.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $l2ufW.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $l2ufW.Name && !(res instanceof $l2ufW.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $5457ac2764e63104$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $l2ufW._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, $l2ufW._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, $l2ufW._)`${to} || {}`).code((0, $l2ufW._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, $l2ufW._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $l2ufW._)`${to} || {}`);
                    $5457ac2764e63104$var$setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: $5457ac2764e63104$var$evaluatedPropsToName
    }),
    items: $5457ac2764e63104$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $l2ufW._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, $l2ufW._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, $l2ufW._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, $l2ufW._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function $5457ac2764e63104$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, $l2ufW._)`{}`);
    if (ps !== undefined) $5457ac2764e63104$var$setEvaluated(gen, props, ps);
    return props;
}
module.exports.evaluatedPropsToName = $5457ac2764e63104$var$evaluatedPropsToName;
function $5457ac2764e63104$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, $l2ufW._)`${props}${(0, $l2ufW.getProperty)(p)}`, true));
}
module.exports.setEvaluated = $5457ac2764e63104$var$setEvaluated;
const $5457ac2764e63104$var$snippets = {};
function $5457ac2764e63104$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $5457ac2764e63104$var$snippets[f.code] || ($5457ac2764e63104$var$snippets[f.code] = new $4GpWJ._Code(f.code))
    });
}
module.exports.useFunc = $5457ac2764e63104$var$useFunc;
var $5457ac2764e63104$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($5457ac2764e63104$var$Type = module.exports.Type || (module.exports.Type = {}));
function $5457ac2764e63104$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $l2ufW.Name) {
        const isNumber = dataPropType === $5457ac2764e63104$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $l2ufW._)`"[" + ${dataProp} + "]"` : (0, $l2ufW._)`"['" + ${dataProp} + "']"` : isNumber ? (0, $l2ufW._)`"/" + ${dataProp}` : (0, $l2ufW._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $l2ufW.getProperty)(dataProp).toString() : "/" + $5457ac2764e63104$var$escapeJsonPointer(dataProp);
}
module.exports.getErrorPath = $5457ac2764e63104$var$getErrorPath;
function $5457ac2764e63104$var$checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
module.exports.checkStrictMode = $5457ac2764e63104$var$checkStrictMode;

});

parcelRegister("dOpvc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $a0e3ba1039b4828f$var$names = {
    // validation function arguments
    data: new $l2ufW.Name("data"),
    // args passed from referencing schema
    valCxt: new $l2ufW.Name("valCxt"),
    instancePath: new $l2ufW.Name("instancePath"),
    parentData: new $l2ufW.Name("parentData"),
    parentDataProperty: new $l2ufW.Name("parentDataProperty"),
    rootData: new $l2ufW.Name("rootData"),
    dynamicAnchors: new $l2ufW.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new $l2ufW.Name("vErrors"),
    errors: new $l2ufW.Name("errors"),
    this: new $l2ufW.Name("this"),
    // "globals"
    self: new $l2ufW.Name("self"),
    scope: new $l2ufW.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $l2ufW.Name("json"),
    jsonPos: new $l2ufW.Name("jsonPos"),
    jsonLen: new $l2ufW.Name("jsonLen"),
    jsonPart: new $l2ufW.Name("jsonPart")
};
module.exports.default = $a0e3ba1039b4828f$var$names;

});



parcelRegister("46MS3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportTypeError = module.exports.checkDataTypes = module.exports.checkDataType = module.exports.coerceAndCheckDataType = module.exports.getJSONTypes = module.exports.getSchemaTypes = module.exports.DataType = void 0;

var $1sl6b = parcelRequire("1sl6b");

var $9KPK3 = parcelRequire("9KPK3");

var $hYgW9 = parcelRequire("hYgW9");

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
var $2fdda1abbf4dbf9f$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($2fdda1abbf4dbf9f$var$DataType = module.exports.DataType || (module.exports.DataType = {}));
function $2fdda1abbf4dbf9f$var$getSchemaTypes(schema) {
    const types = $2fdda1abbf4dbf9f$var$getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
module.exports.getSchemaTypes = $2fdda1abbf4dbf9f$var$getSchemaTypes;
function $2fdda1abbf4dbf9f$var$getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($1sl6b.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
module.exports.getJSONTypes = $2fdda1abbf4dbf9f$var$getJSONTypes;
function $2fdda1abbf4dbf9f$var$coerceAndCheckDataType(it, types) {
    const { gen: gen, data: data, opts: opts } = it;
    const coerceTo = $2fdda1abbf4dbf9f$var$coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $9KPK3.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = $2fdda1abbf4dbf9f$var$checkDataTypes(types, data, opts.strictNumbers, $2fdda1abbf4dbf9f$var$DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) $2fdda1abbf4dbf9f$var$coerceData(it, types, coerceTo);
            else $2fdda1abbf4dbf9f$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
module.exports.coerceAndCheckDataType = $2fdda1abbf4dbf9f$var$coerceAndCheckDataType;
const $2fdda1abbf4dbf9f$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $2fdda1abbf4dbf9f$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>$2fdda1abbf4dbf9f$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function $2fdda1abbf4dbf9f$var$coerceData(it, types, coerceTo) {
    const { gen: gen, data: data, opts: opts } = it;
    const dataType = gen.let("dataType", (0, $l2ufW._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, $l2ufW._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, $l2ufW._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, $l2ufW._)`${data}[0]`).assign(dataType, (0, $l2ufW._)`typeof ${data}`).if($2fdda1abbf4dbf9f$var$checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, $l2ufW._)`${coerced} !== undefined`);
    for (const t of coerceTo)if ($2fdda1abbf4dbf9f$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    $2fdda1abbf4dbf9f$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $l2ufW._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        $2fdda1abbf4dbf9f$var$assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $l2ufW._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, $l2ufW._)`"" + ${data}`).elseIf((0, $l2ufW._)`${data} === null`).assign(coerced, (0, $l2ufW._)`""`);
                return;
            case "number":
                gen.elseIf((0, $l2ufW._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, $l2ufW._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, $l2ufW._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, $l2ufW._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, $l2ufW._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, $l2ufW._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $l2ufW._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $l2ufW._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, $l2ufW._)`[${data}]`);
        }
    }
}
function $2fdda1abbf4dbf9f$var$assignParentData({ gen: gen, parentData: parentData, parentDataProperty: parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, $l2ufW._)`${parentData} !== undefined`, ()=>gen.assign((0, $l2ufW._)`${parentData}[${parentDataProperty}]`, expr));
}
function $2fdda1abbf4dbf9f$var$checkDataType(dataType, data, strictNums, correct = $2fdda1abbf4dbf9f$var$DataType.Correct) {
    const EQ = correct === $2fdda1abbf4dbf9f$var$DataType.Correct ? $l2ufW.operators.EQ : $l2ufW.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, $l2ufW._)`${data} ${EQ} null`;
        case "array":
            cond = (0, $l2ufW._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, $l2ufW._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, $l2ufW._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $l2ufW._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === $2fdda1abbf4dbf9f$var$DataType.Correct ? cond : (0, $l2ufW.not)(cond);
    function numCond(_cond = $l2ufW.nil) {
        return (0, $l2ufW.and)((0, $l2ufW._)`typeof ${data} == "number"`, _cond, strictNums ? (0, $l2ufW._)`isFinite(${data})` : $l2ufW.nil);
    }
}
module.exports.checkDataType = $2fdda1abbf4dbf9f$var$checkDataType;
function $2fdda1abbf4dbf9f$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $2fdda1abbf4dbf9f$var$checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, $7eX5i.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, $l2ufW._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, $l2ufW._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $l2ufW.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, $l2ufW.and)(cond, $2fdda1abbf4dbf9f$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
module.exports.checkDataTypes = $2fdda1abbf4dbf9f$var$checkDataTypes;
const $2fdda1abbf4dbf9f$var$typeError = {
    message: ({ schema: schema })=>`must be ${schema}`,
    params: ({ schema: schema, schemaValue: schemaValue })=>typeof schema == "string" ? (0, $l2ufW._)`{type: ${schema}}` : (0, $l2ufW._)`{type: ${schemaValue}}`
};
function $2fdda1abbf4dbf9f$var$reportTypeError(it) {
    const cxt = $2fdda1abbf4dbf9f$var$getTypeErrorContext(it);
    (0, $hYgW9.reportError)(cxt, $2fdda1abbf4dbf9f$var$typeError);
}
module.exports.reportTypeError = $2fdda1abbf4dbf9f$var$reportTypeError;
function $2fdda1abbf4dbf9f$var$getTypeErrorContext(it) {
    const { gen: gen, data: data, schema: schema } = it;
    const schemaCode = (0, $7eX5i.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRegister("1sl6b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRules = module.exports.isJSONType = void 0;
const $10f8c5b811d8a69e$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const $10f8c5b811d8a69e$var$jsonTypes = new Set($10f8c5b811d8a69e$var$_jsonTypes);
function $10f8c5b811d8a69e$var$isJSONType(x) {
    return typeof x == "string" && $10f8c5b811d8a69e$var$jsonTypes.has(x);
}
module.exports.isJSONType = $10f8c5b811d8a69e$var$isJSONType;
function $10f8c5b811d8a69e$var$getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
module.exports.getRules = $10f8c5b811d8a69e$var$getRules;

});

parcelRegister("9KPK3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldUseRule = module.exports.shouldUseGroup = module.exports.schemaHasRulesForType = void 0;
function $71a08bc6f5a5bab9$var$schemaHasRulesForType({ schema: schema, self: self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && $71a08bc6f5a5bab9$var$shouldUseGroup(schema, group);
}
module.exports.schemaHasRulesForType = $71a08bc6f5a5bab9$var$schemaHasRulesForType;
function $71a08bc6f5a5bab9$var$shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>$71a08bc6f5a5bab9$var$shouldUseRule(schema, rule));
}
module.exports.shouldUseGroup = $71a08bc6f5a5bab9$var$shouldUseGroup;
function $71a08bc6f5a5bab9$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
module.exports.shouldUseRule = $71a08bc6f5a5bab9$var$shouldUseRule;

});


parcelRegister("9OJAU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
function $725c26a0727ed10f$var$assignDefaults(it, ty) {
    const { properties: properties, items: items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)$725c26a0727ed10f$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>$725c26a0727ed10f$var$assignDefault(it, i, sch.default));
}
module.exports.assignDefaults = $725c26a0727ed10f$var$assignDefaults;
function $725c26a0727ed10f$var$assignDefault(it, prop, defaultValue) {
    const { gen: gen, compositeRule: compositeRule, data: data, opts: opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)(prop)}`;
    if (compositeRule) {
        (0, $7eX5i.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, $l2ufW._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, $l2ufW._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $l2ufW._)`${childData} = ${(0, $l2ufW.stringify)(defaultValue)}`);
}

});

parcelRegister("dTewx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateKeywordUsage = module.exports.validSchemaType = module.exports.funcKeywordCode = module.exports.macroKeywordCode = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");

var $7unnO = parcelRequire("7unnO");

var $hYgW9 = parcelRequire("hYgW9");
function $a1cbad90d3b10795$var$macroKeywordCode(cxt, def) {
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, it: it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = $a1cbad90d3b10795$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $l2ufW.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
module.exports.macroKeywordCode = $a1cbad90d3b10795$var$macroKeywordCode;
function $a1cbad90d3b10795$var$funcKeywordCode(cxt, def) {
    var _a;
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, $data: $data, it: it } = cxt;
    $a1cbad90d3b10795$var$checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = $a1cbad90d3b10795$var$useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $a1cbad90d3b10795$var$modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $a1cbad90d3b10795$var$modifyData(cxt);
            reportErrs(()=>$a1cbad90d3b10795$var$addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, $l2ufW._)`await `), (e)=>gen.assign(valid, false).if((0, $l2ufW._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, $l2ufW._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, $l2ufW._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid($l2ufW.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, $l2ufW._)`await ` : $l2ufW.nil) {
        const passCxt = it.opts.passContext ? $dOpvc.default.this : $dOpvc.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $l2ufW._)`${_await}${(0, $7unnO.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, $l2ufW.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
module.exports.funcKeywordCode = $a1cbad90d3b10795$var$funcKeywordCode;
function $a1cbad90d3b10795$var$modifyData(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, $l2ufW._)`${it.parentData}[${it.parentDataProperty}]`));
}
function $a1cbad90d3b10795$var$addErrs(cxt, errs) {
    const { gen: gen } = cxt;
    gen.if((0, $l2ufW._)`Array.isArray(${errs})`, ()=>{
        gen.assign($dOpvc.default.vErrors, (0, $l2ufW._)`${$dOpvc.default.vErrors} === null ? ${errs} : ${$dOpvc.default.vErrors}.concat(${errs})`).assign($dOpvc.default.errors, (0, $l2ufW._)`${$dOpvc.default.vErrors}.length`);
        (0, $hYgW9.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function $a1cbad90d3b10795$var$checkAsyncKeyword({ schemaEnv: schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $a1cbad90d3b10795$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $l2ufW.stringify)(result)
    });
}
function $a1cbad90d3b10795$var$validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
module.exports.validSchemaType = $a1cbad90d3b10795$var$validSchemaType;
function $a1cbad90d3b10795$var$validateKeywordUsage({ schema: schema, opts: opts, self: self, errSchemaPath: errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
module.exports.validateKeywordUsage = $a1cbad90d3b10795$var$validateKeywordUsage;

});
parcelRegister("7unnO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateUnion = module.exports.validateArray = module.exports.usePattern = module.exports.callValidateCode = module.exports.schemaProperties = module.exports.allSchemaProperties = module.exports.noPropertyInData = module.exports.propertyInData = module.exports.isOwnProperty = module.exports.hasPropFunc = module.exports.reportMissingProp = module.exports.checkMissingProp = module.exports.checkReportMissingProp = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $dOpvc = parcelRequire("dOpvc");

var $7eX5i = parcelRequire("7eX5i");
function $573d792233d8638b$var$checkReportMissingProp(cxt, prop) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if($573d792233d8638b$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, $l2ufW._)`${prop}`
        }, true);
        cxt.error();
    });
}
module.exports.checkReportMissingProp = $573d792233d8638b$var$checkReportMissingProp;
function $573d792233d8638b$var$checkMissingProp({ gen: gen, data: data, it: { opts: opts } }, properties, missing) {
    return (0, $l2ufW.or)(...properties.map((prop)=>(0, $l2ufW.and)($573d792233d8638b$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $l2ufW._)`${missing} = ${prop}`)));
}
module.exports.checkMissingProp = $573d792233d8638b$var$checkMissingProp;
function $573d792233d8638b$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
module.exports.reportMissingProp = $573d792233d8638b$var$reportMissingProp;
function $573d792233d8638b$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $l2ufW._)`Object.prototype.hasOwnProperty`
    });
}
module.exports.hasPropFunc = $573d792233d8638b$var$hasPropFunc;
function $573d792233d8638b$var$isOwnProperty(gen, data, property) {
    return (0, $l2ufW._)`${$573d792233d8638b$var$hasPropFunc(gen)}.call(${data}, ${property})`;
}
module.exports.isOwnProperty = $573d792233d8638b$var$isOwnProperty;
function $573d792233d8638b$var$propertyInData(gen, data, property, ownProperties) {
    const cond = (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, $l2ufW._)`${cond} && ${$573d792233d8638b$var$isOwnProperty(gen, data, property)}` : cond;
}
module.exports.propertyInData = $573d792233d8638b$var$propertyInData;
function $573d792233d8638b$var$noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)(property)} === undefined`;
    return ownProperties ? (0, $l2ufW.or)(cond, (0, $l2ufW.not)($573d792233d8638b$var$isOwnProperty(gen, data, property))) : cond;
}
module.exports.noPropertyInData = $573d792233d8638b$var$noPropertyInData;
function $573d792233d8638b$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
module.exports.allSchemaProperties = $573d792233d8638b$var$allSchemaProperties;
function $573d792233d8638b$var$schemaProperties(it, schemaMap) {
    return $573d792233d8638b$var$allSchemaProperties(schemaMap).filter((p)=>!(0, $7eX5i.alwaysValidSchema)(it, schemaMap[p]));
}
module.exports.schemaProperties = $573d792233d8638b$var$schemaProperties;
function $573d792233d8638b$var$callValidateCode({ schemaCode: schemaCode, data: data, it: { gen: gen, topSchemaRef: topSchemaRef, schemaPath: schemaPath, errorPath: errorPath }, it: it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, $l2ufW._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            $dOpvc.default.instancePath,
            (0, $l2ufW.strConcat)($dOpvc.default.instancePath, errorPath)
        ],
        [
            $dOpvc.default.parentData,
            it.parentData
        ],
        [
            $dOpvc.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $dOpvc.default.rootData,
            $dOpvc.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $dOpvc.default.dynamicAnchors,
        $dOpvc.default.dynamicAnchors
    ]);
    const args = (0, $l2ufW._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== $l2ufW.nil ? (0, $l2ufW._)`${func}.call(${context}, ${args})` : (0, $l2ufW._)`${func}(${args})`;
}
module.exports.callValidateCode = $573d792233d8638b$var$callValidateCode;
const $573d792233d8638b$var$newRegExp = (0, $l2ufW._)`new RegExp`;
function $573d792233d8638b$var$usePattern({ gen: gen, it: { opts: opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp: regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $l2ufW._)`${regExp.code === "new RegExp" ? $573d792233d8638b$var$newRegExp : (0, $7eX5i.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
module.exports.usePattern = $573d792233d8638b$var$usePattern;
function $573d792233d8638b$var$validateArray(cxt) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, $l2ufW._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $7eX5i.Type.Num
            }, valid);
            gen.if((0, $l2ufW.not)(valid), notValid);
        });
    }
}
module.exports.validateArray = $573d792233d8638b$var$validateArray;
function $573d792233d8638b$var$validateUnion(cxt) {
    const { gen: gen, schema: schema, keyword: keyword, it: it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, $7eX5i.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $l2ufW._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $l2ufW.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
module.exports.validateUnion = $573d792233d8638b$var$validateUnion;

});


parcelRegister("5eunN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendSubschemaMode = module.exports.extendSubschemaData = module.exports.getSubschema = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
function $3cf5d3ecc8063845$var$getSubschema(it, { keyword: keyword, schemaProp: schemaProp, schema: schema, schemaPath: schemaPath, errSchemaPath: errSchemaPath, topSchemaRef: topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $l2ufW._)`${it.schemaPath}${(0, $l2ufW.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $l2ufW._)`${it.schemaPath}${(0, $l2ufW.getProperty)(keyword)}${(0, $l2ufW.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, $7eX5i.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
module.exports.getSubschema = $3cf5d3ecc8063845$var$getSubschema;
function $3cf5d3ecc8063845$var$extendSubschemaData(subschema, it, { dataProp: dataProp, dataPropType: dpType, data: data, dataTypes: dataTypes, propertyName: propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: gen } = it;
    if (dataProp !== undefined) {
        const { errorPath: errorPath, dataPathArr: dataPathArr, opts: opts } = it;
        const nextData = gen.let("data", (0, $l2ufW._)`${it.data}${(0, $l2ufW.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $l2ufW.str)`${errorPath}${(0, $7eX5i.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, $l2ufW._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof $l2ufW.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
module.exports.extendSubschemaData = $3cf5d3ecc8063845$var$extendSubschemaData;
function $3cf5d3ecc8063845$var$extendSubschemaMode(subschema, { jtdDiscriminator: jtdDiscriminator, jtdMetadata: jtdMetadata, compositeRule: compositeRule, createErrors: createErrors, allErrors: allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
module.exports.extendSubschemaMode = $3cf5d3ecc8063845$var$extendSubschemaMode;

});

parcelRegister("9ZpNV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaRefs = module.exports.resolveUrl = module.exports.normalizeId = module.exports._getFullPath = module.exports.getFullPath = module.exports.inlineRef = void 0;

var $7eX5i = parcelRequire("7eX5i");

var $7hFx0 = parcelRequire("7hFx0");

var $7dBhG = parcelRequire("7dBhG");
// TODO refactor to use keyword definitions
const $745dd3bb66238608$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $745dd3bb66238608$var$inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$745dd3bb66238608$var$hasRef(schema);
    if (!limit) return false;
    return $745dd3bb66238608$var$countKeys(schema) <= limit;
}
module.exports.inlineRef = $745dd3bb66238608$var$inlineRef;
const $745dd3bb66238608$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $745dd3bb66238608$var$hasRef(schema) {
    for(const key in schema){
        if ($745dd3bb66238608$var$REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some($745dd3bb66238608$var$hasRef)) return true;
        if (typeof sch == "object" && $745dd3bb66238608$var$hasRef(sch)) return true;
    }
    return false;
}
function $745dd3bb66238608$var$countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($745dd3bb66238608$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $7eX5i.eachItem)(schema[key], (sch)=>count += $745dd3bb66238608$var$countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $745dd3bb66238608$var$getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = $745dd3bb66238608$var$normalizeId(id);
    const p = resolver.parse(id);
    return $745dd3bb66238608$var$_getFullPath(resolver, p);
}
module.exports.getFullPath = $745dd3bb66238608$var$getFullPath;
function $745dd3bb66238608$var$_getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
module.exports._getFullPath = $745dd3bb66238608$var$_getFullPath;
const $745dd3bb66238608$var$TRAILING_SLASH_HASH = /#\/?$/;
function $745dd3bb66238608$var$normalizeId(id) {
    return id ? id.replace($745dd3bb66238608$var$TRAILING_SLASH_HASH, "") : "";
}
module.exports.normalizeId = $745dd3bb66238608$var$normalizeId;
function $745dd3bb66238608$var$resolveUrl(resolver, baseId, id) {
    id = $745dd3bb66238608$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
module.exports.resolveUrl = $745dd3bb66238608$var$resolveUrl;
const $745dd3bb66238608$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $745dd3bb66238608$var$getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId: schemaId, uriResolver: uriResolver } = this.opts;
    const schId = $745dd3bb66238608$var$normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = $745dd3bb66238608$var$getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    $7dBhG(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let baseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") baseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = baseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = $745dd3bb66238608$var$normalizeId(baseId ? _resolve(baseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $745dd3bb66238608$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$745dd3bb66238608$var$ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$7hFx0(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
module.exports.getSchemaRefs = $745dd3bb66238608$var$getSchemaRefs;

});
parcelRegister("7hFx0", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("7dBhG", function(module, exports) {
"use strict";
var $5416ab2f1394f8d9$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == "function") {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == "function" ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $5416ab2f1394f8d9$var$_traverse(opts, pre, post, schema, "", schema);
};
$5416ab2f1394f8d9$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
$5416ab2f1394f8d9$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$5416ab2f1394f8d9$var$traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$5416ab2f1394f8d9$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $5416ab2f1394f8d9$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == "object" && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $5416ab2f1394f8d9$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch[i], jsonPtr + "/" + key + "/" + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $5416ab2f1394f8d9$var$traverse.propsKeywords) {
                if (sch && typeof sch == "object") for(var prop in sch)$5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch[prop], jsonPtr + "/" + key + "/" + $5416ab2f1394f8d9$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $5416ab2f1394f8d9$var$traverse.keywords || opts.allKeys && !(key in $5416ab2f1394f8d9$var$traverse.skipKeywords)) $5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $5416ab2f1394f8d9$var$escapeJsonPtr(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}

});



parcelRegister("2gvZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $1a65e520856caceb$var$ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
module.exports.default = $1a65e520856caceb$var$ValidationError;

});

parcelRegister("euTEo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9ZpNV = parcelRequire("9ZpNV");
class $a8df090d24729250$var$MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, $9ZpNV.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, $9ZpNV.normalizeId)((0, $9ZpNV.getFullPath)(resolver, this.missingRef));
    }
}
module.exports.default = $a8df090d24729250$var$MissingRefError;

});

parcelRegister("jstQR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveSchema = module.exports.getCompilingSchema = module.exports.resolveRef = module.exports.compileSchema = module.exports.SchemaEnv = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $2gvZO = parcelRequire("2gvZO");

var $dOpvc = parcelRequire("dOpvc");

var $9ZpNV = parcelRequire("9ZpNV");

var $7eX5i = parcelRequire("7eX5i");

var $9hgV1 = parcelRequire("9hgV1");
class $e2a7c9c4276e8f03$var$SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $9ZpNV.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
module.exports.SchemaEnv = $e2a7c9c4276e8f03$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $e2a7c9c4276e8f03$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = $e2a7c9c4276e8f03$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, $9ZpNV.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $l2ufW.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $2gvZO.default,
        code: (0, $l2ufW._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $dOpvc.default.data,
        parentData: $dOpvc.default.parentData,
        parentDataProperty: $dOpvc.default.parentDataProperty,
        dataNames: [
            $dOpvc.default.data
        ],
        dataPathArr: [
            $l2ufW.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $l2ufW.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $l2ufW.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $l2ufW._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, $9hgV1.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs($dOpvc.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${$dOpvc.default.self}`, `${$dOpvc.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props: props, items: items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof $l2ufW.Name ? undefined : props,
                items: items instanceof $l2ufW.Name ? undefined : items,
                dynamicProps: props instanceof $l2ufW.Name,
                dynamicItems: items instanceof $l2ufW.Name
            };
            if (validate.source) validate.source.evaluated = (0, $l2ufW.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
module.exports.compileSchema = $e2a7c9c4276e8f03$var$compileSchema;
function $e2a7c9c4276e8f03$var$resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, $9ZpNV.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = $e2a7c9c4276e8f03$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId: schemaId } = this.opts;
        if (schema) _sch = new $e2a7c9c4276e8f03$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $e2a7c9c4276e8f03$var$inlineOrCompile.call(this, _sch);
}
module.exports.resolveRef = $e2a7c9c4276e8f03$var$resolveRef;
function $e2a7c9c4276e8f03$var$inlineOrCompile(sch) {
    if ((0, $9ZpNV.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $e2a7c9c4276e8f03$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $e2a7c9c4276e8f03$var$getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if ($e2a7c9c4276e8f03$var$sameSchemaEnv(sch, schEnv)) return sch;
    }
}
module.exports.getCompilingSchema = $e2a7c9c4276e8f03$var$getCompilingSchema;
function $e2a7c9c4276e8f03$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $e2a7c9c4276e8f03$var$resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $e2a7c9c4276e8f03$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $e2a7c9c4276e8f03$var$resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, $9ZpNV._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, $9ZpNV.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $e2a7c9c4276e8f03$var$getJsonPointer.call(this, p, root);
    const id = (0, $9ZpNV.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = $e2a7c9c4276e8f03$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $e2a7c9c4276e8f03$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $e2a7c9c4276e8f03$var$compileSchema.call(this, schOrRef);
    if (id === (0, $9ZpNV.normalizeId)(ref)) {
        const { schema: schema } = schOrRef;
        const { schemaId: schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, $9ZpNV.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $e2a7c9c4276e8f03$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $e2a7c9c4276e8f03$var$getJsonPointer.call(this, p, schOrRef);
}
module.exports.resolveSchema = $e2a7c9c4276e8f03$var$resolveSchema;
const $e2a7c9c4276e8f03$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $e2a7c9c4276e8f03$var$getJsonPointer(parsedRef, { baseId: baseId, schema: schema, root: root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, $7eX5i.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!$e2a7c9c4276e8f03$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $9ZpNV.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $7eX5i.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, $9ZpNV.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $e2a7c9c4276e8f03$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId: schemaId } = this.opts;
    env = env || new $e2a7c9c4276e8f03$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRegister("83wzf", function(module, exports) {
module.exports = JSON.parse('{"$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON AnySchema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

});

parcelRegister("FaKkF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2h43S = parcelRequire("2h43S");
$2h43S.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $2h43S;

});
parcelRegister("2h43S", function(module, exports) {
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join("");
        } else return sets[0];
    }
    function subexp(str) {
        return "(?:" + str + ")";
    }
    function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
        return str.toUpperCase();
    }
    function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    }
    function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    }
    function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = "-"; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    }
    /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1("invalid-input");
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1("overflow");
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1("overflow");
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1("overflow");
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ "version": "2.1.0",
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    }
    function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    }
    function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    }
    function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    }
    function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number" || typeof components.port === "string") {
            uriTokens.push(":");
            uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    }
    function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    }
    function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    }
    function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: "null"
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    }
    function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    }
    function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            var secure = String(components.scheme).toLowerCase() === "https";
            //normalize the default port
            if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    //RFC 6455
    var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse(components, options) {
            var wsComponents = components;
            //indicate if the secure flag is set
            wsComponents.secure = isSecure(wsComponents);
            //construct resouce name
            wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
            wsComponents.path = undefined;
            wsComponents.query = undefined;
            return wsComponents;
        },
        serialize: function serialize(wsComponents, options) {
            //normalize the default port
            if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
            //ensure scheme matches secure flag
            if (typeof wsComponents.secure === "boolean") {
                wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
                wsComponents.secure = undefined;
            }
            //reconstruct path from resource name
            if (wsComponents.resourceName) {
                var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
                wsComponents.path = path && path !== "/" ? path : undefined;
                wsComponents.query = query;
                wsComponents.resourceName = undefined;
            }
            //forbid fragment component
            wsComponents.fragment = undefined;
            return wsComponents;
        }
    };
    var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});



parcelRegister("hHp9H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kt8nB = parcelRequire("kt8nB");

var $9hSw4 = parcelRequire("9hSw4");

var $8U9k8 = parcelRequire("8U9k8");

var $kLdb8 = parcelRequire("kLdb8");

var $koD8T = parcelRequire("koD8T");
const $ce29f730388cb405$var$draft7Vocabularies = [
    $kt8nB.default,
    $9hSw4.default,
    (0, $8U9k8.default)(),
    $kLdb8.default,
    $koD8T.metadataVocabulary,
    $koD8T.contentVocabulary
];
module.exports.default = $ce29f730388cb405$var$draft7Vocabularies;

});
parcelRegister("kt8nB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6qsig = parcelRequire("6qsig");

var $kw3FV = parcelRequire("kw3FV");
const $ee6d041c7fe7d577$var$core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    $6qsig.default,
    $kw3FV.default
];
module.exports.default = $ee6d041c7fe7d577$var$core;

});
parcelRegister("6qsig", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $4adb1e4936824bf9$var$def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
module.exports.default = $4adb1e4936824bf9$var$def;

});

parcelRegister("kw3FV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callRef = module.exports.getValidate = void 0;

var $euTEo = parcelRequire("euTEo");

var $7unnO = parcelRequire("7unnO");

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");

var $jstQR = parcelRequire("jstQR");

var $7eX5i = parcelRequire("7eX5i");
const $eef9a5a25da20ed8$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen: gen, schema: $ref, it: it } = cxt;
        const { baseId: baseId, schemaEnv: env, validateName: validateName, opts: opts, self: self } = it;
        const { root: root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = $jstQR.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $euTEo.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $jstQR.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return $eef9a5a25da20ed8$var$callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return $eef9a5a25da20ed8$var$callRef(cxt, (0, $l2ufW._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = $eef9a5a25da20ed8$var$getValidate(cxt, sch);
            $eef9a5a25da20ed8$var$callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $l2ufW.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $l2ufW.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function $eef9a5a25da20ed8$var$getValidate(cxt, sch) {
    const { gen: gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $l2ufW._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
module.exports.getValidate = $eef9a5a25da20ed8$var$getValidate;
function $eef9a5a25da20ed8$var$callRef(cxt, v, sch, $async) {
    const { gen: gen, it: it } = cxt;
    const { allErrors: allErrors, schemaEnv: env, opts: opts } = it;
    const passCxt = opts.passContext ? $dOpvc.default.this : $l2ufW.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, $l2ufW._)`await ${(0, $7unnO.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, $l2ufW._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, $7unnO.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, $l2ufW._)`${source}.errors`;
        gen.assign($dOpvc.default.vErrors, (0, $l2ufW._)`${$dOpvc.default.vErrors} === null ? ${errs} : ${$dOpvc.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign($dOpvc.default.errors, (0, $l2ufW._)`${$dOpvc.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $7eX5i.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, $l2ufW._)`${source}.evaluated.props`);
                it.props = $7eX5i.mergeEvaluated.props(gen, props, it.props, $l2ufW.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $7eX5i.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, $l2ufW._)`${source}.evaluated.items`);
                it.items = $7eX5i.mergeEvaluated.items(gen, items, it.items, $l2ufW.Name);
            }
        }
    }
}
module.exports.callRef = $eef9a5a25da20ed8$var$callRef;
module.exports.default = $eef9a5a25da20ed8$var$def;

});


parcelRegister("9hSw4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3WoId = parcelRequire("3WoId");

var $bUCRi = parcelRequire("bUCRi");

var $Nqi0g = parcelRequire("Nqi0g");

var $9V0CC = parcelRequire("9V0CC");

var $3HmRG = parcelRequire("3HmRG");

var $aQ9E5 = parcelRequire("aQ9E5");

var $37rVP = parcelRequire("37rVP");

var $1ObWf = parcelRequire("1ObWf");

var $1jiSd = parcelRequire("1jiSd");

var $6bLKD = parcelRequire("6bLKD");
const $6c2ffd64a2866684$var$validation = [
    // number
    $3WoId.default,
    $bUCRi.default,
    // string
    $Nqi0g.default,
    $9V0CC.default,
    // object
    $3HmRG.default,
    $aQ9E5.default,
    // array
    $37rVP.default,
    $1ObWf.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    $1jiSd.default,
    $6bLKD.default
];
module.exports.default = $6c2ffd64a2866684$var$validation;

});
parcelRegister("3WoId", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $2de9f5322632f65d$var$ops = $l2ufW.operators;
const $2de9f5322632f65d$var$KWDs = {
    maximum: {
        okStr: "<=",
        ok: $2de9f5322632f65d$var$ops.LTE,
        fail: $2de9f5322632f65d$var$ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: $2de9f5322632f65d$var$ops.GTE,
        fail: $2de9f5322632f65d$var$ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: $2de9f5322632f65d$var$ops.LT,
        fail: $2de9f5322632f65d$var$ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: $2de9f5322632f65d$var$ops.GT,
        fail: $2de9f5322632f65d$var$ops.LTE
    }
};
const $2de9f5322632f65d$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $l2ufW.str)`must be ${$2de9f5322632f65d$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $l2ufW._)`{comparison: ${$2de9f5322632f65d$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
const $2de9f5322632f65d$var$def = {
    keyword: Object.keys($2de9f5322632f65d$var$KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error: $2de9f5322632f65d$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        cxt.fail$data((0, $l2ufW._)`${data} ${$2de9f5322632f65d$var$KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    }
};
module.exports.default = $2de9f5322632f65d$var$def;

});

parcelRegister("bUCRi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $8ac31129cbdb6091$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $l2ufW.str)`must be multiple of ${schemaCode}`,
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{multipleOf: ${schemaCode}}`
};
const $8ac31129cbdb6091$var$def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error: $8ac31129cbdb6091$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, it: it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, $l2ufW._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, $l2ufW._)`${res} !== parseInt(${res})`;
        cxt.fail$data((0, $l2ufW._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    }
};
module.exports.default = $8ac31129cbdb6091$var$def;

});

parcelRegister("Nqi0g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $6BTyZ = parcelRequire("6BTyZ");
const $0948f83d70ebc31d$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, $l2ufW.str)`must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{limit: ${schemaCode}}`
};
const $0948f83d70ebc31d$var$def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error: $0948f83d70ebc31d$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode, it: it } = cxt;
        const op = keyword === "maxLength" ? $l2ufW.operators.GT : $l2ufW.operators.LT;
        const len = it.opts.unicode === false ? (0, $l2ufW._)`${data}.length` : (0, $l2ufW._)`${(0, $7eX5i.useFunc)(cxt.gen, $6BTyZ.default)}(${data})`;
        cxt.fail$data((0, $l2ufW._)`${len} ${op} ${schemaCode}`);
    }
};
module.exports.default = $0948f83d70ebc31d$var$def;

});
parcelRegister("6BTyZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function $4d014c7f52d4c6e1$var$ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
module.exports.default = $4d014c7f52d4c6e1$var$ucs2length;
$4d014c7f52d4c6e1$var$ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

});


parcelRegister("9V0CC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");

var $l2ufW = parcelRequire("l2ufW");
const $7389eb6c89297209$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $l2ufW.str)`must match pattern "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{pattern: ${schemaCode}}`
};
const $7389eb6c89297209$var$def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error: $7389eb6c89297209$var$error,
    code (cxt) {
        const { data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        // TODO regexp should be wrapped in try/catchs
        const u = it.opts.unicodeRegExp ? "u" : "";
        const regExp = $data ? (0, $l2ufW._)`(new RegExp(${schemaCode}, ${u}))` : (0, $7unnO.usePattern)(cxt, schema);
        cxt.fail$data((0, $l2ufW._)`!${regExp}.test(${data})`);
    }
};
module.exports.default = $7389eb6c89297209$var$def;

});

parcelRegister("3HmRG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $2b171fbd18b88a3a$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, $l2ufW.str)`must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{limit: ${schemaCode}}`
};
const $2b171fbd18b88a3a$var$def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error: $2b171fbd18b88a3a$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxProperties" ? $l2ufW.operators.GT : $l2ufW.operators.LT;
        cxt.fail$data((0, $l2ufW._)`Object.keys(${data}).length ${op} ${schemaCode}`);
    }
};
module.exports.default = $2b171fbd18b88a3a$var$def;

});

parcelRegister("aQ9E5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $7e463e1d6144c89a$var$error = {
    message: ({ params: { missingProperty: missingProperty } })=>(0, $l2ufW.str)`must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty: missingProperty } })=>(0, $l2ufW._)`{missingProperty: ${missingProperty}}`
};
const $7e463e1d6144c89a$var$def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error: $7e463e1d6144c89a$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, schemaCode: schemaCode, data: data, $data: $data, it: it } = cxt;
        const { opts: opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties: definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, $7eX5i.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data($l2ufW.nil, loopAllRequired);
            else for (const prop of schema)(0, $7unnO.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, $7unnO.checkMissingProp)(cxt, schema, missing));
                (0, $7unnO.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, $7unnO.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, $7unnO.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, $l2ufW.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, $l2ufW.nil);
        }
    }
};
module.exports.default = $7e463e1d6144c89a$var$def;

});

parcelRegister("37rVP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $2457b12e61a8fb9a$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, $l2ufW.str)`must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{limit: ${schemaCode}}`
};
const $2457b12e61a8fb9a$var$def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error: $2457b12e61a8fb9a$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxItems" ? $l2ufW.operators.GT : $l2ufW.operators.LT;
        cxt.fail$data((0, $l2ufW._)`${data}.length ${op} ${schemaCode}`);
    }
};
module.exports.default = $2457b12e61a8fb9a$var$def;

});

parcelRegister("1ObWf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $46MS3 = parcelRequire("46MS3");

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $cMsoH = parcelRequire("cMsoH");
const $1513b8ab19deb343$var$error = {
    message: ({ params: { i: i, j: j } })=>(0, $l2ufW.str)`must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i: i, j: j } })=>(0, $l2ufW._)`{i: ${i}, j: ${j}}`
};
const $1513b8ab19deb343$var$def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error: $1513b8ab19deb343$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, parentSchema: parentSchema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, $46MS3.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, $l2ufW._)`${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, $l2ufW._)`${data}.length`);
            const j = gen.let("j");
            cxt.setParams({
                i: i,
                j: j
            });
            gen.assign(valid, true);
            gen.if((0, $l2ufW._)`${i} > 1`, ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, $46MS3.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, $46MS3.DataType.Wrong);
            const indices = gen.const("indices", (0, $l2ufW._)`{}`);
            gen.for((0, $l2ufW._)`;${i}--;`, ()=>{
                gen.let(item, (0, $l2ufW._)`${data}[${i}]`);
                gen.if(wrongType, (0, $l2ufW._)`continue`);
                if (itemTypes.length > 1) gen.if((0, $l2ufW._)`typeof ${item} == "string"`, (0, $l2ufW._)`${item} += "_"`);
                gen.if((0, $l2ufW._)`typeof ${indices}[${item}] == "number"`, ()=>{
                    gen.assign(j, (0, $l2ufW._)`${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, $l2ufW._)`${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, $7eX5i.useFunc)(gen, $cMsoH.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, $l2ufW._)`;${i}--;`, ()=>gen.for((0, $l2ufW._)`${j} = ${i}; ${j}--;`, ()=>gen.if((0, $l2ufW._)`${eql}(${data}[${i}], ${data}[${j}])`, ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
module.exports.default = $1513b8ab19deb343$var$def;

});
parcelRegister("cMsoH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7hFx0 = parcelRequire("7hFx0");
$7hFx0.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $7hFx0;

});


parcelRegister("1jiSd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $cMsoH = parcelRequire("cMsoH");
const $0f4634aee52087bc$var$error = {
    message: "must be equal to constant",
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{allowedValue: ${schemaCode}}`
};
const $0f4634aee52087bc$var$def = {
    keyword: "const",
    $data: true,
    error: $0f4634aee52087bc$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schemaCode: schemaCode, schema: schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, $l2ufW._)`!${(0, $7eX5i.useFunc)(gen, $cMsoH.default)}(${data}, ${schemaCode})`);
        else cxt.fail((0, $l2ufW._)`${schema} !== ${data}`);
    }
};
module.exports.default = $0f4634aee52087bc$var$def;

});

parcelRegister("6bLKD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $cMsoH = parcelRequire("cMsoH");
const $4818cf8a0c8b5641$var$error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{allowedValues: ${schemaCode}}`
};
const $4818cf8a0c8b5641$var$def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error: $4818cf8a0c8b5641$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, $7eX5i.useFunc)(gen, $cMsoH.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, $l2ufW.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, $l2ufW._)`${getEql()}(${data}, ${v})`, ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, $l2ufW._)`${getEql()}(${data}, ${vSchema}[${i}])` : (0, $l2ufW._)`${data} === ${sch}`;
        }
    }
};
module.exports.default = $4818cf8a0c8b5641$var$def;

});


parcelRegister("8U9k8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7FQbu = parcelRequire("7FQbu");

var $9llPm = parcelRequire("9llPm");

var $cNKK7 = parcelRequire("cNKK7");

var $a2HBF = parcelRequire("a2HBF");

var $2dY63 = parcelRequire("2dY63");

var $ksuYJ = parcelRequire("ksuYJ");

var $bXp0l = parcelRequire("bXp0l");

var $8Wg07 = parcelRequire("8Wg07");

var $iBNsK = parcelRequire("iBNsK");

var $eSOrH = parcelRequire("eSOrH");

var $62Mii = parcelRequire("62Mii");

var $d3kOu = parcelRequire("d3kOu");

var $gC5PA = parcelRequire("gC5PA");

var $fhXQa = parcelRequire("fhXQa");

var $jfpXQ = parcelRequire("jfpXQ");

var $5HS6k = parcelRequire("5HS6k");
function $67bac937e8bbc1f1$var$getApplicator(draft2020 = false) {
    const applicator = [
        // any
        $62Mii.default,
        $d3kOu.default,
        $gC5PA.default,
        $fhXQa.default,
        $jfpXQ.default,
        $5HS6k.default,
        // object
        $bXp0l.default,
        $8Wg07.default,
        $ksuYJ.default,
        $iBNsK.default,
        $eSOrH.default
    ];
    // array
    if (draft2020) applicator.push($9llPm.default, $a2HBF.default);
    else applicator.push($7FQbu.default, $cNKK7.default);
    applicator.push($2dY63.default);
    return applicator;
}
module.exports.default = $67bac937e8bbc1f1$var$getApplicator;

});
parcelRegister("7FQbu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAdditionalItems = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $5964d7729d257dac$var$error = {
    message: ({ params: { len: len } })=>(0, $l2ufW.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $l2ufW._)`{limit: ${len}}`
};
const $5964d7729d257dac$var$def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: $5964d7729d257dac$var$error,
    code (cxt) {
        const { parentSchema: parentSchema, it: it } = cxt;
        const { items: items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, $7eX5i.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        $5964d7729d257dac$var$validateAdditionalItems(cxt, items);
    }
};
function $5964d7729d257dac$var$validateAdditionalItems(cxt, items) {
    const { gen: gen, schema: schema, data: data, keyword: keyword, it: it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, $l2ufW._)`${data}.length`);
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, $l2ufW._)`${len} <= ${items.length}`);
    } else if (typeof schema == "object" && !(0, $7eX5i.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, $l2ufW._)`${len} <= ${items.length}`); // TODO var
        gen.if((0, $l2ufW.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $7eX5i.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, $l2ufW.not)(valid), ()=>gen.break());
        });
    }
}
module.exports.validateAdditionalItems = $5964d7729d257dac$var$validateAdditionalItems;
module.exports.default = $5964d7729d257dac$var$def;

});

parcelRegister("9llPm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cNKK7 = parcelRequire("cNKK7");
const $6cd701aaf66b3db3$var$def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, $cNKK7.validateTuple)(cxt, "items")
};
module.exports.default = $6cd701aaf66b3db3$var$def;

});
parcelRegister("cNKK7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTuple = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $7unnO = parcelRequire("7unnO");
const $951e51c9b8ab42ca$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema: schema, it: it } = cxt;
        if (Array.isArray(schema)) return $951e51c9b8ab42ca$var$validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, $7unnO.validateArray)(cxt));
    }
};
function $951e51c9b8ab42ca$var$validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen: gen, parentSchema: parentSchema, data: data, keyword: keyword, it: it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = $7eX5i.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, $l2ufW._)`${data}.length`);
    schArr.forEach((sch, i)=>{
        if ((0, $7eX5i.alwaysValidSchema)(it, sch)) return;
        gen.if((0, $l2ufW._)`${len} > ${i}`, ()=>cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts: opts, errSchemaPath: errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, $7eX5i.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
module.exports.validateTuple = $951e51c9b8ab42ca$var$validateTuple;
module.exports.default = $951e51c9b8ab42ca$var$def;

});


parcelRegister("a2HBF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $7unnO = parcelRequire("7unnO");

var $7FQbu = parcelRequire("7FQbu");
const $74fbeaa6b7e34267$var$error = {
    message: ({ params: { len: len } })=>(0, $l2ufW.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $l2ufW._)`{limit: ${len}}`
};
const $74fbeaa6b7e34267$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: $74fbeaa6b7e34267$var$error,
    code (cxt) {
        const { schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { prefixItems: prefixItems } = parentSchema;
        it.items = true;
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, $7FQbu.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, $7unnO.validateArray)(cxt));
    }
};
module.exports.default = $74fbeaa6b7e34267$var$def;

});

parcelRegister("2dY63", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $19eb69a255f3d502$var$error = {
    message: ({ params: { min: min, max: max } })=>max === undefined ? (0, $l2ufW.str)`must contain at least ${min} valid item(s)` : (0, $l2ufW.str)`must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min: min, max: max } })=>max === undefined ? (0, $l2ufW._)`{minContains: ${min}}` : (0, $l2ufW._)`{minContains: ${min}, maxContains: ${max}}`
};
const $19eb69a255f3d502$var$def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error: $19eb69a255f3d502$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        let min;
        let max;
        const { minContains: minContains, maxContains: maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, $l2ufW._)`${data}.length`);
        cxt.setParams({
            min: min,
            max: max
        });
        if (max === undefined && min === 0) {
            (0, $7eX5i.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, $7eX5i.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) {
            let cond = (0, $l2ufW._)`${len} >= ${min}`;
            if (max !== undefined) cond = (0, $l2ufW._)`${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, $l2ufW._)`${data}.length > 0`, validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: $7eX5i.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, $l2ufW._)`${count}++`);
            if (max === undefined) gen.if((0, $l2ufW._)`${count} >= ${min}`, ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, $l2ufW._)`${count} > ${max}`, ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, $l2ufW._)`${count} >= ${min}`, ()=>gen.assign(valid, true));
            }
        }
    }
};
module.exports.default = $19eb69a255f3d502$var$def;

});

parcelRegister("ksuYJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSchemaDeps = module.exports.validatePropertyDeps = module.exports.error = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $7unnO = parcelRequire("7unnO");
module.exports.error = {
    message: ({ params: { property: property, depsCount: depsCount, deps: deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, $l2ufW.str)`must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property: property, depsCount: depsCount, deps: deps, missingProperty: missingProperty } })=>(0, $l2ufW._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
};
const $ee4e73e135a0dc71$var$def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: module.exports.error,
    code (cxt) {
        const [propDeps, schDeps] = $ee4e73e135a0dc71$var$splitDependencies(cxt);
        $ee4e73e135a0dc71$var$validatePropertyDeps(cxt, propDeps);
        $ee4e73e135a0dc71$var$validateSchemaDeps(cxt, schDeps);
    }
};
function $ee4e73e135a0dc71$var$splitDependencies({ schema: schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function $ee4e73e135a0dc71$var$validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen: gen, data: data, it: it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, $7unnO.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, $7unnO.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, $l2ufW._)`${hasProperty} && (${(0, $7unnO.checkMissingProp)(cxt, deps, missing)})`);
            (0, $7unnO.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
module.exports.validatePropertyDeps = $ee4e73e135a0dc71$var$validatePropertyDeps;
function $ee4e73e135a0dc71$var$validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, $7eX5i.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, $7unnO.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
module.exports.validateSchemaDeps = $ee4e73e135a0dc71$var$validateSchemaDeps;
module.exports.default = $ee4e73e135a0dc71$var$def;

});

parcelRegister("bXp0l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $8b4899c22aaf5c4d$var$error = {
    message: "property name must be valid",
    params: ({ params: params })=>(0, $l2ufW._)`{propertyName: ${params.propertyName}}`
};
const $8b4899c22aaf5c4d$var$def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: $8b4899c22aaf5c4d$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, $l2ufW.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $8b4899c22aaf5c4d$var$def;

});

parcelRegister("8Wg07", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");

var $7eX5i = parcelRequire("7eX5i");
const $682026f44715605d$var$error = {
    message: "must NOT have additional properties",
    params: ({ params: params })=>(0, $l2ufW._)`{additionalProperty: ${params.additionalProperty}}`
};
const $682026f44715605d$var$def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $682026f44715605d$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, errsCount: errsCount, it: it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, opts: opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, $7eX5i.alwaysValidSchema)(it, schema)) return;
        const props = (0, $7unnO.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, $7unnO.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, $l2ufW._)`${errsCount} === ${$dOpvc.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, $7eX5i.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, $7unnO.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, $l2ufW.or)(...props.map((p)=>(0, $l2ufW._)`${key} === ${p}`));
            else definedProp = $l2ufW.nil;
            if (patProps.length) definedProp = (0, $l2ufW.or)(definedProp, ...patProps.map((p)=>(0, $l2ufW._)`${(0, $7unnO.usePattern)(cxt, p)}.test(${key})`));
            return (0, $l2ufW.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, $l2ufW._)`delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, $7eX5i.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, $l2ufW.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, $l2ufW.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: $7eX5i.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
module.exports.default = $682026f44715605d$var$def;

});

parcelRegister("iBNsK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9hgV1 = parcelRequire("9hgV1");

var $7unnO = parcelRequire("7unnO");

var $7eX5i = parcelRequire("7eX5i");

var $8Wg07 = parcelRequire("8Wg07");
const $d8c20cf8939dcc93$var$def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) $8Wg07.default.code(new $9hgV1.KeywordCxt(it, $8Wg07.default, "additionalProperties"));
        const allProps = (0, $7unnO.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = $7eX5i.mergeEvaluated.props(gen, (0, $7eX5i.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, $7eX5i.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, $7unnO.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
module.exports.default = $d8c20cf8939dcc93$var$def;

});

parcelRegister("eSOrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $7eX5i = parcelRequire("7eX5i");
const $ad5d3d4f26070f68$var$def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, data: data, parentSchema: parentSchema, it: it } = cxt;
        const { opts: opts } = it;
        const patterns = (0, $7unnO.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, $7eX5i.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof $l2ufW.Name)) it.props = (0, $7eX5i.evaluatedPropsToName)(gen, it.props);
        const { props: props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, $7eX5i.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, $l2ufW._)`${(0, $7unnO.usePattern)(cxt, pat)}.test(${key})`, ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: $7eX5i.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, $l2ufW._)`${props}[${key}]`, true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, $l2ufW.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
module.exports.default = $ad5d3d4f26070f68$var$def;

});

parcelRegister("62Mii", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7eX5i = parcelRequire("7eX5i");
const $46686429bf9656cd$var$def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
module.exports.default = $46686429bf9656cd$var$def;

});

parcelRegister("d3kOu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");
const $980bb340f96346f4$var$def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: $7unnO.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
module.exports.default = $980bb340f96346f4$var$def;

});

parcelRegister("gC5PA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $c184b7de888f90fb$var$error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params: params })=>(0, $l2ufW._)`{passingSchemas: ${params.passing}}`
};
const $c184b7de888f90fb$var$def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error: $c184b7de888f90fb$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing: passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, $7eX5i.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, $l2ufW._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, $l2ufW._)`[${passing}, ${i}]`).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, $l2ufW.Name);
                });
            });
        }
    }
};
module.exports.default = $c184b7de888f90fb$var$def;

});

parcelRegister("fhXQa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7eX5i = parcelRequire("7eX5i");
const $b216dc95106535e4$var$def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, $7eX5i.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
module.exports.default = $b216dc95106535e4$var$def;

});

parcelRegister("jfpXQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $e0338efb54c30e45$var$error = {
    message: ({ params: params })=>(0, $l2ufW.str)`must match "${params.ifClause}" schema`,
    params: ({ params: params })=>(0, $l2ufW._)`{failingKeyword: ${params.ifClause}}`
};
const $e0338efb54c30e45$var$def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error: $e0338efb54c30e45$var$error,
    code (cxt) {
        const { gen: gen, parentSchema: parentSchema, it: it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, $7eX5i.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = $e0338efb54c30e45$var$hasSchema(it, "then");
        const hasElse = $e0338efb54c30e45$var$hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause: ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, $l2ufW.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword: keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, $l2ufW._)`${keyword}`);
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function $e0338efb54c30e45$var$hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, $7eX5i.alwaysValidSchema)(it, schema);
}
module.exports.default = $e0338efb54c30e45$var$def;

});

parcelRegister("5HS6k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7eX5i = parcelRequire("7eX5i");
const $427aef3e960393f3$var$def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.if === undefined) (0, $7eX5i.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
module.exports.default = $427aef3e960393f3$var$def;

});


parcelRegister("kLdb8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k9lk2 = parcelRequire("k9lk2");
const $f1d26b70ddc76007$var$format = [
    $k9lk2.default
];
module.exports.default = $f1d26b70ddc76007$var$format;

});
parcelRegister("k9lk2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $eab5300bdea14c03$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $l2ufW.str)`must match format "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{format: ${schemaCode}}`
};
const $eab5300bdea14c03$var$def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error: $eab5300bdea14c03$var$error,
    code (cxt, ruleType) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const { opts: opts, errSchemaPath: errSchemaPath, schemaEnv: schemaEnv, self: self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, $l2ufW._)`${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, $l2ufW._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, ()=>gen.assign(fType, (0, $l2ufW._)`${fDef}.type || "string"`).assign(format, (0, $l2ufW._)`${fDef}.validate`), ()=>gen.assign(fType, (0, $l2ufW._)`"string"`).assign(format, fDef));
            cxt.fail$data((0, $l2ufW.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return $l2ufW.nil;
                return (0, $l2ufW._)`${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, $l2ufW._)`(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))` : (0, $l2ufW._)`${format}(${data})`;
                const validData = (0, $l2ufW._)`(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, $l2ufW._)`${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, $l2ufW.regexpCode)(fmtDef) : opts.code.formats ? (0, $l2ufW._)`${opts.code.formats}${(0, $l2ufW.getProperty)(schema)}` : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code: code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, $l2ufW._)`${fmt}.validate`
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, $l2ufW._)`await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, $l2ufW._)`${fmtRef}(${data})` : (0, $l2ufW._)`${fmtRef}.test(${data})`;
            }
        }
    }
};
module.exports.default = $eab5300bdea14c03$var$def;

});


parcelRegister("koD8T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contentVocabulary = module.exports.metadataVocabulary = void 0;
module.exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
module.exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

});


parcelRegister("81ULr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $6x7md = parcelRequire("6x7md");

var $jstQR = parcelRequire("jstQR");

var $7eX5i = parcelRequire("7eX5i");
const $5d8a72e3f593aa35$var$error = {
    message: ({ params: { discrError: discrError, tagName: tagName } })=>discrError === $6x7md.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError: discrError, tag: tag, tagName: tagName } })=>(0, $l2ufW._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
};
const $5d8a72e3f593aa35$var$def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: $5d8a72e3f593aa35$var$error,
    code (cxt) {
        const { gen: gen, data: data, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { oneOf: oneOf } = parentSchema;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)(tagName)}`);
        gen.if((0, $l2ufW._)`typeof ${tag} == "string"`, ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: $6x7md.DiscrError.Tag,
                tag: tag,
                tagName: tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, $l2ufW._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: $6x7md.DiscrError.Mapping,
                tag: tag,
                tagName: tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp: schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, $l2ufW.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < oneOf.length; i++){
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, $7eX5i.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    sch = $jstQR.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, sch === null || sch === void 0 ? void 0 : sch.$ref);
                    if (sch instanceof $jstQR.SchemaEnv) sch = sch.schema;
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required: required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                oneOfMapping[tagValue] = i;
            }
        }
    }
};
module.exports.default = $5d8a72e3f593aa35$var$def;

});
parcelRegister("6x7md", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $4c1b8829d2a29cc7$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($4c1b8829d2a29cc7$var$DiscrError = module.exports.DiscrError || (module.exports.DiscrError = {}));

});


parcelRegister("BbyF4", function(module, exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

});


parcelRegister("lzTPx", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

var $5JKDD = parcelRequire("5JKDD");

var $9i56x = parcelRequire("9i56x");

var $dYeWu = parcelRequire("dYeWu");
const fullName = new $dYeWu.Name("fullFormats");
const fastName = new $dYeWu.Name("fastFormats");
const formatsPlugin = (ajv, opts = {
    keywords: true
})=>{
    if (Array.isArray(opts)) {
        addFormats(ajv, opts, $5JKDD.fullFormats, fullName);
        return ajv;
    }
    const [formats, exportName] = opts.mode === "fast" ? [
        $5JKDD.fastFormats,
        fastName
    ] : [
        $5JKDD.fullFormats,
        fullName
    ];
    const list = opts.formats || $5JKDD.formatNames;
    addFormats(ajv, list, formats, exportName);
    if (opts.keywords) $9i56x.default(ajv);
    return ajv;
};
formatsPlugin.get = (name, mode = "full")=>{
    const formats = mode === "fast" ? $5JKDD.fastFormats : $5JKDD.fullFormats;
    const f = formats[name];
    if (!f) throw new Error(`Unknown format "${name}"`);
    return f;
};
function addFormats(ajv, list, fs, exportName) {
    var _a;
    var _b;
    (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : _b.formats = $dYeWu._`require("ajv-formats/dist/formats").${exportName}`;
    for (const f of list)ajv.addFormat(f, fs[f]);
}
module.exports = exports = formatsPlugin;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatsPlugin;

});
parcelRegister("5JKDD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatNames = module.exports.fastFormats = module.exports.fullFormats = void 0;
function $42d5551d613883af$var$fmtDef(validate, compare) {
    return {
        validate: validate,
        compare: compare
    };
}
module.exports.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: $42d5551d613883af$var$fmtDef($42d5551d613883af$var$date, $42d5551d613883af$var$compareDate),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: $42d5551d613883af$var$fmtDef($42d5551d613883af$var$time, $42d5551d613883af$var$compareTime),
    "date-time": $42d5551d613883af$var$fmtDef($42d5551d613883af$var$date_time, $42d5551d613883af$var$compareDateTime),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri: $42d5551d613883af$var$uri,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex: $42d5551d613883af$var$regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    byte: // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    $42d5551d613883af$var$byte,
    // signed 32 bit integer
    int32: {
        type: "number",
        validate: $42d5551d613883af$var$validateInt32
    },
    // signed 64 bit integer
    int64: {
        type: "number",
        validate: $42d5551d613883af$var$validateInt64
    },
    // C-type float
    float: {
        type: "number",
        validate: $42d5551d613883af$var$validateNumber
    },
    // C-type double
    double: {
        type: "number",
        validate: $42d5551d613883af$var$validateNumber
    },
    // hint to the UI to hide input strings
    password: true,
    // unchecked string payload
    binary: true
};
module.exports.fastFormats = {
    ...module.exports.fullFormats,
    date: $42d5551d613883af$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, $42d5551d613883af$var$compareDate),
    time: $42d5551d613883af$var$fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, $42d5551d613883af$var$compareTime),
    "date-time": $42d5551d613883af$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, $42d5551d613883af$var$compareDateTime),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
};
module.exports.formatNames = Object.keys(module.exports.fullFormats);
function $42d5551d613883af$var$isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
const $42d5551d613883af$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const $42d5551d613883af$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $42d5551d613883af$var$date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    const matches = $42d5551d613883af$var$DATE.exec(str);
    if (!matches) return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && $42d5551d613883af$var$isLeapYear(year) ? 29 : $42d5551d613883af$var$DAYS[month]);
}
function $42d5551d613883af$var$compareDate(d1, d2) {
    if (!(d1 && d2)) return undefined;
    if (d1 > d2) return 1;
    if (d1 < d2) return -1;
    return 0;
}
const $42d5551d613883af$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
function $42d5551d613883af$var$time(str, withTimeZone) {
    const matches = $42d5551d613883af$var$TIME.exec(str);
    if (!matches) return false;
    const hour = +matches[1];
    const minute = +matches[2];
    const second = +matches[3];
    const timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour === 23 && minute === 59 && second === 60) && (!withTimeZone || timeZone !== "");
}
function $42d5551d613883af$var$compareTime(t1, t2) {
    if (!(t1 && t2)) return undefined;
    const a1 = $42d5551d613883af$var$TIME.exec(t1);
    const a2 = $42d5551d613883af$var$TIME.exec(t2);
    if (!(a1 && a2)) return undefined;
    t1 = a1[1] + a1[2] + a1[3] + (a1[4] || "");
    t2 = a2[1] + a2[2] + a2[3] + (a2[4] || "");
    if (t1 > t2) return 1;
    if (t1 < t2) return -1;
    return 0;
}
const $42d5551d613883af$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $42d5551d613883af$var$date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    const dateTime = str.split($42d5551d613883af$var$DATE_TIME_SEPARATOR);
    return dateTime.length === 2 && $42d5551d613883af$var$date(dateTime[0]) && $42d5551d613883af$var$time(dateTime[1], true);
}
function $42d5551d613883af$var$compareDateTime(dt1, dt2) {
    if (!(dt1 && dt2)) return undefined;
    const [d1, t1] = dt1.split($42d5551d613883af$var$DATE_TIME_SEPARATOR);
    const [d2, t2] = dt2.split($42d5551d613883af$var$DATE_TIME_SEPARATOR);
    const res = $42d5551d613883af$var$compareDate(d1, d2);
    if (res === undefined) return undefined;
    return res || $42d5551d613883af$var$compareTime(t1, t2);
}
const $42d5551d613883af$var$NOT_URI_FRAGMENT = /\/|:/;
const $42d5551d613883af$var$URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function $42d5551d613883af$var$uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return $42d5551d613883af$var$NOT_URI_FRAGMENT.test(str) && $42d5551d613883af$var$URI.test(str);
}
const $42d5551d613883af$var$BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
function $42d5551d613883af$var$byte(str) {
    $42d5551d613883af$var$BYTE.lastIndex = 0;
    return $42d5551d613883af$var$BYTE.test(str);
}
const $42d5551d613883af$var$MIN_INT32 = -(2 ** 31);
const $42d5551d613883af$var$MAX_INT32 = 2 ** 31 - 1;
function $42d5551d613883af$var$validateInt32(value) {
    return Number.isInteger(value) && value <= $42d5551d613883af$var$MAX_INT32 && value >= $42d5551d613883af$var$MIN_INT32;
}
function $42d5551d613883af$var$validateInt64(value) {
    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
    return Number.isInteger(value);
}
function $42d5551d613883af$var$validateNumber() {
    return true;
}
const $42d5551d613883af$var$Z_ANCHOR = /[^\\]\\Z/;
function $42d5551d613883af$var$regex(str) {
    if ($42d5551d613883af$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("9i56x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatLimitDefinition = void 0;

var $7BPBD = parcelRequire("7BPBD");

var $dYeWu = parcelRequire("dYeWu");
const $6c39c11c4b8c4d96$var$ops = $dYeWu.operators;
const $6c39c11c4b8c4d96$var$KWDs = {
    formatMaximum: {
        okStr: "<=",
        ok: $6c39c11c4b8c4d96$var$ops.LTE,
        fail: $6c39c11c4b8c4d96$var$ops.GT
    },
    formatMinimum: {
        okStr: ">=",
        ok: $6c39c11c4b8c4d96$var$ops.GTE,
        fail: $6c39c11c4b8c4d96$var$ops.LT
    },
    formatExclusiveMaximum: {
        okStr: "<",
        ok: $6c39c11c4b8c4d96$var$ops.LT,
        fail: $6c39c11c4b8c4d96$var$ops.GTE
    },
    formatExclusiveMinimum: {
        okStr: ">",
        ok: $6c39c11c4b8c4d96$var$ops.GT,
        fail: $6c39c11c4b8c4d96$var$ops.LTE
    }
};
const $6c39c11c4b8c4d96$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>$dYeWu.str`should be ${$6c39c11c4b8c4d96$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>$dYeWu._`{comparison: ${$6c39c11c4b8c4d96$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
module.exports.formatLimitDefinition = {
    keyword: Object.keys($6c39c11c4b8c4d96$var$KWDs),
    type: "string",
    schemaType: "string",
    $data: true,
    error: $6c39c11c4b8c4d96$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, keyword: keyword, it: it } = cxt;
        const { opts: opts, self: self } = it;
        if (!opts.validateFormats) return;
        const fCxt = new $7BPBD.KeywordCxt(it, self.RULES.all.format.definition, "format");
        if (fCxt.$data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fmt = gen.const("fmt", $dYeWu._`${fmts}[${fCxt.schemaCode}]`);
            cxt.fail$data($dYeWu.or($dYeWu._`typeof ${fmt} != "object"`, $dYeWu._`${fmt} instanceof RegExp`, $dYeWu._`typeof ${fmt}.compare != "function"`, compareCode(fmt)));
        }
        function validateFormat() {
            const format = fCxt.schema;
            const fmtDef = self.formats[format];
            if (!fmtDef || fmtDef === true) return;
            if (typeof fmtDef != "object" || fmtDef instanceof RegExp || typeof fmtDef.compare != "function") throw new Error(`"${keyword}": format "${format}" does not define "compare" function`);
            const fmt = gen.scopeValue("formats", {
                key: format,
                ref: fmtDef,
                code: opts.code.formats ? $dYeWu._`${opts.code.formats}${$dYeWu.getProperty(format)}` : undefined
            });
            cxt.fail$data(compareCode(fmt));
        }
        function compareCode(fmt) {
            return $dYeWu._`${fmt}.compare(${data}, ${schemaCode}) ${$6c39c11c4b8c4d96$var$KWDs[keyword].fail} 0`;
        }
    },
    dependencies: [
        "format"
    ]
};
const $6c39c11c4b8c4d96$var$formatLimitPlugin = (ajv)=>{
    ajv.addKeyword(module.exports.formatLimitDefinition);
    return ajv;
};
module.exports.default = $6c39c11c4b8c4d96$var$formatLimitPlugin;

});
parcelRegister("7BPBD", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;

var $horFH = parcelRequire("horFH");

var $15dSG = parcelRequire("15dSG");

var $aco7w = parcelRequire("aco7w");

var $lE94y = parcelRequire("lE94y");
const META_SUPPORT_DATA = [
    "/properties"
];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends $horFH.default {
    _addVocabularies() {
        super._addVocabularies();
        $15dSG.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword($aco7w.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        const metaSchema = this.opts.$data ? this.$dataMetaSchema($lE94y, META_SUPPORT_DATA) : $lE94y;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
exports.Ajv = Ajv;
module.exports = exports = Ajv;
module.exports.Ajv = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;

var $2yHXE = parcelRequire("2yHXE");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $2yHXE.KeywordCxt;
    }
});

var $dYeWu = parcelRequire("dYeWu");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $dYeWu._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $dYeWu.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $dYeWu.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $dYeWu.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $dYeWu.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $dYeWu.CodeGen;
    }
});

var $dadHg = parcelRequire("dadHg");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return $dadHg.default;
    }
});

var $7HCI9 = parcelRequire("7HCI9");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return $7HCI9.default;
    }
});

});
parcelRegister("horFH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $2yHXE = parcelRequire("2yHXE");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $2yHXE.KeywordCxt;
    }
});

var $dYeWu = parcelRequire("dYeWu");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $dYeWu._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $dYeWu.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $dYeWu.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $dYeWu.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $dYeWu.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $dYeWu.CodeGen;
    }
});

var $dadHg = parcelRequire("dadHg");

var $7HCI9 = parcelRequire("7HCI9");

var $fg7KZ = parcelRequire("fg7KZ");

var $dPtKJ = parcelRequire("dPtKJ");

var $dYeWu = parcelRequire("dYeWu");

var $k3Was = parcelRequire("k3Was");

var $fQkz4 = parcelRequire("fQkz4");

var $2qwj7 = parcelRequire("2qwj7");

var $fmgZL = parcelRequire("fmgZL");

var $2Pbnb = parcelRequire("2Pbnb");
const $ca9a2489479993bc$var$defaultRegExp = (str, flags)=>new RegExp(str, flags);
$ca9a2489479993bc$var$defaultRegExp.code = "new RegExp";
const $ca9a2489479993bc$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const $ca9a2489479993bc$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const $ca9a2489479993bc$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const $ca9a2489479993bc$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const $ca9a2489479993bc$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $ca9a2489479993bc$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $ca9a2489479993bc$var$defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $2Pbnb.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize: optimize,
            regExp: regExp
        } : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $ca9a2489479993bc$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $ca9a2489479993bc$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class $ca9a2489479993bc$var$Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...$ca9a2489479993bc$var$requiredOptions(opts)
        };
        const { es5: es5, lines: lines } = this.opts.code;
        this.scope = new $dYeWu.ValueScope({
            scope: {},
            prefixes: $ca9a2489479993bc$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $ca9a2489479993bc$var$getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $fg7KZ.getRules)();
        $ca9a2489479993bc$var$checkOptions.call(this, $ca9a2489479993bc$var$removedOptions, opts, "NOT SUPPORTED");
        $ca9a2489479993bc$var$checkOptions.call(this, $ca9a2489479993bc$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $ca9a2489479993bc$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $ca9a2489479993bc$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $ca9a2489479993bc$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $ca9a2489479993bc$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data: $data, meta: meta, schemaId: schemaId } = this.opts;
        let _dataRefSchema = $fmgZL;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$fmgZL
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta: meta, schemaId: schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema: loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref: $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof $7HCI9.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef: missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId: schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, $k3Was.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = $ca9a2489479993bc$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId: schemaId } = this.opts;
            const root = new $dPtKJ.SchemaEnv({
                schema: {},
                schemaId: schemaId
            });
            sch = $dPtKJ.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = $ca9a2489479993bc$var$getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, $k3Was.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        $ca9a2489479993bc$var$checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, $2qwj7.eachItem)(keyword, (kwd)=>$ca9a2489479993bc$var$addRule.call(this, kwd));
            return this;
        }
        $ca9a2489479993bc$var$keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, $fQkz4.getJSONTypes)(def.type),
            schemaType: (0, $fQkz4.getJSONTypes)(def.schemaType)
        };
        (0, $2qwj7.eachItem)(keyword, definition.type.length === 0 ? (k)=>$ca9a2489479993bc$var$addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>$ca9a2489479993bc$var$addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES: RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator: separator = ", ", dataVar: dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data: $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = $ca9a2489479993bc$var$schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId: schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, $k3Was.normalizeId)(id || baseId);
        const localRefs = $k3Was.getSchemaRefs.call(this, schema, baseId);
        sch = new $dPtKJ.SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            meta: meta,
            baseId: baseId,
            localRefs: localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else $dPtKJ.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            $dPtKJ.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
$ca9a2489479993bc$var$Ajv.ValidationError = $dadHg.default;
$ca9a2489479993bc$var$Ajv.MissingRefError = $7HCI9.default;
module.exports.default = $ca9a2489479993bc$var$Ajv;
function $ca9a2489479993bc$var$checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function $ca9a2489479993bc$var$getSchEnv(keyRef) {
    keyRef = (0, $k3Was.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $ca9a2489479993bc$var$addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $ca9a2489479993bc$var$addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $ca9a2489479993bc$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $ca9a2489479993bc$var$getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of $ca9a2489479993bc$var$META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const $ca9a2489479993bc$var$noLogs = {
    log () {},
    warn () {},
    error () {}
};
function $ca9a2489479993bc$var$getLogger(logger) {
    if (logger === false) return $ca9a2489479993bc$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const $ca9a2489479993bc$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $ca9a2489479993bc$var$checkKeyword(keyword, def) {
    const { RULES: RULES } = this;
    (0, $2qwj7.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!$ca9a2489479993bc$var$KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $ca9a2489479993bc$var$addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword: keyword,
        definition: {
            ...definition,
            type: (0, $fQkz4.getJSONTypes)(definition.type),
            schemaType: (0, $fQkz4.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) $ca9a2489479993bc$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function $ca9a2489479993bc$var$addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function $ca9a2489479993bc$var$keywordMetaschema(def) {
    let { metaSchema: metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $ca9a2489479993bc$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $ca9a2489479993bc$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $ca9a2489479993bc$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $ca9a2489479993bc$var$$dataRef
        ]
    };
}

});
parcelRegister("2yHXE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.KeywordCxt = module.exports.validateFunctionCode = void 0;

var $fDea2 = parcelRequire("fDea2");

var $fQkz4 = parcelRequire("fQkz4");

var $ekHgi = parcelRequire("ekHgi");

var $fQkz4 = parcelRequire("fQkz4");

var $kLUiA = parcelRequire("kLUiA");

var $4A0ru = parcelRequire("4A0ru");

var $1WUod = parcelRequire("1WUod");

var $dYeWu = parcelRequire("dYeWu");

var $dP98Q = parcelRequire("dP98Q");

var $k3Was = parcelRequire("k3Was");

var $2qwj7 = parcelRequire("2qwj7");

var $k5EIn = parcelRequire("k5EIn");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $1dd0db851032762e$var$validateFunctionCode(it) {
    if ($1dd0db851032762e$var$isSchemaObj(it)) {
        $1dd0db851032762e$var$checkKeywords(it);
        if ($1dd0db851032762e$var$schemaCxtHasRules(it)) {
            $1dd0db851032762e$var$topSchemaObjCode(it);
            return;
        }
    }
    $1dd0db851032762e$var$validateFunction(it, ()=>(0, $fDea2.topBoolOrEmptySchema)(it));
}
module.exports.validateFunctionCode = $1dd0db851032762e$var$validateFunctionCode;
function $1dd0db851032762e$var$validateFunction({ gen: gen, validateName: validateName, schema: schema, schemaEnv: schemaEnv, opts: opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, $dYeWu._)`${$dP98Q.default.data}, ${$dP98Q.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, $dYeWu._)`"use strict"; ${$1dd0db851032762e$var$funcSourceUrl(schema, opts)}`);
        $1dd0db851032762e$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $dYeWu._)`${$dP98Q.default.data}, ${$1dd0db851032762e$var$destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code($1dd0db851032762e$var$funcSourceUrl(schema, opts)).code(body));
}
function $1dd0db851032762e$var$destructureValCxt(opts) {
    return (0, $dYeWu._)`{${$dP98Q.default.instancePath}="", ${$dP98Q.default.parentData}, ${$dP98Q.default.parentDataProperty}, ${$dP98Q.default.rootData}=${$dP98Q.default.data}${opts.dynamicRef ? (0, $dYeWu._)`, ${$dP98Q.default.dynamicAnchors}={}` : $dYeWu.nil}}={}`;
}
function $1dd0db851032762e$var$destructureValCxtES5(gen, opts) {
    gen.if($dP98Q.default.valCxt, ()=>{
        gen.var($dP98Q.default.instancePath, (0, $dYeWu._)`${$dP98Q.default.valCxt}.${$dP98Q.default.instancePath}`);
        gen.var($dP98Q.default.parentData, (0, $dYeWu._)`${$dP98Q.default.valCxt}.${$dP98Q.default.parentData}`);
        gen.var($dP98Q.default.parentDataProperty, (0, $dYeWu._)`${$dP98Q.default.valCxt}.${$dP98Q.default.parentDataProperty}`);
        gen.var($dP98Q.default.rootData, (0, $dYeWu._)`${$dP98Q.default.valCxt}.${$dP98Q.default.rootData}`);
        if (opts.dynamicRef) gen.var($dP98Q.default.dynamicAnchors, (0, $dYeWu._)`${$dP98Q.default.valCxt}.${$dP98Q.default.dynamicAnchors}`);
    }, ()=>{
        gen.var($dP98Q.default.instancePath, (0, $dYeWu._)`""`);
        gen.var($dP98Q.default.parentData, (0, $dYeWu._)`undefined`);
        gen.var($dP98Q.default.parentDataProperty, (0, $dYeWu._)`undefined`);
        gen.var($dP98Q.default.rootData, $dP98Q.default.data);
        if (opts.dynamicRef) gen.var($dP98Q.default.dynamicAnchors, (0, $dYeWu._)`{}`);
    });
}
function $1dd0db851032762e$var$topSchemaObjCode(it) {
    const { schema: schema, opts: opts, gen: gen } = it;
    $1dd0db851032762e$var$validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) $1dd0db851032762e$var$commentKeyword(it);
        $1dd0db851032762e$var$checkNoDefault(it);
        gen.let($dP98Q.default.vErrors, null);
        gen.let($dP98Q.default.errors, 0);
        if (opts.unevaluated) $1dd0db851032762e$var$resetEvaluated(it);
        $1dd0db851032762e$var$typeAndKeywords(it);
        $1dd0db851032762e$var$returnResults(it);
    });
    return;
}
function $1dd0db851032762e$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen: gen, validateName: validateName } = it;
    it.evaluated = gen.const("evaluated", (0, $dYeWu._)`${validateName}.evaluated`);
    gen.if((0, $dYeWu._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, $dYeWu._)`${it.evaluated}.props`, (0, $dYeWu._)`undefined`));
    gen.if((0, $dYeWu._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, $dYeWu._)`${it.evaluated}.items`, (0, $dYeWu._)`undefined`));
}
function $1dd0db851032762e$var$funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $dYeWu._)`/*# sourceURL=${schId} */` : $dYeWu.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $1dd0db851032762e$var$subschemaCode(it, valid) {
    if ($1dd0db851032762e$var$isSchemaObj(it)) {
        $1dd0db851032762e$var$checkKeywords(it);
        if ($1dd0db851032762e$var$schemaCxtHasRules(it)) {
            $1dd0db851032762e$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $fDea2.boolOrEmptySchema)(it, valid);
}
function $1dd0db851032762e$var$schemaCxtHasRules({ schema: schema, self: self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $1dd0db851032762e$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $1dd0db851032762e$var$subSchemaObjCode(it, valid) {
    const { schema: schema, gen: gen, opts: opts } = it;
    if (opts.$comment && schema.$comment) $1dd0db851032762e$var$commentKeyword(it);
    $1dd0db851032762e$var$updateContext(it);
    $1dd0db851032762e$var$checkAsyncSchema(it);
    const errsCount = gen.const("_errs", $dP98Q.default.errors);
    $1dd0db851032762e$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $dYeWu._)`${errsCount} === ${$dP98Q.default.errors}`);
}
function $1dd0db851032762e$var$checkKeywords(it) {
    (0, $2qwj7.checkUnknownRules)(it);
    $1dd0db851032762e$var$checkRefsAndKeywords(it);
}
function $1dd0db851032762e$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $1dd0db851032762e$var$schemaKeywords(it, [], false, errsCount);
    const types = (0, $fQkz4.getSchemaTypes)(it.schema);
    const checkedTypes = (0, $fQkz4.coerceAndCheckDataType)(it, types);
    $1dd0db851032762e$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $1dd0db851032762e$var$checkRefsAndKeywords(it) {
    const { schema: schema, errSchemaPath: errSchemaPath, opts: opts, self: self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $2qwj7.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function $1dd0db851032762e$var$checkNoDefault(it) {
    const { schema: schema, opts: opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $2qwj7.checkStrictMode)(it, "default is ignored in the schema root");
}
function $1dd0db851032762e$var$updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $k3Was.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $1dd0db851032762e$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $1dd0db851032762e$var$commentKeyword({ gen: gen, schemaEnv: schemaEnv, schema: schema, errSchemaPath: errSchemaPath, opts: opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $dYeWu._)`${$dP98Q.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, $dYeWu.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $dYeWu._)`${$dP98Q.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function $1dd0db851032762e$var$returnResults(it) {
    const { gen: gen, schemaEnv: schemaEnv, validateName: validateName, ValidationError: ValidationError, opts: opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $dYeWu._)`${$dP98Q.default.errors} === 0`, ()=>gen.return($dP98Q.default.data), ()=>gen.throw((0, $dYeWu._)`new ${ValidationError}(${$dP98Q.default.vErrors})`));
    else {
        gen.assign((0, $dYeWu._)`${validateName}.errors`, $dP98Q.default.vErrors);
        if (opts.unevaluated) $1dd0db851032762e$var$assignEvaluated(it);
        gen.return((0, $dYeWu._)`${$dP98Q.default.errors} === 0`);
    }
}
function $1dd0db851032762e$var$assignEvaluated({ gen: gen, evaluated: evaluated, props: props, items: items }) {
    if (props instanceof $dYeWu.Name) gen.assign((0, $dYeWu._)`${evaluated}.props`, props);
    if (items instanceof $dYeWu.Name) gen.assign((0, $dYeWu._)`${evaluated}.items`, items);
}
function $1dd0db851032762e$var$schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen: gen, schema: schema, data: data, allErrors: allErrors, opts: opts, self: self } = it;
    const { RULES: RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $2qwj7.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>$1dd0db851032762e$var$keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) $1dd0db851032762e$var$checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, $ekHgi.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $fQkz4.checkDataType)(group.type, data, opts.strictNumbers));
            $1dd0db851032762e$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $fQkz4.reportTypeError)(it);
            }
            gen.endIf();
        } else $1dd0db851032762e$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $dYeWu._)`${$dP98Q.default.errors} === ${errsCount || 0}`);
    }
}
function $1dd0db851032762e$var$iterateKeywords(it, group) {
    const { gen: gen, schema: schema, opts: { useDefaults: useDefaults } } = it;
    if (useDefaults) (0, $kLUiA.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, $ekHgi.shouldUseRule)(schema, rule)) $1dd0db851032762e$var$keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function $1dd0db851032762e$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $1dd0db851032762e$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $1dd0db851032762e$var$checkMultipleTypes(it, types);
    $1dd0db851032762e$var$checkKeywordTypes(it, it.dataTypes);
}
function $1dd0db851032762e$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!$1dd0db851032762e$var$includesType(it.dataTypes, t)) $1dd0db851032762e$var$strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    $1dd0db851032762e$var$narrowSchemaTypes(it, types);
}
function $1dd0db851032762e$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $1dd0db851032762e$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $1dd0db851032762e$var$checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, $ekHgi.shouldUseRule)(it.schema, rule)) {
            const { type: type } = rule.definition;
            if (type.length && !type.some((t)=>$1dd0db851032762e$var$hasApplicableType(ts, t))) $1dd0db851032762e$var$strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function $1dd0db851032762e$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $1dd0db851032762e$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $1dd0db851032762e$var$narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes){
        if ($1dd0db851032762e$var$includesType(withTypes, t)) ts.push(t);
        else if (withTypes.includes("integer") && t === "number") ts.push("integer");
    }
    it.dataTypes = ts;
}
function $1dd0db851032762e$var$strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, $2qwj7.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class $1dd0db851032762e$var$KeywordCxt {
    constructor(it, def, keyword){
        (0, $4A0ru.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $2qwj7.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $1dd0db851032762e$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $4A0ru.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $dP98Q.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, $dYeWu.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, $dYeWu.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode: schemaCode } = this;
        this.fail((0, $dYeWu._)`${schemaCode} !== undefined && (${(0, $dYeWu.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? $k5EIn.reportExtraError : $k5EIn.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, $k5EIn.reportError)(this, this.def.$dataError || $k5EIn.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, $k5EIn.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = $dYeWu.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = $dYeWu.nil, $dataValid = $dYeWu.nil) {
        if (!this.$data) return;
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def } = this;
        gen.if((0, $dYeWu.or)((0, $dYeWu._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== $dYeWu.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== $dYeWu.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def, it: it } = this;
        return (0, $dYeWu.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof $dYeWu.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, $dYeWu._)`${(0, $fQkz4.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $fQkz4.DataType.Wrong)}`;
            }
            return $dYeWu.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, $dYeWu._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return $dYeWu.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, $1WUod.getSubschema)(this.it, appl);
        (0, $1WUod.extendSubschemaData)(subschema, this.it, appl);
        (0, $1WUod.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        $1dd0db851032762e$var$subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it: it, gen: gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = $2qwj7.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = $2qwj7.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it: it, gen: gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, $dYeWu.Name));
            return true;
        }
    }
}
module.exports.KeywordCxt = $1dd0db851032762e$var$KeywordCxt;
function $1dd0db851032762e$var$keywordCode(it, keyword, def, ruleType) {
    const cxt = new $1dd0db851032762e$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $4A0ru.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $4A0ru.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $4A0ru.funcKeywordCode)(cxt, def);
}
const $1dd0db851032762e$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const $1dd0db851032762e$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $1dd0db851032762e$var$getData($data, { dataLevel: dataLevel, dataNames: dataNames, dataPathArr: dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return $dP98Q.default.rootData;
    if ($data[0] === "/") {
        if (!$1dd0db851032762e$var$JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = $dP98Q.default.rootData;
    } else {
        const matches = $1dd0db851032762e$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, $dYeWu._)`${data}${(0, $dYeWu.getProperty)((0, $2qwj7.unescapeJsonPointer)(segment))}`;
        expr = (0, $dYeWu._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
module.exports.getData = $1dd0db851032762e$var$getData;

});
parcelRegister("fDea2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolOrEmptySchema = module.exports.topBoolOrEmptySchema = void 0;

var $k5EIn = parcelRequire("k5EIn");

var $dYeWu = parcelRequire("dYeWu");

var $dP98Q = parcelRequire("dP98Q");
const $b6157b9343051abb$var$boolError = {
    message: "boolean schema is false"
};
function $b6157b9343051abb$var$topBoolOrEmptySchema(it) {
    const { gen: gen, schema: schema, validateName: validateName } = it;
    if (schema === false) $b6157b9343051abb$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($dP98Q.default.data);
    else {
        gen.assign((0, $dYeWu._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
module.exports.topBoolOrEmptySchema = $b6157b9343051abb$var$topBoolOrEmptySchema;
function $b6157b9343051abb$var$boolOrEmptySchema(it, valid) {
    const { gen: gen, schema: schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $b6157b9343051abb$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
module.exports.boolOrEmptySchema = $b6157b9343051abb$var$boolOrEmptySchema;
function $b6157b9343051abb$var$falseSchemaError(it, overrideAllErrors) {
    const { gen: gen, data: data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $k5EIn.reportError)(cxt, $b6157b9343051abb$var$boolError, undefined, overrideAllErrors);
}

});
parcelRegister("k5EIn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendErrors = module.exports.resetErrorsCount = module.exports.reportExtraError = module.exports.reportError = module.exports.keyword$DataError = module.exports.keywordError = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $dP98Q = parcelRequire("dP98Q");
module.exports.keywordError = {
    message: ({ keyword: keyword })=>(0, $dYeWu.str)`must pass "${keyword}" keyword validation`
};
module.exports.keyword$DataError = {
    message: ({ keyword: keyword, schemaType: schemaType })=>schemaType ? (0, $dYeWu.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, $dYeWu.str)`"${keyword}" keyword is invalid ($data)`
};
function $ea03db64ce68baf8$var$reportError(cxt, error = module.exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $ea03db64ce68baf8$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $ea03db64ce68baf8$var$addError(gen, errObj);
    else $ea03db64ce68baf8$var$returnErrors(it, (0, $dYeWu._)`[${errObj}]`);
}
module.exports.reportError = $ea03db64ce68baf8$var$reportError;
function $ea03db64ce68baf8$var$reportExtraError(cxt, error = module.exports.keywordError, errorPaths) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $ea03db64ce68baf8$var$errorObjectCode(cxt, error, errorPaths);
    $ea03db64ce68baf8$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $ea03db64ce68baf8$var$returnErrors(it, $dP98Q.default.vErrors);
}
module.exports.reportExtraError = $ea03db64ce68baf8$var$reportExtraError;
function $ea03db64ce68baf8$var$resetErrorsCount(gen, errsCount) {
    gen.assign($dP98Q.default.errors, errsCount);
    gen.if((0, $dYeWu._)`${$dP98Q.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, $dYeWu._)`${$dP98Q.default.vErrors}.length`, errsCount), ()=>gen.assign($dP98Q.default.vErrors, null)));
}
module.exports.resetErrorsCount = $ea03db64ce68baf8$var$resetErrorsCount;
function $ea03db64ce68baf8$var$extendErrors({ gen: gen, keyword: keyword, schemaValue: schemaValue, data: data, errsCount: errsCount, it: it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, $dP98Q.default.errors, (i)=>{
        gen.const(err, (0, $dYeWu._)`${$dP98Q.default.vErrors}[${i}]`);
        gen.if((0, $dYeWu._)`${err}.instancePath === undefined`, ()=>gen.assign((0, $dYeWu._)`${err}.instancePath`, (0, $dYeWu.strConcat)($dP98Q.default.instancePath, it.errorPath)));
        gen.assign((0, $dYeWu._)`${err}.schemaPath`, (0, $dYeWu.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, $dYeWu._)`${err}.schema`, schemaValue);
            gen.assign((0, $dYeWu._)`${err}.data`, data);
        }
    });
}
module.exports.extendErrors = $ea03db64ce68baf8$var$extendErrors;
function $ea03db64ce68baf8$var$addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, $dYeWu._)`${$dP98Q.default.vErrors} === null`, ()=>gen.assign($dP98Q.default.vErrors, (0, $dYeWu._)`[${err}]`), (0, $dYeWu._)`${$dP98Q.default.vErrors}.push(${err})`);
    gen.code((0, $dYeWu._)`${$dP98Q.default.errors}++`);
}
function $ea03db64ce68baf8$var$returnErrors(it, errs) {
    const { gen: gen, validateName: validateName, schemaEnv: schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, $dYeWu._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, $dYeWu._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const $ea03db64ce68baf8$var$E = {
    keyword: new $dYeWu.Name("keyword"),
    schemaPath: new $dYeWu.Name("schemaPath"),
    params: new $dYeWu.Name("params"),
    propertyName: new $dYeWu.Name("propertyName"),
    message: new $dYeWu.Name("message"),
    schema: new $dYeWu.Name("schema"),
    parentSchema: new $dYeWu.Name("parentSchema")
};
function $ea03db64ce68baf8$var$errorObjectCode(cxt, error, errorPaths) {
    const { createErrors: createErrors } = cxt.it;
    if (createErrors === false) return (0, $dYeWu._)`{}`;
    return $ea03db64ce68baf8$var$errorObject(cxt, error, errorPaths);
}
function $ea03db64ce68baf8$var$errorObject(cxt, error, errorPaths = {}) {
    const { gen: gen, it: it } = cxt;
    const keyValues = [
        $ea03db64ce68baf8$var$errorInstancePath(it, errorPaths),
        $ea03db64ce68baf8$var$errorSchemaPath(cxt, errorPaths)
    ];
    $ea03db64ce68baf8$var$extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function $ea03db64ce68baf8$var$errorInstancePath({ errorPath: errorPath }, { instancePath: instancePath }) {
    const instPath = instancePath ? (0, $dYeWu.str)`${errorPath}${(0, $2qwj7.getErrorPath)(instancePath, $2qwj7.Type.Str)}` : errorPath;
    return [
        $dP98Q.default.instancePath,
        (0, $dYeWu.strConcat)($dP98Q.default.instancePath, instPath)
    ];
}
function $ea03db64ce68baf8$var$errorSchemaPath({ keyword: keyword, it: { errSchemaPath: errSchemaPath } }, { schemaPath: schemaPath, parentSchema: parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, $dYeWu.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, $dYeWu.str)`${schPath}${(0, $2qwj7.getErrorPath)(schemaPath, $2qwj7.Type.Str)}`;
    return [
        $ea03db64ce68baf8$var$E.schemaPath,
        schPath
    ];
}
function $ea03db64ce68baf8$var$extraErrorProps(cxt, { params: params, message: message }, keyValues) {
    const { keyword: keyword, data: data, schemaValue: schemaValue, it: it } = cxt;
    const { opts: opts, propertyName: propertyName, topSchemaRef: topSchemaRef, schemaPath: schemaPath } = it;
    keyValues.push([
        $ea03db64ce68baf8$var$E.keyword,
        keyword
    ], [
        $ea03db64ce68baf8$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $dYeWu._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        $ea03db64ce68baf8$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $ea03db64ce68baf8$var$E.schema,
        schemaValue
    ], [
        $ea03db64ce68baf8$var$E.parentSchema,
        (0, $dYeWu._)`${topSchemaRef}${schemaPath}`
    ], [
        $dP98Q.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $ea03db64ce68baf8$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRegister("dYeWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.or = module.exports.and = module.exports.not = module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;

var $8KKsO = parcelRequire("8KKsO");

var $7ZghD = parcelRequire("7ZghD");

var $8KKsO = parcelRequire("8KKsO");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $8KKsO._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $8KKsO.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function() {
        return $8KKsO.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $8KKsO.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function() {
        return $8KKsO.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $8KKsO.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return $8KKsO.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $8KKsO.Name;
    }
});

var $7ZghD = parcelRequire("7ZghD");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $7ZghD.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return $7ZghD.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return $7ZghD.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function() {
        return $7ZghD.varKinds;
    }
});
module.exports.operators = {
    GT: new $8KKsO._Code(">"),
    GTE: new $8KKsO._Code(">="),
    LT: new $8KKsO._Code("<"),
    LTE: new $8KKsO._Code("<="),
    EQ: new $8KKsO._Code("==="),
    NEQ: new $8KKsO._Code("!=="),
    NOT: new $8KKsO._Code("!"),
    OR: new $8KKsO._Code("||"),
    AND: new $8KKsO._Code("&&"),
    ADD: new $8KKsO._Code("+")
};
class $a2bc78349c8cecba$var$Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class $a2bc78349c8cecba$var$Def extends $a2bc78349c8cecba$var$Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5: es5, _n: _n }) {
        const varKind = es5 ? $7ZghD.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = $a2bc78349c8cecba$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof $8KKsO._CodeOrName ? this.rhs.names : {};
    }
}
class $a2bc78349c8cecba$var$Assign extends $a2bc78349c8cecba$var$Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n: _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof $8KKsO.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = $a2bc78349c8cecba$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof $8KKsO.Name ? {} : {
            ...this.lhs.names
        };
        return $a2bc78349c8cecba$var$addExprNames(names, this.rhs);
    }
}
class $a2bc78349c8cecba$var$AssignOp extends $a2bc78349c8cecba$var$Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n: _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class $a2bc78349c8cecba$var$Label extends $a2bc78349c8cecba$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        return `${this.label}:` + _n;
    }
}
class $a2bc78349c8cecba$var$Break extends $a2bc78349c8cecba$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class $a2bc78349c8cecba$var$Throw extends $a2bc78349c8cecba$var$Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n: _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class $a2bc78349c8cecba$var$AnyCode extends $a2bc78349c8cecba$var$Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n: _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = $a2bc78349c8cecba$var$optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof $8KKsO._CodeOrName ? this.code.names : {};
    }
}
class $a2bc78349c8cecba$var$ParentNode extends $a2bc78349c8cecba$var$Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            $a2bc78349c8cecba$var$subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>$a2bc78349c8cecba$var$addNames(names, n.names), {});
    }
}
class $a2bc78349c8cecba$var$BlockNode extends $a2bc78349c8cecba$var$ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class $a2bc78349c8cecba$var$Root extends $a2bc78349c8cecba$var$ParentNode {
}
class $a2bc78349c8cecba$var$Else extends $a2bc78349c8cecba$var$BlockNode {
}
$a2bc78349c8cecba$var$Else.kind = "else";
class $a2bc78349c8cecba$var$If extends $a2bc78349c8cecba$var$BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new $a2bc78349c8cecba$var$Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof $a2bc78349c8cecba$var$If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new $a2bc78349c8cecba$var$If($a2bc78349c8cecba$var$not(cond), e instanceof $a2bc78349c8cecba$var$If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = $a2bc78349c8cecba$var$optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        $a2bc78349c8cecba$var$addExprNames(names, this.condition);
        if (this.else) $a2bc78349c8cecba$var$addNames(names, this.else.names);
        return names;
    }
}
$a2bc78349c8cecba$var$If.kind = "if";
class $a2bc78349c8cecba$var$For extends $a2bc78349c8cecba$var$BlockNode {
}
$a2bc78349c8cecba$var$For.kind = "for";
class $a2bc78349c8cecba$var$ForLoop extends $a2bc78349c8cecba$var$For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = $a2bc78349c8cecba$var$optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return $a2bc78349c8cecba$var$addNames(super.names, this.iteration.names);
    }
}
class $a2bc78349c8cecba$var$ForRange extends $a2bc78349c8cecba$var$For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? $7ZghD.varKinds.var : this.varKind;
        const { name: name, from: from, to: to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = $a2bc78349c8cecba$var$addExprNames(super.names, this.from);
        return $a2bc78349c8cecba$var$addExprNames(names, this.to);
    }
}
class $a2bc78349c8cecba$var$ForIter extends $a2bc78349c8cecba$var$For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = $a2bc78349c8cecba$var$optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return $a2bc78349c8cecba$var$addNames(super.names, this.iterable.names);
    }
}
class $a2bc78349c8cecba$var$Func extends $a2bc78349c8cecba$var$BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
$a2bc78349c8cecba$var$Func.kind = "func";
class $a2bc78349c8cecba$var$Return extends $a2bc78349c8cecba$var$ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
$a2bc78349c8cecba$var$Return.kind = "return";
class $a2bc78349c8cecba$var$Try extends $a2bc78349c8cecba$var$BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) $a2bc78349c8cecba$var$addNames(names, this.catch.names);
        if (this.finally) $a2bc78349c8cecba$var$addNames(names, this.finally.names);
        return names;
    }
}
class $a2bc78349c8cecba$var$Catch extends $a2bc78349c8cecba$var$BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
$a2bc78349c8cecba$var$Catch.kind = "catch";
class $a2bc78349c8cecba$var$Finally extends $a2bc78349c8cecba$var$BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
$a2bc78349c8cecba$var$Finally.kind = "finally";
class $a2bc78349c8cecba$var$CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new $7ZghD.Scope({
            parent: extScope
        });
        this._nodes = [
            new $a2bc78349c8cecba$var$Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new $a2bc78349c8cecba$var$Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def($7ZghD.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def($7ZghD.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def($7ZghD.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new $a2bc78349c8cecba$var$Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new $a2bc78349c8cecba$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== $8KKsO.nil) this._leafNode(new $a2bc78349c8cecba$var$AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, $8KKsO.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new $8KKsO._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new $a2bc78349c8cecba$var$If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new $a2bc78349c8cecba$var$If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new $a2bc78349c8cecba$var$Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode($a2bc78349c8cecba$var$If, $a2bc78349c8cecba$var$Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new $a2bc78349c8cecba$var$ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? $7ZghD.varKinds.var : $7ZghD.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $a2bc78349c8cecba$var$ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = $7ZghD.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof $8KKsO.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, $8KKsO._)`${arr}.length`, (i)=>{
                this.var(name, (0, $8KKsO._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new $a2bc78349c8cecba$var$ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? $7ZghD.varKinds.var : $7ZghD.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $8KKsO._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $a2bc78349c8cecba$var$ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode($a2bc78349c8cecba$var$For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new $a2bc78349c8cecba$var$Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new $a2bc78349c8cecba$var$Break(label));
    }
    // `return` statement
    return(value) {
        const node = new $a2bc78349c8cecba$var$Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode($a2bc78349c8cecba$var$Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new $a2bc78349c8cecba$var$Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new $a2bc78349c8cecba$var$Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new $a2bc78349c8cecba$var$Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode($a2bc78349c8cecba$var$Catch, $a2bc78349c8cecba$var$Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new $a2bc78349c8cecba$var$Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = $8KKsO.nil, async, funcBody) {
        this._blockNode(new $a2bc78349c8cecba$var$Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode($a2bc78349c8cecba$var$Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof $a2bc78349c8cecba$var$If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
module.exports.CodeGen = $a2bc78349c8cecba$var$CodeGen;
function $a2bc78349c8cecba$var$addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $a2bc78349c8cecba$var$addExprNames(names, from) {
    return from instanceof $8KKsO._CodeOrName ? $a2bc78349c8cecba$var$addNames(names, from.names) : names;
}
function $a2bc78349c8cecba$var$optimizeExpr(expr, names, constants) {
    if (expr instanceof $8KKsO.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $8KKsO._Code(expr._items.reduce((items, c)=>{
        if (c instanceof $8KKsO.Name) c = replaceName(c);
        if (c instanceof $8KKsO._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof $8KKsO._Code && e._items.some((c)=>c instanceof $8KKsO.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function $a2bc78349c8cecba$var$subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $a2bc78349c8cecba$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $8KKsO._)`!${$a2bc78349c8cecba$var$par(x)}`;
}
module.exports.not = $a2bc78349c8cecba$var$not;
const $a2bc78349c8cecba$var$andCode = $a2bc78349c8cecba$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $a2bc78349c8cecba$var$and(...args) {
    return args.reduce($a2bc78349c8cecba$var$andCode);
}
module.exports.and = $a2bc78349c8cecba$var$and;
const $a2bc78349c8cecba$var$orCode = $a2bc78349c8cecba$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $a2bc78349c8cecba$var$or(...args) {
    return args.reduce($a2bc78349c8cecba$var$orCode);
}
module.exports.or = $a2bc78349c8cecba$var$or;
function $a2bc78349c8cecba$var$mappend(op) {
    return (x, y)=>x === $8KKsO.nil ? y : y === $8KKsO.nil ? x : (0, $8KKsO._)`${$a2bc78349c8cecba$var$par(x)} ${op} ${$a2bc78349c8cecba$var$par(y)}`;
}
function $a2bc78349c8cecba$var$par(x) {
    return x instanceof $8KKsO.Name ? x : (0, $8KKsO._)`(${x})`;
}

});
parcelRegister("8KKsO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regexpCode = module.exports.getEsmExportName = module.exports.getProperty = module.exports.safeStringify = module.exports.stringify = module.exports.strConcat = module.exports.addCodeArg = module.exports.str = module.exports._ = module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
class $65f6a95271352053$var$_CodeOrName {
}
module.exports._CodeOrName = $65f6a95271352053$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class $65f6a95271352053$var$Name extends $65f6a95271352053$var$_CodeOrName {
    constructor(s){
        super();
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
module.exports.Name = $65f6a95271352053$var$Name;
class $65f6a95271352053$var$_Code extends $65f6a95271352053$var$_CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof $65f6a95271352053$var$Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
module.exports._Code = $65f6a95271352053$var$_Code;
module.exports.nil = new $65f6a95271352053$var$_Code("");
function $65f6a95271352053$var$_(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        $65f6a95271352053$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $65f6a95271352053$var$_Code(code);
}
module.exports._ = $65f6a95271352053$var$_;
const $65f6a95271352053$var$plus = new $65f6a95271352053$var$_Code("+");
function $65f6a95271352053$var$str(strs, ...args) {
    const expr = [
        $65f6a95271352053$var$safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push($65f6a95271352053$var$plus);
        $65f6a95271352053$var$addCodeArg(expr, args[i]);
        expr.push($65f6a95271352053$var$plus, $65f6a95271352053$var$safeStringify(strs[++i]));
    }
    $65f6a95271352053$var$optimize(expr);
    return new $65f6a95271352053$var$_Code(expr);
}
module.exports.str = $65f6a95271352053$var$str;
function $65f6a95271352053$var$addCodeArg(code, arg) {
    if (arg instanceof $65f6a95271352053$var$_Code) code.push(...arg._items);
    else if (arg instanceof $65f6a95271352053$var$Name) code.push(arg);
    else code.push($65f6a95271352053$var$interpolate(arg));
}
module.exports.addCodeArg = $65f6a95271352053$var$addCodeArg;
function $65f6a95271352053$var$optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $65f6a95271352053$var$plus) {
            const res = $65f6a95271352053$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $65f6a95271352053$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $65f6a95271352053$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $65f6a95271352053$var$Name)) return `"${a}${b.slice(1)}`;
    return;
}
function $65f6a95271352053$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $65f6a95271352053$var$str`${c1}${c2}`;
}
module.exports.strConcat = $65f6a95271352053$var$strConcat;
// TODO do not allow arrays here
function $65f6a95271352053$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $65f6a95271352053$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $65f6a95271352053$var$stringify(x) {
    return new $65f6a95271352053$var$_Code($65f6a95271352053$var$safeStringify(x));
}
module.exports.stringify = $65f6a95271352053$var$stringify;
function $65f6a95271352053$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
module.exports.safeStringify = $65f6a95271352053$var$safeStringify;
function $65f6a95271352053$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $65f6a95271352053$var$_Code(`.${key}`) : $65f6a95271352053$var$_`[${key}]`;
}
module.exports.getProperty = $65f6a95271352053$var$getProperty;
//Does best effort to format the name properly
function $65f6a95271352053$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $65f6a95271352053$var$_Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
module.exports.getEsmExportName = $65f6a95271352053$var$getEsmExportName;
function $65f6a95271352053$var$regexpCode(rx) {
    return new $65f6a95271352053$var$_Code(rx.toString());
}
module.exports.regexpCode = $65f6a95271352053$var$regexpCode;

});

parcelRegister("7ZghD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $8KKsO = parcelRequire("8KKsO");
class $5d0adc77b45672fc$var$ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var $5d0adc77b45672fc$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($5d0adc77b45672fc$var$UsedValueState || (module.exports.UsedValueState = $5d0adc77b45672fc$var$UsedValueState = {}));
module.exports.varKinds = {
    const: new $8KKsO.Name("const"),
    let: new $8KKsO.Name("let"),
    var: new $8KKsO.Name("var")
};
class $5d0adc77b45672fc$var$Scope {
    constructor({ prefixes: prefixes, parent: parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof $8KKsO.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new $8KKsO.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix: prefix,
            index: 0
        };
    }
}
module.exports.Scope = $5d0adc77b45672fc$var$Scope;
class $5d0adc77b45672fc$var$ValueScopeName extends $8KKsO.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property: property, itemIndex: itemIndex }) {
        this.value = value;
        this.scopePath = (0, $8KKsO._)`.${new $8KKsO.Name(property)}[${itemIndex}]`;
    }
}
module.exports.ValueScopeName = $5d0adc77b45672fc$var$ValueScopeName;
const $5d0adc77b45672fc$var$line = (0, $8KKsO._)`\n`;
class $5d0adc77b45672fc$var$ValueScope extends $5d0adc77b45672fc$var$Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? $5d0adc77b45672fc$var$line : $8KKsO.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new $5d0adc77b45672fc$var$ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix: prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex: itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, $8KKsO._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = $8KKsO.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, $5d0adc77b45672fc$var$UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                    code = (0, $8KKsO._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $8KKsO._)`${code}${c}${this.opts._n}`;
                else throw new $5d0adc77b45672fc$var$ValueError(name);
                nameSet.set(name, $5d0adc77b45672fc$var$UsedValueState.Completed);
            });
        }
        return code;
    }
}
module.exports.ValueScope = $5d0adc77b45672fc$var$ValueScope;

});


parcelRegister("2qwj7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkStrictMode = module.exports.getErrorPath = module.exports.Type = module.exports.useFunc = module.exports.setEvaluated = module.exports.evaluatedPropsToName = module.exports.mergeEvaluated = module.exports.eachItem = module.exports.unescapeJsonPointer = module.exports.escapeJsonPointer = module.exports.escapeFragment = module.exports.unescapeFragment = module.exports.schemaRefOrVal = module.exports.schemaHasRulesButRef = module.exports.schemaHasRules = module.exports.checkUnknownRules = module.exports.alwaysValidSchema = module.exports.toHash = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $8KKsO = parcelRequire("8KKsO");
// TODO refactor to use Set
function $1c47120fe13c0772$var$toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
module.exports.toHash = $1c47120fe13c0772$var$toHash;
function $1c47120fe13c0772$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $1c47120fe13c0772$var$checkUnknownRules(it, schema);
    return !$1c47120fe13c0772$var$schemaHasRules(schema, it.self.RULES.all);
}
module.exports.alwaysValidSchema = $1c47120fe13c0772$var$alwaysValidSchema;
function $1c47120fe13c0772$var$checkUnknownRules(it, schema = it.schema) {
    const { opts: opts, self: self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) $1c47120fe13c0772$var$checkStrictMode(it, `unknown keyword: "${key}"`);
}
module.exports.checkUnknownRules = $1c47120fe13c0772$var$checkUnknownRules;
function $1c47120fe13c0772$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
module.exports.schemaHasRules = $1c47120fe13c0772$var$schemaHasRules;
function $1c47120fe13c0772$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
module.exports.schemaHasRulesButRef = $1c47120fe13c0772$var$schemaHasRulesButRef;
function $1c47120fe13c0772$var$schemaRefOrVal({ topSchemaRef: topSchemaRef, schemaPath: schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $dYeWu._)`${schema}`;
    }
    return (0, $dYeWu._)`${topSchemaRef}${schemaPath}${(0, $dYeWu.getProperty)(keyword)}`;
}
module.exports.schemaRefOrVal = $1c47120fe13c0772$var$schemaRefOrVal;
function $1c47120fe13c0772$var$unescapeFragment(str) {
    return $1c47120fe13c0772$var$unescapeJsonPointer(decodeURIComponent(str));
}
module.exports.unescapeFragment = $1c47120fe13c0772$var$unescapeFragment;
function $1c47120fe13c0772$var$escapeFragment(str) {
    return encodeURIComponent($1c47120fe13c0772$var$escapeJsonPointer(str));
}
module.exports.escapeFragment = $1c47120fe13c0772$var$escapeFragment;
function $1c47120fe13c0772$var$escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
module.exports.escapeJsonPointer = $1c47120fe13c0772$var$escapeJsonPointer;
function $1c47120fe13c0772$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
module.exports.unescapeJsonPointer = $1c47120fe13c0772$var$unescapeJsonPointer;
function $1c47120fe13c0772$var$eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
module.exports.eachItem = $1c47120fe13c0772$var$eachItem;
function $1c47120fe13c0772$var$makeMergeEvaluated({ mergeNames: mergeNames, mergeToName: mergeToName, mergeValues: mergeValues, resultToName: resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof $dYeWu.Name ? (from instanceof $dYeWu.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $dYeWu.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $dYeWu.Name && !(res instanceof $dYeWu.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $1c47120fe13c0772$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $dYeWu._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, $dYeWu._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, $dYeWu._)`${to} || {}`).code((0, $dYeWu._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, $dYeWu._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $dYeWu._)`${to} || {}`);
                    $1c47120fe13c0772$var$setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: $1c47120fe13c0772$var$evaluatedPropsToName
    }),
    items: $1c47120fe13c0772$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $dYeWu._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, $dYeWu._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, $dYeWu._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, $dYeWu._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function $1c47120fe13c0772$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, $dYeWu._)`{}`);
    if (ps !== undefined) $1c47120fe13c0772$var$setEvaluated(gen, props, ps);
    return props;
}
module.exports.evaluatedPropsToName = $1c47120fe13c0772$var$evaluatedPropsToName;
function $1c47120fe13c0772$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, $dYeWu._)`${props}${(0, $dYeWu.getProperty)(p)}`, true));
}
module.exports.setEvaluated = $1c47120fe13c0772$var$setEvaluated;
const $1c47120fe13c0772$var$snippets = {};
function $1c47120fe13c0772$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $1c47120fe13c0772$var$snippets[f.code] || ($1c47120fe13c0772$var$snippets[f.code] = new $8KKsO._Code(f.code))
    });
}
module.exports.useFunc = $1c47120fe13c0772$var$useFunc;
var $1c47120fe13c0772$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($1c47120fe13c0772$var$Type || (module.exports.Type = $1c47120fe13c0772$var$Type = {}));
function $1c47120fe13c0772$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $dYeWu.Name) {
        const isNumber = dataPropType === $1c47120fe13c0772$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $dYeWu._)`"[" + ${dataProp} + "]"` : (0, $dYeWu._)`"['" + ${dataProp} + "']"` : isNumber ? (0, $dYeWu._)`"/" + ${dataProp}` : (0, $dYeWu._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $dYeWu.getProperty)(dataProp).toString() : "/" + $1c47120fe13c0772$var$escapeJsonPointer(dataProp);
}
module.exports.getErrorPath = $1c47120fe13c0772$var$getErrorPath;
function $1c47120fe13c0772$var$checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
module.exports.checkStrictMode = $1c47120fe13c0772$var$checkStrictMode;

});

parcelRegister("dP98Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");
const $a10721243c8accf4$var$names = {
    // validation function arguments
    data: new $dYeWu.Name("data"),
    // args passed from referencing schema
    valCxt: new $dYeWu.Name("valCxt"),
    instancePath: new $dYeWu.Name("instancePath"),
    parentData: new $dYeWu.Name("parentData"),
    parentDataProperty: new $dYeWu.Name("parentDataProperty"),
    rootData: new $dYeWu.Name("rootData"),
    dynamicAnchors: new $dYeWu.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new $dYeWu.Name("vErrors"),
    errors: new $dYeWu.Name("errors"),
    this: new $dYeWu.Name("this"),
    // "globals"
    self: new $dYeWu.Name("self"),
    scope: new $dYeWu.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $dYeWu.Name("json"),
    jsonPos: new $dYeWu.Name("jsonPos"),
    jsonLen: new $dYeWu.Name("jsonLen"),
    jsonPart: new $dYeWu.Name("jsonPart")
};
module.exports.default = $a10721243c8accf4$var$names;

});



parcelRegister("fQkz4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportTypeError = module.exports.checkDataTypes = module.exports.checkDataType = module.exports.coerceAndCheckDataType = module.exports.getJSONTypes = module.exports.getSchemaTypes = module.exports.DataType = void 0;

var $fg7KZ = parcelRequire("fg7KZ");

var $ekHgi = parcelRequire("ekHgi");

var $k5EIn = parcelRequire("k5EIn");

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");
var $b88baa14336caaba$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($b88baa14336caaba$var$DataType || (module.exports.DataType = $b88baa14336caaba$var$DataType = {}));
function $b88baa14336caaba$var$getSchemaTypes(schema) {
    const types = $b88baa14336caaba$var$getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
module.exports.getSchemaTypes = $b88baa14336caaba$var$getSchemaTypes;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
function $b88baa14336caaba$var$getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($fg7KZ.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
module.exports.getJSONTypes = $b88baa14336caaba$var$getJSONTypes;
function $b88baa14336caaba$var$coerceAndCheckDataType(it, types) {
    const { gen: gen, data: data, opts: opts } = it;
    const coerceTo = $b88baa14336caaba$var$coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $ekHgi.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = $b88baa14336caaba$var$checkDataTypes(types, data, opts.strictNumbers, $b88baa14336caaba$var$DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) $b88baa14336caaba$var$coerceData(it, types, coerceTo);
            else $b88baa14336caaba$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
module.exports.coerceAndCheckDataType = $b88baa14336caaba$var$coerceAndCheckDataType;
const $b88baa14336caaba$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $b88baa14336caaba$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>$b88baa14336caaba$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function $b88baa14336caaba$var$coerceData(it, types, coerceTo) {
    const { gen: gen, data: data, opts: opts } = it;
    const dataType = gen.let("dataType", (0, $dYeWu._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, $dYeWu._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, $dYeWu._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, $dYeWu._)`${data}[0]`).assign(dataType, (0, $dYeWu._)`typeof ${data}`).if($b88baa14336caaba$var$checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, $dYeWu._)`${coerced} !== undefined`);
    for (const t of coerceTo)if ($b88baa14336caaba$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    $b88baa14336caaba$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $dYeWu._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        $b88baa14336caaba$var$assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $dYeWu._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, $dYeWu._)`"" + ${data}`).elseIf((0, $dYeWu._)`${data} === null`).assign(coerced, (0, $dYeWu._)`""`);
                return;
            case "number":
                gen.elseIf((0, $dYeWu._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, $dYeWu._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, $dYeWu._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, $dYeWu._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, $dYeWu._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, $dYeWu._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $dYeWu._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $dYeWu._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, $dYeWu._)`[${data}]`);
        }
    }
}
function $b88baa14336caaba$var$assignParentData({ gen: gen, parentData: parentData, parentDataProperty: parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, $dYeWu._)`${parentData} !== undefined`, ()=>gen.assign((0, $dYeWu._)`${parentData}[${parentDataProperty}]`, expr));
}
function $b88baa14336caaba$var$checkDataType(dataType, data, strictNums, correct = $b88baa14336caaba$var$DataType.Correct) {
    const EQ = correct === $b88baa14336caaba$var$DataType.Correct ? $dYeWu.operators.EQ : $dYeWu.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, $dYeWu._)`${data} ${EQ} null`;
        case "array":
            cond = (0, $dYeWu._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, $dYeWu._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, $dYeWu._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $dYeWu._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === $b88baa14336caaba$var$DataType.Correct ? cond : (0, $dYeWu.not)(cond);
    function numCond(_cond = $dYeWu.nil) {
        return (0, $dYeWu.and)((0, $dYeWu._)`typeof ${data} == "number"`, _cond, strictNums ? (0, $dYeWu._)`isFinite(${data})` : $dYeWu.nil);
    }
}
module.exports.checkDataType = $b88baa14336caaba$var$checkDataType;
function $b88baa14336caaba$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $b88baa14336caaba$var$checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, $2qwj7.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, $dYeWu._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, $dYeWu._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $dYeWu.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, $dYeWu.and)(cond, $b88baa14336caaba$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
module.exports.checkDataTypes = $b88baa14336caaba$var$checkDataTypes;
const $b88baa14336caaba$var$typeError = {
    message: ({ schema: schema })=>`must be ${schema}`,
    params: ({ schema: schema, schemaValue: schemaValue })=>typeof schema == "string" ? (0, $dYeWu._)`{type: ${schema}}` : (0, $dYeWu._)`{type: ${schemaValue}}`
};
function $b88baa14336caaba$var$reportTypeError(it) {
    const cxt = $b88baa14336caaba$var$getTypeErrorContext(it);
    (0, $k5EIn.reportError)(cxt, $b88baa14336caaba$var$typeError);
}
module.exports.reportTypeError = $b88baa14336caaba$var$reportTypeError;
function $b88baa14336caaba$var$getTypeErrorContext(it) {
    const { gen: gen, data: data, schema: schema } = it;
    const schemaCode = (0, $2qwj7.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRegister("fg7KZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRules = module.exports.isJSONType = void 0;
const $b1be5dfbeba0d769$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const $b1be5dfbeba0d769$var$jsonTypes = new Set($b1be5dfbeba0d769$var$_jsonTypes);
function $b1be5dfbeba0d769$var$isJSONType(x) {
    return typeof x == "string" && $b1be5dfbeba0d769$var$jsonTypes.has(x);
}
module.exports.isJSONType = $b1be5dfbeba0d769$var$isJSONType;
function $b1be5dfbeba0d769$var$getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
module.exports.getRules = $b1be5dfbeba0d769$var$getRules;

});

parcelRegister("ekHgi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldUseRule = module.exports.shouldUseGroup = module.exports.schemaHasRulesForType = void 0;
function $a6f47dd230b4ff84$var$schemaHasRulesForType({ schema: schema, self: self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && $a6f47dd230b4ff84$var$shouldUseGroup(schema, group);
}
module.exports.schemaHasRulesForType = $a6f47dd230b4ff84$var$schemaHasRulesForType;
function $a6f47dd230b4ff84$var$shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>$a6f47dd230b4ff84$var$shouldUseRule(schema, rule));
}
module.exports.shouldUseGroup = $a6f47dd230b4ff84$var$shouldUseGroup;
function $a6f47dd230b4ff84$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
module.exports.shouldUseRule = $a6f47dd230b4ff84$var$shouldUseRule;

});


parcelRegister("kLUiA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");
function $f1f3de33dbe34bdf$var$assignDefaults(it, ty) {
    const { properties: properties, items: items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)$f1f3de33dbe34bdf$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>$f1f3de33dbe34bdf$var$assignDefault(it, i, sch.default));
}
module.exports.assignDefaults = $f1f3de33dbe34bdf$var$assignDefaults;
function $f1f3de33dbe34bdf$var$assignDefault(it, prop, defaultValue) {
    const { gen: gen, compositeRule: compositeRule, data: data, opts: opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, $dYeWu._)`${data}${(0, $dYeWu.getProperty)(prop)}`;
    if (compositeRule) {
        (0, $2qwj7.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, $dYeWu._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, $dYeWu._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $dYeWu._)`${childData} = ${(0, $dYeWu.stringify)(defaultValue)}`);
}

});

parcelRegister("4A0ru", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateKeywordUsage = module.exports.validSchemaType = module.exports.funcKeywordCode = module.exports.macroKeywordCode = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $dP98Q = parcelRequire("dP98Q");

var $9vIlD = parcelRequire("9vIlD");

var $k5EIn = parcelRequire("k5EIn");
function $355ade0e42f31f9b$var$macroKeywordCode(cxt, def) {
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, it: it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = $355ade0e42f31f9b$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $dYeWu.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
module.exports.macroKeywordCode = $355ade0e42f31f9b$var$macroKeywordCode;
function $355ade0e42f31f9b$var$funcKeywordCode(cxt, def) {
    var _a;
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, $data: $data, it: it } = cxt;
    $355ade0e42f31f9b$var$checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = $355ade0e42f31f9b$var$useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $355ade0e42f31f9b$var$modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $355ade0e42f31f9b$var$modifyData(cxt);
            reportErrs(()=>$355ade0e42f31f9b$var$addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, $dYeWu._)`await `), (e)=>gen.assign(valid, false).if((0, $dYeWu._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, $dYeWu._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, $dYeWu._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid($dYeWu.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, $dYeWu._)`await ` : $dYeWu.nil) {
        const passCxt = it.opts.passContext ? $dP98Q.default.this : $dP98Q.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $dYeWu._)`${_await}${(0, $9vIlD.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, $dYeWu.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
module.exports.funcKeywordCode = $355ade0e42f31f9b$var$funcKeywordCode;
function $355ade0e42f31f9b$var$modifyData(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, $dYeWu._)`${it.parentData}[${it.parentDataProperty}]`));
}
function $355ade0e42f31f9b$var$addErrs(cxt, errs) {
    const { gen: gen } = cxt;
    gen.if((0, $dYeWu._)`Array.isArray(${errs})`, ()=>{
        gen.assign($dP98Q.default.vErrors, (0, $dYeWu._)`${$dP98Q.default.vErrors} === null ? ${errs} : ${$dP98Q.default.vErrors}.concat(${errs})`).assign($dP98Q.default.errors, (0, $dYeWu._)`${$dP98Q.default.vErrors}.length`);
        (0, $k5EIn.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function $355ade0e42f31f9b$var$checkAsyncKeyword({ schemaEnv: schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $355ade0e42f31f9b$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $dYeWu.stringify)(result)
    });
}
function $355ade0e42f31f9b$var$validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
module.exports.validSchemaType = $355ade0e42f31f9b$var$validSchemaType;
function $355ade0e42f31f9b$var$validateKeywordUsage({ schema: schema, opts: opts, self: self, errSchemaPath: errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
module.exports.validateKeywordUsage = $355ade0e42f31f9b$var$validateKeywordUsage;

});
parcelRegister("9vIlD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateUnion = module.exports.validateArray = module.exports.usePattern = module.exports.callValidateCode = module.exports.schemaProperties = module.exports.allSchemaProperties = module.exports.noPropertyInData = module.exports.propertyInData = module.exports.isOwnProperty = module.exports.hasPropFunc = module.exports.reportMissingProp = module.exports.checkMissingProp = module.exports.checkReportMissingProp = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $dP98Q = parcelRequire("dP98Q");

var $2qwj7 = parcelRequire("2qwj7");
function $6ec968de004d5c7c$var$checkReportMissingProp(cxt, prop) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if($6ec968de004d5c7c$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, $dYeWu._)`${prop}`
        }, true);
        cxt.error();
    });
}
module.exports.checkReportMissingProp = $6ec968de004d5c7c$var$checkReportMissingProp;
function $6ec968de004d5c7c$var$checkMissingProp({ gen: gen, data: data, it: { opts: opts } }, properties, missing) {
    return (0, $dYeWu.or)(...properties.map((prop)=>(0, $dYeWu.and)($6ec968de004d5c7c$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $dYeWu._)`${missing} = ${prop}`)));
}
module.exports.checkMissingProp = $6ec968de004d5c7c$var$checkMissingProp;
function $6ec968de004d5c7c$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
module.exports.reportMissingProp = $6ec968de004d5c7c$var$reportMissingProp;
function $6ec968de004d5c7c$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $dYeWu._)`Object.prototype.hasOwnProperty`
    });
}
module.exports.hasPropFunc = $6ec968de004d5c7c$var$hasPropFunc;
function $6ec968de004d5c7c$var$isOwnProperty(gen, data, property) {
    return (0, $dYeWu._)`${$6ec968de004d5c7c$var$hasPropFunc(gen)}.call(${data}, ${property})`;
}
module.exports.isOwnProperty = $6ec968de004d5c7c$var$isOwnProperty;
function $6ec968de004d5c7c$var$propertyInData(gen, data, property, ownProperties) {
    const cond = (0, $dYeWu._)`${data}${(0, $dYeWu.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, $dYeWu._)`${cond} && ${$6ec968de004d5c7c$var$isOwnProperty(gen, data, property)}` : cond;
}
module.exports.propertyInData = $6ec968de004d5c7c$var$propertyInData;
function $6ec968de004d5c7c$var$noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, $dYeWu._)`${data}${(0, $dYeWu.getProperty)(property)} === undefined`;
    return ownProperties ? (0, $dYeWu.or)(cond, (0, $dYeWu.not)($6ec968de004d5c7c$var$isOwnProperty(gen, data, property))) : cond;
}
module.exports.noPropertyInData = $6ec968de004d5c7c$var$noPropertyInData;
function $6ec968de004d5c7c$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
module.exports.allSchemaProperties = $6ec968de004d5c7c$var$allSchemaProperties;
function $6ec968de004d5c7c$var$schemaProperties(it, schemaMap) {
    return $6ec968de004d5c7c$var$allSchemaProperties(schemaMap).filter((p)=>!(0, $2qwj7.alwaysValidSchema)(it, schemaMap[p]));
}
module.exports.schemaProperties = $6ec968de004d5c7c$var$schemaProperties;
function $6ec968de004d5c7c$var$callValidateCode({ schemaCode: schemaCode, data: data, it: { gen: gen, topSchemaRef: topSchemaRef, schemaPath: schemaPath, errorPath: errorPath }, it: it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, $dYeWu._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            $dP98Q.default.instancePath,
            (0, $dYeWu.strConcat)($dP98Q.default.instancePath, errorPath)
        ],
        [
            $dP98Q.default.parentData,
            it.parentData
        ],
        [
            $dP98Q.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $dP98Q.default.rootData,
            $dP98Q.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $dP98Q.default.dynamicAnchors,
        $dP98Q.default.dynamicAnchors
    ]);
    const args = (0, $dYeWu._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== $dYeWu.nil ? (0, $dYeWu._)`${func}.call(${context}, ${args})` : (0, $dYeWu._)`${func}(${args})`;
}
module.exports.callValidateCode = $6ec968de004d5c7c$var$callValidateCode;
const $6ec968de004d5c7c$var$newRegExp = (0, $dYeWu._)`new RegExp`;
function $6ec968de004d5c7c$var$usePattern({ gen: gen, it: { opts: opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp: regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $dYeWu._)`${regExp.code === "new RegExp" ? $6ec968de004d5c7c$var$newRegExp : (0, $2qwj7.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
module.exports.usePattern = $6ec968de004d5c7c$var$usePattern;
function $6ec968de004d5c7c$var$validateArray(cxt) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, $dYeWu._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $2qwj7.Type.Num
            }, valid);
            gen.if((0, $dYeWu.not)(valid), notValid);
        });
    }
}
module.exports.validateArray = $6ec968de004d5c7c$var$validateArray;
function $6ec968de004d5c7c$var$validateUnion(cxt) {
    const { gen: gen, schema: schema, keyword: keyword, it: it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, $2qwj7.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $dYeWu._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $dYeWu.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
module.exports.validateUnion = $6ec968de004d5c7c$var$validateUnion;

});


parcelRegister("1WUod", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendSubschemaMode = module.exports.extendSubschemaData = module.exports.getSubschema = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");
function $16b6f301e6dcc0ae$var$getSubschema(it, { keyword: keyword, schemaProp: schemaProp, schema: schema, schemaPath: schemaPath, errSchemaPath: errSchemaPath, topSchemaRef: topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $dYeWu._)`${it.schemaPath}${(0, $dYeWu.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $dYeWu._)`${it.schemaPath}${(0, $dYeWu.getProperty)(keyword)}${(0, $dYeWu.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, $2qwj7.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
module.exports.getSubschema = $16b6f301e6dcc0ae$var$getSubschema;
function $16b6f301e6dcc0ae$var$extendSubschemaData(subschema, it, { dataProp: dataProp, dataPropType: dpType, data: data, dataTypes: dataTypes, propertyName: propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: gen } = it;
    if (dataProp !== undefined) {
        const { errorPath: errorPath, dataPathArr: dataPathArr, opts: opts } = it;
        const nextData = gen.let("data", (0, $dYeWu._)`${it.data}${(0, $dYeWu.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $dYeWu.str)`${errorPath}${(0, $2qwj7.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, $dYeWu._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof $dYeWu.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
module.exports.extendSubschemaData = $16b6f301e6dcc0ae$var$extendSubschemaData;
function $16b6f301e6dcc0ae$var$extendSubschemaMode(subschema, { jtdDiscriminator: jtdDiscriminator, jtdMetadata: jtdMetadata, compositeRule: compositeRule, createErrors: createErrors, allErrors: allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
module.exports.extendSubschemaMode = $16b6f301e6dcc0ae$var$extendSubschemaMode;

});

parcelRegister("k3Was", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaRefs = module.exports.resolveUrl = module.exports.normalizeId = module.exports._getFullPath = module.exports.getFullPath = module.exports.inlineRef = void 0;

var $2qwj7 = parcelRequire("2qwj7");

var $7hFx0 = parcelRequire("7hFx0");

var $7dBhG = parcelRequire("7dBhG");
// TODO refactor to use keyword definitions
const $e9b135535ce9c4c2$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $e9b135535ce9c4c2$var$inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$e9b135535ce9c4c2$var$hasRef(schema);
    if (!limit) return false;
    return $e9b135535ce9c4c2$var$countKeys(schema) <= limit;
}
module.exports.inlineRef = $e9b135535ce9c4c2$var$inlineRef;
const $e9b135535ce9c4c2$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $e9b135535ce9c4c2$var$hasRef(schema) {
    for(const key in schema){
        if ($e9b135535ce9c4c2$var$REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some($e9b135535ce9c4c2$var$hasRef)) return true;
        if (typeof sch == "object" && $e9b135535ce9c4c2$var$hasRef(sch)) return true;
    }
    return false;
}
function $e9b135535ce9c4c2$var$countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($e9b135535ce9c4c2$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $2qwj7.eachItem)(schema[key], (sch)=>count += $e9b135535ce9c4c2$var$countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $e9b135535ce9c4c2$var$getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = $e9b135535ce9c4c2$var$normalizeId(id);
    const p = resolver.parse(id);
    return $e9b135535ce9c4c2$var$_getFullPath(resolver, p);
}
module.exports.getFullPath = $e9b135535ce9c4c2$var$getFullPath;
function $e9b135535ce9c4c2$var$_getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
module.exports._getFullPath = $e9b135535ce9c4c2$var$_getFullPath;
const $e9b135535ce9c4c2$var$TRAILING_SLASH_HASH = /#\/?$/;
function $e9b135535ce9c4c2$var$normalizeId(id) {
    return id ? id.replace($e9b135535ce9c4c2$var$TRAILING_SLASH_HASH, "") : "";
}
module.exports.normalizeId = $e9b135535ce9c4c2$var$normalizeId;
function $e9b135535ce9c4c2$var$resolveUrl(resolver, baseId, id) {
    id = $e9b135535ce9c4c2$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
module.exports.resolveUrl = $e9b135535ce9c4c2$var$resolveUrl;
const $e9b135535ce9c4c2$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $e9b135535ce9c4c2$var$getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId: schemaId, uriResolver: uriResolver } = this.opts;
    const schId = $e9b135535ce9c4c2$var$normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = $e9b135535ce9c4c2$var$getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    $7dBhG(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let innerBaseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") innerBaseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = innerBaseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = $e9b135535ce9c4c2$var$normalizeId(innerBaseId ? _resolve(innerBaseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $e9b135535ce9c4c2$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$e9b135535ce9c4c2$var$ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$7hFx0(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
module.exports.getSchemaRefs = $e9b135535ce9c4c2$var$getSchemaRefs;

});


parcelRegister("dadHg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $9956d56d986048b4$var$ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
module.exports.default = $9956d56d986048b4$var$ValidationError;

});

parcelRegister("7HCI9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k3Was = parcelRequire("k3Was");
class $59ba93c6bc2ff313$var$MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, $k3Was.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, $k3Was.normalizeId)((0, $k3Was.getFullPath)(resolver, this.missingRef));
    }
}
module.exports.default = $59ba93c6bc2ff313$var$MissingRefError;

});

parcelRegister("dPtKJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveSchema = module.exports.getCompilingSchema = module.exports.resolveRef = module.exports.compileSchema = module.exports.SchemaEnv = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $dadHg = parcelRequire("dadHg");

var $dP98Q = parcelRequire("dP98Q");

var $k3Was = parcelRequire("k3Was");

var $2qwj7 = parcelRequire("2qwj7");

var $2yHXE = parcelRequire("2yHXE");
class $a1171e1389ee24e0$var$SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $k3Was.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
module.exports.SchemaEnv = $a1171e1389ee24e0$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $a1171e1389ee24e0$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = $a1171e1389ee24e0$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, $k3Was.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $dYeWu.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $dadHg.default,
        code: (0, $dYeWu._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $dP98Q.default.data,
        parentData: $dP98Q.default.parentData,
        parentDataProperty: $dP98Q.default.parentDataProperty,
        dataNames: [
            $dP98Q.default.data
        ],
        dataPathArr: [
            $dYeWu.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $dYeWu.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $dYeWu.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $dYeWu._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, $2yHXE.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs($dP98Q.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${$dP98Q.default.self}`, `${$dP98Q.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props: props, items: items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof $dYeWu.Name ? undefined : props,
                items: items instanceof $dYeWu.Name ? undefined : items,
                dynamicProps: props instanceof $dYeWu.Name,
                dynamicItems: items instanceof $dYeWu.Name
            };
            if (validate.source) validate.source.evaluated = (0, $dYeWu.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
module.exports.compileSchema = $a1171e1389ee24e0$var$compileSchema;
function $a1171e1389ee24e0$var$resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, $k3Was.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = $a1171e1389ee24e0$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId: schemaId } = this.opts;
        if (schema) _sch = new $a1171e1389ee24e0$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $a1171e1389ee24e0$var$inlineOrCompile.call(this, _sch);
}
module.exports.resolveRef = $a1171e1389ee24e0$var$resolveRef;
function $a1171e1389ee24e0$var$inlineOrCompile(sch) {
    if ((0, $k3Was.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $a1171e1389ee24e0$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $a1171e1389ee24e0$var$getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if ($a1171e1389ee24e0$var$sameSchemaEnv(sch, schEnv)) return sch;
    }
}
module.exports.getCompilingSchema = $a1171e1389ee24e0$var$getCompilingSchema;
function $a1171e1389ee24e0$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $a1171e1389ee24e0$var$resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $a1171e1389ee24e0$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $a1171e1389ee24e0$var$resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, $k3Was._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, $k3Was.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $a1171e1389ee24e0$var$getJsonPointer.call(this, p, root);
    const id = (0, $k3Was.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = $a1171e1389ee24e0$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $a1171e1389ee24e0$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $a1171e1389ee24e0$var$compileSchema.call(this, schOrRef);
    if (id === (0, $k3Was.normalizeId)(ref)) {
        const { schema: schema } = schOrRef;
        const { schemaId: schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, $k3Was.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $a1171e1389ee24e0$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $a1171e1389ee24e0$var$getJsonPointer.call(this, p, schOrRef);
}
module.exports.resolveSchema = $a1171e1389ee24e0$var$resolveSchema;
const $a1171e1389ee24e0$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $a1171e1389ee24e0$var$getJsonPointer(parsedRef, { baseId: baseId, schema: schema, root: root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, $2qwj7.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!$a1171e1389ee24e0$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $k3Was.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $2qwj7.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, $k3Was.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $a1171e1389ee24e0$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId: schemaId } = this.opts;
    env = env || new $a1171e1389ee24e0$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRegister("fmgZL", function(module, exports) {
module.exports = JSON.parse('{"$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON AnySchema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

});

parcelRegister("2Pbnb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2h43S = parcelRequire("2h43S");
$2h43S.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $2h43S;

});


parcelRegister("15dSG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $90y9k = parcelRequire("90y9k");

var $4Z0z9 = parcelRequire("4Z0z9");

var $fMgD0 = parcelRequire("fMgD0");

var $bYj8R = parcelRequire("bYj8R");

var $edW00 = parcelRequire("edW00");
const $0ca10691d12e2dcb$var$draft7Vocabularies = [
    $90y9k.default,
    $4Z0z9.default,
    (0, $fMgD0.default)(),
    $bYj8R.default,
    $edW00.metadataVocabulary,
    $edW00.contentVocabulary
];
module.exports.default = $0ca10691d12e2dcb$var$draft7Vocabularies;

});
parcelRegister("90y9k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3Vd6C = parcelRequire("3Vd6C");

var $jYVr5 = parcelRequire("jYVr5");
const $68ee9a816625cc06$var$core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    $3Vd6C.default,
    $jYVr5.default
];
module.exports.default = $68ee9a816625cc06$var$core;

});
parcelRegister("3Vd6C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $2db0dc849eb2641c$var$def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
module.exports.default = $2db0dc849eb2641c$var$def;

});

parcelRegister("jYVr5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callRef = module.exports.getValidate = void 0;

var $7HCI9 = parcelRequire("7HCI9");

var $9vIlD = parcelRequire("9vIlD");

var $dYeWu = parcelRequire("dYeWu");

var $dP98Q = parcelRequire("dP98Q");

var $dPtKJ = parcelRequire("dPtKJ");

var $2qwj7 = parcelRequire("2qwj7");
const $e8c02c7dfc39f359$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen: gen, schema: $ref, it: it } = cxt;
        const { baseId: baseId, schemaEnv: env, validateName: validateName, opts: opts, self: self } = it;
        const { root: root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = $dPtKJ.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $7HCI9.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $dPtKJ.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return $e8c02c7dfc39f359$var$callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return $e8c02c7dfc39f359$var$callRef(cxt, (0, $dYeWu._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = $e8c02c7dfc39f359$var$getValidate(cxt, sch);
            $e8c02c7dfc39f359$var$callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $dYeWu.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $dYeWu.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function $e8c02c7dfc39f359$var$getValidate(cxt, sch) {
    const { gen: gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $dYeWu._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
module.exports.getValidate = $e8c02c7dfc39f359$var$getValidate;
function $e8c02c7dfc39f359$var$callRef(cxt, v, sch, $async) {
    const { gen: gen, it: it } = cxt;
    const { allErrors: allErrors, schemaEnv: env, opts: opts } = it;
    const passCxt = opts.passContext ? $dP98Q.default.this : $dYeWu.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, $dYeWu._)`await ${(0, $9vIlD.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, $dYeWu._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, $9vIlD.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, $dYeWu._)`${source}.errors`;
        gen.assign($dP98Q.default.vErrors, (0, $dYeWu._)`${$dP98Q.default.vErrors} === null ? ${errs} : ${$dP98Q.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign($dP98Q.default.errors, (0, $dYeWu._)`${$dP98Q.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $2qwj7.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, $dYeWu._)`${source}.evaluated.props`);
                it.props = $2qwj7.mergeEvaluated.props(gen, props, it.props, $dYeWu.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $2qwj7.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, $dYeWu._)`${source}.evaluated.items`);
                it.items = $2qwj7.mergeEvaluated.items(gen, items, it.items, $dYeWu.Name);
            }
        }
    }
}
module.exports.callRef = $e8c02c7dfc39f359$var$callRef;
module.exports.default = $e8c02c7dfc39f359$var$def;

});


parcelRegister("4Z0z9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7FohZ = parcelRequire("7FohZ");

var $huY1O = parcelRequire("huY1O");

var $4nCco = parcelRequire("4nCco");

var $9qnhm = parcelRequire("9qnhm");

var $j9nNC = parcelRequire("j9nNC");

var $1pcNh = parcelRequire("1pcNh");

var $hAspj = parcelRequire("hAspj");

var $bGIo0 = parcelRequire("bGIo0");

var $jlwXX = parcelRequire("jlwXX");

var $hbJFr = parcelRequire("hbJFr");
const $3a0d4c4b9795bf71$var$validation = [
    // number
    $7FohZ.default,
    $huY1O.default,
    // string
    $4nCco.default,
    $9qnhm.default,
    // object
    $j9nNC.default,
    $1pcNh.default,
    // array
    $hAspj.default,
    $bGIo0.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    $jlwXX.default,
    $hbJFr.default
];
module.exports.default = $3a0d4c4b9795bf71$var$validation;

});
parcelRegister("7FohZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");
const $594f3412074d02a9$var$ops = $dYeWu.operators;
const $594f3412074d02a9$var$KWDs = {
    maximum: {
        okStr: "<=",
        ok: $594f3412074d02a9$var$ops.LTE,
        fail: $594f3412074d02a9$var$ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: $594f3412074d02a9$var$ops.GTE,
        fail: $594f3412074d02a9$var$ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: $594f3412074d02a9$var$ops.LT,
        fail: $594f3412074d02a9$var$ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: $594f3412074d02a9$var$ops.GT,
        fail: $594f3412074d02a9$var$ops.LTE
    }
};
const $594f3412074d02a9$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $dYeWu.str)`must be ${$594f3412074d02a9$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $dYeWu._)`{comparison: ${$594f3412074d02a9$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
const $594f3412074d02a9$var$def = {
    keyword: Object.keys($594f3412074d02a9$var$KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error: $594f3412074d02a9$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        cxt.fail$data((0, $dYeWu._)`${data} ${$594f3412074d02a9$var$KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    }
};
module.exports.default = $594f3412074d02a9$var$def;

});

parcelRegister("huY1O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");
const $cbd3cd5ee8deeac7$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $dYeWu.str)`must be multiple of ${schemaCode}`,
    params: ({ schemaCode: schemaCode })=>(0, $dYeWu._)`{multipleOf: ${schemaCode}}`
};
const $cbd3cd5ee8deeac7$var$def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error: $cbd3cd5ee8deeac7$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, it: it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, $dYeWu._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, $dYeWu._)`${res} !== parseInt(${res})`;
        cxt.fail$data((0, $dYeWu._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    }
};
module.exports.default = $cbd3cd5ee8deeac7$var$def;

});

parcelRegister("4nCco", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $hOdSd = parcelRequire("hOdSd");
const $3306f0e6a380ef87$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, $dYeWu.str)`must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $dYeWu._)`{limit: ${schemaCode}}`
};
const $3306f0e6a380ef87$var$def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error: $3306f0e6a380ef87$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode, it: it } = cxt;
        const op = keyword === "maxLength" ? $dYeWu.operators.GT : $dYeWu.operators.LT;
        const len = it.opts.unicode === false ? (0, $dYeWu._)`${data}.length` : (0, $dYeWu._)`${(0, $2qwj7.useFunc)(cxt.gen, $hOdSd.default)}(${data})`;
        cxt.fail$data((0, $dYeWu._)`${len} ${op} ${schemaCode}`);
    }
};
module.exports.default = $3306f0e6a380ef87$var$def;

});
parcelRegister("hOdSd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function $cf71de22b8ebd710$var$ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
module.exports.default = $cf71de22b8ebd710$var$ucs2length;
$cf71de22b8ebd710$var$ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

});


parcelRegister("9qnhm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9vIlD = parcelRequire("9vIlD");

var $dYeWu = parcelRequire("dYeWu");
const $6dc8997f0f21ec52$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $dYeWu.str)`must match pattern "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $dYeWu._)`{pattern: ${schemaCode}}`
};
const $6dc8997f0f21ec52$var$def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error: $6dc8997f0f21ec52$var$error,
    code (cxt) {
        const { data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        // TODO regexp should be wrapped in try/catchs
        const u = it.opts.unicodeRegExp ? "u" : "";
        const regExp = $data ? (0, $dYeWu._)`(new RegExp(${schemaCode}, ${u}))` : (0, $9vIlD.usePattern)(cxt, schema);
        cxt.fail$data((0, $dYeWu._)`!${regExp}.test(${data})`);
    }
};
module.exports.default = $6dc8997f0f21ec52$var$def;

});

parcelRegister("j9nNC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");
const $df1151a6028d71a9$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, $dYeWu.str)`must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $dYeWu._)`{limit: ${schemaCode}}`
};
const $df1151a6028d71a9$var$def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error: $df1151a6028d71a9$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxProperties" ? $dYeWu.operators.GT : $dYeWu.operators.LT;
        cxt.fail$data((0, $dYeWu._)`Object.keys(${data}).length ${op} ${schemaCode}`);
    }
};
module.exports.default = $df1151a6028d71a9$var$def;

});

parcelRegister("1pcNh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9vIlD = parcelRequire("9vIlD");

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");
const $10620cdbb8003466$var$error = {
    message: ({ params: { missingProperty: missingProperty } })=>(0, $dYeWu.str)`must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty: missingProperty } })=>(0, $dYeWu._)`{missingProperty: ${missingProperty}}`
};
const $10620cdbb8003466$var$def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error: $10620cdbb8003466$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, schemaCode: schemaCode, data: data, $data: $data, it: it } = cxt;
        const { opts: opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties: definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, $2qwj7.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data($dYeWu.nil, loopAllRequired);
            else for (const prop of schema)(0, $9vIlD.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, $9vIlD.checkMissingProp)(cxt, schema, missing));
                (0, $9vIlD.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, $9vIlD.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, $9vIlD.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, $dYeWu.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, $dYeWu.nil);
        }
    }
};
module.exports.default = $10620cdbb8003466$var$def;

});

parcelRegister("hAspj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");
const $ccdbd5916efd3edc$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, $dYeWu.str)`must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $dYeWu._)`{limit: ${schemaCode}}`
};
const $ccdbd5916efd3edc$var$def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error: $ccdbd5916efd3edc$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxItems" ? $dYeWu.operators.GT : $dYeWu.operators.LT;
        cxt.fail$data((0, $dYeWu._)`${data}.length ${op} ${schemaCode}`);
    }
};
module.exports.default = $ccdbd5916efd3edc$var$def;

});

parcelRegister("bGIo0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fQkz4 = parcelRequire("fQkz4");

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $25F0o = parcelRequire("25F0o");
const $88260c1e194acaa4$var$error = {
    message: ({ params: { i: i, j: j } })=>(0, $dYeWu.str)`must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i: i, j: j } })=>(0, $dYeWu._)`{i: ${i}, j: ${j}}`
};
const $88260c1e194acaa4$var$def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error: $88260c1e194acaa4$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, parentSchema: parentSchema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, $fQkz4.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, $dYeWu._)`${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, $dYeWu._)`${data}.length`);
            const j = gen.let("j");
            cxt.setParams({
                i: i,
                j: j
            });
            gen.assign(valid, true);
            gen.if((0, $dYeWu._)`${i} > 1`, ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, $fQkz4.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, $fQkz4.DataType.Wrong);
            const indices = gen.const("indices", (0, $dYeWu._)`{}`);
            gen.for((0, $dYeWu._)`;${i}--;`, ()=>{
                gen.let(item, (0, $dYeWu._)`${data}[${i}]`);
                gen.if(wrongType, (0, $dYeWu._)`continue`);
                if (itemTypes.length > 1) gen.if((0, $dYeWu._)`typeof ${item} == "string"`, (0, $dYeWu._)`${item} += "_"`);
                gen.if((0, $dYeWu._)`typeof ${indices}[${item}] == "number"`, ()=>{
                    gen.assign(j, (0, $dYeWu._)`${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, $dYeWu._)`${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, $2qwj7.useFunc)(gen, $25F0o.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, $dYeWu._)`;${i}--;`, ()=>gen.for((0, $dYeWu._)`${j} = ${i}; ${j}--;`, ()=>gen.if((0, $dYeWu._)`${eql}(${data}[${i}], ${data}[${j}])`, ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
module.exports.default = $88260c1e194acaa4$var$def;

});
parcelRegister("25F0o", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7hFx0 = parcelRequire("7hFx0");
$7hFx0.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $7hFx0;

});


parcelRegister("jlwXX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $25F0o = parcelRequire("25F0o");
const $e1598ce20d5b4068$var$error = {
    message: "must be equal to constant",
    params: ({ schemaCode: schemaCode })=>(0, $dYeWu._)`{allowedValue: ${schemaCode}}`
};
const $e1598ce20d5b4068$var$def = {
    keyword: "const",
    $data: true,
    error: $e1598ce20d5b4068$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schemaCode: schemaCode, schema: schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, $dYeWu._)`!${(0, $2qwj7.useFunc)(gen, $25F0o.default)}(${data}, ${schemaCode})`);
        else cxt.fail((0, $dYeWu._)`${schema} !== ${data}`);
    }
};
module.exports.default = $e1598ce20d5b4068$var$def;

});

parcelRegister("hbJFr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $25F0o = parcelRequire("25F0o");
const $c836e356af94497b$var$error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode: schemaCode })=>(0, $dYeWu._)`{allowedValues: ${schemaCode}}`
};
const $c836e356af94497b$var$def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error: $c836e356af94497b$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, $2qwj7.useFunc)(gen, $25F0o.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, $dYeWu.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, $dYeWu._)`${getEql()}(${data}, ${v})`, ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, $dYeWu._)`${getEql()}(${data}, ${vSchema}[${i}])` : (0, $dYeWu._)`${data} === ${sch}`;
        }
    }
};
module.exports.default = $c836e356af94497b$var$def;

});


parcelRegister("fMgD0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eWR1z = parcelRequire("eWR1z");

var $5niP6 = parcelRequire("5niP6");

var $30H0Q = parcelRequire("30H0Q");

var $1agiW = parcelRequire("1agiW");

var $fEHho = parcelRequire("fEHho");

var $fo2Wi = parcelRequire("fo2Wi");

var $2EllJ = parcelRequire("2EllJ");

var $9Jele = parcelRequire("9Jele");

var $9HziM = parcelRequire("9HziM");

var $2FSLJ = parcelRequire("2FSLJ");

var $3LFcv = parcelRequire("3LFcv");

var $7917y = parcelRequire("7917y");

var $gNXFq = parcelRequire("gNXFq");

var $c8Tz6 = parcelRequire("c8Tz6");

var $5pH9z = parcelRequire("5pH9z");

var $gjx8g = parcelRequire("gjx8g");
function $b7c83cb99f131010$var$getApplicator(draft2020 = false) {
    const applicator = [
        // any
        $3LFcv.default,
        $7917y.default,
        $gNXFq.default,
        $c8Tz6.default,
        $5pH9z.default,
        $gjx8g.default,
        // object
        $2EllJ.default,
        $9Jele.default,
        $fo2Wi.default,
        $9HziM.default,
        $2FSLJ.default
    ];
    // array
    if (draft2020) applicator.push($5niP6.default, $1agiW.default);
    else applicator.push($eWR1z.default, $30H0Q.default);
    applicator.push($fEHho.default);
    return applicator;
}
module.exports.default = $b7c83cb99f131010$var$getApplicator;

});
parcelRegister("eWR1z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAdditionalItems = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");
const $ae1f9d02518872bf$var$error = {
    message: ({ params: { len: len } })=>(0, $dYeWu.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $dYeWu._)`{limit: ${len}}`
};
const $ae1f9d02518872bf$var$def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: $ae1f9d02518872bf$var$error,
    code (cxt) {
        const { parentSchema: parentSchema, it: it } = cxt;
        const { items: items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, $2qwj7.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        $ae1f9d02518872bf$var$validateAdditionalItems(cxt, items);
    }
};
function $ae1f9d02518872bf$var$validateAdditionalItems(cxt, items) {
    const { gen: gen, schema: schema, data: data, keyword: keyword, it: it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, $dYeWu._)`${data}.length`);
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, $dYeWu._)`${len} <= ${items.length}`);
    } else if (typeof schema == "object" && !(0, $2qwj7.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, $dYeWu._)`${len} <= ${items.length}`); // TODO var
        gen.if((0, $dYeWu.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $2qwj7.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, $dYeWu.not)(valid), ()=>gen.break());
        });
    }
}
module.exports.validateAdditionalItems = $ae1f9d02518872bf$var$validateAdditionalItems;
module.exports.default = $ae1f9d02518872bf$var$def;

});

parcelRegister("5niP6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $30H0Q = parcelRequire("30H0Q");
const $3e9db3a1e78bcc3a$var$def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, $30H0Q.validateTuple)(cxt, "items")
};
module.exports.default = $3e9db3a1e78bcc3a$var$def;

});
parcelRegister("30H0Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTuple = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $9vIlD = parcelRequire("9vIlD");
const $2312bc925194dbdb$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema: schema, it: it } = cxt;
        if (Array.isArray(schema)) return $2312bc925194dbdb$var$validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, $2qwj7.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, $9vIlD.validateArray)(cxt));
    }
};
function $2312bc925194dbdb$var$validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen: gen, parentSchema: parentSchema, data: data, keyword: keyword, it: it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = $2qwj7.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, $dYeWu._)`${data}.length`);
    schArr.forEach((sch, i)=>{
        if ((0, $2qwj7.alwaysValidSchema)(it, sch)) return;
        gen.if((0, $dYeWu._)`${len} > ${i}`, ()=>cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts: opts, errSchemaPath: errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, $2qwj7.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
module.exports.validateTuple = $2312bc925194dbdb$var$validateTuple;
module.exports.default = $2312bc925194dbdb$var$def;

});


parcelRegister("1agiW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $9vIlD = parcelRequire("9vIlD");

var $eWR1z = parcelRequire("eWR1z");
const $0d935f56ab85aac9$var$error = {
    message: ({ params: { len: len } })=>(0, $dYeWu.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $dYeWu._)`{limit: ${len}}`
};
const $0d935f56ab85aac9$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: $0d935f56ab85aac9$var$error,
    code (cxt) {
        const { schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { prefixItems: prefixItems } = parentSchema;
        it.items = true;
        if ((0, $2qwj7.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, $eWR1z.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, $9vIlD.validateArray)(cxt));
    }
};
module.exports.default = $0d935f56ab85aac9$var$def;

});

parcelRegister("fEHho", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");
const $b65c29d63489edb6$var$error = {
    message: ({ params: { min: min, max: max } })=>max === undefined ? (0, $dYeWu.str)`must contain at least ${min} valid item(s)` : (0, $dYeWu.str)`must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min: min, max: max } })=>max === undefined ? (0, $dYeWu._)`{minContains: ${min}}` : (0, $dYeWu._)`{minContains: ${min}, maxContains: ${max}}`
};
const $b65c29d63489edb6$var$def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error: $b65c29d63489edb6$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        let min;
        let max;
        const { minContains: minContains, maxContains: maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, $dYeWu._)`${data}.length`);
        cxt.setParams({
            min: min,
            max: max
        });
        if (max === undefined && min === 0) {
            (0, $2qwj7.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, $2qwj7.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, $2qwj7.alwaysValidSchema)(it, schema)) {
            let cond = (0, $dYeWu._)`${len} >= ${min}`;
            if (max !== undefined) cond = (0, $dYeWu._)`${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, $dYeWu._)`${data}.length > 0`, validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: $2qwj7.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, $dYeWu._)`${count}++`);
            if (max === undefined) gen.if((0, $dYeWu._)`${count} >= ${min}`, ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, $dYeWu._)`${count} > ${max}`, ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, $dYeWu._)`${count} >= ${min}`, ()=>gen.assign(valid, true));
            }
        }
    }
};
module.exports.default = $b65c29d63489edb6$var$def;

});

parcelRegister("fo2Wi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSchemaDeps = module.exports.validatePropertyDeps = module.exports.error = void 0;

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $9vIlD = parcelRequire("9vIlD");
module.exports.error = {
    message: ({ params: { property: property, depsCount: depsCount, deps: deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, $dYeWu.str)`must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property: property, depsCount: depsCount, deps: deps, missingProperty: missingProperty } })=>(0, $dYeWu._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
};
const $b33b6098674bbd8c$var$def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: module.exports.error,
    code (cxt) {
        const [propDeps, schDeps] = $b33b6098674bbd8c$var$splitDependencies(cxt);
        $b33b6098674bbd8c$var$validatePropertyDeps(cxt, propDeps);
        $b33b6098674bbd8c$var$validateSchemaDeps(cxt, schDeps);
    }
};
function $b33b6098674bbd8c$var$splitDependencies({ schema: schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function $b33b6098674bbd8c$var$validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen: gen, data: data, it: it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, $9vIlD.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, $9vIlD.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, $dYeWu._)`${hasProperty} && (${(0, $9vIlD.checkMissingProp)(cxt, deps, missing)})`);
            (0, $9vIlD.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
module.exports.validatePropertyDeps = $b33b6098674bbd8c$var$validatePropertyDeps;
function $b33b6098674bbd8c$var$validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, $2qwj7.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, $9vIlD.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
module.exports.validateSchemaDeps = $b33b6098674bbd8c$var$validateSchemaDeps;
module.exports.default = $b33b6098674bbd8c$var$def;

});

parcelRegister("2EllJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");
const $1edfe0c085a97e51$var$error = {
    message: "property name must be valid",
    params: ({ params: params })=>(0, $dYeWu._)`{propertyName: ${params.propertyName}}`
};
const $1edfe0c085a97e51$var$def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: $1edfe0c085a97e51$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        if ((0, $2qwj7.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, $dYeWu.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $1edfe0c085a97e51$var$def;

});

parcelRegister("9Jele", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9vIlD = parcelRequire("9vIlD");

var $dYeWu = parcelRequire("dYeWu");

var $dP98Q = parcelRequire("dP98Q");

var $2qwj7 = parcelRequire("2qwj7");
const $715370ee88053b25$var$error = {
    message: "must NOT have additional properties",
    params: ({ params: params })=>(0, $dYeWu._)`{additionalProperty: ${params.additionalProperty}}`
};
const $715370ee88053b25$var$def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $715370ee88053b25$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, errsCount: errsCount, it: it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, opts: opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, $2qwj7.alwaysValidSchema)(it, schema)) return;
        const props = (0, $9vIlD.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, $9vIlD.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, $dYeWu._)`${errsCount} === ${$dP98Q.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, $2qwj7.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, $9vIlD.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, $dYeWu.or)(...props.map((p)=>(0, $dYeWu._)`${key} === ${p}`));
            else definedProp = $dYeWu.nil;
            if (patProps.length) definedProp = (0, $dYeWu.or)(definedProp, ...patProps.map((p)=>(0, $dYeWu._)`${(0, $9vIlD.usePattern)(cxt, p)}.test(${key})`));
            return (0, $dYeWu.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, $dYeWu._)`delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, $2qwj7.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, $dYeWu.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, $dYeWu.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: $2qwj7.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
module.exports.default = $715370ee88053b25$var$def;

});

parcelRegister("9HziM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2yHXE = parcelRequire("2yHXE");

var $9vIlD = parcelRequire("9vIlD");

var $2qwj7 = parcelRequire("2qwj7");

var $9Jele = parcelRequire("9Jele");
const $71038374f09290e7$var$def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) $9Jele.default.code(new $2yHXE.KeywordCxt(it, $9Jele.default, "additionalProperties"));
        const allProps = (0, $9vIlD.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = $2qwj7.mergeEvaluated.props(gen, (0, $2qwj7.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, $2qwj7.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, $9vIlD.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
module.exports.default = $71038374f09290e7$var$def;

});

parcelRegister("2FSLJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9vIlD = parcelRequire("9vIlD");

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");

var $2qwj7 = parcelRequire("2qwj7");
const $1f29e51008ebecbe$var$def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, data: data, parentSchema: parentSchema, it: it } = cxt;
        const { opts: opts } = it;
        const patterns = (0, $9vIlD.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, $2qwj7.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof $dYeWu.Name)) it.props = (0, $2qwj7.evaluatedPropsToName)(gen, it.props);
        const { props: props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, $2qwj7.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, $dYeWu._)`${(0, $9vIlD.usePattern)(cxt, pat)}.test(${key})`, ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: $2qwj7.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, $dYeWu._)`${props}[${key}]`, true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, $dYeWu.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
module.exports.default = $1f29e51008ebecbe$var$def;

});

parcelRegister("3LFcv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2qwj7 = parcelRequire("2qwj7");
const $2be5b876dfd305aa$var$def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        if ((0, $2qwj7.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
module.exports.default = $2be5b876dfd305aa$var$def;

});

parcelRegister("7917y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9vIlD = parcelRequire("9vIlD");
const $533a3e40b8facd55$var$def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: $9vIlD.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
module.exports.default = $533a3e40b8facd55$var$def;

});

parcelRegister("gNXFq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");
const $c3bf819ad239db59$var$error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params: params })=>(0, $dYeWu._)`{passingSchemas: ${params.passing}}`
};
const $c3bf819ad239db59$var$def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error: $c3bf819ad239db59$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing: passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, $2qwj7.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, $dYeWu._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, $dYeWu._)`[${passing}, ${i}]`).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, $dYeWu.Name);
                });
            });
        }
    }
};
module.exports.default = $c3bf819ad239db59$var$def;

});

parcelRegister("c8Tz6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2qwj7 = parcelRequire("2qwj7");
const $8d715580756e9499$var$def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, $2qwj7.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
module.exports.default = $8d715580756e9499$var$def;

});

parcelRegister("5pH9z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");

var $2qwj7 = parcelRequire("2qwj7");
const $3f10c2ea3988a29a$var$error = {
    message: ({ params: params })=>(0, $dYeWu.str)`must match "${params.ifClause}" schema`,
    params: ({ params: params })=>(0, $dYeWu._)`{failingKeyword: ${params.ifClause}}`
};
const $3f10c2ea3988a29a$var$def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error: $3f10c2ea3988a29a$var$error,
    code (cxt) {
        const { gen: gen, parentSchema: parentSchema, it: it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, $2qwj7.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = $3f10c2ea3988a29a$var$hasSchema(it, "then");
        const hasElse = $3f10c2ea3988a29a$var$hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause: ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, $dYeWu.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword: keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, $dYeWu._)`${keyword}`);
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function $3f10c2ea3988a29a$var$hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, $2qwj7.alwaysValidSchema)(it, schema);
}
module.exports.default = $3f10c2ea3988a29a$var$def;

});

parcelRegister("gjx8g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2qwj7 = parcelRequire("2qwj7");
const $be081f0d7360f151$var$def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.if === undefined) (0, $2qwj7.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
module.exports.default = $be081f0d7360f151$var$def;

});


parcelRegister("bYj8R", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $799gX = parcelRequire("799gX");
const $8b7425817e03677e$var$format = [
    $799gX.default
];
module.exports.default = $8b7425817e03677e$var$format;

});
parcelRegister("799gX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");
const $534091043f1a8825$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $dYeWu.str)`must match format "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $dYeWu._)`{format: ${schemaCode}}`
};
const $534091043f1a8825$var$def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error: $534091043f1a8825$var$error,
    code (cxt, ruleType) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const { opts: opts, errSchemaPath: errSchemaPath, schemaEnv: schemaEnv, self: self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, $dYeWu._)`${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, $dYeWu._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, ()=>gen.assign(fType, (0, $dYeWu._)`${fDef}.type || "string"`).assign(format, (0, $dYeWu._)`${fDef}.validate`), ()=>gen.assign(fType, (0, $dYeWu._)`"string"`).assign(format, fDef));
            cxt.fail$data((0, $dYeWu.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return $dYeWu.nil;
                return (0, $dYeWu._)`${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, $dYeWu._)`(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))` : (0, $dYeWu._)`${format}(${data})`;
                const validData = (0, $dYeWu._)`(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, $dYeWu._)`${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, $dYeWu.regexpCode)(fmtDef) : opts.code.formats ? (0, $dYeWu._)`${opts.code.formats}${(0, $dYeWu.getProperty)(schema)}` : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code: code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, $dYeWu._)`${fmt}.validate`
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, $dYeWu._)`await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, $dYeWu._)`${fmtRef}(${data})` : (0, $dYeWu._)`${fmtRef}.test(${data})`;
            }
        }
    }
};
module.exports.default = $534091043f1a8825$var$def;

});


parcelRegister("edW00", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contentVocabulary = module.exports.metadataVocabulary = void 0;
module.exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
module.exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

});


parcelRegister("aco7w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dYeWu = parcelRequire("dYeWu");

var $6M9fG = parcelRequire("6M9fG");

var $dPtKJ = parcelRequire("dPtKJ");

var $7HCI9 = parcelRequire("7HCI9");

var $2qwj7 = parcelRequire("2qwj7");
const $76cdbc30776e0876$var$error = {
    message: ({ params: { discrError: discrError, tagName: tagName } })=>discrError === $6M9fG.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError: discrError, tag: tag, tagName: tagName } })=>(0, $dYeWu._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
};
const $76cdbc30776e0876$var$def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: $76cdbc30776e0876$var$error,
    code (cxt) {
        const { gen: gen, data: data, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { oneOf: oneOf } = parentSchema;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, $dYeWu._)`${data}${(0, $dYeWu.getProperty)(tagName)}`);
        gen.if((0, $dYeWu._)`typeof ${tag} == "string"`, ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: $6M9fG.DiscrError.Tag,
                tag: tag,
                tagName: tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, $dYeWu._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: $6M9fG.DiscrError.Mapping,
                tag: tag,
                tagName: tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp: schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, $dYeWu.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < oneOf.length; i++){
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, $2qwj7.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    const ref = sch.$ref;
                    sch = $dPtKJ.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, ref);
                    if (sch instanceof $dPtKJ.SchemaEnv) sch = sch.schema;
                    if (sch === undefined) throw new $7HCI9.default(it.opts.uriResolver, it.baseId, ref);
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required: required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                oneOfMapping[tagValue] = i;
            }
        }
    }
};
module.exports.default = $76cdbc30776e0876$var$def;

});
parcelRegister("6M9fG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $4eee670167192eaf$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($4eee670167192eaf$var$DiscrError || (module.exports.DiscrError = $4eee670167192eaf$var$DiscrError = {}));

});


parcelRegister("lE94y", function(module, exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

});




parcelRegister("lbI4N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AbiSerializationType = module.exports.AbiFunctionModifier = module.exports.AbiFunctionKind = module.exports.SCHEMA_VERSION = void 0;
module.exports.SCHEMA_VERSION = "0.3.0";
/**
 * Function kind regulates whether this function's invocation requires a transaction (so-called
 * call functions) or not (view functions).
 */ var $f6ccd0b5d11b86c7$var$AbiFunctionKind;
(function(AbiFunctionKind) {
    AbiFunctionKind["View"] = "view";
    AbiFunctionKind["Call"] = "call";
})($f6ccd0b5d11b86c7$var$AbiFunctionKind = module.exports.AbiFunctionKind || (module.exports.AbiFunctionKind = {}));
/** Function can have multiple modifiers that can change its semantics. */ var $f6ccd0b5d11b86c7$var$AbiFunctionModifier;
(function(AbiFunctionModifier) {
    /** Init functions can be used to initialize the state of the contract. */ AbiFunctionModifier["Init"] = "init";
    /**
     * Private functions can only be called from the contract containing them. Usually, when a
     * contract has to have a callback for a remote cross-contract call, this callback method
     * should only be called by the contract itself.
     */ AbiFunctionModifier["Private"] = "private";
    /** Payable functions can accept token transfer together with the function call.
     * This is done so that contracts can define a fee in tokens that needs to be payed when
     * they are used.
     */ AbiFunctionModifier["Payable"] = "payable";
})($f6ccd0b5d11b86c7$var$AbiFunctionModifier = module.exports.AbiFunctionModifier || (module.exports.AbiFunctionModifier = {}));
/** Supported serialization formats. */ var $f6ccd0b5d11b86c7$var$AbiSerializationType;
(function(AbiSerializationType) {
    AbiSerializationType["Json"] = "json";
    AbiSerializationType["Borsh"] = "borsh";
})($f6ccd0b5d11b86c7$var$AbiSerializationType = module.exports.AbiSerializationType || (module.exports.AbiSerializationType = {}));

});

parcelRegister("cqsOI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConflictingOptions = module.exports.ArgumentSchemaError = module.exports.UnknownArgumentError = module.exports.UnsupportedSerializationError = void 0;
class $90be4432ca3a3c83$var$UnsupportedSerializationError extends Error {
    constructor(methodName, serializationType){
        super(`Contract method '${methodName}' is using an unsupported serialization type ${serializationType}`);
    }
}
module.exports.UnsupportedSerializationError = $90be4432ca3a3c83$var$UnsupportedSerializationError;
class $90be4432ca3a3c83$var$UnknownArgumentError extends Error {
    constructor(actualArgName, expectedArgNames){
        super(`Unrecognized argument '${actualArgName}', expected '${JSON.stringify(expectedArgNames)}'`);
    }
}
module.exports.UnknownArgumentError = $90be4432ca3a3c83$var$UnknownArgumentError;
class $90be4432ca3a3c83$var$ArgumentSchemaError extends Error {
    constructor(argName, errors){
        super(`Argument '${argName}' does not conform to the specified ABI schema: '${JSON.stringify(errors)}'`);
    }
}
module.exports.ArgumentSchemaError = $90be4432ca3a3c83$var$ArgumentSchemaError;
class $90be4432ca3a3c83$var$ConflictingOptions extends Error {
    constructor(){
        super("Conflicting contract method options have been passed. You can either specify ABI or a list of view/call methods.");
    }
}
module.exports.ConflictingOptions = $90be4432ca3a3c83$var$ConflictingOptions;

});




parcelRegister("hugRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Logger = void 0;

var $hNbI3 = parcelRequire("hNbI3");
Object.defineProperty(module.exports, "Logger", {
    enumerable: true,
    get: function() {
        return $hNbI3.Logger;
    }
});

});


parcelRegister("9v9vF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transfer = module.exports.stake = module.exports.functionCallAccessKey = module.exports.functionCall = module.exports.fullAccessKey = module.exports.deployContract = module.exports.deleteKey = module.exports.deleteAccount = module.exports.createAccount = module.exports.addKey = module.exports.encodeDelegateAction = module.exports.encodeSignedDelegate = module.exports.Transaction = module.exports.SignedTransaction = module.exports.Signature = module.exports.signTransaction = module.exports.createTransaction = module.exports.SCHEMA = module.exports.Transfer = module.exports.Stake = module.exports.FunctionCallPermission = module.exports.FunctionCall = module.exports.FullAccessPermission = module.exports.DeployContract = module.exports.DeleteKey = module.exports.DeleteAccount = module.exports.CreateAccount = module.exports.AddKey = module.exports.AccessKeyPermission = module.exports.AccessKey = module.exports.Action = module.exports.stringifyJsonOrBytes = void 0;

var $hynq1 = parcelRequire("hynq1");
Object.defineProperty(module.exports, "stringifyJsonOrBytes", {
    enumerable: true,
    get: function() {
        return $hynq1.stringifyJsonOrBytes;
    }
});
Object.defineProperty(module.exports, "Action", {
    enumerable: true,
    get: function() {
        return $hynq1.Action;
    }
});
Object.defineProperty(module.exports, "AccessKey", {
    enumerable: true,
    get: function() {
        return $hynq1.AccessKey;
    }
});
Object.defineProperty(module.exports, "AccessKeyPermission", {
    enumerable: true,
    get: function() {
        return $hynq1.AccessKeyPermission;
    }
});
Object.defineProperty(module.exports, "AddKey", {
    enumerable: true,
    get: function() {
        return $hynq1.AddKey;
    }
});
Object.defineProperty(module.exports, "CreateAccount", {
    enumerable: true,
    get: function() {
        return $hynq1.CreateAccount;
    }
});
Object.defineProperty(module.exports, "DeleteAccount", {
    enumerable: true,
    get: function() {
        return $hynq1.DeleteAccount;
    }
});
Object.defineProperty(module.exports, "DeleteKey", {
    enumerable: true,
    get: function() {
        return $hynq1.DeleteKey;
    }
});
Object.defineProperty(module.exports, "DeployContract", {
    enumerable: true,
    get: function() {
        return $hynq1.DeployContract;
    }
});
Object.defineProperty(module.exports, "FullAccessPermission", {
    enumerable: true,
    get: function() {
        return $hynq1.FullAccessPermission;
    }
});
Object.defineProperty(module.exports, "FunctionCall", {
    enumerable: true,
    get: function() {
        return $hynq1.FunctionCall;
    }
});
Object.defineProperty(module.exports, "FunctionCallPermission", {
    enumerable: true,
    get: function() {
        return $hynq1.FunctionCallPermission;
    }
});
Object.defineProperty(module.exports, "Stake", {
    enumerable: true,
    get: function() {
        return $hynq1.Stake;
    }
});
Object.defineProperty(module.exports, "Transfer", {
    enumerable: true,
    get: function() {
        return $hynq1.Transfer;
    }
});
Object.defineProperty(module.exports, "SCHEMA", {
    enumerable: true,
    get: function() {
        return $hynq1.SCHEMA;
    }
});
Object.defineProperty(module.exports, "createTransaction", {
    enumerable: true,
    get: function() {
        return $hynq1.createTransaction;
    }
});
Object.defineProperty(module.exports, "signTransaction", {
    enumerable: true,
    get: function() {
        return $hynq1.signTransaction;
    }
});
Object.defineProperty(module.exports, "Signature", {
    enumerable: true,
    get: function() {
        return $hynq1.Signature;
    }
});
Object.defineProperty(module.exports, "SignedTransaction", {
    enumerable: true,
    get: function() {
        return $hynq1.SignedTransaction;
    }
});
Object.defineProperty(module.exports, "Transaction", {
    enumerable: true,
    get: function() {
        return $hynq1.Transaction;
    }
});
Object.defineProperty(module.exports, "encodeSignedDelegate", {
    enumerable: true,
    get: function() {
        return $hynq1.encodeSignedDelegate;
    }
});
Object.defineProperty(module.exports, "encodeDelegateAction", {
    enumerable: true,
    get: function() {
        return $hynq1.encodeDelegateAction;
    }
});

var $hynq1 = parcelRequire("hynq1");
const $6eae62be96d8757d$var$addKey = (publicKey, accessKey)=>$hynq1.actionCreators.addKey(publicKey, accessKey);
module.exports.addKey = $6eae62be96d8757d$var$addKey;
const $6eae62be96d8757d$var$createAccount = ()=>$hynq1.actionCreators.createAccount();
module.exports.createAccount = $6eae62be96d8757d$var$createAccount;
const $6eae62be96d8757d$var$deleteAccount = (beneficiaryId)=>$hynq1.actionCreators.deleteAccount(beneficiaryId);
module.exports.deleteAccount = $6eae62be96d8757d$var$deleteAccount;
const $6eae62be96d8757d$var$deleteKey = (publicKey)=>$hynq1.actionCreators.deleteKey(publicKey);
module.exports.deleteKey = $6eae62be96d8757d$var$deleteKey;
const $6eae62be96d8757d$var$deployContract = (code)=>$hynq1.actionCreators.deployContract(code);
module.exports.deployContract = $6eae62be96d8757d$var$deployContract;
const $6eae62be96d8757d$var$fullAccessKey = ()=>$hynq1.actionCreators.fullAccessKey();
module.exports.fullAccessKey = $6eae62be96d8757d$var$fullAccessKey;
const $6eae62be96d8757d$var$functionCall = (methodName, args, gas, deposit, stringify, jsContract)=>$hynq1.actionCreators.functionCall(methodName, args, gas, deposit, stringify, jsContract);
module.exports.functionCall = $6eae62be96d8757d$var$functionCall;
const $6eae62be96d8757d$var$functionCallAccessKey = (receiverId, methodNames, allowance)=>$hynq1.actionCreators.functionCallAccessKey(receiverId, methodNames, allowance);
module.exports.functionCallAccessKey = $6eae62be96d8757d$var$functionCallAccessKey;
const $6eae62be96d8757d$var$stake = (stake, publicKey)=>$hynq1.actionCreators.stake(stake, publicKey);
module.exports.stake = $6eae62be96d8757d$var$stake;
const $6eae62be96d8757d$var$transfer = (deposit)=>$hynq1.actionCreators.transfer(deposit);
module.exports.transfer = $6eae62be96d8757d$var$transfer;

});

parcelRegister("hjq28", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findSeatPrice = module.exports.diffEpochValidators = void 0;

var $hNbI3 = parcelRequire("hNbI3");
Object.defineProperty(module.exports, "diffEpochValidators", {
    enumerable: true,
    get: function() {
        return $hNbI3.diffEpochValidators;
    }
});
Object.defineProperty(module.exports, "findSeatPrice", {
    enumerable: true,
    get: function() {
        return $hNbI3.findSeatPrice;
    }
});

});

parcelRegister("2As4n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Account = void 0;

var $nk9dM = parcelRequire("nk9dM");
Object.defineProperty(module.exports, "Account", {
    enumerable: true,
    get: function() {
        return $nk9dM.Account;
    }
});

});

parcelRegister("iJiDq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MultisigStateStatus = module.exports.MultisigDeleteRequestRejectionError = module.exports.MULTISIG_CONFIRM_METHODS = module.exports.MULTISIG_CHANGE_METHODS = module.exports.MULTISIG_DEPOSIT = module.exports.MULTISIG_GAS = module.exports.MULTISIG_ALLOWANCE = module.exports.MULTISIG_STORAGE_KEY = module.exports.AccountMultisig = module.exports.Account2FA = void 0;

var $nk9dM = parcelRequire("nk9dM");
Object.defineProperty(module.exports, "Account2FA", {
    enumerable: true,
    get: function() {
        return $nk9dM.Account2FA;
    }
});
Object.defineProperty(module.exports, "AccountMultisig", {
    enumerable: true,
    get: function() {
        return $nk9dM.AccountMultisig;
    }
});
Object.defineProperty(module.exports, "MULTISIG_STORAGE_KEY", {
    enumerable: true,
    get: function() {
        return $nk9dM.MULTISIG_STORAGE_KEY;
    }
});
Object.defineProperty(module.exports, "MULTISIG_ALLOWANCE", {
    enumerable: true,
    get: function() {
        return $nk9dM.MULTISIG_ALLOWANCE;
    }
});
Object.defineProperty(module.exports, "MULTISIG_GAS", {
    enumerable: true,
    get: function() {
        return $nk9dM.MULTISIG_GAS;
    }
});
Object.defineProperty(module.exports, "MULTISIG_DEPOSIT", {
    enumerable: true,
    get: function() {
        return $nk9dM.MULTISIG_DEPOSIT;
    }
});
Object.defineProperty(module.exports, "MULTISIG_CHANGE_METHODS", {
    enumerable: true,
    get: function() {
        return $nk9dM.MULTISIG_CHANGE_METHODS;
    }
});
Object.defineProperty(module.exports, "MULTISIG_CONFIRM_METHODS", {
    enumerable: true,
    get: function() {
        return $nk9dM.MULTISIG_CONFIRM_METHODS;
    }
});
Object.defineProperty(module.exports, "MultisigDeleteRequestRejectionError", {
    enumerable: true,
    get: function() {
        return $nk9dM.MultisigDeleteRequestRejectionError;
    }
});
Object.defineProperty(module.exports, "MultisigStateStatus", {
    enumerable: true,
    get: function() {
        return $nk9dM.MultisigStateStatus;
    }
});

});

parcelRegister("7lsXa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlAccountCreator = module.exports.LocalAccountCreator = module.exports.AccountCreator = void 0;

var $nk9dM = parcelRequire("nk9dM");
Object.defineProperty(module.exports, "AccountCreator", {
    enumerable: true,
    get: function() {
        return $nk9dM.AccountCreator;
    }
});
Object.defineProperty(module.exports, "LocalAccountCreator", {
    enumerable: true,
    get: function() {
        return $nk9dM.LocalAccountCreator;
    }
});
Object.defineProperty(module.exports, "UrlAccountCreator", {
    enumerable: true,
    get: function() {
        return $nk9dM.UrlAccountCreator;
    }
});

});

parcelRegister("aRlce", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Connection = void 0;

var $nk9dM = parcelRequire("nk9dM");
Object.defineProperty(module.exports, "Connection", {
    enumerable: true,
    get: function() {
        return $nk9dM.Connection;
    }
});

});

parcelRegister("9BnjH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Signer = module.exports.InMemorySigner = void 0;

var $lqZ7x = parcelRequire("lqZ7x");
Object.defineProperty(module.exports, "InMemorySigner", {
    enumerable: true,
    get: function() {
        return $lqZ7x.InMemorySigner;
    }
});
Object.defineProperty(module.exports, "Signer", {
    enumerable: true,
    get: function() {
        return $lqZ7x.Signer;
    }
});

});

parcelRegister("jVkqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Contract = void 0;

var $nk9dM = parcelRequire("nk9dM");
Object.defineProperty(module.exports, "Contract", {
    enumerable: true,
    get: function() {
        return $nk9dM.Contract;
    }
});

});

parcelRegister("bfxBf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Near = void 0;

var $jEpB0 = parcelRequire("jEpB0");
Object.defineProperty(module.exports, "Near", {
    enumerable: true,
    get: function() {
        return $jEpB0.Near;
    }
});

});
parcelRegister("jEpB0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletConnection = module.exports.ConnectedWalletAccount = module.exports.Near = void 0;

var $34VQM = parcelRequire("34VQM");
Object.defineProperty(module.exports, "Near", {
    enumerable: true,
    get: function() {
        return $34VQM.Near;
    }
});

var $iff2c = parcelRequire("iff2c");
Object.defineProperty(module.exports, "ConnectedWalletAccount", {
    enumerable: true,
    get: function() {
        return $iff2c.ConnectedWalletAccount;
    }
});
Object.defineProperty(module.exports, "WalletConnection", {
    enumerable: true,
    get: function() {
        return $iff2c.WalletConnection;
    }
});

});
parcelRegister("34VQM", function(module, exports) {
"use strict";
var $23de9eaf6e3ac3f0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $23de9eaf6e3ac3f0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Near = void 0;

var $nk9dM = parcelRequire("nk9dM");

const $23de9eaf6e3ac3f0$var$bn_js_1 = $23de9eaf6e3ac3f0$var$__importDefault((parcelRequire("dEXSZ")));
/**
 * This is the main class developers should use to interact with NEAR.
 * @example
 * ```js
 * const near = new Near(config);
 * ```
 */ class $23de9eaf6e3ac3f0$var$Near {
    constructor(config){
        var _a;
        this.config = config;
        this.connection = $nk9dM.Connection.fromConfig({
            networkId: config.networkId,
            provider: {
                type: "JsonRpcProvider",
                args: {
                    url: config.nodeUrl,
                    headers: config.headers
                }
            },
            signer: config.signer || {
                type: "InMemorySigner",
                keyStore: config.keyStore || ((_a = config.deps) === null || _a === void 0 ? void 0 : _a.keyStore)
            },
            jsvmAccountId: config.jsvmAccountId || `jsvm.${config.networkId}`
        });
        if (config.masterAccount) {
            // TODO: figure out better way of specifiying initial balance.
            // Hardcoded number below must be enough to pay the gas cost to dev-deploy with near-shell for multiple times
            const initialBalance = config.initialBalance ? new $23de9eaf6e3ac3f0$var$bn_js_1.default(config.initialBalance) : new $23de9eaf6e3ac3f0$var$bn_js_1.default("500000000000000000000000000");
            this.accountCreator = new $nk9dM.LocalAccountCreator(new $nk9dM.Account(this.connection, config.masterAccount), initialBalance);
        } else if (config.helperUrl) this.accountCreator = new $nk9dM.UrlAccountCreator(this.connection, config.helperUrl);
        else this.accountCreator = null;
    }
    /**
     * @param accountId near accountId used to interact with the network.
     */ account(accountId) {
        return $23de9eaf6e3ac3f0$var$__awaiter(this, void 0, void 0, function*() {
            const account = new $nk9dM.Account(this.connection, accountId);
            return account;
        });
    }
    /**
     * Create an account using the {@link AccountCreator}. Either:
     * * using a masterAccount with {@link LocalAccountCreator}
     * * using the helperUrl with {@link UrlAccountCreator}
     * @see {@link NearConfig#masterAccount} and {@link NearConfig#helperUrl}
     *
     * @param accountId
     * @param publicKey
     */ createAccount(accountId, publicKey) {
        return $23de9eaf6e3ac3f0$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.accountCreator) throw new Error("Must specify account creator, either via masterAccount or helperUrl configuration settings.");
            yield this.accountCreator.createAccount(accountId, publicKey);
            return new $nk9dM.Account(this.connection, accountId);
        });
    }
}
module.exports.Near = $23de9eaf6e3ac3f0$var$Near;

});

parcelRegister("iff2c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d4854a3e5a1ec2f3$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $d4854a3e5a1ec2f3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d4854a3e5a1ec2f3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ConnectedWalletAccount = module.exports.WalletConnection = void 0;

var $nk9dM = parcelRequire("nk9dM");

var $hp647 = parcelRequire("hp647");

var $hNbI3 = parcelRequire("hNbI3");

var $hynq1 = parcelRequire("hynq1");

const $d4854a3e5a1ec2f3$var$bn_js_1 = $d4854a3e5a1ec2f3$var$__importDefault((parcelRequire("dEXSZ")));

var $7U40k = parcelRequire("7U40k");
const $d4854a3e5a1ec2f3$var$LOGIN_WALLET_URL_SUFFIX = "/login/";
const $d4854a3e5a1ec2f3$var$MULTISIG_HAS_METHOD = "add_request_and_confirm";
const $d4854a3e5a1ec2f3$var$LOCAL_STORAGE_KEY_SUFFIX = "_wallet_auth_key";
const $d4854a3e5a1ec2f3$var$PENDING_ACCESS_KEY_PREFIX = "pending_key"; // browser storage key for a pending access key (i.e. key has been generated but we are not sure it was added yet)
/**
 * This class is not intended for use outside the browser. Without `window` (i.e. in server contexts), it will instantiate but will throw a clear error when used.
 *
 * @see [https://docs.near.org/tools/near-api-js/quick-reference#wallet](https://docs.near.org/tools/near-api-js/quick-reference#wallet)
 * @example
 * ```js
 * // create new WalletConnection instance
 * const wallet = new WalletConnection(near, 'my-app');
 *
 * // If not signed in redirect to the NEAR wallet to sign in
 * // keys will be stored in the BrowserLocalStorageKeyStore
 * if(!wallet.isSignedIn()) return wallet.requestSignIn()
 * ```
 */ class $d4854a3e5a1ec2f3$var$WalletConnection {
    constructor(near, appKeyPrefix){
        if (typeof appKeyPrefix !== "string") throw new Error("Please define a clear appKeyPrefix for this WalletConnection instance as the second argument to the constructor");
        if (typeof window === "undefined") return new Proxy(this, {
            get (target, property) {
                if (property === "isSignedIn") return ()=>false;
                if (property === "getAccountId") return ()=>"";
                if (target[property] && typeof target[property] === "function") return ()=>{
                    throw new Error("No window found in context, please ensure you are using WalletConnection on the browser");
                };
                return target[property];
            }
        });
        this._near = near;
        const authDataKey = appKeyPrefix + $d4854a3e5a1ec2f3$var$LOCAL_STORAGE_KEY_SUFFIX;
        const authData = JSON.parse(window.localStorage.getItem(authDataKey));
        this._networkId = near.config.networkId;
        this._walletBaseUrl = near.config.walletUrl;
        appKeyPrefix = appKeyPrefix || near.config.contractName || "default";
        this._keyStore = near.connection.signer.keyStore;
        this._authData = authData || {
            allKeys: []
        };
        this._authDataKey = authDataKey;
        if (!this.isSignedIn()) this._completeSignInPromise = this._completeSignInWithAccessKey();
    }
    /**
     * Returns true, if this WalletConnection is authorized with the wallet.
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * wallet.isSignedIn();
     * ```
     */ isSignedIn() {
        return !!this._authData.accountId;
    }
    /**
     * Returns promise of completing signing in after redirecting from wallet
     * @example
     * ```js
     * // on login callback page
     * const wallet = new WalletConnection(near, 'my-app');
     * wallet.isSignedIn(); // false
     * await wallet.isSignedInAsync(); // true
     * ```
     */ isSignedInAsync() {
        return $d4854a3e5a1ec2f3$var$__awaiter(this, void 0, void 0, function*() {
            if (!this._completeSignInPromise) return this.isSignedIn();
            yield this._completeSignInPromise;
            return this.isSignedIn();
        });
    }
    /**
     * Returns authorized Account ID.
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * wallet.getAccountId();
     * ```
     */ getAccountId() {
        return this._authData.accountId || "";
    }
    /**
     * Constructs string URL to the wallet authentication page.
     * @param options An optional options object
     * @param options.contractId The NEAR account where the contract is deployed
     * @param options.successUrl URL to redirect upon success. Default: current url
     * @param options.failureUrl URL to redirect upon failure. Default: current url
     *
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * // return string URL to the NEAR Wallet
     * const url = await wallet.requestSignInUrl({ contractId: 'account-with-deploy-contract.near' });
     * ```
     */ requestSignInUrl({ contractId: contractId, methodNames: methodNames, successUrl: successUrl, failureUrl: failureUrl }) {
        return $d4854a3e5a1ec2f3$var$__awaiter(this, void 0, void 0, function*() {
            const currentUrl = new URL(window.location.href);
            const newUrl = new URL(this._walletBaseUrl + $d4854a3e5a1ec2f3$var$LOGIN_WALLET_URL_SUFFIX);
            newUrl.searchParams.set("success_url", successUrl || currentUrl.href);
            newUrl.searchParams.set("failure_url", failureUrl || currentUrl.href);
            if (contractId) {
                /* Throws exception if contract account does not exist */ const contractAccount = yield this._near.account(contractId);
                yield contractAccount.state();
                newUrl.searchParams.set("contract_id", contractId);
                const accessKey = $hp647.KeyPair.fromRandom("ed25519");
                newUrl.searchParams.set("public_key", accessKey.getPublicKey().toString());
                yield this._keyStore.setKey(this._networkId, $d4854a3e5a1ec2f3$var$PENDING_ACCESS_KEY_PREFIX + accessKey.getPublicKey(), accessKey);
            }
            if (methodNames) methodNames.forEach((methodName)=>{
                newUrl.searchParams.append("methodNames", methodName);
            });
            return newUrl.toString();
        });
    }
    /**
     * Redirects current page to the wallet authentication page.
     * @param options An optional options object
     * @param options.contractId The NEAR account where the contract is deployed
     * @param options.successUrl URL to redirect upon success. Default: current url
     * @param options.failureUrl URL to redirect upon failure. Default: current url
     *
     * @example
     * ```js
     * const wallet = new WalletConnection(near, 'my-app');
     * // redirects to the NEAR Wallet
     * wallet.requestSignIn({ contractId: 'account-with-deploy-contract.near' });
     * ```
     */ requestSignIn(options) {
        return $d4854a3e5a1ec2f3$var$__awaiter(this, void 0, void 0, function*() {
            const url = yield this.requestSignInUrl(options);
            window.location.assign(url);
        });
    }
    /**
     * Constructs string URL to the wallet to sign a transaction or batch of transactions.
     *
     * @param options A required options object
     * @param options.transactions List of transactions to sign
     * @param options.callbackUrl URL to redirect upon success. Default: current url
     * @param options.meta Meta information the wallet will send back to the application. `meta` will be attached to the `callbackUrl` as a url search param
     *
     */ requestSignTransactionsUrl({ transactions: transactions, meta: meta, callbackUrl: callbackUrl }) {
        const currentUrl = new URL(window.location.href);
        const newUrl = new URL("sign", this._walletBaseUrl);
        newUrl.searchParams.set("transactions", transactions.map((transaction)=>(0, $7U40k.serialize)($hynq1.SCHEMA.Transaction, transaction)).map((serialized)=>$d4854a3e5a1ec2f3$require$Buffer.from(serialized).toString("base64")).join(","));
        newUrl.searchParams.set("callbackUrl", callbackUrl || currentUrl.href);
        if (meta) newUrl.searchParams.set("meta", meta);
        return newUrl.toString();
    }
    /**
     * Requests the user to quickly sign for a transaction or batch of transactions by redirecting to the wallet.
     *
     * @param options A required options object
     * @param options.transactions List of transactions to sign
     * @param options.callbackUrl URL to redirect upon success. Default: current url
     * @param options.meta Meta information the wallet will send back to the application. `meta` will be attached to the `callbackUrl` as a url search param
     *
     */ requestSignTransactions(options) {
        const url = this.requestSignTransactionsUrl(options);
        window.location.assign(url);
    }
    /**
     * @hidden
     * Complete sign in for a given account id and public key. To be invoked by the app when getting a callback from the wallet.
     */ _completeSignInWithAccessKey() {
        return $d4854a3e5a1ec2f3$var$__awaiter(this, void 0, void 0, function*() {
            const currentUrl = new URL(window.location.href);
            const publicKey = currentUrl.searchParams.get("public_key") || "";
            const allKeys = (currentUrl.searchParams.get("all_keys") || "").split(",");
            const accountId = currentUrl.searchParams.get("account_id") || "";
            // TODO: Handle errors during login
            if (accountId) {
                const authData = {
                    accountId: accountId,
                    allKeys: allKeys
                };
                window.localStorage.setItem(this._authDataKey, JSON.stringify(authData));
                if (publicKey) yield this._moveKeyFromTempToPermanent(accountId, publicKey);
                this._authData = authData;
            }
            currentUrl.searchParams.delete("public_key");
            currentUrl.searchParams.delete("all_keys");
            currentUrl.searchParams.delete("account_id");
            currentUrl.searchParams.delete("meta");
            currentUrl.searchParams.delete("transactionHashes");
            window.history.replaceState({}, document.title, currentUrl.toString());
        });
    }
    /**
     * @hidden
     * @param accountId The NEAR account owning the given public key
     * @param publicKey The public key being set to the key store
     */ _moveKeyFromTempToPermanent(accountId, publicKey) {
        return $d4854a3e5a1ec2f3$var$__awaiter(this, void 0, void 0, function*() {
            const keyPair = yield this._keyStore.getKey(this._networkId, $d4854a3e5a1ec2f3$var$PENDING_ACCESS_KEY_PREFIX + publicKey);
            yield this._keyStore.setKey(this._networkId, accountId, keyPair);
            yield this._keyStore.removeKey(this._networkId, $d4854a3e5a1ec2f3$var$PENDING_ACCESS_KEY_PREFIX + publicKey);
        });
    }
    /**
     * Sign out from the current account
     * @example
     * walletConnection.signOut();
     */ signOut() {
        this._authData = {};
        window.localStorage.removeItem(this._authDataKey);
    }
    /**
     * Returns the current connected wallet account
     */ account() {
        if (!this._connectedAccount) this._connectedAccount = new $d4854a3e5a1ec2f3$var$ConnectedWalletAccount(this, this._near.connection, this._authData.accountId);
        return this._connectedAccount;
    }
}
module.exports.WalletConnection = $d4854a3e5a1ec2f3$var$WalletConnection;
/**
 * {@link Account} implementation which redirects to wallet using {@link WalletConnection} when no local key is available.
 */ class $d4854a3e5a1ec2f3$var$ConnectedWalletAccount extends $nk9dM.Account {
    constructor(walletConnection, connection, accountId){
        super(connection, accountId);
        this.walletConnection = walletConnection;
    }
    // Overriding Account methods
    /**
     * Sign a transaction by redirecting to the NEAR Wallet
     * @see {@link WalletConnection#requestSignTransactions}
     * @param options An optional options object
     * @param options.receiverId The NEAR account ID of the transaction receiver.
     * @param options.actions An array of transaction actions to be performed.
     * @param options.walletMeta Additional metadata to be included in the wallet signing request.
     * @param options.walletCallbackUrl URL to redirect upon completion of the wallet signing process. Default: current URL.
     */ signAndSendTransaction({ receiverId: receiverId, actions: actions, walletMeta: walletMeta, walletCallbackUrl: walletCallbackUrl = window.location.href }) {
        const _super = Object.create(null, {
            signAndSendTransaction: {
                get: ()=>super.signAndSendTransaction
            }
        });
        return $d4854a3e5a1ec2f3$var$__awaiter(this, void 0, void 0, function*() {
            const localKey = yield this.connection.signer.getPublicKey(this.accountId, this.connection.networkId);
            let accessKey = yield this.accessKeyForTransaction(receiverId, actions, localKey);
            if (!accessKey) throw new Error(`Cannot find matching key for transaction sent to ${receiverId}`);
            if (localKey && localKey.toString() === accessKey.public_key) try {
                return yield _super.signAndSendTransaction.call(this, {
                    receiverId: receiverId,
                    actions: actions
                });
            } catch (e) {
                if (e.type === "NotEnoughAllowance") accessKey = yield this.accessKeyForTransaction(receiverId, actions);
                else throw e;
            }
            const block = yield this.connection.provider.block({
                finality: "final"
            });
            const blockHash = (0, $hNbI3.baseDecode)(block.header.hash);
            const publicKey = $hp647.PublicKey.from(accessKey.public_key);
            // TODO: Cache & listen for nonce updates for given access key
            const nonce = accessKey.access_key.nonce.add(new $d4854a3e5a1ec2f3$var$bn_js_1.default(1));
            const transaction = (0, $hynq1.createTransaction)(this.accountId, publicKey, receiverId, nonce, actions, blockHash);
            yield this.walletConnection.requestSignTransactions({
                transactions: [
                    transaction
                ],
                meta: walletMeta,
                callbackUrl: walletCallbackUrl
            });
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject(new Error("Failed to redirect to sign transaction"));
                }, 1000);
            });
        // TODO: Aggregate multiple transaction request with "debounce".
        // TODO: Introduce TransactionQueue which also can be used to watch for status?
        });
    }
    /**
     * Check if given access key allows the function call or method attempted in transaction
     * @param accessKey Array of \{access_key: AccessKey, public_key: PublicKey\} items
     * @param receiverId The NEAR account attempting to have access
     * @param actions The action(s) needed to be checked for access
     */ accessKeyMatchesTransaction(accessKey, receiverId, actions) {
        return $d4854a3e5a1ec2f3$var$__awaiter(this, void 0, void 0, function*() {
            const { access_key: { permission: permission } } = accessKey;
            if (permission === "FullAccess") return true;
            if (permission.FunctionCall) {
                const { receiver_id: allowedReceiverId, method_names: allowedMethods } = permission.FunctionCall;
                /********************************
                Accept multisig access keys and let wallets attempt to signAndSendTransaction
                If an access key has itself as receiverId and method permission add_request_and_confirm, then it is being used in a wallet with multisig contract: https://github.com/near/core-contracts/blob/671c05f09abecabe7a7e58efe942550a35fc3292/multisig/src/lib.rs#L149-L153
                ********************************/ if (allowedReceiverId === this.accountId && allowedMethods.includes($d4854a3e5a1ec2f3$var$MULTISIG_HAS_METHOD)) return true;
                if (allowedReceiverId === receiverId) {
                    if (actions.length !== 1) return false;
                    const [{ functionCall: functionCall }] = actions;
                    return functionCall && (!functionCall.deposit || functionCall.deposit.toString() === "0") && // TODO: Should support charging amount smaller than allowance?
                    (allowedMethods.length === 0 || allowedMethods.includes(functionCall.methodName));
                // TODO: Handle cases when allowance doesn't have enough to pay for gas
                }
            }
            // TODO: Support other permissions than FunctionCall
            return false;
        });
    }
    /**
     * Helper function returning the access key (if it exists) to the receiver that grants the designated permission
     * @param receiverId The NEAR account seeking the access key for a transaction
     * @param actions The action(s) sought to gain access to
     * @param localKey A local public key provided to check for access
     */ accessKeyForTransaction(receiverId, actions, localKey) {
        return $d4854a3e5a1ec2f3$var$__awaiter(this, void 0, void 0, function*() {
            const accessKeys = yield this.getAccessKeys();
            if (localKey) {
                const accessKey = accessKeys.find((key)=>key.public_key.toString() === localKey.toString());
                if (accessKey && (yield this.accessKeyMatchesTransaction(accessKey, receiverId, actions))) return accessKey;
            }
            const walletKeys = this.walletConnection._authData.allKeys;
            for (const accessKey of accessKeys){
                if (walletKeys.indexOf(accessKey.public_key) !== -1 && (yield this.accessKeyMatchesTransaction(accessKey, receiverId, actions))) return accessKey;
            }
            return null;
        });
    }
}
module.exports.ConnectedWalletAccount = $d4854a3e5a1ec2f3$var$ConnectedWalletAccount;

});



parcelRegister("DUo3W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletConnection = module.exports.ConnectedWalletAccount = void 0;

var $jEpB0 = parcelRequire("jEpB0");
Object.defineProperty(module.exports, "ConnectedWalletAccount", {
    enumerable: true,
    get: function() {
        return $jEpB0.ConnectedWalletAccount;
    }
});
Object.defineProperty(module.exports, "WalletConnection", {
    enumerable: true,
    get: function() {
        return $jEpB0.WalletConnection;
    }
});

});


parcelRegister("cgxXB", function(module, exports) {
"use strict";
var $8ee15275564caae5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.connect = void 0;

var $bfxBf = parcelRequire("bfxBf");
/**
 * Initialize connection to Near network.
 */ function $8ee15275564caae5$var$connect(config) {
    return $8ee15275564caae5$var$__awaiter(this, void 0, void 0, function*() {
        return new $bfxBf.Near(config);
    });
}
module.exports.connect = $8ee15275564caae5$var$connect;

});

parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("lqZGs", function(module, exports) {

var $0DhcF = parcelRequire("0DhcF");
var $f9abdfcc234cde65$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $0DhcF($f9abdfcc234cde65$var$ALPHABET);

});
parcelRegister("0DhcF", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $001e77b0dfd1bf3d$require$_Buffer = $1U9GM.Buffer;
function $001e77b0dfd1bf3d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $001e77b0dfd1bf3d$require$_Buffer.from(source);
        if (!$001e77b0dfd1bf3d$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $001e77b0dfd1bf3d$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $001e77b0dfd1bf3d$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $001e77b0dfd1bf3d$var$base;

});


parcelRegister("kOaA4", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", () => $f260af419b27244f$export$88fb0cfd153261a7, (v) => $f260af419b27244f$export$88fb0cfd153261a7 = v);
$parcel$export(module.exports, "TextDecoder", () => $f260af419b27244f$export$9c6b53e35bc51b5c, (v) => $f260af419b27244f$export$9c6b53e35bc51b5c = v);
var $f260af419b27244f$export$88fb0cfd153261a7;
var $f260af419b27244f$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $f260af419b27244f$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $f260af419b27244f$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $f260af419b27244f$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $f260af419b27244f$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $f260af419b27244f$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $f260af419b27244f$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$f260af419b27244f$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $f260af419b27244f$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $f260af419b27244f$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $f260af419b27244f$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $f260af419b27244f$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f260af419b27244f$var$TextDecoder(encoding, options) {
    if (!(this instanceof $f260af419b27244f$var$TextDecoder)) return new $f260af419b27244f$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f260af419b27244f$var$DEFAULT_ENCODING;
    if (encoding !== $f260af419b27244f$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $f260af419b27244f$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$f260af419b27244f$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $f260af419b27244f$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $f260af419b27244f$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $f260af419b27244f$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $f260af419b27244f$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $f260af419b27244f$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $f260af419b27244f$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $f260af419b27244f$var$TextEncoder(encoding, options) {
    if (!(this instanceof $f260af419b27244f$var$TextEncoder)) return new $f260af419b27244f$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $f260af419b27244f$var$DEFAULT_ENCODING;
    if (encoding !== $f260af419b27244f$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $f260af419b27244f$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$f260af419b27244f$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $f260af419b27244f$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $f260af419b27244f$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $f260af419b27244f$var$Stream($f260af419b27244f$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $f260af419b27244f$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $f260af419b27244f$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $f260af419b27244f$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $f260af419b27244f$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $f260af419b27244f$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $f260af419b27244f$var$end_of_stream) return $f260af419b27244f$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($f260af419b27244f$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($f260af419b27244f$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($f260af419b27244f$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($f260af419b27244f$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $f260af419b27244f$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$f260af419b27244f$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $f260af419b27244f$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $f260af419b27244f$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $f260af419b27244f$var$end_of_stream) return $f260af419b27244f$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($f260af419b27244f$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($f260af419b27244f$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($f260af419b27244f$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($f260af419b27244f$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$f260af419b27244f$export$88fb0cfd153261a7 = $f260af419b27244f$var$TextEncoder;
$f260af419b27244f$export$9c6b53e35bc51b5c = $f260af419b27244f$var$TextDecoder;

});

parcelRegister("fBCU1", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.9.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var ERROR = "input is invalid type";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof $hPtJY === "object" && $hPtJY.versions && $hPtJY.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [
        -2147483648,
        8388608,
        32768,
        128
    ];
    var SHIFT = [
        24,
        16,
        8,
        0
    ];
    var K = [
        0x428a2f98,
        0x71374491,
        0xb5c0fbcf,
        0xe9b5dba5,
        0x3956c25b,
        0x59f111f1,
        0x923f82a4,
        0xab1c5ed5,
        0xd807aa98,
        0x12835b01,
        0x243185be,
        0x550c7dc3,
        0x72be5d74,
        0x80deb1fe,
        0x9bdc06a7,
        0xc19bf174,
        0xe49b69c1,
        0xefbe4786,
        0x0fc19dc6,
        0x240ca1cc,
        0x2de92c6f,
        0x4a7484aa,
        0x5cb0a9dc,
        0x76f988da,
        0x983e5152,
        0xa831c66d,
        0xb00327c8,
        0xbf597fc7,
        0xc6e00bf3,
        0xd5a79147,
        0x06ca6351,
        0x14292967,
        0x27b70a85,
        0x2e1b2138,
        0x4d2c6dfc,
        0x53380d13,
        0x650a7354,
        0x766a0abb,
        0x81c2c92e,
        0x92722c85,
        0xa2bfe8a1,
        0xa81a664b,
        0xc24b8b70,
        0xc76c51a3,
        0xd192e819,
        0xd6990624,
        0xf40e3585,
        0x106aa070,
        0x19a4c116,
        0x1e376c08,
        0x2748774c,
        0x34b0bcb5,
        0x391c0cb3,
        0x4ed8aa4a,
        0x5b9cca4f,
        0x682e6ff3,
        0x748f82ee,
        0x78a5636f,
        0x84c87814,
        0x8cc70208,
        0x90befffa,
        0xa4506ceb,
        0xbef9a3f7,
        0xc67178f2
    ];
    var OUTPUT_TYPES = [
        "hex",
        "array",
        "digest",
        "arrayBuffer"
    ];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(outputType, is224) {
        return function(message) {
            return new Sha256(is224, true).update(message)[outputType]();
        };
    };
    var createMethod = function(is224) {
        var method = createOutputMethod("hex", is224);
        if (NODE_JS) method = nodeWrap(method, is224);
        method.create = function() {
            return new Sha256(is224);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type, is224);
        }
        return method;
    };
    var nodeWrap = function(method, is224) {
        var crypto = eval("require('crypto')");
        var Buffer = eval("require('buffer').Buffer");
        var algorithm = is224 ? "sha224" : "sha256";
        var nodeMethod = function(message) {
            if (typeof message === "string") return crypto.createHash(algorithm).update(message, "utf8").digest("hex");
            else {
                if (message === null || message === undefined) throw new Error(ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer) return crypto.createHash(algorithm).update(new Buffer(message)).digest("hex");
            else return method(message);
        };
        return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
        return function(key, message) {
            return new HmacSha256(key, is224, true).update(message)[outputType]();
        };
    };
    var createHmacMethod = function(is224) {
        var method = createHmacOutputMethod("hex", is224);
        method.create = function(key) {
            return new HmacSha256(key, is224);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type, is224);
        }
        return method;
    };
    function Sha256(is224, sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (is224) {
            this.h0 = 0xc1059ed8;
            this.h1 = 0x367cd507;
            this.h2 = 0x3070dd17;
            this.h3 = 0xf70e5939;
            this.h4 = 0xffc00b31;
            this.h5 = 0x68581511;
            this.h6 = 0x64f98fa7;
            this.h7 = 0xbefa4fa4;
        } else {
            this.h0 = 0x6a09e667;
            this.h1 = 0xbb67ae85;
            this.h2 = 0x3c6ef372;
            this.h3 = 0xa54ff53a;
            this.h4 = 0x510e527f;
            this.h5 = 0x9b05688c;
            this.h6 = 0x1f83d9ab;
            this.h7 = 0x5be0cd19;
        }
        this.block = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
        this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
        if (this.finalized) return;
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
            notString = true;
        }
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = this.block;
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (notString) for(i = this.start; index < length && i < 64; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < 64; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.block = blocks[16];
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Sha256.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[16] = this.block;
        blocks[i >> 2] |= EXTRA[i & 3];
        this.block = blocks[16];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = this.block;
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.hBytes << 3 | this.bytes >>> 29;
        blocks[15] = this.bytes << 3;
        this.hash();
    };
    Sha256.prototype.hash = function() {
        var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
        for(j = 16; j < 64; ++j){
            // rightrotate
            t1 = blocks[j - 15];
            s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
            t1 = blocks[j - 2];
            s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
            blocks[j] = blocks[j - 16] + s0 + blocks[j - 7] + s1 << 0;
        }
        bc = b & c;
        for(j = 0; j < 64; j += 4){
            if (this.first) {
                if (this.is224) {
                    ab = 300032;
                    t1 = blocks[0] - 1413257819;
                    h = t1 - 150054599 << 0;
                    d = t1 + 24177077 << 0;
                } else {
                    ab = 704751109;
                    t1 = blocks[0] - 210244248;
                    h = t1 - 1521486534 << 0;
                    d = t1 + 143694565 << 0;
                }
                this.first = false;
            } else {
                s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
                s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
                ab = a & b;
                maj = ab ^ a & c ^ bc;
                ch = e & f ^ ~e & g;
                t1 = h + s1 + ch + K[j] + blocks[j];
                t2 = s0 + maj;
                h = d + t1 << 0;
                d = t1 + t2 << 0;
            }
            s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
            s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
            da = d & a;
            maj = da ^ d & b ^ ab;
            ch = h & e ^ ~h & f;
            t1 = g + s1 + ch + K[j + 1] + blocks[j + 1];
            t2 = s0 + maj;
            g = c + t1 << 0;
            c = t1 + t2 << 0;
            s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
            s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
            cd = c & d;
            maj = cd ^ c & a ^ da;
            ch = g & h ^ ~g & e;
            t1 = f + s1 + ch + K[j + 2] + blocks[j + 2];
            t2 = s0 + maj;
            f = b + t1 << 0;
            b = t1 + t2 << 0;
            s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
            s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
            bc = b & c;
            maj = bc ^ b & d ^ cd;
            ch = f & g ^ ~f & h;
            t1 = e + s1 + ch + K[j + 3] + blocks[j + 3];
            t2 = s0 + maj;
            e = a + t1 << 0;
            a = t1 + t2 << 0;
        }
        this.h0 = this.h0 + a << 0;
        this.h1 = this.h1 + b << 0;
        this.h2 = this.h2 + c << 0;
        this.h3 = this.h3 + d << 0;
        this.h4 = this.h4 + e << 0;
        this.h5 = this.h5 + f << 0;
        this.h6 = this.h6 + g << 0;
        this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var hex = HEX_CHARS[h0 >> 28 & 0x0F] + HEX_CHARS[h0 >> 24 & 0x0F] + HEX_CHARS[h0 >> 20 & 0x0F] + HEX_CHARS[h0 >> 16 & 0x0F] + HEX_CHARS[h0 >> 12 & 0x0F] + HEX_CHARS[h0 >> 8 & 0x0F] + HEX_CHARS[h0 >> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h1 >> 28 & 0x0F] + HEX_CHARS[h1 >> 24 & 0x0F] + HEX_CHARS[h1 >> 20 & 0x0F] + HEX_CHARS[h1 >> 16 & 0x0F] + HEX_CHARS[h1 >> 12 & 0x0F] + HEX_CHARS[h1 >> 8 & 0x0F] + HEX_CHARS[h1 >> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h2 >> 28 & 0x0F] + HEX_CHARS[h2 >> 24 & 0x0F] + HEX_CHARS[h2 >> 20 & 0x0F] + HEX_CHARS[h2 >> 16 & 0x0F] + HEX_CHARS[h2 >> 12 & 0x0F] + HEX_CHARS[h2 >> 8 & 0x0F] + HEX_CHARS[h2 >> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h3 >> 28 & 0x0F] + HEX_CHARS[h3 >> 24 & 0x0F] + HEX_CHARS[h3 >> 20 & 0x0F] + HEX_CHARS[h3 >> 16 & 0x0F] + HEX_CHARS[h3 >> 12 & 0x0F] + HEX_CHARS[h3 >> 8 & 0x0F] + HEX_CHARS[h3 >> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h4 >> 28 & 0x0F] + HEX_CHARS[h4 >> 24 & 0x0F] + HEX_CHARS[h4 >> 20 & 0x0F] + HEX_CHARS[h4 >> 16 & 0x0F] + HEX_CHARS[h4 >> 12 & 0x0F] + HEX_CHARS[h4 >> 8 & 0x0F] + HEX_CHARS[h4 >> 4 & 0x0F] + HEX_CHARS[h4 & 0x0F] + HEX_CHARS[h5 >> 28 & 0x0F] + HEX_CHARS[h5 >> 24 & 0x0F] + HEX_CHARS[h5 >> 20 & 0x0F] + HEX_CHARS[h5 >> 16 & 0x0F] + HEX_CHARS[h5 >> 12 & 0x0F] + HEX_CHARS[h5 >> 8 & 0x0F] + HEX_CHARS[h5 >> 4 & 0x0F] + HEX_CHARS[h5 & 0x0F] + HEX_CHARS[h6 >> 28 & 0x0F] + HEX_CHARS[h6 >> 24 & 0x0F] + HEX_CHARS[h6 >> 20 & 0x0F] + HEX_CHARS[h6 >> 16 & 0x0F] + HEX_CHARS[h6 >> 12 & 0x0F] + HEX_CHARS[h6 >> 8 & 0x0F] + HEX_CHARS[h6 >> 4 & 0x0F] + HEX_CHARS[h6 & 0x0F];
        if (!this.is224) hex += HEX_CHARS[h7 >> 28 & 0x0F] + HEX_CHARS[h7 >> 24 & 0x0F] + HEX_CHARS[h7 >> 20 & 0x0F] + HEX_CHARS[h7 >> 16 & 0x0F] + HEX_CHARS[h7 >> 12 & 0x0F] + HEX_CHARS[h7 >> 8 & 0x0F] + HEX_CHARS[h7 >> 4 & 0x0F] + HEX_CHARS[h7 & 0x0F];
        return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
        var arr = [
            h0 >> 24 & 0xFF,
            h0 >> 16 & 0xFF,
            h0 >> 8 & 0xFF,
            h0 & 0xFF,
            h1 >> 24 & 0xFF,
            h1 >> 16 & 0xFF,
            h1 >> 8 & 0xFF,
            h1 & 0xFF,
            h2 >> 24 & 0xFF,
            h2 >> 16 & 0xFF,
            h2 >> 8 & 0xFF,
            h2 & 0xFF,
            h3 >> 24 & 0xFF,
            h3 >> 16 & 0xFF,
            h3 >> 8 & 0xFF,
            h3 & 0xFF,
            h4 >> 24 & 0xFF,
            h4 >> 16 & 0xFF,
            h4 >> 8 & 0xFF,
            h4 & 0xFF,
            h5 >> 24 & 0xFF,
            h5 >> 16 & 0xFF,
            h5 >> 8 & 0xFF,
            h5 & 0xFF,
            h6 >> 24 & 0xFF,
            h6 >> 16 & 0xFF,
            h6 >> 8 & 0xFF,
            h6 & 0xFF
        ];
        if (!this.is224) arr.push(h7 >> 24 & 0xFF, h7 >> 16 & 0xFF, h7 >> 8 & 0xFF, h7 & 0xFF);
        return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
        var dataView = new DataView(buffer);
        dataView.setUint32(0, this.h0);
        dataView.setUint32(4, this.h1);
        dataView.setUint32(8, this.h2);
        dataView.setUint32(12, this.h3);
        dataView.setUint32(16, this.h4);
        dataView.setUint32(20, this.h5);
        dataView.setUint32(24, this.h6);
        if (!this.is224) dataView.setUint32(28, this.h7);
        return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
        var i, type = typeof key;
        if (type === "string") {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >> 12;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >> 18;
                    bytes[index++] = 0x80 | code >> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        } else {
            if (type === "object") {
                if (key === null) throw new Error(ERROR);
                else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) key = new Uint8Array(key);
                else if (!Array.isArray(key)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) throw new Error(ERROR);
                }
            } else throw new Error(ERROR);
        }
        if (key.length > 64) key = new Sha256(is224, true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Sha256.call(this, is224, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
        Sha256.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Sha256.call(this, this.is224, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Sha256.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) module.exports = exports;
    else {
        root.sha256 = exports.sha256;
        root.sha224 = exports.sha224;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});

parcelRegister("gyf5Z", function(module, exports) {
"use strict";
var $c0cb87fcd68000dd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HereKeyStore = void 0;

var $lsY0f = parcelRequire("lsY0f");

var $fHqIu = parcelRequire("fHqIu");
class $c0cb87fcd68000dd$var$HereKeyStore {
    constructor(storage = new $fHqIu.StateStorage()){
        this.storage = storage;
    }
    setActiveAccount(network, id) {
        return $c0cb87fcd68000dd$var$__awaiter(this, void 0, void 0, function*() {
            const state = yield this.storage.getState(network);
            state.activeAccount = id;
            this.storage.setState(network, state);
        });
    }
    setKey(networkId, accountId, keyPair) {
        return $c0cb87fcd68000dd$var$__awaiter(this, void 0, void 0, function*() {
            const state = yield this.storage.getState(networkId);
            state.accounts[accountId] = keyPair.toString();
            this.storage.setState(networkId, state);
        });
    }
    getAccounts(network) {
        return $c0cb87fcd68000dd$var$__awaiter(this, void 0, void 0, function*() {
            const state = yield this.storage.getState(network);
            return Object.keys(state.accounts);
        });
    }
    getActiveAccount(network) {
        return $c0cb87fcd68000dd$var$__awaiter(this, void 0, void 0, function*() {
            const state = yield this.storage.getState(network);
            return state.activeAccount;
        });
    }
    getKey(networkId, accountId) {
        return $c0cb87fcd68000dd$var$__awaiter(this, void 0, void 0, function*() {
            const state = yield this.storage.getState(networkId);
            const privateKey = state.accounts[accountId];
            if (privateKey == null) throw Error(`For ${accountId} in ${networkId} network key not found`);
            const keyPair = $lsY0f.KeyPair.fromString(privateKey);
            return keyPair;
        });
    }
    removeKey(networkId, accountId) {
        return $c0cb87fcd68000dd$var$__awaiter(this, void 0, void 0, function*() {
            let state = yield this.storage.getState(networkId);
            if (state.activeAccount === accountId) state.activeAccount = null;
            delete state.accounts[accountId];
            this.storage.setState(networkId, state);
        });
    }
    getNetworks() {
        return $c0cb87fcd68000dd$var$__awaiter(this, void 0, void 0, function*() {
            let state = yield this.storage.getFullState();
            return Object.keys(state.accounts);
        });
    }
    clear() {
        return $c0cb87fcd68000dd$var$__awaiter(this, void 0, void 0, function*() {
            yield this.storage.clear();
        });
    }
}
module.exports.HereKeyStore = $c0cb87fcd68000dd$var$HereKeyStore;

});
parcelRegister("fHqIu", function(module, exports) {
"use strict";
var $b6df988041e6147b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StateStorage = void 0;

var $80Uyb = parcelRequire("80Uyb");
class $b6df988041e6147b$var$StateStorage {
    constructor(){
        this.dataKey = `herewallet:keystore`;
        $80Uyb.waitInjectedHereWallet.then((injected)=>{
            if (!injected) return;
            this.setState(injected.network, {
                accounts: {
                    [injected.accountId]: injected.publicKey
                },
                activeAccount: injected.accountId
            });
        });
    }
    setState(network, state) {
        return $b6df988041e6147b$var$__awaiter(this, void 0, void 0, function*() {
            yield $80Uyb.waitInjectedHereWallet;
            const data = yield this.getFullState();
            data[network] = state;
            window.localStorage.setItem(this.dataKey, JSON.stringify(data));
        });
    }
    getFullState() {
        return $b6df988041e6147b$var$__awaiter(this, void 0, void 0, function*() {
            yield $80Uyb.waitInjectedHereWallet;
            try {
                return JSON.parse(window.localStorage.getItem(this.dataKey)) || {};
            } catch (_a) {
                return {};
            }
        });
    }
    getState(network) {
        return $b6df988041e6147b$var$__awaiter(this, void 0, void 0, function*() {
            yield $80Uyb.waitInjectedHereWallet;
            const json = yield this.getFullState();
            return json[network] || {
                activeAccount: null,
                accounts: {}
            };
        });
    }
    clear() {
        return $b6df988041e6147b$var$__awaiter(this, void 0, void 0, function*() {
            window.localStorage.removeItem(this.dataKey);
        });
    }
}
module.exports.StateStorage = $b6df988041e6147b$var$StateStorage;

});
parcelRegister("80Uyb", function(module, exports) {
"use strict";
var $5d5a308bad8b725d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5d5a308bad8b725d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5d5a308bad8b725d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.proxyProvider = module.exports.waitInjectedHereWallet = module.exports.getRequest = module.exports.proxyApi = module.exports.deleteRequest = module.exports.getResponse = module.exports.createRequest = void 0;

const $5d5a308bad8b725d$var$uuid4_1 = $5d5a308bad8b725d$var$__importDefault((parcelRequire("bMaVy")));

var $aQl1z = parcelRequire("aQl1z");

var $c0EFx = parcelRequire("c0EFx");

var $3lfHw = parcelRequire("3lfHw");
Object.defineProperty(module.exports, "createRequest", {
    enumerable: true,
    get: function() {
        return $3lfHw.createRequest;
    }
});
Object.defineProperty(module.exports, "getResponse", {
    enumerable: true,
    get: function() {
        return $3lfHw.getResponse;
    }
});
Object.defineProperty(module.exports, "deleteRequest", {
    enumerable: true,
    get: function() {
        return $3lfHw.deleteRequest;
    }
});
Object.defineProperty(module.exports, "proxyApi", {
    enumerable: true,
    get: function() {
        return $3lfHw.proxyApi;
    }
});
Object.defineProperty(module.exports, "getRequest", {
    enumerable: true,
    get: function() {
        return $3lfHw.getRequest;
    }
});
module.exports.waitInjectedHereWallet = new Promise((resolve)=>{
    if (typeof window === "undefined") return resolve(null);
    if (window.self === window.top) return resolve(null);
    const handler = (e)=>{
        if (e.data.type !== "here-wallet-injected") return;
        window.parent.postMessage("here-sdk-init", "*");
        window.removeEventListener("message", handler);
        resolve({
            accountId: e.data.accountId,
            publicKey: e.data.publicKey,
            network: e.data.network || "mainnet"
        });
    };
    window.addEventListener("message", handler);
    setTimeout(()=>resolve(null), 2000);
});
const $5d5a308bad8b725d$var$proxyProvider = (conf)=>$5d5a308bad8b725d$var$__awaiter(void 0, void 0, void 0, function*() {
        const isInjected = yield module.exports.waitInjectedHereWallet;
        if (isInjected && typeof window !== "undefined") return new Promise((resolve)=>{
            const id = (0, $5d5a308bad8b725d$var$uuid4_1.default)();
            const handler = (e)=>{
                if (e.data.id !== id) return;
                if (e.data.status === $c0EFx.HereProviderStatus.SUCCESS || e.data.status === $c0EFx.HereProviderStatus.FAILED) {
                    window.removeEventListener("message", handler);
                    return resolve(e.data);
                }
            };
            window.parent.postMessage(Object.assign(Object.assign({
                $here: true
            }, conf.request), {
                id: id
            }), "*");
            window.addEventListener("message", handler);
        });
        let { strategy: strategy, request: request, disableCleanupRequest: disableCleanupRequest, id: id, signal: signal } = conf, delegate = $5d5a308bad8b725d$var$__rest(conf, [
            "strategy",
            "request",
            "disableCleanupRequest",
            "id",
            "signal"
        ]);
        if (id != null) request = yield (0, $3lfHw.getRequest)(id, signal);
        else id = yield (0, $3lfHw.createRequest)(request, signal);
        return new Promise((resolve, reject)=>{
            var _a, _b;
            const socketApi = $3lfHw.proxyApi.replace("https", "wss");
            let fallbackHttpTimer = null;
            let socket = null;
            const clear = ()=>$5d5a308bad8b725d$var$__awaiter(void 0, void 0, void 0, function*() {
                    fallbackHttpTimer = -1;
                    clearInterval(fallbackHttpTimer);
                    socket === null || socket === void 0 || socket.close();
                    if (disableCleanupRequest !== true) yield (0, $3lfHw.deleteRequest)(id);
                });
            const processApprove = (data)=>{
                var _a, _b, _c, _d, _e, _f;
                switch(data.status){
                    case $c0EFx.HereProviderStatus.APPROVING:
                        (_a = delegate.onApproving) === null || _a === void 0 || _a.call(delegate, data);
                        (_b = strategy === null || strategy === void 0 ? void 0 : strategy.onApproving) === null || _b === void 0 || _b.call(strategy, data);
                        return;
                    case $c0EFx.HereProviderStatus.FAILED:
                        clear();
                        reject(new $c0EFx.HereProviderError(data.payload));
                        (_c = delegate.onFailed) === null || _c === void 0 || _c.call(delegate, data);
                        (_d = strategy === null || strategy === void 0 ? void 0 : strategy.onFailed) === null || _d === void 0 || _d.call(strategy, data);
                        return;
                    case $c0EFx.HereProviderStatus.SUCCESS:
                        clear();
                        resolve(data);
                        (_e = delegate.onSuccess) === null || _e === void 0 || _e.call(delegate, data);
                        (_f = strategy === null || strategy === void 0 ? void 0 : strategy.onSuccess) === null || _f === void 0 || _f.call(strategy, data);
                        return;
                }
            };
            const rejectAction = (payload)=>{
                var _a;
                processApprove({
                    type: ((_a = request.selector) === null || _a === void 0 ? void 0 : _a.type) || "local",
                    status: $c0EFx.HereProviderStatus.FAILED,
                    payload: payload
                });
            };
            (_a = delegate.onRequested) === null || _a === void 0 || _a.call(delegate, id, request, rejectAction);
            (_b = strategy === null || strategy === void 0 ? void 0 : strategy.onRequested) === null || _b === void 0 || _b.call(strategy, id, request, rejectAction);
            signal === null || signal === void 0 || signal.addEventListener("abort", ()=>rejectAction());
            const setupTimer = ()=>{
                if (fallbackHttpTimer === -1) return;
                fallbackHttpTimer = setTimeout(()=>$5d5a308bad8b725d$var$__awaiter(void 0, void 0, void 0, function*() {
                        var _a, _b, _c, _d;
                        try {
                            const data = yield (0, $3lfHw.getResponse)(id);
                            if (fallbackHttpTimer === -1) return;
                            processApprove(data);
                            setupTimer();
                        } catch (e) {
                            const status = $c0EFx.HereProviderStatus.FAILED;
                            const error = e instanceof Error ? e : undefined;
                            const payload = error === null || error === void 0 ? void 0 : error.message;
                            clear();
                            reject(new $c0EFx.HereProviderError(payload, error));
                            (_a = delegate.onFailed) === null || _a === void 0 || _a.call(delegate, {
                                type: ((_b = request.selector) === null || _b === void 0 ? void 0 : _b.type) || "local",
                                status: status,
                                payload: payload
                            });
                            (_c = strategy === null || strategy === void 0 ? void 0 : strategy.onFailed) === null || _c === void 0 || _c.call(strategy, {
                                type: ((_d = request.selector) === null || _d === void 0 ? void 0 : _d.type) || "local",
                                status: status,
                                payload: payload
                            });
                        }
                    }), 3000);
            };
            setupTimer();
            // Mobile flow doesn't support cross tabs socket background process
            if ((0, $aQl1z.isMobile)() === false) {
                const endpoint = `${socketApi}/ws/${id}`;
                socket = new WebSocket(endpoint);
                socket.onmessage = (e)=>{
                    if (e.data == null) return;
                    try {
                        const data = JSON.parse(e.data);
                        processApprove(data);
                    } catch (_a) {
                    // nope
                    }
                };
            }
        });
    });
module.exports.proxyProvider = $5d5a308bad8b725d$var$proxyProvider;

});
parcelRegister("bMaVy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "valid", () => $d7a2e7bdd244e054$export$4143f540b2febe77);
$parcel$export(module.exports, "uuid4", () => $d7a2e7bdd244e054$export$19f53698e68b2496);
$parcel$export(module.exports, "default", () => $d7a2e7bdd244e054$export$2e2bcd8739ae039);
const $d7a2e7bdd244e054$var$uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
function $d7a2e7bdd244e054$export$4143f540b2febe77(uuid) {
    return $d7a2e7bdd244e054$var$uuidPattern.test(uuid);
}
// Based on https://abhishekdutta.org/blog/standalone_uuid_generator_in_javascript.html
// IE11 and Modern Browsers Only
function $d7a2e7bdd244e054$export$19f53698e68b2496() {
    var temp_url = URL.createObjectURL(new Blob());
    var uuid = temp_url.toString();
    URL.revokeObjectURL(temp_url);
    return uuid.split(/[:\/]/g).pop().toLowerCase(); // remove prefixes
}
$d7a2e7bdd244e054$export$19f53698e68b2496.valid = $d7a2e7bdd244e054$export$4143f540b2febe77;
var $d7a2e7bdd244e054$export$2e2bcd8739ae039 = $d7a2e7bdd244e054$export$19f53698e68b2496;

});

parcelRegister("aQl1z", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $7e4f11af06b97229$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $7e4f11af06b97229$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7e4f11af06b97229$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidAccessKey = module.exports.internalThrow = module.exports.getPublicKeys = module.exports.serializeActions = module.exports.isMobile = module.exports.getDeviceId = void 0;

const $7e4f11af06b97229$var$uuid4_1 = $7e4f11af06b97229$var$__importDefault((parcelRequire("bMaVy")));

var $c0EFx = parcelRequire("c0EFx");
const $7e4f11af06b97229$var$getDeviceId = ()=>{
    const topicId = window.localStorage.getItem("herewallet-topic") || (0, $7e4f11af06b97229$var$uuid4_1.default)();
    window.localStorage.setItem("herewallet-topic", topicId);
    return topicId;
};
module.exports.getDeviceId = $7e4f11af06b97229$var$getDeviceId;
const $7e4f11af06b97229$var$isMobile = ()=>{
    return window.matchMedia("(any-pointer:coarse)").matches;
};
module.exports.isMobile = $7e4f11af06b97229$var$isMobile;
const $7e4f11af06b97229$var$serializeActions = (actions)=>{
    return actions.map((act)=>{
        if (act.type !== "FunctionCall") return act;
        let { args: args, deposit: deposit, gas: gas, methodName: methodName } = act.params;
        if (ArrayBuffer.isView(args)) args = $7e4f11af06b97229$require$Buffer.from(args.buffer, args.byteOffset, args.byteLength);
        if (args instanceof $7e4f11af06b97229$require$Buffer) args = args.toString("base64");
        return {
            type: act.type,
            params: {
                args: args,
                deposit: deposit,
                gas: gas,
                methodName: methodName
            }
        };
    });
};
module.exports.serializeActions = $7e4f11af06b97229$var$serializeActions;
const $7e4f11af06b97229$var$getPublicKeys = (rpc, accountId)=>$7e4f11af06b97229$var$__awaiter(void 0, void 0, void 0, function*() {
        const res = yield fetch(rpc, {
            method: "POST",
            body: JSON.stringify({
                jsonrpc: "2.0",
                id: "dontcare",
                method: "query",
                params: {
                    request_type: "view_access_key_list",
                    finality: "final",
                    account_id: accountId
                }
            }),
            headers: {
                "content-type": "application/json"
            }
        });
        if (res.ok === false) return [];
        const data = yield res.json();
        return data.result.keys;
    });
module.exports.getPublicKeys = $7e4f11af06b97229$var$getPublicKeys;
const $7e4f11af06b97229$var$internalThrow = (error, delegate)=>{
    var _a, _b, _c, _d, _e;
    if (error instanceof $c0EFx.HereProviderError) throw error;
    const result = {
        payload: error instanceof Error ? error.message : "UNKNOWN",
        status: $c0EFx.HereProviderStatus.FAILED,
        type: ((_a = delegate.selector) === null || _a === void 0 ? void 0 : _a.type) || "local",
        account_id: ((_b = delegate.selector) === null || _b === void 0 ? void 0 : _b.id) || ""
    };
    (_c = delegate.onFailed) === null || _c === void 0 || _c.call(delegate, result);
    (_e = (_d = delegate === null || delegate === void 0 ? void 0 : delegate.strategy) === null || _d === void 0 ? void 0 : _d.onFailed) === null || _e === void 0 || _e.call(_d, result);
    throw error;
};
module.exports.internalThrow = $7e4f11af06b97229$var$internalThrow;
const $7e4f11af06b97229$var$isValidAccessKey = (accountId, accessKey, call)=>{
    const { permission: permission } = accessKey.access_key;
    if (permission === "FullAccess") return true;
    if (permission.FunctionCall) {
        const { receiver_id: allowedReceiverId, method_names: allowedMethods } = permission.FunctionCall;
        /********************************
        Accept multisig access keys and let wallets attempt to signAndSendTransaction
        If an access key has itself as receiverId and method permission add_request_and_confirm, then it is being used in a wallet with multisig contract: https://github.com/near/core-contracts/blob/671c05f09abecabe7a7e58efe942550a35fc3292/multisig/src/lib.rs#L149-L153
        ********************************/ if (allowedReceiverId === accountId && allowedMethods.includes("add_request_and_confirm")) return true;
        if (allowedReceiverId === call.receiverId) {
            if (call.actions.length !== 1) return false;
            return call.actions.every((action)=>{
                if (action.type !== "FunctionCall") return false;
                return (!action.params.deposit || action.params.deposit.toString() === "0") && (allowedMethods.length === 0 || allowedMethods.includes(action.params.methodName));
            });
        }
    }
    return false;
};
module.exports.isValidAccessKey = $7e4f11af06b97229$var$isValidAccessKey;

});
parcelRegister("c0EFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HereProviderError = module.exports.HereProviderStatus = void 0;
var $8be50827e020b706$var$HereProviderStatus;
(function(HereProviderStatus) {
    HereProviderStatus[HereProviderStatus["APPROVING"] = 1] = "APPROVING";
    HereProviderStatus[HereProviderStatus["FAILED"] = 2] = "FAILED";
    HereProviderStatus[HereProviderStatus["SUCCESS"] = 3] = "SUCCESS";
})($8be50827e020b706$var$HereProviderStatus = module.exports.HereProviderStatus || (module.exports.HereProviderStatus = {}));
class $8be50827e020b706$var$HereProviderError extends Error {
    constructor(payload, parentError){
        super(payload !== null && payload !== void 0 ? payload : parentError === null || parentError === void 0 ? void 0 : parentError.message);
        this.payload = payload;
        this.parentError = parentError;
    }
}
module.exports.HereProviderError = $8be50827e020b706$var$HereProviderError;

});


parcelRegister("3lfHw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $26ef8321cdae342f$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $26ef8321cdae342f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $26ef8321cdae342f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createRequest = module.exports.deleteRequest = module.exports.getResponse = module.exports.getRequest = module.exports.proxyApi = void 0;

const $26ef8321cdae342f$var$sha1_1 = $26ef8321cdae342f$var$__importDefault((parcelRequire("gSWFQ")));

const $26ef8321cdae342f$var$uuid4_1 = $26ef8321cdae342f$var$__importDefault((parcelRequire("bMaVy")));

var $11V5S = parcelRequire("11V5S");

var $aQl1z = parcelRequire("aQl1z");
module.exports.proxyApi = "https://h4n.app";
const $26ef8321cdae342f$var$getRequest = (id, signal)=>$26ef8321cdae342f$var$__awaiter(void 0, void 0, void 0, function*() {
        const res = yield fetch(`${module.exports.proxyApi}/${id}/request`, {
            signal: signal,
            headers: {
                "content-type": "application/json"
            },
            method: "GET"
        });
        if (res.ok === false) throw Error((yield res.text()));
        const { data: data } = yield res.json();
        return JSON.parse($26ef8321cdae342f$require$Buffer.from((0, $11V5S.base_decode)(data)).toString("utf8"));
    });
module.exports.getRequest = $26ef8321cdae342f$var$getRequest;
const $26ef8321cdae342f$var$getResponse = (id)=>$26ef8321cdae342f$var$__awaiter(void 0, void 0, void 0, function*() {
        var _a;
        const res = yield fetch(`${module.exports.proxyApi}/${id}/response`, {
            headers: {
                "content-type": "application/json"
            },
            method: "GET"
        });
        if (res.ok === false) throw Error((yield res.text()));
        const { data: data } = yield res.json();
        const result = (_a = JSON.parse(data)) !== null && _a !== void 0 ? _a : {};
        return Object.assign({
            type: "here",
            public_key: "",
            account_id: "",
            payload: "",
            status: -1,
            path: ""
        }, result);
    });
module.exports.getResponse = $26ef8321cdae342f$var$getResponse;
const $26ef8321cdae342f$var$deleteRequest = (id)=>$26ef8321cdae342f$var$__awaiter(void 0, void 0, void 0, function*() {
        const res = yield fetch(`${module.exports.proxyApi}/${id}`, {
            headers: {
                "content-type": "application/json"
            },
            method: "DELETE"
        });
        if (res.ok === false) throw Error((yield res.text()));
    });
module.exports.deleteRequest = $26ef8321cdae342f$var$deleteRequest;
const $26ef8321cdae342f$var$createRequest = (request, signal)=>$26ef8321cdae342f$var$__awaiter(void 0, void 0, void 0, function*() {
        const query = (0, $11V5S.base_encode)(JSON.stringify(Object.assign(Object.assign({}, request), {
            _id: (0, $26ef8321cdae342f$var$uuid4_1.default)()
        })));
        const hashsum = (0, $26ef8321cdae342f$var$sha1_1.default)(query);
        const id = $26ef8321cdae342f$require$Buffer.from(hashsum, "hex").toString("base64");
        const urlsafe = id.replaceAll("/", "_").replaceAll("-", "+").slice(0, 13);
        const res = yield fetch(`${module.exports.proxyApi}/${urlsafe}/request`, {
            method: "POST",
            signal: signal,
            body: JSON.stringify({
                topic_id: (0, $aQl1z.getDeviceId)(),
                data: query
            }),
            headers: {
                "content-type": "application/json"
            }
        });
        if (res.ok === false) throw Error((yield res.text()));
        return urlsafe;
    });
module.exports.createRequest = $26ef8321cdae342f$var$createRequest;

});
parcelRegister("gSWFQ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c4af33e4b432cf2d$require$Buffer = $6ZWSX.Buffer;



(function() {
    var crypt = (parcelRequire("12eZZ")), utf8 = (parcelRequire("a74v9")).utf8, bin = (parcelRequire("a74v9")).bin, // The core
    sha1 = function(message) {
        // Convert to byte array
        if (message.constructor == String) message = utf8.stringToBytes(message);
        else if (typeof $c4af33e4b432cf2d$require$Buffer !== "undefined" && typeof $c4af33e4b432cf2d$require$Buffer.isBuffer == "function" && $c4af33e4b432cf2d$require$Buffer.isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message)) message = message.toString();
        // otherwise assume byte array
        var m = crypt.bytesToWords(message), l = message.length * 8, w = [], H0 = 1732584193, H1 = -271733879, H2 = -1732584194, H3 = 271733878, H4 = -1009589776;
        // Padding
        m[l >> 5] |= 0x80 << 24 - l % 32;
        m[(l + 64 >>> 9 << 4) + 15] = l;
        for(var i = 0; i < m.length; i += 16){
            var a = H0, b = H1, c = H2, d = H3, e = H4;
            for(var j = 0; j < 80; j++){
                if (j < 16) w[j] = m[i + j];
                else {
                    var n = w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16];
                    w[j] = n << 1 | n >>> 31;
                }
                var t = (H0 << 5 | H0 >>> 27) + H4 + (w[j] >>> 0) + (j < 20 ? (H1 & H2 | ~H1 & H3) + 1518500249 : j < 40 ? (H1 ^ H2 ^ H3) + 1859775393 : j < 60 ? (H1 & H2 | H1 & H3 | H2 & H3) - 1894007588 : (H1 ^ H2 ^ H3) - 899497514);
                H4 = H3;
                H3 = H2;
                H2 = H1 << 30 | H1 >>> 2;
                H1 = H0;
                H0 = t;
            }
            H0 += a;
            H1 += b;
            H2 += c;
            H3 += d;
            H4 += e;
        }
        return [
            H0,
            H1,
            H2,
            H3,
            H4
        ];
    }, // Public API
    api = function(message, options) {
        var digestbytes = crypt.wordsToBytes(sha1(message));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
    api._blocksize = 16;
    api._digestsize = 20;
    module.exports = api;
})();

});
parcelRegister("12eZZ", function(module, exports) {
(function() {
    var base64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join("");
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push("=");
            }
            return base64.join("");
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, "");
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("a74v9", function(module, exports) {
var $75ce0cb6501c8271$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $75ce0cb6501c8271$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($75ce0cb6501c8271$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join("");
        }
    }
};
module.exports = $75ce0cb6501c8271$var$charenc;

});






parcelRegister("kxtkJ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $ef3da4bb38cb3d6a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createAction = module.exports.parseArgs = void 0;

var $dEXSZ = parcelRequire("dEXSZ");

var $k4rlt = parcelRequire("k4rlt");
const $ef3da4bb38cb3d6a$var$getAccessKey = (permission)=>{
    if (permission === "FullAccess") return $k4rlt.transactions.fullAccessKey();
    const { receiverId: receiverId, methodNames: methodNames = [] } = permission;
    const allowance = permission.allowance ? new $dEXSZ.BN(permission.allowance) : undefined;
    return $k4rlt.transactions.functionCallAccessKey(receiverId, methodNames, allowance);
};
const $ef3da4bb38cb3d6a$var$parseArgs = (data)=>{
    if (typeof data === "string") return $ef3da4bb38cb3d6a$require$Buffer.from(data, "base64");
    return data;
};
module.exports.parseArgs = $ef3da4bb38cb3d6a$var$parseArgs;
const $ef3da4bb38cb3d6a$var$createAction = (action)=>{
    switch(action.type){
        case "CreateAccount":
            return $k4rlt.transactions.createAccount();
        case "DeployContract":
            {
                const { code: code } = action.params;
                return $k4rlt.transactions.deployContract(code);
            }
        case "FunctionCall":
            {
                const { methodName: methodName, args: args, gas: gas, deposit: deposit } = action.params;
                return $k4rlt.transactions.functionCall(methodName, (0, module.exports.parseArgs)(args), new $dEXSZ.BN(gas), new $dEXSZ.BN(deposit));
            }
        case "Transfer":
            {
                const { deposit: deposit } = action.params;
                return $k4rlt.transactions.transfer(new $dEXSZ.BN(deposit));
            }
        case "Stake":
            {
                const { stake: stake, publicKey: publicKey } = action.params;
                return $k4rlt.transactions.stake(new $dEXSZ.BN(stake), $k4rlt.utils.PublicKey.from(publicKey));
            }
        case "AddKey":
            {
                const { publicKey: publicKey, accessKey: accessKey } = action.params;
                return $k4rlt.transactions.addKey($k4rlt.utils.PublicKey.from(publicKey), $ef3da4bb38cb3d6a$var$getAccessKey(accessKey.permission));
            }
        case "DeleteKey":
            {
                const { publicKey: publicKey } = action.params;
                return $k4rlt.transactions.deleteKey($k4rlt.utils.PublicKey.from(publicKey));
            }
        case "DeleteAccount":
            {
                const { beneficiaryId: beneficiaryId } = action.params;
                return $k4rlt.transactions.deleteAccount(beneficiaryId);
            }
        default:
            throw new Error("Invalid action type");
    }
};
module.exports.createAction = $ef3da4bb38cb3d6a$var$createAction;

});
parcelRegister("k4rlt", function(module, exports) {
"use strict";
var $e9c96496ce82840e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e9c96496ce82840e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e9c96496ce82840e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e9c96496ce82840e$var$__createBinding(result, mod, k);
    }
    $e9c96496ce82840e$var$__setModuleDefault(result, mod);
    return result;
};
var $e9c96496ce82840e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $e9c96496ce82840e$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keyStores = void 0;

/** @hidden @module */ module.exports.keyStores = $e9c96496ce82840e$var$__importStar((parcelRequire("88YbF")));

$e9c96496ce82840e$var$__exportStar((parcelRequire("dyqiS")), module.exports);

$e9c96496ce82840e$var$__exportStar((parcelRequire("cgxXB")), module.exports);

});


parcelRegister("d9LjM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WidgetStrategy = module.exports.defaultUrl = void 0;
const $9940d1fbccdf8490$var$createIframe = (widget)=>{
    const connector = document.createElement("iframe");
    connector.src = widget;
    connector.allow = "usb";
    connector.style.border = "none";
    connector.style.zIndex = "10000";
    connector.style.position = "fixed";
    connector.style.display = "none";
    connector.style.top = "0";
    connector.style.left = "0";
    connector.style.width = "100%";
    connector.style.height = "100%";
    document.body.appendChild(connector);
    return connector;
};
module.exports.defaultUrl = "https://my.herewallet.app/connector/index.html";
class $9940d1fbccdf8490$var$WidgetStrategy {
    constructor(options = {
        widget: module.exports.defaultUrl,
        lazy: false
    }){
        this.options = {
            lazy: typeof options === "object" ? options.lazy || false : false,
            widget: typeof options === "string" ? options : options.widget || module.exports.defaultUrl
        };
        if (!this.options.lazy) this.initIframe();
    }
    initIframe() {
        if ($9940d1fbccdf8490$var$WidgetStrategy.connector == null) {
            $9940d1fbccdf8490$var$WidgetStrategy.connector = $9940d1fbccdf8490$var$createIframe(this.options.widget);
            $9940d1fbccdf8490$var$WidgetStrategy.connector.addEventListener("load", ()=>{
                $9940d1fbccdf8490$var$WidgetStrategy.isLoaded = true;
            });
        }
        return $9940d1fbccdf8490$var$WidgetStrategy.connector;
    }
    onRequested(id, request, reject) {
        const iframe = this.initIframe();
        iframe.style.display = "block";
        const loadHandler = ()=>{
            var _a, _b, _c;
            (_a = $9940d1fbccdf8490$var$WidgetStrategy.connector) === null || _a === void 0 || _a.removeEventListener("load", loadHandler);
            (_c = (_b = $9940d1fbccdf8490$var$WidgetStrategy.connector) === null || _b === void 0 ? void 0 : _b.contentWindow) === null || _c === void 0 || _c.postMessage(JSON.stringify({
                type: "request",
                payload: {
                    id: id,
                    request: request
                }
            }), new URL(this.options.widget).origin);
        };
        if ($9940d1fbccdf8490$var$WidgetStrategy.isLoaded) loadHandler();
        else iframe.addEventListener("load", loadHandler);
        this.messageHandler = (event)=>{
            try {
                if (event.origin !== new URL(this.options.widget).origin) return;
                if (JSON.parse(event.data).type === "reject") reject();
            } catch (_a) {}
        };
        window.addEventListener("message", this.messageHandler);
    }
    postMessage(data) {
        var _a;
        const iframe = this.initIframe();
        const args = JSON.stringify(data);
        const origin = new URL(this.options.widget).origin;
        (_a = iframe.contentWindow) === null || _a === void 0 || _a.postMessage(args, origin);
    }
    onApproving() {
        this.postMessage({
            type: "approving"
        });
    }
    onSuccess(request) {
        console.log(request);
        this.postMessage({
            type: "result",
            payload: {
                request: request
            }
        });
        this.close();
    }
    onFailed(request) {
        this.postMessage({
            type: "result",
            payload: {
                request: request
            }
        });
        this.close();
    }
    close() {
        if (this.messageHandler) {
            window.removeEventListener("message", this.messageHandler);
            this.messageHandler = undefined;
        }
        if ($9940d1fbccdf8490$var$WidgetStrategy.connector) $9940d1fbccdf8490$var$WidgetStrategy.connector.style.display = "none";
    }
}
module.exports.WidgetStrategy = $9940d1fbccdf8490$var$WidgetStrategy;
$9940d1fbccdf8490$var$WidgetStrategy.isLoaded = false;

});

parcelRegister("53WOC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("1OggS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WindowStrategy = void 0;
class $1517150dfd8f11b7$var$WindowStrategy {
    constructor(endpoint = "https://my.herewallet.app"){
        this.endpoint = endpoint;
        this.signWindow = null;
        this.onFailed = ()=>this.close();
        this.onSuccess = ()=>this.close();
    }
    onInitialized() {
        if (this.signWindow) return;
        const left = window.innerWidth / 2 - 210;
        const top = window.innerHeight / 2 - 350;
        this.signWindow = window.open(`${this.endpoint}/loading`, "_blank", `popup=1,width=420,height=700,top=${top},left=${left}`);
    }
    onRequested(id, request, reject) {
        if (this.signWindow == null) return;
        this.unloadHandler = ()=>{
            var _a;
            return (_a = this.signWindow) === null || _a === void 0 ? void 0 : _a.close();
        };
        window.addEventListener("beforeunload", this.unloadHandler);
        this.signWindow.location = `${this.endpoint}/request/${id}`;
        this.timerHandler = setInterval(()=>{
            var _a;
            if ((_a = this.signWindow) === null || _a === void 0 ? void 0 : _a.closed) reject("CLOSED");
        }, 1000);
    }
    close() {
        var _a;
        clearInterval(this.timerHandler);
        (_a = this.signWindow) === null || _a === void 0 || _a.close();
        this.signWindow = null;
        if (this.unloadHandler) window.removeEventListener("beforeunload", this.unloadHandler);
    }
}
module.exports.WindowStrategy = $1517150dfd8f11b7$var$WindowStrategy;

});

parcelRegister("kvy29", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

var $7238a34a955809b2$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7238a34a955809b2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7238a34a955809b2$exports));
try {
    regeneratorRuntime = $7238a34a955809b2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7238a34a955809b2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7238a34a955809b2$var$runtime);
}



var $k4rlt = parcelRequire("k4rlt");
// near api js

var $k4rlt = parcelRequire("k4rlt");
function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}


function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}


function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};






function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(errors)), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && "closed" in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};


function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));


function $6fb8b1c12553edae$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $7569c528cdd9d182$export$f0954fd7d5368655);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $6fb8b1c12553edae$var$defaultCompare;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $6fb8b1c12553edae$var$defaultCompare(a, b) {
    return a === b;
}



function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}



var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";
var $11492dca620dcaa5$exports = {};
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



var $acw62 = parcelRequire("acw62");

var $k4rlt = parcelRequire("k4rlt");

var $7etJZ = parcelRequire("7etJZ");




var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();



function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);


var $7aced346698c521d$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038));



function $35711d117487b96b$export$30fc204bc7867c02(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}


function $095ac41f805f8ce2$export$c87d910e63d22ed6(accumulator, seed) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)((0, $35711d117487b96b$export$30fc204bc7867c02)(accumulator, seed, arguments.length >= 2, true));
}


var $142391d738890b4f$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $142391d738890b4f$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $142391d738890b4f$var$__createBinding = $142391d738890b4f$exports && $142391d738890b4f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $142391d738890b4f$var$__setModuleDefault = $142391d738890b4f$exports && $142391d738890b4f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $142391d738890b4f$var$__decorate = $142391d738890b4f$exports && $142391d738890b4f$exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $142391d738890b4f$var$__importStar = $142391d738890b4f$exports && $142391d738890b4f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $142391d738890b4f$var$__createBinding(result, mod, k);
    }
    $142391d738890b4f$var$__setModuleDefault(result, mod);
    return result;
};
var $142391d738890b4f$var$__importDefault = $142391d738890b4f$exports && $142391d738890b4f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($142391d738890b4f$exports, "__esModule", {
    value: true
});
$142391d738890b4f$exports.deserializeUnchecked = $142391d738890b4f$exports.deserialize = $142391d738890b4f$exports.serialize = $142391d738890b4f$exports.BinaryReader = $142391d738890b4f$exports.BinaryWriter = $142391d738890b4f$exports.BorshError = $142391d738890b4f$exports.baseDecode = $142391d738890b4f$exports.baseEncode = void 0;

const $142391d738890b4f$var$bn_js_1 = $142391d738890b4f$var$__importDefault((parcelRequire("dEXSZ")));

const $142391d738890b4f$var$bs58_1 = $142391d738890b4f$var$__importDefault((parcelRequire("lqZGs")));

// TODO: Make sure this polyfill not included when not required
const $142391d738890b4f$var$encoding = $142391d738890b4f$var$__importStar((parcelRequire("kOaA4")));
const $142391d738890b4f$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $142391d738890b4f$var$encoding.TextDecoder : TextDecoder;
const $142391d738890b4f$var$textDecoder = new $142391d738890b4f$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $142391d738890b4f$var$baseEncode(value) {
    if (typeof value === "string") value = $142391d738890b4f$require$Buffer.from(value, "utf8");
    return $142391d738890b4f$var$bs58_1.default.encode($142391d738890b4f$require$Buffer.from(value));
}
$142391d738890b4f$exports.baseEncode = $142391d738890b4f$var$baseEncode;
function $142391d738890b4f$var$baseDecode(value) {
    return $142391d738890b4f$require$Buffer.from($142391d738890b4f$var$bs58_1.default.decode(value));
}
$142391d738890b4f$exports.baseDecode = $142391d738890b4f$var$baseDecode;
const $142391d738890b4f$var$INITIAL_LENGTH = 1024;
class $142391d738890b4f$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
$142391d738890b4f$exports.BorshError = $142391d738890b4f$var$BorshError;
/// Binary encoder.
class $142391d738890b4f$var$BinaryWriter {
    constructor(){
        this.buf = $142391d738890b4f$require$Buffer.alloc($142391d738890b4f$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $142391d738890b4f$require$Buffer.concat([
            this.buf,
            $142391d738890b4f$require$Buffer.alloc($142391d738890b4f$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($142391d738890b4f$require$Buffer.from(new $142391d738890b4f$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($142391d738890b4f$require$Buffer.from(new $142391d738890b4f$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($142391d738890b4f$require$Buffer.from(new $142391d738890b4f$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($142391d738890b4f$require$Buffer.from(new $142391d738890b4f$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $142391d738890b4f$require$Buffer.concat([
            $142391d738890b4f$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $142391d738890b4f$require$Buffer.alloc($142391d738890b4f$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $142391d738890b4f$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($142391d738890b4f$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
$142391d738890b4f$exports.BinaryWriter = $142391d738890b4f$var$BinaryWriter;
function $142391d738890b4f$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $142391d738890b4f$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $142391d738890b4f$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $142391d738890b4f$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $142391d738890b4f$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $142391d738890b4f$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $142391d738890b4f$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $142391d738890b4f$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $142391d738890b4f$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $142391d738890b4f$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readU8", null);
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readU16", null);
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readU32", null);
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readU64", null);
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readU128", null);
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readU256", null);
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readU512", null);
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readString", null);
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readFixedArray", null);
$142391d738890b4f$var$__decorate([
    $142391d738890b4f$var$handlingRangeError
], $142391d738890b4f$var$BinaryReader.prototype, "readArray", null);
$142391d738890b4f$exports.BinaryReader = $142391d738890b4f$var$BinaryReader;
function $142391d738890b4f$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $142391d738890b4f$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$142391d738890b4f$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $142391d738890b4f$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $142391d738890b4f$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$142391d738890b4f$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $142391d738890b4f$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $142391d738890b4f$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $142391d738890b4f$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $142391d738890b4f$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $142391d738890b4f$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $142391d738890b4f$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $142391d738890b4f$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $142391d738890b4f$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $142391d738890b4f$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $142391d738890b4f$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $142391d738890b4f$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $142391d738890b4f$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $142391d738890b4f$var$serialize(schema, obj, Writer = $142391d738890b4f$var$BinaryWriter) {
    const writer = new Writer();
    $142391d738890b4f$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
$142391d738890b4f$exports.serialize = $142391d738890b4f$var$serialize;
function $142391d738890b4f$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$142391d738890b4f$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($142391d738890b4f$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$142391d738890b4f$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $142391d738890b4f$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $142391d738890b4f$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $142391d738890b4f$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $142391d738890b4f$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $142391d738890b4f$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $142391d738890b4f$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $142391d738890b4f$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $142391d738890b4f$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $142391d738890b4f$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $142391d738890b4f$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $142391d738890b4f$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $142391d738890b4f$var$deserialize(schema, classType, buffer, Reader = $142391d738890b4f$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $142391d738890b4f$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $142391d738890b4f$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
$142391d738890b4f$exports.deserialize = $142391d738890b4f$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $142391d738890b4f$var$deserializeUnchecked(schema, classType, buffer, Reader = $142391d738890b4f$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $142391d738890b4f$var$deserializeStruct(schema, classType, reader);
}
$142391d738890b4f$exports.deserializeUnchecked = $142391d738890b4f$var$deserializeUnchecked;



var $fBCU1 = parcelRequire("fBCU1");

var $6ZWSX = parcelRequire("6ZWSX");
var $5bb7220e37bd460f$require$Buffer = $6ZWSX.Buffer;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $5bb7220e37bd460f$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
class $5bb7220e37bd460f$var$Provider {
    constructor(url){
        this.provider = new $k4rlt.providers.JsonRpcProvider({
            url: url
        });
    }
    query(params) {
        return this.provider.query(params);
    }
    viewAccessKey({ accountId: accountId, publicKey: publicKey }) {
        return this.query({
            request_type: "view_access_key",
            finality: "final",
            account_id: accountId,
            public_key: publicKey
        });
    }
    block(reference) {
        return this.provider.block(reference);
    }
    sendTransaction(signedTransaction) {
        return this.provider.sendTransaction(signedTransaction);
    }
}
const $5bb7220e37bd460f$var$KEY_DELIMITER = ":";
class $5bb7220e37bd460f$var$JsonStorage {
    constructor(storage, namespace){
        this.storage = storage;
        this.namespace = Array.isArray(namespace) ? namespace.join($5bb7220e37bd460f$var$KEY_DELIMITER) : namespace;
    }
    resolveKey(key) {
        return [
            this.namespace,
            key
        ].join($5bb7220e37bd460f$var$KEY_DELIMITER);
    }
    getItem(key) {
        return this.storage.getItem(this.resolveKey(key)).then((item)=>{
            return typeof item === "string" ? JSON.parse(item) : null;
        });
    }
    setItem(key, value) {
        return this.storage.setItem(this.resolveKey(key), JSON.stringify(value));
    }
    removeItem(key) {
        return this.storage.removeItem(this.resolveKey(key));
    }
}
var $5bb7220e37bd460f$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $5bb7220e37bd460f$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $5bb7220e37bd460f$var$global$t = // eslint-disable-next-line es-x/no-global-this -- safe
$5bb7220e37bd460f$var$check(typeof globalThis == "object" && globalThis) || $5bb7220e37bd460f$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$5bb7220e37bd460f$var$check(typeof self == "object" && self) || $5bb7220e37bd460f$var$check(typeof $5bb7220e37bd460f$var$commonjsGlobal == "object" && $5bb7220e37bd460f$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor = {};
var $5bb7220e37bd460f$var$fails$s = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $5bb7220e37bd460f$var$fails$r = $5bb7220e37bd460f$var$fails$s;
// Detect IE8's incomplete defineProperty implementation
var $5bb7220e37bd460f$var$descriptors = !$5bb7220e37bd460f$var$fails$r(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $5bb7220e37bd460f$var$fails$q = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$functionBindNative = !$5bb7220e37bd460f$var$fails$q(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $5bb7220e37bd460f$var$NATIVE_BIND$3 = $5bb7220e37bd460f$var$functionBindNative;
var $5bb7220e37bd460f$var$call$l = Function.prototype.call;
var $5bb7220e37bd460f$var$functionCall = $5bb7220e37bd460f$var$NATIVE_BIND$3 ? $5bb7220e37bd460f$var$call$l.bind($5bb7220e37bd460f$var$call$l) : function() {
    return $5bb7220e37bd460f$var$call$l.apply($5bb7220e37bd460f$var$call$l, arguments);
};
var $5bb7220e37bd460f$var$objectPropertyIsEnumerable = {};
var $5bb7220e37bd460f$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5bb7220e37bd460f$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $5bb7220e37bd460f$var$NASHORN_BUG = $5bb7220e37bd460f$var$getOwnPropertyDescriptor$2 && !$5bb7220e37bd460f$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$5bb7220e37bd460f$var$objectPropertyIsEnumerable.f = $5bb7220e37bd460f$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $5bb7220e37bd460f$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $5bb7220e37bd460f$var$$propertyIsEnumerable;
var $5bb7220e37bd460f$var$createPropertyDescriptor$5 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $5bb7220e37bd460f$var$NATIVE_BIND$2 = $5bb7220e37bd460f$var$functionBindNative;
var $5bb7220e37bd460f$var$FunctionPrototype$2 = Function.prototype;
var $5bb7220e37bd460f$var$bind$7 = $5bb7220e37bd460f$var$FunctionPrototype$2.bind;
var $5bb7220e37bd460f$var$call$k = $5bb7220e37bd460f$var$FunctionPrototype$2.call;
var $5bb7220e37bd460f$var$uncurryThis$p = $5bb7220e37bd460f$var$NATIVE_BIND$2 && $5bb7220e37bd460f$var$bind$7.bind($5bb7220e37bd460f$var$call$k, $5bb7220e37bd460f$var$call$k);
var $5bb7220e37bd460f$var$functionUncurryThis = $5bb7220e37bd460f$var$NATIVE_BIND$2 ? function(fn) {
    return fn && $5bb7220e37bd460f$var$uncurryThis$p(fn);
} : function(fn) {
    return fn && function() {
        return $5bb7220e37bd460f$var$call$k.apply(fn, arguments);
    };
};
var $5bb7220e37bd460f$var$uncurryThis$o = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$toString$7 = $5bb7220e37bd460f$var$uncurryThis$o({}.toString);
var $5bb7220e37bd460f$var$stringSlice$3 = $5bb7220e37bd460f$var$uncurryThis$o("".slice);
var $5bb7220e37bd460f$var$classofRaw$1 = function(it) {
    return $5bb7220e37bd460f$var$stringSlice$3($5bb7220e37bd460f$var$toString$7(it), 8, -1);
};
var $5bb7220e37bd460f$var$uncurryThis$n = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$fails$p = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$classof$b = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$$Object$4 = Object;
var $5bb7220e37bd460f$var$split = $5bb7220e37bd460f$var$uncurryThis$n("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $5bb7220e37bd460f$var$indexedObject = $5bb7220e37bd460f$var$fails$p(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$5bb7220e37bd460f$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $5bb7220e37bd460f$var$classof$b(it) == "String" ? $5bb7220e37bd460f$var$split(it, "") : $5bb7220e37bd460f$var$$Object$4(it);
} : $5bb7220e37bd460f$var$$Object$4;
var $5bb7220e37bd460f$var$$TypeError$f = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $5bb7220e37bd460f$var$requireObjectCoercible$6 = function(it) {
    if (it == undefined) throw $5bb7220e37bd460f$var$$TypeError$f("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $5bb7220e37bd460f$var$IndexedObject$3 = $5bb7220e37bd460f$var$indexedObject;
var $5bb7220e37bd460f$var$requireObjectCoercible$5 = $5bb7220e37bd460f$var$requireObjectCoercible$6;
var $5bb7220e37bd460f$var$toIndexedObject$6 = function(it) {
    return $5bb7220e37bd460f$var$IndexedObject$3($5bb7220e37bd460f$var$requireObjectCoercible$5(it));
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $5bb7220e37bd460f$var$isCallable$n = function(argument) {
    return typeof argument == "function";
};
var $5bb7220e37bd460f$var$isCallable$m = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$isObject$d = function(it) {
    return typeof it == "object" ? it !== null : $5bb7220e37bd460f$var$isCallable$m(it);
};
var $5bb7220e37bd460f$var$global$s = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$isCallable$l = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$aFunction = function(argument) {
    return $5bb7220e37bd460f$var$isCallable$l(argument) ? argument : undefined;
};
var $5bb7220e37bd460f$var$getBuiltIn$8 = function(namespace, method) {
    return arguments.length < 2 ? $5bb7220e37bd460f$var$aFunction($5bb7220e37bd460f$var$global$s[namespace]) : $5bb7220e37bd460f$var$global$s[namespace] && $5bb7220e37bd460f$var$global$s[namespace][method];
};
var $5bb7220e37bd460f$var$uncurryThis$m = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$objectIsPrototypeOf = $5bb7220e37bd460f$var$uncurryThis$m({}.isPrototypeOf);
var $5bb7220e37bd460f$var$getBuiltIn$7 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$engineUserAgent = $5bb7220e37bd460f$var$getBuiltIn$7("navigator", "userAgent") || "";
var $5bb7220e37bd460f$var$global$r = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$userAgent$5 = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$process$3 = $5bb7220e37bd460f$var$global$r.process;
var $5bb7220e37bd460f$var$Deno$1 = $5bb7220e37bd460f$var$global$r.Deno;
var $5bb7220e37bd460f$var$versions = $5bb7220e37bd460f$var$process$3 && $5bb7220e37bd460f$var$process$3.versions || $5bb7220e37bd460f$var$Deno$1 && $5bb7220e37bd460f$var$Deno$1.version;
var $5bb7220e37bd460f$var$v8 = $5bb7220e37bd460f$var$versions && $5bb7220e37bd460f$var$versions.v8;
var $5bb7220e37bd460f$var$match, $5bb7220e37bd460f$var$version;
if ($5bb7220e37bd460f$var$v8) {
    $5bb7220e37bd460f$var$match = $5bb7220e37bd460f$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $5bb7220e37bd460f$var$version = $5bb7220e37bd460f$var$match[0] > 0 && $5bb7220e37bd460f$var$match[0] < 4 ? 1 : +($5bb7220e37bd460f$var$match[0] + $5bb7220e37bd460f$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$5bb7220e37bd460f$var$version && $5bb7220e37bd460f$var$userAgent$5) {
    $5bb7220e37bd460f$var$match = $5bb7220e37bd460f$var$userAgent$5.match(/Edge\/(\d+)/);
    if (!$5bb7220e37bd460f$var$match || $5bb7220e37bd460f$var$match[1] >= 74) {
        $5bb7220e37bd460f$var$match = $5bb7220e37bd460f$var$userAgent$5.match(/Chrome\/(\d+)/);
        if ($5bb7220e37bd460f$var$match) $5bb7220e37bd460f$var$version = +$5bb7220e37bd460f$var$match[1];
    }
}
var $5bb7220e37bd460f$var$engineV8Version = $5bb7220e37bd460f$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $5bb7220e37bd460f$var$V8_VERSION$1 = $5bb7220e37bd460f$var$engineV8Version;
var $5bb7220e37bd460f$var$fails$o = $5bb7220e37bd460f$var$fails$s;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $5bb7220e37bd460f$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$5bb7220e37bd460f$var$fails$o(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $5bb7220e37bd460f$var$V8_VERSION$1 && $5bb7220e37bd460f$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $5bb7220e37bd460f$var$NATIVE_SYMBOL$1 = $5bb7220e37bd460f$var$nativeSymbol;
var $5bb7220e37bd460f$var$useSymbolAsUid = $5bb7220e37bd460f$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $5bb7220e37bd460f$var$getBuiltIn$6 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$isCallable$k = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$isPrototypeOf$4 = $5bb7220e37bd460f$var$objectIsPrototypeOf;
var $5bb7220e37bd460f$var$USE_SYMBOL_AS_UID$1 = $5bb7220e37bd460f$var$useSymbolAsUid;
var $5bb7220e37bd460f$var$$Object$3 = Object;
var $5bb7220e37bd460f$var$isSymbol$3 = $5bb7220e37bd460f$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $5bb7220e37bd460f$var$getBuiltIn$6("Symbol");
    return $5bb7220e37bd460f$var$isCallable$k($Symbol) && $5bb7220e37bd460f$var$isPrototypeOf$4($Symbol.prototype, $5bb7220e37bd460f$var$$Object$3(it));
};
var $5bb7220e37bd460f$var$$String$3 = String;
var $5bb7220e37bd460f$var$tryToString$5 = function(argument) {
    try {
        return $5bb7220e37bd460f$var$$String$3(argument);
    } catch (error) {
        return "Object";
    }
};
var $5bb7220e37bd460f$var$isCallable$j = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$tryToString$4 = $5bb7220e37bd460f$var$tryToString$5;
var $5bb7220e37bd460f$var$$TypeError$e = TypeError;
// `Assert: IsCallable(argument) is true`
var $5bb7220e37bd460f$var$aCallable$9 = function(argument) {
    if ($5bb7220e37bd460f$var$isCallable$j(argument)) return argument;
    throw $5bb7220e37bd460f$var$$TypeError$e($5bb7220e37bd460f$var$tryToString$4(argument) + " is not a function");
};
var $5bb7220e37bd460f$var$aCallable$8 = $5bb7220e37bd460f$var$aCallable$9;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $5bb7220e37bd460f$var$getMethod$4 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $5bb7220e37bd460f$var$aCallable$8(func);
};
var $5bb7220e37bd460f$var$call$j = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$isCallable$i = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$isObject$c = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$$TypeError$d = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $5bb7220e37bd460f$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $5bb7220e37bd460f$var$isCallable$i(fn = input.toString) && !$5bb7220e37bd460f$var$isObject$c(val = $5bb7220e37bd460f$var$call$j(fn, input))) return val;
    if ($5bb7220e37bd460f$var$isCallable$i(fn = input.valueOf) && !$5bb7220e37bd460f$var$isObject$c(val = $5bb7220e37bd460f$var$call$j(fn, input))) return val;
    if (pref !== "string" && $5bb7220e37bd460f$var$isCallable$i(fn = input.toString) && !$5bb7220e37bd460f$var$isObject$c(val = $5bb7220e37bd460f$var$call$j(fn, input))) return val;
    throw $5bb7220e37bd460f$var$$TypeError$d("Can't convert object to primitive value");
};
var $5bb7220e37bd460f$var$shared$4 = {
    exports: {}
};
var $5bb7220e37bd460f$var$global$q = $5bb7220e37bd460f$var$global$t;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5bb7220e37bd460f$var$defineProperty$7 = Object.defineProperty;
var $5bb7220e37bd460f$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $5bb7220e37bd460f$var$defineProperty$7($5bb7220e37bd460f$var$global$q, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $5bb7220e37bd460f$var$global$q[key] = value;
    }
    return value;
};
var $5bb7220e37bd460f$var$global$p = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$defineGlobalProperty$2 = $5bb7220e37bd460f$var$defineGlobalProperty$3;
var $5bb7220e37bd460f$var$SHARED = "__core-js_shared__";
var $5bb7220e37bd460f$var$store$3 = $5bb7220e37bd460f$var$global$p[$5bb7220e37bd460f$var$SHARED] || $5bb7220e37bd460f$var$defineGlobalProperty$2($5bb7220e37bd460f$var$SHARED, {});
var $5bb7220e37bd460f$var$sharedStore = $5bb7220e37bd460f$var$store$3;
var $5bb7220e37bd460f$var$store$2 = $5bb7220e37bd460f$var$sharedStore;
($5bb7220e37bd460f$var$shared$4.exports = function(key, value) {
    return $5bb7220e37bd460f$var$store$2[key] || ($5bb7220e37bd460f$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $5bb7220e37bd460f$var$requireObjectCoercible$4 = $5bb7220e37bd460f$var$requireObjectCoercible$6;
var $5bb7220e37bd460f$var$$Object$2 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $5bb7220e37bd460f$var$toObject$7 = function(argument) {
    return $5bb7220e37bd460f$var$$Object$2($5bb7220e37bd460f$var$requireObjectCoercible$4(argument));
};
var $5bb7220e37bd460f$var$uncurryThis$l = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$toObject$6 = $5bb7220e37bd460f$var$toObject$7;
var $5bb7220e37bd460f$var$hasOwnProperty = $5bb7220e37bd460f$var$uncurryThis$l({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $5bb7220e37bd460f$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $5bb7220e37bd460f$var$hasOwnProperty($5bb7220e37bd460f$var$toObject$6(it), key);
};
var $5bb7220e37bd460f$var$uncurryThis$k = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$id = 0;
var $5bb7220e37bd460f$var$postfix = Math.random();
var $5bb7220e37bd460f$var$toString$6 = $5bb7220e37bd460f$var$uncurryThis$k(1.0.toString);
var $5bb7220e37bd460f$var$uid$3 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5bb7220e37bd460f$var$toString$6(++$5bb7220e37bd460f$var$id + $5bb7220e37bd460f$var$postfix, 36);
};
var $5bb7220e37bd460f$var$global$o = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$shared$3 = $5bb7220e37bd460f$var$shared$4.exports;
var $5bb7220e37bd460f$var$hasOwn$b = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$uid$2 = $5bb7220e37bd460f$var$uid$3;
var $5bb7220e37bd460f$var$NATIVE_SYMBOL = $5bb7220e37bd460f$var$nativeSymbol;
var $5bb7220e37bd460f$var$USE_SYMBOL_AS_UID = $5bb7220e37bd460f$var$useSymbolAsUid;
var $5bb7220e37bd460f$var$WellKnownSymbolsStore = $5bb7220e37bd460f$var$shared$3("wks");
var $5bb7220e37bd460f$var$Symbol$1 = $5bb7220e37bd460f$var$global$o.Symbol;
var $5bb7220e37bd460f$var$symbolFor = $5bb7220e37bd460f$var$Symbol$1 && $5bb7220e37bd460f$var$Symbol$1["for"];
var $5bb7220e37bd460f$var$createWellKnownSymbol = $5bb7220e37bd460f$var$USE_SYMBOL_AS_UID ? $5bb7220e37bd460f$var$Symbol$1 : $5bb7220e37bd460f$var$Symbol$1 && $5bb7220e37bd460f$var$Symbol$1.withoutSetter || $5bb7220e37bd460f$var$uid$2;
var $5bb7220e37bd460f$var$wellKnownSymbol$j = function(name) {
    if (!$5bb7220e37bd460f$var$hasOwn$b($5bb7220e37bd460f$var$WellKnownSymbolsStore, name) || !($5bb7220e37bd460f$var$NATIVE_SYMBOL || typeof $5bb7220e37bd460f$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($5bb7220e37bd460f$var$NATIVE_SYMBOL && $5bb7220e37bd460f$var$hasOwn$b($5bb7220e37bd460f$var$Symbol$1, name)) $5bb7220e37bd460f$var$WellKnownSymbolsStore[name] = $5bb7220e37bd460f$var$Symbol$1[name];
        else if ($5bb7220e37bd460f$var$USE_SYMBOL_AS_UID && $5bb7220e37bd460f$var$symbolFor) $5bb7220e37bd460f$var$WellKnownSymbolsStore[name] = $5bb7220e37bd460f$var$symbolFor(description);
        else $5bb7220e37bd460f$var$WellKnownSymbolsStore[name] = $5bb7220e37bd460f$var$createWellKnownSymbol(description);
    }
    return $5bb7220e37bd460f$var$WellKnownSymbolsStore[name];
};
var $5bb7220e37bd460f$var$call$i = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$isObject$b = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$isSymbol$2 = $5bb7220e37bd460f$var$isSymbol$3;
var $5bb7220e37bd460f$var$getMethod$3 = $5bb7220e37bd460f$var$getMethod$4;
var $5bb7220e37bd460f$var$ordinaryToPrimitive = $5bb7220e37bd460f$var$ordinaryToPrimitive$1;
var $5bb7220e37bd460f$var$wellKnownSymbol$i = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$$TypeError$c = TypeError;
var $5bb7220e37bd460f$var$TO_PRIMITIVE = $5bb7220e37bd460f$var$wellKnownSymbol$i("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $5bb7220e37bd460f$var$toPrimitive$2 = function(input, pref) {
    if (!$5bb7220e37bd460f$var$isObject$b(input) || $5bb7220e37bd460f$var$isSymbol$2(input)) return input;
    var exoticToPrim = $5bb7220e37bd460f$var$getMethod$3(input, $5bb7220e37bd460f$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $5bb7220e37bd460f$var$call$i(exoticToPrim, input, pref);
        if (!$5bb7220e37bd460f$var$isObject$b(result) || $5bb7220e37bd460f$var$isSymbol$2(result)) return result;
        throw $5bb7220e37bd460f$var$$TypeError$c("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $5bb7220e37bd460f$var$ordinaryToPrimitive(input, pref);
};
var $5bb7220e37bd460f$var$toPrimitive$1 = $5bb7220e37bd460f$var$toPrimitive$2;
var $5bb7220e37bd460f$var$isSymbol$1 = $5bb7220e37bd460f$var$isSymbol$3;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $5bb7220e37bd460f$var$toPropertyKey$4 = function(argument) {
    var key = $5bb7220e37bd460f$var$toPrimitive$1(argument, "string");
    return $5bb7220e37bd460f$var$isSymbol$1(key) ? key : key + "";
};
var $5bb7220e37bd460f$var$global$n = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$isObject$a = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$document$3 = $5bb7220e37bd460f$var$global$n.document;
// typeof document.createElement is 'object' in old IE
var $5bb7220e37bd460f$var$EXISTS$1 = $5bb7220e37bd460f$var$isObject$a($5bb7220e37bd460f$var$document$3) && $5bb7220e37bd460f$var$isObject$a($5bb7220e37bd460f$var$document$3.createElement);
var $5bb7220e37bd460f$var$documentCreateElement$2 = function(it) {
    return $5bb7220e37bd460f$var$EXISTS$1 ? $5bb7220e37bd460f$var$document$3.createElement(it) : {};
};
var $5bb7220e37bd460f$var$DESCRIPTORS$d = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$fails$n = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$createElement$1 = $5bb7220e37bd460f$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $5bb7220e37bd460f$var$ie8DomDefine = !$5bb7220e37bd460f$var$DESCRIPTORS$d && !$5bb7220e37bd460f$var$fails$n(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($5bb7220e37bd460f$var$createElement$1("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $5bb7220e37bd460f$var$DESCRIPTORS$c = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$call$h = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$propertyIsEnumerableModule$1 = $5bb7220e37bd460f$var$objectPropertyIsEnumerable;
var $5bb7220e37bd460f$var$createPropertyDescriptor$4 = $5bb7220e37bd460f$var$createPropertyDescriptor$5;
var $5bb7220e37bd460f$var$toIndexedObject$5 = $5bb7220e37bd460f$var$toIndexedObject$6;
var $5bb7220e37bd460f$var$toPropertyKey$3 = $5bb7220e37bd460f$var$toPropertyKey$4;
var $5bb7220e37bd460f$var$hasOwn$a = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$IE8_DOM_DEFINE$1 = $5bb7220e37bd460f$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5bb7220e37bd460f$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor.f = $5bb7220e37bd460f$var$DESCRIPTORS$c ? $5bb7220e37bd460f$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $5bb7220e37bd460f$var$toIndexedObject$5(O);
    P = $5bb7220e37bd460f$var$toPropertyKey$3(P);
    if ($5bb7220e37bd460f$var$IE8_DOM_DEFINE$1) try {
        return $5bb7220e37bd460f$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($5bb7220e37bd460f$var$hasOwn$a(O, P)) return $5bb7220e37bd460f$var$createPropertyDescriptor$4(!$5bb7220e37bd460f$var$call$h($5bb7220e37bd460f$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $5bb7220e37bd460f$var$objectDefineProperty = {};
var $5bb7220e37bd460f$var$DESCRIPTORS$b = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$fails$m = $5bb7220e37bd460f$var$fails$s;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $5bb7220e37bd460f$var$v8PrototypeDefineBug = $5bb7220e37bd460f$var$DESCRIPTORS$b && $5bb7220e37bd460f$var$fails$m(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $5bb7220e37bd460f$var$isObject$9 = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$$String$2 = String;
var $5bb7220e37bd460f$var$$TypeError$b = TypeError;
// `Assert: Type(argument) is Object`
var $5bb7220e37bd460f$var$anObject$e = function(argument) {
    if ($5bb7220e37bd460f$var$isObject$9(argument)) return argument;
    throw $5bb7220e37bd460f$var$$TypeError$b($5bb7220e37bd460f$var$$String$2(argument) + " is not an object");
};
var $5bb7220e37bd460f$var$DESCRIPTORS$a = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$IE8_DOM_DEFINE = $5bb7220e37bd460f$var$ie8DomDefine;
var $5bb7220e37bd460f$var$V8_PROTOTYPE_DEFINE_BUG$1 = $5bb7220e37bd460f$var$v8PrototypeDefineBug;
var $5bb7220e37bd460f$var$anObject$d = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$toPropertyKey$2 = $5bb7220e37bd460f$var$toPropertyKey$4;
var $5bb7220e37bd460f$var$$TypeError$a = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5bb7220e37bd460f$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5bb7220e37bd460f$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $5bb7220e37bd460f$var$ENUMERABLE = "enumerable";
var $5bb7220e37bd460f$var$CONFIGURABLE$1 = "configurable";
var $5bb7220e37bd460f$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$5bb7220e37bd460f$var$objectDefineProperty.f = $5bb7220e37bd460f$var$DESCRIPTORS$a ? $5bb7220e37bd460f$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $5bb7220e37bd460f$var$anObject$d(O);
    P = $5bb7220e37bd460f$var$toPropertyKey$2(P);
    $5bb7220e37bd460f$var$anObject$d(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $5bb7220e37bd460f$var$WRITABLE in Attributes && !Attributes[$5bb7220e37bd460f$var$WRITABLE]) {
        var current = $5bb7220e37bd460f$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$5bb7220e37bd460f$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $5bb7220e37bd460f$var$CONFIGURABLE$1 in Attributes ? Attributes[$5bb7220e37bd460f$var$CONFIGURABLE$1] : current[$5bb7220e37bd460f$var$CONFIGURABLE$1],
                enumerable: $5bb7220e37bd460f$var$ENUMERABLE in Attributes ? Attributes[$5bb7220e37bd460f$var$ENUMERABLE] : current[$5bb7220e37bd460f$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $5bb7220e37bd460f$var$$defineProperty(O, P, Attributes);
} : $5bb7220e37bd460f$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $5bb7220e37bd460f$var$anObject$d(O);
    P = $5bb7220e37bd460f$var$toPropertyKey$2(P);
    $5bb7220e37bd460f$var$anObject$d(Attributes);
    if ($5bb7220e37bd460f$var$IE8_DOM_DEFINE) try {
        return $5bb7220e37bd460f$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $5bb7220e37bd460f$var$$TypeError$a("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $5bb7220e37bd460f$var$DESCRIPTORS$9 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$definePropertyModule$6 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$createPropertyDescriptor$3 = $5bb7220e37bd460f$var$createPropertyDescriptor$5;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$8 = $5bb7220e37bd460f$var$DESCRIPTORS$9 ? function(object, key, value) {
    return $5bb7220e37bd460f$var$definePropertyModule$6.f(object, key, $5bb7220e37bd460f$var$createPropertyDescriptor$3(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $5bb7220e37bd460f$var$makeBuiltIn$2 = {
    exports: {}
};
var $5bb7220e37bd460f$var$DESCRIPTORS$8 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$hasOwn$9 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5bb7220e37bd460f$var$getDescriptor = $5bb7220e37bd460f$var$DESCRIPTORS$8 && Object.getOwnPropertyDescriptor;
var $5bb7220e37bd460f$var$EXISTS = $5bb7220e37bd460f$var$hasOwn$9($5bb7220e37bd460f$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $5bb7220e37bd460f$var$PROPER = $5bb7220e37bd460f$var$EXISTS && (function something() {}).name === "something";
var $5bb7220e37bd460f$var$CONFIGURABLE = $5bb7220e37bd460f$var$EXISTS && (!$5bb7220e37bd460f$var$DESCRIPTORS$8 || $5bb7220e37bd460f$var$DESCRIPTORS$8 && $5bb7220e37bd460f$var$getDescriptor($5bb7220e37bd460f$var$FunctionPrototype$1, "name").configurable);
var $5bb7220e37bd460f$var$functionName = {
    EXISTS: $5bb7220e37bd460f$var$EXISTS,
    PROPER: $5bb7220e37bd460f$var$PROPER,
    CONFIGURABLE: $5bb7220e37bd460f$var$CONFIGURABLE
};
var $5bb7220e37bd460f$var$uncurryThis$j = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$isCallable$h = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$store$1 = $5bb7220e37bd460f$var$sharedStore;
var $5bb7220e37bd460f$var$functionToString = $5bb7220e37bd460f$var$uncurryThis$j(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$5bb7220e37bd460f$var$isCallable$h($5bb7220e37bd460f$var$store$1.inspectSource)) $5bb7220e37bd460f$var$store$1.inspectSource = function(it) {
    return $5bb7220e37bd460f$var$functionToString(it);
};
var $5bb7220e37bd460f$var$inspectSource$4 = $5bb7220e37bd460f$var$store$1.inspectSource;
var $5bb7220e37bd460f$var$global$m = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$isCallable$g = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$inspectSource$3 = $5bb7220e37bd460f$var$inspectSource$4;
var $5bb7220e37bd460f$var$WeakMap$1 = $5bb7220e37bd460f$var$global$m.WeakMap;
var $5bb7220e37bd460f$var$nativeWeakMap = $5bb7220e37bd460f$var$isCallable$g($5bb7220e37bd460f$var$WeakMap$1) && /native code/.test($5bb7220e37bd460f$var$inspectSource$3($5bb7220e37bd460f$var$WeakMap$1));
var $5bb7220e37bd460f$var$shared$2 = $5bb7220e37bd460f$var$shared$4.exports;
var $5bb7220e37bd460f$var$uid$1 = $5bb7220e37bd460f$var$uid$3;
var $5bb7220e37bd460f$var$keys$1 = $5bb7220e37bd460f$var$shared$2("keys");
var $5bb7220e37bd460f$var$sharedKey$3 = function(key) {
    return $5bb7220e37bd460f$var$keys$1[key] || ($5bb7220e37bd460f$var$keys$1[key] = $5bb7220e37bd460f$var$uid$1(key));
};
var $5bb7220e37bd460f$var$hiddenKeys$4 = {};
var $5bb7220e37bd460f$var$NATIVE_WEAK_MAP = $5bb7220e37bd460f$var$nativeWeakMap;
var $5bb7220e37bd460f$var$global$l = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$uncurryThis$i = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$isObject$8 = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$7 = $5bb7220e37bd460f$var$createNonEnumerableProperty$8;
var $5bb7220e37bd460f$var$hasOwn$8 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$shared$1 = $5bb7220e37bd460f$var$sharedStore;
var $5bb7220e37bd460f$var$sharedKey$2 = $5bb7220e37bd460f$var$sharedKey$3;
var $5bb7220e37bd460f$var$hiddenKeys$3 = $5bb7220e37bd460f$var$hiddenKeys$4;
var $5bb7220e37bd460f$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $5bb7220e37bd460f$var$TypeError$3 = $5bb7220e37bd460f$var$global$l.TypeError;
var $5bb7220e37bd460f$var$WeakMap = $5bb7220e37bd460f$var$global$l.WeakMap;
var $5bb7220e37bd460f$var$set$2, $5bb7220e37bd460f$var$get$1, $5bb7220e37bd460f$var$has;
var $5bb7220e37bd460f$var$enforce = function(it) {
    return $5bb7220e37bd460f$var$has(it) ? $5bb7220e37bd460f$var$get$1(it) : $5bb7220e37bd460f$var$set$2(it, {});
};
var $5bb7220e37bd460f$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$5bb7220e37bd460f$var$isObject$8(it) || (state = $5bb7220e37bd460f$var$get$1(it)).type !== TYPE) throw $5bb7220e37bd460f$var$TypeError$3("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($5bb7220e37bd460f$var$NATIVE_WEAK_MAP || $5bb7220e37bd460f$var$shared$1.state) {
    var $5bb7220e37bd460f$var$store = $5bb7220e37bd460f$var$shared$1.state || ($5bb7220e37bd460f$var$shared$1.state = new $5bb7220e37bd460f$var$WeakMap());
    var $5bb7220e37bd460f$var$wmget = $5bb7220e37bd460f$var$uncurryThis$i($5bb7220e37bd460f$var$store.get);
    var $5bb7220e37bd460f$var$wmhas = $5bb7220e37bd460f$var$uncurryThis$i($5bb7220e37bd460f$var$store.has);
    var $5bb7220e37bd460f$var$wmset = $5bb7220e37bd460f$var$uncurryThis$i($5bb7220e37bd460f$var$store.set);
    $5bb7220e37bd460f$var$set$2 = function(it, metadata) {
        if ($5bb7220e37bd460f$var$wmhas($5bb7220e37bd460f$var$store, it)) throw new $5bb7220e37bd460f$var$TypeError$3($5bb7220e37bd460f$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5bb7220e37bd460f$var$wmset($5bb7220e37bd460f$var$store, it, metadata);
        return metadata;
    };
    $5bb7220e37bd460f$var$get$1 = function(it) {
        return $5bb7220e37bd460f$var$wmget($5bb7220e37bd460f$var$store, it) || {};
    };
    $5bb7220e37bd460f$var$has = function(it) {
        return $5bb7220e37bd460f$var$wmhas($5bb7220e37bd460f$var$store, it);
    };
} else {
    var $5bb7220e37bd460f$var$STATE = $5bb7220e37bd460f$var$sharedKey$2("state");
    $5bb7220e37bd460f$var$hiddenKeys$3[$5bb7220e37bd460f$var$STATE] = true;
    $5bb7220e37bd460f$var$set$2 = function(it, metadata) {
        if ($5bb7220e37bd460f$var$hasOwn$8(it, $5bb7220e37bd460f$var$STATE)) throw new $5bb7220e37bd460f$var$TypeError$3($5bb7220e37bd460f$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5bb7220e37bd460f$var$createNonEnumerableProperty$7(it, $5bb7220e37bd460f$var$STATE, metadata);
        return metadata;
    };
    $5bb7220e37bd460f$var$get$1 = function(it) {
        return $5bb7220e37bd460f$var$hasOwn$8(it, $5bb7220e37bd460f$var$STATE) ? it[$5bb7220e37bd460f$var$STATE] : {};
    };
    $5bb7220e37bd460f$var$has = function(it) {
        return $5bb7220e37bd460f$var$hasOwn$8(it, $5bb7220e37bd460f$var$STATE);
    };
}
var $5bb7220e37bd460f$var$internalState = {
    set: $5bb7220e37bd460f$var$set$2,
    get: $5bb7220e37bd460f$var$get$1,
    has: $5bb7220e37bd460f$var$has,
    enforce: $5bb7220e37bd460f$var$enforce,
    getterFor: $5bb7220e37bd460f$var$getterFor
};
var $5bb7220e37bd460f$var$fails$l = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$isCallable$f = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$hasOwn$7 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$DESCRIPTORS$7 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME$2 = $5bb7220e37bd460f$var$functionName.CONFIGURABLE;
var $5bb7220e37bd460f$var$inspectSource$2 = $5bb7220e37bd460f$var$inspectSource$4;
var $5bb7220e37bd460f$var$InternalStateModule$5 = $5bb7220e37bd460f$var$internalState;
var $5bb7220e37bd460f$var$enforceInternalState$2 = $5bb7220e37bd460f$var$InternalStateModule$5.enforce;
var $5bb7220e37bd460f$var$getInternalState$5 = $5bb7220e37bd460f$var$InternalStateModule$5.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5bb7220e37bd460f$var$defineProperty$6 = Object.defineProperty;
var $5bb7220e37bd460f$var$CONFIGURABLE_LENGTH = $5bb7220e37bd460f$var$DESCRIPTORS$7 && !$5bb7220e37bd460f$var$fails$l(function() {
    return $5bb7220e37bd460f$var$defineProperty$6(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $5bb7220e37bd460f$var$TEMPLATE = String(String).split("String");
var $5bb7220e37bd460f$var$makeBuiltIn$1 = $5bb7220e37bd460f$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$5bb7220e37bd460f$var$hasOwn$7(value, "name") || $5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME$2 && value.name !== name) {
        if ($5bb7220e37bd460f$var$DESCRIPTORS$7) $5bb7220e37bd460f$var$defineProperty$6(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($5bb7220e37bd460f$var$CONFIGURABLE_LENGTH && options && $5bb7220e37bd460f$var$hasOwn$7(options, "arity") && value.length !== options.arity) $5bb7220e37bd460f$var$defineProperty$6(value, "length", {
        value: options.arity
    });
    try {
        if (options && $5bb7220e37bd460f$var$hasOwn$7(options, "constructor") && options.constructor) {
            if ($5bb7220e37bd460f$var$DESCRIPTORS$7) $5bb7220e37bd460f$var$defineProperty$6(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $5bb7220e37bd460f$var$enforceInternalState$2(value);
    if (!$5bb7220e37bd460f$var$hasOwn$7(state, "source")) state.source = $5bb7220e37bd460f$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $5bb7220e37bd460f$var$makeBuiltIn$1(function toString() {
    return $5bb7220e37bd460f$var$isCallable$f(this) && $5bb7220e37bd460f$var$getInternalState$5(this).source || $5bb7220e37bd460f$var$inspectSource$2(this);
}, "toString");
var $5bb7220e37bd460f$var$isCallable$e = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$definePropertyModule$5 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$makeBuiltIn = $5bb7220e37bd460f$var$makeBuiltIn$2.exports;
var $5bb7220e37bd460f$var$defineGlobalProperty$1 = $5bb7220e37bd460f$var$defineGlobalProperty$3;
var $5bb7220e37bd460f$var$defineBuiltIn$8 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($5bb7220e37bd460f$var$isCallable$e(value)) $5bb7220e37bd460f$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $5bb7220e37bd460f$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $5bb7220e37bd460f$var$definePropertyModule$5.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $5bb7220e37bd460f$var$objectGetOwnPropertyNames = {};
var $5bb7220e37bd460f$var$ceil = Math.ceil;
var $5bb7220e37bd460f$var$floor$3 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $5bb7220e37bd460f$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5bb7220e37bd460f$var$floor$3 : $5bb7220e37bd460f$var$ceil)(n);
};
var $5bb7220e37bd460f$var$trunc = $5bb7220e37bd460f$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $5bb7220e37bd460f$var$toIntegerOrInfinity$6 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5bb7220e37bd460f$var$trunc(number);
};
var $5bb7220e37bd460f$var$toIntegerOrInfinity$5 = $5bb7220e37bd460f$var$toIntegerOrInfinity$6;
var $5bb7220e37bd460f$var$max$1 = Math.max;
var $5bb7220e37bd460f$var$min$2 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $5bb7220e37bd460f$var$toAbsoluteIndex$4 = function(index, length) {
    var integer = $5bb7220e37bd460f$var$toIntegerOrInfinity$5(index);
    return integer < 0 ? $5bb7220e37bd460f$var$max$1(integer + length, 0) : $5bb7220e37bd460f$var$min$2(integer, length);
};
var $5bb7220e37bd460f$var$toIntegerOrInfinity$4 = $5bb7220e37bd460f$var$toIntegerOrInfinity$6;
var $5bb7220e37bd460f$var$min$1 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $5bb7220e37bd460f$var$toLength$6 = function(argument) {
    return argument > 0 ? $5bb7220e37bd460f$var$min$1($5bb7220e37bd460f$var$toIntegerOrInfinity$4(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $5bb7220e37bd460f$var$toLength$5 = $5bb7220e37bd460f$var$toLength$6;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $5bb7220e37bd460f$var$lengthOfArrayLike$8 = function(obj) {
    return $5bb7220e37bd460f$var$toLength$5(obj.length);
};
var $5bb7220e37bd460f$var$toIndexedObject$4 = $5bb7220e37bd460f$var$toIndexedObject$6;
var $5bb7220e37bd460f$var$toAbsoluteIndex$3 = $5bb7220e37bd460f$var$toAbsoluteIndex$4;
var $5bb7220e37bd460f$var$lengthOfArrayLike$7 = $5bb7220e37bd460f$var$lengthOfArrayLike$8;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $5bb7220e37bd460f$var$createMethod$4 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $5bb7220e37bd460f$var$toIndexedObject$4($this);
        var length = $5bb7220e37bd460f$var$lengthOfArrayLike$7(O);
        var index = $5bb7220e37bd460f$var$toAbsoluteIndex$3(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $5bb7220e37bd460f$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $5bb7220e37bd460f$var$createMethod$4(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $5bb7220e37bd460f$var$createMethod$4(false)
};
var $5bb7220e37bd460f$var$uncurryThis$h = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$hasOwn$6 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$toIndexedObject$3 = $5bb7220e37bd460f$var$toIndexedObject$6;
var $5bb7220e37bd460f$var$indexOf$1 = $5bb7220e37bd460f$var$arrayIncludes.indexOf;
var $5bb7220e37bd460f$var$hiddenKeys$2 = $5bb7220e37bd460f$var$hiddenKeys$4;
var $5bb7220e37bd460f$var$push$2 = $5bb7220e37bd460f$var$uncurryThis$h([].push);
var $5bb7220e37bd460f$var$objectKeysInternal = function(object, names) {
    var O = $5bb7220e37bd460f$var$toIndexedObject$3(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$5bb7220e37bd460f$var$hasOwn$6($5bb7220e37bd460f$var$hiddenKeys$2, key) && $5bb7220e37bd460f$var$hasOwn$6(O, key) && $5bb7220e37bd460f$var$push$2(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($5bb7220e37bd460f$var$hasOwn$6(O, key = names[i++])) ~$5bb7220e37bd460f$var$indexOf$1(result, key) || $5bb7220e37bd460f$var$push$2(result, key);
    return result;
};
// IE8- don't enum bug keys
var $5bb7220e37bd460f$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $5bb7220e37bd460f$var$internalObjectKeys$1 = $5bb7220e37bd460f$var$objectKeysInternal;
var $5bb7220e37bd460f$var$enumBugKeys$2 = $5bb7220e37bd460f$var$enumBugKeys$3;
var $5bb7220e37bd460f$var$hiddenKeys$1 = $5bb7220e37bd460f$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$5bb7220e37bd460f$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $5bb7220e37bd460f$var$internalObjectKeys$1(O, $5bb7220e37bd460f$var$hiddenKeys$1);
};
var $5bb7220e37bd460f$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$5bb7220e37bd460f$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $5bb7220e37bd460f$var$getBuiltIn$5 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$uncurryThis$g = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$getOwnPropertyNamesModule = $5bb7220e37bd460f$var$objectGetOwnPropertyNames;
var $5bb7220e37bd460f$var$getOwnPropertySymbolsModule$1 = $5bb7220e37bd460f$var$objectGetOwnPropertySymbols;
var $5bb7220e37bd460f$var$anObject$c = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$concat$1 = $5bb7220e37bd460f$var$uncurryThis$g([].concat);
// all object keys, includes non-enumerable and symbols
var $5bb7220e37bd460f$var$ownKeys$1 = $5bb7220e37bd460f$var$getBuiltIn$5("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $5bb7220e37bd460f$var$getOwnPropertyNamesModule.f($5bb7220e37bd460f$var$anObject$c(it));
    var getOwnPropertySymbols = $5bb7220e37bd460f$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $5bb7220e37bd460f$var$concat$1(keys, getOwnPropertySymbols(it)) : keys;
};
var $5bb7220e37bd460f$var$hasOwn$5 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$ownKeys = $5bb7220e37bd460f$var$ownKeys$1;
var $5bb7220e37bd460f$var$getOwnPropertyDescriptorModule$1 = $5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor;
var $5bb7220e37bd460f$var$definePropertyModule$4 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $5bb7220e37bd460f$var$ownKeys(source);
    var defineProperty = $5bb7220e37bd460f$var$definePropertyModule$4.f;
    var getOwnPropertyDescriptor = $5bb7220e37bd460f$var$getOwnPropertyDescriptorModule$1.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$5bb7220e37bd460f$var$hasOwn$5(target, key) && !(exceptions && $5bb7220e37bd460f$var$hasOwn$5(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $5bb7220e37bd460f$var$fails$k = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$isCallable$d = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$replacement = /#|\.prototype\./;
var $5bb7220e37bd460f$var$isForced$2 = function(feature, detection) {
    var value = $5bb7220e37bd460f$var$data[$5bb7220e37bd460f$var$normalize(feature)];
    return value == $5bb7220e37bd460f$var$POLYFILL ? true : value == $5bb7220e37bd460f$var$NATIVE ? false : $5bb7220e37bd460f$var$isCallable$d(detection) ? $5bb7220e37bd460f$var$fails$k(detection) : !!detection;
};
var $5bb7220e37bd460f$var$normalize = $5bb7220e37bd460f$var$isForced$2.normalize = function(string) {
    return String(string).replace($5bb7220e37bd460f$var$replacement, ".").toLowerCase();
};
var $5bb7220e37bd460f$var$data = $5bb7220e37bd460f$var$isForced$2.data = {};
var $5bb7220e37bd460f$var$NATIVE = $5bb7220e37bd460f$var$isForced$2.NATIVE = "N";
var $5bb7220e37bd460f$var$POLYFILL = $5bb7220e37bd460f$var$isForced$2.POLYFILL = "P";
var $5bb7220e37bd460f$var$isForced_1 = $5bb7220e37bd460f$var$isForced$2;
var $5bb7220e37bd460f$var$global$k = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$getOwnPropertyDescriptor$1 = $5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor.f;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$6 = $5bb7220e37bd460f$var$createNonEnumerableProperty$8;
var $5bb7220e37bd460f$var$defineBuiltIn$7 = $5bb7220e37bd460f$var$defineBuiltIn$8;
var $5bb7220e37bd460f$var$defineGlobalProperty = $5bb7220e37bd460f$var$defineGlobalProperty$3;
var $5bb7220e37bd460f$var$copyConstructorProperties = $5bb7220e37bd460f$var$copyConstructorProperties$1;
var $5bb7220e37bd460f$var$isForced$1 = $5bb7220e37bd460f$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $5bb7220e37bd460f$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $5bb7220e37bd460f$var$global$k;
    else if (STATIC) target = $5bb7220e37bd460f$var$global$k[TARGET] || $5bb7220e37bd460f$var$defineGlobalProperty(TARGET, {});
    else target = ($5bb7220e37bd460f$var$global$k[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $5bb7220e37bd460f$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $5bb7220e37bd460f$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $5bb7220e37bd460f$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $5bb7220e37bd460f$var$createNonEnumerableProperty$6(sourceProperty, "sham", true);
        $5bb7220e37bd460f$var$defineBuiltIn$7(target, key, sourceProperty, options);
    }
};
var $5bb7220e37bd460f$var$classof$a = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$global$j = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$engineIsNode = $5bb7220e37bd460f$var$classof$a($5bb7220e37bd460f$var$global$j.process) == "process";
var $5bb7220e37bd460f$var$isCallable$c = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$$String$1 = String;
var $5bb7220e37bd460f$var$$TypeError$9 = TypeError;
var $5bb7220e37bd460f$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || $5bb7220e37bd460f$var$isCallable$c(argument)) return argument;
    throw $5bb7220e37bd460f$var$$TypeError$9("Can't set " + $5bb7220e37bd460f$var$$String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $5bb7220e37bd460f$var$uncurryThis$f = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$anObject$b = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$aPossiblePrototype = $5bb7220e37bd460f$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $5bb7220e37bd460f$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $5bb7220e37bd460f$var$uncurryThis$f(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $5bb7220e37bd460f$var$anObject$b(O);
        $5bb7220e37bd460f$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $5bb7220e37bd460f$var$defineProperty$5 = $5bb7220e37bd460f$var$objectDefineProperty.f;
var $5bb7220e37bd460f$var$hasOwn$4 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$wellKnownSymbol$h = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$TO_STRING_TAG$4 = $5bb7220e37bd460f$var$wellKnownSymbol$h("toStringTag");
var $5bb7220e37bd460f$var$setToStringTag$4 = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$5bb7220e37bd460f$var$hasOwn$4(target, $5bb7220e37bd460f$var$TO_STRING_TAG$4)) $5bb7220e37bd460f$var$defineProperty$5(target, $5bb7220e37bd460f$var$TO_STRING_TAG$4, {
        configurable: true,
        value: TAG
    });
};
var $5bb7220e37bd460f$var$getBuiltIn$4 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$definePropertyModule$3 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$wellKnownSymbol$g = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$DESCRIPTORS$6 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$SPECIES$4 = $5bb7220e37bd460f$var$wellKnownSymbol$g("species");
var $5bb7220e37bd460f$var$setSpecies$2 = function(CONSTRUCTOR_NAME) {
    var Constructor = $5bb7220e37bd460f$var$getBuiltIn$4(CONSTRUCTOR_NAME);
    var defineProperty = $5bb7220e37bd460f$var$definePropertyModule$3.f;
    if ($5bb7220e37bd460f$var$DESCRIPTORS$6 && Constructor && !Constructor[$5bb7220e37bd460f$var$SPECIES$4]) defineProperty(Constructor, $5bb7220e37bd460f$var$SPECIES$4, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $5bb7220e37bd460f$var$isPrototypeOf$3 = $5bb7220e37bd460f$var$objectIsPrototypeOf;
var $5bb7220e37bd460f$var$$TypeError$8 = TypeError;
var $5bb7220e37bd460f$var$anInstance$3 = function(it, Prototype) {
    if ($5bb7220e37bd460f$var$isPrototypeOf$3(Prototype, it)) return it;
    throw $5bb7220e37bd460f$var$$TypeError$8("Incorrect invocation");
};
var $5bb7220e37bd460f$var$wellKnownSymbol$f = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$TO_STRING_TAG$3 = $5bb7220e37bd460f$var$wellKnownSymbol$f("toStringTag");
var $5bb7220e37bd460f$var$test = {};
$5bb7220e37bd460f$var$test[$5bb7220e37bd460f$var$TO_STRING_TAG$3] = "z";
var $5bb7220e37bd460f$var$toStringTagSupport = String($5bb7220e37bd460f$var$test) === "[object z]";
var $5bb7220e37bd460f$var$TO_STRING_TAG_SUPPORT = $5bb7220e37bd460f$var$toStringTagSupport;
var $5bb7220e37bd460f$var$isCallable$b = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$classofRaw = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$wellKnownSymbol$e = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$TO_STRING_TAG$2 = $5bb7220e37bd460f$var$wellKnownSymbol$e("toStringTag");
var $5bb7220e37bd460f$var$$Object$1 = Object;
// ES3 wrong here
var $5bb7220e37bd460f$var$CORRECT_ARGUMENTS = $5bb7220e37bd460f$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $5bb7220e37bd460f$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $5bb7220e37bd460f$var$classof$9 = $5bb7220e37bd460f$var$TO_STRING_TAG_SUPPORT ? $5bb7220e37bd460f$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $5bb7220e37bd460f$var$tryGet(O = $5bb7220e37bd460f$var$$Object$1(it), $5bb7220e37bd460f$var$TO_STRING_TAG$2)) == "string" ? tag : $5bb7220e37bd460f$var$CORRECT_ARGUMENTS ? $5bb7220e37bd460f$var$classofRaw(O) : (result = $5bb7220e37bd460f$var$classofRaw(O)) == "Object" && $5bb7220e37bd460f$var$isCallable$b(O.callee) ? "Arguments" : result;
};
var $5bb7220e37bd460f$var$uncurryThis$e = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$fails$j = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$isCallable$a = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$classof$8 = $5bb7220e37bd460f$var$classof$9;
var $5bb7220e37bd460f$var$getBuiltIn$3 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$inspectSource$1 = $5bb7220e37bd460f$var$inspectSource$4;
var $5bb7220e37bd460f$var$noop = function() {};
var $5bb7220e37bd460f$var$empty = [];
var $5bb7220e37bd460f$var$construct = $5bb7220e37bd460f$var$getBuiltIn$3("Reflect", "construct");
var $5bb7220e37bd460f$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $5bb7220e37bd460f$var$exec$2 = $5bb7220e37bd460f$var$uncurryThis$e($5bb7220e37bd460f$var$constructorRegExp.exec);
var $5bb7220e37bd460f$var$INCORRECT_TO_STRING = !$5bb7220e37bd460f$var$constructorRegExp.exec($5bb7220e37bd460f$var$noop);
var $5bb7220e37bd460f$var$isConstructorModern = function isConstructor(argument) {
    if (!$5bb7220e37bd460f$var$isCallable$a(argument)) return false;
    try {
        $5bb7220e37bd460f$var$construct($5bb7220e37bd460f$var$noop, $5bb7220e37bd460f$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $5bb7220e37bd460f$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$5bb7220e37bd460f$var$isCallable$a(argument)) return false;
    switch($5bb7220e37bd460f$var$classof$8(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $5bb7220e37bd460f$var$INCORRECT_TO_STRING || !!$5bb7220e37bd460f$var$exec$2($5bb7220e37bd460f$var$constructorRegExp, $5bb7220e37bd460f$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$5bb7220e37bd460f$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $5bb7220e37bd460f$var$isConstructor$2 = !$5bb7220e37bd460f$var$construct || $5bb7220e37bd460f$var$fails$j(function() {
    var called;
    return $5bb7220e37bd460f$var$isConstructorModern($5bb7220e37bd460f$var$isConstructorModern.call) || !$5bb7220e37bd460f$var$isConstructorModern(Object) || !$5bb7220e37bd460f$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $5bb7220e37bd460f$var$isConstructorLegacy : $5bb7220e37bd460f$var$isConstructorModern;
var $5bb7220e37bd460f$var$isConstructor$1 = $5bb7220e37bd460f$var$isConstructor$2;
var $5bb7220e37bd460f$var$tryToString$3 = $5bb7220e37bd460f$var$tryToString$5;
var $5bb7220e37bd460f$var$$TypeError$7 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $5bb7220e37bd460f$var$aConstructor$2 = function(argument) {
    if ($5bb7220e37bd460f$var$isConstructor$1(argument)) return argument;
    throw $5bb7220e37bd460f$var$$TypeError$7($5bb7220e37bd460f$var$tryToString$3(argument) + " is not a constructor");
};
var $5bb7220e37bd460f$var$anObject$a = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$aConstructor$1 = $5bb7220e37bd460f$var$aConstructor$2;
var $5bb7220e37bd460f$var$wellKnownSymbol$d = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$SPECIES$3 = $5bb7220e37bd460f$var$wellKnownSymbol$d("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $5bb7220e37bd460f$var$speciesConstructor$3 = function(O, defaultConstructor) {
    var C = $5bb7220e37bd460f$var$anObject$a(O).constructor;
    var S;
    return C === undefined || (S = $5bb7220e37bd460f$var$anObject$a(C)[$5bb7220e37bd460f$var$SPECIES$3]) == undefined ? defaultConstructor : $5bb7220e37bd460f$var$aConstructor$1(S);
};
var $5bb7220e37bd460f$var$NATIVE_BIND$1 = $5bb7220e37bd460f$var$functionBindNative;
var $5bb7220e37bd460f$var$FunctionPrototype = Function.prototype;
var $5bb7220e37bd460f$var$apply$3 = $5bb7220e37bd460f$var$FunctionPrototype.apply;
var $5bb7220e37bd460f$var$call$g = $5bb7220e37bd460f$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $5bb7220e37bd460f$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($5bb7220e37bd460f$var$NATIVE_BIND$1 ? $5bb7220e37bd460f$var$call$g.bind($5bb7220e37bd460f$var$apply$3) : function() {
    return $5bb7220e37bd460f$var$call$g.apply($5bb7220e37bd460f$var$apply$3, arguments);
});
var $5bb7220e37bd460f$var$uncurryThis$d = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$aCallable$7 = $5bb7220e37bd460f$var$aCallable$9;
var $5bb7220e37bd460f$var$NATIVE_BIND = $5bb7220e37bd460f$var$functionBindNative;
var $5bb7220e37bd460f$var$bind$6 = $5bb7220e37bd460f$var$uncurryThis$d($5bb7220e37bd460f$var$uncurryThis$d.bind);
// optional / simple context binding
var $5bb7220e37bd460f$var$functionBindContext = function(fn, that) {
    $5bb7220e37bd460f$var$aCallable$7(fn);
    return that === undefined ? fn : $5bb7220e37bd460f$var$NATIVE_BIND ? $5bb7220e37bd460f$var$bind$6(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $5bb7220e37bd460f$var$getBuiltIn$2 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$html$2 = $5bb7220e37bd460f$var$getBuiltIn$2("document", "documentElement");
var $5bb7220e37bd460f$var$uncurryThis$c = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$arraySlice$5 = $5bb7220e37bd460f$var$uncurryThis$c([].slice);
var $5bb7220e37bd460f$var$$TypeError$6 = TypeError;
var $5bb7220e37bd460f$var$validateArgumentsLength$1 = function(passed, required) {
    if (passed < required) throw $5bb7220e37bd460f$var$$TypeError$6("Not enough arguments");
    return passed;
};
var $5bb7220e37bd460f$var$userAgent$4 = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($5bb7220e37bd460f$var$userAgent$4);
var $5bb7220e37bd460f$var$global$i = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$apply$2 = $5bb7220e37bd460f$var$functionApply;
var $5bb7220e37bd460f$var$bind$5 = $5bb7220e37bd460f$var$functionBindContext;
var $5bb7220e37bd460f$var$isCallable$9 = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$hasOwn$3 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$fails$i = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$html$1 = $5bb7220e37bd460f$var$html$2;
var $5bb7220e37bd460f$var$arraySlice$4 = $5bb7220e37bd460f$var$arraySlice$5;
var $5bb7220e37bd460f$var$createElement = $5bb7220e37bd460f$var$documentCreateElement$2;
var $5bb7220e37bd460f$var$validateArgumentsLength = $5bb7220e37bd460f$var$validateArgumentsLength$1;
var $5bb7220e37bd460f$var$IS_IOS$1 = $5bb7220e37bd460f$var$engineIsIos;
var $5bb7220e37bd460f$var$IS_NODE$3 = $5bb7220e37bd460f$var$engineIsNode;
var $5bb7220e37bd460f$var$set$1 = $5bb7220e37bd460f$var$global$i.setImmediate;
var $5bb7220e37bd460f$var$clear = $5bb7220e37bd460f$var$global$i.clearImmediate;
var $5bb7220e37bd460f$var$process$2 = $5bb7220e37bd460f$var$global$i.process;
var $5bb7220e37bd460f$var$Dispatch = $5bb7220e37bd460f$var$global$i.Dispatch;
var $5bb7220e37bd460f$var$Function$1 = $5bb7220e37bd460f$var$global$i.Function;
var $5bb7220e37bd460f$var$MessageChannel = $5bb7220e37bd460f$var$global$i.MessageChannel;
var $5bb7220e37bd460f$var$String$1 = $5bb7220e37bd460f$var$global$i.String;
var $5bb7220e37bd460f$var$counter = 0;
var $5bb7220e37bd460f$var$queue$1 = {};
var $5bb7220e37bd460f$var$ONREADYSTATECHANGE = "onreadystatechange";
var $5bb7220e37bd460f$var$location, $5bb7220e37bd460f$var$defer, $5bb7220e37bd460f$var$channel, $5bb7220e37bd460f$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $5bb7220e37bd460f$var$location = $5bb7220e37bd460f$var$global$i.location;
} catch (error) {}
var $5bb7220e37bd460f$var$run = function(id) {
    if ($5bb7220e37bd460f$var$hasOwn$3($5bb7220e37bd460f$var$queue$1, id)) {
        var fn = $5bb7220e37bd460f$var$queue$1[id];
        delete $5bb7220e37bd460f$var$queue$1[id];
        fn();
    }
};
var $5bb7220e37bd460f$var$runner = function(id) {
    return function() {
        $5bb7220e37bd460f$var$run(id);
    };
};
var $5bb7220e37bd460f$var$listener = function(event) {
    $5bb7220e37bd460f$var$run(event.data);
};
var $5bb7220e37bd460f$var$post = function(id) {
    // old engines have not location.origin
    $5bb7220e37bd460f$var$global$i.postMessage($5bb7220e37bd460f$var$String$1(id), $5bb7220e37bd460f$var$location.protocol + "//" + $5bb7220e37bd460f$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$5bb7220e37bd460f$var$set$1 || !$5bb7220e37bd460f$var$clear) {
    $5bb7220e37bd460f$var$set$1 = function setImmediate(handler) {
        $5bb7220e37bd460f$var$validateArgumentsLength(arguments.length, 1);
        var fn = $5bb7220e37bd460f$var$isCallable$9(handler) ? handler : $5bb7220e37bd460f$var$Function$1(handler);
        var args = $5bb7220e37bd460f$var$arraySlice$4(arguments, 1);
        $5bb7220e37bd460f$var$queue$1[++$5bb7220e37bd460f$var$counter] = function() {
            $5bb7220e37bd460f$var$apply$2(fn, undefined, args);
        };
        $5bb7220e37bd460f$var$defer($5bb7220e37bd460f$var$counter);
        return $5bb7220e37bd460f$var$counter;
    };
    $5bb7220e37bd460f$var$clear = function clearImmediate(id) {
        delete $5bb7220e37bd460f$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($5bb7220e37bd460f$var$IS_NODE$3) $5bb7220e37bd460f$var$defer = function(id) {
        $5bb7220e37bd460f$var$process$2.nextTick($5bb7220e37bd460f$var$runner(id));
    };
    else if ($5bb7220e37bd460f$var$Dispatch && $5bb7220e37bd460f$var$Dispatch.now) $5bb7220e37bd460f$var$defer = function(id) {
        $5bb7220e37bd460f$var$Dispatch.now($5bb7220e37bd460f$var$runner(id));
    };
    else if ($5bb7220e37bd460f$var$MessageChannel && !$5bb7220e37bd460f$var$IS_IOS$1) {
        $5bb7220e37bd460f$var$channel = new $5bb7220e37bd460f$var$MessageChannel();
        $5bb7220e37bd460f$var$port = $5bb7220e37bd460f$var$channel.port2;
        $5bb7220e37bd460f$var$channel.port1.onmessage = $5bb7220e37bd460f$var$listener;
        $5bb7220e37bd460f$var$defer = $5bb7220e37bd460f$var$bind$5($5bb7220e37bd460f$var$port.postMessage, $5bb7220e37bd460f$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($5bb7220e37bd460f$var$global$i.addEventListener && $5bb7220e37bd460f$var$isCallable$9($5bb7220e37bd460f$var$global$i.postMessage) && !$5bb7220e37bd460f$var$global$i.importScripts && $5bb7220e37bd460f$var$location && $5bb7220e37bd460f$var$location.protocol !== "file:" && !$5bb7220e37bd460f$var$fails$i($5bb7220e37bd460f$var$post)) {
        $5bb7220e37bd460f$var$defer = $5bb7220e37bd460f$var$post;
        $5bb7220e37bd460f$var$global$i.addEventListener("message", $5bb7220e37bd460f$var$listener, false);
    // IE8-
    } else if ($5bb7220e37bd460f$var$ONREADYSTATECHANGE in $5bb7220e37bd460f$var$createElement("script")) $5bb7220e37bd460f$var$defer = function(id) {
        $5bb7220e37bd460f$var$html$1.appendChild($5bb7220e37bd460f$var$createElement("script"))[$5bb7220e37bd460f$var$ONREADYSTATECHANGE] = function() {
            $5bb7220e37bd460f$var$html$1.removeChild(this);
            $5bb7220e37bd460f$var$run(id);
        };
    };
    else $5bb7220e37bd460f$var$defer = function(id) {
        setTimeout($5bb7220e37bd460f$var$runner(id), 0);
    };
}
var $5bb7220e37bd460f$var$task$1 = {
    set: $5bb7220e37bd460f$var$set$1,
    clear: $5bb7220e37bd460f$var$clear
};
var $5bb7220e37bd460f$var$userAgent$3 = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$global$h = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($5bb7220e37bd460f$var$userAgent$3) && $5bb7220e37bd460f$var$global$h.Pebble !== undefined;
var $5bb7220e37bd460f$var$userAgent$2 = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($5bb7220e37bd460f$var$userAgent$2);
var $5bb7220e37bd460f$var$global$g = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$bind$4 = $5bb7220e37bd460f$var$functionBindContext;
var $5bb7220e37bd460f$var$getOwnPropertyDescriptor = $5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor.f;
var $5bb7220e37bd460f$var$macrotask = $5bb7220e37bd460f$var$task$1.set;
var $5bb7220e37bd460f$var$IS_IOS = $5bb7220e37bd460f$var$engineIsIos;
var $5bb7220e37bd460f$var$IS_IOS_PEBBLE = $5bb7220e37bd460f$var$engineIsIosPebble;
var $5bb7220e37bd460f$var$IS_WEBOS_WEBKIT = $5bb7220e37bd460f$var$engineIsWebosWebkit;
var $5bb7220e37bd460f$var$IS_NODE$2 = $5bb7220e37bd460f$var$engineIsNode;
var $5bb7220e37bd460f$var$MutationObserver = $5bb7220e37bd460f$var$global$g.MutationObserver || $5bb7220e37bd460f$var$global$g.WebKitMutationObserver;
var $5bb7220e37bd460f$var$document$2 = $5bb7220e37bd460f$var$global$g.document;
var $5bb7220e37bd460f$var$process$1 = $5bb7220e37bd460f$var$global$g.process;
var $5bb7220e37bd460f$var$Promise$1 = $5bb7220e37bd460f$var$global$g.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $5bb7220e37bd460f$var$queueMicrotaskDescriptor = $5bb7220e37bd460f$var$getOwnPropertyDescriptor($5bb7220e37bd460f$var$global$g, "queueMicrotask");
var $5bb7220e37bd460f$var$queueMicrotask = $5bb7220e37bd460f$var$queueMicrotaskDescriptor && $5bb7220e37bd460f$var$queueMicrotaskDescriptor.value;
var $5bb7220e37bd460f$var$flush, $5bb7220e37bd460f$var$head, $5bb7220e37bd460f$var$last, $5bb7220e37bd460f$var$notify$1, $5bb7220e37bd460f$var$toggle, $5bb7220e37bd460f$var$node, $5bb7220e37bd460f$var$promise, $5bb7220e37bd460f$var$then;
// modern engines have queueMicrotask method
if (!$5bb7220e37bd460f$var$queueMicrotask) {
    $5bb7220e37bd460f$var$flush = function() {
        var parent, fn;
        if ($5bb7220e37bd460f$var$IS_NODE$2 && (parent = $5bb7220e37bd460f$var$process$1.domain)) parent.exit();
        while($5bb7220e37bd460f$var$head){
            fn = $5bb7220e37bd460f$var$head.fn;
            $5bb7220e37bd460f$var$head = $5bb7220e37bd460f$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($5bb7220e37bd460f$var$head) $5bb7220e37bd460f$var$notify$1();
                else $5bb7220e37bd460f$var$last = undefined;
                throw error;
            }
        }
        $5bb7220e37bd460f$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$5bb7220e37bd460f$var$IS_IOS && !$5bb7220e37bd460f$var$IS_NODE$2 && !$5bb7220e37bd460f$var$IS_WEBOS_WEBKIT && $5bb7220e37bd460f$var$MutationObserver && $5bb7220e37bd460f$var$document$2) {
        $5bb7220e37bd460f$var$toggle = true;
        $5bb7220e37bd460f$var$node = $5bb7220e37bd460f$var$document$2.createTextNode("");
        new $5bb7220e37bd460f$var$MutationObserver($5bb7220e37bd460f$var$flush).observe($5bb7220e37bd460f$var$node, {
            characterData: true
        });
        $5bb7220e37bd460f$var$notify$1 = function() {
            $5bb7220e37bd460f$var$node.data = $5bb7220e37bd460f$var$toggle = !$5bb7220e37bd460f$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$5bb7220e37bd460f$var$IS_IOS_PEBBLE && $5bb7220e37bd460f$var$Promise$1 && $5bb7220e37bd460f$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $5bb7220e37bd460f$var$promise = $5bb7220e37bd460f$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $5bb7220e37bd460f$var$promise.constructor = $5bb7220e37bd460f$var$Promise$1;
        $5bb7220e37bd460f$var$then = $5bb7220e37bd460f$var$bind$4($5bb7220e37bd460f$var$promise.then, $5bb7220e37bd460f$var$promise);
        $5bb7220e37bd460f$var$notify$1 = function() {
            $5bb7220e37bd460f$var$then($5bb7220e37bd460f$var$flush);
        };
    // Node.js without promises
    } else if ($5bb7220e37bd460f$var$IS_NODE$2) $5bb7220e37bd460f$var$notify$1 = function() {
        $5bb7220e37bd460f$var$process$1.nextTick($5bb7220e37bd460f$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $5bb7220e37bd460f$var$macrotask = $5bb7220e37bd460f$var$bind$4($5bb7220e37bd460f$var$macrotask, $5bb7220e37bd460f$var$global$g);
        $5bb7220e37bd460f$var$notify$1 = function() {
            $5bb7220e37bd460f$var$macrotask($5bb7220e37bd460f$var$flush);
        };
    }
}
var $5bb7220e37bd460f$var$microtask$1 = $5bb7220e37bd460f$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($5bb7220e37bd460f$var$last) $5bb7220e37bd460f$var$last.next = task;
    if (!$5bb7220e37bd460f$var$head) {
        $5bb7220e37bd460f$var$head = task;
        $5bb7220e37bd460f$var$notify$1();
    }
    $5bb7220e37bd460f$var$last = task;
};
var $5bb7220e37bd460f$var$global$f = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$hostReportErrors$1 = function(a, b) {
    var console1 = $5bb7220e37bd460f$var$global$f.console;
    if (console1 && console1.error) arguments.length == 1 ? console1.error(a) : console1.error(a, b);
};
var $5bb7220e37bd460f$var$perform$3 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $5bb7220e37bd460f$var$Queue$1 = function() {
    this.head = null;
    this.tail = null;
};
$5bb7220e37bd460f$var$Queue$1.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $5bb7220e37bd460f$var$queue = $5bb7220e37bd460f$var$Queue$1;
var $5bb7220e37bd460f$var$global$e = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$promiseNativeConstructor = $5bb7220e37bd460f$var$global$e.Promise;
var $5bb7220e37bd460f$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $5bb7220e37bd460f$var$global$d = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$NativePromiseConstructor$3 = $5bb7220e37bd460f$var$promiseNativeConstructor;
var $5bb7220e37bd460f$var$isCallable$8 = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$isForced = $5bb7220e37bd460f$var$isForced_1;
var $5bb7220e37bd460f$var$inspectSource = $5bb7220e37bd460f$var$inspectSource$4;
var $5bb7220e37bd460f$var$wellKnownSymbol$c = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$IS_BROWSER = $5bb7220e37bd460f$var$engineIsBrowser;
var $5bb7220e37bd460f$var$V8_VERSION = $5bb7220e37bd460f$var$engineV8Version;
$5bb7220e37bd460f$var$NativePromiseConstructor$3 && $5bb7220e37bd460f$var$NativePromiseConstructor$3.prototype;
var $5bb7220e37bd460f$var$SPECIES$2 = $5bb7220e37bd460f$var$wellKnownSymbol$c("species");
var $5bb7220e37bd460f$var$SUBCLASSING = false;
var $5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $5bb7220e37bd460f$var$isCallable$8($5bb7220e37bd460f$var$global$d.PromiseRejectionEvent);
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$5 = $5bb7220e37bd460f$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $5bb7220e37bd460f$var$inspectSource($5bb7220e37bd460f$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($5bb7220e37bd460f$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $5bb7220e37bd460f$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($5bb7220e37bd460f$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $5bb7220e37bd460f$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$5bb7220e37bd460f$var$SPECIES$2] = FakePromise;
    $5bb7220e37bd460f$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$5bb7220e37bd460f$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $5bb7220e37bd460f$var$IS_BROWSER && !$5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $5bb7220e37bd460f$var$promiseConstructorDetection = {
    CONSTRUCTOR: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $5bb7220e37bd460f$var$SUBCLASSING
};
var $5bb7220e37bd460f$var$newPromiseCapability$2 = {};
var $5bb7220e37bd460f$var$aCallable$6 = $5bb7220e37bd460f$var$aCallable$9;
var $5bb7220e37bd460f$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $5bb7220e37bd460f$var$aCallable$6(resolve);
    this.reject = $5bb7220e37bd460f$var$aCallable$6(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$5bb7220e37bd460f$var$newPromiseCapability$2.f = function(C) {
    return new $5bb7220e37bd460f$var$PromiseCapability(C);
};
var $5bb7220e37bd460f$var$$$e = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$IS_NODE$1 = $5bb7220e37bd460f$var$engineIsNode;
var $5bb7220e37bd460f$var$global$c = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$call$f = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$defineBuiltIn$6 = $5bb7220e37bd460f$var$defineBuiltIn$8;
var $5bb7220e37bd460f$var$setPrototypeOf$5 = $5bb7220e37bd460f$var$objectSetPrototypeOf;
var $5bb7220e37bd460f$var$setToStringTag$3 = $5bb7220e37bd460f$var$setToStringTag$4;
var $5bb7220e37bd460f$var$setSpecies$1 = $5bb7220e37bd460f$var$setSpecies$2;
var $5bb7220e37bd460f$var$aCallable$5 = $5bb7220e37bd460f$var$aCallable$9;
var $5bb7220e37bd460f$var$isCallable$7 = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$isObject$7 = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$anInstance$2 = $5bb7220e37bd460f$var$anInstance$3;
var $5bb7220e37bd460f$var$speciesConstructor$2 = $5bb7220e37bd460f$var$speciesConstructor$3;
var $5bb7220e37bd460f$var$task = $5bb7220e37bd460f$var$task$1.set;
var $5bb7220e37bd460f$var$microtask = $5bb7220e37bd460f$var$microtask$1;
var $5bb7220e37bd460f$var$hostReportErrors = $5bb7220e37bd460f$var$hostReportErrors$1;
var $5bb7220e37bd460f$var$perform$2 = $5bb7220e37bd460f$var$perform$3;
var $5bb7220e37bd460f$var$Queue = $5bb7220e37bd460f$var$queue;
var $5bb7220e37bd460f$var$InternalStateModule$4 = $5bb7220e37bd460f$var$internalState;
var $5bb7220e37bd460f$var$NativePromiseConstructor$2 = $5bb7220e37bd460f$var$promiseNativeConstructor;
var $5bb7220e37bd460f$var$PromiseConstructorDetection = $5bb7220e37bd460f$var$promiseConstructorDetection;
var $5bb7220e37bd460f$var$newPromiseCapabilityModule$3 = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$PROMISE = "Promise";
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$4 = $5bb7220e37bd460f$var$PromiseConstructorDetection.CONSTRUCTOR;
var $5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT = $5bb7220e37bd460f$var$PromiseConstructorDetection.REJECTION_EVENT;
var $5bb7220e37bd460f$var$NATIVE_PROMISE_SUBCLASSING = $5bb7220e37bd460f$var$PromiseConstructorDetection.SUBCLASSING;
var $5bb7220e37bd460f$var$getInternalPromiseState = $5bb7220e37bd460f$var$InternalStateModule$4.getterFor($5bb7220e37bd460f$var$PROMISE);
var $5bb7220e37bd460f$var$setInternalState$3 = $5bb7220e37bd460f$var$InternalStateModule$4.set;
var $5bb7220e37bd460f$var$NativePromisePrototype$1 = $5bb7220e37bd460f$var$NativePromiseConstructor$2 && $5bb7220e37bd460f$var$NativePromiseConstructor$2.prototype;
var $5bb7220e37bd460f$var$PromiseConstructor = $5bb7220e37bd460f$var$NativePromiseConstructor$2;
var $5bb7220e37bd460f$var$PromisePrototype = $5bb7220e37bd460f$var$NativePromisePrototype$1;
var $5bb7220e37bd460f$var$TypeError$2 = $5bb7220e37bd460f$var$global$c.TypeError;
var $5bb7220e37bd460f$var$document$1 = $5bb7220e37bd460f$var$global$c.document;
var $5bb7220e37bd460f$var$process = $5bb7220e37bd460f$var$global$c.process;
var $5bb7220e37bd460f$var$newPromiseCapability$1 = $5bb7220e37bd460f$var$newPromiseCapabilityModule$3.f;
var $5bb7220e37bd460f$var$newGenericPromiseCapability = $5bb7220e37bd460f$var$newPromiseCapability$1;
var $5bb7220e37bd460f$var$DISPATCH_EVENT = !!($5bb7220e37bd460f$var$document$1 && $5bb7220e37bd460f$var$document$1.createEvent && $5bb7220e37bd460f$var$global$c.dispatchEvent);
var $5bb7220e37bd460f$var$UNHANDLED_REJECTION = "unhandledrejection";
var $5bb7220e37bd460f$var$REJECTION_HANDLED = "rejectionhandled";
var $5bb7220e37bd460f$var$PENDING = 0;
var $5bb7220e37bd460f$var$FULFILLED = 1;
var $5bb7220e37bd460f$var$REJECTED = 2;
var $5bb7220e37bd460f$var$HANDLED = 1;
var $5bb7220e37bd460f$var$UNHANDLED = 2;
var $5bb7220e37bd460f$var$Internal, $5bb7220e37bd460f$var$OwnPromiseCapability, $5bb7220e37bd460f$var$PromiseWrapper, $5bb7220e37bd460f$var$nativeThen;
// helpers
var $5bb7220e37bd460f$var$isThenable = function(it) {
    var then;
    return $5bb7220e37bd460f$var$isObject$7(it) && $5bb7220e37bd460f$var$isCallable$7(then = it.then) ? then : false;
};
var $5bb7220e37bd460f$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $5bb7220e37bd460f$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $5bb7220e37bd460f$var$UNHANDLED) $5bb7220e37bd460f$var$onHandleUnhandled(state);
                state.rejection = $5bb7220e37bd460f$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($5bb7220e37bd460f$var$TypeError$2("Promise-chain cycle"));
            else if (then = $5bb7220e37bd460f$var$isThenable(result)) $5bb7220e37bd460f$var$call$f(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $5bb7220e37bd460f$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $5bb7220e37bd460f$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$5bb7220e37bd460f$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $5bb7220e37bd460f$var$onUnhandled(state);
    });
};
var $5bb7220e37bd460f$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($5bb7220e37bd460f$var$DISPATCH_EVENT) {
        event = $5bb7220e37bd460f$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $5bb7220e37bd460f$var$global$c.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$5bb7220e37bd460f$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $5bb7220e37bd460f$var$global$c["on" + name])) handler(event);
    else if (name === $5bb7220e37bd460f$var$UNHANDLED_REJECTION) $5bb7220e37bd460f$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $5bb7220e37bd460f$var$onUnhandled = function(state) {
    $5bb7220e37bd460f$var$call$f($5bb7220e37bd460f$var$task, $5bb7220e37bd460f$var$global$c, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $5bb7220e37bd460f$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $5bb7220e37bd460f$var$perform$2(function() {
                if ($5bb7220e37bd460f$var$IS_NODE$1) $5bb7220e37bd460f$var$process.emit("unhandledRejection", value, promise);
                else $5bb7220e37bd460f$var$dispatchEvent($5bb7220e37bd460f$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $5bb7220e37bd460f$var$IS_NODE$1 || $5bb7220e37bd460f$var$isUnhandled(state) ? $5bb7220e37bd460f$var$UNHANDLED : $5bb7220e37bd460f$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $5bb7220e37bd460f$var$isUnhandled = function(state) {
    return state.rejection !== $5bb7220e37bd460f$var$HANDLED && !state.parent;
};
var $5bb7220e37bd460f$var$onHandleUnhandled = function(state) {
    $5bb7220e37bd460f$var$call$f($5bb7220e37bd460f$var$task, $5bb7220e37bd460f$var$global$c, function() {
        var promise = state.facade;
        if ($5bb7220e37bd460f$var$IS_NODE$1) $5bb7220e37bd460f$var$process.emit("rejectionHandled", promise);
        else $5bb7220e37bd460f$var$dispatchEvent($5bb7220e37bd460f$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $5bb7220e37bd460f$var$bind$3 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $5bb7220e37bd460f$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $5bb7220e37bd460f$var$REJECTED;
    $5bb7220e37bd460f$var$notify(state, true);
};
var $5bb7220e37bd460f$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $5bb7220e37bd460f$var$TypeError$2("Promise can't be resolved itself");
        var then = $5bb7220e37bd460f$var$isThenable(value);
        if (then) $5bb7220e37bd460f$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $5bb7220e37bd460f$var$call$f(then, value, $5bb7220e37bd460f$var$bind$3($5bb7220e37bd460f$var$internalResolve, wrapper, state), $5bb7220e37bd460f$var$bind$3($5bb7220e37bd460f$var$internalReject, wrapper, state));
            } catch (error) {
                $5bb7220e37bd460f$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $5bb7220e37bd460f$var$FULFILLED;
            $5bb7220e37bd460f$var$notify(state, false);
        }
    } catch (error) {
        $5bb7220e37bd460f$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $5bb7220e37bd460f$var$PromiseConstructor = function Promise1(executor) {
        $5bb7220e37bd460f$var$anInstance$2(this, $5bb7220e37bd460f$var$PromisePrototype);
        $5bb7220e37bd460f$var$aCallable$5(executor);
        $5bb7220e37bd460f$var$call$f($5bb7220e37bd460f$var$Internal, this);
        var state = $5bb7220e37bd460f$var$getInternalPromiseState(this);
        try {
            executor($5bb7220e37bd460f$var$bind$3($5bb7220e37bd460f$var$internalResolve, state), $5bb7220e37bd460f$var$bind$3($5bb7220e37bd460f$var$internalReject, state));
        } catch (error) {
            $5bb7220e37bd460f$var$internalReject(state, error);
        }
    };
    $5bb7220e37bd460f$var$PromisePrototype = $5bb7220e37bd460f$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $5bb7220e37bd460f$var$Internal = function Promise1(executor) {
        $5bb7220e37bd460f$var$setInternalState$3(this, {
            type: $5bb7220e37bd460f$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $5bb7220e37bd460f$var$Queue(),
            rejection: false,
            state: $5bb7220e37bd460f$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $5bb7220e37bd460f$var$Internal.prototype = $5bb7220e37bd460f$var$defineBuiltIn$6($5bb7220e37bd460f$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $5bb7220e37bd460f$var$getInternalPromiseState(this);
        var reaction = $5bb7220e37bd460f$var$newPromiseCapability$1($5bb7220e37bd460f$var$speciesConstructor$2(this, $5bb7220e37bd460f$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $5bb7220e37bd460f$var$isCallable$7(onFulfilled) ? onFulfilled : true;
        reaction.fail = $5bb7220e37bd460f$var$isCallable$7(onRejected) && onRejected;
        reaction.domain = $5bb7220e37bd460f$var$IS_NODE$1 ? $5bb7220e37bd460f$var$process.domain : undefined;
        if (state.state == $5bb7220e37bd460f$var$PENDING) state.reactions.add(reaction);
        else $5bb7220e37bd460f$var$microtask(function() {
            $5bb7220e37bd460f$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $5bb7220e37bd460f$var$OwnPromiseCapability = function() {
        var promise = new $5bb7220e37bd460f$var$Internal();
        var state = $5bb7220e37bd460f$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $5bb7220e37bd460f$var$bind$3($5bb7220e37bd460f$var$internalResolve, state);
        this.reject = $5bb7220e37bd460f$var$bind$3($5bb7220e37bd460f$var$internalReject, state);
    };
    $5bb7220e37bd460f$var$newPromiseCapabilityModule$3.f = $5bb7220e37bd460f$var$newPromiseCapability$1 = function(C) {
        return C === $5bb7220e37bd460f$var$PromiseConstructor || C === $5bb7220e37bd460f$var$PromiseWrapper ? new $5bb7220e37bd460f$var$OwnPromiseCapability(C) : $5bb7220e37bd460f$var$newGenericPromiseCapability(C);
    };
    if ($5bb7220e37bd460f$var$isCallable$7($5bb7220e37bd460f$var$NativePromiseConstructor$2) && $5bb7220e37bd460f$var$NativePromisePrototype$1 !== Object.prototype) {
        $5bb7220e37bd460f$var$nativeThen = $5bb7220e37bd460f$var$NativePromisePrototype$1.then;
        if (!$5bb7220e37bd460f$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $5bb7220e37bd460f$var$defineBuiltIn$6($5bb7220e37bd460f$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $5bb7220e37bd460f$var$PromiseConstructor(function(resolve, reject) {
                $5bb7220e37bd460f$var$call$f($5bb7220e37bd460f$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $5bb7220e37bd460f$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($5bb7220e37bd460f$var$setPrototypeOf$5) $5bb7220e37bd460f$var$setPrototypeOf$5($5bb7220e37bd460f$var$NativePromisePrototype$1, $5bb7220e37bd460f$var$PromisePrototype);
    }
}
$5bb7220e37bd460f$var$$$e({
    global: true,
    constructor: true,
    wrap: true,
    forced: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $5bb7220e37bd460f$var$PromiseConstructor
});
$5bb7220e37bd460f$var$setToStringTag$3($5bb7220e37bd460f$var$PromiseConstructor, $5bb7220e37bd460f$var$PROMISE, false);
$5bb7220e37bd460f$var$setSpecies$1($5bb7220e37bd460f$var$PROMISE);
var $5bb7220e37bd460f$var$iterators = {};
var $5bb7220e37bd460f$var$wellKnownSymbol$b = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$Iterators$4 = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$ITERATOR$5 = $5bb7220e37bd460f$var$wellKnownSymbol$b("iterator");
var $5bb7220e37bd460f$var$ArrayPrototype$1 = Array.prototype;
// check on default Array iterator
var $5bb7220e37bd460f$var$isArrayIteratorMethod$2 = function(it) {
    return it !== undefined && ($5bb7220e37bd460f$var$Iterators$4.Array === it || $5bb7220e37bd460f$var$ArrayPrototype$1[$5bb7220e37bd460f$var$ITERATOR$5] === it);
};
var $5bb7220e37bd460f$var$classof$7 = $5bb7220e37bd460f$var$classof$9;
var $5bb7220e37bd460f$var$getMethod$2 = $5bb7220e37bd460f$var$getMethod$4;
var $5bb7220e37bd460f$var$Iterators$3 = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$wellKnownSymbol$a = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$ITERATOR$4 = $5bb7220e37bd460f$var$wellKnownSymbol$a("iterator");
var $5bb7220e37bd460f$var$getIteratorMethod$3 = function(it) {
    if (it != undefined) return $5bb7220e37bd460f$var$getMethod$2(it, $5bb7220e37bd460f$var$ITERATOR$4) || $5bb7220e37bd460f$var$getMethod$2(it, "@@iterator") || $5bb7220e37bd460f$var$Iterators$3[$5bb7220e37bd460f$var$classof$7(it)];
};
var $5bb7220e37bd460f$var$call$e = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$aCallable$4 = $5bb7220e37bd460f$var$aCallable$9;
var $5bb7220e37bd460f$var$anObject$9 = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$tryToString$2 = $5bb7220e37bd460f$var$tryToString$5;
var $5bb7220e37bd460f$var$getIteratorMethod$2 = $5bb7220e37bd460f$var$getIteratorMethod$3;
var $5bb7220e37bd460f$var$$TypeError$5 = TypeError;
var $5bb7220e37bd460f$var$getIterator$2 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $5bb7220e37bd460f$var$getIteratorMethod$2(argument) : usingIterator;
    if ($5bb7220e37bd460f$var$aCallable$4(iteratorMethod)) return $5bb7220e37bd460f$var$anObject$9($5bb7220e37bd460f$var$call$e(iteratorMethod, argument));
    throw $5bb7220e37bd460f$var$$TypeError$5($5bb7220e37bd460f$var$tryToString$2(argument) + " is not iterable");
};
var $5bb7220e37bd460f$var$call$d = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$anObject$8 = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$getMethod$1 = $5bb7220e37bd460f$var$getMethod$4;
var $5bb7220e37bd460f$var$iteratorClose$1 = function(iterator, kind, value) {
    var innerResult, innerError;
    $5bb7220e37bd460f$var$anObject$8(iterator);
    try {
        innerResult = $5bb7220e37bd460f$var$getMethod$1(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $5bb7220e37bd460f$var$call$d(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $5bb7220e37bd460f$var$anObject$8(innerResult);
    return value;
};
var $5bb7220e37bd460f$var$bind$2 = $5bb7220e37bd460f$var$functionBindContext;
var $5bb7220e37bd460f$var$call$c = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$anObject$7 = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$tryToString$1 = $5bb7220e37bd460f$var$tryToString$5;
var $5bb7220e37bd460f$var$isArrayIteratorMethod$1 = $5bb7220e37bd460f$var$isArrayIteratorMethod$2;
var $5bb7220e37bd460f$var$lengthOfArrayLike$6 = $5bb7220e37bd460f$var$lengthOfArrayLike$8;
var $5bb7220e37bd460f$var$isPrototypeOf$2 = $5bb7220e37bd460f$var$objectIsPrototypeOf;
var $5bb7220e37bd460f$var$getIterator$1 = $5bb7220e37bd460f$var$getIterator$2;
var $5bb7220e37bd460f$var$getIteratorMethod$1 = $5bb7220e37bd460f$var$getIteratorMethod$3;
var $5bb7220e37bd460f$var$iteratorClose = $5bb7220e37bd460f$var$iteratorClose$1;
var $5bb7220e37bd460f$var$$TypeError$4 = TypeError;
var $5bb7220e37bd460f$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $5bb7220e37bd460f$var$ResultPrototype = $5bb7220e37bd460f$var$Result.prototype;
var $5bb7220e37bd460f$var$iterate$2 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $5bb7220e37bd460f$var$bind$2(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $5bb7220e37bd460f$var$iteratorClose(iterator, "normal", condition);
        return new $5bb7220e37bd460f$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $5bb7220e37bd460f$var$anObject$7(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $5bb7220e37bd460f$var$getIteratorMethod$1(iterable);
        if (!iterFn) throw $5bb7220e37bd460f$var$$TypeError$4($5bb7220e37bd460f$var$tryToString$1(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($5bb7220e37bd460f$var$isArrayIteratorMethod$1(iterFn)) {
            for(index = 0, length = $5bb7220e37bd460f$var$lengthOfArrayLike$6(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5bb7220e37bd460f$var$isPrototypeOf$2($5bb7220e37bd460f$var$ResultPrototype, result)) return result;
            }
            return new $5bb7220e37bd460f$var$Result(false);
        }
        iterator = $5bb7220e37bd460f$var$getIterator$1(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $5bb7220e37bd460f$var$call$c(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $5bb7220e37bd460f$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $5bb7220e37bd460f$var$isPrototypeOf$2($5bb7220e37bd460f$var$ResultPrototype, result)) return result;
    }
    return new $5bb7220e37bd460f$var$Result(false);
};
var $5bb7220e37bd460f$var$wellKnownSymbol$9 = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$ITERATOR$3 = $5bb7220e37bd460f$var$wellKnownSymbol$9("iterator");
var $5bb7220e37bd460f$var$SAFE_CLOSING = false;
try {
    var $5bb7220e37bd460f$var$called = 0;
    var $5bb7220e37bd460f$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$5bb7220e37bd460f$var$called++
            };
        },
        "return": function() {
            $5bb7220e37bd460f$var$SAFE_CLOSING = true;
        }
    };
    $5bb7220e37bd460f$var$iteratorWithReturn[$5bb7220e37bd460f$var$ITERATOR$3] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($5bb7220e37bd460f$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $5bb7220e37bd460f$var$checkCorrectnessOfIteration$2 = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$5bb7220e37bd460f$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$5bb7220e37bd460f$var$ITERATOR$3] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $5bb7220e37bd460f$var$NativePromiseConstructor$1 = $5bb7220e37bd460f$var$promiseNativeConstructor;
var $5bb7220e37bd460f$var$checkCorrectnessOfIteration$1 = $5bb7220e37bd460f$var$checkCorrectnessOfIteration$2;
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$3 = $5bb7220e37bd460f$var$promiseConstructorDetection.CONSTRUCTOR;
var $5bb7220e37bd460f$var$promiseStaticsIncorrectIteration = $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$5bb7220e37bd460f$var$checkCorrectnessOfIteration$1(function(iterable) {
    $5bb7220e37bd460f$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $5bb7220e37bd460f$var$$$d = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$call$b = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$aCallable$3 = $5bb7220e37bd460f$var$aCallable$9;
var $5bb7220e37bd460f$var$newPromiseCapabilityModule$2 = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$perform$1 = $5bb7220e37bd460f$var$perform$3;
var $5bb7220e37bd460f$var$iterate$1 = $5bb7220e37bd460f$var$iterate$2;
var $5bb7220e37bd460f$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $5bb7220e37bd460f$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$5bb7220e37bd460f$var$$$d({
    target: "Promise",
    stat: true,
    forced: $5bb7220e37bd460f$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $5bb7220e37bd460f$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $5bb7220e37bd460f$var$perform$1(function() {
            var $promiseResolve = $5bb7220e37bd460f$var$aCallable$3(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $5bb7220e37bd460f$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $5bb7220e37bd460f$var$call$b($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $5bb7220e37bd460f$var$$$c = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$2 = $5bb7220e37bd460f$var$promiseConstructorDetection.CONSTRUCTOR;
var $5bb7220e37bd460f$var$NativePromiseConstructor = $5bb7220e37bd460f$var$promiseNativeConstructor;
var $5bb7220e37bd460f$var$getBuiltIn$1 = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$isCallable$6 = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$defineBuiltIn$5 = $5bb7220e37bd460f$var$defineBuiltIn$8;
var $5bb7220e37bd460f$var$NativePromisePrototype = $5bb7220e37bd460f$var$NativePromiseConstructor && $5bb7220e37bd460f$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$5bb7220e37bd460f$var$$$c({
    target: "Promise",
    proto: true,
    forced: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($5bb7220e37bd460f$var$isCallable$6($5bb7220e37bd460f$var$NativePromiseConstructor)) {
    var $5bb7220e37bd460f$var$method = $5bb7220e37bd460f$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($5bb7220e37bd460f$var$NativePromisePrototype["catch"] !== $5bb7220e37bd460f$var$method) $5bb7220e37bd460f$var$defineBuiltIn$5($5bb7220e37bd460f$var$NativePromisePrototype, "catch", $5bb7220e37bd460f$var$method, {
        unsafe: true
    });
}
var $5bb7220e37bd460f$var$$$b = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$call$a = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$aCallable$2 = $5bb7220e37bd460f$var$aCallable$9;
var $5bb7220e37bd460f$var$newPromiseCapabilityModule$1 = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$perform = $5bb7220e37bd460f$var$perform$3;
var $5bb7220e37bd460f$var$iterate = $5bb7220e37bd460f$var$iterate$2;
var $5bb7220e37bd460f$var$PROMISE_STATICS_INCORRECT_ITERATION = $5bb7220e37bd460f$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$5bb7220e37bd460f$var$$$b({
    target: "Promise",
    stat: true,
    forced: $5bb7220e37bd460f$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $5bb7220e37bd460f$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $5bb7220e37bd460f$var$perform(function() {
            var $promiseResolve = $5bb7220e37bd460f$var$aCallable$2(C.resolve);
            $5bb7220e37bd460f$var$iterate(iterable, function(promise) {
                $5bb7220e37bd460f$var$call$a($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $5bb7220e37bd460f$var$$$a = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$call$9 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$newPromiseCapabilityModule = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$1 = $5bb7220e37bd460f$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$5bb7220e37bd460f$var$$$a({
    target: "Promise",
    stat: true,
    forced: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $5bb7220e37bd460f$var$newPromiseCapabilityModule.f(this);
        $5bb7220e37bd460f$var$call$9(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $5bb7220e37bd460f$var$anObject$6 = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$isObject$6 = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$newPromiseCapability = $5bb7220e37bd460f$var$newPromiseCapability$2;
var $5bb7220e37bd460f$var$promiseResolve$1 = function(C, x) {
    $5bb7220e37bd460f$var$anObject$6(C);
    if ($5bb7220e37bd460f$var$isObject$6(x) && x.constructor === C) return x;
    var promiseCapability = $5bb7220e37bd460f$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $5bb7220e37bd460f$var$$$9 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$getBuiltIn = $5bb7220e37bd460f$var$getBuiltIn$8;
var $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR = $5bb7220e37bd460f$var$promiseConstructorDetection.CONSTRUCTOR;
var $5bb7220e37bd460f$var$promiseResolve = $5bb7220e37bd460f$var$promiseResolve$1;
$5bb7220e37bd460f$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$5bb7220e37bd460f$var$$$9({
    target: "Promise",
    stat: true,
    forced: $5bb7220e37bd460f$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $5bb7220e37bd460f$var$promiseResolve(this, x);
    }
});
class $5bb7220e37bd460f$var$WebStorageService {
    getItem(key) {
        return new Promise((resolve)=>{
            const value = localStorage.getItem(key);
            resolve(value);
        });
    }
    setItem(key, value) {
        return new Promise((resolve)=>{
            localStorage.setItem(key, value);
            resolve();
        });
    }
    removeItem(key) {
        return new Promise((resolve)=>{
            localStorage.removeItem(key);
            resolve();
        });
    }
}
var $5bb7220e37bd460f$var$objectDefineProperties = {};
var $5bb7220e37bd460f$var$internalObjectKeys = $5bb7220e37bd460f$var$objectKeysInternal;
var $5bb7220e37bd460f$var$enumBugKeys$1 = $5bb7220e37bd460f$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $5bb7220e37bd460f$var$objectKeys$2 = Object.keys || function keys(O) {
    return $5bb7220e37bd460f$var$internalObjectKeys(O, $5bb7220e37bd460f$var$enumBugKeys$1);
};
var $5bb7220e37bd460f$var$DESCRIPTORS$5 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$V8_PROTOTYPE_DEFINE_BUG = $5bb7220e37bd460f$var$v8PrototypeDefineBug;
var $5bb7220e37bd460f$var$definePropertyModule$2 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$anObject$5 = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$toIndexedObject$2 = $5bb7220e37bd460f$var$toIndexedObject$6;
var $5bb7220e37bd460f$var$objectKeys$1 = $5bb7220e37bd460f$var$objectKeys$2;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$5bb7220e37bd460f$var$objectDefineProperties.f = $5bb7220e37bd460f$var$DESCRIPTORS$5 && !$5bb7220e37bd460f$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $5bb7220e37bd460f$var$anObject$5(O);
    var props = $5bb7220e37bd460f$var$toIndexedObject$2(Properties);
    var keys = $5bb7220e37bd460f$var$objectKeys$1(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$5bb7220e37bd460f$var$definePropertyModule$2.f(O, key = keys[index++], props[key]);
    return O;
};
/* global ActiveXObject -- old IE, WSH */ var $5bb7220e37bd460f$var$anObject$4 = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$definePropertiesModule = $5bb7220e37bd460f$var$objectDefineProperties;
var $5bb7220e37bd460f$var$enumBugKeys = $5bb7220e37bd460f$var$enumBugKeys$3;
var $5bb7220e37bd460f$var$hiddenKeys = $5bb7220e37bd460f$var$hiddenKeys$4;
var $5bb7220e37bd460f$var$html = $5bb7220e37bd460f$var$html$2;
var $5bb7220e37bd460f$var$documentCreateElement$1 = $5bb7220e37bd460f$var$documentCreateElement$2;
var $5bb7220e37bd460f$var$sharedKey$1 = $5bb7220e37bd460f$var$sharedKey$3;
var $5bb7220e37bd460f$var$GT = ">";
var $5bb7220e37bd460f$var$LT = "<";
var $5bb7220e37bd460f$var$PROTOTYPE$1 = "prototype";
var $5bb7220e37bd460f$var$SCRIPT = "script";
var $5bb7220e37bd460f$var$IE_PROTO$1 = $5bb7220e37bd460f$var$sharedKey$1("IE_PROTO");
var $5bb7220e37bd460f$var$EmptyConstructor = function() {};
var $5bb7220e37bd460f$var$scriptTag = function(content) {
    return $5bb7220e37bd460f$var$LT + $5bb7220e37bd460f$var$SCRIPT + $5bb7220e37bd460f$var$GT + content + $5bb7220e37bd460f$var$LT + "/" + $5bb7220e37bd460f$var$SCRIPT + $5bb7220e37bd460f$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $5bb7220e37bd460f$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($5bb7220e37bd460f$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $5bb7220e37bd460f$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $5bb7220e37bd460f$var$documentCreateElement$1("iframe");
    var JS = "java" + $5bb7220e37bd460f$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $5bb7220e37bd460f$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($5bb7220e37bd460f$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $5bb7220e37bd460f$var$activeXDocument;
var $5bb7220e37bd460f$var$NullProtoObject = function() {
    try {
        $5bb7220e37bd460f$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $5bb7220e37bd460f$var$NullProtoObject = typeof document != "undefined" ? document.domain && $5bb7220e37bd460f$var$activeXDocument ? $5bb7220e37bd460f$var$NullProtoObjectViaActiveX($5bb7220e37bd460f$var$activeXDocument) // old IE
     : $5bb7220e37bd460f$var$NullProtoObjectViaIFrame() : $5bb7220e37bd460f$var$NullProtoObjectViaActiveX($5bb7220e37bd460f$var$activeXDocument); // WSH
    var length = $5bb7220e37bd460f$var$enumBugKeys.length;
    while(length--)delete $5bb7220e37bd460f$var$NullProtoObject[$5bb7220e37bd460f$var$PROTOTYPE$1][$5bb7220e37bd460f$var$enumBugKeys[length]];
    return $5bb7220e37bd460f$var$NullProtoObject();
};
$5bb7220e37bd460f$var$hiddenKeys[$5bb7220e37bd460f$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $5bb7220e37bd460f$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $5bb7220e37bd460f$var$EmptyConstructor[$5bb7220e37bd460f$var$PROTOTYPE$1] = $5bb7220e37bd460f$var$anObject$4(O);
        result = new $5bb7220e37bd460f$var$EmptyConstructor();
        $5bb7220e37bd460f$var$EmptyConstructor[$5bb7220e37bd460f$var$PROTOTYPE$1] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$5bb7220e37bd460f$var$IE_PROTO$1] = O;
    } else result = $5bb7220e37bd460f$var$NullProtoObject();
    return Properties === undefined ? result : $5bb7220e37bd460f$var$definePropertiesModule.f(result, Properties);
};
var $5bb7220e37bd460f$var$wellKnownSymbol$8 = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$create$3 = $5bb7220e37bd460f$var$objectCreate;
var $5bb7220e37bd460f$var$defineProperty$4 = $5bb7220e37bd460f$var$objectDefineProperty.f;
var $5bb7220e37bd460f$var$UNSCOPABLES = $5bb7220e37bd460f$var$wellKnownSymbol$8("unscopables");
var $5bb7220e37bd460f$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($5bb7220e37bd460f$var$ArrayPrototype[$5bb7220e37bd460f$var$UNSCOPABLES] == undefined) $5bb7220e37bd460f$var$defineProperty$4($5bb7220e37bd460f$var$ArrayPrototype, $5bb7220e37bd460f$var$UNSCOPABLES, {
    configurable: true,
    value: $5bb7220e37bd460f$var$create$3(null)
});
// add a key to Array.prototype[@@unscopables]
var $5bb7220e37bd460f$var$addToUnscopables$2 = function(key) {
    $5bb7220e37bd460f$var$ArrayPrototype[$5bb7220e37bd460f$var$UNSCOPABLES][key] = true;
};
var $5bb7220e37bd460f$var$fails$h = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$correctPrototypeGetter = !$5bb7220e37bd460f$var$fails$h(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $5bb7220e37bd460f$var$hasOwn$2 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$isCallable$5 = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$toObject$5 = $5bb7220e37bd460f$var$toObject$7;
var $5bb7220e37bd460f$var$sharedKey = $5bb7220e37bd460f$var$sharedKey$3;
var $5bb7220e37bd460f$var$CORRECT_PROTOTYPE_GETTER = $5bb7220e37bd460f$var$correctPrototypeGetter;
var $5bb7220e37bd460f$var$IE_PROTO = $5bb7220e37bd460f$var$sharedKey("IE_PROTO");
var $5bb7220e37bd460f$var$$Object = Object;
var $5bb7220e37bd460f$var$ObjectPrototype$2 = $5bb7220e37bd460f$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $5bb7220e37bd460f$var$objectGetPrototypeOf = $5bb7220e37bd460f$var$CORRECT_PROTOTYPE_GETTER ? $5bb7220e37bd460f$var$$Object.getPrototypeOf : function(O) {
    var object = $5bb7220e37bd460f$var$toObject$5(O);
    if ($5bb7220e37bd460f$var$hasOwn$2(object, $5bb7220e37bd460f$var$IE_PROTO)) return object[$5bb7220e37bd460f$var$IE_PROTO];
    var constructor = object.constructor;
    if ($5bb7220e37bd460f$var$isCallable$5(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $5bb7220e37bd460f$var$$Object ? $5bb7220e37bd460f$var$ObjectPrototype$2 : null;
};
var $5bb7220e37bd460f$var$fails$g = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$isCallable$4 = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$getPrototypeOf$3 = $5bb7220e37bd460f$var$objectGetPrototypeOf;
var $5bb7220e37bd460f$var$defineBuiltIn$4 = $5bb7220e37bd460f$var$defineBuiltIn$8;
var $5bb7220e37bd460f$var$wellKnownSymbol$7 = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$ITERATOR$2 = $5bb7220e37bd460f$var$wellKnownSymbol$7("iterator");
var $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $5bb7220e37bd460f$var$IteratorPrototype$2, $5bb7220e37bd460f$var$PrototypeOfArrayIteratorPrototype, $5bb7220e37bd460f$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $5bb7220e37bd460f$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $5bb7220e37bd460f$var$arrayIterator)) $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $5bb7220e37bd460f$var$PrototypeOfArrayIteratorPrototype = $5bb7220e37bd460f$var$getPrototypeOf$3($5bb7220e37bd460f$var$getPrototypeOf$3($5bb7220e37bd460f$var$arrayIterator));
        if ($5bb7220e37bd460f$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $5bb7220e37bd460f$var$IteratorPrototype$2 = $5bb7220e37bd460f$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $5bb7220e37bd460f$var$NEW_ITERATOR_PROTOTYPE = $5bb7220e37bd460f$var$IteratorPrototype$2 == undefined || $5bb7220e37bd460f$var$fails$g(function() {
    var test = {};
    // FF44- legacy iterators case
    return $5bb7220e37bd460f$var$IteratorPrototype$2[$5bb7220e37bd460f$var$ITERATOR$2].call(test) !== test;
});
if ($5bb7220e37bd460f$var$NEW_ITERATOR_PROTOTYPE) $5bb7220e37bd460f$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$5bb7220e37bd460f$var$isCallable$4($5bb7220e37bd460f$var$IteratorPrototype$2[$5bb7220e37bd460f$var$ITERATOR$2])) $5bb7220e37bd460f$var$defineBuiltIn$4($5bb7220e37bd460f$var$IteratorPrototype$2, $5bb7220e37bd460f$var$ITERATOR$2, function() {
    return this;
});
var $5bb7220e37bd460f$var$iteratorsCore = {
    IteratorPrototype: $5bb7220e37bd460f$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS$1
};
var $5bb7220e37bd460f$var$IteratorPrototype$1 = $5bb7220e37bd460f$var$iteratorsCore.IteratorPrototype;
var $5bb7220e37bd460f$var$create$2 = $5bb7220e37bd460f$var$objectCreate;
var $5bb7220e37bd460f$var$createPropertyDescriptor$2 = $5bb7220e37bd460f$var$createPropertyDescriptor$5;
var $5bb7220e37bd460f$var$setToStringTag$2 = $5bb7220e37bd460f$var$setToStringTag$4;
var $5bb7220e37bd460f$var$Iterators$2 = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$returnThis$1 = function() {
    return this;
};
var $5bb7220e37bd460f$var$createIteratorConstructor$1 = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $5bb7220e37bd460f$var$create$2($5bb7220e37bd460f$var$IteratorPrototype$1, {
        next: $5bb7220e37bd460f$var$createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next)
    });
    $5bb7220e37bd460f$var$setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
    $5bb7220e37bd460f$var$Iterators$2[TO_STRING_TAG] = $5bb7220e37bd460f$var$returnThis$1;
    return IteratorConstructor;
};
var $5bb7220e37bd460f$var$$$8 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$call$8 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$FunctionName$1 = $5bb7220e37bd460f$var$functionName;
var $5bb7220e37bd460f$var$isCallable$3 = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$createIteratorConstructor = $5bb7220e37bd460f$var$createIteratorConstructor$1;
var $5bb7220e37bd460f$var$getPrototypeOf$2 = $5bb7220e37bd460f$var$objectGetPrototypeOf;
var $5bb7220e37bd460f$var$setPrototypeOf$4 = $5bb7220e37bd460f$var$objectSetPrototypeOf;
var $5bb7220e37bd460f$var$setToStringTag$1 = $5bb7220e37bd460f$var$setToStringTag$4;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$5 = $5bb7220e37bd460f$var$createNonEnumerableProperty$8;
var $5bb7220e37bd460f$var$defineBuiltIn$3 = $5bb7220e37bd460f$var$defineBuiltIn$8;
var $5bb7220e37bd460f$var$wellKnownSymbol$6 = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$Iterators$1 = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$IteratorsCore = $5bb7220e37bd460f$var$iteratorsCore;
var $5bb7220e37bd460f$var$PROPER_FUNCTION_NAME$2 = $5bb7220e37bd460f$var$FunctionName$1.PROPER;
var $5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME$1 = $5bb7220e37bd460f$var$FunctionName$1.CONFIGURABLE;
var $5bb7220e37bd460f$var$IteratorPrototype = $5bb7220e37bd460f$var$IteratorsCore.IteratorPrototype;
var $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS = $5bb7220e37bd460f$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $5bb7220e37bd460f$var$ITERATOR$1 = $5bb7220e37bd460f$var$wellKnownSymbol$6("iterator");
var $5bb7220e37bd460f$var$KEYS = "keys";
var $5bb7220e37bd460f$var$VALUES = "values";
var $5bb7220e37bd460f$var$ENTRIES = "entries";
var $5bb7220e37bd460f$var$returnThis = function() {
    return this;
};
var $5bb7220e37bd460f$var$defineIterator$1 = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $5bb7220e37bd460f$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $5bb7220e37bd460f$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $5bb7220e37bd460f$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $5bb7220e37bd460f$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$5bb7220e37bd460f$var$ITERATOR$1] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $5bb7220e37bd460f$var$getPrototypeOf$2(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($5bb7220e37bd460f$var$getPrototypeOf$2(CurrentIteratorPrototype) !== $5bb7220e37bd460f$var$IteratorPrototype) {
                if ($5bb7220e37bd460f$var$setPrototypeOf$4) $5bb7220e37bd460f$var$setPrototypeOf$4(CurrentIteratorPrototype, $5bb7220e37bd460f$var$IteratorPrototype);
                else if (!$5bb7220e37bd460f$var$isCallable$3(CurrentIteratorPrototype[$5bb7220e37bd460f$var$ITERATOR$1])) $5bb7220e37bd460f$var$defineBuiltIn$3(CurrentIteratorPrototype, $5bb7220e37bd460f$var$ITERATOR$1, $5bb7220e37bd460f$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $5bb7220e37bd460f$var$setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($5bb7220e37bd460f$var$PROPER_FUNCTION_NAME$2 && DEFAULT == $5bb7220e37bd460f$var$VALUES && nativeIterator && nativeIterator.name !== $5bb7220e37bd460f$var$VALUES) {
        if ($5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME$1) $5bb7220e37bd460f$var$createNonEnumerableProperty$5(IterablePrototype, "name", $5bb7220e37bd460f$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $5bb7220e37bd460f$var$call$8(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($5bb7220e37bd460f$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($5bb7220e37bd460f$var$KEYS),
            entries: getIterationMethod($5bb7220e37bd460f$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $5bb7220e37bd460f$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $5bb7220e37bd460f$var$$$8({
            target: NAME,
            proto: true,
            forced: $5bb7220e37bd460f$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$5bb7220e37bd460f$var$ITERATOR$1] !== defaultIterator) $5bb7220e37bd460f$var$defineBuiltIn$3(IterablePrototype, $5bb7220e37bd460f$var$ITERATOR$1, defaultIterator, {
        name: DEFAULT
    });
    $5bb7220e37bd460f$var$Iterators$1[NAME] = defaultIterator;
    return methods;
};
var $5bb7220e37bd460f$var$toIndexedObject$1 = $5bb7220e37bd460f$var$toIndexedObject$6;
var $5bb7220e37bd460f$var$addToUnscopables$1 = $5bb7220e37bd460f$var$addToUnscopables$2;
var $5bb7220e37bd460f$var$Iterators = $5bb7220e37bd460f$var$iterators;
var $5bb7220e37bd460f$var$InternalStateModule$3 = $5bb7220e37bd460f$var$internalState;
var $5bb7220e37bd460f$var$defineProperty$3 = $5bb7220e37bd460f$var$objectDefineProperty.f;
var $5bb7220e37bd460f$var$defineIterator = $5bb7220e37bd460f$var$defineIterator$1;
var $5bb7220e37bd460f$var$DESCRIPTORS$4 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$ARRAY_ITERATOR = "Array Iterator";
var $5bb7220e37bd460f$var$setInternalState$2 = $5bb7220e37bd460f$var$InternalStateModule$3.set;
var $5bb7220e37bd460f$var$getInternalState$4 = $5bb7220e37bd460f$var$InternalStateModule$3.getterFor($5bb7220e37bd460f$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $5bb7220e37bd460f$var$es_array_iterator = $5bb7220e37bd460f$var$defineIterator(Array, "Array", function(iterated, kind) {
    $5bb7220e37bd460f$var$setInternalState$2(this, {
        type: $5bb7220e37bd460f$var$ARRAY_ITERATOR,
        target: $5bb7220e37bd460f$var$toIndexedObject$1(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $5bb7220e37bd460f$var$getInternalState$4(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $5bb7220e37bd460f$var$values = $5bb7220e37bd460f$var$Iterators.Arguments = $5bb7220e37bd460f$var$Iterators.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$5bb7220e37bd460f$var$addToUnscopables$1("keys");
$5bb7220e37bd460f$var$addToUnscopables$1("values");
$5bb7220e37bd460f$var$addToUnscopables$1("entries");
// V8 ~ Chrome 45- bug
if ($5bb7220e37bd460f$var$DESCRIPTORS$4 && $5bb7220e37bd460f$var$values.name !== "values") try {
    $5bb7220e37bd460f$var$defineProperty$3($5bb7220e37bd460f$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $5bb7220e37bd460f$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $5bb7220e37bd460f$var$documentCreateElement = $5bb7220e37bd460f$var$documentCreateElement$2;
var $5bb7220e37bd460f$var$classList = $5bb7220e37bd460f$var$documentCreateElement("span").classList;
var $5bb7220e37bd460f$var$DOMTokenListPrototype$1 = $5bb7220e37bd460f$var$classList && $5bb7220e37bd460f$var$classList.constructor && $5bb7220e37bd460f$var$classList.constructor.prototype;
var $5bb7220e37bd460f$var$domTokenListPrototype = $5bb7220e37bd460f$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $5bb7220e37bd460f$var$DOMTokenListPrototype$1;
var $5bb7220e37bd460f$var$global$b = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$DOMIterables = $5bb7220e37bd460f$var$domIterables;
var $5bb7220e37bd460f$var$DOMTokenListPrototype = $5bb7220e37bd460f$var$domTokenListPrototype;
var $5bb7220e37bd460f$var$ArrayIteratorMethods = $5bb7220e37bd460f$var$es_array_iterator;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$4 = $5bb7220e37bd460f$var$createNonEnumerableProperty$8;
var $5bb7220e37bd460f$var$wellKnownSymbol$5 = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$ITERATOR = $5bb7220e37bd460f$var$wellKnownSymbol$5("iterator");
var $5bb7220e37bd460f$var$TO_STRING_TAG$1 = $5bb7220e37bd460f$var$wellKnownSymbol$5("toStringTag");
var $5bb7220e37bd460f$var$ArrayValues = $5bb7220e37bd460f$var$ArrayIteratorMethods.values;
var $5bb7220e37bd460f$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$5bb7220e37bd460f$var$ITERATOR] !== $5bb7220e37bd460f$var$ArrayValues) try {
            $5bb7220e37bd460f$var$createNonEnumerableProperty$4(CollectionPrototype, $5bb7220e37bd460f$var$ITERATOR, $5bb7220e37bd460f$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$5bb7220e37bd460f$var$ITERATOR] = $5bb7220e37bd460f$var$ArrayValues;
        }
        if (!CollectionPrototype[$5bb7220e37bd460f$var$TO_STRING_TAG$1]) $5bb7220e37bd460f$var$createNonEnumerableProperty$4(CollectionPrototype, $5bb7220e37bd460f$var$TO_STRING_TAG$1, COLLECTION_NAME);
        if ($5bb7220e37bd460f$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $5bb7220e37bd460f$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $5bb7220e37bd460f$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $5bb7220e37bd460f$var$createNonEnumerableProperty$4(CollectionPrototype, METHOD_NAME, $5bb7220e37bd460f$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $5bb7220e37bd460f$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $5bb7220e37bd460f$var$COLLECTION_NAME in $5bb7220e37bd460f$var$DOMIterables)$5bb7220e37bd460f$var$handlePrototype($5bb7220e37bd460f$var$global$b[$5bb7220e37bd460f$var$COLLECTION_NAME] && $5bb7220e37bd460f$var$global$b[$5bb7220e37bd460f$var$COLLECTION_NAME].prototype, $5bb7220e37bd460f$var$COLLECTION_NAME);
$5bb7220e37bd460f$var$handlePrototype($5bb7220e37bd460f$var$DOMTokenListPrototype, "DOMTokenList");
class $5bb7220e37bd460f$var$Logger {
    constructor(namespace){
        this.namespace = namespace;
    }
    emit(method, ...params) {
        if (!$5bb7220e37bd460f$var$Logger.debug) return;
        if (this.namespace && method !== "error") {
            // eslint-disable-next-line no-console
            console[method](this.namespace, ...params);
            return;
        }
        // eslint-disable-next-line no-console
        console[method](...params);
    }
    log(...params) {
        this.emit("log", ...params);
    }
    info(...params) {
        this.emit("info", ...params);
    }
    warn(...params) {
        this.emit("warn", ...params);
    }
    error(...params) {
        this.emit("error", ...params);
    }
}
$5bb7220e37bd460f$var$Logger.debug = false;
const $5bb7220e37bd460f$var$logger = new $5bb7220e37bd460f$var$Logger();
var $5bb7220e37bd460f$var$$$7 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$$includes = $5bb7220e37bd460f$var$arrayIncludes.includes;
var $5bb7220e37bd460f$var$fails$f = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$addToUnscopables = $5bb7220e37bd460f$var$addToUnscopables$2;
// FF99+ bug
var $5bb7220e37bd460f$var$BROKEN_ON_SPARSE = $5bb7220e37bd460f$var$fails$f(function() {
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$5bb7220e37bd460f$var$$$7({
    target: "Array",
    proto: true,
    forced: $5bb7220e37bd460f$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $5bb7220e37bd460f$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$5bb7220e37bd460f$var$addToUnscopables("includes");
var $5bb7220e37bd460f$var$isObject$5 = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$classof$6 = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$wellKnownSymbol$4 = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$MATCH$1 = $5bb7220e37bd460f$var$wellKnownSymbol$4("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var $5bb7220e37bd460f$var$isRegexp = function(it) {
    var isRegExp;
    return $5bb7220e37bd460f$var$isObject$5(it) && ((isRegExp = it[$5bb7220e37bd460f$var$MATCH$1]) !== undefined ? !!isRegExp : $5bb7220e37bd460f$var$classof$6(it) == "RegExp");
};
var $5bb7220e37bd460f$var$isRegExp$1 = $5bb7220e37bd460f$var$isRegexp;
var $5bb7220e37bd460f$var$$TypeError$3 = TypeError;
var $5bb7220e37bd460f$var$notARegexp = function(it) {
    if ($5bb7220e37bd460f$var$isRegExp$1(it)) throw $5bb7220e37bd460f$var$$TypeError$3("The method doesn't accept regular expressions");
    return it;
};
var $5bb7220e37bd460f$var$classof$5 = $5bb7220e37bd460f$var$classof$9;
var $5bb7220e37bd460f$var$$String = String;
var $5bb7220e37bd460f$var$toString$5 = function(argument) {
    if ($5bb7220e37bd460f$var$classof$5(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $5bb7220e37bd460f$var$$String(argument);
};
var $5bb7220e37bd460f$var$wellKnownSymbol$3 = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$MATCH = $5bb7220e37bd460f$var$wellKnownSymbol$3("match");
var $5bb7220e37bd460f$var$correctIsRegexpLogic = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$5bb7220e37bd460f$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};
var $5bb7220e37bd460f$var$$$6 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$uncurryThis$b = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$notARegExp = $5bb7220e37bd460f$var$notARegexp;
var $5bb7220e37bd460f$var$requireObjectCoercible$3 = $5bb7220e37bd460f$var$requireObjectCoercible$6;
var $5bb7220e37bd460f$var$toString$4 = $5bb7220e37bd460f$var$toString$5;
var $5bb7220e37bd460f$var$correctIsRegExpLogic = $5bb7220e37bd460f$var$correctIsRegexpLogic;
var $5bb7220e37bd460f$var$stringIndexOf = $5bb7220e37bd460f$var$uncurryThis$b("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$5bb7220e37bd460f$var$$$6({
    target: "String",
    proto: true,
    forced: !$5bb7220e37bd460f$var$correctIsRegExpLogic("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$5bb7220e37bd460f$var$stringIndexOf($5bb7220e37bd460f$var$toString$4($5bb7220e37bd460f$var$requireObjectCoercible$3(this)), $5bb7220e37bd460f$var$toString$4($5bb7220e37bd460f$var$notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});
// a string of all valid unicode whitespaces
var $5bb7220e37bd460f$var$whitespaces$2 = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
var $5bb7220e37bd460f$var$uncurryThis$a = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$requireObjectCoercible$2 = $5bb7220e37bd460f$var$requireObjectCoercible$6;
var $5bb7220e37bd460f$var$toString$3 = $5bb7220e37bd460f$var$toString$5;
var $5bb7220e37bd460f$var$whitespaces$1 = $5bb7220e37bd460f$var$whitespaces$2;
var $5bb7220e37bd460f$var$replace$1 = $5bb7220e37bd460f$var$uncurryThis$a("".replace);
var $5bb7220e37bd460f$var$whitespace = "[" + $5bb7220e37bd460f$var$whitespaces$1 + "]";
var $5bb7220e37bd460f$var$ltrim = RegExp("^" + $5bb7220e37bd460f$var$whitespace + $5bb7220e37bd460f$var$whitespace + "*");
var $5bb7220e37bd460f$var$rtrim = RegExp($5bb7220e37bd460f$var$whitespace + $5bb7220e37bd460f$var$whitespace + "*$");
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $5bb7220e37bd460f$var$createMethod$3 = function(TYPE) {
    return function($this) {
        var string = $5bb7220e37bd460f$var$toString$3($5bb7220e37bd460f$var$requireObjectCoercible$2($this));
        if (TYPE & 1) string = $5bb7220e37bd460f$var$replace$1(string, $5bb7220e37bd460f$var$ltrim, "");
        if (TYPE & 2) string = $5bb7220e37bd460f$var$replace$1(string, $5bb7220e37bd460f$var$rtrim, "");
        return string;
    };
};
var $5bb7220e37bd460f$var$stringTrim = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $5bb7220e37bd460f$var$createMethod$3(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $5bb7220e37bd460f$var$createMethod$3(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $5bb7220e37bd460f$var$createMethod$3(3)
};
var $5bb7220e37bd460f$var$PROPER_FUNCTION_NAME$1 = $5bb7220e37bd460f$var$functionName.PROPER;
var $5bb7220e37bd460f$var$fails$e = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$whitespaces = $5bb7220e37bd460f$var$whitespaces$2;
var $5bb7220e37bd460f$var$non = "\u200B\x85\u180E";
// check that a method works with the correct list
// of whitespaces and has a correct name
var $5bb7220e37bd460f$var$stringTrimForced = function(METHOD_NAME) {
    return $5bb7220e37bd460f$var$fails$e(function() {
        return !!$5bb7220e37bd460f$var$whitespaces[METHOD_NAME]() || $5bb7220e37bd460f$var$non[METHOD_NAME]() !== $5bb7220e37bd460f$var$non || $5bb7220e37bd460f$var$PROPER_FUNCTION_NAME$1 && $5bb7220e37bd460f$var$whitespaces[METHOD_NAME].name !== METHOD_NAME;
    });
};
var $5bb7220e37bd460f$var$$$5 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$$trim = $5bb7220e37bd460f$var$stringTrim.trim;
var $5bb7220e37bd460f$var$forcedStringTrimMethod = $5bb7220e37bd460f$var$stringTrimForced;
// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$5bb7220e37bd460f$var$$$5({
    target: "String",
    proto: true,
    forced: $5bb7220e37bd460f$var$forcedStringTrimMethod("trim")
}, {
    trim: function trim() {
        return $5bb7220e37bd460f$var$$trim(this);
    }
});
var $5bb7220e37bd460f$var$DESCRIPTORS$3 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$uncurryThis$9 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$call$7 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$fails$d = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$objectKeys = $5bb7220e37bd460f$var$objectKeys$2;
var $5bb7220e37bd460f$var$getOwnPropertySymbolsModule = $5bb7220e37bd460f$var$objectGetOwnPropertySymbols;
var $5bb7220e37bd460f$var$propertyIsEnumerableModule = $5bb7220e37bd460f$var$objectPropertyIsEnumerable;
var $5bb7220e37bd460f$var$toObject$4 = $5bb7220e37bd460f$var$toObject$7;
var $5bb7220e37bd460f$var$IndexedObject$2 = $5bb7220e37bd460f$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $5bb7220e37bd460f$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $5bb7220e37bd460f$var$defineProperty$2 = Object.defineProperty;
var $5bb7220e37bd460f$var$concat = $5bb7220e37bd460f$var$uncurryThis$9([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $5bb7220e37bd460f$var$objectAssign = !$5bb7220e37bd460f$var$$assign || $5bb7220e37bd460f$var$fails$d(function() {
    // should have correct order of operations (Edge bug)
    if ($5bb7220e37bd460f$var$DESCRIPTORS$3 && $5bb7220e37bd460f$var$$assign({
        b: 1
    }, $5bb7220e37bd460f$var$$assign($5bb7220e37bd460f$var$defineProperty$2({}, "a", {
        enumerable: true,
        get: function() {
            $5bb7220e37bd460f$var$defineProperty$2(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $5bb7220e37bd460f$var$$assign({}, A)[symbol] != 7 || $5bb7220e37bd460f$var$objectKeys($5bb7220e37bd460f$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $5bb7220e37bd460f$var$toObject$4(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $5bb7220e37bd460f$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $5bb7220e37bd460f$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $5bb7220e37bd460f$var$IndexedObject$2(arguments[index++]);
        var keys = getOwnPropertySymbols ? $5bb7220e37bd460f$var$concat($5bb7220e37bd460f$var$objectKeys(S), getOwnPropertySymbols(S)) : $5bb7220e37bd460f$var$objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$5bb7220e37bd460f$var$DESCRIPTORS$3 || $5bb7220e37bd460f$var$call$7(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $5bb7220e37bd460f$var$$assign;
var $5bb7220e37bd460f$var$$$4 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$assign = $5bb7220e37bd460f$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$5bb7220e37bd460f$var$$$4({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $5bb7220e37bd460f$var$assign
}, {
    assign: $5bb7220e37bd460f$var$assign
});
class $5bb7220e37bd460f$export$4fae95256245c8c0 {
    constructor(){
        this.emitter = new (0, $7etJZ.EventEmitter)();
    }
    on(eventName, callback) {
        this.emitter.on(eventName, callback);
        return {
            remove: ()=>this.emitter.off(eventName, callback)
        };
    }
    off(eventName, callback) {
        this.emitter.off(eventName, callback);
    }
    emit(eventName, event) {
        this.emitter.emit(eventName, event);
    }
}
const $5bb7220e37bd460f$var$PACKAGE_NAME = "near-wallet-selector";
const $5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS = "recentlySignedInWallets";
const $5bb7220e37bd460f$var$CONTRACT = "contract";
const $5bb7220e37bd460f$var$PENDING_CONTRACT = "contract:pending";
const $5bb7220e37bd460f$var$SELECTED_WALLET_ID = `selectedWalletId`;
const $5bb7220e37bd460f$var$PENDING_SELECTED_WALLET_ID = `selectedWalletId:pending`;
class $5bb7220e37bd460f$var$WalletModules {
    constructor({ factories: factories, storage: storage, options: options, store: store, emitter: emitter, provider: provider }){
        this.factories = factories;
        this.storage = storage;
        this.options = options;
        this.store = store;
        this.emitter = emitter;
        this.provider = provider;
        this.modules = [];
        this.instances = {};
    }
    validateWallet(id) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            let accounts = [];
            const wallet = yield this.getWallet(id);
            if (wallet) // Ensure our persistent state aligns with the selected wallet.
            // For example a wallet is selected, but it returns no accounts (not signed in).
            accounts = yield wallet.getAccounts().catch((err)=>{
                $5bb7220e37bd460f$var$logger.log(`Failed to validate ${wallet.id} during setup`);
                $5bb7220e37bd460f$var$logger.error(err);
                return [];
            });
            return accounts;
        });
    }
    resolveStorageState() {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const jsonStorage = new $5bb7220e37bd460f$var$JsonStorage(this.storage, $5bb7220e37bd460f$var$PACKAGE_NAME);
            const pendingSelectedWalletId = yield jsonStorage.getItem($5bb7220e37bd460f$var$PENDING_SELECTED_WALLET_ID);
            const pendingContract = yield jsonStorage.getItem($5bb7220e37bd460f$var$PENDING_CONTRACT);
            if (pendingSelectedWalletId && pendingContract) {
                const _accounts = yield this.validateWallet(pendingSelectedWalletId);
                yield jsonStorage.removeItem($5bb7220e37bd460f$var$PENDING_SELECTED_WALLET_ID);
                yield jsonStorage.removeItem($5bb7220e37bd460f$var$PENDING_CONTRACT);
                if (_accounts.length) {
                    const { selectedWalletId: _selectedWalletId } = this.store.getState();
                    const selectedWallet = yield this.getWallet(_selectedWalletId);
                    if (selectedWallet && pendingSelectedWalletId !== _selectedWalletId) yield selectedWallet.signOut().catch((err)=>{
                        $5bb7220e37bd460f$var$logger.log("Failed to sign out existing wallet");
                        $5bb7220e37bd460f$var$logger.error(err);
                    });
                    const recentlySignedInWalletsFromPending = yield this.setWalletAsRecentlySignedIn(pendingSelectedWalletId);
                    return {
                        accounts: _accounts,
                        contract: pendingContract,
                        selectedWalletId: pendingSelectedWalletId,
                        recentlySignedInWallets: recentlySignedInWalletsFromPending
                    };
                }
            }
            const { contract: contract, selectedWalletId: selectedWalletId } = this.store.getState();
            const accounts = yield this.validateWallet(selectedWalletId);
            const recentlySignedInWallets = yield jsonStorage.getItem($5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS);
            if (!accounts.length) return {
                accounts: [],
                contract: null,
                selectedWalletId: null,
                recentlySignedInWallets: recentlySignedInWallets || []
            };
            return {
                accounts: accounts,
                contract: contract,
                selectedWalletId: selectedWalletId,
                recentlySignedInWallets: recentlySignedInWallets || []
            };
        });
    }
    setWalletAsRecentlySignedIn(walletId) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const jsonStorage = new $5bb7220e37bd460f$var$JsonStorage(this.storage, $5bb7220e37bd460f$var$PACKAGE_NAME);
            let recentlySignedInWallets = yield jsonStorage.getItem($5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS);
            if (!recentlySignedInWallets) recentlySignedInWallets = [];
            if (!recentlySignedInWallets.includes(walletId)) {
                recentlySignedInWallets.unshift(walletId);
                recentlySignedInWallets = recentlySignedInWallets.slice(0, 5);
                yield jsonStorage.setItem($5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS, recentlySignedInWallets);
            }
            return recentlySignedInWallets;
        });
    }
    signOutWallet(walletId) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const wallet = yield this.getWallet(walletId);
            yield wallet.signOut().catch((err)=>{
                $5bb7220e37bd460f$var$logger.log(`Failed to sign out ${wallet.id}`);
                $5bb7220e37bd460f$var$logger.error(err);
                // At least clean up state on our side.
                this.onWalletSignedOut(wallet.id);
            });
        });
    }
    onWalletSignedIn(walletId, { accounts: accounts, contractId: contractId, methodNames: methodNames }) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const { selectedWalletId: selectedWalletId } = this.store.getState();
            const jsonStorage = new $5bb7220e37bd460f$var$JsonStorage(this.storage, $5bb7220e37bd460f$var$PACKAGE_NAME);
            const contract = {
                contractId: contractId,
                methodNames: methodNames
            };
            if (!accounts.length) {
                const module = this.getModule(walletId);
                // We can't guarantee the user will actually sign in with browser wallets.
                // Best we can do is set in storage and validate on init.
                if (module.type === "browser") {
                    yield jsonStorage.setItem($5bb7220e37bd460f$var$PENDING_SELECTED_WALLET_ID, walletId);
                    yield jsonStorage.setItem($5bb7220e37bd460f$var$PENDING_CONTRACT, contract);
                }
                return;
            }
            if (selectedWalletId && selectedWalletId !== walletId) yield this.signOutWallet(selectedWalletId);
            const recentlySignedInWallets = yield this.setWalletAsRecentlySignedIn(walletId);
            this.store.dispatch({
                type: "WALLET_CONNECTED",
                payload: {
                    walletId: walletId,
                    contract: contract,
                    accounts: accounts,
                    recentlySignedInWallets: recentlySignedInWallets
                }
            });
            this.emitter.emit("signedIn", {
                walletId: walletId,
                contractId: contractId,
                methodNames: methodNames,
                accounts: accounts
            });
        });
    }
    onWalletSignedOut(walletId) {
        this.store.dispatch({
            type: "WALLET_DISCONNECTED",
            payload: {
                walletId: walletId
            }
        });
        this.emitter.emit("signedOut", {
            walletId: walletId
        });
    }
    setupWalletEmitter(module) {
        const emitter = new $5bb7220e37bd460f$export$4fae95256245c8c0();
        emitter.on("signedOut", ()=>{
            this.onWalletSignedOut(module.id);
        });
        emitter.on("signedIn", (event)=>{
            this.onWalletSignedIn(module.id, event);
        });
        emitter.on("accountsChanged", ({ accounts: accounts })=>$5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
                this.emitter.emit("accountsChanged", {
                    walletId: module.id,
                    accounts: accounts
                });
                if (!accounts.length) return this.signOutWallet(module.id);
                this.store.dispatch({
                    type: "ACCOUNTS_CHANGED",
                    payload: {
                        walletId: module.id,
                        accounts: accounts
                    }
                });
            }));
        emitter.on("networkChanged", ({ networkId: networkId })=>{
            this.emitter.emit("networkChanged", {
                walletId: module.id,
                networkId: networkId
            });
        });
        emitter.on("uriChanged", ({ uri: uri })=>{
            this.emitter.emit("uriChanged", {
                walletId: module.id,
                uri: uri
            });
        });
        return emitter;
    }
    validateSignMessageParams({ message: message, nonce: nonce, recipient: recipient }) {
        if (!message || message.trim() === "") throw new Error("Invalid message. It must be a non-empty string.");
        if (!$5bb7220e37bd460f$require$Buffer.isBuffer(nonce) || nonce.length !== 32) throw new Error("Invalid nonce. It must be a Buffer with a length of 32 bytes.");
        if (!recipient || recipient.trim() === "") throw new Error("Invalid recipient. It must be a non-empty string.");
    }
    decorateWallet(wallet) {
        const _signIn = wallet.signIn;
        const _signOut = wallet.signOut;
        const _signMessage = wallet.signMessage;
        wallet.signIn = (params)=>$5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
                const accounts = yield _signIn(params);
                const { contractId: contractId, methodNames: methodNames = [] } = params;
                yield this.onWalletSignedIn(wallet.id, {
                    accounts: accounts,
                    contractId: contractId,
                    methodNames: methodNames
                });
                return accounts;
            });
        wallet.signOut = ()=>$5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
                yield _signOut();
                this.onWalletSignedOut(wallet.id);
            });
        wallet.signMessage = (params)=>$5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
                if (_signMessage === undefined) throw Error(`The signMessage method is not supported by ${wallet.metadata.name}`);
                this.validateSignMessageParams(params);
                return yield _signMessage(params);
            });
        return wallet;
    }
    setupInstance(module) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            if (!module.metadata.available) {
                const message = module.type === "injected" ? "not installed" : "not available";
                throw Error(`${module.metadata.name} is ${message}`);
            }
            const wallet = Object.assign({
                id: module.id,
                type: module.type,
                metadata: module.metadata
            }, (yield module.init({
                id: module.id,
                type: module.type,
                metadata: module.metadata,
                options: this.options,
                store: this.store.toReadOnly(),
                provider: this.provider,
                emitter: this.setupWalletEmitter(module),
                logger: new $5bb7220e37bd460f$var$Logger(module.id),
                storage: new $5bb7220e37bd460f$var$JsonStorage(this.storage, [
                    $5bb7220e37bd460f$var$PACKAGE_NAME,
                    module.id
                ])
            })));
            return this.decorateWallet(wallet);
        });
    }
    getModule(id) {
        return this.modules.find((x)=>x.id === id);
    }
    getWallet(id) {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const module = this.getModule(id);
            if (!module) return null;
            const { selectedWalletId: selectedWalletId } = this.store.getState();
            // If user uninstalled/removed a wallet which was previously signed in with
            // best we can do is clean up state on our side.
            if (!module.metadata.available && selectedWalletId) {
                this.onWalletSignedOut(selectedWalletId);
                return null;
            }
            return yield module.wallet();
        });
    }
    setup() {
        return $5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
            const modules = [];
            for(let i = 0; i < this.factories.length; i += 1){
                const module = yield this.factories[i]({
                    options: this.options
                }).catch((err)=>{
                    $5bb7220e37bd460f$var$logger.log("Failed to setup module");
                    $5bb7220e37bd460f$var$logger.error(err);
                    return null;
                });
                // Filter out wallets that aren't available.
                if (!module) continue;
                // Skip duplicated module.
                if (modules.some((x)=>x.id === module.id)) continue;
                modules.push({
                    id: module.id,
                    type: module.type,
                    metadata: module.metadata,
                    wallet: ()=>$5bb7220e37bd460f$var$__awaiter(this, void 0, void 0, function*() {
                            let instance = this.instances[module.id];
                            if (instance) return instance;
                            instance = yield this.setupInstance(module);
                            this.instances[module.id] = instance;
                            return instance;
                        })
                });
            }
            this.modules = modules;
            const { accounts: accounts, contract: contract, selectedWalletId: selectedWalletId, recentlySignedInWallets: recentlySignedInWallets } = yield this.resolveStorageState();
            this.store.dispatch({
                type: "SETUP_WALLET_MODULES",
                payload: {
                    modules: modules,
                    accounts: accounts,
                    contract: contract,
                    selectedWalletId: selectedWalletId,
                    recentlySignedInWallets: recentlySignedInWallets
                }
            });
            for(let i = 0; i < this.modules.length; i++){
                if (this.modules[i].type !== "instant-link") continue;
                const wallet = yield this.modules[i].wallet();
                if (!wallet.metadata.runOnStartup) continue;
                try {
                    yield wallet.signIn({
                        contractId: wallet.getContractId()
                    });
                } catch (err) {
                    $5bb7220e37bd460f$var$logger.error("Failed to sign in to wallet. " + err);
                }
            }
        });
    }
}
const $5bb7220e37bd460f$var$getNetworkPreset = (networkId)=>{
    switch(networkId){
        case "mainnet":
            return {
                networkId: networkId,
                nodeUrl: "https://rpc.mainnet.near.org",
                helperUrl: "https://helper.mainnet.near.org",
                explorerUrl: "https://nearblocks.io",
                indexerUrl: "https://api.kitwallet.app"
            };
        case "testnet":
            return {
                networkId: networkId,
                nodeUrl: "https://rpc.testnet.near.org",
                helperUrl: "https://helper.testnet.near.org",
                explorerUrl: "https://testnet.nearblocks.io",
                indexerUrl: "https://testnet-api.kitwallet.app"
            };
        default:
            throw Error(`Failed to find config for: '${networkId}'`);
    }
};
const $5bb7220e37bd460f$var$resolveNetwork = (network)=>{
    return typeof network === "string" ? $5bb7220e37bd460f$var$getNetworkPreset(network) : network;
};
const $5bb7220e37bd460f$var$resolveOptions = (params)=>{
    const options = {
        languageCode: params.languageCode || undefined,
        network: $5bb7220e37bd460f$var$resolveNetwork(params.network),
        debug: params.debug || false,
        optimizeWalletOrder: params.optimizeWalletOrder === false ? false : true,
        randomizeWalletOrder: params.randomizeWalletOrder || false,
        relayerUrl: params.relayerUrl || undefined
    };
    return {
        options: options,
        storage: params.storage || new $5bb7220e37bd460f$var$WebStorageService()
    };
};
const $5bb7220e37bd460f$var$reducer = (state, action)=>{
    $5bb7220e37bd460f$var$logger.log("Store Action", action);
    switch(action.type){
        case "SETUP_WALLET_MODULES":
            {
                const { modules: modules, accounts: accounts, contract: contract, selectedWalletId: selectedWalletId, recentlySignedInWallets: recentlySignedInWallets } = action.payload;
                const accountStates = accounts.map((account, i)=>{
                    return Object.assign(Object.assign({}, account), {
                        active: i === 0
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    modules: modules,
                    accounts: accountStates,
                    contract: contract,
                    selectedWalletId: selectedWalletId,
                    recentlySignedInWallets: recentlySignedInWallets
                });
            }
        case "WALLET_CONNECTED":
            {
                const { walletId: walletId, contract: contract, accounts: accounts, recentlySignedInWallets: recentlySignedInWallets } = action.payload;
                if (!accounts.length) return state;
                const activeAccountIndex = state.accounts.findIndex((account)=>account.active);
                const accountStates = accounts.map((account, i)=>{
                    return Object.assign(Object.assign({}, account), {
                        active: i === (activeAccountIndex > -1 ? activeAccountIndex : 0)
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    contract: contract,
                    accounts: accountStates,
                    selectedWalletId: walletId,
                    recentlySignedInWallets: recentlySignedInWallets
                });
            }
        case "WALLET_DISCONNECTED":
            {
                const { walletId: walletId } = action.payload;
                if (walletId !== state.selectedWalletId) return state;
                return Object.assign(Object.assign({}, state), {
                    contract: null,
                    accounts: [],
                    selectedWalletId: null
                });
            }
        case "ACCOUNTS_CHANGED":
            {
                const { walletId: walletId, accounts: accounts } = action.payload;
                if (walletId !== state.selectedWalletId) return state;
                const activeAccount = state.accounts.find((account)=>account.active);
                const isActiveAccountRemoved = !accounts.some((account)=>account.accountId === (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.accountId));
                const accountStates = accounts.map((account, i)=>{
                    return Object.assign(Object.assign({}, account), {
                        active: isActiveAccountRemoved ? i === 0 : account.accountId === (activeAccount === null || activeAccount === void 0 ? void 0 : activeAccount.accountId)
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    accounts: accountStates
                });
            }
        case "SET_ACTIVE_ACCOUNT":
            {
                const { accountId: accountId } = action.payload;
                const accountStates = state.accounts.map((account)=>{
                    return Object.assign(Object.assign({}, account), {
                        active: account.accountId === accountId
                    });
                });
                return Object.assign(Object.assign({}, state), {
                    accounts: accountStates
                });
            }
        default:
            return state;
    }
};
const $5bb7220e37bd460f$var$createStore = (storage)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const jsonStorage = new $5bb7220e37bd460f$var$JsonStorage(storage, $5bb7220e37bd460f$var$PACKAGE_NAME);
        const initialState = {
            modules: [],
            accounts: [],
            contract: yield jsonStorage.getItem($5bb7220e37bd460f$var$CONTRACT),
            selectedWalletId: yield jsonStorage.getItem($5bb7220e37bd460f$var$SELECTED_WALLET_ID),
            recentlySignedInWallets: (yield jsonStorage.getItem($5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS)) || []
        };
        const state$ = new (0, $7aced346698c521d$export$cc3d42e6b2b9cf8b)(initialState);
        const actions$ = new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
        actions$.pipe((0, $095ac41f805f8ce2$export$c87d910e63d22ed6)($5bb7220e37bd460f$var$reducer, initialState)).subscribe(state$);
        const syncStorage = (prevState, state, storageKey, property)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
                if (state[property] === prevState[property]) return;
                if (state[property]) {
                    yield jsonStorage.setItem(storageKey, state[property]);
                    return;
                }
                yield jsonStorage.removeItem(storageKey);
            });
        let prevState = state$.getValue();
        state$.subscribe((state)=>{
            syncStorage(prevState, state, $5bb7220e37bd460f$var$SELECTED_WALLET_ID, "selectedWalletId");
            syncStorage(prevState, state, $5bb7220e37bd460f$var$CONTRACT, "contract");
            syncStorage(prevState, state, $5bb7220e37bd460f$var$RECENTLY_SIGNED_IN_WALLETS, "recentlySignedInWallets");
            prevState = state;
        });
        return {
            observable: state$,
            getState: ()=>state$.getValue(),
            dispatch: (action)=>actions$.next(action),
            toReadOnly: ()=>({
                    getState: ()=>state$.getValue(),
                    observable: state$.asObservable()
                })
        };
    });
let $5bb7220e37bd460f$var$walletSelectorInstance = null;
const $5bb7220e37bd460f$var$createSelector = (options, store, walletModules, emitter)=>{
    return {
        options: options,
        store: store.toReadOnly(),
        wallet: (id)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
                const { selectedWalletId: selectedWalletId } = store.getState();
                const wallet = yield walletModules.getWallet(id || selectedWalletId);
                if (!wallet) {
                    if (id) throw new Error("Invalid wallet id");
                    throw new Error("No wallet selected");
                }
                return wallet;
            }),
        setActiveAccount: (accountId)=>{
            const { accounts: accounts } = store.getState();
            if (!accounts.some((account)=>account.accountId === accountId)) throw new Error("Invalid account id");
            store.dispatch({
                type: "SET_ACTIVE_ACCOUNT",
                payload: {
                    accountId: accountId
                }
            });
        },
        isSignedIn () {
            const { accounts: accounts } = store.getState();
            return Boolean(accounts.length);
        },
        on: (eventName, callback)=>{
            return emitter.on(eventName, callback);
        },
        off: (eventName, callback)=>{
            emitter.off(eventName, callback);
        }
    };
};
/**
 * Initiates a wallet selector instance
 * @param {WalletSelectorParams} params Selector parameters (network, modules...)
 * @returns {Promise<WalletSelector>} Returns a WalletSelector object
 */ const $5bb7220e37bd460f$export$f9bdc9e9de5b988e = (params)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const { options: options, storage: storage } = $5bb7220e37bd460f$var$resolveOptions(params);
        $5bb7220e37bd460f$var$Logger.debug = options.debug;
        const emitter = new $5bb7220e37bd460f$export$4fae95256245c8c0();
        const store = yield $5bb7220e37bd460f$var$createStore(storage);
        const walletModules = new $5bb7220e37bd460f$var$WalletModules({
            factories: params.modules,
            storage: storage,
            options: options,
            store: store,
            emitter: emitter,
            provider: new $5bb7220e37bd460f$var$Provider(options.network.nodeUrl)
        });
        yield walletModules.setup();
        if (params.allowMultipleSelectors) return $5bb7220e37bd460f$var$createSelector(options, store, walletModules, emitter);
        if (!$5bb7220e37bd460f$var$walletSelectorInstance) $5bb7220e37bd460f$var$walletSelectorInstance = $5bb7220e37bd460f$var$createSelector(options, store, walletModules, emitter);
        return $5bb7220e37bd460f$var$walletSelectorInstance;
    });
const $5bb7220e37bd460f$var$wait = (ms)=>{
    return new Promise((resolve)=>setTimeout(resolve, ms));
};
const $5bb7220e37bd460f$var$poll = (cb, interval, remaining)=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const result = cb();
        if (result) return result;
        if (!remaining) throw new Error("Exceeded timeout");
        return $5bb7220e37bd460f$var$wait(interval).then(()=>$5bb7220e37bd460f$var$poll(cb, interval, remaining - 1));
    });
const $5bb7220e37bd460f$export$9bbfceb27f687c1b = (cb, opts = {})=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const { timeout: timeout = 100, interval: interval = 50 } = opts;
        return Promise.race([
            $5bb7220e37bd460f$var$wait(timeout).then(()=>{
                throw new Error("Exceeded timeout");
            }),
            $5bb7220e37bd460f$var$poll(cb, interval, Math.floor(timeout / interval))
        ]);
    });
const $5bb7220e37bd460f$export$13dd2e33a23839ad = (state)=>{
    return state.accounts.find((account)=>account.active) || null;
};
var $5bb7220e37bd460f$var$aCallable$1 = $5bb7220e37bd460f$var$aCallable$9;
var $5bb7220e37bd460f$var$toObject$3 = $5bb7220e37bd460f$var$toObject$7;
var $5bb7220e37bd460f$var$IndexedObject$1 = $5bb7220e37bd460f$var$indexedObject;
var $5bb7220e37bd460f$var$lengthOfArrayLike$5 = $5bb7220e37bd460f$var$lengthOfArrayLike$8;
var $5bb7220e37bd460f$var$$TypeError$2 = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $5bb7220e37bd460f$var$createMethod$2 = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $5bb7220e37bd460f$var$aCallable$1(callbackfn);
        var O = $5bb7220e37bd460f$var$toObject$3(that);
        var self1 = $5bb7220e37bd460f$var$IndexedObject$1(O);
        var length = $5bb7220e37bd460f$var$lengthOfArrayLike$5(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self1) {
                memo = self1[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $5bb7220e37bd460f$var$$TypeError$2("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
        return memo;
    };
};
var $5bb7220e37bd460f$var$arrayReduce = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $5bb7220e37bd460f$var$createMethod$2(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $5bb7220e37bd460f$var$createMethod$2(true)
};
var $5bb7220e37bd460f$var$fails$c = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$arrayMethodIsStrict$1 = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $5bb7220e37bd460f$var$fails$c(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};
var $5bb7220e37bd460f$var$$$3 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$$reduce = $5bb7220e37bd460f$var$arrayReduce.left;
var $5bb7220e37bd460f$var$arrayMethodIsStrict = $5bb7220e37bd460f$var$arrayMethodIsStrict$1;
var $5bb7220e37bd460f$var$CHROME_VERSION = $5bb7220e37bd460f$var$engineV8Version;
var $5bb7220e37bd460f$var$IS_NODE = $5bb7220e37bd460f$var$engineIsNode;
var $5bb7220e37bd460f$var$STRICT_METHOD = $5bb7220e37bd460f$var$arrayMethodIsStrict("reduce");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $5bb7220e37bd460f$var$CHROME_BUG = !$5bb7220e37bd460f$var$IS_NODE && $5bb7220e37bd460f$var$CHROME_VERSION > 79 && $5bb7220e37bd460f$var$CHROME_VERSION < 83;
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$5bb7220e37bd460f$var$$$3({
    target: "Array",
    proto: true,
    forced: !$5bb7220e37bd460f$var$STRICT_METHOD || $5bb7220e37bd460f$var$CHROME_BUG
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $5bb7220e37bd460f$var$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});
var $5bb7220e37bd460f$var$anObject$3 = $5bb7220e37bd460f$var$anObject$e;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $5bb7220e37bd460f$var$regexpFlags$1 = function() {
    var that = $5bb7220e37bd460f$var$anObject$3(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $5bb7220e37bd460f$var$fails$b = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$global$a = $5bb7220e37bd460f$var$global$t;
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $5bb7220e37bd460f$var$$RegExp$2 = $5bb7220e37bd460f$var$global$a.RegExp;
var $5bb7220e37bd460f$var$UNSUPPORTED_Y$2 = $5bb7220e37bd460f$var$fails$b(function() {
    var re = $5bb7220e37bd460f$var$$RegExp$2("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $5bb7220e37bd460f$var$MISSED_STICKY = $5bb7220e37bd460f$var$UNSUPPORTED_Y$2 || $5bb7220e37bd460f$var$fails$b(function() {
    return !$5bb7220e37bd460f$var$$RegExp$2("a", "y").sticky;
});
var $5bb7220e37bd460f$var$BROKEN_CARET = $5bb7220e37bd460f$var$UNSUPPORTED_Y$2 || $5bb7220e37bd460f$var$fails$b(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $5bb7220e37bd460f$var$$RegExp$2("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
var $5bb7220e37bd460f$var$regexpStickyHelpers = {
    BROKEN_CARET: $5bb7220e37bd460f$var$BROKEN_CARET,
    MISSED_STICKY: $5bb7220e37bd460f$var$MISSED_STICKY,
    UNSUPPORTED_Y: $5bb7220e37bd460f$var$UNSUPPORTED_Y$2
};
var $5bb7220e37bd460f$var$fails$a = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$global$9 = $5bb7220e37bd460f$var$global$t;
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $5bb7220e37bd460f$var$$RegExp$1 = $5bb7220e37bd460f$var$global$9.RegExp;
var $5bb7220e37bd460f$var$regexpUnsupportedDotAll = $5bb7220e37bd460f$var$fails$a(function() {
    var re = $5bb7220e37bd460f$var$$RegExp$1(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});
var $5bb7220e37bd460f$var$fails$9 = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$global$8 = $5bb7220e37bd460f$var$global$t;
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $5bb7220e37bd460f$var$$RegExp = $5bb7220e37bd460f$var$global$8.RegExp;
var $5bb7220e37bd460f$var$regexpUnsupportedNcg = $5bb7220e37bd460f$var$fails$9(function() {
    var re = $5bb7220e37bd460f$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var $5bb7220e37bd460f$var$call$6 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$uncurryThis$8 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$toString$2 = $5bb7220e37bd460f$var$toString$5;
var $5bb7220e37bd460f$var$regexpFlags = $5bb7220e37bd460f$var$regexpFlags$1;
var $5bb7220e37bd460f$var$stickyHelpers$1 = $5bb7220e37bd460f$var$regexpStickyHelpers;
var $5bb7220e37bd460f$var$shared = $5bb7220e37bd460f$var$shared$4.exports;
var $5bb7220e37bd460f$var$create$1 = $5bb7220e37bd460f$var$objectCreate;
var $5bb7220e37bd460f$var$getInternalState$3 = $5bb7220e37bd460f$var$internalState.get;
var $5bb7220e37bd460f$var$UNSUPPORTED_DOT_ALL = $5bb7220e37bd460f$var$regexpUnsupportedDotAll;
var $5bb7220e37bd460f$var$UNSUPPORTED_NCG = $5bb7220e37bd460f$var$regexpUnsupportedNcg;
var $5bb7220e37bd460f$var$nativeReplace = $5bb7220e37bd460f$var$shared("native-string-replace", String.prototype.replace);
var $5bb7220e37bd460f$var$nativeExec = RegExp.prototype.exec;
var $5bb7220e37bd460f$var$patchedExec = $5bb7220e37bd460f$var$nativeExec;
var $5bb7220e37bd460f$var$charAt$2 = $5bb7220e37bd460f$var$uncurryThis$8("".charAt);
var $5bb7220e37bd460f$var$indexOf = $5bb7220e37bd460f$var$uncurryThis$8("".indexOf);
var $5bb7220e37bd460f$var$replace = $5bb7220e37bd460f$var$uncurryThis$8("".replace);
var $5bb7220e37bd460f$var$stringSlice$2 = $5bb7220e37bd460f$var$uncurryThis$8("".slice);
var $5bb7220e37bd460f$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $5bb7220e37bd460f$var$call$6($5bb7220e37bd460f$var$nativeExec, re1, "a");
    $5bb7220e37bd460f$var$call$6($5bb7220e37bd460f$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $5bb7220e37bd460f$var$UNSUPPORTED_Y$1 = $5bb7220e37bd460f$var$stickyHelpers$1.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $5bb7220e37bd460f$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $5bb7220e37bd460f$var$PATCH = $5bb7220e37bd460f$var$UPDATES_LAST_INDEX_WRONG || $5bb7220e37bd460f$var$NPCG_INCLUDED || $5bb7220e37bd460f$var$UNSUPPORTED_Y$1 || $5bb7220e37bd460f$var$UNSUPPORTED_DOT_ALL || $5bb7220e37bd460f$var$UNSUPPORTED_NCG;
if ($5bb7220e37bd460f$var$PATCH) $5bb7220e37bd460f$var$patchedExec = function exec(string) {
    var re = this;
    var state = $5bb7220e37bd460f$var$getInternalState$3(re);
    var str = $5bb7220e37bd460f$var$toString$2(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $5bb7220e37bd460f$var$call$6($5bb7220e37bd460f$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $5bb7220e37bd460f$var$UNSUPPORTED_Y$1 && re.sticky;
    var flags = $5bb7220e37bd460f$var$call$6($5bb7220e37bd460f$var$regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $5bb7220e37bd460f$var$replace(flags, "y", "");
        if ($5bb7220e37bd460f$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $5bb7220e37bd460f$var$stringSlice$2(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $5bb7220e37bd460f$var$charAt$2(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($5bb7220e37bd460f$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($5bb7220e37bd460f$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $5bb7220e37bd460f$var$call$6($5bb7220e37bd460f$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $5bb7220e37bd460f$var$stringSlice$2(match.input, charsAdded);
            match[0] = $5bb7220e37bd460f$var$stringSlice$2(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($5bb7220e37bd460f$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($5bb7220e37bd460f$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    $5bb7220e37bd460f$var$call$6($5bb7220e37bd460f$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $5bb7220e37bd460f$var$create$1(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
var $5bb7220e37bd460f$var$regexpExec$3 = $5bb7220e37bd460f$var$patchedExec;
var $5bb7220e37bd460f$var$$$2 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$exec$1 = $5bb7220e37bd460f$var$regexpExec$3;
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$5bb7220e37bd460f$var$$$2({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $5bb7220e37bd460f$var$exec$1
}, {
    exec: $5bb7220e37bd460f$var$exec$1
});
/* eslint-disable no-useless-escape */ // https://github.com/DamonOehlman/detect-browser/blob/master/src/index.ts
const $5bb7220e37bd460f$var$SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
const $5bb7220e37bd460f$var$userAgentRules = [
    [
        "aol",
        /AOLShield\/([0-9\._]+)/
    ],
    [
        "edge",
        /Edge\/([0-9\._]+)/
    ],
    [
        "edge-ios",
        /EdgiOS\/([0-9\._]+)/
    ],
    [
        "yandexbrowser",
        /YaBrowser\/([0-9\._]+)/
    ],
    [
        "kakaotalk",
        /KAKAOTALK\s([0-9\.]+)/
    ],
    [
        "samsung",
        /SamsungBrowser\/([0-9\.]+)/
    ],
    [
        "silk",
        /\bSilk\/([0-9._-]+)\b/
    ],
    [
        "miui",
        /MiuiBrowser\/([0-9\.]+)$/
    ],
    [
        "beaker",
        /BeakerBrowser\/([0-9\.]+)/
    ],
    [
        "edge-chromium",
        /EdgA?\/([0-9\.]+)/
    ],
    [
        "chromium-webview",
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "chrome",
        /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "phantomjs",
        /PhantomJS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "crios",
        /CriOS\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "firefox",
        /Firefox\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "fxios",
        /FxiOS\/([0-9\.]+)/
    ],
    [
        "opera-mini",
        /Opera Mini.*Version\/([0-9\.]+)/
    ],
    [
        "opera",
        /Opera\/([0-9\.]+)(?:\s|$)/
    ],
    [
        "opera",
        /OPR\/([0-9\.]+)(:?\s|$)/
    ],
    [
        "pie",
        /^Microsoft Pocket Internet Explorer\/(\d+\.\d+)$/
    ],
    [
        "pie",
        /^Mozilla\/\d\.\d+\s\(compatible;\s(?:MSP?IE|MSInternet Explorer) (\d+\.\d+);.*Windows CE.*\)$/
    ],
    [
        "netfront",
        /^Mozilla\/\d\.\d+.*NetFront\/(\d.\d)/
    ],
    [
        "ie",
        /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/
    ],
    [
        "ie",
        /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/
    ],
    [
        "ie",
        /MSIE\s(7\.0)/
    ],
    [
        "bb10",
        /BB10;\sTouch.*Version\/([0-9\.]+)/
    ],
    [
        "android",
        /Android\s([0-9\.]+)/
    ],
    [
        "ios",
        /Version\/([0-9\._]+).*Mobile.*Safari.*/
    ],
    [
        "safari",
        /Version\/([0-9\._]+).*Safari/
    ],
    [
        "facebook",
        /FB[AS]V\/([0-9\.]+)/
    ],
    [
        "instagram",
        /Instagram\s([0-9\.]+)/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Mobile/
    ],
    [
        "ios-webview",
        /AppleWebKit\/([0-9\.]+).*Gecko\)$/
    ],
    [
        "curl",
        /^curl\/([0-9\.]+)$/
    ],
    [
        "searchbot",
        $5bb7220e37bd460f$var$SEARCHBOX_UA_REGEX
    ]
];
const $5bb7220e37bd460f$var$matchUserAgent = (ua)=>{
    return ua !== "" && $5bb7220e37bd460f$var$userAgentRules.reduce((matched, [browser, regex])=>{
        if (matched) return matched;
        const uaMatch = regex.exec(ua);
        return !!uaMatch && [
            browser,
            uaMatch
        ];
    }, false);
};
const $5bb7220e37bd460f$export$3ef098392766df13 = (supportedBrowser)=>{
    if (typeof navigator === "undefined") return false;
    const matchedRule = $5bb7220e37bd460f$var$matchUserAgent(navigator.userAgent);
    if (!matchedRule) return false;
    const [name] = matchedRule;
    if (name === "searchbot") return false;
    return !!supportedBrowser.find((item)=>item === name);
};
// eslint-disable-next-line es-x/no-typed-arrays -- safe
var $5bb7220e37bd460f$var$arrayBufferNative = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined";
var $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER$1 = $5bb7220e37bd460f$var$arrayBufferNative;
var $5bb7220e37bd460f$var$DESCRIPTORS$2 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$global$7 = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$isCallable$2 = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$isObject$4 = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$hasOwn$1 = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$classof$4 = $5bb7220e37bd460f$var$classof$9;
var $5bb7220e37bd460f$var$tryToString = $5bb7220e37bd460f$var$tryToString$5;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$3 = $5bb7220e37bd460f$var$createNonEnumerableProperty$8;
var $5bb7220e37bd460f$var$defineBuiltIn$2 = $5bb7220e37bd460f$var$defineBuiltIn$8;
var $5bb7220e37bd460f$var$defineProperty$1 = $5bb7220e37bd460f$var$objectDefineProperty.f;
var $5bb7220e37bd460f$var$isPrototypeOf$1 = $5bb7220e37bd460f$var$objectIsPrototypeOf;
var $5bb7220e37bd460f$var$getPrototypeOf$1 = $5bb7220e37bd460f$var$objectGetPrototypeOf;
var $5bb7220e37bd460f$var$setPrototypeOf$3 = $5bb7220e37bd460f$var$objectSetPrototypeOf;
var $5bb7220e37bd460f$var$wellKnownSymbol$2 = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$uid = $5bb7220e37bd460f$var$uid$3;
var $5bb7220e37bd460f$var$InternalStateModule$2 = $5bb7220e37bd460f$var$internalState;
var $5bb7220e37bd460f$var$enforceInternalState$1 = $5bb7220e37bd460f$var$InternalStateModule$2.enforce;
var $5bb7220e37bd460f$var$getInternalState$2 = $5bb7220e37bd460f$var$InternalStateModule$2.get;
var $5bb7220e37bd460f$var$Int8Array$4 = $5bb7220e37bd460f$var$global$7.Int8Array;
var $5bb7220e37bd460f$var$Int8ArrayPrototype$1 = $5bb7220e37bd460f$var$Int8Array$4 && $5bb7220e37bd460f$var$Int8Array$4.prototype;
var $5bb7220e37bd460f$var$Uint8ClampedArray$1 = $5bb7220e37bd460f$var$global$7.Uint8ClampedArray;
var $5bb7220e37bd460f$var$Uint8ClampedArrayPrototype = $5bb7220e37bd460f$var$Uint8ClampedArray$1 && $5bb7220e37bd460f$var$Uint8ClampedArray$1.prototype;
var $5bb7220e37bd460f$var$TypedArray$1 = $5bb7220e37bd460f$var$Int8Array$4 && $5bb7220e37bd460f$var$getPrototypeOf$1($5bb7220e37bd460f$var$Int8Array$4);
var $5bb7220e37bd460f$var$TypedArrayPrototype$1 = $5bb7220e37bd460f$var$Int8ArrayPrototype$1 && $5bb7220e37bd460f$var$getPrototypeOf$1($5bb7220e37bd460f$var$Int8ArrayPrototype$1);
var $5bb7220e37bd460f$var$ObjectPrototype$1 = Object.prototype;
var $5bb7220e37bd460f$var$TypeError$1 = $5bb7220e37bd460f$var$global$7.TypeError;
var $5bb7220e37bd460f$var$TO_STRING_TAG = $5bb7220e37bd460f$var$wellKnownSymbol$2("toStringTag");
var $5bb7220e37bd460f$var$TYPED_ARRAY_TAG$1 = $5bb7220e37bd460f$var$uid("TYPED_ARRAY_TAG");
var $5bb7220e37bd460f$var$TYPED_ARRAY_CONSTRUCTOR = "TypedArrayConstructor";
// Fixing native typed arrays in Opera Presto crashes the browser, see #595
var $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2 = $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER$1 && !!$5bb7220e37bd460f$var$setPrototypeOf$3 && $5bb7220e37bd460f$var$classof$4($5bb7220e37bd460f$var$global$7.opera) !== "Opera";
var $5bb7220e37bd460f$var$TYPED_ARRAY_TAG_REQUIRED = false;
var $5bb7220e37bd460f$var$NAME, $5bb7220e37bd460f$var$Constructor, $5bb7220e37bd460f$var$Prototype;
var $5bb7220e37bd460f$var$TypedArrayConstructorsList = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
};
var $5bb7220e37bd460f$var$BigIntArrayConstructorsList = {
    BigInt64Array: 8,
    BigUint64Array: 8
};
var $5bb7220e37bd460f$var$isView = function isView(it) {
    if (!$5bb7220e37bd460f$var$isObject$4(it)) return false;
    var klass = $5bb7220e37bd460f$var$classof$4(it);
    return klass === "DataView" || $5bb7220e37bd460f$var$hasOwn$1($5bb7220e37bd460f$var$TypedArrayConstructorsList, klass) || $5bb7220e37bd460f$var$hasOwn$1($5bb7220e37bd460f$var$BigIntArrayConstructorsList, klass);
};
var $5bb7220e37bd460f$var$getTypedArrayConstructor = function(it) {
    var proto = $5bb7220e37bd460f$var$getPrototypeOf$1(it);
    if (!$5bb7220e37bd460f$var$isObject$4(proto)) return;
    var state = $5bb7220e37bd460f$var$getInternalState$2(proto);
    return state && $5bb7220e37bd460f$var$hasOwn$1(state, $5bb7220e37bd460f$var$TYPED_ARRAY_CONSTRUCTOR) ? state[$5bb7220e37bd460f$var$TYPED_ARRAY_CONSTRUCTOR] : $5bb7220e37bd460f$var$getTypedArrayConstructor(proto);
};
var $5bb7220e37bd460f$var$isTypedArray$1 = function(it) {
    if (!$5bb7220e37bd460f$var$isObject$4(it)) return false;
    var klass = $5bb7220e37bd460f$var$classof$4(it);
    return $5bb7220e37bd460f$var$hasOwn$1($5bb7220e37bd460f$var$TypedArrayConstructorsList, klass) || $5bb7220e37bd460f$var$hasOwn$1($5bb7220e37bd460f$var$BigIntArrayConstructorsList, klass);
};
var $5bb7220e37bd460f$var$aTypedArray$4 = function(it) {
    if ($5bb7220e37bd460f$var$isTypedArray$1(it)) return it;
    throw $5bb7220e37bd460f$var$TypeError$1("Target is not a typed array");
};
var $5bb7220e37bd460f$var$aTypedArrayConstructor$2 = function(C) {
    if ($5bb7220e37bd460f$var$isCallable$2(C) && (!$5bb7220e37bd460f$var$setPrototypeOf$3 || $5bb7220e37bd460f$var$isPrototypeOf$1($5bb7220e37bd460f$var$TypedArray$1, C))) return C;
    throw $5bb7220e37bd460f$var$TypeError$1($5bb7220e37bd460f$var$tryToString(C) + " is not a typed array constructor");
};
var $5bb7220e37bd460f$var$exportTypedArrayMethod$4 = function(KEY, property, forced, options) {
    if (!$5bb7220e37bd460f$var$DESCRIPTORS$2) return;
    if (forced) for(var ARRAY in $5bb7220e37bd460f$var$TypedArrayConstructorsList){
        var TypedArrayConstructor = $5bb7220e37bd460f$var$global$7[ARRAY];
        if (TypedArrayConstructor && $5bb7220e37bd460f$var$hasOwn$1(TypedArrayConstructor.prototype, KEY)) try {
            delete TypedArrayConstructor.prototype[KEY];
        } catch (error) {
            // old WebKit bug - some methods are non-configurable
            try {
                TypedArrayConstructor.prototype[KEY] = property;
            } catch (error2) {}
        }
    }
    if (!$5bb7220e37bd460f$var$TypedArrayPrototype$1[KEY] || forced) $5bb7220e37bd460f$var$defineBuiltIn$2($5bb7220e37bd460f$var$TypedArrayPrototype$1, KEY, forced ? property : $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2 && $5bb7220e37bd460f$var$Int8ArrayPrototype$1[KEY] || property, options);
};
var $5bb7220e37bd460f$var$exportTypedArrayStaticMethod$1 = function(KEY, property, forced) {
    var ARRAY, TypedArrayConstructor;
    if (!$5bb7220e37bd460f$var$DESCRIPTORS$2) return;
    if ($5bb7220e37bd460f$var$setPrototypeOf$3) {
        if (forced) for(ARRAY in $5bb7220e37bd460f$var$TypedArrayConstructorsList){
            TypedArrayConstructor = $5bb7220e37bd460f$var$global$7[ARRAY];
            if (TypedArrayConstructor && $5bb7220e37bd460f$var$hasOwn$1(TypedArrayConstructor, KEY)) try {
                delete TypedArrayConstructor[KEY];
            } catch (error) {}
        }
        if (!$5bb7220e37bd460f$var$TypedArray$1[KEY] || forced) // V8 ~ Chrome 49-50 `%TypedArray%` methods are non-writable non-configurable
        try {
            return $5bb7220e37bd460f$var$defineBuiltIn$2($5bb7220e37bd460f$var$TypedArray$1, KEY, forced ? property : $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2 && $5bb7220e37bd460f$var$TypedArray$1[KEY] || property);
        } catch (error) {}
        else return;
    }
    for(ARRAY in $5bb7220e37bd460f$var$TypedArrayConstructorsList){
        TypedArrayConstructor = $5bb7220e37bd460f$var$global$7[ARRAY];
        if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) $5bb7220e37bd460f$var$defineBuiltIn$2(TypedArrayConstructor, KEY, property);
    }
};
for($5bb7220e37bd460f$var$NAME in $5bb7220e37bd460f$var$TypedArrayConstructorsList){
    $5bb7220e37bd460f$var$Constructor = $5bb7220e37bd460f$var$global$7[$5bb7220e37bd460f$var$NAME];
    $5bb7220e37bd460f$var$Prototype = $5bb7220e37bd460f$var$Constructor && $5bb7220e37bd460f$var$Constructor.prototype;
    if ($5bb7220e37bd460f$var$Prototype) $5bb7220e37bd460f$var$enforceInternalState$1($5bb7220e37bd460f$var$Prototype)[$5bb7220e37bd460f$var$TYPED_ARRAY_CONSTRUCTOR] = $5bb7220e37bd460f$var$Constructor;
    else $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2 = false;
}
for($5bb7220e37bd460f$var$NAME in $5bb7220e37bd460f$var$BigIntArrayConstructorsList){
    $5bb7220e37bd460f$var$Constructor = $5bb7220e37bd460f$var$global$7[$5bb7220e37bd460f$var$NAME];
    $5bb7220e37bd460f$var$Prototype = $5bb7220e37bd460f$var$Constructor && $5bb7220e37bd460f$var$Constructor.prototype;
    if ($5bb7220e37bd460f$var$Prototype) $5bb7220e37bd460f$var$enforceInternalState$1($5bb7220e37bd460f$var$Prototype)[$5bb7220e37bd460f$var$TYPED_ARRAY_CONSTRUCTOR] = $5bb7220e37bd460f$var$Constructor;
}
// WebKit bug - typed arrays constructors prototype is Object.prototype
if (!$5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2 || !$5bb7220e37bd460f$var$isCallable$2($5bb7220e37bd460f$var$TypedArray$1) || $5bb7220e37bd460f$var$TypedArray$1 === Function.prototype) {
    // eslint-disable-next-line no-shadow -- safe
    $5bb7220e37bd460f$var$TypedArray$1 = function TypedArray() {
        throw $5bb7220e37bd460f$var$TypeError$1("Incorrect invocation");
    };
    if ($5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2) {
        for($5bb7220e37bd460f$var$NAME in $5bb7220e37bd460f$var$TypedArrayConstructorsList)if ($5bb7220e37bd460f$var$global$7[$5bb7220e37bd460f$var$NAME]) $5bb7220e37bd460f$var$setPrototypeOf$3($5bb7220e37bd460f$var$global$7[$5bb7220e37bd460f$var$NAME], $5bb7220e37bd460f$var$TypedArray$1);
    }
}
if (!$5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2 || !$5bb7220e37bd460f$var$TypedArrayPrototype$1 || $5bb7220e37bd460f$var$TypedArrayPrototype$1 === $5bb7220e37bd460f$var$ObjectPrototype$1) {
    $5bb7220e37bd460f$var$TypedArrayPrototype$1 = $5bb7220e37bd460f$var$TypedArray$1.prototype;
    if ($5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2) {
        for($5bb7220e37bd460f$var$NAME in $5bb7220e37bd460f$var$TypedArrayConstructorsList)if ($5bb7220e37bd460f$var$global$7[$5bb7220e37bd460f$var$NAME]) $5bb7220e37bd460f$var$setPrototypeOf$3($5bb7220e37bd460f$var$global$7[$5bb7220e37bd460f$var$NAME].prototype, $5bb7220e37bd460f$var$TypedArrayPrototype$1);
    }
}
// WebKit bug - one more object in Uint8ClampedArray prototype chain
if ($5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2 && $5bb7220e37bd460f$var$getPrototypeOf$1($5bb7220e37bd460f$var$Uint8ClampedArrayPrototype) !== $5bb7220e37bd460f$var$TypedArrayPrototype$1) $5bb7220e37bd460f$var$setPrototypeOf$3($5bb7220e37bd460f$var$Uint8ClampedArrayPrototype, $5bb7220e37bd460f$var$TypedArrayPrototype$1);
if ($5bb7220e37bd460f$var$DESCRIPTORS$2 && !$5bb7220e37bd460f$var$hasOwn$1($5bb7220e37bd460f$var$TypedArrayPrototype$1, $5bb7220e37bd460f$var$TO_STRING_TAG)) {
    $5bb7220e37bd460f$var$TYPED_ARRAY_TAG_REQUIRED = true;
    $5bb7220e37bd460f$var$defineProperty$1($5bb7220e37bd460f$var$TypedArrayPrototype$1, $5bb7220e37bd460f$var$TO_STRING_TAG, {
        get: function() {
            return $5bb7220e37bd460f$var$isObject$4(this) ? this[$5bb7220e37bd460f$var$TYPED_ARRAY_TAG$1] : undefined;
        }
    });
    for($5bb7220e37bd460f$var$NAME in $5bb7220e37bd460f$var$TypedArrayConstructorsList)if ($5bb7220e37bd460f$var$global$7[$5bb7220e37bd460f$var$NAME]) $5bb7220e37bd460f$var$createNonEnumerableProperty$3($5bb7220e37bd460f$var$global$7[$5bb7220e37bd460f$var$NAME], $5bb7220e37bd460f$var$TYPED_ARRAY_TAG$1, $5bb7220e37bd460f$var$NAME);
}
var $5bb7220e37bd460f$var$arrayBufferViewCore = {
    NATIVE_ARRAY_BUFFER_VIEWS: $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$2,
    TYPED_ARRAY_TAG: $5bb7220e37bd460f$var$TYPED_ARRAY_TAG_REQUIRED && $5bb7220e37bd460f$var$TYPED_ARRAY_TAG$1,
    aTypedArray: $5bb7220e37bd460f$var$aTypedArray$4,
    aTypedArrayConstructor: $5bb7220e37bd460f$var$aTypedArrayConstructor$2,
    exportTypedArrayMethod: $5bb7220e37bd460f$var$exportTypedArrayMethod$4,
    exportTypedArrayStaticMethod: $5bb7220e37bd460f$var$exportTypedArrayStaticMethod$1,
    getTypedArrayConstructor: $5bb7220e37bd460f$var$getTypedArrayConstructor,
    isView: $5bb7220e37bd460f$var$isView,
    isTypedArray: $5bb7220e37bd460f$var$isTypedArray$1,
    TypedArray: $5bb7220e37bd460f$var$TypedArray$1,
    TypedArrayPrototype: $5bb7220e37bd460f$var$TypedArrayPrototype$1
};
/* eslint-disable no-new -- required for testing */ var $5bb7220e37bd460f$var$global$6 = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$fails$8 = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$checkCorrectnessOfIteration = $5bb7220e37bd460f$var$checkCorrectnessOfIteration$2;
var $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$1 = $5bb7220e37bd460f$var$arrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS;
var $5bb7220e37bd460f$var$ArrayBuffer$3 = $5bb7220e37bd460f$var$global$6.ArrayBuffer;
var $5bb7220e37bd460f$var$Int8Array$3 = $5bb7220e37bd460f$var$global$6.Int8Array;
var $5bb7220e37bd460f$var$typedArrayConstructorsRequireWrappers = !$5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS$1 || !$5bb7220e37bd460f$var$fails$8(function() {
    $5bb7220e37bd460f$var$Int8Array$3(1);
}) || !$5bb7220e37bd460f$var$fails$8(function() {
    new $5bb7220e37bd460f$var$Int8Array$3(-1);
}) || !$5bb7220e37bd460f$var$checkCorrectnessOfIteration(function(iterable) {
    new $5bb7220e37bd460f$var$Int8Array$3();
    new $5bb7220e37bd460f$var$Int8Array$3(null);
    new $5bb7220e37bd460f$var$Int8Array$3(1.5);
    new $5bb7220e37bd460f$var$Int8Array$3(iterable);
}, true) || $5bb7220e37bd460f$var$fails$8(function() {
    // Safari (11+) bug - a reason why even Safari 13 should load a typed array polyfill
    return new $5bb7220e37bd460f$var$Int8Array$3(new $5bb7220e37bd460f$var$ArrayBuffer$3(2), 1, undefined).length !== 1;
});
var $5bb7220e37bd460f$var$bind$1 = $5bb7220e37bd460f$var$functionBindContext;
var $5bb7220e37bd460f$var$call$5 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$aConstructor = $5bb7220e37bd460f$var$aConstructor$2;
var $5bb7220e37bd460f$var$toObject$2 = $5bb7220e37bd460f$var$toObject$7;
var $5bb7220e37bd460f$var$lengthOfArrayLike$4 = $5bb7220e37bd460f$var$lengthOfArrayLike$8;
var $5bb7220e37bd460f$var$getIterator = $5bb7220e37bd460f$var$getIterator$2;
var $5bb7220e37bd460f$var$getIteratorMethod = $5bb7220e37bd460f$var$getIteratorMethod$3;
var $5bb7220e37bd460f$var$isArrayIteratorMethod = $5bb7220e37bd460f$var$isArrayIteratorMethod$2;
var $5bb7220e37bd460f$var$aTypedArrayConstructor$1 = $5bb7220e37bd460f$var$arrayBufferViewCore.aTypedArrayConstructor;
var $5bb7220e37bd460f$var$typedArrayFrom$2 = function from(source /* , mapfn, thisArg */ ) {
    var C = $5bb7220e37bd460f$var$aConstructor(this);
    var O = $5bb7220e37bd460f$var$toObject$2(source);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iteratorMethod = $5bb7220e37bd460f$var$getIteratorMethod(O);
    var i, length, result, step, iterator, next;
    if (iteratorMethod && !$5bb7220e37bd460f$var$isArrayIteratorMethod(iteratorMethod)) {
        iterator = $5bb7220e37bd460f$var$getIterator(O, iteratorMethod);
        next = iterator.next;
        O = [];
        while(!(step = $5bb7220e37bd460f$var$call$5(next, iterator)).done)O.push(step.value);
    }
    if (mapping && argumentsLength > 2) mapfn = $5bb7220e37bd460f$var$bind$1(mapfn, arguments[2]);
    length = $5bb7220e37bd460f$var$lengthOfArrayLike$4(O);
    result = new ($5bb7220e37bd460f$var$aTypedArrayConstructor$1(C))(length);
    for(i = 0; length > i; i++)result[i] = mapping ? mapfn(O[i], i) : O[i];
    return result;
};
var $5bb7220e37bd460f$var$TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS$1 = $5bb7220e37bd460f$var$typedArrayConstructorsRequireWrappers;
var $5bb7220e37bd460f$var$exportTypedArrayStaticMethod = $5bb7220e37bd460f$var$arrayBufferViewCore.exportTypedArrayStaticMethod;
var $5bb7220e37bd460f$var$typedArrayFrom$1 = $5bb7220e37bd460f$var$typedArrayFrom$2;
// `%TypedArray%.from` method
// https://tc39.es/ecma262/#sec-%typedarray%.from
$5bb7220e37bd460f$var$exportTypedArrayStaticMethod("from", $5bb7220e37bd460f$var$typedArrayFrom$1, $5bb7220e37bd460f$var$TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS$1);
var $5bb7220e37bd460f$var$defineBuiltIn$1 = $5bb7220e37bd460f$var$defineBuiltIn$8;
var $5bb7220e37bd460f$var$defineBuiltIns$1 = function(target, src, options) {
    for(var key in src)$5bb7220e37bd460f$var$defineBuiltIn$1(target, key, src[key], options);
    return target;
};
var $5bb7220e37bd460f$var$toIntegerOrInfinity$3 = $5bb7220e37bd460f$var$toIntegerOrInfinity$6;
var $5bb7220e37bd460f$var$toLength$4 = $5bb7220e37bd460f$var$toLength$6;
var $5bb7220e37bd460f$var$$RangeError$2 = RangeError;
// `ToIndex` abstract operation
// https://tc39.es/ecma262/#sec-toindex
var $5bb7220e37bd460f$var$toIndex$2 = function(it) {
    if (it === undefined) return 0;
    var number = $5bb7220e37bd460f$var$toIntegerOrInfinity$3(it);
    var length = $5bb7220e37bd460f$var$toLength$4(number);
    if (number !== length) throw $5bb7220e37bd460f$var$$RangeError$2("Wrong length or index");
    return length;
};
// IEEE754 conversions based on https://github.com/feross/ieee754
var $5bb7220e37bd460f$var$$Array$2 = Array;
var $5bb7220e37bd460f$var$abs = Math.abs;
var $5bb7220e37bd460f$var$pow = Math.pow;
var $5bb7220e37bd460f$var$floor$2 = Math.floor;
var $5bb7220e37bd460f$var$log = Math.log;
var $5bb7220e37bd460f$var$LN2 = Math.LN2;
var $5bb7220e37bd460f$var$pack = function(number, mantissaLength, bytes) {
    var buffer = $5bb7220e37bd460f$var$$Array$2(bytes);
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var rt = mantissaLength === 23 ? $5bb7220e37bd460f$var$pow(2, -24) - $5bb7220e37bd460f$var$pow(2, -77) : 0;
    var sign = number < 0 || number === 0 && 1 / number < 0 ? 1 : 0;
    var index = 0;
    var exponent, mantissa, c;
    number = $5bb7220e37bd460f$var$abs(number);
    // eslint-disable-next-line no-self-compare -- NaN check
    if (number != number || number === Infinity) {
        // eslint-disable-next-line no-self-compare -- NaN check
        mantissa = number != number ? 1 : 0;
        exponent = eMax;
    } else {
        exponent = $5bb7220e37bd460f$var$floor$2($5bb7220e37bd460f$var$log(number) / $5bb7220e37bd460f$var$LN2);
        c = $5bb7220e37bd460f$var$pow(2, -exponent);
        if (number * c < 1) {
            exponent--;
            c *= 2;
        }
        if (exponent + eBias >= 1) number += rt / c;
        else number += rt * $5bb7220e37bd460f$var$pow(2, 1 - eBias);
        if (number * c >= 2) {
            exponent++;
            c /= 2;
        }
        if (exponent + eBias >= eMax) {
            mantissa = 0;
            exponent = eMax;
        } else if (exponent + eBias >= 1) {
            mantissa = (number * c - 1) * $5bb7220e37bd460f$var$pow(2, mantissaLength);
            exponent = exponent + eBias;
        } else {
            mantissa = number * $5bb7220e37bd460f$var$pow(2, eBias - 1) * $5bb7220e37bd460f$var$pow(2, mantissaLength);
            exponent = 0;
        }
    }
    while(mantissaLength >= 8){
        buffer[index++] = mantissa & 255;
        mantissa /= 256;
        mantissaLength -= 8;
    }
    exponent = exponent << mantissaLength | mantissa;
    exponentLength += mantissaLength;
    while(exponentLength > 0){
        buffer[index++] = exponent & 255;
        exponent /= 256;
        exponentLength -= 8;
    }
    buffer[--index] |= sign * 128;
    return buffer;
};
var $5bb7220e37bd460f$var$unpack = function(buffer, mantissaLength) {
    var bytes = buffer.length;
    var exponentLength = bytes * 8 - mantissaLength - 1;
    var eMax = (1 << exponentLength) - 1;
    var eBias = eMax >> 1;
    var nBits = exponentLength - 7;
    var index = bytes - 1;
    var sign = buffer[index--];
    var exponent = sign & 127;
    var mantissa;
    sign >>= 7;
    while(nBits > 0){
        exponent = exponent * 256 + buffer[index--];
        nBits -= 8;
    }
    mantissa = exponent & (1 << -nBits) - 1;
    exponent >>= -nBits;
    nBits += mantissaLength;
    while(nBits > 0){
        mantissa = mantissa * 256 + buffer[index--];
        nBits -= 8;
    }
    if (exponent === 0) exponent = 1 - eBias;
    else if (exponent === eMax) return mantissa ? NaN : sign ? -Infinity : Infinity;
    else {
        mantissa = mantissa + $5bb7220e37bd460f$var$pow(2, mantissaLength);
        exponent = exponent - eBias;
    }
    return (sign ? -1 : 1) * mantissa * $5bb7220e37bd460f$var$pow(2, exponent - mantissaLength);
};
var $5bb7220e37bd460f$var$ieee754 = {
    pack: $5bb7220e37bd460f$var$pack,
    unpack: $5bb7220e37bd460f$var$unpack
};
var $5bb7220e37bd460f$var$toObject$1 = $5bb7220e37bd460f$var$toObject$7;
var $5bb7220e37bd460f$var$toAbsoluteIndex$2 = $5bb7220e37bd460f$var$toAbsoluteIndex$4;
var $5bb7220e37bd460f$var$lengthOfArrayLike$3 = $5bb7220e37bd460f$var$lengthOfArrayLike$8;
// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var $5bb7220e37bd460f$var$arrayFill$1 = function fill(value /* , start = 0, end = @length */ ) {
    var O = $5bb7220e37bd460f$var$toObject$1(this);
    var length = $5bb7220e37bd460f$var$lengthOfArrayLike$3(O);
    var argumentsLength = arguments.length;
    var index = $5bb7220e37bd460f$var$toAbsoluteIndex$2(argumentsLength > 1 ? arguments[1] : undefined, length);
    var end = argumentsLength > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $5bb7220e37bd460f$var$toAbsoluteIndex$2(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};
var $5bb7220e37bd460f$var$toPropertyKey$1 = $5bb7220e37bd460f$var$toPropertyKey$4;
var $5bb7220e37bd460f$var$definePropertyModule$1 = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$createPropertyDescriptor$1 = $5bb7220e37bd460f$var$createPropertyDescriptor$5;
var $5bb7220e37bd460f$var$createProperty$1 = function(object, key, value) {
    var propertyKey = $5bb7220e37bd460f$var$toPropertyKey$1(key);
    if (propertyKey in object) $5bb7220e37bd460f$var$definePropertyModule$1.f(object, propertyKey, $5bb7220e37bd460f$var$createPropertyDescriptor$1(0, value));
    else object[propertyKey] = value;
};
var $5bb7220e37bd460f$var$toAbsoluteIndex$1 = $5bb7220e37bd460f$var$toAbsoluteIndex$4;
var $5bb7220e37bd460f$var$lengthOfArrayLike$2 = $5bb7220e37bd460f$var$lengthOfArrayLike$8;
var $5bb7220e37bd460f$var$createProperty = $5bb7220e37bd460f$var$createProperty$1;
var $5bb7220e37bd460f$var$$Array$1 = Array;
var $5bb7220e37bd460f$var$max = Math.max;
var $5bb7220e37bd460f$var$arraySliceSimple = function(O, start, end) {
    var length = $5bb7220e37bd460f$var$lengthOfArrayLike$2(O);
    var k = $5bb7220e37bd460f$var$toAbsoluteIndex$1(start, length);
    var fin = $5bb7220e37bd460f$var$toAbsoluteIndex$1(end === undefined ? length : end, length);
    var result = $5bb7220e37bd460f$var$$Array$1($5bb7220e37bd460f$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$5bb7220e37bd460f$var$createProperty(result, n, O[k]);
    result.length = n;
    return result;
};
var $5bb7220e37bd460f$var$global$5 = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$uncurryThis$7 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$DESCRIPTORS$1 = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER = $5bb7220e37bd460f$var$arrayBufferNative;
var $5bb7220e37bd460f$var$FunctionName = $5bb7220e37bd460f$var$functionName;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$2 = $5bb7220e37bd460f$var$createNonEnumerableProperty$8;
var $5bb7220e37bd460f$var$defineBuiltIns = $5bb7220e37bd460f$var$defineBuiltIns$1;
var $5bb7220e37bd460f$var$fails$7 = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$anInstance$1 = $5bb7220e37bd460f$var$anInstance$3;
var $5bb7220e37bd460f$var$toIntegerOrInfinity$2 = $5bb7220e37bd460f$var$toIntegerOrInfinity$6;
var $5bb7220e37bd460f$var$toLength$3 = $5bb7220e37bd460f$var$toLength$6;
var $5bb7220e37bd460f$var$toIndex$1 = $5bb7220e37bd460f$var$toIndex$2;
var $5bb7220e37bd460f$var$IEEE754 = $5bb7220e37bd460f$var$ieee754;
var $5bb7220e37bd460f$var$getPrototypeOf = $5bb7220e37bd460f$var$objectGetPrototypeOf;
var $5bb7220e37bd460f$var$setPrototypeOf$2 = $5bb7220e37bd460f$var$objectSetPrototypeOf;
var $5bb7220e37bd460f$var$getOwnPropertyNames$1 = $5bb7220e37bd460f$var$objectGetOwnPropertyNames.f;
var $5bb7220e37bd460f$var$defineProperty = $5bb7220e37bd460f$var$objectDefineProperty.f;
var $5bb7220e37bd460f$var$arrayFill = $5bb7220e37bd460f$var$arrayFill$1;
var $5bb7220e37bd460f$var$arraySlice$3 = $5bb7220e37bd460f$var$arraySliceSimple;
var $5bb7220e37bd460f$var$setToStringTag = $5bb7220e37bd460f$var$setToStringTag$4;
var $5bb7220e37bd460f$var$InternalStateModule$1 = $5bb7220e37bd460f$var$internalState;
var $5bb7220e37bd460f$var$PROPER_FUNCTION_NAME = $5bb7220e37bd460f$var$FunctionName.PROPER;
var $5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME = $5bb7220e37bd460f$var$FunctionName.CONFIGURABLE;
var $5bb7220e37bd460f$var$getInternalState$1 = $5bb7220e37bd460f$var$InternalStateModule$1.get;
var $5bb7220e37bd460f$var$setInternalState$1 = $5bb7220e37bd460f$var$InternalStateModule$1.set;
var $5bb7220e37bd460f$var$ARRAY_BUFFER = "ArrayBuffer";
var $5bb7220e37bd460f$var$DATA_VIEW = "DataView";
var $5bb7220e37bd460f$var$PROTOTYPE = "prototype";
var $5bb7220e37bd460f$var$WRONG_LENGTH$1 = "Wrong length";
var $5bb7220e37bd460f$var$WRONG_INDEX = "Wrong index";
var $5bb7220e37bd460f$var$NativeArrayBuffer = $5bb7220e37bd460f$var$global$5[$5bb7220e37bd460f$var$ARRAY_BUFFER];
var $5bb7220e37bd460f$var$$ArrayBuffer = $5bb7220e37bd460f$var$NativeArrayBuffer;
var $5bb7220e37bd460f$var$ArrayBufferPrototype$1 = $5bb7220e37bd460f$var$$ArrayBuffer && $5bb7220e37bd460f$var$$ArrayBuffer[$5bb7220e37bd460f$var$PROTOTYPE];
var $5bb7220e37bd460f$var$$DataView = $5bb7220e37bd460f$var$global$5[$5bb7220e37bd460f$var$DATA_VIEW];
var $5bb7220e37bd460f$var$DataViewPrototype$1 = $5bb7220e37bd460f$var$$DataView && $5bb7220e37bd460f$var$$DataView[$5bb7220e37bd460f$var$PROTOTYPE];
var $5bb7220e37bd460f$var$ObjectPrototype = Object.prototype;
var $5bb7220e37bd460f$var$Array$1 = $5bb7220e37bd460f$var$global$5.Array;
var $5bb7220e37bd460f$var$RangeError$3 = $5bb7220e37bd460f$var$global$5.RangeError;
var $5bb7220e37bd460f$var$fill = $5bb7220e37bd460f$var$uncurryThis$7($5bb7220e37bd460f$var$arrayFill);
var $5bb7220e37bd460f$var$reverse = $5bb7220e37bd460f$var$uncurryThis$7([].reverse);
var $5bb7220e37bd460f$var$packIEEE754 = $5bb7220e37bd460f$var$IEEE754.pack;
var $5bb7220e37bd460f$var$unpackIEEE754 = $5bb7220e37bd460f$var$IEEE754.unpack;
var $5bb7220e37bd460f$var$packInt8 = function(number) {
    return [
        number & 0xFF
    ];
};
var $5bb7220e37bd460f$var$packInt16 = function(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF
    ];
};
var $5bb7220e37bd460f$var$packInt32 = function(number) {
    return [
        number & 0xFF,
        number >> 8 & 0xFF,
        number >> 16 & 0xFF,
        number >> 24 & 0xFF
    ];
};
var $5bb7220e37bd460f$var$unpackInt32 = function(buffer) {
    return buffer[3] << 24 | buffer[2] << 16 | buffer[1] << 8 | buffer[0];
};
var $5bb7220e37bd460f$var$packFloat32 = function(number) {
    return $5bb7220e37bd460f$var$packIEEE754(number, 23, 4);
};
var $5bb7220e37bd460f$var$packFloat64 = function(number) {
    return $5bb7220e37bd460f$var$packIEEE754(number, 52, 8);
};
var $5bb7220e37bd460f$var$addGetter$1 = function(Constructor, key) {
    $5bb7220e37bd460f$var$defineProperty(Constructor[$5bb7220e37bd460f$var$PROTOTYPE], key, {
        get: function() {
            return $5bb7220e37bd460f$var$getInternalState$1(this)[key];
        }
    });
};
var $5bb7220e37bd460f$var$get = function(view, count, index, isLittleEndian) {
    var intIndex = $5bb7220e37bd460f$var$toIndex$1(index);
    var store = $5bb7220e37bd460f$var$getInternalState$1(view);
    if (intIndex + count > store.byteLength) throw $5bb7220e37bd460f$var$RangeError$3($5bb7220e37bd460f$var$WRONG_INDEX);
    var bytes = $5bb7220e37bd460f$var$getInternalState$1(store.buffer).bytes;
    var start = intIndex + store.byteOffset;
    var pack = $5bb7220e37bd460f$var$arraySlice$3(bytes, start, start + count);
    return isLittleEndian ? pack : $5bb7220e37bd460f$var$reverse(pack);
};
var $5bb7220e37bd460f$var$set = function(view, count, index, conversion, value, isLittleEndian) {
    var intIndex = $5bb7220e37bd460f$var$toIndex$1(index);
    var store = $5bb7220e37bd460f$var$getInternalState$1(view);
    if (intIndex + count > store.byteLength) throw $5bb7220e37bd460f$var$RangeError$3($5bb7220e37bd460f$var$WRONG_INDEX);
    var bytes = $5bb7220e37bd460f$var$getInternalState$1(store.buffer).bytes;
    var start = intIndex + store.byteOffset;
    var pack = conversion(+value);
    for(var i = 0; i < count; i++)bytes[start + i] = pack[isLittleEndian ? i : count - i - 1];
};
if (!$5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER) {
    $5bb7220e37bd460f$var$$ArrayBuffer = function ArrayBuffer1(length) {
        $5bb7220e37bd460f$var$anInstance$1(this, $5bb7220e37bd460f$var$ArrayBufferPrototype$1);
        var byteLength = $5bb7220e37bd460f$var$toIndex$1(length);
        $5bb7220e37bd460f$var$setInternalState$1(this, {
            bytes: $5bb7220e37bd460f$var$fill($5bb7220e37bd460f$var$Array$1(byteLength), 0),
            byteLength: byteLength
        });
        if (!$5bb7220e37bd460f$var$DESCRIPTORS$1) this.byteLength = byteLength;
    };
    $5bb7220e37bd460f$var$ArrayBufferPrototype$1 = $5bb7220e37bd460f$var$$ArrayBuffer[$5bb7220e37bd460f$var$PROTOTYPE];
    $5bb7220e37bd460f$var$$DataView = function DataView1(buffer, byteOffset, byteLength) {
        $5bb7220e37bd460f$var$anInstance$1(this, $5bb7220e37bd460f$var$DataViewPrototype$1);
        $5bb7220e37bd460f$var$anInstance$1(buffer, $5bb7220e37bd460f$var$ArrayBufferPrototype$1);
        var bufferLength = $5bb7220e37bd460f$var$getInternalState$1(buffer).byteLength;
        var offset = $5bb7220e37bd460f$var$toIntegerOrInfinity$2(byteOffset);
        if (offset < 0 || offset > bufferLength) throw $5bb7220e37bd460f$var$RangeError$3("Wrong offset");
        byteLength = byteLength === undefined ? bufferLength - offset : $5bb7220e37bd460f$var$toLength$3(byteLength);
        if (offset + byteLength > bufferLength) throw $5bb7220e37bd460f$var$RangeError$3($5bb7220e37bd460f$var$WRONG_LENGTH$1);
        $5bb7220e37bd460f$var$setInternalState$1(this, {
            buffer: buffer,
            byteLength: byteLength,
            byteOffset: offset
        });
        if (!$5bb7220e37bd460f$var$DESCRIPTORS$1) {
            this.buffer = buffer;
            this.byteLength = byteLength;
            this.byteOffset = offset;
        }
    };
    $5bb7220e37bd460f$var$DataViewPrototype$1 = $5bb7220e37bd460f$var$$DataView[$5bb7220e37bd460f$var$PROTOTYPE];
    if ($5bb7220e37bd460f$var$DESCRIPTORS$1) {
        $5bb7220e37bd460f$var$addGetter$1($5bb7220e37bd460f$var$$ArrayBuffer, "byteLength");
        $5bb7220e37bd460f$var$addGetter$1($5bb7220e37bd460f$var$$DataView, "buffer");
        $5bb7220e37bd460f$var$addGetter$1($5bb7220e37bd460f$var$$DataView, "byteLength");
        $5bb7220e37bd460f$var$addGetter$1($5bb7220e37bd460f$var$$DataView, "byteOffset");
    }
    $5bb7220e37bd460f$var$defineBuiltIns($5bb7220e37bd460f$var$DataViewPrototype$1, {
        getInt8: function getInt8(byteOffset) {
            return $5bb7220e37bd460f$var$get(this, 1, byteOffset)[0] << 24 >> 24;
        },
        getUint8: function getUint8(byteOffset) {
            return $5bb7220e37bd460f$var$get(this, 1, byteOffset)[0];
        },
        getInt16: function getInt16(byteOffset /* , littleEndian */ ) {
            var bytes = $5bb7220e37bd460f$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
            return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
        },
        getUint16: function getUint16(byteOffset /* , littleEndian */ ) {
            var bytes = $5bb7220e37bd460f$var$get(this, 2, byteOffset, arguments.length > 1 ? arguments[1] : undefined);
            return bytes[1] << 8 | bytes[0];
        },
        getInt32: function getInt32(byteOffset /* , littleEndian */ ) {
            return $5bb7220e37bd460f$var$unpackInt32($5bb7220e37bd460f$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined));
        },
        getUint32: function getUint32(byteOffset /* , littleEndian */ ) {
            return $5bb7220e37bd460f$var$unpackInt32($5bb7220e37bd460f$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined)) >>> 0;
        },
        getFloat32: function getFloat32(byteOffset /* , littleEndian */ ) {
            return $5bb7220e37bd460f$var$unpackIEEE754($5bb7220e37bd460f$var$get(this, 4, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 23);
        },
        getFloat64: function getFloat64(byteOffset /* , littleEndian */ ) {
            return $5bb7220e37bd460f$var$unpackIEEE754($5bb7220e37bd460f$var$get(this, 8, byteOffset, arguments.length > 1 ? arguments[1] : undefined), 52);
        },
        setInt8: function setInt8(byteOffset, value) {
            $5bb7220e37bd460f$var$set(this, 1, byteOffset, $5bb7220e37bd460f$var$packInt8, value);
        },
        setUint8: function setUint8(byteOffset, value) {
            $5bb7220e37bd460f$var$set(this, 1, byteOffset, $5bb7220e37bd460f$var$packInt8, value);
        },
        setInt16: function setInt16(byteOffset, value /* , littleEndian */ ) {
            $5bb7220e37bd460f$var$set(this, 2, byteOffset, $5bb7220e37bd460f$var$packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setUint16: function setUint16(byteOffset, value /* , littleEndian */ ) {
            $5bb7220e37bd460f$var$set(this, 2, byteOffset, $5bb7220e37bd460f$var$packInt16, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setInt32: function setInt32(byteOffset, value /* , littleEndian */ ) {
            $5bb7220e37bd460f$var$set(this, 4, byteOffset, $5bb7220e37bd460f$var$packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setUint32: function setUint32(byteOffset, value /* , littleEndian */ ) {
            $5bb7220e37bd460f$var$set(this, 4, byteOffset, $5bb7220e37bd460f$var$packInt32, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setFloat32: function setFloat32(byteOffset, value /* , littleEndian */ ) {
            $5bb7220e37bd460f$var$set(this, 4, byteOffset, $5bb7220e37bd460f$var$packFloat32, value, arguments.length > 2 ? arguments[2] : undefined);
        },
        setFloat64: function setFloat64(byteOffset, value /* , littleEndian */ ) {
            $5bb7220e37bd460f$var$set(this, 8, byteOffset, $5bb7220e37bd460f$var$packFloat64, value, arguments.length > 2 ? arguments[2] : undefined);
        }
    });
} else {
    var $5bb7220e37bd460f$var$INCORRECT_ARRAY_BUFFER_NAME = $5bb7220e37bd460f$var$PROPER_FUNCTION_NAME && $5bb7220e37bd460f$var$NativeArrayBuffer.name !== $5bb7220e37bd460f$var$ARRAY_BUFFER;
    /* eslint-disable no-new -- required for testing */ if (!$5bb7220e37bd460f$var$fails$7(function() {
        $5bb7220e37bd460f$var$NativeArrayBuffer(1);
    }) || !$5bb7220e37bd460f$var$fails$7(function() {
        new $5bb7220e37bd460f$var$NativeArrayBuffer(-1);
    }) || $5bb7220e37bd460f$var$fails$7(function() {
        new $5bb7220e37bd460f$var$NativeArrayBuffer();
        new $5bb7220e37bd460f$var$NativeArrayBuffer(1.5);
        new $5bb7220e37bd460f$var$NativeArrayBuffer(NaN);
        return $5bb7220e37bd460f$var$INCORRECT_ARRAY_BUFFER_NAME && !$5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME;
    })) {
        /* eslint-enable no-new -- required for testing */ $5bb7220e37bd460f$var$$ArrayBuffer = function ArrayBuffer1(length) {
            $5bb7220e37bd460f$var$anInstance$1(this, $5bb7220e37bd460f$var$ArrayBufferPrototype$1);
            return new $5bb7220e37bd460f$var$NativeArrayBuffer($5bb7220e37bd460f$var$toIndex$1(length));
        };
        $5bb7220e37bd460f$var$$ArrayBuffer[$5bb7220e37bd460f$var$PROTOTYPE] = $5bb7220e37bd460f$var$ArrayBufferPrototype$1;
        for(var $5bb7220e37bd460f$var$keys = $5bb7220e37bd460f$var$getOwnPropertyNames$1($5bb7220e37bd460f$var$NativeArrayBuffer), $5bb7220e37bd460f$var$j = 0, $5bb7220e37bd460f$var$key; $5bb7220e37bd460f$var$keys.length > $5bb7220e37bd460f$var$j;)if (!(($5bb7220e37bd460f$var$key = $5bb7220e37bd460f$var$keys[$5bb7220e37bd460f$var$j++]) in $5bb7220e37bd460f$var$$ArrayBuffer)) $5bb7220e37bd460f$var$createNonEnumerableProperty$2($5bb7220e37bd460f$var$$ArrayBuffer, $5bb7220e37bd460f$var$key, $5bb7220e37bd460f$var$NativeArrayBuffer[$5bb7220e37bd460f$var$key]);
        $5bb7220e37bd460f$var$ArrayBufferPrototype$1.constructor = $5bb7220e37bd460f$var$$ArrayBuffer;
    } else if ($5bb7220e37bd460f$var$INCORRECT_ARRAY_BUFFER_NAME && $5bb7220e37bd460f$var$CONFIGURABLE_FUNCTION_NAME) $5bb7220e37bd460f$var$createNonEnumerableProperty$2($5bb7220e37bd460f$var$NativeArrayBuffer, "name", $5bb7220e37bd460f$var$ARRAY_BUFFER);
    // WebKit bug - the same parent prototype for typed arrays and data view
    if ($5bb7220e37bd460f$var$setPrototypeOf$2 && $5bb7220e37bd460f$var$getPrototypeOf($5bb7220e37bd460f$var$DataViewPrototype$1) !== $5bb7220e37bd460f$var$ObjectPrototype) $5bb7220e37bd460f$var$setPrototypeOf$2($5bb7220e37bd460f$var$DataViewPrototype$1, $5bb7220e37bd460f$var$ObjectPrototype);
    // iOS Safari 7.x bug
    var $5bb7220e37bd460f$var$testView = new $5bb7220e37bd460f$var$$DataView(new $5bb7220e37bd460f$var$$ArrayBuffer(2));
    var $5bb7220e37bd460f$var$$setInt8 = $5bb7220e37bd460f$var$uncurryThis$7($5bb7220e37bd460f$var$DataViewPrototype$1.setInt8);
    $5bb7220e37bd460f$var$testView.setInt8(0, 2147483648);
    $5bb7220e37bd460f$var$testView.setInt8(1, 2147483649);
    if ($5bb7220e37bd460f$var$testView.getInt8(0) || !$5bb7220e37bd460f$var$testView.getInt8(1)) $5bb7220e37bd460f$var$defineBuiltIns($5bb7220e37bd460f$var$DataViewPrototype$1, {
        setInt8: function setInt8(byteOffset, value) {
            $5bb7220e37bd460f$var$$setInt8(this, byteOffset, value << 24 >> 24);
        },
        setUint8: function setUint8(byteOffset, value) {
            $5bb7220e37bd460f$var$$setInt8(this, byteOffset, value << 24 >> 24);
        }
    }, {
        unsafe: true
    });
}
$5bb7220e37bd460f$var$setToStringTag($5bb7220e37bd460f$var$$ArrayBuffer, $5bb7220e37bd460f$var$ARRAY_BUFFER);
$5bb7220e37bd460f$var$setToStringTag($5bb7220e37bd460f$var$$DataView, $5bb7220e37bd460f$var$DATA_VIEW);
var $5bb7220e37bd460f$var$arrayBuffer = {
    ArrayBuffer: $5bb7220e37bd460f$var$$ArrayBuffer,
    DataView: $5bb7220e37bd460f$var$$DataView
};
var $5bb7220e37bd460f$var$$$1 = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$uncurryThis$6 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$fails$6 = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$ArrayBufferModule$1 = $5bb7220e37bd460f$var$arrayBuffer;
var $5bb7220e37bd460f$var$anObject$2 = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$toAbsoluteIndex = $5bb7220e37bd460f$var$toAbsoluteIndex$4;
var $5bb7220e37bd460f$var$toLength$2 = $5bb7220e37bd460f$var$toLength$6;
var $5bb7220e37bd460f$var$speciesConstructor$1 = $5bb7220e37bd460f$var$speciesConstructor$3;
var $5bb7220e37bd460f$var$ArrayBuffer$2 = $5bb7220e37bd460f$var$ArrayBufferModule$1.ArrayBuffer;
var $5bb7220e37bd460f$var$DataView$2 = $5bb7220e37bd460f$var$ArrayBufferModule$1.DataView;
var $5bb7220e37bd460f$var$DataViewPrototype = $5bb7220e37bd460f$var$DataView$2.prototype;
var $5bb7220e37bd460f$var$un$ArrayBufferSlice = $5bb7220e37bd460f$var$uncurryThis$6($5bb7220e37bd460f$var$ArrayBuffer$2.prototype.slice);
var $5bb7220e37bd460f$var$getUint8 = $5bb7220e37bd460f$var$uncurryThis$6($5bb7220e37bd460f$var$DataViewPrototype.getUint8);
var $5bb7220e37bd460f$var$setUint8 = $5bb7220e37bd460f$var$uncurryThis$6($5bb7220e37bd460f$var$DataViewPrototype.setUint8);
var $5bb7220e37bd460f$var$INCORRECT_SLICE = $5bb7220e37bd460f$var$fails$6(function() {
    return !new $5bb7220e37bd460f$var$ArrayBuffer$2(2).slice(1, undefined).byteLength;
});
// `ArrayBuffer.prototype.slice` method
// https://tc39.es/ecma262/#sec-arraybuffer.prototype.slice
$5bb7220e37bd460f$var$$$1({
    target: "ArrayBuffer",
    proto: true,
    unsafe: true,
    forced: $5bb7220e37bd460f$var$INCORRECT_SLICE
}, {
    slice: function slice(start, end) {
        if ($5bb7220e37bd460f$var$un$ArrayBufferSlice && end === undefined) return $5bb7220e37bd460f$var$un$ArrayBufferSlice($5bb7220e37bd460f$var$anObject$2(this), start); // FF fix
        var length = $5bb7220e37bd460f$var$anObject$2(this).byteLength;
        var first = $5bb7220e37bd460f$var$toAbsoluteIndex(start, length);
        var fin = $5bb7220e37bd460f$var$toAbsoluteIndex(end === undefined ? length : end, length);
        var result = new ($5bb7220e37bd460f$var$speciesConstructor$1(this, $5bb7220e37bd460f$var$ArrayBuffer$2))($5bb7220e37bd460f$var$toLength$2(fin - first));
        var viewSource = new $5bb7220e37bd460f$var$DataView$2(this);
        var viewTarget = new $5bb7220e37bd460f$var$DataView$2(result);
        var index = 0;
        while(first < fin)$5bb7220e37bd460f$var$setUint8(viewTarget, index++, $5bb7220e37bd460f$var$getUint8(viewSource, first++));
        return result;
    }
});
var $5bb7220e37bd460f$var$typedArrayConstructor = {
    exports: {}
};
var $5bb7220e37bd460f$var$isObject$3 = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$floor$1 = Math.floor;
// `IsIntegralNumber` abstract operation
// https://tc39.es/ecma262/#sec-isintegralnumber
// eslint-disable-next-line es-x/no-number-isinteger -- safe
var $5bb7220e37bd460f$var$isIntegralNumber$1 = Number.isInteger || function isInteger(it) {
    return !$5bb7220e37bd460f$var$isObject$3(it) && isFinite(it) && $5bb7220e37bd460f$var$floor$1(it) === it;
};
var $5bb7220e37bd460f$var$toIntegerOrInfinity$1 = $5bb7220e37bd460f$var$toIntegerOrInfinity$6;
var $5bb7220e37bd460f$var$$RangeError$1 = RangeError;
var $5bb7220e37bd460f$var$toPositiveInteger$1 = function(it) {
    var result = $5bb7220e37bd460f$var$toIntegerOrInfinity$1(it);
    if (result < 0) throw $5bb7220e37bd460f$var$$RangeError$1("The argument can't be less than 0");
    return result;
};
var $5bb7220e37bd460f$var$toPositiveInteger = $5bb7220e37bd460f$var$toPositiveInteger$1;
var $5bb7220e37bd460f$var$$RangeError = RangeError;
var $5bb7220e37bd460f$var$toOffset$2 = function(it, BYTES) {
    var offset = $5bb7220e37bd460f$var$toPositiveInteger(it);
    if (offset % BYTES) throw $5bb7220e37bd460f$var$$RangeError("Wrong offset");
    return offset;
};
var $5bb7220e37bd460f$var$classof$3 = $5bb7220e37bd460f$var$classofRaw$1;
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es-x/no-array-isarray -- safe
var $5bb7220e37bd460f$var$isArray$1 = Array.isArray || function isArray(argument) {
    return $5bb7220e37bd460f$var$classof$3(argument) == "Array";
};
var $5bb7220e37bd460f$var$isArray = $5bb7220e37bd460f$var$isArray$1;
var $5bb7220e37bd460f$var$isConstructor = $5bb7220e37bd460f$var$isConstructor$2;
var $5bb7220e37bd460f$var$isObject$2 = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$wellKnownSymbol$1 = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$SPECIES$1 = $5bb7220e37bd460f$var$wellKnownSymbol$1("species");
var $5bb7220e37bd460f$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $5bb7220e37bd460f$var$arraySpeciesConstructor$1 = function(originalArray) {
    var C;
    if ($5bb7220e37bd460f$var$isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($5bb7220e37bd460f$var$isConstructor(C) && (C === $5bb7220e37bd460f$var$$Array || $5bb7220e37bd460f$var$isArray(C.prototype))) C = undefined;
        else if ($5bb7220e37bd460f$var$isObject$2(C)) {
            C = C[$5bb7220e37bd460f$var$SPECIES$1];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $5bb7220e37bd460f$var$$Array : C;
};
var $5bb7220e37bd460f$var$arraySpeciesConstructor = $5bb7220e37bd460f$var$arraySpeciesConstructor$1;
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $5bb7220e37bd460f$var$arraySpeciesCreate$1 = function(originalArray, length) {
    return new ($5bb7220e37bd460f$var$arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};
var $5bb7220e37bd460f$var$bind = $5bb7220e37bd460f$var$functionBindContext;
var $5bb7220e37bd460f$var$uncurryThis$5 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$IndexedObject = $5bb7220e37bd460f$var$indexedObject;
var $5bb7220e37bd460f$var$toObject = $5bb7220e37bd460f$var$toObject$7;
var $5bb7220e37bd460f$var$lengthOfArrayLike$1 = $5bb7220e37bd460f$var$lengthOfArrayLike$8;
var $5bb7220e37bd460f$var$arraySpeciesCreate = $5bb7220e37bd460f$var$arraySpeciesCreate$1;
var $5bb7220e37bd460f$var$push$1 = $5bb7220e37bd460f$var$uncurryThis$5([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $5bb7220e37bd460f$var$createMethod$1 = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_REJECT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $5bb7220e37bd460f$var$toObject($this);
        var self1 = $5bb7220e37bd460f$var$IndexedObject(O);
        var boundFunction = $5bb7220e37bd460f$var$bind(callbackfn, that);
        var length = $5bb7220e37bd460f$var$lengthOfArrayLike$1(self1);
        var index = 0;
        var create = specificCreate || $5bb7220e37bd460f$var$arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $5bb7220e37bd460f$var$push$1(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $5bb7220e37bd460f$var$push$1(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $5bb7220e37bd460f$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $5bb7220e37bd460f$var$createMethod$1(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $5bb7220e37bd460f$var$createMethod$1(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $5bb7220e37bd460f$var$createMethod$1(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $5bb7220e37bd460f$var$createMethod$1(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $5bb7220e37bd460f$var$createMethod$1(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $5bb7220e37bd460f$var$createMethod$1(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $5bb7220e37bd460f$var$createMethod$1(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $5bb7220e37bd460f$var$createMethod$1(7)
};
var $5bb7220e37bd460f$var$isCallable$1 = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$isObject$1 = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$setPrototypeOf$1 = $5bb7220e37bd460f$var$objectSetPrototypeOf;
// makes subclassing work correct for wrapped built-ins
var $5bb7220e37bd460f$var$inheritIfRequired$1 = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $5bb7220e37bd460f$var$setPrototypeOf$1 && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $5bb7220e37bd460f$var$isCallable$1(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $5bb7220e37bd460f$var$isObject$1(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $5bb7220e37bd460f$var$setPrototypeOf$1($this, NewTargetPrototype);
    return $this;
};
var $5bb7220e37bd460f$var$$ = $5bb7220e37bd460f$var$_export;
var $5bb7220e37bd460f$var$global$4 = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$call$4 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$DESCRIPTORS = $5bb7220e37bd460f$var$descriptors;
var $5bb7220e37bd460f$var$TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS = $5bb7220e37bd460f$var$typedArrayConstructorsRequireWrappers;
var $5bb7220e37bd460f$var$ArrayBufferViewCore$4 = $5bb7220e37bd460f$var$arrayBufferViewCore;
var $5bb7220e37bd460f$var$ArrayBufferModule = $5bb7220e37bd460f$var$arrayBuffer;
var $5bb7220e37bd460f$var$anInstance = $5bb7220e37bd460f$var$anInstance$3;
var $5bb7220e37bd460f$var$createPropertyDescriptor = $5bb7220e37bd460f$var$createPropertyDescriptor$5;
var $5bb7220e37bd460f$var$createNonEnumerableProperty$1 = $5bb7220e37bd460f$var$createNonEnumerableProperty$8;
var $5bb7220e37bd460f$var$isIntegralNumber = $5bb7220e37bd460f$var$isIntegralNumber$1;
var $5bb7220e37bd460f$var$toLength$1 = $5bb7220e37bd460f$var$toLength$6;
var $5bb7220e37bd460f$var$toIndex = $5bb7220e37bd460f$var$toIndex$2;
var $5bb7220e37bd460f$var$toOffset$1 = $5bb7220e37bd460f$var$toOffset$2;
var $5bb7220e37bd460f$var$toPropertyKey = $5bb7220e37bd460f$var$toPropertyKey$4;
var $5bb7220e37bd460f$var$hasOwn = $5bb7220e37bd460f$var$hasOwnProperty_1;
var $5bb7220e37bd460f$var$classof$2 = $5bb7220e37bd460f$var$classof$9;
var $5bb7220e37bd460f$var$isObject = $5bb7220e37bd460f$var$isObject$d;
var $5bb7220e37bd460f$var$isSymbol = $5bb7220e37bd460f$var$isSymbol$3;
var $5bb7220e37bd460f$var$create = $5bb7220e37bd460f$var$objectCreate;
var $5bb7220e37bd460f$var$isPrototypeOf = $5bb7220e37bd460f$var$objectIsPrototypeOf;
var $5bb7220e37bd460f$var$setPrototypeOf = $5bb7220e37bd460f$var$objectSetPrototypeOf;
var $5bb7220e37bd460f$var$getOwnPropertyNames = $5bb7220e37bd460f$var$objectGetOwnPropertyNames.f;
var $5bb7220e37bd460f$var$typedArrayFrom = $5bb7220e37bd460f$var$typedArrayFrom$2;
var $5bb7220e37bd460f$var$forEach = $5bb7220e37bd460f$var$arrayIteration.forEach;
var $5bb7220e37bd460f$var$setSpecies = $5bb7220e37bd460f$var$setSpecies$2;
var $5bb7220e37bd460f$var$definePropertyModule = $5bb7220e37bd460f$var$objectDefineProperty;
var $5bb7220e37bd460f$var$getOwnPropertyDescriptorModule = $5bb7220e37bd460f$var$objectGetOwnPropertyDescriptor;
var $5bb7220e37bd460f$var$InternalStateModule = $5bb7220e37bd460f$var$internalState;
var $5bb7220e37bd460f$var$inheritIfRequired = $5bb7220e37bd460f$var$inheritIfRequired$1;
var $5bb7220e37bd460f$var$getInternalState = $5bb7220e37bd460f$var$InternalStateModule.get;
var $5bb7220e37bd460f$var$setInternalState = $5bb7220e37bd460f$var$InternalStateModule.set;
var $5bb7220e37bd460f$var$enforceInternalState = $5bb7220e37bd460f$var$InternalStateModule.enforce;
var $5bb7220e37bd460f$var$nativeDefineProperty = $5bb7220e37bd460f$var$definePropertyModule.f;
var $5bb7220e37bd460f$var$nativeGetOwnPropertyDescriptor = $5bb7220e37bd460f$var$getOwnPropertyDescriptorModule.f;
var $5bb7220e37bd460f$var$round = Math.round;
var $5bb7220e37bd460f$var$RangeError$2 = $5bb7220e37bd460f$var$global$4.RangeError;
var $5bb7220e37bd460f$var$ArrayBuffer$1 = $5bb7220e37bd460f$var$ArrayBufferModule.ArrayBuffer;
var $5bb7220e37bd460f$var$ArrayBufferPrototype = $5bb7220e37bd460f$var$ArrayBuffer$1.prototype;
var $5bb7220e37bd460f$var$DataView$1 = $5bb7220e37bd460f$var$ArrayBufferModule.DataView;
var $5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS = $5bb7220e37bd460f$var$ArrayBufferViewCore$4.NATIVE_ARRAY_BUFFER_VIEWS;
var $5bb7220e37bd460f$var$TYPED_ARRAY_TAG = $5bb7220e37bd460f$var$ArrayBufferViewCore$4.TYPED_ARRAY_TAG;
var $5bb7220e37bd460f$var$TypedArray = $5bb7220e37bd460f$var$ArrayBufferViewCore$4.TypedArray;
var $5bb7220e37bd460f$var$TypedArrayPrototype = $5bb7220e37bd460f$var$ArrayBufferViewCore$4.TypedArrayPrototype;
var $5bb7220e37bd460f$var$aTypedArrayConstructor = $5bb7220e37bd460f$var$ArrayBufferViewCore$4.aTypedArrayConstructor;
var $5bb7220e37bd460f$var$isTypedArray = $5bb7220e37bd460f$var$ArrayBufferViewCore$4.isTypedArray;
var $5bb7220e37bd460f$var$BYTES_PER_ELEMENT = "BYTES_PER_ELEMENT";
var $5bb7220e37bd460f$var$WRONG_LENGTH = "Wrong length";
var $5bb7220e37bd460f$var$fromList = function(C, list) {
    $5bb7220e37bd460f$var$aTypedArrayConstructor(C);
    var index = 0;
    var length = list.length;
    var result = new C(length);
    while(length > index)result[index] = list[index++];
    return result;
};
var $5bb7220e37bd460f$var$addGetter = function(it, key) {
    $5bb7220e37bd460f$var$nativeDefineProperty(it, key, {
        get: function() {
            return $5bb7220e37bd460f$var$getInternalState(this)[key];
        }
    });
};
var $5bb7220e37bd460f$var$isArrayBuffer = function(it) {
    var klass;
    return $5bb7220e37bd460f$var$isPrototypeOf($5bb7220e37bd460f$var$ArrayBufferPrototype, it) || (klass = $5bb7220e37bd460f$var$classof$2(it)) == "ArrayBuffer" || klass == "SharedArrayBuffer";
};
var $5bb7220e37bd460f$var$isTypedArrayIndex = function(target, key) {
    return $5bb7220e37bd460f$var$isTypedArray(target) && !$5bb7220e37bd460f$var$isSymbol(key) && key in target && $5bb7220e37bd460f$var$isIntegralNumber(+key) && key >= 0;
};
var $5bb7220e37bd460f$var$wrappedGetOwnPropertyDescriptor = function getOwnPropertyDescriptor(target, key) {
    key = $5bb7220e37bd460f$var$toPropertyKey(key);
    return $5bb7220e37bd460f$var$isTypedArrayIndex(target, key) ? $5bb7220e37bd460f$var$createPropertyDescriptor(2, target[key]) : $5bb7220e37bd460f$var$nativeGetOwnPropertyDescriptor(target, key);
};
var $5bb7220e37bd460f$var$wrappedDefineProperty = function defineProperty(target, key, descriptor) {
    key = $5bb7220e37bd460f$var$toPropertyKey(key);
    if ($5bb7220e37bd460f$var$isTypedArrayIndex(target, key) && $5bb7220e37bd460f$var$isObject(descriptor) && $5bb7220e37bd460f$var$hasOwn(descriptor, "value") && !$5bb7220e37bd460f$var$hasOwn(descriptor, "get") && !$5bb7220e37bd460f$var$hasOwn(descriptor, "set") && !descriptor.configurable && (!$5bb7220e37bd460f$var$hasOwn(descriptor, "writable") || descriptor.writable) && (!$5bb7220e37bd460f$var$hasOwn(descriptor, "enumerable") || descriptor.enumerable)) {
        target[key] = descriptor.value;
        return target;
    }
    return $5bb7220e37bd460f$var$nativeDefineProperty(target, key, descriptor);
};
if ($5bb7220e37bd460f$var$DESCRIPTORS) {
    if (!$5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS) {
        $5bb7220e37bd460f$var$getOwnPropertyDescriptorModule.f = $5bb7220e37bd460f$var$wrappedGetOwnPropertyDescriptor;
        $5bb7220e37bd460f$var$definePropertyModule.f = $5bb7220e37bd460f$var$wrappedDefineProperty;
        $5bb7220e37bd460f$var$addGetter($5bb7220e37bd460f$var$TypedArrayPrototype, "buffer");
        $5bb7220e37bd460f$var$addGetter($5bb7220e37bd460f$var$TypedArrayPrototype, "byteOffset");
        $5bb7220e37bd460f$var$addGetter($5bb7220e37bd460f$var$TypedArrayPrototype, "byteLength");
        $5bb7220e37bd460f$var$addGetter($5bb7220e37bd460f$var$TypedArrayPrototype, "length");
    }
    $5bb7220e37bd460f$var$$({
        target: "Object",
        stat: true,
        forced: !$5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS
    }, {
        getOwnPropertyDescriptor: $5bb7220e37bd460f$var$wrappedGetOwnPropertyDescriptor,
        defineProperty: $5bb7220e37bd460f$var$wrappedDefineProperty
    });
    $5bb7220e37bd460f$var$typedArrayConstructor.exports = function(TYPE, wrapper, CLAMPED) {
        var BYTES = TYPE.match(/\d+$/)[0] / 8;
        var CONSTRUCTOR_NAME = TYPE + (CLAMPED ? "Clamped" : "") + "Array";
        var GETTER = "get" + TYPE;
        var SETTER = "set" + TYPE;
        var NativeTypedArrayConstructor = $5bb7220e37bd460f$var$global$4[CONSTRUCTOR_NAME];
        var TypedArrayConstructor = NativeTypedArrayConstructor;
        var TypedArrayConstructorPrototype = TypedArrayConstructor && TypedArrayConstructor.prototype;
        var exported = {};
        var getter = function(that, index) {
            var data = $5bb7220e37bd460f$var$getInternalState(that);
            return data.view[GETTER](index * BYTES + data.byteOffset, true);
        };
        var setter = function(that, index, value) {
            var data = $5bb7220e37bd460f$var$getInternalState(that);
            if (CLAMPED) value = (value = $5bb7220e37bd460f$var$round(value)) < 0 ? 0 : value > 0xFF ? 0xFF : value & 0xFF;
            data.view[SETTER](index * BYTES + data.byteOffset, value, true);
        };
        var addElement = function(that, index) {
            $5bb7220e37bd460f$var$nativeDefineProperty(that, index, {
                get: function() {
                    return getter(this, index);
                },
                set: function(value) {
                    return setter(this, index, value);
                },
                enumerable: true
            });
        };
        if (!$5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS) {
            TypedArrayConstructor = wrapper(function(that, data, offset, $length) {
                $5bb7220e37bd460f$var$anInstance(that, TypedArrayConstructorPrototype);
                var index = 0;
                var byteOffset = 0;
                var buffer, byteLength, length;
                if (!$5bb7220e37bd460f$var$isObject(data)) {
                    length = $5bb7220e37bd460f$var$toIndex(data);
                    byteLength = length * BYTES;
                    buffer = new $5bb7220e37bd460f$var$ArrayBuffer$1(byteLength);
                } else if ($5bb7220e37bd460f$var$isArrayBuffer(data)) {
                    buffer = data;
                    byteOffset = $5bb7220e37bd460f$var$toOffset$1(offset, BYTES);
                    var $len = data.byteLength;
                    if ($length === undefined) {
                        if ($len % BYTES) throw $5bb7220e37bd460f$var$RangeError$2($5bb7220e37bd460f$var$WRONG_LENGTH);
                        byteLength = $len - byteOffset;
                        if (byteLength < 0) throw $5bb7220e37bd460f$var$RangeError$2($5bb7220e37bd460f$var$WRONG_LENGTH);
                    } else {
                        byteLength = $5bb7220e37bd460f$var$toLength$1($length) * BYTES;
                        if (byteLength + byteOffset > $len) throw $5bb7220e37bd460f$var$RangeError$2($5bb7220e37bd460f$var$WRONG_LENGTH);
                    }
                    length = byteLength / BYTES;
                } else if ($5bb7220e37bd460f$var$isTypedArray(data)) return $5bb7220e37bd460f$var$fromList(TypedArrayConstructor, data);
                else return $5bb7220e37bd460f$var$call$4($5bb7220e37bd460f$var$typedArrayFrom, TypedArrayConstructor, data);
                $5bb7220e37bd460f$var$setInternalState(that, {
                    buffer: buffer,
                    byteOffset: byteOffset,
                    byteLength: byteLength,
                    length: length,
                    view: new $5bb7220e37bd460f$var$DataView$1(buffer)
                });
                while(index < length)addElement(that, index++);
            });
            if ($5bb7220e37bd460f$var$setPrototypeOf) $5bb7220e37bd460f$var$setPrototypeOf(TypedArrayConstructor, $5bb7220e37bd460f$var$TypedArray);
            TypedArrayConstructorPrototype = TypedArrayConstructor.prototype = $5bb7220e37bd460f$var$create($5bb7220e37bd460f$var$TypedArrayPrototype);
        } else if ($5bb7220e37bd460f$var$TYPED_ARRAYS_CONSTRUCTORS_REQUIRES_WRAPPERS) {
            TypedArrayConstructor = wrapper(function(dummy, data, typedArrayOffset, $length) {
                $5bb7220e37bd460f$var$anInstance(dummy, TypedArrayConstructorPrototype);
                return $5bb7220e37bd460f$var$inheritIfRequired(function() {
                    if (!$5bb7220e37bd460f$var$isObject(data)) return new NativeTypedArrayConstructor($5bb7220e37bd460f$var$toIndex(data));
                    if ($5bb7220e37bd460f$var$isArrayBuffer(data)) return $length !== undefined ? new NativeTypedArrayConstructor(data, $5bb7220e37bd460f$var$toOffset$1(typedArrayOffset, BYTES), $length) : typedArrayOffset !== undefined ? new NativeTypedArrayConstructor(data, $5bb7220e37bd460f$var$toOffset$1(typedArrayOffset, BYTES)) : new NativeTypedArrayConstructor(data);
                    if ($5bb7220e37bd460f$var$isTypedArray(data)) return $5bb7220e37bd460f$var$fromList(TypedArrayConstructor, data);
                    return $5bb7220e37bd460f$var$call$4($5bb7220e37bd460f$var$typedArrayFrom, TypedArrayConstructor, data);
                }(), dummy, TypedArrayConstructor);
            });
            if ($5bb7220e37bd460f$var$setPrototypeOf) $5bb7220e37bd460f$var$setPrototypeOf(TypedArrayConstructor, $5bb7220e37bd460f$var$TypedArray);
            $5bb7220e37bd460f$var$forEach($5bb7220e37bd460f$var$getOwnPropertyNames(NativeTypedArrayConstructor), function(key) {
                if (!(key in TypedArrayConstructor)) $5bb7220e37bd460f$var$createNonEnumerableProperty$1(TypedArrayConstructor, key, NativeTypedArrayConstructor[key]);
            });
            TypedArrayConstructor.prototype = TypedArrayConstructorPrototype;
        }
        if (TypedArrayConstructorPrototype.constructor !== TypedArrayConstructor) $5bb7220e37bd460f$var$createNonEnumerableProperty$1(TypedArrayConstructorPrototype, "constructor", TypedArrayConstructor);
        $5bb7220e37bd460f$var$enforceInternalState(TypedArrayConstructorPrototype).TypedArrayConstructor = TypedArrayConstructor;
        if ($5bb7220e37bd460f$var$TYPED_ARRAY_TAG) $5bb7220e37bd460f$var$createNonEnumerableProperty$1(TypedArrayConstructorPrototype, $5bb7220e37bd460f$var$TYPED_ARRAY_TAG, CONSTRUCTOR_NAME);
        var FORCED = TypedArrayConstructor != NativeTypedArrayConstructor;
        exported[CONSTRUCTOR_NAME] = TypedArrayConstructor;
        $5bb7220e37bd460f$var$$({
            global: true,
            constructor: true,
            forced: FORCED,
            sham: !$5bb7220e37bd460f$var$NATIVE_ARRAY_BUFFER_VIEWS
        }, exported);
        if (!($5bb7220e37bd460f$var$BYTES_PER_ELEMENT in TypedArrayConstructor)) $5bb7220e37bd460f$var$createNonEnumerableProperty$1(TypedArrayConstructor, $5bb7220e37bd460f$var$BYTES_PER_ELEMENT, BYTES);
        if (!($5bb7220e37bd460f$var$BYTES_PER_ELEMENT in TypedArrayConstructorPrototype)) $5bb7220e37bd460f$var$createNonEnumerableProperty$1(TypedArrayConstructorPrototype, $5bb7220e37bd460f$var$BYTES_PER_ELEMENT, BYTES);
        $5bb7220e37bd460f$var$setSpecies(CONSTRUCTOR_NAME);
    };
} else $5bb7220e37bd460f$var$typedArrayConstructor.exports = function() {};
var $5bb7220e37bd460f$var$createTypedArrayConstructor = $5bb7220e37bd460f$var$typedArrayConstructor.exports;
// `Uint8Array` constructor
// https://tc39.es/ecma262/#sec-typedarray-objects
$5bb7220e37bd460f$var$createTypedArrayConstructor("Uint8", function(init) {
    return function Uint8Array1(data, byteOffset, length) {
        return init(this, data, byteOffset, length);
    };
});
var $5bb7220e37bd460f$var$toPrimitive = $5bb7220e37bd460f$var$toPrimitive$2;
var $5bb7220e37bd460f$var$$TypeError$1 = TypeError;
// `ToBigInt` abstract operation
// https://tc39.es/ecma262/#sec-tobigint
var $5bb7220e37bd460f$var$toBigInt$1 = function(argument) {
    var prim = $5bb7220e37bd460f$var$toPrimitive(argument, "number");
    if (typeof prim == "number") throw $5bb7220e37bd460f$var$$TypeError$1("Can't convert number to bigint");
    // eslint-disable-next-line es-x/no-bigint -- safe
    return BigInt(prim);
};
var $5bb7220e37bd460f$var$ArrayBufferViewCore$3 = $5bb7220e37bd460f$var$arrayBufferViewCore;
var $5bb7220e37bd460f$var$$fill = $5bb7220e37bd460f$var$arrayFill$1;
var $5bb7220e37bd460f$var$toBigInt = $5bb7220e37bd460f$var$toBigInt$1;
var $5bb7220e37bd460f$var$classof$1 = $5bb7220e37bd460f$var$classof$9;
var $5bb7220e37bd460f$var$call$3 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$uncurryThis$4 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$fails$5 = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$aTypedArray$3 = $5bb7220e37bd460f$var$ArrayBufferViewCore$3.aTypedArray;
var $5bb7220e37bd460f$var$exportTypedArrayMethod$3 = $5bb7220e37bd460f$var$ArrayBufferViewCore$3.exportTypedArrayMethod;
var $5bb7220e37bd460f$var$slice = $5bb7220e37bd460f$var$uncurryThis$4("".slice);
// V8 ~ Chrome < 59, Safari < 14.1, FF < 55, Edge <=18
var $5bb7220e37bd460f$var$CONVERSION_BUG = $5bb7220e37bd460f$var$fails$5(function() {
    var count = 0;
    // eslint-disable-next-line es-x/no-typed-arrays -- safe
    new Int8Array(2).fill({
        valueOf: function() {
            return count++;
        }
    });
    return count !== 1;
});
// `%TypedArray%.prototype.fill` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.fill
$5bb7220e37bd460f$var$exportTypedArrayMethod$3("fill", function fill(value /* , start, end */ ) {
    var length = arguments.length;
    $5bb7220e37bd460f$var$aTypedArray$3(this);
    var actualValue = $5bb7220e37bd460f$var$slice($5bb7220e37bd460f$var$classof$1(this), 0, 3) === "Big" ? $5bb7220e37bd460f$var$toBigInt(value) : +value;
    return $5bb7220e37bd460f$var$call$3($5bb7220e37bd460f$var$$fill, this, actualValue, length > 1 ? arguments[1] : undefined, length > 2 ? arguments[2] : undefined);
}, $5bb7220e37bd460f$var$CONVERSION_BUG);
var $5bb7220e37bd460f$var$global$3 = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$call$2 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$ArrayBufferViewCore$2 = $5bb7220e37bd460f$var$arrayBufferViewCore;
var $5bb7220e37bd460f$var$lengthOfArrayLike = $5bb7220e37bd460f$var$lengthOfArrayLike$8;
var $5bb7220e37bd460f$var$toOffset = $5bb7220e37bd460f$var$toOffset$2;
var $5bb7220e37bd460f$var$toIndexedObject = $5bb7220e37bd460f$var$toObject$7;
var $5bb7220e37bd460f$var$fails$4 = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$RangeError$1 = $5bb7220e37bd460f$var$global$3.RangeError;
var $5bb7220e37bd460f$var$Int8Array$2 = $5bb7220e37bd460f$var$global$3.Int8Array;
var $5bb7220e37bd460f$var$Int8ArrayPrototype = $5bb7220e37bd460f$var$Int8Array$2 && $5bb7220e37bd460f$var$Int8Array$2.prototype;
var $5bb7220e37bd460f$var$$set = $5bb7220e37bd460f$var$Int8ArrayPrototype && $5bb7220e37bd460f$var$Int8ArrayPrototype.set;
var $5bb7220e37bd460f$var$aTypedArray$2 = $5bb7220e37bd460f$var$ArrayBufferViewCore$2.aTypedArray;
var $5bb7220e37bd460f$var$exportTypedArrayMethod$2 = $5bb7220e37bd460f$var$ArrayBufferViewCore$2.exportTypedArrayMethod;
var $5bb7220e37bd460f$var$WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS = !$5bb7220e37bd460f$var$fails$4(function() {
    // eslint-disable-next-line es-x/no-typed-arrays -- required for testing
    var array = new Uint8ClampedArray(2);
    $5bb7220e37bd460f$var$call$2($5bb7220e37bd460f$var$$set, array, {
        length: 1,
        0: 3
    }, 1);
    return array[1] !== 3;
});
// https://bugs.chromium.org/p/v8/issues/detail?id=11294 and other
var $5bb7220e37bd460f$var$TO_OBJECT_BUG = $5bb7220e37bd460f$var$WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS && $5bb7220e37bd460f$var$ArrayBufferViewCore$2.NATIVE_ARRAY_BUFFER_VIEWS && $5bb7220e37bd460f$var$fails$4(function() {
    var array = new $5bb7220e37bd460f$var$Int8Array$2(2);
    array.set(1);
    array.set("2", 1);
    return array[0] !== 0 || array[1] !== 2;
});
// `%TypedArray%.prototype.set` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.set
$5bb7220e37bd460f$var$exportTypedArrayMethod$2("set", function set(arrayLike /* , offset */ ) {
    $5bb7220e37bd460f$var$aTypedArray$2(this);
    var offset = $5bb7220e37bd460f$var$toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
    var src = $5bb7220e37bd460f$var$toIndexedObject(arrayLike);
    if ($5bb7220e37bd460f$var$WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS) return $5bb7220e37bd460f$var$call$2($5bb7220e37bd460f$var$$set, this, src, offset);
    var length = this.length;
    var len = $5bb7220e37bd460f$var$lengthOfArrayLike(src);
    var index = 0;
    if (len + offset > length) throw $5bb7220e37bd460f$var$RangeError$1("Wrong length");
    while(index < len)this[offset + index] = src[index++];
}, !$5bb7220e37bd460f$var$WORKS_WITH_OBJECTS_AND_GEERIC_ON_TYPED_ARRAYS || $5bb7220e37bd460f$var$TO_OBJECT_BUG);
var $5bb7220e37bd460f$var$arraySlice$2 = $5bb7220e37bd460f$var$arraySliceSimple;
var $5bb7220e37bd460f$var$floor = Math.floor;
var $5bb7220e37bd460f$var$mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = $5bb7220e37bd460f$var$floor(length / 2);
    return length < 8 ? $5bb7220e37bd460f$var$insertionSort(array, comparefn) : $5bb7220e37bd460f$var$merge(array, $5bb7220e37bd460f$var$mergeSort($5bb7220e37bd460f$var$arraySlice$2(array, 0, middle), comparefn), $5bb7220e37bd460f$var$mergeSort($5bb7220e37bd460f$var$arraySlice$2(array, middle), comparefn), comparefn);
};
var $5bb7220e37bd460f$var$insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $5bb7220e37bd460f$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
var $5bb7220e37bd460f$var$arraySort = $5bb7220e37bd460f$var$mergeSort;
var $5bb7220e37bd460f$var$userAgent$1 = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$firefox = $5bb7220e37bd460f$var$userAgent$1.match(/firefox\/(\d+)/i);
var $5bb7220e37bd460f$var$engineFfVersion = !!$5bb7220e37bd460f$var$firefox && +$5bb7220e37bd460f$var$firefox[1];
var $5bb7220e37bd460f$var$UA = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$engineIsIeOrEdge = /MSIE|Trident/.test($5bb7220e37bd460f$var$UA);
var $5bb7220e37bd460f$var$userAgent = $5bb7220e37bd460f$var$engineUserAgent;
var $5bb7220e37bd460f$var$webkit = $5bb7220e37bd460f$var$userAgent.match(/AppleWebKit\/(\d+)\./);
var $5bb7220e37bd460f$var$engineWebkitVersion = !!$5bb7220e37bd460f$var$webkit && +$5bb7220e37bd460f$var$webkit[1];
var $5bb7220e37bd460f$var$global$2 = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$uncurryThis$3 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$fails$3 = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$aCallable = $5bb7220e37bd460f$var$aCallable$9;
var $5bb7220e37bd460f$var$internalSort = $5bb7220e37bd460f$var$arraySort;
var $5bb7220e37bd460f$var$ArrayBufferViewCore$1 = $5bb7220e37bd460f$var$arrayBufferViewCore;
var $5bb7220e37bd460f$var$FF = $5bb7220e37bd460f$var$engineFfVersion;
var $5bb7220e37bd460f$var$IE_OR_EDGE = $5bb7220e37bd460f$var$engineIsIeOrEdge;
var $5bb7220e37bd460f$var$V8 = $5bb7220e37bd460f$var$engineV8Version;
var $5bb7220e37bd460f$var$WEBKIT = $5bb7220e37bd460f$var$engineWebkitVersion;
var $5bb7220e37bd460f$var$aTypedArray$1 = $5bb7220e37bd460f$var$ArrayBufferViewCore$1.aTypedArray;
var $5bb7220e37bd460f$var$exportTypedArrayMethod$1 = $5bb7220e37bd460f$var$ArrayBufferViewCore$1.exportTypedArrayMethod;
var $5bb7220e37bd460f$var$Uint16Array = $5bb7220e37bd460f$var$global$2.Uint16Array;
var $5bb7220e37bd460f$var$un$Sort = $5bb7220e37bd460f$var$Uint16Array && $5bb7220e37bd460f$var$uncurryThis$3($5bb7220e37bd460f$var$Uint16Array.prototype.sort);
// WebKit
var $5bb7220e37bd460f$var$ACCEPT_INCORRECT_ARGUMENTS = !!$5bb7220e37bd460f$var$un$Sort && !($5bb7220e37bd460f$var$fails$3(function() {
    $5bb7220e37bd460f$var$un$Sort(new $5bb7220e37bd460f$var$Uint16Array(2), null);
}) && $5bb7220e37bd460f$var$fails$3(function() {
    $5bb7220e37bd460f$var$un$Sort(new $5bb7220e37bd460f$var$Uint16Array(2), {});
}));
var $5bb7220e37bd460f$var$STABLE_SORT = !!$5bb7220e37bd460f$var$un$Sort && !$5bb7220e37bd460f$var$fails$3(function() {
    // feature detection can be too slow, so check engines versions
    if ($5bb7220e37bd460f$var$V8) return $5bb7220e37bd460f$var$V8 < 74;
    if ($5bb7220e37bd460f$var$FF) return $5bb7220e37bd460f$var$FF < 67;
    if ($5bb7220e37bd460f$var$IE_OR_EDGE) return true;
    if ($5bb7220e37bd460f$var$WEBKIT) return $5bb7220e37bd460f$var$WEBKIT < 602;
    var array = new $5bb7220e37bd460f$var$Uint16Array(516);
    var expected = Array(516);
    var index, mod;
    for(index = 0; index < 516; index++){
        mod = index % 4;
        array[index] = 515 - index;
        expected[index] = index - 2 * mod + 3;
    }
    $5bb7220e37bd460f$var$un$Sort(array, function(a, b) {
        return (a / 4 | 0) - (b / 4 | 0);
    });
    for(index = 0; index < 516; index++){
        if (array[index] !== expected[index]) return true;
    }
});
var $5bb7220e37bd460f$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (y !== y) return -1;
        // eslint-disable-next-line no-self-compare -- NaN check
        if (x !== x) return 1;
        if (x === 0 && y === 0) return 1 / x > 0 && 1 / y < 0 ? 1 : -1;
        return x > y;
    };
};
// `%TypedArray%.prototype.sort` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.sort
$5bb7220e37bd460f$var$exportTypedArrayMethod$1("sort", function sort(comparefn) {
    if (comparefn !== undefined) $5bb7220e37bd460f$var$aCallable(comparefn);
    if ($5bb7220e37bd460f$var$STABLE_SORT) return $5bb7220e37bd460f$var$un$Sort(this, comparefn);
    return $5bb7220e37bd460f$var$internalSort($5bb7220e37bd460f$var$aTypedArray$1(this), $5bb7220e37bd460f$var$getSortCompare(comparefn));
}, !$5bb7220e37bd460f$var$STABLE_SORT || $5bb7220e37bd460f$var$ACCEPT_INCORRECT_ARGUMENTS);
var $5bb7220e37bd460f$var$global$1 = $5bb7220e37bd460f$var$global$t;
var $5bb7220e37bd460f$var$apply$1 = $5bb7220e37bd460f$var$functionApply;
var $5bb7220e37bd460f$var$ArrayBufferViewCore = $5bb7220e37bd460f$var$arrayBufferViewCore;
var $5bb7220e37bd460f$var$fails$2 = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$arraySlice$1 = $5bb7220e37bd460f$var$arraySlice$5;
var $5bb7220e37bd460f$var$Int8Array$1 = $5bb7220e37bd460f$var$global$1.Int8Array;
var $5bb7220e37bd460f$var$aTypedArray = $5bb7220e37bd460f$var$ArrayBufferViewCore.aTypedArray;
var $5bb7220e37bd460f$var$exportTypedArrayMethod = $5bb7220e37bd460f$var$ArrayBufferViewCore.exportTypedArrayMethod;
var $5bb7220e37bd460f$var$$toLocaleString = [].toLocaleString;
// iOS Safari 6.x fails here
var $5bb7220e37bd460f$var$TO_LOCALE_STRING_BUG = !!$5bb7220e37bd460f$var$Int8Array$1 && $5bb7220e37bd460f$var$fails$2(function() {
    $5bb7220e37bd460f$var$$toLocaleString.call(new $5bb7220e37bd460f$var$Int8Array$1(1));
});
var $5bb7220e37bd460f$var$FORCED = $5bb7220e37bd460f$var$fails$2(function() {
    return [
        1,
        2
    ].toLocaleString() != new $5bb7220e37bd460f$var$Int8Array$1([
        1,
        2
    ]).toLocaleString();
}) || !$5bb7220e37bd460f$var$fails$2(function() {
    $5bb7220e37bd460f$var$Int8Array$1.prototype.toLocaleString.call([
        1,
        2
    ]);
});
// `%TypedArray%.prototype.toLocaleString` method
// https://tc39.es/ecma262/#sec-%typedarray%.prototype.tolocalestring
$5bb7220e37bd460f$var$exportTypedArrayMethod("toLocaleString", function toLocaleString() {
    return $5bb7220e37bd460f$var$apply$1($5bb7220e37bd460f$var$$toLocaleString, $5bb7220e37bd460f$var$TO_LOCALE_STRING_BUG ? $5bb7220e37bd460f$var$arraySlice$1($5bb7220e37bd460f$var$aTypedArray(this)) : $5bb7220e37bd460f$var$aTypedArray(this), $5bb7220e37bd460f$var$arraySlice$1(arguments));
}, $5bb7220e37bd460f$var$FORCED);
class $5bb7220e37bd460f$var$Payload {
    constructor(data){
        // The tag's value is a hardcoded value as per
        // defined in the NEP [NEP413](https://github.com/near/NEPs/blob/master/neps/nep-0413.md)
        this.tag = 2147484061;
        this.message = data.message;
        this.nonce = data.nonce;
        this.recipient = data.recipient;
        if (data.callbackUrl) this.callbackUrl = data.callbackUrl;
    }
}
const $5bb7220e37bd460f$var$payloadSchema = new Map([
    [
        $5bb7220e37bd460f$var$Payload,
        {
            kind: "struct",
            fields: [
                [
                    "tag",
                    "u32"
                ],
                [
                    "message",
                    "string"
                ],
                [
                    "nonce",
                    [
                        32
                    ]
                ],
                [
                    "recipient",
                    "string"
                ],
                [
                    "callbackUrl",
                    {
                        kind: "option",
                        type: "string"
                    }
                ]
            ]
        }
    ]
]);
const $5bb7220e37bd460f$export$db6ccfcaf9ec7df4 = (signMessageParams)=>{
    const payload = new $5bb7220e37bd460f$var$Payload(Object.assign({}, signMessageParams));
    return $5bb7220e37bd460f$require$Buffer.from((0, $142391d738890b4f$exports.serialize)($5bb7220e37bd460f$var$payloadSchema, payload));
};
const $5bb7220e37bd460f$export$ab54e47fdf2903bb = ({ publicKey: publicKey, signature: signature, message: message, nonce: nonce, recipient: recipient, callbackUrl: callbackUrl })=>{
    // Reconstruct the payload that was **actually signed**
    const payload = new $5bb7220e37bd460f$var$Payload({
        message: message,
        nonce: nonce,
        recipient: recipient,
        callbackUrl: callbackUrl
    });
    // Serialize payload based on payloadSchema
    const borshPayload = (0, $142391d738890b4f$exports.serialize)($5bb7220e37bd460f$var$payloadSchema, payload);
    // Hash the payload as in the NEP0413 referenced example
    // https://github.com/near/NEPs/blob/master/neps/nep-0413.md#references
    // https://github.com/gagdiez/near-login/blob/main/authenticate/wallet-authenticate.js#L21
    const hashedPayload = Uint8Array.from((0, $fBCU1.sha256).array(borshPayload));
    // Convert real signature to buffer base64
    const realSignature = $5bb7220e37bd460f$require$Buffer.from(signature, "base64");
    const pk = (0, $k4rlt.utils).PublicKey.from(publicKey);
    // Verify the signature
    return pk.verify(hashedPayload, realSignature);
};
const $5bb7220e37bd460f$var$fetchAllUserKeys = ({ accountId: accountId, network: network, publicKey: publicKey })=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const provider = new (0, $k4rlt.providers).JsonRpcProvider({
            url: network.nodeUrl
        });
        const key = yield provider.query({
            request_type: "view_access_key",
            account_id: accountId,
            finality: "final",
            public_key: publicKey
        });
        return key;
    });
const $5bb7220e37bd460f$export$5141469bb906af38 = ({ publicKey: publicKey, accountId: accountId, network: network })=>$5bb7220e37bd460f$var$__awaiter(void 0, void 0, void 0, function*() {
        const { permission: permission } = yield $5bb7220e37bd460f$var$fetchAllUserKeys({
            accountId: accountId,
            network: network,
            publicKey: publicKey
        });
        return permission === "FullAccess";
    });
// TODO: Remove from `core-js@4` since it's moved to entry points
var $5bb7220e37bd460f$var$uncurryThis$2 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$defineBuiltIn = $5bb7220e37bd460f$var$defineBuiltIn$8;
var $5bb7220e37bd460f$var$regexpExec$2 = $5bb7220e37bd460f$var$regexpExec$3;
var $5bb7220e37bd460f$var$fails$1 = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$wellKnownSymbol = $5bb7220e37bd460f$var$wellKnownSymbol$j;
var $5bb7220e37bd460f$var$createNonEnumerableProperty = $5bb7220e37bd460f$var$createNonEnumerableProperty$8;
var $5bb7220e37bd460f$var$SPECIES = $5bb7220e37bd460f$var$wellKnownSymbol("species");
var $5bb7220e37bd460f$var$RegExpPrototype = RegExp.prototype;
var $5bb7220e37bd460f$var$fixRegexpWellKnownSymbolLogic = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $5bb7220e37bd460f$var$wellKnownSymbol(KEY);
    var DELEGATES_TO_SYMBOL = !$5bb7220e37bd460f$var$fails$1(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$5bb7220e37bd460f$var$fails$1(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$5bb7220e37bd460f$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $5bb7220e37bd460f$var$uncurryThis$2(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $5bb7220e37bd460f$var$uncurryThis$2(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $5bb7220e37bd460f$var$regexpExec$2 || $exec === $5bb7220e37bd460f$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $5bb7220e37bd460f$var$defineBuiltIn(String.prototype, KEY, methods[0]);
        $5bb7220e37bd460f$var$defineBuiltIn($5bb7220e37bd460f$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $5bb7220e37bd460f$var$createNonEnumerableProperty($5bb7220e37bd460f$var$RegExpPrototype[SYMBOL], "sham", true);
};
var $5bb7220e37bd460f$var$uncurryThis$1 = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$toIntegerOrInfinity = $5bb7220e37bd460f$var$toIntegerOrInfinity$6;
var $5bb7220e37bd460f$var$toString$1 = $5bb7220e37bd460f$var$toString$5;
var $5bb7220e37bd460f$var$requireObjectCoercible$1 = $5bb7220e37bd460f$var$requireObjectCoercible$6;
var $5bb7220e37bd460f$var$charAt$1 = $5bb7220e37bd460f$var$uncurryThis$1("".charAt);
var $5bb7220e37bd460f$var$charCodeAt = $5bb7220e37bd460f$var$uncurryThis$1("".charCodeAt);
var $5bb7220e37bd460f$var$stringSlice$1 = $5bb7220e37bd460f$var$uncurryThis$1("".slice);
var $5bb7220e37bd460f$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $5bb7220e37bd460f$var$toString$1($5bb7220e37bd460f$var$requireObjectCoercible$1($this));
        var position = $5bb7220e37bd460f$var$toIntegerOrInfinity(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $5bb7220e37bd460f$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $5bb7220e37bd460f$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $5bb7220e37bd460f$var$charAt$1(S, position) : first : CONVERT_TO_STRING ? $5bb7220e37bd460f$var$stringSlice$1(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var $5bb7220e37bd460f$var$stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $5bb7220e37bd460f$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $5bb7220e37bd460f$var$createMethod(true)
};
var $5bb7220e37bd460f$var$charAt = $5bb7220e37bd460f$var$stringMultibyte.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var $5bb7220e37bd460f$var$advanceStringIndex$1 = function(S, index, unicode) {
    return index + (unicode ? $5bb7220e37bd460f$var$charAt(S, index).length : 1);
};
var $5bb7220e37bd460f$var$call$1 = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$anObject$1 = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$isCallable = $5bb7220e37bd460f$var$isCallable$n;
var $5bb7220e37bd460f$var$classof = $5bb7220e37bd460f$var$classofRaw$1;
var $5bb7220e37bd460f$var$regexpExec$1 = $5bb7220e37bd460f$var$regexpExec$3;
var $5bb7220e37bd460f$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var $5bb7220e37bd460f$var$regexpExecAbstract = function(R, S) {
    var exec = R.exec;
    if ($5bb7220e37bd460f$var$isCallable(exec)) {
        var result = $5bb7220e37bd460f$var$call$1(exec, R, S);
        if (result !== null) $5bb7220e37bd460f$var$anObject$1(result);
        return result;
    }
    if ($5bb7220e37bd460f$var$classof(R) === "RegExp") return $5bb7220e37bd460f$var$call$1($5bb7220e37bd460f$var$regexpExec$1, R, S);
    throw $5bb7220e37bd460f$var$$TypeError("RegExp#exec called on incompatible receiver");
};
var $5bb7220e37bd460f$var$apply = $5bb7220e37bd460f$var$functionApply;
var $5bb7220e37bd460f$var$call = $5bb7220e37bd460f$var$functionCall;
var $5bb7220e37bd460f$var$uncurryThis = $5bb7220e37bd460f$var$functionUncurryThis;
var $5bb7220e37bd460f$var$fixRegExpWellKnownSymbolLogic = $5bb7220e37bd460f$var$fixRegexpWellKnownSymbolLogic;
var $5bb7220e37bd460f$var$isRegExp = $5bb7220e37bd460f$var$isRegexp;
var $5bb7220e37bd460f$var$anObject = $5bb7220e37bd460f$var$anObject$e;
var $5bb7220e37bd460f$var$requireObjectCoercible = $5bb7220e37bd460f$var$requireObjectCoercible$6;
var $5bb7220e37bd460f$var$speciesConstructor = $5bb7220e37bd460f$var$speciesConstructor$3;
var $5bb7220e37bd460f$var$advanceStringIndex = $5bb7220e37bd460f$var$advanceStringIndex$1;
var $5bb7220e37bd460f$var$toLength = $5bb7220e37bd460f$var$toLength$6;
var $5bb7220e37bd460f$var$toString = $5bb7220e37bd460f$var$toString$5;
var $5bb7220e37bd460f$var$getMethod = $5bb7220e37bd460f$var$getMethod$4;
var $5bb7220e37bd460f$var$arraySlice = $5bb7220e37bd460f$var$arraySliceSimple;
var $5bb7220e37bd460f$var$callRegExpExec = $5bb7220e37bd460f$var$regexpExecAbstract;
var $5bb7220e37bd460f$var$regexpExec = $5bb7220e37bd460f$var$regexpExec$3;
var $5bb7220e37bd460f$var$stickyHelpers = $5bb7220e37bd460f$var$regexpStickyHelpers;
var $5bb7220e37bd460f$var$fails = $5bb7220e37bd460f$var$fails$s;
var $5bb7220e37bd460f$var$UNSUPPORTED_Y = $5bb7220e37bd460f$var$stickyHelpers.UNSUPPORTED_Y;
var $5bb7220e37bd460f$var$MAX_UINT32 = 0xFFFFFFFF;
var $5bb7220e37bd460f$var$min = Math.min;
var $5bb7220e37bd460f$var$$push = [].push;
var $5bb7220e37bd460f$var$exec = $5bb7220e37bd460f$var$uncurryThis(/./.exec);
var $5bb7220e37bd460f$var$push = $5bb7220e37bd460f$var$uncurryThis($5bb7220e37bd460f$var$$push);
var $5bb7220e37bd460f$var$stringSlice = $5bb7220e37bd460f$var$uncurryThis("".slice);
// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var $5bb7220e37bd460f$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !$5bb7220e37bd460f$var$fails(function() {
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    var re = /(?:)/;
    var originalExec = re.exec;
    re.exec = function() {
        return originalExec.apply(this, arguments);
    };
    var result = "ab".split(re);
    return result.length !== 2 || result[0] !== "a" || result[1] !== "b";
});
// @@split logic
$5bb7220e37bd460f$var$fixRegExpWellKnownSymbolLogic("split", function(SPLIT, nativeSplit, maybeCallNative) {
    var internalSplit;
    if ("abbc".split(/(b)*/)[1] == "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
    "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
    ".".split(/()()/).length > 1 || "".split(/.?/).length) // based on es5-shim implementation, need to rework it
    internalSplit = function(separator, limit) {
        var string = $5bb7220e37bd460f$var$toString($5bb7220e37bd460f$var$requireObjectCoercible(this));
        var lim = limit === undefined ? $5bb7220e37bd460f$var$MAX_UINT32 : limit >>> 0;
        if (lim === 0) return [];
        if (separator === undefined) return [
            string
        ];
        // If `separator` is not a regex, use native split
        if (!$5bb7220e37bd460f$var$isRegExp(separator)) return $5bb7220e37bd460f$var$call(nativeSplit, string, separator, lim);
        var output = [];
        var flags = (separator.ignoreCase ? "i" : "") + (separator.multiline ? "m" : "") + (separator.unicode ? "u" : "") + (separator.sticky ? "y" : "");
        var lastLastIndex = 0;
        // Make `global` and avoid `lastIndex` issues by working with a copy
        var separatorCopy = new RegExp(separator.source, flags + "g");
        var match, lastIndex, lastLength;
        while(match = $5bb7220e37bd460f$var$call($5bb7220e37bd460f$var$regexpExec, separatorCopy, string)){
            lastIndex = separatorCopy.lastIndex;
            if (lastIndex > lastLastIndex) {
                $5bb7220e37bd460f$var$push(output, $5bb7220e37bd460f$var$stringSlice(string, lastLastIndex, match.index));
                if (match.length > 1 && match.index < string.length) $5bb7220e37bd460f$var$apply($5bb7220e37bd460f$var$$push, output, $5bb7220e37bd460f$var$arraySlice(match, 1));
                lastLength = match[0].length;
                lastLastIndex = lastIndex;
                if (output.length >= lim) break;
            }
            if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
        }
        if (lastLastIndex === string.length) {
            if (lastLength || !$5bb7220e37bd460f$var$exec(separatorCopy, "")) $5bb7220e37bd460f$var$push(output, "");
        } else $5bb7220e37bd460f$var$push(output, $5bb7220e37bd460f$var$stringSlice(string, lastLastIndex));
        return output.length > lim ? $5bb7220e37bd460f$var$arraySlice(output, 0, lim) : output;
    };
    else if ("0".split(undefined, 0).length) internalSplit = function(separator, limit) {
        return separator === undefined && limit === 0 ? [] : $5bb7220e37bd460f$var$call(nativeSplit, this, separator, limit);
    };
    else internalSplit = nativeSplit;
    return [
        // `String.prototype.split` method
        // https://tc39.es/ecma262/#sec-string.prototype.split
        function split(separator, limit) {
            var O = $5bb7220e37bd460f$var$requireObjectCoercible(this);
            var splitter = separator == undefined ? undefined : $5bb7220e37bd460f$var$getMethod(separator, SPLIT);
            return splitter ? $5bb7220e37bd460f$var$call(splitter, separator, O, limit) : $5bb7220e37bd460f$var$call(internalSplit, $5bb7220e37bd460f$var$toString(O), separator, limit);
        },
        // `RegExp.prototype[@@split]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
        //
        // NOTE: This cannot be properly polyfilled in engines that don't support
        // the 'y' flag.
        function(string, limit) {
            var rx = $5bb7220e37bd460f$var$anObject(this);
            var S = $5bb7220e37bd460f$var$toString(string);
            var res = maybeCallNative(internalSplit, rx, S, limit, internalSplit !== nativeSplit);
            if (res.done) return res.value;
            var C = $5bb7220e37bd460f$var$speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? "i" : "") + (rx.multiline ? "m" : "") + (rx.unicode ? "u" : "") + ($5bb7220e37bd460f$var$UNSUPPORTED_Y ? "g" : "y");
            // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.
            var splitter = new C($5bb7220e37bd460f$var$UNSUPPORTED_Y ? "^(?:" + rx.source + ")" : rx, flags);
            var lim = limit === undefined ? $5bb7220e37bd460f$var$MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return $5bb7220e37bd460f$var$callRegExpExec(splitter, S) === null ? [
                S
            ] : [];
            var p = 0;
            var q = 0;
            var A = [];
            while(q < S.length){
                splitter.lastIndex = $5bb7220e37bd460f$var$UNSUPPORTED_Y ? 0 : q;
                var z = $5bb7220e37bd460f$var$callRegExpExec(splitter, $5bb7220e37bd460f$var$UNSUPPORTED_Y ? $5bb7220e37bd460f$var$stringSlice(S, q) : S);
                var e;
                if (z === null || (e = $5bb7220e37bd460f$var$min($5bb7220e37bd460f$var$toLength(splitter.lastIndex + ($5bb7220e37bd460f$var$UNSUPPORTED_Y ? q : 0)), S.length)) === p) q = $5bb7220e37bd460f$var$advanceStringIndex(S, q, unicodeMatching);
                else {
                    $5bb7220e37bd460f$var$push(A, $5bb7220e37bd460f$var$stringSlice(S, p, q));
                    if (A.length === lim) return A;
                    for(var i = 1; i <= z.length - 1; i++){
                        $5bb7220e37bd460f$var$push(A, z[i]);
                        if (A.length === lim) return A;
                    }
                    q = p = e;
                }
            }
            $5bb7220e37bd460f$var$push(A, $5bb7220e37bd460f$var$stringSlice(S, p));
            return A;
        }
    ];
}, !$5bb7220e37bd460f$var$SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, $5bb7220e37bd460f$var$UNSUPPORTED_Y);
var $5bb7220e37bd460f$var$modal$b = {
    wallet: {
        connectYourWallet: "Connect Your Wallet",
        whatIsAWallet: "What is a Wallet?",
        secureAndManage: "Secure & Manage Your Digital Assets",
        safelyStore: "Safely store and transfer your crypto and NFTs.",
        logInToAny: "Log In to Any NEAR App",
        noNeedToCreate: "No need to create new accounts or credentials. Connect your wallet and you are good to go!",
        getAWallet: "Get a Wallet",
        useAWallet: "Use a wallet to secure and manage your NEAR assets, and to log in to any NEAR app without the need for usernames and passwords.",
        connectionFailed: "Connection Failed",
        connectionSuccessful: "Connection Successful",
        connected: "Connected",
        connectingTo: "Connecting to",
        connectingMessage: {
            injected: "Confirm the connection in the extension window",
            browser: "Confirm the connection in the wallet after redirect",
            hardware: "Confirm the connection in the ledger device",
            bridge: "Confirm the connection in the wallet"
        }
    },
    ledger: {
        connectWithLedger: "Connect with Ledger",
        makeSureYourLedger: "Make sure your Ledger is connected securely, and that the NEAR app is open on your device",
        "continue": "Continue",
        specifyHDPath: "Specify HD Path",
        enterYourPreferredHDPath: "Enter your preferred HD path, then scan for any active accounts.",
        scan: "Scan",
        retry: "Retry",
        ledgerIsNotAvailable: "Ledger is not available",
        accessDeniedToUseLedgerDevice: "Access denied to use Ledger device",
        noAccountsFound: "No Accounts Found",
        selectYourAccounts: "Select Your Accounts",
        connecting1Account: "Connecting 1 Account",
        cantFindAnyAccount: "Can't find any account associated with this Ledger. Please create a new NEAR account on",
        orConnectAnAnotherLedger: "or connect an another Ledger.",
        connecting: "Connecting",
        ofAccounts: "of Accounts",
        failedToAutomatically: "Failed to automatically find account id. Provide it manually:",
        overviewTheListOfAuthorized: "Overview the list of authorized account(s), complete sign in by clicking the button below.",
        finish: "Finish"
    },
    install: {
        youllNeedToInstall: "You'll need to install",
        toContinueAfterInstalling: "to continue. After installing",
        refreshThePage: "refresh the page.",
        open: "Open"
    },
    qr: {
        copiedToClipboard: "Copied to clipboard",
        failedToCopy: "Failed to copy to clipboard",
        scanWithYourMobile: "Scan with Your Mobile Device",
        copyToClipboard: " Copy to clipboard",
        preferTheOfficial: "Prefer the official dialogue of",
        open: "Open"
    },
    walletTypes: {
        hardware: "Hardware Wallet",
        browser: "Browser Wallet",
        injected: "Wallet Extension",
        bridge: "Bridge Wallet",
        mobile: "Mobile Wallet",
        "instant-link": "Instant Wallet"
    },
    exportAccounts: {
        chooseAWallet: "Choose a Wallet",
        transferYourAccounts: "Transfer Your Accounts",
        selectAWallet: "Select a wallet that fits your needs and supports your connected accounts.",
        selectYourAccounts: "Select Your Accounts",
        afterDecide: "After you decide on a wallet, you can select which accounts you want to transfer.",
        disclaimer: "You won\u2019t be able to transfer accounts that have never been funded or used on NEAR.",
        warning: "does not support account export at this time. Please select another wallet.",
        walletTypes: {
            hardware: "Hardware Wallet",
            browser: "Browser Wallet",
            injected: "Wallet Extension",
            bridge: "Bridge Wallet",
            mobile: "Mobile Wallet"
        },
        selectAccounts: {
            title: "Select Accounts to Transfer",
            button: "Continue",
            deselectAll: "Deselect All",
            selectAll: "Select All",
            unavailable: "Transfer Unavailable",
            error: "Account does not exist",
            warningLedger: "Ledger support required",
            noBalance: "Account not funded"
        },
        getPassphrase: {
            title: "Copy Temporary Password",
            desc: "You\u2019ll need to enter this password when you begin exporting your accounts to a different wallet.",
            button: "Continue",
            transferButton: "Transfer Accounts",
            label: "Click to Copy",
            checkLabel: "I copied or wrote down the password"
        },
        complete: {
            title: "Complete the Transfer",
            descOne: "You will now be redirected to the wallet you selected to complete the transfer.",
            descTwo: "Once import part of process is completed from selected wallet, press button to complete the transfer process.",
            startOverButton: "Start Over",
            button: "Complete"
        }
    }
};
var $5bb7220e37bd460f$var$component$1 = {
    clickToCopy: {
        label: "Copied",
        tooltip: "Click to copy"
    }
};
var $5bb7220e37bd460f$var$en = {
    modal: $5bb7220e37bd460f$var$modal$b,
    component: $5bb7220e37bd460f$var$component$1
};
var $5bb7220e37bd460f$var$modal$a = {
    wallet: {
        connectYourWallet: "Conecta Tu Billetera",
        whatIsAWallet: "\xbfQue es una Billetera?",
        secureAndManage: "Resguarda y Administrar Tus Activos Digitales",
        safelyStore: "Almacena de forma segura y transfiere tus cryptos y NFT's",
        logInToAny: "Inicie sesi\xf3n en Cualquier Aplicacion NEAR",
        noNeedToCreate: "No es necesario crear nuevas cuentas o credenciales, \xa1Conecta tu billetera y listo!",
        getAWallet: "Obten una Billetera",
        useAWallet: "Usa tu Billetera para resguardar y administrar tus activos en NEAR, e Iniciar sesi\xf3n en cualquier aplicacion NEAR sin la necesidad de nombres de usuarios y contrase\xf1as",
        connectionFailed: "Conexi\xf3n Fallida",
        connectionSuccessful: "Conexi\xf3n Existosa",
        connected: "Conectado",
        connectingTo: "Conectando a ",
        connectingMessage: {
            injected: "Confirme la conexi\xf3n en la ventana de extensi\xf3n",
            browser: "Confirme la conexi\xf3n en la billetera despu\xe9s de la redirecci\xf3n",
            hardware: "Confirme la conexi\xf3n en el dispositivo de libro mayor",
            bridge: "Confirmar la conexi\xf3n en la billetera"
        }
    },
    ledger: {
        connectWithLedger: "Conectar con Ledger",
        makeSureYourLedger: "Aseg\xfarese de que su ledger est\xe1 conectada de forma segura y que la aplicacion NEAR est\xe9 abierta en su dispositivo",
        "continue": "Continuar",
        specifyHDPath: "Especifique la ruta HD",
        enterYourPreferredHDPath: "Ingrese su ruta HD prerida,y luego busque cualquier cuenta activa.",
        scan: "Escanear",
        retry: "Reintentar",
        ledgerIsNotAvailable: "El Ledger no est\xe1 disponible",
        accessDeniedToUseLedgerDevice: "Acceso denegado para usar el dispositivo ledger",
        noAccountsFound: "No se encontraron cuentas",
        selectYourAccounts: "Selecciona tus cuentas",
        connecting1Account: "Conectando a 1 cuenta",
        cantFindAnyAccount: "No se pudo encontrar ninguna cuenta asociada con este ledger,Por favor crea una nueva cuenta en NEAR",
        orConnectAnAnotherLedger: "o conecta otro ledger",
        connecting: "Conectando",
        ofAccounts: "de Cuentas",
        failedToAutomatically: "No se pudo encontrar automaticamente el id de la cuenta,Ingresalo manualmente:",
        overviewTheListOfAuthorized: "Revise la lista de las cuentas autorizadas,Complete el inicio de sesi\xf3n haciedo click a countinuacion.",
        finish: "Finalizar"
    },
    install: {
        youllNeedToInstall: "Tendr\xe1s que instalar",
        toContinueAfterInstalling: "Para continuar, Despues de instalar",
        refreshThePage: "Recarga la pagina",
        open: "Abrir"
    },
    qr: {
        copiedToClipboard: "Copiado al Portapapeles",
        failedToCopy: "Fall\xf3 la copia al Portapapeles",
        scanWithYourMobile: "Busca con tu dispositivo movil",
        copyToClipboard: " Copiar al Portapapeles",
        preferTheOfficial: "\xbfPrefires el di\xe1logo oficial de",
        open: "Abrir"
    },
    walletTypes: {
        hardware: "Hardware Wallet",
        browser: "Browser Wallet",
        injected: "Wallet Extension",
        bridge: "Bridge Wallet",
        mobile: "Mobile Wallet",
        "instant-link": "Instant Wallet"
    }
};
var $5bb7220e37bd460f$var$es = {
    modal: $5bb7220e37bd460f$var$modal$a
};
var $5bb7220e37bd460f$var$modal$9 = {
    wallet: {
        connectYourWallet: "\u8FDE\u63A5\u4F60\u7684\u94B1\u5305",
        whatIsAWallet: "\u4EC0\u4E48\u662F\u94B1\u5305\uFF1F",
        secureAndManage: "\u4FDD\u62A4\u548C\u7BA1\u7406\u4F60\u7684\u6570\u5B57\u8D44\u4EA7",
        safelyStore: "\u5B89\u5168\u5B58\u50A8\u548C\u8F6C\u79FB\u4F60\u7684\u52A0\u5BC6\u8D27\u5E01\u548CNFT",
        logInToAny: "\u767B\u5F55\u4EFB\u4F55 NEAR \u5E94\u7528",
        noNeedToCreate: "\u4E0D\u9700\u8981\u521B\u5EFA\u65B0\u8D26\u6237\u6216\u5BC6\u7801\u3002\u8FDE\u63A5\u4F60\u7684\u94B1\u5305\uFF0C\u5373\u53EF\u5F00\u59CB\u4F7F\u7528\uFF01",
        getAWallet: "\u83B7\u53D6\u65B0\u8D26\u6237",
        useAWallet: "\u4F7F\u7528\u94B1\u5305\u6765\u4FDD\u62A4\u548C\u7BA1\u7406\u4F60\u7684 NEAR \u8D44\u4EA7\uFF0C\u65E0\u9700\u7528\u6237\u540D\u548C\u5BC6\u7801\u5373\u53EF\u767B\u5F55\u4EFB\u4F55 NEAR \u5E94\u7528",
        connectionFailed: "\u8FDE\u63A5\u5931\u8D25",
        connectionSuccessful: "\u8FDE\u63A5\u6210\u529F",
        connected: "\u5DF2\u8FDE\u63A5",
        connectingTo: "\u6B63\u5728\u8FDE\u63A5"
    },
    ledger: {
        connectWithLedger: "\u8FDE\u63A5 Ledger",
        makeSureYourLedger: "\u786E\u4FDD\u4F60\u7684 Ledger \u5DF2\u7ECF\u5B89\u5168\u8FDE\u63A5\uFF0C\u5E76\u4E14 NEAR \u5E94\u7528\u5DF2\u7ECF\u5728\u4F60\u8BBE\u5907\u4E0A\u6253\u5F00",
        "continue": "\u7EE7\u7EED",
        specifyHDPath: "\u6307\u5B9A HD \u8DEF\u5F84",
        enterYourPreferredHDPath: "\u8F93\u5165\u4F60\u504F\u597D\u7684 HD \u8DEF\u5F84\uFF0C\u7136\u540E\u4E3A\u4EFB\u610F\u6D3B\u8DC3\u8D26\u6237\u626B\u7801",
        scan: "\u626B\u7801",
        retry: "\u91CD\u8BD5",
        ledgerIsNotAvailable: "Ledger \u4E0D\u53EF\u7528",
        accessDeniedToUseLedgerDevice: "\u8BBF\u95EE Ledger \u8BBE\u5907\u88AB\u62D2\u7EDD",
        noAccountsFound: "\u6CA1\u6709\u627E\u5230\u8D26\u6237",
        selectYourAccounts: "\u9009\u62E9\u4F60\u7684\u8D26\u6237",
        connecting1Account: "\u6B63\u5728\u8FDE\u63A51\u4E2A\u8D26\u6237",
        cantFindAnyAccount: "\u6CA1\u6709\u627E\u5230\u4EFB\u4F55\u4E0E\u8FD9\u4E2A Ledger \u76F8\u5173\u8054\u7684\u8D26\u6237\u3002\u8BF7\u521B\u5EFA\u65B0\u8D26\u6237\u4E8E",
        "orConnectAnAnotherLedger.": "\u6216\u8FDE\u63A5\u53E6\u4E00\u4E2A Ledger",
        connecting: "\u6B63\u5728\u8FDE\u63A5",
        ofAccounts: "\u4E2A\u8D26\u6237",
        failedToAutomatically: "\u65E0\u6CD5\u81EA\u52A8\u627E\u5230\u8D26\u6237ID\uFF0C\u8BF7\u4E3B\u52A8\u63D0\u4F9B\uFF1A",
        overviewTheListOfAuthorized: "\u8BF7\u67E5\u770B\u5DF2\u6388\u6743\u7684\u8D26\u6237\u5217\u8868\uFF0C\u70B9\u51FB\u4EE5\u4E0B\u6309\u94AE\u5B8C\u6210\u767B\u5F55",
        finish: "\u5B8C\u6210"
    },
    install: {
        youllNeedToInstall: "\u4F60\u5C06\u9700\u8981\u5B89\u88C5",
        toContinueAfterInstalling: "\u4EE5\u7EE7\u7EED\u3002\u5B89\u88C5\u5B8C",
        refreshThePage: "\u8BF7\u5237\u65B0\u9875\u9762",
        open: "\u6253\u5F00"
    },
    qr: {
        copiedToClipboard: "\u590D\u5236\u5230\u4E86\u526A\u8D34\u677F",
        failedToCopy: "\u590D\u5236\u5230\u526A\u8D34\u677F\u5931\u8D25",
        scanWithYourMobile: "\u7528\u4F60\u7684\u79FB\u52A8\u8BBE\u5907\u626B\u7801",
        copyToClipboard: " \u590D\u5236\u5230\u526A\u8D34\u677F",
        preferTheOfficial: "\u5E0C\u671B\u4F7F\u7528\u5B98\u65B9\u5BF9\u8BDD\u6846\u4E8E",
        open: "\u6253\u5F00"
    },
    walletTypes: {
        hardware: "Hardware Wallet",
        browser: "Browser Wallet",
        injected: "Wallet Extension",
        bridge: "Bridge Wallet",
        mobile: "Mobile Wallet",
        "instant-link": "Instant Wallet"
    }
};
var $5bb7220e37bd460f$var$zh = {
    modal: $5bb7220e37bd460f$var$modal$9
};
var $5bb7220e37bd460f$var$modal$8 = {
    wallet: {
        connectYourWallet: "\u0421\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u044F \u041F\u043E\u0440\u0442\u0444\u0435\u0439\u043B",
        whatIsAWallet: "\u041A\u0430\u043A\u0432\u043E \u0435 \u041F\u043E\u0440\u0442\u0444\u0435\u0439\u043B?",
        secureAndManage: "\u0417\u0430\u0449\u0438\u0442\u0435\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0432\u0430\u0439\u0442\u0435 \u0434\u0438\u0433\u0438\u0442\u0430\u043B\u043D\u0438\u0442\u0435 \u0441\u0438 \u0430\u043A\u0442\u0438\u0432\u0438",
        safelyStore: "\u0421\u044A\u0445\u0440\u0430\u043D\u044F\u0432\u0430\u0439\u0442\u0435 \u0438 \u043F\u0440\u0435\u0445\u0432\u044A\u0440\u043B\u044F\u0439\u0442\u0435 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E \u0432\u0430\u0448\u0438\u0442\u0435 \u043A\u0440\u0438\u043F\u0442\u043E \u0438 NFT.",
        logInToAny: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u0432\u0441\u044F\u043A\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 NEAR",
        noNeedToCreate: "\u041D\u044F\u043C\u0430 \u043D\u0443\u0436\u0434\u0430 \u0434\u0430 \u0441\u044A\u0437\u0434\u0430\u0432\u0430\u0442\u0435 \u043D\u043E\u0432\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0438. \u0421\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0430 \u0441\u0438 \u0438 \u0441\u0442\u0435 \u0433\u043E\u0442\u043E\u0432\u0438!",
        getAWallet: "\u0421\u044A\u0437\u0434\u0430\u0439\u0442\u0435 \u041F\u043E\u0440\u0442\u0444\u0435\u0439\u043B",
        useAWallet: "\u0418\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0439\u0442\u0435 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0430, \u0437\u0430 \u0434\u0430 \u0437\u0430\u0449\u0438\u0442\u0438\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0432\u0430\u0442\u0435 \u0430\u043A\u0442\u0438\u0432\u0438\u0442\u0435 \u0441\u0438 \u043D\u0430 NEAR \u043A\u0430\u043A\u0442\u043E \u0438 \u0434\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u0442\u0435 \u0432\u0441\u044F\u043A\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043D\u0430 NEAR \u0431\u0435\u0437 \u043D\u0443\u0436\u0434\u0430 \u043E\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u0438 \u0438\u043C\u0435\u043D\u0430 \u0438 \u043F\u0430\u0440\u043E\u043B\u0438.",
        connectionFailed: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u043D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E",
        connectionSuccessful: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u0443\u0441\u043F\u0435\u0448\u043D\u043E",
        connected: "\u0421\u0432\u044A\u0440\u0437\u0430\u043D",
        connectingTo: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435 \u043A\u044A\u043C",
        connectingMessage: {
            injected: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u0432 \u043F\u0440\u043E\u0437\u043E\u0440\u0435\u0446\u0430 \u043D\u0430 \u0440\u0430\u0437\u0448\u0438\u0440\u0435\u043D\u0438\u0435\u0442\u043E",
            browser: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u0432 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0430 \u0441\u043B\u0435\u0434 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0432\u0430\u043D\u0435\u0442\u043E",
            hardware: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0441\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435\u0442\u043E \u0432 \u0445\u0430\u0440\u0434\u0443\u0435\u0440\u043D\u0438\u044F \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B",
            bridge: "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u0442\u0435 \u0432\u0440\u044A\u0437\u043A\u0430\u0442\u0430 \u0432 \u043F\u043E\u0440\u0442\u0444\u0435\u0439\u043B\u0430"
        }
    },
    ledger: {
        connectWithLedger: "\u0421\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0441\u0435 \u0441 Ledger",
        makeSureYourLedger: "\u0423\u0432\u0435\u0440\u0435\u0442\u0435 \u0441\u0435, \u0447\u0435 \u0432\u0430\u0448\u0438\u044F\u0442 Ledger \u0435 \u0441\u0432\u044A\u0440\u0437\u0430\u043D \u0438 \u0447\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u0442\u043E NEAR \u0435 \u043E\u0442\u0432\u043E\u0440\u0435\u043D\u043E \u043Da \u043D\u0435\u0433\u043E.",
        "continue": "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0435\u0442\u0435",
        specifyHDPath: "\u041F\u043E\u0441\u043E\u0447\u0435\u0442\u0435 HD \u043F\u044A\u0442",
        enterYourPreferredHDPath: "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043F\u0440\u0435\u0434\u043F\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u044F HD \u043F\u044A\u0442, \u0441\u043B\u0435\u0434 \u043A\u043E\u0435\u0442\u043E \u0441\u043A\u0430\u043D\u0438\u0440\u0430\u0439\u0442\u0435 \u0437\u0430 \u0430\u043A\u0442\u0438\u0432\u043D\u0438 \u0430\u043A\u0430\u0443\u043D\u0442\u0438.",
        scan: "\u0421\u043A\u0430\u043D\u0438\u0440\u0430\u0439\u0442\u0435",
        retry: "\u041E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043E\u0442\u043D\u043E\u0432\u043E",
        ledgerIsNotAvailable: "Ledger \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E\u0442\u043E \u043D\u0435 \u0435 \u0434\u043E\u0441\u0442\u044A\u043F\u043D\u043E",
        accessDeniedToUseLedgerDevice: "\u0414\u043E\u0441\u0442\u044A\u043F\u044A\u0442 \u0437\u0430 \u0438\u0437\u043F\u043E\u043B\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 Ledger \u0435 \u043E\u0442\u043A\u0430\u0437\u0430\u043D",
        noAccountsFound: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0438",
        selectYourAccounts: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0432\u0430\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0444\u0438\u043B\u0438",
        connecting1Account: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 1 \u043F\u0440\u043E\u0444\u0438\u043B",
        cantFindAnyAccount: "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0438, \u0441\u044A\u0432\u0440\u0437\u0430\u043D\u0438 \u0441 \u0442\u043E\u0437\u0438 Ledger. \u041C\u043E\u043B\u044F, \u0441\u044A\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432 NEAR \u043F\u0440\u043E\u0444\u0438\u043B \u043D\u0430",
        orConnectAnAnotherLedger: "\u0438\u043B\u0438 \u0441\u0432\u044A\u0440\u0436\u0435\u0442\u0435 \u0434\u0440\u0443\u0433 Ledger.",
        connecting: "\u0421\u0432\u044A\u0440\u0437\u0432\u0430\u043D\u0435",
        ofAccounts: "\u043E\u0442 \u043F\u0440\u043E\u0444\u0438\u043B\u0438",
        failedToAutomatically: "\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u043D\u043E\u0442\u043E \u043D\u0430\u043C\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u0440\u043E\u0444\u0438\u043B\u0430 \u043D\u0435 \u0431\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E. \u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u0433\u043E \u0440\u044A\u0447\u043D\u043E:",
        overviewTheListOfAuthorized: "\u041F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0439\u0442\u0435 \u0441\u043F\u0438\u0441\u044A\u043A\u0430 \u0441 \u0443\u043F\u044A\u043B\u043D\u043E\u043C\u043E\u0449\u0435\u043D\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0438, \u0437\u0430\u0432\u044A\u0440\u0448\u0435\u0442\u0435 \u0432\u043B\u0438\u0437\u0430\u043D\u0435\u0442\u043E, \u043A\u0430\u0442\u043E \u0449\u0440\u0430\u043A\u043D\u0435\u0442\u0435 \u0432\u044A\u0440\u0445\u0443 \u0431\u0443\u0442\u043E\u043D\u0430 \u043F\u043E-\u0434\u043E\u043B\u0443..",
        finish: "\u0417\u0430\u0432\u044A\u0440\u0448\u0435\u0442\u0435"
    },
    install: {
        youllNeedToInstall: "\u0429\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u0442\u0435",
        toContinueAfterInstalling: "\u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435. \u0421\u043B\u0435\u0434 \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u043D\u0435",
        refreshThePage: "\u043F\u0440\u0435\u0437\u0430\u0440\u0435\u0434\u0435\u0442\u0435 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0442\u0430.",
        open: "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    qr: {
        copiedToClipboard: "\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E \u0432 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u0430",
        failedToCopy: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043A\u043E\u043F\u0438\u0440\u0430\u043D\u0435 \u0432 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u0430",
        scanWithYourMobile: " \u0421\u043A\u0430\u043D\u0438\u0440\u0430\u0439\u0442\u0435 \u0441 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0442\u043E \u0441\u0438 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E",
        copyToClipboard: " \u041A\u043E\u043F\u0438\u0440\u0430\u0439\u0442\u0435 \u0432 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u0430",
        preferTheOfficial: "\u041F\u0440\u0435\u0434\u043F\u043E\u0447\u0438\u0442\u0430\u043D \u0435\u0437\u0438\u043A \u0437\u0430 \u043A\u043E\u0440\u0435\u0441\u043F\u043E\u043D\u0434\u0435\u043D\u0446\u0438\u044F",
        open: "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    walletTypes: {
        hardware: "Hardware Wallet",
        browser: "Browser Wallet",
        injected: "Wallet Extension",
        bridge: "Bridge Wallet",
        mobile: "Mobile Wallet",
        "instant-link": "Instant Wallet"
    }
};
var $5bb7220e37bd460f$var$bg = {
    modal: $5bb7220e37bd460f$var$modal$8
};
var $5bb7220e37bd460f$var$modal$7 = {
    wallet: {
        connectYourWallet: "\uC9C0\uAC11 \uC5F0\uACB0\uD558\uAE30",
        whatIsAWallet: "\uC9C0\uAC11\uC740 \uBB34\uC2A8 \uC5ED\uD560\uC744 \uD558\uB098\uC694?",
        secureAndManage: "\uB2F9\uC2E0\uC758 \uB514\uC9C0\uD138 \uC790\uC0B0\uC744 \uBCF4\uD638\uD558\uACE0 \uAD00\uB9AC\uD569\uB2C8\uB2E4.",
        safelyStore: "\uC554\uD638\uD654\uD3D0\uC640 NFT\uB97C \uC548\uC804\uD558\uAC8C \uC800\uC7A5\uD558\uACE0 \uC804\uC1A1\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        logInToAny: "NEAR App\uC5D0 \uB85C\uADF8\uC778\uD569\uB2C8\uB2E4.",
        noNeedToCreate: "\uC0C8\uB85C\uC6B4 \uACC4\uC815\uC774\uB098 \uBE44\uBC00\uBC88\uD638\uB97C \uB9CC\uB4E4 \uD544\uC694 \uC5C6\uC774 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD55C \uD6C4 \uBC14\uB85C \uC0AC\uC6A9\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        getAWallet: "\uC9C0\uAC11 \uAC00\uC838\uC624\uAE30",
        useAWallet: "\uC9C0\uAC11\uC744 \uC0AC\uC6A9\uD558\uC5EC NEAR \uC790\uC0B0\uC744 \uBCF4\uD638\xb7\uAD00\uB9AC\uD558\uACE0, \uC544\uC774\uB514\uC640 \uBE44\uBC00\uBC88\uD638 \uC5C6\uC774 NEAR \uC571\uC5D0 \uB85C\uADF8\uC778\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        connectionFailed: "\uC5F0\uACB0 \uC2E4\uD328",
        connectionSuccessful: "\uC5F0\uACB0 \uC131\uACF5",
        connected: "Connected",
        connectingTo: "\uC5F0\uACB0 \uC911: ",
        connectingMessage: {
            injected: "\uC775\uC2A4\uD150\uC158 \uCC3D\uC5D0\uC11C \uC5F0\uACB0\uC744 \uD655\uC778\uD558\uC138\uC694",
            browser: "\uB9AC\uB2E4\uC774\uB809\uD2B8 \uB41C \uC9C0\uAC11\uC5D0\uC11C \uC5F0\uACB0\uC744 \uD655\uC778\uD558\uC138\uC694",
            hardware: "Ledger \uAE30\uAE30\uC5D0\uC11C \uC5F0\uACB0\uC744 \uD655\uC778\uD558\uC138\uC694",
            bridge: "\uC9C0\uAC11\uC5D0\uC11C \uC5F0\uACB0 \uD655\uC778"
        }
    },
    ledger: {
        connectWithLedger: "Ledger \uC5F0\uACB0\uD558\uAE30",
        makeSureYourLedger: "Ledger\uAC00 \uC548\uC804\uD558\uAC8C \uC5F0\uACB0\uB418\uC5B4 \uC788\uACE0, NEAR \uC571\uC774 \uC5F4\uB824 \uC788\uB294 \uC9C0 \uD655\uC778\uD558\uC138\uC694",
        "continue": "\uACC4\uC18D\uD558\uAE30",
        specifyHDPath: "HD Path \uC9C0\uC815\uD558\uAE30",
        enterYourPreferredHDPath: "\uC6D0\uD558\uB294 HD Path\uB97C \uC120\uD0DD\uD558\uACE0, \uD65C\uC131\uD654\uB41C \uACC4\uC815\uC774 \uC788\uB294 \uC9C0 \uAC80\uC0C9\uD558\uC138\uC694",
        scan: "\uAC80\uC0C9",
        retry: "\uB2E4\uC2DC \uC2DC\uB3C4",
        ledgerIsNotAvailable: "Ledger\uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
        accessDeniedToUseLedgerDevice: "Ledger \uAE30\uAE30 \uC811\uADFC \uAD8C\uD55C\uC774 \uAC70\uBD80\uB418\uC5C8\uC2B5\uB2C8\uB2E4",
        noAccountsFound: "\uACC4\uC815\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
        selectYourAccounts: "\uACC4\uC815 \uC120\uD0DD\uD558\uAE30",
        connecting1Account: "\uD558\uB098\uC758 \uACC4\uC815\uC5D0 \uC5F0\uACB0",
        cantFindAnyAccount: "Ledger\uC640 \uC5F0\uACB0\uB41C \uACC4\uC815\uC744 \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4. \uC0C8\uB85C\uC6B4 \uACC4\uC815\uC744 \uC0DD\uC131\uD558\uAC70\uB098 ",
        orConnectAnAnotherLedger: "\uB2E4\uB978 Ledger\uB97C \uC5F0\uACB0\uD558\uC138\uC694",
        connecting: "\uACC4\uC815 \uC5F0\uACB0\uD558\uAE30: ",
        ofAccounts: "\uAC1C \uACC4\uC815\uC744 \uCC3E\uC558\uC2B5\uB2C8\uB2E4",
        failedToAutomatically: "\uACC4\uC815 ID\uB97C \uCC3E\uC9C0 \uBABB\uD588\uC2B5\uB2C8\uB2E4. \uC218\uB3D9\uC73C\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694.",
        overviewTheListOfAuthorized: "\uC778\uC99D\uB41C \uACC4\uC815 \uBAA9\uB85D\uC744 \uD655\uC778\uD55C \uD6C4 \uC544\uB798 \uBC84\uD2BC\uC744 \uD074\uB9AD\uD558\uC5EC \uB85C\uADF8\uC778\uC744 \uC644\uB8CC\uD558\uC138\uC694",
        finish: "\uC644\uB8CC"
    },
    walletTypes: {
        hardware: "\uD558\uB4DC\uC6E8\uC5B4 \uC9C0\uAC11",
        browser: "\uBE0C\uB77C\uC6B0\uC800 \uC9C0\uAC11",
        injected: "\uC9C0\uAC11 \uD655\uC7A5",
        bridge: "\uBE0C\uB9AC\uC9C0 \uC9C0\uAC11",
        mobile: "\uBAA8\uBC14\uC77C \uC9C0\uAC11",
        "instant-link": "\uC778\uC2A4\uD134\uD2B8 \uC9C0\uAC11"
    },
    install: {
        youllNeedToInstall: "\uB2E4\uC74C \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD574\uC8FC\uC138\uC694:",
        toContinueAfterInstalling: ". \uC124\uCE58 \uC644\uB8CC \uD6C4 \uD398\uC774\uC9C0 \uC0C8\uB85C \uACE0\uCE68\uC774 \uD544\uC694\uD569\uB2C8\uB2E4. ",
        refreshThePage: "\uC0C8\uB85C \uACE0\uCE68",
        open: "Open"
    },
    qr: {
        copiedToClipboard: "\uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC \uC644\uB8CC",
        failedToCopy: "\uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC \uC2E4\uD328",
        scanWithYourMobile: "\uBAA8\uBC14\uC77C \uC7A5\uCE58\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC2A4\uCE94\uD574\uC8FC\uC138\uC694",
        copyToClipboard: " \uD074\uB9BD\uBCF4\uB4DC\uC5D0 \uBCF5\uC0AC\uD558\uAE30",
        preferTheOfficial: "\uB2E4\uC74C \uD504\uB85C\uADF8\uB7A8\uC5D0\uC11C \uC81C\uACF5\uD558\uB294 \uACF5\uC2DD \uD504\uB85C\uC138\uC2A4\uB97C \uC120\uD638\uD558\uC2ED\uB2C8\uAE4C: ",
        open: "Open"
    }
};
var $5bb7220e37bd460f$var$ko = {
    modal: $5bb7220e37bd460f$var$modal$7
};
var $5bb7220e37bd460f$var$modal$6 = {
    wallet: {
        connectYourWallet: "K\u1EBFt n\u1ED1i v\xed c\u1EE7a b\u1EA1n",
        whatIsAWallet: "V\xed l\xe0 g\xec?",
        secureAndManage: "B\u1EA3o m\u1EADt & Qu\u1EA3n l\xfd t\xe0i s\u1EA3n s\u1ED1 c\u1EE7a b\u1EA1n",
        safelyStore: "L\u01B0u tr\u1EEF v\xe0 chuy\u1EC3n ti\u1EC1n \u0111i\u1EC7n t\u1EED v\xe0 NFT c\u1EE7a b\u1EA1n m\u1ED9t c\xe1ch an to\xe0n.",
        logInToAny: "\u0110\u0103ng nh\u1EADp v\xe0o b\u1EA5t k\u1EF3 \u1EE9ng d\u1EE5ng tr\xean NEAR",
        noNeedToCreate: "Kh\xf4ng c\u1EA7n t\u1EA1o t\xe0i kho\u1EA3n ho\u1EB7c th\xf4ng tin \u0111\u0103ng nh\u1EADp m\u1EDBi. K\u1EBFt n\u1ED1i v\xed c\u1EE7a b\u1EA1n v\xe0 b\u1EAFt \u0111\u1EA7u!",
        getAWallet: "T\u1EA1o V\xed",
        useAWallet: "S\u1EED d\u1EE5ng v\xed \u0111\u1EC3 b\u1EA3o m\u1EADt v\xe0 qu\u1EA3n l\xfd t\xe0i s\u1EA3n tr\xean NEAR c\u1EE7a b\u1EA1n v\xe0 \u0111\u0103ng nh\u1EADp v\xe0o b\u1EA5t k\u1EF3 \u1EE9ng d\u1EE5ng NEAR n\xe0o, kh\xf4ng c\u1EA7n t\xean ng\u01B0\u1EDDi d\xf9ng v\xe0 m\u1EADt kh\u1EA9u.",
        connectionFailed: "K\u1EBFt n\u1ED1i th\u1EA5t b\u1EA1i",
        connectionSuccessful: "K\u1EBFt n\u1ED1i th\xe0nh c\xf4ng",
        connected: "\u0110\xe3 k\u1EBFt n\u1ED1i",
        connectingTo: "\u0110ang k\u1EBFt n\u1ED1i t\u1EDBi",
        connectingMessage: {
            injected: "X\xe1c nh\u1EADn k\u1EBFt n\u1ED1i trong c\u1EEDa s\u1ED5 ti\u1EC7n \xedch m\u1EDF r\u1ED9ng",
            browser: "X\xe1c nh\u1EADn k\u1EBFt n\u1ED1i trong v\xed sau khi \u0111\u01B0\u1EE3c chuy\u1EC3n h\u01B0\u1EDBng",
            hardware: "X\xe1c nh\u1EADn k\u1EBFt n\u1ED1i v\u1EDBi v\xed l\u1EA1nh",
            bridge: "X\xe1c nh\u1EADn k\u1EBFt n\u1ED1i trong v\xed"
        }
    },
    ledger: {
        connectWithLedger: "K\u1EBFt n\u1ED1i v\xed Ledger",
        makeSureYourLedger: "\u0110\u1EA3m b\u1EA3o Ledger c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c k\u1EBFt n\u1ED1i an to\xe0n v\xe0 \u1EE9ng d\u1EE5ng NEAR \u0111ang m\u1EDF s\u1EB5n tr\xean thi\u1EBFt b\u1ECB",
        "continue": "Ti\u1EBFp t\u1EE5c",
        specifyHDPath: "Ch\u1EC9 \u0111\u1ECBnh HD Path",
        enterYourPreferredHDPath: "Nh\u1EADp HD Path c\u1EE7a b\u1EA1n, sau \u0111\xf3 qu\xe9t t\xecm c\xe1c t\xe0i kho\u1EA3n ho\u1EA1t \u0111\u1ED9ng",
        scan: "Qu\xe9t",
        retry: "Th\u1EED l\u1EA1i",
        ledgerIsNotAvailable: "Ledger kh\xf4ng kh\u1EA3 d\u1EE5ng",
        accessDeniedToUseLedgerDevice: "Truy c\u1EADp Ledger b\u1ECB t\u1EEB ch\u1ED1i",
        noAccountsFound: "Kh\xf4ng t\xecm th\u1EA5y t\xe0i kho\u1EA3n",
        selectYourAccounts: "Ch\u1ECDn t\xe0i kho\u1EA3n c\u1EE7a b\u1EA1n",
        connecting1Account: "\u0110ang k\u1EBFt n\u1ED1i 1 t\xe0i kho\u1EA3n",
        cantFindAnyAccount: "Kh\xf4ng th\u1EC3 t\xecm th\u1EA5y b\u1EA5t k\u1EF3 t\xe0i kho\u1EA3n n\xe0o \u0111\u01B0\u1EE3c li\xean k\u1EBFt v\u1EDBi Ledger n\xe0y. Vui l\xf2ng t\u1EA1o m\u1ED9t t\xe0i kho\u1EA3n NEAR m\u1EDBi",
        orConnectAnAnotherLedger: "ho\u1EB7c k\u1EBFt n\u1ED1i v\u1EDBi v\xed Ledger kh\xe1c.",
        connecting: "\u0110ang k\u1EBFt n\u1ED1i",
        ofAccounts: "c\u1EE7a t\xe0i kho\u1EA3n",
        failedToAutomatically: "Kh\xf4ng th\u1EC3 t\u1EF1 \u0111\u1ED9ng t\xecm id t\xe0i kho\u1EA3n. Nh\u1EADp th\u1EE7 c\xf4ng:",
        overviewTheListOfAuthorized: "T\u1ED5ng quan danh s\xe1ch c\xe1c t\xe0i kho\u1EA3n \u0111\u01B0\u1EE3c \u1EE7y quy\u1EC1n, ho\xe0n t\u1EA5t \u0111\u0103ng nh\u1EADp b\u1EB1ng c\xe1ch b\u1EA5m v\xe0o n\xfat b\xean d\u01B0\u1EDBi.",
        finish: "Ho\xe0n th\xe0nh"
    },
    install: {
        youllNeedToInstall: "B\u1EA1n s\u1EBD c\u1EA7n c\xe0i \u0111\u1EB7t",
        toContinueAfterInstalling: "\u0111\u1EC3 b\u1EAFt \u0111\u1EA7u. Sau khi c\xe0i \u0111\u1EB7t xong",
        refreshThePage: "T\u1EA3i l\u1EA1i trang.",
        open: "M\u1EDF"
    },
    qr: {
        copiedToClipboard: "\u0110\xe3 sao ch\xe9p v\xe0o b\u1EA3ng ghi t\u1EA1m",
        failedToCopy: "Sao ch\xe9p v\xe0o b\u1EA3ng ghi t\u1EA1m th\u1EA5t b\u1EA1i",
        scanWithYourMobile: "Qu\xe9t v\u1EDBi \u0111i\u1EC7n tho\u1EA1i c\u1EE7a b\u1EA1n",
        copyToClipboard: " Sao ch\xe9p v\xe0o b\u1EA3ng ghi t\u1EA1m",
        preferTheOfficial: "Dialogue ch\xednh th\u1EE9c c\u1EE7a",
        open: "M\u1EDF"
    },
    walletTypes: {
        hardware: "V\xed l\u1EA1nh",
        browser: "V\xed tr\xecnh duy\u1EC7t",
        injected: "V\xed ti\u1EC7n \xedch m\u1EDF r\u1ED9ng",
        bridge: "V\xed C\u1EA7u",
        mobile: "V\xed Mobile",
        "instant-link": "V\xed t\u1EE9c th\xec"
    },
    exportAccounts: {
        chooseAWallet: "Ch\u1ECDn v\xed",
        transferYourAccounts: "Chuy\u1EC3n t\xe0i kho\u1EA3n",
        selectAWallet: "Ch\u1ECDn v\xed ph\xf9 h\u1EE3p v\u1EDBi nhu c\u1EA7u c\u1EE7a b\u1EA1n, v\xed \u0111\u01B0\u1EE3c ch\u1ECDn c\u1EA7n h\u1ED7 tr\u1EE3 c\xe1c t\xe0i kho\u1EA3n \u0111ang s\u1EED d\u1EE5ng.",
        selectYourAccounts: "Ch\u1ECDn t\xe0i kho\u1EA3n",
        afterDecide: "Sau khi ch\u1ECDn \u0111\u01B0\u1EE3c t\xe0i kho\u1EA3n b\u1EA1n c\xf3 chuy\u1EC3n.",
        disclaimer: "B\u1EA1n kh\xf4ng th\u1EC3 chuy\u1EC3n t\xe0i kho\u1EA3n n\u1EBFu t\xe0i kho\u1EA3n \u0111\xf3 ch\u01B0a \u0111\u01B0\u1EE3c nh\u1EADn ti\u1EC1n ho\u1EB7c ch\u01B0a ph\xe1t sinh giao d\u1ECBch tr\xean NEAR.",
        warning: "kh\xf4ng h\u1ED7 tr\u1EE3 xu\u1EA5t t\xe0i kho\u1EA3n. Vui l\xf2ng ch\u1ECDn v\xed kh\xe1c.",
        walletTypes: {
            hardware: "V\xed l\u1EA1nh",
            browser: "V\xed tr\xecnh duy\u1EC7t",
            injected: "V\xed ti\u1EC7n \xedch m\u1EDF r\u1ED9ng",
            bridge: "V\xed C\u1EA7u",
            mobile: "V\xed Mobile"
        },
        selectAccounts: {
            title: "Ch\u1ECDn t\xe0i kho\u1EA3n \u0111\u1EC3 chuy\u1EC3n",
            button: "L\u1EA5y c\u1EE5m m\u1EADt kh\u1EA9u",
            deselectAll: "B\u1ECF ch\u1ECDn t\u1EA5t c\u1EA3",
            selectAll: "Ch\u1ECDn t\u1EA5t c\u1EA3",
            unavailable: "Chuy\u1EC3n kh\xf4ng kh\u1EA3 d\u1EE5ng",
            error: "T\xe0i kho\u1EA3n kh\xf4ng t\u1ED3n t\u1EA1i",
            warningLedger: "Y\xeau c\u1EA7u h\u1ED7 tr\u1EE3 Ledger",
            noBalance: "T\xe0i kho\u1EA3n tr\u1ED1ng"
        },
        getPassphrase: {
            title: "Sao ch\xe9p m\u1EADt kh\u1EA9u t\u1EA1m th\u1EDDi",
            desc: "B\u1EA1n s\u1EBD c\u1EA7n nh\u1EADp m\u1EADt kh\u1EA9u khi b\u1EAFt \u0111\u1EA7u xu\u1EA5t c\xe1c kho\u1EA3n t\u1EDBi v\xed kh\xe1c.",
            button: "Ti\u1EBFp t\u1EE5c",
            label: "B\u1EA5m \u0111\u1EC3 sao ch\xe9p",
            checkLabel: "T\xf4i \u0111\xe3 ch\xe9p ho\u1EB7c ghi l\u1EA1i m\u1EADt kh\u1EA9u"
        },
        complete: {
            title: "Ho\xe0n th\xe0nh chuy\u1EC3n",
            descOne: "B\u1EA1n s\u1EBD \u0111\u01B0\u1EE3c chuy\u1EC3n h\u01B0\u1EDBng t\u1EDBi t\xe0i kho\u1EA3n \u0111\xe3 ch\u1ECDn \u0111\u1EC3 ho\xe0n t\u1EA5t qu\xe1 tr\xecnh.",
            descTwo: "Sau khi nh\u1EADp, nh\u1EA5n n\xfat \u0111\u1EC3 ho\xe0n t\u1EA5t quy tr\xecnh chuy\u1EC3n.",
            button: "Ho\xe0n th\xe0nh"
        }
    }
};
var $5bb7220e37bd460f$var$component = {
    clickToCopy: {
        label: "\u0110\xe3 sao ch\xe9p",
        tooltip: "B\u1EA5m \u0111\u1EC3 sao ch\xe9p"
    }
};
var $5bb7220e37bd460f$var$vi = {
    modal: $5bb7220e37bd460f$var$modal$6,
    component: $5bb7220e37bd460f$var$component
};
var $5bb7220e37bd460f$var$modal$5 = {
    wallet: {
        connectYourWallet: "\u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F (Wallet) \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902\u0964",
        whatIsAWallet: "\u0935\u0949\u0932\u0947\u091F \u0915\u094D\u092F\u093E \u0939\u0948?",
        secureAndManage: "\u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0914\u0930 \u092A\u094D\u0930\u092C\u0902\u0927\u093F\u0924 \u0915\u0930\u0947\u0902\u0964",
        safelyStore: "\u0905\u092A\u0928\u0940 \u0915\u094D\u0930\u093F\u092A\u094D\u091F\u094B\u0915\u0930\u0947\u0902\u0938\u0940 \u0914\u0930 \u090F\u0928\u090F\u092B\u091F\u0940 \u0915\u094B \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0938\u094D\u091F\u094B\u0930 \u0914\u0930 \u091F\u094D\u0930\u093E\u0902\u0938\u092B\u0930 \u0915\u0930\u0947\u0902\u0964",
        logInToAny: "NEAR \u092A\u0930 \u0915\u093F\u0938\u0940 \u092D\u0940 \u0910\u092A \u092E\u0947\u0902 \u0938\u093E\u0907\u0928 \u0907\u0928 \u0915\u0930\u0947\u0902\u0964",
        noNeedToCreate: "\u0928\u090F \u0916\u093E\u0924\u0947 \u092F\u093E \u0932\u0949\u0917\u093F\u0928 \u092C\u0928\u093E\u0928\u0947 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902 \u0939\u0948\u0964 \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F(NEAR Wallet)\u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902 \u0914\u0930 \u0906\u0930\u0902\u092D \u0915\u0930\u0947\u0902\u0964",
        getAWallet: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0901\u0964",
        useAWallet: "\u0905\u092A\u0928\u0940 NEAR \u0938\u0902\u092A\u0924\u094D\u0924\u093F\u092F\u094B\u0902 \u0915\u094B \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0914\u0930 \u092A\u094D\u0930\u092C\u0902\u0927\u093F\u0924 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0947\u0902 \u0914\u0930 \u0915\u093F\u0938\u0940 \u092D\u0940 NEAR \u0910\u092A (app) \u092E\u0947\u0902 \u0932\u0949\u0917 \u0907\u0928 \u0915\u0930\u0947\u0902, \u0915\u093F\u0938\u0940 \u0909\u092A\u092F\u094B\u0917\u0915\u0930\u094D\u0924\u093E (user) \u0928\u093E\u092E \u0914\u0930 \u092A\u093E\u0938\u0935\u0930\u094D\u0921 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0928\u0939\u0940\u0902 \u0939\u0948\u0964",
        connectionFailed: "\u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0935\u093F\u092B\u0932|",
        connectionSuccessful: "\u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0938\u092B\u0932|",
        connected: "\u0935\u0949\u0932\u0947\u091F \u091C\u0941\u095C \u0917\u092F\u093E|",
        connectingTo: "\u0935\u0949\u0932\u0947\u091F \u091C\u0941\u095C \u0930\u0939\u093E \u0939\u0947|",
        connectingMessage: {
            injected: "\u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0935\u093F\u0902\u0921\u094B \u092E\u0947\u0902 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902|",
            browser: "\u0930\u0940\u0921\u093E\u092F\u0930\u0947\u0915\u094D\u091F \u0939\u094B\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926 \u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902|",
            hardware: "\u0915\u094B\u0932\u094D\u0921 \u0935\u0949\u0932\u0947\u091F \u0915\u0947 \u0938\u093E\u0925 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902|"
        }
    },
    ledger: {
        connectWithLedger: "\u0932\u0947\u091C\u0930(Ledger)\u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902|",
        makeSureYourLedger: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A\u0915\u093E \u0932\u0947\u091C\u0930 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u091C\u0941\u0921\u093C\u093E \u0939\u0941\u0906 \u0939\u0948 \u0914\u0930 NEAR \u0910\u092A \u0906\u092A\u0915\u0947 \u0921\u093F\u0935\u093E\u0907\u0938 (Device)\u092A\u0930 \u092A\u0939\u0932\u0947 \u0938\u0947 \u0939\u0940 \u0916\u0941\u0932\u093E \u0939\u0948|",
        "continue": "\u091C\u093E\u0930\u0940 \u0930\u0916\u0947|",
        specifyHDPath: "\u0939\u093E\u0930\u094D\u0921 \u0921\u093F\u0938\u094D\u0915(Hard Disk)\u092A\u0925(Path)\u0928\u093F\u0930\u094D\u0927\u093E\u0930\u093F\u0924 \u0915\u0930\u0947|",
        enterYourPreferredHDPath: "\u0905\u092A\u0928\u093E \u090F\u091A\u0921\u0940 \u092A\u0925 \u0926\u0930\u094D\u091C \u0915\u0930\u0947\u0902, \u092B\u093F\u0930 \u0938\u0915\u094D\u0930\u093F\u092F \u0916\u093E\u0924\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902|",
        scan: "\u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947|",
        retry: "\u0926\u094B\u092C\u093E\u0930\u093E \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947|",
        ledgerIsNotAvailable: "\u0932\u0947\u091C\u0930 \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948|",
        accessDeniedToUseLedgerDevice: "\u0932\u0947\u091C\u0930 \u0921\u093F\u0935\u093E\u0907\u0938 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092A\u094D\u0930\u0935\u0947\u0936 \u0928\u093F\u0937\u0947\u0927|",
        noAccountsFound: "\u0916\u093E\u0924\u093E \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E|",
        selectYourAccounts: "\u0905\u092A\u0928\u0947 \u0916\u093E\u0924\u0947 \u091A\u0941\u0928\u0947\u0902|",
        connecting1Account: "\u090F\u0915 \u0916\u093E\u0924\u093E \u0915\u0928\u0947\u0915\u094D\u091F \u0939\u094B \u0930\u0939\u093E \u0939\u0948|",
        cantFindAnyAccount: "\u0907\u0938 \u0932\u0947\u091C\u0930 \u0938\u0947 \u091C\u0941\u0921\u093C\u093E \u0915\u094B\u0908 \u0916\u093E\u0924\u093E \u0928\u0939\u0940\u0902 \u092E\u093F\u0932\u093E\u0964 \u0915\u0943\u092A\u092F\u093E \u090F\u0915 \u0928\u092F\u093E NEAR \u0916\u093E\u0924\u093E \u092C\u0928\u093E\u090F\u0901|",
        orConnectAnAnotherLedger: "\u0905\u0925\u0935\u093E \u0926\u0942\u0938\u0930\u0947 \u0932\u0947\u091C\u0930 \u0935\u0949\u0932\u0947\u091F \u0938\u0947 \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902\u0964",
        connecting: "\u091C\u0941\u095C \u0930\u0939\u093E \u0939\u0947|",
        ofAccounts: "\u0916\u093E\u0924\u093E \u0905\u092C \u091C\u0941\u095C\u093E \u0928\u0939\u0940\u0902 \u0939\u0947|",
        failedToAutomatically: "\u0916\u093E\u0924\u093E \u0906\u0908\u0921\u0940 \u0938\u094D\u0935\u091A\u093E\u0932\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0916\u094B\u091C\u0928\u0947 \u092E\u0947\u0902 \u0905\u0938\u092E\u0930\u094D\u0925\u0964 \u092E\u0948\u0928\u094D\u092F\u0941\u0905\u0932 (Manuall) \u0930\u0942\u092A \u0938\u0947 \u0915\u094B\u0936\u093F\u0936 \u0915\u0930\u0947\u0902|",
        overviewTheListOfAuthorized: "\u0905\u0935\u0932\u094B\u0915\u0928 \u0905\u0927\u093F\u0915\u0943\u0924 \u0915\u0940 \u0938\u0942\u091A\u0940, \u0928\u0940\u091A\u0947 \u0926\u093F\u090F \u0917\u090F \u092C\u091F\u0928 \u092A\u0930 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0915\u0947 \u0932\u0949\u0917\u093F\u0928 \u092A\u0942\u0930\u093E \u0915\u0930\u0947\u0902\u0964",
        finish: "\u0938\u092E\u093E\u092A\u094D\u0924|"
    },
    install: {
        youllNeedToInstall: "\u0906\u092A\u0915\u094B \u0907\u0902\u0938\u094D\u091F\u0949\u0932 \u0915\u0930\u0928\u093E \u0939\u094B\u0917\u093E|",
        toContinueAfterInstalling: "\u0907\u0902\u0938\u094D\u091F\u0949\u0932 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926 \u091C\u093E\u0930\u0940 \u0930\u0916\u0947|",
        refreshThePage: "\u092A\u0941\u0928: \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964",
        open: "\u0916\u094B\u0932\u0947|"
    },
    qr: {
        copiedToClipboard: "\u0915\u094D\u0932\u093F\u092A\u092C\u094B\u0930\u094D\u0921(Clipboard)\u092A\u0930 \u0915\u0949\u092A\u0940 \u0915\u093F\u092F\u093E \u0917\u092F\u093E|",
        failedToCopy: "\u0915\u094D\u0932\u093F\u092A\u092C\u094B\u0930\u094D\u0921 \u092A\u0930 \u0915\u0949\u092A\u0940 \u0915\u0930\u0928\u093E \u0935\u093F\u092B\u0932 \u0930\u0939\u093E|",
        scanWithYourMobile: "\u0905\u092A\u0928\u0947 \u092B\u094B\u0928 (Mobile)\u0938\u0947 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902|",
        copyToClipboard: " \u0915\u094D\u0932\u093F\u092A\u092C\u094B\u0930\u094D\u0921 \u092A\u0930 \u0915\u0949\u092A\u0940 \u0915\u0930\u0947\u0902|",
        preferTheOfficial: "\u0906\u0927\u093F\u0915\u093E\u0930\u093F\u0915 \u0938\u0902\u0935\u093E\u0926 \u0915\u094B \u092A\u094D\u0930\u093E\u0925\u092E\u093F\u0915\u0924\u093E \u0926\u0947\u0902|",
        open: "\u0916\u094B\u0932\u0947|"
    },
    walletTypes: {
        hardware: "Hardware Wallet",
        browser: "Browser Wallet",
        injected: "Wallet Extension",
        bridge: "Bridge Wallet",
        mobile: "Mobile Wallet",
        "instant-link": "Instant Wallet"
    }
};
var $5bb7220e37bd460f$var$hi = {
    modal: $5bb7220e37bd460f$var$modal$5
};
var $5bb7220e37bd460f$var$modal$4 = {
    wallet: {
        connectYourWallet: "\u0635\u0644 \u0645\u062D\u0641\u0638\u062A\u0643",
        whatIsAWallet: "\u0645\u0627 \u0647\u064A \u0627\u0644\u0645\u062D\u0641\u0638\u0629\u061F",
        secureAndManage: "\u062A\u0623\u0645\u064A\u0646 \u0648\u0625\u062F\u0627\u0631\u0629 \u0627\u0644\u0645\u0645\u062A\u0644\u0643\u0627\u062A \u0627\u0644\u0631\u0642\u0645\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643",
        safelyStore: "\u0642\u0645 \u0628\u062A\u062E\u0632\u064A\u0646 \u0648 \u0627\u0631\u0633\u0627\u0644 \u0639\u0645\u0644\u0627\u062A\u0643 \u0648 \u0623\u0635\u0648\u0644\u0643 \u0627\u0644\u0631\u0642\u0645\u064A\u0629 \u0628\u0623\u0645\u0627\u0646",
        logInToAny: "\u0633\u062C\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0625\u0644\u0649 \u0623\u064A \u062A\u0637\u0628\u064A\u0642 \u064A\u0633\u062A\u062E\u062F\u0645 \u0646\u064A\u0631",
        noNeedToCreate: ".\u0644\u0627 \u062F\u0627\u0639\u064A \u0644\u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u062C\u062F\u064A\u062F. \u0641\u0642\u0637 \u0642\u0645 \u0628\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643 \u0648\u0627\u0646\u0637\u0644\u0642",
        getAWallet: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0645\u062D\u0641\u0638\u0629",
        useAWallet: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0645\u062D\u0641\u0638\u0629 \u0644\u062A\u0623\u0645\u064A\u0646 \u0648\u0625\u062F\u0627\u0631\u0629 \u0623\u0635\u0648\u0644 \u0646\u064A\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643\u060C \u0648\u0627\u062F\u062E\u0644 \u0644\u0623\u064A \u062A\u0637\u0628\u064A\u0642 \u064A\u0633\u062A\u062E\u062F\u0645 \u0646\u064A\u0631 \u062F\u0648\u0646 \u0627\u0644\u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u0627\u0633\u0645 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645 \u0648\u0643\u0644\u0645\u0629\u0627\u0644\u0645\u0631\u0648\u0631",
        connectionFailed: "\u0627\u062A\u0635\u0627\u0644 \u0641\u0627\u0634\u0644",
        connectionSuccessful: "\u0627\u062A\u0635\u0627\u0644 \u0646\u0627\u062C\u062D",
        connected: "\u0645\u062A\u0635\u0644",
        connectingTo: "\u062C\u0627\u0631\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628",
        connectingMessage: {
            injected: "\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0625\u0636\u0627\u0641\u0629",
            browser: "\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0628\u0639\u062F \u0625\u0639\u0627\u062F\u0629 \u062A\u0648\u062C\u064A\u0647",
            hardware: "\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u062C\u0647\u0627\u0632 \u0644\u064A\u062F\u062C\u0631",
            bridge: "\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u0627\u0644\u0645\u062D\u0641\u0638\u0629"
        }
    },
    ledger: {
        connectWithLedger: "\u0627\u062A\u0635\u0644 \u0645\u0639 \u0644\u064A\u062F\u062C\u0631",
        makeSureYourLedger: "\u062A\u0623\u0643\u062F \u0623\u0646 \u0644\u064A\u062F\u062C\u0631 \u0645\u062A\u0635\u0644 \u0628\u0623\u0645\u0627\u0646, \u0648 \u0623\u0646 \u062A\u0637\u0628\u064A\u0642 \u0646\u064A\u0631 \u0645\u0641\u062A\u0648\u062D \u0641\u064A \u062C\u0647\u0627\u0632\u0643",
        "continue": "\u062A\u0627\u0628\u0639",
        specifyHDPath: "\u062D\u062F\u062F \u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0633\u0627\u0628",
        enterYourPreferredHDPath: "\u0623\u062F\u062E\u0644 \u0645\u0633\u0627\u0631 \u0627\u0644\u062D\u0633\u0627\u0628 \u0627\u0644\u0645\u0641\u0636\u0644\u060C \u062B\u0645 \u0627\u0628\u062D\u062B \u0639\u0646 \u0643\u0644 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0646\u0634\u0637\u0629",
        scan: "\u0645\u0633\u062D",
        retry: "\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629",
        ledgerIsNotAvailable: "\u0644\u064A\u062F\u062C\u0631 \u063A\u064A\u0631 \u0645\u062A\u0648\u0641\u0631",
        accessDeniedToUseLedgerDevice: "\u062A\u0645 \u0631\u0641\u0636 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0644\u064A\u062F\u062C\u0631",
        noAccountsFound: "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u064A \u062D\u0633\u0627\u0628\u0627\u062A",
        selectYourAccounts: "\u062D\u062F\u062F \u062D\u0633\u0627\u0628\u0627\u062A\u0643",
        connecting1Account: "\u062C\u0627\u0631\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u062D\u0633\u0627\u0628 \u0648\u0627\u062D\u062F",
        cantFindAnyAccount: "\u0644\u0627 \u064A\u0645\u0643\u0646 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0623\u064A \u062D\u0633\u0627\u0628 \u0645\u0631\u062A\u0628\u0637 \u0628\u0647\u0630\u0627 \u0644\u064A\u062F\u062C\u0631 \u0627\u0644\u0631\u062C\u0627\u0621 \u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628 \u0646\u064A\u0631 \u062C\u062F\u064A\u062F \u0639\u0644\u0649",
        orConnectAnAnotherLedger: "\u0627\u0648 \u0627\u0631\u0628\u0637 \u062C\u0647\u0627\u0632 \u0644\u064A\u062F\u062C\u0631 \u0622\u062E\u0631",
        connecting: "\u062C\u0627\u0631\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
        ofAccounts: "\u0645\u0646 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A",
        failedToAutomatically: "\u0641\u0634\u0644 \u0641\u064A \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062D\u0633\u0627\u0628 \u062A\u0644\u0642\u0627\u0626\u064A\u0627. \u064A\u0631\u062C\u0649 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u062D\u0633\u0627\u0628 \u064A\u062F\u0648\u064A\u0627",
        overviewTheListOfAuthorized: "\u0644\u0627\u0626\u062D\u0629 \u0627\u0644\u062D\u0633\u0627\u0628\u0627\u062A \u0627\u0644\u0645\u0635\u0631\u062D \u0628\u0647\u0627, \u0623\u0643\u0645\u0644 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644 \u0628\u0627\u0644\u0646\u0642\u0631 \u0639\u0644\u0649 \u0627\u0644\u0632\u0631 \u0623\u062F\u0646\u0627\u0647",
        finish: "\u0625\u0646\u0647\u0627\u0621"
    },
    install: {
        youllNeedToInstall: "\u0633\u062A\u062D\u062A\u0627\u062C \u0644\u062A\u062B\u0628\u064A\u062A",
        toContinueAfterInstalling: "\u0644\u0644\u0627\u0633\u062A\u0643\u0645\u0627\u0644. \u0628\u0639\u062F \u0627\u0644\u062A\u062B\u0628\u064A\u062A",
        refreshThePage: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0635\u0641\u062D\u0629",
        open: "\u0627\u0641\u062A\u062D"
    },
    qr: {
        copiedToClipboard: "\u062A\u0645 \u0627\u0644\u0646\u0633\u062E",
        failedToCopy: "\u0641\u0634\u0644 \u0627\u0644\u0646\u0633\u062E",
        scanWithYourMobile: "\u0627\u0645\u0633\u062D \u0628\u062C\u0647\u0627\u0632\u0643 \u0627\u0644\u0645\u062D\u0645\u0648\u0644",
        copyToClipboard: "\u0646\u0633\u062E",
        preferTheOfficial: "\u062A\u0641\u0636\u0644 \u0627\u0644\u062D\u0648\u0627\u0631 \u0627\u0644\u0631\u0633\u0645\u064A \u0644",
        open: "\u0641\u062A\u062D"
    },
    walletTypes: {
        hardware: "Hardware Wallet",
        browser: "Browser Wallet",
        injected: "Wallet Extension",
        bridge: "Bridge Wallet",
        mobile: "Mobile Wallet",
        "instant-link": "Instant Wallet"
    }
};
var $5bb7220e37bd460f$var$ar = {
    modal: $5bb7220e37bd460f$var$modal$4
};
var $5bb7220e37bd460f$var$modal$3 = {
    wallet: {
        connectYourWallet: "Spojite crypto nov\u010Danik!",
        whatIsAWallet: "\u0160to je to crypto nov\u010Danik?",
        secureAndManage: "Osigurajte i upravljajte svojom digitalnom imovinom.",
        safelyStore: "Sigurno pohranite i prebacite svoj crypto i NFT-eve.",
        logInToAny: " Prijavite se u bilo koju NEAR aplikaciju",
        noNeedToCreate: "Nema potrebe za stvaranjem novih naloga ili korisni\u010Dkih podataka. Spojite svoj crypto nov\u010Danik i spremni ste!",
        getAWallet: "Otvorite crypto nov\u010Danik",
        useAWallet: "Koristite crypto nov\u010Danik da biste osigurali i upravljali svojom NEAR imovinom, te se prijavite u bilo koju NEAR aplikaciju bez korisni\u010Dkog imena i lozinke.",
        connectionFailed: "Neuspje\u0161no povezivanje.",
        connectionSuccessful: "Uspje\u0161no povezivanje.",
        connected: "Povezano.",
        connectingTo: "Povezivanje u tijeku",
        connectingMessage: {
            injected: "Potvrdite vezu u eksternom prozoru",
            browser: "Nakon redirekcije, potvrdite vezu u nov\u010Daniku",
            hardware: "Potvrdite vezu sa nov\u010Danikom",
            bridge: "Potvrdite vezu u nov\u010Daniku"
        }
    },
    ledger: {
        connectWithLedger: "Pove\u017Eite se hardverskim nov\u010Danikom",
        makeSureYourLedger: "Osigurajte sigurnu vezu s hardverskim nov\u010Danikom, te da je NEAR aplikacija otvorena na va\u0161em ure\u0111aju",
        "continue": "Nastavite",
        specifyHDPath: "Specificirajte HD putanju",
        enterYourPreferredHDPath: "Upi\u0161ite preferiranu HD putanju, zatim skenirajte aktivne naloge",
        scan: "Skenirajte",
        retry: "Poku\u0161ajte ponovno",
        ledgerIsNotAvailable: "Hardverski nov\u010Danik nije dostupan.",
        accessDeniedToUseLedgerDevice: "Odbijen pristup za kori\u0161tenjem hardverskog nov\u010Danika",
        noAccountsFound: "Nalozi nisu prona\u0111eni",
        selectYourAccounts: "Odaberite svoje naloge",
        connecting1Account: "Povezivanje 1 naloga",
        cantFindAnyAccount: "Nije mogu\u0107e prona\u0107i niti jedan nalog povezan s ovim hardverskim nov\u010Danikom. Molimo vas, kreirajte novi NEAR nalog",
        orConnectAnAnotherLedger: "Ili pove\u017Eite drugi hardverski nov\u010Danik.",
        connecting: "Povezivanje",
        ofAccounts: "naloga",
        failedToAutomatically: "Neuspje\u0161no automatsko pronala\u017Eenje ID naloga. Unesite ru\u010Dno:",
        overviewTheListOfAuthorized: "Pregledajte popis odobrenih naloga, zavr\u0161ite prijavu pritiskom na ni\u017Ee prikazani gumb.",
        finish: "Zavr\u0161ite"
    },
    install: {
        youllNeedToInstall: " Potrebno je instalirati modal",
        toContinueAfterInstalling: "za nastavak. Nakon instalacije",
        refreshThePage: "osvje\u017Eite stranicu.",
        open: "Otvorite QR modal"
    },
    qr: {
        copiedToClipboard: "Kopirano u me\u0111uspremnik",
        failedToCopy: "Neupsje\u0161no kopiranje u me\u0111uspremnik",
        scanWithYourMobile: "Skenirajte svojim mobilnim ure\u0111ajem",
        copyToClipboard: " Kopirajte u me\u0111uspremnik",
        preferTheOfficial: "Odaberite slu\u017Ebeni dijalog",
        open: "Otvorite"
    },
    walletTypes: {
        hardware: "Hardware Wallet",
        browser: "Browser Wallet",
        injected: "Wallet Extension",
        bridge: "Bridge Wallet",
        mobile: "Mobile Wallet",
        "instant-link": "Instant Wallet"
    },
    exportAccounts: {
        chooseAWallet: "Odaberi Wallet",
        transferYourAccounts: "Prenesi svoje naloge",
        selectAWallet: "Odaberite wallet koji odgovara va\u0161im potrebama i podr\u017Eava va\u0161e povezane naloge.",
        selectYourAccounts: "Odaberi svoje naloge",
        afterDecide: "Nakon \u0161to odlu\u010Dite koji wallet koristite, mo\u017Eete odabrati koje ra\u010Dune \u017Eelite prebaciti.",
        disclaimer: "Ne\u0107ete mo\u0107i prebaciti naloge koji nisu nikada bili kori\u0161teni na NEAR-u.",
        warning: "ne podr\u017Eava izvoz naloga u ovom trenutku. Molimo odaberite drugi wallet.",
        walletTypes: {
            hardware: "Hardware Wallet",
            browser: "Browser Wallet",
            injected: "Wallet Extension",
            bridge: "Bridge Wallet",
            mobile: "Mobile Wallet"
        },
        selectAccounts: {
            title: "Odaberi naloge za prijenos",
            button: "Generiraj lozinku",
            deselectAll: "Makni odabir sa svih",
            selectAll: "Odaberi sve",
            unavailable: "Prijenos nije dostupan",
            error: "Nalog ne postoji",
            warningLedger: "Potrebna ledger podr\u0161ka",
            noBalance: "Nalog nema sredstava"
        },
        getPassphrase: {
            title: "Kopiraj privremenu lozinku",
            desc: "Bit \u0107e potrebno unijeti ovu lozinku na po\u010Detku izvoza naloga na drugi wallet.",
            button: "Nastavi",
            label: "Klikni za kopiju",
            checkLabel: "Kopirao sam ili zapisao lozinku"
        },
        complete: {
            title: "Zavr\u0161i prijenos",
            descOne: "You will now be redirected to the wallet you selected to complete the transfer.",
            descTwo: "Kada je unos s odabranog walleta zavr\u0161en, pritisnite gumb da biste zavr\u0161ili prijenos.",
            button: "Zavr\u0161i"
        }
    }
};
var $5bb7220e37bd460f$var$hr = {
    modal: $5bb7220e37bd460f$var$modal$3
};
var $5bb7220e37bd460f$var$modal$2 = {
    wallet: {
        connectYourWallet: "\u041F\u043E\u0432\u0440\u0437\u0435\u0442\u0435 \u0433\u043E \u0432\u0430\u0448\u0438\u043E\u0442 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A!",
        whatIsAWallet: "\u0428\u0442\u043E \u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A?",
        secureAndManage: "\u0417\u0430\u0448\u0442\u0438\u0442\u0435\u0442\u0435 \u0433\u0438 \u0438 \u0443\u043F\u0440\u0430\u0432\u0443\u0432\u0430\u0458\u0442\u0435 \u0441\u043E \u0432\u0430\u0448\u0438\u0442\u0435 \u0434\u0438\u0433\u0438\u0442\u0430\u043B\u043D\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430.",
        safelyStore: "\u0411\u0435\u0437\u0431\u0435\u0434\u043D\u043E \u0441\u043A\u043B\u0430\u0434\u0438\u0440\u0430\u0458\u0442\u0435 \u0438 \u0438\u0437\u0432\u0440\u0448\u0443\u0432\u0430\u0458\u0442\u0435 \u0442\u0440\u0430\u043D\u0441\u0430\u043A\u0446\u0438\u0438 \u0441\u043E \u0432\u0430\u0448\u0438\u0442\u0435 \u043A\u0440\u0438\u043F\u0442\u043E \u0438 NFT.",
        logInToAny: "\u041D\u0430\u0458\u0430\u0432\u0435\u0442\u0435 \u0441\u0435 \u043D\u0430 \u043A\u043E\u0458\u0430 \u0431\u0438\u043B\u043E NEAR \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430",
        noNeedToCreate: "\u041D\u0435\u043C\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0430 \u0434\u0430 \u043A\u0440\u0435\u0438\u0440\u0430\u0442\u0435 \u043D\u043E\u0432\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u0438\u043B\u0438 \u0438\u043D\u0433\u0435\u0440\u0435\u043D\u0446\u0438\u0438. \u041F\u043E\u0432\u0440\u0437\u0435\u0442\u0435 \u0433\u043E \u0432\u0430\u0448\u0438\u043E\u0442 \u043F\u0430\u0440\u0438\u0447\u043D\u0438\u043A \u0438 \u0441\u0442\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u0432\u0435\u043D\u0438!",
        getAWallet: "\u041D\u0430\u043F\u0440\u0430\u0432\u0435\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        useAWallet: "\u041A\u043E\u0440\u0438\u0441\u0442\u0435\u0442\u0435 \u043F\u0430\u0440\u0438\u0447\u043D\u0438\u043A \u0437\u0430 \u0434\u0430 \u0433\u0438 \u0437\u0430\u0448\u0442\u0438\u0442\u0438\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u0443\u0432\u0430\u0442\u0435 \u0432\u0430\u0448\u0438\u0442\u0435 NEAR \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u0438 \u0434\u0430 \u0441\u0435 \u043D\u0430\u0458\u0430\u0432\u0438\u0442\u0435 \u043D\u0430 \u043A\u043E\u0458\u0430 \u0431\u0438\u043B\u043E NEAR \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430 \u0431\u0435\u0437 \u043F\u043E\u0442\u0440\u0435\u0431\u0430 \u043E\u0434 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0438\u043C\u0438\u045A\u0430 \u0438 \u043B\u043E\u0437\u0438\u043D\u043A\u0438.",
        connectionFailed: "\u041F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435\u0442\u043E \u043D\u0435 \u0431\u0435\u0448\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E.",
        connectionSuccessful: "\u0423\u0441\u043F\u0435\u0448\u043D\u043E \u043F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435.",
        connected: "\u041F\u043E\u0432\u0440\u0437\u0430\u043D\u043E.",
        connectingTo: "\u041F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435 \u0441\u043E",
        connectingMessage: {
            injected: "\u041F\u043E\u0442\u0432\u0440\u0434\u0435\u0442\u0435 \u0433\u043E \u043F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435\u0442\u043E \u0432\u043E \u0435\u043A\u0441\u0442\u0435\u0440\u043D\u0438\u043E\u0442 \u043F\u0440\u043E\u0437\u043E\u0440\u0435\u0446",
            browser: "\u041F\u043E \u043F\u0440\u0435\u0443\u0441\u043C\u0435\u0440\u0443\u0432\u0430\u045A\u0435\u0442\u043E, \u043F\u043E\u0442\u0432\u0440\u0434\u0435\u0442\u0435 \u0433\u043E \u043F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435\u0442\u043E \u043E\u0434 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043E\u043A\u0442",
            hardware: "\u041F\u043E\u0442\u0432\u0440\u0434\u0435\u0442\u0435 \u0433\u043E \u043F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435\u0442\u043E \u0441\u043E \u043B\u0430\u0434\u0435\u043D \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            bridge: "\u041F\u043E\u0442\u0432\u0440\u0434\u0435\u0442\u0435 \u0458\u0430 \u0432\u0440\u0441\u043A\u0430\u0442\u0430 \u0432\u043E \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u043E\u0442"
        }
    },
    ledger: {
        connectWithLedger: "\u041F\u043E\u0432\u0440\u0437\u0435\u0442\u0435 \u0441\u0435 \u0441\u043E \u041B\u0435\u045F\u0435\u0440",
        makeSureYourLedger: "\u041E\u0441\u0438\u0433\u0443\u0440\u0430\u0458\u0442\u0435 \u0441\u0435 \u0434\u0435\u043A\u0430 \u0432\u0430\u0448\u0438\u043E\u0442 \u041B\u0435\u045F\u0435\u0440 \u0435 \u043F\u043E\u0432\u0440\u0437\u0430\u043D \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E, \u0438 \u0434\u0435\u043A\u0430 NEAR \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430\u0442\u0430 \u0435 \u043E\u0442\u0432\u043E\u0440\u0435\u043D\u0430 \u043D\u0430 \u0432\u0430\u0448\u0438\u043E\u0442 \u0443\u0440\u0435\u0434",
        "continue": "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u0442\u0435",
        specifyHDPath: "\u041D\u0430\u0432\u0435\u0434\u0435\u0442\u0435 \u0425\u0414 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430",
        enterYourPreferredHDPath: "\u0412\u043D\u0435\u0441\u0435\u0442\u0435 \u0458\u0430 \u0432\u0430\u0448\u0430\u0442\u0430 \u043F\u0440\u0435\u0444\u0435\u0440\u0438\u0440\u0430\u043D\u0430 \u0425\u0414 \u043B\u043E\u043A\u0430\u0446\u0438\u0458\u0430, \u0430 \u043F\u043E\u0442\u043E\u0430 \u0441\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435 \u0434\u0430 \u0433\u0438 \u043D\u0430\u0458\u0434\u0435\u0442\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0438\u0442\u0435 \u0441\u043C\u0435\u0442\u043A\u0438.",
        scan: "\u0421\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435",
        retry: "\u041E\u0431\u0438\u0434\u0435\u0442\u0435 \u0441\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E",
        ledgerIsNotAvailable: "\u041B\u0435\u045F\u0435\u0440\u043E\u0442 \u043D\u0435 \u0435 \u0434\u043E\u0441\u0442\u0430\u043F\u0435\u043D.",
        accessDeniedToUseLedgerDevice: "\u041F\u0440\u0438\u0441\u0442\u0430\u043F\u043E\u0442 \u0437\u0430 \u043A\u043E\u0440\u0438\u0441\u0442\u0435\u045A\u0435 \u043D\u0430 \u041B\u0435\u045F\u0435\u0440 \u0443\u0440\u0435\u0434 \u0435 \u043E\u0434\u0431\u0438\u0435\u043D",
        noAccountsFound: "\u041D\u0435\u043C\u0430 \u043D\u0430\u0458\u0434\u0435\u043D\u0438 \u0441\u043C\u0435\u0442\u043A\u0438",
        selectYourAccounts: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0433\u0438 \u0432\u0430\u0448\u0438\u0442\u0435 \u0441\u043C\u0435\u0442\u043A\u0438",
        connecting1Account: "\u041F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435 \u043D\u0430 \u0435\u0434\u043D\u0430 \u0441\u043C\u0435\u0442\u043A\u0430",
        cantFindAnyAccount: "\u041D\u0435 \u0441\u0435 \u043D\u0430\u0458\u0434\u0435\u043D\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u043F\u043E\u0432\u0440\u0437\u0430\u043D\u0438 \u0441\u043E \u043E\u0432\u043E\u0458 \u041B\u0435\u045F\u0435\u0440. \u0412\u0435 \u043C\u043E\u043B\u0438\u043C\u0435 \u043A\u0440\u0435\u0438\u0440\u0430\u0458\u0442\u0435 \u043D\u043E\u0432\u0430 NEAR \u0441\u043C\u0435\u0442\u043A\u0430 ",
        orConnectAnAnotherLedger: "\u0438\u043B\u0438 \u043F\u043E\u0432\u0440\u0437\u0435\u0442\u0435 \u0434\u0440\u0443\u0433 \u041B\u0435\u045F\u0435\u0440.",
        connecting: "\u041F\u043E\u0432\u0440\u0437\u0443\u0432\u0430\u045A\u0435",
        ofAccounts: "\u043D\u0430 \u0441\u043C\u0435\u0442\u043A\u0438",
        failedToAutomatically: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0441\u043A\u043E \u0431\u0430\u0440\u0430\u045A\u0435 \u043D\u0430 \u0418\u0414 \u043D\u0430 \u0441\u043C\u0435\u0442\u043A\u0430\u0442\u0430. \u0412\u043D\u0435\u0441\u0435\u0442\u0435 \u0433\u043E \u0440\u0430\u0447\u043D\u043E:",
        overviewTheListOfAuthorized: "\u041F\u0440\u0435\u0433\u043B\u0435\u0434 \u043D\u0430 \u043B\u0438\u0441\u0442\u0430\u0442\u0430 \u043D\u0430 \u043E\u0432\u043B\u0430\u0441\u0442\u0435\u043D\u0438 \u0441\u043C\u0435\u0442\u043A\u0438, \u0437\u0430\u0432\u0440\u0448\u0435\u0442\u0435 \u0441\u0435 \u043D\u0430\u0458\u0430\u0432\u0430\u0442\u0430 \u0441\u043E \u043A\u043B\u0438\u043A\u043D\u0443\u0432\u0430\u045A\u0435 \u043D\u0430 \u043A\u043E\u043F\u0447\u0435\u0442\u043E \u043F\u043E\u0434\u043E\u043B\u0443.",
        finish: "\u0417\u0430\u0432\u0440\u0448\u0435\u0442\u0435"
    },
    install: {
        youllNeedToInstall: "\u0422\u0440\u0435\u0431\u0430 \u0434\u0430 \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u0442\u0435",
        toContinueAfterInstalling: "\u0437\u0430 \u0434\u0430 \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435. \u041F\u043E \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u045A\u0435\u0442\u043E",
        refreshThePage: "\u041E\u0441\u0432\u0435\u0436\u0435\u0442\u0435 \u0458\u0430 \u0441\u0442\u0440\u0430\u043D\u0430\u0442\u0430.",
        open: "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    qr: {
        copiedToClipboard: "\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E \u043D\u0430 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434\u043E\u0442",
        failedToCopy: "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u043A\u043E\u043F\u0438\u0440\u0430\u045A\u0435 \u043D\u0430 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434",
        scanWithYourMobile: "\u0421\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435 \u0441\u043E \u0432\u0430\u0448\u0438\u043E\u0442 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0441\u043A\u0438 \u0443\u0440\u0435\u0434",
        copyToClipboard: "\u041A\u043E\u043F\u0438\u0440\u0430\u0458\u0442\u0435 \u043D\u0430 \u043A\u043B\u0438\u043F\u0431\u043E\u0440\u0434",
        preferTheOfficial: "\u041F\u0440\u0435\u0444\u0435\u0440\u0438\u0440\u0430\u0458\u0442\u0435 \u043E\u0444\u0438\u0446\u0438\u0458\u0430\u043B\u0435\u043D \u0434\u0438\u0430\u043B\u043E\u0433 \u043D\u0430",
        open: "\u041E\u0442\u0432\u043E\u0440\u0435\u0442\u0435"
    },
    walletTypes: {
        hardware: "\u0425\u0430\u0440\u0434\u0432\u0435\u0440\u0441\u043A\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        browser: "\u041D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043D\u0430 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u0440\u0435\u043B\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
        injected: "\u0415\u043A\u0441\u0442\u0435\u043D\u0437\u0438\u0458\u0430 \u0437\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        bridge: "Bridge \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        mobile: "\u041C\u043E\u0431\u0438\u043B\u0435\u043D \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        "instant-link": "\u0418\u043D\u0441\u0442\u0430\u043D\u0442 \u043F\u0430\u0440\u0438\u0447\u043D\u0438\u043A"
    },
    exportAccounts: {
        chooseAWallet: "\u041E\u0434\u0431\u0435\u0440\u0435\u0442\u0435 \u043F\u0430\u0440\u0438\u0447\u043D\u0438\u043A",
        transferYourAccounts: "\u041F\u0440\u0435\u0444\u0440\u043B\u0435\u0442\u0435 \u0433\u0438 \u0432\u0430\u0448\u0438\u0442\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438",
        selectAWallet: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435\u043D \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043A\u043E\u0458 \u0433\u0438 \u0437\u0430\u0434\u043E\u0432\u043E\u043B\u0443\u0432\u0430 \u0432\u0430\u0448\u0438\u0442\u0435 \u0431\u0430\u0440\u0430\u043D\u045A\u0430 \u0438 \u0433\u0438 \u043F\u043E\u0434\u0434\u0440\u0436\u0443\u0432\u0430 \u0432\u0430\u0448\u0438\u0442\u0435 \u043F\u043E\u0432\u0440\u0437\u0430\u043D\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438.",
        selectYourAccounts: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0433\u0438 \u0432\u0430\u0448\u0438\u0442\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438",
        afterDecide: "\u041E\u0434\u043A\u0430\u043A\u043E \u045C\u0435 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A, \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043A\u043E\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u0441\u0430\u043A\u0430\u0442\u0435 \u0434\u0430 \u0433\u0438 \u043F\u0440\u0435\u0444\u0440\u043B\u0438\u0442\u0435.",
        disclaimer: "\u041D\u0435 \u043C\u043E\u0436\u0435\u0442\u0435 \u0434\u0430 \u043F\u0440\u0444\u0440\u043B\u0430\u0442\u0435 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u043A\u043E\u0438 \u043D\u0438\u043A\u043E\u0433\u0430\u0448 \u043D\u0435 \u0431\u0438\u043B\u0435 \u043D\u0430\u0434\u043E\u043F\u043E\u043B\u043D\u0430\u0442\u0438 \u0438\u043B\u0438 \u043A\u043E\u0440\u0438\u0441\u0442\u0435\u043D\u0438 \u043D\u0430 NEAR.",
        warning: "\u043D\u0435 \u043F\u043E\u0434\u0434\u0440\u0436\u0443\u0432\u0430 \u0438\u0437\u0432\u0435\u0437\u0443\u0432\u0430\u045A\u0435 \u043D\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438 \u0441\u043C\u0435\u0442\u043A\u0438 \u0432\u043E \u043E\u0432\u043E\u0458 \u043C\u043E\u043C\u0435\u043D\u0442. \u0412\u0435 \u043C\u043E\u043B\u0438\u043C\u0435 \u0438\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0434\u0440\u0443\u0433 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A.",
        walletTypes: {
            hardware: "\u0425\u0430\u0440\u0434\u0432\u0435\u0440\u0441\u043A\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            browser: "\u041D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043D\u0430 \u0438\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u043F\u0440\u0435\u043B\u0438\u0441\u0442\u0443\u0432\u0430\u0447",
            injected: "\u0415\u043A\u0441\u0442\u0435\u043D\u0437\u0438\u0458\u0430 \u0437\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            bridge: "Bridge \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            mobile: "\u041C\u043E\u0431\u0438\u043B\u0435\u043D \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A"
        },
        selectAccounts: {
            title: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0433\u0438 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438\u0442\u0435 \u0441\u043C\u0435\u0442\u043A\u0438 \u0437\u0430 \u0434\u0430 \u0433\u0438 \u043F\u0440\u0435\u0444\u0440\u043B\u0438\u0442\u0435.",
            button: "\u0414\u043E\u0431\u0438\u0458\u0442\u0435 \u043B\u043E\u0437\u0438\u043D\u043A\u0430",
            deselectAll: "\u041E\u0442\u0441\u0435\u043B\u0435\u043A\u0442\u0438\u0440\u0430\u0458\u0442\u0435 \u0441\u0435",
            selectAll: "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0441\u0435",
            unavailable: "\u0422\u0440\u0430\u043D\u0441\u0444\u0435\u0440\u043E\u0442 \u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u043F\u0435\u043D",
            error: "\u041A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0430\u0442\u0430 \u0441\u043C\u0435\u0442\u043A\u0430 \u043D\u0435 \u043F\u043E\u0441\u0442\u043E\u0438",
            warningLedger: "\u041F\u043E\u0442\u0440\u0435\u0431\u043D\u0430 \u0435 \u043F\u043E\u0434\u0434\u0440\u0448\u043A\u0430 \u043E\u0434 \u041B\u0435\u045F\u0435\u0440",
            noBalance: "\u0421\u043C\u0435\u0442\u043A\u0430\u0442\u0430 \u043D\u0435 \u0435 \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u0430\u043D\u0430"
        },
        getPassphrase: {
            title: "\u041A\u043E\u043F\u0438\u0440\u0430\u0458\u0442\u0435 \u0458\u0430 \u043F\u0440\u0438\u0432\u0440\u0435\u043C\u0435\u043D\u0430\u0442\u0430 \u043B\u043E\u0437\u0438\u043D\u043A\u0430",
            desc: "\u040C\u0435 \u0442\u0440\u0435\u0431\u0430 \u0434\u0430 \u0458\u0430 \u0432\u043D\u0435\u0441\u0435\u0442\u0435 \u043E\u0432\u0430\u0430 \u043B\u043E\u0437\u0438\u043D\u043A\u0430 \u043A\u043E\u0433\u0430 \u045C\u0435 \u0437\u0430\u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u0433\u0438 \u0438\u0437\u0432\u0435\u0437\u0443\u0432\u0430\u0442\u0435 \u0432\u0430\u0448\u0438\u0442\u0435 \u0441\u043C\u0435\u0442\u043A\u0438 \u043D\u0430 \u0434\u0440\u0443\u0433 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A.",
            button: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u0442\u0435",
            label: "\u041A\u043B\u0438\u043A\u043D\u0435\u0442\u0435 \u0437\u0430 \u0434\u0430 \u043A\u043E\u043F\u0438\u0440\u0430\u0442\u0435",
            checkLabel: "\u0408\u0430 \u043A\u043E\u043F\u0438\u0440\u0430\u0432 \u0438\u043B\u0438 \u0437\u0430\u043F\u0438\u0448\u0430\u0432 \u043B\u043E\u0437\u0438\u043D\u043A\u0430\u0442\u0430"
        },
        complete: {
            title: "\u0417\u0430\u0432\u0440\u0448\u0435\u0442\u0435 \u0433\u043E \u043F\u0440\u0435\u043D\u043E\u0441\u043E\u0442",
            descOne: "\u0421\u0435\u0433\u0430 \u045C\u0435 \u0431\u0438\u0434\u0435\u0442\u0435 \u043F\u0440\u0435\u043D\u0430\u0441\u043E\u0447\u0435\u043D\u0438 \u043D\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u043E\u0442 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u0437\u0430 \u0437\u0430\u0432\u0440\u0448\u0443\u0432\u0430\u045A\u0435 \u043D\u0430 \u043F\u0440\u0435\u043D\u043E\u0441\u043E\u0442.",
            descTwo: "\u041E\u0442\u043A\u0430\u043A\u043E \u045C\u0435 \u0437\u0430\u0432\u0440\u0448\u0438 \u0443\u0432\u043E\u0437\u043E\u0442 \u043E\u0434 \u0438\u0437\u0431\u0440\u0430\u043D\u0438\u043E\u0442 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A, \u043F\u0440\u0438\u0442\u0438\u0441\u043D\u0435\u0442\u0435 \u0433\u043E \u043A\u043E\u043F\u0447\u0435\u0442\u043E \u0437\u0430 \u0434\u0430 \u0433\u043E \u0437\u0430\u0432\u0440\u0448\u0438\u0442\u0435 \u043F\u0440\u0435\u043D\u043E\u0441\u043E\u0442.",
            button: "\u0417\u0430\u0432\u0440\u0448\u0435\u0442\u0435"
        }
    }
};
var $5bb7220e37bd460f$var$mk = {
    modal: $5bb7220e37bd460f$var$modal$2
};
var $5bb7220e37bd460f$var$modal$1 = {
    wallet: {
        connectYourWallet: "Pove\u017Eite svojo denarnico!",
        whatIsAWallet: "Kaj je denarnica?",
        secureAndManage: "Zavarujte in upravljajte svoja digitalna sredstva.",
        safelyStore: "Varno shranjujte in prena\u0161ajte svoje kriptovalute in NFTje.",
        logInToAny: "Prijavite se v katero koli aplikacijo na NEAR",
        noNeedToCreate: "Ni vam treba ustvarjati novih ra\u010Dunov. Pove\u017Eite svojo denarnico in za\u010Dnite!",
        getAWallet: "Ustvarite denarnico",
        useAWallet: "Uporabite denarnico, da bi zavarovali in upravljali s svoja NEAR digitalna sredstva, in se prijavite v katero koli aplikacijo ekosistema NEAR",
        connectionFailed: "Povezava ni bila uspe\u0161na.",
        connectionSuccessful: "Povezava je bila uspe\u0161na.",
        connected: "Va\u0161a denarnica je povezana.",
        connectingTo: "Povezovanje z",
        connectingMessage: {
            injected: "Potrdite povezavo v oknu raz\u0161iritve",
            browser: "Po preusmeritvi potrdite povezavo v denarnici",
            hardware: "Potrdite povezavo s hladno denarnico",
            bridge: "Potrdite povezavo v denarnici"
        }
    },
    ledger: {
        connectWithLedger: "Pove\u017Eite se z Ledger",
        makeSureYourLedger: "Prepri\u010Dajte se, da je va\u0161 Ledger varno povezan in da je aplikacija NEAR odprta v va\u0161i napravi",
        "continue": "Nadaljuj",
        specifyHDPath: "Dolo\u010Dite HD pot",
        enterYourPreferredHDPath: "Vnesite \u017Eeleno HD pot, nato poi\u0161\u010Dite vse aktivne ra\u010Dune.",
        scan: "Skenirajte",
        retry: "Poskusite znova",
        ledgerIsNotAvailable: "Ledger ni na voljo",
        accessDeniedToUseLedgerDevice: "Dostop za uporabo naprave Ledger zavrnjen",
        noAccountsFound: "Ni najdenih ra\u010Dunov",
        selectYourAccounts: "Izberite Va\u0161i ra\u010Duni",
        connecting1Account: "Povezovanje enega ra\u010Duna",
        cantFindAnyAccount: "Ni mogo\u010De najti nobenega ra\u010Duna, povezanega s tem Ledgerjem. Ustvarite nov NEAR ra\u010Dun ",
        orConnectAnAnotherLedger: "ali pove\u017Eite drug Ledger..",
        connecting: "Povezovanje",
        ofAccounts: "ra\u010Dunov",
        failedToAutomatically: "ID-ja ra\u010Duna ni bilo mogo\u010De samodejno najti. Zagotovite ga ro\u010Dno:",
        overviewTheListOfAuthorized: "Oglejte si seznam poobla\u0161\u010Denih ra\u010Dunov, dokon\u010Dajte prijavo s klikom na spodnji gumb.",
        finish: "Kon\u010Dajte"
    },
    install: {
        youllNeedToInstall: "Morali ga boste namestiti",
        toContinueAfterInstalling: "nadaljevati. Po namestitvi",
        refreshThePage: "Osve\u017Eite stran.",
        open: "Odprite"
    },
    qr: {
        copiedToClipboard: "Kopirano v podlo\u017Eni mapi",
        failedToCopy: "Kopiranje v podlo\u017Eni mapi ni uspelo",
        scanWithYourMobile: "Skenirajte s svojo mobilno napravo",
        copyToClipboard: " Kopirajte v podlo\u017Eni mapi",
        preferTheOfficial: "Preferirajte uradno pogovorno okno",
        open: "Odprite"
    },
    walletTypes: {
        hardware: "Hladna denarnica",
        browser: "Denarnica brskalnika",
        injected: "Raz\u0161iritev za denarnico",
        bridge: "Bridge denarnica",
        mobile: "Mobilna denarnica",
        "instant-link": "Takoj\u0161nja denarnica"
    },
    exportAccounts: {
        chooseAWallet: "Izberite denarnico",
        transferYourAccounts: "Prenesite svoje ra\u010Dune",
        selectAWallet: "Izberite denarnico, ki ustreza va\u0161im potrebam in podpira va\u0161e povezane ra\u010Dune.",
        selectYourAccounts: "Izberite va\u0161i ra\u010Duni",
        afterDecide: "Ko se odlo\u010Dite za denarnico, lahko izberete, katere ra\u010Dune \u017Eelite prenesti.",
        disclaimer: "Ne boste mogli prenesti Ra\u010Dunov, ki nikoli niso bili financirani ali uporabljeni na NEAR.",
        warning: "trenutno ne podpira izvoza ra\u010Duna. Izberite drugo denarnico",
        walletTypes: {
            hardware: "Hladna denarnica",
            browser: "Denarnica brskalnika",
            injected: "Raz\u0161iritev za denarnico",
            bridge: "Bridge denarnica",
            mobile: "Mobilna denarnica"
        },
        selectAccounts: {
            title: "Izberite ra\u010Duni za prenos.",
            button: "Pridobite geslo",
            deselectAll: "Prekli\u010Di izbiro vseh",
            selectAll: "Izberi vse",
            unavailable: "Prenos ni na voljo",
            error: "Ra\u010Dun ne obstaja",
            warningLedger: "Potrebna je podpora za Ledger",
            noBalance: "Ra\u010Dun ni financiran"
        },
        getPassphrase: {
            title: "Kopiraj za\u010Dasno geslo",
            desc: "To geslo boste morali vnesti, ko boste za\u010Deli izva\u017Eati svoje ra\u010Dune v drugo denarnico.",
            button: "Nadaljujte",
            label: "Kliknite za kopiranje",
            checkLabel: "Geslo sem kopiral ali zapisal"
        },
        complete: {
            title: "Dokon\u010Dajte prenos",
            descOne: "Zdaj boste preusmerjeni v denarnico, ki ste jo izbrali za dokon\u010Danje prenosa.",
            descTwo: "Ko je uvozni del postopka kon\u010Dan iz izbrane denarnice, pritisnite gumb za dokon\u010Danje postopka prenosa.",
            button: "Kon\u010Dajte"
        }
    }
};
var $5bb7220e37bd460f$var$sl = {
    modal: $5bb7220e37bd460f$var$modal$1
};
var $5bb7220e37bd460f$var$modal = {
    wallet: {
        connectYourWallet: "\u041F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u0441\u0432\u043E\u0458 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A!",
        whatIsAWallet: "\u0428\u0442\u0430 \u0458\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A?",
        secureAndManage: "\u041E\u0431\u0435\u0437\u0431\u0435\u0434\u0438\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u0459\u0430\u0458\u0442\u0435 \u0441\u0432\u043E\u0458\u043E\u043C \u0434\u0438\u0433\u0438\u0442\u0430\u043B\u043D\u043E\u043C \u0438\u043C\u043E\u0432\u0438\u043D\u043E\u043C.",
        safelyStore: "\u0411\u0435\u0437\u0431\u0435\u0434\u043D\u043E \u0447\u0443\u0432\u0430\u0458\u0442\u0435 \u0438 \u043F\u0440\u0435\u043D\u043E\u0441\u0438\u0442\u0435 \u0441\u0432\u043E\u0458\u0435 \u043A\u0440\u0438\u043F\u0442\u043E\u0432\u0430\u043B\u0443\u0442\u0435 \u0438 NFT.",
        logInToAny: "\u041F\u0440\u0438\u0458\u0430\u0432\u0438\u0442\u0435 \u0441\u0435 \u043D\u0430 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u0443 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0443 NEAR",
        noNeedToCreate: "\u041D\u0435\u043C\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0435 \u0434\u0430 \u043A\u0440\u0435\u0438\u0440\u0430\u0442\u0435 \u043D\u043E\u0432\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u0438\u043B\u0438 \u0430\u043A\u0440\u0435\u0434\u0438\u0442\u0438\u0432\u0435. \u041F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u0438 \u0441\u043F\u0440\u0435\u043C\u043D\u0438 \u0441\u0442e!",
        getAWallet: "\u041D\u0430\u0431\u0430\u0432\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        useAWallet: "\u041A\u043E\u0440\u0438\u0441\u0442\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u0434\u0430 \u043E\u0431\u0435\u0437\u0431\u0435\u0434\u0438\u0442\u0435 \u0438 \u0443\u043F\u0440\u0430\u0432\u0459\u0430\u0442\u0435 \u0441\u0432\u043E\u0458\u0438\u043C NEAR \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0438\u043C\u0430 \u0438 \u0434\u0430 \u0441\u0435 \u043F\u0440\u0438\u0458\u0430\u0432\u0438\u0442\u0435 \u0443 \u0431\u0438\u043B\u043E \u043A\u043E\u0458\u0443 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0443 NEAR \u0431\u0435\u0437 \u043F\u043E\u0442\u0440\u0435\u0431\u0435 \u0437\u0430 \u043A\u043E\u0440\u0438\u0441\u043D\u0438\u0447\u043A\u0438\u043C \u0438\u043C\u0435\u043D\u0438\u043C\u0430 \u0438 \u043B\u043E\u0437\u0438\u043D\u043A\u0430\u043C\u0430.",
        connectionFailed: "\u0412\u0435\u0437\u0430 \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u043E\u0441\u0442\u0430\u0432\u0459\u0435\u043D\u0430.",
        connectionSuccessful: "\u0412\u0435\u0437\u0430 \u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u0430.",
        connected: "\u041F\u043E\u0432\u0435\u0437\u0430\u043D.",
        connectingTo: "\u041F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435 \u043D\u0430",
        connectingMessage: {
            injected: "\u041F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0432\u0435\u0437\u0443 \u0443 \u0441\u043F\u043E\u0459\u043D\u043E\u043C \u043F\u0440\u043E\u0437\u043E\u0440\u0443",
            browser: "\u041D\u0430\u043A\u043E\u043D \u043F\u0440\u0435\u0443\u0441\u043C\u0435\u0440\u0430\u0432\u0430\u045A\u0430, \u043F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0432\u0435\u0437\u0443 \u0443 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0443",
            hardware: "\u041F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0432\u0435\u0437\u0443 \u0441\u0430 \u0445\u043B\u0430\u0434\u043D\u0438\u043C \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u043E\u043C",
            bridge: "\u041F\u043E\u0442\u0432\u0440\u0434\u0438\u0442\u0435 \u0432\u0435\u0437\u0443 \u0441\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u043E\u043C"
        }
    },
    ledger: {
        connectWithLedger: "\u041F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u0441\u0435 \u0441\u0430 Ledger",
        makeSureYourLedger: "\u0423\u0432\u0435\u0440\u0438\u0442\u0435 \u0441\u0435 \u0434\u0430 \u0458\u0435 \u0432\u0430\u0448 Ledger \u0431\u0435\u0437\u0431\u0435\u0434\u043D\u043E \u043F\u043E\u0432\u0435\u0437\u0430\u043D \u0438 \u0434\u0430 \u0458\u0435 \u0430\u043F\u043B\u0438\u043A\u0430\u0446\u0438\u0458\u0430 NEAR \u043E\u0442\u0432\u043E\u0440\u0435\u043D\u0430 \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0443\u0440\u0435\u0452\u0430\u0458\u0443",
        "continue": "\u041D\u0430\u0441\u0442\u0430\u0432\u0438",
        specifyHDPath: "\u041D\u0430\u0432\u0435\u0434\u0438\u0442\u0435 \u0425\u0414 \u043F\u0443\u0442\u0430\u045A\u0443",
        enterYourPreferredHDPath: "\u0423\u043D\u0435\u0441\u0438\u0442\u0435 \u0436\u0435\u0459\u0435\u043D\u0443 \u0436\u0435\u0459\u0435\u043D\u0443 \u0425\u0414 \u043F\u0443\u0442\u0430\u045A\u0443, \u0430 \u0437\u0430\u0442\u0438\u043C \u0441\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435 \u0441\u0432\u0435 \u0430\u043A\u0442\u0438\u0432\u043D\u0435 \u043D\u0430\u043B\u043E\u0433\u0435.",
        scan: "\u0421\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435",
        retry: "\u041F\u043E\u043A\u0443\u0448\u0430\u0458 \u043F\u043E\u043D\u043E\u0432\u043E",
        ledgerIsNotAvailable: "Ledger \u043D\u0438\u0458\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0430\u043D.",
        accessDeniedToUseLedgerDevice: "\u041F\u0440\u0438\u0441\u0442\u0443\u043F \u0458\u0435 \u043E\u0434\u0431\u0438\u0458\u0435\u043D \u0437\u0430 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u045A\u0435 Ledger \u0443\u0440\u0435\u0452\u0430\u0458\u0430",
        noAccountsFound: "\u041D\u0430l\u043E\u0437\u0438 \u043D\u0438\u0441\u0443 \u043F\u0440\u043E\u043D\u0430\u0452\u0435\u043D\u0438",
        selectYourAccounts: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0412\u0430\u0448 \u043D\u0430l\u043E\u0433",
        connecting1Account: "\u041F\u043E\u0432\u0435\u0437\u0430\u0442\u0438 1 \u043D\u0430l\u043E\u0433",
        cantFindAnyAccount: "\u041D\u0438\u0458\u0435 \u043C\u043E\u0433\u0443\u045B\u0435 \u043F\u0440\u043E\u043D\u0430\u045B\u0438 \u043D\u0438\u0458\u0435\u0434\u0430\u043D \u043D\u0430l\u043E\u0433 \u043F\u043E\u0432\u0435\u0437\u0430\u043D \u0441\u0430 \u043E\u0432\u0438\u043C Ledger-\u043E\u043C. \u041D\u0430\u043F\u0440\u0430\u0432\u0438\u0442\u0435 \u043D\u043E\u0432\u0438 NEAR \u043D\u0430l\u043E\u0433",
        orConnectAnAnotherLedger: "\u0438\u043B\u0438 \u043F\u043E\u0432\u0435\u0436\u0438\u0442\u0435 \u0434\u0440\u0443\u0433\u0438 Ledger.",
        connecting: "\u041F\u043E\u0432\u0435\u0437\u0438\u0432\u0430\u045A\u0435",
        ofAccounts: "\u043D\u0430l\u043E\u0433\u0430",
        failedToAutomatically: "\u0410\u0443\u0442\u043E\u043C\u0430\u0442\u0441\u043A\u043E \u043F\u0440\u043E\u043D\u0430\u043B\u0430\u0436\u0435\u045A\u0435 ID-a \u043D\u0430l\u043E\u0433\u0430 \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u043E. \u041D\u0430\u0432\u0435\u0434\u0438\u0442\u0435 \u0433\u0430 \u0440\u0443\u0447\u043D\u043E:",
        overviewTheListOfAuthorized: "\u041F\u0440\u0435\u0433\u043B\u0435\u0434\u0430\u0458\u0442\u0435 \u043B\u0438\u0441\u0442\u0443 \u043E\u0432\u043B\u0430\u0448\u045B\u0435\u043D\u0438\u0445 \u0440\u0430\u0447\u0443\u043D\u0430, \u0437\u0430\u0432\u0440\u0448\u0438\u0442\u0435 \u043F\u0440\u0438\u0458\u0430\u0432\u0443 \u043A\u043B\u0438\u043A\u043E\u043C \u043D\u0430 \u0434\u0443\u0433\u043C\u0435 \u0438\u0441\u043F\u043E\u0434.",
        finish: "\u0417\u0430\u0432\u0440\u0448\u0438"
    },
    install: {
        youllNeedToInstall: "\u041C\u043E\u0440\u0430\u045B\u0435\u0442\u0435 \u0434\u0430 \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u0442\u0435",
        toContinueAfterInstalling: "\u0437\u0430 \u043D\u0430\u0441\u0442\u0430\u0432\u0430\u043A. \u041D\u0430\u043A\u043E\u043D \u0438\u043D\u0441\u0442\u0430\u043B\u0438\u0440\u0430\u045A\u0430",
        refreshThePage: "\u043F\u043E\u043D\u043E\u0432\u043E \u0443\u0447\u0438\u0442\u0430\u0442\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443.",
        open: "\u041E\u0442\u0432\u043E\u0440\u0438"
    },
    qr: {
        copiedToClipboard: "\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E \u0443 \u043C\u0435\u0452\u0443\u0441\u043F\u0440\u0435\u043C\u043D\u0438\u043A",
        failedToCopy: "\u041A\u043E\u043F\u0438\u0440\u0430\u045A\u0435 \u0443 \u043C\u0435\u0452\u0443\u0441\u043F\u0440\u0435\u043C\u043D\u0438\u043A \u043D\u0438\u0458\u0435 \u0443\u0441\u043F\u0435\u043B\u043E",
        scanWithYourMobile: "\u0421\u043A\u0435\u043D\u0438\u0440\u0430\u0458\u0442\u0435 \u043F\u043E\u043C\u043E\u045B\u0443 \u043C\u043E\u0431\u0438\u043B\u043D\u043E\u0433 \u0443\u0440\u0435\u0452\u0430\u0458\u0430",
        copyToClipboard: " \u041A\u043E\u043F\u0438\u0440\u0430\u0458 \u0443 \u043C\u0435\u0452\u0443\u0441\u043F\u0440\u0435\u043C\u043D\u0438\u043A",
        preferTheOfficial: "\u041F\u0440\u0435\u0444\u0435\u0440\u0438\u0440\u0430\u0442\u0435 \u0437\u0432\u0430\u043D\u0438\u0447\u043D\u0438 \u0434\u0438\u0458\u0430\u043B\u043E\u0433 \u043E\u0434",
        open: "\u041E\u0442\u0432\u043E\u0440\u0438"
    },
    walletTypes: {
        hardware: "\u0425\u0430\u0440\u0434\u0432\u0435\u0440\u0441\u043A\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        browser: "\u041D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043F\u0440\u0435\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u0447\u0430,",
        injected: "\u0414\u043E\u0434\u0430\u0442\u0430\u043A \u0437\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A,",
        bridge: "Bridge \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        mobile: "\u041C\u043E\u0431\u0438\u043B\u043D\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        "instant-link": "\u0418\u043D\u0441\u0442\u0430\u043D\u0442 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A"
    },
    exportAccounts: {
        chooseAWallet: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
        transferYourAccounts: "\u041F\u0440\u0435\u043D\u0435\u0441\u0438\u0442\u0435 \u0441\u0432\u043E\u0458\u0435 \u043D\u0430\u043B\u043E\u0433\u0435",
        selectAWallet: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043A\u043E\u0458\u0438 \u043E\u0434\u0433\u043E\u0432\u0430\u0440\u0430 \u0432\u0430\u0448\u0438\u043C \u043F\u043E\u0442\u0440\u0435\u0431\u0430\u043C\u0430 \u0438 \u043A\u043E\u0458\u0438 \u043F\u043E\u0434\u0440\u0436\u0430\u0432\u0430 \u0432\u0430\u0448\u0435 \u043F\u043E\u0432\u0435\u0437\u0430\u043D\u0435 \u043D\u0430\u043B\u043E\u0433\u0435.",
        selectYourAccounts: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0432\u0430\u0448\u0435 \u043D\u0430\u043B\u043E\u0433\u0435",
        afterDecide: "\u041D\u0430\u043A\u043E\u043D \u0448\u0442\u043E \u0441\u0435 \u043E\u0434\u043B\u0443\u0447\u0438\u0442\u0435 \u0437\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A, \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0437\u0430\u0431\u0440\u0430\u0442\u0438 \u043A\u043E\u0458\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u0436\u0435\u043B\u0438\u0442\u0435 \u0434\u0430 \u043F\u0440\u0435\u043D\u0435\u0441\u0435\u0442\u0435.",
        disclaimer: "\u041D\u0435\u045B\u0435\u0442\u0435 \u043C\u043E\u045B\u0438 \u0434\u0430 \u043F\u0440\u0435\u043D\u0435\u0441\u0435\u0442\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u043A\u043E\u0458\u0438 \u043D\u0438\u043A\u0430\u0434\u0430 \u043D\u0438\u0441\u0443 \u0431\u0438\u043B\u0438 \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u0430\u043D\u0438 \u0438\u043B\u0438 \u043A\u043E\u0440\u0438\u0448\u045B\u0435\u043D\u0438 \u043D\u0430  NEAR.",
        warning: "\u0442\u0440\u0435\u043D\u0443\u0442\u043D\u043E \u043D\u0435 \u043F\u043E\u0434\u0440\u0436\u0430\u0432\u0430 \u0438\u0437\u0432\u043E\u0437 \u043D\u0430\u043B\u043E\u0433\u0430. \u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0440\u0443\u0433\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A.",
        walletTypes: {
            hardware: "\u0425\u0430\u0440\u0434\u0432\u0435\u0440\u0441\u043A\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            browser: "\u041D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043F\u0440\u0435\u0442\u0440\u0430\u0436\u0438\u0432\u0430\u0447\u0430,",
            injected: "\u0414\u043E\u0434\u0430\u0442\u0430\u043A \u0437\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A,",
            bridge: "Bridge \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A",
            mobile: "\u041C\u043E\u0431\u0438\u043B\u043D\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A"
        },
        selectAccounts: {
            title: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u0437\u0430 \u043F\u0440\u0435\u043D\u043E\u0441.",
            button: "\u0414\u043E\u0431\u0438\u0458\u0442\u0435 \u043F\u0440\u0438\u0441\u0442\u0443\u043F\u043D\u0443 \u0444\u0440\u0430\u0437\u0443",
            deselectAll: "\u041F\u043E\u043D\u0438\u0448\u0442\u0438\u0442\u0435 \u0438\u0437\u0431\u043E\u0440",
            selectAll: "\u0418\u0437\u0430\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u0435",
            unavailable: "\u0422\u0440\u0430\u043D\u0441\u0444\u0435\u0440 \u043D\u0438\u0458\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0430\u043D",
            error: "\u041D\u0430\u043B\u043E\u0433 \u043D\u0435 \u043F\u043E\u0441\u0442\u043E\u0458\u0438",
            warningLedger: "\u041F\u043E\u0442\u0440\u0435\u0431\u043D\u0430 \u043F\u043E\u0434\u0440\u0448\u043A\u0430 \u0437\u0430 Ledger",
            noBalance: "\u041D\u0430\u043B\u043E\u0433 \u043D\u0438\u0458\u0435 \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u0430\u043D"
        },
        getPassphrase: {
            title: "\u041A\u043E\u043F\u0438\u0440\u0430\u0458 \u043F\u0440\u0438\u0432\u0440\u0435\u043C\u0435\u043D\u0443 \u043B\u043E\u0437\u0438\u043D\u043A\u0443",
            desc: "\u041C\u043E\u0440\u0430\u045B\u0435\u0442\u0435 \u0434\u0430 \u0443\u043D\u0435\u0441\u0435\u0442\u0435 \u043E\u0432\u0443 \u043B\u043E\u0437\u0438\u043D\u043A\u0443 \u043A\u0430\u0434\u0430 \u043F\u043E\u0447\u043D\u0435\u0442\u0435 \u0434\u0430 \u0438\u0437\u0432\u043E\u0437\u0438\u0442\u0435 \u0441\u0432\u043E\u0458\u0435 \u043D\u0430\u043B\u043E\u0433\u0435 \u0443 \u0434\u0440\u0443\u0433\u0438 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A.",
            button: "\u041D\u0430\u0441\u0442\u0430\u0432\u0438\u0442\u0435",
            label: "\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u0434\u0430 \u0431\u0438\u0441\u0442\u0435 \u043A\u043E\u043F\u0438\u0440\u0430\u043B\u0438",
            checkLabel: "\u041A\u043E\u043F\u0438\u0440\u0430\u043E \u0441\u0430\u043C \u0438\u043B\u0438 \u0437\u0430\u043F\u0438\u0441\u0430\u043E \u043B\u043E\u0437\u0438\u043D\u043A\u0443"
        },
        complete: {
            title: "\u0414\u043E\u0432\u0440\u0448\u0438\u0442\u0435 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440",
            descOne: "\u0421\u0430\u0434\u0430 \u045B\u0435\u0442\u0435 \u0431\u0438\u0442\u0438 \u043F\u0440\u0435\u0443\u0441\u043C\u0435\u0440\u0435\u043D\u0438 \u043D\u0430 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A \u043A\u043E\u0458\u0438 \u0441\u0442\u0435 \u0438\u0437\u0430\u0431\u0440\u0430\u043B\u0438 \u0434\u0430 \u0437\u0430\u0432\u0440\u0448\u0438\u0442\u0435 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440.",
            descTwo: "\u041A\u0430\u0434\u0430 \u0441\u0435 \u0434\u0435\u043E \u043F\u0440\u043E\u0446\u0435\u0441\u0430 \u0443\u0432\u043E\u0437\u0430 \u0437\u0430\u0432\u0440\u0448\u0438 \u0438\u0437 \u0438\u0437\u0430\u0431\u0440\u0430\u043D\u043E\u0433 \u043D\u043E\u0432\u0447\u0430\u043D\u0438\u043A\u0430, \u043F\u0440\u0438\u0442\u0438\u0441\u043D\u0438\u0442\u0435 \u0434\u0443\u0433\u043C\u0435 \u0434\u0430 \u0437\u0430\u0432\u0440\u0448\u0438\u0442\u0435 \u043F\u0440\u043E\u0446\u0435\u0441 \u043F\u0440\u0435\u043D\u043E\u0441\u0430.",
            button: "\u0417\u0430\u0432\u0440\u0448\u0438\u0442\u0435"
        }
    }
};
var $5bb7220e37bd460f$var$sr = {
    modal: $5bb7220e37bd460f$var$modal
};
const $5bb7220e37bd460f$var$getLanguage = (languageCode)=>{
    switch(languageCode){
        case "en":
            return $5bb7220e37bd460f$var$en;
        case "es":
            return $5bb7220e37bd460f$var$es;
        case "zh":
            return $5bb7220e37bd460f$var$zh;
        case "bg":
            return $5bb7220e37bd460f$var$bg;
        case "ko":
            return $5bb7220e37bd460f$var$ko;
        case "vi":
            return $5bb7220e37bd460f$var$vi;
        case "hi":
            return $5bb7220e37bd460f$var$hi;
        case "ar":
            return $5bb7220e37bd460f$var$ar;
        case "hr":
            return $5bb7220e37bd460f$var$hr;
        case "mk":
            return $5bb7220e37bd460f$var$mk;
        case "sl":
            return $5bb7220e37bd460f$var$sl;
        case "sr":
            return $5bb7220e37bd460f$var$sr;
        default:
            return $5bb7220e37bd460f$var$en;
    }
};
let $5bb7220e37bd460f$var$chosenLang;
const $5bb7220e37bd460f$export$b162ef060a488de1 = (langCode)=>{
    $5bb7220e37bd460f$var$chosenLang = langCode;
};
// (i.e en-CA returns just en)
const $5bb7220e37bd460f$var$shortenLanguageCode = (lang)=>{
    return lang.indexOf("-") !== -1 ? lang.split("-")[0] : lang.split("_")[0];
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5bb7220e37bd460f$var$findObjectPropByStringPath = (obj, prop)=>{
    if (!obj) return "";
    const _index = prop.indexOf(".");
    if (_index > -1) {
        const currentProp = prop.substring(0, _index);
        const nextProp = prop.substring(_index + 1);
        return $5bb7220e37bd460f$var$findObjectPropByStringPath(obj[currentProp], nextProp);
    }
    return obj[prop];
};
const $5bb7220e37bd460f$export$d73ee8ef04f5226a = (path)=>{
    let browserLang = window.navigator.languages ? window.navigator.languages[0] : null;
    browserLang = browserLang || window.navigator.language;
    const languageCode = $5bb7220e37bd460f$var$shortenLanguageCode($5bb7220e37bd460f$var$chosenLang || browserLang);
    const selectedLanguage = $5bb7220e37bd460f$var$getLanguage(languageCode);
    const text = $5bb7220e37bd460f$var$findObjectPropByStringPath(selectedLanguage, path);
    return text && typeof text === "string" ? text : path;
};


var $092c7e998bebe629$exports = {};

$parcel$export($092c7e998bebe629$exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export($092c7e998bebe629$exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export($092c7e998bebe629$exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export($092c7e998bebe629$exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;
var $e6419622b12b5572$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e6419622b12b5572$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== "undefined";
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};


var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $d22956012916b666$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $d22956012916b666$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $22a6389bcfc83921$exports = {};
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$22a6389bcfc83921$exports = $22a6389bcfc83921$var$BitBuffer;


var $3c0264e2c9c64d36$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$3c0264e2c9c64d36$exports = $3c0264e2c9c64d36$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $c20e4b3185223698$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $b4836838cc492349$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $06a1abce65162dc0$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};


$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $758ebb328fd03b3c$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $9563d144998a4c78$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $9563d144998a4c78$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$06a1abce65162dc0$exports = $06a1abce65162dc0$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = "[0-9]+";
const $d479c387334094fb$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, "\\u");
const $d479c387334094fb$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $d479c387334094fb$var$kanji + ")(?:.|[\r\n]))+";
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, "g");
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, "g");
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, "g");
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, "g");
const $d479c387334094fb$var$TEST_KANJI = new RegExp("^" + $d479c387334094fb$var$kanji + "$");
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp("^" + $d479c387334094fb$var$numeric + "$");
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};


$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d479c387334094fb$export$50b7f9bf92c74274(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($d479c387334094fb$export$4ba5f52893b4ac97(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($d479c387334094fb$export$175f16aef75a4569(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case "alphanumeric":
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case "kanji":
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case "byte":
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $c1483b5b1305278f$export$ed1d66da50968976($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $21e4e023abb588c2$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $21e4e023abb588c2$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7f0bebb05133540b$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $21e4e023abb588c2$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $d22956012916b666$export$6788812c4e6611e6(errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $c1483b5b1305278f$export$ed1d66da50968976($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $7a5bacf4a539441d$exports = {};

function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $21e4e023abb588c2$export$4d318981b5a83836;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$7a5bacf4a539441d$exports = $7a5bacf4a539441d$var$NumericData;


var $f6549c884fd9ace3$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $21e4e023abb588c2$export$376a9ed239d6c1c8;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$f6549c884fd9ace3$exports = $f6549c884fd9ace3$var$AlphanumericData;


var $47f01312d66828cb$exports = {};
var $b5acdf7c8123a019$exports = {};
"use strict";
$b5acdf7c8123a019$exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};



function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    if (typeof data === "string") data = $b5acdf7c8123a019$exports(data);
    this.data = new Uint8Array(data);
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$47f01312d66828cb$exports = $47f01312d66828cb$var$ByteData;


var $668803520f2d7445$exports = {};


function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $21e4e023abb588c2$export$a4d452c2363c8e12;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $c1483b5b1305278f$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$668803520f2d7445$exports = $668803520f2d7445$var$KanjiData;




var $6c1abb425b529163$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$6c1abb425b529163$exports = $6c1abb425b529163$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$4d318981b5a83836, $21e4e023abb588c2$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$376a9ed239d6c1c8, $21e4e023abb588c2$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($c1483b5b1305278f$export$ce5b1274f8597fa0()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$8f4bf8f7eb581284, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$a4d452c2363c8e12, $21e4e023abb588c2$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$9df7c29d562bab83, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return $7a5bacf4a539441d$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return $f6549c884fd9ace3$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return $668803520f2d7445$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return $47f01312d66828cb$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $21e4e023abb588c2$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $21e4e023abb588c2$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $21e4e023abb588c2$export$1bd4c93ffb42e55e(data);
    mode = $21e4e023abb588c2$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $21e4e023abb588c2$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $21e4e023abb588c2$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $21e4e023abb588c2$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $21e4e023abb588c2$export$a4d452c2363c8e12 && !$c1483b5b1305278f$export$ce5b1274f8597fa0()) mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return new $7a5bacf4a539441d$exports(data);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return new $f6549c884fd9ace3$exports(data);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return new $668803520f2d7445$exports(data);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return new $47f01312d66828cb$exports(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $6c1abb425b529163$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $b4836838cc492349$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $c20e4b3185223698$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $140eee110ea3b5f9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1f894980312e7d2a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $22a6389bcfc83921$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $21e4e023abb588c2$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7f809b8d8966b945$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $06a1abce65162dc0$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $06b6d7424b9df2df$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $06b6d7424b9df2df$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $06b6d7424b9df2df$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $c1483b5b1305278f$export$8d4a06d3facd414b(version);
    const modules = new $3c0264e2c9c64d36$exports(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $1edc2624fba191d0$export$fe9625aaceb0e563(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $1edc2624fba191d0$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $d22956012916b666$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $d22956012916b666$export$6788812c4e6611e6(options.errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
        version = $140eee110ea3b5f9$export$6788812c4e6611e6(options.version);
        mask = $1edc2624fba191d0$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $c1483b5b1305278f$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $c890d85f31194258$export$d2312e68e1f5ad00(opts);
    const size = $c890d85f31194258$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $c890d85f31194258$export$83136f57c739c5f3(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $3112213e4acbe245$export$b3890eb0ae9dca99;

function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd("M", col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $c890d85f31194258$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$e6419622b12b5572$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $5f2127839fe01a16$export$185802fd694ee1f5;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$b3890eb0ae9dca99);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$c3e5526bbaf70a25);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $3112213e4acbe245$export$b3890eb0ae9dca99(data, opts);
});


var $e5a78797c4262d1f$exports = {};
"use strict";
var $9e6bd5018912b3a9$exports = {};
$9e6bd5018912b3a9$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case "INPUT":
        case "TEXTAREA":
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $e5a78797c4262d1f$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $e5a78797c4262d1f$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $e5a78797c4262d1f$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $e5a78797c4262d1f$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $9e6bd5018912b3a9$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $e5a78797c4262d1f$var$clipboardToIE11Formatting[options.format] || $e5a78797c4262d1f$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $e5a78797c4262d1f$var$format("message" in options ? options.message : $e5a78797c4262d1f$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$e5a78797c4262d1f$exports = $e5a78797c4262d1f$var$copy;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $6daeff2c8e1d7f1b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
var $6daeff2c8e1d7f1b$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $6daeff2c8e1d7f1b$var$fails$h = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $6daeff2c8e1d7f1b$var$fails$g = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$functionBindNative = !$6daeff2c8e1d7f1b$var$fails$g(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $6daeff2c8e1d7f1b$var$NATIVE_BIND$3 = $6daeff2c8e1d7f1b$var$functionBindNative;
var $6daeff2c8e1d7f1b$var$FunctionPrototype$2 = Function.prototype;
var $6daeff2c8e1d7f1b$var$bind$5 = $6daeff2c8e1d7f1b$var$FunctionPrototype$2.bind;
var $6daeff2c8e1d7f1b$var$call$f = $6daeff2c8e1d7f1b$var$FunctionPrototype$2.call;
var $6daeff2c8e1d7f1b$var$uncurryThis$h = $6daeff2c8e1d7f1b$var$NATIVE_BIND$3 && $6daeff2c8e1d7f1b$var$bind$5.bind($6daeff2c8e1d7f1b$var$call$f, $6daeff2c8e1d7f1b$var$call$f);
var $6daeff2c8e1d7f1b$var$functionUncurryThis = $6daeff2c8e1d7f1b$var$NATIVE_BIND$3 ? function(fn) {
    return fn && $6daeff2c8e1d7f1b$var$uncurryThis$h(fn);
} : function(fn) {
    return fn && function() {
        return $6daeff2c8e1d7f1b$var$call$f.apply(fn, arguments);
    };
};
var $6daeff2c8e1d7f1b$var$uncurryThis$g = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$toString$5 = $6daeff2c8e1d7f1b$var$uncurryThis$g({}.toString);
var $6daeff2c8e1d7f1b$var$stringSlice$1 = $6daeff2c8e1d7f1b$var$uncurryThis$g("".slice);
var $6daeff2c8e1d7f1b$var$classofRaw$1 = function(it) {
    return $6daeff2c8e1d7f1b$var$stringSlice$1($6daeff2c8e1d7f1b$var$toString$5(it), 8, -1);
};
var $6daeff2c8e1d7f1b$var$uncurryThis$f = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$fails$f = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$classof$6 = $6daeff2c8e1d7f1b$var$classofRaw$1;
var $6daeff2c8e1d7f1b$var$$Object$4 = Object;
var $6daeff2c8e1d7f1b$var$split = $6daeff2c8e1d7f1b$var$uncurryThis$f("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $6daeff2c8e1d7f1b$var$indexedObject = $6daeff2c8e1d7f1b$var$fails$f(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$6daeff2c8e1d7f1b$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $6daeff2c8e1d7f1b$var$classof$6(it) == "String" ? $6daeff2c8e1d7f1b$var$split(it, "") : $6daeff2c8e1d7f1b$var$$Object$4(it);
} : $6daeff2c8e1d7f1b$var$$Object$4;
var $6daeff2c8e1d7f1b$var$$TypeError$e = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $6daeff2c8e1d7f1b$var$requireObjectCoercible$3 = function(it) {
    if (it == undefined) throw $6daeff2c8e1d7f1b$var$$TypeError$e("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $6daeff2c8e1d7f1b$var$IndexedObject$2 = $6daeff2c8e1d7f1b$var$indexedObject;
var $6daeff2c8e1d7f1b$var$requireObjectCoercible$2 = $6daeff2c8e1d7f1b$var$requireObjectCoercible$3;
var $6daeff2c8e1d7f1b$var$toIndexedObject$5 = function(it) {
    return $6daeff2c8e1d7f1b$var$IndexedObject$2($6daeff2c8e1d7f1b$var$requireObjectCoercible$2(it));
};
var $6daeff2c8e1d7f1b$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $6daeff2c8e1d7f1b$var$global$k = // eslint-disable-next-line es-x/no-global-this -- safe
$6daeff2c8e1d7f1b$var$check(typeof globalThis == "object" && globalThis) || $6daeff2c8e1d7f1b$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$6daeff2c8e1d7f1b$var$check(typeof self == "object" && self) || $6daeff2c8e1d7f1b$var$check(typeof $6daeff2c8e1d7f1b$var$commonjsGlobal == "object" && $6daeff2c8e1d7f1b$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $6daeff2c8e1d7f1b$var$shared$3 = {
    exports: {}
};
var $6daeff2c8e1d7f1b$var$global$j = $6daeff2c8e1d7f1b$var$global$k;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $6daeff2c8e1d7f1b$var$defineProperty$6 = Object.defineProperty;
var $6daeff2c8e1d7f1b$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $6daeff2c8e1d7f1b$var$defineProperty$6($6daeff2c8e1d7f1b$var$global$j, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $6daeff2c8e1d7f1b$var$global$j[key] = value;
    }
    return value;
};
var $6daeff2c8e1d7f1b$var$global$i = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$defineGlobalProperty$2 = $6daeff2c8e1d7f1b$var$defineGlobalProperty$3;
var $6daeff2c8e1d7f1b$var$SHARED = "__core-js_shared__";
var $6daeff2c8e1d7f1b$var$store$3 = $6daeff2c8e1d7f1b$var$global$i[$6daeff2c8e1d7f1b$var$SHARED] || $6daeff2c8e1d7f1b$var$defineGlobalProperty$2($6daeff2c8e1d7f1b$var$SHARED, {});
var $6daeff2c8e1d7f1b$var$sharedStore = $6daeff2c8e1d7f1b$var$store$3;
var $6daeff2c8e1d7f1b$var$store$2 = $6daeff2c8e1d7f1b$var$sharedStore;
($6daeff2c8e1d7f1b$var$shared$3.exports = function(key, value) {
    return $6daeff2c8e1d7f1b$var$store$2[key] || ($6daeff2c8e1d7f1b$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $6daeff2c8e1d7f1b$var$requireObjectCoercible$1 = $6daeff2c8e1d7f1b$var$requireObjectCoercible$3;
var $6daeff2c8e1d7f1b$var$$Object$3 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $6daeff2c8e1d7f1b$var$toObject$5 = function(argument) {
    return $6daeff2c8e1d7f1b$var$$Object$3($6daeff2c8e1d7f1b$var$requireObjectCoercible$1(argument));
};
var $6daeff2c8e1d7f1b$var$uncurryThis$e = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$toObject$4 = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$hasOwnProperty = $6daeff2c8e1d7f1b$var$uncurryThis$e({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $6daeff2c8e1d7f1b$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $6daeff2c8e1d7f1b$var$hasOwnProperty($6daeff2c8e1d7f1b$var$toObject$4(it), key);
};
var $6daeff2c8e1d7f1b$var$uncurryThis$d = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$id = 0;
var $6daeff2c8e1d7f1b$var$postfix = Math.random();
var $6daeff2c8e1d7f1b$var$toString$4 = $6daeff2c8e1d7f1b$var$uncurryThis$d(1.0.toString);
var $6daeff2c8e1d7f1b$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $6daeff2c8e1d7f1b$var$toString$4(++$6daeff2c8e1d7f1b$var$id + $6daeff2c8e1d7f1b$var$postfix, 36);
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $6daeff2c8e1d7f1b$var$isCallable$l = function(argument) {
    return typeof argument == "function";
};
var $6daeff2c8e1d7f1b$var$global$h = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$isCallable$k = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$aFunction = function(argument) {
    return $6daeff2c8e1d7f1b$var$isCallable$k(argument) ? argument : undefined;
};
var $6daeff2c8e1d7f1b$var$getBuiltIn$8 = function(namespace, method) {
    return arguments.length < 2 ? $6daeff2c8e1d7f1b$var$aFunction($6daeff2c8e1d7f1b$var$global$h[namespace]) : $6daeff2c8e1d7f1b$var$global$h[namespace] && $6daeff2c8e1d7f1b$var$global$h[namespace][method];
};
var $6daeff2c8e1d7f1b$var$getBuiltIn$7 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$engineUserAgent = $6daeff2c8e1d7f1b$var$getBuiltIn$7("navigator", "userAgent") || "";
var $6daeff2c8e1d7f1b$var$global$g = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$userAgent$5 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$process$3 = $6daeff2c8e1d7f1b$var$global$g.process;
var $6daeff2c8e1d7f1b$var$Deno$1 = $6daeff2c8e1d7f1b$var$global$g.Deno;
var $6daeff2c8e1d7f1b$var$versions = $6daeff2c8e1d7f1b$var$process$3 && $6daeff2c8e1d7f1b$var$process$3.versions || $6daeff2c8e1d7f1b$var$Deno$1 && $6daeff2c8e1d7f1b$var$Deno$1.version;
var $6daeff2c8e1d7f1b$var$v8 = $6daeff2c8e1d7f1b$var$versions && $6daeff2c8e1d7f1b$var$versions.v8;
var $6daeff2c8e1d7f1b$var$match, $6daeff2c8e1d7f1b$var$version;
if ($6daeff2c8e1d7f1b$var$v8) {
    $6daeff2c8e1d7f1b$var$match = $6daeff2c8e1d7f1b$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $6daeff2c8e1d7f1b$var$version = $6daeff2c8e1d7f1b$var$match[0] > 0 && $6daeff2c8e1d7f1b$var$match[0] < 4 ? 1 : +($6daeff2c8e1d7f1b$var$match[0] + $6daeff2c8e1d7f1b$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$6daeff2c8e1d7f1b$var$version && $6daeff2c8e1d7f1b$var$userAgent$5) {
    $6daeff2c8e1d7f1b$var$match = $6daeff2c8e1d7f1b$var$userAgent$5.match(/Edge\/(\d+)/);
    if (!$6daeff2c8e1d7f1b$var$match || $6daeff2c8e1d7f1b$var$match[1] >= 74) {
        $6daeff2c8e1d7f1b$var$match = $6daeff2c8e1d7f1b$var$userAgent$5.match(/Chrome\/(\d+)/);
        if ($6daeff2c8e1d7f1b$var$match) $6daeff2c8e1d7f1b$var$version = +$6daeff2c8e1d7f1b$var$match[1];
    }
}
var $6daeff2c8e1d7f1b$var$engineV8Version = $6daeff2c8e1d7f1b$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $6daeff2c8e1d7f1b$var$V8_VERSION$1 = $6daeff2c8e1d7f1b$var$engineV8Version;
var $6daeff2c8e1d7f1b$var$fails$e = $6daeff2c8e1d7f1b$var$fails$h;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $6daeff2c8e1d7f1b$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$6daeff2c8e1d7f1b$var$fails$e(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $6daeff2c8e1d7f1b$var$V8_VERSION$1 && $6daeff2c8e1d7f1b$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$2 = $6daeff2c8e1d7f1b$var$nativeSymbol;
var $6daeff2c8e1d7f1b$var$useSymbolAsUid = $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$2 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $6daeff2c8e1d7f1b$var$global$f = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$shared$2 = $6daeff2c8e1d7f1b$var$shared$3.exports;
var $6daeff2c8e1d7f1b$var$hasOwn$b = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$uid$1 = $6daeff2c8e1d7f1b$var$uid$2;
var $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$1 = $6daeff2c8e1d7f1b$var$nativeSymbol;
var $6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID$1 = $6daeff2c8e1d7f1b$var$useSymbolAsUid;
var $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore = $6daeff2c8e1d7f1b$var$shared$2("wks");
var $6daeff2c8e1d7f1b$var$Symbol$1 = $6daeff2c8e1d7f1b$var$global$f.Symbol;
var $6daeff2c8e1d7f1b$var$symbolFor = $6daeff2c8e1d7f1b$var$Symbol$1 && $6daeff2c8e1d7f1b$var$Symbol$1["for"];
var $6daeff2c8e1d7f1b$var$createWellKnownSymbol = $6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID$1 ? $6daeff2c8e1d7f1b$var$Symbol$1 : $6daeff2c8e1d7f1b$var$Symbol$1 && $6daeff2c8e1d7f1b$var$Symbol$1.withoutSetter || $6daeff2c8e1d7f1b$var$uid$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$g = function(name) {
    if (!$6daeff2c8e1d7f1b$var$hasOwn$b($6daeff2c8e1d7f1b$var$WellKnownSymbolsStore, name) || !($6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$1 || typeof $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($6daeff2c8e1d7f1b$var$NATIVE_SYMBOL$1 && $6daeff2c8e1d7f1b$var$hasOwn$b($6daeff2c8e1d7f1b$var$Symbol$1, name)) $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name] = $6daeff2c8e1d7f1b$var$Symbol$1[name];
        else if ($6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID$1 && $6daeff2c8e1d7f1b$var$symbolFor) $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name] = $6daeff2c8e1d7f1b$var$symbolFor(description);
        else $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name] = $6daeff2c8e1d7f1b$var$createWellKnownSymbol(description);
    }
    return $6daeff2c8e1d7f1b$var$WellKnownSymbolsStore[name];
};
var $6daeff2c8e1d7f1b$var$isCallable$j = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isObject$8 = function(it) {
    return typeof it == "object" ? it !== null : $6daeff2c8e1d7f1b$var$isCallable$j(it);
};
var $6daeff2c8e1d7f1b$var$isObject$7 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$$String$3 = String;
var $6daeff2c8e1d7f1b$var$$TypeError$d = TypeError;
// `Assert: Type(argument) is Object`
var $6daeff2c8e1d7f1b$var$anObject$c = function(argument) {
    if ($6daeff2c8e1d7f1b$var$isObject$7(argument)) return argument;
    throw $6daeff2c8e1d7f1b$var$$TypeError$d($6daeff2c8e1d7f1b$var$$String$3(argument) + " is not an object");
};
var $6daeff2c8e1d7f1b$var$objectDefineProperties = {};
var $6daeff2c8e1d7f1b$var$fails$d = $6daeff2c8e1d7f1b$var$fails$h;
// Detect IE8's incomplete defineProperty implementation
var $6daeff2c8e1d7f1b$var$descriptors = !$6daeff2c8e1d7f1b$var$fails$d(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$b = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$fails$c = $6daeff2c8e1d7f1b$var$fails$h;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $6daeff2c8e1d7f1b$var$v8PrototypeDefineBug = $6daeff2c8e1d7f1b$var$DESCRIPTORS$b && $6daeff2c8e1d7f1b$var$fails$c(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $6daeff2c8e1d7f1b$var$objectDefineProperty = {};
var $6daeff2c8e1d7f1b$var$global$e = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$isObject$6 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$document$3 = $6daeff2c8e1d7f1b$var$global$e.document;
// typeof document.createElement is 'object' in old IE
var $6daeff2c8e1d7f1b$var$EXISTS$1 = $6daeff2c8e1d7f1b$var$isObject$6($6daeff2c8e1d7f1b$var$document$3) && $6daeff2c8e1d7f1b$var$isObject$6($6daeff2c8e1d7f1b$var$document$3.createElement);
var $6daeff2c8e1d7f1b$var$documentCreateElement$2 = function(it) {
    return $6daeff2c8e1d7f1b$var$EXISTS$1 ? $6daeff2c8e1d7f1b$var$document$3.createElement(it) : {};
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$a = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$fails$b = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$createElement$1 = $6daeff2c8e1d7f1b$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $6daeff2c8e1d7f1b$var$ie8DomDefine = !$6daeff2c8e1d7f1b$var$DESCRIPTORS$a && !$6daeff2c8e1d7f1b$var$fails$b(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($6daeff2c8e1d7f1b$var$createElement$1("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $6daeff2c8e1d7f1b$var$NATIVE_BIND$2 = $6daeff2c8e1d7f1b$var$functionBindNative;
var $6daeff2c8e1d7f1b$var$call$e = Function.prototype.call;
var $6daeff2c8e1d7f1b$var$functionCall = $6daeff2c8e1d7f1b$var$NATIVE_BIND$2 ? $6daeff2c8e1d7f1b$var$call$e.bind($6daeff2c8e1d7f1b$var$call$e) : function() {
    return $6daeff2c8e1d7f1b$var$call$e.apply($6daeff2c8e1d7f1b$var$call$e, arguments);
};
var $6daeff2c8e1d7f1b$var$uncurryThis$c = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$objectIsPrototypeOf = $6daeff2c8e1d7f1b$var$uncurryThis$c({}.isPrototypeOf);
var $6daeff2c8e1d7f1b$var$getBuiltIn$6 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$isCallable$i = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isPrototypeOf$4 = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID = $6daeff2c8e1d7f1b$var$useSymbolAsUid;
var $6daeff2c8e1d7f1b$var$$Object$2 = Object;
var $6daeff2c8e1d7f1b$var$isSymbol$2 = $6daeff2c8e1d7f1b$var$USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $6daeff2c8e1d7f1b$var$getBuiltIn$6("Symbol");
    return $6daeff2c8e1d7f1b$var$isCallable$i($Symbol) && $6daeff2c8e1d7f1b$var$isPrototypeOf$4($Symbol.prototype, $6daeff2c8e1d7f1b$var$$Object$2(it));
};
var $6daeff2c8e1d7f1b$var$$String$2 = String;
var $6daeff2c8e1d7f1b$var$tryToString$5 = function(argument) {
    try {
        return $6daeff2c8e1d7f1b$var$$String$2(argument);
    } catch (error) {
        return "Object";
    }
};
var $6daeff2c8e1d7f1b$var$isCallable$h = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$tryToString$4 = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$$TypeError$c = TypeError;
// `Assert: IsCallable(argument) is true`
var $6daeff2c8e1d7f1b$var$aCallable$9 = function(argument) {
    if ($6daeff2c8e1d7f1b$var$isCallable$h(argument)) return argument;
    throw $6daeff2c8e1d7f1b$var$$TypeError$c($6daeff2c8e1d7f1b$var$tryToString$4(argument) + " is not a function");
};
var $6daeff2c8e1d7f1b$var$aCallable$8 = $6daeff2c8e1d7f1b$var$aCallable$9;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $6daeff2c8e1d7f1b$var$getMethod$3 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $6daeff2c8e1d7f1b$var$aCallable$8(func);
};
var $6daeff2c8e1d7f1b$var$call$d = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$isCallable$g = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isObject$5 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$$TypeError$b = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $6daeff2c8e1d7f1b$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $6daeff2c8e1d7f1b$var$isCallable$g(fn = input.toString) && !$6daeff2c8e1d7f1b$var$isObject$5(val = $6daeff2c8e1d7f1b$var$call$d(fn, input))) return val;
    if ($6daeff2c8e1d7f1b$var$isCallable$g(fn = input.valueOf) && !$6daeff2c8e1d7f1b$var$isObject$5(val = $6daeff2c8e1d7f1b$var$call$d(fn, input))) return val;
    if (pref !== "string" && $6daeff2c8e1d7f1b$var$isCallable$g(fn = input.toString) && !$6daeff2c8e1d7f1b$var$isObject$5(val = $6daeff2c8e1d7f1b$var$call$d(fn, input))) return val;
    throw $6daeff2c8e1d7f1b$var$$TypeError$b("Can't convert object to primitive value");
};
var $6daeff2c8e1d7f1b$var$call$c = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$isObject$4 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$isSymbol$1 = $6daeff2c8e1d7f1b$var$isSymbol$2;
var $6daeff2c8e1d7f1b$var$getMethod$2 = $6daeff2c8e1d7f1b$var$getMethod$3;
var $6daeff2c8e1d7f1b$var$ordinaryToPrimitive = $6daeff2c8e1d7f1b$var$ordinaryToPrimitive$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$f = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$$TypeError$a = TypeError;
var $6daeff2c8e1d7f1b$var$TO_PRIMITIVE = $6daeff2c8e1d7f1b$var$wellKnownSymbol$f("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $6daeff2c8e1d7f1b$var$toPrimitive$1 = function(input, pref) {
    if (!$6daeff2c8e1d7f1b$var$isObject$4(input) || $6daeff2c8e1d7f1b$var$isSymbol$1(input)) return input;
    var exoticToPrim = $6daeff2c8e1d7f1b$var$getMethod$2(input, $6daeff2c8e1d7f1b$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $6daeff2c8e1d7f1b$var$call$c(exoticToPrim, input, pref);
        if (!$6daeff2c8e1d7f1b$var$isObject$4(result) || $6daeff2c8e1d7f1b$var$isSymbol$1(result)) return result;
        throw $6daeff2c8e1d7f1b$var$$TypeError$a("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $6daeff2c8e1d7f1b$var$ordinaryToPrimitive(input, pref);
};
var $6daeff2c8e1d7f1b$var$toPrimitive = $6daeff2c8e1d7f1b$var$toPrimitive$1;
var $6daeff2c8e1d7f1b$var$isSymbol = $6daeff2c8e1d7f1b$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $6daeff2c8e1d7f1b$var$toPropertyKey$3 = function(argument) {
    var key = $6daeff2c8e1d7f1b$var$toPrimitive(argument, "string");
    return $6daeff2c8e1d7f1b$var$isSymbol(key) ? key : key + "";
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$9 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$IE8_DOM_DEFINE$1 = $6daeff2c8e1d7f1b$var$ie8DomDefine;
var $6daeff2c8e1d7f1b$var$V8_PROTOTYPE_DEFINE_BUG$1 = $6daeff2c8e1d7f1b$var$v8PrototypeDefineBug;
var $6daeff2c8e1d7f1b$var$anObject$b = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$toPropertyKey$2 = $6daeff2c8e1d7f1b$var$toPropertyKey$3;
var $6daeff2c8e1d7f1b$var$$TypeError$9 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $6daeff2c8e1d7f1b$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var $6daeff2c8e1d7f1b$var$ENUMERABLE = "enumerable";
var $6daeff2c8e1d7f1b$var$CONFIGURABLE$1 = "configurable";
var $6daeff2c8e1d7f1b$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$6daeff2c8e1d7f1b$var$objectDefineProperty.f = $6daeff2c8e1d7f1b$var$DESCRIPTORS$9 ? $6daeff2c8e1d7f1b$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $6daeff2c8e1d7f1b$var$anObject$b(O);
    P = $6daeff2c8e1d7f1b$var$toPropertyKey$2(P);
    $6daeff2c8e1d7f1b$var$anObject$b(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $6daeff2c8e1d7f1b$var$WRITABLE in Attributes && !Attributes[$6daeff2c8e1d7f1b$var$WRITABLE]) {
        var current = $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor$1(O, P);
        if (current && current[$6daeff2c8e1d7f1b$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $6daeff2c8e1d7f1b$var$CONFIGURABLE$1 in Attributes ? Attributes[$6daeff2c8e1d7f1b$var$CONFIGURABLE$1] : current[$6daeff2c8e1d7f1b$var$CONFIGURABLE$1],
                enumerable: $6daeff2c8e1d7f1b$var$ENUMERABLE in Attributes ? Attributes[$6daeff2c8e1d7f1b$var$ENUMERABLE] : current[$6daeff2c8e1d7f1b$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $6daeff2c8e1d7f1b$var$$defineProperty(O, P, Attributes);
} : $6daeff2c8e1d7f1b$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $6daeff2c8e1d7f1b$var$anObject$b(O);
    P = $6daeff2c8e1d7f1b$var$toPropertyKey$2(P);
    $6daeff2c8e1d7f1b$var$anObject$b(Attributes);
    if ($6daeff2c8e1d7f1b$var$IE8_DOM_DEFINE$1) try {
        return $6daeff2c8e1d7f1b$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $6daeff2c8e1d7f1b$var$$TypeError$9("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $6daeff2c8e1d7f1b$var$ceil = Math.ceil;
var $6daeff2c8e1d7f1b$var$floor$1 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $6daeff2c8e1d7f1b$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $6daeff2c8e1d7f1b$var$floor$1 : $6daeff2c8e1d7f1b$var$ceil)(n);
};
var $6daeff2c8e1d7f1b$var$trunc = $6daeff2c8e1d7f1b$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $6daeff2c8e1d7f1b$var$trunc(number);
};
var $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$1 = $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$2;
var $6daeff2c8e1d7f1b$var$max$1 = Math.max;
var $6daeff2c8e1d7f1b$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $6daeff2c8e1d7f1b$var$toAbsoluteIndex$2 = function(index, length) {
    var integer = $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $6daeff2c8e1d7f1b$var$max$1(integer + length, 0) : $6daeff2c8e1d7f1b$var$min$1(integer, length);
};
var $6daeff2c8e1d7f1b$var$toIntegerOrInfinity = $6daeff2c8e1d7f1b$var$toIntegerOrInfinity$2;
var $6daeff2c8e1d7f1b$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $6daeff2c8e1d7f1b$var$toLength$1 = function(argument) {
    return argument > 0 ? $6daeff2c8e1d7f1b$var$min($6daeff2c8e1d7f1b$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $6daeff2c8e1d7f1b$var$toLength = $6daeff2c8e1d7f1b$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5 = function(obj) {
    return $6daeff2c8e1d7f1b$var$toLength(obj.length);
};
var $6daeff2c8e1d7f1b$var$toIndexedObject$4 = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$toAbsoluteIndex$1 = $6daeff2c8e1d7f1b$var$toAbsoluteIndex$2;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$4 = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $6daeff2c8e1d7f1b$var$createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $6daeff2c8e1d7f1b$var$toIndexedObject$4($this);
        var length = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$4(O);
        var index = $6daeff2c8e1d7f1b$var$toAbsoluteIndex$1(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $6daeff2c8e1d7f1b$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $6daeff2c8e1d7f1b$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $6daeff2c8e1d7f1b$var$createMethod$1(false)
};
var $6daeff2c8e1d7f1b$var$hiddenKeys$4 = {};
var $6daeff2c8e1d7f1b$var$uncurryThis$b = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$hasOwn$a = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$toIndexedObject$3 = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$indexOf = $6daeff2c8e1d7f1b$var$arrayIncludes.indexOf;
var $6daeff2c8e1d7f1b$var$hiddenKeys$3 = $6daeff2c8e1d7f1b$var$hiddenKeys$4;
var $6daeff2c8e1d7f1b$var$push$1 = $6daeff2c8e1d7f1b$var$uncurryThis$b([].push);
var $6daeff2c8e1d7f1b$var$objectKeysInternal = function(object, names) {
    var O = $6daeff2c8e1d7f1b$var$toIndexedObject$3(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$6daeff2c8e1d7f1b$var$hasOwn$a($6daeff2c8e1d7f1b$var$hiddenKeys$3, key) && $6daeff2c8e1d7f1b$var$hasOwn$a(O, key) && $6daeff2c8e1d7f1b$var$push$1(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($6daeff2c8e1d7f1b$var$hasOwn$a(O, key = names[i++])) ~$6daeff2c8e1d7f1b$var$indexOf(result, key) || $6daeff2c8e1d7f1b$var$push$1(result, key);
    return result;
};
// IE8- don't enum bug keys
var $6daeff2c8e1d7f1b$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $6daeff2c8e1d7f1b$var$internalObjectKeys$1 = $6daeff2c8e1d7f1b$var$objectKeysInternal;
var $6daeff2c8e1d7f1b$var$enumBugKeys$2 = $6daeff2c8e1d7f1b$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $6daeff2c8e1d7f1b$var$objectKeys$2 = Object.keys || function keys(O) {
    return $6daeff2c8e1d7f1b$var$internalObjectKeys$1(O, $6daeff2c8e1d7f1b$var$enumBugKeys$2);
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$8 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$V8_PROTOTYPE_DEFINE_BUG = $6daeff2c8e1d7f1b$var$v8PrototypeDefineBug;
var $6daeff2c8e1d7f1b$var$definePropertyModule$5 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$anObject$a = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$toIndexedObject$2 = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$objectKeys$1 = $6daeff2c8e1d7f1b$var$objectKeys$2;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$6daeff2c8e1d7f1b$var$objectDefineProperties.f = $6daeff2c8e1d7f1b$var$DESCRIPTORS$8 && !$6daeff2c8e1d7f1b$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $6daeff2c8e1d7f1b$var$anObject$a(O);
    var props = $6daeff2c8e1d7f1b$var$toIndexedObject$2(Properties);
    var keys = $6daeff2c8e1d7f1b$var$objectKeys$1(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$6daeff2c8e1d7f1b$var$definePropertyModule$5.f(O, key = keys[index++], props[key]);
    return O;
};
var $6daeff2c8e1d7f1b$var$getBuiltIn$5 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$html$2 = $6daeff2c8e1d7f1b$var$getBuiltIn$5("document", "documentElement");
var $6daeff2c8e1d7f1b$var$shared$1 = $6daeff2c8e1d7f1b$var$shared$3.exports;
var $6daeff2c8e1d7f1b$var$uid = $6daeff2c8e1d7f1b$var$uid$2;
var $6daeff2c8e1d7f1b$var$keys = $6daeff2c8e1d7f1b$var$shared$1("keys");
var $6daeff2c8e1d7f1b$var$sharedKey$3 = function(key) {
    return $6daeff2c8e1d7f1b$var$keys[key] || ($6daeff2c8e1d7f1b$var$keys[key] = $6daeff2c8e1d7f1b$var$uid(key));
};
/* global ActiveXObject -- old IE, WSH */ var $6daeff2c8e1d7f1b$var$anObject$9 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$definePropertiesModule = $6daeff2c8e1d7f1b$var$objectDefineProperties;
var $6daeff2c8e1d7f1b$var$enumBugKeys$1 = $6daeff2c8e1d7f1b$var$enumBugKeys$3;
var $6daeff2c8e1d7f1b$var$hiddenKeys$2 = $6daeff2c8e1d7f1b$var$hiddenKeys$4;
var $6daeff2c8e1d7f1b$var$html$1 = $6daeff2c8e1d7f1b$var$html$2;
var $6daeff2c8e1d7f1b$var$documentCreateElement$1 = $6daeff2c8e1d7f1b$var$documentCreateElement$2;
var $6daeff2c8e1d7f1b$var$sharedKey$2 = $6daeff2c8e1d7f1b$var$sharedKey$3;
var $6daeff2c8e1d7f1b$var$GT = ">";
var $6daeff2c8e1d7f1b$var$LT = "<";
var $6daeff2c8e1d7f1b$var$PROTOTYPE = "prototype";
var $6daeff2c8e1d7f1b$var$SCRIPT = "script";
var $6daeff2c8e1d7f1b$var$IE_PROTO$1 = $6daeff2c8e1d7f1b$var$sharedKey$2("IE_PROTO");
var $6daeff2c8e1d7f1b$var$EmptyConstructor = function() {};
var $6daeff2c8e1d7f1b$var$scriptTag = function(content) {
    return $6daeff2c8e1d7f1b$var$LT + $6daeff2c8e1d7f1b$var$SCRIPT + $6daeff2c8e1d7f1b$var$GT + content + $6daeff2c8e1d7f1b$var$LT + "/" + $6daeff2c8e1d7f1b$var$SCRIPT + $6daeff2c8e1d7f1b$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $6daeff2c8e1d7f1b$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($6daeff2c8e1d7f1b$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $6daeff2c8e1d7f1b$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $6daeff2c8e1d7f1b$var$documentCreateElement$1("iframe");
    var JS = "java" + $6daeff2c8e1d7f1b$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $6daeff2c8e1d7f1b$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($6daeff2c8e1d7f1b$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $6daeff2c8e1d7f1b$var$activeXDocument;
var $6daeff2c8e1d7f1b$var$NullProtoObject = function() {
    try {
        $6daeff2c8e1d7f1b$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $6daeff2c8e1d7f1b$var$NullProtoObject = typeof document != "undefined" ? document.domain && $6daeff2c8e1d7f1b$var$activeXDocument ? $6daeff2c8e1d7f1b$var$NullProtoObjectViaActiveX($6daeff2c8e1d7f1b$var$activeXDocument) // old IE
     : $6daeff2c8e1d7f1b$var$NullProtoObjectViaIFrame() : $6daeff2c8e1d7f1b$var$NullProtoObjectViaActiveX($6daeff2c8e1d7f1b$var$activeXDocument); // WSH
    var length = $6daeff2c8e1d7f1b$var$enumBugKeys$1.length;
    while(length--)delete $6daeff2c8e1d7f1b$var$NullProtoObject[$6daeff2c8e1d7f1b$var$PROTOTYPE][$6daeff2c8e1d7f1b$var$enumBugKeys$1[length]];
    return $6daeff2c8e1d7f1b$var$NullProtoObject();
};
$6daeff2c8e1d7f1b$var$hiddenKeys$2[$6daeff2c8e1d7f1b$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $6daeff2c8e1d7f1b$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $6daeff2c8e1d7f1b$var$EmptyConstructor[$6daeff2c8e1d7f1b$var$PROTOTYPE] = $6daeff2c8e1d7f1b$var$anObject$9(O);
        result = new $6daeff2c8e1d7f1b$var$EmptyConstructor();
        $6daeff2c8e1d7f1b$var$EmptyConstructor[$6daeff2c8e1d7f1b$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$6daeff2c8e1d7f1b$var$IE_PROTO$1] = O;
    } else result = $6daeff2c8e1d7f1b$var$NullProtoObject();
    return Properties === undefined ? result : $6daeff2c8e1d7f1b$var$definePropertiesModule.f(result, Properties);
};
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$e = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$create$1 = $6daeff2c8e1d7f1b$var$objectCreate;
var $6daeff2c8e1d7f1b$var$defineProperty$5 = $6daeff2c8e1d7f1b$var$objectDefineProperty.f;
var $6daeff2c8e1d7f1b$var$UNSCOPABLES = $6daeff2c8e1d7f1b$var$wellKnownSymbol$e("unscopables");
var $6daeff2c8e1d7f1b$var$ArrayPrototype$1 = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($6daeff2c8e1d7f1b$var$ArrayPrototype$1[$6daeff2c8e1d7f1b$var$UNSCOPABLES] == undefined) $6daeff2c8e1d7f1b$var$defineProperty$5($6daeff2c8e1d7f1b$var$ArrayPrototype$1, $6daeff2c8e1d7f1b$var$UNSCOPABLES, {
    configurable: true,
    value: $6daeff2c8e1d7f1b$var$create$1(null)
});
// add a key to Array.prototype[@@unscopables]
var $6daeff2c8e1d7f1b$var$addToUnscopables$2 = function(key) {
    $6daeff2c8e1d7f1b$var$ArrayPrototype$1[$6daeff2c8e1d7f1b$var$UNSCOPABLES][key] = true;
};
var $6daeff2c8e1d7f1b$var$iterators = {};
var $6daeff2c8e1d7f1b$var$uncurryThis$a = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$isCallable$f = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$store$1 = $6daeff2c8e1d7f1b$var$sharedStore;
var $6daeff2c8e1d7f1b$var$functionToString = $6daeff2c8e1d7f1b$var$uncurryThis$a(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$6daeff2c8e1d7f1b$var$isCallable$f($6daeff2c8e1d7f1b$var$store$1.inspectSource)) $6daeff2c8e1d7f1b$var$store$1.inspectSource = function(it) {
    return $6daeff2c8e1d7f1b$var$functionToString(it);
};
var $6daeff2c8e1d7f1b$var$inspectSource$4 = $6daeff2c8e1d7f1b$var$store$1.inspectSource;
var $6daeff2c8e1d7f1b$var$global$d = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$isCallable$e = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$inspectSource$3 = $6daeff2c8e1d7f1b$var$inspectSource$4;
var $6daeff2c8e1d7f1b$var$WeakMap$1 = $6daeff2c8e1d7f1b$var$global$d.WeakMap;
var $6daeff2c8e1d7f1b$var$nativeWeakMap = $6daeff2c8e1d7f1b$var$isCallable$e($6daeff2c8e1d7f1b$var$WeakMap$1) && /native code/.test($6daeff2c8e1d7f1b$var$inspectSource$3($6daeff2c8e1d7f1b$var$WeakMap$1));
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$7 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$definePropertyModule$4 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor$3 = $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4 = $6daeff2c8e1d7f1b$var$DESCRIPTORS$7 ? function(object, key, value) {
    return $6daeff2c8e1d7f1b$var$definePropertyModule$4.f(object, key, $6daeff2c8e1d7f1b$var$createPropertyDescriptor$3(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $6daeff2c8e1d7f1b$var$NATIVE_WEAK_MAP = $6daeff2c8e1d7f1b$var$nativeWeakMap;
var $6daeff2c8e1d7f1b$var$global$c = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$uncurryThis$9 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$isObject$3 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$3 = $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4;
var $6daeff2c8e1d7f1b$var$hasOwn$9 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$shared = $6daeff2c8e1d7f1b$var$sharedStore;
var $6daeff2c8e1d7f1b$var$sharedKey$1 = $6daeff2c8e1d7f1b$var$sharedKey$3;
var $6daeff2c8e1d7f1b$var$hiddenKeys$1 = $6daeff2c8e1d7f1b$var$hiddenKeys$4;
var $6daeff2c8e1d7f1b$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $6daeff2c8e1d7f1b$var$TypeError$2 = $6daeff2c8e1d7f1b$var$global$c.TypeError;
var $6daeff2c8e1d7f1b$var$WeakMap = $6daeff2c8e1d7f1b$var$global$c.WeakMap;
var $6daeff2c8e1d7f1b$var$set$1, $6daeff2c8e1d7f1b$var$get, $6daeff2c8e1d7f1b$var$has;
var $6daeff2c8e1d7f1b$var$enforce = function(it) {
    return $6daeff2c8e1d7f1b$var$has(it) ? $6daeff2c8e1d7f1b$var$get(it) : $6daeff2c8e1d7f1b$var$set$1(it, {});
};
var $6daeff2c8e1d7f1b$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$6daeff2c8e1d7f1b$var$isObject$3(it) || (state = $6daeff2c8e1d7f1b$var$get(it)).type !== TYPE) throw $6daeff2c8e1d7f1b$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($6daeff2c8e1d7f1b$var$NATIVE_WEAK_MAP || $6daeff2c8e1d7f1b$var$shared.state) {
    var $6daeff2c8e1d7f1b$var$store = $6daeff2c8e1d7f1b$var$shared.state || ($6daeff2c8e1d7f1b$var$shared.state = new $6daeff2c8e1d7f1b$var$WeakMap());
    var $6daeff2c8e1d7f1b$var$wmget = $6daeff2c8e1d7f1b$var$uncurryThis$9($6daeff2c8e1d7f1b$var$store.get);
    var $6daeff2c8e1d7f1b$var$wmhas = $6daeff2c8e1d7f1b$var$uncurryThis$9($6daeff2c8e1d7f1b$var$store.has);
    var $6daeff2c8e1d7f1b$var$wmset = $6daeff2c8e1d7f1b$var$uncurryThis$9($6daeff2c8e1d7f1b$var$store.set);
    $6daeff2c8e1d7f1b$var$set$1 = function(it, metadata) {
        if ($6daeff2c8e1d7f1b$var$wmhas($6daeff2c8e1d7f1b$var$store, it)) throw new $6daeff2c8e1d7f1b$var$TypeError$2($6daeff2c8e1d7f1b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $6daeff2c8e1d7f1b$var$wmset($6daeff2c8e1d7f1b$var$store, it, metadata);
        return metadata;
    };
    $6daeff2c8e1d7f1b$var$get = function(it) {
        return $6daeff2c8e1d7f1b$var$wmget($6daeff2c8e1d7f1b$var$store, it) || {};
    };
    $6daeff2c8e1d7f1b$var$has = function(it) {
        return $6daeff2c8e1d7f1b$var$wmhas($6daeff2c8e1d7f1b$var$store, it);
    };
} else {
    var $6daeff2c8e1d7f1b$var$STATE = $6daeff2c8e1d7f1b$var$sharedKey$1("state");
    $6daeff2c8e1d7f1b$var$hiddenKeys$1[$6daeff2c8e1d7f1b$var$STATE] = true;
    $6daeff2c8e1d7f1b$var$set$1 = function(it, metadata) {
        if ($6daeff2c8e1d7f1b$var$hasOwn$9(it, $6daeff2c8e1d7f1b$var$STATE)) throw new $6daeff2c8e1d7f1b$var$TypeError$2($6daeff2c8e1d7f1b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$3(it, $6daeff2c8e1d7f1b$var$STATE, metadata);
        return metadata;
    };
    $6daeff2c8e1d7f1b$var$get = function(it) {
        return $6daeff2c8e1d7f1b$var$hasOwn$9(it, $6daeff2c8e1d7f1b$var$STATE) ? it[$6daeff2c8e1d7f1b$var$STATE] : {};
    };
    $6daeff2c8e1d7f1b$var$has = function(it) {
        return $6daeff2c8e1d7f1b$var$hasOwn$9(it, $6daeff2c8e1d7f1b$var$STATE);
    };
}
var $6daeff2c8e1d7f1b$var$internalState = {
    set: $6daeff2c8e1d7f1b$var$set$1,
    get: $6daeff2c8e1d7f1b$var$get,
    has: $6daeff2c8e1d7f1b$var$has,
    enforce: $6daeff2c8e1d7f1b$var$enforce,
    getterFor: $6daeff2c8e1d7f1b$var$getterFor
};
var $6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor = {};
var $6daeff2c8e1d7f1b$var$objectPropertyIsEnumerable = {};
var $6daeff2c8e1d7f1b$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $6daeff2c8e1d7f1b$var$NASHORN_BUG = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$2 && !$6daeff2c8e1d7f1b$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$6daeff2c8e1d7f1b$var$objectPropertyIsEnumerable.f = $6daeff2c8e1d7f1b$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $6daeff2c8e1d7f1b$var$$propertyIsEnumerable;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$6 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$call$b = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$propertyIsEnumerableModule$1 = $6daeff2c8e1d7f1b$var$objectPropertyIsEnumerable;
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor$2 = $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4;
var $6daeff2c8e1d7f1b$var$toIndexedObject$1 = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$toPropertyKey$1 = $6daeff2c8e1d7f1b$var$toPropertyKey$3;
var $6daeff2c8e1d7f1b$var$hasOwn$8 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$IE8_DOM_DEFINE = $6daeff2c8e1d7f1b$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor.f = $6daeff2c8e1d7f1b$var$DESCRIPTORS$6 ? $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $6daeff2c8e1d7f1b$var$toIndexedObject$1(O);
    P = $6daeff2c8e1d7f1b$var$toPropertyKey$1(P);
    if ($6daeff2c8e1d7f1b$var$IE8_DOM_DEFINE) try {
        return $6daeff2c8e1d7f1b$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($6daeff2c8e1d7f1b$var$hasOwn$8(O, P)) return $6daeff2c8e1d7f1b$var$createPropertyDescriptor$2(!$6daeff2c8e1d7f1b$var$call$b($6daeff2c8e1d7f1b$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $6daeff2c8e1d7f1b$var$makeBuiltIn$2 = {
    exports: {}
};
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$5 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$hasOwn$7 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $6daeff2c8e1d7f1b$var$getDescriptor = $6daeff2c8e1d7f1b$var$DESCRIPTORS$5 && Object.getOwnPropertyDescriptor;
var $6daeff2c8e1d7f1b$var$EXISTS = $6daeff2c8e1d7f1b$var$hasOwn$7($6daeff2c8e1d7f1b$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $6daeff2c8e1d7f1b$var$PROPER = $6daeff2c8e1d7f1b$var$EXISTS && (function something() {}).name === "something";
var $6daeff2c8e1d7f1b$var$CONFIGURABLE = $6daeff2c8e1d7f1b$var$EXISTS && (!$6daeff2c8e1d7f1b$var$DESCRIPTORS$5 || $6daeff2c8e1d7f1b$var$DESCRIPTORS$5 && $6daeff2c8e1d7f1b$var$getDescriptor($6daeff2c8e1d7f1b$var$FunctionPrototype$1, "name").configurable);
var $6daeff2c8e1d7f1b$var$functionName = {
    EXISTS: $6daeff2c8e1d7f1b$var$EXISTS,
    PROPER: $6daeff2c8e1d7f1b$var$PROPER,
    CONFIGURABLE: $6daeff2c8e1d7f1b$var$CONFIGURABLE
};
var $6daeff2c8e1d7f1b$var$fails$a = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$isCallable$d = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$hasOwn$6 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$4 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$CONFIGURABLE_FUNCTION_NAME$1 = $6daeff2c8e1d7f1b$var$functionName.CONFIGURABLE;
var $6daeff2c8e1d7f1b$var$inspectSource$2 = $6daeff2c8e1d7f1b$var$inspectSource$4;
var $6daeff2c8e1d7f1b$var$InternalStateModule$2 = $6daeff2c8e1d7f1b$var$internalState;
var $6daeff2c8e1d7f1b$var$enforceInternalState = $6daeff2c8e1d7f1b$var$InternalStateModule$2.enforce;
var $6daeff2c8e1d7f1b$var$getInternalState$1 = $6daeff2c8e1d7f1b$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $6daeff2c8e1d7f1b$var$defineProperty$4 = Object.defineProperty;
var $6daeff2c8e1d7f1b$var$CONFIGURABLE_LENGTH = $6daeff2c8e1d7f1b$var$DESCRIPTORS$4 && !$6daeff2c8e1d7f1b$var$fails$a(function() {
    return $6daeff2c8e1d7f1b$var$defineProperty$4(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $6daeff2c8e1d7f1b$var$TEMPLATE = String(String).split("String");
var $6daeff2c8e1d7f1b$var$makeBuiltIn$1 = $6daeff2c8e1d7f1b$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$6daeff2c8e1d7f1b$var$hasOwn$6(value, "name") || $6daeff2c8e1d7f1b$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$4) $6daeff2c8e1d7f1b$var$defineProperty$4(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($6daeff2c8e1d7f1b$var$CONFIGURABLE_LENGTH && options && $6daeff2c8e1d7f1b$var$hasOwn$6(options, "arity") && value.length !== options.arity) $6daeff2c8e1d7f1b$var$defineProperty$4(value, "length", {
        value: options.arity
    });
    try {
        if (options && $6daeff2c8e1d7f1b$var$hasOwn$6(options, "constructor") && options.constructor) {
            if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$4) $6daeff2c8e1d7f1b$var$defineProperty$4(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $6daeff2c8e1d7f1b$var$enforceInternalState(value);
    if (!$6daeff2c8e1d7f1b$var$hasOwn$6(state, "source")) state.source = $6daeff2c8e1d7f1b$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $6daeff2c8e1d7f1b$var$makeBuiltIn$1(function toString() {
    return $6daeff2c8e1d7f1b$var$isCallable$d(this) && $6daeff2c8e1d7f1b$var$getInternalState$1(this).source || $6daeff2c8e1d7f1b$var$inspectSource$2(this);
}, "toString");
var $6daeff2c8e1d7f1b$var$isCallable$c = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$definePropertyModule$3 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$makeBuiltIn = $6daeff2c8e1d7f1b$var$makeBuiltIn$2.exports;
var $6daeff2c8e1d7f1b$var$defineGlobalProperty$1 = $6daeff2c8e1d7f1b$var$defineGlobalProperty$3;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$6 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($6daeff2c8e1d7f1b$var$isCallable$c(value)) $6daeff2c8e1d7f1b$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $6daeff2c8e1d7f1b$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $6daeff2c8e1d7f1b$var$definePropertyModule$3.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $6daeff2c8e1d7f1b$var$objectGetOwnPropertyNames = {};
var $6daeff2c8e1d7f1b$var$internalObjectKeys = $6daeff2c8e1d7f1b$var$objectKeysInternal;
var $6daeff2c8e1d7f1b$var$enumBugKeys = $6daeff2c8e1d7f1b$var$enumBugKeys$3;
var $6daeff2c8e1d7f1b$var$hiddenKeys = $6daeff2c8e1d7f1b$var$enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$6daeff2c8e1d7f1b$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $6daeff2c8e1d7f1b$var$internalObjectKeys(O, $6daeff2c8e1d7f1b$var$hiddenKeys);
};
var $6daeff2c8e1d7f1b$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$6daeff2c8e1d7f1b$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $6daeff2c8e1d7f1b$var$getBuiltIn$4 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$uncurryThis$8 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$getOwnPropertyNamesModule = $6daeff2c8e1d7f1b$var$objectGetOwnPropertyNames;
var $6daeff2c8e1d7f1b$var$getOwnPropertySymbolsModule$1 = $6daeff2c8e1d7f1b$var$objectGetOwnPropertySymbols;
var $6daeff2c8e1d7f1b$var$anObject$8 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$concat$1 = $6daeff2c8e1d7f1b$var$uncurryThis$8([].concat);
// all object keys, includes non-enumerable and symbols
var $6daeff2c8e1d7f1b$var$ownKeys$1 = $6daeff2c8e1d7f1b$var$getBuiltIn$4("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $6daeff2c8e1d7f1b$var$getOwnPropertyNamesModule.f($6daeff2c8e1d7f1b$var$anObject$8(it));
    var getOwnPropertySymbols = $6daeff2c8e1d7f1b$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $6daeff2c8e1d7f1b$var$concat$1(keys, getOwnPropertySymbols(it)) : keys;
};
var $6daeff2c8e1d7f1b$var$hasOwn$5 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$ownKeys = $6daeff2c8e1d7f1b$var$ownKeys$1;
var $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptorModule = $6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor;
var $6daeff2c8e1d7f1b$var$definePropertyModule$2 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$copyConstructorProperties$2 = function(target, source, exceptions) {
    var keys = $6daeff2c8e1d7f1b$var$ownKeys(source);
    var defineProperty = $6daeff2c8e1d7f1b$var$definePropertyModule$2.f;
    var getOwnPropertyDescriptor = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$6daeff2c8e1d7f1b$var$hasOwn$5(target, key) && !(exceptions && $6daeff2c8e1d7f1b$var$hasOwn$5(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $6daeff2c8e1d7f1b$var$fails$9 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$isCallable$b = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$replacement = /#|\.prototype\./;
var $6daeff2c8e1d7f1b$var$isForced$2 = function(feature, detection) {
    var value = $6daeff2c8e1d7f1b$var$data[$6daeff2c8e1d7f1b$var$normalize(feature)];
    return value == $6daeff2c8e1d7f1b$var$POLYFILL ? true : value == $6daeff2c8e1d7f1b$var$NATIVE ? false : $6daeff2c8e1d7f1b$var$isCallable$b(detection) ? $6daeff2c8e1d7f1b$var$fails$9(detection) : !!detection;
};
var $6daeff2c8e1d7f1b$var$normalize = $6daeff2c8e1d7f1b$var$isForced$2.normalize = function(string) {
    return String(string).replace($6daeff2c8e1d7f1b$var$replacement, ".").toLowerCase();
};
var $6daeff2c8e1d7f1b$var$data = $6daeff2c8e1d7f1b$var$isForced$2.data = {};
var $6daeff2c8e1d7f1b$var$NATIVE = $6daeff2c8e1d7f1b$var$isForced$2.NATIVE = "N";
var $6daeff2c8e1d7f1b$var$POLYFILL = $6daeff2c8e1d7f1b$var$isForced$2.POLYFILL = "P";
var $6daeff2c8e1d7f1b$var$isForced_1 = $6daeff2c8e1d7f1b$var$isForced$2;
var $6daeff2c8e1d7f1b$var$global$b = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$1 = $6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor.f;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$2 = $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$5 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$defineGlobalProperty = $6daeff2c8e1d7f1b$var$defineGlobalProperty$3;
var $6daeff2c8e1d7f1b$var$copyConstructorProperties$1 = $6daeff2c8e1d7f1b$var$copyConstructorProperties$2;
var $6daeff2c8e1d7f1b$var$isForced$1 = $6daeff2c8e1d7f1b$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $6daeff2c8e1d7f1b$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $6daeff2c8e1d7f1b$var$global$b;
    else if (STATIC) target = $6daeff2c8e1d7f1b$var$global$b[TARGET] || $6daeff2c8e1d7f1b$var$defineGlobalProperty(TARGET, {});
    else target = ($6daeff2c8e1d7f1b$var$global$b[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $6daeff2c8e1d7f1b$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $6daeff2c8e1d7f1b$var$copyConstructorProperties$1(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$2(sourceProperty, "sham", true);
        $6daeff2c8e1d7f1b$var$defineBuiltIn$5(target, key, sourceProperty, options);
    }
};
var $6daeff2c8e1d7f1b$var$fails$8 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$correctPrototypeGetter = !$6daeff2c8e1d7f1b$var$fails$8(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $6daeff2c8e1d7f1b$var$hasOwn$4 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$isCallable$a = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$toObject$3 = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$sharedKey = $6daeff2c8e1d7f1b$var$sharedKey$3;
var $6daeff2c8e1d7f1b$var$CORRECT_PROTOTYPE_GETTER = $6daeff2c8e1d7f1b$var$correctPrototypeGetter;
var $6daeff2c8e1d7f1b$var$IE_PROTO = $6daeff2c8e1d7f1b$var$sharedKey("IE_PROTO");
var $6daeff2c8e1d7f1b$var$$Object$1 = Object;
var $6daeff2c8e1d7f1b$var$ObjectPrototype = $6daeff2c8e1d7f1b$var$$Object$1.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $6daeff2c8e1d7f1b$var$objectGetPrototypeOf = $6daeff2c8e1d7f1b$var$CORRECT_PROTOTYPE_GETTER ? $6daeff2c8e1d7f1b$var$$Object$1.getPrototypeOf : function(O) {
    var object = $6daeff2c8e1d7f1b$var$toObject$3(O);
    if ($6daeff2c8e1d7f1b$var$hasOwn$4(object, $6daeff2c8e1d7f1b$var$IE_PROTO)) return object[$6daeff2c8e1d7f1b$var$IE_PROTO];
    var constructor = object.constructor;
    if ($6daeff2c8e1d7f1b$var$isCallable$a(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $6daeff2c8e1d7f1b$var$$Object$1 ? $6daeff2c8e1d7f1b$var$ObjectPrototype : null;
};
var $6daeff2c8e1d7f1b$var$fails$7 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$isCallable$9 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$getPrototypeOf$1 = $6daeff2c8e1d7f1b$var$objectGetPrototypeOf;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$4 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$d = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$ITERATOR$5 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$d("iterator");
var $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $6daeff2c8e1d7f1b$var$IteratorPrototype$2, $6daeff2c8e1d7f1b$var$PrototypeOfArrayIteratorPrototype, $6daeff2c8e1d7f1b$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $6daeff2c8e1d7f1b$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $6daeff2c8e1d7f1b$var$arrayIterator)) $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $6daeff2c8e1d7f1b$var$PrototypeOfArrayIteratorPrototype = $6daeff2c8e1d7f1b$var$getPrototypeOf$1($6daeff2c8e1d7f1b$var$getPrototypeOf$1($6daeff2c8e1d7f1b$var$arrayIterator));
        if ($6daeff2c8e1d7f1b$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $6daeff2c8e1d7f1b$var$IteratorPrototype$2 = $6daeff2c8e1d7f1b$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $6daeff2c8e1d7f1b$var$NEW_ITERATOR_PROTOTYPE = $6daeff2c8e1d7f1b$var$IteratorPrototype$2 == undefined || $6daeff2c8e1d7f1b$var$fails$7(function() {
    var test = {};
    // FF44- legacy iterators case
    return $6daeff2c8e1d7f1b$var$IteratorPrototype$2[$6daeff2c8e1d7f1b$var$ITERATOR$5].call(test) !== test;
});
if ($6daeff2c8e1d7f1b$var$NEW_ITERATOR_PROTOTYPE) $6daeff2c8e1d7f1b$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$6daeff2c8e1d7f1b$var$isCallable$9($6daeff2c8e1d7f1b$var$IteratorPrototype$2[$6daeff2c8e1d7f1b$var$ITERATOR$5])) $6daeff2c8e1d7f1b$var$defineBuiltIn$4($6daeff2c8e1d7f1b$var$IteratorPrototype$2, $6daeff2c8e1d7f1b$var$ITERATOR$5, function() {
    return this;
});
var $6daeff2c8e1d7f1b$var$iteratorsCore = {
    IteratorPrototype: $6daeff2c8e1d7f1b$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS$1
};
var $6daeff2c8e1d7f1b$var$defineProperty$3 = $6daeff2c8e1d7f1b$var$objectDefineProperty.f;
var $6daeff2c8e1d7f1b$var$hasOwn$3 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$c = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG$3 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$c("toStringTag");
var $6daeff2c8e1d7f1b$var$setToStringTag$3 = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$6daeff2c8e1d7f1b$var$hasOwn$3(target, $6daeff2c8e1d7f1b$var$TO_STRING_TAG$3)) $6daeff2c8e1d7f1b$var$defineProperty$3(target, $6daeff2c8e1d7f1b$var$TO_STRING_TAG$3, {
        configurable: true,
        value: TAG
    });
};
var $6daeff2c8e1d7f1b$var$IteratorPrototype$1 = $6daeff2c8e1d7f1b$var$iteratorsCore.IteratorPrototype;
var $6daeff2c8e1d7f1b$var$create = $6daeff2c8e1d7f1b$var$objectCreate;
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor$1 = $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4;
var $6daeff2c8e1d7f1b$var$setToStringTag$2 = $6daeff2c8e1d7f1b$var$setToStringTag$3;
var $6daeff2c8e1d7f1b$var$Iterators$4 = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$returnThis$1 = function() {
    return this;
};
var $6daeff2c8e1d7f1b$var$createIteratorConstructor$1 = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $6daeff2c8e1d7f1b$var$create($6daeff2c8e1d7f1b$var$IteratorPrototype$1, {
        next: $6daeff2c8e1d7f1b$var$createPropertyDescriptor$1(+!ENUMERABLE_NEXT, next)
    });
    $6daeff2c8e1d7f1b$var$setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
    $6daeff2c8e1d7f1b$var$Iterators$4[TO_STRING_TAG] = $6daeff2c8e1d7f1b$var$returnThis$1;
    return IteratorConstructor;
};
var $6daeff2c8e1d7f1b$var$isCallable$8 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$$String$1 = String;
var $6daeff2c8e1d7f1b$var$$TypeError$8 = TypeError;
var $6daeff2c8e1d7f1b$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || $6daeff2c8e1d7f1b$var$isCallable$8(argument)) return argument;
    throw $6daeff2c8e1d7f1b$var$$TypeError$8("Can't set " + $6daeff2c8e1d7f1b$var$$String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $6daeff2c8e1d7f1b$var$uncurryThis$7 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$anObject$7 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$aPossiblePrototype = $6daeff2c8e1d7f1b$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $6daeff2c8e1d7f1b$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $6daeff2c8e1d7f1b$var$uncurryThis$7(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $6daeff2c8e1d7f1b$var$anObject$7(O);
        $6daeff2c8e1d7f1b$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $6daeff2c8e1d7f1b$var$$$c = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$call$a = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$FunctionName = $6daeff2c8e1d7f1b$var$functionName;
var $6daeff2c8e1d7f1b$var$isCallable$7 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$createIteratorConstructor = $6daeff2c8e1d7f1b$var$createIteratorConstructor$1;
var $6daeff2c8e1d7f1b$var$getPrototypeOf = $6daeff2c8e1d7f1b$var$objectGetPrototypeOf;
var $6daeff2c8e1d7f1b$var$setPrototypeOf$1 = $6daeff2c8e1d7f1b$var$objectSetPrototypeOf;
var $6daeff2c8e1d7f1b$var$setToStringTag$1 = $6daeff2c8e1d7f1b$var$setToStringTag$3;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$1 = $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$3 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$b = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$Iterators$3 = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$IteratorsCore = $6daeff2c8e1d7f1b$var$iteratorsCore;
var $6daeff2c8e1d7f1b$var$PROPER_FUNCTION_NAME$1 = $6daeff2c8e1d7f1b$var$FunctionName.PROPER;
var $6daeff2c8e1d7f1b$var$CONFIGURABLE_FUNCTION_NAME = $6daeff2c8e1d7f1b$var$FunctionName.CONFIGURABLE;
var $6daeff2c8e1d7f1b$var$IteratorPrototype = $6daeff2c8e1d7f1b$var$IteratorsCore.IteratorPrototype;
var $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS = $6daeff2c8e1d7f1b$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $6daeff2c8e1d7f1b$var$ITERATOR$4 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$b("iterator");
var $6daeff2c8e1d7f1b$var$KEYS = "keys";
var $6daeff2c8e1d7f1b$var$VALUES = "values";
var $6daeff2c8e1d7f1b$var$ENTRIES = "entries";
var $6daeff2c8e1d7f1b$var$returnThis = function() {
    return this;
};
var $6daeff2c8e1d7f1b$var$defineIterator$1 = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $6daeff2c8e1d7f1b$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $6daeff2c8e1d7f1b$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $6daeff2c8e1d7f1b$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $6daeff2c8e1d7f1b$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$6daeff2c8e1d7f1b$var$ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $6daeff2c8e1d7f1b$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($6daeff2c8e1d7f1b$var$getPrototypeOf(CurrentIteratorPrototype) !== $6daeff2c8e1d7f1b$var$IteratorPrototype) {
                if ($6daeff2c8e1d7f1b$var$setPrototypeOf$1) $6daeff2c8e1d7f1b$var$setPrototypeOf$1(CurrentIteratorPrototype, $6daeff2c8e1d7f1b$var$IteratorPrototype);
                else if (!$6daeff2c8e1d7f1b$var$isCallable$7(CurrentIteratorPrototype[$6daeff2c8e1d7f1b$var$ITERATOR$4])) $6daeff2c8e1d7f1b$var$defineBuiltIn$3(CurrentIteratorPrototype, $6daeff2c8e1d7f1b$var$ITERATOR$4, $6daeff2c8e1d7f1b$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $6daeff2c8e1d7f1b$var$setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($6daeff2c8e1d7f1b$var$PROPER_FUNCTION_NAME$1 && DEFAULT == $6daeff2c8e1d7f1b$var$VALUES && nativeIterator && nativeIterator.name !== $6daeff2c8e1d7f1b$var$VALUES) {
        if ($6daeff2c8e1d7f1b$var$CONFIGURABLE_FUNCTION_NAME) $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$1(IterablePrototype, "name", $6daeff2c8e1d7f1b$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $6daeff2c8e1d7f1b$var$call$a(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($6daeff2c8e1d7f1b$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($6daeff2c8e1d7f1b$var$KEYS),
            entries: getIterationMethod($6daeff2c8e1d7f1b$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $6daeff2c8e1d7f1b$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $6daeff2c8e1d7f1b$var$$$c({
            target: NAME,
            proto: true,
            forced: $6daeff2c8e1d7f1b$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$6daeff2c8e1d7f1b$var$ITERATOR$4] !== defaultIterator) $6daeff2c8e1d7f1b$var$defineBuiltIn$3(IterablePrototype, $6daeff2c8e1d7f1b$var$ITERATOR$4, defaultIterator, {
        name: DEFAULT
    });
    $6daeff2c8e1d7f1b$var$Iterators$3[NAME] = defaultIterator;
    return methods;
};
var $6daeff2c8e1d7f1b$var$toIndexedObject = $6daeff2c8e1d7f1b$var$toIndexedObject$5;
var $6daeff2c8e1d7f1b$var$addToUnscopables$1 = $6daeff2c8e1d7f1b$var$addToUnscopables$2;
var $6daeff2c8e1d7f1b$var$Iterators$2 = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$InternalStateModule$1 = $6daeff2c8e1d7f1b$var$internalState;
var $6daeff2c8e1d7f1b$var$defineProperty$2 = $6daeff2c8e1d7f1b$var$objectDefineProperty.f;
var $6daeff2c8e1d7f1b$var$defineIterator = $6daeff2c8e1d7f1b$var$defineIterator$1;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$3 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$ARRAY_ITERATOR = "Array Iterator";
var $6daeff2c8e1d7f1b$var$setInternalState$1 = $6daeff2c8e1d7f1b$var$InternalStateModule$1.set;
var $6daeff2c8e1d7f1b$var$getInternalState = $6daeff2c8e1d7f1b$var$InternalStateModule$1.getterFor($6daeff2c8e1d7f1b$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $6daeff2c8e1d7f1b$var$es_array_iterator = $6daeff2c8e1d7f1b$var$defineIterator(Array, "Array", function(iterated, kind) {
    $6daeff2c8e1d7f1b$var$setInternalState$1(this, {
        type: $6daeff2c8e1d7f1b$var$ARRAY_ITERATOR,
        target: $6daeff2c8e1d7f1b$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $6daeff2c8e1d7f1b$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $6daeff2c8e1d7f1b$var$values = $6daeff2c8e1d7f1b$var$Iterators$2.Arguments = $6daeff2c8e1d7f1b$var$Iterators$2.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$6daeff2c8e1d7f1b$var$addToUnscopables$1("keys");
$6daeff2c8e1d7f1b$var$addToUnscopables$1("values");
$6daeff2c8e1d7f1b$var$addToUnscopables$1("entries");
// V8 ~ Chrome 45- bug
if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$3 && $6daeff2c8e1d7f1b$var$values.name !== "values") try {
    $6daeff2c8e1d7f1b$var$defineProperty$2($6daeff2c8e1d7f1b$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $6daeff2c8e1d7f1b$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $6daeff2c8e1d7f1b$var$documentCreateElement = $6daeff2c8e1d7f1b$var$documentCreateElement$2;
var $6daeff2c8e1d7f1b$var$classList = $6daeff2c8e1d7f1b$var$documentCreateElement("span").classList;
var $6daeff2c8e1d7f1b$var$DOMTokenListPrototype$1 = $6daeff2c8e1d7f1b$var$classList && $6daeff2c8e1d7f1b$var$classList.constructor && $6daeff2c8e1d7f1b$var$classList.constructor.prototype;
var $6daeff2c8e1d7f1b$var$domTokenListPrototype = $6daeff2c8e1d7f1b$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $6daeff2c8e1d7f1b$var$DOMTokenListPrototype$1;
var $6daeff2c8e1d7f1b$var$global$a = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$DOMIterables = $6daeff2c8e1d7f1b$var$domIterables;
var $6daeff2c8e1d7f1b$var$DOMTokenListPrototype = $6daeff2c8e1d7f1b$var$domTokenListPrototype;
var $6daeff2c8e1d7f1b$var$ArrayIteratorMethods = $6daeff2c8e1d7f1b$var$es_array_iterator;
var $6daeff2c8e1d7f1b$var$createNonEnumerableProperty = $6daeff2c8e1d7f1b$var$createNonEnumerableProperty$4;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$a = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$ITERATOR$3 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$a("iterator");
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG$2 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$a("toStringTag");
var $6daeff2c8e1d7f1b$var$ArrayValues = $6daeff2c8e1d7f1b$var$ArrayIteratorMethods.values;
var $6daeff2c8e1d7f1b$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$6daeff2c8e1d7f1b$var$ITERATOR$3] !== $6daeff2c8e1d7f1b$var$ArrayValues) try {
            $6daeff2c8e1d7f1b$var$createNonEnumerableProperty(CollectionPrototype, $6daeff2c8e1d7f1b$var$ITERATOR$3, $6daeff2c8e1d7f1b$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$6daeff2c8e1d7f1b$var$ITERATOR$3] = $6daeff2c8e1d7f1b$var$ArrayValues;
        }
        if (!CollectionPrototype[$6daeff2c8e1d7f1b$var$TO_STRING_TAG$2]) $6daeff2c8e1d7f1b$var$createNonEnumerableProperty(CollectionPrototype, $6daeff2c8e1d7f1b$var$TO_STRING_TAG$2, COLLECTION_NAME);
        if ($6daeff2c8e1d7f1b$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $6daeff2c8e1d7f1b$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $6daeff2c8e1d7f1b$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $6daeff2c8e1d7f1b$var$createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, $6daeff2c8e1d7f1b$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $6daeff2c8e1d7f1b$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $6daeff2c8e1d7f1b$var$COLLECTION_NAME in $6daeff2c8e1d7f1b$var$DOMIterables)$6daeff2c8e1d7f1b$var$handlePrototype($6daeff2c8e1d7f1b$var$global$a[$6daeff2c8e1d7f1b$var$COLLECTION_NAME] && $6daeff2c8e1d7f1b$var$global$a[$6daeff2c8e1d7f1b$var$COLLECTION_NAME].prototype, $6daeff2c8e1d7f1b$var$COLLECTION_NAME);
$6daeff2c8e1d7f1b$var$handlePrototype($6daeff2c8e1d7f1b$var$DOMTokenListPrototype, "DOMTokenList");
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$2 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$uncurryThis$6 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$call$9 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$fails$6 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$objectKeys = $6daeff2c8e1d7f1b$var$objectKeys$2;
var $6daeff2c8e1d7f1b$var$getOwnPropertySymbolsModule = $6daeff2c8e1d7f1b$var$objectGetOwnPropertySymbols;
var $6daeff2c8e1d7f1b$var$propertyIsEnumerableModule = $6daeff2c8e1d7f1b$var$objectPropertyIsEnumerable;
var $6daeff2c8e1d7f1b$var$toObject$2 = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$IndexedObject$1 = $6daeff2c8e1d7f1b$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $6daeff2c8e1d7f1b$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $6daeff2c8e1d7f1b$var$defineProperty$1 = Object.defineProperty;
var $6daeff2c8e1d7f1b$var$concat = $6daeff2c8e1d7f1b$var$uncurryThis$6([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $6daeff2c8e1d7f1b$var$objectAssign = !$6daeff2c8e1d7f1b$var$$assign || $6daeff2c8e1d7f1b$var$fails$6(function() {
    // should have correct order of operations (Edge bug)
    if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$2 && $6daeff2c8e1d7f1b$var$$assign({
        b: 1
    }, $6daeff2c8e1d7f1b$var$$assign($6daeff2c8e1d7f1b$var$defineProperty$1({}, "a", {
        enumerable: true,
        get: function() {
            $6daeff2c8e1d7f1b$var$defineProperty$1(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $6daeff2c8e1d7f1b$var$$assign({}, A)[symbol] != 7 || $6daeff2c8e1d7f1b$var$objectKeys($6daeff2c8e1d7f1b$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $6daeff2c8e1d7f1b$var$toObject$2(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $6daeff2c8e1d7f1b$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $6daeff2c8e1d7f1b$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $6daeff2c8e1d7f1b$var$IndexedObject$1(arguments[index++]);
        var keys = getOwnPropertySymbols ? $6daeff2c8e1d7f1b$var$concat($6daeff2c8e1d7f1b$var$objectKeys(S), getOwnPropertySymbols(S)) : $6daeff2c8e1d7f1b$var$objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$6daeff2c8e1d7f1b$var$DESCRIPTORS$2 || $6daeff2c8e1d7f1b$var$call$9(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $6daeff2c8e1d7f1b$var$$assign;
var $6daeff2c8e1d7f1b$var$$$b = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$assign = $6daeff2c8e1d7f1b$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$6daeff2c8e1d7f1b$var$$$b({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $6daeff2c8e1d7f1b$var$assign
}, {
    assign: $6daeff2c8e1d7f1b$var$assign
});
const $6daeff2c8e1d7f1b$var$CloseIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        xmlns: "http://www.w3.org/2000/svg",
        height: "24",
        viewBox: "0 0 24 24",
        width: "24",
        fill: "#C1C1C1"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M0 0h24v24H0z",
                fill: "none"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$CloseButton = ({ onClick: onClick })=>{
    return (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
        onClick: onClick,
        className: "close-button"
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$CloseIcon, {})
    }));
};
const $6daeff2c8e1d7f1b$var$ModalHeader = ({ title: title, onCloseModal: onCloseModal })=>{
    const additionalClasses = title === "Get a Wallet" ? " -open" : "";
    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
        className: "nws-modal-header"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                className: `middleTitle ${additionalClasses}`
            }, {
                children: title
            })),
            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$CloseButton, {
                onClick: onCloseModal
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$BackArrowIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsx)("svg", Object.assign({
        width: "8",
        height: "14",
        viewBox: "0 0 8 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 13L1 7L7 1",
            stroke: "#6494EE",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
const $6daeff2c8e1d7f1b$var$BackArrow = ({ onClick: onClick })=>{
    return (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
        onClick: onClick,
        className: "back-button"
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$BackArrowIcon, {})
    }));
};
const $6daeff2c8e1d7f1b$var$WalletNetworkChanged = ({ selector: selector, onBack: onBack, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$BackArrow, {
                        onClick: onBack
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                        title: "You Must Change the Network",
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "switch-network-message-wrapper"
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                "We've detected that you need to change your wallet's network to",
                                (0, $7b02d682eb115277$exports.jsx)("strong", Object.assign({
                                    className: "network-id"
                                }, {
                                    children: ` ${selector.options.network.networkId}`
                                })),
                                " ",
                                "for this dApp."
                            ]
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("p", {
                            children: "Some wallets may not support changing networks. If you can not change networks you may consider switching to another wallet."
                        })
                    ]
                }))
            }))
        ]
    });
};
var $6daeff2c8e1d7f1b$var$tryToString$3 = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$$TypeError$7 = TypeError;
var $6daeff2c8e1d7f1b$var$deletePropertyOrThrow$1 = function(O, P) {
    if (!delete O[P]) throw $6daeff2c8e1d7f1b$var$$TypeError$7("Cannot delete property " + $6daeff2c8e1d7f1b$var$tryToString$3(P) + " of " + $6daeff2c8e1d7f1b$var$tryToString$3(O));
};
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$9 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$9("toStringTag");
var $6daeff2c8e1d7f1b$var$test$1 = {};
$6daeff2c8e1d7f1b$var$test$1[$6daeff2c8e1d7f1b$var$TO_STRING_TAG$1] = "z";
var $6daeff2c8e1d7f1b$var$toStringTagSupport = String($6daeff2c8e1d7f1b$var$test$1) === "[object z]";
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG_SUPPORT = $6daeff2c8e1d7f1b$var$toStringTagSupport;
var $6daeff2c8e1d7f1b$var$isCallable$6 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$classofRaw = $6daeff2c8e1d7f1b$var$classofRaw$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$8 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$TO_STRING_TAG = $6daeff2c8e1d7f1b$var$wellKnownSymbol$8("toStringTag");
var $6daeff2c8e1d7f1b$var$$Object = Object;
// ES3 wrong here
var $6daeff2c8e1d7f1b$var$CORRECT_ARGUMENTS = $6daeff2c8e1d7f1b$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $6daeff2c8e1d7f1b$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $6daeff2c8e1d7f1b$var$classof$5 = $6daeff2c8e1d7f1b$var$TO_STRING_TAG_SUPPORT ? $6daeff2c8e1d7f1b$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $6daeff2c8e1d7f1b$var$tryGet(O = $6daeff2c8e1d7f1b$var$$Object(it), $6daeff2c8e1d7f1b$var$TO_STRING_TAG)) == "string" ? tag : $6daeff2c8e1d7f1b$var$CORRECT_ARGUMENTS ? $6daeff2c8e1d7f1b$var$classofRaw(O) : (result = $6daeff2c8e1d7f1b$var$classofRaw(O)) == "Object" && $6daeff2c8e1d7f1b$var$isCallable$6(O.callee) ? "Arguments" : result;
};
var $6daeff2c8e1d7f1b$var$classof$4 = $6daeff2c8e1d7f1b$var$classof$5;
var $6daeff2c8e1d7f1b$var$$String = String;
var $6daeff2c8e1d7f1b$var$toString$3 = function(argument) {
    if ($6daeff2c8e1d7f1b$var$classof$4(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $6daeff2c8e1d7f1b$var$$String(argument);
};
var $6daeff2c8e1d7f1b$var$toPropertyKey = $6daeff2c8e1d7f1b$var$toPropertyKey$3;
var $6daeff2c8e1d7f1b$var$definePropertyModule$1 = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$createPropertyDescriptor = $6daeff2c8e1d7f1b$var$createPropertyDescriptor$4;
var $6daeff2c8e1d7f1b$var$createProperty$1 = function(object, key, value) {
    var propertyKey = $6daeff2c8e1d7f1b$var$toPropertyKey(key);
    if (propertyKey in object) $6daeff2c8e1d7f1b$var$definePropertyModule$1.f(object, propertyKey, $6daeff2c8e1d7f1b$var$createPropertyDescriptor(0, value));
    else object[propertyKey] = value;
};
var $6daeff2c8e1d7f1b$var$toAbsoluteIndex = $6daeff2c8e1d7f1b$var$toAbsoluteIndex$2;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$3 = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
var $6daeff2c8e1d7f1b$var$createProperty = $6daeff2c8e1d7f1b$var$createProperty$1;
var $6daeff2c8e1d7f1b$var$$Array = Array;
var $6daeff2c8e1d7f1b$var$max = Math.max;
var $6daeff2c8e1d7f1b$var$arraySliceSimple = function(O, start, end) {
    var length = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$3(O);
    var k = $6daeff2c8e1d7f1b$var$toAbsoluteIndex(start, length);
    var fin = $6daeff2c8e1d7f1b$var$toAbsoluteIndex(end === undefined ? length : end, length);
    var result = $6daeff2c8e1d7f1b$var$$Array($6daeff2c8e1d7f1b$var$max(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$6daeff2c8e1d7f1b$var$createProperty(result, n, O[k]);
    result.length = n;
    return result;
};
var $6daeff2c8e1d7f1b$var$arraySlice$2 = $6daeff2c8e1d7f1b$var$arraySliceSimple;
var $6daeff2c8e1d7f1b$var$floor = Math.floor;
var $6daeff2c8e1d7f1b$var$mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = $6daeff2c8e1d7f1b$var$floor(length / 2);
    return length < 8 ? $6daeff2c8e1d7f1b$var$insertionSort(array, comparefn) : $6daeff2c8e1d7f1b$var$merge(array, $6daeff2c8e1d7f1b$var$mergeSort($6daeff2c8e1d7f1b$var$arraySlice$2(array, 0, middle), comparefn), $6daeff2c8e1d7f1b$var$mergeSort($6daeff2c8e1d7f1b$var$arraySlice$2(array, middle), comparefn), comparefn);
};
var $6daeff2c8e1d7f1b$var$insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $6daeff2c8e1d7f1b$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
var $6daeff2c8e1d7f1b$var$arraySort = $6daeff2c8e1d7f1b$var$mergeSort;
var $6daeff2c8e1d7f1b$var$fails$5 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$2 = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $6daeff2c8e1d7f1b$var$fails$5(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};
var $6daeff2c8e1d7f1b$var$userAgent$4 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$firefox = $6daeff2c8e1d7f1b$var$userAgent$4.match(/firefox\/(\d+)/i);
var $6daeff2c8e1d7f1b$var$engineFfVersion = !!$6daeff2c8e1d7f1b$var$firefox && +$6daeff2c8e1d7f1b$var$firefox[1];
var $6daeff2c8e1d7f1b$var$UA = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$engineIsIeOrEdge = /MSIE|Trident/.test($6daeff2c8e1d7f1b$var$UA);
var $6daeff2c8e1d7f1b$var$userAgent$3 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$webkit = $6daeff2c8e1d7f1b$var$userAgent$3.match(/AppleWebKit\/(\d+)\./);
var $6daeff2c8e1d7f1b$var$engineWebkitVersion = !!$6daeff2c8e1d7f1b$var$webkit && +$6daeff2c8e1d7f1b$var$webkit[1];
var $6daeff2c8e1d7f1b$var$$$a = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$uncurryThis$5 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$aCallable$7 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$toObject$1 = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$2 = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
var $6daeff2c8e1d7f1b$var$deletePropertyOrThrow = $6daeff2c8e1d7f1b$var$deletePropertyOrThrow$1;
var $6daeff2c8e1d7f1b$var$toString$2 = $6daeff2c8e1d7f1b$var$toString$3;
var $6daeff2c8e1d7f1b$var$fails$4 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$internalSort = $6daeff2c8e1d7f1b$var$arraySort;
var $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$1 = $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$2;
var $6daeff2c8e1d7f1b$var$FF = $6daeff2c8e1d7f1b$var$engineFfVersion;
var $6daeff2c8e1d7f1b$var$IE_OR_EDGE = $6daeff2c8e1d7f1b$var$engineIsIeOrEdge;
var $6daeff2c8e1d7f1b$var$V8 = $6daeff2c8e1d7f1b$var$engineV8Version;
var $6daeff2c8e1d7f1b$var$WEBKIT = $6daeff2c8e1d7f1b$var$engineWebkitVersion;
var $6daeff2c8e1d7f1b$var$test = [];
var $6daeff2c8e1d7f1b$var$un$Sort = $6daeff2c8e1d7f1b$var$uncurryThis$5($6daeff2c8e1d7f1b$var$test.sort);
var $6daeff2c8e1d7f1b$var$push = $6daeff2c8e1d7f1b$var$uncurryThis$5($6daeff2c8e1d7f1b$var$test.push);
// IE8-
var $6daeff2c8e1d7f1b$var$FAILS_ON_UNDEFINED = $6daeff2c8e1d7f1b$var$fails$4(function() {
    $6daeff2c8e1d7f1b$var$test.sort(undefined);
});
// V8 bug
var $6daeff2c8e1d7f1b$var$FAILS_ON_NULL = $6daeff2c8e1d7f1b$var$fails$4(function() {
    $6daeff2c8e1d7f1b$var$test.sort(null);
});
// Old WebKit
var $6daeff2c8e1d7f1b$var$STRICT_METHOD$1 = $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$1("sort");
var $6daeff2c8e1d7f1b$var$STABLE_SORT = !$6daeff2c8e1d7f1b$var$fails$4(function() {
    // feature detection can be too slow, so check engines versions
    if ($6daeff2c8e1d7f1b$var$V8) return $6daeff2c8e1d7f1b$var$V8 < 70;
    if ($6daeff2c8e1d7f1b$var$FF && $6daeff2c8e1d7f1b$var$FF > 3) return;
    if ($6daeff2c8e1d7f1b$var$IE_OR_EDGE) return true;
    if ($6daeff2c8e1d7f1b$var$WEBKIT) return $6daeff2c8e1d7f1b$var$WEBKIT < 603;
    var result = "";
    var code, chr, value, index;
    // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
    for(code = 65; code < 76; code++){
        chr = String.fromCharCode(code);
        switch(code){
            case 66:
            case 69:
            case 70:
            case 72:
                value = 3;
                break;
            case 68:
            case 71:
                value = 4;
                break;
            default:
                value = 2;
        }
        for(index = 0; index < 47; index++)$6daeff2c8e1d7f1b$var$test.push({
            k: chr + index,
            v: value
        });
    }
    $6daeff2c8e1d7f1b$var$test.sort(function(a, b) {
        return b.v - a.v;
    });
    for(index = 0; index < $6daeff2c8e1d7f1b$var$test.length; index++){
        chr = $6daeff2c8e1d7f1b$var$test[index].k.charAt(0);
        if (result.charAt(result.length - 1) !== chr) result += chr;
    }
    return result !== "DGBEFHACIJK";
});
var $6daeff2c8e1d7f1b$var$FORCED = $6daeff2c8e1d7f1b$var$FAILS_ON_UNDEFINED || !$6daeff2c8e1d7f1b$var$FAILS_ON_NULL || !$6daeff2c8e1d7f1b$var$STRICT_METHOD$1 || !$6daeff2c8e1d7f1b$var$STABLE_SORT;
var $6daeff2c8e1d7f1b$var$getSortCompare = function(comparefn) {
    return function(x, y) {
        if (y === undefined) return -1;
        if (x === undefined) return 1;
        if (comparefn !== undefined) return +comparefn(x, y) || 0;
        return $6daeff2c8e1d7f1b$var$toString$2(x) > $6daeff2c8e1d7f1b$var$toString$2(y) ? 1 : -1;
    };
};
// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$6daeff2c8e1d7f1b$var$$$a({
    target: "Array",
    proto: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED
}, {
    sort: function sort(comparefn) {
        if (comparefn !== undefined) $6daeff2c8e1d7f1b$var$aCallable$7(comparefn);
        var array = $6daeff2c8e1d7f1b$var$toObject$1(this);
        if ($6daeff2c8e1d7f1b$var$STABLE_SORT) return comparefn === undefined ? $6daeff2c8e1d7f1b$var$un$Sort(array) : $6daeff2c8e1d7f1b$var$un$Sort(array, comparefn);
        var items = [];
        var arrayLength = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$2(array);
        var itemsLength, index;
        for(index = 0; index < arrayLength; index++)if (index in array) $6daeff2c8e1d7f1b$var$push(items, array[index]);
        $6daeff2c8e1d7f1b$var$internalSort(items, $6daeff2c8e1d7f1b$var$getSortCompare(comparefn));
        itemsLength = items.length;
        index = 0;
        while(index < itemsLength)array[index] = items[index++];
        while(index < arrayLength)$6daeff2c8e1d7f1b$var$deletePropertyOrThrow(array, index++);
        return array;
    }
});
var $6daeff2c8e1d7f1b$var$$$9 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$$includes = $6daeff2c8e1d7f1b$var$arrayIncludes.includes;
var $6daeff2c8e1d7f1b$var$fails$3 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$addToUnscopables = $6daeff2c8e1d7f1b$var$addToUnscopables$2;
// FF99+ bug
var $6daeff2c8e1d7f1b$var$BROKEN_ON_SPARSE = $6daeff2c8e1d7f1b$var$fails$3(function() {
    return !Array(1).includes();
});
// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$6daeff2c8e1d7f1b$var$$$9({
    target: "Array",
    proto: true,
    forced: $6daeff2c8e1d7f1b$var$BROKEN_ON_SPARSE
}, {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $6daeff2c8e1d7f1b$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$6daeff2c8e1d7f1b$var$addToUnscopables("includes");
var $6daeff2c8e1d7f1b$var$isObject$2 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$classof$3 = $6daeff2c8e1d7f1b$var$classofRaw$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$7 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$MATCH$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$7("match");
// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var $6daeff2c8e1d7f1b$var$isRegexp = function(it) {
    var isRegExp;
    return $6daeff2c8e1d7f1b$var$isObject$2(it) && ((isRegExp = it[$6daeff2c8e1d7f1b$var$MATCH$1]) !== undefined ? !!isRegExp : $6daeff2c8e1d7f1b$var$classof$3(it) == "RegExp");
};
var $6daeff2c8e1d7f1b$var$isRegExp = $6daeff2c8e1d7f1b$var$isRegexp;
var $6daeff2c8e1d7f1b$var$$TypeError$6 = TypeError;
var $6daeff2c8e1d7f1b$var$notARegexp = function(it) {
    if ($6daeff2c8e1d7f1b$var$isRegExp(it)) throw $6daeff2c8e1d7f1b$var$$TypeError$6("The method doesn't accept regular expressions");
    return it;
};
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$6 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$MATCH = $6daeff2c8e1d7f1b$var$wellKnownSymbol$6("match");
var $6daeff2c8e1d7f1b$var$correctIsRegexpLogic = function(METHOD_NAME) {
    var regexp = /./;
    try {
        "/./"[METHOD_NAME](regexp);
    } catch (error1) {
        try {
            regexp[$6daeff2c8e1d7f1b$var$MATCH] = false;
            return "/./"[METHOD_NAME](regexp);
        } catch (error2) {}
    }
    return false;
};
var $6daeff2c8e1d7f1b$var$$$8 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$uncurryThis$4 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$notARegExp = $6daeff2c8e1d7f1b$var$notARegexp;
var $6daeff2c8e1d7f1b$var$requireObjectCoercible = $6daeff2c8e1d7f1b$var$requireObjectCoercible$3;
var $6daeff2c8e1d7f1b$var$toString$1 = $6daeff2c8e1d7f1b$var$toString$3;
var $6daeff2c8e1d7f1b$var$correctIsRegExpLogic = $6daeff2c8e1d7f1b$var$correctIsRegexpLogic;
var $6daeff2c8e1d7f1b$var$stringIndexOf = $6daeff2c8e1d7f1b$var$uncurryThis$4("".indexOf);
// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$6daeff2c8e1d7f1b$var$$$8({
    target: "String",
    proto: true,
    forced: !$6daeff2c8e1d7f1b$var$correctIsRegExpLogic("includes")
}, {
    includes: function includes(searchString /* , position = 0 */ ) {
        return !!~$6daeff2c8e1d7f1b$var$stringIndexOf($6daeff2c8e1d7f1b$var$toString$1($6daeff2c8e1d7f1b$var$requireObjectCoercible(this)), $6daeff2c8e1d7f1b$var$toString$1($6daeff2c8e1d7f1b$var$notARegExp(searchString)), arguments.length > 1 ? arguments[1] : undefined);
    }
});
var $6daeff2c8e1d7f1b$var$aCallable$6 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$toObject = $6daeff2c8e1d7f1b$var$toObject$5;
var $6daeff2c8e1d7f1b$var$IndexedObject = $6daeff2c8e1d7f1b$var$indexedObject;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike$1 = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
var $6daeff2c8e1d7f1b$var$$TypeError$5 = TypeError;
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $6daeff2c8e1d7f1b$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        $6daeff2c8e1d7f1b$var$aCallable$6(callbackfn);
        var O = $6daeff2c8e1d7f1b$var$toObject(that);
        var self1 = $6daeff2c8e1d7f1b$var$IndexedObject(O);
        var length = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$1(O);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self1) {
                memo = self1[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw $6daeff2c8e1d7f1b$var$$TypeError$5("Reduce of empty array with no initial value");
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self1) memo = callbackfn(memo, self1[index], index, O);
        return memo;
    };
};
var $6daeff2c8e1d7f1b$var$arrayReduce = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $6daeff2c8e1d7f1b$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $6daeff2c8e1d7f1b$var$createMethod(true)
};
var $6daeff2c8e1d7f1b$var$classof$2 = $6daeff2c8e1d7f1b$var$classofRaw$1;
var $6daeff2c8e1d7f1b$var$global$9 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$engineIsNode = $6daeff2c8e1d7f1b$var$classof$2($6daeff2c8e1d7f1b$var$global$9.process) == "process";
var $6daeff2c8e1d7f1b$var$$$7 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$$reduce = $6daeff2c8e1d7f1b$var$arrayReduce.left;
var $6daeff2c8e1d7f1b$var$arrayMethodIsStrict = $6daeff2c8e1d7f1b$var$arrayMethodIsStrict$2;
var $6daeff2c8e1d7f1b$var$CHROME_VERSION = $6daeff2c8e1d7f1b$var$engineV8Version;
var $6daeff2c8e1d7f1b$var$IS_NODE$3 = $6daeff2c8e1d7f1b$var$engineIsNode;
var $6daeff2c8e1d7f1b$var$STRICT_METHOD = $6daeff2c8e1d7f1b$var$arrayMethodIsStrict("reduce");
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $6daeff2c8e1d7f1b$var$CHROME_BUG = !$6daeff2c8e1d7f1b$var$IS_NODE$3 && $6daeff2c8e1d7f1b$var$CHROME_VERSION > 79 && $6daeff2c8e1d7f1b$var$CHROME_VERSION < 83;
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$6daeff2c8e1d7f1b$var$$$7({
    target: "Array",
    proto: true,
    forced: !$6daeff2c8e1d7f1b$var$STRICT_METHOD || $6daeff2c8e1d7f1b$var$CHROME_BUG
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $6daeff2c8e1d7f1b$var$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});
var $6daeff2c8e1d7f1b$var$$$6 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS$1 = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$global$8 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$uncurryThis$3 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$hasOwn$2 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$isCallable$5 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isPrototypeOf$3 = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$toString = $6daeff2c8e1d7f1b$var$toString$3;
var $6daeff2c8e1d7f1b$var$defineProperty = $6daeff2c8e1d7f1b$var$objectDefineProperty.f;
var $6daeff2c8e1d7f1b$var$copyConstructorProperties = $6daeff2c8e1d7f1b$var$copyConstructorProperties$2;
var $6daeff2c8e1d7f1b$var$NativeSymbol = $6daeff2c8e1d7f1b$var$global$8.Symbol;
var $6daeff2c8e1d7f1b$var$SymbolPrototype = $6daeff2c8e1d7f1b$var$NativeSymbol && $6daeff2c8e1d7f1b$var$NativeSymbol.prototype;
if ($6daeff2c8e1d7f1b$var$DESCRIPTORS$1 && $6daeff2c8e1d7f1b$var$isCallable$5($6daeff2c8e1d7f1b$var$NativeSymbol) && (!("description" in $6daeff2c8e1d7f1b$var$SymbolPrototype) || // Safari 12 bug
$6daeff2c8e1d7f1b$var$NativeSymbol().description !== undefined)) {
    var $6daeff2c8e1d7f1b$var$EmptyStringDescriptionStore = {};
    // wrap Symbol constructor for correct work with undefined description
    var $6daeff2c8e1d7f1b$var$SymbolWrapper = function Symbol1() {
        var description = arguments.length < 1 || arguments[0] === undefined ? undefined : $6daeff2c8e1d7f1b$var$toString(arguments[0]);
        var result = $6daeff2c8e1d7f1b$var$isPrototypeOf$3($6daeff2c8e1d7f1b$var$SymbolPrototype, this) ? new $6daeff2c8e1d7f1b$var$NativeSymbol(description) : description === undefined ? $6daeff2c8e1d7f1b$var$NativeSymbol() : $6daeff2c8e1d7f1b$var$NativeSymbol(description);
        if (description === "") $6daeff2c8e1d7f1b$var$EmptyStringDescriptionStore[result] = true;
        return result;
    };
    $6daeff2c8e1d7f1b$var$copyConstructorProperties($6daeff2c8e1d7f1b$var$SymbolWrapper, $6daeff2c8e1d7f1b$var$NativeSymbol);
    $6daeff2c8e1d7f1b$var$SymbolWrapper.prototype = $6daeff2c8e1d7f1b$var$SymbolPrototype;
    $6daeff2c8e1d7f1b$var$SymbolPrototype.constructor = $6daeff2c8e1d7f1b$var$SymbolWrapper;
    var $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL = String($6daeff2c8e1d7f1b$var$NativeSymbol("test")) == "Symbol(test)";
    var $6daeff2c8e1d7f1b$var$symbolToString = $6daeff2c8e1d7f1b$var$uncurryThis$3($6daeff2c8e1d7f1b$var$SymbolPrototype.toString);
    var $6daeff2c8e1d7f1b$var$symbolValueOf = $6daeff2c8e1d7f1b$var$uncurryThis$3($6daeff2c8e1d7f1b$var$SymbolPrototype.valueOf);
    var $6daeff2c8e1d7f1b$var$regexp = /^Symbol\((.*)\)[^)]+$/;
    var $6daeff2c8e1d7f1b$var$replace = $6daeff2c8e1d7f1b$var$uncurryThis$3("".replace);
    var $6daeff2c8e1d7f1b$var$stringSlice = $6daeff2c8e1d7f1b$var$uncurryThis$3("".slice);
    $6daeff2c8e1d7f1b$var$defineProperty($6daeff2c8e1d7f1b$var$SymbolPrototype, "description", {
        configurable: true,
        get: function description() {
            var symbol = $6daeff2c8e1d7f1b$var$symbolValueOf(this);
            var string = $6daeff2c8e1d7f1b$var$symbolToString(symbol);
            if ($6daeff2c8e1d7f1b$var$hasOwn$2($6daeff2c8e1d7f1b$var$EmptyStringDescriptionStore, symbol)) return "";
            var desc = $6daeff2c8e1d7f1b$var$NATIVE_SYMBOL ? $6daeff2c8e1d7f1b$var$stringSlice(string, 7, -1) : $6daeff2c8e1d7f1b$var$replace(string, $6daeff2c8e1d7f1b$var$regexp, "$1");
            return desc === "" ? undefined : desc;
        }
    });
    $6daeff2c8e1d7f1b$var$$$6({
        global: true,
        constructor: true,
        forced: true
    }, {
        Symbol: $6daeff2c8e1d7f1b$var$SymbolWrapper
    });
}
const $6daeff2c8e1d7f1b$var$WarningIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: "18",
        height: "18",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M4.95215 16.3536L10.2152 5.85657C10.9531 4.38481 13.0538 4.38519 13.7912 5.85723L19.0494 16.3543C19.7156 17.6841 18.7486 19.25 17.2612 19.25H6.74001C5.25228 19.25 4.28535 17.6835 4.95215 16.3536Z",
                stroke: "#E6B73E",
                strokeWidth: "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 10V12",
                stroke: "#E6B73E",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12.5 16C12.5 16.2761 12.2761 16.5 12 16.5C11.7239 16.5 11.5 16.2761 11.5 16C11.5 15.7239 11.7239 15.5 12 15.5C12.2761 15.5 12.5 15.7239 12.5 16Z",
                stroke: "#E6B73E"
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$WalletOptions = ({ selector: selector, handleWalletClick: handleWalletClick })=>{
    const [modules, setModules] = (0, $acw62.useState)([]);
    const [recentModules, setRecentModules] = (0, $acw62.useState)([]);
    const [moreModules, setMoreModules] = (0, $acw62.useState)([]);
    const [activeWalletId, setActiveWalletId] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        const subscription = selector.store.observable.subscribe((state)=>{
            const { selectedWalletId: selectedWalletId } = selector.store.getState();
            if (selectedWalletId) setActiveWalletId(selectedWalletId);
            const wallets = state.modules.filter((module)=>!(module.type === "instant-link" && selectedWalletId !== module.id));
            if (selector.options.optimizeWalletOrder) {
                state.modules.sort((current, next)=>{
                    if (current.metadata.deprecated === next.metadata.deprecated) return 0;
                    return current.metadata.deprecated ? 1 : -1;
                });
                state.modules.sort((current, next)=>{
                    if (next.metadata.available === current.metadata.available) return 0;
                    return next.metadata.available ? 1 : -1;
                });
                const moreWallets = [];
                const recentlySignedInWallets = [];
                wallets.forEach((module)=>{
                    if (selector.store.getState().recentlySignedInWallets.includes(module.id)) recentlySignedInWallets.push(module);
                    else moreWallets.push(module);
                });
                setRecentModules(recentlySignedInWallets);
                setMoreModules(moreWallets);
            }
            if (selector.options.randomizeWalletOrder) setModules(wallets.sort(()=>Math.random() - 0.5));
            else setModules(wallets);
        });
        return ()=>subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    function renderOptionsList(modulesToRender) {
        return modulesToRender.reduce((result, module, index)=>{
            const { selectedWalletId: selectedWalletId } = selector.store.getState();
            const { name: name, description: description, iconUrl: iconUrl, deprecated: deprecated } = module.metadata;
            const selected = module.id === selectedWalletId;
            result.push((0, $7b02d682eb115277$exports.jsxs)("li", Object.assign({
                tabIndex: 0,
                className: `single-wallet ${activeWalletId === module.id ? "selected-wallet" : ""} ${selected ? "connected-wallet" : ""} ${deprecated ? "deprecated-wallet" : ""} sidebar ${module.id}`,
                onClick: ()=>{
                    if (module.id === modulesToRender[index].id) setActiveWalletId(module.id);
                    return handleWalletClick(module);
                }
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "icon"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsx)("img", {
                            src: iconUrl,
                            alt: name
                        })
                    })),
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "content"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "title"
                            }, {
                                children: name
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "description"
                            }, {
                                children: description
                            }))
                        ]
                    })),
                    deprecated && (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "warning-triangle"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WarningIcon, {})
                    }))
                ]
            }), module.id));
            return result;
        }, []);
    }
    return (0, $7b02d682eb115277$exports.jsx)("div", {
        children: selector.options.optimizeWalletOrder && selector.store.getState().recentlySignedInWallets.length > 0 ? (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
            className: "wallet-options-wrapper"
        }, {
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "options-list-section"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "options-list-section-header"
                        }, {
                            children: "Recent"
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "options-list more-options-list-content"
                        }, {
                            children: renderOptionsList(recentModules)
                        }))
                    ]
                })),
                (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "options-list-section"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "options-list-section-header"
                        }, {
                            children: "More"
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "options-list more-options-list-content"
                        }, {
                            children: renderOptionsList(moreModules)
                        }))
                    ]
                }))
            ]
        })) : (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
            className: "wallet-options-wrapper"
        }, {
            children: (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "options-list"
            }, {
                children: renderOptionsList(modules)
            }))
        }))
    });
};
const $6daeff2c8e1d7f1b$var$ConnectionErrorIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.5001 18.3333C15.1025 18.3333 18.8334 14.6023 18.8334 9.99996C18.8334 5.39759 15.1025 1.66663 10.5001 1.66663C5.89771 1.66663 2.16675 5.39759 2.16675 9.99996C2.16675 14.6023 5.89771 18.3333 10.5001 18.3333Z",
                stroke: "#CE5A6F",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13 7.5L8 12.5",
                stroke: "#CE5A6F",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8 7.5L13 12.5",
                stroke: "#CE5A6F",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$ConnectionSuccessIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.8333 9.2333V9.99997C18.8323 11.797 18.2504 13.5455 17.1744 14.9848C16.0984 16.4241 14.586 17.477 12.8628 17.9866C11.1395 18.4961 9.29768 18.4349 7.61202 17.8121C5.92636 17.1894 4.48717 16.0384 3.50909 14.5309C2.53101 13.0233 2.06645 11.24 2.18469 9.4469C2.30293 7.65377 2.99763 5.94691 4.16519 4.58086C5.33275 3.21482 6.91061 2.26279 8.66345 1.86676C10.4163 1.47073 12.2502 1.65192 13.8916 2.3833",
                stroke: "#4FD98F",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M18.8333 3.33337L10.5 11.675L8 9.17504",
                stroke: "#4FD98F",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$ConnectionResult = ({ module: module, message: message, err: err, onRetry: onRetry })=>{
    return (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
        className: "connection connecting-details"
    }, {
        children: err ? (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
            className: "error-wrapper"
        }, {
            children: [
                (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "error"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ConnectionErrorIcon, {}),
                        (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectionFailed")
                    ]
                })),
                (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: message
                }),
                (module === null || module === void 0 ? void 0 : module.metadata.available) && (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                    onClick: onRetry
                }, {
                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.retry")
                }))
            ]
        })) : (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
            className: "success"
        }, {
            children: [
                (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ConnectionSuccessIcon, {}),
                (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectionSuccessful")
            ]
        }))
    }));
};
const $6daeff2c8e1d7f1b$var$AlertMessage = ({ message: message, module: module, onBack: onBack, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                title: "",
                onCloseModal: onCloseModal
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "alert-message connecting-wrapper connecting-wrapper-err"
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "icon"
                        }, {
                            children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: module === null || module === void 0 ? void 0 : module.metadata.iconUrl,
                                alt: module === null || module === void 0 ? void 0 : module.metadata.name
                            })
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                            className: "connecting-name"
                        }, {
                            children: module === null || module === void 0 ? void 0 : module.metadata.name
                        })),
                        (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ConnectionResult, {
                            module: module,
                            message: message,
                            err: message !== null,
                            onRetry: ()=>{
                                onBack(true);
                            }
                        })
                    ]
                }))
            }))
        ]
    });
};
var $6daeff2c8e1d7f1b$var$getBuiltIn$3 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$definePropertyModule = $6daeff2c8e1d7f1b$var$objectDefineProperty;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$5 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$DESCRIPTORS = $6daeff2c8e1d7f1b$var$descriptors;
var $6daeff2c8e1d7f1b$var$SPECIES$2 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$5("species");
var $6daeff2c8e1d7f1b$var$setSpecies$1 = function(CONSTRUCTOR_NAME) {
    var Constructor = $6daeff2c8e1d7f1b$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    var defineProperty = $6daeff2c8e1d7f1b$var$definePropertyModule.f;
    if ($6daeff2c8e1d7f1b$var$DESCRIPTORS && Constructor && !Constructor[$6daeff2c8e1d7f1b$var$SPECIES$2]) defineProperty(Constructor, $6daeff2c8e1d7f1b$var$SPECIES$2, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $6daeff2c8e1d7f1b$var$isPrototypeOf$2 = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$$TypeError$4 = TypeError;
var $6daeff2c8e1d7f1b$var$anInstance$1 = function(it, Prototype) {
    if ($6daeff2c8e1d7f1b$var$isPrototypeOf$2(Prototype, it)) return it;
    throw $6daeff2c8e1d7f1b$var$$TypeError$4("Incorrect invocation");
};
var $6daeff2c8e1d7f1b$var$uncurryThis$2 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$fails$2 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$isCallable$4 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$classof$1 = $6daeff2c8e1d7f1b$var$classof$5;
var $6daeff2c8e1d7f1b$var$getBuiltIn$2 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$inspectSource$1 = $6daeff2c8e1d7f1b$var$inspectSource$4;
var $6daeff2c8e1d7f1b$var$noop = function() {};
var $6daeff2c8e1d7f1b$var$empty = [];
var $6daeff2c8e1d7f1b$var$construct = $6daeff2c8e1d7f1b$var$getBuiltIn$2("Reflect", "construct");
var $6daeff2c8e1d7f1b$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $6daeff2c8e1d7f1b$var$exec = $6daeff2c8e1d7f1b$var$uncurryThis$2($6daeff2c8e1d7f1b$var$constructorRegExp.exec);
var $6daeff2c8e1d7f1b$var$INCORRECT_TO_STRING = !$6daeff2c8e1d7f1b$var$constructorRegExp.exec($6daeff2c8e1d7f1b$var$noop);
var $6daeff2c8e1d7f1b$var$isConstructorModern = function isConstructor(argument) {
    if (!$6daeff2c8e1d7f1b$var$isCallable$4(argument)) return false;
    try {
        $6daeff2c8e1d7f1b$var$construct($6daeff2c8e1d7f1b$var$noop, $6daeff2c8e1d7f1b$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $6daeff2c8e1d7f1b$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$6daeff2c8e1d7f1b$var$isCallable$4(argument)) return false;
    switch($6daeff2c8e1d7f1b$var$classof$1(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $6daeff2c8e1d7f1b$var$INCORRECT_TO_STRING || !!$6daeff2c8e1d7f1b$var$exec($6daeff2c8e1d7f1b$var$constructorRegExp, $6daeff2c8e1d7f1b$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$6daeff2c8e1d7f1b$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $6daeff2c8e1d7f1b$var$isConstructor$1 = !$6daeff2c8e1d7f1b$var$construct || $6daeff2c8e1d7f1b$var$fails$2(function() {
    var called;
    return $6daeff2c8e1d7f1b$var$isConstructorModern($6daeff2c8e1d7f1b$var$isConstructorModern.call) || !$6daeff2c8e1d7f1b$var$isConstructorModern(Object) || !$6daeff2c8e1d7f1b$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $6daeff2c8e1d7f1b$var$isConstructorLegacy : $6daeff2c8e1d7f1b$var$isConstructorModern;
var $6daeff2c8e1d7f1b$var$isConstructor = $6daeff2c8e1d7f1b$var$isConstructor$1;
var $6daeff2c8e1d7f1b$var$tryToString$2 = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$$TypeError$3 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $6daeff2c8e1d7f1b$var$aConstructor$1 = function(argument) {
    if ($6daeff2c8e1d7f1b$var$isConstructor(argument)) return argument;
    throw $6daeff2c8e1d7f1b$var$$TypeError$3($6daeff2c8e1d7f1b$var$tryToString$2(argument) + " is not a constructor");
};
var $6daeff2c8e1d7f1b$var$anObject$6 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$aConstructor = $6daeff2c8e1d7f1b$var$aConstructor$1;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$4 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$SPECIES$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$4("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $6daeff2c8e1d7f1b$var$speciesConstructor$1 = function(O, defaultConstructor) {
    var C = $6daeff2c8e1d7f1b$var$anObject$6(O).constructor;
    var S;
    return C === undefined || (S = $6daeff2c8e1d7f1b$var$anObject$6(C)[$6daeff2c8e1d7f1b$var$SPECIES$1]) == undefined ? defaultConstructor : $6daeff2c8e1d7f1b$var$aConstructor(S);
};
var $6daeff2c8e1d7f1b$var$NATIVE_BIND$1 = $6daeff2c8e1d7f1b$var$functionBindNative;
var $6daeff2c8e1d7f1b$var$FunctionPrototype = Function.prototype;
var $6daeff2c8e1d7f1b$var$apply$1 = $6daeff2c8e1d7f1b$var$FunctionPrototype.apply;
var $6daeff2c8e1d7f1b$var$call$8 = $6daeff2c8e1d7f1b$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $6daeff2c8e1d7f1b$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($6daeff2c8e1d7f1b$var$NATIVE_BIND$1 ? $6daeff2c8e1d7f1b$var$call$8.bind($6daeff2c8e1d7f1b$var$apply$1) : function() {
    return $6daeff2c8e1d7f1b$var$call$8.apply($6daeff2c8e1d7f1b$var$apply$1, arguments);
});
var $6daeff2c8e1d7f1b$var$uncurryThis$1 = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$aCallable$5 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$NATIVE_BIND = $6daeff2c8e1d7f1b$var$functionBindNative;
var $6daeff2c8e1d7f1b$var$bind$4 = $6daeff2c8e1d7f1b$var$uncurryThis$1($6daeff2c8e1d7f1b$var$uncurryThis$1.bind);
// optional / simple context binding
var $6daeff2c8e1d7f1b$var$functionBindContext = function(fn, that) {
    $6daeff2c8e1d7f1b$var$aCallable$5(fn);
    return that === undefined ? fn : $6daeff2c8e1d7f1b$var$NATIVE_BIND ? $6daeff2c8e1d7f1b$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $6daeff2c8e1d7f1b$var$uncurryThis = $6daeff2c8e1d7f1b$var$functionUncurryThis;
var $6daeff2c8e1d7f1b$var$arraySlice$1 = $6daeff2c8e1d7f1b$var$uncurryThis([].slice);
var $6daeff2c8e1d7f1b$var$$TypeError$2 = TypeError;
var $6daeff2c8e1d7f1b$var$validateArgumentsLength$1 = function(passed, required) {
    if (passed < required) throw $6daeff2c8e1d7f1b$var$$TypeError$2("Not enough arguments");
    return passed;
};
var $6daeff2c8e1d7f1b$var$userAgent$2 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($6daeff2c8e1d7f1b$var$userAgent$2);
var $6daeff2c8e1d7f1b$var$global$7 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$apply = $6daeff2c8e1d7f1b$var$functionApply;
var $6daeff2c8e1d7f1b$var$bind$3 = $6daeff2c8e1d7f1b$var$functionBindContext;
var $6daeff2c8e1d7f1b$var$isCallable$3 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$hasOwn$1 = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$fails$1 = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$html = $6daeff2c8e1d7f1b$var$html$2;
var $6daeff2c8e1d7f1b$var$arraySlice = $6daeff2c8e1d7f1b$var$arraySlice$1;
var $6daeff2c8e1d7f1b$var$createElement = $6daeff2c8e1d7f1b$var$documentCreateElement$2;
var $6daeff2c8e1d7f1b$var$validateArgumentsLength = $6daeff2c8e1d7f1b$var$validateArgumentsLength$1;
var $6daeff2c8e1d7f1b$var$IS_IOS$1 = $6daeff2c8e1d7f1b$var$engineIsIos;
var $6daeff2c8e1d7f1b$var$IS_NODE$2 = $6daeff2c8e1d7f1b$var$engineIsNode;
var $6daeff2c8e1d7f1b$var$set = $6daeff2c8e1d7f1b$var$global$7.setImmediate;
var $6daeff2c8e1d7f1b$var$clear = $6daeff2c8e1d7f1b$var$global$7.clearImmediate;
var $6daeff2c8e1d7f1b$var$process$2 = $6daeff2c8e1d7f1b$var$global$7.process;
var $6daeff2c8e1d7f1b$var$Dispatch = $6daeff2c8e1d7f1b$var$global$7.Dispatch;
var $6daeff2c8e1d7f1b$var$Function$1 = $6daeff2c8e1d7f1b$var$global$7.Function;
var $6daeff2c8e1d7f1b$var$MessageChannel = $6daeff2c8e1d7f1b$var$global$7.MessageChannel;
var $6daeff2c8e1d7f1b$var$String$1 = $6daeff2c8e1d7f1b$var$global$7.String;
var $6daeff2c8e1d7f1b$var$counter = 0;
var $6daeff2c8e1d7f1b$var$queue$1 = {};
var $6daeff2c8e1d7f1b$var$ONREADYSTATECHANGE = "onreadystatechange";
var $6daeff2c8e1d7f1b$var$location, $6daeff2c8e1d7f1b$var$defer, $6daeff2c8e1d7f1b$var$channel, $6daeff2c8e1d7f1b$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $6daeff2c8e1d7f1b$var$location = $6daeff2c8e1d7f1b$var$global$7.location;
} catch (error) {}
var $6daeff2c8e1d7f1b$var$run = function(id) {
    if ($6daeff2c8e1d7f1b$var$hasOwn$1($6daeff2c8e1d7f1b$var$queue$1, id)) {
        var fn = $6daeff2c8e1d7f1b$var$queue$1[id];
        delete $6daeff2c8e1d7f1b$var$queue$1[id];
        fn();
    }
};
var $6daeff2c8e1d7f1b$var$runner = function(id) {
    return function() {
        $6daeff2c8e1d7f1b$var$run(id);
    };
};
var $6daeff2c8e1d7f1b$var$listener = function(event) {
    $6daeff2c8e1d7f1b$var$run(event.data);
};
var $6daeff2c8e1d7f1b$var$post = function(id) {
    // old engines have not location.origin
    $6daeff2c8e1d7f1b$var$global$7.postMessage($6daeff2c8e1d7f1b$var$String$1(id), $6daeff2c8e1d7f1b$var$location.protocol + "//" + $6daeff2c8e1d7f1b$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$6daeff2c8e1d7f1b$var$set || !$6daeff2c8e1d7f1b$var$clear) {
    $6daeff2c8e1d7f1b$var$set = function setImmediate(handler) {
        $6daeff2c8e1d7f1b$var$validateArgumentsLength(arguments.length, 1);
        var fn = $6daeff2c8e1d7f1b$var$isCallable$3(handler) ? handler : $6daeff2c8e1d7f1b$var$Function$1(handler);
        var args = $6daeff2c8e1d7f1b$var$arraySlice(arguments, 1);
        $6daeff2c8e1d7f1b$var$queue$1[++$6daeff2c8e1d7f1b$var$counter] = function() {
            $6daeff2c8e1d7f1b$var$apply(fn, undefined, args);
        };
        $6daeff2c8e1d7f1b$var$defer($6daeff2c8e1d7f1b$var$counter);
        return $6daeff2c8e1d7f1b$var$counter;
    };
    $6daeff2c8e1d7f1b$var$clear = function clearImmediate(id) {
        delete $6daeff2c8e1d7f1b$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($6daeff2c8e1d7f1b$var$IS_NODE$2) $6daeff2c8e1d7f1b$var$defer = function(id) {
        $6daeff2c8e1d7f1b$var$process$2.nextTick($6daeff2c8e1d7f1b$var$runner(id));
    };
    else if ($6daeff2c8e1d7f1b$var$Dispatch && $6daeff2c8e1d7f1b$var$Dispatch.now) $6daeff2c8e1d7f1b$var$defer = function(id) {
        $6daeff2c8e1d7f1b$var$Dispatch.now($6daeff2c8e1d7f1b$var$runner(id));
    };
    else if ($6daeff2c8e1d7f1b$var$MessageChannel && !$6daeff2c8e1d7f1b$var$IS_IOS$1) {
        $6daeff2c8e1d7f1b$var$channel = new $6daeff2c8e1d7f1b$var$MessageChannel();
        $6daeff2c8e1d7f1b$var$port = $6daeff2c8e1d7f1b$var$channel.port2;
        $6daeff2c8e1d7f1b$var$channel.port1.onmessage = $6daeff2c8e1d7f1b$var$listener;
        $6daeff2c8e1d7f1b$var$defer = $6daeff2c8e1d7f1b$var$bind$3($6daeff2c8e1d7f1b$var$port.postMessage, $6daeff2c8e1d7f1b$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($6daeff2c8e1d7f1b$var$global$7.addEventListener && $6daeff2c8e1d7f1b$var$isCallable$3($6daeff2c8e1d7f1b$var$global$7.postMessage) && !$6daeff2c8e1d7f1b$var$global$7.importScripts && $6daeff2c8e1d7f1b$var$location && $6daeff2c8e1d7f1b$var$location.protocol !== "file:" && !$6daeff2c8e1d7f1b$var$fails$1($6daeff2c8e1d7f1b$var$post)) {
        $6daeff2c8e1d7f1b$var$defer = $6daeff2c8e1d7f1b$var$post;
        $6daeff2c8e1d7f1b$var$global$7.addEventListener("message", $6daeff2c8e1d7f1b$var$listener, false);
    // IE8-
    } else if ($6daeff2c8e1d7f1b$var$ONREADYSTATECHANGE in $6daeff2c8e1d7f1b$var$createElement("script")) $6daeff2c8e1d7f1b$var$defer = function(id) {
        $6daeff2c8e1d7f1b$var$html.appendChild($6daeff2c8e1d7f1b$var$createElement("script"))[$6daeff2c8e1d7f1b$var$ONREADYSTATECHANGE] = function() {
            $6daeff2c8e1d7f1b$var$html.removeChild(this);
            $6daeff2c8e1d7f1b$var$run(id);
        };
    };
    else $6daeff2c8e1d7f1b$var$defer = function(id) {
        setTimeout($6daeff2c8e1d7f1b$var$runner(id), 0);
    };
}
var $6daeff2c8e1d7f1b$var$task$1 = {
    set: $6daeff2c8e1d7f1b$var$set,
    clear: $6daeff2c8e1d7f1b$var$clear
};
var $6daeff2c8e1d7f1b$var$userAgent$1 = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$global$6 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($6daeff2c8e1d7f1b$var$userAgent$1) && $6daeff2c8e1d7f1b$var$global$6.Pebble !== undefined;
var $6daeff2c8e1d7f1b$var$userAgent = $6daeff2c8e1d7f1b$var$engineUserAgent;
var $6daeff2c8e1d7f1b$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($6daeff2c8e1d7f1b$var$userAgent);
var $6daeff2c8e1d7f1b$var$global$5 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$bind$2 = $6daeff2c8e1d7f1b$var$functionBindContext;
var $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor = $6daeff2c8e1d7f1b$var$objectGetOwnPropertyDescriptor.f;
var $6daeff2c8e1d7f1b$var$macrotask = $6daeff2c8e1d7f1b$var$task$1.set;
var $6daeff2c8e1d7f1b$var$IS_IOS = $6daeff2c8e1d7f1b$var$engineIsIos;
var $6daeff2c8e1d7f1b$var$IS_IOS_PEBBLE = $6daeff2c8e1d7f1b$var$engineIsIosPebble;
var $6daeff2c8e1d7f1b$var$IS_WEBOS_WEBKIT = $6daeff2c8e1d7f1b$var$engineIsWebosWebkit;
var $6daeff2c8e1d7f1b$var$IS_NODE$1 = $6daeff2c8e1d7f1b$var$engineIsNode;
var $6daeff2c8e1d7f1b$var$MutationObserver = $6daeff2c8e1d7f1b$var$global$5.MutationObserver || $6daeff2c8e1d7f1b$var$global$5.WebKitMutationObserver;
var $6daeff2c8e1d7f1b$var$document$2 = $6daeff2c8e1d7f1b$var$global$5.document;
var $6daeff2c8e1d7f1b$var$process$1 = $6daeff2c8e1d7f1b$var$global$5.process;
var $6daeff2c8e1d7f1b$var$Promise$1 = $6daeff2c8e1d7f1b$var$global$5.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $6daeff2c8e1d7f1b$var$queueMicrotaskDescriptor = $6daeff2c8e1d7f1b$var$getOwnPropertyDescriptor($6daeff2c8e1d7f1b$var$global$5, "queueMicrotask");
var $6daeff2c8e1d7f1b$var$queueMicrotask = $6daeff2c8e1d7f1b$var$queueMicrotaskDescriptor && $6daeff2c8e1d7f1b$var$queueMicrotaskDescriptor.value;
var $6daeff2c8e1d7f1b$var$flush, $6daeff2c8e1d7f1b$var$head, $6daeff2c8e1d7f1b$var$last, $6daeff2c8e1d7f1b$var$notify$1, $6daeff2c8e1d7f1b$var$toggle, $6daeff2c8e1d7f1b$var$node, $6daeff2c8e1d7f1b$var$promise, $6daeff2c8e1d7f1b$var$then;
// modern engines have queueMicrotask method
if (!$6daeff2c8e1d7f1b$var$queueMicrotask) {
    $6daeff2c8e1d7f1b$var$flush = function() {
        var parent, fn;
        if ($6daeff2c8e1d7f1b$var$IS_NODE$1 && (parent = $6daeff2c8e1d7f1b$var$process$1.domain)) parent.exit();
        while($6daeff2c8e1d7f1b$var$head){
            fn = $6daeff2c8e1d7f1b$var$head.fn;
            $6daeff2c8e1d7f1b$var$head = $6daeff2c8e1d7f1b$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($6daeff2c8e1d7f1b$var$head) $6daeff2c8e1d7f1b$var$notify$1();
                else $6daeff2c8e1d7f1b$var$last = undefined;
                throw error;
            }
        }
        $6daeff2c8e1d7f1b$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$6daeff2c8e1d7f1b$var$IS_IOS && !$6daeff2c8e1d7f1b$var$IS_NODE$1 && !$6daeff2c8e1d7f1b$var$IS_WEBOS_WEBKIT && $6daeff2c8e1d7f1b$var$MutationObserver && $6daeff2c8e1d7f1b$var$document$2) {
        $6daeff2c8e1d7f1b$var$toggle = true;
        $6daeff2c8e1d7f1b$var$node = $6daeff2c8e1d7f1b$var$document$2.createTextNode("");
        new $6daeff2c8e1d7f1b$var$MutationObserver($6daeff2c8e1d7f1b$var$flush).observe($6daeff2c8e1d7f1b$var$node, {
            characterData: true
        });
        $6daeff2c8e1d7f1b$var$notify$1 = function() {
            $6daeff2c8e1d7f1b$var$node.data = $6daeff2c8e1d7f1b$var$toggle = !$6daeff2c8e1d7f1b$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$6daeff2c8e1d7f1b$var$IS_IOS_PEBBLE && $6daeff2c8e1d7f1b$var$Promise$1 && $6daeff2c8e1d7f1b$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $6daeff2c8e1d7f1b$var$promise = $6daeff2c8e1d7f1b$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $6daeff2c8e1d7f1b$var$promise.constructor = $6daeff2c8e1d7f1b$var$Promise$1;
        $6daeff2c8e1d7f1b$var$then = $6daeff2c8e1d7f1b$var$bind$2($6daeff2c8e1d7f1b$var$promise.then, $6daeff2c8e1d7f1b$var$promise);
        $6daeff2c8e1d7f1b$var$notify$1 = function() {
            $6daeff2c8e1d7f1b$var$then($6daeff2c8e1d7f1b$var$flush);
        };
    // Node.js without promises
    } else if ($6daeff2c8e1d7f1b$var$IS_NODE$1) $6daeff2c8e1d7f1b$var$notify$1 = function() {
        $6daeff2c8e1d7f1b$var$process$1.nextTick($6daeff2c8e1d7f1b$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $6daeff2c8e1d7f1b$var$macrotask = $6daeff2c8e1d7f1b$var$bind$2($6daeff2c8e1d7f1b$var$macrotask, $6daeff2c8e1d7f1b$var$global$5);
        $6daeff2c8e1d7f1b$var$notify$1 = function() {
            $6daeff2c8e1d7f1b$var$macrotask($6daeff2c8e1d7f1b$var$flush);
        };
    }
}
var $6daeff2c8e1d7f1b$var$microtask$1 = $6daeff2c8e1d7f1b$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($6daeff2c8e1d7f1b$var$last) $6daeff2c8e1d7f1b$var$last.next = task;
    if (!$6daeff2c8e1d7f1b$var$head) {
        $6daeff2c8e1d7f1b$var$head = task;
        $6daeff2c8e1d7f1b$var$notify$1();
    }
    $6daeff2c8e1d7f1b$var$last = task;
};
var $6daeff2c8e1d7f1b$var$global$4 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$hostReportErrors$1 = function(a, b) {
    var console = $6daeff2c8e1d7f1b$var$global$4.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};
var $6daeff2c8e1d7f1b$var$perform$3 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $6daeff2c8e1d7f1b$var$Queue$1 = function() {
    this.head = null;
    this.tail = null;
};
$6daeff2c8e1d7f1b$var$Queue$1.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $6daeff2c8e1d7f1b$var$queue = $6daeff2c8e1d7f1b$var$Queue$1;
var $6daeff2c8e1d7f1b$var$global$3 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$promiseNativeConstructor = $6daeff2c8e1d7f1b$var$global$3.Promise;
var $6daeff2c8e1d7f1b$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $6daeff2c8e1d7f1b$var$global$2 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$NativePromiseConstructor$3 = $6daeff2c8e1d7f1b$var$promiseNativeConstructor;
var $6daeff2c8e1d7f1b$var$isCallable$2 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isForced = $6daeff2c8e1d7f1b$var$isForced_1;
var $6daeff2c8e1d7f1b$var$inspectSource = $6daeff2c8e1d7f1b$var$inspectSource$4;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$3 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$IS_BROWSER = $6daeff2c8e1d7f1b$var$engineIsBrowser;
var $6daeff2c8e1d7f1b$var$V8_VERSION = $6daeff2c8e1d7f1b$var$engineV8Version;
$6daeff2c8e1d7f1b$var$NativePromiseConstructor$3 && $6daeff2c8e1d7f1b$var$NativePromiseConstructor$3.prototype;
var $6daeff2c8e1d7f1b$var$SPECIES = $6daeff2c8e1d7f1b$var$wellKnownSymbol$3("species");
var $6daeff2c8e1d7f1b$var$SUBCLASSING = false;
var $6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $6daeff2c8e1d7f1b$var$isCallable$2($6daeff2c8e1d7f1b$var$global$2.PromiseRejectionEvent);
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$5 = $6daeff2c8e1d7f1b$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $6daeff2c8e1d7f1b$var$inspectSource($6daeff2c8e1d7f1b$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($6daeff2c8e1d7f1b$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $6daeff2c8e1d7f1b$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($6daeff2c8e1d7f1b$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $6daeff2c8e1d7f1b$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$6daeff2c8e1d7f1b$var$SPECIES] = FakePromise;
    $6daeff2c8e1d7f1b$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$6daeff2c8e1d7f1b$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $6daeff2c8e1d7f1b$var$IS_BROWSER && !$6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $6daeff2c8e1d7f1b$var$promiseConstructorDetection = {
    CONSTRUCTOR: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $6daeff2c8e1d7f1b$var$SUBCLASSING
};
var $6daeff2c8e1d7f1b$var$newPromiseCapability$2 = {};
var $6daeff2c8e1d7f1b$var$aCallable$4 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $6daeff2c8e1d7f1b$var$aCallable$4(resolve);
    this.reject = $6daeff2c8e1d7f1b$var$aCallable$4(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$6daeff2c8e1d7f1b$var$newPromiseCapability$2.f = function(C) {
    return new $6daeff2c8e1d7f1b$var$PromiseCapability(C);
};
var $6daeff2c8e1d7f1b$var$$$5 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$IS_NODE = $6daeff2c8e1d7f1b$var$engineIsNode;
var $6daeff2c8e1d7f1b$var$global$1 = $6daeff2c8e1d7f1b$var$global$k;
var $6daeff2c8e1d7f1b$var$call$7 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$2 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$setPrototypeOf = $6daeff2c8e1d7f1b$var$objectSetPrototypeOf;
var $6daeff2c8e1d7f1b$var$setToStringTag = $6daeff2c8e1d7f1b$var$setToStringTag$3;
var $6daeff2c8e1d7f1b$var$setSpecies = $6daeff2c8e1d7f1b$var$setSpecies$1;
var $6daeff2c8e1d7f1b$var$aCallable$3 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$isCallable$1 = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$isObject$1 = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$anInstance = $6daeff2c8e1d7f1b$var$anInstance$1;
var $6daeff2c8e1d7f1b$var$speciesConstructor = $6daeff2c8e1d7f1b$var$speciesConstructor$1;
var $6daeff2c8e1d7f1b$var$task = $6daeff2c8e1d7f1b$var$task$1.set;
var $6daeff2c8e1d7f1b$var$microtask = $6daeff2c8e1d7f1b$var$microtask$1;
var $6daeff2c8e1d7f1b$var$hostReportErrors = $6daeff2c8e1d7f1b$var$hostReportErrors$1;
var $6daeff2c8e1d7f1b$var$perform$2 = $6daeff2c8e1d7f1b$var$perform$3;
var $6daeff2c8e1d7f1b$var$Queue = $6daeff2c8e1d7f1b$var$queue;
var $6daeff2c8e1d7f1b$var$InternalStateModule = $6daeff2c8e1d7f1b$var$internalState;
var $6daeff2c8e1d7f1b$var$NativePromiseConstructor$2 = $6daeff2c8e1d7f1b$var$promiseNativeConstructor;
var $6daeff2c8e1d7f1b$var$PromiseConstructorDetection = $6daeff2c8e1d7f1b$var$promiseConstructorDetection;
var $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$3 = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$PROMISE = "Promise";
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$4 = $6daeff2c8e1d7f1b$var$PromiseConstructorDetection.CONSTRUCTOR;
var $6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT = $6daeff2c8e1d7f1b$var$PromiseConstructorDetection.REJECTION_EVENT;
var $6daeff2c8e1d7f1b$var$NATIVE_PROMISE_SUBCLASSING = $6daeff2c8e1d7f1b$var$PromiseConstructorDetection.SUBCLASSING;
var $6daeff2c8e1d7f1b$var$getInternalPromiseState = $6daeff2c8e1d7f1b$var$InternalStateModule.getterFor($6daeff2c8e1d7f1b$var$PROMISE);
var $6daeff2c8e1d7f1b$var$setInternalState = $6daeff2c8e1d7f1b$var$InternalStateModule.set;
var $6daeff2c8e1d7f1b$var$NativePromisePrototype$1 = $6daeff2c8e1d7f1b$var$NativePromiseConstructor$2 && $6daeff2c8e1d7f1b$var$NativePromiseConstructor$2.prototype;
var $6daeff2c8e1d7f1b$var$PromiseConstructor = $6daeff2c8e1d7f1b$var$NativePromiseConstructor$2;
var $6daeff2c8e1d7f1b$var$PromisePrototype = $6daeff2c8e1d7f1b$var$NativePromisePrototype$1;
var $6daeff2c8e1d7f1b$var$TypeError$1 = $6daeff2c8e1d7f1b$var$global$1.TypeError;
var $6daeff2c8e1d7f1b$var$document$1 = $6daeff2c8e1d7f1b$var$global$1.document;
var $6daeff2c8e1d7f1b$var$process = $6daeff2c8e1d7f1b$var$global$1.process;
var $6daeff2c8e1d7f1b$var$newPromiseCapability$1 = $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$3.f;
var $6daeff2c8e1d7f1b$var$newGenericPromiseCapability = $6daeff2c8e1d7f1b$var$newPromiseCapability$1;
var $6daeff2c8e1d7f1b$var$DISPATCH_EVENT = !!($6daeff2c8e1d7f1b$var$document$1 && $6daeff2c8e1d7f1b$var$document$1.createEvent && $6daeff2c8e1d7f1b$var$global$1.dispatchEvent);
var $6daeff2c8e1d7f1b$var$UNHANDLED_REJECTION = "unhandledrejection";
var $6daeff2c8e1d7f1b$var$REJECTION_HANDLED = "rejectionhandled";
var $6daeff2c8e1d7f1b$var$PENDING = 0;
var $6daeff2c8e1d7f1b$var$FULFILLED = 1;
var $6daeff2c8e1d7f1b$var$REJECTED = 2;
var $6daeff2c8e1d7f1b$var$HANDLED = 1;
var $6daeff2c8e1d7f1b$var$UNHANDLED = 2;
var $6daeff2c8e1d7f1b$var$Internal, $6daeff2c8e1d7f1b$var$OwnPromiseCapability, $6daeff2c8e1d7f1b$var$PromiseWrapper, $6daeff2c8e1d7f1b$var$nativeThen;
// helpers
var $6daeff2c8e1d7f1b$var$isThenable = function(it) {
    var then;
    return $6daeff2c8e1d7f1b$var$isObject$1(it) && $6daeff2c8e1d7f1b$var$isCallable$1(then = it.then) ? then : false;
};
var $6daeff2c8e1d7f1b$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $6daeff2c8e1d7f1b$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $6daeff2c8e1d7f1b$var$UNHANDLED) $6daeff2c8e1d7f1b$var$onHandleUnhandled(state);
                state.rejection = $6daeff2c8e1d7f1b$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($6daeff2c8e1d7f1b$var$TypeError$1("Promise-chain cycle"));
            else if (then = $6daeff2c8e1d7f1b$var$isThenable(result)) $6daeff2c8e1d7f1b$var$call$7(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $6daeff2c8e1d7f1b$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $6daeff2c8e1d7f1b$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$6daeff2c8e1d7f1b$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $6daeff2c8e1d7f1b$var$onUnhandled(state);
    });
};
var $6daeff2c8e1d7f1b$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($6daeff2c8e1d7f1b$var$DISPATCH_EVENT) {
        event = $6daeff2c8e1d7f1b$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $6daeff2c8e1d7f1b$var$global$1.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$6daeff2c8e1d7f1b$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $6daeff2c8e1d7f1b$var$global$1["on" + name])) handler(event);
    else if (name === $6daeff2c8e1d7f1b$var$UNHANDLED_REJECTION) $6daeff2c8e1d7f1b$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $6daeff2c8e1d7f1b$var$onUnhandled = function(state) {
    $6daeff2c8e1d7f1b$var$call$7($6daeff2c8e1d7f1b$var$task, $6daeff2c8e1d7f1b$var$global$1, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $6daeff2c8e1d7f1b$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $6daeff2c8e1d7f1b$var$perform$2(function() {
                if ($6daeff2c8e1d7f1b$var$IS_NODE) $6daeff2c8e1d7f1b$var$process.emit("unhandledRejection", value, promise);
                else $6daeff2c8e1d7f1b$var$dispatchEvent($6daeff2c8e1d7f1b$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $6daeff2c8e1d7f1b$var$IS_NODE || $6daeff2c8e1d7f1b$var$isUnhandled(state) ? $6daeff2c8e1d7f1b$var$UNHANDLED : $6daeff2c8e1d7f1b$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $6daeff2c8e1d7f1b$var$isUnhandled = function(state) {
    return state.rejection !== $6daeff2c8e1d7f1b$var$HANDLED && !state.parent;
};
var $6daeff2c8e1d7f1b$var$onHandleUnhandled = function(state) {
    $6daeff2c8e1d7f1b$var$call$7($6daeff2c8e1d7f1b$var$task, $6daeff2c8e1d7f1b$var$global$1, function() {
        var promise = state.facade;
        if ($6daeff2c8e1d7f1b$var$IS_NODE) $6daeff2c8e1d7f1b$var$process.emit("rejectionHandled", promise);
        else $6daeff2c8e1d7f1b$var$dispatchEvent($6daeff2c8e1d7f1b$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $6daeff2c8e1d7f1b$var$bind$1 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $6daeff2c8e1d7f1b$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $6daeff2c8e1d7f1b$var$REJECTED;
    $6daeff2c8e1d7f1b$var$notify(state, true);
};
var $6daeff2c8e1d7f1b$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $6daeff2c8e1d7f1b$var$TypeError$1("Promise can't be resolved itself");
        var then = $6daeff2c8e1d7f1b$var$isThenable(value);
        if (then) $6daeff2c8e1d7f1b$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $6daeff2c8e1d7f1b$var$call$7(then, value, $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalResolve, wrapper, state), $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalReject, wrapper, state));
            } catch (error) {
                $6daeff2c8e1d7f1b$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $6daeff2c8e1d7f1b$var$FULFILLED;
            $6daeff2c8e1d7f1b$var$notify(state, false);
        }
    } catch (error) {
        $6daeff2c8e1d7f1b$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $6daeff2c8e1d7f1b$var$PromiseConstructor = function Promise1(executor) {
        $6daeff2c8e1d7f1b$var$anInstance(this, $6daeff2c8e1d7f1b$var$PromisePrototype);
        $6daeff2c8e1d7f1b$var$aCallable$3(executor);
        $6daeff2c8e1d7f1b$var$call$7($6daeff2c8e1d7f1b$var$Internal, this);
        var state = $6daeff2c8e1d7f1b$var$getInternalPromiseState(this);
        try {
            executor($6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalResolve, state), $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalReject, state));
        } catch (error) {
            $6daeff2c8e1d7f1b$var$internalReject(state, error);
        }
    };
    $6daeff2c8e1d7f1b$var$PromisePrototype = $6daeff2c8e1d7f1b$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $6daeff2c8e1d7f1b$var$Internal = function Promise1(executor) {
        $6daeff2c8e1d7f1b$var$setInternalState(this, {
            type: $6daeff2c8e1d7f1b$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $6daeff2c8e1d7f1b$var$Queue(),
            rejection: false,
            state: $6daeff2c8e1d7f1b$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $6daeff2c8e1d7f1b$var$Internal.prototype = $6daeff2c8e1d7f1b$var$defineBuiltIn$2($6daeff2c8e1d7f1b$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $6daeff2c8e1d7f1b$var$getInternalPromiseState(this);
        var reaction = $6daeff2c8e1d7f1b$var$newPromiseCapability$1($6daeff2c8e1d7f1b$var$speciesConstructor(this, $6daeff2c8e1d7f1b$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $6daeff2c8e1d7f1b$var$isCallable$1(onFulfilled) ? onFulfilled : true;
        reaction.fail = $6daeff2c8e1d7f1b$var$isCallable$1(onRejected) && onRejected;
        reaction.domain = $6daeff2c8e1d7f1b$var$IS_NODE ? $6daeff2c8e1d7f1b$var$process.domain : undefined;
        if (state.state == $6daeff2c8e1d7f1b$var$PENDING) state.reactions.add(reaction);
        else $6daeff2c8e1d7f1b$var$microtask(function() {
            $6daeff2c8e1d7f1b$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $6daeff2c8e1d7f1b$var$OwnPromiseCapability = function() {
        var promise = new $6daeff2c8e1d7f1b$var$Internal();
        var state = $6daeff2c8e1d7f1b$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalResolve, state);
        this.reject = $6daeff2c8e1d7f1b$var$bind$1($6daeff2c8e1d7f1b$var$internalReject, state);
    };
    $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$3.f = $6daeff2c8e1d7f1b$var$newPromiseCapability$1 = function(C) {
        return C === $6daeff2c8e1d7f1b$var$PromiseConstructor || C === $6daeff2c8e1d7f1b$var$PromiseWrapper ? new $6daeff2c8e1d7f1b$var$OwnPromiseCapability(C) : $6daeff2c8e1d7f1b$var$newGenericPromiseCapability(C);
    };
    if ($6daeff2c8e1d7f1b$var$isCallable$1($6daeff2c8e1d7f1b$var$NativePromiseConstructor$2) && $6daeff2c8e1d7f1b$var$NativePromisePrototype$1 !== Object.prototype) {
        $6daeff2c8e1d7f1b$var$nativeThen = $6daeff2c8e1d7f1b$var$NativePromisePrototype$1.then;
        if (!$6daeff2c8e1d7f1b$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $6daeff2c8e1d7f1b$var$defineBuiltIn$2($6daeff2c8e1d7f1b$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $6daeff2c8e1d7f1b$var$PromiseConstructor(function(resolve, reject) {
                $6daeff2c8e1d7f1b$var$call$7($6daeff2c8e1d7f1b$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $6daeff2c8e1d7f1b$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($6daeff2c8e1d7f1b$var$setPrototypeOf) $6daeff2c8e1d7f1b$var$setPrototypeOf($6daeff2c8e1d7f1b$var$NativePromisePrototype$1, $6daeff2c8e1d7f1b$var$PromisePrototype);
    }
}
$6daeff2c8e1d7f1b$var$$$5({
    global: true,
    constructor: true,
    wrap: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $6daeff2c8e1d7f1b$var$PromiseConstructor
});
$6daeff2c8e1d7f1b$var$setToStringTag($6daeff2c8e1d7f1b$var$PromiseConstructor, $6daeff2c8e1d7f1b$var$PROMISE, false);
$6daeff2c8e1d7f1b$var$setSpecies($6daeff2c8e1d7f1b$var$PROMISE);
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$2 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$Iterators$1 = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$ITERATOR$2 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$2("iterator");
var $6daeff2c8e1d7f1b$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
var $6daeff2c8e1d7f1b$var$isArrayIteratorMethod$1 = function(it) {
    return it !== undefined && ($6daeff2c8e1d7f1b$var$Iterators$1.Array === it || $6daeff2c8e1d7f1b$var$ArrayPrototype[$6daeff2c8e1d7f1b$var$ITERATOR$2] === it);
};
var $6daeff2c8e1d7f1b$var$classof = $6daeff2c8e1d7f1b$var$classof$5;
var $6daeff2c8e1d7f1b$var$getMethod$1 = $6daeff2c8e1d7f1b$var$getMethod$3;
var $6daeff2c8e1d7f1b$var$Iterators = $6daeff2c8e1d7f1b$var$iterators;
var $6daeff2c8e1d7f1b$var$wellKnownSymbol$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$ITERATOR$1 = $6daeff2c8e1d7f1b$var$wellKnownSymbol$1("iterator");
var $6daeff2c8e1d7f1b$var$getIteratorMethod$2 = function(it) {
    if (it != undefined) return $6daeff2c8e1d7f1b$var$getMethod$1(it, $6daeff2c8e1d7f1b$var$ITERATOR$1) || $6daeff2c8e1d7f1b$var$getMethod$1(it, "@@iterator") || $6daeff2c8e1d7f1b$var$Iterators[$6daeff2c8e1d7f1b$var$classof(it)];
};
var $6daeff2c8e1d7f1b$var$call$6 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$aCallable$2 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$anObject$5 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$tryToString$1 = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$getIteratorMethod$1 = $6daeff2c8e1d7f1b$var$getIteratorMethod$2;
var $6daeff2c8e1d7f1b$var$$TypeError$1 = TypeError;
var $6daeff2c8e1d7f1b$var$getIterator$1 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $6daeff2c8e1d7f1b$var$getIteratorMethod$1(argument) : usingIterator;
    if ($6daeff2c8e1d7f1b$var$aCallable$2(iteratorMethod)) return $6daeff2c8e1d7f1b$var$anObject$5($6daeff2c8e1d7f1b$var$call$6(iteratorMethod, argument));
    throw $6daeff2c8e1d7f1b$var$$TypeError$1($6daeff2c8e1d7f1b$var$tryToString$1(argument) + " is not iterable");
};
var $6daeff2c8e1d7f1b$var$call$5 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$anObject$4 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$getMethod = $6daeff2c8e1d7f1b$var$getMethod$3;
var $6daeff2c8e1d7f1b$var$iteratorClose$1 = function(iterator, kind, value) {
    var innerResult, innerError;
    $6daeff2c8e1d7f1b$var$anObject$4(iterator);
    try {
        innerResult = $6daeff2c8e1d7f1b$var$getMethod(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $6daeff2c8e1d7f1b$var$call$5(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $6daeff2c8e1d7f1b$var$anObject$4(innerResult);
    return value;
};
var $6daeff2c8e1d7f1b$var$bind = $6daeff2c8e1d7f1b$var$functionBindContext;
var $6daeff2c8e1d7f1b$var$call$4 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$anObject$3 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$tryToString = $6daeff2c8e1d7f1b$var$tryToString$5;
var $6daeff2c8e1d7f1b$var$isArrayIteratorMethod = $6daeff2c8e1d7f1b$var$isArrayIteratorMethod$1;
var $6daeff2c8e1d7f1b$var$lengthOfArrayLike = $6daeff2c8e1d7f1b$var$lengthOfArrayLike$5;
var $6daeff2c8e1d7f1b$var$isPrototypeOf$1 = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$getIterator = $6daeff2c8e1d7f1b$var$getIterator$1;
var $6daeff2c8e1d7f1b$var$getIteratorMethod = $6daeff2c8e1d7f1b$var$getIteratorMethod$2;
var $6daeff2c8e1d7f1b$var$iteratorClose = $6daeff2c8e1d7f1b$var$iteratorClose$1;
var $6daeff2c8e1d7f1b$var$$TypeError = TypeError;
var $6daeff2c8e1d7f1b$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $6daeff2c8e1d7f1b$var$ResultPrototype = $6daeff2c8e1d7f1b$var$Result.prototype;
var $6daeff2c8e1d7f1b$var$iterate$2 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $6daeff2c8e1d7f1b$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $6daeff2c8e1d7f1b$var$iteratorClose(iterator, "normal", condition);
        return new $6daeff2c8e1d7f1b$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $6daeff2c8e1d7f1b$var$anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $6daeff2c8e1d7f1b$var$getIteratorMethod(iterable);
        if (!iterFn) throw $6daeff2c8e1d7f1b$var$$TypeError($6daeff2c8e1d7f1b$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($6daeff2c8e1d7f1b$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $6daeff2c8e1d7f1b$var$lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $6daeff2c8e1d7f1b$var$isPrototypeOf$1($6daeff2c8e1d7f1b$var$ResultPrototype, result)) return result;
            }
            return new $6daeff2c8e1d7f1b$var$Result(false);
        }
        iterator = $6daeff2c8e1d7f1b$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $6daeff2c8e1d7f1b$var$call$4(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $6daeff2c8e1d7f1b$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $6daeff2c8e1d7f1b$var$isPrototypeOf$1($6daeff2c8e1d7f1b$var$ResultPrototype, result)) return result;
    }
    return new $6daeff2c8e1d7f1b$var$Result(false);
};
var $6daeff2c8e1d7f1b$var$wellKnownSymbol = $6daeff2c8e1d7f1b$var$wellKnownSymbol$g;
var $6daeff2c8e1d7f1b$var$ITERATOR = $6daeff2c8e1d7f1b$var$wellKnownSymbol("iterator");
var $6daeff2c8e1d7f1b$var$SAFE_CLOSING = false;
try {
    var $6daeff2c8e1d7f1b$var$called = 0;
    var $6daeff2c8e1d7f1b$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$6daeff2c8e1d7f1b$var$called++
            };
        },
        "return": function() {
            $6daeff2c8e1d7f1b$var$SAFE_CLOSING = true;
        }
    };
    $6daeff2c8e1d7f1b$var$iteratorWithReturn[$6daeff2c8e1d7f1b$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($6daeff2c8e1d7f1b$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $6daeff2c8e1d7f1b$var$checkCorrectnessOfIteration$1 = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$6daeff2c8e1d7f1b$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$6daeff2c8e1d7f1b$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $6daeff2c8e1d7f1b$var$NativePromiseConstructor$1 = $6daeff2c8e1d7f1b$var$promiseNativeConstructor;
var $6daeff2c8e1d7f1b$var$checkCorrectnessOfIteration = $6daeff2c8e1d7f1b$var$checkCorrectnessOfIteration$1;
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$3 = $6daeff2c8e1d7f1b$var$promiseConstructorDetection.CONSTRUCTOR;
var $6daeff2c8e1d7f1b$var$promiseStaticsIncorrectIteration = $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$6daeff2c8e1d7f1b$var$checkCorrectnessOfIteration(function(iterable) {
    $6daeff2c8e1d7f1b$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $6daeff2c8e1d7f1b$var$$$4 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$call$3 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$aCallable$1 = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$2 = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$perform$1 = $6daeff2c8e1d7f1b$var$perform$3;
var $6daeff2c8e1d7f1b$var$iterate$1 = $6daeff2c8e1d7f1b$var$iterate$2;
var $6daeff2c8e1d7f1b$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $6daeff2c8e1d7f1b$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$6daeff2c8e1d7f1b$var$$$4({
    target: "Promise",
    stat: true,
    forced: $6daeff2c8e1d7f1b$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $6daeff2c8e1d7f1b$var$perform$1(function() {
            var $promiseResolve = $6daeff2c8e1d7f1b$var$aCallable$1(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $6daeff2c8e1d7f1b$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $6daeff2c8e1d7f1b$var$call$3($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $6daeff2c8e1d7f1b$var$$$3 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$2 = $6daeff2c8e1d7f1b$var$promiseConstructorDetection.CONSTRUCTOR;
var $6daeff2c8e1d7f1b$var$NativePromiseConstructor = $6daeff2c8e1d7f1b$var$promiseNativeConstructor;
var $6daeff2c8e1d7f1b$var$getBuiltIn$1 = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$isCallable = $6daeff2c8e1d7f1b$var$isCallable$l;
var $6daeff2c8e1d7f1b$var$defineBuiltIn$1 = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$NativePromisePrototype = $6daeff2c8e1d7f1b$var$NativePromiseConstructor && $6daeff2c8e1d7f1b$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$6daeff2c8e1d7f1b$var$$$3({
    target: "Promise",
    proto: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($6daeff2c8e1d7f1b$var$isCallable($6daeff2c8e1d7f1b$var$NativePromiseConstructor)) {
    var $6daeff2c8e1d7f1b$var$method = $6daeff2c8e1d7f1b$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($6daeff2c8e1d7f1b$var$NativePromisePrototype["catch"] !== $6daeff2c8e1d7f1b$var$method) $6daeff2c8e1d7f1b$var$defineBuiltIn$1($6daeff2c8e1d7f1b$var$NativePromisePrototype, "catch", $6daeff2c8e1d7f1b$var$method, {
        unsafe: true
    });
}
var $6daeff2c8e1d7f1b$var$$$2 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$call$2 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$aCallable = $6daeff2c8e1d7f1b$var$aCallable$9;
var $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$1 = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$perform = $6daeff2c8e1d7f1b$var$perform$3;
var $6daeff2c8e1d7f1b$var$iterate = $6daeff2c8e1d7f1b$var$iterate$2;
var $6daeff2c8e1d7f1b$var$PROMISE_STATICS_INCORRECT_ITERATION = $6daeff2c8e1d7f1b$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$6daeff2c8e1d7f1b$var$$$2({
    target: "Promise",
    stat: true,
    forced: $6daeff2c8e1d7f1b$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $6daeff2c8e1d7f1b$var$perform(function() {
            var $promiseResolve = $6daeff2c8e1d7f1b$var$aCallable(C.resolve);
            $6daeff2c8e1d7f1b$var$iterate(iterable, function(promise) {
                $6daeff2c8e1d7f1b$var$call$2($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $6daeff2c8e1d7f1b$var$$$1 = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$call$1 = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$1 = $6daeff2c8e1d7f1b$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$6daeff2c8e1d7f1b$var$$$1({
    target: "Promise",
    stat: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $6daeff2c8e1d7f1b$var$newPromiseCapabilityModule.f(this);
        $6daeff2c8e1d7f1b$var$call$1(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $6daeff2c8e1d7f1b$var$anObject$2 = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$isObject = $6daeff2c8e1d7f1b$var$isObject$8;
var $6daeff2c8e1d7f1b$var$newPromiseCapability = $6daeff2c8e1d7f1b$var$newPromiseCapability$2;
var $6daeff2c8e1d7f1b$var$promiseResolve$1 = function(C, x) {
    $6daeff2c8e1d7f1b$var$anObject$2(C);
    if ($6daeff2c8e1d7f1b$var$isObject(x) && x.constructor === C) return x;
    var promiseCapability = $6daeff2c8e1d7f1b$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $6daeff2c8e1d7f1b$var$$ = $6daeff2c8e1d7f1b$var$_export;
var $6daeff2c8e1d7f1b$var$getBuiltIn = $6daeff2c8e1d7f1b$var$getBuiltIn$8;
var $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR = $6daeff2c8e1d7f1b$var$promiseConstructorDetection.CONSTRUCTOR;
var $6daeff2c8e1d7f1b$var$promiseResolve = $6daeff2c8e1d7f1b$var$promiseResolve$1;
$6daeff2c8e1d7f1b$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$6daeff2c8e1d7f1b$var$$({
    target: "Promise",
    stat: true,
    forced: $6daeff2c8e1d7f1b$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $6daeff2c8e1d7f1b$var$promiseResolve(this, x);
    }
});
const $6daeff2c8e1d7f1b$var$HardwareWalletAccountsForm = ({ accounts: accounts, onSelectedChanged: onSelectedChanged, onSubmit: onSubmit, onChangeRoute: onChangeRoute })=>{
    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
        className: "choose-ledger-account-form-wrapper"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    "We found ",
                    accounts.length,
                    " accounts on your device. Select the account(s) you wish to connect."
                ]
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "button-wrapper"
            }, {
                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                    onClick: ()=>{
                        onChangeRoute("SpecifyHDPath");
                    }
                }, {
                    children: "HD.../0"
                }))
            })),
            (0, $7b02d682eb115277$exports.jsx)("form", Object.assign({
                className: "form",
                onSubmit: (e)=>{
                    onSubmit(accounts, e);
                }
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "nws-form-control"
                        }, {
                            children: accounts.map((account, index)=>(0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                    className: "account"
                                }, {
                                    children: [
                                        (0, $7b02d682eb115277$exports.jsx)("input", {
                                            onChange: (e)=>{
                                                onSelectedChanged(index, e.target.checked);
                                            },
                                            checked: account.selected,
                                            type: "checkbox",
                                            id: account.accountId,
                                            name: account.accountId,
                                            value: account.accountId
                                        }),
                                        (0, $7b02d682eb115277$exports.jsxs)("label", Object.assign({
                                            htmlFor: account.accountId
                                        }, {
                                            children: [
                                                " ",
                                                account.accountId
                                            ]
                                        })),
                                        (0, $7b02d682eb115277$exports.jsx)("br", {})
                                    ]
                                }), index))
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "action-buttons"
                        }, {
                            children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                className: "middleButton",
                                type: "submit",
                                disabled: !accounts.some((x)=>x.selected)
                            }, {
                                children: "Connect"
                            }))
                        }))
                    ]
                })
            }))
        ]
    }));
};
var $6daeff2c8e1d7f1b$var$img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAR3SURBVHgBpVZ9aJVVGH+e55z33bi7zY9hMz+yMAeNoEIq6A9ZRKQWEsQNFIIpsf5Y9E+GsD9iBEEDMUkDa6ShRKKZYIWiRkaKaUGUGCKOTGMF84PNO99773vOefq9720yK5ZzD/dwPt/nd37P17lEk5Qnuz9roUkKT7T5bNe+QjTNLCHv24h1Xgh+OmtwQYPH2jUXwlnW9NRooqePfLS6MmmQ59cdeEGJlkJZA5MGVecoAwghBYZTVY9ftuaDSy8x8w9fbFl95JZAXuw9dmelkvRAyXxS7wMFryG4bIyWZiqzPgMhaFfGfn3NY3AZG9sPf/Dy8HidZvxkZc/h1pqnPlKey6yspMqUd9jVAEYY6RCGDQTwjGDwGTgAlbwRijV1C9vanz577tT+6r+YrOz5rlXFrQ/qZ+FbDxCfXS5oOgxln4v473f3rbgwdn7FK5/MCaH2eAg6X8g3K2iBMTiBkNJVKbod+ze9mgPZsY/UaicYzCE1HgpZc558olCTjTvWLxv9p1n3bV45iO7T5zq3TU9j9xTOLwQ5D9t48aEYrtGj2P/2BpNS78nZJoRdlDsYd8vphz273lqyhW5Rnlnz3hOe6SEwghvxPUMTVfYe2rpuUOqOkZeIxdSbsSJ8eTIAmXy5tftrMPkzi0C4B2ZDNHp+INvLQURkhYiJ6gDGko376DbEJ8k3mcnYBSeSM2ptL/XGsurNnxfnDIQNwCKADO1845Ef6Tbk0M51g4joMgncDyBmkrtsNEMQovcDxGYsGL2yDNAUxPv0VySs4yxhfeYbabJg0Awg+ILylEB6nKMpSOp0WCR1+QSuD4ELljNDEfyRrdXPCU1BTEgD7pyOzVmC2iBm0KgYAMCEeXovoClIjdKiVdQ3FYbzmatxWRqMPcNsDHyfNWskWk5TkJhNEwVyxA6hLL5clLJsW7voFxa6LiR5CCOeWzo3XFxKtyEdy3tnp7VahAoDp6PEVGvJye09l3P7K9k9WQijXBv4B6WG+0pvD0ybFEBHZ6OPh+/OGaBsIvNRAGp/ZHv1jJeon+omszBkFsr3FhsLB7rev3JLQKVSyfjmaW2BJSavDlqR7c5VrR+4AbLttbkXMehH7gjA8gZiD/tq+Or/ABZ3dUW/J62LcPUGcrW8pKSVFAg6cHz3O0l25qZHa/XGwWPg9aAwwzdZAaDX+7tbNsMYf5+bpaUS0dDQEF8rtsUxCbI5e5KRzGhBMiqNxllKju7d8NOYXjseRBytQngcVDL3wD9H+7vf3YS7mnnzqrZpwSxrwkh04cpM5NTMyJdHbIgaESyxJ6tZ5cDbw3qd0tqVCp25Se/4yYdr5/zm/ehjwvpxZHgN0Wlub0/Yt7awdykqRYFHy6NUQVrBd4o6p6ngrVL2Bo8ksuJqoXzq9Ln9m6rj9U74b6Wjo8OeP082aY5NUxRsYzwDkeFsU+MdUU3U4PG0QtbahqhadDMuHTy4fvS/9EwIUpdeuW/ZiShOipFxURRbNdWETFMRZrCFlEZGkuPHdycTafgLExNiI6YfUpcAAAAASUVORK5CYII=";
const $6daeff2c8e1d7f1b$var$WalletConnecting = ({ wallet: wallet, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                title: "",
                onCloseModal: onCloseModal
            }),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "connecting-wrapper"
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "icon"
                        }, {
                            children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: wallet === null || wallet === void 0 ? void 0 : wallet.metadata.iconUrl,
                                alt: wallet === null || wallet === void 0 ? void 0 : wallet.metadata.name
                            })
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                            className: "connecting-name"
                        }, {
                            children: wallet === null || wallet === void 0 ? void 0 : wallet.metadata.name
                        })),
                        (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                            className: "connecting-details"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                    className: "spinner"
                                }, {
                                    children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                        src: $6daeff2c8e1d7f1b$var$img,
                                        alt: "loading-icon"
                                    })
                                })),
                                (0, $7b02d682eb115277$exports.jsxs)("span", {
                                    children: [
                                        (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectingTo"),
                                        " ",
                                        wallet === null || wallet === void 0 ? void 0 : wallet.metadata.name,
                                        "..."
                                    ]
                                })
                            ]
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                            className: "connecting-message"
                        }, {
                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)(`modal.wallet.connectingMessage.${wallet === null || wallet === void 0 ? void 0 : wallet.type}`)
                            })
                        }))
                    ]
                }))
            }))
        ]
    });
};
const $6daeff2c8e1d7f1b$var$LedgerDeviceIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: "317",
        height: "157",
        viewBox: "0 0 317 157",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M249.99 16.0994C270.063 -0.864155 289.788 1.58873 301.497 10.7365C307.402 15.3499 311.278 21.6575 312.267 28.1258C313.247 34.5412 311.413 41.2233 305.692 46.8044C297.366 54.9273 286.343 55.3362 273.015 51.5109C261.654 48.25 249.058 42.0377 235.726 35.4627L235.726 35.4626L235.717 35.458C233.367 34.2992 230.995 33.129 228.602 31.9618C212.742 24.2253 196.067 16.6575 179.842 13.8595C163.538 11.0479 147.552 13.0313 133.266 24.522C128.032 28.732 123.478 35.2086 121.716 44.8205C119.961 54.3947 120.992 66.9771 126.703 83.4311C135.432 108.583 132.899 126.677 123.575 138.063C114.217 149.491 97.5614 154.733 76.7887 153.121C55.0043 151.43 29.0621 142.206 3.29867 125.227L0.887817 127.942C27.2472 145.405 53.9251 154.952 76.5105 156.705C97.9028 158.365 115.96 153.035 126.356 140.341C136.785 127.606 139.045 108.029 130.099 82.2524C124.521 66.1801 123.642 54.2493 125.252 45.4687C126.854 36.7258 130.94 31.006 135.519 27.3232C148.794 16.6458 163.649 14.715 179.231 17.4021C194.891 20.1027 211.146 27.4463 227.026 35.1928C229.381 36.3415 231.729 37.5001 234.066 38.6531L234.073 38.6568C247.382 45.223 260.324 51.608 272.024 54.9662C285.819 58.9258 298.493 58.8501 308.202 49.3776C314.764 42.9759 316.974 35.1288 315.82 27.5826C314.675 20.0893 310.237 13.0029 303.71 7.90363C290.555 -2.37382 268.938 -4.62038 247.67 13.3537L249.99 16.0994Z",
                fill: "url(#paint0_linear_3_672)"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M260.264 17.8767L177.605 89.4649L157.679 73.9664L239.23 3.85423L260.264 17.8767Z",
                fill: "#6A7075"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M205.939 54.4577L199.764 50.2636L233.316 20.9053L239.907 25.8395L205.939 54.4577Z",
                fill: "#494E52"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M260.264 17.8757L177.605 89.4639L182.033 98.3202L264.323 26.363L260.264 17.8757Z",
                fill: "#494E52"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M177.236 89.4646L181.295 98.3209L165.059 85.7745L170.963 85.0365L177.236 89.4646Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M93.4708 99.6384L91.9948 110.13L174.653 92.894L164.69 85.7749L93.4708 99.6384Z",
                fill: "#DCDADA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M93.1157 104.323L94.314 100.129L165.613 86.3483L169.208 89.344L93.1157 104.323Z",
                fill: "#C1C1C1"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M94.2086 99.7963L86.0903 101.272L92.3635 110.129L94.2086 99.7963Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M86.0903 100.907L89.0027 74.1304L178.455 55.2416C184.695 53.9962 195.766 54.7675 197.177 63.7058C198.284 70.717 195.506 73.9943 191.628 77.3592C188.495 80.0671 180.152 82.4646 178.343 82.8944C178.293 82.9064 178.241 82.9188 178.186 82.9319C177.38 83.1245 176.007 83.4525 170.644 84.5088C169.085 84.8158 167.382 85.1501 165.557 85.5078L164.933 85.63C146.312 89.2764 115.528 95.2297 93.9844 99.3849C91.1808 99.9257 88.5337 100.436 86.0903 100.907ZM185.076 75.554C190.748 73.3535 193.99 68.0745 192.318 63.7631C190.645 59.4517 184.691 57.7405 179.019 59.941C173.347 62.1416 170.105 67.4206 171.778 71.732C173.45 76.0434 179.404 77.7546 185.076 75.554Z",
                fill: "#F4F1E8"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M199.764 50.3994L196.768 48.3043L232.194 18.0454L233.316 21.6403L199.764 50.3994Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M239.968 25.9943L232.588 20.4592V17.5071L241.813 24.5183L239.968 25.9943Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "182.084",
                cy: "68.0811",
                rx: "10.242",
                ry: "7.46772",
                transform: "rotate(-23.7949 182.084 68.0811)",
                fill: "#494E52"
            }),
            (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "182.084",
                cy: "68.0816",
                rx: "6.68462",
                ry: "4.87394",
                transform: "rotate(-23.7949 182.084 68.0816)",
                fill: "#494E52"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M238.725 2.93094L260.368 17.2564L264.865 26.4556L181.615 99.0341L175.16 94.311L92.0028 110.947L85.3267 101.399L88.3269 73.8157L178.118 54.8553L238.725 2.93094ZM178.599 56.2622L89.6786 75.0388L86.9321 100.29C89.0979 99.8725 91.4124 99.4263 93.8446 98.9572C115.388 94.8019 146.171 88.8488 164.791 85.2026L165.415 85.0804C167.24 84.7228 168.943 84.3885 170.501 84.0816C175.853 83.0275 177.219 82.701 178.015 82.5107C178.07 82.4976 178.122 82.4852 178.173 82.4732C179.048 82.2652 181.558 81.5669 184.235 80.5851C186.742 79.6655 189.286 78.5354 190.802 77.3758L191.151 77.0922L191.644 76.6595C193.341 75.147 194.723 73.6739 195.61 71.871C196.571 69.916 196.982 67.5029 196.448 64.1178C195.8 60.0131 192.959 57.7574 189.408 56.6566C185.833 55.5483 181.637 55.6566 178.603 56.2615C178.601 56.2617 178.6 56.262 178.599 56.2622ZM192.631 77.7565L259.555 18.9531L263.042 26.0869L181.808 96.9078L178.132 89.5713L191.724 78.529C191.859 78.4249 191.988 78.32 192.11 78.2144L192.111 78.2136C192.286 78.0617 192.46 77.9094 192.631 77.7565ZM185.491 81.6908C185.24 81.7868 184.99 81.8802 184.743 81.9709C182.013 82.9723 179.447 83.6875 178.514 83.9093C178.463 83.9213 178.411 83.9338 178.356 83.9468C177.635 84.1192 176.472 84.3971 172.491 85.1919L177.172 88.4492L185.491 81.6908ZM176.631 89.8707L170.479 85.5903C169.306 85.8213 168.054 86.0673 166.731 86.3265L175.769 92.9276L179.548 95.6924L176.631 89.8707ZM164.758 86.7132C146.252 90.3362 116.027 96.1817 94.6324 100.308L93.2258 109.197L173.543 93.1293L164.758 86.7132ZM91.888 108.207L93.0909 100.606C91.0848 100.993 89.1642 101.363 87.3471 101.713L91.888 108.207ZM258.581 17.8436L197.306 71.6841C198.142 69.5779 198.41 67.0795 197.906 63.8876C197.143 59.0539 193.743 56.4549 189.845 55.2467C186.921 54.3402 183.662 54.1916 180.861 54.449L238.84 4.77668L258.581 17.8436ZM232.505 16.82L243.089 24.5643L205.915 56.5106L196.042 48.0665L232.505 16.82ZM232.118 19.096L198.312 48.0654L199.744 49.29L232.584 20.9424L232.118 19.096ZM233.456 22.1396L200.878 50.2604L205.913 54.5664L239.041 26.0969L233.456 22.1396ZM240.195 25.1054L240.717 24.6571L233.759 19.5663L234.06 20.7586L240.195 25.1054Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M190.194 69.9744C191.32 68.1409 191.576 66.2271 190.942 64.5937C190.308 62.9603 188.829 61.7198 186.761 61.1254C184.691 60.5307 182.116 60.6196 179.553 61.6139C176.991 62.6081 175.029 64.2794 173.902 66.1141C172.776 67.9477 172.52 69.8614 173.154 71.4948C173.788 73.1282 175.267 74.3687 177.335 74.9631C179.405 75.5578 181.98 75.4689 184.543 74.4746C187.105 73.4804 189.067 71.8091 190.194 69.9744ZM185.077 75.8508C190.749 73.6502 193.991 68.3712 192.318 64.0598C190.645 59.7484 184.691 58.0372 179.019 60.2378C173.347 62.4383 170.105 67.7173 171.778 72.0287C173.451 76.3401 179.405 78.0513 185.077 75.8508Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M187.391 69.169C188.127 67.9713 188.266 66.7721 187.881 65.7812C187.497 64.7903 186.586 63.9984 185.235 63.6102C183.883 63.2216 182.173 63.2741 180.456 63.9404C178.738 64.6068 177.441 65.7208 176.705 66.9196C175.969 68.1172 175.83 69.3165 176.215 70.3074C176.599 71.2983 177.511 72.0901 178.861 72.4783C180.214 72.8669 181.923 72.8144 183.64 72.1481C185.358 71.4818 186.655 70.3678 187.391 69.169ZM184.174 73.5242C188.156 71.9795 190.432 68.2738 189.257 65.2473C188.083 62.2208 183.904 61.0196 179.922 62.5643C175.94 64.1091 173.665 67.8148 174.839 70.8412C176.013 73.8677 180.193 75.0689 184.174 73.5242Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M240.499 41.2441C239.744 40.3649 239.844 39.04 240.724 38.285L249.781 30.5067C250.66 29.7516 251.985 29.8523 252.74 30.7315V30.7315C253.495 31.6108 253.395 32.9356 252.516 33.6907L243.458 41.469C242.579 42.224 241.254 42.1234 240.499 41.2441V41.2441Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M250.743 31.6265L241.685 39.4048C241.424 39.6287 241.395 40.0217 241.619 40.2825C241.842 40.5433 242.235 40.5731 242.496 40.3492L251.554 32.5709C251.815 32.3469 251.845 31.954 251.621 31.6932C251.397 31.4324 251.004 31.4025 250.743 31.6265ZM240.724 38.285C239.844 39.04 239.744 40.3649 240.499 41.2441C241.254 42.1234 242.579 42.224 243.458 41.469L252.516 33.6907C253.395 32.9356 253.495 31.6108 252.74 30.7315C251.985 29.8523 250.66 29.7516 249.781 30.5067L240.724 38.285Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M205.779 71.4647C205.005 70.5642 205.108 69.2073 206.009 68.4339L214.989 60.7218C215.89 59.9485 217.247 60.0516 218.02 60.9521V60.9521C218.793 61.8526 218.69 63.2095 217.79 63.9829L208.809 71.695C207.909 72.4683 206.552 72.3652 205.779 71.4647V71.4647Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M215.951 61.8416L206.97 69.5537C206.688 69.796 206.656 70.221 206.898 70.5031C207.141 70.7851 207.566 70.8174 207.848 70.5752L216.828 62.863C217.11 62.6208 217.143 62.1958 216.9 61.9137C216.658 61.6317 216.233 61.5994 215.951 61.8416ZM206.009 68.4339C205.108 69.2073 205.005 70.5642 205.779 71.4647C206.552 72.3652 207.909 72.4683 208.809 71.695L217.79 63.9829C218.69 63.2095 218.793 61.8526 218.02 60.9521C217.247 60.0516 215.89 59.9485 214.989 60.7218L206.009 68.4339Z",
                fill: "black"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "141.356",
                cy: "19.525",
                r: "10.1855",
                fill: "#FE89B4"
            }),
            (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "139.062",
                cy: "14.7094",
                rx: "2.42519",
                ry: "1.94015",
                transform: "rotate(-34.544 139.062 14.7094)",
                fill: "#FDF7FF"
            }),
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "252.489",
                cy: "79.7577",
                r: "7.78893",
                fill: "#EC5236"
            }),
            (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                cx: "250.434",
                cy: "76.3701",
                rx: "2.61272",
                ry: "2.09018",
                transform: "rotate(-34.544 250.434 76.3701)",
                fill: "#EDB69D"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M100.436 79.9254C100.461 79.6567 100.732 79.3897 101.042 79.329L106.657 78.2299C107.587 78.0478 108.281 78.5536 108.207 79.3596L107.759 84.2243C107.734 84.493 107.463 84.76 107.153 84.8207L100.416 86.1396C100.106 86.2003 99.8742 86.0317 99.899 85.7631L100.436 79.9254Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.8553 81.7775C95.9294 80.9715 96.7437 80.1704 97.6739 79.9883L98.7968 79.7685C99.1069 79.7078 99.3382 79.8764 99.3135 80.1451L99.1344 82.091C99.1096 82.3597 98.8382 82.6267 98.5282 82.6874L96.2824 83.127C95.9723 83.1877 95.741 83.0191 95.7657 82.7505L95.8553 81.7775Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.5865 84.6965C95.6112 84.4278 95.8826 84.1608 96.1927 84.1001L98.4385 83.6605C98.7486 83.5998 98.9799 83.7684 98.9552 84.037L98.7761 85.9829C98.7513 86.2516 98.4799 86.5186 98.1699 86.5793L95.9241 87.019C95.614 87.0797 95.3827 86.9111 95.4074 86.6424L95.5865 84.6965Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.2282 88.5884C95.2529 88.3197 95.5244 88.0527 95.8344 87.992L98.0802 87.5524C98.3903 87.4917 98.6216 87.6603 98.5969 87.929L98.4178 89.8749C98.3931 90.1435 98.1216 90.4105 97.8116 90.4712L96.6887 90.6911C95.7584 90.8732 95.0645 90.3674 95.1387 89.5614L95.2282 88.5884Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M99.7197 87.709C99.7444 87.4403 100.016 87.1733 100.326 87.1126L102.572 86.673C102.882 86.6123 103.113 86.7809 103.088 87.0496L102.909 88.9955C102.885 89.2641 102.613 89.5312 102.303 89.5919L100.057 90.0315C99.7472 90.0922 99.5159 89.9236 99.5406 89.6549L99.7197 87.709Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.211 86.8298C104.236 86.5611 104.507 86.2941 104.817 86.2334L107.063 85.7938C107.373 85.7331 107.605 85.9017 107.58 86.1704L107.49 87.1433C107.416 87.9493 106.602 88.7504 105.672 88.9325L104.549 89.1523C104.239 89.213 104.007 89.0444 104.032 88.7757L104.211 86.8298Z",
                fill: "#B3AAAA"
            }),
            (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: (0, $7b02d682eb115277$exports.jsxs)("linearGradient", Object.assign({
                    id: "paint0_linear_3_672",
                    x1: "-44.5195",
                    y1: "122.42",
                    x2: "263.357",
                    y2: "-8.65023",
                    gradientUnits: "userSpaceOnUse"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0.110697",
                            stopColor: "#232323"
                        }),
                        (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "1",
                            stopColor: "#3D3D3D"
                        })
                    ]
                }))
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$UpArrowIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsx)("svg", Object.assign({
        width: "10",
        height: "7",
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 5.4762L5 1.4762L1 5.4762",
            stroke: "#4F7CD1",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
const $6daeff2c8e1d7f1b$var$DownArrowIcon = ()=>{
    return (0, $7b02d682eb115277$exports.jsx)("svg", Object.assign({
        width: "10",
        height: "7",
        viewBox: "0 0 10 7",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M1 1.52382L5 5.52382L9 1.52382",
            stroke: "#4F7CD1",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
};
const $6daeff2c8e1d7f1b$var$DEFAULT_DERIVATION_PATH = "44'/397'/0'/0'/1'";
const $6daeff2c8e1d7f1b$var$DerivationPath = ({ selector: selector, options: options, onBack: onBack, onConnected: onConnected, params: params, onError: onError, onCloseModal: onCloseModal })=>{
    const [route, setRoute] = (0, $acw62.useState)("EnterDerivationPath");
    const [derivationPath, setDerivationPath] = (0, $acw62.useState)($6daeff2c8e1d7f1b$var$DEFAULT_DERIVATION_PATH);
    const [customDerivationPath, setCustomDerivationPath] = (0, $acw62.useState)(1);
    const [accounts, setAccounts] = (0, $acw62.useState)([]);
    const [selectedAccounts, setSelectedAccounts] = (0, $acw62.useState)([]);
    const [hardwareWallet, setHardwareWallet] = (0, $acw62.useState)();
    const [customAccountId, setCustomAccountId] = (0, $acw62.useState)("");
    const [connecting, setConnecting] = (0, $acw62.useState)(false);
    const initalHeaderTitle = (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.connectWithLedger");
    const [headerTitle, setHeaderTitle] = (0, $acw62.useState)(initalHeaderTitle);
    const getAccountIds = (publicKey)=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            const response = yield fetch(`${selector.options.network.indexerUrl}/publicKey/ed25519:${publicKey}/accounts`);
            if (!response.ok) throw new Error("Failed to get account id from public key");
            const accountIds = yield response.json();
            if (!Array.isArray(accountIds) || !accountIds.length) return [];
            return accountIds;
        });
    const resolveAccounts = (wallet)=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            const publicKey = yield wallet.getPublicKey(derivationPath);
            try {
                const accountIds = yield getAccountIds(publicKey);
                return accountIds.map((accountId, index)=>{
                    return {
                        derivationPath: derivationPath,
                        publicKey: publicKey,
                        accountId: accountId,
                        selected: index === 0
                    };
                });
            } catch (e) {
                return null;
            }
        });
    const handleValidateAccount = ()=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            const wallet = yield selector.wallet(params.walletId);
            if (wallet.type !== "hardware") return;
            setConnecting(true);
            setHardwareWallet(wallet);
            try {
                const resolvedAccounts = yield resolveAccounts(wallet);
                if (!resolvedAccounts) {
                    setRoute("AddCustomAccountId");
                    return;
                }
                const noAccounts = resolvedAccounts.length === 0;
                const multipleAccounts = resolvedAccounts.length > 1;
                if (noAccounts) {
                    setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.noAccountsFound"));
                    setRoute("NoAccountsFound");
                    return;
                }
                setAccounts(resolvedAccounts);
                if (!multipleAccounts) {
                    setSelectedAccounts(resolvedAccounts);
                    setRoute("OverviewAccounts");
                } else {
                    setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.selectYourAccounts"));
                    setRoute("ChooseAccount");
                }
            } catch (err) {
                setConnecting(false);
                const message = err && typeof err === "object" && "message" in err ? err.message : "Something went wrong";
                onError(message, wallet);
            } finally{
                setConnecting(false);
            }
        });
    const handleAddCustomAccountId = ()=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            try {
                setConnecting(true);
                const publicKey = yield hardwareWallet.getPublicKey(derivationPath);
                const accountList = [
                    {
                        derivationPath: derivationPath,
                        publicKey: publicKey,
                        accountId: customAccountId,
                        selected: true
                    }
                ];
                setAccounts(accountList);
                setSelectedAccounts(accountList);
                setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.connecting1Account"));
                setRoute("OverviewAccounts");
            } catch (err) {
                setConnecting(false);
                const message = err && typeof err === "object" && "message" in err ? err.message : "Something went wrong";
                onError(message, hardwareWallet);
            } finally{
                setConnecting(false);
            }
        });
    const handleSignIn = ()=>{
        const mapAccounts = selectedAccounts.map((account)=>{
            return {
                derivationPath: account.derivationPath,
                publicKey: account.publicKey,
                accountId: account.accountId
            };
        });
        return hardwareWallet.signIn({
            contractId: options.contractId,
            methodNames: options.methodNames,
            accounts: mapAccounts
        }).then(()=>onConnected()).catch((err)=>{
            onError(`Error: ${err.message}`, hardwareWallet);
        });
    };
    const handleOnBackButtonClick = ()=>{
        if (route === "SpecifyHDPath" || route === "NoAccountsFound" || route === "ChooseAccount") {
            setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.connectWithLedger"));
            setRoute("EnterDerivationPath");
        }
        if (route === "OverviewAccounts") {
            setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.selectYourAccounts"));
            setRoute("ChooseAccount");
        }
    };
    if (connecting) return (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
        className: "derivation-path-wrapper"
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletConnecting, {
            wallet: hardwareWallet,
            onBack: ()=>{
                setConnecting(false);
            },
            onCloseModal: onCloseModal
        })
    }));
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    (route === "SpecifyHDPath" || route === "NoAccountsFound" || route === "ChooseAccount" || route === "OverviewAccounts") && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$BackArrow, {
                        onClick: handleOnBackButtonClick
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                        title: headerTitle,
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "derivation-path-wrapper"
            }, {
                children: [
                    route === "EnterDerivationPath" && (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "enter-derivation-path"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "ledger-image"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$LedgerDeviceIcon, {})
                            })),
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "ledger-description"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.makeSureYourLedger")
                                    }),
                                    (0, $7b02d682eb115277$exports.jsx)("p", Object.assign({
                                        className: "specify-path",
                                        onClick: ()=>{
                                            setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.specifyHDPath"));
                                            setRoute("SpecifyHDPath");
                                        }
                                    }, {
                                        children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.specifyHDPath")
                                    }))
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleValidateAccount
                                }, {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.continue")
                                }))
                            }))
                        ]
                    })),
                    route === "SpecifyHDPath" && (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "specify-path-wrapper"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "change-path-wrapper"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "display-path"
                                    }, {
                                        children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: derivationPath.slice(0, -2)
                                        })
                                    })),
                                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                        className: "change-path"
                                    }, {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                                className: "path-value"
                                            }, {
                                                children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: customDerivationPath
                                                })
                                            })),
                                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                                className: "buttons-wrapper"
                                            }, {
                                                children: [
                                                    (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                                        onClick: ()=>{
                                                            const newValue = customDerivationPath + 1;
                                                            const path = derivationPath.slice(0, -2);
                                                            setDerivationPath(`${path}${newValue}'`);
                                                            setCustomDerivationPath(newValue);
                                                        }
                                                    }, {
                                                        children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$UpArrowIcon, {})
                                                    })),
                                                    (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                                        onClick: ()=>{
                                                            const newValue = customDerivationPath - 1;
                                                            if (newValue < 0) return;
                                                            const path = derivationPath.slice(0, -2);
                                                            setDerivationPath(`${path}${newValue}'`);
                                                            setCustomDerivationPath(newValue);
                                                        }
                                                    }, {
                                                        children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$DownArrowIcon, {})
                                                    }))
                                                ]
                                            }))
                                        ]
                                    }))
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("p", Object.assign({
                                className: "path-description"
                            }, {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.enterYourPreferredHDPath")
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("p", Object.assign({
                                className: "what-link"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
                                    href: "https://www.ledger.com/academy/crypto/what-are-hierarchical-deterministic-hd-wallets",
                                    target: "_blank"
                                }, {
                                    children: "What's this?"
                                }))
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleValidateAccount
                                }, {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.scan")
                                }))
                            }))
                        ]
                    })),
                    route === "NoAccountsFound" && (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "no-accounts-found-wrapper"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsxs)("p", {
                            children: [
                                (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.cantFindAnyAccount"),
                                " ",
                                (0, $7b02d682eb115277$exports.jsx)("a", Object.assign({
                                    href: `https://${selector.options.network.networkId === "testnet" ? "testnet" : "app"}.mynearwallet.com/create`,
                                    target: "_blank"
                                }, {
                                    children: "MyNearWallet"
                                })),
                                " ",
                                (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.orConnectAnAnotherLedger")
                            ]
                        })
                    })),
                    route === "ChooseAccount" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$HardwareWalletAccountsForm, {
                        accounts: accounts,
                        onSelectedChanged: (index, selected)=>{
                            setAccounts((prevAccounts)=>{
                                const updateAccounts = prevAccounts.map((account, idx)=>{
                                    const selectedValue = index === idx ? selected : account.selected;
                                    return Object.assign(Object.assign({}, account), {
                                        selected: selectedValue
                                    });
                                });
                                return [
                                    ...updateAccounts
                                ];
                            });
                        },
                        onSubmit: (acc, e)=>{
                            e.preventDefault();
                            const selectedAcc = acc.filter((account)=>account.selected);
                            setSelectedAccounts(selectedAcc);
                            const numberOfAccounts = selectedAcc.length;
                            setHeaderTitle(`${(0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.connecting")} ${numberOfAccounts} ${(0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.ofAccounts")}`);
                            setRoute("OverviewAccounts");
                        },
                        onChangeRoute: (newRoute)=>{
                            if (newRoute === "SpecifyHDPath") setHeaderTitle((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.specifyHDPath"));
                            setRoute(newRoute);
                        }
                    }),
                    route === "AddCustomAccountId" && (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "enter-custom-account"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.failedToAutomatically")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "input-wrapper"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("input", {
                                    type: "text",
                                    placeholder: "Account ID",
                                    value: customAccountId,
                                    onChange: (e)=>{
                                        setCustomAccountId(e.target.value);
                                    }
                                })
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleAddCustomAccountId
                                }, {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("ledger.Continue")
                                }))
                            }))
                        ]
                    })),
                    route === "OverviewAccounts" && (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "overview-wrapper"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.overviewTheListOfAuthorized")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "accounts"
                            }, {
                                children: selectedAccounts.map((account, index)=>(0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                            className: "account"
                                        }, {
                                            children: (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: account.accountId
                                            })
                                        }))
                                    }, account.accountId))
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "action-buttons"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                    className: "middleButton",
                                    onClick: handleSignIn,
                                    disabled: accounts.length === 0
                                }, {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.ledger.finish")
                                }))
                            }))
                        ]
                    }))
                ]
            }))
        ]
    });
};
const $6daeff2c8e1d7f1b$var$WalletNotInstalled = ({ module: module, onBack: onBack, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$BackArrow, {
                        onClick: onBack
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                        title: "",
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "wallet-not-installed-wrapper"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "wallet-data"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: `wallet-icon-box ${module.id}`
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: module.metadata.iconUrl,
                                    alt: module.metadata.name
                                })
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: module.metadata.name
                            })
                        ]
                    })),
                    (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.install.youllNeedToInstall"),
                            " ",
                            module.metadata.name,
                            " ",
                            (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.install.toContinueAfterInstalling"),
                            (0, $7b02d682eb115277$exports.jsxs)("span", Object.assign({
                                className: "refresh-link",
                                onClick: ()=>window.location.reload()
                            }, {
                                children: [
                                    " ",
                                    (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.install.refreshThePage")
                                ]
                            }))
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "action-buttons"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsxs)("button", Object.assign({
                            className: "middleButton",
                            onClick: ()=>{
                                if (module.type !== "injected") return;
                                window.open(module.metadata.downloadUrl, "_blank");
                            }
                        }, {
                            children: [
                                (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.install.open"),
                                " ",
                                module.metadata.name
                            ]
                        }))
                    }))
                ]
            }))
        ]
    });
};
const $6daeff2c8e1d7f1b$var$QRIcon = ()=>(0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: "18",
        height: "16",
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.22224 1.33334H1.44446V6.66668H7.22224V1.33334Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M15.8889 1.33334H10.1111V6.66668H15.8889V1.33334Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.22224 9.33334H1.44446V14.6667H7.22224V9.33334Z",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.1111 13.1429V14.6667H15.8889M10.1111 9.33334V10.8572H12.5873V9.33334H15.8889V12.381",
                stroke: "#4C5155",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "3.61108",
                y: "3.33334",
                width: "1.44444",
                height: "1.33333",
                fill: "#4C5155"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "3.61108",
                y: "11.3333",
                width: "1.44444",
                height: "1.33333",
                fill: "#4C5155"
            }),
            (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "12.2778",
                y: "3.33334",
                width: "1.44445",
                height: "1.33333",
                fill: "#4C5155"
            })
        ]
    }));
const $6daeff2c8e1d7f1b$var$LinkIcon = ()=>(0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: "18",
        height: "16",
        viewBox: "0 0 18 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M13 8.66667V12.6667C13 13.0203 12.8478 13.3594 12.577 13.6095C12.3061 13.8595 11.9387 14 11.5556 14H3.61113C3.22804 14 2.86064 13.8595 2.58975 13.6095C2.31887 13.3594 2.16669 13.0203 2.16669 12.6667V5.33333C2.16669 4.97971 2.31887 4.64057 2.58975 4.39052C2.86064 4.14048 3.22804 4 3.61113 4H7.94447",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M10.8333 2H15.1666V6",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M7.22223 9.33333L15.1667 2",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
const $6daeff2c8e1d7f1b$var$KeyIcon = ()=>(0, $7b02d682eb115277$exports.jsx)("svg", Object.assign({
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M33.5 1.83325L30.1666 5.16658M17.4818 17.8514C19.1406 19.5103 20.1666 21.8019 20.1666 24.3333C20.1666 29.3959 16.0626 33.4999 11 33.4999C5.93735 33.4999 1.8333 29.3959 1.8333 24.3333C1.8333 19.2706 5.93735 15.1666 11 15.1666C13.5313 15.1666 15.8229 16.1926 17.4818 17.8514ZM17.4818 17.8514L24.3333 10.9999M24.3333 10.9999L29.3333 15.9999L35.1666 10.1666L30.1666 5.16658M24.3333 10.9999L30.1666 5.16658",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    }));
const $6daeff2c8e1d7f1b$var$FolderIcon = ()=>(0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: "40",
        height: "41",
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "28.3333",
                cy: "23.8333",
                r: "1.66667",
                fill: "currentColor"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M35 12.1667H7C5.89543 12.1667 5 11.2712 5 10.1667V7.5C5 6.39543 5.89543 5.5 7 5.5H31.6667",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M35 12.1667V35.5H7C5.89543 35.5 5 34.6046 5 33.5V8.83334",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
const $6daeff2c8e1d7f1b$var$WalletHome = ({ selector: selector, onCloseModal: onCloseModal })=>{
    const [modules, setModules] = (0, $acw62.useState)([]);
    const [route, setRoute] = (0, $acw62.useState)("WalletInfo");
    (0, $acw62.useEffect)(()=>{
        const subscription = selector.store.observable.subscribe((state)=>{
            const filterByType = (item)=>{
                return item.type !== "bridge" && item.type !== "hardware" && item.type !== "instant-link";
            };
            const filteredModules = state.modules.filter(filterByType);
            setModules(filteredModules);
        });
        return ()=>subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getWalletUrl = (module)=>{
        let url = "";
        if (module.type === "injected") url = module.metadata.downloadUrl;
        if (module.type === "browser") url = module.metadata.walletUrl;
        return url;
    };
    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
        className: "wallet-home-wrapper"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header-wrapper"
            }, {
                children: [
                    route === "GetWallets" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$BackArrow, {
                        onClick: ()=>{
                            setRoute("WalletInfo");
                        }
                    }),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                        title: route === "GetWallets" ? (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.getAWallet") : (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.whatIsAWallet"),
                        onCloseModal: onCloseModal
                    })
                ]
            })),
            route === "GetWallets" && (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "get-wallet-wrapper"
            }, {
                children: modules.map((module)=>{
                    const { iconUrl: iconUrl, name: name } = module.metadata;
                    const qrIcon = [
                        "nearfi",
                        "here-wallet"
                    ].includes(module.id);
                    const hereWalletType = module.id === "here-wallet" ? "mobile" : "";
                    const walletUrl = getWalletUrl(module);
                    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        tabIndex: 0,
                        className: `single-wallet-get ${module.id}`,
                        onClick: ()=>{
                            if (walletUrl) window.open(walletUrl, "_blank");
                        }
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "small-icon"
                            }, {
                                children: [
                                    qrIcon && walletUrl && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$QRIcon, {}),
                                    !qrIcon && walletUrl && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$LinkIcon, {})
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "icon"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: iconUrl,
                                    alt: name
                                })
                            })),
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "content"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "title"
                                    }, {
                                        children: name
                                    })),
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "type"
                                    }, {
                                        children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)(`modal.walletTypes.${hereWalletType || module.type}`)
                                    }))
                                ]
                            }))
                        ]
                    }), module.id);
                })
            })),
            route === "WalletInfo" && (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "wallet-info-wrapper what-wallet-hide"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "wallet-what"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "icon-side"
                                    }, {
                                        children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$KeyIcon, {})
                                    })),
                                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                        className: "content-side"
                                    }, {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.secureAndManage")
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.safelyStore")
                                            })
                                        ]
                                    }))
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                className: "wallet-what"
                            }, {
                                children: [
                                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                        className: "icon-side"
                                    }, {
                                        children: (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$FolderIcon, {})
                                    })),
                                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                                        className: "content-side"
                                    }, {
                                        children: [
                                            (0, $7b02d682eb115277$exports.jsx)("h3", {
                                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.logInToAny")
                                            }),
                                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.noNeedToCreate")
                                            })
                                        ]
                                    }))
                                ]
                            })),
                            (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "button-spacing"
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                className: "middleButton",
                                onClick: ()=>{
                                    setRoute("GetWallets");
                                }
                            }, {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.getAWallet")
                            }))
                        ]
                    })),
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "what-wallet-mobile"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.useAWallet")
                            }),
                            (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                                className: "middleButton",
                                onClick: ()=>{
                                    setRoute("GetWallets");
                                }
                            }, {
                                children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.getAWallet")
                            }))
                        ]
                    })),
                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "lang-selector-wrapper"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsxs)("select", Object.assign({
                            className: "lang-selector",
                            name: "lang"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("option", Object.assign({
                                    value: "en"
                                }, {
                                    children: "English"
                                })),
                                (0, $7b02d682eb115277$exports.jsx)("option", Object.assign({
                                    value: "es"
                                }, {
                                    children: "Spanish"
                                }))
                            ]
                        }))
                    }))
                ]
            })
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$WalletConnected = ({ module: module, onCloseModal: onCloseModal })=>{
    return (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal-header"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                        className: "middleTitle"
                    }, {
                        children: ``
                    })),
                    (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$CloseButton, {
                        onClick: onCloseModal
                    })
                ]
            })),
            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                className: "connecting-wrapper"
            }, {
                children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                    className: "content"
                }, {
                    children: [
                        (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                            className: "icon"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "green-dot"
                                }),
                                (0, $7b02d682eb115277$exports.jsx)("img", {
                                    src: module === null || module === void 0 ? void 0 : module.metadata.iconUrl,
                                    alt: module === null || module === void 0 ? void 0 : module.metadata.name
                                })
                            ]
                        })),
                        (0, $7b02d682eb115277$exports.jsx)("h3", Object.assign({
                            className: "connecting-name"
                        }, {
                            children: module === null || module === void 0 ? void 0 : module.metadata.name
                        })),
                        (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                            className: "wallet-connected-success"
                        }, {
                            children: [
                                (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ConnectionSuccessIcon, {}),
                                (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectionSuccessful")
                                })
                            ]
                        }))
                    ]
                }))
            }))
        ]
    });
};
var $6daeff2c8e1d7f1b$var$anObject$1 = $6daeff2c8e1d7f1b$var$anObject$c;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $6daeff2c8e1d7f1b$var$regexpFlags = function() {
    var that = $6daeff2c8e1d7f1b$var$anObject$1(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $6daeff2c8e1d7f1b$var$call = $6daeff2c8e1d7f1b$var$functionCall;
var $6daeff2c8e1d7f1b$var$hasOwn = $6daeff2c8e1d7f1b$var$hasOwnProperty_1;
var $6daeff2c8e1d7f1b$var$isPrototypeOf = $6daeff2c8e1d7f1b$var$objectIsPrototypeOf;
var $6daeff2c8e1d7f1b$var$regExpFlags = $6daeff2c8e1d7f1b$var$regexpFlags;
var $6daeff2c8e1d7f1b$var$RegExpPrototype$1 = RegExp.prototype;
var $6daeff2c8e1d7f1b$var$regexpGetFlags = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $6daeff2c8e1d7f1b$var$RegExpPrototype$1) && !$6daeff2c8e1d7f1b$var$hasOwn(R, "flags") && $6daeff2c8e1d7f1b$var$isPrototypeOf($6daeff2c8e1d7f1b$var$RegExpPrototype$1, R) ? $6daeff2c8e1d7f1b$var$call($6daeff2c8e1d7f1b$var$regExpFlags, R) : flags;
};
var $6daeff2c8e1d7f1b$var$PROPER_FUNCTION_NAME = $6daeff2c8e1d7f1b$var$functionName.PROPER;
var $6daeff2c8e1d7f1b$var$defineBuiltIn = $6daeff2c8e1d7f1b$var$defineBuiltIn$6;
var $6daeff2c8e1d7f1b$var$anObject = $6daeff2c8e1d7f1b$var$anObject$c;
var $6daeff2c8e1d7f1b$var$$toString = $6daeff2c8e1d7f1b$var$toString$3;
var $6daeff2c8e1d7f1b$var$fails = $6daeff2c8e1d7f1b$var$fails$h;
var $6daeff2c8e1d7f1b$var$getRegExpFlags = $6daeff2c8e1d7f1b$var$regexpGetFlags;
var $6daeff2c8e1d7f1b$var$TO_STRING = "toString";
var $6daeff2c8e1d7f1b$var$RegExpPrototype = RegExp.prototype;
var $6daeff2c8e1d7f1b$var$n$ToString = $6daeff2c8e1d7f1b$var$RegExpPrototype[$6daeff2c8e1d7f1b$var$TO_STRING];
var $6daeff2c8e1d7f1b$var$NOT_GENERIC = $6daeff2c8e1d7f1b$var$fails(function() {
    return $6daeff2c8e1d7f1b$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $6daeff2c8e1d7f1b$var$INCORRECT_NAME = $6daeff2c8e1d7f1b$var$PROPER_FUNCTION_NAME && $6daeff2c8e1d7f1b$var$n$ToString.name != $6daeff2c8e1d7f1b$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($6daeff2c8e1d7f1b$var$NOT_GENERIC || $6daeff2c8e1d7f1b$var$INCORRECT_NAME) $6daeff2c8e1d7f1b$var$defineBuiltIn(RegExp.prototype, $6daeff2c8e1d7f1b$var$TO_STRING, function toString() {
    var R = $6daeff2c8e1d7f1b$var$anObject(this);
    var pattern = $6daeff2c8e1d7f1b$var$$toString(R.source);
    var flags = $6daeff2c8e1d7f1b$var$$toString($6daeff2c8e1d7f1b$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
const $6daeff2c8e1d7f1b$var$CopyIcon = ()=>(0, $7b02d682eb115277$exports.jsxs)("svg", Object.assign({
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M6.5 15.25a1.75 1.75 0 0 1-1.75-1.75V6.75a2 2 0 0 1 2-2h6.75c.966 0 1.75.784 1.75 1.75",
                stroke: "#4F7CD1",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M8.75 10.75a2 2 0 0 1 2-2h6.5a2 2 0 0 1 2 2v6.5a2 2 0 0 1-2 2h-6.5a2 2 0 0 1-2-2v-6.5Z",
                stroke: "#4F7CD1",
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
function $6daeff2c8e1d7f1b$var$formatQRCodeImage(data) {
    return $6daeff2c8e1d7f1b$var$__awaiter(this, void 0, void 0, function*() {
        return yield (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toString(data, {
            margin: 0,
            type: "svg"
        });
    });
}
const $6daeff2c8e1d7f1b$var$ScanQRCode = ({ wallet: wallet, uri: uri, onCloseModal: onCloseModal, handleOpenDefaultModal: handleOpenDefaultModal })=>{
    const [notification, setNotification] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const [svg, setSvg] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("");
    const copyToClipboard = ()=>{
        if (!uri) return;
        const success = (0, (/*@__PURE__*/$parcel$interopDefault($e5a78797c4262d1f$exports)))(uri);
        if (success) {
            setNotification((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.copiedToClipboard"));
            setTimeout(()=>setNotification(""), 1200);
        } else {
            setNotification((0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.failedToCopy"));
            setTimeout(()=>setNotification(""), 1200);
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        (()=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
                if (uri) setSvg((yield $6daeff2c8e1d7f1b$var$formatQRCodeImage(uri)));
            }))();
    }, [
        uri
    ]);
    return (0, $7b02d682eb115277$exports.jsxs)("section", Object.assign({
        className: "scan-qr-code"
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ModalHeader, {
                title: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.scanWithYourMobile"),
                onCloseModal: onCloseModal
            }),
            (0, $7b02d682eb115277$exports.jsxs)("section", Object.assign({
                className: "qr-code"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: svg
                        }
                    }),
                    notification ? (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "notification"
                    }, {
                        children: notification
                    })) : (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "copy-btn",
                        onClick: copyToClipboard
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$CopyIcon, {}),
                            (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.copyToClipboard")
                        ]
                    }))
                ]
            })),
            (0, $7b02d682eb115277$exports.jsxs)("footer", Object.assign({
                className: "footer"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("p", {
                        children: [
                            (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.preferTheOfficial"),
                            " ",
                            wallet.metadata.name,
                            "?"
                        ]
                    }),
                    (0, $7b02d682eb115277$exports.jsx)("button", Object.assign({
                        className: "btn",
                        onClick: handleOpenDefaultModal
                    }, {
                        children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.qr.open")
                    }))
                ]
            }))
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$getThemeClass = (theme)=>{
    switch(theme){
        case "dark":
            return "dark-theme";
        case "light":
            return "light-theme";
        default:
            return "";
    }
};
const $6daeff2c8e1d7f1b$var$Modal = ({ selector: selector, options: options, visible: visible, hide: hide, emitter: emitter })=>{
    var _a, _b, _c;
    const [route, setRoute] = (0, $acw62.useState)({
        name: "WalletHome"
    });
    const [alertMessage, setAlertMessage] = (0, $acw62.useState)(null);
    const [selectedWallet, setSelectedWallet] = (0, $acw62.useState)();
    const [bridgeWalletUri, setBridgeWalletUri] = (0, $acw62.useState)();
    (0, $acw62.useEffect)(()=>{
        setRoute({
            name: "WalletHome"
        });
        (0, $5bb7220e37bd460f$export$b162ef060a488de1)(selector.options.languageCode);
        const { selectedWalletId: selectedWalletId, modules: modules } = selector.store.getState();
        if (selectedWalletId) {
            const module = modules.find((m)=>m.id === selectedWalletId);
            setSelectedWallet(module);
            setRoute({
                name: "WalletConnected",
                params: {
                    module: module
                }
            });
        }
        setBridgeWalletUri("");
    // eslint-disable-next-line
    }, [
        visible
    ]);
    (0, $acw62.useEffect)(()=>{
        const subscription = selector.on("networkChanged", ({ networkId: networkId })=>{
            // Switched back to the correct network.
            if (networkId === selector.options.network.networkId) return handleDismissClick({});
            setRoute({
                name: "WalletNetworkChanged"
            });
        });
        return ()=>subscription.remove();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleDismissClick = (0, $acw62.useCallback)(({ hideReason: hideReason })=>{
        setAlertMessage(null);
        setRoute({
            name: "WalletHome"
        });
        if (hideReason === "user-triggered") emitter.emit("onHide", {
            hideReason: hideReason
        });
        if (hideReason === "wallet-navigation") emitter.emit("onHide", {
            hideReason: hideReason
        });
        hide();
    }, [
        hide,
        emitter
    ]);
    (0, $acw62.useEffect)(()=>{
        const close = (e)=>{
            if (e.key === "Escape") handleDismissClick({
                hideReason: "user-triggered"
            });
        };
        window.addEventListener("keydown", close);
        return ()=>window.removeEventListener("keydown", close);
    }, [
        handleDismissClick
    ]);
    const handleWalletClick = (module, qrCodeModal)=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            setSelectedWallet(module);
            const { selectedWalletId: selectedWalletId } = selector.store.getState();
            if (selectedWalletId === module.id) {
                setRoute({
                    name: "WalletConnected",
                    params: {
                        module: module
                    }
                });
                return;
            }
            try {
                const { deprecated: deprecated, available: available } = module.metadata;
                if (module.type === "injected" && !available) {
                    setRoute({
                        name: "WalletNotInstalled",
                        params: {
                            module: module
                        }
                    });
                    return;
                }
                const wallet = yield module.wallet();
                if (deprecated) {
                    setAlertMessage(`${module.metadata.name} is deprecated. Please select another wallet.`);
                    setRoute({
                        name: "AlertMessage",
                        params: {
                            module: module
                        }
                    });
                    return;
                }
                if (wallet.type === "hardware") {
                    setRoute({
                        name: "DerivationPath",
                        params: {
                            walletId: wallet.id || "ledger"
                        }
                    });
                    return;
                }
                setRoute({
                    name: "WalletConnecting",
                    params: {
                        wallet: wallet
                    }
                });
                if (wallet.type === "bridge") {
                    const subscription = selector.on("uriChanged", ({ uri: uri })=>{
                        setBridgeWalletUri(uri);
                        setRoute({
                            name: "ScanQRCode",
                            params: {
                                uri: uri,
                                wallet: wallet
                            }
                        });
                    });
                    yield wallet.signIn({
                        contractId: options.contractId,
                        methodNames: options.methodNames,
                        qrCodeModal: qrCodeModal
                    });
                    subscription.remove();
                    handleDismissClick({
                        hideReason: "wallet-navigation"
                    });
                    return;
                }
                if (wallet.type === "browser") {
                    yield wallet.signIn({
                        contractId: options.contractId,
                        methodNames: options.methodNames,
                        successUrl: wallet.metadata.successUrl,
                        failureUrl: wallet.metadata.failureUrl
                    });
                    handleDismissClick({
                        hideReason: "wallet-navigation"
                    });
                    return;
                }
                yield wallet.signIn({
                    contractId: options.contractId,
                    methodNames: options.methodNames
                });
                handleDismissClick({
                    hideReason: "wallet-navigation"
                });
            } catch (err) {
                const { name: name } = module.metadata;
                const message = err && typeof err === "object" && "message" in err ? err.message : "Something went wrong";
                setAlertMessage(`Failed to sign in with ${name}: ${message}`);
                setRoute({
                    name: "AlertMessage",
                    params: {
                        module: module
                    }
                });
            }
        });
    if (!visible) return null;
    return (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
        className: `nws-modal-wrapper ${$6daeff2c8e1d7f1b$var$getThemeClass(options === null || options === void 0 ? void 0 : options.theme)} ${visible ? "open" : ""}`
    }, {
        children: [
            (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "nws-modal-overlay",
                onClick: ()=>{
                    handleDismissClick({
                        hideReason: "user-triggered"
                    });
                }
            }),
            (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                className: "nws-modal"
            }, {
                children: [
                    (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                        className: "modal-left"
                    }, {
                        children: [
                            (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                                className: "modal-left-title"
                            }, {
                                children: (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    children: (0, $5bb7220e37bd460f$export$d73ee8ef04f5226a)("modal.wallet.connectYourWallet")
                                })
                            })),
                            (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletOptions, {
                                handleWalletClick: (module)=>{
                                    handleWalletClick(module, false);
                                },
                                selector: selector
                            })
                        ]
                    })),
                    (0, $7b02d682eb115277$exports.jsx)("div", Object.assign({
                        className: "modal-right"
                    }, {
                        children: (0, $7b02d682eb115277$exports.jsxs)("div", Object.assign({
                            className: "nws-modal-body"
                        }, {
                            children: [
                                route.name === "AlertMessage" && alertMessage && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$AlertMessage, {
                                    message: alertMessage,
                                    module: (_a = route.params) === null || _a === void 0 ? void 0 : _a.module,
                                    onBack: (retry)=>{
                                        if (retry) handleWalletClick(selectedWallet, false);
                                        setAlertMessage(null);
                                        setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "DerivationPath" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$DerivationPath, {
                                    selector: selector,
                                    options: options,
                                    onConnected: ()=>{
                                        handleDismissClick({
                                            hideReason: "wallet-navigation"
                                        });
                                    },
                                    params: route.params,
                                    onBack: ()=>setRoute({
                                            name: "WalletHome"
                                        }),
                                    onError: (message, wallet)=>{
                                        const { modules: modules } = selector.store.getState();
                                        const findModule = modules.find((module)=>module.id === wallet.id);
                                        setAlertMessage(message);
                                        setRoute({
                                            name: "AlertMessage",
                                            params: {
                                                module: findModule
                                            }
                                        });
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletNetworkChanged" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletNetworkChanged, {
                                    selector: selector,
                                    onBack: ()=>setRoute({
                                            name: "WalletHome"
                                        }),
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletNotInstalled" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletNotInstalled, {
                                    module: (_b = route.params) === null || _b === void 0 ? void 0 : _b.module,
                                    onBack: ()=>{
                                        setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletConnecting" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletConnecting, {
                                    wallet: (_c = route.params) === null || _c === void 0 ? void 0 : _c.wallet,
                                    onBack: ()=>{
                                        setRoute({
                                            name: "WalletHome"
                                        });
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletHome" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletHome, {
                                    selector: selector,
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "WalletConnected" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$WalletConnected, {
                                    module: selectedWallet,
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        })
                                }),
                                route.name === "ScanQRCode" && (0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$ScanQRCode, {
                                    handleOpenDefaultModal: ()=>{
                                        handleWalletClick(selectedWallet, true);
                                    },
                                    onCloseModal: ()=>handleDismissClick({
                                            hideReason: "user-triggered"
                                        }),
                                    uri: bridgeWalletUri,
                                    wallet: selectedWallet
                                })
                            ]
                        }))
                    }))
                ]
            }))
        ]
    }));
};
const $6daeff2c8e1d7f1b$var$MODAL_ELEMENT_ID = "near-wallet-selector-modal";
let $6daeff2c8e1d7f1b$var$modalInstance = null;
let $6daeff2c8e1d7f1b$var$root = null;
/**
 * Initiates a modal instance
 * @param {WalletSelector} selector Selector
 * @param {ModalOptions} options Modal options
 * @returns {WalletSelectorModal} Returns a WalletSelectorModal object
 */ const $6daeff2c8e1d7f1b$export$60f0f9f4cfa9469a = (selector, options)=>{
    if (!$6daeff2c8e1d7f1b$var$root) {
        const body = document.body;
        const container = document.createElement("div");
        container.id = $6daeff2c8e1d7f1b$var$MODAL_ELEMENT_ID;
        body.appendChild(container);
        $6daeff2c8e1d7f1b$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(container);
    }
    const emitter = new (0, $5bb7220e37bd460f$export$4fae95256245c8c0)();
    selector.store.getState().modules.forEach((module)=>$6daeff2c8e1d7f1b$var$__awaiter(void 0, void 0, void 0, function*() {
            if ("topLevelInjected" in module.metadata) {
                if (!module.metadata.topLevelInjected) return;
                const wallet = yield module.wallet();
                if (wallet.type !== "injected") return;
                yield wallet.signIn({
                    contractId: options.contractId,
                    methodNames: options.methodNames
                });
            }
        }));
    const render = (visible = false)=>{
        $6daeff2c8e1d7f1b$var$root.render((0, $7b02d682eb115277$exports.jsx)($6daeff2c8e1d7f1b$var$Modal, {
            selector: selector,
            options: options,
            visible: visible,
            hide: ()=>render(false),
            emitter: emitter
        }));
    };
    if (!$6daeff2c8e1d7f1b$var$modalInstance) $6daeff2c8e1d7f1b$var$modalInstance = {
        show: ()=>{
            render(true);
        },
        hide: ()=>{
            render(false);
        },
        on: (eventName, callback)=>{
            return emitter.on(eventName, callback);
        },
        off: (eventName, callback)=>{
            emitter.off(eventName, callback);
        }
    };
    return $6daeff2c8e1d7f1b$var$modalInstance;
};



var $329a9076209dab3d$exports = {};
"use strict";
var $329a9076209dab3d$var$__createBinding = $329a9076209dab3d$exports && $329a9076209dab3d$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $329a9076209dab3d$var$__exportStar = $329a9076209dab3d$exports && $329a9076209dab3d$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $329a9076209dab3d$var$__createBinding(exports1, m, p);
};
Object.defineProperty($329a9076209dab3d$exports, "__esModule", {
    value: true
});
$329a9076209dab3d$exports.HereWallet = void 0;
var $c8b0ca89f2e01a6d$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $c8b0ca89f2e01a6d$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $c8b0ca89f2e01a6d$var$__awaiter = $c8b0ca89f2e01a6d$exports && $c8b0ca89f2e01a6d$exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c8b0ca89f2e01a6d$var$__rest = $c8b0ca89f2e01a6d$exports && $c8b0ca89f2e01a6d$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c8b0ca89f2e01a6d$var$__importDefault = $c8b0ca89f2e01a6d$exports && $c8b0ca89f2e01a6d$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($c8b0ca89f2e01a6d$exports, "__esModule", {
    value: true
});
$c8b0ca89f2e01a6d$exports.HereWallet = void 0;

var $k4rlt = parcelRequire("k4rlt");

var $2EqIG = parcelRequire("2EqIG");

var $lsY0f = parcelRequire("lsY0f");

var $fBCU1 = parcelRequire("fBCU1");

var $5UUfm = parcelRequire("5UUfm");

const $c8b0ca89f2e01a6d$var$bn_js_1 = $c8b0ca89f2e01a6d$var$__importDefault((parcelRequire("dEXSZ")));

var $gyf5Z = parcelRequire("gyf5Z");

var $c0EFx = parcelRequire("c0EFx");

var $aQl1z = parcelRequire("aQl1z");

var $80Uyb = parcelRequire("80Uyb");

var $kxtkJ = parcelRequire("kxtkJ");

var $d9LjM = parcelRequire("d9LjM");
var $a29a76be9c02ac1b$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $a29a76be9c02ac1b$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $a29a76be9c02ac1b$var$__createBinding = $a29a76be9c02ac1b$exports && $a29a76be9c02ac1b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a29a76be9c02ac1b$var$__setModuleDefault = $a29a76be9c02ac1b$exports && $a29a76be9c02ac1b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a29a76be9c02ac1b$var$__importStar = $a29a76be9c02ac1b$exports && $a29a76be9c02ac1b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a29a76be9c02ac1b$var$__createBinding(result, mod, k);
    }
    $a29a76be9c02ac1b$var$__setModuleDefault(result, mod);
    return result;
};
var $a29a76be9c02ac1b$var$__importDefault = $a29a76be9c02ac1b$exports && $a29a76be9c02ac1b$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($a29a76be9c02ac1b$exports, "__esModule", {
    value: true
});
$a29a76be9c02ac1b$exports.verifySignature = $a29a76be9c02ac1b$exports.authPayloadSchema = $a29a76be9c02ac1b$exports.AuthPayload = void 0;

const $a29a76be9c02ac1b$var$borsh = $a29a76be9c02ac1b$var$__importStar((parcelRequire("7U40k")));

const $a29a76be9c02ac1b$var$js_sha256_1 = $a29a76be9c02ac1b$var$__importDefault((parcelRequire("fBCU1")));

var $gphuu = parcelRequire("gphuu");
class $a29a76be9c02ac1b$var$AuthPayload {
    constructor({ message: message, nonce: nonce, recipient: recipient, callbackUrl: callbackUrl }){
        this.tag = 2147484061;
        this.message = message;
        this.nonce = nonce;
        this.recipient = recipient;
        if (callbackUrl) this.callbackUrl = callbackUrl;
    }
}
$a29a76be9c02ac1b$exports.AuthPayload = $a29a76be9c02ac1b$var$AuthPayload;
$a29a76be9c02ac1b$exports.authPayloadSchema = {
    struct: {
        tag: "u32",
        message: "string",
        nonce: {
            array: {
                type: "u8",
                len: 32
            }
        },
        recipient: "string",
        callbackUrl: {
            option: "string"
        }
    }
};
function $a29a76be9c02ac1b$var$verifySignature(request, result) {
    // Reconstruct the payload that was **actually signed**
    const payload = new $a29a76be9c02ac1b$var$AuthPayload(request);
    const borsh_payload = $a29a76be9c02ac1b$var$borsh.serialize($a29a76be9c02ac1b$exports.authPayloadSchema, payload);
    const to_sign = Uint8Array.from($a29a76be9c02ac1b$var$js_sha256_1.default.sha256.array(borsh_payload));
    // Reconstruct the signature from the parameter given in the URL
    let real_signature = new Uint8Array($a29a76be9c02ac1b$require$Buffer.from(result.signature, "base64"));
    // Use the public Key to verify that the private-counterpart signed the message
    const myPK = $gphuu.PublicKey.from(result.publicKey);
    return myPK.verify(to_sign, real_signature);
}
$a29a76be9c02ac1b$exports.verifySignature = $a29a76be9c02ac1b$var$verifySignature;


class $c8b0ca89f2e01a6d$var$AccessDenied extends Error {
}
class $c8b0ca89f2e01a6d$var$HereWallet {
    constructor({ nodeUrl: nodeUrl, networkId: networkId = "mainnet", authStorage: authStorage = new $gyf5Z.HereKeyStore(), defaultStrategy: defaultStrategy = ()=>new $d9LjM.WidgetStrategy(), defaultProvider: defaultProvider = $80Uyb.proxyProvider } = {}){
        this.authStorage = authStorage;
        this.defaultProvider = defaultProvider;
        this.defaultStrategy = defaultStrategy;
        const signer = new $k4rlt.InMemorySigner(this.authStorage);
        const rpc = new $2EqIG.JsonRpcProvider({
            url: nodeUrl !== null && nodeUrl !== void 0 ? nodeUrl : `https://rpc.${networkId}.near.org`
        });
        this.connection = $k4rlt.Connection.fromConfig({
            jsvmAccountId: `jsvm.${networkId}`,
            provider: rpc,
            networkId: networkId,
            signer: signer
        });
    }
    get rpc() {
        return this.connection.provider;
    }
    get signer() {
        return this.connection.signer;
    }
    get networkId() {
        return this.connection.networkId;
    }
    account(id) {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const accountId = id !== null && id !== void 0 ? id : yield this.authStorage.getActiveAccount(this.networkId);
            if (accountId == null) throw new $c8b0ca89f2e01a6d$var$AccessDenied("Wallet not signed in");
            return new $k4rlt.Account(this.connection, accountId);
        });
    }
    isSignedIn() {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const id = yield this.authStorage.getActiveAccount(this.networkId);
            return id != null;
        });
    }
    signOut() {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const accountId = yield this.authStorage.getActiveAccount(this.networkId);
            if (accountId == null) throw new Error("Wallet not signed in");
            const key = yield this.authStorage.getKey(this.networkId, accountId);
            if (key != null) {
                const publicKey = key.getPublicKey().toString();
                yield this.silentSignAndSendTransaction({
                    receiverId: accountId,
                    actions: [
                        {
                            type: "DeleteKey",
                            params: {
                                publicKey: publicKey
                            }
                        }
                    ]
                }).catch(()=>{});
            }
            yield this.authStorage.removeKey(this.networkId, accountId);
        });
    }
    getHereBalance(id) {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const account = yield this.account(id);
            const contractId = this.networkId === "mainnet" ? "here.storage.near" : "here.storage.testnet";
            const hereCoins = yield account.viewFunction({
                args: {
                    account_id: account.accountId
                },
                methodName: "ft_balance_of",
                contractId: contractId
            }).catch(()=>"0");
            return new $c8b0ca89f2e01a6d$var$bn_js_1.default(hereCoins);
        });
    }
    getAvailableBalance(id) {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const account = yield this.account(id);
            const result = yield account.getAccountBalance();
            const hereBalance = yield this.getHereBalance();
            return new $c8b0ca89f2e01a6d$var$bn_js_1.default(result.available).add(new $c8b0ca89f2e01a6d$var$bn_js_1.default(hereBalance));
        });
    }
    getAccounts() {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.authStorage.getAccounts(this.networkId);
        });
    }
    getAccountId() {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const accountId = yield this.authStorage.getActiveAccount(this.networkId);
            if (accountId == null) throw new Error("Wallet not signed in");
            return accountId;
        });
    }
    switchAccount(id) {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const key = yield this.authStorage.getKey(this.networkId, id);
            if (key == null) throw new Error(`Account ${id} not signed in`);
            yield this.authStorage.setActiveAccount(this.networkId, id);
        });
    }
    signIn(_a = {}) {
        var _b, _c, _d, _e, _f;
        var { contractId: contractId, allowance: allowance, methodNames: methodNames = [], selector: selector } = _a, delegate = $c8b0ca89f2e01a6d$var$__rest(_a, [
            "contractId",
            "allowance",
            "methodNames",
            "selector"
        ]);
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            if (contractId == null) {
                const { accountId: accountId } = yield this.authenticate(delegate);
                // Generate random keypair
                yield this.authStorage.setKey(this.networkId, accountId, $lsY0f.KeyPairEd25519.fromRandom());
                yield this.authStorage.setActiveAccount(this.networkId, accountId);
                return accountId;
            }
            delegate.strategy = (_b = delegate.strategy) !== null && _b !== void 0 ? _b : this.defaultStrategy();
            delegate.provider = (_c = delegate.provider) !== null && _c !== void 0 ? _c : this.defaultProvider;
            (_d = delegate.onInitialized) === null || _d === void 0 || _d.call(delegate);
            (_f = (_e = delegate.strategy) === null || _e === void 0 ? void 0 : _e.onInitialized) === null || _f === void 0 || _f.call(_e);
            try {
                const accessKey = $k4rlt.KeyPair.fromRandom("ed25519");
                const permission = {
                    receiverId: contractId,
                    methodNames: methodNames,
                    allowance: allowance
                };
                const data = yield delegate.provider(Object.assign(Object.assign({}, delegate), {
                    request: {
                        type: "call",
                        network: this.networkId,
                        selector: selector || {},
                        transactions: [
                            {
                                actions: [
                                    {
                                        type: "AddKey",
                                        params: {
                                            publicKey: accessKey.getPublicKey().toString(),
                                            accessKey: {
                                                permission: permission
                                            }
                                        }
                                    }
                                ]
                            }
                        ]
                    }
                }));
                if (data.account_id == null) throw Error("Transaction is failed");
                yield this.authStorage.setKey(this.networkId, data.account_id, accessKey);
                yield this.authStorage.setActiveAccount(this.networkId, data.account_id);
                return data.account_id;
            } catch (error) {
                (0, $aQl1z.internalThrow)(error, delegate);
                throw error;
            }
        });
    }
    silentSignAndSendTransaction({ actions: actions, receiverId: receiverId, signerId: signerId }) {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const account = yield this.account(signerId);
            const localKey = yield this.authStorage.getKey(this.networkId, account.accountId).catch(()=>null);
            if (localKey == null) throw new $c8b0ca89f2e01a6d$var$AccessDenied();
            const publicKey = localKey.getPublicKey();
            const accessKeys = yield account.getAccessKeys();
            const call = {
                receiverId: receiverId,
                actions: actions
            };
            const isValid = accessKeys.some((v)=>{
                if (v.public_key !== publicKey.toString()) return false;
                return (0, $aQl1z.isValidAccessKey)(account.accountId, v, call);
            });
            if (isValid === false) throw new $c8b0ca89f2e01a6d$var$AccessDenied();
            return yield account.signAndSendTransaction({
                actions: actions.map((a)=>(0, $kxtkJ.createAction)(a)),
                receiverId: receiverId !== null && receiverId !== void 0 ? receiverId : account.accountId
            });
        });
    }
    signAndSendTransaction(opts) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const { signerId: signerId, receiverId: receiverId, actions: actions } = opts, args = $c8b0ca89f2e01a6d$var$__rest(opts, [
                "signerId",
                "receiverId",
                "actions"
            ]);
            const delegate = args;
            delegate.strategy = (_a = delegate.strategy) !== null && _a !== void 0 ? _a : this.defaultStrategy();
            delegate.provider = (_b = delegate.provider) !== null && _b !== void 0 ? _b : this.defaultProvider;
            (_c = delegate.onInitialized) === null || _c === void 0 || _c.call(delegate);
            (_e = (_d = delegate.strategy) === null || _d === void 0 ? void 0 : _d.onInitialized) === null || _e === void 0 || _e.call(_d);
            try {
                const result = yield this.silentSignAndSendTransaction({
                    receiverId: receiverId,
                    actions: actions,
                    signerId: signerId
                });
                const success = {
                    type: "local",
                    status: $c0EFx.HereProviderStatus.SUCCESS,
                    payload: result === null || result === void 0 ? void 0 : result.transaction_outcome.id
                };
                (_f = delegate.onSuccess) === null || _f === void 0 || _f.call(delegate, success);
                (_h = (_g = delegate.strategy) === null || _g === void 0 ? void 0 : _g.onSuccess) === null || _h === void 0 || _h.call(_g, success);
                return result;
            } catch (e) {
                try {
                    // If silent sign return AccessDenied or NotEnoughAllowance we request mobile wallet
                    // OR its just transaction error
                    if (!(e instanceof $c8b0ca89f2e01a6d$var$AccessDenied) && (e === null || e === void 0 ? void 0 : e.type) !== "NotEnoughAllowance") {
                        (0, $aQl1z.internalThrow)(e, delegate);
                        throw e;
                    }
                    const activeAccount = yield this.getAccountId().catch(()=>undefined);
                    const data = yield delegate.provider(Object.assign(Object.assign({}, delegate), {
                        request: {
                            type: "call",
                            network: this.networkId,
                            transactions: [
                                {
                                    actions: (0, $aQl1z.serializeActions)(actions),
                                    receiverId: receiverId,
                                    signerId: signerId
                                }
                            ],
                            selector: opts.selector || {
                                id: signerId || activeAccount
                            }
                        }
                    }));
                    if (data.payload == null || data.account_id == null) throw Error("Transaction not found, but maybe executed");
                    return yield this.rpc.txStatus(data.payload, data.account_id);
                } catch (error) {
                    (0, $aQl1z.internalThrow)(error, delegate);
                    throw error;
                }
            }
        });
    }
    verifyMessageNEP0413(request, result) {
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const isSignatureValid = (0, $a29a76be9c02ac1b$exports.verifySignature)(request, result);
            if (!isSignatureValid) throw Error("Incorrect signature");
            const account = yield this.account(result.accountId);
            const keys = yield account.getAccessKeys();
            const isFullAccess = keys.some((k)=>{
                if (k.public_key !== result.publicKey) return false;
                if (k.access_key.permission !== "FullAccess") return false;
                return true;
            });
            if (!isFullAccess) throw Error("Signer public key is not full access");
            return true;
        });
    }
    authenticate(options = {}) {
        var _a, _b, _c;
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            const signRequest = {
                nonce: (_a = options.nonce) !== null && _a !== void 0 ? _a : (0, $5UUfm.randomBytes)(32),
                recipient: (_b = options.recipient) !== null && _b !== void 0 ? _b : window.location.host,
                message: (_c = options.message) !== null && _c !== void 0 ? _c : "Authenticate"
            };
            const signed = yield this.signMessage(Object.assign(Object.assign({}, signRequest), options));
            yield this.verifyMessageNEP0413(signRequest, signed);
            return signed;
        });
    }
    signMessage(options) {
        var _a, _b, _c, _d, _e;
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            options.strategy = (_a = options.strategy) !== null && _a !== void 0 ? _a : this.defaultStrategy();
            options.provider = (_b = options.provider) !== null && _b !== void 0 ? _b : this.defaultProvider;
            (_c = options.onInitialized) === null || _c === void 0 || _c.call(options);
            (_e = (_d = options.strategy) === null || _d === void 0 ? void 0 : _d.onInitialized) === null || _e === void 0 || _e.call(_d);
            // Legacy format with receiver property, does not correspond to the current version of the standard
            if ("receiver" in options) return yield this.legacySignMessage(options);
            const activeAccount = yield this.getAccountId().catch(()=>undefined);
            const data = yield options.provider(Object.assign(Object.assign({}, options), {
                request: {
                    type: "sign",
                    message: options.message,
                    recipient: options.recipient,
                    nonce: Array.from(options.nonce),
                    network: this.networkId,
                    selector: options.selector || {
                        id: activeAccount
                    }
                }
            }));
            if ((data === null || data === void 0 ? void 0 : data.payload) == null) throw Error("Signature not found");
            const { publicKey: publicKey, signature: signature, accountId: accountId } = JSON.parse(data.payload);
            return {
                publicKey: publicKey,
                signature: signature,
                accountId: accountId
            };
        });
    }
    legacySignMessage(_a) {
        var _b;
        var { message: message, receiver: receiver, nonce: nonce, selector: selector } = _a, delegate = $c8b0ca89f2e01a6d$var$__rest(_a, [
            "message",
            "receiver",
            "nonce",
            "selector"
        ]);
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            if (nonce == null) {
                let nonceArray = new Uint8Array(32);
                nonce = [
                    ...crypto.getRandomValues(nonceArray)
                ];
            }
            const activeAccount = yield this.getAccountId().catch(()=>undefined);
            const data = yield (_b = delegate.provider) === null || _b === void 0 ? void 0 : _b.call(delegate, Object.assign(Object.assign({}, delegate), {
                request: {
                    type: "sign",
                    network: this.networkId,
                    selector: selector || {
                        id: activeAccount
                    },
                    message: message,
                    receiver: receiver,
                    nonce: nonce
                }
            }));
            if ((data === null || data === void 0 ? void 0 : data.payload) == null) throw Error("Signature not found");
            try {
                const { publicKey: publicKey, signature: signature, accountId: accountId } = JSON.parse(data.payload);
                const sign = new Uint8Array($c8b0ca89f2e01a6d$require$Buffer.from(signature, "base64"));
                const json = JSON.stringify({
                    message: message,
                    receiver: receiver,
                    nonce: nonce
                });
                const msg = new Uint8Array($fBCU1.sha256.digest(`NEP0413:` + json));
                const isVerify = $lsY0f.PublicKey.from(publicKey).verify(msg, sign);
                if (isVerify === false) throw Error();
                const account = yield this.account(accountId);
                const keys = yield account.getAccessKeys();
                const pb = publicKey.toString();
                const isValid = keys.some((k)=>{
                    if (k.public_key !== pb) return false;
                    if (k.access_key.permission !== "FullAccess") return false;
                    return true;
                });
                if (isValid === false) throw Error();
                return {
                    signature: new Uint8Array($c8b0ca89f2e01a6d$require$Buffer.from(signature, "base64")),
                    publicKey: $lsY0f.PublicKey.from(publicKey),
                    message: `NEP0413:` + json,
                    receiver: receiver,
                    accountId: accountId,
                    nonce: nonce
                };
            } catch (_c) {
                throw Error("Signature not correct");
            }
        });
    }
    signAndSendTransactions(_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j;
        var { transactions: transactions, selector: selector } = _a, delegate = $c8b0ca89f2e01a6d$var$__rest(_a, [
            "transactions",
            "selector"
        ]);
        return $c8b0ca89f2e01a6d$var$__awaiter(this, void 0, void 0, function*() {
            delegate.strategy = (_b = delegate.strategy) !== null && _b !== void 0 ? _b : this.defaultStrategy();
            delegate.provider = (_c = delegate.provider) !== null && _c !== void 0 ? _c : this.defaultProvider;
            (_d = delegate.onInitialized) === null || _d === void 0 || _d.call(delegate);
            (_f = (_e = delegate.strategy) === null || _e === void 0 ? void 0 : _e.onInitialized) === null || _f === void 0 || _f.call(_e);
            let results = [];
            try {
                for (const call of transactions){
                    const r = yield this.silentSignAndSendTransaction(call);
                    results.push(r);
                }
                const payload = results.map((result)=>result.transaction_outcome.id).join(",");
                const success = {
                    type: "local",
                    status: $c0EFx.HereProviderStatus.SUCCESS,
                    payload: payload
                };
                (_g = delegate.onSuccess) === null || _g === void 0 || _g.call(delegate, success);
                (_j = (_h = delegate.strategy) === null || _h === void 0 ? void 0 : _h.onSuccess) === null || _j === void 0 || _j.call(_h, success);
                return results;
            } catch (e) {
                try {
                    // If silent sign return access denied or not enough balance we request mobile wallet
                    // OR its just transaction error
                    if (!(e instanceof $c8b0ca89f2e01a6d$var$AccessDenied) && (e === null || e === void 0 ? void 0 : e.type) !== "NotEnoughAllowance") {
                        (0, $aQl1z.internalThrow)(e, delegate);
                        throw e;
                    }
                    const activeAccount = yield this.getAccountId().catch(()=>undefined);
                    const uncompleted = transactions.slice(results.length);
                    const data = yield delegate.provider(Object.assign(Object.assign({}, delegate), {
                        request: {
                            type: "call",
                            network: this.networkId,
                            selector: selector || {
                                id: uncompleted[0].signerId || activeAccount
                            },
                            transactions: uncompleted.map((trx)=>Object.assign(Object.assign({}, trx), {
                                    actions: (0, $aQl1z.serializeActions)(trx.actions)
                                }))
                        }
                    }));
                    if (data.payload == null || data.account_id == null) throw Error("Transaction not found, but maybe executed");
                    const promises = data.payload.split(",").map((id)=>this.rpc.txStatus(id, data.account_id));
                    return yield Promise.all(promises);
                } catch (error) {
                    (0, $aQl1z.internalThrow)(error, delegate);
                    throw error;
                }
            }
        });
    }
}
$c8b0ca89f2e01a6d$exports.HereWallet = $c8b0ca89f2e01a6d$var$HereWallet;


Object.defineProperty($329a9076209dab3d$exports, "HereWallet", {
    enumerable: true,
    get: function() {
        return $c8b0ca89f2e01a6d$exports.HereWallet;
    }
});

$329a9076209dab3d$var$__exportStar((parcelRequire("kxtkJ")), $329a9076209dab3d$exports);

$329a9076209dab3d$var$__exportStar((parcelRequire("gyf5Z")), $329a9076209dab3d$exports);

$329a9076209dab3d$var$__exportStar((parcelRequire("fHqIu")), $329a9076209dab3d$exports);

$329a9076209dab3d$var$__exportStar((parcelRequire("53WOC")), $329a9076209dab3d$exports);

$329a9076209dab3d$var$__exportStar((parcelRequire("d9LjM")), $329a9076209dab3d$exports);

$329a9076209dab3d$var$__exportStar((parcelRequire("1OggS")), $329a9076209dab3d$exports);

$329a9076209dab3d$var$__exportStar((parcelRequire("c0EFx")), $329a9076209dab3d$exports);

$329a9076209dab3d$var$__exportStar((parcelRequire("kvy29")), $329a9076209dab3d$exports);

$329a9076209dab3d$var$__exportStar((parcelRequire("aQl1z")), $329a9076209dab3d$exports);

$329a9076209dab3d$var$__exportStar((parcelRequire("80Uyb")), $329a9076209dab3d$exports);


var $3b33b5b5cc18ae8d$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $3b33b5b5cc18ae8d$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $3b33b5b5cc18ae8d$var$global$a = // eslint-disable-next-line es-x/no-global-this -- safe
$3b33b5b5cc18ae8d$var$check(typeof globalThis == "object" && globalThis) || $3b33b5b5cc18ae8d$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$3b33b5b5cc18ae8d$var$check(typeof self == "object" && self) || $3b33b5b5cc18ae8d$var$check(typeof $3b33b5b5cc18ae8d$var$commonjsGlobal == "object" && $3b33b5b5cc18ae8d$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $3b33b5b5cc18ae8d$var$objectGetOwnPropertyDescriptor = {};
var $3b33b5b5cc18ae8d$var$fails$a = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $3b33b5b5cc18ae8d$var$fails$9 = $3b33b5b5cc18ae8d$var$fails$a;
// Detect IE8's incomplete defineProperty implementation
var $3b33b5b5cc18ae8d$var$descriptors = !$3b33b5b5cc18ae8d$var$fails$9(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $3b33b5b5cc18ae8d$var$fails$8 = $3b33b5b5cc18ae8d$var$fails$a;
var $3b33b5b5cc18ae8d$var$functionBindNative = !$3b33b5b5cc18ae8d$var$fails$8(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $3b33b5b5cc18ae8d$var$NATIVE_BIND$1 = $3b33b5b5cc18ae8d$var$functionBindNative;
var $3b33b5b5cc18ae8d$var$call$6 = Function.prototype.call;
var $3b33b5b5cc18ae8d$var$functionCall = $3b33b5b5cc18ae8d$var$NATIVE_BIND$1 ? $3b33b5b5cc18ae8d$var$call$6.bind($3b33b5b5cc18ae8d$var$call$6) : function() {
    return $3b33b5b5cc18ae8d$var$call$6.apply($3b33b5b5cc18ae8d$var$call$6, arguments);
};
var $3b33b5b5cc18ae8d$var$objectPropertyIsEnumerable = {};
var $3b33b5b5cc18ae8d$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $3b33b5b5cc18ae8d$var$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $3b33b5b5cc18ae8d$var$NASHORN_BUG = $3b33b5b5cc18ae8d$var$getOwnPropertyDescriptor$1 && !$3b33b5b5cc18ae8d$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$3b33b5b5cc18ae8d$var$objectPropertyIsEnumerable.f = $3b33b5b5cc18ae8d$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $3b33b5b5cc18ae8d$var$getOwnPropertyDescriptor$1(this, V);
    return !!descriptor && descriptor.enumerable;
} : $3b33b5b5cc18ae8d$var$$propertyIsEnumerable;
var $3b33b5b5cc18ae8d$var$createPropertyDescriptor$2 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $3b33b5b5cc18ae8d$var$NATIVE_BIND = $3b33b5b5cc18ae8d$var$functionBindNative;
var $3b33b5b5cc18ae8d$var$FunctionPrototype$1 = Function.prototype;
var $3b33b5b5cc18ae8d$var$bind = $3b33b5b5cc18ae8d$var$FunctionPrototype$1.bind;
var $3b33b5b5cc18ae8d$var$call$5 = $3b33b5b5cc18ae8d$var$FunctionPrototype$1.call;
var $3b33b5b5cc18ae8d$var$uncurryThis$a = $3b33b5b5cc18ae8d$var$NATIVE_BIND && $3b33b5b5cc18ae8d$var$bind.bind($3b33b5b5cc18ae8d$var$call$5, $3b33b5b5cc18ae8d$var$call$5);
var $3b33b5b5cc18ae8d$var$functionUncurryThis = $3b33b5b5cc18ae8d$var$NATIVE_BIND ? function(fn) {
    return fn && $3b33b5b5cc18ae8d$var$uncurryThis$a(fn);
} : function(fn) {
    return fn && function() {
        return $3b33b5b5cc18ae8d$var$call$5.apply(fn, arguments);
    };
};
var $3b33b5b5cc18ae8d$var$uncurryThis$9 = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$toString$2 = $3b33b5b5cc18ae8d$var$uncurryThis$9({}.toString);
var $3b33b5b5cc18ae8d$var$stringSlice = $3b33b5b5cc18ae8d$var$uncurryThis$9("".slice);
var $3b33b5b5cc18ae8d$var$classofRaw$1 = function(it) {
    return $3b33b5b5cc18ae8d$var$stringSlice($3b33b5b5cc18ae8d$var$toString$2(it), 8, -1);
};
var $3b33b5b5cc18ae8d$var$uncurryThis$8 = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$fails$7 = $3b33b5b5cc18ae8d$var$fails$a;
var $3b33b5b5cc18ae8d$var$classof$2 = $3b33b5b5cc18ae8d$var$classofRaw$1;
var $3b33b5b5cc18ae8d$var$$Object$3 = Object;
var $3b33b5b5cc18ae8d$var$split = $3b33b5b5cc18ae8d$var$uncurryThis$8("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $3b33b5b5cc18ae8d$var$indexedObject = $3b33b5b5cc18ae8d$var$fails$7(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$3b33b5b5cc18ae8d$var$$Object$3("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $3b33b5b5cc18ae8d$var$classof$2(it) == "String" ? $3b33b5b5cc18ae8d$var$split(it, "") : $3b33b5b5cc18ae8d$var$$Object$3(it);
} : $3b33b5b5cc18ae8d$var$$Object$3;
var $3b33b5b5cc18ae8d$var$$TypeError$5 = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $3b33b5b5cc18ae8d$var$requireObjectCoercible$2 = function(it) {
    if (it == undefined) throw $3b33b5b5cc18ae8d$var$$TypeError$5("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $3b33b5b5cc18ae8d$var$IndexedObject$1 = $3b33b5b5cc18ae8d$var$indexedObject;
var $3b33b5b5cc18ae8d$var$requireObjectCoercible$1 = $3b33b5b5cc18ae8d$var$requireObjectCoercible$2;
var $3b33b5b5cc18ae8d$var$toIndexedObject$3 = function(it) {
    return $3b33b5b5cc18ae8d$var$IndexedObject$1($3b33b5b5cc18ae8d$var$requireObjectCoercible$1(it));
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $3b33b5b5cc18ae8d$var$isCallable$b = function(argument) {
    return typeof argument == "function";
};
var $3b33b5b5cc18ae8d$var$isCallable$a = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$isObject$5 = function(it) {
    return typeof it == "object" ? it !== null : $3b33b5b5cc18ae8d$var$isCallable$a(it);
};
var $3b33b5b5cc18ae8d$var$global$9 = $3b33b5b5cc18ae8d$var$global$a;
var $3b33b5b5cc18ae8d$var$isCallable$9 = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$aFunction = function(argument) {
    return $3b33b5b5cc18ae8d$var$isCallable$9(argument) ? argument : undefined;
};
var $3b33b5b5cc18ae8d$var$getBuiltIn$3 = function(namespace, method) {
    return arguments.length < 2 ? $3b33b5b5cc18ae8d$var$aFunction($3b33b5b5cc18ae8d$var$global$9[namespace]) : $3b33b5b5cc18ae8d$var$global$9[namespace] && $3b33b5b5cc18ae8d$var$global$9[namespace][method];
};
var $3b33b5b5cc18ae8d$var$uncurryThis$7 = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$objectIsPrototypeOf = $3b33b5b5cc18ae8d$var$uncurryThis$7({}.isPrototypeOf);
var $3b33b5b5cc18ae8d$var$getBuiltIn$2 = $3b33b5b5cc18ae8d$var$getBuiltIn$3;
var $3b33b5b5cc18ae8d$var$engineUserAgent = $3b33b5b5cc18ae8d$var$getBuiltIn$2("navigator", "userAgent") || "";
var $3b33b5b5cc18ae8d$var$global$8 = $3b33b5b5cc18ae8d$var$global$a;
var $3b33b5b5cc18ae8d$var$userAgent = $3b33b5b5cc18ae8d$var$engineUserAgent;
var $3b33b5b5cc18ae8d$var$process = $3b33b5b5cc18ae8d$var$global$8.process;
var $3b33b5b5cc18ae8d$var$Deno = $3b33b5b5cc18ae8d$var$global$8.Deno;
var $3b33b5b5cc18ae8d$var$versions = $3b33b5b5cc18ae8d$var$process && $3b33b5b5cc18ae8d$var$process.versions || $3b33b5b5cc18ae8d$var$Deno && $3b33b5b5cc18ae8d$var$Deno.version;
var $3b33b5b5cc18ae8d$var$v8 = $3b33b5b5cc18ae8d$var$versions && $3b33b5b5cc18ae8d$var$versions.v8;
var $3b33b5b5cc18ae8d$var$match, $3b33b5b5cc18ae8d$var$version;
if ($3b33b5b5cc18ae8d$var$v8) {
    $3b33b5b5cc18ae8d$var$match = $3b33b5b5cc18ae8d$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $3b33b5b5cc18ae8d$var$version = $3b33b5b5cc18ae8d$var$match[0] > 0 && $3b33b5b5cc18ae8d$var$match[0] < 4 ? 1 : +($3b33b5b5cc18ae8d$var$match[0] + $3b33b5b5cc18ae8d$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$3b33b5b5cc18ae8d$var$version && $3b33b5b5cc18ae8d$var$userAgent) {
    $3b33b5b5cc18ae8d$var$match = $3b33b5b5cc18ae8d$var$userAgent.match(/Edge\/(\d+)/);
    if (!$3b33b5b5cc18ae8d$var$match || $3b33b5b5cc18ae8d$var$match[1] >= 74) {
        $3b33b5b5cc18ae8d$var$match = $3b33b5b5cc18ae8d$var$userAgent.match(/Chrome\/(\d+)/);
        if ($3b33b5b5cc18ae8d$var$match) $3b33b5b5cc18ae8d$var$version = +$3b33b5b5cc18ae8d$var$match[1];
    }
}
var $3b33b5b5cc18ae8d$var$engineV8Version = $3b33b5b5cc18ae8d$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $3b33b5b5cc18ae8d$var$V8_VERSION = $3b33b5b5cc18ae8d$var$engineV8Version;
var $3b33b5b5cc18ae8d$var$fails$6 = $3b33b5b5cc18ae8d$var$fails$a;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $3b33b5b5cc18ae8d$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$3b33b5b5cc18ae8d$var$fails$6(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $3b33b5b5cc18ae8d$var$V8_VERSION && $3b33b5b5cc18ae8d$var$V8_VERSION < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $3b33b5b5cc18ae8d$var$NATIVE_SYMBOL$1 = $3b33b5b5cc18ae8d$var$nativeSymbol;
var $3b33b5b5cc18ae8d$var$useSymbolAsUid = $3b33b5b5cc18ae8d$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $3b33b5b5cc18ae8d$var$getBuiltIn$1 = $3b33b5b5cc18ae8d$var$getBuiltIn$3;
var $3b33b5b5cc18ae8d$var$isCallable$8 = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$isPrototypeOf$1 = $3b33b5b5cc18ae8d$var$objectIsPrototypeOf;
var $3b33b5b5cc18ae8d$var$USE_SYMBOL_AS_UID$1 = $3b33b5b5cc18ae8d$var$useSymbolAsUid;
var $3b33b5b5cc18ae8d$var$$Object$2 = Object;
var $3b33b5b5cc18ae8d$var$isSymbol$2 = $3b33b5b5cc18ae8d$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $3b33b5b5cc18ae8d$var$getBuiltIn$1("Symbol");
    return $3b33b5b5cc18ae8d$var$isCallable$8($Symbol) && $3b33b5b5cc18ae8d$var$isPrototypeOf$1($Symbol.prototype, $3b33b5b5cc18ae8d$var$$Object$2(it));
};
var $3b33b5b5cc18ae8d$var$$String$2 = String;
var $3b33b5b5cc18ae8d$var$tryToString$1 = function(argument) {
    try {
        return $3b33b5b5cc18ae8d$var$$String$2(argument);
    } catch (error) {
        return "Object";
    }
};
var $3b33b5b5cc18ae8d$var$isCallable$7 = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$tryToString = $3b33b5b5cc18ae8d$var$tryToString$1;
var $3b33b5b5cc18ae8d$var$$TypeError$4 = TypeError;
// `Assert: IsCallable(argument) is true`
var $3b33b5b5cc18ae8d$var$aCallable$1 = function(argument) {
    if ($3b33b5b5cc18ae8d$var$isCallable$7(argument)) return argument;
    throw $3b33b5b5cc18ae8d$var$$TypeError$4($3b33b5b5cc18ae8d$var$tryToString(argument) + " is not a function");
};
var $3b33b5b5cc18ae8d$var$aCallable = $3b33b5b5cc18ae8d$var$aCallable$1;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $3b33b5b5cc18ae8d$var$getMethod$1 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $3b33b5b5cc18ae8d$var$aCallable(func);
};
var $3b33b5b5cc18ae8d$var$call$4 = $3b33b5b5cc18ae8d$var$functionCall;
var $3b33b5b5cc18ae8d$var$isCallable$6 = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$isObject$4 = $3b33b5b5cc18ae8d$var$isObject$5;
var $3b33b5b5cc18ae8d$var$$TypeError$3 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $3b33b5b5cc18ae8d$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $3b33b5b5cc18ae8d$var$isCallable$6(fn = input.toString) && !$3b33b5b5cc18ae8d$var$isObject$4(val = $3b33b5b5cc18ae8d$var$call$4(fn, input))) return val;
    if ($3b33b5b5cc18ae8d$var$isCallable$6(fn = input.valueOf) && !$3b33b5b5cc18ae8d$var$isObject$4(val = $3b33b5b5cc18ae8d$var$call$4(fn, input))) return val;
    if (pref !== "string" && $3b33b5b5cc18ae8d$var$isCallable$6(fn = input.toString) && !$3b33b5b5cc18ae8d$var$isObject$4(val = $3b33b5b5cc18ae8d$var$call$4(fn, input))) return val;
    throw $3b33b5b5cc18ae8d$var$$TypeError$3("Can't convert object to primitive value");
};
var $3b33b5b5cc18ae8d$var$shared$3 = {
    exports: {}
};
var $3b33b5b5cc18ae8d$var$global$7 = $3b33b5b5cc18ae8d$var$global$a;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $3b33b5b5cc18ae8d$var$defineProperty$2 = Object.defineProperty;
var $3b33b5b5cc18ae8d$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $3b33b5b5cc18ae8d$var$defineProperty$2($3b33b5b5cc18ae8d$var$global$7, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $3b33b5b5cc18ae8d$var$global$7[key] = value;
    }
    return value;
};
var $3b33b5b5cc18ae8d$var$global$6 = $3b33b5b5cc18ae8d$var$global$a;
var $3b33b5b5cc18ae8d$var$defineGlobalProperty$2 = $3b33b5b5cc18ae8d$var$defineGlobalProperty$3;
var $3b33b5b5cc18ae8d$var$SHARED = "__core-js_shared__";
var $3b33b5b5cc18ae8d$var$store$3 = $3b33b5b5cc18ae8d$var$global$6[$3b33b5b5cc18ae8d$var$SHARED] || $3b33b5b5cc18ae8d$var$defineGlobalProperty$2($3b33b5b5cc18ae8d$var$SHARED, {});
var $3b33b5b5cc18ae8d$var$sharedStore = $3b33b5b5cc18ae8d$var$store$3;
var $3b33b5b5cc18ae8d$var$store$2 = $3b33b5b5cc18ae8d$var$sharedStore;
($3b33b5b5cc18ae8d$var$shared$3.exports = function(key, value) {
    return $3b33b5b5cc18ae8d$var$store$2[key] || ($3b33b5b5cc18ae8d$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $3b33b5b5cc18ae8d$var$requireObjectCoercible = $3b33b5b5cc18ae8d$var$requireObjectCoercible$2;
var $3b33b5b5cc18ae8d$var$$Object$1 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $3b33b5b5cc18ae8d$var$toObject$2 = function(argument) {
    return $3b33b5b5cc18ae8d$var$$Object$1($3b33b5b5cc18ae8d$var$requireObjectCoercible(argument));
};
var $3b33b5b5cc18ae8d$var$uncurryThis$6 = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$toObject$1 = $3b33b5b5cc18ae8d$var$toObject$2;
var $3b33b5b5cc18ae8d$var$hasOwnProperty = $3b33b5b5cc18ae8d$var$uncurryThis$6({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $3b33b5b5cc18ae8d$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $3b33b5b5cc18ae8d$var$hasOwnProperty($3b33b5b5cc18ae8d$var$toObject$1(it), key);
};
var $3b33b5b5cc18ae8d$var$uncurryThis$5 = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$id = 0;
var $3b33b5b5cc18ae8d$var$postfix = Math.random();
var $3b33b5b5cc18ae8d$var$toString$1 = $3b33b5b5cc18ae8d$var$uncurryThis$5(1.0.toString);
var $3b33b5b5cc18ae8d$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $3b33b5b5cc18ae8d$var$toString$1(++$3b33b5b5cc18ae8d$var$id + $3b33b5b5cc18ae8d$var$postfix, 36);
};
var $3b33b5b5cc18ae8d$var$global$5 = $3b33b5b5cc18ae8d$var$global$a;
var $3b33b5b5cc18ae8d$var$shared$2 = $3b33b5b5cc18ae8d$var$shared$3.exports;
var $3b33b5b5cc18ae8d$var$hasOwn$7 = $3b33b5b5cc18ae8d$var$hasOwnProperty_1;
var $3b33b5b5cc18ae8d$var$uid$1 = $3b33b5b5cc18ae8d$var$uid$2;
var $3b33b5b5cc18ae8d$var$NATIVE_SYMBOL = $3b33b5b5cc18ae8d$var$nativeSymbol;
var $3b33b5b5cc18ae8d$var$USE_SYMBOL_AS_UID = $3b33b5b5cc18ae8d$var$useSymbolAsUid;
var $3b33b5b5cc18ae8d$var$WellKnownSymbolsStore = $3b33b5b5cc18ae8d$var$shared$2("wks");
var $3b33b5b5cc18ae8d$var$Symbol$1 = $3b33b5b5cc18ae8d$var$global$5.Symbol;
var $3b33b5b5cc18ae8d$var$symbolFor = $3b33b5b5cc18ae8d$var$Symbol$1 && $3b33b5b5cc18ae8d$var$Symbol$1["for"];
var $3b33b5b5cc18ae8d$var$createWellKnownSymbol = $3b33b5b5cc18ae8d$var$USE_SYMBOL_AS_UID ? $3b33b5b5cc18ae8d$var$Symbol$1 : $3b33b5b5cc18ae8d$var$Symbol$1 && $3b33b5b5cc18ae8d$var$Symbol$1.withoutSetter || $3b33b5b5cc18ae8d$var$uid$1;
var $3b33b5b5cc18ae8d$var$wellKnownSymbol$3 = function(name) {
    if (!$3b33b5b5cc18ae8d$var$hasOwn$7($3b33b5b5cc18ae8d$var$WellKnownSymbolsStore, name) || !($3b33b5b5cc18ae8d$var$NATIVE_SYMBOL || typeof $3b33b5b5cc18ae8d$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($3b33b5b5cc18ae8d$var$NATIVE_SYMBOL && $3b33b5b5cc18ae8d$var$hasOwn$7($3b33b5b5cc18ae8d$var$Symbol$1, name)) $3b33b5b5cc18ae8d$var$WellKnownSymbolsStore[name] = $3b33b5b5cc18ae8d$var$Symbol$1[name];
        else if ($3b33b5b5cc18ae8d$var$USE_SYMBOL_AS_UID && $3b33b5b5cc18ae8d$var$symbolFor) $3b33b5b5cc18ae8d$var$WellKnownSymbolsStore[name] = $3b33b5b5cc18ae8d$var$symbolFor(description);
        else $3b33b5b5cc18ae8d$var$WellKnownSymbolsStore[name] = $3b33b5b5cc18ae8d$var$createWellKnownSymbol(description);
    }
    return $3b33b5b5cc18ae8d$var$WellKnownSymbolsStore[name];
};
var $3b33b5b5cc18ae8d$var$call$3 = $3b33b5b5cc18ae8d$var$functionCall;
var $3b33b5b5cc18ae8d$var$isObject$3 = $3b33b5b5cc18ae8d$var$isObject$5;
var $3b33b5b5cc18ae8d$var$isSymbol$1 = $3b33b5b5cc18ae8d$var$isSymbol$2;
var $3b33b5b5cc18ae8d$var$getMethod = $3b33b5b5cc18ae8d$var$getMethod$1;
var $3b33b5b5cc18ae8d$var$ordinaryToPrimitive = $3b33b5b5cc18ae8d$var$ordinaryToPrimitive$1;
var $3b33b5b5cc18ae8d$var$wellKnownSymbol$2 = $3b33b5b5cc18ae8d$var$wellKnownSymbol$3;
var $3b33b5b5cc18ae8d$var$$TypeError$2 = TypeError;
var $3b33b5b5cc18ae8d$var$TO_PRIMITIVE = $3b33b5b5cc18ae8d$var$wellKnownSymbol$2("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $3b33b5b5cc18ae8d$var$toPrimitive$1 = function(input, pref) {
    if (!$3b33b5b5cc18ae8d$var$isObject$3(input) || $3b33b5b5cc18ae8d$var$isSymbol$1(input)) return input;
    var exoticToPrim = $3b33b5b5cc18ae8d$var$getMethod(input, $3b33b5b5cc18ae8d$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $3b33b5b5cc18ae8d$var$call$3(exoticToPrim, input, pref);
        if (!$3b33b5b5cc18ae8d$var$isObject$3(result) || $3b33b5b5cc18ae8d$var$isSymbol$1(result)) return result;
        throw $3b33b5b5cc18ae8d$var$$TypeError$2("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $3b33b5b5cc18ae8d$var$ordinaryToPrimitive(input, pref);
};
var $3b33b5b5cc18ae8d$var$toPrimitive = $3b33b5b5cc18ae8d$var$toPrimitive$1;
var $3b33b5b5cc18ae8d$var$isSymbol = $3b33b5b5cc18ae8d$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $3b33b5b5cc18ae8d$var$toPropertyKey$2 = function(argument) {
    var key = $3b33b5b5cc18ae8d$var$toPrimitive(argument, "string");
    return $3b33b5b5cc18ae8d$var$isSymbol(key) ? key : key + "";
};
var $3b33b5b5cc18ae8d$var$global$4 = $3b33b5b5cc18ae8d$var$global$a;
var $3b33b5b5cc18ae8d$var$isObject$2 = $3b33b5b5cc18ae8d$var$isObject$5;
var $3b33b5b5cc18ae8d$var$document = $3b33b5b5cc18ae8d$var$global$4.document;
// typeof document.createElement is 'object' in old IE
var $3b33b5b5cc18ae8d$var$EXISTS$1 = $3b33b5b5cc18ae8d$var$isObject$2($3b33b5b5cc18ae8d$var$document) && $3b33b5b5cc18ae8d$var$isObject$2($3b33b5b5cc18ae8d$var$document.createElement);
var $3b33b5b5cc18ae8d$var$documentCreateElement = function(it) {
    return $3b33b5b5cc18ae8d$var$EXISTS$1 ? $3b33b5b5cc18ae8d$var$document.createElement(it) : {};
};
var $3b33b5b5cc18ae8d$var$DESCRIPTORS$7 = $3b33b5b5cc18ae8d$var$descriptors;
var $3b33b5b5cc18ae8d$var$fails$5 = $3b33b5b5cc18ae8d$var$fails$a;
var $3b33b5b5cc18ae8d$var$createElement = $3b33b5b5cc18ae8d$var$documentCreateElement;
// Thanks to IE8 for its funny defineProperty
var $3b33b5b5cc18ae8d$var$ie8DomDefine = !$3b33b5b5cc18ae8d$var$DESCRIPTORS$7 && !$3b33b5b5cc18ae8d$var$fails$5(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($3b33b5b5cc18ae8d$var$createElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $3b33b5b5cc18ae8d$var$DESCRIPTORS$6 = $3b33b5b5cc18ae8d$var$descriptors;
var $3b33b5b5cc18ae8d$var$call$2 = $3b33b5b5cc18ae8d$var$functionCall;
var $3b33b5b5cc18ae8d$var$propertyIsEnumerableModule$1 = $3b33b5b5cc18ae8d$var$objectPropertyIsEnumerable;
var $3b33b5b5cc18ae8d$var$createPropertyDescriptor$1 = $3b33b5b5cc18ae8d$var$createPropertyDescriptor$2;
var $3b33b5b5cc18ae8d$var$toIndexedObject$2 = $3b33b5b5cc18ae8d$var$toIndexedObject$3;
var $3b33b5b5cc18ae8d$var$toPropertyKey$1 = $3b33b5b5cc18ae8d$var$toPropertyKey$2;
var $3b33b5b5cc18ae8d$var$hasOwn$6 = $3b33b5b5cc18ae8d$var$hasOwnProperty_1;
var $3b33b5b5cc18ae8d$var$IE8_DOM_DEFINE$1 = $3b33b5b5cc18ae8d$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $3b33b5b5cc18ae8d$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$3b33b5b5cc18ae8d$var$objectGetOwnPropertyDescriptor.f = $3b33b5b5cc18ae8d$var$DESCRIPTORS$6 ? $3b33b5b5cc18ae8d$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $3b33b5b5cc18ae8d$var$toIndexedObject$2(O);
    P = $3b33b5b5cc18ae8d$var$toPropertyKey$1(P);
    if ($3b33b5b5cc18ae8d$var$IE8_DOM_DEFINE$1) try {
        return $3b33b5b5cc18ae8d$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($3b33b5b5cc18ae8d$var$hasOwn$6(O, P)) return $3b33b5b5cc18ae8d$var$createPropertyDescriptor$1(!$3b33b5b5cc18ae8d$var$call$2($3b33b5b5cc18ae8d$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $3b33b5b5cc18ae8d$var$objectDefineProperty = {};
var $3b33b5b5cc18ae8d$var$DESCRIPTORS$5 = $3b33b5b5cc18ae8d$var$descriptors;
var $3b33b5b5cc18ae8d$var$fails$4 = $3b33b5b5cc18ae8d$var$fails$a;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $3b33b5b5cc18ae8d$var$v8PrototypeDefineBug = $3b33b5b5cc18ae8d$var$DESCRIPTORS$5 && $3b33b5b5cc18ae8d$var$fails$4(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $3b33b5b5cc18ae8d$var$isObject$1 = $3b33b5b5cc18ae8d$var$isObject$5;
var $3b33b5b5cc18ae8d$var$$String$1 = String;
var $3b33b5b5cc18ae8d$var$$TypeError$1 = TypeError;
// `Assert: Type(argument) is Object`
var $3b33b5b5cc18ae8d$var$anObject$4 = function(argument) {
    if ($3b33b5b5cc18ae8d$var$isObject$1(argument)) return argument;
    throw $3b33b5b5cc18ae8d$var$$TypeError$1($3b33b5b5cc18ae8d$var$$String$1(argument) + " is not an object");
};
var $3b33b5b5cc18ae8d$var$DESCRIPTORS$4 = $3b33b5b5cc18ae8d$var$descriptors;
var $3b33b5b5cc18ae8d$var$IE8_DOM_DEFINE = $3b33b5b5cc18ae8d$var$ie8DomDefine;
var $3b33b5b5cc18ae8d$var$V8_PROTOTYPE_DEFINE_BUG = $3b33b5b5cc18ae8d$var$v8PrototypeDefineBug;
var $3b33b5b5cc18ae8d$var$anObject$3 = $3b33b5b5cc18ae8d$var$anObject$4;
var $3b33b5b5cc18ae8d$var$toPropertyKey = $3b33b5b5cc18ae8d$var$toPropertyKey$2;
var $3b33b5b5cc18ae8d$var$$TypeError = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $3b33b5b5cc18ae8d$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $3b33b5b5cc18ae8d$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3b33b5b5cc18ae8d$var$ENUMERABLE = "enumerable";
var $3b33b5b5cc18ae8d$var$CONFIGURABLE$1 = "configurable";
var $3b33b5b5cc18ae8d$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$3b33b5b5cc18ae8d$var$objectDefineProperty.f = $3b33b5b5cc18ae8d$var$DESCRIPTORS$4 ? $3b33b5b5cc18ae8d$var$V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
    $3b33b5b5cc18ae8d$var$anObject$3(O);
    P = $3b33b5b5cc18ae8d$var$toPropertyKey(P);
    $3b33b5b5cc18ae8d$var$anObject$3(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $3b33b5b5cc18ae8d$var$WRITABLE in Attributes && !Attributes[$3b33b5b5cc18ae8d$var$WRITABLE]) {
        var current = $3b33b5b5cc18ae8d$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$3b33b5b5cc18ae8d$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $3b33b5b5cc18ae8d$var$CONFIGURABLE$1 in Attributes ? Attributes[$3b33b5b5cc18ae8d$var$CONFIGURABLE$1] : current[$3b33b5b5cc18ae8d$var$CONFIGURABLE$1],
                enumerable: $3b33b5b5cc18ae8d$var$ENUMERABLE in Attributes ? Attributes[$3b33b5b5cc18ae8d$var$ENUMERABLE] : current[$3b33b5b5cc18ae8d$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $3b33b5b5cc18ae8d$var$$defineProperty(O, P, Attributes);
} : $3b33b5b5cc18ae8d$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $3b33b5b5cc18ae8d$var$anObject$3(O);
    P = $3b33b5b5cc18ae8d$var$toPropertyKey(P);
    $3b33b5b5cc18ae8d$var$anObject$3(Attributes);
    if ($3b33b5b5cc18ae8d$var$IE8_DOM_DEFINE) try {
        return $3b33b5b5cc18ae8d$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $3b33b5b5cc18ae8d$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $3b33b5b5cc18ae8d$var$DESCRIPTORS$3 = $3b33b5b5cc18ae8d$var$descriptors;
var $3b33b5b5cc18ae8d$var$definePropertyModule$2 = $3b33b5b5cc18ae8d$var$objectDefineProperty;
var $3b33b5b5cc18ae8d$var$createPropertyDescriptor = $3b33b5b5cc18ae8d$var$createPropertyDescriptor$2;
var $3b33b5b5cc18ae8d$var$createNonEnumerableProperty$2 = $3b33b5b5cc18ae8d$var$DESCRIPTORS$3 ? function(object, key, value) {
    return $3b33b5b5cc18ae8d$var$definePropertyModule$2.f(object, key, $3b33b5b5cc18ae8d$var$createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $3b33b5b5cc18ae8d$var$makeBuiltIn$2 = {
    exports: {}
};
var $3b33b5b5cc18ae8d$var$DESCRIPTORS$2 = $3b33b5b5cc18ae8d$var$descriptors;
var $3b33b5b5cc18ae8d$var$hasOwn$5 = $3b33b5b5cc18ae8d$var$hasOwnProperty_1;
var $3b33b5b5cc18ae8d$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $3b33b5b5cc18ae8d$var$getDescriptor = $3b33b5b5cc18ae8d$var$DESCRIPTORS$2 && Object.getOwnPropertyDescriptor;
var $3b33b5b5cc18ae8d$var$EXISTS = $3b33b5b5cc18ae8d$var$hasOwn$5($3b33b5b5cc18ae8d$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $3b33b5b5cc18ae8d$var$PROPER = $3b33b5b5cc18ae8d$var$EXISTS && (function something() {}).name === "something";
var $3b33b5b5cc18ae8d$var$CONFIGURABLE = $3b33b5b5cc18ae8d$var$EXISTS && (!$3b33b5b5cc18ae8d$var$DESCRIPTORS$2 || $3b33b5b5cc18ae8d$var$DESCRIPTORS$2 && $3b33b5b5cc18ae8d$var$getDescriptor($3b33b5b5cc18ae8d$var$FunctionPrototype, "name").configurable);
var $3b33b5b5cc18ae8d$var$functionName = {
    EXISTS: $3b33b5b5cc18ae8d$var$EXISTS,
    PROPER: $3b33b5b5cc18ae8d$var$PROPER,
    CONFIGURABLE: $3b33b5b5cc18ae8d$var$CONFIGURABLE
};
var $3b33b5b5cc18ae8d$var$uncurryThis$4 = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$isCallable$5 = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$store$1 = $3b33b5b5cc18ae8d$var$sharedStore;
var $3b33b5b5cc18ae8d$var$functionToString = $3b33b5b5cc18ae8d$var$uncurryThis$4(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$3b33b5b5cc18ae8d$var$isCallable$5($3b33b5b5cc18ae8d$var$store$1.inspectSource)) $3b33b5b5cc18ae8d$var$store$1.inspectSource = function(it) {
    return $3b33b5b5cc18ae8d$var$functionToString(it);
};
var $3b33b5b5cc18ae8d$var$inspectSource$2 = $3b33b5b5cc18ae8d$var$store$1.inspectSource;
var $3b33b5b5cc18ae8d$var$global$3 = $3b33b5b5cc18ae8d$var$global$a;
var $3b33b5b5cc18ae8d$var$isCallable$4 = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$inspectSource$1 = $3b33b5b5cc18ae8d$var$inspectSource$2;
var $3b33b5b5cc18ae8d$var$WeakMap$1 = $3b33b5b5cc18ae8d$var$global$3.WeakMap;
var $3b33b5b5cc18ae8d$var$nativeWeakMap = $3b33b5b5cc18ae8d$var$isCallable$4($3b33b5b5cc18ae8d$var$WeakMap$1) && /native code/.test($3b33b5b5cc18ae8d$var$inspectSource$1($3b33b5b5cc18ae8d$var$WeakMap$1));
var $3b33b5b5cc18ae8d$var$shared$1 = $3b33b5b5cc18ae8d$var$shared$3.exports;
var $3b33b5b5cc18ae8d$var$uid = $3b33b5b5cc18ae8d$var$uid$2;
var $3b33b5b5cc18ae8d$var$keys = $3b33b5b5cc18ae8d$var$shared$1("keys");
var $3b33b5b5cc18ae8d$var$sharedKey$1 = function(key) {
    return $3b33b5b5cc18ae8d$var$keys[key] || ($3b33b5b5cc18ae8d$var$keys[key] = $3b33b5b5cc18ae8d$var$uid(key));
};
var $3b33b5b5cc18ae8d$var$hiddenKeys$3 = {};
var $3b33b5b5cc18ae8d$var$NATIVE_WEAK_MAP = $3b33b5b5cc18ae8d$var$nativeWeakMap;
var $3b33b5b5cc18ae8d$var$global$2 = $3b33b5b5cc18ae8d$var$global$a;
var $3b33b5b5cc18ae8d$var$uncurryThis$3 = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$isObject = $3b33b5b5cc18ae8d$var$isObject$5;
var $3b33b5b5cc18ae8d$var$createNonEnumerableProperty$1 = $3b33b5b5cc18ae8d$var$createNonEnumerableProperty$2;
var $3b33b5b5cc18ae8d$var$hasOwn$4 = $3b33b5b5cc18ae8d$var$hasOwnProperty_1;
var $3b33b5b5cc18ae8d$var$shared = $3b33b5b5cc18ae8d$var$sharedStore;
var $3b33b5b5cc18ae8d$var$sharedKey = $3b33b5b5cc18ae8d$var$sharedKey$1;
var $3b33b5b5cc18ae8d$var$hiddenKeys$2 = $3b33b5b5cc18ae8d$var$hiddenKeys$3;
var $3b33b5b5cc18ae8d$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $3b33b5b5cc18ae8d$var$TypeError$1 = $3b33b5b5cc18ae8d$var$global$2.TypeError;
var $3b33b5b5cc18ae8d$var$WeakMap = $3b33b5b5cc18ae8d$var$global$2.WeakMap;
var $3b33b5b5cc18ae8d$var$set, $3b33b5b5cc18ae8d$var$get, $3b33b5b5cc18ae8d$var$has;
var $3b33b5b5cc18ae8d$var$enforce = function(it) {
    return $3b33b5b5cc18ae8d$var$has(it) ? $3b33b5b5cc18ae8d$var$get(it) : $3b33b5b5cc18ae8d$var$set(it, {});
};
var $3b33b5b5cc18ae8d$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$3b33b5b5cc18ae8d$var$isObject(it) || (state = $3b33b5b5cc18ae8d$var$get(it)).type !== TYPE) throw $3b33b5b5cc18ae8d$var$TypeError$1("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($3b33b5b5cc18ae8d$var$NATIVE_WEAK_MAP || $3b33b5b5cc18ae8d$var$shared.state) {
    var $3b33b5b5cc18ae8d$var$store = $3b33b5b5cc18ae8d$var$shared.state || ($3b33b5b5cc18ae8d$var$shared.state = new $3b33b5b5cc18ae8d$var$WeakMap());
    var $3b33b5b5cc18ae8d$var$wmget = $3b33b5b5cc18ae8d$var$uncurryThis$3($3b33b5b5cc18ae8d$var$store.get);
    var $3b33b5b5cc18ae8d$var$wmhas = $3b33b5b5cc18ae8d$var$uncurryThis$3($3b33b5b5cc18ae8d$var$store.has);
    var $3b33b5b5cc18ae8d$var$wmset = $3b33b5b5cc18ae8d$var$uncurryThis$3($3b33b5b5cc18ae8d$var$store.set);
    $3b33b5b5cc18ae8d$var$set = function(it, metadata) {
        if ($3b33b5b5cc18ae8d$var$wmhas($3b33b5b5cc18ae8d$var$store, it)) throw new $3b33b5b5cc18ae8d$var$TypeError$1($3b33b5b5cc18ae8d$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3b33b5b5cc18ae8d$var$wmset($3b33b5b5cc18ae8d$var$store, it, metadata);
        return metadata;
    };
    $3b33b5b5cc18ae8d$var$get = function(it) {
        return $3b33b5b5cc18ae8d$var$wmget($3b33b5b5cc18ae8d$var$store, it) || {};
    };
    $3b33b5b5cc18ae8d$var$has = function(it) {
        return $3b33b5b5cc18ae8d$var$wmhas($3b33b5b5cc18ae8d$var$store, it);
    };
} else {
    var $3b33b5b5cc18ae8d$var$STATE = $3b33b5b5cc18ae8d$var$sharedKey("state");
    $3b33b5b5cc18ae8d$var$hiddenKeys$2[$3b33b5b5cc18ae8d$var$STATE] = true;
    $3b33b5b5cc18ae8d$var$set = function(it, metadata) {
        if ($3b33b5b5cc18ae8d$var$hasOwn$4(it, $3b33b5b5cc18ae8d$var$STATE)) throw new $3b33b5b5cc18ae8d$var$TypeError$1($3b33b5b5cc18ae8d$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $3b33b5b5cc18ae8d$var$createNonEnumerableProperty$1(it, $3b33b5b5cc18ae8d$var$STATE, metadata);
        return metadata;
    };
    $3b33b5b5cc18ae8d$var$get = function(it) {
        return $3b33b5b5cc18ae8d$var$hasOwn$4(it, $3b33b5b5cc18ae8d$var$STATE) ? it[$3b33b5b5cc18ae8d$var$STATE] : {};
    };
    $3b33b5b5cc18ae8d$var$has = function(it) {
        return $3b33b5b5cc18ae8d$var$hasOwn$4(it, $3b33b5b5cc18ae8d$var$STATE);
    };
}
var $3b33b5b5cc18ae8d$var$internalState = {
    set: $3b33b5b5cc18ae8d$var$set,
    get: $3b33b5b5cc18ae8d$var$get,
    has: $3b33b5b5cc18ae8d$var$has,
    enforce: $3b33b5b5cc18ae8d$var$enforce,
    getterFor: $3b33b5b5cc18ae8d$var$getterFor
};
var $3b33b5b5cc18ae8d$var$fails$3 = $3b33b5b5cc18ae8d$var$fails$a;
var $3b33b5b5cc18ae8d$var$isCallable$3 = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$hasOwn$3 = $3b33b5b5cc18ae8d$var$hasOwnProperty_1;
var $3b33b5b5cc18ae8d$var$DESCRIPTORS$1 = $3b33b5b5cc18ae8d$var$descriptors;
var $3b33b5b5cc18ae8d$var$CONFIGURABLE_FUNCTION_NAME = $3b33b5b5cc18ae8d$var$functionName.CONFIGURABLE;
var $3b33b5b5cc18ae8d$var$inspectSource = $3b33b5b5cc18ae8d$var$inspectSource$2;
var $3b33b5b5cc18ae8d$var$InternalStateModule = $3b33b5b5cc18ae8d$var$internalState;
var $3b33b5b5cc18ae8d$var$enforceInternalState = $3b33b5b5cc18ae8d$var$InternalStateModule.enforce;
var $3b33b5b5cc18ae8d$var$getInternalState = $3b33b5b5cc18ae8d$var$InternalStateModule.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $3b33b5b5cc18ae8d$var$defineProperty$1 = Object.defineProperty;
var $3b33b5b5cc18ae8d$var$CONFIGURABLE_LENGTH = $3b33b5b5cc18ae8d$var$DESCRIPTORS$1 && !$3b33b5b5cc18ae8d$var$fails$3(function() {
    return $3b33b5b5cc18ae8d$var$defineProperty$1(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $3b33b5b5cc18ae8d$var$TEMPLATE = String(String).split("String");
var $3b33b5b5cc18ae8d$var$makeBuiltIn$1 = $3b33b5b5cc18ae8d$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$3b33b5b5cc18ae8d$var$hasOwn$3(value, "name") || $3b33b5b5cc18ae8d$var$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($3b33b5b5cc18ae8d$var$DESCRIPTORS$1) $3b33b5b5cc18ae8d$var$defineProperty$1(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($3b33b5b5cc18ae8d$var$CONFIGURABLE_LENGTH && options && $3b33b5b5cc18ae8d$var$hasOwn$3(options, "arity") && value.length !== options.arity) $3b33b5b5cc18ae8d$var$defineProperty$1(value, "length", {
        value: options.arity
    });
    try {
        if (options && $3b33b5b5cc18ae8d$var$hasOwn$3(options, "constructor") && options.constructor) {
            if ($3b33b5b5cc18ae8d$var$DESCRIPTORS$1) $3b33b5b5cc18ae8d$var$defineProperty$1(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $3b33b5b5cc18ae8d$var$enforceInternalState(value);
    if (!$3b33b5b5cc18ae8d$var$hasOwn$3(state, "source")) state.source = $3b33b5b5cc18ae8d$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $3b33b5b5cc18ae8d$var$makeBuiltIn$1(function toString() {
    return $3b33b5b5cc18ae8d$var$isCallable$3(this) && $3b33b5b5cc18ae8d$var$getInternalState(this).source || $3b33b5b5cc18ae8d$var$inspectSource(this);
}, "toString");
var $3b33b5b5cc18ae8d$var$isCallable$2 = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$definePropertyModule$1 = $3b33b5b5cc18ae8d$var$objectDefineProperty;
var $3b33b5b5cc18ae8d$var$makeBuiltIn = $3b33b5b5cc18ae8d$var$makeBuiltIn$2.exports;
var $3b33b5b5cc18ae8d$var$defineGlobalProperty$1 = $3b33b5b5cc18ae8d$var$defineGlobalProperty$3;
var $3b33b5b5cc18ae8d$var$defineBuiltIn$2 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($3b33b5b5cc18ae8d$var$isCallable$2(value)) $3b33b5b5cc18ae8d$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $3b33b5b5cc18ae8d$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $3b33b5b5cc18ae8d$var$definePropertyModule$1.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $3b33b5b5cc18ae8d$var$objectGetOwnPropertyNames = {};
var $3b33b5b5cc18ae8d$var$ceil = Math.ceil;
var $3b33b5b5cc18ae8d$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $3b33b5b5cc18ae8d$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $3b33b5b5cc18ae8d$var$floor : $3b33b5b5cc18ae8d$var$ceil)(n);
};
var $3b33b5b5cc18ae8d$var$trunc = $3b33b5b5cc18ae8d$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $3b33b5b5cc18ae8d$var$toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $3b33b5b5cc18ae8d$var$trunc(number);
};
var $3b33b5b5cc18ae8d$var$toIntegerOrInfinity$1 = $3b33b5b5cc18ae8d$var$toIntegerOrInfinity$2;
var $3b33b5b5cc18ae8d$var$max = Math.max;
var $3b33b5b5cc18ae8d$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $3b33b5b5cc18ae8d$var$toAbsoluteIndex$1 = function(index, length) {
    var integer = $3b33b5b5cc18ae8d$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $3b33b5b5cc18ae8d$var$max(integer + length, 0) : $3b33b5b5cc18ae8d$var$min$1(integer, length);
};
var $3b33b5b5cc18ae8d$var$toIntegerOrInfinity = $3b33b5b5cc18ae8d$var$toIntegerOrInfinity$2;
var $3b33b5b5cc18ae8d$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $3b33b5b5cc18ae8d$var$toLength$1 = function(argument) {
    return argument > 0 ? $3b33b5b5cc18ae8d$var$min($3b33b5b5cc18ae8d$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $3b33b5b5cc18ae8d$var$toLength = $3b33b5b5cc18ae8d$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $3b33b5b5cc18ae8d$var$lengthOfArrayLike$1 = function(obj) {
    return $3b33b5b5cc18ae8d$var$toLength(obj.length);
};
var $3b33b5b5cc18ae8d$var$toIndexedObject$1 = $3b33b5b5cc18ae8d$var$toIndexedObject$3;
var $3b33b5b5cc18ae8d$var$toAbsoluteIndex = $3b33b5b5cc18ae8d$var$toAbsoluteIndex$1;
var $3b33b5b5cc18ae8d$var$lengthOfArrayLike = $3b33b5b5cc18ae8d$var$lengthOfArrayLike$1;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $3b33b5b5cc18ae8d$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $3b33b5b5cc18ae8d$var$toIndexedObject$1($this);
        var length = $3b33b5b5cc18ae8d$var$lengthOfArrayLike(O);
        var index = $3b33b5b5cc18ae8d$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $3b33b5b5cc18ae8d$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $3b33b5b5cc18ae8d$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $3b33b5b5cc18ae8d$var$createMethod(false)
};
var $3b33b5b5cc18ae8d$var$uncurryThis$2 = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$hasOwn$2 = $3b33b5b5cc18ae8d$var$hasOwnProperty_1;
var $3b33b5b5cc18ae8d$var$toIndexedObject = $3b33b5b5cc18ae8d$var$toIndexedObject$3;
var $3b33b5b5cc18ae8d$var$indexOf = $3b33b5b5cc18ae8d$var$arrayIncludes.indexOf;
var $3b33b5b5cc18ae8d$var$hiddenKeys$1 = $3b33b5b5cc18ae8d$var$hiddenKeys$3;
var $3b33b5b5cc18ae8d$var$push = $3b33b5b5cc18ae8d$var$uncurryThis$2([].push);
var $3b33b5b5cc18ae8d$var$objectKeysInternal = function(object, names) {
    var O = $3b33b5b5cc18ae8d$var$toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$3b33b5b5cc18ae8d$var$hasOwn$2($3b33b5b5cc18ae8d$var$hiddenKeys$1, key) && $3b33b5b5cc18ae8d$var$hasOwn$2(O, key) && $3b33b5b5cc18ae8d$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($3b33b5b5cc18ae8d$var$hasOwn$2(O, key = names[i++])) ~$3b33b5b5cc18ae8d$var$indexOf(result, key) || $3b33b5b5cc18ae8d$var$push(result, key);
    return result;
};
// IE8- don't enum bug keys
var $3b33b5b5cc18ae8d$var$enumBugKeys$2 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $3b33b5b5cc18ae8d$var$internalObjectKeys$1 = $3b33b5b5cc18ae8d$var$objectKeysInternal;
var $3b33b5b5cc18ae8d$var$enumBugKeys$1 = $3b33b5b5cc18ae8d$var$enumBugKeys$2;
var $3b33b5b5cc18ae8d$var$hiddenKeys = $3b33b5b5cc18ae8d$var$enumBugKeys$1.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$3b33b5b5cc18ae8d$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $3b33b5b5cc18ae8d$var$internalObjectKeys$1(O, $3b33b5b5cc18ae8d$var$hiddenKeys);
};
var $3b33b5b5cc18ae8d$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$3b33b5b5cc18ae8d$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $3b33b5b5cc18ae8d$var$getBuiltIn = $3b33b5b5cc18ae8d$var$getBuiltIn$3;
var $3b33b5b5cc18ae8d$var$uncurryThis$1 = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$getOwnPropertyNamesModule = $3b33b5b5cc18ae8d$var$objectGetOwnPropertyNames;
var $3b33b5b5cc18ae8d$var$getOwnPropertySymbolsModule$1 = $3b33b5b5cc18ae8d$var$objectGetOwnPropertySymbols;
var $3b33b5b5cc18ae8d$var$anObject$2 = $3b33b5b5cc18ae8d$var$anObject$4;
var $3b33b5b5cc18ae8d$var$concat$1 = $3b33b5b5cc18ae8d$var$uncurryThis$1([].concat);
// all object keys, includes non-enumerable and symbols
var $3b33b5b5cc18ae8d$var$ownKeys$1 = $3b33b5b5cc18ae8d$var$getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $3b33b5b5cc18ae8d$var$getOwnPropertyNamesModule.f($3b33b5b5cc18ae8d$var$anObject$2(it));
    var getOwnPropertySymbols = $3b33b5b5cc18ae8d$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $3b33b5b5cc18ae8d$var$concat$1(keys, getOwnPropertySymbols(it)) : keys;
};
var $3b33b5b5cc18ae8d$var$hasOwn$1 = $3b33b5b5cc18ae8d$var$hasOwnProperty_1;
var $3b33b5b5cc18ae8d$var$ownKeys = $3b33b5b5cc18ae8d$var$ownKeys$1;
var $3b33b5b5cc18ae8d$var$getOwnPropertyDescriptorModule = $3b33b5b5cc18ae8d$var$objectGetOwnPropertyDescriptor;
var $3b33b5b5cc18ae8d$var$definePropertyModule = $3b33b5b5cc18ae8d$var$objectDefineProperty;
var $3b33b5b5cc18ae8d$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $3b33b5b5cc18ae8d$var$ownKeys(source);
    var defineProperty = $3b33b5b5cc18ae8d$var$definePropertyModule.f;
    var getOwnPropertyDescriptor = $3b33b5b5cc18ae8d$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$3b33b5b5cc18ae8d$var$hasOwn$1(target, key) && !(exceptions && $3b33b5b5cc18ae8d$var$hasOwn$1(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $3b33b5b5cc18ae8d$var$fails$2 = $3b33b5b5cc18ae8d$var$fails$a;
var $3b33b5b5cc18ae8d$var$isCallable$1 = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$replacement = /#|\.prototype\./;
var $3b33b5b5cc18ae8d$var$isForced$1 = function(feature, detection) {
    var value = $3b33b5b5cc18ae8d$var$data[$3b33b5b5cc18ae8d$var$normalize(feature)];
    return value == $3b33b5b5cc18ae8d$var$POLYFILL ? true : value == $3b33b5b5cc18ae8d$var$NATIVE ? false : $3b33b5b5cc18ae8d$var$isCallable$1(detection) ? $3b33b5b5cc18ae8d$var$fails$2(detection) : !!detection;
};
var $3b33b5b5cc18ae8d$var$normalize = $3b33b5b5cc18ae8d$var$isForced$1.normalize = function(string) {
    return String(string).replace($3b33b5b5cc18ae8d$var$replacement, ".").toLowerCase();
};
var $3b33b5b5cc18ae8d$var$data = $3b33b5b5cc18ae8d$var$isForced$1.data = {};
var $3b33b5b5cc18ae8d$var$NATIVE = $3b33b5b5cc18ae8d$var$isForced$1.NATIVE = "N";
var $3b33b5b5cc18ae8d$var$POLYFILL = $3b33b5b5cc18ae8d$var$isForced$1.POLYFILL = "P";
var $3b33b5b5cc18ae8d$var$isForced_1 = $3b33b5b5cc18ae8d$var$isForced$1;
var $3b33b5b5cc18ae8d$var$global$1 = $3b33b5b5cc18ae8d$var$global$a;
var $3b33b5b5cc18ae8d$var$getOwnPropertyDescriptor = $3b33b5b5cc18ae8d$var$objectGetOwnPropertyDescriptor.f;
var $3b33b5b5cc18ae8d$var$createNonEnumerableProperty = $3b33b5b5cc18ae8d$var$createNonEnumerableProperty$2;
var $3b33b5b5cc18ae8d$var$defineBuiltIn$1 = $3b33b5b5cc18ae8d$var$defineBuiltIn$2;
var $3b33b5b5cc18ae8d$var$defineGlobalProperty = $3b33b5b5cc18ae8d$var$defineGlobalProperty$3;
var $3b33b5b5cc18ae8d$var$copyConstructorProperties = $3b33b5b5cc18ae8d$var$copyConstructorProperties$1;
var $3b33b5b5cc18ae8d$var$isForced = $3b33b5b5cc18ae8d$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $3b33b5b5cc18ae8d$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $3b33b5b5cc18ae8d$var$global$1;
    else if (STATIC) target = $3b33b5b5cc18ae8d$var$global$1[TARGET] || $3b33b5b5cc18ae8d$var$defineGlobalProperty(TARGET, {});
    else target = ($3b33b5b5cc18ae8d$var$global$1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $3b33b5b5cc18ae8d$var$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $3b33b5b5cc18ae8d$var$isForced(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $3b33b5b5cc18ae8d$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $3b33b5b5cc18ae8d$var$createNonEnumerableProperty(sourceProperty, "sham", true);
        $3b33b5b5cc18ae8d$var$defineBuiltIn$1(target, key, sourceProperty, options);
    }
};
var $3b33b5b5cc18ae8d$var$internalObjectKeys = $3b33b5b5cc18ae8d$var$objectKeysInternal;
var $3b33b5b5cc18ae8d$var$enumBugKeys = $3b33b5b5cc18ae8d$var$enumBugKeys$2;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $3b33b5b5cc18ae8d$var$objectKeys$1 = Object.keys || function keys(O) {
    return $3b33b5b5cc18ae8d$var$internalObjectKeys(O, $3b33b5b5cc18ae8d$var$enumBugKeys);
};
var $3b33b5b5cc18ae8d$var$DESCRIPTORS = $3b33b5b5cc18ae8d$var$descriptors;
var $3b33b5b5cc18ae8d$var$uncurryThis = $3b33b5b5cc18ae8d$var$functionUncurryThis;
var $3b33b5b5cc18ae8d$var$call$1 = $3b33b5b5cc18ae8d$var$functionCall;
var $3b33b5b5cc18ae8d$var$fails$1 = $3b33b5b5cc18ae8d$var$fails$a;
var $3b33b5b5cc18ae8d$var$objectKeys = $3b33b5b5cc18ae8d$var$objectKeys$1;
var $3b33b5b5cc18ae8d$var$getOwnPropertySymbolsModule = $3b33b5b5cc18ae8d$var$objectGetOwnPropertySymbols;
var $3b33b5b5cc18ae8d$var$propertyIsEnumerableModule = $3b33b5b5cc18ae8d$var$objectPropertyIsEnumerable;
var $3b33b5b5cc18ae8d$var$toObject = $3b33b5b5cc18ae8d$var$toObject$2;
var $3b33b5b5cc18ae8d$var$IndexedObject = $3b33b5b5cc18ae8d$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $3b33b5b5cc18ae8d$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $3b33b5b5cc18ae8d$var$defineProperty = Object.defineProperty;
var $3b33b5b5cc18ae8d$var$concat = $3b33b5b5cc18ae8d$var$uncurryThis([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $3b33b5b5cc18ae8d$var$objectAssign = !$3b33b5b5cc18ae8d$var$$assign || $3b33b5b5cc18ae8d$var$fails$1(function() {
    // should have correct order of operations (Edge bug)
    if ($3b33b5b5cc18ae8d$var$DESCRIPTORS && $3b33b5b5cc18ae8d$var$$assign({
        b: 1
    }, $3b33b5b5cc18ae8d$var$$assign($3b33b5b5cc18ae8d$var$defineProperty({}, "a", {
        enumerable: true,
        get: function() {
            $3b33b5b5cc18ae8d$var$defineProperty(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $3b33b5b5cc18ae8d$var$$assign({}, A)[symbol] != 7 || $3b33b5b5cc18ae8d$var$objectKeys($3b33b5b5cc18ae8d$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $3b33b5b5cc18ae8d$var$toObject(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $3b33b5b5cc18ae8d$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $3b33b5b5cc18ae8d$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $3b33b5b5cc18ae8d$var$IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? $3b33b5b5cc18ae8d$var$concat($3b33b5b5cc18ae8d$var$objectKeys(S), getOwnPropertySymbols(S)) : $3b33b5b5cc18ae8d$var$objectKeys(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$3b33b5b5cc18ae8d$var$DESCRIPTORS || $3b33b5b5cc18ae8d$var$call$1(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $3b33b5b5cc18ae8d$var$$assign;
var $3b33b5b5cc18ae8d$var$$ = $3b33b5b5cc18ae8d$var$_export;
var $3b33b5b5cc18ae8d$var$assign = $3b33b5b5cc18ae8d$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$3b33b5b5cc18ae8d$var$$({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $3b33b5b5cc18ae8d$var$assign
}, {
    assign: $3b33b5b5cc18ae8d$var$assign
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $3b33b5b5cc18ae8d$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
var $3b33b5b5cc18ae8d$var$wellKnownSymbol$1 = $3b33b5b5cc18ae8d$var$wellKnownSymbol$3;
var $3b33b5b5cc18ae8d$var$TO_STRING_TAG$1 = $3b33b5b5cc18ae8d$var$wellKnownSymbol$1("toStringTag");
var $3b33b5b5cc18ae8d$var$test = {};
$3b33b5b5cc18ae8d$var$test[$3b33b5b5cc18ae8d$var$TO_STRING_TAG$1] = "z";
var $3b33b5b5cc18ae8d$var$toStringTagSupport = String($3b33b5b5cc18ae8d$var$test) === "[object z]";
var $3b33b5b5cc18ae8d$var$TO_STRING_TAG_SUPPORT = $3b33b5b5cc18ae8d$var$toStringTagSupport;
var $3b33b5b5cc18ae8d$var$isCallable = $3b33b5b5cc18ae8d$var$isCallable$b;
var $3b33b5b5cc18ae8d$var$classofRaw = $3b33b5b5cc18ae8d$var$classofRaw$1;
var $3b33b5b5cc18ae8d$var$wellKnownSymbol = $3b33b5b5cc18ae8d$var$wellKnownSymbol$3;
var $3b33b5b5cc18ae8d$var$TO_STRING_TAG = $3b33b5b5cc18ae8d$var$wellKnownSymbol("toStringTag");
var $3b33b5b5cc18ae8d$var$$Object = Object;
// ES3 wrong here
var $3b33b5b5cc18ae8d$var$CORRECT_ARGUMENTS = $3b33b5b5cc18ae8d$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $3b33b5b5cc18ae8d$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $3b33b5b5cc18ae8d$var$classof$1 = $3b33b5b5cc18ae8d$var$TO_STRING_TAG_SUPPORT ? $3b33b5b5cc18ae8d$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $3b33b5b5cc18ae8d$var$tryGet(O = $3b33b5b5cc18ae8d$var$$Object(it), $3b33b5b5cc18ae8d$var$TO_STRING_TAG)) == "string" ? tag : $3b33b5b5cc18ae8d$var$CORRECT_ARGUMENTS ? $3b33b5b5cc18ae8d$var$classofRaw(O) : (result = $3b33b5b5cc18ae8d$var$classofRaw(O)) == "Object" && $3b33b5b5cc18ae8d$var$isCallable(O.callee) ? "Arguments" : result;
};
var $3b33b5b5cc18ae8d$var$classof = $3b33b5b5cc18ae8d$var$classof$1;
var $3b33b5b5cc18ae8d$var$$String = String;
var $3b33b5b5cc18ae8d$var$toString = function(argument) {
    if ($3b33b5b5cc18ae8d$var$classof(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $3b33b5b5cc18ae8d$var$$String(argument);
};
var $3b33b5b5cc18ae8d$var$anObject$1 = $3b33b5b5cc18ae8d$var$anObject$4;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $3b33b5b5cc18ae8d$var$regexpFlags = function() {
    var that = $3b33b5b5cc18ae8d$var$anObject$1(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $3b33b5b5cc18ae8d$var$call = $3b33b5b5cc18ae8d$var$functionCall;
var $3b33b5b5cc18ae8d$var$hasOwn = $3b33b5b5cc18ae8d$var$hasOwnProperty_1;
var $3b33b5b5cc18ae8d$var$isPrototypeOf = $3b33b5b5cc18ae8d$var$objectIsPrototypeOf;
var $3b33b5b5cc18ae8d$var$regExpFlags = $3b33b5b5cc18ae8d$var$regexpFlags;
var $3b33b5b5cc18ae8d$var$RegExpPrototype$1 = RegExp.prototype;
var $3b33b5b5cc18ae8d$var$regexpGetFlags = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $3b33b5b5cc18ae8d$var$RegExpPrototype$1) && !$3b33b5b5cc18ae8d$var$hasOwn(R, "flags") && $3b33b5b5cc18ae8d$var$isPrototypeOf($3b33b5b5cc18ae8d$var$RegExpPrototype$1, R) ? $3b33b5b5cc18ae8d$var$call($3b33b5b5cc18ae8d$var$regExpFlags, R) : flags;
};
var $3b33b5b5cc18ae8d$var$PROPER_FUNCTION_NAME = $3b33b5b5cc18ae8d$var$functionName.PROPER;
var $3b33b5b5cc18ae8d$var$defineBuiltIn = $3b33b5b5cc18ae8d$var$defineBuiltIn$2;
var $3b33b5b5cc18ae8d$var$anObject = $3b33b5b5cc18ae8d$var$anObject$4;
var $3b33b5b5cc18ae8d$var$$toString = $3b33b5b5cc18ae8d$var$toString;
var $3b33b5b5cc18ae8d$var$fails = $3b33b5b5cc18ae8d$var$fails$a;
var $3b33b5b5cc18ae8d$var$getRegExpFlags = $3b33b5b5cc18ae8d$var$regexpGetFlags;
var $3b33b5b5cc18ae8d$var$TO_STRING = "toString";
var $3b33b5b5cc18ae8d$var$RegExpPrototype = RegExp.prototype;
var $3b33b5b5cc18ae8d$var$n$ToString = $3b33b5b5cc18ae8d$var$RegExpPrototype[$3b33b5b5cc18ae8d$var$TO_STRING];
var $3b33b5b5cc18ae8d$var$NOT_GENERIC = $3b33b5b5cc18ae8d$var$fails(function() {
    return $3b33b5b5cc18ae8d$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $3b33b5b5cc18ae8d$var$INCORRECT_NAME = $3b33b5b5cc18ae8d$var$PROPER_FUNCTION_NAME && $3b33b5b5cc18ae8d$var$n$ToString.name != $3b33b5b5cc18ae8d$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($3b33b5b5cc18ae8d$var$NOT_GENERIC || $3b33b5b5cc18ae8d$var$INCORRECT_NAME) $3b33b5b5cc18ae8d$var$defineBuiltIn(RegExp.prototype, $3b33b5b5cc18ae8d$var$TO_STRING, function toString() {
    var R = $3b33b5b5cc18ae8d$var$anObject(this);
    var pattern = $3b33b5b5cc18ae8d$var$$toString(R.source);
    var flags = $3b33b5b5cc18ae8d$var$$toString($3b33b5b5cc18ae8d$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
const $3b33b5b5cc18ae8d$var$initHereWallet = (config)=>$3b33b5b5cc18ae8d$var$__awaiter(void 0, void 0, void 0, function*() {
        const { store: store, logger: logger, emitter: emitter, options: options, defaultProvider: defaultProvider, defaultStrategy: defaultStrategy } = config;
        const here = new (0, $329a9076209dab3d$exports.HereWallet)({
            networkId: options.network.networkId,
            nodeUrl: options.network.nodeUrl,
            defaultProvider: defaultProvider,
            defaultStrategy: defaultStrategy
        });
        function getAccounts() {
            return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                logger.log("HereWallet:getAccounts");
                const accountIds = yield here.getAccounts();
                const accounts = [];
                for(let i = 0; i < accountIds.length; i++)accounts.push({
                    accountId: accountIds[i],
                    publicKey: (yield here.signer.getPublicKey(accountIds[i], options.network.networkId)).toString()
                });
                return accounts;
            });
        }
        return {
            get networkId () {
                return here.networkId;
            },
            buildImportAccountsUrl () {
                return `https://my.herewallet.app/import?network=${options.network.networkId}`;
            },
            account (id) {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:account");
                    return yield here.account(id);
                });
            },
            switchAccount (id) {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:switchAccount");
                    yield here.switchAccount(id);
                });
            },
            getAccountId () {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:getAccountId");
                    return yield here.getAccountId();
                });
            },
            isSignedIn () {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:isSignedIn");
                    return yield here.isSignedIn();
                });
            },
            signIn (data) {
                var _a;
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:signIn");
                    const isInjected = yield (0, $329a9076209dab3d$exports.waitInjectedHereWallet);
                    if (!isInjected) {
                        const contractId = data.contractId !== "" ? data.contractId : undefined;
                        yield here.signIn(Object.assign(Object.assign({}, data), {
                            contractId: contractId
                        }));
                    }
                    emitter.emit("signedIn", {
                        contractId: data.contractId,
                        methodNames: (_a = data.methodNames) !== null && _a !== void 0 ? _a : [],
                        accounts: yield getAccounts()
                    });
                    return yield getAccounts();
                });
            },
            getHereBalance () {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:getHereBalance");
                    return yield here.getHereBalance();
                });
            },
            getAvailableBalance () {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:getAvailableBalance");
                    return yield here.getAvailableBalance();
                });
            },
            signOut () {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:signOut");
                    yield here.signOut();
                });
            },
            getAccounts () {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    return getAccounts();
                });
            },
            signAndSendTransaction (data) {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:signAndSendTransaction", data);
                    const { contract: contract } = store.getState();
                    return yield here.signAndSendTransaction(Object.assign({
                        receiverId: contract === null || contract === void 0 ? void 0 : contract.contractId
                    }, data));
                });
            },
            verifyOwner () {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    throw Error("HereWallet:verifyOwner is deprecated, use signMessage method with implementation NEP0413 Standard");
                });
            },
            signMessage (data) {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:signMessage", data);
                    return yield here.signMessage(data);
                });
            },
            signAndSendTransactions (data) {
                return $3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("HereWallet:signAndSendTransactions", data);
                    return yield here.signAndSendTransactions(data);
                });
            }
        };
    });
var $3b33b5b5cc18ae8d$var$icon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS43MzM1IDExLjY4MzFMMjEuNzA4OSA4TDI0LjI5ODMgMTYuNjc2NkwyMC40MTYgMTQuOTIxNUwxOS43MzM1IDExLjY4MzFaTTUuNzYzODggMTUuNTQwOUwzLjc1NTYyIDE5LjE2MjFMOS44OTYwNSAyMi4xNjYxTDE4LjM0NzMgMjEuNTgyOEw1Ljc2Mzg4IDE1LjU0MDlaTTQuNjQ0NjQgMjIuMzY5NEwyLjY0ODY1IDI1Ljk3MTNMMTQuOTA4MyAzMi4wNTc1TDM1LjMzODggMzAuODE3NEwzNy4zMzQ4IDI3LjIxNTRMMTYuOTA0MyAyOC40NTU3TDQuNjQ0NjQgMjIuMzY5NFoiIGZpbGw9IiMyQzMwMzQiLz4KPHBhdGggZD0iTTM3LjMzNTkgMjcuMjE1N0wxNi45MTEyIDI4LjQ1NjFMNC41NDYzMyAyMi4zNTU0TDE3LjkzNTggMjEuNTQ1M0w1Ljc2Mzg3IDE1LjU0MDlMMTEuNzQxIDEwLjQ3ODZMMjQuMTQwMSAxNi41NzYzTDIxLjcwOSA4TDMzLjU1NyAxMy44MUwzNy4zMzU5IDI3LjIxNTdaIiBmaWxsPSIjRkRCRjFDIi8+Cjwvc3ZnPgo=";
function $3b33b5b5cc18ae8d$export$63a96487f02e71cb({ deprecated: deprecated = false, iconUrl: iconUrl = $3b33b5b5cc18ae8d$var$icon, defaultStrategy: defaultStrategy, defaultProvider: defaultProvider } = {}) {
    return ()=>$3b33b5b5cc18ae8d$var$__awaiter(this, void 0, void 0, function*() {
            const isInjected = yield (0, $329a9076209dab3d$exports.waitInjectedHereWallet);
            return {
                id: "here-wallet",
                type: "injected",
                metadata: {
                    name: "Here Wallet",
                    description: "Mobile wallet for NEAR Protocol",
                    useUrlAccountImport: true,
                    downloadUrl: "https://herewallet.app",
                    topLevelInjected: isInjected != null,
                    iconUrl: iconUrl,
                    deprecated: deprecated,
                    available: true
                },
                init: (config)=>$3b33b5b5cc18ae8d$var$initHereWallet(Object.assign(Object.assign({}, config), {
                        defaultStrategy: defaultStrategy,
                        defaultProvider: defaultProvider
                    }))
            };
        });
}



var $k4rlt = parcelRequire("k4rlt");

var $dEXSZ = parcelRequire("dEXSZ");

var $k4rlt = parcelRequire("k4rlt");
const { transactions: $5aa677c457ee63c9$var$transactions, utils: $5aa677c457ee63c9$var$utils } = $k4rlt;
const $5aa677c457ee63c9$var$getAccessKey = (permission)=>{
    if (permission === "FullAccess") return $5aa677c457ee63c9$var$transactions.fullAccessKey();
    const { receiverId: receiverId, methodNames: methodNames = [] } = permission;
    const allowance = permission.allowance ? new (0, $dEXSZ.BN)(permission.allowance) : undefined;
    return $5aa677c457ee63c9$var$transactions.functionCallAccessKey(receiverId, methodNames, allowance);
};
const $5aa677c457ee63c9$export$309c7a02b0b0bc62 = (action)=>{
    switch(action.type){
        case "CreateAccount":
            return $5aa677c457ee63c9$var$transactions.createAccount();
        case "DeployContract":
            {
                const { code: code } = action.params;
                return $5aa677c457ee63c9$var$transactions.deployContract(code);
            }
        case "FunctionCall":
            {
                const { methodName: methodName, args: args, gas: gas, deposit: deposit } = action.params;
                return $5aa677c457ee63c9$var$transactions.functionCall(methodName, args, new (0, $dEXSZ.BN)(gas), new (0, $dEXSZ.BN)(deposit));
            }
        case "Transfer":
            {
                const { deposit: deposit } = action.params;
                return $5aa677c457ee63c9$var$transactions.transfer(new (0, $dEXSZ.BN)(deposit));
            }
        case "Stake":
            {
                const { stake: stake, publicKey: publicKey } = action.params;
                return $5aa677c457ee63c9$var$transactions.stake(new (0, $dEXSZ.BN)(stake), $5aa677c457ee63c9$var$utils.PublicKey.from(publicKey));
            }
        case "AddKey":
            {
                const { publicKey: publicKey, accessKey: accessKey } = action.params;
                return $5aa677c457ee63c9$var$transactions.addKey($5aa677c457ee63c9$var$utils.PublicKey.from(publicKey), // TODO: Use accessKey.nonce? near-api-js seems to think 0 is fine?
                $5aa677c457ee63c9$var$getAccessKey(accessKey.permission));
            }
        case "DeleteKey":
            {
                const { publicKey: publicKey } = action.params;
                return $5aa677c457ee63c9$var$transactions.deleteKey($5aa677c457ee63c9$var$utils.PublicKey.from(publicKey));
            }
        case "DeleteAccount":
            {
                const { beneficiaryId: beneficiaryId } = action.params;
                return $5aa677c457ee63c9$var$transactions.deleteAccount(beneficiaryId);
            }
        default:
            throw new Error("Invalid action type");
    }
};
var $5aa677c457ee63c9$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $5aa677c457ee63c9$var$fails$d = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $5aa677c457ee63c9$var$fails$c = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$functionBindNative = !$5aa677c457ee63c9$var$fails$c(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $5aa677c457ee63c9$var$NATIVE_BIND$3 = $5aa677c457ee63c9$var$functionBindNative;
var $5aa677c457ee63c9$var$FunctionPrototype$2 = Function.prototype;
var $5aa677c457ee63c9$var$bind$5 = $5aa677c457ee63c9$var$FunctionPrototype$2.bind;
var $5aa677c457ee63c9$var$call$e = $5aa677c457ee63c9$var$FunctionPrototype$2.call;
var $5aa677c457ee63c9$var$uncurryThis$d = $5aa677c457ee63c9$var$NATIVE_BIND$3 && $5aa677c457ee63c9$var$bind$5.bind($5aa677c457ee63c9$var$call$e, $5aa677c457ee63c9$var$call$e);
var $5aa677c457ee63c9$var$functionUncurryThis = $5aa677c457ee63c9$var$NATIVE_BIND$3 ? function(fn) {
    return fn && $5aa677c457ee63c9$var$uncurryThis$d(fn);
} : function(fn) {
    return fn && function() {
        return $5aa677c457ee63c9$var$call$e.apply(fn, arguments);
    };
};
var $5aa677c457ee63c9$var$uncurryThis$c = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$toString$2 = $5aa677c457ee63c9$var$uncurryThis$c({}.toString);
var $5aa677c457ee63c9$var$stringSlice = $5aa677c457ee63c9$var$uncurryThis$c("".slice);
var $5aa677c457ee63c9$var$classofRaw$1 = function(it) {
    return $5aa677c457ee63c9$var$stringSlice($5aa677c457ee63c9$var$toString$2(it), 8, -1);
};
var $5aa677c457ee63c9$var$uncurryThis$b = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$fails$b = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$classof$5 = $5aa677c457ee63c9$var$classofRaw$1;
var $5aa677c457ee63c9$var$$Object$4 = Object;
var $5aa677c457ee63c9$var$split = $5aa677c457ee63c9$var$uncurryThis$b("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $5aa677c457ee63c9$var$indexedObject = $5aa677c457ee63c9$var$fails$b(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$5aa677c457ee63c9$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $5aa677c457ee63c9$var$classof$5(it) == "String" ? $5aa677c457ee63c9$var$split(it, "") : $5aa677c457ee63c9$var$$Object$4(it);
} : $5aa677c457ee63c9$var$$Object$4;
var $5aa677c457ee63c9$var$$TypeError$b = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $5aa677c457ee63c9$var$requireObjectCoercible$2 = function(it) {
    if (it == undefined) throw $5aa677c457ee63c9$var$$TypeError$b("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $5aa677c457ee63c9$var$IndexedObject = $5aa677c457ee63c9$var$indexedObject;
var $5aa677c457ee63c9$var$requireObjectCoercible$1 = $5aa677c457ee63c9$var$requireObjectCoercible$2;
var $5aa677c457ee63c9$var$toIndexedObject$5 = function(it) {
    return $5aa677c457ee63c9$var$IndexedObject($5aa677c457ee63c9$var$requireObjectCoercible$1(it));
};
var $5aa677c457ee63c9$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $5aa677c457ee63c9$var$global$j = // eslint-disable-next-line es-x/no-global-this -- safe
$5aa677c457ee63c9$var$check(typeof globalThis == "object" && globalThis) || $5aa677c457ee63c9$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$5aa677c457ee63c9$var$check(typeof self == "object" && self) || $5aa677c457ee63c9$var$check(typeof $5aa677c457ee63c9$var$commonjsGlobal == "object" && $5aa677c457ee63c9$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $5aa677c457ee63c9$var$shared$3 = {
    exports: {}
};
var $5aa677c457ee63c9$var$global$i = $5aa677c457ee63c9$var$global$j;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5aa677c457ee63c9$var$defineProperty$4 = Object.defineProperty;
var $5aa677c457ee63c9$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $5aa677c457ee63c9$var$defineProperty$4($5aa677c457ee63c9$var$global$i, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $5aa677c457ee63c9$var$global$i[key] = value;
    }
    return value;
};
var $5aa677c457ee63c9$var$global$h = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$defineGlobalProperty$2 = $5aa677c457ee63c9$var$defineGlobalProperty$3;
var $5aa677c457ee63c9$var$SHARED = "__core-js_shared__";
var $5aa677c457ee63c9$var$store$3 = $5aa677c457ee63c9$var$global$h[$5aa677c457ee63c9$var$SHARED] || $5aa677c457ee63c9$var$defineGlobalProperty$2($5aa677c457ee63c9$var$SHARED, {});
var $5aa677c457ee63c9$var$sharedStore = $5aa677c457ee63c9$var$store$3;
var $5aa677c457ee63c9$var$store$2 = $5aa677c457ee63c9$var$sharedStore;
($5aa677c457ee63c9$var$shared$3.exports = function(key, value) {
    return $5aa677c457ee63c9$var$store$2[key] || ($5aa677c457ee63c9$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $5aa677c457ee63c9$var$requireObjectCoercible = $5aa677c457ee63c9$var$requireObjectCoercible$2;
var $5aa677c457ee63c9$var$$Object$3 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $5aa677c457ee63c9$var$toObject$2 = function(argument) {
    return $5aa677c457ee63c9$var$$Object$3($5aa677c457ee63c9$var$requireObjectCoercible(argument));
};
var $5aa677c457ee63c9$var$uncurryThis$a = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$toObject$1 = $5aa677c457ee63c9$var$toObject$2;
var $5aa677c457ee63c9$var$hasOwnProperty = $5aa677c457ee63c9$var$uncurryThis$a({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $5aa677c457ee63c9$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $5aa677c457ee63c9$var$hasOwnProperty($5aa677c457ee63c9$var$toObject$1(it), key);
};
var $5aa677c457ee63c9$var$uncurryThis$9 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$id = 0;
var $5aa677c457ee63c9$var$postfix = Math.random();
var $5aa677c457ee63c9$var$toString$1 = $5aa677c457ee63c9$var$uncurryThis$9(1.0.toString);
var $5aa677c457ee63c9$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $5aa677c457ee63c9$var$toString$1(++$5aa677c457ee63c9$var$id + $5aa677c457ee63c9$var$postfix, 36);
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $5aa677c457ee63c9$var$isCallable$k = function(argument) {
    return typeof argument == "function";
};
var $5aa677c457ee63c9$var$global$g = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$isCallable$j = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$aFunction = function(argument) {
    return $5aa677c457ee63c9$var$isCallable$j(argument) ? argument : undefined;
};
var $5aa677c457ee63c9$var$getBuiltIn$8 = function(namespace, method) {
    return arguments.length < 2 ? $5aa677c457ee63c9$var$aFunction($5aa677c457ee63c9$var$global$g[namespace]) : $5aa677c457ee63c9$var$global$g[namespace] && $5aa677c457ee63c9$var$global$g[namespace][method];
};
var $5aa677c457ee63c9$var$getBuiltIn$7 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$engineUserAgent = $5aa677c457ee63c9$var$getBuiltIn$7("navigator", "userAgent") || "";
var $5aa677c457ee63c9$var$global$f = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$userAgent$3 = $5aa677c457ee63c9$var$engineUserAgent;
var $5aa677c457ee63c9$var$process$3 = $5aa677c457ee63c9$var$global$f.process;
var $5aa677c457ee63c9$var$Deno$1 = $5aa677c457ee63c9$var$global$f.Deno;
var $5aa677c457ee63c9$var$versions = $5aa677c457ee63c9$var$process$3 && $5aa677c457ee63c9$var$process$3.versions || $5aa677c457ee63c9$var$Deno$1 && $5aa677c457ee63c9$var$Deno$1.version;
var $5aa677c457ee63c9$var$v8 = $5aa677c457ee63c9$var$versions && $5aa677c457ee63c9$var$versions.v8;
var $5aa677c457ee63c9$var$match, $5aa677c457ee63c9$var$version;
if ($5aa677c457ee63c9$var$v8) {
    $5aa677c457ee63c9$var$match = $5aa677c457ee63c9$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $5aa677c457ee63c9$var$version = $5aa677c457ee63c9$var$match[0] > 0 && $5aa677c457ee63c9$var$match[0] < 4 ? 1 : +($5aa677c457ee63c9$var$match[0] + $5aa677c457ee63c9$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$5aa677c457ee63c9$var$version && $5aa677c457ee63c9$var$userAgent$3) {
    $5aa677c457ee63c9$var$match = $5aa677c457ee63c9$var$userAgent$3.match(/Edge\/(\d+)/);
    if (!$5aa677c457ee63c9$var$match || $5aa677c457ee63c9$var$match[1] >= 74) {
        $5aa677c457ee63c9$var$match = $5aa677c457ee63c9$var$userAgent$3.match(/Chrome\/(\d+)/);
        if ($5aa677c457ee63c9$var$match) $5aa677c457ee63c9$var$version = +$5aa677c457ee63c9$var$match[1];
    }
}
var $5aa677c457ee63c9$var$engineV8Version = $5aa677c457ee63c9$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $5aa677c457ee63c9$var$V8_VERSION$1 = $5aa677c457ee63c9$var$engineV8Version;
var $5aa677c457ee63c9$var$fails$a = $5aa677c457ee63c9$var$fails$d;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $5aa677c457ee63c9$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$5aa677c457ee63c9$var$fails$a(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $5aa677c457ee63c9$var$V8_VERSION$1 && $5aa677c457ee63c9$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $5aa677c457ee63c9$var$NATIVE_SYMBOL$1 = $5aa677c457ee63c9$var$nativeSymbol;
var $5aa677c457ee63c9$var$useSymbolAsUid = $5aa677c457ee63c9$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $5aa677c457ee63c9$var$global$e = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$shared$2 = $5aa677c457ee63c9$var$shared$3.exports;
var $5aa677c457ee63c9$var$hasOwn$a = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$uid$1 = $5aa677c457ee63c9$var$uid$2;
var $5aa677c457ee63c9$var$NATIVE_SYMBOL = $5aa677c457ee63c9$var$nativeSymbol;
var $5aa677c457ee63c9$var$USE_SYMBOL_AS_UID$1 = $5aa677c457ee63c9$var$useSymbolAsUid;
var $5aa677c457ee63c9$var$WellKnownSymbolsStore = $5aa677c457ee63c9$var$shared$2("wks");
var $5aa677c457ee63c9$var$Symbol$1 = $5aa677c457ee63c9$var$global$e.Symbol;
var $5aa677c457ee63c9$var$symbolFor = $5aa677c457ee63c9$var$Symbol$1 && $5aa677c457ee63c9$var$Symbol$1["for"];
var $5aa677c457ee63c9$var$createWellKnownSymbol = $5aa677c457ee63c9$var$USE_SYMBOL_AS_UID$1 ? $5aa677c457ee63c9$var$Symbol$1 : $5aa677c457ee63c9$var$Symbol$1 && $5aa677c457ee63c9$var$Symbol$1.withoutSetter || $5aa677c457ee63c9$var$uid$1;
var $5aa677c457ee63c9$var$wellKnownSymbol$e = function(name) {
    if (!$5aa677c457ee63c9$var$hasOwn$a($5aa677c457ee63c9$var$WellKnownSymbolsStore, name) || !($5aa677c457ee63c9$var$NATIVE_SYMBOL || typeof $5aa677c457ee63c9$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($5aa677c457ee63c9$var$NATIVE_SYMBOL && $5aa677c457ee63c9$var$hasOwn$a($5aa677c457ee63c9$var$Symbol$1, name)) $5aa677c457ee63c9$var$WellKnownSymbolsStore[name] = $5aa677c457ee63c9$var$Symbol$1[name];
        else if ($5aa677c457ee63c9$var$USE_SYMBOL_AS_UID$1 && $5aa677c457ee63c9$var$symbolFor) $5aa677c457ee63c9$var$WellKnownSymbolsStore[name] = $5aa677c457ee63c9$var$symbolFor(description);
        else $5aa677c457ee63c9$var$WellKnownSymbolsStore[name] = $5aa677c457ee63c9$var$createWellKnownSymbol(description);
    }
    return $5aa677c457ee63c9$var$WellKnownSymbolsStore[name];
};
var $5aa677c457ee63c9$var$isCallable$i = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isObject$7 = function(it) {
    return typeof it == "object" ? it !== null : $5aa677c457ee63c9$var$isCallable$i(it);
};
var $5aa677c457ee63c9$var$isObject$6 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$$String$3 = String;
var $5aa677c457ee63c9$var$$TypeError$a = TypeError;
// `Assert: Type(argument) is Object`
var $5aa677c457ee63c9$var$anObject$c = function(argument) {
    if ($5aa677c457ee63c9$var$isObject$6(argument)) return argument;
    throw $5aa677c457ee63c9$var$$TypeError$a($5aa677c457ee63c9$var$$String$3(argument) + " is not an object");
};
var $5aa677c457ee63c9$var$objectDefineProperties = {};
var $5aa677c457ee63c9$var$fails$9 = $5aa677c457ee63c9$var$fails$d;
// Detect IE8's incomplete defineProperty implementation
var $5aa677c457ee63c9$var$descriptors = !$5aa677c457ee63c9$var$fails$9(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $5aa677c457ee63c9$var$DESCRIPTORS$9 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$fails$8 = $5aa677c457ee63c9$var$fails$d;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $5aa677c457ee63c9$var$v8PrototypeDefineBug = $5aa677c457ee63c9$var$DESCRIPTORS$9 && $5aa677c457ee63c9$var$fails$8(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $5aa677c457ee63c9$var$objectDefineProperty = {};
var $5aa677c457ee63c9$var$global$d = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$isObject$5 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$document$3 = $5aa677c457ee63c9$var$global$d.document;
// typeof document.createElement is 'object' in old IE
var $5aa677c457ee63c9$var$EXISTS$1 = $5aa677c457ee63c9$var$isObject$5($5aa677c457ee63c9$var$document$3) && $5aa677c457ee63c9$var$isObject$5($5aa677c457ee63c9$var$document$3.createElement);
var $5aa677c457ee63c9$var$documentCreateElement$2 = function(it) {
    return $5aa677c457ee63c9$var$EXISTS$1 ? $5aa677c457ee63c9$var$document$3.createElement(it) : {};
};
var $5aa677c457ee63c9$var$DESCRIPTORS$8 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$fails$7 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$createElement$1 = $5aa677c457ee63c9$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $5aa677c457ee63c9$var$ie8DomDefine = !$5aa677c457ee63c9$var$DESCRIPTORS$8 && !$5aa677c457ee63c9$var$fails$7(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($5aa677c457ee63c9$var$createElement$1("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $5aa677c457ee63c9$var$NATIVE_BIND$2 = $5aa677c457ee63c9$var$functionBindNative;
var $5aa677c457ee63c9$var$call$d = Function.prototype.call;
var $5aa677c457ee63c9$var$functionCall = $5aa677c457ee63c9$var$NATIVE_BIND$2 ? $5aa677c457ee63c9$var$call$d.bind($5aa677c457ee63c9$var$call$d) : function() {
    return $5aa677c457ee63c9$var$call$d.apply($5aa677c457ee63c9$var$call$d, arguments);
};
var $5aa677c457ee63c9$var$uncurryThis$8 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$objectIsPrototypeOf = $5aa677c457ee63c9$var$uncurryThis$8({}.isPrototypeOf);
var $5aa677c457ee63c9$var$getBuiltIn$6 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$isCallable$h = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isPrototypeOf$3 = $5aa677c457ee63c9$var$objectIsPrototypeOf;
var $5aa677c457ee63c9$var$USE_SYMBOL_AS_UID = $5aa677c457ee63c9$var$useSymbolAsUid;
var $5aa677c457ee63c9$var$$Object$2 = Object;
var $5aa677c457ee63c9$var$isSymbol$2 = $5aa677c457ee63c9$var$USE_SYMBOL_AS_UID ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $5aa677c457ee63c9$var$getBuiltIn$6("Symbol");
    return $5aa677c457ee63c9$var$isCallable$h($Symbol) && $5aa677c457ee63c9$var$isPrototypeOf$3($Symbol.prototype, $5aa677c457ee63c9$var$$Object$2(it));
};
var $5aa677c457ee63c9$var$$String$2 = String;
var $5aa677c457ee63c9$var$tryToString$4 = function(argument) {
    try {
        return $5aa677c457ee63c9$var$$String$2(argument);
    } catch (error) {
        return "Object";
    }
};
var $5aa677c457ee63c9$var$isCallable$g = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$tryToString$3 = $5aa677c457ee63c9$var$tryToString$4;
var $5aa677c457ee63c9$var$$TypeError$9 = TypeError;
// `Assert: IsCallable(argument) is true`
var $5aa677c457ee63c9$var$aCallable$7 = function(argument) {
    if ($5aa677c457ee63c9$var$isCallable$g(argument)) return argument;
    throw $5aa677c457ee63c9$var$$TypeError$9($5aa677c457ee63c9$var$tryToString$3(argument) + " is not a function");
};
var $5aa677c457ee63c9$var$aCallable$6 = $5aa677c457ee63c9$var$aCallable$7;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $5aa677c457ee63c9$var$getMethod$3 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $5aa677c457ee63c9$var$aCallable$6(func);
};
var $5aa677c457ee63c9$var$call$c = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$isCallable$f = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isObject$4 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$$TypeError$8 = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $5aa677c457ee63c9$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $5aa677c457ee63c9$var$isCallable$f(fn = input.toString) && !$5aa677c457ee63c9$var$isObject$4(val = $5aa677c457ee63c9$var$call$c(fn, input))) return val;
    if ($5aa677c457ee63c9$var$isCallable$f(fn = input.valueOf) && !$5aa677c457ee63c9$var$isObject$4(val = $5aa677c457ee63c9$var$call$c(fn, input))) return val;
    if (pref !== "string" && $5aa677c457ee63c9$var$isCallable$f(fn = input.toString) && !$5aa677c457ee63c9$var$isObject$4(val = $5aa677c457ee63c9$var$call$c(fn, input))) return val;
    throw $5aa677c457ee63c9$var$$TypeError$8("Can't convert object to primitive value");
};
var $5aa677c457ee63c9$var$call$b = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$isObject$3 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$isSymbol$1 = $5aa677c457ee63c9$var$isSymbol$2;
var $5aa677c457ee63c9$var$getMethod$2 = $5aa677c457ee63c9$var$getMethod$3;
var $5aa677c457ee63c9$var$ordinaryToPrimitive = $5aa677c457ee63c9$var$ordinaryToPrimitive$1;
var $5aa677c457ee63c9$var$wellKnownSymbol$d = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$$TypeError$7 = TypeError;
var $5aa677c457ee63c9$var$TO_PRIMITIVE = $5aa677c457ee63c9$var$wellKnownSymbol$d("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $5aa677c457ee63c9$var$toPrimitive$1 = function(input, pref) {
    if (!$5aa677c457ee63c9$var$isObject$3(input) || $5aa677c457ee63c9$var$isSymbol$1(input)) return input;
    var exoticToPrim = $5aa677c457ee63c9$var$getMethod$2(input, $5aa677c457ee63c9$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $5aa677c457ee63c9$var$call$b(exoticToPrim, input, pref);
        if (!$5aa677c457ee63c9$var$isObject$3(result) || $5aa677c457ee63c9$var$isSymbol$1(result)) return result;
        throw $5aa677c457ee63c9$var$$TypeError$7("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $5aa677c457ee63c9$var$ordinaryToPrimitive(input, pref);
};
var $5aa677c457ee63c9$var$toPrimitive = $5aa677c457ee63c9$var$toPrimitive$1;
var $5aa677c457ee63c9$var$isSymbol = $5aa677c457ee63c9$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $5aa677c457ee63c9$var$toPropertyKey$2 = function(argument) {
    var key = $5aa677c457ee63c9$var$toPrimitive(argument, "string");
    return $5aa677c457ee63c9$var$isSymbol(key) ? key : key + "";
};
var $5aa677c457ee63c9$var$DESCRIPTORS$7 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$IE8_DOM_DEFINE$1 = $5aa677c457ee63c9$var$ie8DomDefine;
var $5aa677c457ee63c9$var$V8_PROTOTYPE_DEFINE_BUG$1 = $5aa677c457ee63c9$var$v8PrototypeDefineBug;
var $5aa677c457ee63c9$var$anObject$b = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$toPropertyKey$1 = $5aa677c457ee63c9$var$toPropertyKey$2;
var $5aa677c457ee63c9$var$$TypeError$6 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5aa677c457ee63c9$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5aa677c457ee63c9$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
var $5aa677c457ee63c9$var$ENUMERABLE = "enumerable";
var $5aa677c457ee63c9$var$CONFIGURABLE$1 = "configurable";
var $5aa677c457ee63c9$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$5aa677c457ee63c9$var$objectDefineProperty.f = $5aa677c457ee63c9$var$DESCRIPTORS$7 ? $5aa677c457ee63c9$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $5aa677c457ee63c9$var$anObject$b(O);
    P = $5aa677c457ee63c9$var$toPropertyKey$1(P);
    $5aa677c457ee63c9$var$anObject$b(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $5aa677c457ee63c9$var$WRITABLE in Attributes && !Attributes[$5aa677c457ee63c9$var$WRITABLE]) {
        var current = $5aa677c457ee63c9$var$$getOwnPropertyDescriptor$1(O, P);
        if (current && current[$5aa677c457ee63c9$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $5aa677c457ee63c9$var$CONFIGURABLE$1 in Attributes ? Attributes[$5aa677c457ee63c9$var$CONFIGURABLE$1] : current[$5aa677c457ee63c9$var$CONFIGURABLE$1],
                enumerable: $5aa677c457ee63c9$var$ENUMERABLE in Attributes ? Attributes[$5aa677c457ee63c9$var$ENUMERABLE] : current[$5aa677c457ee63c9$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $5aa677c457ee63c9$var$$defineProperty(O, P, Attributes);
} : $5aa677c457ee63c9$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $5aa677c457ee63c9$var$anObject$b(O);
    P = $5aa677c457ee63c9$var$toPropertyKey$1(P);
    $5aa677c457ee63c9$var$anObject$b(Attributes);
    if ($5aa677c457ee63c9$var$IE8_DOM_DEFINE$1) try {
        return $5aa677c457ee63c9$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $5aa677c457ee63c9$var$$TypeError$6("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $5aa677c457ee63c9$var$ceil = Math.ceil;
var $5aa677c457ee63c9$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $5aa677c457ee63c9$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5aa677c457ee63c9$var$floor : $5aa677c457ee63c9$var$ceil)(n);
};
var $5aa677c457ee63c9$var$trunc = $5aa677c457ee63c9$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $5aa677c457ee63c9$var$toIntegerOrInfinity$2 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5aa677c457ee63c9$var$trunc(number);
};
var $5aa677c457ee63c9$var$toIntegerOrInfinity$1 = $5aa677c457ee63c9$var$toIntegerOrInfinity$2;
var $5aa677c457ee63c9$var$max = Math.max;
var $5aa677c457ee63c9$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $5aa677c457ee63c9$var$toAbsoluteIndex$1 = function(index, length) {
    var integer = $5aa677c457ee63c9$var$toIntegerOrInfinity$1(index);
    return integer < 0 ? $5aa677c457ee63c9$var$max(integer + length, 0) : $5aa677c457ee63c9$var$min$1(integer, length);
};
var $5aa677c457ee63c9$var$toIntegerOrInfinity = $5aa677c457ee63c9$var$toIntegerOrInfinity$2;
var $5aa677c457ee63c9$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $5aa677c457ee63c9$var$toLength$1 = function(argument) {
    return argument > 0 ? $5aa677c457ee63c9$var$min($5aa677c457ee63c9$var$toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $5aa677c457ee63c9$var$toLength = $5aa677c457ee63c9$var$toLength$1;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $5aa677c457ee63c9$var$lengthOfArrayLike$2 = function(obj) {
    return $5aa677c457ee63c9$var$toLength(obj.length);
};
var $5aa677c457ee63c9$var$toIndexedObject$4 = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$toAbsoluteIndex = $5aa677c457ee63c9$var$toAbsoluteIndex$1;
var $5aa677c457ee63c9$var$lengthOfArrayLike$1 = $5aa677c457ee63c9$var$lengthOfArrayLike$2;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $5aa677c457ee63c9$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $5aa677c457ee63c9$var$toIndexedObject$4($this);
        var length = $5aa677c457ee63c9$var$lengthOfArrayLike$1(O);
        var index = $5aa677c457ee63c9$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $5aa677c457ee63c9$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $5aa677c457ee63c9$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $5aa677c457ee63c9$var$createMethod(false)
};
var $5aa677c457ee63c9$var$hiddenKeys$4 = {};
var $5aa677c457ee63c9$var$uncurryThis$7 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$hasOwn$9 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$toIndexedObject$3 = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$indexOf = $5aa677c457ee63c9$var$arrayIncludes.indexOf;
var $5aa677c457ee63c9$var$hiddenKeys$3 = $5aa677c457ee63c9$var$hiddenKeys$4;
var $5aa677c457ee63c9$var$push = $5aa677c457ee63c9$var$uncurryThis$7([].push);
var $5aa677c457ee63c9$var$objectKeysInternal = function(object, names) {
    var O = $5aa677c457ee63c9$var$toIndexedObject$3(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$5aa677c457ee63c9$var$hasOwn$9($5aa677c457ee63c9$var$hiddenKeys$3, key) && $5aa677c457ee63c9$var$hasOwn$9(O, key) && $5aa677c457ee63c9$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($5aa677c457ee63c9$var$hasOwn$9(O, key = names[i++])) ~$5aa677c457ee63c9$var$indexOf(result, key) || $5aa677c457ee63c9$var$push(result, key);
    return result;
};
// IE8- don't enum bug keys
var $5aa677c457ee63c9$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $5aa677c457ee63c9$var$internalObjectKeys$1 = $5aa677c457ee63c9$var$objectKeysInternal;
var $5aa677c457ee63c9$var$enumBugKeys$2 = $5aa677c457ee63c9$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $5aa677c457ee63c9$var$objectKeys$1 = Object.keys || function keys(O) {
    return $5aa677c457ee63c9$var$internalObjectKeys$1(O, $5aa677c457ee63c9$var$enumBugKeys$2);
};
var $5aa677c457ee63c9$var$DESCRIPTORS$6 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$V8_PROTOTYPE_DEFINE_BUG = $5aa677c457ee63c9$var$v8PrototypeDefineBug;
var $5aa677c457ee63c9$var$definePropertyModule$4 = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$anObject$a = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$toIndexedObject$2 = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$objectKeys = $5aa677c457ee63c9$var$objectKeys$1;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$5aa677c457ee63c9$var$objectDefineProperties.f = $5aa677c457ee63c9$var$DESCRIPTORS$6 && !$5aa677c457ee63c9$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $5aa677c457ee63c9$var$anObject$a(O);
    var props = $5aa677c457ee63c9$var$toIndexedObject$2(Properties);
    var keys = $5aa677c457ee63c9$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$5aa677c457ee63c9$var$definePropertyModule$4.f(O, key = keys[index++], props[key]);
    return O;
};
var $5aa677c457ee63c9$var$getBuiltIn$5 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$html$2 = $5aa677c457ee63c9$var$getBuiltIn$5("document", "documentElement");
var $5aa677c457ee63c9$var$shared$1 = $5aa677c457ee63c9$var$shared$3.exports;
var $5aa677c457ee63c9$var$uid = $5aa677c457ee63c9$var$uid$2;
var $5aa677c457ee63c9$var$keys = $5aa677c457ee63c9$var$shared$1("keys");
var $5aa677c457ee63c9$var$sharedKey$3 = function(key) {
    return $5aa677c457ee63c9$var$keys[key] || ($5aa677c457ee63c9$var$keys[key] = $5aa677c457ee63c9$var$uid(key));
};
/* global ActiveXObject -- old IE, WSH */ var $5aa677c457ee63c9$var$anObject$9 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$definePropertiesModule = $5aa677c457ee63c9$var$objectDefineProperties;
var $5aa677c457ee63c9$var$enumBugKeys$1 = $5aa677c457ee63c9$var$enumBugKeys$3;
var $5aa677c457ee63c9$var$hiddenKeys$2 = $5aa677c457ee63c9$var$hiddenKeys$4;
var $5aa677c457ee63c9$var$html$1 = $5aa677c457ee63c9$var$html$2;
var $5aa677c457ee63c9$var$documentCreateElement$1 = $5aa677c457ee63c9$var$documentCreateElement$2;
var $5aa677c457ee63c9$var$sharedKey$2 = $5aa677c457ee63c9$var$sharedKey$3;
var $5aa677c457ee63c9$var$GT = ">";
var $5aa677c457ee63c9$var$LT = "<";
var $5aa677c457ee63c9$var$PROTOTYPE = "prototype";
var $5aa677c457ee63c9$var$SCRIPT = "script";
var $5aa677c457ee63c9$var$IE_PROTO$1 = $5aa677c457ee63c9$var$sharedKey$2("IE_PROTO");
var $5aa677c457ee63c9$var$EmptyConstructor = function() {};
var $5aa677c457ee63c9$var$scriptTag = function(content) {
    return $5aa677c457ee63c9$var$LT + $5aa677c457ee63c9$var$SCRIPT + $5aa677c457ee63c9$var$GT + content + $5aa677c457ee63c9$var$LT + "/" + $5aa677c457ee63c9$var$SCRIPT + $5aa677c457ee63c9$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $5aa677c457ee63c9$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($5aa677c457ee63c9$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $5aa677c457ee63c9$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $5aa677c457ee63c9$var$documentCreateElement$1("iframe");
    var JS = "java" + $5aa677c457ee63c9$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $5aa677c457ee63c9$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($5aa677c457ee63c9$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $5aa677c457ee63c9$var$activeXDocument;
var $5aa677c457ee63c9$var$NullProtoObject = function() {
    try {
        $5aa677c457ee63c9$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $5aa677c457ee63c9$var$NullProtoObject = typeof document != "undefined" ? document.domain && $5aa677c457ee63c9$var$activeXDocument ? $5aa677c457ee63c9$var$NullProtoObjectViaActiveX($5aa677c457ee63c9$var$activeXDocument) // old IE
     : $5aa677c457ee63c9$var$NullProtoObjectViaIFrame() : $5aa677c457ee63c9$var$NullProtoObjectViaActiveX($5aa677c457ee63c9$var$activeXDocument); // WSH
    var length = $5aa677c457ee63c9$var$enumBugKeys$1.length;
    while(length--)delete $5aa677c457ee63c9$var$NullProtoObject[$5aa677c457ee63c9$var$PROTOTYPE][$5aa677c457ee63c9$var$enumBugKeys$1[length]];
    return $5aa677c457ee63c9$var$NullProtoObject();
};
$5aa677c457ee63c9$var$hiddenKeys$2[$5aa677c457ee63c9$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $5aa677c457ee63c9$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $5aa677c457ee63c9$var$EmptyConstructor[$5aa677c457ee63c9$var$PROTOTYPE] = $5aa677c457ee63c9$var$anObject$9(O);
        result = new $5aa677c457ee63c9$var$EmptyConstructor();
        $5aa677c457ee63c9$var$EmptyConstructor[$5aa677c457ee63c9$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$5aa677c457ee63c9$var$IE_PROTO$1] = O;
    } else result = $5aa677c457ee63c9$var$NullProtoObject();
    return Properties === undefined ? result : $5aa677c457ee63c9$var$definePropertiesModule.f(result, Properties);
};
var $5aa677c457ee63c9$var$wellKnownSymbol$c = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$create$1 = $5aa677c457ee63c9$var$objectCreate;
var $5aa677c457ee63c9$var$defineProperty$3 = $5aa677c457ee63c9$var$objectDefineProperty.f;
var $5aa677c457ee63c9$var$UNSCOPABLES = $5aa677c457ee63c9$var$wellKnownSymbol$c("unscopables");
var $5aa677c457ee63c9$var$ArrayPrototype$1 = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($5aa677c457ee63c9$var$ArrayPrototype$1[$5aa677c457ee63c9$var$UNSCOPABLES] == undefined) $5aa677c457ee63c9$var$defineProperty$3($5aa677c457ee63c9$var$ArrayPrototype$1, $5aa677c457ee63c9$var$UNSCOPABLES, {
    configurable: true,
    value: $5aa677c457ee63c9$var$create$1(null)
});
// add a key to Array.prototype[@@unscopables]
var $5aa677c457ee63c9$var$addToUnscopables$1 = function(key) {
    $5aa677c457ee63c9$var$ArrayPrototype$1[$5aa677c457ee63c9$var$UNSCOPABLES][key] = true;
};
var $5aa677c457ee63c9$var$iterators = {};
var $5aa677c457ee63c9$var$uncurryThis$6 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$isCallable$e = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$store$1 = $5aa677c457ee63c9$var$sharedStore;
var $5aa677c457ee63c9$var$functionToString = $5aa677c457ee63c9$var$uncurryThis$6(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$5aa677c457ee63c9$var$isCallable$e($5aa677c457ee63c9$var$store$1.inspectSource)) $5aa677c457ee63c9$var$store$1.inspectSource = function(it) {
    return $5aa677c457ee63c9$var$functionToString(it);
};
var $5aa677c457ee63c9$var$inspectSource$4 = $5aa677c457ee63c9$var$store$1.inspectSource;
var $5aa677c457ee63c9$var$global$c = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$isCallable$d = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$inspectSource$3 = $5aa677c457ee63c9$var$inspectSource$4;
var $5aa677c457ee63c9$var$WeakMap$1 = $5aa677c457ee63c9$var$global$c.WeakMap;
var $5aa677c457ee63c9$var$nativeWeakMap = $5aa677c457ee63c9$var$isCallable$d($5aa677c457ee63c9$var$WeakMap$1) && /native code/.test($5aa677c457ee63c9$var$inspectSource$3($5aa677c457ee63c9$var$WeakMap$1));
var $5aa677c457ee63c9$var$createPropertyDescriptor$3 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $5aa677c457ee63c9$var$DESCRIPTORS$5 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$definePropertyModule$3 = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$createPropertyDescriptor$2 = $5aa677c457ee63c9$var$createPropertyDescriptor$3;
var $5aa677c457ee63c9$var$createNonEnumerableProperty$4 = $5aa677c457ee63c9$var$DESCRIPTORS$5 ? function(object, key, value) {
    return $5aa677c457ee63c9$var$definePropertyModule$3.f(object, key, $5aa677c457ee63c9$var$createPropertyDescriptor$2(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $5aa677c457ee63c9$var$NATIVE_WEAK_MAP = $5aa677c457ee63c9$var$nativeWeakMap;
var $5aa677c457ee63c9$var$global$b = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$uncurryThis$5 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$isObject$2 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$createNonEnumerableProperty$3 = $5aa677c457ee63c9$var$createNonEnumerableProperty$4;
var $5aa677c457ee63c9$var$hasOwn$8 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$shared = $5aa677c457ee63c9$var$sharedStore;
var $5aa677c457ee63c9$var$sharedKey$1 = $5aa677c457ee63c9$var$sharedKey$3;
var $5aa677c457ee63c9$var$hiddenKeys$1 = $5aa677c457ee63c9$var$hiddenKeys$4;
var $5aa677c457ee63c9$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $5aa677c457ee63c9$var$TypeError$2 = $5aa677c457ee63c9$var$global$b.TypeError;
var $5aa677c457ee63c9$var$WeakMap = $5aa677c457ee63c9$var$global$b.WeakMap;
var $5aa677c457ee63c9$var$set$1, $5aa677c457ee63c9$var$get, $5aa677c457ee63c9$var$has;
var $5aa677c457ee63c9$var$enforce = function(it) {
    return $5aa677c457ee63c9$var$has(it) ? $5aa677c457ee63c9$var$get(it) : $5aa677c457ee63c9$var$set$1(it, {});
};
var $5aa677c457ee63c9$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$5aa677c457ee63c9$var$isObject$2(it) || (state = $5aa677c457ee63c9$var$get(it)).type !== TYPE) throw $5aa677c457ee63c9$var$TypeError$2("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($5aa677c457ee63c9$var$NATIVE_WEAK_MAP || $5aa677c457ee63c9$var$shared.state) {
    var $5aa677c457ee63c9$var$store = $5aa677c457ee63c9$var$shared.state || ($5aa677c457ee63c9$var$shared.state = new $5aa677c457ee63c9$var$WeakMap());
    var $5aa677c457ee63c9$var$wmget = $5aa677c457ee63c9$var$uncurryThis$5($5aa677c457ee63c9$var$store.get);
    var $5aa677c457ee63c9$var$wmhas = $5aa677c457ee63c9$var$uncurryThis$5($5aa677c457ee63c9$var$store.has);
    var $5aa677c457ee63c9$var$wmset = $5aa677c457ee63c9$var$uncurryThis$5($5aa677c457ee63c9$var$store.set);
    $5aa677c457ee63c9$var$set$1 = function(it, metadata) {
        if ($5aa677c457ee63c9$var$wmhas($5aa677c457ee63c9$var$store, it)) throw new $5aa677c457ee63c9$var$TypeError$2($5aa677c457ee63c9$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5aa677c457ee63c9$var$wmset($5aa677c457ee63c9$var$store, it, metadata);
        return metadata;
    };
    $5aa677c457ee63c9$var$get = function(it) {
        return $5aa677c457ee63c9$var$wmget($5aa677c457ee63c9$var$store, it) || {};
    };
    $5aa677c457ee63c9$var$has = function(it) {
        return $5aa677c457ee63c9$var$wmhas($5aa677c457ee63c9$var$store, it);
    };
} else {
    var $5aa677c457ee63c9$var$STATE = $5aa677c457ee63c9$var$sharedKey$1("state");
    $5aa677c457ee63c9$var$hiddenKeys$1[$5aa677c457ee63c9$var$STATE] = true;
    $5aa677c457ee63c9$var$set$1 = function(it, metadata) {
        if ($5aa677c457ee63c9$var$hasOwn$8(it, $5aa677c457ee63c9$var$STATE)) throw new $5aa677c457ee63c9$var$TypeError$2($5aa677c457ee63c9$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $5aa677c457ee63c9$var$createNonEnumerableProperty$3(it, $5aa677c457ee63c9$var$STATE, metadata);
        return metadata;
    };
    $5aa677c457ee63c9$var$get = function(it) {
        return $5aa677c457ee63c9$var$hasOwn$8(it, $5aa677c457ee63c9$var$STATE) ? it[$5aa677c457ee63c9$var$STATE] : {};
    };
    $5aa677c457ee63c9$var$has = function(it) {
        return $5aa677c457ee63c9$var$hasOwn$8(it, $5aa677c457ee63c9$var$STATE);
    };
}
var $5aa677c457ee63c9$var$internalState = {
    set: $5aa677c457ee63c9$var$set$1,
    get: $5aa677c457ee63c9$var$get,
    has: $5aa677c457ee63c9$var$has,
    enforce: $5aa677c457ee63c9$var$enforce,
    getterFor: $5aa677c457ee63c9$var$getterFor
};
var $5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor = {};
var $5aa677c457ee63c9$var$objectPropertyIsEnumerable = {};
var $5aa677c457ee63c9$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5aa677c457ee63c9$var$getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $5aa677c457ee63c9$var$NASHORN_BUG = $5aa677c457ee63c9$var$getOwnPropertyDescriptor$2 && !$5aa677c457ee63c9$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$5aa677c457ee63c9$var$objectPropertyIsEnumerable.f = $5aa677c457ee63c9$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $5aa677c457ee63c9$var$getOwnPropertyDescriptor$2(this, V);
    return !!descriptor && descriptor.enumerable;
} : $5aa677c457ee63c9$var$$propertyIsEnumerable;
var $5aa677c457ee63c9$var$DESCRIPTORS$4 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$call$a = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$propertyIsEnumerableModule = $5aa677c457ee63c9$var$objectPropertyIsEnumerable;
var $5aa677c457ee63c9$var$createPropertyDescriptor$1 = $5aa677c457ee63c9$var$createPropertyDescriptor$3;
var $5aa677c457ee63c9$var$toIndexedObject$1 = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$toPropertyKey = $5aa677c457ee63c9$var$toPropertyKey$2;
var $5aa677c457ee63c9$var$hasOwn$7 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$IE8_DOM_DEFINE = $5aa677c457ee63c9$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5aa677c457ee63c9$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor.f = $5aa677c457ee63c9$var$DESCRIPTORS$4 ? $5aa677c457ee63c9$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $5aa677c457ee63c9$var$toIndexedObject$1(O);
    P = $5aa677c457ee63c9$var$toPropertyKey(P);
    if ($5aa677c457ee63c9$var$IE8_DOM_DEFINE) try {
        return $5aa677c457ee63c9$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($5aa677c457ee63c9$var$hasOwn$7(O, P)) return $5aa677c457ee63c9$var$createPropertyDescriptor$1(!$5aa677c457ee63c9$var$call$a($5aa677c457ee63c9$var$propertyIsEnumerableModule.f, O, P), O[P]);
};
var $5aa677c457ee63c9$var$makeBuiltIn$2 = {
    exports: {}
};
var $5aa677c457ee63c9$var$DESCRIPTORS$3 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$hasOwn$6 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $5aa677c457ee63c9$var$getDescriptor = $5aa677c457ee63c9$var$DESCRIPTORS$3 && Object.getOwnPropertyDescriptor;
var $5aa677c457ee63c9$var$EXISTS = $5aa677c457ee63c9$var$hasOwn$6($5aa677c457ee63c9$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $5aa677c457ee63c9$var$PROPER = $5aa677c457ee63c9$var$EXISTS && (function something() {}).name === "something";
var $5aa677c457ee63c9$var$CONFIGURABLE = $5aa677c457ee63c9$var$EXISTS && (!$5aa677c457ee63c9$var$DESCRIPTORS$3 || $5aa677c457ee63c9$var$DESCRIPTORS$3 && $5aa677c457ee63c9$var$getDescriptor($5aa677c457ee63c9$var$FunctionPrototype$1, "name").configurable);
var $5aa677c457ee63c9$var$functionName = {
    EXISTS: $5aa677c457ee63c9$var$EXISTS,
    PROPER: $5aa677c457ee63c9$var$PROPER,
    CONFIGURABLE: $5aa677c457ee63c9$var$CONFIGURABLE
};
var $5aa677c457ee63c9$var$fails$6 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$isCallable$c = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$hasOwn$5 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$DESCRIPTORS$2 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$CONFIGURABLE_FUNCTION_NAME$1 = $5aa677c457ee63c9$var$functionName.CONFIGURABLE;
var $5aa677c457ee63c9$var$inspectSource$2 = $5aa677c457ee63c9$var$inspectSource$4;
var $5aa677c457ee63c9$var$InternalStateModule$2 = $5aa677c457ee63c9$var$internalState;
var $5aa677c457ee63c9$var$enforceInternalState = $5aa677c457ee63c9$var$InternalStateModule$2.enforce;
var $5aa677c457ee63c9$var$getInternalState$1 = $5aa677c457ee63c9$var$InternalStateModule$2.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $5aa677c457ee63c9$var$defineProperty$2 = Object.defineProperty;
var $5aa677c457ee63c9$var$CONFIGURABLE_LENGTH = $5aa677c457ee63c9$var$DESCRIPTORS$2 && !$5aa677c457ee63c9$var$fails$6(function() {
    return $5aa677c457ee63c9$var$defineProperty$2(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $5aa677c457ee63c9$var$TEMPLATE = String(String).split("String");
var $5aa677c457ee63c9$var$makeBuiltIn$1 = $5aa677c457ee63c9$var$makeBuiltIn$2.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$5aa677c457ee63c9$var$hasOwn$5(value, "name") || $5aa677c457ee63c9$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($5aa677c457ee63c9$var$DESCRIPTORS$2) $5aa677c457ee63c9$var$defineProperty$2(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($5aa677c457ee63c9$var$CONFIGURABLE_LENGTH && options && $5aa677c457ee63c9$var$hasOwn$5(options, "arity") && value.length !== options.arity) $5aa677c457ee63c9$var$defineProperty$2(value, "length", {
        value: options.arity
    });
    try {
        if (options && $5aa677c457ee63c9$var$hasOwn$5(options, "constructor") && options.constructor) {
            if ($5aa677c457ee63c9$var$DESCRIPTORS$2) $5aa677c457ee63c9$var$defineProperty$2(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $5aa677c457ee63c9$var$enforceInternalState(value);
    if (!$5aa677c457ee63c9$var$hasOwn$5(state, "source")) state.source = $5aa677c457ee63c9$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $5aa677c457ee63c9$var$makeBuiltIn$1(function toString() {
    return $5aa677c457ee63c9$var$isCallable$c(this) && $5aa677c457ee63c9$var$getInternalState$1(this).source || $5aa677c457ee63c9$var$inspectSource$2(this);
}, "toString");
var $5aa677c457ee63c9$var$isCallable$b = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$definePropertyModule$2 = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$makeBuiltIn = $5aa677c457ee63c9$var$makeBuiltIn$2.exports;
var $5aa677c457ee63c9$var$defineGlobalProperty$1 = $5aa677c457ee63c9$var$defineGlobalProperty$3;
var $5aa677c457ee63c9$var$defineBuiltIn$6 = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($5aa677c457ee63c9$var$isCallable$b(value)) $5aa677c457ee63c9$var$makeBuiltIn(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $5aa677c457ee63c9$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $5aa677c457ee63c9$var$definePropertyModule$2.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $5aa677c457ee63c9$var$objectGetOwnPropertyNames = {};
var $5aa677c457ee63c9$var$internalObjectKeys = $5aa677c457ee63c9$var$objectKeysInternal;
var $5aa677c457ee63c9$var$enumBugKeys = $5aa677c457ee63c9$var$enumBugKeys$3;
var $5aa677c457ee63c9$var$hiddenKeys = $5aa677c457ee63c9$var$enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$5aa677c457ee63c9$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $5aa677c457ee63c9$var$internalObjectKeys(O, $5aa677c457ee63c9$var$hiddenKeys);
};
var $5aa677c457ee63c9$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$5aa677c457ee63c9$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $5aa677c457ee63c9$var$getBuiltIn$4 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$uncurryThis$4 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$getOwnPropertyNamesModule = $5aa677c457ee63c9$var$objectGetOwnPropertyNames;
var $5aa677c457ee63c9$var$getOwnPropertySymbolsModule = $5aa677c457ee63c9$var$objectGetOwnPropertySymbols;
var $5aa677c457ee63c9$var$anObject$8 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$concat = $5aa677c457ee63c9$var$uncurryThis$4([].concat);
// all object keys, includes non-enumerable and symbols
var $5aa677c457ee63c9$var$ownKeys$1 = $5aa677c457ee63c9$var$getBuiltIn$4("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $5aa677c457ee63c9$var$getOwnPropertyNamesModule.f($5aa677c457ee63c9$var$anObject$8(it));
    var getOwnPropertySymbols = $5aa677c457ee63c9$var$getOwnPropertySymbolsModule.f;
    return getOwnPropertySymbols ? $5aa677c457ee63c9$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};
var $5aa677c457ee63c9$var$hasOwn$4 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$ownKeys = $5aa677c457ee63c9$var$ownKeys$1;
var $5aa677c457ee63c9$var$getOwnPropertyDescriptorModule = $5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor;
var $5aa677c457ee63c9$var$definePropertyModule$1 = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $5aa677c457ee63c9$var$ownKeys(source);
    var defineProperty = $5aa677c457ee63c9$var$definePropertyModule$1.f;
    var getOwnPropertyDescriptor = $5aa677c457ee63c9$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$5aa677c457ee63c9$var$hasOwn$4(target, key) && !(exceptions && $5aa677c457ee63c9$var$hasOwn$4(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $5aa677c457ee63c9$var$fails$5 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$isCallable$a = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$replacement = /#|\.prototype\./;
var $5aa677c457ee63c9$var$isForced$2 = function(feature, detection) {
    var value = $5aa677c457ee63c9$var$data[$5aa677c457ee63c9$var$normalize(feature)];
    return value == $5aa677c457ee63c9$var$POLYFILL ? true : value == $5aa677c457ee63c9$var$NATIVE ? false : $5aa677c457ee63c9$var$isCallable$a(detection) ? $5aa677c457ee63c9$var$fails$5(detection) : !!detection;
};
var $5aa677c457ee63c9$var$normalize = $5aa677c457ee63c9$var$isForced$2.normalize = function(string) {
    return String(string).replace($5aa677c457ee63c9$var$replacement, ".").toLowerCase();
};
var $5aa677c457ee63c9$var$data = $5aa677c457ee63c9$var$isForced$2.data = {};
var $5aa677c457ee63c9$var$NATIVE = $5aa677c457ee63c9$var$isForced$2.NATIVE = "N";
var $5aa677c457ee63c9$var$POLYFILL = $5aa677c457ee63c9$var$isForced$2.POLYFILL = "P";
var $5aa677c457ee63c9$var$isForced_1 = $5aa677c457ee63c9$var$isForced$2;
var $5aa677c457ee63c9$var$global$a = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$getOwnPropertyDescriptor$1 = $5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor.f;
var $5aa677c457ee63c9$var$createNonEnumerableProperty$2 = $5aa677c457ee63c9$var$createNonEnumerableProperty$4;
var $5aa677c457ee63c9$var$defineBuiltIn$5 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$defineGlobalProperty = $5aa677c457ee63c9$var$defineGlobalProperty$3;
var $5aa677c457ee63c9$var$copyConstructorProperties = $5aa677c457ee63c9$var$copyConstructorProperties$1;
var $5aa677c457ee63c9$var$isForced$1 = $5aa677c457ee63c9$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $5aa677c457ee63c9$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $5aa677c457ee63c9$var$global$a;
    else if (STATIC) target = $5aa677c457ee63c9$var$global$a[TARGET] || $5aa677c457ee63c9$var$defineGlobalProperty(TARGET, {});
    else target = ($5aa677c457ee63c9$var$global$a[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $5aa677c457ee63c9$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $5aa677c457ee63c9$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $5aa677c457ee63c9$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $5aa677c457ee63c9$var$createNonEnumerableProperty$2(sourceProperty, "sham", true);
        $5aa677c457ee63c9$var$defineBuiltIn$5(target, key, sourceProperty, options);
    }
};
var $5aa677c457ee63c9$var$fails$4 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$correctPrototypeGetter = !$5aa677c457ee63c9$var$fails$4(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $5aa677c457ee63c9$var$hasOwn$3 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$isCallable$9 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$toObject = $5aa677c457ee63c9$var$toObject$2;
var $5aa677c457ee63c9$var$sharedKey = $5aa677c457ee63c9$var$sharedKey$3;
var $5aa677c457ee63c9$var$CORRECT_PROTOTYPE_GETTER = $5aa677c457ee63c9$var$correctPrototypeGetter;
var $5aa677c457ee63c9$var$IE_PROTO = $5aa677c457ee63c9$var$sharedKey("IE_PROTO");
var $5aa677c457ee63c9$var$$Object$1 = Object;
var $5aa677c457ee63c9$var$ObjectPrototype = $5aa677c457ee63c9$var$$Object$1.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $5aa677c457ee63c9$var$objectGetPrototypeOf = $5aa677c457ee63c9$var$CORRECT_PROTOTYPE_GETTER ? $5aa677c457ee63c9$var$$Object$1.getPrototypeOf : function(O) {
    var object = $5aa677c457ee63c9$var$toObject(O);
    if ($5aa677c457ee63c9$var$hasOwn$3(object, $5aa677c457ee63c9$var$IE_PROTO)) return object[$5aa677c457ee63c9$var$IE_PROTO];
    var constructor = object.constructor;
    if ($5aa677c457ee63c9$var$isCallable$9(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $5aa677c457ee63c9$var$$Object$1 ? $5aa677c457ee63c9$var$ObjectPrototype : null;
};
var $5aa677c457ee63c9$var$fails$3 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$isCallable$8 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$getPrototypeOf$1 = $5aa677c457ee63c9$var$objectGetPrototypeOf;
var $5aa677c457ee63c9$var$defineBuiltIn$4 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$wellKnownSymbol$b = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$ITERATOR$5 = $5aa677c457ee63c9$var$wellKnownSymbol$b("iterator");
var $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $5aa677c457ee63c9$var$IteratorPrototype$2, $5aa677c457ee63c9$var$PrototypeOfArrayIteratorPrototype, $5aa677c457ee63c9$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $5aa677c457ee63c9$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $5aa677c457ee63c9$var$arrayIterator)) $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $5aa677c457ee63c9$var$PrototypeOfArrayIteratorPrototype = $5aa677c457ee63c9$var$getPrototypeOf$1($5aa677c457ee63c9$var$getPrototypeOf$1($5aa677c457ee63c9$var$arrayIterator));
        if ($5aa677c457ee63c9$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $5aa677c457ee63c9$var$IteratorPrototype$2 = $5aa677c457ee63c9$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $5aa677c457ee63c9$var$NEW_ITERATOR_PROTOTYPE = $5aa677c457ee63c9$var$IteratorPrototype$2 == undefined || $5aa677c457ee63c9$var$fails$3(function() {
    var test = {};
    // FF44- legacy iterators case
    return $5aa677c457ee63c9$var$IteratorPrototype$2[$5aa677c457ee63c9$var$ITERATOR$5].call(test) !== test;
});
if ($5aa677c457ee63c9$var$NEW_ITERATOR_PROTOTYPE) $5aa677c457ee63c9$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$5aa677c457ee63c9$var$isCallable$8($5aa677c457ee63c9$var$IteratorPrototype$2[$5aa677c457ee63c9$var$ITERATOR$5])) $5aa677c457ee63c9$var$defineBuiltIn$4($5aa677c457ee63c9$var$IteratorPrototype$2, $5aa677c457ee63c9$var$ITERATOR$5, function() {
    return this;
});
var $5aa677c457ee63c9$var$iteratorsCore = {
    IteratorPrototype: $5aa677c457ee63c9$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS$1
};
var $5aa677c457ee63c9$var$defineProperty$1 = $5aa677c457ee63c9$var$objectDefineProperty.f;
var $5aa677c457ee63c9$var$hasOwn$2 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$wellKnownSymbol$a = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$TO_STRING_TAG$3 = $5aa677c457ee63c9$var$wellKnownSymbol$a("toStringTag");
var $5aa677c457ee63c9$var$setToStringTag$3 = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$5aa677c457ee63c9$var$hasOwn$2(target, $5aa677c457ee63c9$var$TO_STRING_TAG$3)) $5aa677c457ee63c9$var$defineProperty$1(target, $5aa677c457ee63c9$var$TO_STRING_TAG$3, {
        configurable: true,
        value: TAG
    });
};
var $5aa677c457ee63c9$var$IteratorPrototype$1 = $5aa677c457ee63c9$var$iteratorsCore.IteratorPrototype;
var $5aa677c457ee63c9$var$create = $5aa677c457ee63c9$var$objectCreate;
var $5aa677c457ee63c9$var$createPropertyDescriptor = $5aa677c457ee63c9$var$createPropertyDescriptor$3;
var $5aa677c457ee63c9$var$setToStringTag$2 = $5aa677c457ee63c9$var$setToStringTag$3;
var $5aa677c457ee63c9$var$Iterators$4 = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$returnThis$1 = function() {
    return this;
};
var $5aa677c457ee63c9$var$createIteratorConstructor$1 = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $5aa677c457ee63c9$var$create($5aa677c457ee63c9$var$IteratorPrototype$1, {
        next: $5aa677c457ee63c9$var$createPropertyDescriptor(+!ENUMERABLE_NEXT, next)
    });
    $5aa677c457ee63c9$var$setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
    $5aa677c457ee63c9$var$Iterators$4[TO_STRING_TAG] = $5aa677c457ee63c9$var$returnThis$1;
    return IteratorConstructor;
};
var $5aa677c457ee63c9$var$isCallable$7 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$$String$1 = String;
var $5aa677c457ee63c9$var$$TypeError$5 = TypeError;
var $5aa677c457ee63c9$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || $5aa677c457ee63c9$var$isCallable$7(argument)) return argument;
    throw $5aa677c457ee63c9$var$$TypeError$5("Can't set " + $5aa677c457ee63c9$var$$String$1(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $5aa677c457ee63c9$var$uncurryThis$3 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$anObject$7 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$aPossiblePrototype = $5aa677c457ee63c9$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $5aa677c457ee63c9$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $5aa677c457ee63c9$var$uncurryThis$3(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $5aa677c457ee63c9$var$anObject$7(O);
        $5aa677c457ee63c9$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $5aa677c457ee63c9$var$$$6 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$call$9 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$FunctionName = $5aa677c457ee63c9$var$functionName;
var $5aa677c457ee63c9$var$isCallable$6 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$createIteratorConstructor = $5aa677c457ee63c9$var$createIteratorConstructor$1;
var $5aa677c457ee63c9$var$getPrototypeOf = $5aa677c457ee63c9$var$objectGetPrototypeOf;
var $5aa677c457ee63c9$var$setPrototypeOf$1 = $5aa677c457ee63c9$var$objectSetPrototypeOf;
var $5aa677c457ee63c9$var$setToStringTag$1 = $5aa677c457ee63c9$var$setToStringTag$3;
var $5aa677c457ee63c9$var$createNonEnumerableProperty$1 = $5aa677c457ee63c9$var$createNonEnumerableProperty$4;
var $5aa677c457ee63c9$var$defineBuiltIn$3 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$wellKnownSymbol$9 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$Iterators$3 = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$IteratorsCore = $5aa677c457ee63c9$var$iteratorsCore;
var $5aa677c457ee63c9$var$PROPER_FUNCTION_NAME$1 = $5aa677c457ee63c9$var$FunctionName.PROPER;
var $5aa677c457ee63c9$var$CONFIGURABLE_FUNCTION_NAME = $5aa677c457ee63c9$var$FunctionName.CONFIGURABLE;
var $5aa677c457ee63c9$var$IteratorPrototype = $5aa677c457ee63c9$var$IteratorsCore.IteratorPrototype;
var $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS = $5aa677c457ee63c9$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $5aa677c457ee63c9$var$ITERATOR$4 = $5aa677c457ee63c9$var$wellKnownSymbol$9("iterator");
var $5aa677c457ee63c9$var$KEYS = "keys";
var $5aa677c457ee63c9$var$VALUES = "values";
var $5aa677c457ee63c9$var$ENTRIES = "entries";
var $5aa677c457ee63c9$var$returnThis = function() {
    return this;
};
var $5aa677c457ee63c9$var$defineIterator$1 = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $5aa677c457ee63c9$var$createIteratorConstructor(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $5aa677c457ee63c9$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $5aa677c457ee63c9$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $5aa677c457ee63c9$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$5aa677c457ee63c9$var$ITERATOR$4] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $5aa677c457ee63c9$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($5aa677c457ee63c9$var$getPrototypeOf(CurrentIteratorPrototype) !== $5aa677c457ee63c9$var$IteratorPrototype) {
                if ($5aa677c457ee63c9$var$setPrototypeOf$1) $5aa677c457ee63c9$var$setPrototypeOf$1(CurrentIteratorPrototype, $5aa677c457ee63c9$var$IteratorPrototype);
                else if (!$5aa677c457ee63c9$var$isCallable$6(CurrentIteratorPrototype[$5aa677c457ee63c9$var$ITERATOR$4])) $5aa677c457ee63c9$var$defineBuiltIn$3(CurrentIteratorPrototype, $5aa677c457ee63c9$var$ITERATOR$4, $5aa677c457ee63c9$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $5aa677c457ee63c9$var$setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($5aa677c457ee63c9$var$PROPER_FUNCTION_NAME$1 && DEFAULT == $5aa677c457ee63c9$var$VALUES && nativeIterator && nativeIterator.name !== $5aa677c457ee63c9$var$VALUES) {
        if ($5aa677c457ee63c9$var$CONFIGURABLE_FUNCTION_NAME) $5aa677c457ee63c9$var$createNonEnumerableProperty$1(IterablePrototype, "name", $5aa677c457ee63c9$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $5aa677c457ee63c9$var$call$9(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($5aa677c457ee63c9$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($5aa677c457ee63c9$var$KEYS),
            entries: getIterationMethod($5aa677c457ee63c9$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $5aa677c457ee63c9$var$defineBuiltIn$3(IterablePrototype, KEY, methods[KEY]);
        } else $5aa677c457ee63c9$var$$$6({
            target: NAME,
            proto: true,
            forced: $5aa677c457ee63c9$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$5aa677c457ee63c9$var$ITERATOR$4] !== defaultIterator) $5aa677c457ee63c9$var$defineBuiltIn$3(IterablePrototype, $5aa677c457ee63c9$var$ITERATOR$4, defaultIterator, {
        name: DEFAULT
    });
    $5aa677c457ee63c9$var$Iterators$3[NAME] = defaultIterator;
    return methods;
};
var $5aa677c457ee63c9$var$toIndexedObject = $5aa677c457ee63c9$var$toIndexedObject$5;
var $5aa677c457ee63c9$var$addToUnscopables = $5aa677c457ee63c9$var$addToUnscopables$1;
var $5aa677c457ee63c9$var$Iterators$2 = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$InternalStateModule$1 = $5aa677c457ee63c9$var$internalState;
var $5aa677c457ee63c9$var$defineProperty = $5aa677c457ee63c9$var$objectDefineProperty.f;
var $5aa677c457ee63c9$var$defineIterator = $5aa677c457ee63c9$var$defineIterator$1;
var $5aa677c457ee63c9$var$DESCRIPTORS$1 = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$ARRAY_ITERATOR = "Array Iterator";
var $5aa677c457ee63c9$var$setInternalState$1 = $5aa677c457ee63c9$var$InternalStateModule$1.set;
var $5aa677c457ee63c9$var$getInternalState = $5aa677c457ee63c9$var$InternalStateModule$1.getterFor($5aa677c457ee63c9$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $5aa677c457ee63c9$var$es_array_iterator = $5aa677c457ee63c9$var$defineIterator(Array, "Array", function(iterated, kind) {
    $5aa677c457ee63c9$var$setInternalState$1(this, {
        type: $5aa677c457ee63c9$var$ARRAY_ITERATOR,
        target: $5aa677c457ee63c9$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $5aa677c457ee63c9$var$getInternalState(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $5aa677c457ee63c9$var$values = $5aa677c457ee63c9$var$Iterators$2.Arguments = $5aa677c457ee63c9$var$Iterators$2.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$5aa677c457ee63c9$var$addToUnscopables("keys");
$5aa677c457ee63c9$var$addToUnscopables("values");
$5aa677c457ee63c9$var$addToUnscopables("entries");
// V8 ~ Chrome 45- bug
if ($5aa677c457ee63c9$var$DESCRIPTORS$1 && $5aa677c457ee63c9$var$values.name !== "values") try {
    $5aa677c457ee63c9$var$defineProperty($5aa677c457ee63c9$var$values, "name", {
        value: "values"
    });
} catch (error) {}
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $5aa677c457ee63c9$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $5aa677c457ee63c9$var$documentCreateElement = $5aa677c457ee63c9$var$documentCreateElement$2;
var $5aa677c457ee63c9$var$classList = $5aa677c457ee63c9$var$documentCreateElement("span").classList;
var $5aa677c457ee63c9$var$DOMTokenListPrototype$1 = $5aa677c457ee63c9$var$classList && $5aa677c457ee63c9$var$classList.constructor && $5aa677c457ee63c9$var$classList.constructor.prototype;
var $5aa677c457ee63c9$var$domTokenListPrototype = $5aa677c457ee63c9$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $5aa677c457ee63c9$var$DOMTokenListPrototype$1;
var $5aa677c457ee63c9$var$global$9 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$DOMIterables = $5aa677c457ee63c9$var$domIterables;
var $5aa677c457ee63c9$var$DOMTokenListPrototype = $5aa677c457ee63c9$var$domTokenListPrototype;
var $5aa677c457ee63c9$var$ArrayIteratorMethods = $5aa677c457ee63c9$var$es_array_iterator;
var $5aa677c457ee63c9$var$createNonEnumerableProperty = $5aa677c457ee63c9$var$createNonEnumerableProperty$4;
var $5aa677c457ee63c9$var$wellKnownSymbol$8 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$ITERATOR$3 = $5aa677c457ee63c9$var$wellKnownSymbol$8("iterator");
var $5aa677c457ee63c9$var$TO_STRING_TAG$2 = $5aa677c457ee63c9$var$wellKnownSymbol$8("toStringTag");
var $5aa677c457ee63c9$var$ArrayValues = $5aa677c457ee63c9$var$ArrayIteratorMethods.values;
var $5aa677c457ee63c9$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$5aa677c457ee63c9$var$ITERATOR$3] !== $5aa677c457ee63c9$var$ArrayValues) try {
            $5aa677c457ee63c9$var$createNonEnumerableProperty(CollectionPrototype, $5aa677c457ee63c9$var$ITERATOR$3, $5aa677c457ee63c9$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$5aa677c457ee63c9$var$ITERATOR$3] = $5aa677c457ee63c9$var$ArrayValues;
        }
        if (!CollectionPrototype[$5aa677c457ee63c9$var$TO_STRING_TAG$2]) $5aa677c457ee63c9$var$createNonEnumerableProperty(CollectionPrototype, $5aa677c457ee63c9$var$TO_STRING_TAG$2, COLLECTION_NAME);
        if ($5aa677c457ee63c9$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $5aa677c457ee63c9$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $5aa677c457ee63c9$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $5aa677c457ee63c9$var$createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, $5aa677c457ee63c9$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $5aa677c457ee63c9$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $5aa677c457ee63c9$var$COLLECTION_NAME in $5aa677c457ee63c9$var$DOMIterables)$5aa677c457ee63c9$var$handlePrototype($5aa677c457ee63c9$var$global$9[$5aa677c457ee63c9$var$COLLECTION_NAME] && $5aa677c457ee63c9$var$global$9[$5aa677c457ee63c9$var$COLLECTION_NAME].prototype, $5aa677c457ee63c9$var$COLLECTION_NAME);
$5aa677c457ee63c9$var$handlePrototype($5aa677c457ee63c9$var$DOMTokenListPrototype, "DOMTokenList");
var $5aa677c457ee63c9$var$classof$4 = $5aa677c457ee63c9$var$classofRaw$1;
var $5aa677c457ee63c9$var$global$8 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$engineIsNode = $5aa677c457ee63c9$var$classof$4($5aa677c457ee63c9$var$global$8.process) == "process";
var $5aa677c457ee63c9$var$getBuiltIn$3 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$definePropertyModule = $5aa677c457ee63c9$var$objectDefineProperty;
var $5aa677c457ee63c9$var$wellKnownSymbol$7 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$DESCRIPTORS = $5aa677c457ee63c9$var$descriptors;
var $5aa677c457ee63c9$var$SPECIES$2 = $5aa677c457ee63c9$var$wellKnownSymbol$7("species");
var $5aa677c457ee63c9$var$setSpecies$1 = function(CONSTRUCTOR_NAME) {
    var Constructor = $5aa677c457ee63c9$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    var defineProperty = $5aa677c457ee63c9$var$definePropertyModule.f;
    if ($5aa677c457ee63c9$var$DESCRIPTORS && Constructor && !Constructor[$5aa677c457ee63c9$var$SPECIES$2]) defineProperty(Constructor, $5aa677c457ee63c9$var$SPECIES$2, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $5aa677c457ee63c9$var$isPrototypeOf$2 = $5aa677c457ee63c9$var$objectIsPrototypeOf;
var $5aa677c457ee63c9$var$$TypeError$4 = TypeError;
var $5aa677c457ee63c9$var$anInstance$1 = function(it, Prototype) {
    if ($5aa677c457ee63c9$var$isPrototypeOf$2(Prototype, it)) return it;
    throw $5aa677c457ee63c9$var$$TypeError$4("Incorrect invocation");
};
var $5aa677c457ee63c9$var$wellKnownSymbol$6 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$TO_STRING_TAG$1 = $5aa677c457ee63c9$var$wellKnownSymbol$6("toStringTag");
var $5aa677c457ee63c9$var$test = {};
$5aa677c457ee63c9$var$test[$5aa677c457ee63c9$var$TO_STRING_TAG$1] = "z";
var $5aa677c457ee63c9$var$toStringTagSupport = String($5aa677c457ee63c9$var$test) === "[object z]";
var $5aa677c457ee63c9$var$TO_STRING_TAG_SUPPORT = $5aa677c457ee63c9$var$toStringTagSupport;
var $5aa677c457ee63c9$var$isCallable$5 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$classofRaw = $5aa677c457ee63c9$var$classofRaw$1;
var $5aa677c457ee63c9$var$wellKnownSymbol$5 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$TO_STRING_TAG = $5aa677c457ee63c9$var$wellKnownSymbol$5("toStringTag");
var $5aa677c457ee63c9$var$$Object = Object;
// ES3 wrong here
var $5aa677c457ee63c9$var$CORRECT_ARGUMENTS = $5aa677c457ee63c9$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $5aa677c457ee63c9$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $5aa677c457ee63c9$var$classof$3 = $5aa677c457ee63c9$var$TO_STRING_TAG_SUPPORT ? $5aa677c457ee63c9$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $5aa677c457ee63c9$var$tryGet(O = $5aa677c457ee63c9$var$$Object(it), $5aa677c457ee63c9$var$TO_STRING_TAG)) == "string" ? tag : $5aa677c457ee63c9$var$CORRECT_ARGUMENTS ? $5aa677c457ee63c9$var$classofRaw(O) : (result = $5aa677c457ee63c9$var$classofRaw(O)) == "Object" && $5aa677c457ee63c9$var$isCallable$5(O.callee) ? "Arguments" : result;
};
var $5aa677c457ee63c9$var$uncurryThis$2 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$fails$2 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$isCallable$4 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$classof$2 = $5aa677c457ee63c9$var$classof$3;
var $5aa677c457ee63c9$var$getBuiltIn$2 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$inspectSource$1 = $5aa677c457ee63c9$var$inspectSource$4;
var $5aa677c457ee63c9$var$noop = function() {};
var $5aa677c457ee63c9$var$empty = [];
var $5aa677c457ee63c9$var$construct = $5aa677c457ee63c9$var$getBuiltIn$2("Reflect", "construct");
var $5aa677c457ee63c9$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $5aa677c457ee63c9$var$exec = $5aa677c457ee63c9$var$uncurryThis$2($5aa677c457ee63c9$var$constructorRegExp.exec);
var $5aa677c457ee63c9$var$INCORRECT_TO_STRING = !$5aa677c457ee63c9$var$constructorRegExp.exec($5aa677c457ee63c9$var$noop);
var $5aa677c457ee63c9$var$isConstructorModern = function isConstructor(argument) {
    if (!$5aa677c457ee63c9$var$isCallable$4(argument)) return false;
    try {
        $5aa677c457ee63c9$var$construct($5aa677c457ee63c9$var$noop, $5aa677c457ee63c9$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $5aa677c457ee63c9$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$5aa677c457ee63c9$var$isCallable$4(argument)) return false;
    switch($5aa677c457ee63c9$var$classof$2(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $5aa677c457ee63c9$var$INCORRECT_TO_STRING || !!$5aa677c457ee63c9$var$exec($5aa677c457ee63c9$var$constructorRegExp, $5aa677c457ee63c9$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$5aa677c457ee63c9$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $5aa677c457ee63c9$var$isConstructor$1 = !$5aa677c457ee63c9$var$construct || $5aa677c457ee63c9$var$fails$2(function() {
    var called;
    return $5aa677c457ee63c9$var$isConstructorModern($5aa677c457ee63c9$var$isConstructorModern.call) || !$5aa677c457ee63c9$var$isConstructorModern(Object) || !$5aa677c457ee63c9$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $5aa677c457ee63c9$var$isConstructorLegacy : $5aa677c457ee63c9$var$isConstructorModern;
var $5aa677c457ee63c9$var$isConstructor = $5aa677c457ee63c9$var$isConstructor$1;
var $5aa677c457ee63c9$var$tryToString$2 = $5aa677c457ee63c9$var$tryToString$4;
var $5aa677c457ee63c9$var$$TypeError$3 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $5aa677c457ee63c9$var$aConstructor$1 = function(argument) {
    if ($5aa677c457ee63c9$var$isConstructor(argument)) return argument;
    throw $5aa677c457ee63c9$var$$TypeError$3($5aa677c457ee63c9$var$tryToString$2(argument) + " is not a constructor");
};
var $5aa677c457ee63c9$var$anObject$6 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$aConstructor = $5aa677c457ee63c9$var$aConstructor$1;
var $5aa677c457ee63c9$var$wellKnownSymbol$4 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$SPECIES$1 = $5aa677c457ee63c9$var$wellKnownSymbol$4("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $5aa677c457ee63c9$var$speciesConstructor$1 = function(O, defaultConstructor) {
    var C = $5aa677c457ee63c9$var$anObject$6(O).constructor;
    var S;
    return C === undefined || (S = $5aa677c457ee63c9$var$anObject$6(C)[$5aa677c457ee63c9$var$SPECIES$1]) == undefined ? defaultConstructor : $5aa677c457ee63c9$var$aConstructor(S);
};
var $5aa677c457ee63c9$var$NATIVE_BIND$1 = $5aa677c457ee63c9$var$functionBindNative;
var $5aa677c457ee63c9$var$FunctionPrototype = Function.prototype;
var $5aa677c457ee63c9$var$apply$1 = $5aa677c457ee63c9$var$FunctionPrototype.apply;
var $5aa677c457ee63c9$var$call$8 = $5aa677c457ee63c9$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $5aa677c457ee63c9$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($5aa677c457ee63c9$var$NATIVE_BIND$1 ? $5aa677c457ee63c9$var$call$8.bind($5aa677c457ee63c9$var$apply$1) : function() {
    return $5aa677c457ee63c9$var$call$8.apply($5aa677c457ee63c9$var$apply$1, arguments);
});
var $5aa677c457ee63c9$var$uncurryThis$1 = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$aCallable$5 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$NATIVE_BIND = $5aa677c457ee63c9$var$functionBindNative;
var $5aa677c457ee63c9$var$bind$4 = $5aa677c457ee63c9$var$uncurryThis$1($5aa677c457ee63c9$var$uncurryThis$1.bind);
// optional / simple context binding
var $5aa677c457ee63c9$var$functionBindContext = function(fn, that) {
    $5aa677c457ee63c9$var$aCallable$5(fn);
    return that === undefined ? fn : $5aa677c457ee63c9$var$NATIVE_BIND ? $5aa677c457ee63c9$var$bind$4(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $5aa677c457ee63c9$var$uncurryThis = $5aa677c457ee63c9$var$functionUncurryThis;
var $5aa677c457ee63c9$var$arraySlice$1 = $5aa677c457ee63c9$var$uncurryThis([].slice);
var $5aa677c457ee63c9$var$$TypeError$2 = TypeError;
var $5aa677c457ee63c9$var$validateArgumentsLength$1 = function(passed, required) {
    if (passed < required) throw $5aa677c457ee63c9$var$$TypeError$2("Not enough arguments");
    return passed;
};
var $5aa677c457ee63c9$var$userAgent$2 = $5aa677c457ee63c9$var$engineUserAgent;
var $5aa677c457ee63c9$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($5aa677c457ee63c9$var$userAgent$2);
var $5aa677c457ee63c9$var$global$7 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$apply = $5aa677c457ee63c9$var$functionApply;
var $5aa677c457ee63c9$var$bind$3 = $5aa677c457ee63c9$var$functionBindContext;
var $5aa677c457ee63c9$var$isCallable$3 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$hasOwn$1 = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$fails$1 = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$html = $5aa677c457ee63c9$var$html$2;
var $5aa677c457ee63c9$var$arraySlice = $5aa677c457ee63c9$var$arraySlice$1;
var $5aa677c457ee63c9$var$createElement = $5aa677c457ee63c9$var$documentCreateElement$2;
var $5aa677c457ee63c9$var$validateArgumentsLength = $5aa677c457ee63c9$var$validateArgumentsLength$1;
var $5aa677c457ee63c9$var$IS_IOS$1 = $5aa677c457ee63c9$var$engineIsIos;
var $5aa677c457ee63c9$var$IS_NODE$2 = $5aa677c457ee63c9$var$engineIsNode;
var $5aa677c457ee63c9$var$set = $5aa677c457ee63c9$var$global$7.setImmediate;
var $5aa677c457ee63c9$var$clear = $5aa677c457ee63c9$var$global$7.clearImmediate;
var $5aa677c457ee63c9$var$process$2 = $5aa677c457ee63c9$var$global$7.process;
var $5aa677c457ee63c9$var$Dispatch = $5aa677c457ee63c9$var$global$7.Dispatch;
var $5aa677c457ee63c9$var$Function$1 = $5aa677c457ee63c9$var$global$7.Function;
var $5aa677c457ee63c9$var$MessageChannel = $5aa677c457ee63c9$var$global$7.MessageChannel;
var $5aa677c457ee63c9$var$String$1 = $5aa677c457ee63c9$var$global$7.String;
var $5aa677c457ee63c9$var$counter = 0;
var $5aa677c457ee63c9$var$queue$1 = {};
var $5aa677c457ee63c9$var$ONREADYSTATECHANGE = "onreadystatechange";
var $5aa677c457ee63c9$var$location, $5aa677c457ee63c9$var$defer, $5aa677c457ee63c9$var$channel, $5aa677c457ee63c9$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $5aa677c457ee63c9$var$location = $5aa677c457ee63c9$var$global$7.location;
} catch (error) {}
var $5aa677c457ee63c9$var$run = function(id) {
    if ($5aa677c457ee63c9$var$hasOwn$1($5aa677c457ee63c9$var$queue$1, id)) {
        var fn = $5aa677c457ee63c9$var$queue$1[id];
        delete $5aa677c457ee63c9$var$queue$1[id];
        fn();
    }
};
var $5aa677c457ee63c9$var$runner = function(id) {
    return function() {
        $5aa677c457ee63c9$var$run(id);
    };
};
var $5aa677c457ee63c9$var$listener = function(event) {
    $5aa677c457ee63c9$var$run(event.data);
};
var $5aa677c457ee63c9$var$post = function(id) {
    // old engines have not location.origin
    $5aa677c457ee63c9$var$global$7.postMessage($5aa677c457ee63c9$var$String$1(id), $5aa677c457ee63c9$var$location.protocol + "//" + $5aa677c457ee63c9$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$5aa677c457ee63c9$var$set || !$5aa677c457ee63c9$var$clear) {
    $5aa677c457ee63c9$var$set = function setImmediate(handler) {
        $5aa677c457ee63c9$var$validateArgumentsLength(arguments.length, 1);
        var fn = $5aa677c457ee63c9$var$isCallable$3(handler) ? handler : $5aa677c457ee63c9$var$Function$1(handler);
        var args = $5aa677c457ee63c9$var$arraySlice(arguments, 1);
        $5aa677c457ee63c9$var$queue$1[++$5aa677c457ee63c9$var$counter] = function() {
            $5aa677c457ee63c9$var$apply(fn, undefined, args);
        };
        $5aa677c457ee63c9$var$defer($5aa677c457ee63c9$var$counter);
        return $5aa677c457ee63c9$var$counter;
    };
    $5aa677c457ee63c9$var$clear = function clearImmediate(id) {
        delete $5aa677c457ee63c9$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($5aa677c457ee63c9$var$IS_NODE$2) $5aa677c457ee63c9$var$defer = function(id) {
        $5aa677c457ee63c9$var$process$2.nextTick($5aa677c457ee63c9$var$runner(id));
    };
    else if ($5aa677c457ee63c9$var$Dispatch && $5aa677c457ee63c9$var$Dispatch.now) $5aa677c457ee63c9$var$defer = function(id) {
        $5aa677c457ee63c9$var$Dispatch.now($5aa677c457ee63c9$var$runner(id));
    };
    else if ($5aa677c457ee63c9$var$MessageChannel && !$5aa677c457ee63c9$var$IS_IOS$1) {
        $5aa677c457ee63c9$var$channel = new $5aa677c457ee63c9$var$MessageChannel();
        $5aa677c457ee63c9$var$port = $5aa677c457ee63c9$var$channel.port2;
        $5aa677c457ee63c9$var$channel.port1.onmessage = $5aa677c457ee63c9$var$listener;
        $5aa677c457ee63c9$var$defer = $5aa677c457ee63c9$var$bind$3($5aa677c457ee63c9$var$port.postMessage, $5aa677c457ee63c9$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($5aa677c457ee63c9$var$global$7.addEventListener && $5aa677c457ee63c9$var$isCallable$3($5aa677c457ee63c9$var$global$7.postMessage) && !$5aa677c457ee63c9$var$global$7.importScripts && $5aa677c457ee63c9$var$location && $5aa677c457ee63c9$var$location.protocol !== "file:" && !$5aa677c457ee63c9$var$fails$1($5aa677c457ee63c9$var$post)) {
        $5aa677c457ee63c9$var$defer = $5aa677c457ee63c9$var$post;
        $5aa677c457ee63c9$var$global$7.addEventListener("message", $5aa677c457ee63c9$var$listener, false);
    // IE8-
    } else if ($5aa677c457ee63c9$var$ONREADYSTATECHANGE in $5aa677c457ee63c9$var$createElement("script")) $5aa677c457ee63c9$var$defer = function(id) {
        $5aa677c457ee63c9$var$html.appendChild($5aa677c457ee63c9$var$createElement("script"))[$5aa677c457ee63c9$var$ONREADYSTATECHANGE] = function() {
            $5aa677c457ee63c9$var$html.removeChild(this);
            $5aa677c457ee63c9$var$run(id);
        };
    };
    else $5aa677c457ee63c9$var$defer = function(id) {
        setTimeout($5aa677c457ee63c9$var$runner(id), 0);
    };
}
var $5aa677c457ee63c9$var$task$1 = {
    set: $5aa677c457ee63c9$var$set,
    clear: $5aa677c457ee63c9$var$clear
};
var $5aa677c457ee63c9$var$userAgent$1 = $5aa677c457ee63c9$var$engineUserAgent;
var $5aa677c457ee63c9$var$global$6 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($5aa677c457ee63c9$var$userAgent$1) && $5aa677c457ee63c9$var$global$6.Pebble !== undefined;
var $5aa677c457ee63c9$var$userAgent = $5aa677c457ee63c9$var$engineUserAgent;
var $5aa677c457ee63c9$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($5aa677c457ee63c9$var$userAgent);
var $5aa677c457ee63c9$var$global$5 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$bind$2 = $5aa677c457ee63c9$var$functionBindContext;
var $5aa677c457ee63c9$var$getOwnPropertyDescriptor = $5aa677c457ee63c9$var$objectGetOwnPropertyDescriptor.f;
var $5aa677c457ee63c9$var$macrotask = $5aa677c457ee63c9$var$task$1.set;
var $5aa677c457ee63c9$var$IS_IOS = $5aa677c457ee63c9$var$engineIsIos;
var $5aa677c457ee63c9$var$IS_IOS_PEBBLE = $5aa677c457ee63c9$var$engineIsIosPebble;
var $5aa677c457ee63c9$var$IS_WEBOS_WEBKIT = $5aa677c457ee63c9$var$engineIsWebosWebkit;
var $5aa677c457ee63c9$var$IS_NODE$1 = $5aa677c457ee63c9$var$engineIsNode;
var $5aa677c457ee63c9$var$MutationObserver = $5aa677c457ee63c9$var$global$5.MutationObserver || $5aa677c457ee63c9$var$global$5.WebKitMutationObserver;
var $5aa677c457ee63c9$var$document$2 = $5aa677c457ee63c9$var$global$5.document;
var $5aa677c457ee63c9$var$process$1 = $5aa677c457ee63c9$var$global$5.process;
var $5aa677c457ee63c9$var$Promise$1 = $5aa677c457ee63c9$var$global$5.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $5aa677c457ee63c9$var$queueMicrotaskDescriptor = $5aa677c457ee63c9$var$getOwnPropertyDescriptor($5aa677c457ee63c9$var$global$5, "queueMicrotask");
var $5aa677c457ee63c9$var$queueMicrotask = $5aa677c457ee63c9$var$queueMicrotaskDescriptor && $5aa677c457ee63c9$var$queueMicrotaskDescriptor.value;
var $5aa677c457ee63c9$var$flush, $5aa677c457ee63c9$var$head, $5aa677c457ee63c9$var$last, $5aa677c457ee63c9$var$notify$1, $5aa677c457ee63c9$var$toggle, $5aa677c457ee63c9$var$node, $5aa677c457ee63c9$var$promise, $5aa677c457ee63c9$var$then;
// modern engines have queueMicrotask method
if (!$5aa677c457ee63c9$var$queueMicrotask) {
    $5aa677c457ee63c9$var$flush = function() {
        var parent, fn;
        if ($5aa677c457ee63c9$var$IS_NODE$1 && (parent = $5aa677c457ee63c9$var$process$1.domain)) parent.exit();
        while($5aa677c457ee63c9$var$head){
            fn = $5aa677c457ee63c9$var$head.fn;
            $5aa677c457ee63c9$var$head = $5aa677c457ee63c9$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($5aa677c457ee63c9$var$head) $5aa677c457ee63c9$var$notify$1();
                else $5aa677c457ee63c9$var$last = undefined;
                throw error;
            }
        }
        $5aa677c457ee63c9$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$5aa677c457ee63c9$var$IS_IOS && !$5aa677c457ee63c9$var$IS_NODE$1 && !$5aa677c457ee63c9$var$IS_WEBOS_WEBKIT && $5aa677c457ee63c9$var$MutationObserver && $5aa677c457ee63c9$var$document$2) {
        $5aa677c457ee63c9$var$toggle = true;
        $5aa677c457ee63c9$var$node = $5aa677c457ee63c9$var$document$2.createTextNode("");
        new $5aa677c457ee63c9$var$MutationObserver($5aa677c457ee63c9$var$flush).observe($5aa677c457ee63c9$var$node, {
            characterData: true
        });
        $5aa677c457ee63c9$var$notify$1 = function() {
            $5aa677c457ee63c9$var$node.data = $5aa677c457ee63c9$var$toggle = !$5aa677c457ee63c9$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$5aa677c457ee63c9$var$IS_IOS_PEBBLE && $5aa677c457ee63c9$var$Promise$1 && $5aa677c457ee63c9$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $5aa677c457ee63c9$var$promise = $5aa677c457ee63c9$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $5aa677c457ee63c9$var$promise.constructor = $5aa677c457ee63c9$var$Promise$1;
        $5aa677c457ee63c9$var$then = $5aa677c457ee63c9$var$bind$2($5aa677c457ee63c9$var$promise.then, $5aa677c457ee63c9$var$promise);
        $5aa677c457ee63c9$var$notify$1 = function() {
            $5aa677c457ee63c9$var$then($5aa677c457ee63c9$var$flush);
        };
    // Node.js without promises
    } else if ($5aa677c457ee63c9$var$IS_NODE$1) $5aa677c457ee63c9$var$notify$1 = function() {
        $5aa677c457ee63c9$var$process$1.nextTick($5aa677c457ee63c9$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $5aa677c457ee63c9$var$macrotask = $5aa677c457ee63c9$var$bind$2($5aa677c457ee63c9$var$macrotask, $5aa677c457ee63c9$var$global$5);
        $5aa677c457ee63c9$var$notify$1 = function() {
            $5aa677c457ee63c9$var$macrotask($5aa677c457ee63c9$var$flush);
        };
    }
}
var $5aa677c457ee63c9$var$microtask$1 = $5aa677c457ee63c9$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($5aa677c457ee63c9$var$last) $5aa677c457ee63c9$var$last.next = task;
    if (!$5aa677c457ee63c9$var$head) {
        $5aa677c457ee63c9$var$head = task;
        $5aa677c457ee63c9$var$notify$1();
    }
    $5aa677c457ee63c9$var$last = task;
};
var $5aa677c457ee63c9$var$global$4 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$hostReportErrors$1 = function(a, b) {
    var console = $5aa677c457ee63c9$var$global$4.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};
var $5aa677c457ee63c9$var$perform$3 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $5aa677c457ee63c9$var$Queue$1 = function() {
    this.head = null;
    this.tail = null;
};
$5aa677c457ee63c9$var$Queue$1.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $5aa677c457ee63c9$var$queue = $5aa677c457ee63c9$var$Queue$1;
var $5aa677c457ee63c9$var$global$3 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$promiseNativeConstructor = $5aa677c457ee63c9$var$global$3.Promise;
var $5aa677c457ee63c9$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $5aa677c457ee63c9$var$global$2 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$NativePromiseConstructor$3 = $5aa677c457ee63c9$var$promiseNativeConstructor;
var $5aa677c457ee63c9$var$isCallable$2 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isForced = $5aa677c457ee63c9$var$isForced_1;
var $5aa677c457ee63c9$var$inspectSource = $5aa677c457ee63c9$var$inspectSource$4;
var $5aa677c457ee63c9$var$wellKnownSymbol$3 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$IS_BROWSER = $5aa677c457ee63c9$var$engineIsBrowser;
var $5aa677c457ee63c9$var$V8_VERSION = $5aa677c457ee63c9$var$engineV8Version;
$5aa677c457ee63c9$var$NativePromiseConstructor$3 && $5aa677c457ee63c9$var$NativePromiseConstructor$3.prototype;
var $5aa677c457ee63c9$var$SPECIES = $5aa677c457ee63c9$var$wellKnownSymbol$3("species");
var $5aa677c457ee63c9$var$SUBCLASSING = false;
var $5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $5aa677c457ee63c9$var$isCallable$2($5aa677c457ee63c9$var$global$2.PromiseRejectionEvent);
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$5 = $5aa677c457ee63c9$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $5aa677c457ee63c9$var$inspectSource($5aa677c457ee63c9$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($5aa677c457ee63c9$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $5aa677c457ee63c9$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($5aa677c457ee63c9$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $5aa677c457ee63c9$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$5aa677c457ee63c9$var$SPECIES] = FakePromise;
    $5aa677c457ee63c9$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$5aa677c457ee63c9$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $5aa677c457ee63c9$var$IS_BROWSER && !$5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $5aa677c457ee63c9$var$promiseConstructorDetection = {
    CONSTRUCTOR: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $5aa677c457ee63c9$var$SUBCLASSING
};
var $5aa677c457ee63c9$var$newPromiseCapability$2 = {};
var $5aa677c457ee63c9$var$aCallable$4 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $5aa677c457ee63c9$var$aCallable$4(resolve);
    this.reject = $5aa677c457ee63c9$var$aCallable$4(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$5aa677c457ee63c9$var$newPromiseCapability$2.f = function(C) {
    return new $5aa677c457ee63c9$var$PromiseCapability(C);
};
var $5aa677c457ee63c9$var$$$5 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$IS_NODE = $5aa677c457ee63c9$var$engineIsNode;
var $5aa677c457ee63c9$var$global$1 = $5aa677c457ee63c9$var$global$j;
var $5aa677c457ee63c9$var$call$7 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$defineBuiltIn$2 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$setPrototypeOf = $5aa677c457ee63c9$var$objectSetPrototypeOf;
var $5aa677c457ee63c9$var$setToStringTag = $5aa677c457ee63c9$var$setToStringTag$3;
var $5aa677c457ee63c9$var$setSpecies = $5aa677c457ee63c9$var$setSpecies$1;
var $5aa677c457ee63c9$var$aCallable$3 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$isCallable$1 = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$isObject$1 = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$anInstance = $5aa677c457ee63c9$var$anInstance$1;
var $5aa677c457ee63c9$var$speciesConstructor = $5aa677c457ee63c9$var$speciesConstructor$1;
var $5aa677c457ee63c9$var$task = $5aa677c457ee63c9$var$task$1.set;
var $5aa677c457ee63c9$var$microtask = $5aa677c457ee63c9$var$microtask$1;
var $5aa677c457ee63c9$var$hostReportErrors = $5aa677c457ee63c9$var$hostReportErrors$1;
var $5aa677c457ee63c9$var$perform$2 = $5aa677c457ee63c9$var$perform$3;
var $5aa677c457ee63c9$var$Queue = $5aa677c457ee63c9$var$queue;
var $5aa677c457ee63c9$var$InternalStateModule = $5aa677c457ee63c9$var$internalState;
var $5aa677c457ee63c9$var$NativePromiseConstructor$2 = $5aa677c457ee63c9$var$promiseNativeConstructor;
var $5aa677c457ee63c9$var$PromiseConstructorDetection = $5aa677c457ee63c9$var$promiseConstructorDetection;
var $5aa677c457ee63c9$var$newPromiseCapabilityModule$3 = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$PROMISE = "Promise";
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$4 = $5aa677c457ee63c9$var$PromiseConstructorDetection.CONSTRUCTOR;
var $5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT = $5aa677c457ee63c9$var$PromiseConstructorDetection.REJECTION_EVENT;
var $5aa677c457ee63c9$var$NATIVE_PROMISE_SUBCLASSING = $5aa677c457ee63c9$var$PromiseConstructorDetection.SUBCLASSING;
var $5aa677c457ee63c9$var$getInternalPromiseState = $5aa677c457ee63c9$var$InternalStateModule.getterFor($5aa677c457ee63c9$var$PROMISE);
var $5aa677c457ee63c9$var$setInternalState = $5aa677c457ee63c9$var$InternalStateModule.set;
var $5aa677c457ee63c9$var$NativePromisePrototype$1 = $5aa677c457ee63c9$var$NativePromiseConstructor$2 && $5aa677c457ee63c9$var$NativePromiseConstructor$2.prototype;
var $5aa677c457ee63c9$var$PromiseConstructor = $5aa677c457ee63c9$var$NativePromiseConstructor$2;
var $5aa677c457ee63c9$var$PromisePrototype = $5aa677c457ee63c9$var$NativePromisePrototype$1;
var $5aa677c457ee63c9$var$TypeError$1 = $5aa677c457ee63c9$var$global$1.TypeError;
var $5aa677c457ee63c9$var$document$1 = $5aa677c457ee63c9$var$global$1.document;
var $5aa677c457ee63c9$var$process = $5aa677c457ee63c9$var$global$1.process;
var $5aa677c457ee63c9$var$newPromiseCapability$1 = $5aa677c457ee63c9$var$newPromiseCapabilityModule$3.f;
var $5aa677c457ee63c9$var$newGenericPromiseCapability = $5aa677c457ee63c9$var$newPromiseCapability$1;
var $5aa677c457ee63c9$var$DISPATCH_EVENT = !!($5aa677c457ee63c9$var$document$1 && $5aa677c457ee63c9$var$document$1.createEvent && $5aa677c457ee63c9$var$global$1.dispatchEvent);
var $5aa677c457ee63c9$var$UNHANDLED_REJECTION = "unhandledrejection";
var $5aa677c457ee63c9$var$REJECTION_HANDLED = "rejectionhandled";
var $5aa677c457ee63c9$var$PENDING = 0;
var $5aa677c457ee63c9$var$FULFILLED = 1;
var $5aa677c457ee63c9$var$REJECTED = 2;
var $5aa677c457ee63c9$var$HANDLED = 1;
var $5aa677c457ee63c9$var$UNHANDLED = 2;
var $5aa677c457ee63c9$var$Internal, $5aa677c457ee63c9$var$OwnPromiseCapability, $5aa677c457ee63c9$var$PromiseWrapper, $5aa677c457ee63c9$var$nativeThen;
// helpers
var $5aa677c457ee63c9$var$isThenable = function(it) {
    var then;
    return $5aa677c457ee63c9$var$isObject$1(it) && $5aa677c457ee63c9$var$isCallable$1(then = it.then) ? then : false;
};
var $5aa677c457ee63c9$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $5aa677c457ee63c9$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $5aa677c457ee63c9$var$UNHANDLED) $5aa677c457ee63c9$var$onHandleUnhandled(state);
                state.rejection = $5aa677c457ee63c9$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($5aa677c457ee63c9$var$TypeError$1("Promise-chain cycle"));
            else if (then = $5aa677c457ee63c9$var$isThenable(result)) $5aa677c457ee63c9$var$call$7(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $5aa677c457ee63c9$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $5aa677c457ee63c9$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$5aa677c457ee63c9$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $5aa677c457ee63c9$var$onUnhandled(state);
    });
};
var $5aa677c457ee63c9$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($5aa677c457ee63c9$var$DISPATCH_EVENT) {
        event = $5aa677c457ee63c9$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $5aa677c457ee63c9$var$global$1.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$5aa677c457ee63c9$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $5aa677c457ee63c9$var$global$1["on" + name])) handler(event);
    else if (name === $5aa677c457ee63c9$var$UNHANDLED_REJECTION) $5aa677c457ee63c9$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $5aa677c457ee63c9$var$onUnhandled = function(state) {
    $5aa677c457ee63c9$var$call$7($5aa677c457ee63c9$var$task, $5aa677c457ee63c9$var$global$1, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $5aa677c457ee63c9$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $5aa677c457ee63c9$var$perform$2(function() {
                if ($5aa677c457ee63c9$var$IS_NODE) $5aa677c457ee63c9$var$process.emit("unhandledRejection", value, promise);
                else $5aa677c457ee63c9$var$dispatchEvent($5aa677c457ee63c9$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $5aa677c457ee63c9$var$IS_NODE || $5aa677c457ee63c9$var$isUnhandled(state) ? $5aa677c457ee63c9$var$UNHANDLED : $5aa677c457ee63c9$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $5aa677c457ee63c9$var$isUnhandled = function(state) {
    return state.rejection !== $5aa677c457ee63c9$var$HANDLED && !state.parent;
};
var $5aa677c457ee63c9$var$onHandleUnhandled = function(state) {
    $5aa677c457ee63c9$var$call$7($5aa677c457ee63c9$var$task, $5aa677c457ee63c9$var$global$1, function() {
        var promise = state.facade;
        if ($5aa677c457ee63c9$var$IS_NODE) $5aa677c457ee63c9$var$process.emit("rejectionHandled", promise);
        else $5aa677c457ee63c9$var$dispatchEvent($5aa677c457ee63c9$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $5aa677c457ee63c9$var$bind$1 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $5aa677c457ee63c9$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $5aa677c457ee63c9$var$REJECTED;
    $5aa677c457ee63c9$var$notify(state, true);
};
var $5aa677c457ee63c9$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $5aa677c457ee63c9$var$TypeError$1("Promise can't be resolved itself");
        var then = $5aa677c457ee63c9$var$isThenable(value);
        if (then) $5aa677c457ee63c9$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $5aa677c457ee63c9$var$call$7(then, value, $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalResolve, wrapper, state), $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalReject, wrapper, state));
            } catch (error) {
                $5aa677c457ee63c9$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $5aa677c457ee63c9$var$FULFILLED;
            $5aa677c457ee63c9$var$notify(state, false);
        }
    } catch (error) {
        $5aa677c457ee63c9$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $5aa677c457ee63c9$var$PromiseConstructor = function Promise1(executor) {
        $5aa677c457ee63c9$var$anInstance(this, $5aa677c457ee63c9$var$PromisePrototype);
        $5aa677c457ee63c9$var$aCallable$3(executor);
        $5aa677c457ee63c9$var$call$7($5aa677c457ee63c9$var$Internal, this);
        var state = $5aa677c457ee63c9$var$getInternalPromiseState(this);
        try {
            executor($5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalResolve, state), $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalReject, state));
        } catch (error) {
            $5aa677c457ee63c9$var$internalReject(state, error);
        }
    };
    $5aa677c457ee63c9$var$PromisePrototype = $5aa677c457ee63c9$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $5aa677c457ee63c9$var$Internal = function Promise1(executor) {
        $5aa677c457ee63c9$var$setInternalState(this, {
            type: $5aa677c457ee63c9$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $5aa677c457ee63c9$var$Queue(),
            rejection: false,
            state: $5aa677c457ee63c9$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $5aa677c457ee63c9$var$Internal.prototype = $5aa677c457ee63c9$var$defineBuiltIn$2($5aa677c457ee63c9$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $5aa677c457ee63c9$var$getInternalPromiseState(this);
        var reaction = $5aa677c457ee63c9$var$newPromiseCapability$1($5aa677c457ee63c9$var$speciesConstructor(this, $5aa677c457ee63c9$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $5aa677c457ee63c9$var$isCallable$1(onFulfilled) ? onFulfilled : true;
        reaction.fail = $5aa677c457ee63c9$var$isCallable$1(onRejected) && onRejected;
        reaction.domain = $5aa677c457ee63c9$var$IS_NODE ? $5aa677c457ee63c9$var$process.domain : undefined;
        if (state.state == $5aa677c457ee63c9$var$PENDING) state.reactions.add(reaction);
        else $5aa677c457ee63c9$var$microtask(function() {
            $5aa677c457ee63c9$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $5aa677c457ee63c9$var$OwnPromiseCapability = function() {
        var promise = new $5aa677c457ee63c9$var$Internal();
        var state = $5aa677c457ee63c9$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalResolve, state);
        this.reject = $5aa677c457ee63c9$var$bind$1($5aa677c457ee63c9$var$internalReject, state);
    };
    $5aa677c457ee63c9$var$newPromiseCapabilityModule$3.f = $5aa677c457ee63c9$var$newPromiseCapability$1 = function(C) {
        return C === $5aa677c457ee63c9$var$PromiseConstructor || C === $5aa677c457ee63c9$var$PromiseWrapper ? new $5aa677c457ee63c9$var$OwnPromiseCapability(C) : $5aa677c457ee63c9$var$newGenericPromiseCapability(C);
    };
    if ($5aa677c457ee63c9$var$isCallable$1($5aa677c457ee63c9$var$NativePromiseConstructor$2) && $5aa677c457ee63c9$var$NativePromisePrototype$1 !== Object.prototype) {
        $5aa677c457ee63c9$var$nativeThen = $5aa677c457ee63c9$var$NativePromisePrototype$1.then;
        if (!$5aa677c457ee63c9$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $5aa677c457ee63c9$var$defineBuiltIn$2($5aa677c457ee63c9$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $5aa677c457ee63c9$var$PromiseConstructor(function(resolve, reject) {
                $5aa677c457ee63c9$var$call$7($5aa677c457ee63c9$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $5aa677c457ee63c9$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($5aa677c457ee63c9$var$setPrototypeOf) $5aa677c457ee63c9$var$setPrototypeOf($5aa677c457ee63c9$var$NativePromisePrototype$1, $5aa677c457ee63c9$var$PromisePrototype);
    }
}
$5aa677c457ee63c9$var$$$5({
    global: true,
    constructor: true,
    wrap: true,
    forced: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $5aa677c457ee63c9$var$PromiseConstructor
});
$5aa677c457ee63c9$var$setToStringTag($5aa677c457ee63c9$var$PromiseConstructor, $5aa677c457ee63c9$var$PROMISE, false);
$5aa677c457ee63c9$var$setSpecies($5aa677c457ee63c9$var$PROMISE);
var $5aa677c457ee63c9$var$wellKnownSymbol$2 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$Iterators$1 = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$ITERATOR$2 = $5aa677c457ee63c9$var$wellKnownSymbol$2("iterator");
var $5aa677c457ee63c9$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
var $5aa677c457ee63c9$var$isArrayIteratorMethod$1 = function(it) {
    return it !== undefined && ($5aa677c457ee63c9$var$Iterators$1.Array === it || $5aa677c457ee63c9$var$ArrayPrototype[$5aa677c457ee63c9$var$ITERATOR$2] === it);
};
var $5aa677c457ee63c9$var$classof$1 = $5aa677c457ee63c9$var$classof$3;
var $5aa677c457ee63c9$var$getMethod$1 = $5aa677c457ee63c9$var$getMethod$3;
var $5aa677c457ee63c9$var$Iterators = $5aa677c457ee63c9$var$iterators;
var $5aa677c457ee63c9$var$wellKnownSymbol$1 = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$ITERATOR$1 = $5aa677c457ee63c9$var$wellKnownSymbol$1("iterator");
var $5aa677c457ee63c9$var$getIteratorMethod$2 = function(it) {
    if (it != undefined) return $5aa677c457ee63c9$var$getMethod$1(it, $5aa677c457ee63c9$var$ITERATOR$1) || $5aa677c457ee63c9$var$getMethod$1(it, "@@iterator") || $5aa677c457ee63c9$var$Iterators[$5aa677c457ee63c9$var$classof$1(it)];
};
var $5aa677c457ee63c9$var$call$6 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$aCallable$2 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$anObject$5 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$tryToString$1 = $5aa677c457ee63c9$var$tryToString$4;
var $5aa677c457ee63c9$var$getIteratorMethod$1 = $5aa677c457ee63c9$var$getIteratorMethod$2;
var $5aa677c457ee63c9$var$$TypeError$1 = TypeError;
var $5aa677c457ee63c9$var$getIterator$1 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $5aa677c457ee63c9$var$getIteratorMethod$1(argument) : usingIterator;
    if ($5aa677c457ee63c9$var$aCallable$2(iteratorMethod)) return $5aa677c457ee63c9$var$anObject$5($5aa677c457ee63c9$var$call$6(iteratorMethod, argument));
    throw $5aa677c457ee63c9$var$$TypeError$1($5aa677c457ee63c9$var$tryToString$1(argument) + " is not iterable");
};
var $5aa677c457ee63c9$var$call$5 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$anObject$4 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$getMethod = $5aa677c457ee63c9$var$getMethod$3;
var $5aa677c457ee63c9$var$iteratorClose$1 = function(iterator, kind, value) {
    var innerResult, innerError;
    $5aa677c457ee63c9$var$anObject$4(iterator);
    try {
        innerResult = $5aa677c457ee63c9$var$getMethod(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $5aa677c457ee63c9$var$call$5(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $5aa677c457ee63c9$var$anObject$4(innerResult);
    return value;
};
var $5aa677c457ee63c9$var$bind = $5aa677c457ee63c9$var$functionBindContext;
var $5aa677c457ee63c9$var$call$4 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$anObject$3 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$tryToString = $5aa677c457ee63c9$var$tryToString$4;
var $5aa677c457ee63c9$var$isArrayIteratorMethod = $5aa677c457ee63c9$var$isArrayIteratorMethod$1;
var $5aa677c457ee63c9$var$lengthOfArrayLike = $5aa677c457ee63c9$var$lengthOfArrayLike$2;
var $5aa677c457ee63c9$var$isPrototypeOf$1 = $5aa677c457ee63c9$var$objectIsPrototypeOf;
var $5aa677c457ee63c9$var$getIterator = $5aa677c457ee63c9$var$getIterator$1;
var $5aa677c457ee63c9$var$getIteratorMethod = $5aa677c457ee63c9$var$getIteratorMethod$2;
var $5aa677c457ee63c9$var$iteratorClose = $5aa677c457ee63c9$var$iteratorClose$1;
var $5aa677c457ee63c9$var$$TypeError = TypeError;
var $5aa677c457ee63c9$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $5aa677c457ee63c9$var$ResultPrototype = $5aa677c457ee63c9$var$Result.prototype;
var $5aa677c457ee63c9$var$iterate$2 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $5aa677c457ee63c9$var$bind(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $5aa677c457ee63c9$var$iteratorClose(iterator, "normal", condition);
        return new $5aa677c457ee63c9$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $5aa677c457ee63c9$var$anObject$3(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $5aa677c457ee63c9$var$getIteratorMethod(iterable);
        if (!iterFn) throw $5aa677c457ee63c9$var$$TypeError($5aa677c457ee63c9$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($5aa677c457ee63c9$var$isArrayIteratorMethod(iterFn)) {
            for(index = 0, length = $5aa677c457ee63c9$var$lengthOfArrayLike(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $5aa677c457ee63c9$var$isPrototypeOf$1($5aa677c457ee63c9$var$ResultPrototype, result)) return result;
            }
            return new $5aa677c457ee63c9$var$Result(false);
        }
        iterator = $5aa677c457ee63c9$var$getIterator(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $5aa677c457ee63c9$var$call$4(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $5aa677c457ee63c9$var$iteratorClose(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $5aa677c457ee63c9$var$isPrototypeOf$1($5aa677c457ee63c9$var$ResultPrototype, result)) return result;
    }
    return new $5aa677c457ee63c9$var$Result(false);
};
var $5aa677c457ee63c9$var$wellKnownSymbol = $5aa677c457ee63c9$var$wellKnownSymbol$e;
var $5aa677c457ee63c9$var$ITERATOR = $5aa677c457ee63c9$var$wellKnownSymbol("iterator");
var $5aa677c457ee63c9$var$SAFE_CLOSING = false;
try {
    var $5aa677c457ee63c9$var$called = 0;
    var $5aa677c457ee63c9$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$5aa677c457ee63c9$var$called++
            };
        },
        "return": function() {
            $5aa677c457ee63c9$var$SAFE_CLOSING = true;
        }
    };
    $5aa677c457ee63c9$var$iteratorWithReturn[$5aa677c457ee63c9$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($5aa677c457ee63c9$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $5aa677c457ee63c9$var$checkCorrectnessOfIteration$1 = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$5aa677c457ee63c9$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$5aa677c457ee63c9$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $5aa677c457ee63c9$var$NativePromiseConstructor$1 = $5aa677c457ee63c9$var$promiseNativeConstructor;
var $5aa677c457ee63c9$var$checkCorrectnessOfIteration = $5aa677c457ee63c9$var$checkCorrectnessOfIteration$1;
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$3 = $5aa677c457ee63c9$var$promiseConstructorDetection.CONSTRUCTOR;
var $5aa677c457ee63c9$var$promiseStaticsIncorrectIteration = $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$5aa677c457ee63c9$var$checkCorrectnessOfIteration(function(iterable) {
    $5aa677c457ee63c9$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $5aa677c457ee63c9$var$$$4 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$call$3 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$aCallable$1 = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$newPromiseCapabilityModule$2 = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$perform$1 = $5aa677c457ee63c9$var$perform$3;
var $5aa677c457ee63c9$var$iterate$1 = $5aa677c457ee63c9$var$iterate$2;
var $5aa677c457ee63c9$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $5aa677c457ee63c9$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$5aa677c457ee63c9$var$$$4({
    target: "Promise",
    stat: true,
    forced: $5aa677c457ee63c9$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $5aa677c457ee63c9$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $5aa677c457ee63c9$var$perform$1(function() {
            var $promiseResolve = $5aa677c457ee63c9$var$aCallable$1(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $5aa677c457ee63c9$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $5aa677c457ee63c9$var$call$3($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $5aa677c457ee63c9$var$$$3 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$2 = $5aa677c457ee63c9$var$promiseConstructorDetection.CONSTRUCTOR;
var $5aa677c457ee63c9$var$NativePromiseConstructor = $5aa677c457ee63c9$var$promiseNativeConstructor;
var $5aa677c457ee63c9$var$getBuiltIn$1 = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$isCallable = $5aa677c457ee63c9$var$isCallable$k;
var $5aa677c457ee63c9$var$defineBuiltIn$1 = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$NativePromisePrototype = $5aa677c457ee63c9$var$NativePromiseConstructor && $5aa677c457ee63c9$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$5aa677c457ee63c9$var$$$3({
    target: "Promise",
    proto: true,
    forced: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($5aa677c457ee63c9$var$isCallable($5aa677c457ee63c9$var$NativePromiseConstructor)) {
    var $5aa677c457ee63c9$var$method = $5aa677c457ee63c9$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($5aa677c457ee63c9$var$NativePromisePrototype["catch"] !== $5aa677c457ee63c9$var$method) $5aa677c457ee63c9$var$defineBuiltIn$1($5aa677c457ee63c9$var$NativePromisePrototype, "catch", $5aa677c457ee63c9$var$method, {
        unsafe: true
    });
}
var $5aa677c457ee63c9$var$$$2 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$call$2 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$aCallable = $5aa677c457ee63c9$var$aCallable$7;
var $5aa677c457ee63c9$var$newPromiseCapabilityModule$1 = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$perform = $5aa677c457ee63c9$var$perform$3;
var $5aa677c457ee63c9$var$iterate = $5aa677c457ee63c9$var$iterate$2;
var $5aa677c457ee63c9$var$PROMISE_STATICS_INCORRECT_ITERATION = $5aa677c457ee63c9$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$5aa677c457ee63c9$var$$$2({
    target: "Promise",
    stat: true,
    forced: $5aa677c457ee63c9$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $5aa677c457ee63c9$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $5aa677c457ee63c9$var$perform(function() {
            var $promiseResolve = $5aa677c457ee63c9$var$aCallable(C.resolve);
            $5aa677c457ee63c9$var$iterate(iterable, function(promise) {
                $5aa677c457ee63c9$var$call$2($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $5aa677c457ee63c9$var$$$1 = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$call$1 = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$newPromiseCapabilityModule = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$1 = $5aa677c457ee63c9$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$5aa677c457ee63c9$var$$$1({
    target: "Promise",
    stat: true,
    forced: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $5aa677c457ee63c9$var$newPromiseCapabilityModule.f(this);
        $5aa677c457ee63c9$var$call$1(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $5aa677c457ee63c9$var$anObject$2 = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$isObject = $5aa677c457ee63c9$var$isObject$7;
var $5aa677c457ee63c9$var$newPromiseCapability = $5aa677c457ee63c9$var$newPromiseCapability$2;
var $5aa677c457ee63c9$var$promiseResolve$1 = function(C, x) {
    $5aa677c457ee63c9$var$anObject$2(C);
    if ($5aa677c457ee63c9$var$isObject(x) && x.constructor === C) return x;
    var promiseCapability = $5aa677c457ee63c9$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $5aa677c457ee63c9$var$$ = $5aa677c457ee63c9$var$_export;
var $5aa677c457ee63c9$var$getBuiltIn = $5aa677c457ee63c9$var$getBuiltIn$8;
var $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR = $5aa677c457ee63c9$var$promiseConstructorDetection.CONSTRUCTOR;
var $5aa677c457ee63c9$var$promiseResolve = $5aa677c457ee63c9$var$promiseResolve$1;
$5aa677c457ee63c9$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$5aa677c457ee63c9$var$$({
    target: "Promise",
    stat: true,
    forced: $5aa677c457ee63c9$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $5aa677c457ee63c9$var$promiseResolve(this, x);
    }
});
var $5aa677c457ee63c9$var$classof = $5aa677c457ee63c9$var$classof$3;
var $5aa677c457ee63c9$var$$String = String;
var $5aa677c457ee63c9$var$toString = function(argument) {
    if ($5aa677c457ee63c9$var$classof(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $5aa677c457ee63c9$var$$String(argument);
};
var $5aa677c457ee63c9$var$anObject$1 = $5aa677c457ee63c9$var$anObject$c;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $5aa677c457ee63c9$var$regexpFlags = function() {
    var that = $5aa677c457ee63c9$var$anObject$1(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $5aa677c457ee63c9$var$call = $5aa677c457ee63c9$var$functionCall;
var $5aa677c457ee63c9$var$hasOwn = $5aa677c457ee63c9$var$hasOwnProperty_1;
var $5aa677c457ee63c9$var$isPrototypeOf = $5aa677c457ee63c9$var$objectIsPrototypeOf;
var $5aa677c457ee63c9$var$regExpFlags = $5aa677c457ee63c9$var$regexpFlags;
var $5aa677c457ee63c9$var$RegExpPrototype$1 = RegExp.prototype;
var $5aa677c457ee63c9$var$regexpGetFlags = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $5aa677c457ee63c9$var$RegExpPrototype$1) && !$5aa677c457ee63c9$var$hasOwn(R, "flags") && $5aa677c457ee63c9$var$isPrototypeOf($5aa677c457ee63c9$var$RegExpPrototype$1, R) ? $5aa677c457ee63c9$var$call($5aa677c457ee63c9$var$regExpFlags, R) : flags;
};
var $5aa677c457ee63c9$var$PROPER_FUNCTION_NAME = $5aa677c457ee63c9$var$functionName.PROPER;
var $5aa677c457ee63c9$var$defineBuiltIn = $5aa677c457ee63c9$var$defineBuiltIn$6;
var $5aa677c457ee63c9$var$anObject = $5aa677c457ee63c9$var$anObject$c;
var $5aa677c457ee63c9$var$$toString = $5aa677c457ee63c9$var$toString;
var $5aa677c457ee63c9$var$fails = $5aa677c457ee63c9$var$fails$d;
var $5aa677c457ee63c9$var$getRegExpFlags = $5aa677c457ee63c9$var$regexpGetFlags;
var $5aa677c457ee63c9$var$TO_STRING = "toString";
var $5aa677c457ee63c9$var$RegExpPrototype = RegExp.prototype;
var $5aa677c457ee63c9$var$n$ToString = $5aa677c457ee63c9$var$RegExpPrototype[$5aa677c457ee63c9$var$TO_STRING];
var $5aa677c457ee63c9$var$NOT_GENERIC = $5aa677c457ee63c9$var$fails(function() {
    return $5aa677c457ee63c9$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $5aa677c457ee63c9$var$INCORRECT_NAME = $5aa677c457ee63c9$var$PROPER_FUNCTION_NAME && $5aa677c457ee63c9$var$n$ToString.name != $5aa677c457ee63c9$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($5aa677c457ee63c9$var$NOT_GENERIC || $5aa677c457ee63c9$var$INCORRECT_NAME) $5aa677c457ee63c9$var$defineBuiltIn(RegExp.prototype, $5aa677c457ee63c9$var$TO_STRING, function toString() {
    var R = $5aa677c457ee63c9$var$anObject(this);
    var pattern = $5aa677c457ee63c9$var$$toString(R.source);
    var flags = $5aa677c457ee63c9$var$$toString($5aa677c457ee63c9$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $5aa677c457ee63c9$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $5aa677c457ee63c9$export$6a7fdf2f99a9cf08 = (transactions, signer, network)=>$5aa677c457ee63c9$var$__awaiter(void 0, void 0, void 0, function*() {
        const provider = new $k4rlt.providers.JsonRpcProvider({
            url: network.nodeUrl
        });
        const signedTransactions = [];
        for(let i = 0; i < transactions.length; i++){
            const publicKey = yield signer.getPublicKey(transactions[i].signerId, network.networkId);
            const [block, accessKey] = yield Promise.all([
                provider.block({
                    finality: "final"
                }),
                provider.query({
                    request_type: "view_access_key",
                    finality: "final",
                    account_id: transactions[i].signerId,
                    public_key: publicKey.toString()
                })
            ]);
            const actions = transactions[i].actions.map((action)=>$5aa677c457ee63c9$export$309c7a02b0b0bc62(action));
            const transaction = $k4rlt.transactions.createTransaction(transactions[i].signerId, $k4rlt.utils.PublicKey.from(publicKey.toString()), transactions[i].receiverId, accessKey.nonce + i + 1, actions, $k4rlt.utils.serialize.base_decode(block.header.hash));
            const response = yield $k4rlt.transactions.signTransaction(transaction, signer, transactions[i].signerId, network.networkId);
            signedTransactions.push(response[1]);
        }
        return signedTransactions;
    });


var $f9a22d5a80b70b70$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
var $f9a22d5a80b70b70$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $f9a22d5a80b70b70$var$global$o = // eslint-disable-next-line es-x/no-global-this -- safe
$f9a22d5a80b70b70$var$check(typeof globalThis == "object" && globalThis) || $f9a22d5a80b70b70$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$f9a22d5a80b70b70$var$check(typeof self == "object" && self) || $f9a22d5a80b70b70$var$check(typeof $f9a22d5a80b70b70$var$commonjsGlobal == "object" && $f9a22d5a80b70b70$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor = {};
var $f9a22d5a80b70b70$var$fails$k = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
var $f9a22d5a80b70b70$var$fails$j = $f9a22d5a80b70b70$var$fails$k;
// Detect IE8's incomplete defineProperty implementation
var $f9a22d5a80b70b70$var$descriptors = !$f9a22d5a80b70b70$var$fails$j(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $f9a22d5a80b70b70$var$fails$i = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$functionBindNative = !$f9a22d5a80b70b70$var$fails$i(function() {
    // eslint-disable-next-line es-x/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});
var $f9a22d5a80b70b70$var$NATIVE_BIND$3 = $f9a22d5a80b70b70$var$functionBindNative;
var $f9a22d5a80b70b70$var$call$k = Function.prototype.call;
var $f9a22d5a80b70b70$var$functionCall = $f9a22d5a80b70b70$var$NATIVE_BIND$3 ? $f9a22d5a80b70b70$var$call$k.bind($f9a22d5a80b70b70$var$call$k) : function() {
    return $f9a22d5a80b70b70$var$call$k.apply($f9a22d5a80b70b70$var$call$k, arguments);
};
var $f9a22d5a80b70b70$var$objectPropertyIsEnumerable = {};
var $f9a22d5a80b70b70$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $f9a22d5a80b70b70$var$NASHORN_BUG = $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$3 && !$f9a22d5a80b70b70$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
$f9a22d5a80b70b70$var$objectPropertyIsEnumerable.f = $f9a22d5a80b70b70$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$3(this, V);
    return !!descriptor && descriptor.enumerable;
} : $f9a22d5a80b70b70$var$$propertyIsEnumerable;
var $f9a22d5a80b70b70$var$createPropertyDescriptor$5 = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $f9a22d5a80b70b70$var$NATIVE_BIND$2 = $f9a22d5a80b70b70$var$functionBindNative;
var $f9a22d5a80b70b70$var$FunctionPrototype$2 = Function.prototype;
var $f9a22d5a80b70b70$var$bind$8 = $f9a22d5a80b70b70$var$FunctionPrototype$2.bind;
var $f9a22d5a80b70b70$var$call$j = $f9a22d5a80b70b70$var$FunctionPrototype$2.call;
var $f9a22d5a80b70b70$var$uncurryThis$m = $f9a22d5a80b70b70$var$NATIVE_BIND$2 && $f9a22d5a80b70b70$var$bind$8.bind($f9a22d5a80b70b70$var$call$j, $f9a22d5a80b70b70$var$call$j);
var $f9a22d5a80b70b70$var$functionUncurryThis = $f9a22d5a80b70b70$var$NATIVE_BIND$2 ? function(fn) {
    return fn && $f9a22d5a80b70b70$var$uncurryThis$m(fn);
} : function(fn) {
    return fn && function() {
        return $f9a22d5a80b70b70$var$call$j.apply(fn, arguments);
    };
};
var $f9a22d5a80b70b70$var$uncurryThis$l = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toString$6 = $f9a22d5a80b70b70$var$uncurryThis$l({}.toString);
var $f9a22d5a80b70b70$var$stringSlice$6 = $f9a22d5a80b70b70$var$uncurryThis$l("".slice);
var $f9a22d5a80b70b70$var$classofRaw$1 = function(it) {
    return $f9a22d5a80b70b70$var$stringSlice$6($f9a22d5a80b70b70$var$toString$6(it), 8, -1);
};
var $f9a22d5a80b70b70$var$uncurryThis$k = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$fails$h = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$classof$7 = $f9a22d5a80b70b70$var$classofRaw$1;
var $f9a22d5a80b70b70$var$$Object$4 = Object;
var $f9a22d5a80b70b70$var$split$3 = $f9a22d5a80b70b70$var$uncurryThis$k("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $f9a22d5a80b70b70$var$indexedObject = $f9a22d5a80b70b70$var$fails$h(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$f9a22d5a80b70b70$var$$Object$4("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $f9a22d5a80b70b70$var$classof$7(it) == "String" ? $f9a22d5a80b70b70$var$split$3(it, "") : $f9a22d5a80b70b70$var$$Object$4(it);
} : $f9a22d5a80b70b70$var$$Object$4;
var $f9a22d5a80b70b70$var$$TypeError$c = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $f9a22d5a80b70b70$var$requireObjectCoercible$4 = function(it) {
    if (it == undefined) throw $f9a22d5a80b70b70$var$$TypeError$c("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $f9a22d5a80b70b70$var$IndexedObject$1 = $f9a22d5a80b70b70$var$indexedObject;
var $f9a22d5a80b70b70$var$requireObjectCoercible$3 = $f9a22d5a80b70b70$var$requireObjectCoercible$4;
var $f9a22d5a80b70b70$var$toIndexedObject$5 = function(it) {
    return $f9a22d5a80b70b70$var$IndexedObject$1($f9a22d5a80b70b70$var$requireObjectCoercible$3(it));
};
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
var $f9a22d5a80b70b70$var$isCallable$n = function(argument) {
    return typeof argument == "function";
};
var $f9a22d5a80b70b70$var$isCallable$m = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$isObject$8 = function(it) {
    return typeof it == "object" ? it !== null : $f9a22d5a80b70b70$var$isCallable$m(it);
};
var $f9a22d5a80b70b70$var$global$n = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$isCallable$l = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$aFunction = function(argument) {
    return $f9a22d5a80b70b70$var$isCallable$l(argument) ? argument : undefined;
};
var $f9a22d5a80b70b70$var$getBuiltIn$8 = function(namespace, method) {
    return arguments.length < 2 ? $f9a22d5a80b70b70$var$aFunction($f9a22d5a80b70b70$var$global$n[namespace]) : $f9a22d5a80b70b70$var$global$n[namespace] && $f9a22d5a80b70b70$var$global$n[namespace][method];
};
var $f9a22d5a80b70b70$var$uncurryThis$j = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$objectIsPrototypeOf = $f9a22d5a80b70b70$var$uncurryThis$j({}.isPrototypeOf);
var $f9a22d5a80b70b70$var$getBuiltIn$7 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$engineUserAgent = $f9a22d5a80b70b70$var$getBuiltIn$7("navigator", "userAgent") || "";
var $f9a22d5a80b70b70$var$global$m = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$userAgent$3 = $f9a22d5a80b70b70$var$engineUserAgent;
var $f9a22d5a80b70b70$var$process$3 = $f9a22d5a80b70b70$var$global$m.process;
var $f9a22d5a80b70b70$var$Deno$1 = $f9a22d5a80b70b70$var$global$m.Deno;
var $f9a22d5a80b70b70$var$versions = $f9a22d5a80b70b70$var$process$3 && $f9a22d5a80b70b70$var$process$3.versions || $f9a22d5a80b70b70$var$Deno$1 && $f9a22d5a80b70b70$var$Deno$1.version;
var $f9a22d5a80b70b70$var$v8 = $f9a22d5a80b70b70$var$versions && $f9a22d5a80b70b70$var$versions.v8;
var $f9a22d5a80b70b70$var$match, $f9a22d5a80b70b70$var$version;
if ($f9a22d5a80b70b70$var$v8) {
    $f9a22d5a80b70b70$var$match = $f9a22d5a80b70b70$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $f9a22d5a80b70b70$var$version = $f9a22d5a80b70b70$var$match[0] > 0 && $f9a22d5a80b70b70$var$match[0] < 4 ? 1 : +($f9a22d5a80b70b70$var$match[0] + $f9a22d5a80b70b70$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$f9a22d5a80b70b70$var$version && $f9a22d5a80b70b70$var$userAgent$3) {
    $f9a22d5a80b70b70$var$match = $f9a22d5a80b70b70$var$userAgent$3.match(/Edge\/(\d+)/);
    if (!$f9a22d5a80b70b70$var$match || $f9a22d5a80b70b70$var$match[1] >= 74) {
        $f9a22d5a80b70b70$var$match = $f9a22d5a80b70b70$var$userAgent$3.match(/Chrome\/(\d+)/);
        if ($f9a22d5a80b70b70$var$match) $f9a22d5a80b70b70$var$version = +$f9a22d5a80b70b70$var$match[1];
    }
}
var $f9a22d5a80b70b70$var$engineV8Version = $f9a22d5a80b70b70$var$version;
/* eslint-disable es-x/no-symbol -- required for testing */ var $f9a22d5a80b70b70$var$V8_VERSION$1 = $f9a22d5a80b70b70$var$engineV8Version;
var $f9a22d5a80b70b70$var$fails$g = $f9a22d5a80b70b70$var$fails$k;
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- required for testing
var $f9a22d5a80b70b70$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$f9a22d5a80b70b70$var$fails$g(function() {
    var symbol = Symbol();
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    return !String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $f9a22d5a80b70b70$var$V8_VERSION$1 && $f9a22d5a80b70b70$var$V8_VERSION$1 < 41;
});
/* eslint-disable es-x/no-symbol -- required for testing */ var $f9a22d5a80b70b70$var$NATIVE_SYMBOL$1 = $f9a22d5a80b70b70$var$nativeSymbol;
var $f9a22d5a80b70b70$var$useSymbolAsUid = $f9a22d5a80b70b70$var$NATIVE_SYMBOL$1 && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $f9a22d5a80b70b70$var$getBuiltIn$6 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$isCallable$k = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$isPrototypeOf$3 = $f9a22d5a80b70b70$var$objectIsPrototypeOf;
var $f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID$1 = $f9a22d5a80b70b70$var$useSymbolAsUid;
var $f9a22d5a80b70b70$var$$Object$3 = Object;
var $f9a22d5a80b70b70$var$isSymbol$2 = $f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID$1 ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $f9a22d5a80b70b70$var$getBuiltIn$6("Symbol");
    return $f9a22d5a80b70b70$var$isCallable$k($Symbol) && $f9a22d5a80b70b70$var$isPrototypeOf$3($Symbol.prototype, $f9a22d5a80b70b70$var$$Object$3(it));
};
var $f9a22d5a80b70b70$var$$String$3 = String;
var $f9a22d5a80b70b70$var$tryToString$4 = function(argument) {
    try {
        return $f9a22d5a80b70b70$var$$String$3(argument);
    } catch (error) {
        return "Object";
    }
};
var $f9a22d5a80b70b70$var$isCallable$j = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$tryToString$3 = $f9a22d5a80b70b70$var$tryToString$4;
var $f9a22d5a80b70b70$var$$TypeError$b = TypeError;
// `Assert: IsCallable(argument) is true`
var $f9a22d5a80b70b70$var$aCallable$7 = function(argument) {
    if ($f9a22d5a80b70b70$var$isCallable$j(argument)) return argument;
    throw $f9a22d5a80b70b70$var$$TypeError$b($f9a22d5a80b70b70$var$tryToString$3(argument) + " is not a function");
};
var $f9a22d5a80b70b70$var$aCallable$6 = $f9a22d5a80b70b70$var$aCallable$7;
// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var $f9a22d5a80b70b70$var$getMethod$4 = function(V, P) {
    var func = V[P];
    return func == null ? undefined : $f9a22d5a80b70b70$var$aCallable$6(func);
};
var $f9a22d5a80b70b70$var$call$i = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$isCallable$i = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$isObject$7 = $f9a22d5a80b70b70$var$isObject$8;
var $f9a22d5a80b70b70$var$$TypeError$a = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var $f9a22d5a80b70b70$var$ordinaryToPrimitive$1 = function(input, pref) {
    var fn, val;
    if (pref === "string" && $f9a22d5a80b70b70$var$isCallable$i(fn = input.toString) && !$f9a22d5a80b70b70$var$isObject$7(val = $f9a22d5a80b70b70$var$call$i(fn, input))) return val;
    if ($f9a22d5a80b70b70$var$isCallable$i(fn = input.valueOf) && !$f9a22d5a80b70b70$var$isObject$7(val = $f9a22d5a80b70b70$var$call$i(fn, input))) return val;
    if (pref !== "string" && $f9a22d5a80b70b70$var$isCallable$i(fn = input.toString) && !$f9a22d5a80b70b70$var$isObject$7(val = $f9a22d5a80b70b70$var$call$i(fn, input))) return val;
    throw $f9a22d5a80b70b70$var$$TypeError$a("Can't convert object to primitive value");
};
var $f9a22d5a80b70b70$var$shared$4 = {
    exports: {}
};
var $f9a22d5a80b70b70$var$isPure = false;
var $f9a22d5a80b70b70$var$global$l = $f9a22d5a80b70b70$var$global$o;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $f9a22d5a80b70b70$var$defineProperty$6 = Object.defineProperty;
var $f9a22d5a80b70b70$var$defineGlobalProperty$3 = function(key, value) {
    try {
        $f9a22d5a80b70b70$var$defineProperty$6($f9a22d5a80b70b70$var$global$l, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $f9a22d5a80b70b70$var$global$l[key] = value;
    }
    return value;
};
var $f9a22d5a80b70b70$var$global$k = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$defineGlobalProperty$2 = $f9a22d5a80b70b70$var$defineGlobalProperty$3;
var $f9a22d5a80b70b70$var$SHARED = "__core-js_shared__";
var $f9a22d5a80b70b70$var$store$3 = $f9a22d5a80b70b70$var$global$k[$f9a22d5a80b70b70$var$SHARED] || $f9a22d5a80b70b70$var$defineGlobalProperty$2($f9a22d5a80b70b70$var$SHARED, {});
var $f9a22d5a80b70b70$var$sharedStore = $f9a22d5a80b70b70$var$store$3;
var $f9a22d5a80b70b70$var$store$2 = $f9a22d5a80b70b70$var$sharedStore;
($f9a22d5a80b70b70$var$shared$4.exports = function(key, value) {
    return $f9a22d5a80b70b70$var$store$2[key] || ($f9a22d5a80b70b70$var$store$2[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: "3.23.3",
    mode: "global",
    copyright: "\xa9 2014-2022 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.23.3/LICENSE",
    source: "https://github.com/zloirock/core-js"
});
var $f9a22d5a80b70b70$var$requireObjectCoercible$2 = $f9a22d5a80b70b70$var$requireObjectCoercible$4;
var $f9a22d5a80b70b70$var$$Object$2 = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $f9a22d5a80b70b70$var$toObject$5 = function(argument) {
    return $f9a22d5a80b70b70$var$$Object$2($f9a22d5a80b70b70$var$requireObjectCoercible$2(argument));
};
var $f9a22d5a80b70b70$var$uncurryThis$i = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toObject$4 = $f9a22d5a80b70b70$var$toObject$5;
var $f9a22d5a80b70b70$var$hasOwnProperty = $f9a22d5a80b70b70$var$uncurryThis$i({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es-x/no-object-hasown -- safe
var $f9a22d5a80b70b70$var$hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
    return $f9a22d5a80b70b70$var$hasOwnProperty($f9a22d5a80b70b70$var$toObject$4(it), key);
};
var $f9a22d5a80b70b70$var$uncurryThis$h = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$id = 0;
var $f9a22d5a80b70b70$var$postfix = Math.random();
var $f9a22d5a80b70b70$var$toString$5 = $f9a22d5a80b70b70$var$uncurryThis$h(1.0.toString);
var $f9a22d5a80b70b70$var$uid$2 = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $f9a22d5a80b70b70$var$toString$5(++$f9a22d5a80b70b70$var$id + $f9a22d5a80b70b70$var$postfix, 36);
};
var $f9a22d5a80b70b70$var$global$j = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$shared$3 = $f9a22d5a80b70b70$var$shared$4.exports;
var $f9a22d5a80b70b70$var$hasOwn$c = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$uid$1 = $f9a22d5a80b70b70$var$uid$2;
var $f9a22d5a80b70b70$var$NATIVE_SYMBOL = $f9a22d5a80b70b70$var$nativeSymbol;
var $f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID = $f9a22d5a80b70b70$var$useSymbolAsUid;
var $f9a22d5a80b70b70$var$WellKnownSymbolsStore = $f9a22d5a80b70b70$var$shared$3("wks");
var $f9a22d5a80b70b70$var$Symbol$1 = $f9a22d5a80b70b70$var$global$j.Symbol;
var $f9a22d5a80b70b70$var$symbolFor = $f9a22d5a80b70b70$var$Symbol$1 && $f9a22d5a80b70b70$var$Symbol$1["for"];
var $f9a22d5a80b70b70$var$createWellKnownSymbol = $f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID ? $f9a22d5a80b70b70$var$Symbol$1 : $f9a22d5a80b70b70$var$Symbol$1 && $f9a22d5a80b70b70$var$Symbol$1.withoutSetter || $f9a22d5a80b70b70$var$uid$1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$i = function(name) {
    if (!$f9a22d5a80b70b70$var$hasOwn$c($f9a22d5a80b70b70$var$WellKnownSymbolsStore, name) || !($f9a22d5a80b70b70$var$NATIVE_SYMBOL || typeof $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name] == "string")) {
        var description = "Symbol." + name;
        if ($f9a22d5a80b70b70$var$NATIVE_SYMBOL && $f9a22d5a80b70b70$var$hasOwn$c($f9a22d5a80b70b70$var$Symbol$1, name)) $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name] = $f9a22d5a80b70b70$var$Symbol$1[name];
        else if ($f9a22d5a80b70b70$var$USE_SYMBOL_AS_UID && $f9a22d5a80b70b70$var$symbolFor) $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name] = $f9a22d5a80b70b70$var$symbolFor(description);
        else $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name] = $f9a22d5a80b70b70$var$createWellKnownSymbol(description);
    }
    return $f9a22d5a80b70b70$var$WellKnownSymbolsStore[name];
};
var $f9a22d5a80b70b70$var$call$h = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$isObject$6 = $f9a22d5a80b70b70$var$isObject$8;
var $f9a22d5a80b70b70$var$isSymbol$1 = $f9a22d5a80b70b70$var$isSymbol$2;
var $f9a22d5a80b70b70$var$getMethod$3 = $f9a22d5a80b70b70$var$getMethod$4;
var $f9a22d5a80b70b70$var$ordinaryToPrimitive = $f9a22d5a80b70b70$var$ordinaryToPrimitive$1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$h = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$$TypeError$9 = TypeError;
var $f9a22d5a80b70b70$var$TO_PRIMITIVE = $f9a22d5a80b70b70$var$wellKnownSymbol$h("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var $f9a22d5a80b70b70$var$toPrimitive$1 = function(input, pref) {
    if (!$f9a22d5a80b70b70$var$isObject$6(input) || $f9a22d5a80b70b70$var$isSymbol$1(input)) return input;
    var exoticToPrim = $f9a22d5a80b70b70$var$getMethod$3(input, $f9a22d5a80b70b70$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $f9a22d5a80b70b70$var$call$h(exoticToPrim, input, pref);
        if (!$f9a22d5a80b70b70$var$isObject$6(result) || $f9a22d5a80b70b70$var$isSymbol$1(result)) return result;
        throw $f9a22d5a80b70b70$var$$TypeError$9("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $f9a22d5a80b70b70$var$ordinaryToPrimitive(input, pref);
};
var $f9a22d5a80b70b70$var$toPrimitive = $f9a22d5a80b70b70$var$toPrimitive$1;
var $f9a22d5a80b70b70$var$isSymbol = $f9a22d5a80b70b70$var$isSymbol$2;
// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var $f9a22d5a80b70b70$var$toPropertyKey$3 = function(argument) {
    var key = $f9a22d5a80b70b70$var$toPrimitive(argument, "string");
    return $f9a22d5a80b70b70$var$isSymbol(key) ? key : key + "";
};
var $f9a22d5a80b70b70$var$global$i = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$isObject$5 = $f9a22d5a80b70b70$var$isObject$8;
var $f9a22d5a80b70b70$var$document$3 = $f9a22d5a80b70b70$var$global$i.document;
// typeof document.createElement is 'object' in old IE
var $f9a22d5a80b70b70$var$EXISTS$1 = $f9a22d5a80b70b70$var$isObject$5($f9a22d5a80b70b70$var$document$3) && $f9a22d5a80b70b70$var$isObject$5($f9a22d5a80b70b70$var$document$3.createElement);
var $f9a22d5a80b70b70$var$documentCreateElement$2 = function(it) {
    return $f9a22d5a80b70b70$var$EXISTS$1 ? $f9a22d5a80b70b70$var$document$3.createElement(it) : {};
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$c = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$fails$f = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$createElement$1 = $f9a22d5a80b70b70$var$documentCreateElement$2;
// Thanks to IE8 for its funny defineProperty
var $f9a22d5a80b70b70$var$ie8DomDefine = !$f9a22d5a80b70b70$var$DESCRIPTORS$c && !$f9a22d5a80b70b70$var$fails$f(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty($f9a22d5a80b70b70$var$createElement$1("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
var $f9a22d5a80b70b70$var$DESCRIPTORS$b = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$call$g = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$propertyIsEnumerableModule$1 = $f9a22d5a80b70b70$var$objectPropertyIsEnumerable;
var $f9a22d5a80b70b70$var$createPropertyDescriptor$4 = $f9a22d5a80b70b70$var$createPropertyDescriptor$5;
var $f9a22d5a80b70b70$var$toIndexedObject$4 = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$toPropertyKey$2 = $f9a22d5a80b70b70$var$toPropertyKey$3;
var $f9a22d5a80b70b70$var$hasOwn$b = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$IE8_DOM_DEFINE$1 = $f9a22d5a80b70b70$var$ie8DomDefine;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor.f = $f9a22d5a80b70b70$var$DESCRIPTORS$b ? $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
    O = $f9a22d5a80b70b70$var$toIndexedObject$4(O);
    P = $f9a22d5a80b70b70$var$toPropertyKey$2(P);
    if ($f9a22d5a80b70b70$var$IE8_DOM_DEFINE$1) try {
        return $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor$1(O, P);
    } catch (error) {}
    if ($f9a22d5a80b70b70$var$hasOwn$b(O, P)) return $f9a22d5a80b70b70$var$createPropertyDescriptor$4(!$f9a22d5a80b70b70$var$call$g($f9a22d5a80b70b70$var$propertyIsEnumerableModule$1.f, O, P), O[P]);
};
var $f9a22d5a80b70b70$var$objectDefineProperty = {};
var $f9a22d5a80b70b70$var$DESCRIPTORS$a = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$fails$e = $f9a22d5a80b70b70$var$fails$k;
// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var $f9a22d5a80b70b70$var$v8PrototypeDefineBug = $f9a22d5a80b70b70$var$DESCRIPTORS$a && $f9a22d5a80b70b70$var$fails$e(function() {
    // eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype != 42;
});
var $f9a22d5a80b70b70$var$isObject$4 = $f9a22d5a80b70b70$var$isObject$8;
var $f9a22d5a80b70b70$var$$String$2 = String;
var $f9a22d5a80b70b70$var$$TypeError$8 = TypeError;
// `Assert: Type(argument) is Object`
var $f9a22d5a80b70b70$var$anObject$g = function(argument) {
    if ($f9a22d5a80b70b70$var$isObject$4(argument)) return argument;
    throw $f9a22d5a80b70b70$var$$TypeError$8($f9a22d5a80b70b70$var$$String$2(argument) + " is not an object");
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$9 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$IE8_DOM_DEFINE = $f9a22d5a80b70b70$var$ie8DomDefine;
var $f9a22d5a80b70b70$var$V8_PROTOTYPE_DEFINE_BUG$1 = $f9a22d5a80b70b70$var$v8PrototypeDefineBug;
var $f9a22d5a80b70b70$var$anObject$f = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$toPropertyKey$1 = $f9a22d5a80b70b70$var$toPropertyKey$3;
var $f9a22d5a80b70b70$var$$TypeError$7 = TypeError;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $f9a22d5a80b70b70$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f9a22d5a80b70b70$var$ENUMERABLE = "enumerable";
var $f9a22d5a80b70b70$var$CONFIGURABLE$1 = "configurable";
var $f9a22d5a80b70b70$var$WRITABLE = "writable";
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
$f9a22d5a80b70b70$var$objectDefineProperty.f = $f9a22d5a80b70b70$var$DESCRIPTORS$9 ? $f9a22d5a80b70b70$var$V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
    $f9a22d5a80b70b70$var$anObject$f(O);
    P = $f9a22d5a80b70b70$var$toPropertyKey$1(P);
    $f9a22d5a80b70b70$var$anObject$f(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $f9a22d5a80b70b70$var$WRITABLE in Attributes && !Attributes[$f9a22d5a80b70b70$var$WRITABLE]) {
        var current = $f9a22d5a80b70b70$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$f9a22d5a80b70b70$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $f9a22d5a80b70b70$var$CONFIGURABLE$1 in Attributes ? Attributes[$f9a22d5a80b70b70$var$CONFIGURABLE$1] : current[$f9a22d5a80b70b70$var$CONFIGURABLE$1],
                enumerable: $f9a22d5a80b70b70$var$ENUMERABLE in Attributes ? Attributes[$f9a22d5a80b70b70$var$ENUMERABLE] : current[$f9a22d5a80b70b70$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $f9a22d5a80b70b70$var$$defineProperty(O, P, Attributes);
} : $f9a22d5a80b70b70$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $f9a22d5a80b70b70$var$anObject$f(O);
    P = $f9a22d5a80b70b70$var$toPropertyKey$1(P);
    $f9a22d5a80b70b70$var$anObject$f(Attributes);
    if ($f9a22d5a80b70b70$var$IE8_DOM_DEFINE) try {
        return $f9a22d5a80b70b70$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw $f9a22d5a80b70b70$var$$TypeError$7("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$8 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$definePropertyModule$5 = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$createPropertyDescriptor$3 = $f9a22d5a80b70b70$var$createPropertyDescriptor$5;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$5 = $f9a22d5a80b70b70$var$DESCRIPTORS$8 ? function(object, key, value) {
    return $f9a22d5a80b70b70$var$definePropertyModule$5.f(object, key, $f9a22d5a80b70b70$var$createPropertyDescriptor$3(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $f9a22d5a80b70b70$var$makeBuiltIn$3 = {
    exports: {}
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$7 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$hasOwn$a = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f9a22d5a80b70b70$var$getDescriptor = $f9a22d5a80b70b70$var$DESCRIPTORS$7 && Object.getOwnPropertyDescriptor;
var $f9a22d5a80b70b70$var$EXISTS = $f9a22d5a80b70b70$var$hasOwn$a($f9a22d5a80b70b70$var$FunctionPrototype$1, "name");
// additional protection from minified / mangled / dropped function names
var $f9a22d5a80b70b70$var$PROPER = $f9a22d5a80b70b70$var$EXISTS && (function something() {}).name === "something";
var $f9a22d5a80b70b70$var$CONFIGURABLE = $f9a22d5a80b70b70$var$EXISTS && (!$f9a22d5a80b70b70$var$DESCRIPTORS$7 || $f9a22d5a80b70b70$var$DESCRIPTORS$7 && $f9a22d5a80b70b70$var$getDescriptor($f9a22d5a80b70b70$var$FunctionPrototype$1, "name").configurable);
var $f9a22d5a80b70b70$var$functionName = {
    EXISTS: $f9a22d5a80b70b70$var$EXISTS,
    PROPER: $f9a22d5a80b70b70$var$PROPER,
    CONFIGURABLE: $f9a22d5a80b70b70$var$CONFIGURABLE
};
var $f9a22d5a80b70b70$var$uncurryThis$g = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$isCallable$h = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$store$1 = $f9a22d5a80b70b70$var$sharedStore;
var $f9a22d5a80b70b70$var$functionToString = $f9a22d5a80b70b70$var$uncurryThis$g(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$f9a22d5a80b70b70$var$isCallable$h($f9a22d5a80b70b70$var$store$1.inspectSource)) $f9a22d5a80b70b70$var$store$1.inspectSource = function(it) {
    return $f9a22d5a80b70b70$var$functionToString(it);
};
var $f9a22d5a80b70b70$var$inspectSource$4 = $f9a22d5a80b70b70$var$store$1.inspectSource;
var $f9a22d5a80b70b70$var$global$h = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$isCallable$g = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$inspectSource$3 = $f9a22d5a80b70b70$var$inspectSource$4;
var $f9a22d5a80b70b70$var$WeakMap$1 = $f9a22d5a80b70b70$var$global$h.WeakMap;
var $f9a22d5a80b70b70$var$nativeWeakMap = $f9a22d5a80b70b70$var$isCallable$g($f9a22d5a80b70b70$var$WeakMap$1) && /native code/.test($f9a22d5a80b70b70$var$inspectSource$3($f9a22d5a80b70b70$var$WeakMap$1));
var $f9a22d5a80b70b70$var$shared$2 = $f9a22d5a80b70b70$var$shared$4.exports;
var $f9a22d5a80b70b70$var$uid = $f9a22d5a80b70b70$var$uid$2;
var $f9a22d5a80b70b70$var$keys = $f9a22d5a80b70b70$var$shared$2("keys");
var $f9a22d5a80b70b70$var$sharedKey$3 = function(key) {
    return $f9a22d5a80b70b70$var$keys[key] || ($f9a22d5a80b70b70$var$keys[key] = $f9a22d5a80b70b70$var$uid(key));
};
var $f9a22d5a80b70b70$var$hiddenKeys$4 = {};
var $f9a22d5a80b70b70$var$NATIVE_WEAK_MAP = $f9a22d5a80b70b70$var$nativeWeakMap;
var $f9a22d5a80b70b70$var$global$g = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$uncurryThis$f = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$isObject$3 = $f9a22d5a80b70b70$var$isObject$8;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$4 = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$hasOwn$9 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$shared$1 = $f9a22d5a80b70b70$var$sharedStore;
var $f9a22d5a80b70b70$var$sharedKey$2 = $f9a22d5a80b70b70$var$sharedKey$3;
var $f9a22d5a80b70b70$var$hiddenKeys$3 = $f9a22d5a80b70b70$var$hiddenKeys$4;
var $f9a22d5a80b70b70$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $f9a22d5a80b70b70$var$TypeError$4 = $f9a22d5a80b70b70$var$global$g.TypeError;
var $f9a22d5a80b70b70$var$WeakMap = $f9a22d5a80b70b70$var$global$g.WeakMap;
var $f9a22d5a80b70b70$var$set$1, $f9a22d5a80b70b70$var$get, $f9a22d5a80b70b70$var$has;
var $f9a22d5a80b70b70$var$enforce = function(it) {
    return $f9a22d5a80b70b70$var$has(it) ? $f9a22d5a80b70b70$var$get(it) : $f9a22d5a80b70b70$var$set$1(it, {});
};
var $f9a22d5a80b70b70$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$f9a22d5a80b70b70$var$isObject$3(it) || (state = $f9a22d5a80b70b70$var$get(it)).type !== TYPE) throw $f9a22d5a80b70b70$var$TypeError$4("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($f9a22d5a80b70b70$var$NATIVE_WEAK_MAP || $f9a22d5a80b70b70$var$shared$1.state) {
    var $f9a22d5a80b70b70$var$store = $f9a22d5a80b70b70$var$shared$1.state || ($f9a22d5a80b70b70$var$shared$1.state = new $f9a22d5a80b70b70$var$WeakMap());
    var $f9a22d5a80b70b70$var$wmget = $f9a22d5a80b70b70$var$uncurryThis$f($f9a22d5a80b70b70$var$store.get);
    var $f9a22d5a80b70b70$var$wmhas = $f9a22d5a80b70b70$var$uncurryThis$f($f9a22d5a80b70b70$var$store.has);
    var $f9a22d5a80b70b70$var$wmset = $f9a22d5a80b70b70$var$uncurryThis$f($f9a22d5a80b70b70$var$store.set);
    $f9a22d5a80b70b70$var$set$1 = function(it, metadata) {
        if ($f9a22d5a80b70b70$var$wmhas($f9a22d5a80b70b70$var$store, it)) throw new $f9a22d5a80b70b70$var$TypeError$4($f9a22d5a80b70b70$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f9a22d5a80b70b70$var$wmset($f9a22d5a80b70b70$var$store, it, metadata);
        return metadata;
    };
    $f9a22d5a80b70b70$var$get = function(it) {
        return $f9a22d5a80b70b70$var$wmget($f9a22d5a80b70b70$var$store, it) || {};
    };
    $f9a22d5a80b70b70$var$has = function(it) {
        return $f9a22d5a80b70b70$var$wmhas($f9a22d5a80b70b70$var$store, it);
    };
} else {
    var $f9a22d5a80b70b70$var$STATE = $f9a22d5a80b70b70$var$sharedKey$2("state");
    $f9a22d5a80b70b70$var$hiddenKeys$3[$f9a22d5a80b70b70$var$STATE] = true;
    $f9a22d5a80b70b70$var$set$1 = function(it, metadata) {
        if ($f9a22d5a80b70b70$var$hasOwn$9(it, $f9a22d5a80b70b70$var$STATE)) throw new $f9a22d5a80b70b70$var$TypeError$4($f9a22d5a80b70b70$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f9a22d5a80b70b70$var$createNonEnumerableProperty$4(it, $f9a22d5a80b70b70$var$STATE, metadata);
        return metadata;
    };
    $f9a22d5a80b70b70$var$get = function(it) {
        return $f9a22d5a80b70b70$var$hasOwn$9(it, $f9a22d5a80b70b70$var$STATE) ? it[$f9a22d5a80b70b70$var$STATE] : {};
    };
    $f9a22d5a80b70b70$var$has = function(it) {
        return $f9a22d5a80b70b70$var$hasOwn$9(it, $f9a22d5a80b70b70$var$STATE);
    };
}
var $f9a22d5a80b70b70$var$internalState = {
    set: $f9a22d5a80b70b70$var$set$1,
    get: $f9a22d5a80b70b70$var$get,
    has: $f9a22d5a80b70b70$var$has,
    enforce: $f9a22d5a80b70b70$var$enforce,
    getterFor: $f9a22d5a80b70b70$var$getterFor
};
var $f9a22d5a80b70b70$var$fails$d = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$isCallable$f = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$hasOwn$8 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$DESCRIPTORS$6 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$CONFIGURABLE_FUNCTION_NAME$1 = $f9a22d5a80b70b70$var$functionName.CONFIGURABLE;
var $f9a22d5a80b70b70$var$inspectSource$2 = $f9a22d5a80b70b70$var$inspectSource$4;
var $f9a22d5a80b70b70$var$InternalStateModule$5 = $f9a22d5a80b70b70$var$internalState;
var $f9a22d5a80b70b70$var$enforceInternalState = $f9a22d5a80b70b70$var$InternalStateModule$5.enforce;
var $f9a22d5a80b70b70$var$getInternalState$3 = $f9a22d5a80b70b70$var$InternalStateModule$5.get;
// eslint-disable-next-line es-x/no-object-defineproperty -- safe
var $f9a22d5a80b70b70$var$defineProperty$5 = Object.defineProperty;
var $f9a22d5a80b70b70$var$CONFIGURABLE_LENGTH = $f9a22d5a80b70b70$var$DESCRIPTORS$6 && !$f9a22d5a80b70b70$var$fails$d(function() {
    return $f9a22d5a80b70b70$var$defineProperty$5(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $f9a22d5a80b70b70$var$TEMPLATE = String(String).split("String");
var $f9a22d5a80b70b70$var$makeBuiltIn$2 = $f9a22d5a80b70b70$var$makeBuiltIn$3.exports = function(value, name, options) {
    if (String(name).slice(0, 7) === "Symbol(") name = "[" + String(name).replace(/^Symbol\(([^)]*)\)/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$f9a22d5a80b70b70$var$hasOwn$8(value, "name") || $f9a22d5a80b70b70$var$CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name) {
        if ($f9a22d5a80b70b70$var$DESCRIPTORS$6) $f9a22d5a80b70b70$var$defineProperty$5(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($f9a22d5a80b70b70$var$CONFIGURABLE_LENGTH && options && $f9a22d5a80b70b70$var$hasOwn$8(options, "arity") && value.length !== options.arity) $f9a22d5a80b70b70$var$defineProperty$5(value, "length", {
        value: options.arity
    });
    try {
        if (options && $f9a22d5a80b70b70$var$hasOwn$8(options, "constructor") && options.constructor) {
            if ($f9a22d5a80b70b70$var$DESCRIPTORS$6) $f9a22d5a80b70b70$var$defineProperty$5(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $f9a22d5a80b70b70$var$enforceInternalState(value);
    if (!$f9a22d5a80b70b70$var$hasOwn$8(state, "source")) state.source = $f9a22d5a80b70b70$var$TEMPLATE.join(typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $f9a22d5a80b70b70$var$makeBuiltIn$2(function toString() {
    return $f9a22d5a80b70b70$var$isCallable$f(this) && $f9a22d5a80b70b70$var$getInternalState$3(this).source || $f9a22d5a80b70b70$var$inspectSource$2(this);
}, "toString");
var $f9a22d5a80b70b70$var$isCallable$e = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$definePropertyModule$4 = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$makeBuiltIn$1 = $f9a22d5a80b70b70$var$makeBuiltIn$3.exports;
var $f9a22d5a80b70b70$var$defineGlobalProperty$1 = $f9a22d5a80b70b70$var$defineGlobalProperty$3;
var $f9a22d5a80b70b70$var$defineBuiltIn$a = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($f9a22d5a80b70b70$var$isCallable$e(value)) $f9a22d5a80b70b70$var$makeBuiltIn$1(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $f9a22d5a80b70b70$var$defineGlobalProperty$1(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $f9a22d5a80b70b70$var$definePropertyModule$4.f(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};
var $f9a22d5a80b70b70$var$objectGetOwnPropertyNames = {};
var $f9a22d5a80b70b70$var$ceil = Math.ceil;
var $f9a22d5a80b70b70$var$floor$4 = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es-x/no-math-trunc -- safe
var $f9a22d5a80b70b70$var$mathTrunc = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $f9a22d5a80b70b70$var$floor$4 : $f9a22d5a80b70b70$var$ceil)(n);
};
var $f9a22d5a80b70b70$var$trunc = $f9a22d5a80b70b70$var$mathTrunc;
// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var $f9a22d5a80b70b70$var$toIntegerOrInfinity$4 = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $f9a22d5a80b70b70$var$trunc(number);
};
var $f9a22d5a80b70b70$var$toIntegerOrInfinity$3 = $f9a22d5a80b70b70$var$toIntegerOrInfinity$4;
var $f9a22d5a80b70b70$var$max$2 = Math.max;
var $f9a22d5a80b70b70$var$min$2 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $f9a22d5a80b70b70$var$toAbsoluteIndex$2 = function(index, length) {
    var integer = $f9a22d5a80b70b70$var$toIntegerOrInfinity$3(index);
    return integer < 0 ? $f9a22d5a80b70b70$var$max$2(integer + length, 0) : $f9a22d5a80b70b70$var$min$2(integer, length);
};
var $f9a22d5a80b70b70$var$toIntegerOrInfinity$2 = $f9a22d5a80b70b70$var$toIntegerOrInfinity$4;
var $f9a22d5a80b70b70$var$min$1 = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $f9a22d5a80b70b70$var$toLength$2 = function(argument) {
    return argument > 0 ? $f9a22d5a80b70b70$var$min$1($f9a22d5a80b70b70$var$toIntegerOrInfinity$2(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $f9a22d5a80b70b70$var$toLength$1 = $f9a22d5a80b70b70$var$toLength$2;
// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var $f9a22d5a80b70b70$var$lengthOfArrayLike$4 = function(obj) {
    return $f9a22d5a80b70b70$var$toLength$1(obj.length);
};
var $f9a22d5a80b70b70$var$toIndexedObject$3 = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$toAbsoluteIndex$1 = $f9a22d5a80b70b70$var$toAbsoluteIndex$2;
var $f9a22d5a80b70b70$var$lengthOfArrayLike$3 = $f9a22d5a80b70b70$var$lengthOfArrayLike$4;
// `Array.prototype.{ indexOf, includes }` methods implementation
var $f9a22d5a80b70b70$var$createMethod$1 = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $f9a22d5a80b70b70$var$toIndexedObject$3($this);
        var length = $f9a22d5a80b70b70$var$lengthOfArrayLike$3(O);
        var index = $f9a22d5a80b70b70$var$toAbsoluteIndex$1(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $f9a22d5a80b70b70$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $f9a22d5a80b70b70$var$createMethod$1(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $f9a22d5a80b70b70$var$createMethod$1(false)
};
var $f9a22d5a80b70b70$var$uncurryThis$e = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$hasOwn$7 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$toIndexedObject$2 = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$indexOf$1 = $f9a22d5a80b70b70$var$arrayIncludes.indexOf;
var $f9a22d5a80b70b70$var$hiddenKeys$2 = $f9a22d5a80b70b70$var$hiddenKeys$4;
var $f9a22d5a80b70b70$var$push$4 = $f9a22d5a80b70b70$var$uncurryThis$e([].push);
var $f9a22d5a80b70b70$var$objectKeysInternal = function(object, names) {
    var O = $f9a22d5a80b70b70$var$toIndexedObject$2(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$f9a22d5a80b70b70$var$hasOwn$7($f9a22d5a80b70b70$var$hiddenKeys$2, key) && $f9a22d5a80b70b70$var$hasOwn$7(O, key) && $f9a22d5a80b70b70$var$push$4(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($f9a22d5a80b70b70$var$hasOwn$7(O, key = names[i++])) ~$f9a22d5a80b70b70$var$indexOf$1(result, key) || $f9a22d5a80b70b70$var$push$4(result, key);
    return result;
};
// IE8- don't enum bug keys
var $f9a22d5a80b70b70$var$enumBugKeys$3 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $f9a22d5a80b70b70$var$internalObjectKeys$1 = $f9a22d5a80b70b70$var$objectKeysInternal;
var $f9a22d5a80b70b70$var$enumBugKeys$2 = $f9a22d5a80b70b70$var$enumBugKeys$3;
var $f9a22d5a80b70b70$var$hiddenKeys$1 = $f9a22d5a80b70b70$var$enumBugKeys$2.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es-x/no-object-getownpropertynames -- safe
$f9a22d5a80b70b70$var$objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $f9a22d5a80b70b70$var$internalObjectKeys$1(O, $f9a22d5a80b70b70$var$hiddenKeys$1);
};
var $f9a22d5a80b70b70$var$objectGetOwnPropertySymbols = {};
// eslint-disable-next-line es-x/no-object-getownpropertysymbols -- safe
$f9a22d5a80b70b70$var$objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;
var $f9a22d5a80b70b70$var$getBuiltIn$5 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$uncurryThis$d = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$getOwnPropertyNamesModule = $f9a22d5a80b70b70$var$objectGetOwnPropertyNames;
var $f9a22d5a80b70b70$var$getOwnPropertySymbolsModule$1 = $f9a22d5a80b70b70$var$objectGetOwnPropertySymbols;
var $f9a22d5a80b70b70$var$anObject$e = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$concat$2 = $f9a22d5a80b70b70$var$uncurryThis$d([].concat);
// all object keys, includes non-enumerable and symbols
var $f9a22d5a80b70b70$var$ownKeys$1 = $f9a22d5a80b70b70$var$getBuiltIn$5("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $f9a22d5a80b70b70$var$getOwnPropertyNamesModule.f($f9a22d5a80b70b70$var$anObject$e(it));
    var getOwnPropertySymbols = $f9a22d5a80b70b70$var$getOwnPropertySymbolsModule$1.f;
    return getOwnPropertySymbols ? $f9a22d5a80b70b70$var$concat$2(keys, getOwnPropertySymbols(it)) : keys;
};
var $f9a22d5a80b70b70$var$hasOwn$6 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$ownKeys = $f9a22d5a80b70b70$var$ownKeys$1;
var $f9a22d5a80b70b70$var$getOwnPropertyDescriptorModule = $f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor;
var $f9a22d5a80b70b70$var$definePropertyModule$3 = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$copyConstructorProperties$1 = function(target, source, exceptions) {
    var keys = $f9a22d5a80b70b70$var$ownKeys(source);
    var defineProperty = $f9a22d5a80b70b70$var$definePropertyModule$3.f;
    var getOwnPropertyDescriptor = $f9a22d5a80b70b70$var$getOwnPropertyDescriptorModule.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$f9a22d5a80b70b70$var$hasOwn$6(target, key) && !(exceptions && $f9a22d5a80b70b70$var$hasOwn$6(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $f9a22d5a80b70b70$var$fails$c = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$isCallable$d = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$replacement = /#|\.prototype\./;
var $f9a22d5a80b70b70$var$isForced$2 = function(feature, detection) {
    var value = $f9a22d5a80b70b70$var$data[$f9a22d5a80b70b70$var$normalize(feature)];
    return value == $f9a22d5a80b70b70$var$POLYFILL ? true : value == $f9a22d5a80b70b70$var$NATIVE ? false : $f9a22d5a80b70b70$var$isCallable$d(detection) ? $f9a22d5a80b70b70$var$fails$c(detection) : !!detection;
};
var $f9a22d5a80b70b70$var$normalize = $f9a22d5a80b70b70$var$isForced$2.normalize = function(string) {
    return String(string).replace($f9a22d5a80b70b70$var$replacement, ".").toLowerCase();
};
var $f9a22d5a80b70b70$var$data = $f9a22d5a80b70b70$var$isForced$2.data = {};
var $f9a22d5a80b70b70$var$NATIVE = $f9a22d5a80b70b70$var$isForced$2.NATIVE = "N";
var $f9a22d5a80b70b70$var$POLYFILL = $f9a22d5a80b70b70$var$isForced$2.POLYFILL = "P";
var $f9a22d5a80b70b70$var$isForced_1 = $f9a22d5a80b70b70$var$isForced$2;
var $f9a22d5a80b70b70$var$global$f = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$2 = $f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor.f;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$3 = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$defineBuiltIn$9 = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$defineGlobalProperty = $f9a22d5a80b70b70$var$defineGlobalProperty$3;
var $f9a22d5a80b70b70$var$copyConstructorProperties = $f9a22d5a80b70b70$var$copyConstructorProperties$1;
var $f9a22d5a80b70b70$var$isForced$1 = $f9a22d5a80b70b70$var$isForced_1;
/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ var $f9a22d5a80b70b70$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $f9a22d5a80b70b70$var$global$f;
    else if (STATIC) target = $f9a22d5a80b70b70$var$global$f[TARGET] || $f9a22d5a80b70b70$var$defineGlobalProperty(TARGET, {});
    else target = ($f9a22d5a80b70b70$var$global$f[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$2(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $f9a22d5a80b70b70$var$isForced$1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $f9a22d5a80b70b70$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $f9a22d5a80b70b70$var$createNonEnumerableProperty$3(sourceProperty, "sham", true);
        $f9a22d5a80b70b70$var$defineBuiltIn$9(target, key, sourceProperty, options);
    }
};
var $f9a22d5a80b70b70$var$internalObjectKeys = $f9a22d5a80b70b70$var$objectKeysInternal;
var $f9a22d5a80b70b70$var$enumBugKeys$1 = $f9a22d5a80b70b70$var$enumBugKeys$3;
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es-x/no-object-keys -- safe
var $f9a22d5a80b70b70$var$objectKeys$2 = Object.keys || function keys(O) {
    return $f9a22d5a80b70b70$var$internalObjectKeys(O, $f9a22d5a80b70b70$var$enumBugKeys$1);
};
var $f9a22d5a80b70b70$var$DESCRIPTORS$5 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$uncurryThis$c = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$call$f = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$fails$b = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$objectKeys$1 = $f9a22d5a80b70b70$var$objectKeys$2;
var $f9a22d5a80b70b70$var$getOwnPropertySymbolsModule = $f9a22d5a80b70b70$var$objectGetOwnPropertySymbols;
var $f9a22d5a80b70b70$var$propertyIsEnumerableModule = $f9a22d5a80b70b70$var$objectPropertyIsEnumerable;
var $f9a22d5a80b70b70$var$toObject$3 = $f9a22d5a80b70b70$var$toObject$5;
var $f9a22d5a80b70b70$var$IndexedObject = $f9a22d5a80b70b70$var$indexedObject;
// eslint-disable-next-line es-x/no-object-assign -- safe
var $f9a22d5a80b70b70$var$$assign = Object.assign;
// eslint-disable-next-line es-x/no-object-defineproperty -- required for testing
var $f9a22d5a80b70b70$var$defineProperty$4 = Object.defineProperty;
var $f9a22d5a80b70b70$var$concat$1 = $f9a22d5a80b70b70$var$uncurryThis$c([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var $f9a22d5a80b70b70$var$objectAssign = !$f9a22d5a80b70b70$var$$assign || $f9a22d5a80b70b70$var$fails$b(function() {
    // should have correct order of operations (Edge bug)
    if ($f9a22d5a80b70b70$var$DESCRIPTORS$5 && $f9a22d5a80b70b70$var$$assign({
        b: 1
    }, $f9a22d5a80b70b70$var$$assign($f9a22d5a80b70b70$var$defineProperty$4({}, "a", {
        enumerable: true,
        get: function() {
            $f9a22d5a80b70b70$var$defineProperty$4(this, "b", {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es-x/no-symbol -- safe
    var symbol = Symbol();
    var alphabet = "abcdefghijklmnopqrst";
    A[symbol] = 7;
    alphabet.split("").forEach(function(chr) {
        B[chr] = chr;
    });
    return $f9a22d5a80b70b70$var$$assign({}, A)[symbol] != 7 || $f9a22d5a80b70b70$var$objectKeys$1($f9a22d5a80b70b70$var$$assign({}, B)).join("") != alphabet;
}) ? function assign(target, source) {
    var T = $f9a22d5a80b70b70$var$toObject$3(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $f9a22d5a80b70b70$var$getOwnPropertySymbolsModule.f;
    var propertyIsEnumerable = $f9a22d5a80b70b70$var$propertyIsEnumerableModule.f;
    while(argumentsLength > index){
        var S = $f9a22d5a80b70b70$var$IndexedObject(arguments[index++]);
        var keys = getOwnPropertySymbols ? $f9a22d5a80b70b70$var$concat$1($f9a22d5a80b70b70$var$objectKeys$1(S), getOwnPropertySymbols(S)) : $f9a22d5a80b70b70$var$objectKeys$1(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$f9a22d5a80b70b70$var$DESCRIPTORS$5 || $f9a22d5a80b70b70$var$call$f(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $f9a22d5a80b70b70$var$$assign;
var $f9a22d5a80b70b70$var$$$a = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$assign$1 = $f9a22d5a80b70b70$var$objectAssign;
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es-x/no-object-assign -- required for testing
$f9a22d5a80b70b70$var$$$a({
    target: "Object",
    stat: true,
    arity: 2,
    forced: Object.assign !== $f9a22d5a80b70b70$var$assign$1
}, {
    assign: $f9a22d5a80b70b70$var$assign$1
});
var $f9a22d5a80b70b70$var$wellKnownSymbol$g = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$TO_STRING_TAG$3 = $f9a22d5a80b70b70$var$wellKnownSymbol$g("toStringTag");
var $f9a22d5a80b70b70$var$test = {};
$f9a22d5a80b70b70$var$test[$f9a22d5a80b70b70$var$TO_STRING_TAG$3] = "z";
var $f9a22d5a80b70b70$var$toStringTagSupport = String($f9a22d5a80b70b70$var$test) === "[object z]";
var $f9a22d5a80b70b70$var$TO_STRING_TAG_SUPPORT = $f9a22d5a80b70b70$var$toStringTagSupport;
var $f9a22d5a80b70b70$var$isCallable$c = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$classofRaw = $f9a22d5a80b70b70$var$classofRaw$1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$f = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$TO_STRING_TAG$2 = $f9a22d5a80b70b70$var$wellKnownSymbol$f("toStringTag");
var $f9a22d5a80b70b70$var$$Object$1 = Object;
// ES3 wrong here
var $f9a22d5a80b70b70$var$CORRECT_ARGUMENTS = $f9a22d5a80b70b70$var$classofRaw(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $f9a22d5a80b70b70$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
var $f9a22d5a80b70b70$var$classof$6 = $f9a22d5a80b70b70$var$TO_STRING_TAG_SUPPORT ? $f9a22d5a80b70b70$var$classofRaw : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $f9a22d5a80b70b70$var$tryGet(O = $f9a22d5a80b70b70$var$$Object$1(it), $f9a22d5a80b70b70$var$TO_STRING_TAG$2)) == "string" ? tag : $f9a22d5a80b70b70$var$CORRECT_ARGUMENTS ? $f9a22d5a80b70b70$var$classofRaw(O) : (result = $f9a22d5a80b70b70$var$classofRaw(O)) == "Object" && $f9a22d5a80b70b70$var$isCallable$c(O.callee) ? "Arguments" : result;
};
var $f9a22d5a80b70b70$var$classof$5 = $f9a22d5a80b70b70$var$classof$6;
var $f9a22d5a80b70b70$var$$String$1 = String;
var $f9a22d5a80b70b70$var$toString$4 = function(argument) {
    if ($f9a22d5a80b70b70$var$classof$5(argument) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
    return $f9a22d5a80b70b70$var$$String$1(argument);
};
var $f9a22d5a80b70b70$var$anObject$d = $f9a22d5a80b70b70$var$anObject$g;
// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var $f9a22d5a80b70b70$var$regexpFlags$1 = function() {
    var that = $f9a22d5a80b70b70$var$anObject$d(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};
var $f9a22d5a80b70b70$var$call$e = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$hasOwn$5 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$isPrototypeOf$2 = $f9a22d5a80b70b70$var$objectIsPrototypeOf;
var $f9a22d5a80b70b70$var$regExpFlags = $f9a22d5a80b70b70$var$regexpFlags$1;
var $f9a22d5a80b70b70$var$RegExpPrototype$2 = RegExp.prototype;
var $f9a22d5a80b70b70$var$regexpGetFlags = function(R) {
    var flags = R.flags;
    return flags === undefined && !("flags" in $f9a22d5a80b70b70$var$RegExpPrototype$2) && !$f9a22d5a80b70b70$var$hasOwn$5(R, "flags") && $f9a22d5a80b70b70$var$isPrototypeOf$2($f9a22d5a80b70b70$var$RegExpPrototype$2, R) ? $f9a22d5a80b70b70$var$call$e($f9a22d5a80b70b70$var$regExpFlags, R) : flags;
};
var $f9a22d5a80b70b70$var$PROPER_FUNCTION_NAME$1 = $f9a22d5a80b70b70$var$functionName.PROPER;
var $f9a22d5a80b70b70$var$defineBuiltIn$8 = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$anObject$c = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$$toString$2 = $f9a22d5a80b70b70$var$toString$4;
var $f9a22d5a80b70b70$var$fails$a = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$getRegExpFlags = $f9a22d5a80b70b70$var$regexpGetFlags;
var $f9a22d5a80b70b70$var$TO_STRING = "toString";
var $f9a22d5a80b70b70$var$RegExpPrototype$1 = RegExp.prototype;
var $f9a22d5a80b70b70$var$n$ToString = $f9a22d5a80b70b70$var$RegExpPrototype$1[$f9a22d5a80b70b70$var$TO_STRING];
var $f9a22d5a80b70b70$var$NOT_GENERIC = $f9a22d5a80b70b70$var$fails$a(function() {
    return $f9a22d5a80b70b70$var$n$ToString.call({
        source: "a",
        flags: "b"
    }) != "/a/b";
});
// FF44- RegExp#toString has a wrong name
var $f9a22d5a80b70b70$var$INCORRECT_NAME = $f9a22d5a80b70b70$var$PROPER_FUNCTION_NAME$1 && $f9a22d5a80b70b70$var$n$ToString.name != $f9a22d5a80b70b70$var$TO_STRING;
// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if ($f9a22d5a80b70b70$var$NOT_GENERIC || $f9a22d5a80b70b70$var$INCORRECT_NAME) $f9a22d5a80b70b70$var$defineBuiltIn$8(RegExp.prototype, $f9a22d5a80b70b70$var$TO_STRING, function toString() {
    var R = $f9a22d5a80b70b70$var$anObject$c(this);
    var pattern = $f9a22d5a80b70b70$var$$toString$2(R.source);
    var flags = $f9a22d5a80b70b70$var$$toString$2($f9a22d5a80b70b70$var$getRegExpFlags(R));
    return "/" + pattern + "/" + flags;
}, {
    unsafe: true
});
var $f9a22d5a80b70b70$var$objectDefineProperties = {};
var $f9a22d5a80b70b70$var$DESCRIPTORS$4 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$V8_PROTOTYPE_DEFINE_BUG = $f9a22d5a80b70b70$var$v8PrototypeDefineBug;
var $f9a22d5a80b70b70$var$definePropertyModule$2 = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$anObject$b = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$toIndexedObject$1 = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$objectKeys = $f9a22d5a80b70b70$var$objectKeys$2;
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es-x/no-object-defineproperties -- safe
$f9a22d5a80b70b70$var$objectDefineProperties.f = $f9a22d5a80b70b70$var$DESCRIPTORS$4 && !$f9a22d5a80b70b70$var$V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
    $f9a22d5a80b70b70$var$anObject$b(O);
    var props = $f9a22d5a80b70b70$var$toIndexedObject$1(Properties);
    var keys = $f9a22d5a80b70b70$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$f9a22d5a80b70b70$var$definePropertyModule$2.f(O, key = keys[index++], props[key]);
    return O;
};
var $f9a22d5a80b70b70$var$getBuiltIn$4 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$html$2 = $f9a22d5a80b70b70$var$getBuiltIn$4("document", "documentElement");
/* global ActiveXObject -- old IE, WSH */ var $f9a22d5a80b70b70$var$anObject$a = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$definePropertiesModule = $f9a22d5a80b70b70$var$objectDefineProperties;
var $f9a22d5a80b70b70$var$enumBugKeys = $f9a22d5a80b70b70$var$enumBugKeys$3;
var $f9a22d5a80b70b70$var$hiddenKeys = $f9a22d5a80b70b70$var$hiddenKeys$4;
var $f9a22d5a80b70b70$var$html$1 = $f9a22d5a80b70b70$var$html$2;
var $f9a22d5a80b70b70$var$documentCreateElement$1 = $f9a22d5a80b70b70$var$documentCreateElement$2;
var $f9a22d5a80b70b70$var$sharedKey$1 = $f9a22d5a80b70b70$var$sharedKey$3;
var $f9a22d5a80b70b70$var$GT = ">";
var $f9a22d5a80b70b70$var$LT = "<";
var $f9a22d5a80b70b70$var$PROTOTYPE = "prototype";
var $f9a22d5a80b70b70$var$SCRIPT = "script";
var $f9a22d5a80b70b70$var$IE_PROTO$1 = $f9a22d5a80b70b70$var$sharedKey$1("IE_PROTO");
var $f9a22d5a80b70b70$var$EmptyConstructor = function() {};
var $f9a22d5a80b70b70$var$scriptTag = function(content) {
    return $f9a22d5a80b70b70$var$LT + $f9a22d5a80b70b70$var$SCRIPT + $f9a22d5a80b70b70$var$GT + content + $f9a22d5a80b70b70$var$LT + "/" + $f9a22d5a80b70b70$var$SCRIPT + $f9a22d5a80b70b70$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $f9a22d5a80b70b70$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($f9a22d5a80b70b70$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f9a22d5a80b70b70$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $f9a22d5a80b70b70$var$documentCreateElement$1("iframe");
    var JS = "java" + $f9a22d5a80b70b70$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $f9a22d5a80b70b70$var$html$1.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($f9a22d5a80b70b70$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $f9a22d5a80b70b70$var$activeXDocument;
var $f9a22d5a80b70b70$var$NullProtoObject = function() {
    try {
        $f9a22d5a80b70b70$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $f9a22d5a80b70b70$var$NullProtoObject = typeof document != "undefined" ? document.domain && $f9a22d5a80b70b70$var$activeXDocument ? $f9a22d5a80b70b70$var$NullProtoObjectViaActiveX($f9a22d5a80b70b70$var$activeXDocument) // old IE
     : $f9a22d5a80b70b70$var$NullProtoObjectViaIFrame() : $f9a22d5a80b70b70$var$NullProtoObjectViaActiveX($f9a22d5a80b70b70$var$activeXDocument); // WSH
    var length = $f9a22d5a80b70b70$var$enumBugKeys.length;
    while(length--)delete $f9a22d5a80b70b70$var$NullProtoObject[$f9a22d5a80b70b70$var$PROTOTYPE][$f9a22d5a80b70b70$var$enumBugKeys[length]];
    return $f9a22d5a80b70b70$var$NullProtoObject();
};
$f9a22d5a80b70b70$var$hiddenKeys[$f9a22d5a80b70b70$var$IE_PROTO$1] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es-x/no-object-create -- safe
var $f9a22d5a80b70b70$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f9a22d5a80b70b70$var$EmptyConstructor[$f9a22d5a80b70b70$var$PROTOTYPE] = $f9a22d5a80b70b70$var$anObject$a(O);
        result = new $f9a22d5a80b70b70$var$EmptyConstructor();
        $f9a22d5a80b70b70$var$EmptyConstructor[$f9a22d5a80b70b70$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f9a22d5a80b70b70$var$IE_PROTO$1] = O;
    } else result = $f9a22d5a80b70b70$var$NullProtoObject();
    return Properties === undefined ? result : $f9a22d5a80b70b70$var$definePropertiesModule.f(result, Properties);
};
var $f9a22d5a80b70b70$var$wellKnownSymbol$e = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$create$3 = $f9a22d5a80b70b70$var$objectCreate;
var $f9a22d5a80b70b70$var$defineProperty$3 = $f9a22d5a80b70b70$var$objectDefineProperty.f;
var $f9a22d5a80b70b70$var$UNSCOPABLES = $f9a22d5a80b70b70$var$wellKnownSymbol$e("unscopables");
var $f9a22d5a80b70b70$var$ArrayPrototype$1 = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($f9a22d5a80b70b70$var$ArrayPrototype$1[$f9a22d5a80b70b70$var$UNSCOPABLES] == undefined) $f9a22d5a80b70b70$var$defineProperty$3($f9a22d5a80b70b70$var$ArrayPrototype$1, $f9a22d5a80b70b70$var$UNSCOPABLES, {
    configurable: true,
    value: $f9a22d5a80b70b70$var$create$3(null)
});
// add a key to Array.prototype[@@unscopables]
var $f9a22d5a80b70b70$var$addToUnscopables$1 = function(key) {
    $f9a22d5a80b70b70$var$ArrayPrototype$1[$f9a22d5a80b70b70$var$UNSCOPABLES][key] = true;
};
var $f9a22d5a80b70b70$var$iterators = {};
var $f9a22d5a80b70b70$var$fails$9 = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$correctPrototypeGetter = !$f9a22d5a80b70b70$var$fails$9(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es-x/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});
var $f9a22d5a80b70b70$var$hasOwn$4 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$isCallable$b = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$toObject$2 = $f9a22d5a80b70b70$var$toObject$5;
var $f9a22d5a80b70b70$var$sharedKey = $f9a22d5a80b70b70$var$sharedKey$3;
var $f9a22d5a80b70b70$var$CORRECT_PROTOTYPE_GETTER = $f9a22d5a80b70b70$var$correctPrototypeGetter;
var $f9a22d5a80b70b70$var$IE_PROTO = $f9a22d5a80b70b70$var$sharedKey("IE_PROTO");
var $f9a22d5a80b70b70$var$$Object = Object;
var $f9a22d5a80b70b70$var$ObjectPrototype = $f9a22d5a80b70b70$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es-x/no-object-getprototypeof -- safe
var $f9a22d5a80b70b70$var$objectGetPrototypeOf = $f9a22d5a80b70b70$var$CORRECT_PROTOTYPE_GETTER ? $f9a22d5a80b70b70$var$$Object.getPrototypeOf : function(O) {
    var object = $f9a22d5a80b70b70$var$toObject$2(O);
    if ($f9a22d5a80b70b70$var$hasOwn$4(object, $f9a22d5a80b70b70$var$IE_PROTO)) return object[$f9a22d5a80b70b70$var$IE_PROTO];
    var constructor = object.constructor;
    if ($f9a22d5a80b70b70$var$isCallable$b(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $f9a22d5a80b70b70$var$$Object ? $f9a22d5a80b70b70$var$ObjectPrototype : null;
};
var $f9a22d5a80b70b70$var$fails$8 = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$isCallable$a = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$getPrototypeOf$1 = $f9a22d5a80b70b70$var$objectGetPrototypeOf;
var $f9a22d5a80b70b70$var$defineBuiltIn$7 = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$wellKnownSymbol$d = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$ITERATOR$7 = $f9a22d5a80b70b70$var$wellKnownSymbol$d("iterator");
var $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS$1 = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $f9a22d5a80b70b70$var$IteratorPrototype$2, $f9a22d5a80b70b70$var$PrototypeOfArrayIteratorPrototype, $f9a22d5a80b70b70$var$arrayIterator;
/* eslint-disable es-x/no-array-prototype-keys -- safe */ if ([].keys) {
    $f9a22d5a80b70b70$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $f9a22d5a80b70b70$var$arrayIterator)) $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS$1 = true;
    else {
        $f9a22d5a80b70b70$var$PrototypeOfArrayIteratorPrototype = $f9a22d5a80b70b70$var$getPrototypeOf$1($f9a22d5a80b70b70$var$getPrototypeOf$1($f9a22d5a80b70b70$var$arrayIterator));
        if ($f9a22d5a80b70b70$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $f9a22d5a80b70b70$var$IteratorPrototype$2 = $f9a22d5a80b70b70$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $f9a22d5a80b70b70$var$NEW_ITERATOR_PROTOTYPE = $f9a22d5a80b70b70$var$IteratorPrototype$2 == undefined || $f9a22d5a80b70b70$var$fails$8(function() {
    var test = {};
    // FF44- legacy iterators case
    return $f9a22d5a80b70b70$var$IteratorPrototype$2[$f9a22d5a80b70b70$var$ITERATOR$7].call(test) !== test;
});
if ($f9a22d5a80b70b70$var$NEW_ITERATOR_PROTOTYPE) $f9a22d5a80b70b70$var$IteratorPrototype$2 = {};
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$f9a22d5a80b70b70$var$isCallable$a($f9a22d5a80b70b70$var$IteratorPrototype$2[$f9a22d5a80b70b70$var$ITERATOR$7])) $f9a22d5a80b70b70$var$defineBuiltIn$7($f9a22d5a80b70b70$var$IteratorPrototype$2, $f9a22d5a80b70b70$var$ITERATOR$7, function() {
    return this;
});
var $f9a22d5a80b70b70$var$iteratorsCore = {
    IteratorPrototype: $f9a22d5a80b70b70$var$IteratorPrototype$2,
    BUGGY_SAFARI_ITERATORS: $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS$1
};
var $f9a22d5a80b70b70$var$defineProperty$2 = $f9a22d5a80b70b70$var$objectDefineProperty.f;
var $f9a22d5a80b70b70$var$hasOwn$3 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$c = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$TO_STRING_TAG$1 = $f9a22d5a80b70b70$var$wellKnownSymbol$c("toStringTag");
var $f9a22d5a80b70b70$var$setToStringTag$5 = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$f9a22d5a80b70b70$var$hasOwn$3(target, $f9a22d5a80b70b70$var$TO_STRING_TAG$1)) $f9a22d5a80b70b70$var$defineProperty$2(target, $f9a22d5a80b70b70$var$TO_STRING_TAG$1, {
        configurable: true,
        value: TAG
    });
};
var $f9a22d5a80b70b70$var$IteratorPrototype$1 = $f9a22d5a80b70b70$var$iteratorsCore.IteratorPrototype;
var $f9a22d5a80b70b70$var$create$2 = $f9a22d5a80b70b70$var$objectCreate;
var $f9a22d5a80b70b70$var$createPropertyDescriptor$2 = $f9a22d5a80b70b70$var$createPropertyDescriptor$5;
var $f9a22d5a80b70b70$var$setToStringTag$4 = $f9a22d5a80b70b70$var$setToStringTag$5;
var $f9a22d5a80b70b70$var$Iterators$4 = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$returnThis$1 = function() {
    return this;
};
var $f9a22d5a80b70b70$var$createIteratorConstructor$2 = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $f9a22d5a80b70b70$var$create$2($f9a22d5a80b70b70$var$IteratorPrototype$1, {
        next: $f9a22d5a80b70b70$var$createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next)
    });
    $f9a22d5a80b70b70$var$setToStringTag$4(IteratorConstructor, TO_STRING_TAG, false);
    $f9a22d5a80b70b70$var$Iterators$4[TO_STRING_TAG] = $f9a22d5a80b70b70$var$returnThis$1;
    return IteratorConstructor;
};
var $f9a22d5a80b70b70$var$isCallable$9 = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$$String = String;
var $f9a22d5a80b70b70$var$$TypeError$6 = TypeError;
var $f9a22d5a80b70b70$var$aPossiblePrototype$1 = function(argument) {
    if (typeof argument == "object" || $f9a22d5a80b70b70$var$isCallable$9(argument)) return argument;
    throw $f9a22d5a80b70b70$var$$TypeError$6("Can't set " + $f9a22d5a80b70b70$var$$String(argument) + " as a prototype");
};
/* eslint-disable no-proto -- safe */ var $f9a22d5a80b70b70$var$uncurryThis$b = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$anObject$9 = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$aPossiblePrototype = $f9a22d5a80b70b70$var$aPossiblePrototype$1;
// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es-x/no-object-setprototypeof -- safe
var $f9a22d5a80b70b70$var$objectSetPrototypeOf = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        // eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
        setter = $f9a22d5a80b70b70$var$uncurryThis$b(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set);
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $f9a22d5a80b70b70$var$anObject$9(O);
        $f9a22d5a80b70b70$var$aPossiblePrototype(proto);
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);
var $f9a22d5a80b70b70$var$$$9 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$call$d = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$FunctionName = $f9a22d5a80b70b70$var$functionName;
var $f9a22d5a80b70b70$var$isCallable$8 = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$createIteratorConstructor$1 = $f9a22d5a80b70b70$var$createIteratorConstructor$2;
var $f9a22d5a80b70b70$var$getPrototypeOf = $f9a22d5a80b70b70$var$objectGetPrototypeOf;
var $f9a22d5a80b70b70$var$setPrototypeOf$1 = $f9a22d5a80b70b70$var$objectSetPrototypeOf;
var $f9a22d5a80b70b70$var$setToStringTag$3 = $f9a22d5a80b70b70$var$setToStringTag$5;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$2 = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$defineBuiltIn$6 = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$wellKnownSymbol$b = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$Iterators$3 = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$IteratorsCore = $f9a22d5a80b70b70$var$iteratorsCore;
var $f9a22d5a80b70b70$var$PROPER_FUNCTION_NAME = $f9a22d5a80b70b70$var$FunctionName.PROPER;
var $f9a22d5a80b70b70$var$CONFIGURABLE_FUNCTION_NAME = $f9a22d5a80b70b70$var$FunctionName.CONFIGURABLE;
var $f9a22d5a80b70b70$var$IteratorPrototype = $f9a22d5a80b70b70$var$IteratorsCore.IteratorPrototype;
var $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS = $f9a22d5a80b70b70$var$IteratorsCore.BUGGY_SAFARI_ITERATORS;
var $f9a22d5a80b70b70$var$ITERATOR$6 = $f9a22d5a80b70b70$var$wellKnownSymbol$b("iterator");
var $f9a22d5a80b70b70$var$KEYS = "keys";
var $f9a22d5a80b70b70$var$VALUES = "values";
var $f9a22d5a80b70b70$var$ENTRIES = "entries";
var $f9a22d5a80b70b70$var$returnThis = function() {
    return this;
};
var $f9a22d5a80b70b70$var$defineIterator$2 = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $f9a22d5a80b70b70$var$createIteratorConstructor$1(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $f9a22d5a80b70b70$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f9a22d5a80b70b70$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $f9a22d5a80b70b70$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$f9a22d5a80b70b70$var$ITERATOR$6] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME == "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $f9a22d5a80b70b70$var$getPrototypeOf(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if ($f9a22d5a80b70b70$var$getPrototypeOf(CurrentIteratorPrototype) !== $f9a22d5a80b70b70$var$IteratorPrototype) {
                if ($f9a22d5a80b70b70$var$setPrototypeOf$1) $f9a22d5a80b70b70$var$setPrototypeOf$1(CurrentIteratorPrototype, $f9a22d5a80b70b70$var$IteratorPrototype);
                else if (!$f9a22d5a80b70b70$var$isCallable$8(CurrentIteratorPrototype[$f9a22d5a80b70b70$var$ITERATOR$6])) $f9a22d5a80b70b70$var$defineBuiltIn$6(CurrentIteratorPrototype, $f9a22d5a80b70b70$var$ITERATOR$6, $f9a22d5a80b70b70$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $f9a22d5a80b70b70$var$setToStringTag$3(CurrentIteratorPrototype, TO_STRING_TAG, true);
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($f9a22d5a80b70b70$var$PROPER_FUNCTION_NAME && DEFAULT == $f9a22d5a80b70b70$var$VALUES && nativeIterator && nativeIterator.name !== $f9a22d5a80b70b70$var$VALUES) {
        if ($f9a22d5a80b70b70$var$CONFIGURABLE_FUNCTION_NAME) $f9a22d5a80b70b70$var$createNonEnumerableProperty$2(IterablePrototype, "name", $f9a22d5a80b70b70$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $f9a22d5a80b70b70$var$call$d(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($f9a22d5a80b70b70$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($f9a22d5a80b70b70$var$KEYS),
            entries: getIterationMethod($f9a22d5a80b70b70$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $f9a22d5a80b70b70$var$defineBuiltIn$6(IterablePrototype, KEY, methods[KEY]);
        } else $f9a22d5a80b70b70$var$$$9({
            target: NAME,
            proto: true,
            forced: $f9a22d5a80b70b70$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if (IterablePrototype[$f9a22d5a80b70b70$var$ITERATOR$6] !== defaultIterator) $f9a22d5a80b70b70$var$defineBuiltIn$6(IterablePrototype, $f9a22d5a80b70b70$var$ITERATOR$6, defaultIterator, {
        name: DEFAULT
    });
    $f9a22d5a80b70b70$var$Iterators$3[NAME] = defaultIterator;
    return methods;
};
var $f9a22d5a80b70b70$var$toIndexedObject = $f9a22d5a80b70b70$var$toIndexedObject$5;
var $f9a22d5a80b70b70$var$addToUnscopables = $f9a22d5a80b70b70$var$addToUnscopables$1;
var $f9a22d5a80b70b70$var$Iterators$2 = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$InternalStateModule$4 = $f9a22d5a80b70b70$var$internalState;
var $f9a22d5a80b70b70$var$defineProperty$1 = $f9a22d5a80b70b70$var$objectDefineProperty.f;
var $f9a22d5a80b70b70$var$defineIterator$1 = $f9a22d5a80b70b70$var$defineIterator$2;
var $f9a22d5a80b70b70$var$DESCRIPTORS$3 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$ARRAY_ITERATOR = "Array Iterator";
var $f9a22d5a80b70b70$var$setInternalState$4 = $f9a22d5a80b70b70$var$InternalStateModule$4.set;
var $f9a22d5a80b70b70$var$getInternalState$2 = $f9a22d5a80b70b70$var$InternalStateModule$4.getterFor($f9a22d5a80b70b70$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var $f9a22d5a80b70b70$var$es_array_iterator = $f9a22d5a80b70b70$var$defineIterator$1(Array, "Array", function(iterated, kind) {
    $f9a22d5a80b70b70$var$setInternalState$4(this, {
        type: $f9a22d5a80b70b70$var$ARRAY_ITERATOR,
        target: $f9a22d5a80b70b70$var$toIndexedObject(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $f9a22d5a80b70b70$var$getInternalState$2(this);
    var target = state.target;
    var kind = state.kind;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return {
            value: undefined,
            done: true
        };
    }
    if (kind == "keys") return {
        value: index,
        done: false
    };
    if (kind == "values") return {
        value: target[index],
        done: false
    };
    return {
        value: [
            index,
            target[index]
        ],
        done: false
    };
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $f9a22d5a80b70b70$var$values = $f9a22d5a80b70b70$var$Iterators$2.Arguments = $f9a22d5a80b70b70$var$Iterators$2.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$f9a22d5a80b70b70$var$addToUnscopables("keys");
$f9a22d5a80b70b70$var$addToUnscopables("values");
$f9a22d5a80b70b70$var$addToUnscopables("entries");
// V8 ~ Chrome 45- bug
if ($f9a22d5a80b70b70$var$DESCRIPTORS$3 && $f9a22d5a80b70b70$var$values.name !== "values") try {
    $f9a22d5a80b70b70$var$defineProperty$1($f9a22d5a80b70b70$var$values, "name", {
        value: "values"
    });
} catch (error) {}
var $f9a22d5a80b70b70$var$classof$4 = $f9a22d5a80b70b70$var$classofRaw$1;
var $f9a22d5a80b70b70$var$global$e = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$engineIsNode = $f9a22d5a80b70b70$var$classof$4($f9a22d5a80b70b70$var$global$e.process) == "process";
var $f9a22d5a80b70b70$var$getBuiltIn$3 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$definePropertyModule$1 = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$wellKnownSymbol$a = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$DESCRIPTORS$2 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$SPECIES$3 = $f9a22d5a80b70b70$var$wellKnownSymbol$a("species");
var $f9a22d5a80b70b70$var$setSpecies$1 = function(CONSTRUCTOR_NAME) {
    var Constructor = $f9a22d5a80b70b70$var$getBuiltIn$3(CONSTRUCTOR_NAME);
    var defineProperty = $f9a22d5a80b70b70$var$definePropertyModule$1.f;
    if ($f9a22d5a80b70b70$var$DESCRIPTORS$2 && Constructor && !Constructor[$f9a22d5a80b70b70$var$SPECIES$3]) defineProperty(Constructor, $f9a22d5a80b70b70$var$SPECIES$3, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};
var $f9a22d5a80b70b70$var$isPrototypeOf$1 = $f9a22d5a80b70b70$var$objectIsPrototypeOf;
var $f9a22d5a80b70b70$var$$TypeError$5 = TypeError;
var $f9a22d5a80b70b70$var$anInstance$3 = function(it, Prototype) {
    if ($f9a22d5a80b70b70$var$isPrototypeOf$1(Prototype, it)) return it;
    throw $f9a22d5a80b70b70$var$$TypeError$5("Incorrect invocation");
};
var $f9a22d5a80b70b70$var$uncurryThis$a = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$fails$7 = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$isCallable$7 = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$classof$3 = $f9a22d5a80b70b70$var$classof$6;
var $f9a22d5a80b70b70$var$getBuiltIn$2 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$inspectSource$1 = $f9a22d5a80b70b70$var$inspectSource$4;
var $f9a22d5a80b70b70$var$noop = function() {};
var $f9a22d5a80b70b70$var$empty = [];
var $f9a22d5a80b70b70$var$construct = $f9a22d5a80b70b70$var$getBuiltIn$2("Reflect", "construct");
var $f9a22d5a80b70b70$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $f9a22d5a80b70b70$var$exec$3 = $f9a22d5a80b70b70$var$uncurryThis$a($f9a22d5a80b70b70$var$constructorRegExp.exec);
var $f9a22d5a80b70b70$var$INCORRECT_TO_STRING = !$f9a22d5a80b70b70$var$constructorRegExp.exec($f9a22d5a80b70b70$var$noop);
var $f9a22d5a80b70b70$var$isConstructorModern = function isConstructor(argument) {
    if (!$f9a22d5a80b70b70$var$isCallable$7(argument)) return false;
    try {
        $f9a22d5a80b70b70$var$construct($f9a22d5a80b70b70$var$noop, $f9a22d5a80b70b70$var$empty, argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $f9a22d5a80b70b70$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$f9a22d5a80b70b70$var$isCallable$7(argument)) return false;
    switch($f9a22d5a80b70b70$var$classof$3(argument)){
        case "AsyncFunction":
        case "GeneratorFunction":
        case "AsyncGeneratorFunction":
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $f9a22d5a80b70b70$var$INCORRECT_TO_STRING || !!$f9a22d5a80b70b70$var$exec$3($f9a22d5a80b70b70$var$constructorRegExp, $f9a22d5a80b70b70$var$inspectSource$1(argument));
    } catch (error) {
        return true;
    }
};
$f9a22d5a80b70b70$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var $f9a22d5a80b70b70$var$isConstructor$2 = !$f9a22d5a80b70b70$var$construct || $f9a22d5a80b70b70$var$fails$7(function() {
    var called;
    return $f9a22d5a80b70b70$var$isConstructorModern($f9a22d5a80b70b70$var$isConstructorModern.call) || !$f9a22d5a80b70b70$var$isConstructorModern(Object) || !$f9a22d5a80b70b70$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $f9a22d5a80b70b70$var$isConstructorLegacy : $f9a22d5a80b70b70$var$isConstructorModern;
var $f9a22d5a80b70b70$var$isConstructor$1 = $f9a22d5a80b70b70$var$isConstructor$2;
var $f9a22d5a80b70b70$var$tryToString$2 = $f9a22d5a80b70b70$var$tryToString$4;
var $f9a22d5a80b70b70$var$$TypeError$4 = TypeError;
// `Assert: IsConstructor(argument) is true`
var $f9a22d5a80b70b70$var$aConstructor$1 = function(argument) {
    if ($f9a22d5a80b70b70$var$isConstructor$1(argument)) return argument;
    throw $f9a22d5a80b70b70$var$$TypeError$4($f9a22d5a80b70b70$var$tryToString$2(argument) + " is not a constructor");
};
var $f9a22d5a80b70b70$var$anObject$8 = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$aConstructor = $f9a22d5a80b70b70$var$aConstructor$1;
var $f9a22d5a80b70b70$var$wellKnownSymbol$9 = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$SPECIES$2 = $f9a22d5a80b70b70$var$wellKnownSymbol$9("species");
// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var $f9a22d5a80b70b70$var$speciesConstructor$1 = function(O, defaultConstructor) {
    var C = $f9a22d5a80b70b70$var$anObject$8(O).constructor;
    var S;
    return C === undefined || (S = $f9a22d5a80b70b70$var$anObject$8(C)[$f9a22d5a80b70b70$var$SPECIES$2]) == undefined ? defaultConstructor : $f9a22d5a80b70b70$var$aConstructor(S);
};
var $f9a22d5a80b70b70$var$NATIVE_BIND$1 = $f9a22d5a80b70b70$var$functionBindNative;
var $f9a22d5a80b70b70$var$FunctionPrototype = Function.prototype;
var $f9a22d5a80b70b70$var$apply$2 = $f9a22d5a80b70b70$var$FunctionPrototype.apply;
var $f9a22d5a80b70b70$var$call$c = $f9a22d5a80b70b70$var$FunctionPrototype.call;
// eslint-disable-next-line es-x/no-reflect -- safe
var $f9a22d5a80b70b70$var$functionApply = typeof Reflect == "object" && Reflect.apply || ($f9a22d5a80b70b70$var$NATIVE_BIND$1 ? $f9a22d5a80b70b70$var$call$c.bind($f9a22d5a80b70b70$var$apply$2) : function() {
    return $f9a22d5a80b70b70$var$call$c.apply($f9a22d5a80b70b70$var$apply$2, arguments);
});
var $f9a22d5a80b70b70$var$uncurryThis$9 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$aCallable$5 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$NATIVE_BIND = $f9a22d5a80b70b70$var$functionBindNative;
var $f9a22d5a80b70b70$var$bind$7 = $f9a22d5a80b70b70$var$uncurryThis$9($f9a22d5a80b70b70$var$uncurryThis$9.bind);
// optional / simple context binding
var $f9a22d5a80b70b70$var$functionBindContext = function(fn, that) {
    $f9a22d5a80b70b70$var$aCallable$5(fn);
    return that === undefined ? fn : $f9a22d5a80b70b70$var$NATIVE_BIND ? $f9a22d5a80b70b70$var$bind$7(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};
var $f9a22d5a80b70b70$var$uncurryThis$8 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$arraySlice$3 = $f9a22d5a80b70b70$var$uncurryThis$8([].slice);
var $f9a22d5a80b70b70$var$$TypeError$3 = TypeError;
var $f9a22d5a80b70b70$var$validateArgumentsLength$3 = function(passed, required) {
    if (passed < required) throw $f9a22d5a80b70b70$var$$TypeError$3("Not enough arguments");
    return passed;
};
var $f9a22d5a80b70b70$var$userAgent$2 = $f9a22d5a80b70b70$var$engineUserAgent;
var $f9a22d5a80b70b70$var$engineIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test($f9a22d5a80b70b70$var$userAgent$2);
var $f9a22d5a80b70b70$var$global$d = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$apply$1 = $f9a22d5a80b70b70$var$functionApply;
var $f9a22d5a80b70b70$var$bind$6 = $f9a22d5a80b70b70$var$functionBindContext;
var $f9a22d5a80b70b70$var$isCallable$6 = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$hasOwn$2 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$fails$6 = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$html = $f9a22d5a80b70b70$var$html$2;
var $f9a22d5a80b70b70$var$arraySlice$2 = $f9a22d5a80b70b70$var$arraySlice$3;
var $f9a22d5a80b70b70$var$createElement = $f9a22d5a80b70b70$var$documentCreateElement$2;
var $f9a22d5a80b70b70$var$validateArgumentsLength$2 = $f9a22d5a80b70b70$var$validateArgumentsLength$3;
var $f9a22d5a80b70b70$var$IS_IOS$1 = $f9a22d5a80b70b70$var$engineIsIos;
var $f9a22d5a80b70b70$var$IS_NODE$2 = $f9a22d5a80b70b70$var$engineIsNode;
var $f9a22d5a80b70b70$var$set = $f9a22d5a80b70b70$var$global$d.setImmediate;
var $f9a22d5a80b70b70$var$clear = $f9a22d5a80b70b70$var$global$d.clearImmediate;
var $f9a22d5a80b70b70$var$process$2 = $f9a22d5a80b70b70$var$global$d.process;
var $f9a22d5a80b70b70$var$Dispatch = $f9a22d5a80b70b70$var$global$d.Dispatch;
var $f9a22d5a80b70b70$var$Function$1 = $f9a22d5a80b70b70$var$global$d.Function;
var $f9a22d5a80b70b70$var$MessageChannel = $f9a22d5a80b70b70$var$global$d.MessageChannel;
var $f9a22d5a80b70b70$var$String$1 = $f9a22d5a80b70b70$var$global$d.String;
var $f9a22d5a80b70b70$var$counter = 0;
var $f9a22d5a80b70b70$var$queue$1 = {};
var $f9a22d5a80b70b70$var$ONREADYSTATECHANGE = "onreadystatechange";
var $f9a22d5a80b70b70$var$location, $f9a22d5a80b70b70$var$defer, $f9a22d5a80b70b70$var$channel, $f9a22d5a80b70b70$var$port;
try {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $f9a22d5a80b70b70$var$location = $f9a22d5a80b70b70$var$global$d.location;
} catch (error) {}
var $f9a22d5a80b70b70$var$run = function(id) {
    if ($f9a22d5a80b70b70$var$hasOwn$2($f9a22d5a80b70b70$var$queue$1, id)) {
        var fn = $f9a22d5a80b70b70$var$queue$1[id];
        delete $f9a22d5a80b70b70$var$queue$1[id];
        fn();
    }
};
var $f9a22d5a80b70b70$var$runner = function(id) {
    return function() {
        $f9a22d5a80b70b70$var$run(id);
    };
};
var $f9a22d5a80b70b70$var$listener = function(event) {
    $f9a22d5a80b70b70$var$run(event.data);
};
var $f9a22d5a80b70b70$var$post = function(id) {
    // old engines have not location.origin
    $f9a22d5a80b70b70$var$global$d.postMessage($f9a22d5a80b70b70$var$String$1(id), $f9a22d5a80b70b70$var$location.protocol + "//" + $f9a22d5a80b70b70$var$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$f9a22d5a80b70b70$var$set || !$f9a22d5a80b70b70$var$clear) {
    $f9a22d5a80b70b70$var$set = function setImmediate(handler) {
        $f9a22d5a80b70b70$var$validateArgumentsLength$2(arguments.length, 1);
        var fn = $f9a22d5a80b70b70$var$isCallable$6(handler) ? handler : $f9a22d5a80b70b70$var$Function$1(handler);
        var args = $f9a22d5a80b70b70$var$arraySlice$2(arguments, 1);
        $f9a22d5a80b70b70$var$queue$1[++$f9a22d5a80b70b70$var$counter] = function() {
            $f9a22d5a80b70b70$var$apply$1(fn, undefined, args);
        };
        $f9a22d5a80b70b70$var$defer($f9a22d5a80b70b70$var$counter);
        return $f9a22d5a80b70b70$var$counter;
    };
    $f9a22d5a80b70b70$var$clear = function clearImmediate(id) {
        delete $f9a22d5a80b70b70$var$queue$1[id];
    };
    // Node.js 0.8-
    if ($f9a22d5a80b70b70$var$IS_NODE$2) $f9a22d5a80b70b70$var$defer = function(id) {
        $f9a22d5a80b70b70$var$process$2.nextTick($f9a22d5a80b70b70$var$runner(id));
    };
    else if ($f9a22d5a80b70b70$var$Dispatch && $f9a22d5a80b70b70$var$Dispatch.now) $f9a22d5a80b70b70$var$defer = function(id) {
        $f9a22d5a80b70b70$var$Dispatch.now($f9a22d5a80b70b70$var$runner(id));
    };
    else if ($f9a22d5a80b70b70$var$MessageChannel && !$f9a22d5a80b70b70$var$IS_IOS$1) {
        $f9a22d5a80b70b70$var$channel = new $f9a22d5a80b70b70$var$MessageChannel();
        $f9a22d5a80b70b70$var$port = $f9a22d5a80b70b70$var$channel.port2;
        $f9a22d5a80b70b70$var$channel.port1.onmessage = $f9a22d5a80b70b70$var$listener;
        $f9a22d5a80b70b70$var$defer = $f9a22d5a80b70b70$var$bind$6($f9a22d5a80b70b70$var$port.postMessage, $f9a22d5a80b70b70$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($f9a22d5a80b70b70$var$global$d.addEventListener && $f9a22d5a80b70b70$var$isCallable$6($f9a22d5a80b70b70$var$global$d.postMessage) && !$f9a22d5a80b70b70$var$global$d.importScripts && $f9a22d5a80b70b70$var$location && $f9a22d5a80b70b70$var$location.protocol !== "file:" && !$f9a22d5a80b70b70$var$fails$6($f9a22d5a80b70b70$var$post)) {
        $f9a22d5a80b70b70$var$defer = $f9a22d5a80b70b70$var$post;
        $f9a22d5a80b70b70$var$global$d.addEventListener("message", $f9a22d5a80b70b70$var$listener, false);
    // IE8-
    } else if ($f9a22d5a80b70b70$var$ONREADYSTATECHANGE in $f9a22d5a80b70b70$var$createElement("script")) $f9a22d5a80b70b70$var$defer = function(id) {
        $f9a22d5a80b70b70$var$html.appendChild($f9a22d5a80b70b70$var$createElement("script"))[$f9a22d5a80b70b70$var$ONREADYSTATECHANGE] = function() {
            $f9a22d5a80b70b70$var$html.removeChild(this);
            $f9a22d5a80b70b70$var$run(id);
        };
    };
    else $f9a22d5a80b70b70$var$defer = function(id) {
        setTimeout($f9a22d5a80b70b70$var$runner(id), 0);
    };
}
var $f9a22d5a80b70b70$var$task$1 = {
    set: $f9a22d5a80b70b70$var$set,
    clear: $f9a22d5a80b70b70$var$clear
};
var $f9a22d5a80b70b70$var$userAgent$1 = $f9a22d5a80b70b70$var$engineUserAgent;
var $f9a22d5a80b70b70$var$global$c = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$engineIsIosPebble = /ipad|iphone|ipod/i.test($f9a22d5a80b70b70$var$userAgent$1) && $f9a22d5a80b70b70$var$global$c.Pebble !== undefined;
var $f9a22d5a80b70b70$var$userAgent = $f9a22d5a80b70b70$var$engineUserAgent;
var $f9a22d5a80b70b70$var$engineIsWebosWebkit = /web0s(?!.*chrome)/i.test($f9a22d5a80b70b70$var$userAgent);
var $f9a22d5a80b70b70$var$global$b = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$bind$5 = $f9a22d5a80b70b70$var$functionBindContext;
var $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$1 = $f9a22d5a80b70b70$var$objectGetOwnPropertyDescriptor.f;
var $f9a22d5a80b70b70$var$macrotask = $f9a22d5a80b70b70$var$task$1.set;
var $f9a22d5a80b70b70$var$IS_IOS = $f9a22d5a80b70b70$var$engineIsIos;
var $f9a22d5a80b70b70$var$IS_IOS_PEBBLE = $f9a22d5a80b70b70$var$engineIsIosPebble;
var $f9a22d5a80b70b70$var$IS_WEBOS_WEBKIT = $f9a22d5a80b70b70$var$engineIsWebosWebkit;
var $f9a22d5a80b70b70$var$IS_NODE$1 = $f9a22d5a80b70b70$var$engineIsNode;
var $f9a22d5a80b70b70$var$MutationObserver = $f9a22d5a80b70b70$var$global$b.MutationObserver || $f9a22d5a80b70b70$var$global$b.WebKitMutationObserver;
var $f9a22d5a80b70b70$var$document$2 = $f9a22d5a80b70b70$var$global$b.document;
var $f9a22d5a80b70b70$var$process$1 = $f9a22d5a80b70b70$var$global$b.process;
var $f9a22d5a80b70b70$var$Promise$1 = $f9a22d5a80b70b70$var$global$b.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var $f9a22d5a80b70b70$var$queueMicrotaskDescriptor = $f9a22d5a80b70b70$var$getOwnPropertyDescriptor$1($f9a22d5a80b70b70$var$global$b, "queueMicrotask");
var $f9a22d5a80b70b70$var$queueMicrotask = $f9a22d5a80b70b70$var$queueMicrotaskDescriptor && $f9a22d5a80b70b70$var$queueMicrotaskDescriptor.value;
var $f9a22d5a80b70b70$var$flush, $f9a22d5a80b70b70$var$head, $f9a22d5a80b70b70$var$last, $f9a22d5a80b70b70$var$notify$1, $f9a22d5a80b70b70$var$toggle, $f9a22d5a80b70b70$var$node, $f9a22d5a80b70b70$var$promise, $f9a22d5a80b70b70$var$then;
// modern engines have queueMicrotask method
if (!$f9a22d5a80b70b70$var$queueMicrotask) {
    $f9a22d5a80b70b70$var$flush = function() {
        var parent, fn;
        if ($f9a22d5a80b70b70$var$IS_NODE$1 && (parent = $f9a22d5a80b70b70$var$process$1.domain)) parent.exit();
        while($f9a22d5a80b70b70$var$head){
            fn = $f9a22d5a80b70b70$var$head.fn;
            $f9a22d5a80b70b70$var$head = $f9a22d5a80b70b70$var$head.next;
            try {
                fn();
            } catch (error) {
                if ($f9a22d5a80b70b70$var$head) $f9a22d5a80b70b70$var$notify$1();
                else $f9a22d5a80b70b70$var$last = undefined;
                throw error;
            }
        }
        $f9a22d5a80b70b70$var$last = undefined;
        if (parent) parent.enter();
    };
    // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
    // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
    if (!$f9a22d5a80b70b70$var$IS_IOS && !$f9a22d5a80b70b70$var$IS_NODE$1 && !$f9a22d5a80b70b70$var$IS_WEBOS_WEBKIT && $f9a22d5a80b70b70$var$MutationObserver && $f9a22d5a80b70b70$var$document$2) {
        $f9a22d5a80b70b70$var$toggle = true;
        $f9a22d5a80b70b70$var$node = $f9a22d5a80b70b70$var$document$2.createTextNode("");
        new $f9a22d5a80b70b70$var$MutationObserver($f9a22d5a80b70b70$var$flush).observe($f9a22d5a80b70b70$var$node, {
            characterData: true
        });
        $f9a22d5a80b70b70$var$notify$1 = function() {
            $f9a22d5a80b70b70$var$node.data = $f9a22d5a80b70b70$var$toggle = !$f9a22d5a80b70b70$var$toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if (!$f9a22d5a80b70b70$var$IS_IOS_PEBBLE && $f9a22d5a80b70b70$var$Promise$1 && $f9a22d5a80b70b70$var$Promise$1.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        $f9a22d5a80b70b70$var$promise = $f9a22d5a80b70b70$var$Promise$1.resolve(undefined);
        // workaround of WebKit ~ iOS Safari 10.1 bug
        $f9a22d5a80b70b70$var$promise.constructor = $f9a22d5a80b70b70$var$Promise$1;
        $f9a22d5a80b70b70$var$then = $f9a22d5a80b70b70$var$bind$5($f9a22d5a80b70b70$var$promise.then, $f9a22d5a80b70b70$var$promise);
        $f9a22d5a80b70b70$var$notify$1 = function() {
            $f9a22d5a80b70b70$var$then($f9a22d5a80b70b70$var$flush);
        };
    // Node.js without promises
    } else if ($f9a22d5a80b70b70$var$IS_NODE$1) $f9a22d5a80b70b70$var$notify$1 = function() {
        $f9a22d5a80b70b70$var$process$1.nextTick($f9a22d5a80b70b70$var$flush);
    };
    else {
        // strange IE + webpack dev server bug - use .bind(global)
        $f9a22d5a80b70b70$var$macrotask = $f9a22d5a80b70b70$var$bind$5($f9a22d5a80b70b70$var$macrotask, $f9a22d5a80b70b70$var$global$b);
        $f9a22d5a80b70b70$var$notify$1 = function() {
            $f9a22d5a80b70b70$var$macrotask($f9a22d5a80b70b70$var$flush);
        };
    }
}
var $f9a22d5a80b70b70$var$microtask$1 = $f9a22d5a80b70b70$var$queueMicrotask || function(fn) {
    var task = {
        fn: fn,
        next: undefined
    };
    if ($f9a22d5a80b70b70$var$last) $f9a22d5a80b70b70$var$last.next = task;
    if (!$f9a22d5a80b70b70$var$head) {
        $f9a22d5a80b70b70$var$head = task;
        $f9a22d5a80b70b70$var$notify$1();
    }
    $f9a22d5a80b70b70$var$last = task;
};
var $f9a22d5a80b70b70$var$global$a = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$hostReportErrors$1 = function(a, b) {
    var console = $f9a22d5a80b70b70$var$global$a.console;
    if (console && console.error) arguments.length == 1 ? console.error(a) : console.error(a, b);
};
var $f9a22d5a80b70b70$var$perform$3 = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};
var $f9a22d5a80b70b70$var$Queue$1 = function() {
    this.head = null;
    this.tail = null;
};
$f9a22d5a80b70b70$var$Queue$1.prototype = {
    add: function(item) {
        var entry = {
            item: item,
            next: null
        };
        if (this.head) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
    },
    get: function() {
        var entry = this.head;
        if (entry) {
            this.head = entry.next;
            if (this.tail === entry) this.tail = null;
            return entry.item;
        }
    }
};
var $f9a22d5a80b70b70$var$queue = $f9a22d5a80b70b70$var$Queue$1;
var $f9a22d5a80b70b70$var$global$9 = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$promiseNativeConstructor = $f9a22d5a80b70b70$var$global$9.Promise;
var $f9a22d5a80b70b70$var$engineIsBrowser = typeof window == "object" && typeof Deno != "object";
var $f9a22d5a80b70b70$var$global$8 = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$NativePromiseConstructor$3 = $f9a22d5a80b70b70$var$promiseNativeConstructor;
var $f9a22d5a80b70b70$var$isCallable$5 = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$isForced = $f9a22d5a80b70b70$var$isForced_1;
var $f9a22d5a80b70b70$var$inspectSource = $f9a22d5a80b70b70$var$inspectSource$4;
var $f9a22d5a80b70b70$var$wellKnownSymbol$8 = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$IS_BROWSER = $f9a22d5a80b70b70$var$engineIsBrowser;
var $f9a22d5a80b70b70$var$V8_VERSION = $f9a22d5a80b70b70$var$engineV8Version;
$f9a22d5a80b70b70$var$NativePromiseConstructor$3 && $f9a22d5a80b70b70$var$NativePromiseConstructor$3.prototype;
var $f9a22d5a80b70b70$var$SPECIES$1 = $f9a22d5a80b70b70$var$wellKnownSymbol$8("species");
var $f9a22d5a80b70b70$var$SUBCLASSING = false;
var $f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT$1 = $f9a22d5a80b70b70$var$isCallable$5($f9a22d5a80b70b70$var$global$8.PromiseRejectionEvent);
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$5 = $f9a22d5a80b70b70$var$isForced("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $f9a22d5a80b70b70$var$inspectSource($f9a22d5a80b70b70$var$NativePromiseConstructor$3);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($f9a22d5a80b70b70$var$NativePromiseConstructor$3);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $f9a22d5a80b70b70$var$V8_VERSION === 66) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if ($f9a22d5a80b70b70$var$V8_VERSION >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
    // Detect correctness of subclassing with @@species support
    var promise = new $f9a22d5a80b70b70$var$NativePromiseConstructor$3(function(resolve) {
        resolve(1);
    });
    var FakePromise = function(exec) {
        exec(function() {}, function() {});
    };
    var constructor = promise.constructor = {};
    constructor[$f9a22d5a80b70b70$var$SPECIES$1] = FakePromise;
    $f9a22d5a80b70b70$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
    if (!$f9a22d5a80b70b70$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return !GLOBAL_CORE_JS_PROMISE && $f9a22d5a80b70b70$var$IS_BROWSER && !$f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT$1;
});
var $f9a22d5a80b70b70$var$promiseConstructorDetection = {
    CONSTRUCTOR: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$5,
    REJECTION_EVENT: $f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT$1,
    SUBCLASSING: $f9a22d5a80b70b70$var$SUBCLASSING
};
var $f9a22d5a80b70b70$var$newPromiseCapability$2 = {};
var $f9a22d5a80b70b70$var$aCallable$4 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $f9a22d5a80b70b70$var$aCallable$4(resolve);
    this.reject = $f9a22d5a80b70b70$var$aCallable$4(reject);
};
// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
$f9a22d5a80b70b70$var$newPromiseCapability$2.f = function(C) {
    return new $f9a22d5a80b70b70$var$PromiseCapability(C);
};
var $f9a22d5a80b70b70$var$$$8 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$IS_NODE = $f9a22d5a80b70b70$var$engineIsNode;
var $f9a22d5a80b70b70$var$global$7 = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$call$b = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$defineBuiltIn$5 = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$setPrototypeOf = $f9a22d5a80b70b70$var$objectSetPrototypeOf;
var $f9a22d5a80b70b70$var$setToStringTag$2 = $f9a22d5a80b70b70$var$setToStringTag$5;
var $f9a22d5a80b70b70$var$setSpecies = $f9a22d5a80b70b70$var$setSpecies$1;
var $f9a22d5a80b70b70$var$aCallable$3 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$isCallable$4 = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$isObject$2 = $f9a22d5a80b70b70$var$isObject$8;
var $f9a22d5a80b70b70$var$anInstance$2 = $f9a22d5a80b70b70$var$anInstance$3;
var $f9a22d5a80b70b70$var$speciesConstructor = $f9a22d5a80b70b70$var$speciesConstructor$1;
var $f9a22d5a80b70b70$var$task = $f9a22d5a80b70b70$var$task$1.set;
var $f9a22d5a80b70b70$var$microtask = $f9a22d5a80b70b70$var$microtask$1;
var $f9a22d5a80b70b70$var$hostReportErrors = $f9a22d5a80b70b70$var$hostReportErrors$1;
var $f9a22d5a80b70b70$var$perform$2 = $f9a22d5a80b70b70$var$perform$3;
var $f9a22d5a80b70b70$var$Queue = $f9a22d5a80b70b70$var$queue;
var $f9a22d5a80b70b70$var$InternalStateModule$3 = $f9a22d5a80b70b70$var$internalState;
var $f9a22d5a80b70b70$var$NativePromiseConstructor$2 = $f9a22d5a80b70b70$var$promiseNativeConstructor;
var $f9a22d5a80b70b70$var$PromiseConstructorDetection = $f9a22d5a80b70b70$var$promiseConstructorDetection;
var $f9a22d5a80b70b70$var$newPromiseCapabilityModule$3 = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$PROMISE = "Promise";
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$4 = $f9a22d5a80b70b70$var$PromiseConstructorDetection.CONSTRUCTOR;
var $f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT = $f9a22d5a80b70b70$var$PromiseConstructorDetection.REJECTION_EVENT;
var $f9a22d5a80b70b70$var$NATIVE_PROMISE_SUBCLASSING = $f9a22d5a80b70b70$var$PromiseConstructorDetection.SUBCLASSING;
var $f9a22d5a80b70b70$var$getInternalPromiseState = $f9a22d5a80b70b70$var$InternalStateModule$3.getterFor($f9a22d5a80b70b70$var$PROMISE);
var $f9a22d5a80b70b70$var$setInternalState$3 = $f9a22d5a80b70b70$var$InternalStateModule$3.set;
var $f9a22d5a80b70b70$var$NativePromisePrototype$1 = $f9a22d5a80b70b70$var$NativePromiseConstructor$2 && $f9a22d5a80b70b70$var$NativePromiseConstructor$2.prototype;
var $f9a22d5a80b70b70$var$PromiseConstructor = $f9a22d5a80b70b70$var$NativePromiseConstructor$2;
var $f9a22d5a80b70b70$var$PromisePrototype = $f9a22d5a80b70b70$var$NativePromisePrototype$1;
var $f9a22d5a80b70b70$var$TypeError$3 = $f9a22d5a80b70b70$var$global$7.TypeError;
var $f9a22d5a80b70b70$var$document$1 = $f9a22d5a80b70b70$var$global$7.document;
var $f9a22d5a80b70b70$var$process = $f9a22d5a80b70b70$var$global$7.process;
var $f9a22d5a80b70b70$var$newPromiseCapability$1 = $f9a22d5a80b70b70$var$newPromiseCapabilityModule$3.f;
var $f9a22d5a80b70b70$var$newGenericPromiseCapability = $f9a22d5a80b70b70$var$newPromiseCapability$1;
var $f9a22d5a80b70b70$var$DISPATCH_EVENT = !!($f9a22d5a80b70b70$var$document$1 && $f9a22d5a80b70b70$var$document$1.createEvent && $f9a22d5a80b70b70$var$global$7.dispatchEvent);
var $f9a22d5a80b70b70$var$UNHANDLED_REJECTION = "unhandledrejection";
var $f9a22d5a80b70b70$var$REJECTION_HANDLED = "rejectionhandled";
var $f9a22d5a80b70b70$var$PENDING = 0;
var $f9a22d5a80b70b70$var$FULFILLED = 1;
var $f9a22d5a80b70b70$var$REJECTED = 2;
var $f9a22d5a80b70b70$var$HANDLED = 1;
var $f9a22d5a80b70b70$var$UNHANDLED = 2;
var $f9a22d5a80b70b70$var$Internal, $f9a22d5a80b70b70$var$OwnPromiseCapability, $f9a22d5a80b70b70$var$PromiseWrapper, $f9a22d5a80b70b70$var$nativeThen;
// helpers
var $f9a22d5a80b70b70$var$isThenable = function(it) {
    var then;
    return $f9a22d5a80b70b70$var$isObject$2(it) && $f9a22d5a80b70b70$var$isCallable$4(then = it.then) ? then : false;
};
var $f9a22d5a80b70b70$var$callReaction = function(reaction, state) {
    var value = state.value;
    var ok = state.state == $f9a22d5a80b70b70$var$FULFILLED;
    var handler = ok ? reaction.ok : reaction.fail;
    var resolve = reaction.resolve;
    var reject = reaction.reject;
    var domain = reaction.domain;
    var result, then, exited;
    try {
        if (handler) {
            if (!ok) {
                if (state.rejection === $f9a22d5a80b70b70$var$UNHANDLED) $f9a22d5a80b70b70$var$onHandleUnhandled(state);
                state.rejection = $f9a22d5a80b70b70$var$HANDLED;
            }
            if (handler === true) result = value;
            else {
                if (domain) domain.enter();
                result = handler(value); // can throw
                if (domain) {
                    domain.exit();
                    exited = true;
                }
            }
            if (result === reaction.promise) reject($f9a22d5a80b70b70$var$TypeError$3("Promise-chain cycle"));
            else if (then = $f9a22d5a80b70b70$var$isThenable(result)) $f9a22d5a80b70b70$var$call$b(then, result, resolve, reject);
            else resolve(result);
        } else reject(value);
    } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
    }
};
var $f9a22d5a80b70b70$var$notify = function(state, isReject) {
    if (state.notified) return;
    state.notified = true;
    $f9a22d5a80b70b70$var$microtask(function() {
        var reactions = state.reactions;
        var reaction;
        while(reaction = reactions.get())$f9a22d5a80b70b70$var$callReaction(reaction, state);
        state.notified = false;
        if (isReject && !state.rejection) $f9a22d5a80b70b70$var$onUnhandled(state);
    });
};
var $f9a22d5a80b70b70$var$dispatchEvent = function(name, promise, reason) {
    var event, handler;
    if ($f9a22d5a80b70b70$var$DISPATCH_EVENT) {
        event = $f9a22d5a80b70b70$var$document$1.createEvent("Event");
        event.promise = promise;
        event.reason = reason;
        event.initEvent(name, false, true);
        $f9a22d5a80b70b70$var$global$7.dispatchEvent(event);
    } else event = {
        promise: promise,
        reason: reason
    };
    if (!$f9a22d5a80b70b70$var$NATIVE_PROMISE_REJECTION_EVENT && (handler = $f9a22d5a80b70b70$var$global$7["on" + name])) handler(event);
    else if (name === $f9a22d5a80b70b70$var$UNHANDLED_REJECTION) $f9a22d5a80b70b70$var$hostReportErrors("Unhandled promise rejection", reason);
};
var $f9a22d5a80b70b70$var$onUnhandled = function(state) {
    $f9a22d5a80b70b70$var$call$b($f9a22d5a80b70b70$var$task, $f9a22d5a80b70b70$var$global$7, function() {
        var promise = state.facade;
        var value = state.value;
        var IS_UNHANDLED = $f9a22d5a80b70b70$var$isUnhandled(state);
        var result;
        if (IS_UNHANDLED) {
            result = $f9a22d5a80b70b70$var$perform$2(function() {
                if ($f9a22d5a80b70b70$var$IS_NODE) $f9a22d5a80b70b70$var$process.emit("unhandledRejection", value, promise);
                else $f9a22d5a80b70b70$var$dispatchEvent($f9a22d5a80b70b70$var$UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = $f9a22d5a80b70b70$var$IS_NODE || $f9a22d5a80b70b70$var$isUnhandled(state) ? $f9a22d5a80b70b70$var$UNHANDLED : $f9a22d5a80b70b70$var$HANDLED;
            if (result.error) throw result.value;
        }
    });
};
var $f9a22d5a80b70b70$var$isUnhandled = function(state) {
    return state.rejection !== $f9a22d5a80b70b70$var$HANDLED && !state.parent;
};
var $f9a22d5a80b70b70$var$onHandleUnhandled = function(state) {
    $f9a22d5a80b70b70$var$call$b($f9a22d5a80b70b70$var$task, $f9a22d5a80b70b70$var$global$7, function() {
        var promise = state.facade;
        if ($f9a22d5a80b70b70$var$IS_NODE) $f9a22d5a80b70b70$var$process.emit("rejectionHandled", promise);
        else $f9a22d5a80b70b70$var$dispatchEvent($f9a22d5a80b70b70$var$REJECTION_HANDLED, promise, state.value);
    });
};
var $f9a22d5a80b70b70$var$bind$4 = function(fn, state, unwrap) {
    return function(value) {
        fn(state, value, unwrap);
    };
};
var $f9a22d5a80b70b70$var$internalReject = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    state.value = value;
    state.state = $f9a22d5a80b70b70$var$REJECTED;
    $f9a22d5a80b70b70$var$notify(state, true);
};
var $f9a22d5a80b70b70$var$internalResolve = function(state, value, unwrap) {
    if (state.done) return;
    state.done = true;
    if (unwrap) state = unwrap;
    try {
        if (state.facade === value) throw $f9a22d5a80b70b70$var$TypeError$3("Promise can't be resolved itself");
        var then = $f9a22d5a80b70b70$var$isThenable(value);
        if (then) $f9a22d5a80b70b70$var$microtask(function() {
            var wrapper = {
                done: false
            };
            try {
                $f9a22d5a80b70b70$var$call$b(then, value, $f9a22d5a80b70b70$var$bind$4($f9a22d5a80b70b70$var$internalResolve, wrapper, state), $f9a22d5a80b70b70$var$bind$4($f9a22d5a80b70b70$var$internalReject, wrapper, state));
            } catch (error) {
                $f9a22d5a80b70b70$var$internalReject(wrapper, error, state);
            }
        });
        else {
            state.value = value;
            state.state = $f9a22d5a80b70b70$var$FULFILLED;
            $f9a22d5a80b70b70$var$notify(state, false);
        }
    } catch (error) {
        $f9a22d5a80b70b70$var$internalReject({
            done: false
        }, error, state);
    }
};
// constructor polyfill
if ($f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$4) {
    // 25.4.3.1 Promise(executor)
    $f9a22d5a80b70b70$var$PromiseConstructor = function Promise1(executor) {
        $f9a22d5a80b70b70$var$anInstance$2(this, $f9a22d5a80b70b70$var$PromisePrototype);
        $f9a22d5a80b70b70$var$aCallable$3(executor);
        $f9a22d5a80b70b70$var$call$b($f9a22d5a80b70b70$var$Internal, this);
        var state = $f9a22d5a80b70b70$var$getInternalPromiseState(this);
        try {
            executor($f9a22d5a80b70b70$var$bind$4($f9a22d5a80b70b70$var$internalResolve, state), $f9a22d5a80b70b70$var$bind$4($f9a22d5a80b70b70$var$internalReject, state));
        } catch (error) {
            $f9a22d5a80b70b70$var$internalReject(state, error);
        }
    };
    $f9a22d5a80b70b70$var$PromisePrototype = $f9a22d5a80b70b70$var$PromiseConstructor.prototype;
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    $f9a22d5a80b70b70$var$Internal = function Promise1(executor) {
        $f9a22d5a80b70b70$var$setInternalState$3(this, {
            type: $f9a22d5a80b70b70$var$PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: new $f9a22d5a80b70b70$var$Queue(),
            rejection: false,
            state: $f9a22d5a80b70b70$var$PENDING,
            value: undefined
        });
    };
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    $f9a22d5a80b70b70$var$Internal.prototype = $f9a22d5a80b70b70$var$defineBuiltIn$5($f9a22d5a80b70b70$var$PromisePrototype, "then", function then(onFulfilled, onRejected) {
        var state = $f9a22d5a80b70b70$var$getInternalPromiseState(this);
        var reaction = $f9a22d5a80b70b70$var$newPromiseCapability$1($f9a22d5a80b70b70$var$speciesConstructor(this, $f9a22d5a80b70b70$var$PromiseConstructor));
        state.parent = true;
        reaction.ok = $f9a22d5a80b70b70$var$isCallable$4(onFulfilled) ? onFulfilled : true;
        reaction.fail = $f9a22d5a80b70b70$var$isCallable$4(onRejected) && onRejected;
        reaction.domain = $f9a22d5a80b70b70$var$IS_NODE ? $f9a22d5a80b70b70$var$process.domain : undefined;
        if (state.state == $f9a22d5a80b70b70$var$PENDING) state.reactions.add(reaction);
        else $f9a22d5a80b70b70$var$microtask(function() {
            $f9a22d5a80b70b70$var$callReaction(reaction, state);
        });
        return reaction.promise;
    });
    $f9a22d5a80b70b70$var$OwnPromiseCapability = function() {
        var promise = new $f9a22d5a80b70b70$var$Internal();
        var state = $f9a22d5a80b70b70$var$getInternalPromiseState(promise);
        this.promise = promise;
        this.resolve = $f9a22d5a80b70b70$var$bind$4($f9a22d5a80b70b70$var$internalResolve, state);
        this.reject = $f9a22d5a80b70b70$var$bind$4($f9a22d5a80b70b70$var$internalReject, state);
    };
    $f9a22d5a80b70b70$var$newPromiseCapabilityModule$3.f = $f9a22d5a80b70b70$var$newPromiseCapability$1 = function(C) {
        return C === $f9a22d5a80b70b70$var$PromiseConstructor || C === $f9a22d5a80b70b70$var$PromiseWrapper ? new $f9a22d5a80b70b70$var$OwnPromiseCapability(C) : $f9a22d5a80b70b70$var$newGenericPromiseCapability(C);
    };
    if ($f9a22d5a80b70b70$var$isCallable$4($f9a22d5a80b70b70$var$NativePromiseConstructor$2) && $f9a22d5a80b70b70$var$NativePromisePrototype$1 !== Object.prototype) {
        $f9a22d5a80b70b70$var$nativeThen = $f9a22d5a80b70b70$var$NativePromisePrototype$1.then;
        if (!$f9a22d5a80b70b70$var$NATIVE_PROMISE_SUBCLASSING) // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
        $f9a22d5a80b70b70$var$defineBuiltIn$5($f9a22d5a80b70b70$var$NativePromisePrototype$1, "then", function then(onFulfilled, onRejected) {
            var that = this;
            return new $f9a22d5a80b70b70$var$PromiseConstructor(function(resolve, reject) {
                $f9a22d5a80b70b70$var$call$b($f9a22d5a80b70b70$var$nativeThen, that, resolve, reject);
            }).then(onFulfilled, onRejected);
        // https://github.com/zloirock/core-js/issues/640
        }, {
            unsafe: true
        });
        // make `.constructor === Promise` work for native promise-based APIs
        try {
            delete $f9a22d5a80b70b70$var$NativePromisePrototype$1.constructor;
        } catch (error) {}
        // make `instanceof Promise` work for native promise-based APIs
        if ($f9a22d5a80b70b70$var$setPrototypeOf) $f9a22d5a80b70b70$var$setPrototypeOf($f9a22d5a80b70b70$var$NativePromisePrototype$1, $f9a22d5a80b70b70$var$PromisePrototype);
    }
}
$f9a22d5a80b70b70$var$$$8({
    global: true,
    constructor: true,
    wrap: true,
    forced: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$4
}, {
    Promise: $f9a22d5a80b70b70$var$PromiseConstructor
});
$f9a22d5a80b70b70$var$setToStringTag$2($f9a22d5a80b70b70$var$PromiseConstructor, $f9a22d5a80b70b70$var$PROMISE, false);
$f9a22d5a80b70b70$var$setSpecies($f9a22d5a80b70b70$var$PROMISE);
var $f9a22d5a80b70b70$var$wellKnownSymbol$7 = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$Iterators$1 = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$ITERATOR$5 = $f9a22d5a80b70b70$var$wellKnownSymbol$7("iterator");
var $f9a22d5a80b70b70$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
var $f9a22d5a80b70b70$var$isArrayIteratorMethod$2 = function(it) {
    return it !== undefined && ($f9a22d5a80b70b70$var$Iterators$1.Array === it || $f9a22d5a80b70b70$var$ArrayPrototype[$f9a22d5a80b70b70$var$ITERATOR$5] === it);
};
var $f9a22d5a80b70b70$var$classof$2 = $f9a22d5a80b70b70$var$classof$6;
var $f9a22d5a80b70b70$var$getMethod$2 = $f9a22d5a80b70b70$var$getMethod$4;
var $f9a22d5a80b70b70$var$Iterators = $f9a22d5a80b70b70$var$iterators;
var $f9a22d5a80b70b70$var$wellKnownSymbol$6 = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$ITERATOR$4 = $f9a22d5a80b70b70$var$wellKnownSymbol$6("iterator");
var $f9a22d5a80b70b70$var$getIteratorMethod$4 = function(it) {
    if (it != undefined) return $f9a22d5a80b70b70$var$getMethod$2(it, $f9a22d5a80b70b70$var$ITERATOR$4) || $f9a22d5a80b70b70$var$getMethod$2(it, "@@iterator") || $f9a22d5a80b70b70$var$Iterators[$f9a22d5a80b70b70$var$classof$2(it)];
};
var $f9a22d5a80b70b70$var$call$a = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$aCallable$2 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$anObject$7 = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$tryToString$1 = $f9a22d5a80b70b70$var$tryToString$4;
var $f9a22d5a80b70b70$var$getIteratorMethod$3 = $f9a22d5a80b70b70$var$getIteratorMethod$4;
var $f9a22d5a80b70b70$var$$TypeError$2 = TypeError;
var $f9a22d5a80b70b70$var$getIterator$3 = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $f9a22d5a80b70b70$var$getIteratorMethod$3(argument) : usingIterator;
    if ($f9a22d5a80b70b70$var$aCallable$2(iteratorMethod)) return $f9a22d5a80b70b70$var$anObject$7($f9a22d5a80b70b70$var$call$a(iteratorMethod, argument));
    throw $f9a22d5a80b70b70$var$$TypeError$2($f9a22d5a80b70b70$var$tryToString$1(argument) + " is not iterable");
};
var $f9a22d5a80b70b70$var$call$9 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$anObject$6 = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$getMethod$1 = $f9a22d5a80b70b70$var$getMethod$4;
var $f9a22d5a80b70b70$var$iteratorClose$2 = function(iterator, kind, value) {
    var innerResult, innerError;
    $f9a22d5a80b70b70$var$anObject$6(iterator);
    try {
        innerResult = $f9a22d5a80b70b70$var$getMethod$1(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $f9a22d5a80b70b70$var$call$9(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $f9a22d5a80b70b70$var$anObject$6(innerResult);
    return value;
};
var $f9a22d5a80b70b70$var$bind$3 = $f9a22d5a80b70b70$var$functionBindContext;
var $f9a22d5a80b70b70$var$call$8 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$anObject$5 = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$tryToString = $f9a22d5a80b70b70$var$tryToString$4;
var $f9a22d5a80b70b70$var$isArrayIteratorMethod$1 = $f9a22d5a80b70b70$var$isArrayIteratorMethod$2;
var $f9a22d5a80b70b70$var$lengthOfArrayLike$2 = $f9a22d5a80b70b70$var$lengthOfArrayLike$4;
var $f9a22d5a80b70b70$var$isPrototypeOf = $f9a22d5a80b70b70$var$objectIsPrototypeOf;
var $f9a22d5a80b70b70$var$getIterator$2 = $f9a22d5a80b70b70$var$getIterator$3;
var $f9a22d5a80b70b70$var$getIteratorMethod$2 = $f9a22d5a80b70b70$var$getIteratorMethod$4;
var $f9a22d5a80b70b70$var$iteratorClose$1 = $f9a22d5a80b70b70$var$iteratorClose$2;
var $f9a22d5a80b70b70$var$$TypeError$1 = TypeError;
var $f9a22d5a80b70b70$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $f9a22d5a80b70b70$var$ResultPrototype = $f9a22d5a80b70b70$var$Result.prototype;
var $f9a22d5a80b70b70$var$iterate$2 = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $f9a22d5a80b70b70$var$bind$3(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $f9a22d5a80b70b70$var$iteratorClose$1(iterator, "normal", condition);
        return new $f9a22d5a80b70b70$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $f9a22d5a80b70b70$var$anObject$5(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $f9a22d5a80b70b70$var$getIteratorMethod$2(iterable);
        if (!iterFn) throw $f9a22d5a80b70b70$var$$TypeError$1($f9a22d5a80b70b70$var$tryToString(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($f9a22d5a80b70b70$var$isArrayIteratorMethod$1(iterFn)) {
            for(index = 0, length = $f9a22d5a80b70b70$var$lengthOfArrayLike$2(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $f9a22d5a80b70b70$var$isPrototypeOf($f9a22d5a80b70b70$var$ResultPrototype, result)) return result;
            }
            return new $f9a22d5a80b70b70$var$Result(false);
        }
        iterator = $f9a22d5a80b70b70$var$getIterator$2(iterable, iterFn);
    }
    next = iterator.next;
    while(!(step = $f9a22d5a80b70b70$var$call$8(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $f9a22d5a80b70b70$var$iteratorClose$1(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $f9a22d5a80b70b70$var$isPrototypeOf($f9a22d5a80b70b70$var$ResultPrototype, result)) return result;
    }
    return new $f9a22d5a80b70b70$var$Result(false);
};
var $f9a22d5a80b70b70$var$wellKnownSymbol$5 = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$ITERATOR$3 = $f9a22d5a80b70b70$var$wellKnownSymbol$5("iterator");
var $f9a22d5a80b70b70$var$SAFE_CLOSING = false;
try {
    var $f9a22d5a80b70b70$var$called = 0;
    var $f9a22d5a80b70b70$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$f9a22d5a80b70b70$var$called++
            };
        },
        "return": function() {
            $f9a22d5a80b70b70$var$SAFE_CLOSING = true;
        }
    };
    $f9a22d5a80b70b70$var$iteratorWithReturn[$f9a22d5a80b70b70$var$ITERATOR$3] = function() {
        return this;
    };
    // eslint-disable-next-line es-x/no-array-from, no-throw-literal -- required for testing
    Array.from($f9a22d5a80b70b70$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
var $f9a22d5a80b70b70$var$checkCorrectnessOfIteration$1 = function(exec, SKIP_CLOSING) {
    if (!SKIP_CLOSING && !$f9a22d5a80b70b70$var$SAFE_CLOSING) return false;
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$f9a22d5a80b70b70$var$ITERATOR$3] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};
var $f9a22d5a80b70b70$var$NativePromiseConstructor$1 = $f9a22d5a80b70b70$var$promiseNativeConstructor;
var $f9a22d5a80b70b70$var$checkCorrectnessOfIteration = $f9a22d5a80b70b70$var$checkCorrectnessOfIteration$1;
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$3 = $f9a22d5a80b70b70$var$promiseConstructorDetection.CONSTRUCTOR;
var $f9a22d5a80b70b70$var$promiseStaticsIncorrectIteration = $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$3 || !$f9a22d5a80b70b70$var$checkCorrectnessOfIteration(function(iterable) {
    $f9a22d5a80b70b70$var$NativePromiseConstructor$1.all(iterable).then(undefined, function() {});
});
var $f9a22d5a80b70b70$var$$$7 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$call$7 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$aCallable$1 = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$newPromiseCapabilityModule$2 = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$perform$1 = $f9a22d5a80b70b70$var$perform$3;
var $f9a22d5a80b70b70$var$iterate$1 = $f9a22d5a80b70b70$var$iterate$2;
var $f9a22d5a80b70b70$var$PROMISE_STATICS_INCORRECT_ITERATION$1 = $f9a22d5a80b70b70$var$promiseStaticsIncorrectIteration;
// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$f9a22d5a80b70b70$var$$$7({
    target: "Promise",
    stat: true,
    forced: $f9a22d5a80b70b70$var$PROMISE_STATICS_INCORRECT_ITERATION$1
}, {
    all: function all(iterable) {
        var C = this;
        var capability = $f9a22d5a80b70b70$var$newPromiseCapabilityModule$2.f(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $f9a22d5a80b70b70$var$perform$1(function() {
            var $promiseResolve = $f9a22d5a80b70b70$var$aCallable$1(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $f9a22d5a80b70b70$var$iterate$1(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $f9a22d5a80b70b70$var$call$7($promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $f9a22d5a80b70b70$var$$$6 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$2 = $f9a22d5a80b70b70$var$promiseConstructorDetection.CONSTRUCTOR;
var $f9a22d5a80b70b70$var$NativePromiseConstructor = $f9a22d5a80b70b70$var$promiseNativeConstructor;
var $f9a22d5a80b70b70$var$getBuiltIn$1 = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$isCallable$3 = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$defineBuiltIn$4 = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$NativePromisePrototype = $f9a22d5a80b70b70$var$NativePromiseConstructor && $f9a22d5a80b70b70$var$NativePromiseConstructor.prototype;
// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$f9a22d5a80b70b70$var$$$6({
    target: "Promise",
    proto: true,
    forced: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$2,
    real: true
}, {
    "catch": function(onRejected) {
        return this.then(undefined, onRejected);
    }
});
// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if ($f9a22d5a80b70b70$var$isCallable$3($f9a22d5a80b70b70$var$NativePromiseConstructor)) {
    var $f9a22d5a80b70b70$var$method = $f9a22d5a80b70b70$var$getBuiltIn$1("Promise").prototype["catch"];
    if ($f9a22d5a80b70b70$var$NativePromisePrototype["catch"] !== $f9a22d5a80b70b70$var$method) $f9a22d5a80b70b70$var$defineBuiltIn$4($f9a22d5a80b70b70$var$NativePromisePrototype, "catch", $f9a22d5a80b70b70$var$method, {
        unsafe: true
    });
}
var $f9a22d5a80b70b70$var$$$5 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$call$6 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$aCallable = $f9a22d5a80b70b70$var$aCallable$7;
var $f9a22d5a80b70b70$var$newPromiseCapabilityModule$1 = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$perform = $f9a22d5a80b70b70$var$perform$3;
var $f9a22d5a80b70b70$var$iterate = $f9a22d5a80b70b70$var$iterate$2;
var $f9a22d5a80b70b70$var$PROMISE_STATICS_INCORRECT_ITERATION = $f9a22d5a80b70b70$var$promiseStaticsIncorrectIteration;
// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$f9a22d5a80b70b70$var$$$5({
    target: "Promise",
    stat: true,
    forced: $f9a22d5a80b70b70$var$PROMISE_STATICS_INCORRECT_ITERATION
}, {
    race: function race(iterable) {
        var C = this;
        var capability = $f9a22d5a80b70b70$var$newPromiseCapabilityModule$1.f(C);
        var reject = capability.reject;
        var result = $f9a22d5a80b70b70$var$perform(function() {
            var $promiseResolve = $f9a22d5a80b70b70$var$aCallable(C.resolve);
            $f9a22d5a80b70b70$var$iterate(iterable, function(promise) {
                $f9a22d5a80b70b70$var$call$6($promiseResolve, C, promise).then(capability.resolve, reject);
            });
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});
var $f9a22d5a80b70b70$var$$$4 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$call$5 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$newPromiseCapabilityModule = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$1 = $f9a22d5a80b70b70$var$promiseConstructorDetection.CONSTRUCTOR;
// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$f9a22d5a80b70b70$var$$$4({
    target: "Promise",
    stat: true,
    forced: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR$1
}, {
    reject: function reject(r) {
        var capability = $f9a22d5a80b70b70$var$newPromiseCapabilityModule.f(this);
        $f9a22d5a80b70b70$var$call$5(capability.reject, undefined, r);
        return capability.promise;
    }
});
var $f9a22d5a80b70b70$var$anObject$4 = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$isObject$1 = $f9a22d5a80b70b70$var$isObject$8;
var $f9a22d5a80b70b70$var$newPromiseCapability = $f9a22d5a80b70b70$var$newPromiseCapability$2;
var $f9a22d5a80b70b70$var$promiseResolve$1 = function(C, x) {
    $f9a22d5a80b70b70$var$anObject$4(C);
    if ($f9a22d5a80b70b70$var$isObject$1(x) && x.constructor === C) return x;
    var promiseCapability = $f9a22d5a80b70b70$var$newPromiseCapability.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};
var $f9a22d5a80b70b70$var$$$3 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$getBuiltIn = $f9a22d5a80b70b70$var$getBuiltIn$8;
var $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR = $f9a22d5a80b70b70$var$promiseConstructorDetection.CONSTRUCTOR;
var $f9a22d5a80b70b70$var$promiseResolve = $f9a22d5a80b70b70$var$promiseResolve$1;
$f9a22d5a80b70b70$var$getBuiltIn("Promise");
// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$f9a22d5a80b70b70$var$$$3({
    target: "Promise",
    stat: true,
    forced: $f9a22d5a80b70b70$var$FORCED_PROMISE_CONSTRUCTOR
}, {
    resolve: function resolve(x) {
        return $f9a22d5a80b70b70$var$promiseResolve(this, x);
    }
});
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var $f9a22d5a80b70b70$var$domIterables = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};
// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var $f9a22d5a80b70b70$var$documentCreateElement = $f9a22d5a80b70b70$var$documentCreateElement$2;
var $f9a22d5a80b70b70$var$classList = $f9a22d5a80b70b70$var$documentCreateElement("span").classList;
var $f9a22d5a80b70b70$var$DOMTokenListPrototype$1 = $f9a22d5a80b70b70$var$classList && $f9a22d5a80b70b70$var$classList.constructor && $f9a22d5a80b70b70$var$classList.constructor.prototype;
var $f9a22d5a80b70b70$var$domTokenListPrototype = $f9a22d5a80b70b70$var$DOMTokenListPrototype$1 === Object.prototype ? undefined : $f9a22d5a80b70b70$var$DOMTokenListPrototype$1;
var $f9a22d5a80b70b70$var$global$6 = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$DOMIterables = $f9a22d5a80b70b70$var$domIterables;
var $f9a22d5a80b70b70$var$DOMTokenListPrototype = $f9a22d5a80b70b70$var$domTokenListPrototype;
var $f9a22d5a80b70b70$var$ArrayIteratorMethods = $f9a22d5a80b70b70$var$es_array_iterator;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty$1 = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$wellKnownSymbol$4 = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$ITERATOR$2 = $f9a22d5a80b70b70$var$wellKnownSymbol$4("iterator");
var $f9a22d5a80b70b70$var$TO_STRING_TAG = $f9a22d5a80b70b70$var$wellKnownSymbol$4("toStringTag");
var $f9a22d5a80b70b70$var$ArrayValues = $f9a22d5a80b70b70$var$ArrayIteratorMethods.values;
var $f9a22d5a80b70b70$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$f9a22d5a80b70b70$var$ITERATOR$2] !== $f9a22d5a80b70b70$var$ArrayValues) try {
            $f9a22d5a80b70b70$var$createNonEnumerableProperty$1(CollectionPrototype, $f9a22d5a80b70b70$var$ITERATOR$2, $f9a22d5a80b70b70$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$f9a22d5a80b70b70$var$ITERATOR$2] = $f9a22d5a80b70b70$var$ArrayValues;
        }
        if (!CollectionPrototype[$f9a22d5a80b70b70$var$TO_STRING_TAG]) $f9a22d5a80b70b70$var$createNonEnumerableProperty$1(CollectionPrototype, $f9a22d5a80b70b70$var$TO_STRING_TAG, COLLECTION_NAME);
        if ($f9a22d5a80b70b70$var$DOMIterables[COLLECTION_NAME]) for(var METHOD_NAME in $f9a22d5a80b70b70$var$ArrayIteratorMethods){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $f9a22d5a80b70b70$var$ArrayIteratorMethods[METHOD_NAME]) try {
                $f9a22d5a80b70b70$var$createNonEnumerableProperty$1(CollectionPrototype, METHOD_NAME, $f9a22d5a80b70b70$var$ArrayIteratorMethods[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $f9a22d5a80b70b70$var$ArrayIteratorMethods[METHOD_NAME];
            }
        }
    }
};
for(var $f9a22d5a80b70b70$var$COLLECTION_NAME in $f9a22d5a80b70b70$var$DOMIterables)$f9a22d5a80b70b70$var$handlePrototype($f9a22d5a80b70b70$var$global$6[$f9a22d5a80b70b70$var$COLLECTION_NAME] && $f9a22d5a80b70b70$var$global$6[$f9a22d5a80b70b70$var$COLLECTION_NAME].prototype, $f9a22d5a80b70b70$var$COLLECTION_NAME);
$f9a22d5a80b70b70$var$handlePrototype($f9a22d5a80b70b70$var$DOMTokenListPrototype, "DOMTokenList");
var $f9a22d5a80b70b70$var$uncurryThis$7 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toIntegerOrInfinity$1 = $f9a22d5a80b70b70$var$toIntegerOrInfinity$4;
var $f9a22d5a80b70b70$var$toString$3 = $f9a22d5a80b70b70$var$toString$4;
var $f9a22d5a80b70b70$var$requireObjectCoercible$1 = $f9a22d5a80b70b70$var$requireObjectCoercible$4;
var $f9a22d5a80b70b70$var$charAt$6 = $f9a22d5a80b70b70$var$uncurryThis$7("".charAt);
var $f9a22d5a80b70b70$var$charCodeAt$1 = $f9a22d5a80b70b70$var$uncurryThis$7("".charCodeAt);
var $f9a22d5a80b70b70$var$stringSlice$5 = $f9a22d5a80b70b70$var$uncurryThis$7("".slice);
var $f9a22d5a80b70b70$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $f9a22d5a80b70b70$var$toString$3($f9a22d5a80b70b70$var$requireObjectCoercible$1($this));
        var position = $f9a22d5a80b70b70$var$toIntegerOrInfinity$1(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? "" : undefined;
        first = $f9a22d5a80b70b70$var$charCodeAt$1(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $f9a22d5a80b70b70$var$charCodeAt$1(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $f9a22d5a80b70b70$var$charAt$6(S, position) : first : CONVERT_TO_STRING ? $f9a22d5a80b70b70$var$stringSlice$5(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
var $f9a22d5a80b70b70$var$stringMultibyte = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $f9a22d5a80b70b70$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $f9a22d5a80b70b70$var$createMethod(true)
};
var $f9a22d5a80b70b70$var$charAt$5 = $f9a22d5a80b70b70$var$stringMultibyte.charAt;
var $f9a22d5a80b70b70$var$toString$2 = $f9a22d5a80b70b70$var$toString$4;
var $f9a22d5a80b70b70$var$InternalStateModule$2 = $f9a22d5a80b70b70$var$internalState;
var $f9a22d5a80b70b70$var$defineIterator = $f9a22d5a80b70b70$var$defineIterator$2;
var $f9a22d5a80b70b70$var$STRING_ITERATOR = "String Iterator";
var $f9a22d5a80b70b70$var$setInternalState$2 = $f9a22d5a80b70b70$var$InternalStateModule$2.set;
var $f9a22d5a80b70b70$var$getInternalState$1 = $f9a22d5a80b70b70$var$InternalStateModule$2.getterFor($f9a22d5a80b70b70$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$f9a22d5a80b70b70$var$defineIterator(String, "String", function(iterated) {
    $f9a22d5a80b70b70$var$setInternalState$2(this, {
        type: $f9a22d5a80b70b70$var$STRING_ITERATOR,
        string: $f9a22d5a80b70b70$var$toString$2(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $f9a22d5a80b70b70$var$getInternalState$1(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return {
        value: undefined,
        done: true
    };
    point = $f9a22d5a80b70b70$var$charAt$5(string, index);
    state.index += point.length;
    return {
        value: point,
        done: false
    };
});
var $f9a22d5a80b70b70$var$fails$5 = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$wellKnownSymbol$3 = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$IS_PURE = $f9a22d5a80b70b70$var$isPure;
var $f9a22d5a80b70b70$var$ITERATOR$1 = $f9a22d5a80b70b70$var$wellKnownSymbol$3("iterator");
var $f9a22d5a80b70b70$var$nativeUrl = !$f9a22d5a80b70b70$var$fails$5(function() {
    // eslint-disable-next-line unicorn/relative-url-style -- required for testing
    var url = new URL("b?a=1&b=2&c=3", "http://a");
    var searchParams = url.searchParams;
    var result = "";
    url.pathname = "c%20d";
    searchParams.forEach(function(value, key) {
        searchParams["delete"]("b");
        result += key + value;
    });
    return $f9a22d5a80b70b70$var$IS_PURE && !url.toJSON || !searchParams.sort || url.href !== "http://a/c%20d?a=1&c=3" || searchParams.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !searchParams[$f9a22d5a80b70b70$var$ITERATOR$1] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("http://\u0442\u0435\u0441\u0442").host !== "xn--e1aybc" || new URL("http://a#\u0431").hash !== "#%D0%B1" || result !== "a1c3" || new URL("http://x", undefined).host !== "x";
});
var $f9a22d5a80b70b70$var$makeBuiltIn = $f9a22d5a80b70b70$var$makeBuiltIn$3.exports;
var $f9a22d5a80b70b70$var$defineProperty = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$defineBuiltInAccessor$1 = function(target, name, descriptor) {
    if (descriptor.get) $f9a22d5a80b70b70$var$makeBuiltIn(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $f9a22d5a80b70b70$var$makeBuiltIn(descriptor.set, name, {
        setter: true
    });
    return $f9a22d5a80b70b70$var$defineProperty.f(target, name, descriptor);
};
var $f9a22d5a80b70b70$var$anObject$3 = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$iteratorClose = $f9a22d5a80b70b70$var$iteratorClose$2;
// call something on iterator step with safe closing on error
var $f9a22d5a80b70b70$var$callWithSafeIterationClosing$1 = function(iterator, fn, value, ENTRIES) {
    try {
        return ENTRIES ? fn($f9a22d5a80b70b70$var$anObject$3(value)[0], value[1]) : fn(value);
    } catch (error) {
        $f9a22d5a80b70b70$var$iteratorClose(iterator, "throw", error);
    }
};
var $f9a22d5a80b70b70$var$toPropertyKey = $f9a22d5a80b70b70$var$toPropertyKey$3;
var $f9a22d5a80b70b70$var$definePropertyModule = $f9a22d5a80b70b70$var$objectDefineProperty;
var $f9a22d5a80b70b70$var$createPropertyDescriptor$1 = $f9a22d5a80b70b70$var$createPropertyDescriptor$5;
var $f9a22d5a80b70b70$var$createProperty$2 = function(object, key, value) {
    var propertyKey = $f9a22d5a80b70b70$var$toPropertyKey(key);
    if (propertyKey in object) $f9a22d5a80b70b70$var$definePropertyModule.f(object, propertyKey, $f9a22d5a80b70b70$var$createPropertyDescriptor$1(0, value));
    else object[propertyKey] = value;
};
var $f9a22d5a80b70b70$var$bind$2 = $f9a22d5a80b70b70$var$functionBindContext;
var $f9a22d5a80b70b70$var$call$4 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$toObject$1 = $f9a22d5a80b70b70$var$toObject$5;
var $f9a22d5a80b70b70$var$callWithSafeIterationClosing = $f9a22d5a80b70b70$var$callWithSafeIterationClosing$1;
var $f9a22d5a80b70b70$var$isArrayIteratorMethod = $f9a22d5a80b70b70$var$isArrayIteratorMethod$2;
var $f9a22d5a80b70b70$var$isConstructor = $f9a22d5a80b70b70$var$isConstructor$2;
var $f9a22d5a80b70b70$var$lengthOfArrayLike$1 = $f9a22d5a80b70b70$var$lengthOfArrayLike$4;
var $f9a22d5a80b70b70$var$createProperty$1 = $f9a22d5a80b70b70$var$createProperty$2;
var $f9a22d5a80b70b70$var$getIterator$1 = $f9a22d5a80b70b70$var$getIterator$3;
var $f9a22d5a80b70b70$var$getIteratorMethod$1 = $f9a22d5a80b70b70$var$getIteratorMethod$4;
var $f9a22d5a80b70b70$var$$Array$1 = Array;
// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var $f9a22d5a80b70b70$var$arrayFrom$1 = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
    var O = $f9a22d5a80b70b70$var$toObject$1(arrayLike);
    var IS_CONSTRUCTOR = $f9a22d5a80b70b70$var$isConstructor(this);
    var argumentsLength = arguments.length;
    var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    if (mapping) mapfn = $f9a22d5a80b70b70$var$bind$2(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
    var iteratorMethod = $f9a22d5a80b70b70$var$getIteratorMethod$1(O);
    var index = 0;
    var length, result, step, iterator, next, value;
    // if the target is not iterable or it's an array with the default iterator - use a simple case
    if (iteratorMethod && !(this === $f9a22d5a80b70b70$var$$Array$1 && $f9a22d5a80b70b70$var$isArrayIteratorMethod(iteratorMethod))) {
        iterator = $f9a22d5a80b70b70$var$getIterator$1(O, iteratorMethod);
        next = iterator.next;
        result = IS_CONSTRUCTOR ? new this() : [];
        for(; !(step = $f9a22d5a80b70b70$var$call$4(next, iterator)).done; index++){
            value = mapping ? $f9a22d5a80b70b70$var$callWithSafeIterationClosing(iterator, mapfn, [
                step.value,
                index
            ], true) : step.value;
            $f9a22d5a80b70b70$var$createProperty$1(result, index, value);
        }
    } else {
        length = $f9a22d5a80b70b70$var$lengthOfArrayLike$1(O);
        result = IS_CONSTRUCTOR ? new this(length) : $f9a22d5a80b70b70$var$$Array$1(length);
        for(; length > index; index++){
            value = mapping ? mapfn(O[index], index) : O[index];
            $f9a22d5a80b70b70$var$createProperty$1(result, index, value);
        }
    }
    result.length = index;
    return result;
};
var $f9a22d5a80b70b70$var$toAbsoluteIndex = $f9a22d5a80b70b70$var$toAbsoluteIndex$2;
var $f9a22d5a80b70b70$var$lengthOfArrayLike = $f9a22d5a80b70b70$var$lengthOfArrayLike$4;
var $f9a22d5a80b70b70$var$createProperty = $f9a22d5a80b70b70$var$createProperty$2;
var $f9a22d5a80b70b70$var$$Array = Array;
var $f9a22d5a80b70b70$var$max$1 = Math.max;
var $f9a22d5a80b70b70$var$arraySliceSimple = function(O, start, end) {
    var length = $f9a22d5a80b70b70$var$lengthOfArrayLike(O);
    var k = $f9a22d5a80b70b70$var$toAbsoluteIndex(start, length);
    var fin = $f9a22d5a80b70b70$var$toAbsoluteIndex(end === undefined ? length : end, length);
    var result = $f9a22d5a80b70b70$var$$Array($f9a22d5a80b70b70$var$max$1(fin - k, 0));
    for(var n = 0; k < fin; k++, n++)$f9a22d5a80b70b70$var$createProperty(result, n, O[k]);
    result.length = n;
    return result;
};
// based on https://github.com/bestiejs/punycode.js/blob/master/punycode.js
var $f9a22d5a80b70b70$var$uncurryThis$6 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
var $f9a22d5a80b70b70$var$base = 36;
var $f9a22d5a80b70b70$var$tMin = 1;
var $f9a22d5a80b70b70$var$tMax = 26;
var $f9a22d5a80b70b70$var$skew = 38;
var $f9a22d5a80b70b70$var$damp = 700;
var $f9a22d5a80b70b70$var$initialBias = 72;
var $f9a22d5a80b70b70$var$initialN = 128; // 0x80
var $f9a22d5a80b70b70$var$delimiter = "-"; // '\x2D'
var $f9a22d5a80b70b70$var$regexNonASCII = /[^\0-\u007E]/; // non-ASCII chars
var $f9a22d5a80b70b70$var$regexSeparators = /[.\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
var $f9a22d5a80b70b70$var$OVERFLOW_ERROR = "Overflow: input needs wider integers to process";
var $f9a22d5a80b70b70$var$baseMinusTMin = $f9a22d5a80b70b70$var$base - $f9a22d5a80b70b70$var$tMin;
var $f9a22d5a80b70b70$var$$RangeError = RangeError;
var $f9a22d5a80b70b70$var$exec$2 = $f9a22d5a80b70b70$var$uncurryThis$6($f9a22d5a80b70b70$var$regexSeparators.exec);
var $f9a22d5a80b70b70$var$floor$3 = Math.floor;
var $f9a22d5a80b70b70$var$fromCharCode = String.fromCharCode;
var $f9a22d5a80b70b70$var$charCodeAt = $f9a22d5a80b70b70$var$uncurryThis$6("".charCodeAt);
var $f9a22d5a80b70b70$var$join$2 = $f9a22d5a80b70b70$var$uncurryThis$6([].join);
var $f9a22d5a80b70b70$var$push$3 = $f9a22d5a80b70b70$var$uncurryThis$6([].push);
var $f9a22d5a80b70b70$var$replace$4 = $f9a22d5a80b70b70$var$uncurryThis$6("".replace);
var $f9a22d5a80b70b70$var$split$2 = $f9a22d5a80b70b70$var$uncurryThis$6("".split);
var $f9a22d5a80b70b70$var$toLowerCase$1 = $f9a22d5a80b70b70$var$uncurryThis$6("".toLowerCase);
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 */ var $f9a22d5a80b70b70$var$ucs2decode = function(string) {
    var output = [];
    var counter = 0;
    var length = string.length;
    while(counter < length){
        var value = $f9a22d5a80b70b70$var$charCodeAt(string, counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            var extra = $f9a22d5a80b70b70$var$charCodeAt(string, counter++);
            if ((extra & 0xFC00) == 0xDC00) $f9a22d5a80b70b70$var$push$3(output, ((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                $f9a22d5a80b70b70$var$push$3(output, value);
                counter--;
            }
        } else $f9a22d5a80b70b70$var$push$3(output, value);
    }
    return output;
};
/**
 * Converts a digit/integer into a basic code point.
 */ var $f9a22d5a80b70b70$var$digitToBasic = function(digit) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 */ var $f9a22d5a80b70b70$var$adapt = function(delta, numPoints, firstTime) {
    var k = 0;
    delta = firstTime ? $f9a22d5a80b70b70$var$floor$3(delta / $f9a22d5a80b70b70$var$damp) : delta >> 1;
    delta += $f9a22d5a80b70b70$var$floor$3(delta / numPoints);
    while(delta > $f9a22d5a80b70b70$var$baseMinusTMin * $f9a22d5a80b70b70$var$tMax >> 1){
        delta = $f9a22d5a80b70b70$var$floor$3(delta / $f9a22d5a80b70b70$var$baseMinusTMin);
        k += $f9a22d5a80b70b70$var$base;
    }
    return $f9a22d5a80b70b70$var$floor$3(k + ($f9a22d5a80b70b70$var$baseMinusTMin + 1) * delta / (delta + $f9a22d5a80b70b70$var$skew));
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 */ var $f9a22d5a80b70b70$var$encode = function(input) {
    var output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $f9a22d5a80b70b70$var$ucs2decode(input);
    // Cache the length.
    var inputLength = input.length;
    // Initialize the state.
    var n = $f9a22d5a80b70b70$var$initialN;
    var delta = 0;
    var bias = $f9a22d5a80b70b70$var$initialBias;
    var i, currentValue;
    // Handle the basic code points.
    for(i = 0; i < input.length; i++){
        currentValue = input[i];
        if (currentValue < 0x80) $f9a22d5a80b70b70$var$push$3(output, $f9a22d5a80b70b70$var$fromCharCode(currentValue));
    }
    var basicLength = output.length; // number of basic code points.
    var handledCPCount = basicLength; // number of code points that have been handled;
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) $f9a22d5a80b70b70$var$push$3(output, $f9a22d5a80b70b70$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next larger one:
        var m = $f9a22d5a80b70b70$var$maxInt;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue >= n && currentValue < m) m = currentValue;
        }
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>, but guard against overflow.
        var handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $f9a22d5a80b70b70$var$floor$3(($f9a22d5a80b70b70$var$maxInt - delta) / handledCPCountPlusOne)) throw $f9a22d5a80b70b70$var$$RangeError($f9a22d5a80b70b70$var$OVERFLOW_ERROR);
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for(i = 0; i < input.length; i++){
            currentValue = input[i];
            if (currentValue < n && ++delta > $f9a22d5a80b70b70$var$maxInt) throw $f9a22d5a80b70b70$var$$RangeError($f9a22d5a80b70b70$var$OVERFLOW_ERROR);
            if (currentValue == n) {
                // Represent delta as a generalized variable-length integer.
                var q = delta;
                var k = $f9a22d5a80b70b70$var$base;
                while(true){
                    var t = k <= bias ? $f9a22d5a80b70b70$var$tMin : k >= bias + $f9a22d5a80b70b70$var$tMax ? $f9a22d5a80b70b70$var$tMax : k - bias;
                    if (q < t) break;
                    var qMinusT = q - t;
                    var baseMinusT = $f9a22d5a80b70b70$var$base - t;
                    $f9a22d5a80b70b70$var$push$3(output, $f9a22d5a80b70b70$var$fromCharCode($f9a22d5a80b70b70$var$digitToBasic(t + qMinusT % baseMinusT)));
                    q = $f9a22d5a80b70b70$var$floor$3(qMinusT / baseMinusT);
                    k += $f9a22d5a80b70b70$var$base;
                }
                $f9a22d5a80b70b70$var$push$3(output, $f9a22d5a80b70b70$var$fromCharCode($f9a22d5a80b70b70$var$digitToBasic(q)));
                bias = $f9a22d5a80b70b70$var$adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                delta = 0;
                handledCPCount++;
            }
        }
        delta++;
        n++;
    }
    return $f9a22d5a80b70b70$var$join$2(output, "");
};
var $f9a22d5a80b70b70$var$stringPunycodeToAscii = function(input) {
    var encoded = [];
    var labels = $f9a22d5a80b70b70$var$split$2($f9a22d5a80b70b70$var$replace$4($f9a22d5a80b70b70$var$toLowerCase$1(input), $f9a22d5a80b70b70$var$regexSeparators, "."), ".");
    var i, label;
    for(i = 0; i < labels.length; i++){
        label = labels[i];
        $f9a22d5a80b70b70$var$push$3(encoded, $f9a22d5a80b70b70$var$exec$2($f9a22d5a80b70b70$var$regexNonASCII, label) ? "xn--" + $f9a22d5a80b70b70$var$encode(label) : label);
    }
    return $f9a22d5a80b70b70$var$join$2(encoded, ".");
};
var $f9a22d5a80b70b70$var$defineBuiltIn$3 = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$defineBuiltIns$1 = function(target, src, options) {
    for(var key in src)$f9a22d5a80b70b70$var$defineBuiltIn$3(target, key, src[key], options);
    return target;
};
var $f9a22d5a80b70b70$var$arraySlice$1 = $f9a22d5a80b70b70$var$arraySliceSimple;
var $f9a22d5a80b70b70$var$floor$2 = Math.floor;
var $f9a22d5a80b70b70$var$mergeSort = function(array, comparefn) {
    var length = array.length;
    var middle = $f9a22d5a80b70b70$var$floor$2(length / 2);
    return length < 8 ? $f9a22d5a80b70b70$var$insertionSort(array, comparefn) : $f9a22d5a80b70b70$var$merge(array, $f9a22d5a80b70b70$var$mergeSort($f9a22d5a80b70b70$var$arraySlice$1(array, 0, middle), comparefn), $f9a22d5a80b70b70$var$mergeSort($f9a22d5a80b70b70$var$arraySlice$1(array, middle), comparefn), comparefn);
};
var $f9a22d5a80b70b70$var$insertionSort = function(array, comparefn) {
    var length = array.length;
    var i = 1;
    var element, j;
    while(i < length){
        j = i;
        element = array[i];
        while(j && comparefn(array[j - 1], element) > 0)array[j] = array[--j];
        if (j !== i++) array[j] = element;
    }
    return array;
};
var $f9a22d5a80b70b70$var$merge = function(array, left, right, comparefn) {
    var llength = left.length;
    var rlength = right.length;
    var lindex = 0;
    var rindex = 0;
    while(lindex < llength || rindex < rlength)array[lindex + rindex] = lindex < llength && rindex < rlength ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++] : lindex < llength ? left[lindex++] : right[rindex++];
    return array;
};
var $f9a22d5a80b70b70$var$arraySort$1 = $f9a22d5a80b70b70$var$mergeSort;
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
var $f9a22d5a80b70b70$var$$$2 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$global$5 = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$call$3 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$uncurryThis$5 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$DESCRIPTORS$1 = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$USE_NATIVE_URL$1 = $f9a22d5a80b70b70$var$nativeUrl;
var $f9a22d5a80b70b70$var$defineBuiltIn$2 = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$defineBuiltIns = $f9a22d5a80b70b70$var$defineBuiltIns$1;
var $f9a22d5a80b70b70$var$setToStringTag$1 = $f9a22d5a80b70b70$var$setToStringTag$5;
var $f9a22d5a80b70b70$var$createIteratorConstructor = $f9a22d5a80b70b70$var$createIteratorConstructor$2;
var $f9a22d5a80b70b70$var$InternalStateModule$1 = $f9a22d5a80b70b70$var$internalState;
var $f9a22d5a80b70b70$var$anInstance$1 = $f9a22d5a80b70b70$var$anInstance$3;
var $f9a22d5a80b70b70$var$isCallable$2 = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$hasOwn$1 = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$bind$1 = $f9a22d5a80b70b70$var$functionBindContext;
var $f9a22d5a80b70b70$var$classof$1 = $f9a22d5a80b70b70$var$classof$6;
var $f9a22d5a80b70b70$var$anObject$2 = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$isObject = $f9a22d5a80b70b70$var$isObject$8;
var $f9a22d5a80b70b70$var$$toString$1 = $f9a22d5a80b70b70$var$toString$4;
var $f9a22d5a80b70b70$var$create$1 = $f9a22d5a80b70b70$var$objectCreate;
var $f9a22d5a80b70b70$var$createPropertyDescriptor = $f9a22d5a80b70b70$var$createPropertyDescriptor$5;
var $f9a22d5a80b70b70$var$getIterator = $f9a22d5a80b70b70$var$getIterator$3;
var $f9a22d5a80b70b70$var$getIteratorMethod = $f9a22d5a80b70b70$var$getIteratorMethod$4;
var $f9a22d5a80b70b70$var$validateArgumentsLength$1 = $f9a22d5a80b70b70$var$validateArgumentsLength$3;
var $f9a22d5a80b70b70$var$wellKnownSymbol$2 = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$arraySort = $f9a22d5a80b70b70$var$arraySort$1;
var $f9a22d5a80b70b70$var$ITERATOR = $f9a22d5a80b70b70$var$wellKnownSymbol$2("iterator");
var $f9a22d5a80b70b70$var$URL_SEARCH_PARAMS = "URLSearchParams";
var $f9a22d5a80b70b70$var$URL_SEARCH_PARAMS_ITERATOR = $f9a22d5a80b70b70$var$URL_SEARCH_PARAMS + "Iterator";
var $f9a22d5a80b70b70$var$setInternalState$1 = $f9a22d5a80b70b70$var$InternalStateModule$1.set;
var $f9a22d5a80b70b70$var$getInternalParamsState = $f9a22d5a80b70b70$var$InternalStateModule$1.getterFor($f9a22d5a80b70b70$var$URL_SEARCH_PARAMS);
var $f9a22d5a80b70b70$var$getInternalIteratorState = $f9a22d5a80b70b70$var$InternalStateModule$1.getterFor($f9a22d5a80b70b70$var$URL_SEARCH_PARAMS_ITERATOR);
// eslint-disable-next-line es-x/no-object-getownpropertydescriptor -- safe
var $f9a22d5a80b70b70$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Avoid NodeJS experimental warning
var $f9a22d5a80b70b70$var$safeGetBuiltIn = function(name) {
    if (!$f9a22d5a80b70b70$var$DESCRIPTORS$1) return $f9a22d5a80b70b70$var$global$5[name];
    var descriptor = $f9a22d5a80b70b70$var$getOwnPropertyDescriptor($f9a22d5a80b70b70$var$global$5, name);
    return descriptor && descriptor.value;
};
var $f9a22d5a80b70b70$var$nativeFetch = $f9a22d5a80b70b70$var$safeGetBuiltIn("fetch");
var $f9a22d5a80b70b70$var$NativeRequest = $f9a22d5a80b70b70$var$safeGetBuiltIn("Request");
var $f9a22d5a80b70b70$var$Headers = $f9a22d5a80b70b70$var$safeGetBuiltIn("Headers");
var $f9a22d5a80b70b70$var$RequestPrototype = $f9a22d5a80b70b70$var$NativeRequest && $f9a22d5a80b70b70$var$NativeRequest.prototype;
var $f9a22d5a80b70b70$var$HeadersPrototype = $f9a22d5a80b70b70$var$Headers && $f9a22d5a80b70b70$var$Headers.prototype;
var $f9a22d5a80b70b70$var$RegExp$1 = $f9a22d5a80b70b70$var$global$5.RegExp;
var $f9a22d5a80b70b70$var$TypeError$2 = $f9a22d5a80b70b70$var$global$5.TypeError;
var $f9a22d5a80b70b70$var$decodeURIComponent = $f9a22d5a80b70b70$var$global$5.decodeURIComponent;
var $f9a22d5a80b70b70$var$encodeURIComponent$1 = $f9a22d5a80b70b70$var$global$5.encodeURIComponent;
var $f9a22d5a80b70b70$var$charAt$4 = $f9a22d5a80b70b70$var$uncurryThis$5("".charAt);
var $f9a22d5a80b70b70$var$join$1 = $f9a22d5a80b70b70$var$uncurryThis$5([].join);
var $f9a22d5a80b70b70$var$push$2 = $f9a22d5a80b70b70$var$uncurryThis$5([].push);
var $f9a22d5a80b70b70$var$replace$3 = $f9a22d5a80b70b70$var$uncurryThis$5("".replace);
var $f9a22d5a80b70b70$var$shift$1 = $f9a22d5a80b70b70$var$uncurryThis$5([].shift);
var $f9a22d5a80b70b70$var$splice = $f9a22d5a80b70b70$var$uncurryThis$5([].splice);
var $f9a22d5a80b70b70$var$split$1 = $f9a22d5a80b70b70$var$uncurryThis$5("".split);
var $f9a22d5a80b70b70$var$stringSlice$4 = $f9a22d5a80b70b70$var$uncurryThis$5("".slice);
var $f9a22d5a80b70b70$var$plus = /\+/g;
var $f9a22d5a80b70b70$var$sequences = Array(4);
var $f9a22d5a80b70b70$var$percentSequence = function(bytes) {
    return $f9a22d5a80b70b70$var$sequences[bytes - 1] || ($f9a22d5a80b70b70$var$sequences[bytes - 1] = $f9a22d5a80b70b70$var$RegExp$1("((?:%[\\da-f]{2}){" + bytes + "})", "gi"));
};
var $f9a22d5a80b70b70$var$percentDecode = function(sequence) {
    try {
        return $f9a22d5a80b70b70$var$decodeURIComponent(sequence);
    } catch (error) {
        return sequence;
    }
};
var $f9a22d5a80b70b70$var$deserialize = function(it) {
    var result = $f9a22d5a80b70b70$var$replace$3(it, $f9a22d5a80b70b70$var$plus, " ");
    var bytes = 4;
    try {
        return $f9a22d5a80b70b70$var$decodeURIComponent(result);
    } catch (error) {
        while(bytes)result = $f9a22d5a80b70b70$var$replace$3(result, $f9a22d5a80b70b70$var$percentSequence(bytes--), $f9a22d5a80b70b70$var$percentDecode);
        return result;
    }
};
var $f9a22d5a80b70b70$var$find = /[!'()~]|%20/g;
var $f9a22d5a80b70b70$var$replacements = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
};
var $f9a22d5a80b70b70$var$replacer = function(match) {
    return $f9a22d5a80b70b70$var$replacements[match];
};
var $f9a22d5a80b70b70$var$serialize = function(it) {
    return $f9a22d5a80b70b70$var$replace$3($f9a22d5a80b70b70$var$encodeURIComponent$1(it), $f9a22d5a80b70b70$var$find, $f9a22d5a80b70b70$var$replacer);
};
var $f9a22d5a80b70b70$var$URLSearchParamsIterator = $f9a22d5a80b70b70$var$createIteratorConstructor(function Iterator(params, kind) {
    $f9a22d5a80b70b70$var$setInternalState$1(this, {
        type: $f9a22d5a80b70b70$var$URL_SEARCH_PARAMS_ITERATOR,
        iterator: $f9a22d5a80b70b70$var$getIterator($f9a22d5a80b70b70$var$getInternalParamsState(params).entries),
        kind: kind
    });
}, "Iterator", function next() {
    var state = $f9a22d5a80b70b70$var$getInternalIteratorState(this);
    var kind = state.kind;
    var step = state.iterator.next();
    var entry = step.value;
    if (!step.done) step.value = kind === "keys" ? entry.key : kind === "values" ? entry.value : [
        entry.key,
        entry.value
    ];
    return step;
}, true);
var $f9a22d5a80b70b70$var$URLSearchParamsState = function(init) {
    this.entries = [];
    this.url = null;
    if (init !== undefined) {
        if ($f9a22d5a80b70b70$var$isObject(init)) this.parseObject(init);
        else this.parseQuery(typeof init == "string" ? $f9a22d5a80b70b70$var$charAt$4(init, 0) === "?" ? $f9a22d5a80b70b70$var$stringSlice$4(init, 1) : init : $f9a22d5a80b70b70$var$$toString$1(init));
    }
};
$f9a22d5a80b70b70$var$URLSearchParamsState.prototype = {
    type: $f9a22d5a80b70b70$var$URL_SEARCH_PARAMS,
    bindURL: function(url) {
        this.url = url;
        this.update();
    },
    parseObject: function(object) {
        var iteratorMethod = $f9a22d5a80b70b70$var$getIteratorMethod(object);
        var iterator, next, step, entryIterator, entryNext, first, second;
        if (iteratorMethod) {
            iterator = $f9a22d5a80b70b70$var$getIterator(object, iteratorMethod);
            next = iterator.next;
            while(!(step = $f9a22d5a80b70b70$var$call$3(next, iterator)).done){
                entryIterator = $f9a22d5a80b70b70$var$getIterator($f9a22d5a80b70b70$var$anObject$2(step.value));
                entryNext = entryIterator.next;
                if ((first = $f9a22d5a80b70b70$var$call$3(entryNext, entryIterator)).done || (second = $f9a22d5a80b70b70$var$call$3(entryNext, entryIterator)).done || !$f9a22d5a80b70b70$var$call$3(entryNext, entryIterator).done) throw $f9a22d5a80b70b70$var$TypeError$2("Expected sequence with length 2");
                $f9a22d5a80b70b70$var$push$2(this.entries, {
                    key: $f9a22d5a80b70b70$var$$toString$1(first.value),
                    value: $f9a22d5a80b70b70$var$$toString$1(second.value)
                });
            }
        } else for(var key in object)if ($f9a22d5a80b70b70$var$hasOwn$1(object, key)) $f9a22d5a80b70b70$var$push$2(this.entries, {
            key: key,
            value: $f9a22d5a80b70b70$var$$toString$1(object[key])
        });
    },
    parseQuery: function(query) {
        if (query) {
            var attributes = $f9a22d5a80b70b70$var$split$1(query, "&");
            var index = 0;
            var attribute, entry;
            while(index < attributes.length){
                attribute = attributes[index++];
                if (attribute.length) {
                    entry = $f9a22d5a80b70b70$var$split$1(attribute, "=");
                    $f9a22d5a80b70b70$var$push$2(this.entries, {
                        key: $f9a22d5a80b70b70$var$deserialize($f9a22d5a80b70b70$var$shift$1(entry)),
                        value: $f9a22d5a80b70b70$var$deserialize($f9a22d5a80b70b70$var$join$1(entry, "="))
                    });
                }
            }
        }
    },
    serialize: function() {
        var entries = this.entries;
        var result = [];
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            $f9a22d5a80b70b70$var$push$2(result, $f9a22d5a80b70b70$var$serialize(entry.key) + "=" + $f9a22d5a80b70b70$var$serialize(entry.value));
        }
        return $f9a22d5a80b70b70$var$join$1(result, "&");
    },
    update: function() {
        this.entries.length = 0;
        this.parseQuery(this.url.query);
    },
    updateURL: function() {
        if (this.url) this.url.update();
    }
};
// `URLSearchParams` constructor
// https://url.spec.whatwg.org/#interface-urlsearchparams
var $f9a22d5a80b70b70$var$URLSearchParamsConstructor = function URLSearchParams1() {
    $f9a22d5a80b70b70$var$anInstance$1(this, $f9a22d5a80b70b70$var$URLSearchParamsPrototype);
    var init = arguments.length > 0 ? arguments[0] : undefined;
    $f9a22d5a80b70b70$var$setInternalState$1(this, new $f9a22d5a80b70b70$var$URLSearchParamsState(init));
};
var $f9a22d5a80b70b70$var$URLSearchParamsPrototype = $f9a22d5a80b70b70$var$URLSearchParamsConstructor.prototype;
$f9a22d5a80b70b70$var$defineBuiltIns($f9a22d5a80b70b70$var$URLSearchParamsPrototype, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function append(name, value) {
        $f9a22d5a80b70b70$var$validateArgumentsLength$1(arguments.length, 2);
        var state = $f9a22d5a80b70b70$var$getInternalParamsState(this);
        $f9a22d5a80b70b70$var$push$2(state.entries, {
            key: $f9a22d5a80b70b70$var$$toString$1(name),
            value: $f9a22d5a80b70b70$var$$toString$1(value)
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    "delete": function(name) {
        $f9a22d5a80b70b70$var$validateArgumentsLength$1(arguments.length, 1);
        var state = $f9a22d5a80b70b70$var$getInternalParamsState(this);
        var entries = state.entries;
        var key = $f9a22d5a80b70b70$var$$toString$1(name);
        var index = 0;
        while(index < entries.length)if (entries[index].key === key) $f9a22d5a80b70b70$var$splice(entries, index, 1);
        else index++;
        state.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function get(name) {
        $f9a22d5a80b70b70$var$validateArgumentsLength$1(arguments.length, 1);
        var entries = $f9a22d5a80b70b70$var$getInternalParamsState(this).entries;
        var key = $f9a22d5a80b70b70$var$$toString$1(name);
        var index = 0;
        for(; index < entries.length; index++){
            if (entries[index].key === key) return entries[index].value;
        }
        return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function getAll(name) {
        $f9a22d5a80b70b70$var$validateArgumentsLength$1(arguments.length, 1);
        var entries = $f9a22d5a80b70b70$var$getInternalParamsState(this).entries;
        var key = $f9a22d5a80b70b70$var$$toString$1(name);
        var result = [];
        var index = 0;
        for(; index < entries.length; index++)if (entries[index].key === key) $f9a22d5a80b70b70$var$push$2(result, entries[index].value);
        return result;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function has(name) {
        $f9a22d5a80b70b70$var$validateArgumentsLength$1(arguments.length, 1);
        var entries = $f9a22d5a80b70b70$var$getInternalParamsState(this).entries;
        var key = $f9a22d5a80b70b70$var$$toString$1(name);
        var index = 0;
        while(index < entries.length){
            if (entries[index++].key === key) return true;
        }
        return false;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function set(name, value) {
        $f9a22d5a80b70b70$var$validateArgumentsLength$1(arguments.length, 1);
        var state = $f9a22d5a80b70b70$var$getInternalParamsState(this);
        var entries = state.entries;
        var found = false;
        var key = $f9a22d5a80b70b70$var$$toString$1(name);
        var val = $f9a22d5a80b70b70$var$$toString$1(value);
        var index = 0;
        var entry;
        for(; index < entries.length; index++){
            entry = entries[index];
            if (entry.key === key) {
                if (found) $f9a22d5a80b70b70$var$splice(entries, index--, 1);
                else {
                    found = true;
                    entry.value = val;
                }
            }
        }
        if (!found) $f9a22d5a80b70b70$var$push$2(entries, {
            key: key,
            value: val
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function sort() {
        var state = $f9a22d5a80b70b70$var$getInternalParamsState(this);
        $f9a22d5a80b70b70$var$arraySort(state.entries, function(a, b) {
            return a.key > b.key ? 1 : -1;
        });
        state.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function forEach(callback /* , thisArg */ ) {
        var entries = $f9a22d5a80b70b70$var$getInternalParamsState(this).entries;
        var boundFunction = $f9a22d5a80b70b70$var$bind$1(callback, arguments.length > 1 ? arguments[1] : undefined);
        var index = 0;
        var entry;
        while(index < entries.length){
            entry = entries[index++];
            boundFunction(entry.value, entry.key, this);
        }
    },
    // `URLSearchParams.prototype.keys` method
    keys: function keys() {
        return new $f9a22d5a80b70b70$var$URLSearchParamsIterator(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function values() {
        return new $f9a22d5a80b70b70$var$URLSearchParamsIterator(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function entries() {
        return new $f9a22d5a80b70b70$var$URLSearchParamsIterator(this, "entries");
    }
}, {
    enumerable: true
});
// `URLSearchParams.prototype[@@iterator]` method
$f9a22d5a80b70b70$var$defineBuiltIn$2($f9a22d5a80b70b70$var$URLSearchParamsPrototype, $f9a22d5a80b70b70$var$ITERATOR, $f9a22d5a80b70b70$var$URLSearchParamsPrototype.entries, {
    name: "entries"
});
// `URLSearchParams.prototype.toString` method
// https://url.spec.whatwg.org/#urlsearchparams-stringification-behavior
$f9a22d5a80b70b70$var$defineBuiltIn$2($f9a22d5a80b70b70$var$URLSearchParamsPrototype, "toString", function toString() {
    return $f9a22d5a80b70b70$var$getInternalParamsState(this).serialize();
}, {
    enumerable: true
});
$f9a22d5a80b70b70$var$setToStringTag$1($f9a22d5a80b70b70$var$URLSearchParamsConstructor, $f9a22d5a80b70b70$var$URL_SEARCH_PARAMS);
$f9a22d5a80b70b70$var$$$2({
    global: true,
    constructor: true,
    forced: !$f9a22d5a80b70b70$var$USE_NATIVE_URL$1
}, {
    URLSearchParams: $f9a22d5a80b70b70$var$URLSearchParamsConstructor
});
// Wrap `fetch` and `Request` for correct work with polyfilled `URLSearchParams`
if (!$f9a22d5a80b70b70$var$USE_NATIVE_URL$1 && $f9a22d5a80b70b70$var$isCallable$2($f9a22d5a80b70b70$var$Headers)) {
    var $f9a22d5a80b70b70$var$headersHas = $f9a22d5a80b70b70$var$uncurryThis$5($f9a22d5a80b70b70$var$HeadersPrototype.has);
    var $f9a22d5a80b70b70$var$headersSet = $f9a22d5a80b70b70$var$uncurryThis$5($f9a22d5a80b70b70$var$HeadersPrototype.set);
    var $f9a22d5a80b70b70$var$wrapRequestOptions = function(init) {
        if ($f9a22d5a80b70b70$var$isObject(init)) {
            var body = init.body;
            var headers;
            if ($f9a22d5a80b70b70$var$classof$1(body) === $f9a22d5a80b70b70$var$URL_SEARCH_PARAMS) {
                headers = init.headers ? new $f9a22d5a80b70b70$var$Headers(init.headers) : new $f9a22d5a80b70b70$var$Headers();
                if (!$f9a22d5a80b70b70$var$headersHas(headers, "content-type")) $f9a22d5a80b70b70$var$headersSet(headers, "content-type", "application/x-www-form-urlencoded;charset=UTF-8");
                return $f9a22d5a80b70b70$var$create$1(init, {
                    body: $f9a22d5a80b70b70$var$createPropertyDescriptor(0, $f9a22d5a80b70b70$var$$toString$1(body)),
                    headers: $f9a22d5a80b70b70$var$createPropertyDescriptor(0, headers)
                });
            }
        }
        return init;
    };
    if ($f9a22d5a80b70b70$var$isCallable$2($f9a22d5a80b70b70$var$nativeFetch)) $f9a22d5a80b70b70$var$$$2({
        global: true,
        enumerable: true,
        dontCallGetSet: true,
        forced: true
    }, {
        fetch: function fetch(input /* , init */ ) {
            return $f9a22d5a80b70b70$var$nativeFetch(input, arguments.length > 1 ? $f9a22d5a80b70b70$var$wrapRequestOptions(arguments[1]) : {});
        }
    });
    if ($f9a22d5a80b70b70$var$isCallable$2($f9a22d5a80b70b70$var$NativeRequest)) {
        var $f9a22d5a80b70b70$var$RequestConstructor = function Request(input /* , init */ ) {
            $f9a22d5a80b70b70$var$anInstance$1(this, $f9a22d5a80b70b70$var$RequestPrototype);
            return new $f9a22d5a80b70b70$var$NativeRequest(input, arguments.length > 1 ? $f9a22d5a80b70b70$var$wrapRequestOptions(arguments[1]) : {});
        };
        $f9a22d5a80b70b70$var$RequestPrototype.constructor = $f9a22d5a80b70b70$var$RequestConstructor;
        $f9a22d5a80b70b70$var$RequestConstructor.prototype = $f9a22d5a80b70b70$var$RequestPrototype;
        $f9a22d5a80b70b70$var$$$2({
            global: true,
            constructor: true,
            dontCallGetSet: true,
            forced: true
        }, {
            Request: $f9a22d5a80b70b70$var$RequestConstructor
        });
    }
}
var $f9a22d5a80b70b70$var$web_urlSearchParams_constructor = {
    URLSearchParams: $f9a22d5a80b70b70$var$URLSearchParamsConstructor,
    getState: $f9a22d5a80b70b70$var$getInternalParamsState
};
// TODO: in core-js@4, move /modules/ dependencies to public entries for better optimization by tools like `preset-env`
var $f9a22d5a80b70b70$var$$$1 = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$DESCRIPTORS = $f9a22d5a80b70b70$var$descriptors;
var $f9a22d5a80b70b70$var$USE_NATIVE_URL = $f9a22d5a80b70b70$var$nativeUrl;
var $f9a22d5a80b70b70$var$global$4 = $f9a22d5a80b70b70$var$global$o;
var $f9a22d5a80b70b70$var$bind = $f9a22d5a80b70b70$var$functionBindContext;
var $f9a22d5a80b70b70$var$uncurryThis$4 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$defineBuiltIn$1 = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$defineBuiltInAccessor = $f9a22d5a80b70b70$var$defineBuiltInAccessor$1;
var $f9a22d5a80b70b70$var$anInstance = $f9a22d5a80b70b70$var$anInstance$3;
var $f9a22d5a80b70b70$var$hasOwn = $f9a22d5a80b70b70$var$hasOwnProperty_1;
var $f9a22d5a80b70b70$var$assign = $f9a22d5a80b70b70$var$objectAssign;
var $f9a22d5a80b70b70$var$arrayFrom = $f9a22d5a80b70b70$var$arrayFrom$1;
var $f9a22d5a80b70b70$var$arraySlice = $f9a22d5a80b70b70$var$arraySliceSimple;
var $f9a22d5a80b70b70$var$codeAt = $f9a22d5a80b70b70$var$stringMultibyte.codeAt;
var $f9a22d5a80b70b70$var$toASCII = $f9a22d5a80b70b70$var$stringPunycodeToAscii;
var $f9a22d5a80b70b70$var$$toString = $f9a22d5a80b70b70$var$toString$4;
var $f9a22d5a80b70b70$var$setToStringTag = $f9a22d5a80b70b70$var$setToStringTag$5;
var $f9a22d5a80b70b70$var$validateArgumentsLength = $f9a22d5a80b70b70$var$validateArgumentsLength$3;
var $f9a22d5a80b70b70$var$URLSearchParamsModule = $f9a22d5a80b70b70$var$web_urlSearchParams_constructor;
var $f9a22d5a80b70b70$var$InternalStateModule = $f9a22d5a80b70b70$var$internalState;
var $f9a22d5a80b70b70$var$setInternalState = $f9a22d5a80b70b70$var$InternalStateModule.set;
var $f9a22d5a80b70b70$var$getInternalURLState = $f9a22d5a80b70b70$var$InternalStateModule.getterFor("URL");
var $f9a22d5a80b70b70$var$URLSearchParams$1 = $f9a22d5a80b70b70$var$URLSearchParamsModule.URLSearchParams;
var $f9a22d5a80b70b70$var$getInternalSearchParamsState = $f9a22d5a80b70b70$var$URLSearchParamsModule.getState;
var $f9a22d5a80b70b70$var$NativeURL = $f9a22d5a80b70b70$var$global$4.URL;
var $f9a22d5a80b70b70$var$TypeError$1 = $f9a22d5a80b70b70$var$global$4.TypeError;
var $f9a22d5a80b70b70$var$parseInt = $f9a22d5a80b70b70$var$global$4.parseInt;
var $f9a22d5a80b70b70$var$floor$1 = Math.floor;
var $f9a22d5a80b70b70$var$pow = Math.pow;
var $f9a22d5a80b70b70$var$charAt$3 = $f9a22d5a80b70b70$var$uncurryThis$4("".charAt);
var $f9a22d5a80b70b70$var$exec$1 = $f9a22d5a80b70b70$var$uncurryThis$4(/./.exec);
var $f9a22d5a80b70b70$var$join = $f9a22d5a80b70b70$var$uncurryThis$4([].join);
var $f9a22d5a80b70b70$var$numberToString = $f9a22d5a80b70b70$var$uncurryThis$4(1.0.toString);
var $f9a22d5a80b70b70$var$pop = $f9a22d5a80b70b70$var$uncurryThis$4([].pop);
var $f9a22d5a80b70b70$var$push$1 = $f9a22d5a80b70b70$var$uncurryThis$4([].push);
var $f9a22d5a80b70b70$var$replace$2 = $f9a22d5a80b70b70$var$uncurryThis$4("".replace);
var $f9a22d5a80b70b70$var$shift = $f9a22d5a80b70b70$var$uncurryThis$4([].shift);
var $f9a22d5a80b70b70$var$split = $f9a22d5a80b70b70$var$uncurryThis$4("".split);
var $f9a22d5a80b70b70$var$stringSlice$3 = $f9a22d5a80b70b70$var$uncurryThis$4("".slice);
var $f9a22d5a80b70b70$var$toLowerCase = $f9a22d5a80b70b70$var$uncurryThis$4("".toLowerCase);
var $f9a22d5a80b70b70$var$unshift = $f9a22d5a80b70b70$var$uncurryThis$4([].unshift);
var $f9a22d5a80b70b70$var$INVALID_AUTHORITY = "Invalid authority";
var $f9a22d5a80b70b70$var$INVALID_SCHEME = "Invalid scheme";
var $f9a22d5a80b70b70$var$INVALID_HOST = "Invalid host";
var $f9a22d5a80b70b70$var$INVALID_PORT = "Invalid port";
var $f9a22d5a80b70b70$var$ALPHA = /[a-z]/i;
// eslint-disable-next-line regexp/no-obscure-range -- safe
var $f9a22d5a80b70b70$var$ALPHANUMERIC = /[\d+-.a-z]/i;
var $f9a22d5a80b70b70$var$DIGIT = /\d/;
var $f9a22d5a80b70b70$var$HEX_START = /^0x/i;
var $f9a22d5a80b70b70$var$OCT = /^[0-7]+$/;
var $f9a22d5a80b70b70$var$DEC = /^\d+$/;
var $f9a22d5a80b70b70$var$HEX = /^[\da-f]+$/i;
/* eslint-disable regexp/no-control-character -- safe */ var $f9a22d5a80b70b70$var$FORBIDDEN_HOST_CODE_POINT = /[\0\t\n\r #%/:<>?@[\\\]^|]/;
var $f9a22d5a80b70b70$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT = /[\0\t\n\r #/:<>?@[\\\]^|]/;
var $f9a22d5a80b70b70$var$LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE = /^[\u0000-\u0020]+|[\u0000-\u0020]+$/g;
var $f9a22d5a80b70b70$var$TAB_AND_NEW_LINE = /[\t\n\r]/g;
/* eslint-enable regexp/no-control-character -- safe */ var $f9a22d5a80b70b70$var$EOF;
// https://url.spec.whatwg.org/#ipv4-number-parser
var $f9a22d5a80b70b70$var$parseIPv4 = function(input) {
    var parts = $f9a22d5a80b70b70$var$split(input, ".");
    var partsLength, numbers, index, part, radix, number, ipv4;
    if (parts.length && parts[parts.length - 1] == "") parts.length--;
    partsLength = parts.length;
    if (partsLength > 4) return input;
    numbers = [];
    for(index = 0; index < partsLength; index++){
        part = parts[index];
        if (part == "") return input;
        radix = 10;
        if (part.length > 1 && $f9a22d5a80b70b70$var$charAt$3(part, 0) == "0") {
            radix = $f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$HEX_START, part) ? 16 : 8;
            part = $f9a22d5a80b70b70$var$stringSlice$3(part, radix == 8 ? 1 : 2);
        }
        if (part === "") number = 0;
        else {
            if (!$f9a22d5a80b70b70$var$exec$1(radix == 10 ? $f9a22d5a80b70b70$var$DEC : radix == 8 ? $f9a22d5a80b70b70$var$OCT : $f9a22d5a80b70b70$var$HEX, part)) return input;
            number = $f9a22d5a80b70b70$var$parseInt(part, radix);
        }
        $f9a22d5a80b70b70$var$push$1(numbers, number);
    }
    for(index = 0; index < partsLength; index++){
        number = numbers[index];
        if (index == partsLength - 1) {
            if (number >= $f9a22d5a80b70b70$var$pow(256, 5 - partsLength)) return null;
        } else if (number > 255) return null;
    }
    ipv4 = $f9a22d5a80b70b70$var$pop(numbers);
    for(index = 0; index < numbers.length; index++)ipv4 += numbers[index] * $f9a22d5a80b70b70$var$pow(256, 3 - index);
    return ipv4;
};
// https://url.spec.whatwg.org/#concept-ipv6-parser
// eslint-disable-next-line max-statements -- TODO
var $f9a22d5a80b70b70$var$parseIPv6 = function(input) {
    var address = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var pieceIndex = 0;
    var compress = null;
    var pointer = 0;
    var value, length, numbersSeen, ipv4Piece, number, swaps, swap;
    var chr = function() {
        return $f9a22d5a80b70b70$var$charAt$3(input, pointer);
    };
    if (chr() == ":") {
        if ($f9a22d5a80b70b70$var$charAt$3(input, 1) != ":") return;
        pointer += 2;
        pieceIndex++;
        compress = pieceIndex;
    }
    while(chr()){
        if (pieceIndex == 8) return;
        if (chr() == ":") {
            if (compress !== null) return;
            pointer++;
            pieceIndex++;
            compress = pieceIndex;
            continue;
        }
        value = length = 0;
        while(length < 4 && $f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$HEX, chr())){
            value = value * 16 + $f9a22d5a80b70b70$var$parseInt(chr(), 16);
            pointer++;
            length++;
        }
        if (chr() == ".") {
            if (length == 0) return;
            pointer -= length;
            if (pieceIndex > 6) return;
            numbersSeen = 0;
            while(chr()){
                ipv4Piece = null;
                if (numbersSeen > 0) {
                    if (chr() == "." && numbersSeen < 4) pointer++;
                    else return;
                }
                if (!$f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$DIGIT, chr())) return;
                while($f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$DIGIT, chr())){
                    number = $f9a22d5a80b70b70$var$parseInt(chr(), 10);
                    if (ipv4Piece === null) ipv4Piece = number;
                    else if (ipv4Piece == 0) return;
                    else ipv4Piece = ipv4Piece * 10 + number;
                    if (ipv4Piece > 255) return;
                    pointer++;
                }
                address[pieceIndex] = address[pieceIndex] * 256 + ipv4Piece;
                numbersSeen++;
                if (numbersSeen == 2 || numbersSeen == 4) pieceIndex++;
            }
            if (numbersSeen != 4) return;
            break;
        } else if (chr() == ":") {
            pointer++;
            if (!chr()) return;
        } else if (chr()) return;
        address[pieceIndex++] = value;
    }
    if (compress !== null) {
        swaps = pieceIndex - compress;
        pieceIndex = 7;
        while(pieceIndex != 0 && swaps > 0){
            swap = address[pieceIndex];
            address[pieceIndex--] = address[compress + swaps - 1];
            address[compress + --swaps] = swap;
        }
    } else if (pieceIndex != 8) return;
    return address;
};
var $f9a22d5a80b70b70$var$findLongestZeroSequence = function(ipv6) {
    var maxIndex = null;
    var maxLength = 1;
    var currStart = null;
    var currLength = 0;
    var index = 0;
    for(; index < 8; index++)if (ipv6[index] !== 0) {
        if (currLength > maxLength) {
            maxIndex = currStart;
            maxLength = currLength;
        }
        currStart = null;
        currLength = 0;
    } else {
        if (currStart === null) currStart = index;
        ++currLength;
    }
    if (currLength > maxLength) {
        maxIndex = currStart;
        maxLength = currLength;
    }
    return maxIndex;
};
// https://url.spec.whatwg.org/#host-serializing
var $f9a22d5a80b70b70$var$serializeHost = function(host) {
    var result, index, compress, ignore0;
    // ipv4
    if (typeof host == "number") {
        result = [];
        for(index = 0; index < 4; index++){
            $f9a22d5a80b70b70$var$unshift(result, host % 256);
            host = $f9a22d5a80b70b70$var$floor$1(host / 256);
        }
        return $f9a22d5a80b70b70$var$join(result, ".");
    // ipv6
    } else if (typeof host == "object") {
        result = "";
        compress = $f9a22d5a80b70b70$var$findLongestZeroSequence(host);
        for(index = 0; index < 8; index++){
            if (ignore0 && host[index] === 0) continue;
            if (ignore0) ignore0 = false;
            if (compress === index) {
                result += index ? ":" : "::";
                ignore0 = true;
            } else {
                result += $f9a22d5a80b70b70$var$numberToString(host[index], 16);
                if (index < 7) result += ":";
            }
        }
        return "[" + result + "]";
    }
    return host;
};
var $f9a22d5a80b70b70$var$C0ControlPercentEncodeSet = {};
var $f9a22d5a80b70b70$var$fragmentPercentEncodeSet = $f9a22d5a80b70b70$var$assign({}, $f9a22d5a80b70b70$var$C0ControlPercentEncodeSet, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
});
var $f9a22d5a80b70b70$var$pathPercentEncodeSet = $f9a22d5a80b70b70$var$assign({}, $f9a22d5a80b70b70$var$fragmentPercentEncodeSet, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
});
var $f9a22d5a80b70b70$var$userinfoPercentEncodeSet = $f9a22d5a80b70b70$var$assign({}, $f9a22d5a80b70b70$var$pathPercentEncodeSet, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
});
var $f9a22d5a80b70b70$var$percentEncode = function(chr, set) {
    var code = $f9a22d5a80b70b70$var$codeAt(chr, 0);
    return code > 0x20 && code < 0x7F && !$f9a22d5a80b70b70$var$hasOwn(set, chr) ? chr : encodeURIComponent(chr);
};
// https://url.spec.whatwg.org/#special-scheme
var $f9a22d5a80b70b70$var$specialSchemes = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
};
// https://url.spec.whatwg.org/#windows-drive-letter
var $f9a22d5a80b70b70$var$isWindowsDriveLetter = function(string, normalized) {
    var second;
    return string.length == 2 && $f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$ALPHA, $f9a22d5a80b70b70$var$charAt$3(string, 0)) && ((second = $f9a22d5a80b70b70$var$charAt$3(string, 1)) == ":" || !normalized && second == "|");
};
// https://url.spec.whatwg.org/#start-with-a-windows-drive-letter
var $f9a22d5a80b70b70$var$startsWithWindowsDriveLetter = function(string) {
    var third;
    return string.length > 1 && $f9a22d5a80b70b70$var$isWindowsDriveLetter($f9a22d5a80b70b70$var$stringSlice$3(string, 0, 2)) && (string.length == 2 || (third = $f9a22d5a80b70b70$var$charAt$3(string, 2)) === "/" || third === "\\" || third === "?" || third === "#");
};
// https://url.spec.whatwg.org/#single-dot-path-segment
var $f9a22d5a80b70b70$var$isSingleDot = function(segment) {
    return segment === "." || $f9a22d5a80b70b70$var$toLowerCase(segment) === "%2e";
};
// https://url.spec.whatwg.org/#double-dot-path-segment
var $f9a22d5a80b70b70$var$isDoubleDot = function(segment) {
    segment = $f9a22d5a80b70b70$var$toLowerCase(segment);
    return segment === ".." || segment === "%2e." || segment === ".%2e" || segment === "%2e%2e";
};
// States:
var $f9a22d5a80b70b70$var$SCHEME_START = {};
var $f9a22d5a80b70b70$var$SCHEME = {};
var $f9a22d5a80b70b70$var$NO_SCHEME = {};
var $f9a22d5a80b70b70$var$SPECIAL_RELATIVE_OR_AUTHORITY = {};
var $f9a22d5a80b70b70$var$PATH_OR_AUTHORITY = {};
var $f9a22d5a80b70b70$var$RELATIVE = {};
var $f9a22d5a80b70b70$var$RELATIVE_SLASH = {};
var $f9a22d5a80b70b70$var$SPECIAL_AUTHORITY_SLASHES = {};
var $f9a22d5a80b70b70$var$SPECIAL_AUTHORITY_IGNORE_SLASHES = {};
var $f9a22d5a80b70b70$var$AUTHORITY = {};
var $f9a22d5a80b70b70$var$HOST = {};
var $f9a22d5a80b70b70$var$HOSTNAME = {};
var $f9a22d5a80b70b70$var$PORT = {};
var $f9a22d5a80b70b70$var$FILE = {};
var $f9a22d5a80b70b70$var$FILE_SLASH = {};
var $f9a22d5a80b70b70$var$FILE_HOST = {};
var $f9a22d5a80b70b70$var$PATH_START = {};
var $f9a22d5a80b70b70$var$PATH = {};
var $f9a22d5a80b70b70$var$CANNOT_BE_A_BASE_URL_PATH = {};
var $f9a22d5a80b70b70$var$QUERY = {};
var $f9a22d5a80b70b70$var$FRAGMENT = {};
var $f9a22d5a80b70b70$var$URLState = function(url, isBase, base) {
    var urlString = $f9a22d5a80b70b70$var$$toString(url);
    var baseState, failure, searchParams;
    if (isBase) {
        failure = this.parse(urlString);
        if (failure) throw $f9a22d5a80b70b70$var$TypeError$1(failure);
        this.searchParams = null;
    } else {
        if (base !== undefined) baseState = new $f9a22d5a80b70b70$var$URLState(base, true);
        failure = this.parse(urlString, null, baseState);
        if (failure) throw $f9a22d5a80b70b70$var$TypeError$1(failure);
        searchParams = $f9a22d5a80b70b70$var$getInternalSearchParamsState(new $f9a22d5a80b70b70$var$URLSearchParams$1());
        searchParams.bindURL(this);
        this.searchParams = searchParams;
    }
};
$f9a22d5a80b70b70$var$URLState.prototype = {
    type: "URL",
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function(input, stateOverride, base) {
        var url = this;
        var state = stateOverride || $f9a22d5a80b70b70$var$SCHEME_START;
        var pointer = 0;
        var buffer = "";
        var seenAt = false;
        var seenBracket = false;
        var seenPasswordToken = false;
        var codePoints, chr, bufferCodePoints, failure;
        input = $f9a22d5a80b70b70$var$$toString(input);
        if (!stateOverride) {
            url.scheme = "";
            url.username = "";
            url.password = "";
            url.host = null;
            url.port = null;
            url.path = [];
            url.query = null;
            url.fragment = null;
            url.cannotBeABaseURL = false;
            input = $f9a22d5a80b70b70$var$replace$2(input, $f9a22d5a80b70b70$var$LEADING_AND_TRAILING_C0_CONTROL_OR_SPACE, "");
        }
        input = $f9a22d5a80b70b70$var$replace$2(input, $f9a22d5a80b70b70$var$TAB_AND_NEW_LINE, "");
        codePoints = $f9a22d5a80b70b70$var$arrayFrom(input);
        while(pointer <= codePoints.length){
            chr = codePoints[pointer];
            switch(state){
                case $f9a22d5a80b70b70$var$SCHEME_START:
                    if (chr && $f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$ALPHA, chr)) {
                        buffer += $f9a22d5a80b70b70$var$toLowerCase(chr);
                        state = $f9a22d5a80b70b70$var$SCHEME;
                    } else if (!stateOverride) {
                        state = $f9a22d5a80b70b70$var$NO_SCHEME;
                        continue;
                    } else return $f9a22d5a80b70b70$var$INVALID_SCHEME;
                    break;
                case $f9a22d5a80b70b70$var$SCHEME:
                    if (chr && ($f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$ALPHANUMERIC, chr) || chr == "+" || chr == "-" || chr == ".")) buffer += $f9a22d5a80b70b70$var$toLowerCase(chr);
                    else if (chr == ":") {
                        if (stateOverride && (url.isSpecial() != $f9a22d5a80b70b70$var$hasOwn($f9a22d5a80b70b70$var$specialSchemes, buffer) || buffer == "file" && (url.includesCredentials() || url.port !== null) || url.scheme == "file" && !url.host)) return;
                        url.scheme = buffer;
                        if (stateOverride) {
                            if (url.isSpecial() && $f9a22d5a80b70b70$var$specialSchemes[url.scheme] == url.port) url.port = null;
                            return;
                        }
                        buffer = "";
                        if (url.scheme == "file") state = $f9a22d5a80b70b70$var$FILE;
                        else if (url.isSpecial() && base && base.scheme == url.scheme) state = $f9a22d5a80b70b70$var$SPECIAL_RELATIVE_OR_AUTHORITY;
                        else if (url.isSpecial()) state = $f9a22d5a80b70b70$var$SPECIAL_AUTHORITY_SLASHES;
                        else if (codePoints[pointer + 1] == "/") {
                            state = $f9a22d5a80b70b70$var$PATH_OR_AUTHORITY;
                            pointer++;
                        } else {
                            url.cannotBeABaseURL = true;
                            $f9a22d5a80b70b70$var$push$1(url.path, "");
                            state = $f9a22d5a80b70b70$var$CANNOT_BE_A_BASE_URL_PATH;
                        }
                    } else if (!stateOverride) {
                        buffer = "";
                        state = $f9a22d5a80b70b70$var$NO_SCHEME;
                        pointer = 0;
                        continue;
                    } else return $f9a22d5a80b70b70$var$INVALID_SCHEME;
                    break;
                case $f9a22d5a80b70b70$var$NO_SCHEME:
                    if (!base || base.cannotBeABaseURL && chr != "#") return $f9a22d5a80b70b70$var$INVALID_SCHEME;
                    if (base.cannotBeABaseURL && chr == "#") {
                        url.scheme = base.scheme;
                        url.path = $f9a22d5a80b70b70$var$arraySlice(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        url.cannotBeABaseURL = true;
                        state = $f9a22d5a80b70b70$var$FRAGMENT;
                        break;
                    }
                    state = base.scheme == "file" ? $f9a22d5a80b70b70$var$FILE : $f9a22d5a80b70b70$var$RELATIVE;
                    continue;
                case $f9a22d5a80b70b70$var$SPECIAL_RELATIVE_OR_AUTHORITY:
                    if (chr == "/" && codePoints[pointer + 1] == "/") {
                        state = $f9a22d5a80b70b70$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                        pointer++;
                    } else {
                        state = $f9a22d5a80b70b70$var$RELATIVE;
                        continue;
                    }
                    break;
                case $f9a22d5a80b70b70$var$PATH_OR_AUTHORITY:
                    if (chr == "/") {
                        state = $f9a22d5a80b70b70$var$AUTHORITY;
                        break;
                    } else {
                        state = $f9a22d5a80b70b70$var$PATH;
                        continue;
                    }
                case $f9a22d5a80b70b70$var$RELATIVE:
                    url.scheme = base.scheme;
                    if (chr == $f9a22d5a80b70b70$var$EOF) {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $f9a22d5a80b70b70$var$arraySlice(base.path);
                        url.query = base.query;
                    } else if (chr == "/" || chr == "\\" && url.isSpecial()) state = $f9a22d5a80b70b70$var$RELATIVE_SLASH;
                    else if (chr == "?") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $f9a22d5a80b70b70$var$arraySlice(base.path);
                        url.query = "";
                        state = $f9a22d5a80b70b70$var$QUERY;
                    } else if (chr == "#") {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $f9a22d5a80b70b70$var$arraySlice(base.path);
                        url.query = base.query;
                        url.fragment = "";
                        state = $f9a22d5a80b70b70$var$FRAGMENT;
                    } else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        url.path = $f9a22d5a80b70b70$var$arraySlice(base.path);
                        url.path.length--;
                        state = $f9a22d5a80b70b70$var$PATH;
                        continue;
                    }
                    break;
                case $f9a22d5a80b70b70$var$RELATIVE_SLASH:
                    if (url.isSpecial() && (chr == "/" || chr == "\\")) state = $f9a22d5a80b70b70$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    else if (chr == "/") state = $f9a22d5a80b70b70$var$AUTHORITY;
                    else {
                        url.username = base.username;
                        url.password = base.password;
                        url.host = base.host;
                        url.port = base.port;
                        state = $f9a22d5a80b70b70$var$PATH;
                        continue;
                    }
                    break;
                case $f9a22d5a80b70b70$var$SPECIAL_AUTHORITY_SLASHES:
                    state = $f9a22d5a80b70b70$var$SPECIAL_AUTHORITY_IGNORE_SLASHES;
                    if (chr != "/" || $f9a22d5a80b70b70$var$charAt$3(buffer, pointer + 1) != "/") continue;
                    pointer++;
                    break;
                case $f9a22d5a80b70b70$var$SPECIAL_AUTHORITY_IGNORE_SLASHES:
                    if (chr != "/" && chr != "\\") {
                        state = $f9a22d5a80b70b70$var$AUTHORITY;
                        continue;
                    }
                    break;
                case $f9a22d5a80b70b70$var$AUTHORITY:
                    if (chr == "@") {
                        if (seenAt) buffer = "%40" + buffer;
                        seenAt = true;
                        bufferCodePoints = $f9a22d5a80b70b70$var$arrayFrom(buffer);
                        for(var i = 0; i < bufferCodePoints.length; i++){
                            var codePoint = bufferCodePoints[i];
                            if (codePoint == ":" && !seenPasswordToken) {
                                seenPasswordToken = true;
                                continue;
                            }
                            var encodedCodePoints = $f9a22d5a80b70b70$var$percentEncode(codePoint, $f9a22d5a80b70b70$var$userinfoPercentEncodeSet);
                            if (seenPasswordToken) url.password += encodedCodePoints;
                            else url.username += encodedCodePoints;
                        }
                        buffer = "";
                    } else if (chr == $f9a22d5a80b70b70$var$EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && url.isSpecial()) {
                        if (seenAt && buffer == "") return $f9a22d5a80b70b70$var$INVALID_AUTHORITY;
                        pointer -= $f9a22d5a80b70b70$var$arrayFrom(buffer).length + 1;
                        buffer = "";
                        state = $f9a22d5a80b70b70$var$HOST;
                    } else buffer += chr;
                    break;
                case $f9a22d5a80b70b70$var$HOST:
                case $f9a22d5a80b70b70$var$HOSTNAME:
                    if (stateOverride && url.scheme == "file") {
                        state = $f9a22d5a80b70b70$var$FILE_HOST;
                        continue;
                    } else if (chr == ":" && !seenBracket) {
                        if (buffer == "") return $f9a22d5a80b70b70$var$INVALID_HOST;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = $f9a22d5a80b70b70$var$PORT;
                        if (stateOverride == $f9a22d5a80b70b70$var$HOSTNAME) return;
                    } else if (chr == $f9a22d5a80b70b70$var$EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && url.isSpecial()) {
                        if (url.isSpecial() && buffer == "") return $f9a22d5a80b70b70$var$INVALID_HOST;
                        if (stateOverride && buffer == "" && (url.includesCredentials() || url.port !== null)) return;
                        failure = url.parseHost(buffer);
                        if (failure) return failure;
                        buffer = "";
                        state = $f9a22d5a80b70b70$var$PATH_START;
                        if (stateOverride) return;
                        continue;
                    } else {
                        if (chr == "[") seenBracket = true;
                        else if (chr == "]") seenBracket = false;
                        buffer += chr;
                    }
                    break;
                case $f9a22d5a80b70b70$var$PORT:
                    if ($f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$DIGIT, chr)) buffer += chr;
                    else if (chr == $f9a22d5a80b70b70$var$EOF || chr == "/" || chr == "?" || chr == "#" || chr == "\\" && url.isSpecial() || stateOverride) {
                        if (buffer != "") {
                            var port = $f9a22d5a80b70b70$var$parseInt(buffer, 10);
                            if (port > 0xFFFF) return $f9a22d5a80b70b70$var$INVALID_PORT;
                            url.port = url.isSpecial() && port === $f9a22d5a80b70b70$var$specialSchemes[url.scheme] ? null : port;
                            buffer = "";
                        }
                        if (stateOverride) return;
                        state = $f9a22d5a80b70b70$var$PATH_START;
                        continue;
                    } else return $f9a22d5a80b70b70$var$INVALID_PORT;
                    break;
                case $f9a22d5a80b70b70$var$FILE:
                    url.scheme = "file";
                    if (chr == "/" || chr == "\\") state = $f9a22d5a80b70b70$var$FILE_SLASH;
                    else if (base && base.scheme == "file") {
                        if (chr == $f9a22d5a80b70b70$var$EOF) {
                            url.host = base.host;
                            url.path = $f9a22d5a80b70b70$var$arraySlice(base.path);
                            url.query = base.query;
                        } else if (chr == "?") {
                            url.host = base.host;
                            url.path = $f9a22d5a80b70b70$var$arraySlice(base.path);
                            url.query = "";
                            state = $f9a22d5a80b70b70$var$QUERY;
                        } else if (chr == "#") {
                            url.host = base.host;
                            url.path = $f9a22d5a80b70b70$var$arraySlice(base.path);
                            url.query = base.query;
                            url.fragment = "";
                            state = $f9a22d5a80b70b70$var$FRAGMENT;
                        } else {
                            if (!$f9a22d5a80b70b70$var$startsWithWindowsDriveLetter($f9a22d5a80b70b70$var$join($f9a22d5a80b70b70$var$arraySlice(codePoints, pointer), ""))) {
                                url.host = base.host;
                                url.path = $f9a22d5a80b70b70$var$arraySlice(base.path);
                                url.shortenPath();
                            }
                            state = $f9a22d5a80b70b70$var$PATH;
                            continue;
                        }
                    } else {
                        state = $f9a22d5a80b70b70$var$PATH;
                        continue;
                    }
                    break;
                case $f9a22d5a80b70b70$var$FILE_SLASH:
                    if (chr == "/" || chr == "\\") {
                        state = $f9a22d5a80b70b70$var$FILE_HOST;
                        break;
                    }
                    if (base && base.scheme == "file" && !$f9a22d5a80b70b70$var$startsWithWindowsDriveLetter($f9a22d5a80b70b70$var$join($f9a22d5a80b70b70$var$arraySlice(codePoints, pointer), ""))) {
                        if ($f9a22d5a80b70b70$var$isWindowsDriveLetter(base.path[0], true)) $f9a22d5a80b70b70$var$push$1(url.path, base.path[0]);
                        else url.host = base.host;
                    }
                    state = $f9a22d5a80b70b70$var$PATH;
                    continue;
                case $f9a22d5a80b70b70$var$FILE_HOST:
                    if (chr == $f9a22d5a80b70b70$var$EOF || chr == "/" || chr == "\\" || chr == "?" || chr == "#") {
                        if (!stateOverride && $f9a22d5a80b70b70$var$isWindowsDriveLetter(buffer)) state = $f9a22d5a80b70b70$var$PATH;
                        else if (buffer == "") {
                            url.host = "";
                            if (stateOverride) return;
                            state = $f9a22d5a80b70b70$var$PATH_START;
                        } else {
                            failure = url.parseHost(buffer);
                            if (failure) return failure;
                            if (url.host == "localhost") url.host = "";
                            if (stateOverride) return;
                            buffer = "";
                            state = $f9a22d5a80b70b70$var$PATH_START;
                        }
                        continue;
                    } else buffer += chr;
                    break;
                case $f9a22d5a80b70b70$var$PATH_START:
                    if (url.isSpecial()) {
                        state = $f9a22d5a80b70b70$var$PATH;
                        if (chr != "/" && chr != "\\") continue;
                    } else if (!stateOverride && chr == "?") {
                        url.query = "";
                        state = $f9a22d5a80b70b70$var$QUERY;
                    } else if (!stateOverride && chr == "#") {
                        url.fragment = "";
                        state = $f9a22d5a80b70b70$var$FRAGMENT;
                    } else if (chr != $f9a22d5a80b70b70$var$EOF) {
                        state = $f9a22d5a80b70b70$var$PATH;
                        if (chr != "/") continue;
                    }
                    break;
                case $f9a22d5a80b70b70$var$PATH:
                    if (chr == $f9a22d5a80b70b70$var$EOF || chr == "/" || chr == "\\" && url.isSpecial() || !stateOverride && (chr == "?" || chr == "#")) {
                        if ($f9a22d5a80b70b70$var$isDoubleDot(buffer)) {
                            url.shortenPath();
                            if (chr != "/" && !(chr == "\\" && url.isSpecial())) $f9a22d5a80b70b70$var$push$1(url.path, "");
                        } else if ($f9a22d5a80b70b70$var$isSingleDot(buffer)) {
                            if (chr != "/" && !(chr == "\\" && url.isSpecial())) $f9a22d5a80b70b70$var$push$1(url.path, "");
                        } else {
                            if (url.scheme == "file" && !url.path.length && $f9a22d5a80b70b70$var$isWindowsDriveLetter(buffer)) {
                                if (url.host) url.host = "";
                                buffer = $f9a22d5a80b70b70$var$charAt$3(buffer, 0) + ":"; // normalize windows drive letter
                            }
                            $f9a22d5a80b70b70$var$push$1(url.path, buffer);
                        }
                        buffer = "";
                        if (url.scheme == "file" && (chr == $f9a22d5a80b70b70$var$EOF || chr == "?" || chr == "#")) while(url.path.length > 1 && url.path[0] === "")$f9a22d5a80b70b70$var$shift(url.path);
                        if (chr == "?") {
                            url.query = "";
                            state = $f9a22d5a80b70b70$var$QUERY;
                        } else if (chr == "#") {
                            url.fragment = "";
                            state = $f9a22d5a80b70b70$var$FRAGMENT;
                        }
                    } else buffer += $f9a22d5a80b70b70$var$percentEncode(chr, $f9a22d5a80b70b70$var$pathPercentEncodeSet);
                    break;
                case $f9a22d5a80b70b70$var$CANNOT_BE_A_BASE_URL_PATH:
                    if (chr == "?") {
                        url.query = "";
                        state = $f9a22d5a80b70b70$var$QUERY;
                    } else if (chr == "#") {
                        url.fragment = "";
                        state = $f9a22d5a80b70b70$var$FRAGMENT;
                    } else if (chr != $f9a22d5a80b70b70$var$EOF) url.path[0] += $f9a22d5a80b70b70$var$percentEncode(chr, $f9a22d5a80b70b70$var$C0ControlPercentEncodeSet);
                    break;
                case $f9a22d5a80b70b70$var$QUERY:
                    if (!stateOverride && chr == "#") {
                        url.fragment = "";
                        state = $f9a22d5a80b70b70$var$FRAGMENT;
                    } else if (chr != $f9a22d5a80b70b70$var$EOF) {
                        if (chr == "'" && url.isSpecial()) url.query += "%27";
                        else if (chr == "#") url.query += "%23";
                        else url.query += $f9a22d5a80b70b70$var$percentEncode(chr, $f9a22d5a80b70b70$var$C0ControlPercentEncodeSet);
                    }
                    break;
                case $f9a22d5a80b70b70$var$FRAGMENT:
                    if (chr != $f9a22d5a80b70b70$var$EOF) url.fragment += $f9a22d5a80b70b70$var$percentEncode(chr, $f9a22d5a80b70b70$var$fragmentPercentEncodeSet);
                    break;
            }
            pointer++;
        }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function(input) {
        var result, codePoints, index;
        if ($f9a22d5a80b70b70$var$charAt$3(input, 0) == "[") {
            if ($f9a22d5a80b70b70$var$charAt$3(input, input.length - 1) != "]") return $f9a22d5a80b70b70$var$INVALID_HOST;
            result = $f9a22d5a80b70b70$var$parseIPv6($f9a22d5a80b70b70$var$stringSlice$3(input, 1, -1));
            if (!result) return $f9a22d5a80b70b70$var$INVALID_HOST;
            this.host = result;
        // opaque host
        } else if (!this.isSpecial()) {
            if ($f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$FORBIDDEN_HOST_CODE_POINT_EXCLUDING_PERCENT, input)) return $f9a22d5a80b70b70$var$INVALID_HOST;
            result = "";
            codePoints = $f9a22d5a80b70b70$var$arrayFrom(input);
            for(index = 0; index < codePoints.length; index++)result += $f9a22d5a80b70b70$var$percentEncode(codePoints[index], $f9a22d5a80b70b70$var$C0ControlPercentEncodeSet);
            this.host = result;
        } else {
            input = $f9a22d5a80b70b70$var$toASCII(input);
            if ($f9a22d5a80b70b70$var$exec$1($f9a22d5a80b70b70$var$FORBIDDEN_HOST_CODE_POINT, input)) return $f9a22d5a80b70b70$var$INVALID_HOST;
            result = $f9a22d5a80b70b70$var$parseIPv4(input);
            if (result === null) return $f9a22d5a80b70b70$var$INVALID_HOST;
            this.host = result;
        }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function() {
        return !this.host || this.cannotBeABaseURL || this.scheme == "file";
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function() {
        return this.username != "" || this.password != "";
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function() {
        return $f9a22d5a80b70b70$var$hasOwn($f9a22d5a80b70b70$var$specialSchemes, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function() {
        var path = this.path;
        var pathSize = path.length;
        if (pathSize && (this.scheme != "file" || pathSize != 1 || !$f9a22d5a80b70b70$var$isWindowsDriveLetter(path[0], true))) path.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function() {
        var url = this;
        var scheme = url.scheme;
        var username = url.username;
        var password = url.password;
        var host = url.host;
        var port = url.port;
        var path = url.path;
        var query = url.query;
        var fragment = url.fragment;
        var output = scheme + ":";
        if (host !== null) {
            output += "//";
            if (url.includesCredentials()) output += username + (password ? ":" + password : "") + "@";
            output += $f9a22d5a80b70b70$var$serializeHost(host);
            if (port !== null) output += ":" + port;
        } else if (scheme == "file") output += "//";
        output += url.cannotBeABaseURL ? path[0] : path.length ? "/" + $f9a22d5a80b70b70$var$join(path, "/") : "";
        if (query !== null) output += "?" + query;
        if (fragment !== null) output += "#" + fragment;
        return output;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function(href) {
        var failure = this.parse(href);
        if (failure) throw $f9a22d5a80b70b70$var$TypeError$1(failure);
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function() {
        var scheme = this.scheme;
        var port = this.port;
        if (scheme == "blob") try {
            return new $f9a22d5a80b70b70$var$URLConstructor(scheme.path[0]).origin;
        } catch (error) {
            return "null";
        }
        if (scheme == "file" || !this.isSpecial()) return "null";
        return scheme + "://" + $f9a22d5a80b70b70$var$serializeHost(this.host) + (port !== null ? ":" + port : "");
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function() {
        return this.scheme + ":";
    },
    setProtocol: function(protocol) {
        this.parse($f9a22d5a80b70b70$var$$toString(protocol) + ":", $f9a22d5a80b70b70$var$SCHEME_START);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function() {
        return this.username;
    },
    setUsername: function(username) {
        var codePoints = $f9a22d5a80b70b70$var$arrayFrom($f9a22d5a80b70b70$var$$toString(username));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.username = "";
        for(var i = 0; i < codePoints.length; i++)this.username += $f9a22d5a80b70b70$var$percentEncode(codePoints[i], $f9a22d5a80b70b70$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function() {
        return this.password;
    },
    setPassword: function(password) {
        var codePoints = $f9a22d5a80b70b70$var$arrayFrom($f9a22d5a80b70b70$var$$toString(password));
        if (this.cannotHaveUsernamePasswordPort()) return;
        this.password = "";
        for(var i = 0; i < codePoints.length; i++)this.password += $f9a22d5a80b70b70$var$percentEncode(codePoints[i], $f9a22d5a80b70b70$var$userinfoPercentEncodeSet);
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function() {
        var host = this.host;
        var port = this.port;
        return host === null ? "" : port === null ? $f9a22d5a80b70b70$var$serializeHost(host) : $f9a22d5a80b70b70$var$serializeHost(host) + ":" + port;
    },
    setHost: function(host) {
        if (this.cannotBeABaseURL) return;
        this.parse(host, $f9a22d5a80b70b70$var$HOST);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function() {
        var host = this.host;
        return host === null ? "" : $f9a22d5a80b70b70$var$serializeHost(host);
    },
    setHostname: function(hostname) {
        if (this.cannotBeABaseURL) return;
        this.parse(hostname, $f9a22d5a80b70b70$var$HOSTNAME);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function() {
        var port = this.port;
        return port === null ? "" : $f9a22d5a80b70b70$var$$toString(port);
    },
    setPort: function(port) {
        if (this.cannotHaveUsernamePasswordPort()) return;
        port = $f9a22d5a80b70b70$var$$toString(port);
        if (port == "") this.port = null;
        else this.parse(port, $f9a22d5a80b70b70$var$PORT);
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function() {
        var path = this.path;
        return this.cannotBeABaseURL ? path[0] : path.length ? "/" + $f9a22d5a80b70b70$var$join(path, "/") : "";
    },
    setPathname: function(pathname) {
        if (this.cannotBeABaseURL) return;
        this.path = [];
        this.parse(pathname, $f9a22d5a80b70b70$var$PATH_START);
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function() {
        var query = this.query;
        return query ? "?" + query : "";
    },
    setSearch: function(search) {
        search = $f9a22d5a80b70b70$var$$toString(search);
        if (search == "") this.query = null;
        else {
            if ("?" == $f9a22d5a80b70b70$var$charAt$3(search, 0)) search = $f9a22d5a80b70b70$var$stringSlice$3(search, 1);
            this.query = "";
            this.parse(search, $f9a22d5a80b70b70$var$QUERY);
        }
        this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function() {
        return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function() {
        var fragment = this.fragment;
        return fragment ? "#" + fragment : "";
    },
    setHash: function(hash) {
        hash = $f9a22d5a80b70b70$var$$toString(hash);
        if (hash == "") {
            this.fragment = null;
            return;
        }
        if ("#" == $f9a22d5a80b70b70$var$charAt$3(hash, 0)) hash = $f9a22d5a80b70b70$var$stringSlice$3(hash, 1);
        this.fragment = "";
        this.parse(hash, $f9a22d5a80b70b70$var$FRAGMENT);
    },
    update: function() {
        this.query = this.searchParams.serialize() || null;
    }
};
// `URL` constructor
// https://url.spec.whatwg.org/#url-class
var $f9a22d5a80b70b70$var$URLConstructor = function URL1(url /* , base */ ) {
    var that = $f9a22d5a80b70b70$var$anInstance(this, $f9a22d5a80b70b70$var$URLPrototype);
    var base = $f9a22d5a80b70b70$var$validateArgumentsLength(arguments.length, 1) > 1 ? arguments[1] : undefined;
    var state = $f9a22d5a80b70b70$var$setInternalState(that, new $f9a22d5a80b70b70$var$URLState(url, false, base));
    if (!$f9a22d5a80b70b70$var$DESCRIPTORS) {
        that.href = state.serialize();
        that.origin = state.getOrigin();
        that.protocol = state.getProtocol();
        that.username = state.getUsername();
        that.password = state.getPassword();
        that.host = state.getHost();
        that.hostname = state.getHostname();
        that.port = state.getPort();
        that.pathname = state.getPathname();
        that.search = state.getSearch();
        that.searchParams = state.getSearchParams();
        that.hash = state.getHash();
    }
};
var $f9a22d5a80b70b70$var$URLPrototype = $f9a22d5a80b70b70$var$URLConstructor.prototype;
var $f9a22d5a80b70b70$var$accessorDescriptor = function(getter, setter) {
    return {
        get: function() {
            return $f9a22d5a80b70b70$var$getInternalURLState(this)[getter]();
        },
        set: setter && function(value) {
            return $f9a22d5a80b70b70$var$getInternalURLState(this)[setter](value);
        },
        configurable: true,
        enumerable: true
    };
};
if ($f9a22d5a80b70b70$var$DESCRIPTORS) {
    // `URL.prototype.href` accessors pair
    // https://url.spec.whatwg.org/#dom-url-href
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "href", $f9a22d5a80b70b70$var$accessorDescriptor("serialize", "setHref"));
    // `URL.prototype.origin` getter
    // https://url.spec.whatwg.org/#dom-url-origin
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "origin", $f9a22d5a80b70b70$var$accessorDescriptor("getOrigin"));
    // `URL.prototype.protocol` accessors pair
    // https://url.spec.whatwg.org/#dom-url-protocol
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "protocol", $f9a22d5a80b70b70$var$accessorDescriptor("getProtocol", "setProtocol"));
    // `URL.prototype.username` accessors pair
    // https://url.spec.whatwg.org/#dom-url-username
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "username", $f9a22d5a80b70b70$var$accessorDescriptor("getUsername", "setUsername"));
    // `URL.prototype.password` accessors pair
    // https://url.spec.whatwg.org/#dom-url-password
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "password", $f9a22d5a80b70b70$var$accessorDescriptor("getPassword", "setPassword"));
    // `URL.prototype.host` accessors pair
    // https://url.spec.whatwg.org/#dom-url-host
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "host", $f9a22d5a80b70b70$var$accessorDescriptor("getHost", "setHost"));
    // `URL.prototype.hostname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hostname
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "hostname", $f9a22d5a80b70b70$var$accessorDescriptor("getHostname", "setHostname"));
    // `URL.prototype.port` accessors pair
    // https://url.spec.whatwg.org/#dom-url-port
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "port", $f9a22d5a80b70b70$var$accessorDescriptor("getPort", "setPort"));
    // `URL.prototype.pathname` accessors pair
    // https://url.spec.whatwg.org/#dom-url-pathname
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "pathname", $f9a22d5a80b70b70$var$accessorDescriptor("getPathname", "setPathname"));
    // `URL.prototype.search` accessors pair
    // https://url.spec.whatwg.org/#dom-url-search
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "search", $f9a22d5a80b70b70$var$accessorDescriptor("getSearch", "setSearch"));
    // `URL.prototype.searchParams` getter
    // https://url.spec.whatwg.org/#dom-url-searchparams
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "searchParams", $f9a22d5a80b70b70$var$accessorDescriptor("getSearchParams"));
    // `URL.prototype.hash` accessors pair
    // https://url.spec.whatwg.org/#dom-url-hash
    $f9a22d5a80b70b70$var$defineBuiltInAccessor($f9a22d5a80b70b70$var$URLPrototype, "hash", $f9a22d5a80b70b70$var$accessorDescriptor("getHash", "setHash"));
}
// `URL.prototype.toJSON` method
// https://url.spec.whatwg.org/#dom-url-tojson
$f9a22d5a80b70b70$var$defineBuiltIn$1($f9a22d5a80b70b70$var$URLPrototype, "toJSON", function toJSON() {
    return $f9a22d5a80b70b70$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
// `URL.prototype.toString` method
// https://url.spec.whatwg.org/#URL-stringification-behavior
$f9a22d5a80b70b70$var$defineBuiltIn$1($f9a22d5a80b70b70$var$URLPrototype, "toString", function toString() {
    return $f9a22d5a80b70b70$var$getInternalURLState(this).serialize();
}, {
    enumerable: true
});
if ($f9a22d5a80b70b70$var$NativeURL) {
    var $f9a22d5a80b70b70$var$nativeCreateObjectURL = $f9a22d5a80b70b70$var$NativeURL.createObjectURL;
    var $f9a22d5a80b70b70$var$nativeRevokeObjectURL = $f9a22d5a80b70b70$var$NativeURL.revokeObjectURL;
    // `URL.createObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL
    if ($f9a22d5a80b70b70$var$nativeCreateObjectURL) $f9a22d5a80b70b70$var$defineBuiltIn$1($f9a22d5a80b70b70$var$URLConstructor, "createObjectURL", $f9a22d5a80b70b70$var$bind($f9a22d5a80b70b70$var$nativeCreateObjectURL, $f9a22d5a80b70b70$var$NativeURL));
    // `URL.revokeObjectURL` method
    // https://developer.mozilla.org/en-US/docs/Web/API/URL/revokeObjectURL
    if ($f9a22d5a80b70b70$var$nativeRevokeObjectURL) $f9a22d5a80b70b70$var$defineBuiltIn$1($f9a22d5a80b70b70$var$URLConstructor, "revokeObjectURL", $f9a22d5a80b70b70$var$bind($f9a22d5a80b70b70$var$nativeRevokeObjectURL, $f9a22d5a80b70b70$var$NativeURL));
}
$f9a22d5a80b70b70$var$setToStringTag($f9a22d5a80b70b70$var$URLConstructor, "URL");
$f9a22d5a80b70b70$var$$$1({
    global: true,
    constructor: true,
    forced: !$f9a22d5a80b70b70$var$USE_NATIVE_URL,
    sham: !$f9a22d5a80b70b70$var$DESCRIPTORS
}, {
    URL: $f9a22d5a80b70b70$var$URLConstructor
});
var $f9a22d5a80b70b70$var$fails$4 = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$global$3 = $f9a22d5a80b70b70$var$global$o;
// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $f9a22d5a80b70b70$var$$RegExp$2 = $f9a22d5a80b70b70$var$global$3.RegExp;
var $f9a22d5a80b70b70$var$UNSUPPORTED_Y$1 = $f9a22d5a80b70b70$var$fails$4(function() {
    var re = $f9a22d5a80b70b70$var$$RegExp$2("a", "y");
    re.lastIndex = 2;
    return re.exec("abcd") != null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $f9a22d5a80b70b70$var$MISSED_STICKY = $f9a22d5a80b70b70$var$UNSUPPORTED_Y$1 || $f9a22d5a80b70b70$var$fails$4(function() {
    return !$f9a22d5a80b70b70$var$$RegExp$2("a", "y").sticky;
});
var $f9a22d5a80b70b70$var$BROKEN_CARET = $f9a22d5a80b70b70$var$UNSUPPORTED_Y$1 || $f9a22d5a80b70b70$var$fails$4(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $f9a22d5a80b70b70$var$$RegExp$2("^r", "gy");
    re.lastIndex = 2;
    return re.exec("str") != null;
});
var $f9a22d5a80b70b70$var$regexpStickyHelpers = {
    BROKEN_CARET: $f9a22d5a80b70b70$var$BROKEN_CARET,
    MISSED_STICKY: $f9a22d5a80b70b70$var$MISSED_STICKY,
    UNSUPPORTED_Y: $f9a22d5a80b70b70$var$UNSUPPORTED_Y$1
};
var $f9a22d5a80b70b70$var$fails$3 = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$global$2 = $f9a22d5a80b70b70$var$global$o;
// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $f9a22d5a80b70b70$var$$RegExp$1 = $f9a22d5a80b70b70$var$global$2.RegExp;
var $f9a22d5a80b70b70$var$regexpUnsupportedDotAll = $f9a22d5a80b70b70$var$fails$3(function() {
    var re = $f9a22d5a80b70b70$var$$RegExp$1(".", "s");
    return !(re.dotAll && re.exec("\n") && re.flags === "s");
});
var $f9a22d5a80b70b70$var$fails$2 = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$global$1 = $f9a22d5a80b70b70$var$global$o;
// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $f9a22d5a80b70b70$var$$RegExp = $f9a22d5a80b70b70$var$global$1.RegExp;
var $f9a22d5a80b70b70$var$regexpUnsupportedNcg = $f9a22d5a80b70b70$var$fails$2(function() {
    var re = $f9a22d5a80b70b70$var$$RegExp("(?<a>b)", "g");
    return re.exec("b").groups.a !== "b" || "b".replace(re, "$<a>c") !== "bc";
});
/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */ /* eslint-disable regexp/no-useless-quantifier -- testing */ var $f9a22d5a80b70b70$var$call$2 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$uncurryThis$3 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toString$1 = $f9a22d5a80b70b70$var$toString$4;
var $f9a22d5a80b70b70$var$regexpFlags = $f9a22d5a80b70b70$var$regexpFlags$1;
var $f9a22d5a80b70b70$var$stickyHelpers = $f9a22d5a80b70b70$var$regexpStickyHelpers;
var $f9a22d5a80b70b70$var$shared = $f9a22d5a80b70b70$var$shared$4.exports;
var $f9a22d5a80b70b70$var$create = $f9a22d5a80b70b70$var$objectCreate;
var $f9a22d5a80b70b70$var$getInternalState = $f9a22d5a80b70b70$var$internalState.get;
var $f9a22d5a80b70b70$var$UNSUPPORTED_DOT_ALL = $f9a22d5a80b70b70$var$regexpUnsupportedDotAll;
var $f9a22d5a80b70b70$var$UNSUPPORTED_NCG = $f9a22d5a80b70b70$var$regexpUnsupportedNcg;
var $f9a22d5a80b70b70$var$nativeReplace = $f9a22d5a80b70b70$var$shared("native-string-replace", String.prototype.replace);
var $f9a22d5a80b70b70$var$nativeExec = RegExp.prototype.exec;
var $f9a22d5a80b70b70$var$patchedExec = $f9a22d5a80b70b70$var$nativeExec;
var $f9a22d5a80b70b70$var$charAt$2 = $f9a22d5a80b70b70$var$uncurryThis$3("".charAt);
var $f9a22d5a80b70b70$var$indexOf = $f9a22d5a80b70b70$var$uncurryThis$3("".indexOf);
var $f9a22d5a80b70b70$var$replace$1 = $f9a22d5a80b70b70$var$uncurryThis$3("".replace);
var $f9a22d5a80b70b70$var$stringSlice$2 = $f9a22d5a80b70b70$var$uncurryThis$3("".slice);
var $f9a22d5a80b70b70$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$nativeExec, re1, "a");
    $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$nativeExec, re2, "a");
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $f9a22d5a80b70b70$var$UNSUPPORTED_Y = $f9a22d5a80b70b70$var$stickyHelpers.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $f9a22d5a80b70b70$var$NPCG_INCLUDED = /()??/.exec("")[1] !== undefined;
var $f9a22d5a80b70b70$var$PATCH = $f9a22d5a80b70b70$var$UPDATES_LAST_INDEX_WRONG || $f9a22d5a80b70b70$var$NPCG_INCLUDED || $f9a22d5a80b70b70$var$UNSUPPORTED_Y || $f9a22d5a80b70b70$var$UNSUPPORTED_DOT_ALL || $f9a22d5a80b70b70$var$UNSUPPORTED_NCG;
if ($f9a22d5a80b70b70$var$PATCH) $f9a22d5a80b70b70$var$patchedExec = function exec(string) {
    var re = this;
    var state = $f9a22d5a80b70b70$var$getInternalState(re);
    var str = $f9a22d5a80b70b70$var$toString$1(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $f9a22d5a80b70b70$var$UNSUPPORTED_Y && re.sticky;
    var flags = $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $f9a22d5a80b70b70$var$replace$1(flags, "y", "");
        if ($f9a22d5a80b70b70$var$indexOf(flags, "g") === -1) flags += "g";
        strCopy = $f9a22d5a80b70b70$var$stringSlice$2(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $f9a22d5a80b70b70$var$charAt$2(str, re.lastIndex - 1) !== "\n")) {
            source = "(?: " + source + ")";
            strCopy = " " + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp("^(?:" + source + ")", flags);
    }
    if ($f9a22d5a80b70b70$var$NPCG_INCLUDED) reCopy = new RegExp("^" + source + "$(?!\\s)", flags);
    if ($f9a22d5a80b70b70$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $f9a22d5a80b70b70$var$stringSlice$2(match.input, charsAdded);
            match[0] = $f9a22d5a80b70b70$var$stringSlice$2(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($f9a22d5a80b70b70$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($f9a22d5a80b70b70$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
    $f9a22d5a80b70b70$var$call$2($f9a22d5a80b70b70$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $f9a22d5a80b70b70$var$create(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
var $f9a22d5a80b70b70$var$regexpExec$2 = $f9a22d5a80b70b70$var$patchedExec;
var $f9a22d5a80b70b70$var$$ = $f9a22d5a80b70b70$var$_export;
var $f9a22d5a80b70b70$var$exec = $f9a22d5a80b70b70$var$regexpExec$2;
// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$f9a22d5a80b70b70$var$$({
    target: "RegExp",
    proto: true,
    forced: /./.exec !== $f9a22d5a80b70b70$var$exec
}, {
    exec: $f9a22d5a80b70b70$var$exec
});
// TODO: Remove from `core-js@4` since it's moved to entry points
var $f9a22d5a80b70b70$var$uncurryThis$2 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$defineBuiltIn = $f9a22d5a80b70b70$var$defineBuiltIn$a;
var $f9a22d5a80b70b70$var$regexpExec$1 = $f9a22d5a80b70b70$var$regexpExec$2;
var $f9a22d5a80b70b70$var$fails$1 = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$wellKnownSymbol$1 = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$createNonEnumerableProperty = $f9a22d5a80b70b70$var$createNonEnumerableProperty$5;
var $f9a22d5a80b70b70$var$SPECIES = $f9a22d5a80b70b70$var$wellKnownSymbol$1("species");
var $f9a22d5a80b70b70$var$RegExpPrototype = RegExp.prototype;
var $f9a22d5a80b70b70$var$fixRegexpWellKnownSymbolLogic = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $f9a22d5a80b70b70$var$wellKnownSymbol$1(KEY);
    var DELEGATES_TO_SYMBOL = !$f9a22d5a80b70b70$var$fails$1(function() {
        // String methods call symbol-named RegEp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ""[KEY](O) != 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$f9a22d5a80b70b70$var$fails$1(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === "split") {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$f9a22d5a80b70b70$var$SPECIES] = function() {
                return re;
            };
            re.flags = "";
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]("");
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var uncurriedNativeRegExpMethod = $f9a22d5a80b70b70$var$uncurryThis$2(/./[SYMBOL]);
        var methods = exec(SYMBOL, ""[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var uncurriedNativeMethod = $f9a22d5a80b70b70$var$uncurryThis$2(nativeMethod);
            var $exec = regexp.exec;
            if ($exec === $f9a22d5a80b70b70$var$regexpExec$1 || $exec === $f9a22d5a80b70b70$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: uncurriedNativeRegExpMethod(regexp, str, arg2)
                };
                return {
                    done: true,
                    value: uncurriedNativeMethod(str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $f9a22d5a80b70b70$var$defineBuiltIn(String.prototype, KEY, methods[0]);
        $f9a22d5a80b70b70$var$defineBuiltIn($f9a22d5a80b70b70$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $f9a22d5a80b70b70$var$createNonEnumerableProperty($f9a22d5a80b70b70$var$RegExpPrototype[SYMBOL], "sham", true);
};
var $f9a22d5a80b70b70$var$charAt$1 = $f9a22d5a80b70b70$var$stringMultibyte.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var $f9a22d5a80b70b70$var$advanceStringIndex$1 = function(S, index, unicode) {
    return index + (unicode ? $f9a22d5a80b70b70$var$charAt$1(S, index).length : 1);
};
var $f9a22d5a80b70b70$var$uncurryThis$1 = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$toObject = $f9a22d5a80b70b70$var$toObject$5;
var $f9a22d5a80b70b70$var$floor = Math.floor;
var $f9a22d5a80b70b70$var$charAt = $f9a22d5a80b70b70$var$uncurryThis$1("".charAt);
var $f9a22d5a80b70b70$var$replace = $f9a22d5a80b70b70$var$uncurryThis$1("".replace);
var $f9a22d5a80b70b70$var$stringSlice$1 = $f9a22d5a80b70b70$var$uncurryThis$1("".slice);
var $f9a22d5a80b70b70$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $f9a22d5a80b70b70$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var $f9a22d5a80b70b70$var$getSubstitution$1 = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $f9a22d5a80b70b70$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $f9a22d5a80b70b70$var$toObject(namedCaptures);
        symbols = $f9a22d5a80b70b70$var$SUBSTITUTION_SYMBOLS;
    }
    return $f9a22d5a80b70b70$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($f9a22d5a80b70b70$var$charAt(ch, 0)){
            case "$":
                return "$";
            case "&":
                return matched;
            case "`":
                return $f9a22d5a80b70b70$var$stringSlice$1(str, 0, position);
            case "'":
                return $f9a22d5a80b70b70$var$stringSlice$1(str, tailPos);
            case "<":
                capture = namedCaptures[$f9a22d5a80b70b70$var$stringSlice$1(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $f9a22d5a80b70b70$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $f9a22d5a80b70b70$var$charAt(ch, 1) : captures[f - 1] + $f9a22d5a80b70b70$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? "" : capture;
    });
};
var $f9a22d5a80b70b70$var$call$1 = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$anObject$1 = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$isCallable$1 = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$classof = $f9a22d5a80b70b70$var$classofRaw$1;
var $f9a22d5a80b70b70$var$regexpExec = $f9a22d5a80b70b70$var$regexpExec$2;
var $f9a22d5a80b70b70$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var $f9a22d5a80b70b70$var$regexpExecAbstract = function(R, S) {
    var exec = R.exec;
    if ($f9a22d5a80b70b70$var$isCallable$1(exec)) {
        var result = $f9a22d5a80b70b70$var$call$1(exec, R, S);
        if (result !== null) $f9a22d5a80b70b70$var$anObject$1(result);
        return result;
    }
    if ($f9a22d5a80b70b70$var$classof(R) === "RegExp") return $f9a22d5a80b70b70$var$call$1($f9a22d5a80b70b70$var$regexpExec, R, S);
    throw $f9a22d5a80b70b70$var$$TypeError("RegExp#exec called on incompatible receiver");
};
var $f9a22d5a80b70b70$var$apply = $f9a22d5a80b70b70$var$functionApply;
var $f9a22d5a80b70b70$var$call = $f9a22d5a80b70b70$var$functionCall;
var $f9a22d5a80b70b70$var$uncurryThis = $f9a22d5a80b70b70$var$functionUncurryThis;
var $f9a22d5a80b70b70$var$fixRegExpWellKnownSymbolLogic = $f9a22d5a80b70b70$var$fixRegexpWellKnownSymbolLogic;
var $f9a22d5a80b70b70$var$fails = $f9a22d5a80b70b70$var$fails$k;
var $f9a22d5a80b70b70$var$anObject = $f9a22d5a80b70b70$var$anObject$g;
var $f9a22d5a80b70b70$var$isCallable = $f9a22d5a80b70b70$var$isCallable$n;
var $f9a22d5a80b70b70$var$toIntegerOrInfinity = $f9a22d5a80b70b70$var$toIntegerOrInfinity$4;
var $f9a22d5a80b70b70$var$toLength = $f9a22d5a80b70b70$var$toLength$2;
var $f9a22d5a80b70b70$var$toString = $f9a22d5a80b70b70$var$toString$4;
var $f9a22d5a80b70b70$var$requireObjectCoercible = $f9a22d5a80b70b70$var$requireObjectCoercible$4;
var $f9a22d5a80b70b70$var$advanceStringIndex = $f9a22d5a80b70b70$var$advanceStringIndex$1;
var $f9a22d5a80b70b70$var$getMethod = $f9a22d5a80b70b70$var$getMethod$4;
var $f9a22d5a80b70b70$var$getSubstitution = $f9a22d5a80b70b70$var$getSubstitution$1;
var $f9a22d5a80b70b70$var$regExpExec = $f9a22d5a80b70b70$var$regexpExecAbstract;
var $f9a22d5a80b70b70$var$wellKnownSymbol = $f9a22d5a80b70b70$var$wellKnownSymbol$i;
var $f9a22d5a80b70b70$var$REPLACE = $f9a22d5a80b70b70$var$wellKnownSymbol("replace");
var $f9a22d5a80b70b70$var$max = Math.max;
var $f9a22d5a80b70b70$var$min = Math.min;
var $f9a22d5a80b70b70$var$concat = $f9a22d5a80b70b70$var$uncurryThis([].concat);
var $f9a22d5a80b70b70$var$push = $f9a22d5a80b70b70$var$uncurryThis([].push);
var $f9a22d5a80b70b70$var$stringIndexOf = $f9a22d5a80b70b70$var$uncurryThis("".indexOf);
var $f9a22d5a80b70b70$var$stringSlice = $f9a22d5a80b70b70$var$uncurryThis("".slice);
var $f9a22d5a80b70b70$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $f9a22d5a80b70b70$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return "a".replace(/./, "$0") === "$0";
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $f9a22d5a80b70b70$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$f9a22d5a80b70b70$var$REPLACE]) return /./[$f9a22d5a80b70b70$var$REPLACE]("a", "$0") === "";
    return false;
}();
var $f9a22d5a80b70b70$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$f9a22d5a80b70b70$var$fails(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: "7"
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return "".replace(re, "$<a>") !== "7";
});
// @@replace logic
$f9a22d5a80b70b70$var$fixRegExpWellKnownSymbolLogic("replace", function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $f9a22d5a80b70b70$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? "$" : "$0";
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $f9a22d5a80b70b70$var$requireObjectCoercible(this);
            var replacer = searchValue == undefined ? undefined : $f9a22d5a80b70b70$var$getMethod(searchValue, $f9a22d5a80b70b70$var$REPLACE);
            return replacer ? $f9a22d5a80b70b70$var$call(replacer, searchValue, O, replaceValue) : $f9a22d5a80b70b70$var$call(nativeReplace, $f9a22d5a80b70b70$var$toString(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $f9a22d5a80b70b70$var$anObject(this);
            var S = $f9a22d5a80b70b70$var$toString(string);
            if (typeof replaceValue == "string" && $f9a22d5a80b70b70$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $f9a22d5a80b70b70$var$stringIndexOf(replaceValue, "$<") === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $f9a22d5a80b70b70$var$isCallable(replaceValue);
            if (!functionalReplace) replaceValue = $f9a22d5a80b70b70$var$toString(replaceValue);
            var global1 = rx.global;
            if (global1) {
                var fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            while(true){
                var result = $f9a22d5a80b70b70$var$regExpExec(rx, S);
                if (result === null) break;
                $f9a22d5a80b70b70$var$push(results, result);
                if (!global1) break;
                var matchStr = $f9a22d5a80b70b70$var$toString(result[0]);
                if (matchStr === "") rx.lastIndex = $f9a22d5a80b70b70$var$advanceStringIndex(S, $f9a22d5a80b70b70$var$toLength(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = "";
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $f9a22d5a80b70b70$var$toString(result[0]);
                var position = $f9a22d5a80b70b70$var$max($f9a22d5a80b70b70$var$min($f9a22d5a80b70b70$var$toIntegerOrInfinity(result.index), S.length), 0);
                var captures = [];
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$f9a22d5a80b70b70$var$push(captures, $f9a22d5a80b70b70$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $f9a22d5a80b70b70$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $f9a22d5a80b70b70$var$push(replacerArgs, namedCaptures);
                    var replacement = $f9a22d5a80b70b70$var$toString($f9a22d5a80b70b70$var$apply(replaceValue, undefined, replacerArgs));
                } else replacement = $f9a22d5a80b70b70$var$getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $f9a22d5a80b70b70$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $f9a22d5a80b70b70$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$f9a22d5a80b70b70$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$f9a22d5a80b70b70$var$REPLACE_KEEPS_$0 || $f9a22d5a80b70b70$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $f9a22d5a80b70b70$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
var $f9a22d5a80b70b70$var$icon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsCAMAAABOo35HAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAD8UExURUdwTGx5rpLO8YOYx1Og0ly29X5ezR4mT0tiji4eWJ953KGn1Jxs7qB9xvfD/Us0gduu8yeh4HOq74dD647R91256eSz+j82cbvg/dSj/LuL79Wp6zCf24KN9xANGRANF59d/0W+/taa/8iN/3HL9uOn/z638Bil7l3G84TP+FHB8o5A/0i9/ZjU+47S+vq8/4Qy/S6w8O+x/5Rp/wyg7G2T/s+T/vO2/+qt/1qp/qDV/HyD/ki4+4R7/qnY/tyh/1Gx/ptU/76E/2bJ9Ld8/4t0/pxe+XvN9iOq7rB0/0i88aRk/6ps/z++/naL/mab/mGh/pVM/wub5mGd+fAEOhEAAAAgdFJOUwBEyWKA47EKJhnFluGA6l3H67Du6crdNOXs5q/I65rcQbfB9AAAIABJREFUeNrsnE9r4zoXxidOG9tNQqBvSrLKeKGF7WIz4J0WgSCuDc1s7vf/Mq/+S0d2p7Zkd7i0SsZJh3th+PGcR4+OpP748T3+4yNODofDKY2/SYxgdbhcfl4ul9M3rY9ZpZefbFwu6TeMD8dJwPp5Sb6l9eFIL5zW5TDoWrEc35wEjtOFDWPxjE2aJMkqWa3W6/WevuigPyVJ+tWngTg+HQ58PmSDQlqvt5Eax+jIBv2UY7umyL6u0JiMBK6DpETp4KqmL/ngX9hnwcEJYl8TGIV1EpzOEaNUCUBqFPwPfRX0W8GfFSPGgX255JCcTpwUByVY1WAU/FHwLxRWV3RdIYGtvhIvKqoVI0WriwoGK1CDvLi8JDouse5L8YqT08M2Op+vVFOYl54wJ+5PkppkJUkJZYlipN9RV1Ne69UXmCOT0zY6Xq+4Kip7GEYGmKZVyNF1ghj9whx//ZfltXQYTE/b8xnTUeFr1R82Lm7vwuPh6Cgz9jr+TVx8Mt+zcTgt0w6Ik310xIJVJXxdUaqgsIzH1w6tjlekxrVdpX/FSlb7zW63a+lrt3vazG8JFiqHVa2ewOQLlR70W1oX58XlhSiv7aerKz4xUvd7Rse9pWO32xxm/VfE6To64yt1KyEsgUt8ckT99GDsHUpL6oq9EaKT4+cWY5weNrvfbZtlNwqLfkpcM0o8XtFMhZlRUT7YYDLKEtmhsurQJNO6R0sEL0brk3FRWe3+ydpMDvblzpDtnvYz/SPihIYFzHRFYYE6xMazBnJWYTyrhsri4uqEfSESPX+WdcWnza7NbjemKyYpVob/Ml5Zu9vP0cmME1aBxZXDuSpdKWSGlK0qxUqteSxUphA7hLoOsednWVe8YiV4y34zTYkX9a4bhXejtbgJp8VQcVmJuDA4Gyp7d2K8TFn1oGnJWbEjqO5ywnLE5+iK8mGyEnbFlMV0dWO1GEyLmhWdA1kKrdiTG7y2duPvss3QWx1qVLVLSxZiJwRWdOQTxJXsd9qrGKvMHsznn4JocbNic6B5KWW5wlLMBmbDesjcOzN4KZLj0uKKD7tWcslcVIJgiLbi1fasSYk3p2WUJTsOdsqqHGVBw9I5q7BQcVp0XlxYXKdNa4Tlqkp8/uNNi0UrzupqawsLd8cYqqoXSkHOqu0ED5SF1AshQo1+tRyteM+F1RhGjXy0oiwZLU9txWwdKEhpTKIIjWv1pDUQHGpXW66uUGfTWi8WIk5Pd6Ao5VqNNDCGq7170WIx9IqFqq4iuXNUVyWr95RVDeYsSKqwPEvSkrgQLcXFhHW/STz8T2uqz9DKfHwrPVisMP/GSV0tZdkxvq6qgf6fzu+1hQsoC+mwRQd/Pi5kXOnmt+Jh53fH4mkG220m/gOSh0gpyuBSVVhhuNxRsbRfh+5sCH1LCqpjvNg39kHYrLiIcfEqZHwah5DzM8tbk2glbBbEVgHKqVANMxViJzvApWFd9wOWcng9FSrHQtLpaUJdgFa8euqHheExzeWptRuzMgqzgpaO8bClVVXuhoXSVT0kLCEtwUo+mG2hxwVoxetdNhYW09YkXUFQ3LIMJ1OJGPJyFoiqVVrD6K6VpSdCpS0xlqjEdD8a1hRa8fYs8DiuBUrRpSWF1e/+DbSzrCq0YpaaDjv2mJ9Wutll9w8xNWKGpLT242gl0fnDEsRDylKkqoF2Vu24FoxYcsGjypDQEa3npRVvRllWw8MXXWGPpJVE0bXvWCad2sLCfc9yZkSoqkI3suyljnQrrimOi+Q5mplWuhnp7zKqUm2lo6wQlqGqQygsteDBoAFfuWsdp1Oquu+82dBZyoKuRdhr3kqksMbSov8dja8jtZVsoyFlye6DrSwtLVxbydQA05hqW1qOZ1mrQ1GENGyxx7y0KKzbOFgNz6ajXT5xogO+2j0H4Fm2tNxeqZXgB5SF3JQFBnWtefPW2DJsVLRvR9KKk4GgpV1LSQv0HjDcwh8CpTfCQHPGWJampF1+zrw12rPElDghQXBa2PV3LFc9lrIwbCtbs2ExBMzOo9ZEqCtQUpLFmOfH59lW1emYAN+2rb1snEDrHWm56QE7uAZmQ1iInb3QkaTEgwhgiIgPNCetdNxqpzUmn4kexFhauOdbYDVtdwAr9zzb8JahyqSwCjtkS4vwwX/K82g7T38rnqgs9Rf30S5/xX9QlhO1avNyldVzeKejbKpQSosI46Jhi+Rzxa109DoajFs2ntYfpNWbEHstmrofsmQZFrD5Dk2LCJNnpkWBoXlMPh4Jq4ENG563vLTVC1qgDut+F75/5AiUIfR36er6Wy4URrp5bCsZBavpb2fcRva3+tqCMb7CTg+w6p8qfb8MkeblmpaweOZblFl5nKPRHHuW4fj+FshbeIgXPPBQgSNa8iwpnAjtIjTuToBpyaW0GvPYFlXWPYTWhDnRNJcx1rs8yrC0ZfWOO4CGA5gLkW1ZrJ2skAlBWQPl5CXctpiyfGG12ciVz0lWIjZLa6Osyj3XVtfvG5YmVViGZa11pGUREUpFepDSIjPYlqeyGtXfmpK3sNUAtGj1TmnB3p+7aWiON1jW3klJ6ToEwqKoaNp6iP8KrEa5/di8dbLnRNxrl1Z21JLLRJgd3MMzrrur7E6QeQBYpCRRMkPO8itDtbc4tmNzBgZvw3Kb8AM7PEJbmhXYMESgj0V0yDI1mHNplcdgafkbPKfF9hPHnA0cWPmArGV1acCJtt5+YQH9ynYsgvS6EDllSGnRKB/s8QEGb3Yxxs6Jg5YFtyyArApnbSjPdPcSKQLKUgbveFYe7vFB0WFKf6u3kYhB9wH2ljUrFUrroe1CI6qOGGERhFCfE/8IlVaYsqZ0bNTKB2OVIrBTifJy4cAR3HcWOhKYG0d7M+Fc0vJTlld/C86JIGrpJQ/olaqLTXVtoSqsRGpWOTC5m3DFKTFQ3LVCc7yXstp+f2vUno/JW043XsbSuhq4kDJ07hZurMJAOmBXiloZJi3fBN/CoyNsPzGdsPKxYZmzy8KvsK5F9WUok0LXIqCfbCJDrljlYpRh0krDytBaJ07RluNa8Jj3UV0if5b3pu2DpI6yYMAyjQYrMhD9CpVWHBwdVH/r9xRaIMTbTRoBar9aJWKs+H1XSqxn8JpVJ2dDiQrBKEqAsgKlFbaQhnlrdCVewTa+Vha/X89+iUMM/49EACsKc/IdwfMNBLRIkWtYufb5IGkxZbE7AtMXh9nAefnt6P1ErNfV8iYPxmd2QeKdS3txslpTXPJeU1cg5PRnUK/+BB9LVDNIi+0btu2f3Gg0vZFnbHQPomK3U0Qgra7nj26Is9s/xyOlUxRDZ9d0KLXjlealPCsnQdJK+CZrm80w2imVKLqB/HoKV9W7ooK4okJ1sxCMWUQld2QbFvArupbmrZpVgLL+xy6DZfdwUqzLNS1viWXO9Rptk1E7e1xdtAaVbSHU26oAwT03ZiWZlbQO/ZsPFNbrLbsNH7qd0gzU57fS8VmeX9SkFTj+kH+SbKNanGCTJ7E63vgjCEYsouZBRYm7OzP4kL4WhfXr9XYb3H+ePjfesmYCLd6Jv068bMPEpY/O2Cdm1E40sqrQrUTOy9/iGSxFqwlgpc9vNU9jK5HdAJ4kK3W++vkIt+w7qzmK+v0GC1Qelh44rF//3uTN6CbMuW6j89aPlHdsztH0y7rsArGqxM5q+BF3BW3lK0WLLRD9LV7Aotq6ZzJvNb7RwfS3Rs2JlBaNml7XRpLt8UiorApwykjHhtwOC4ZUKT/KR986lLAorYErdF7r63a0ttbedwOpcRHSdXCXAsYG1fIjDi/28K1DBYvTalvv4OD0t0ZpK/b/JRuMlrMJTdw8CrO7paz8JRSW0FZIx9Ta8hmprZBuCaWVy/1CGLGsuK54lcLdpbJy7zo0sLhvZd77Yg04NHJfntY2Mg1lgnrtPuDrSloS1+NzGgpLJoh7gLIm97dCGuLbI4E79o6/W7hIqVmVtAx969CG1U+nPnOizBC/F6e1itR2DhlY5pjuqO1ZUlovq3BYglbr5fONX38rpCW+juz9HOT0sGzLKqVxleLta1oQFvetW3Zv5+lBbBf+HQvUtuSBoj/VoPH4UqAqc+JnWg4sOSe2QctEfdBmwv1EP9uKOnUeC2gqH/YrSYo9/JKWC4vTus0grAnpNLAQYcJyls9lbmJDKQ2ePl7mgRWUt5yY2ixNK3k+8gPJTsCydSVQKUxSWW+PXhv5fVgib4V2A6f1t/yldRwMDU5TRvAy0aEs0cNMsGbpb8lfntE0y9JKoiM76O4IK7eDOzAshuqNKeshnQmWS6v1tq3x9xP9XYvYsKyOe8nempYsQEXMz+FF82+YVtuG2tZtcd+iyZRYW6nvKctQkuMlmUtZpr/VhvsWpbVdjla6PZZcWQ4qKCrbsdh4K70yvFbW68Cc6N+yUbm0bTit5bQVr6J8uN0ODMtW1hufDn0yPNvd+TWsLf9EqhY+7LNZ2OWTl37/2O7J6LhgAXsLgcVxvc6Yt8zvSWKLxmZJWunzsXRxldzaS9utchsVez94K+v11+uwbwVKq2kFrHY5WjRqlWYjh6jFoFw8A1BvFqvH5yBlDWnLt2Uj9qcbRqvhymr+T9vZtTaOZGG4m51O3M3AsDOEgaEDXhjsxr6JcXxh3AKLHQnFDk68/v//ZavOV51TVfKHpJRkxUl6LubhOW+dKtlO9VG0fGhFrajsxiihfqi8grPLUpphtbhV9lhH4wdN4fjA3Pr88PcPvcahXQZdgRoVserUaHEZiluGGd5P7BD0TqeyFq18xn8YrdHvf4fmXWJd1oNRg7Wj8z8P3WA9zcmsltwqO9JybQMdOD6oEu//lXRY0X6MTIEECi4dYc0F1DzfQdy8v+UJ4bnU4/FDaEGnlZglpH7sog6LaHWGRbjmuZiH/a36JqfGJbGKYDm3PuJDMSHhCdR/bRf6Q9XezuT7rpdZ8/ZK7HDHgutPToL17QNoueUhvxg5tA2zdDm4I2a7fmXIauV53XY/sQ51aMWq3OHduv8QWDOJLIXqh4703Uyfuy6LQzILec3T+TB7P7E+qxaQqmOriNcH0Bo9yEvVeB6cmbTaxcB2HVfSbBYAw2JM7bpyfwuLcImJtRwniQWX6tvQtD4/SNdOG6N6caP7djnc+PJ5gMxq706vuZ+4ZLeYVSSWgzW4W86szK6MXTdrWjt4dHk7nZg1n8/VtBhXI+xvjc/uby3JqmWmaSCxMLaGdotghbUg35UIMs0w1yned2jWfefM0p3pvGUP4qJZwoucGusCJFp+fBv0k/hGDz/0YtDs8dneKqCaDGKWZNdT4tbljrTWdbhMpkJmVT3+OiQtB2um7jnbxY0qQJ1YPcyai1y6i8j2W/t2qZYRqXEovzpYVQ3uFpo1i7YZQv3586cpQW9Wl92/XGaZ6DK5db4/LTmyIrGqcHwELc4sm+ncJESUhoL1FBqurFpP6t0F7QvCjFdwFlqsQWn5MkxWzrtMtyCgJu4yhFmm45onbpXnb1EsWxosa1WBtIaaEwFWvBZUC5uIFdLqDusYVaEqQusXvV7+TOfOk+BYNe2+XYi88mOolIeAT2/ghElwNrOoepnlWR3n84xhmQ6i9fVb3F2N064dkSmzCj8eB3Jr9CDNle7Wd7swD052P9GncBmoDMPM+DTP3/NJtmw8onKZmwi5Fw2kioqOohiGlocFbu1UtxDSPVSeOXqU4TFHLJv14FYN7xVe2i0stcixabXUNViwWJV3a4hKFLNmihdTwifCKDzpUYZHC0zahywtiK19VIDpRMiNu80rJZaj9fsAtBjWTjUMO92ua7Xw7BnwSOqYmpVu2+A6Mbzblxv3fIdly7CAMgxjiA4CYamJb5ZMfgGVXL/80sMsVqtlZmztIJZxgxUCq9LrQc0KcG38uRmgEo1ZyqbJ2aM7LMaVZpfs3cyztPCtFRmvKu5IbbqHCgRag1QiwFJTn2GlmanI6m+W+HWMaCVuHZlW3da5i1TWrFCDHtVmsxmAloMlQTWTXQWKp0kUVSHgf+kd8MfsnJj2XEfcCoTw2ktoRfvtUeMeEqsiq1wZAq1+f6uKzOJdPV2CkxSS59cPVnokXVfccdWv+HmS/iVY+2XYw4q2RTWqQoe7w7QZhhaYtTPrZQ3JcuJHH1hH/7DhdcxFl4w7/5dJa9pp2OdWg8s42yuNisXyoyctb1ayUtZJBXAmhItpdYSFlEItJlH/xIvroNcfd3/+dkevvvKvWEv3RdMaND0DmMW0Nr1oebNyLdXErnCi0RkWD7aLWJ1x64/fvn79fId/7HZZi1e1whRt91FYVRmzerpFZXi2X5jIV8bWDVZ9LAWUkMo1EtJ1Aaz7T/fOrVevVT3WVsUb7rJyjkixWQd39HILzTJNekBjrhOFqxesSK44up4ULoL16etvd/tXvPds072qkiosKqa1kcZBxPK4utNCWJNs/ck1HovesCDobXTlNm3mHhb8x86t2t7ICbcmosCy6b7hA8069KFFZsVa7VSq6yeTvmVYGrtEMNui6m1nMMv915/vKKdqulTSt5ttGdlpUGFlxDocDo933WiNHtKEujAWPc0qLau5jq9owRhgebd0uHupinQbWa8HqXUnXAcgBaxWh45uxbAmqldQeOiER68yLMsScSlk8zpdWwsyhgWViFpVyzTZk/WglKASC6rw4HF1oxVgtXQJA5tVloKq1Dmvp8fjXG1yCSxPqwpuKbVUMxol1maz4XTHqRBjyz2+dKE1ejgPCYyyhzs7wgJSZUlfkuyisrSGBVi+g6jiFWGVqEW0glgqsCCywK1OKe9gRY1CWnxcfwuB1xkWc4IncTWa3YgjNRAKFtGqlrl90ciqWCzMduAEo1NueViZOmOFBJvF1QXWCM2CzEJmx1SxOOafDCxPCzjV0GApXoXZdGepCh1X9GBYqw65hWYlrGwJmktvsxAXSEWtRGnnRtN6GVjgVpXZkpEVYdUa7oeN9srBWt2cWzmzJtqsuBi7Z9Y3gCU1SJXIlqXtRA4Wp3yyHoxQ8RZWCCsK9kDLfXcrLQ9rkYZ5kCgN+K5mMSxGFqqR7Kqj+IJLBAtzq1qmPYPdwrK9aJgHoQLJrMOtuQVmJYjgXOgiNN9MBoClHHOUyriz5+g6xrDAragOw3KwkPWNFCEtcgQVksLr6TZaZFb7KZR6Z5aDNfbv/ir5UqoqlGqsfYuq6jGBhbRyN1PNPFgYs6QAV+HwxG7LLQernU/4brHAi79O+phV+3Os1QpVidkPvKivd5cUVkRLbnpVIlZh58GDqkGsQjpXb7f18lSGhtWCSjBAmqjrortZY4+pRrESwUqFS6mVgWVpFYlaG7V8Pti8Ikj0ZXXjnAhmLfQ5YVDqqYDql1ke1jjQMry4Eo/Y53PY58yiDsJsM5gGy/buB91fHYhVGDek/Oi7AWN1khqkn6FYPc1CYgxprHDRUsi2qVlYwa1CZ9aGOyyn1SFaO4cGS+N6W51ucGv0fTGxXlnBFgttFz/vCsvfLGVa4NhYcCGyY62v3rA8rOBW6LA20jUUei3Im1hhKgyk4Pp29arawbJjop43Ot0n8rNFD1j0MVBAyrHSuPx3ZoKEamyBxbQKfTdHljgFpxUvni0qKcM3h8qN1ZX3qhWsiSq/JsKmYPpf/bsrrJI+6hftGktdcoJFRXlsNYtpFXaJYzZGD3bxvDJinUgsr9bpykqMzGqUPnSNqPkfTjrC2qcfkFyOpSxrnfiyOfFrGyykpefBTaEXz9E8uJJ+VInlI4vduoJWBGvSLK4ZA8ESZPi1DGVZcpNRtpoFtEzPYBpRnALtrowpQc4sxHX6ckUlOlgN+nQBk9arh1l7OrLAalWTXJXtZqFbUS9qbk4c1EYyLQkF1xtVIMXW++mKSiSzCFdDlwy5ZjCz8NPYWqjpyMce9gwscMvcdi4MqDiwbIPlig9JrQDW6XLKs1lGL/u0SdB1N2vvxhgeltWeQOFnO2F/AW7V58zCfqsw97z0grAt3FEsZPUORXg6gVsXaOnMaoSOMo1/1ah/1nSHxQcz4xPJ7eUznsSzs2ZRJRZF1LdT9W3OouLGwU2GDta7w3aJFpnVhPJrDJ7G/gwf/cxiu1gxOeGo4aAPfPefnHwelneL2lHdim7OspIqpHHy4/39Ii0d8E2sUfhBNAv0gIVA9qKXyMWo8M8QwMce+uMSLMotuxq02wwZrzwqYYW0PKwLtDwsB6KhSxNUEoKNqVP4TVdY2RFwuVHTQ8ZFWOBWYe7Qm3VzbpHDnTtOhG/vPNbvp3O0Rt+bhlGFcmzEpsY84cegsOzwRYiVCI8rYHm3HjniDxu7MarMsmqFxDoJqbW7nnOLYZFYGlljZsfmw8w6P66ABbSCVXb/KrCKpsFQgGTWybFar8/RElgtgkXNF3zpDOvV/c+/wtk2kl+91lfA8q+xeTQNVnTXK+MV8joRrTcQy7t1WrfT8rCm7rDEwhFCKyRZD1ivROsVTz7CU48Hjj3942vMgtx6DHtYuRoM+wzgFdegEwraBjDrtPZne245WFODa5EyW1hinc16JRpBL4WIkfkTBn7zch2sT/d/3lVKLLMzGtL9zezMYLxLuK9JrnWrW6Pv0ymgmvqvLQOLk89FH1ivTIUhAROtGP8S/+XrlbA+3VMl4vbVJocq6q5wInS03kLCr5lW9p1cDhZyimuxaTLJz5r1MUtXnsYkHMUtP16uhoW0HKeVeQVI3GCtQsC/265BxPIpn/3kCjZrinKdI7YI0HqZJVwUMEtIf3ctLKjEx41e56R3clCslXglWgGkdzrWbZUIsIDV9KJbIfS7wopNujxerof16SvQStbPqh19W0WstFlrMWvrjhwthBWAYX41TWt+NU0/WFcRen2h8+UWWOiWbbHS2xOrRKt3UYpTfutwZWgFWOQWxDxNkPkkW0y7wnrZnyUEpx9Myz/55wZYQCu8SkZe0hDFO+z5ua7hzXglgYVjkqHlYT1PY2DypSX3hzbrhVGFg8S6ySyitUn7dtW4UzNKvZUmpVk5uVJaDtYzY9K0zrLqCusl8QiBvITn8iMef90Ei93KRLtZ5mSLkONq61vTHK3R92ej1tRY1UiG6THtAYvNoZMtwrrjIlTjn9vMIlq5lbPak1G5rkgJLjdmp+02peVhAa7nJkn6WLJesO4BFvIJGW4jKgL18o87bjTLDaAVrQdDWtEsqHCZuNqiXOstDttvEayp8at5bkI3kavHHma9hHKTQE8oMSl33A4rdSvpGUJgSXvlzi2H1RaKMXWLyjCuxQSUUqyzWVJsJphSTMypo1mf7kdIK4DSeaXbqzWtCY1ZAsqPn5qWg/X8jLQI2rT5nyR+nldXs15UQOkyNJg0KT86wLK01B7y6i1e5di2fcsZvyW9ttv/83Z+PY3kWBSHpdkkZBtlHjYtQr9UlaCkliXUKGuIZClRKQ8QbQlU+f7fZe17/edel9MTXMlWMmmGHqTh1+ceHx9XB0FpASxnW7XV19uyb161TxTZBv9OEkHq2vLHFv7JejsnQ4t2ok5Ze8fKVDOfetEzjd+Ki8rL6pcR1urxMdCa/DSoGC+trC6o641RsmIbAovO3n8PiMqj0srKei8GT4tW7vuervYrlkYBlMe12uEgBm15ZcFLZ4B1b5yTw1UP8iyAlRBWwBNe6LXIfOMKoPXxYW9Y2//nY7+PhtDPn98PkhFU9lXpy7v85CfoarnUcqqJvKzfL98It8BsAKweKfvqTCpoatuYR45nMW3t9dOdOn+QLJrK7ZvVhrq7sayNMNrCBDH52SEqa/PE6Ol+0UsMX08Ea+ul5fhwVTX6uch+S5TxP6/hFhm8FQssa0+ncPUZzyCbQ60tYXBpYKq4/of53xgjLFRWR5TFokScU/NgbWOHsoMXJpCBgscAWCNDC6Koze57X7f7JOpZbbyugrLEBqdQCVGYe2xGZm+4tLyctpZ8FD2wN6+vXFhbMn3bSFRJVEOUhdr6cJEU7pQBTh9hCtnFSCnrWRqVVlZr1sTxj5+1QQW4nLaiWXzju+xBytoGUfE49Z4gBdcQWIbWB4mjENo/yAjS/TOCoroCezdjKIq2ba///e3bz87pCrVFvQscfslBwcdDYPUiQkpSICoANgjWhZtER2tF94Mstq+YtysrK41KGGKFxnV9ff2XhtWhtGqnrbAq8j2QP9sYMIY9Ub0fGsATKIvR6jUNn/EySMYQdWXsSr8abcH1WHeIy0qrphvr5VsoI2qyCcqHFRC9p43KU8KrWgx9g7Bvek2047fHzSAxrE/r7DwyWF2Z0CBUIdQv7VpFWxQaWW0Gsevq9CxaeXGvz4S15VuZ9yglbPkAGlTDYRlaRlQmv/ePU10rs+EJSxhXN7TEpoA5dNJq2zeqrc5vrP0vxMLsJObCOjx7yCpSVnUCZekEoWkZZe0/UVurz55fRbJyjmWEZUSlgRlVaZEhrSWZRKetlKgGKiusfO9pT2cj2FTVcFigLXunzH7fWwXjAssqC0htQFqgKGGYASzU1rKjq2LtaHmNLUM1mA8r7VV9XBWwak4Cy2gLItZ+7/srnq74MiiU3RQKq6y2LdzVIi3CqrZPjwsF9rY8jbKSsgJM20hWp/Asq61Pcwix/4zWwY2vGryyhN0/Y2wwBl+wy2srTlxdWBxJjljWA2AxaTV+DWxIDnWiAlwngWW0Ze/s49vBOLe7rgG2hPphrp0A14IRLITo06ptogdp9TY/g5WVSFXc1wOuxWney91M4iqxErLcDnvnYFdGWIBMGVYQTAtM823NJtE3gh1fGHE9PAmsHiSNaFv5+TulsqxvOVR7XvWtIllZUgBIuCn0w4jawry1rLl18YrLfmIgrKb/oFbVBFQng4W+FUh5Wa2ItVtZbUBROikQQu6DHX46sSZ6YFxay2GwGp4XmjgveGWdFhbSYstgcPcI6FJiAAASE0lEQVRQNIBZaWIGijP3yOJ3zuUJrM6VzXXweEttAKwmmr8tD1aoqSYM4uKEPwmG0Nq4jMWmUOAiuAFdCcQUxhA/2rXpNbGrvXeBdXVuHLNhNdtD80eiFVGWlCeEZXyLnTvTgAUrILRX2I3iI9JUAVtEKy3UVnShprrwSz0EVjKruxXQ6coP4UmVBdpiLXLQlYIO2ccrE0VVawaxcN6lGDNVJGjV4eiH9Db5sJreZpmJinECaZ0UltfWph+wbCVj94PWs4qIkGiDifV2PmRx7IysrMByYTmv2vZUZXn5LHoeWJggrFWtwrmzcr0oqqpVrfAzVxR9ajuBnU1bp/eJ/mCxyx9Db+69FFr5dEVRyZPDsrT4aWrQFZbIkBsEiiteCp2yIKQWpN86FCKWy2xYyW6hYcHKfSBPbvDBt1jZ/mjrmLAOqp6tk2URgykw1Z/6XdM1saN53hlYPqwmHkNnV02wdmlFBR/cXZ78x9AirfhAFVVlHZ0aFqyJ7Y6jcwkfsrzRFdv+kI4rX1l/RuUEFSZRympx+p9w7GgBscfQyeB2MK0sl0a9siyuVAfhZQXtc6ayFgcmkGwGvbSke9ydHtbI0lIrUrmbGVT+ZCINrGWDCKPo+61+5HLOlQVruqj6siKJoUFhyWBYAGt6clhWWyt+kANHXgJ9XbXUrLyiRG8Qd3rpJNpKKmwArMQEelQkZUmUl4F1hh9ib7QFth4OCKEYRc+yWaFVTFHCK4poS7TK561umR7GHFij74skqortcGSQlQEm5d3NGWBdXFxqWuSGBhhCJURR9MOooFGLwCpsM6hh/a5TsAYoa3T1r2jLTLbNTUDlE5a9ZuNzwLrw2jLhARq+X86wqDfxrNUzMnCuonD9Fjh6F81jFqzLBeHkHcuLSpIBNJqytMrZ5ehstADW4wZEFQ4Hv3IplyDImuiP+FFdWbB+zMLWpgp7G/2AkSNRFJFZXPOr88BC34JbioATFsi0wHJBVJiQJeKkhToT9ouifmuosi4AVt/VUVmNdJx8aLDXmUzL0wKbh+8bTijcrKVVJrCDUNGqyPstrqw8WOOblLHTnkHa5EAcS8r1mUwLaYGqrLebUewzOpRQhbctVFbc2HjHz4KFEb6i5UKvkeETKM86h4GWu5lB4bGXlY7oc1IJXm59DLT43qfOh1Vxw/Lbm/QMlrIszxNLKS17WI8nN2n9GMcSETIVBhG+OJxVW2SWWBas0XRBW74qLvuca+EQVo7WGefQ+ZaAATTDJBIxQdjaPSEx5feJqqDniR3ND3nKurzbVtGpoI+fvpIJU1jio6zm30dnpaVshSASXV+UT6nAqMUXzuxs3iJxq8tT1uWC1XxEYBVtsIhflRLm8P580gJaQrV2Z6iK/jYwlA5t6t9cA4Fx9rfb+Xh95SlLZwfaWjWVbLysnLhoHnXKktX5LN7Ran2PwDCFIot8NqjLHZbZSWT9lh/DPGXp7CCdR5HkwHVFUFla8szSsi4P37Ld8YiCHUf/IT8UeMBvx9in086ZVpc9hpPpXRXvnoOkYAL9QljapRCe5VmlBbR+qVan0h1fDnloJ5m+JTUgftIBM0YftYF5yhpdLXp6on0Mze0WF8Bay7vZOaUF+0TjW5jgRTJOaY8SCXIicHL7xIL3W5ljqB2+Cmc4TcTLSUwGwypRWmtZnnNBdLTghiIRO1PUv8M2sWDBwX+NzhgC/4bBG0mlmbAuftykMrskyyBPWGBZa7kuy7tzdQ+EljL3qhX+kEuIY7Y+9r4kP5IGF79/KxcWmJYvZWQ4wmH5ypKynoUKO7PHO1pws7vpinHLp0Xy94cXCXi+gxgwhmBatDqWdPtMAlYp0aykxEEsy/V6Pj0/LfNtKvVoJol2ovE+cRcXhIwV3lH5O/hWLqzLWWxU9JCQ0iq9sNC5jG1Nzktrgr7lTriCHSlCSdBKXvGzV8G0Ze8NzIZlkhbt2yUVVkwKJ3FtnuXaDOLsanTxf/EtkEbRMvOmdbP4w3F13G91+bDMCY+MhSXjUqaM10KYQzkfQGs0Gn3F5TFdujrB16RhZVQpz1dMWf4em1xYbA5lhAuAlfxhRLWG14chtEaX08sjaYW8hSIr4v1PwuEVKylYvzVAWaPxTcRKVgd0FeI7sCo1rTKX1uTqdn6c5QEtPIaAb3f3x9OK5G+LqA3MhgVzSJo+CwpRVSEyBFpISssLXvNojae3t0+3t8fS+qUK51voUja779KpQSSaU8heeJ44AJYO8bKJ+/aoRi5tYCDCkmvgZWh9H39Zzfe3T/o6ntaj/jYdrSMbeUFKVbelBnVpbWXD0uvhXcOPJ6SkrEpuWWYpRHWtgdZ6Ppt+7Qc4ji41q5enp5eX2+Mm0SQIE0ahaFbpLgvVJZzszG/6/yDut+p8WKMrHeJlQxJDf/ccRGWVVeIUmqt8mN9ffSFwjb/Pb180K8PreG35xKQOnYmlT1zdEPrLZPl8WBc/ZjJq26XXVhmCu9/nrO2KuMYLbP5ocenVd377+voE18vr8bR22G/tFHekHasf1CF7xzICnprWAFi4P/TZiuqqlL0toZtBMCyA9fCg4+n99yNwjUbjqZWV1hX88vQFl29dhEjeDn+wDPSoXK3fXufD0n/YMj4frDgrNolrqiszhlpb2rlmf4drNBlPjaxeYALx+fTyhUmENlCIg86+a/HgJ/xFDOHvfRC+5jJvzfJtwNt43Nw5s5L9ZZBpStplkPPS6jJGr4dxMjosqqv7+e0zyOn1+cldL1/xrfZw5dD7GwShq+f7b+N6Q2CZ6kGy4C57wd0qax1CVgRLPzUuPY3j3j5G72zGl05Uz0/P1t2f3CAeTcv0UiSR28r5byZyJ4IcbYgYAuticnMXWneuLRm1DTSUMlRw3Rle0++X4/FkMjLXZDIZj6+m9zON6vn55fnFXd6zvkgLd9M75TpRyKnh6HB3jIu1g2Bpacn+zTJS0sAQMkOIWLgYPoTnw8Prej6fGWT6mpqX2b3mdKvn75nCeqIm/3Kky0/ifmsnxIGB3P0psKpBsLRrrdlJDstYss/K03pAXERcmtfD66vOBHO87m7/197V9CaOBNGwBGEmCkJIOEKcMHK0QpbQ+GD3wVLfkfj/f2e7+rOqus0ANtFqEq82yaz2sPvy6vWrV9VG1OrPtcGqtlA9xq3efCti1SVRnn6LcFgZgjENnDrw8qNoBcUqUswCpEoQfKF/BpD0F8CKVKEVLf1DfTu3rudbUXtYRXcxBjNLqVZxOHCl8k0hyxu0d0d1iLCy3DLwCA0T/KFtMVwn83cg1l3cYvlWVbGCO/uUSx+HPqzp/N2xgcxS1MpTviF4d9cT0irUSAWsZCkMVsJ8hQJ030WoQouVF632PpVn+Rbuf7reKH5MZukDMZVgFThywNTCCi8tVE6yNECGX74EqcC3vgI9v+7QLZRv7aveCuzzYoOZpai1OjR8WcYNc5zJgkBZUktqqWXx0lhZ5QI2aVJ5yBy1Tr4K2xOqxdvRwvlWmE2fk1JvDD3ZxRnMrJc5dIimv4FqLIjAG+cOKZYsUljJcBKWZW2p5bEKAo+5RY7DO9H6VOrel2+lr9hhyl0Gg/Xy8Us2h4KOCaPD0Hc7xGVJxCwNmAh41eFAbJFsBY+FEbvHb/F8i3Gq613jGl6GEItvi0NTsAm0mxK63F2yXocB5cAKSAl7KCaYdWqxwt/rt+yQiwcQfA0Crwg6CIeDBc60cYYh2IUQY7kmOnCrRJJFkcJw+aclttSTCjGrvT2x+cT5VnrNpkfqx2AWRDUWLdoRNrglbJLdDvZYlFmWXbVxDgnNailcj+VbzKKfA6vQ6k3g2AhgvSzeVSFagMyiLUlmcPRexL5B4m4nwIUf5LSQuj+k8nG+db4i9mc8uR6FWVCIBW6g4fvBTVYbHzdwzZJMtIwjLSmzrH8P5gEz61G0XL7V4bvT1R9s1kjMgkIsDiwZtUVImRVpFrWk2DtY6yA8Wix3iAzE4/lWxUuyS1rVkZg1VydiOAllg6Y5wV/hxMEplkMMkaoMx6EXeSZaqKNmaL3d3Ccav/Vp7iCevfPq2FUxvBFRdaOABaPiLZpQSLcEQjxDiP1KKVO+oceUuk46xDRO3eNSvGNCdtH78tH+FtEwshzRVSOBNQfZKhBeZPZFAuUS5zOo16FFaMtQJJl1aoPTah9Ay+VbnX/9n4GrSvsHN3sci1latkjgwEK/okfc0VmITsOa+Cx2HBIbT587slOUL8f51vnCOFaNySzjH2B32zHLjSh46OfR4k10KYi8Y8B0qhXxqk0YiMfzra7q3ZZ3ujUeWDBzDWZUaxaqQ4nSGdwUBoUX1Gfh3tAUYU3L8JQowkH5Fr2+Eu1MjlmGGq28CdkM7gm5yXIpKZH4kjY7tBRRtOzrMMksjVZ2o251aLvvfGWSuB+dWeq3tcsLnMzwsU7BipD7d1KIdbI3JMRK2Yfb0YLOpwqJzYV2h1qviN8aOGRN7E9tnV41XNujrpCGMyU/CyOhJ3FpGwxEohJXt+9v0XyrZ4/SBPKqDKejvlsO0DJWq0li5aYU/iiUUatjoaprFjxQT4rz0rgS83s2knC+1XGnFe75jA2WQctcaYK/Ghl5Uq9WVxTLwcVki4wtyFgs5tZtl8+yK/lWdDRWY4Ol0dKGlJ6EEtt3pFgso4m8Q8JnOWaRyXQbNz43/W/xfOvaNjP4rMnLqM98sttawUo5UjoCI71OD7FSHv7PzFrduCQX51vn3rcDKrDGvkezALSkkXncQIc+Giv8NWax7rDFVovMpaMucXn7zTOSb/kbKuHlBej9LF21Gf3S0fzj11YSVkWtDmdW1BcGWmHNQvlf29sdAla7O27pxftbFdetyjFrfLBAt3JrSMNeJNOsMNyh1KJ4mWF+GzstNmltqV7t7tqCDvkW9aM8n7+MaeAjlZcS2Xgi8bKkXbRHill4wRKtOHlIlODy3ht62dTfT6zsx/LAzxcSCyr2/R5b3x1ab7kxWqV1EQVLsiQ17wnvQJvD1IEYpha2IFuzanp3rSi0rN+CzzGi40R/GVZht37SPcmP9xxEvpTR8gxay5LJmWHiLAzMYkENppVZE1lNH7jLaKav5h75J+SmlVuUtDmXNvlPqUI7el2Z7rDEK1ncOkhmSvt8ViJZpi7LbZk+eAHbvPUHADt3x+6otBzsRNiG1xH05mkXcOeLiTkUrbYXkkwqJG116lRvGKjV+jKkIk/j5Rbk6tFrW6DynXt3ML2/ad4fcpw99WUnH2+5kEVBAmW278fNQ8lNVp/Ae3lvUUiavz/+u9d+qzOvsKEpvN3jmq2ferN7nk1XW1WGDq2SRMpsN6ukDt5zq7cMww6g+bbMd4PegaDzLfPpMu4dbdU+vPPoMnvyGxbAzecNGYKVvdNV6uB9CYq0wLPFNh00ZIM/EfCoDddlb1/C5d6VpP7B+XnqjgeKK1AuvVnLh2DSrd5a8xAx69rw8GRFy9JquRuuKIvp5viphz1ddzzqt/8YAVN2dPaavTz/WUzeVtuyARfhFmeSAU3Zw6xoxBNymlNtLqm0Il8NpZX9b93M9r/trOe815+GCHVZzdbTr8DKwJWL0otWgdRd9galxGiJVAJ4EgYpEPa3yVjzvNfZWctWePa/j/+8ZvOXL3oWIPSluTTXo1oRs5KTQ8otDVXdKmEf8deeTdf6rrCWLv31c7b5KlqZX9j84321DPfAPKd6NatGTqsvATydhFDWapwKxEf4Zvbv0b5JdzbbrL+QVki6cjq5v+azBK5AMrIIkiXq8aEycE1e1xv9rF+nky+Hypw1Ci4U/PHWsExrVjzDd3CJZf4EqEwlLLJskmWJW31fVoyGXTJK30WsWXUqKiXMWj4Nqv/LA9oVtF57L5s3hHEYmRtquPQlHrvwoKklalV/Stb/ZqjMyaivptalbKRbCHGpgyDxn2hxCRrkNFLCkGrxt0NlqvFjqvGSOpZx8QxCy2+V+mtiUI3KqgOCLSA1yb4DUgSvrbYSNbpsWCYyeCCU8lOaW8Cpt+k3QsrhpW9AA2CWXLWguXJtL7IKW4MA1E5xavHdoPKGRhFspRADWkkMV+0WQ+D8g5vA6l97n35XoJCjmb7rS/Y5YMYaRGCTvpY/zb45UKQmgWQ7hRl5dj8wXaPZQr/PQeGTLfQLHn5A+Xl+np/n53nC8x/tAMljWkeBnAAAAABJRU5ErkJggg==`;
const $f9a22d5a80b70b70$var$resolveWalletUrl = (network, walletUrl)=>{
    if (walletUrl) return walletUrl;
    switch(network.networkId){
        case "mainnet":
            return "https://app.mynearwallet.com";
        case "testnet":
            return "https://testnet.mynearwallet.com";
        default:
            throw new Error("Invalid wallet url");
    }
};
const $f9a22d5a80b70b70$var$setupWalletState = (params, network)=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
        const keyStore = new $k4rlt.keyStores.BrowserLocalStorageKeyStore();
        const near = yield $k4rlt.connect(Object.assign(Object.assign({
            keyStore: keyStore,
            walletUrl: params.walletUrl
        }, network), {
            headers: {}
        }));
        const wallet = new $k4rlt.WalletConnection(near, "near_app");
        return {
            wallet: wallet,
            keyStore: keyStore
        };
    });
const $f9a22d5a80b70b70$var$MyNearWallet = ({ metadata: metadata, options: options, store: store, params: params, logger: logger, id: id })=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
        const _state = yield $f9a22d5a80b70b70$var$setupWalletState(params, options.network);
        const getAccounts = ()=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
                const accountId = _state.wallet.getAccountId();
                const account = _state.wallet.account();
                if (!accountId || !account) return [];
                const publicKey = yield account.connection.signer.getPublicKey(account.accountId, options.network.networkId);
                return [
                    {
                        accountId: accountId,
                        publicKey: publicKey ? publicKey.toString() : ""
                    }
                ];
            });
        const transformTransactions = (transactions)=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
                const account = _state.wallet.account();
                const { networkId: networkId, signer: signer, provider: provider } = account.connection;
                const localKey = yield signer.getPublicKey(account.accountId, networkId);
                return Promise.all(transactions.map((transaction, index)=>$f9a22d5a80b70b70$var$__awaiter(void 0, void 0, void 0, function*() {
                        const actions = transaction.actions.map((action)=>(0, $5aa677c457ee63c9$export$309c7a02b0b0bc62)(action));
                        const accessKey = yield account.accessKeyForTransaction(transaction.receiverId, actions, localKey);
                        if (!accessKey) throw new Error(`Failed to find matching key for transaction sent to ${transaction.receiverId}`);
                        const block = yield provider.block({
                            finality: "final"
                        });
                        return $k4rlt.transactions.createTransaction(account.accountId, $k4rlt.utils.PublicKey.from(accessKey.public_key), transaction.receiverId, accessKey.access_key.nonce + index + 1, actions, $k4rlt.utils.serialize.base_decode(block.header.hash));
                    })));
            });
        return {
            signIn ({ contractId: contractId, methodNames: methodNames, successUrl: successUrl, failureUrl: failureUrl }) {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    const existingAccounts = yield getAccounts();
                    if (existingAccounts.length) return existingAccounts;
                    yield _state.wallet.requestSignIn({
                        contractId: contractId,
                        methodNames: methodNames,
                        successUrl: successUrl,
                        failureUrl: failureUrl
                    });
                    return getAccounts();
                });
            },
            signOut () {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    if (_state.wallet.isSignedIn()) _state.wallet.signOut();
                });
            },
            getAccounts () {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    return getAccounts();
                });
            },
            verifyOwner () {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    throw new Error(`Method not supported by ${metadata.name}`);
                });
            },
            signMessage ({ message: message, nonce: nonce, recipient: recipient, callbackUrl: callbackUrl, state: state }) {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("sign message", {
                        message: message
                    });
                    if (id !== "my-near-wallet") throw Error(`The signMessage method is not supported by ${metadata.name}`);
                    const locationUrl = typeof window !== "undefined" ? window.location.href : "";
                    const url = callbackUrl || locationUrl;
                    if (!url) throw new Error(`The callbackUrl is missing for ${metadata.name}`);
                    const href = new URL(params.walletUrl);
                    href.pathname = "sign-message";
                    href.searchParams.append("message", message);
                    href.searchParams.append("nonce", nonce.toString("base64"));
                    href.searchParams.append("recipient", recipient);
                    href.searchParams.append("callbackUrl", url);
                    if (state) href.searchParams.append("state", state);
                    window.location.replace(href.toString());
                    return;
                });
            },
            signAndSendTransaction ({ signerId: signerId, receiverId: receiverId, actions: actions, callbackUrl: callbackUrl }) {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("signAndSendTransaction", {
                        signerId: signerId,
                        receiverId: receiverId,
                        actions: actions,
                        callbackUrl: callbackUrl
                    });
                    const { contract: contract } = store.getState();
                    if (!_state.wallet.isSignedIn() || !contract) throw new Error("Wallet not signed in");
                    const account = _state.wallet.account();
                    return account["signAndSendTransaction"]({
                        receiverId: receiverId || contract.contractId,
                        actions: actions.map((action)=>(0, $5aa677c457ee63c9$export$309c7a02b0b0bc62)(action)),
                        walletCallbackUrl: callbackUrl
                    });
                });
            },
            signAndSendTransactions ({ transactions: transactions, callbackUrl: callbackUrl }) {
                return $f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
                    logger.log("signAndSendTransactions", {
                        transactions: transactions,
                        callbackUrl: callbackUrl
                    });
                    if (!_state.wallet.isSignedIn()) throw new Error("Wallet not signed in");
                    return _state.wallet.requestSignTransactions({
                        transactions: yield transformTransactions(transactions),
                        callbackUrl: callbackUrl
                    });
                });
            },
            buildImportAccountsUrl () {
                return `${params.walletUrl}/batch-import`;
            }
        };
    });
function $f9a22d5a80b70b70$export$173acaf083c7f609({ walletUrl: walletUrl, iconUrl: iconUrl = $f9a22d5a80b70b70$var$icon, deprecated: deprecated = false, successUrl: successUrl = "", failureUrl: failureUrl = "" } = {}) {
    return (moduleOptions)=>$f9a22d5a80b70b70$var$__awaiter(this, void 0, void 0, function*() {
            return {
                id: "my-near-wallet",
                type: "browser",
                metadata: {
                    name: "MyNearWallet",
                    description: "NEAR wallet to store, buy, send and stake assets for DeFi.",
                    iconUrl: iconUrl,
                    deprecated: deprecated,
                    available: true,
                    successUrl: successUrl,
                    failureUrl: failureUrl,
                    walletUrl: $f9a22d5a80b70b70$var$resolveWalletUrl(moduleOptions.options.network, walletUrl)
                },
                init: (options)=>{
                    return $f9a22d5a80b70b70$var$MyNearWallet(Object.assign(Object.assign({}, options), {
                        params: {
                            walletUrl: $f9a22d5a80b70b70$var$resolveWalletUrl(options.options.network, walletUrl)
                        }
                    }));
                }
            };
        });
}



var $6ZWSX = parcelRequire("6ZWSX");
var $2fa6d44a8a0d6690$require$Buffer = $6ZWSX.Buffer;
const $2fa6d44a8a0d6690$var$THIRTY_TGAS = "30000000000000";
const $2fa6d44a8a0d6690$var$NO_DEPOSIT = "0";
class $2fa6d44a8a0d6690$export$bcca3ea514774656 {
    /**
   * @constructor
   * @param {Object} options - the options for the wallet
   * @param {string} options.networkId - the network id to connect to
   * @param {string} options.createAccessKeyFor - the contract to create an access key for
   * @example
   * const wallet = new Wallet({ networkId: 'testnet', createAccessKeyFor: 'contractId' });
   * wallet.startUp((signedAccountId) => console.log(signedAccountId));
   */ constructor({ networkId: networkId = "testnet", createAccessKeyFor: createAccessKeyFor }){
        this.createAccessKeyFor = createAccessKeyFor;
        this.networkId = networkId;
    }
    /**
   * To be called when the website loads
   * @param {Function} accountChangeHook - a function that is called when the user signs in or out#
   * @returns {Promise<string>} - the accountId of the signed-in user 
   */ startUp = async (accountChangeHook)=>{
        this.selector = (0, $5bb7220e37bd460f$export$f9bdc9e9de5b988e)({
            network: this.networkId,
            modules: [
                (0, $f9a22d5a80b70b70$export$173acaf083c7f609)(),
                (0, $3b33b5b5cc18ae8d$export$63a96487f02e71cb)()
            ]
        });
        const walletSelector = await this.selector;
        const isSignedIn = walletSelector.isSignedIn();
        const accountId = isSignedIn ? walletSelector.store.getState().accounts[0].accountId : "";
        walletSelector.store.observable.pipe((0, $9853a79d111e4e33$export$871de8747c9eaa88)((state)=>state.accounts), (0, $6fb8b1c12553edae$export$779c5fb865a0172e)()).subscribe((accounts)=>{
            const signedAccount = accounts.find((account)=>account.active)?.accountId;
            accountChangeHook(signedAccount);
        });
        return accountId;
    };
    /**
   * Displays a modal to login the user
   */ signIn = async ()=>{
        const modal = (0, $6daeff2c8e1d7f1b$export$60f0f9f4cfa9469a)(await this.selector, {
            contractId: this.createAccessKeyFor
        });
        modal.show();
    };
    /**
   * Logout the user
   */ signOut = async ()=>{
        const selectedWallet = await (await this.selector).wallet();
        selectedWallet.signOut();
    };
    /**
   * Makes a read-only call to a contract
   * @param {Object} options - the options for the call
   * @param {string} options.contractId - the contract's account id
   * @param {string} options.method - the method to call
   * @param {Object} options.args - the arguments to pass to the method
   * @returns {Promise<JSON.value>} - the result of the method call
   */ viewMethod = async ({ contractId: contractId, method: method, args: args = {} })=>{
        const url = `https://rpc.${this.networkId}.near.org`;
        const provider = new (0, $k4rlt.providers).JsonRpcProvider({
            url: url
        });
        let res = await provider.query({
            request_type: "call_function",
            account_id: contractId,
            method_name: method,
            args_base64: $2fa6d44a8a0d6690$require$Buffer.from(JSON.stringify(args)).toString("base64"),
            finality: "optimistic"
        });
        return JSON.parse($2fa6d44a8a0d6690$require$Buffer.from(res.result).toString());
    };
    /**
   * Makes a call to a contract
   * @param {Object} options - the options for the call
   * @param {string} options.contractId - the contract's account id
   * @param {string} options.method - the method to call
   * @param {Object} options.args - the arguments to pass to the method
   * @param {string} options.gas - the amount of gas to use
   * @param {string} options.deposit - the amount of yoctoNEAR to deposit
   * @returns {Promise<Transaction>} - the resulting transaction
   */ callMethod = async ({ contractId: contractId, method: method, args: args = {}, gas: gas = $2fa6d44a8a0d6690$var$THIRTY_TGAS, deposit: deposit = $2fa6d44a8a0d6690$var$NO_DEPOSIT })=>{
        // Sign a transaction with the "FunctionCall" action
        const selectedWallet = await (await this.selector).wallet();
        const outcome = await selectedWallet.signAndSendTransaction({
            receiverId: contractId,
            actions: [
                {
                    type: "FunctionCall",
                    params: {
                        methodName: method,
                        args: args,
                        gas: gas,
                        deposit: deposit
                    }
                }
            ]
        });
        return (0, $k4rlt.providers).getTransactionLastResult(outcome);
    };
    /**
   * Retrieves transaction result from the network
   * @param {string} txhash - the transaction hash
   * @returns {Promise<JSON.value>} - the result of the transaction
   */ getTransactionResult = async (txhash)=>{
        const walletSelector = await this.selector;
        const { network: network } = walletSelector.options;
        const provider = new (0, $k4rlt.providers).JsonRpcProvider({
            url: network.nodeUrl
        });
        const transaction = await provider.txStatus(txhash, "unnused");
        return (0, $k4rlt.providers).getTransactionLastResult(transaction);
    };
    signAndSendTransactions = async ({ transactions: transactions })=>{
        const selectedWallet = await (await this.selector).wallet();
        return selectedWallet.signAndSendTransactions({
            transactions: transactions
        });
    };
}


const $20a9aa8a7b6d14f9$var$HELLO_ADDRESS = "hello.near-examples.testnet";
const $20a9aa8a7b6d14f9$var$GUEST_ADDRESS = "guestbook.near-examples.testnet";
const $20a9aa8a7b6d14f9$var$wallet = new (0, $2fa6d44a8a0d6690$export$bcca3ea514774656)({});
const $20a9aa8a7b6d14f9$var$THIRTY_TGAS = "30000000000000";
const $20a9aa8a7b6d14f9$var$NO_DEPOSIT = "0";
// Setup on page load
window.onload = ()=>{
    $20a9aa8a7b6d14f9$var$wallet.startUp((signedAccountId)=>signedAccountId ? $20a9aa8a7b6d14f9$var$signedInFlow(signedAccountId) : $20a9aa8a7b6d14f9$var$signedOutFlow());
    $20a9aa8a7b6d14f9$var$getGreetingAndMessages();
};
// Button clicks
document.querySelector("form").onsubmit = $20a9aa8a7b6d14f9$var$sendGreeting;
document.querySelector("#sign-in-button").onclick = ()=>{
    $20a9aa8a7b6d14f9$var$wallet.signIn();
};
document.querySelector("#sign-out-button").onclick = ()=>{
    $20a9aa8a7b6d14f9$var$wallet.signOut();
};
async function $20a9aa8a7b6d14f9$var$sendGreeting(event) {
    // handle UI
    event.preventDefault();
    const { greeting: greeting, premium_check: premium_check } = event.target.elements;
    document.querySelector("#signed-in-flow").classList.add("please-wait");
    const GUEST_DEPOSIT = premium_check.checked ? (0, $k4rlt.utils).format.parseNearAmount("0.1") : "0";
    const guestTx = {
        receiverId: $20a9aa8a7b6d14f9$var$GUEST_ADDRESS,
        actions: [
            {
                type: "FunctionCall",
                params: {
                    methodName: "add_message",
                    args: {
                        text: greeting.value
                    },
                    gas: $20a9aa8a7b6d14f9$var$THIRTY_TGAS,
                    deposit: GUEST_DEPOSIT
                }
            }
        ]
    };
    const helloTx = {
        receiverId: $20a9aa8a7b6d14f9$var$HELLO_ADDRESS,
        actions: [
            {
                type: "FunctionCall",
                params: {
                    methodName: "set_greeting",
                    args: {
                        greeting: greeting.value
                    },
                    gas: $20a9aa8a7b6d14f9$var$THIRTY_TGAS,
                    deposit: $20a9aa8a7b6d14f9$var$NO_DEPOSIT
                }
            }
        ]
    };
    // Sign **independent** transactions: If one fails, the other **DOES NOT** revert
    await $20a9aa8a7b6d14f9$var$wallet.signAndSendTransactions({
        transactions: [
            helloTx,
            guestTx
        ]
    });
}
async function $20a9aa8a7b6d14f9$var$getGreetingAndMessages() {
    // query the greeting in Hello NEAR
    const currentGreeting = await $20a9aa8a7b6d14f9$var$wallet.viewMethod({
        method: "get_greeting",
        contractId: $20a9aa8a7b6d14f9$var$HELLO_ADDRESS
    });
    // query the last 4 messages in the Guest Book
    const totalMessages = await $20a9aa8a7b6d14f9$var$wallet.viewMethod({
        method: "total_messages",
        contractId: $20a9aa8a7b6d14f9$var$GUEST_ADDRESS
    });
    const from_index = (totalMessages > 4 ? totalMessages - 4 : 0).toString();
    const latestMessages = await $20a9aa8a7b6d14f9$var$wallet.viewMethod({
        method: "get_messages",
        contractId: $20a9aa8a7b6d14f9$var$GUEST_ADDRESS,
        args: {
            from_index: from_index,
            limit: "4"
        }
    });
    // handle UI stuff
    $20a9aa8a7b6d14f9$var$update_UI(currentGreeting, from_index, latestMessages);
}
// UI: Display the signed-out-flow container
function $20a9aa8a7b6d14f9$var$signedOutFlow() {
    document.querySelector("#signed-in-flow").style.display = "none";
    document.querySelector("#signed-out-flow").style.display = "block";
}
// UI: Displaying the signed in flow container and fill in account-specific data
function $20a9aa8a7b6d14f9$var$signedInFlow(accountId) {
    document.querySelector("#signed-out-flow").style.display = "none";
    document.querySelector("#signed-in-flow").style.display = "block";
    document.querySelectorAll("[data-behavior=account-id]").forEach((el)=>{
        el.innerText = accountId;
    });
}
function $20a9aa8a7b6d14f9$var$update_UI(greeting, from, messages) {
    document.querySelector("#greeting").innerHTML = greeting;
    const list = document.querySelector("#message-list");
    list.innerHTML = "";
    let idx = from;
    messages.forEach((msg)=>{
        let item = document.createElement("tr");
        const innerHTML = `
      <tr>
       <th scope="row">${idx++}</th>
       <td> ${msg.sender} </td>
       <td> ${msg.text} </td>
       <td> ${msg.premium}</td>
      </tr>
    `;
        item.innerHTML = innerHTML;
        list.appendChild(item);
    });
}


//# sourceMappingURL=index.4efa773e.js.map
